const css = `@charset "UTF-8";
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700;800&display=swap");
@import url("https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@300;400;600&display=swap");
/*!
 * 
 * antd v4.24.10
 * 
 * Copyright 2015-present, Alipay, Inc.
 * All rights reserved.
 *       
 */
[class*=ant-]::-ms-clear, [class*=ant-] input::-ms-clear, [class*=ant-] input::-ms-reveal, [class^=ant-]::-ms-clear, [class^=ant-] input::-ms-clear, [class^=ant-] input::-ms-reveal {
  display: none;
}

body, html {
  width: 100%;
  height: 100%;
}

input::-ms-clear, input::-ms-reveal {
  display: none;
}

*, :after, :before {
  box-sizing: border-box;
}

html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  -ms-overflow-style: scrollbar;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

@-ms-viewport {
  width: device-width;
}
body {
  margin: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  font-variant: tabular-nums;
  line-height: 1.5715;
  background-color: #fff;
  font-feature-settings: "tnum";
}

[tabindex="-1"]:focus {
  outline: none !important;
}

hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}

h1, h2, h3, h4, h5, h6 {
  margin-top: 0;
  margin-bottom: 0.5em;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
}

p {
  margin-top: 0;
  margin-bottom: 1em;
}

abbr[data-original-title], abbr[title] {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
  text-decoration: underline dotted;
  border-bottom: 0;
  cursor: help;
}

address {
  margin-bottom: 1em;
  font-style: normal;
  line-height: inherit;
}

input[type=number], input[type=password], input[type=text], textarea {
  -webkit-appearance: none;
}

dl, ol, ul {
  margin-top: 0;
  margin-bottom: 1em;
}

ol ol, ol ul, ul ol, ul ul {
  margin-bottom: 0;
}

dt {
  font-weight: 500;
}

dd {
  margin-bottom: 0.5em;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1em;
}

dfn {
  font-style: italic;
}

b, strong {
  font-weight: bolder;
}

small {
  font-size: 80%;
}

sub, sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: #1890ff;
  text-decoration: none;
  background-color: transparent;
  outline: none;
  cursor: pointer;
  transition: color 0.3s;
  -webkit-text-decoration-skip: objects;
}

a:hover {
  color: #40a9ff;
}

a:active {
  color: #096dd9;
}

a:active, a:focus, a:hover {
  text-decoration: none;
  outline: 0;
}

a[disabled] {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

code, kbd, pre, samp {
  font-size: 1em;
  font-family: SFMono-Regular, Consolas, Liberation Mono, Menlo, Courier, monospace;
}

pre {
  margin-top: 0;
  margin-bottom: 1em;
  overflow: auto;
}

figure {
  margin: 0 0 1em;
}

img {
  vertical-align: middle;
  border-style: none;
}

[role=button], a, area, button, input:not([type=range]), label, select, summary, textarea {
  touch-action: manipulation;
}

table {
  border-collapse: collapse;
}

caption {
  padding-top: 0.75em;
  padding-bottom: 0.3em;
  color: rgba(0, 0, 0, 0.45);
  text-align: left;
  caption-side: bottom;
}

button, input, optgroup, select, textarea {
  margin: 0;
  color: inherit;
  font-size: inherit;
  font-family: inherit;
  line-height: inherit;
}

button, input {
  overflow: visible;
}

button, select {
  text-transform: none;
}

[type=reset], [type=submit], button, html [type=button] {
  -webkit-appearance: button;
}

[type=button]::-moz-focus-inner, [type=reset]::-moz-focus-inner, [type=submit]::-moz-focus-inner, button::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

input[type=checkbox], input[type=radio] {
  box-sizing: border-box;
  padding: 0;
}

input[type=date], input[type=datetime-local], input[type=month], input[type=time] {
  -webkit-appearance: listbox;
}

textarea {
  overflow: auto;
  resize: vertical;
}

fieldset {
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}

legend {
  display: block;
  width: 100%;
  max-width: 100%;
  margin-bottom: 0.5em;
  padding: 0;
  color: inherit;
  font-size: 1.5em;
  line-height: inherit;
  white-space: normal;
}

progress {
  vertical-align: baseline;
}

[type=number]::-webkit-inner-spin-button, [type=number]::-webkit-outer-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: none;
}

[type=search]::-webkit-search-cancel-button, [type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

summary {
  display: list-item;
}

template {
  display: none;
}

[hidden] {
  display: none !important;
}

mark {
  padding: 0.2em;
  background-color: #feffe6;
}

::-moz-selection {
  color: #fff;
  background: #1890ff;
}

::selection {
  color: #fff;
  background: #1890ff;
}

.clearfix:after, .clearfix:before {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.anticon {
  display: inline-block;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
}

.anticon:before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon > .anticon {
  line-height: 0;
  vertical-align: 0;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin, .anticon-spin:before {
  display: inline-block;
  animation: loadingCircle 1s linear infinite;
}

.ant-fade-appear, .ant-fade-enter, .ant-fade-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.ant-fade-appear.ant-fade-appear-active, .ant-fade-enter.ant-fade-enter-active {
  animation-name: antFadeIn;
  animation-play-state: running;
}

.ant-fade-leave.ant-fade-leave-active {
  animation-name: antFadeOut;
  animation-play-state: running;
  pointer-events: none;
}

.ant-fade-appear, .ant-fade-enter {
  opacity: 0;
  animation-timing-function: linear;
}

.ant-fade-leave {
  animation-timing-function: linear;
}

@keyframes antFadeIn {
  0% {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes antFadeOut {
  0% {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.ant-move-up-appear, .ant-move-up-enter, .ant-move-up-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.ant-move-up-appear.ant-move-up-appear-active, .ant-move-up-enter.ant-move-up-enter-active {
  animation-name: antMoveUpIn;
  animation-play-state: running;
}

.ant-move-up-leave.ant-move-up-leave-active {
  animation-name: antMoveUpOut;
  animation-play-state: running;
  pointer-events: none;
}

.ant-move-up-appear, .ant-move-up-enter {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}

.ant-move-up-leave {
  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);
}

.ant-move-down-appear, .ant-move-down-enter, .ant-move-down-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.ant-move-down-appear.ant-move-down-appear-active, .ant-move-down-enter.ant-move-down-enter-active {
  animation-name: antMoveDownIn;
  animation-play-state: running;
}

.ant-move-down-leave.ant-move-down-leave-active {
  animation-name: antMoveDownOut;
  animation-play-state: running;
  pointer-events: none;
}

.ant-move-down-appear, .ant-move-down-enter {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}

.ant-move-down-leave {
  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);
}

.ant-move-left-appear, .ant-move-left-enter, .ant-move-left-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.ant-move-left-appear.ant-move-left-appear-active, .ant-move-left-enter.ant-move-left-enter-active {
  animation-name: antMoveLeftIn;
  animation-play-state: running;
}

.ant-move-left-leave.ant-move-left-leave-active {
  animation-name: antMoveLeftOut;
  animation-play-state: running;
  pointer-events: none;
}

.ant-move-left-appear, .ant-move-left-enter {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}

.ant-move-left-leave {
  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);
}

.ant-move-right-appear, .ant-move-right-enter, .ant-move-right-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.ant-move-right-appear.ant-move-right-appear-active, .ant-move-right-enter.ant-move-right-enter-active {
  animation-name: antMoveRightIn;
  animation-play-state: running;
}

.ant-move-right-leave.ant-move-right-leave-active {
  animation-name: antMoveRightOut;
  animation-play-state: running;
  pointer-events: none;
}

.ant-move-right-appear, .ant-move-right-enter {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}

.ant-move-right-leave {
  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);
}

@keyframes antMoveDownIn {
  0% {
    transform: translateY(100%);
    transform-origin: 0 0;
    opacity: 0;
  }
  to {
    transform: translateY(0);
    transform-origin: 0 0;
    opacity: 1;
  }
}
@keyframes antMoveDownOut {
  0% {
    transform: translateY(0);
    transform-origin: 0 0;
    opacity: 1;
  }
  to {
    transform: translateY(100%);
    transform-origin: 0 0;
    opacity: 0;
  }
}
@keyframes antMoveLeftIn {
  0% {
    transform: translateX(-100%);
    transform-origin: 0 0;
    opacity: 0;
  }
  to {
    transform: translateX(0);
    transform-origin: 0 0;
    opacity: 1;
  }
}
@keyframes antMoveLeftOut {
  0% {
    transform: translateX(0);
    transform-origin: 0 0;
    opacity: 1;
  }
  to {
    transform: translateX(-100%);
    transform-origin: 0 0;
    opacity: 0;
  }
}
@keyframes antMoveRightIn {
  0% {
    transform: translateX(100%);
    transform-origin: 0 0;
    opacity: 0;
  }
  to {
    transform: translateX(0);
    transform-origin: 0 0;
    opacity: 1;
  }
}
@keyframes antMoveRightOut {
  0% {
    transform: translateX(0);
    transform-origin: 0 0;
    opacity: 1;
  }
  to {
    transform: translateX(100%);
    transform-origin: 0 0;
    opacity: 0;
  }
}
@keyframes antMoveUpIn {
  0% {
    transform: translateY(-100%);
    transform-origin: 0 0;
    opacity: 0;
  }
  to {
    transform: translateY(0);
    transform-origin: 0 0;
    opacity: 1;
  }
}
@keyframes antMoveUpOut {
  0% {
    transform: translateY(0);
    transform-origin: 0 0;
    opacity: 1;
  }
  to {
    transform: translateY(-100%);
    transform-origin: 0 0;
    opacity: 0;
  }
}
@keyframes loadingCircle {
  to {
    transform: rotate(1turn);
  }
}
[ant-click-animating-without-extra-node=true], [ant-click-animating=true] {
  position: relative;
}

html {
  --antd-wave-shadow-color:#1890ff;
  --scroll-bar:0;
}

.ant-click-animating-node, [ant-click-animating-without-extra-node=true]:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: block;
  border-radius: inherit;
  box-shadow: 0 0 0 0 #1890ff;
  box-shadow: 0 0 0 0 var(--antd-wave-shadow-color);
  opacity: 0.2;
  animation: fadeEffect 2s cubic-bezier(0.08, 0.82, 0.17, 1), waveEffect 0.4s cubic-bezier(0.08, 0.82, 0.17, 1);
  animation-fill-mode: forwards;
  content: "";
  pointer-events: none;
}

@keyframes waveEffect {
  to {
    box-shadow: 0 0 0 #1890ff;
    box-shadow: 0 0 0 6px var(--antd-wave-shadow-color);
  }
}
@keyframes fadeEffect {
  to {
    opacity: 0;
  }
}
.ant-slide-up-appear, .ant-slide-up-enter, .ant-slide-up-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.ant-slide-up-appear.ant-slide-up-appear-active, .ant-slide-up-enter.ant-slide-up-enter-active {
  animation-name: antSlideUpIn;
  animation-play-state: running;
}

.ant-slide-up-leave.ant-slide-up-leave-active {
  animation-name: antSlideUpOut;
  animation-play-state: running;
  pointer-events: none;
}

.ant-slide-up-appear, .ant-slide-up-enter {
  transform: scale(0);
  transform-origin: 0 0;
  opacity: 0;
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
}

.ant-slide-up-leave {
  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
}

.ant-slide-down-appear, .ant-slide-down-enter, .ant-slide-down-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.ant-slide-down-appear.ant-slide-down-appear-active, .ant-slide-down-enter.ant-slide-down-enter-active {
  animation-name: antSlideDownIn;
  animation-play-state: running;
}

.ant-slide-down-leave.ant-slide-down-leave-active {
  animation-name: antSlideDownOut;
  animation-play-state: running;
  pointer-events: none;
}

.ant-slide-down-appear, .ant-slide-down-enter {
  transform: scale(0);
  transform-origin: 0 0;
  opacity: 0;
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
}

.ant-slide-down-leave {
  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
}

.ant-slide-left-appear, .ant-slide-left-enter, .ant-slide-left-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.ant-slide-left-appear.ant-slide-left-appear-active, .ant-slide-left-enter.ant-slide-left-enter-active {
  animation-name: antSlideLeftIn;
  animation-play-state: running;
}

.ant-slide-left-leave.ant-slide-left-leave-active {
  animation-name: antSlideLeftOut;
  animation-play-state: running;
  pointer-events: none;
}

.ant-slide-left-appear, .ant-slide-left-enter {
  transform: scale(0);
  transform-origin: 0 0;
  opacity: 0;
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
}

.ant-slide-left-leave {
  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
}

.ant-slide-right-appear, .ant-slide-right-enter, .ant-slide-right-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.ant-slide-right-appear.ant-slide-right-appear-active, .ant-slide-right-enter.ant-slide-right-enter-active {
  animation-name: antSlideRightIn;
  animation-play-state: running;
}

.ant-slide-right-leave.ant-slide-right-leave-active {
  animation-name: antSlideRightOut;
  animation-play-state: running;
  pointer-events: none;
}

.ant-slide-right-appear, .ant-slide-right-enter {
  transform: scale(0);
  transform-origin: 0 0;
  opacity: 0;
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
}

.ant-slide-right-leave {
  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
}

@keyframes antSlideUpIn {
  0% {
    transform: scaleY(0.8);
    transform-origin: 0 0;
    opacity: 0;
  }
  to {
    transform: scaleY(1);
    transform-origin: 0 0;
    opacity: 1;
  }
}
@keyframes antSlideUpOut {
  0% {
    transform: scaleY(1);
    transform-origin: 0 0;
    opacity: 1;
  }
  to {
    transform: scaleY(0.8);
    transform-origin: 0 0;
    opacity: 0;
  }
}
@keyframes antSlideDownIn {
  0% {
    transform: scaleY(0.8);
    transform-origin: 100% 100%;
    opacity: 0;
  }
  to {
    transform: scaleY(1);
    transform-origin: 100% 100%;
    opacity: 1;
  }
}
@keyframes antSlideDownOut {
  0% {
    transform: scaleY(1);
    transform-origin: 100% 100%;
    opacity: 1;
  }
  to {
    transform: scaleY(0.8);
    transform-origin: 100% 100%;
    opacity: 0;
  }
}
@keyframes antSlideLeftIn {
  0% {
    transform: scaleX(0.8);
    transform-origin: 0 0;
    opacity: 0;
  }
  to {
    transform: scaleX(1);
    transform-origin: 0 0;
    opacity: 1;
  }
}
@keyframes antSlideLeftOut {
  0% {
    transform: scaleX(1);
    transform-origin: 0 0;
    opacity: 1;
  }
  to {
    transform: scaleX(0.8);
    transform-origin: 0 0;
    opacity: 0;
  }
}
@keyframes antSlideRightIn {
  0% {
    transform: scaleX(0.8);
    transform-origin: 100% 0;
    opacity: 0;
  }
  to {
    transform: scaleX(1);
    transform-origin: 100% 0;
    opacity: 1;
  }
}
@keyframes antSlideRightOut {
  0% {
    transform: scaleX(1);
    transform-origin: 100% 0;
    opacity: 1;
  }
  to {
    transform: scaleX(0.8);
    transform-origin: 100% 0;
    opacity: 0;
  }
}
.ant-zoom-appear, .ant-zoom-enter, .ant-zoom-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.ant-zoom-appear.ant-zoom-appear-active, .ant-zoom-enter.ant-zoom-enter-active {
  animation-name: antZoomIn;
  animation-play-state: running;
}

.ant-zoom-leave.ant-zoom-leave-active {
  animation-name: antZoomOut;
  animation-play-state: running;
  pointer-events: none;
}

.ant-zoom-appear, .ant-zoom-enter {
  transform: scale(0);
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}

.ant-zoom-appear-prepare, .ant-zoom-enter-prepare {
  transform: none;
}

.ant-zoom-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}

.ant-zoom-big-appear, .ant-zoom-big-enter, .ant-zoom-big-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.ant-zoom-big-appear.ant-zoom-big-appear-active, .ant-zoom-big-enter.ant-zoom-big-enter-active {
  animation-name: antZoomBigIn;
  animation-play-state: running;
}

.ant-zoom-big-leave.ant-zoom-big-leave-active {
  animation-name: antZoomBigOut;
  animation-play-state: running;
  pointer-events: none;
}

.ant-zoom-big-appear, .ant-zoom-big-enter {
  transform: scale(0);
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}

.ant-zoom-big-appear-prepare, .ant-zoom-big-enter-prepare {
  transform: none;
}

.ant-zoom-big-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}

.ant-zoom-big-fast-appear, .ant-zoom-big-fast-enter, .ant-zoom-big-fast-leave {
  animation-duration: 0.1s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.ant-zoom-big-fast-appear.ant-zoom-big-fast-appear-active, .ant-zoom-big-fast-enter.ant-zoom-big-fast-enter-active {
  animation-name: antZoomBigIn;
  animation-play-state: running;
}

.ant-zoom-big-fast-leave.ant-zoom-big-fast-leave-active {
  animation-name: antZoomBigOut;
  animation-play-state: running;
  pointer-events: none;
}

.ant-zoom-big-fast-appear, .ant-zoom-big-fast-enter {
  transform: scale(0);
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}

.ant-zoom-big-fast-appear-prepare, .ant-zoom-big-fast-enter-prepare {
  transform: none;
}

.ant-zoom-big-fast-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}

.ant-zoom-up-appear, .ant-zoom-up-enter, .ant-zoom-up-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.ant-zoom-up-appear.ant-zoom-up-appear-active, .ant-zoom-up-enter.ant-zoom-up-enter-active {
  animation-name: antZoomUpIn;
  animation-play-state: running;
}

.ant-zoom-up-leave.ant-zoom-up-leave-active {
  animation-name: antZoomUpOut;
  animation-play-state: running;
  pointer-events: none;
}

.ant-zoom-up-appear, .ant-zoom-up-enter {
  transform: scale(0);
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}

.ant-zoom-up-appear-prepare, .ant-zoom-up-enter-prepare {
  transform: none;
}

.ant-zoom-up-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}

.ant-zoom-down-appear, .ant-zoom-down-enter, .ant-zoom-down-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.ant-zoom-down-appear.ant-zoom-down-appear-active, .ant-zoom-down-enter.ant-zoom-down-enter-active {
  animation-name: antZoomDownIn;
  animation-play-state: running;
}

.ant-zoom-down-leave.ant-zoom-down-leave-active {
  animation-name: antZoomDownOut;
  animation-play-state: running;
  pointer-events: none;
}

.ant-zoom-down-appear, .ant-zoom-down-enter {
  transform: scale(0);
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}

.ant-zoom-down-appear-prepare, .ant-zoom-down-enter-prepare {
  transform: none;
}

.ant-zoom-down-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}

.ant-zoom-left-appear, .ant-zoom-left-enter, .ant-zoom-left-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.ant-zoom-left-appear.ant-zoom-left-appear-active, .ant-zoom-left-enter.ant-zoom-left-enter-active {
  animation-name: antZoomLeftIn;
  animation-play-state: running;
}

.ant-zoom-left-leave.ant-zoom-left-leave-active {
  animation-name: antZoomLeftOut;
  animation-play-state: running;
  pointer-events: none;
}

.ant-zoom-left-appear, .ant-zoom-left-enter {
  transform: scale(0);
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}

.ant-zoom-left-appear-prepare, .ant-zoom-left-enter-prepare {
  transform: none;
}

.ant-zoom-left-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}

.ant-zoom-right-appear, .ant-zoom-right-enter, .ant-zoom-right-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.ant-zoom-right-appear.ant-zoom-right-appear-active, .ant-zoom-right-enter.ant-zoom-right-enter-active {
  animation-name: antZoomRightIn;
  animation-play-state: running;
}

.ant-zoom-right-leave.ant-zoom-right-leave-active {
  animation-name: antZoomRightOut;
  animation-play-state: running;
  pointer-events: none;
}

.ant-zoom-right-appear, .ant-zoom-right-enter {
  transform: scale(0);
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}

.ant-zoom-right-appear-prepare, .ant-zoom-right-enter-prepare {
  transform: none;
}

.ant-zoom-right-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}

@keyframes antZoomIn {
  0% {
    transform: scale(0.2);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes antZoomOut {
  0% {
    transform: scale(1);
  }
  to {
    transform: scale(0.2);
    opacity: 0;
  }
}
@keyframes antZoomBigIn {
  0% {
    transform: scale(0.8);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes antZoomBigOut {
  0% {
    transform: scale(1);
  }
  to {
    transform: scale(0.8);
    opacity: 0;
  }
}
@keyframes antZoomUpIn {
  0% {
    transform: scale(0.8);
    transform-origin: 50% 0;
    opacity: 0;
  }
  to {
    transform: scale(1);
    transform-origin: 50% 0;
  }
}
@keyframes antZoomUpOut {
  0% {
    transform: scale(1);
    transform-origin: 50% 0;
  }
  to {
    transform: scale(0.8);
    transform-origin: 50% 0;
    opacity: 0;
  }
}
@keyframes antZoomLeftIn {
  0% {
    transform: scale(0.8);
    transform-origin: 0 50%;
    opacity: 0;
  }
  to {
    transform: scale(1);
    transform-origin: 0 50%;
  }
}
@keyframes antZoomLeftOut {
  0% {
    transform: scale(1);
    transform-origin: 0 50%;
  }
  to {
    transform: scale(0.8);
    transform-origin: 0 50%;
    opacity: 0;
  }
}
@keyframes antZoomRightIn {
  0% {
    transform: scale(0.8);
    transform-origin: 100% 50%;
    opacity: 0;
  }
  to {
    transform: scale(1);
    transform-origin: 100% 50%;
  }
}
@keyframes antZoomRightOut {
  0% {
    transform: scale(1);
    transform-origin: 100% 50%;
  }
  to {
    transform: scale(0.8);
    transform-origin: 100% 50%;
    opacity: 0;
  }
}
@keyframes antZoomDownIn {
  0% {
    transform: scale(0.8);
    transform-origin: 50% 100%;
    opacity: 0;
  }
  to {
    transform: scale(1);
    transform-origin: 50% 100%;
  }
}
@keyframes antZoomDownOut {
  0% {
    transform: scale(1);
    transform-origin: 50% 100%;
  }
  to {
    transform: scale(0.8);
    transform-origin: 50% 100%;
    opacity: 0;
  }
}
.ant-motion-collapse-legacy {
  overflow: hidden;
}

.ant-motion-collapse, .ant-motion-collapse-legacy-active {
  transition: height 0.2s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.2s cubic-bezier(0.645, 0.045, 0.355, 1) !important;
}

.ant-motion-collapse {
  overflow: hidden;
}

.ant-affix {
  position: fixed;
  z-index: 10;
}

.ant-alert {
  box-sizing: border-box;
  margin: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  display: flex;
  align-items: center;
  padding: 8px 15px;
  word-wrap: break-word;
  border-radius: 2px;
}

.ant-alert-content {
  flex: 1;
  min-width: 0;
}

.ant-alert-icon {
  margin-right: 8px;
}

.ant-alert-description {
  display: none;
  font-size: 14px;
  line-height: 22px;
}

.ant-alert-success {
  background-color: #f6ffed;
  border: 1px solid #b7eb8f;
}

.ant-alert-success .ant-alert-icon {
  color: #52c41a;
}

.ant-alert-info {
  background-color: #e6f7ff;
  border: 1px solid #91d5ff;
}

.ant-alert-info .ant-alert-icon {
  color: #1890ff;
}

.ant-alert-warning {
  background-color: #fffbe6;
  border: 1px solid #ffe58f;
}

.ant-alert-warning .ant-alert-icon {
  color: #faad14;
}

.ant-alert-error {
  background-color: #fff2f0;
  border: 1px solid #ffccc7;
}

.ant-alert-error .ant-alert-icon {
  color: #ff4d4f;
}

.ant-alert-error .ant-alert-description > pre {
  margin: 0;
  padding: 0;
}

.ant-alert-action {
  margin-left: 8px;
}

.ant-alert-close-icon {
  margin-left: 8px;
  padding: 0;
  overflow: hidden;
  font-size: 12px;
  line-height: 12px;
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
}

.ant-alert-close-icon .anticon-close {
  color: rgba(0, 0, 0, 0.45);
  transition: color 0.3s;
}

.ant-alert-close-icon .anticon-close:hover {
  color: rgba(0, 0, 0, 0.75);
}

.ant-alert-close-text {
  color: rgba(0, 0, 0, 0.45);
  transition: color 0.3s;
}

.ant-alert-close-text:hover {
  color: rgba(0, 0, 0, 0.75);
}

.ant-alert-with-description {
  align-items: flex-start;
  padding: 15px 15px 15px 24px;
}

.ant-alert-with-description.ant-alert-no-icon {
  padding: 15px;
}

.ant-alert-with-description .ant-alert-icon {
  margin-right: 15px;
  font-size: 24px;
}

.ant-alert-with-description .ant-alert-message {
  display: block;
  margin-bottom: 4px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 16px;
}

.ant-alert-message {
  color: rgba(0, 0, 0, 0.85);
}

.ant-alert-with-description .ant-alert-description {
  display: block;
}

.ant-alert.ant-alert-motion-leave {
  overflow: hidden;
  opacity: 1;
  transition: max-height 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86), opacity 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86), padding-top 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86), padding-bottom 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86), margin-bottom 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
}

.ant-alert.ant-alert-motion-leave-active {
  max-height: 0;
  margin-bottom: 0 !important;
  padding-top: 0;
  padding-bottom: 0;
  opacity: 0;
}

.ant-alert-banner {
  margin-bottom: 0;
  border: 0;
  border-radius: 0;
}

.ant-alert.ant-alert-rtl {
  direction: rtl;
}

.ant-alert-rtl .ant-alert-icon {
  margin-right: auto;
  margin-left: 8px;
}

.ant-alert-rtl .ant-alert-action, .ant-alert-rtl .ant-alert-close-icon {
  margin-right: 8px;
  margin-left: auto;
}

.ant-alert-rtl.ant-alert-with-description {
  padding-right: 24px;
  padding-left: 15px;
}

.ant-alert-rtl.ant-alert-with-description .ant-alert-icon {
  margin-right: auto;
  margin-left: 15px;
}

.ant-anchor {
  box-sizing: border-box;
  margin: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  padding: 0 0 0 2px;
}

.ant-anchor-wrapper {
  margin-left: -4px;
  padding-left: 4px;
  overflow: auto;
  background-color: transparent;
}

.ant-anchor-ink {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
}

.ant-anchor-ink:before {
  position: relative;
  display: block;
  width: 2px;
  height: 100%;
  margin: 0 auto;
  background-color: #f0f0f0;
  content: " ";
}

.ant-anchor-ink-ball {
  position: absolute;
  left: 50%;
  display: none;
  width: 8px;
  height: 8px;
  background-color: #fff;
  border: 2px solid #1890ff;
  border-radius: 8px;
  transform: translateX(-50%);
  transition: top 0.3s ease-in-out;
}

.ant-anchor-ink-ball.ant-anchor-ink-ball-visible {
  display: inline-block;
}

.ant-anchor-fixed .ant-anchor-ink .ant-anchor-ink-ball {
  display: none;
}

.ant-anchor-link {
  padding: 4px 0 4px 16px;
}

.ant-anchor-link-title {
  position: relative;
  display: block;
  margin-bottom: 3px;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.85);
  white-space: nowrap;
  text-overflow: ellipsis;
  transition: all 0.3s;
}

.ant-anchor-link-title:only-child {
  margin-bottom: 0;
}

.ant-anchor-link-active > .ant-anchor-link-title {
  color: #1890ff;
}

.ant-anchor-link .ant-anchor-link {
  padding-top: 2px;
  padding-bottom: 2px;
}

.ant-anchor-rtl {
  direction: rtl;
}

.ant-anchor-rtl.ant-anchor-wrapper {
  margin-right: -4px;
  margin-left: 0;
  padding-right: 4px;
  padding-left: 0;
}

.ant-anchor-rtl .ant-anchor-ink {
  right: 0;
  left: auto;
}

.ant-anchor-rtl .ant-anchor-ink-ball {
  right: 50%;
  left: 0;
  transform: translateX(50%);
}

.ant-anchor-rtl .ant-anchor-link {
  padding: 4px 16px 4px 0;
}

.ant-select-auto-complete {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
}

.ant-select-auto-complete .ant-select-clear {
  right: 13px;
}

.ant-avatar {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  display: inline-block;
  overflow: hidden;
  color: #fff;
  white-space: nowrap;
  text-align: center;
  vertical-align: middle;
  background: #ccc;
  width: 32px;
  height: 32px;
  line-height: 32px;
  border-radius: 50%;
}

.ant-avatar-image {
  background: transparent;
}

.ant-avatar .ant-image-img {
  display: block;
}

.ant-avatar-string {
  position: absolute;
  left: 50%;
  transform-origin: 0 center;
}

.ant-avatar.ant-avatar-icon {
  font-size: 18px;
}

.ant-avatar.ant-avatar-icon > .anticon {
  margin: 0;
}

.ant-avatar-lg {
  width: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 50%;
}

.ant-avatar-lg-string {
  position: absolute;
  left: 50%;
  transform-origin: 0 center;
}

.ant-avatar-lg.ant-avatar-icon {
  font-size: 24px;
}

.ant-avatar-lg.ant-avatar-icon > .anticon {
  margin: 0;
}

.ant-avatar-sm {
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 50%;
}

.ant-avatar-sm-string {
  position: absolute;
  left: 50%;
  transform-origin: 0 center;
}

.ant-avatar-sm.ant-avatar-icon {
  font-size: 14px;
}

.ant-avatar-sm.ant-avatar-icon > .anticon {
  margin: 0;
}

.ant-avatar-square {
  border-radius: 2px;
}

.ant-avatar > img {
  display: block;
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
}

.ant-avatar-group {
  display: inline-flex;
}

.ant-avatar-group .ant-avatar {
  border: 1px solid #fff;
}

.ant-avatar-group .ant-avatar:not(:first-child) {
  margin-left: -8px;
}

.ant-avatar-group-popover .ant-avatar + .ant-avatar {
  margin-left: 3px;
}

.ant-avatar-group-rtl .ant-avatar:not(:first-child) {
  margin-right: -8px;
  margin-left: 0;
}

.ant-avatar-group-popover.ant-popover-rtl .ant-avatar + .ant-avatar {
  margin-right: 3px;
  margin-left: 0;
}

.ant-back-top {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: fixed;
  right: 100px;
  bottom: 50px;
  z-index: 10;
  width: 40px;
  height: 40px;
  cursor: pointer;
}

.ant-back-top:empty {
  display: none;
}

.ant-back-top-rtl {
  right: auto;
  left: 100px;
  direction: rtl;
}

.ant-back-top-content {
  width: 40px;
  height: 40px;
  overflow: hidden;
  color: #fff;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.45);
  border-radius: 20px;
  transition: all 0.3s;
}

.ant-back-top-content:hover {
  background-color: rgba(0, 0, 0, 0.85);
  transition: all 0.3s;
}

.ant-back-top-icon {
  font-size: 24px;
  line-height: 40px;
}

@media screen and (max-width: 768px) {
  .ant-back-top {
    right: 60px;
  }
  .ant-back-top-rtl {
    right: auto;
    left: 60px;
  }
}
@media screen and (max-width: 480px) {
  .ant-back-top {
    right: 20px;
  }
  .ant-back-top-rtl {
    right: auto;
    left: 20px;
  }
}
.ant-badge {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  display: inline-block;
  line-height: 1;
}

.ant-badge-count {
  z-index: auto;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  color: #fff;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
  text-align: center;
  background: #ff4d4f;
  border-radius: 10px;
  box-shadow: 0 0 0 1px #fff;
}

.ant-badge-count a, .ant-badge-count a:hover {
  color: #fff;
}

.ant-badge-count-sm {
  min-width: 14px;
  height: 14px;
  padding: 0;
  font-size: 12px;
  line-height: 14px;
  border-radius: 7px;
}

.ant-badge-multiple-words {
  padding: 0 8px;
}

.ant-badge-dot {
  z-index: auto;
  width: 6px;
  min-width: 6px;
  height: 6px;
  background: #ff4d4f;
  border-radius: 100%;
  box-shadow: 0 0 0 1px #fff;
}

.ant-badge-dot.ant-scroll-number {
  transition: background 1.5s;
}

.ant-badge-count, .ant-badge-dot, .ant-badge .ant-scroll-number-custom-component {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
  transform-origin: 100% 0;
}

.ant-badge-count.anticon-spin, .ant-badge-dot.anticon-spin, .ant-badge .ant-scroll-number-custom-component.anticon-spin {
  animation: antBadgeLoadingCircle 1s linear infinite;
}

.ant-badge-status {
  line-height: inherit;
  vertical-align: baseline;
}

.ant-badge-status-dot {
  position: relative;
  top: -1px;
  display: inline-block;
  width: 6px;
  height: 6px;
  vertical-align: middle;
  border-radius: 50%;
}

.ant-badge-status-success {
  background-color: #52c41a;
}

.ant-badge-status-processing {
  position: relative;
  background-color: #1890ff;
}

.ant-badge-status-processing:after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid #1890ff;
  border-radius: 50%;
  animation: antStatusProcessing 1.2s ease-in-out infinite;
  content: "";
}

.ant-badge-status-default {
  background-color: #d9d9d9;
}

.ant-badge-status-error {
  background-color: #ff4d4f;
}

.ant-badge-status-warning {
  background-color: #faad14;
}

.ant-badge-status-magenta, .ant-badge-status-pink {
  background: #eb2f96;
}

.ant-badge-status-red {
  background: #f5222d;
}

.ant-badge-status-volcano {
  background: #fa541c;
}

.ant-badge-status-orange {
  background: #fa8c16;
}

.ant-badge-status-yellow {
  background: #fadb14;
}

.ant-badge-status-gold {
  background: #faad14;
}

.ant-badge-status-cyan {
  background: #13c2c2;
}

.ant-badge-status-lime {
  background: #a0d911;
}

.ant-badge-status-green {
  background: #52c41a;
}

.ant-badge-status-blue {
  background: #1890ff;
}

.ant-badge-status-geekblue {
  background: #2f54eb;
}

.ant-badge-status-purple {
  background: #722ed1;
}

.ant-badge-status-text {
  margin-left: 8px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
}

.ant-badge-zoom-appear, .ant-badge-zoom-enter {
  animation: antZoomBadgeIn 0.3s cubic-bezier(0.12, 0.4, 0.29, 1.46);
  animation-fill-mode: both;
}

.ant-badge-zoom-leave {
  animation: antZoomBadgeOut 0.3s cubic-bezier(0.71, -0.46, 0.88, 0.6);
  animation-fill-mode: both;
}

.ant-badge-not-a-wrapper .ant-badge-zoom-appear, .ant-badge-not-a-wrapper .ant-badge-zoom-enter {
  animation: antNoWrapperZoomBadgeIn 0.3s cubic-bezier(0.12, 0.4, 0.29, 1.46);
}

.ant-badge-not-a-wrapper .ant-badge-zoom-leave {
  animation: antNoWrapperZoomBadgeOut 0.3s cubic-bezier(0.71, -0.46, 0.88, 0.6);
}

.ant-badge-not-a-wrapper:not(.ant-badge-status) {
  vertical-align: middle;
}

.ant-badge-not-a-wrapper .ant-badge-count, .ant-badge-not-a-wrapper .ant-scroll-number-custom-component {
  transform: none;
}

.ant-badge-not-a-wrapper .ant-scroll-number, .ant-badge-not-a-wrapper .ant-scroll-number-custom-component {
  position: relative;
  top: auto;
  display: block;
  transform-origin: 50% 50%;
}

@keyframes antStatusProcessing {
  0% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  to {
    transform: scale(2.4);
    opacity: 0;
  }
}
.ant-scroll-number {
  overflow: hidden;
  direction: ltr;
}

.ant-scroll-number-only {
  position: relative;
  display: inline-block;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-scroll-number-only, .ant-scroll-number-only > p.ant-scroll-number-only-unit {
  height: 20px;
  -webkit-transform-style: preserve-3d;
  -webkit-backface-visibility: hidden;
}

.ant-scroll-number-only > p.ant-scroll-number-only-unit {
  margin: 0;
}

.ant-scroll-number-symbol {
  vertical-align: top;
}

@keyframes antZoomBadgeIn {
  0% {
    transform: scale(0) translate(50%, -50%);
    opacity: 0;
  }
  to {
    transform: scale(1) translate(50%, -50%);
  }
}
@keyframes antZoomBadgeOut {
  0% {
    transform: scale(1) translate(50%, -50%);
  }
  to {
    transform: scale(0) translate(50%, -50%);
    opacity: 0;
  }
}
@keyframes antNoWrapperZoomBadgeIn {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1);
  }
}
@keyframes antNoWrapperZoomBadgeOut {
  0% {
    transform: scale(1);
  }
  to {
    transform: scale(0);
    opacity: 0;
  }
}
@keyframes antBadgeLoadingCircle {
  0% {
    transform-origin: 50%;
  }
  to {
    transform: translate(50%, -50%) rotate(1turn);
    transform-origin: 50%;
  }
}
.ant-ribbon-wrapper {
  position: relative;
}

.ant-ribbon {
  box-sizing: border-box;
  margin: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: absolute;
  top: 8px;
  height: 22px;
  padding: 0 8px;
  color: #fff;
  line-height: 22px;
  white-space: nowrap;
  background-color: #1890ff;
  border-radius: 2px;
}

.ant-ribbon-text {
  color: #fff;
}

.ant-ribbon-corner {
  position: absolute;
  top: 100%;
  width: 8px;
  height: 8px;
  color: currentcolor;
  border: 4px solid;
  transform: scaleY(0.75);
  transform-origin: top;
}

.ant-ribbon-corner:after {
  position: absolute;
  top: -4px;
  left: -4px;
  width: inherit;
  height: inherit;
  color: rgba(0, 0, 0, 0.25);
  border: inherit;
  content: "";
}

.ant-ribbon-color-magenta, .ant-ribbon-color-pink {
  color: #eb2f96;
  background: #eb2f96;
}

.ant-ribbon-color-red {
  color: #f5222d;
  background: #f5222d;
}

.ant-ribbon-color-volcano {
  color: #fa541c;
  background: #fa541c;
}

.ant-ribbon-color-orange {
  color: #fa8c16;
  background: #fa8c16;
}

.ant-ribbon-color-yellow {
  color: #fadb14;
  background: #fadb14;
}

.ant-ribbon-color-gold {
  color: #faad14;
  background: #faad14;
}

.ant-ribbon-color-cyan {
  color: #13c2c2;
  background: #13c2c2;
}

.ant-ribbon-color-lime {
  color: #a0d911;
  background: #a0d911;
}

.ant-ribbon-color-green {
  color: #52c41a;
  background: #52c41a;
}

.ant-ribbon-color-blue {
  color: #1890ff;
  background: #1890ff;
}

.ant-ribbon-color-geekblue {
  color: #2f54eb;
  background: #2f54eb;
}

.ant-ribbon-color-purple {
  color: #722ed1;
  background: #722ed1;
}

.ant-ribbon.ant-ribbon-placement-end {
  right: -8px;
  border-bottom-right-radius: 0;
}

.ant-ribbon.ant-ribbon-placement-end .ant-ribbon-corner {
  right: 0;
  border-color: currentcolor transparent transparent currentcolor;
}

.ant-ribbon.ant-ribbon-placement-start {
  left: -8px;
  border-bottom-left-radius: 0;
}

.ant-ribbon.ant-ribbon-placement-start .ant-ribbon-corner {
  left: 0;
  border-color: currentcolor currentcolor transparent transparent;
}

.ant-badge-rtl {
  direction: rtl;
}

.ant-badge-rtl.ant-badge:not(.ant-badge-not-a-wrapper) .ant-badge-count, .ant-badge-rtl.ant-badge:not(.ant-badge-not-a-wrapper) .ant-badge-dot, .ant-badge-rtl.ant-badge:not(.ant-badge-not-a-wrapper) .ant-scroll-number-custom-component {
  right: auto;
  left: 0;
  direction: ltr;
  transform: translate(-50%, -50%);
  transform-origin: 0 0;
}

.ant-badge-rtl.ant-badge:not(.ant-badge-not-a-wrapper) .ant-scroll-number-custom-component {
  right: auto;
  left: 0;
  transform: translate(-50%, -50%);
  transform-origin: 0 0;
}

.ant-badge-rtl .ant-badge-status-text {
  margin-right: 8px;
  margin-left: 0;
}

.ant-badge:not(.ant-badge-not-a-wrapper).ant-badge-rtl .ant-badge-zoom-appear, .ant-badge:not(.ant-badge-not-a-wrapper).ant-badge-rtl .ant-badge-zoom-enter {
  animation-name: antZoomBadgeInRtl;
}

.ant-badge:not(.ant-badge-not-a-wrapper).ant-badge-rtl .ant-badge-zoom-leave {
  animation-name: antZoomBadgeOutRtl;
}

.ant-ribbon-rtl {
  direction: rtl;
}

.ant-ribbon-rtl.ant-ribbon-placement-end {
  right: unset;
  left: -8px;
  border-bottom-right-radius: 2px;
  border-bottom-left-radius: 0;
}

.ant-ribbon-rtl.ant-ribbon-placement-end .ant-ribbon-corner {
  right: unset;
  left: 0;
}

.ant-ribbon-rtl.ant-ribbon-placement-end .ant-ribbon-corner, .ant-ribbon-rtl.ant-ribbon-placement-end .ant-ribbon-corner:after {
  border-color: currentcolor currentcolor transparent transparent;
}

.ant-ribbon-rtl.ant-ribbon-placement-start {
  right: -8px;
  left: unset;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 2px;
}

.ant-ribbon-rtl.ant-ribbon-placement-start .ant-ribbon-corner {
  right: 0;
  left: unset;
}

.ant-ribbon-rtl.ant-ribbon-placement-start .ant-ribbon-corner, .ant-ribbon-rtl.ant-ribbon-placement-start .ant-ribbon-corner:after {
  border-color: currentcolor transparent transparent currentcolor;
}

@keyframes antZoomBadgeInRtl {
  0% {
    transform: scale(0) translate(-50%, -50%);
    opacity: 0;
  }
  to {
    transform: scale(1) translate(-50%, -50%);
  }
}
@keyframes antZoomBadgeOutRtl {
  0% {
    transform: scale(1) translate(-50%, -50%);
  }
  to {
    transform: scale(0) translate(-50%, -50%);
    opacity: 0;
  }
}
.ant-breadcrumb {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
}

.ant-breadcrumb .anticon {
  font-size: 14px;
}

.ant-breadcrumb ol {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  list-style: none;
}

.ant-breadcrumb a {
  color: rgba(0, 0, 0, 0.45);
  transition: color 0.3s;
}

.ant-breadcrumb a:hover, .ant-breadcrumb li:last-child, .ant-breadcrumb li:last-child a {
  color: rgba(0, 0, 0, 0.85);
}

li:last-child > .ant-breadcrumb-separator {
  display: none;
}

.ant-breadcrumb-separator {
  margin: 0 8px;
  color: rgba(0, 0, 0, 0.45);
}

.ant-breadcrumb-link > .anticon + a, .ant-breadcrumb-link > .anticon + span, .ant-breadcrumb-overlay-link > .anticon {
  margin-left: 4px;
}

.ant-breadcrumb-rtl {
  direction: rtl;
}

.ant-breadcrumb-rtl:before {
  display: table;
  content: "";
}

.ant-breadcrumb-rtl:after {
  display: table;
  clear: both;
  content: "";
}

.ant-breadcrumb-rtl > span {
  float: right;
}

.ant-breadcrumb-rtl .ant-breadcrumb-link > .anticon + a, .ant-breadcrumb-rtl .ant-breadcrumb-link > .anticon + span, .ant-breadcrumb-rtl .ant-breadcrumb-overlay-link > .anticon {
  margin-right: 4px;
  margin-left: 0;
}

.ant-btn {
  line-height: 1.5715;
  position: relative;
  display: inline-block;
  font-weight: 400;
  white-space: nowrap;
  text-align: center;
  background-image: none;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  touch-action: manipulation;
  height: 32px;
  padding: 4px 15px;
  font-size: 14px;
  border-radius: 2px;
  color: rgba(0, 0, 0, 0.85);
  border: 1px solid #d9d9d9;
  background: #fff;
}

.ant-btn > .anticon {
  line-height: 1;
}

.ant-btn, .ant-btn:active, .ant-btn:focus {
  outline: 0;
}

.ant-btn:not([disabled]):hover {
  text-decoration: none;
}

.ant-btn:not([disabled]):active {
  outline: 0;
  box-shadow: none;
}

.ant-btn[disabled] {
  cursor: not-allowed;
}

.ant-btn[disabled] > * {
  pointer-events: none;
}

.ant-btn-lg {
  height: 40px;
  padding: 6.4px 15px;
  font-size: 16px;
  border-radius: 2px;
}

.ant-btn-sm {
  height: 24px;
  padding: 0 7px;
  font-size: 14px;
  border-radius: 2px;
}

.ant-btn > a:only-child {
  color: currentcolor;
}

.ant-btn > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn:focus, .ant-btn:hover {
  color: #40a9ff;
  border-color: #40a9ff;
  background: #fff;
}

.ant-btn:focus > a:only-child, .ant-btn:hover > a:only-child {
  color: currentcolor;
}

.ant-btn:focus > a:only-child:after, .ant-btn:hover > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn:active {
  color: #096dd9;
  border-color: #096dd9;
  background: #fff;
}

.ant-btn:active > a:only-child {
  color: currentcolor;
}

.ant-btn:active > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn[disabled], .ant-btn[disabled]:active, .ant-btn[disabled]:focus, .ant-btn[disabled]:hover {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}

.ant-btn[disabled]:active > a:only-child, .ant-btn[disabled]:focus > a:only-child, .ant-btn[disabled]:hover > a:only-child, .ant-btn[disabled] > a:only-child {
  color: currentcolor;
}

.ant-btn[disabled]:active > a:only-child:after, .ant-btn[disabled]:focus > a:only-child:after, .ant-btn[disabled]:hover > a:only-child:after, .ant-btn[disabled] > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn:active, .ant-btn:focus, .ant-btn:hover {
  text-decoration: none;
  background: #fff;
}

.ant-btn > span {
  display: inline-block;
}

.ant-btn-primary {
  color: #fff;
  border-color: #1890ff;
  background: #1890ff;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
}

.ant-btn-primary > a:only-child {
  color: currentcolor;
}

.ant-btn-primary > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-primary:focus, .ant-btn-primary:hover {
  color: #fff;
  border-color: #40a9ff;
  background: #40a9ff;
}

.ant-btn-primary:focus > a:only-child, .ant-btn-primary:hover > a:only-child {
  color: currentcolor;
}

.ant-btn-primary:focus > a:only-child:after, .ant-btn-primary:hover > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-primary:active {
  color: #fff;
  border-color: #096dd9;
  background: #096dd9;
}

.ant-btn-primary:active > a:only-child {
  color: currentcolor;
}

.ant-btn-primary:active > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-primary[disabled], .ant-btn-primary[disabled]:active, .ant-btn-primary[disabled]:focus, .ant-btn-primary[disabled]:hover {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}

.ant-btn-primary[disabled]:active > a:only-child, .ant-btn-primary[disabled]:focus > a:only-child, .ant-btn-primary[disabled]:hover > a:only-child, .ant-btn-primary[disabled] > a:only-child {
  color: currentcolor;
}

.ant-btn-primary[disabled]:active > a:only-child:after, .ant-btn-primary[disabled]:focus > a:only-child:after, .ant-btn-primary[disabled]:hover > a:only-child:after, .ant-btn-primary[disabled] > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-group .ant-btn-primary:not(:first-child):not(:last-child) {
  border-right-color: #40a9ff;
  border-left-color: #40a9ff;
}

.ant-btn-group .ant-btn-primary:not(:first-child):not(:last-child):disabled {
  border-color: #d9d9d9;
}

.ant-btn-group .ant-btn-primary:first-child:not(:last-child) {
  border-right-color: #40a9ff;
}

.ant-btn-group .ant-btn-primary:first-child:not(:last-child)[disabled] {
  border-right-color: #d9d9d9;
}

.ant-btn-group .ant-btn-primary + .ant-btn-primary, .ant-btn-group .ant-btn-primary:last-child:not(:first-child) {
  border-left-color: #40a9ff;
}

.ant-btn-group .ant-btn-primary + .ant-btn-primary[disabled], .ant-btn-group .ant-btn-primary:last-child:not(:first-child)[disabled] {
  border-left-color: #d9d9d9;
}

.ant-btn-ghost {
  color: rgba(0, 0, 0, 0.85);
  border-color: #d9d9d9;
  background: transparent;
}

.ant-btn-ghost > a:only-child {
  color: currentcolor;
}

.ant-btn-ghost > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-ghost:focus, .ant-btn-ghost:hover {
  color: #40a9ff;
  border-color: #40a9ff;
  background: transparent;
}

.ant-btn-ghost:focus > a:only-child, .ant-btn-ghost:hover > a:only-child {
  color: currentcolor;
}

.ant-btn-ghost:focus > a:only-child:after, .ant-btn-ghost:hover > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-ghost:active {
  color: #096dd9;
  border-color: #096dd9;
  background: transparent;
}

.ant-btn-ghost:active > a:only-child {
  color: currentcolor;
}

.ant-btn-ghost:active > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-ghost[disabled], .ant-btn-ghost[disabled]:active, .ant-btn-ghost[disabled]:focus, .ant-btn-ghost[disabled]:hover {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}

.ant-btn-ghost[disabled]:active > a:only-child, .ant-btn-ghost[disabled]:focus > a:only-child, .ant-btn-ghost[disabled]:hover > a:only-child, .ant-btn-ghost[disabled] > a:only-child {
  color: currentcolor;
}

.ant-btn-ghost[disabled]:active > a:only-child:after, .ant-btn-ghost[disabled]:focus > a:only-child:after, .ant-btn-ghost[disabled]:hover > a:only-child:after, .ant-btn-ghost[disabled] > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-dashed {
  color: rgba(0, 0, 0, 0.85);
  border-color: #d9d9d9;
  background: #fff;
  border-style: dashed;
}

.ant-btn-dashed > a:only-child {
  color: currentcolor;
}

.ant-btn-dashed > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-dashed:focus, .ant-btn-dashed:hover {
  color: #40a9ff;
  border-color: #40a9ff;
  background: #fff;
}

.ant-btn-dashed:focus > a:only-child, .ant-btn-dashed:hover > a:only-child {
  color: currentcolor;
}

.ant-btn-dashed:focus > a:only-child:after, .ant-btn-dashed:hover > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-dashed:active {
  color: #096dd9;
  border-color: #096dd9;
  background: #fff;
}

.ant-btn-dashed:active > a:only-child {
  color: currentcolor;
}

.ant-btn-dashed:active > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-dashed[disabled], .ant-btn-dashed[disabled]:active, .ant-btn-dashed[disabled]:focus, .ant-btn-dashed[disabled]:hover {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}

.ant-btn-dashed[disabled]:active > a:only-child, .ant-btn-dashed[disabled]:focus > a:only-child, .ant-btn-dashed[disabled]:hover > a:only-child, .ant-btn-dashed[disabled] > a:only-child {
  color: currentcolor;
}

.ant-btn-dashed[disabled]:active > a:only-child:after, .ant-btn-dashed[disabled]:focus > a:only-child:after, .ant-btn-dashed[disabled]:hover > a:only-child:after, .ant-btn-dashed[disabled] > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-danger {
  color: #fff;
  border-color: #ff4d4f;
  background: #ff4d4f;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
}

.ant-btn-danger > a:only-child {
  color: currentcolor;
}

.ant-btn-danger > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-danger:focus, .ant-btn-danger:hover {
  color: #fff;
  border-color: #ff7875;
  background: #ff7875;
}

.ant-btn-danger:focus > a:only-child, .ant-btn-danger:hover > a:only-child {
  color: currentcolor;
}

.ant-btn-danger:focus > a:only-child:after, .ant-btn-danger:hover > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-danger:active {
  color: #fff;
  border-color: #d9363e;
  background: #d9363e;
}

.ant-btn-danger:active > a:only-child {
  color: currentcolor;
}

.ant-btn-danger:active > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-danger[disabled], .ant-btn-danger[disabled]:active, .ant-btn-danger[disabled]:focus, .ant-btn-danger[disabled]:hover {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}

.ant-btn-danger[disabled]:active > a:only-child, .ant-btn-danger[disabled]:focus > a:only-child, .ant-btn-danger[disabled]:hover > a:only-child, .ant-btn-danger[disabled] > a:only-child {
  color: currentcolor;
}

.ant-btn-danger[disabled]:active > a:only-child:after, .ant-btn-danger[disabled]:focus > a:only-child:after, .ant-btn-danger[disabled]:hover > a:only-child:after, .ant-btn-danger[disabled] > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-link {
  color: #1890ff;
  border-color: transparent;
  background: transparent;
  box-shadow: none;
}

.ant-btn-link > a:only-child {
  color: currentcolor;
}

.ant-btn-link > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-link:focus, .ant-btn-link:hover {
  color: #40a9ff;
  border-color: #40a9ff;
  background: transparent;
}

.ant-btn-link:focus > a:only-child, .ant-btn-link:hover > a:only-child {
  color: currentcolor;
}

.ant-btn-link:focus > a:only-child:after, .ant-btn-link:hover > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-link:active {
  color: #096dd9;
  border-color: #096dd9;
  background: transparent;
}

.ant-btn-link:active > a:only-child {
  color: currentcolor;
}

.ant-btn-link:active > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-link[disabled], .ant-btn-link[disabled]:active, .ant-btn-link[disabled]:focus, .ant-btn-link[disabled]:hover {
  border-color: #d9d9d9;
  background: #f5f5f5;
}

.ant-btn-link:hover {
  background: transparent;
}

.ant-btn-link:active, .ant-btn-link:focus, .ant-btn-link:hover {
  border-color: transparent;
}

.ant-btn-link[disabled], .ant-btn-link[disabled]:active, .ant-btn-link[disabled]:focus, .ant-btn-link[disabled]:hover {
  color: rgba(0, 0, 0, 0.25);
  border-color: transparent;
  background: transparent;
  text-shadow: none;
  box-shadow: none;
}

.ant-btn-link[disabled]:active > a:only-child, .ant-btn-link[disabled]:focus > a:only-child, .ant-btn-link[disabled]:hover > a:only-child, .ant-btn-link[disabled] > a:only-child {
  color: currentcolor;
}

.ant-btn-link[disabled]:active > a:only-child:after, .ant-btn-link[disabled]:focus > a:only-child:after, .ant-btn-link[disabled]:hover > a:only-child:after, .ant-btn-link[disabled] > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-text {
  color: rgba(0, 0, 0, 0.85);
  border-color: transparent;
  background: transparent;
  box-shadow: none;
}

.ant-btn-text > a:only-child {
  color: currentcolor;
}

.ant-btn-text > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-text:focus, .ant-btn-text:hover {
  color: #40a9ff;
  border-color: #40a9ff;
  background: transparent;
}

.ant-btn-text:focus > a:only-child, .ant-btn-text:hover > a:only-child {
  color: currentcolor;
}

.ant-btn-text:focus > a:only-child:after, .ant-btn-text:hover > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-text:active {
  color: #096dd9;
  border-color: #096dd9;
  background: transparent;
}

.ant-btn-text:active > a:only-child {
  color: currentcolor;
}

.ant-btn-text:active > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-text[disabled], .ant-btn-text[disabled]:active, .ant-btn-text[disabled]:focus, .ant-btn-text[disabled]:hover {
  border-color: #d9d9d9;
  background: #f5f5f5;
}

.ant-btn-text:focus, .ant-btn-text:hover {
  color: rgba(0, 0, 0, 0.85);
  background: rgba(0, 0, 0, 0.018);
  border-color: transparent;
}

.ant-btn-text:active {
  color: rgba(0, 0, 0, 0.85);
  background: rgba(0, 0, 0, 0.028);
  border-color: transparent;
}

.ant-btn-text[disabled], .ant-btn-text[disabled]:active, .ant-btn-text[disabled]:focus, .ant-btn-text[disabled]:hover {
  color: rgba(0, 0, 0, 0.25);
  border-color: transparent;
  background: transparent;
  text-shadow: none;
  box-shadow: none;
}

.ant-btn-text[disabled]:active > a:only-child, .ant-btn-text[disabled]:focus > a:only-child, .ant-btn-text[disabled]:hover > a:only-child, .ant-btn-text[disabled] > a:only-child {
  color: currentcolor;
}

.ant-btn-text[disabled]:active > a:only-child:after, .ant-btn-text[disabled]:focus > a:only-child:after, .ant-btn-text[disabled]:hover > a:only-child:after, .ant-btn-text[disabled] > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-dangerous {
  color: #ff4d4f;
  border-color: #ff4d4f;
  background: #fff;
}

.ant-btn-dangerous > a:only-child {
  color: currentcolor;
}

.ant-btn-dangerous > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-dangerous:focus, .ant-btn-dangerous:hover {
  color: #ff7875;
  border-color: #ff7875;
  background: #fff;
}

.ant-btn-dangerous:focus > a:only-child, .ant-btn-dangerous:hover > a:only-child {
  color: currentcolor;
}

.ant-btn-dangerous:focus > a:only-child:after, .ant-btn-dangerous:hover > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-dangerous:active {
  color: #d9363e;
  border-color: #d9363e;
  background: #fff;
}

.ant-btn-dangerous:active > a:only-child {
  color: currentcolor;
}

.ant-btn-dangerous:active > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-dangerous[disabled], .ant-btn-dangerous[disabled]:active, .ant-btn-dangerous[disabled]:focus, .ant-btn-dangerous[disabled]:hover {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}

.ant-btn-dangerous[disabled]:active > a:only-child, .ant-btn-dangerous[disabled]:focus > a:only-child, .ant-btn-dangerous[disabled]:hover > a:only-child, .ant-btn-dangerous[disabled] > a:only-child {
  color: currentcolor;
}

.ant-btn-dangerous[disabled]:active > a:only-child:after, .ant-btn-dangerous[disabled]:focus > a:only-child:after, .ant-btn-dangerous[disabled]:hover > a:only-child:after, .ant-btn-dangerous[disabled] > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-dangerous.ant-btn-primary {
  color: #fff;
  border-color: #ff4d4f;
  background: #ff4d4f;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
}

.ant-btn-dangerous.ant-btn-primary > a:only-child {
  color: currentcolor;
}

.ant-btn-dangerous.ant-btn-primary > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-dangerous.ant-btn-primary:focus, .ant-btn-dangerous.ant-btn-primary:hover {
  color: #fff;
  border-color: #ff7875;
  background: #ff7875;
}

.ant-btn-dangerous.ant-btn-primary:focus > a:only-child, .ant-btn-dangerous.ant-btn-primary:hover > a:only-child {
  color: currentcolor;
}

.ant-btn-dangerous.ant-btn-primary:focus > a:only-child:after, .ant-btn-dangerous.ant-btn-primary:hover > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-dangerous.ant-btn-primary:active {
  color: #fff;
  border-color: #d9363e;
  background: #d9363e;
}

.ant-btn-dangerous.ant-btn-primary:active > a:only-child {
  color: currentcolor;
}

.ant-btn-dangerous.ant-btn-primary:active > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-dangerous.ant-btn-primary[disabled], .ant-btn-dangerous.ant-btn-primary[disabled]:active, .ant-btn-dangerous.ant-btn-primary[disabled]:focus, .ant-btn-dangerous.ant-btn-primary[disabled]:hover {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}

.ant-btn-dangerous.ant-btn-primary[disabled]:active > a:only-child, .ant-btn-dangerous.ant-btn-primary[disabled]:focus > a:only-child, .ant-btn-dangerous.ant-btn-primary[disabled]:hover > a:only-child, .ant-btn-dangerous.ant-btn-primary[disabled] > a:only-child {
  color: currentcolor;
}

.ant-btn-dangerous.ant-btn-primary[disabled]:active > a:only-child:after, .ant-btn-dangerous.ant-btn-primary[disabled]:focus > a:only-child:after, .ant-btn-dangerous.ant-btn-primary[disabled]:hover > a:only-child:after, .ant-btn-dangerous.ant-btn-primary[disabled] > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-dangerous.ant-btn-link {
  color: #ff4d4f;
  border-color: transparent;
  background: transparent;
  box-shadow: none;
}

.ant-btn-dangerous.ant-btn-link > a:only-child {
  color: currentcolor;
}

.ant-btn-dangerous.ant-btn-link > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-dangerous.ant-btn-link:focus, .ant-btn-dangerous.ant-btn-link:hover {
  color: #40a9ff;
  border-color: #40a9ff;
}

.ant-btn-dangerous.ant-btn-link:active {
  color: #096dd9;
  border-color: #096dd9;
}

.ant-btn-dangerous.ant-btn-link[disabled], .ant-btn-dangerous.ant-btn-link[disabled]:active, .ant-btn-dangerous.ant-btn-link[disabled]:focus, .ant-btn-dangerous.ant-btn-link[disabled]:hover {
  border-color: #d9d9d9;
  background: #f5f5f5;
}

.ant-btn-dangerous.ant-btn-link:focus, .ant-btn-dangerous.ant-btn-link:hover {
  color: #ff7875;
  border-color: transparent;
  background: transparent;
}

.ant-btn-dangerous.ant-btn-link:focus > a:only-child, .ant-btn-dangerous.ant-btn-link:hover > a:only-child {
  color: currentcolor;
}

.ant-btn-dangerous.ant-btn-link:focus > a:only-child:after, .ant-btn-dangerous.ant-btn-link:hover > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-dangerous.ant-btn-link:active {
  color: #d9363e;
  border-color: transparent;
  background: transparent;
}

.ant-btn-dangerous.ant-btn-link:active > a:only-child {
  color: currentcolor;
}

.ant-btn-dangerous.ant-btn-link:active > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-dangerous.ant-btn-link[disabled], .ant-btn-dangerous.ant-btn-link[disabled]:active, .ant-btn-dangerous.ant-btn-link[disabled]:focus, .ant-btn-dangerous.ant-btn-link[disabled]:hover {
  color: rgba(0, 0, 0, 0.25);
  border-color: transparent;
  background: transparent;
  text-shadow: none;
  box-shadow: none;
}

.ant-btn-dangerous.ant-btn-link[disabled]:active > a:only-child, .ant-btn-dangerous.ant-btn-link[disabled]:focus > a:only-child, .ant-btn-dangerous.ant-btn-link[disabled]:hover > a:only-child, .ant-btn-dangerous.ant-btn-link[disabled] > a:only-child {
  color: currentcolor;
}

.ant-btn-dangerous.ant-btn-link[disabled]:active > a:only-child:after, .ant-btn-dangerous.ant-btn-link[disabled]:focus > a:only-child:after, .ant-btn-dangerous.ant-btn-link[disabled]:hover > a:only-child:after, .ant-btn-dangerous.ant-btn-link[disabled] > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-dangerous.ant-btn-text {
  color: #ff4d4f;
  border-color: transparent;
  background: transparent;
  box-shadow: none;
}

.ant-btn-dangerous.ant-btn-text > a:only-child {
  color: currentcolor;
}

.ant-btn-dangerous.ant-btn-text > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-dangerous.ant-btn-text:focus, .ant-btn-dangerous.ant-btn-text:hover {
  color: #40a9ff;
  border-color: #40a9ff;
  background: transparent;
}

.ant-btn-dangerous.ant-btn-text:active {
  color: #096dd9;
  border-color: #096dd9;
  background: transparent;
}

.ant-btn-dangerous.ant-btn-text[disabled], .ant-btn-dangerous.ant-btn-text[disabled]:active, .ant-btn-dangerous.ant-btn-text[disabled]:focus, .ant-btn-dangerous.ant-btn-text[disabled]:hover {
  border-color: #d9d9d9;
  background: #f5f5f5;
}

.ant-btn-dangerous.ant-btn-text:focus, .ant-btn-dangerous.ant-btn-text:hover {
  color: #ff7875;
  border-color: transparent;
  background: rgba(0, 0, 0, 0.018);
}

.ant-btn-dangerous.ant-btn-text:focus > a:only-child, .ant-btn-dangerous.ant-btn-text:hover > a:only-child {
  color: currentcolor;
}

.ant-btn-dangerous.ant-btn-text:focus > a:only-child:after, .ant-btn-dangerous.ant-btn-text:hover > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-dangerous.ant-btn-text:active {
  color: #d9363e;
  border-color: transparent;
  background: rgba(0, 0, 0, 0.028);
}

.ant-btn-dangerous.ant-btn-text:active > a:only-child {
  color: currentcolor;
}

.ant-btn-dangerous.ant-btn-text:active > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-dangerous.ant-btn-text[disabled], .ant-btn-dangerous.ant-btn-text[disabled]:active, .ant-btn-dangerous.ant-btn-text[disabled]:focus, .ant-btn-dangerous.ant-btn-text[disabled]:hover {
  color: rgba(0, 0, 0, 0.25);
  border-color: transparent;
  background: transparent;
  text-shadow: none;
  box-shadow: none;
}

.ant-btn-dangerous.ant-btn-text[disabled]:active > a:only-child, .ant-btn-dangerous.ant-btn-text[disabled]:focus > a:only-child, .ant-btn-dangerous.ant-btn-text[disabled]:hover > a:only-child, .ant-btn-dangerous.ant-btn-text[disabled] > a:only-child {
  color: currentcolor;
}

.ant-btn-dangerous.ant-btn-text[disabled]:active > a:only-child:after, .ant-btn-dangerous.ant-btn-text[disabled]:focus > a:only-child:after, .ant-btn-dangerous.ant-btn-text[disabled]:hover > a:only-child:after, .ant-btn-dangerous.ant-btn-text[disabled] > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-icon-only {
  width: 32px;
  height: 32px;
  padding: 2.4px 0;
  font-size: 16px;
  border-radius: 2px;
  vertical-align: -3px;
}

.ant-btn-icon-only > * {
  font-size: 16px;
}

.ant-btn-icon-only.ant-btn-lg {
  width: 40px;
  height: 40px;
  padding: 4.9px 0;
  font-size: 18px;
  border-radius: 2px;
}

.ant-btn-icon-only.ant-btn-lg > * {
  font-size: 18px;
}

.ant-btn-icon-only.ant-btn-sm {
  width: 24px;
  height: 24px;
  padding: 0;
  font-size: 14px;
  border-radius: 2px;
}

.ant-btn-icon-only.ant-btn-sm > * {
  font-size: 14px;
}

.ant-btn-icon-only > .anticon {
  display: flex;
  justify-content: center;
}

.ant-btn-icon-only .anticon-loading {
  padding: 0 !important;
}

a.ant-btn-icon-only {
  vertical-align: -1px;
}

a.ant-btn-icon-only > .anticon {
  display: inline;
}

.ant-btn-round {
  height: 32px;
  padding: 4px 16px;
  font-size: 14px;
  border-radius: 32px;
}

.ant-btn-round.ant-btn-lg {
  height: 40px;
  padding: 6.4px 20px;
  font-size: 16px;
  border-radius: 40px;
}

.ant-btn-round.ant-btn-sm {
  height: 24px;
  padding: 0 12px;
  font-size: 14px;
  border-radius: 24px;
}

.ant-btn-round.ant-btn-icon-only {
  width: auto;
}

.ant-btn-circle {
  min-width: 32px;
  padding-right: 0;
  padding-left: 0;
  text-align: center;
  border-radius: 50%;
}

.ant-btn-circle.ant-btn-lg {
  min-width: 40px;
  border-radius: 50%;
}

.ant-btn-circle.ant-btn-sm {
  min-width: 24px;
  border-radius: 50%;
}

.ant-btn:before {
  position: absolute;
  top: -1px;
  right: -1px;
  bottom: -1px;
  left: -1px;
  z-index: 1;
  display: none;
  background: #fff;
  border-radius: inherit;
  opacity: 0.35;
  transition: opacity 0.2s;
  content: "";
  pointer-events: none;
}

.ant-btn .anticon {
  transition: margin-left 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-btn .anticon.anticon-minus > svg, .ant-btn .anticon.anticon-plus > svg {
  shape-rendering: optimizespeed;
}

.ant-btn.ant-btn-loading {
  position: relative;
  cursor: default;
}

.ant-btn.ant-btn-loading:before {
  display: block;
}

.ant-btn > .ant-btn-loading-icon {
  transition: width 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-btn > .ant-btn-loading-icon .anticon {
  padding-right: 8px;
  animation: none;
}

.ant-btn > .ant-btn-loading-icon .anticon svg {
  animation: loadingCircle 1s linear infinite;
}

.ant-btn-group {
  display: inline-flex;
}

.ant-btn-group, .ant-btn-group > .ant-btn, .ant-btn-group > span > .ant-btn {
  position: relative;
}

.ant-btn-group > .ant-btn:active, .ant-btn-group > .ant-btn:focus, .ant-btn-group > .ant-btn:hover, .ant-btn-group > span > .ant-btn:active, .ant-btn-group > span > .ant-btn:focus, .ant-btn-group > span > .ant-btn:hover {
  z-index: 2;
}

.ant-btn-group > .ant-btn[disabled], .ant-btn-group > span > .ant-btn[disabled] {
  z-index: 0;
}

.ant-btn-group .ant-btn-icon-only {
  font-size: 14px;
}

.ant-btn + .ant-btn-group, .ant-btn-group + .ant-btn, .ant-btn-group + .ant-btn-group, .ant-btn-group .ant-btn + .ant-btn, .ant-btn-group .ant-btn + span, .ant-btn-group > span + span, .ant-btn-group span + .ant-btn {
  margin-left: -1px;
}

.ant-btn-group .ant-btn-primary + .ant-btn:not(.ant-btn-primary):not([disabled]) {
  border-left-color: transparent;
}

.ant-btn-group .ant-btn {
  border-radius: 0;
}

.ant-btn-group > .ant-btn:first-child, .ant-btn-group > span:first-child > .ant-btn {
  margin-left: 0;
}

.ant-btn-group > .ant-btn:only-child, .ant-btn-group > span:only-child > .ant-btn {
  border-radius: 2px;
}

.ant-btn-group > .ant-btn:first-child:not(:last-child), .ant-btn-group > span:first-child:not(:last-child) > .ant-btn {
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}

.ant-btn-group > .ant-btn:last-child:not(:first-child), .ant-btn-group > span:last-child:not(:first-child) > .ant-btn {
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
}

.ant-btn-group-sm > .ant-btn:only-child, .ant-btn-group-sm > span:only-child > .ant-btn {
  border-radius: 2px;
}

.ant-btn-group-sm > .ant-btn:first-child:not(:last-child), .ant-btn-group-sm > span:first-child:not(:last-child) > .ant-btn {
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}

.ant-btn-group-sm > .ant-btn:last-child:not(:first-child), .ant-btn-group-sm > span:last-child:not(:first-child) > .ant-btn {
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
}

.ant-btn-group > .ant-btn-group {
  float: left;
}

.ant-btn-group > .ant-btn-group:not(:first-child):not(:last-child) > .ant-btn {
  border-radius: 0;
}

.ant-btn-group > .ant-btn-group:first-child:not(:last-child) > .ant-btn:last-child {
  padding-right: 8px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-btn-group > .ant-btn-group:last-child:not(:first-child) > .ant-btn:first-child {
  padding-left: 8px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.ant-btn-group-rtl.ant-btn + .ant-btn-group, .ant-btn-group-rtl.ant-btn-group + .ant-btn, .ant-btn-group-rtl.ant-btn-group + .ant-btn-group, .ant-btn-group-rtl.ant-btn-group .ant-btn + .ant-btn, .ant-btn-group-rtl.ant-btn-group .ant-btn + span, .ant-btn-group-rtl.ant-btn-group > span + span, .ant-btn-group-rtl.ant-btn-group span + .ant-btn, .ant-btn-rtl.ant-btn + .ant-btn-group, .ant-btn-rtl.ant-btn-group + .ant-btn, .ant-btn-rtl.ant-btn-group + .ant-btn-group, .ant-btn-rtl.ant-btn-group .ant-btn + .ant-btn, .ant-btn-rtl.ant-btn-group .ant-btn + span, .ant-btn-rtl.ant-btn-group > span + span, .ant-btn-rtl.ant-btn-group span + .ant-btn {
  margin-right: -1px;
  margin-left: auto;
}

.ant-btn-group.ant-btn-group-rtl {
  direction: rtl;
}

.ant-btn-group-rtl.ant-btn-group > .ant-btn:first-child:not(:last-child), .ant-btn-group-rtl.ant-btn-group > span:first-child:not(:last-child) > .ant-btn {
  border-radius: 0 2px 2px 0;
}

.ant-btn-group-rtl.ant-btn-group > .ant-btn:last-child:not(:first-child), .ant-btn-group-rtl.ant-btn-group > span:last-child:not(:first-child) > .ant-btn {
  border-radius: 2px 0 0 2px;
}

.ant-btn-group-rtl.ant-btn-group-sm > .ant-btn:first-child:not(:last-child), .ant-btn-group-rtl.ant-btn-group-sm > span:first-child:not(:last-child) > .ant-btn {
  border-radius: 0 2px 2px 0;
}

.ant-btn-group-rtl.ant-btn-group-sm > .ant-btn:last-child:not(:first-child), .ant-btn-group-rtl.ant-btn-group-sm > span:last-child:not(:first-child) > .ant-btn {
  border-radius: 2px 0 0 2px;
}

.ant-btn:active > span, .ant-btn:focus > span {
  position: relative;
}

.ant-btn > .anticon + span, .ant-btn > span + .anticon {
  margin-left: 8px;
}

.ant-btn.ant-btn-background-ghost {
  color: #fff;
  border-color: #fff;
}

.ant-btn.ant-btn-background-ghost, .ant-btn.ant-btn-background-ghost:active, .ant-btn.ant-btn-background-ghost:focus, .ant-btn.ant-btn-background-ghost:hover {
  background: transparent;
}

.ant-btn.ant-btn-background-ghost:focus, .ant-btn.ant-btn-background-ghost:hover {
  color: #40a9ff;
  border-color: #40a9ff;
}

.ant-btn.ant-btn-background-ghost:active {
  color: #096dd9;
  border-color: #096dd9;
}

.ant-btn.ant-btn-background-ghost[disabled] {
  color: rgba(0, 0, 0, 0.25);
  background: transparent;
  border-color: #d9d9d9;
}

.ant-btn-background-ghost.ant-btn-primary {
  color: #1890ff;
  border-color: #1890ff;
  text-shadow: none;
}

.ant-btn-background-ghost.ant-btn-primary > a:only-child {
  color: currentcolor;
}

.ant-btn-background-ghost.ant-btn-primary > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-background-ghost.ant-btn-primary:focus, .ant-btn-background-ghost.ant-btn-primary:hover {
  color: #40a9ff;
  border-color: #40a9ff;
}

.ant-btn-background-ghost.ant-btn-primary:focus > a:only-child, .ant-btn-background-ghost.ant-btn-primary:hover > a:only-child {
  color: currentcolor;
}

.ant-btn-background-ghost.ant-btn-primary:focus > a:only-child:after, .ant-btn-background-ghost.ant-btn-primary:hover > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-background-ghost.ant-btn-primary:active {
  color: #096dd9;
  border-color: #096dd9;
}

.ant-btn-background-ghost.ant-btn-primary:active > a:only-child {
  color: currentcolor;
}

.ant-btn-background-ghost.ant-btn-primary:active > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-background-ghost.ant-btn-primary[disabled], .ant-btn-background-ghost.ant-btn-primary[disabled]:active, .ant-btn-background-ghost.ant-btn-primary[disabled]:focus, .ant-btn-background-ghost.ant-btn-primary[disabled]:hover {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}

.ant-btn-background-ghost.ant-btn-primary[disabled]:active > a:only-child, .ant-btn-background-ghost.ant-btn-primary[disabled]:focus > a:only-child, .ant-btn-background-ghost.ant-btn-primary[disabled]:hover > a:only-child, .ant-btn-background-ghost.ant-btn-primary[disabled] > a:only-child {
  color: currentcolor;
}

.ant-btn-background-ghost.ant-btn-primary[disabled]:active > a:only-child:after, .ant-btn-background-ghost.ant-btn-primary[disabled]:focus > a:only-child:after, .ant-btn-background-ghost.ant-btn-primary[disabled]:hover > a:only-child:after, .ant-btn-background-ghost.ant-btn-primary[disabled] > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-background-ghost.ant-btn-danger {
  color: #ff4d4f;
  border-color: #ff4d4f;
  text-shadow: none;
}

.ant-btn-background-ghost.ant-btn-danger > a:only-child {
  color: currentcolor;
}

.ant-btn-background-ghost.ant-btn-danger > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-background-ghost.ant-btn-danger:focus, .ant-btn-background-ghost.ant-btn-danger:hover {
  color: #ff7875;
  border-color: #ff7875;
}

.ant-btn-background-ghost.ant-btn-danger:focus > a:only-child, .ant-btn-background-ghost.ant-btn-danger:hover > a:only-child {
  color: currentcolor;
}

.ant-btn-background-ghost.ant-btn-danger:focus > a:only-child:after, .ant-btn-background-ghost.ant-btn-danger:hover > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-background-ghost.ant-btn-danger:active {
  color: #d9363e;
  border-color: #d9363e;
}

.ant-btn-background-ghost.ant-btn-danger:active > a:only-child {
  color: currentcolor;
}

.ant-btn-background-ghost.ant-btn-danger:active > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-background-ghost.ant-btn-danger[disabled], .ant-btn-background-ghost.ant-btn-danger[disabled]:active, .ant-btn-background-ghost.ant-btn-danger[disabled]:focus, .ant-btn-background-ghost.ant-btn-danger[disabled]:hover {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}

.ant-btn-background-ghost.ant-btn-danger[disabled]:active > a:only-child, .ant-btn-background-ghost.ant-btn-danger[disabled]:focus > a:only-child, .ant-btn-background-ghost.ant-btn-danger[disabled]:hover > a:only-child, .ant-btn-background-ghost.ant-btn-danger[disabled] > a:only-child {
  color: currentcolor;
}

.ant-btn-background-ghost.ant-btn-danger[disabled]:active > a:only-child:after, .ant-btn-background-ghost.ant-btn-danger[disabled]:focus > a:only-child:after, .ant-btn-background-ghost.ant-btn-danger[disabled]:hover > a:only-child:after, .ant-btn-background-ghost.ant-btn-danger[disabled] > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-background-ghost.ant-btn-dangerous {
  color: #ff4d4f;
  border-color: #ff4d4f;
  text-shadow: none;
}

.ant-btn-background-ghost.ant-btn-dangerous > a:only-child {
  color: currentcolor;
}

.ant-btn-background-ghost.ant-btn-dangerous > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-background-ghost.ant-btn-dangerous:focus, .ant-btn-background-ghost.ant-btn-dangerous:hover {
  color: #ff7875;
  border-color: #ff7875;
}

.ant-btn-background-ghost.ant-btn-dangerous:focus > a:only-child, .ant-btn-background-ghost.ant-btn-dangerous:hover > a:only-child {
  color: currentcolor;
}

.ant-btn-background-ghost.ant-btn-dangerous:focus > a:only-child:after, .ant-btn-background-ghost.ant-btn-dangerous:hover > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-background-ghost.ant-btn-dangerous:active {
  color: #d9363e;
  border-color: #d9363e;
}

.ant-btn-background-ghost.ant-btn-dangerous:active > a:only-child {
  color: currentcolor;
}

.ant-btn-background-ghost.ant-btn-dangerous:active > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-background-ghost.ant-btn-dangerous[disabled], .ant-btn-background-ghost.ant-btn-dangerous[disabled]:active, .ant-btn-background-ghost.ant-btn-dangerous[disabled]:focus, .ant-btn-background-ghost.ant-btn-dangerous[disabled]:hover {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}

.ant-btn-background-ghost.ant-btn-dangerous[disabled]:active > a:only-child, .ant-btn-background-ghost.ant-btn-dangerous[disabled]:focus > a:only-child, .ant-btn-background-ghost.ant-btn-dangerous[disabled]:hover > a:only-child, .ant-btn-background-ghost.ant-btn-dangerous[disabled] > a:only-child {
  color: currentcolor;
}

.ant-btn-background-ghost.ant-btn-dangerous[disabled]:active > a:only-child:after, .ant-btn-background-ghost.ant-btn-dangerous[disabled]:focus > a:only-child:after, .ant-btn-background-ghost.ant-btn-dangerous[disabled]:hover > a:only-child:after, .ant-btn-background-ghost.ant-btn-dangerous[disabled] > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link {
  color: #ff4d4f;
  border-color: transparent;
  text-shadow: none;
}

.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link > a:only-child {
  color: currentcolor;
}

.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:focus, .ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:hover {
  color: #ff7875;
  border-color: transparent;
}

.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:focus > a:only-child, .ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:hover > a:only-child {
  color: currentcolor;
}

.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:focus > a:only-child:after, .ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:hover > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:active {
  color: #d9363e;
  border-color: transparent;
}

.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:active > a:only-child {
  color: currentcolor;
}

.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:active > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled], .ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:active, .ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:focus, .ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:hover {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}

.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:active > a:only-child, .ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:focus > a:only-child, .ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:hover > a:only-child, .ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled] > a:only-child {
  color: currentcolor;
}

.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:active > a:only-child:after, .ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:focus > a:only-child:after, .ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:hover > a:only-child:after, .ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled] > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

.ant-btn-two-chinese-chars:first-letter {
  letter-spacing: 0.34em;
}

.ant-btn-two-chinese-chars > :not(.anticon) {
  margin-right: -0.34em;
  letter-spacing: 0.34em;
}

.ant-btn.ant-btn-block {
  width: 100%;
}

.ant-btn:empty {
  display: inline-block;
  width: 0;
  visibility: hidden;
  content: " ";
}

a.ant-btn {
  padding-top: 0.01px !important;
  line-height: 30px;
}

a.ant-btn-disabled {
  cursor: not-allowed;
}

a.ant-btn-disabled > * {
  pointer-events: none;
}

a.ant-btn-disabled, a.ant-btn-disabled:active, a.ant-btn-disabled:focus, a.ant-btn-disabled:hover {
  color: rgba(0, 0, 0, 0.25);
  border-color: transparent;
  background: transparent;
  text-shadow: none;
  box-shadow: none;
}

a.ant-btn-disabled:active > a:only-child, a.ant-btn-disabled:focus > a:only-child, a.ant-btn-disabled:hover > a:only-child, a.ant-btn-disabled > a:only-child {
  color: currentcolor;
}

a.ant-btn-disabled:active > a:only-child:after, a.ant-btn-disabled:focus > a:only-child:after, a.ant-btn-disabled:hover > a:only-child:after, a.ant-btn-disabled > a:only-child:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: "";
}

a.ant-btn-lg {
  line-height: 38px;
}

a.ant-btn-sm {
  line-height: 22px;
}

.ant-btn-compact-item:not(.ant-btn-compact-last-item):not(.ant-btn-compact-item-rtl) {
  margin-right: -1px;
}

.ant-btn-compact-item:not(.ant-btn-compact-last-item).ant-btn-compact-item-rtl {
  margin-left: -1px;
}

.ant-btn-compact-item:active, .ant-btn-compact-item:focus, .ant-btn-compact-item:hover {
  z-index: 2;
}

.ant-btn-compact-item[disabled] {
  z-index: 0;
}

.ant-btn-compact-item:not(.ant-btn-compact-first-item):not(.ant-btn-compact-last-item).ant-btn {
  border-radius: 0;
}

.ant-btn-compact-item.ant-btn.ant-btn-compact-first-item:not(.ant-btn-compact-last-item):not(.ant-btn-compact-item-rtl) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-btn-compact-item.ant-btn.ant-btn-compact-item-rtl.ant-btn-compact-first-item:not(.ant-btn-compact-last-item), .ant-btn-compact-item.ant-btn.ant-btn-compact-last-item:not(.ant-btn-compact-first-item):not(.ant-btn-compact-item-rtl) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.ant-btn-compact-item.ant-btn.ant-btn-compact-item-rtl.ant-btn-compact-last-item:not(.ant-btn-compact-first-item) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-btn-icon-only.ant-btn-compact-item {
  flex: none;
}

.ant-btn-compact-item.ant-btn-primary:not([disabled]) + .ant-btn-compact-item.ant-btn-primary:not([disabled]) {
  position: relative;
}

.ant-btn-compact-item.ant-btn-primary:not([disabled]) + .ant-btn-compact-item.ant-btn-primary:not([disabled]):after {
  position: absolute;
  top: -1px;
  left: -1px;
  display: inline-block;
  width: 1px;
  height: calc(100% + 2px);
  background-color: #40a9ff;
  content: " ";
}

.ant-btn-compact-item-rtl.ant-btn-compact-first-item.ant-btn-compact-item-rtl:not(.ant-btn-compact-last-item) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.ant-btn-compact-item-rtl.ant-btn-compact-last-item.ant-btn-compact-item-rtl:not(.ant-btn-compact-first-item) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-btn-compact-item-rtl.ant-btn-sm.ant-btn-compact-first-item.ant-btn-compact-item-rtl.ant-btn-sm:not(.ant-btn-compact-last-item) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.ant-btn-compact-item-rtl.ant-btn-sm.ant-btn-compact-last-item.ant-btn-compact-item-rtl.ant-btn-sm:not(.ant-btn-compact-first-item) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-btn-compact-item-rtl.ant-btn-primary:not([disabled]) + .ant-btn-compact-item-rtl.ant-btn-primary:not([disabled]):after {
  right: -1px;
}

.ant-btn-compact-vertical-item:not(.ant-btn-compact-vertical-last-item) {
  margin-bottom: -1px;
}

.ant-btn-compact-vertical-item:active, .ant-btn-compact-vertical-item:focus, .ant-btn-compact-vertical-item:hover {
  z-index: 2;
}

.ant-btn-compact-vertical-item[disabled] {
  z-index: 0;
}

.ant-btn-compact-vertical-item:not(.ant-btn-compact-vertical-first-item):not(.ant-btn-compact-vertical-last-item) {
  border-radius: 0;
}

.ant-btn-compact-vertical-item.ant-btn-compact-vertical-first-item:not(.ant-btn-compact-vertical-last-item) {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.ant-btn-compact-vertical-item.ant-btn-compact-vertical-last-item:not(.ant-btn-compact-vertical-first-item) {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.ant-btn-compact-vertical-item.ant-btn-primary:not([disabled]) + .ant-btn-compact-vertical-item.ant-btn-primary:not([disabled]) {
  position: relative;
}

.ant-btn-compact-vertical-item.ant-btn-primary:not([disabled]) + .ant-btn-compact-vertical-item.ant-btn-primary:not([disabled]):after {
  position: absolute;
  top: -1px;
  left: -1px;
  display: inline-block;
  width: calc(100% + 2px);
  height: 1px;
  background-color: #40a9ff;
  content: " ";
}

.ant-btn-rtl {
  direction: rtl;
}

.ant-btn-group-rtl.ant-btn-group .ant-btn-primary + .ant-btn-primary, .ant-btn-group-rtl.ant-btn-group .ant-btn-primary:last-child:not(:first-child) {
  border-right-color: #40a9ff;
  border-left-color: #d9d9d9;
}

.ant-btn-group-rtl.ant-btn-group .ant-btn-primary + .ant-btn-primary[disabled], .ant-btn-group-rtl.ant-btn-group .ant-btn-primary:last-child:not(:first-child)[disabled] {
  border-right-color: #d9d9d9;
  border-left-color: #40a9ff;
}

.ant-btn-rtl.ant-btn > .ant-btn-loading-icon .anticon {
  padding-right: 0;
  padding-left: 8px;
}

.ant-btn-rtl.ant-btn > .anticon + span, .ant-btn-rtl.ant-btn > span + .anticon {
  margin-right: 8px;
  margin-left: 0;
}

.ant-picker-calendar {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  background: #fff;
}

.ant-picker-calendar-header {
  display: flex;
  justify-content: flex-end;
  padding: 12px 0;
}

.ant-picker-calendar-header .ant-picker-calendar-year-select {
  min-width: 80px;
}

.ant-picker-calendar-header .ant-picker-calendar-month-select {
  min-width: 70px;
  margin-left: 8px;
}

.ant-picker-calendar-header .ant-picker-calendar-mode-switch {
  margin-left: 8px;
}

.ant-picker-calendar .ant-picker-panel {
  background: #fff;
  border: 0;
  border-top: 1px solid #f0f0f0;
  border-radius: 0;
}

.ant-picker-calendar .ant-picker-panel .ant-picker-date-panel, .ant-picker-calendar .ant-picker-panel .ant-picker-month-panel {
  width: auto;
}

.ant-picker-calendar .ant-picker-panel .ant-picker-body {
  padding: 8px 0;
}

.ant-picker-calendar .ant-picker-panel .ant-picker-content {
  width: 100%;
}

.ant-picker-calendar-mini {
  border-radius: 2px;
}

.ant-picker-calendar-mini .ant-picker-calendar-header {
  padding-right: 8px;
  padding-left: 8px;
}

.ant-picker-calendar-mini .ant-picker-panel {
  border-radius: 0 0 2px 2px;
}

.ant-picker-calendar-mini .ant-picker-content {
  height: 256px;
}

.ant-picker-calendar-mini .ant-picker-content th {
  height: auto;
  padding: 0;
  line-height: 18px;
}

.ant-picker-calendar-mini .ant-picker-cell:before {
  pointer-events: none;
}

.ant-picker-calendar-full .ant-picker-panel {
  display: block;
  width: 100%;
  text-align: right;
  background: #fff;
  border: 0;
}

.ant-picker-calendar-full .ant-picker-panel .ant-picker-body td, .ant-picker-calendar-full .ant-picker-panel .ant-picker-body th {
  padding: 0;
}

.ant-picker-calendar-full .ant-picker-panel .ant-picker-body th {
  height: auto;
  padding: 0 12px 5px 0;
  line-height: 18px;
}

.ant-picker-calendar-full .ant-picker-panel .ant-picker-cell:before {
  display: none;
}

.ant-picker-calendar-full .ant-picker-panel .ant-picker-cell:hover .ant-picker-calendar-date {
  background: #f5f5f5;
}

.ant-picker-calendar-full .ant-picker-panel .ant-picker-cell .ant-picker-calendar-date-today:before {
  display: none;
}

.ant-picker-calendar-full .ant-picker-panel .ant-picker-cell-selected .ant-picker-calendar-date, .ant-picker-calendar-full .ant-picker-panel .ant-picker-cell-selected .ant-picker-calendar-date-today, .ant-picker-calendar-full .ant-picker-panel .ant-picker-cell-selected:hover .ant-picker-calendar-date, .ant-picker-calendar-full .ant-picker-panel .ant-picker-cell-selected:hover .ant-picker-calendar-date-today {
  background: #e6f7ff;
}

.ant-picker-calendar-full .ant-picker-panel .ant-picker-cell-selected .ant-picker-calendar-date-today .ant-picker-calendar-date-value, .ant-picker-calendar-full .ant-picker-panel .ant-picker-cell-selected .ant-picker-calendar-date .ant-picker-calendar-date-value, .ant-picker-calendar-full .ant-picker-panel .ant-picker-cell-selected:hover .ant-picker-calendar-date-today .ant-picker-calendar-date-value, .ant-picker-calendar-full .ant-picker-panel .ant-picker-cell-selected:hover .ant-picker-calendar-date .ant-picker-calendar-date-value {
  color: #1890ff;
}

.ant-picker-calendar-full .ant-picker-panel .ant-picker-calendar-date {
  display: block;
  width: auto;
  height: auto;
  margin: 0 4px;
  padding: 4px 8px 0;
  border: 0;
  border-top: 2px solid #f0f0f0;
  border-radius: 0;
  transition: background 0.3s;
}

.ant-picker-calendar-full .ant-picker-panel .ant-picker-calendar-date-value {
  line-height: 24px;
  transition: color 0.3s;
}

.ant-picker-calendar-full .ant-picker-panel .ant-picker-calendar-date-content {
  position: static;
  width: auto;
  height: 86px;
  overflow-y: auto;
  color: rgba(0, 0, 0, 0.85);
  line-height: 1.5715;
  text-align: left;
}

.ant-picker-calendar-full .ant-picker-panel .ant-picker-calendar-date-today {
  border-color: #1890ff;
}

.ant-picker-calendar-full .ant-picker-panel .ant-picker-calendar-date-today .ant-picker-calendar-date-value {
  color: rgba(0, 0, 0, 0.85);
}

@media only screen and (max-width: 480px) {
  .ant-picker-calendar-header {
    display: block;
  }
  .ant-picker-calendar-header .ant-picker-calendar-year-select {
    width: 50%;
  }
  .ant-picker-calendar-header .ant-picker-calendar-month-select {
    width: calc(50% - 8px);
  }
  .ant-picker-calendar-header .ant-picker-calendar-mode-switch {
    width: 100%;
    margin-top: 8px;
    margin-left: 0;
  }
  .ant-picker-calendar-header .ant-picker-calendar-mode-switch > label {
    width: 50%;
    text-align: center;
  }
}
.ant-picker-calendar-rtl {
  direction: rtl;
}

.ant-picker-calendar-rtl .ant-picker-calendar-header .ant-picker-calendar-mode-switch, .ant-picker-calendar-rtl .ant-picker-calendar-header .ant-picker-calendar-month-select {
  margin-right: 8px;
  margin-left: 0;
}

.ant-picker-calendar-rtl.ant-picker-calendar-full .ant-picker-panel {
  text-align: left;
}

.ant-picker-calendar-rtl.ant-picker-calendar-full .ant-picker-panel .ant-picker-body th {
  padding: 0 0 5px 12px;
}

.ant-picker-calendar-rtl.ant-picker-calendar-full .ant-picker-panel .ant-picker-calendar-date-content {
  text-align: right;
}

.ant-card {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  background: #fff;
  border-radius: 2px;
}

.ant-card-rtl {
  direction: rtl;
}

.ant-card-hoverable {
  cursor: pointer;
  transition: box-shadow 0.3s, border-color 0.3s;
}

.ant-card-hoverable:hover {
  border-color: transparent;
  box-shadow: 0 1px 2px -2px rgba(0, 0, 0, 0.16), 0 3px 6px 0 rgba(0, 0, 0, 0.12), 0 5px 12px 4px rgba(0, 0, 0, 0.09);
}

.ant-card-bordered {
  border: 1px solid #f0f0f0;
}

.ant-card-head {
  min-height: 48px;
  margin-bottom: -1px;
  padding: 0 24px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  font-size: 16px;
  background: transparent;
  border-bottom: 1px solid #f0f0f0;
  border-radius: 2px 2px 0 0;
}

.ant-card-head:after, .ant-card-head:before {
  display: table;
  content: "";
}

.ant-card-head:after {
  clear: both;
}

.ant-card-head-wrapper {
  display: flex;
  align-items: center;
}

.ant-card-head-title {
  display: inline-block;
  flex: 1;
  padding: 16px 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ant-card-head-title > .ant-typography, .ant-card-head-title > .ant-typography-edit-content {
  left: 0;
  margin-top: 0;
  margin-bottom: 0;
}

.ant-card-head .ant-tabs-top {
  clear: both;
  margin-bottom: -17px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 400;
  font-size: 14px;
}

.ant-card-head .ant-tabs-top-bar {
  border-bottom: 1px solid #f0f0f0;
}

.ant-card-extra {
  margin-left: auto;
  padding: 16px 0;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 400;
  font-size: 14px;
}

.ant-card-rtl .ant-card-extra {
  margin-right: auto;
  margin-left: 0;
}

.ant-card-body {
  padding: 24px;
}

.ant-card-body:after, .ant-card-body:before {
  display: table;
  content: "";
}

.ant-card-body:after {
  clear: both;
}

.ant-card-contain-grid .ant-card-body {
  display: flex;
  flex-wrap: wrap;
}

.ant-card-contain-grid:not(.ant-card-loading) .ant-card-body {
  margin: -1px 0 0 -1px;
  padding: 0;
}

.ant-card-grid {
  width: 33.33%;
  padding: 24px;
  border: 0;
  border-radius: 0;
  box-shadow: 1px 0 0 0 #f0f0f0, 0 1px 0 0 #f0f0f0, 1px 1px 0 0 #f0f0f0, inset 1px 0 0 0 #f0f0f0, inset 0 1px 0 0 #f0f0f0;
  transition: all 0.3s;
}

.ant-card-grid-hoverable:hover {
  position: relative;
  z-index: 1;
  box-shadow: 0 1px 2px -2px rgba(0, 0, 0, 0.16), 0 3px 6px 0 rgba(0, 0, 0, 0.12), 0 5px 12px 4px rgba(0, 0, 0, 0.09);
}

.ant-card-contain-tabs > .ant-card-head .ant-card-head-title {
  min-height: 32px;
  padding-bottom: 0;
}

.ant-card-contain-tabs > .ant-card-head .ant-card-extra {
  padding-bottom: 0;
}

.ant-card-bordered .ant-card-cover {
  margin-top: -1px;
  margin-right: -1px;
  margin-left: -1px;
}

.ant-card-cover > * {
  display: block;
  width: 100%;
}

.ant-card-cover img {
  border-radius: 2px 2px 0 0;
}

.ant-card-actions {
  display: flex;
  margin: 0;
  padding: 0;
  list-style: none;
  background: #fff;
  border-top: 1px solid #f0f0f0;
}

.ant-card-actions:after, .ant-card-actions:before {
  display: table;
  content: "";
}

.ant-card-actions:after {
  clear: both;
}

.ant-card-actions > li {
  margin: 12px 0;
  color: rgba(0, 0, 0, 0.45);
  text-align: center;
}

.ant-card-actions > li > span {
  position: relative;
  display: block;
  min-width: 32px;
  font-size: 14px;
  line-height: 1.5715;
  cursor: pointer;
}

.ant-card-actions > li > span:hover {
  color: #1890ff;
  transition: color 0.3s;
}

.ant-card-actions > li > span > .anticon, .ant-card-actions > li > span a:not(.ant-btn) {
  display: inline-block;
  width: 100%;
  color: rgba(0, 0, 0, 0.45);
  line-height: 22px;
  transition: color 0.3s;
}

.ant-card-actions > li > span > .anticon:hover, .ant-card-actions > li > span a:not(.ant-btn):hover {
  color: #1890ff;
}

.ant-card-actions > li > span > .anticon {
  font-size: 16px;
  line-height: 22px;
}

.ant-card-actions > li:not(:last-child) {
  border-right: 1px solid #f0f0f0;
}

.ant-card-rtl .ant-card-actions > li:not(:last-child) {
  border-right: none;
  border-left: 1px solid #f0f0f0;
}

.ant-card-type-inner .ant-card-head {
  padding: 0 24px;
  background: #fafafa;
}

.ant-card-type-inner .ant-card-head-title {
  padding: 12px 0;
  font-size: 14px;
}

.ant-card-type-inner .ant-card-body {
  padding: 16px 24px;
}

.ant-card-type-inner .ant-card-extra {
  padding: 13.5px 0;
}

.ant-card-meta {
  display: flex;
  margin: -4px 0;
}

.ant-card-meta:after, .ant-card-meta:before {
  display: table;
  content: "";
}

.ant-card-meta:after {
  clear: both;
}

.ant-card-meta-avatar {
  padding-right: 16px;
}

.ant-card-rtl .ant-card-meta-avatar {
  padding-right: 0;
  padding-left: 16px;
}

.ant-card-meta-detail {
  flex: 1;
  overflow: hidden;
}

.ant-card-meta-detail > div:not(:last-child) {
  margin-bottom: 8px;
}

.ant-card-meta-title {
  overflow: hidden;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  font-size: 16px;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ant-card-meta-description {
  color: rgba(0, 0, 0, 0.45);
}

.ant-card-loading {
  overflow: hidden;
}

.ant-card-loading .ant-card-body {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-card-small > .ant-card-head {
  min-height: 36px;
  padding: 0 12px;
  font-size: 14px;
}

.ant-card-small > .ant-card-head > .ant-card-head-wrapper > .ant-card-head-title {
  padding: 8px 0;
}

.ant-card-small > .ant-card-head > .ant-card-head-wrapper > .ant-card-extra {
  padding: 8px 0;
  font-size: 14px;
}

.ant-card-small > .ant-card-body {
  padding: 12px;
}

.ant-carousel {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
}

.ant-carousel .slick-slider {
  position: relative;
  display: block;
  box-sizing: border-box;
  touch-action: pan-y;
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: transparent;
}

.ant-carousel .slick-list {
  position: relative;
  display: block;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.ant-carousel .slick-list:focus {
  outline: none;
}

.ant-carousel .slick-list.dragging {
  cursor: pointer;
}

.ant-carousel .slick-list .slick-slide {
  pointer-events: none;
}

.ant-carousel .slick-list .slick-slide input.ant-checkbox-input, .ant-carousel .slick-list .slick-slide input.ant-radio-input {
  visibility: hidden;
}

.ant-carousel .slick-list .slick-slide.slick-active {
  pointer-events: auto;
}

.ant-carousel .slick-list .slick-slide.slick-active input.ant-checkbox-input, .ant-carousel .slick-list .slick-slide.slick-active input.ant-radio-input {
  visibility: visible;
}

.ant-carousel .slick-list .slick-slide > div > div {
  vertical-align: bottom;
}

.ant-carousel .slick-slider .slick-list, .ant-carousel .slick-slider .slick-track {
  transform: translateZ(0);
  touch-action: pan-y;
}

.ant-carousel .slick-track {
  position: relative;
  top: 0;
  left: 0;
  display: block;
}

.ant-carousel .slick-track:after, .ant-carousel .slick-track:before {
  display: table;
  content: "";
}

.ant-carousel .slick-track:after {
  clear: both;
}

.slick-loading .ant-carousel .slick-track {
  visibility: hidden;
}

.ant-carousel .slick-slide {
  display: none;
  float: left;
  height: 100%;
  min-height: 1px;
}

.ant-carousel .slick-slide img {
  display: block;
}

.ant-carousel .slick-slide.slick-loading img {
  display: none;
}

.ant-carousel .slick-slide.dragging img {
  pointer-events: none;
}

.ant-carousel .slick-initialized .slick-slide {
  display: block;
}

.ant-carousel .slick-loading .slick-slide {
  visibility: hidden;
}

.ant-carousel .slick-vertical .slick-slide {
  display: block;
  height: auto;
}

.ant-carousel .slick-arrow.slick-hidden {
  display: none;
}

.ant-carousel .slick-next, .ant-carousel .slick-prev {
  position: absolute;
  top: 50%;
  display: block;
  width: 20px;
  height: 20px;
  margin-top: -10px;
  padding: 0;
  font-size: 0;
  line-height: 0;
  border: 0;
  cursor: pointer;
}

.ant-carousel .slick-next, .ant-carousel .slick-next:focus, .ant-carousel .slick-next:hover, .ant-carousel .slick-prev, .ant-carousel .slick-prev:focus, .ant-carousel .slick-prev:hover {
  color: transparent;
  background: transparent;
  outline: none;
}

.ant-carousel .slick-next:focus:before, .ant-carousel .slick-next:hover:before, .ant-carousel .slick-prev:focus:before, .ant-carousel .slick-prev:hover:before {
  opacity: 1;
}

.ant-carousel .slick-next.slick-disabled:before, .ant-carousel .slick-prev.slick-disabled:before {
  opacity: 0.25;
}

.ant-carousel .slick-prev {
  left: -25px;
}

.ant-carousel .slick-prev:before {
  content: "←";
}

.ant-carousel .slick-next {
  right: -25px;
}

.ant-carousel .slick-next:before {
  content: "→";
}

.ant-carousel .slick-dots {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 15;
  display: flex !important;
  justify-content: center;
  margin-right: 15%;
  margin-bottom: 0;
  margin-left: 15%;
  padding-left: 0;
  list-style: none;
}

.ant-carousel .slick-dots-bottom {
  bottom: 12px;
}

.ant-carousel .slick-dots-top {
  top: 12px;
  bottom: auto;
}

.ant-carousel .slick-dots li {
  position: relative;
  display: inline-block;
  flex: 0 1 auto;
  box-sizing: content-box;
  width: 16px;
  height: 3px;
  margin: 0 4px;
  padding: 0;
  text-align: center;
  text-indent: -999px;
  vertical-align: top;
  transition: all 0.5s;
}

.ant-carousel .slick-dots li button {
  position: relative;
  display: block;
  width: 100%;
  height: 3px;
  padding: 0;
  color: transparent;
  font-size: 0;
  background: #fff;
  border: 0;
  border-radius: 1px;
  outline: none;
  cursor: pointer;
  opacity: 0.3;
  transition: all 0.5s;
}

.ant-carousel .slick-dots li button:focus, .ant-carousel .slick-dots li button:hover {
  opacity: 0.75;
}

.ant-carousel .slick-dots li button:after {
  position: absolute;
  top: -4px;
  right: -4px;
  bottom: -4px;
  left: -4px;
  content: "";
}

.ant-carousel .slick-dots li.slick-active {
  width: 24px;
}

.ant-carousel .slick-dots li.slick-active button {
  background: #fff;
  opacity: 1;
}

.ant-carousel .slick-dots li.slick-active:focus, .ant-carousel .slick-dots li.slick-active:hover {
  opacity: 1;
}

.ant-carousel-vertical .slick-dots {
  top: 50%;
  bottom: auto;
  flex-direction: column;
  width: 3px;
  height: auto;
  margin: 0;
  transform: translateY(-50%);
}

.ant-carousel-vertical .slick-dots-left {
  right: auto;
  left: 12px;
}

.ant-carousel-vertical .slick-dots-right {
  right: 12px;
  left: auto;
}

.ant-carousel-vertical .slick-dots li {
  width: 3px;
  height: 16px;
  margin: 4px 0;
  vertical-align: baseline;
}

.ant-carousel-vertical .slick-dots li button {
  width: 3px;
  height: 16px;
}

.ant-carousel-vertical .slick-dots li.slick-active, .ant-carousel-vertical .slick-dots li.slick-active button {
  width: 3px;
  height: 24px;
}

.ant-carousel-rtl {
  direction: rtl;
}

.ant-carousel-rtl .ant-carousel .slick-track {
  right: 0;
  left: auto;
}

.ant-carousel-rtl .ant-carousel .slick-prev {
  right: -25px;
  left: auto;
}

.ant-carousel-rtl .ant-carousel .slick-prev:before {
  content: "→";
}

.ant-carousel-rtl .ant-carousel .slick-next {
  right: auto;
  left: -25px;
}

.ant-carousel-rtl .ant-carousel .slick-next:before {
  content: "←";
}

.ant-carousel-rtl.ant-carousel .slick-dots {
  flex-direction: row-reverse;
}

.ant-carousel-rtl.ant-carousel-vertical .slick-dots {
  flex-direction: column;
}

.ant-cascader-checkbox {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  top: 0.2em;
  line-height: 1;
  white-space: nowrap;
  outline: none;
  cursor: pointer;
}

.ant-cascader-checkbox-input:focus + .ant-cascader-checkbox-inner, .ant-cascader-checkbox-wrapper:hover .ant-cascader-checkbox-inner, .ant-cascader-checkbox:hover .ant-cascader-checkbox-inner {
  border-color: #1890ff;
}

.ant-cascader-checkbox-checked:after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid #1890ff;
  border-radius: 2px;
  visibility: hidden;
  animation: antCheckboxEffect 0.36s ease-in-out;
  animation-fill-mode: backwards;
  content: "";
}

.ant-cascader-checkbox-wrapper:hover .ant-cascader-checkbox:after, .ant-cascader-checkbox:hover:after {
  visibility: visible;
}

.ant-cascader-checkbox-inner {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  width: 16px;
  height: 16px;
  direction: ltr;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  border-collapse: separate;
  transition: all 0.3s;
}

.ant-cascader-checkbox-inner:after {
  position: absolute;
  top: 50%;
  left: 21.5%;
  display: table;
  width: 5.71428571px;
  height: 9.14285714px;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  transform: rotate(45deg) scale(0) translate(-50%, -50%);
  opacity: 0;
  transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6), opacity 0.1s;
  content: " ";
}

.ant-cascader-checkbox-input {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  cursor: pointer;
  opacity: 0;
}

.ant-cascader-checkbox-checked .ant-cascader-checkbox-inner:after {
  position: absolute;
  display: table;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  transform: rotate(45deg) scale(1) translate(-50%, -50%);
  opacity: 1;
  transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
  content: " ";
}

.ant-cascader-checkbox-checked .ant-cascader-checkbox-inner {
  background-color: #1890ff;
  border-color: #1890ff;
}

.ant-cascader-checkbox-disabled {
  cursor: not-allowed;
}

.ant-cascader-checkbox-disabled.ant-cascader-checkbox-checked .ant-cascader-checkbox-inner:after {
  border-color: rgba(0, 0, 0, 0.25);
  animation-name: none;
}

.ant-cascader-checkbox-disabled .ant-cascader-checkbox-input {
  cursor: not-allowed;
  pointer-events: none;
}

.ant-cascader-checkbox-disabled .ant-cascader-checkbox-inner {
  background-color: #f5f5f5;
  border-color: #d9d9d9 !important;
}

.ant-cascader-checkbox-disabled .ant-cascader-checkbox-inner:after {
  border-color: #f5f5f5;
  border-collapse: separate;
  animation-name: none;
}

.ant-cascader-checkbox-disabled + span {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ant-cascader-checkbox-disabled:hover:after, .ant-cascader-checkbox-wrapper:hover .ant-cascader-checkbox-disabled:after {
  visibility: hidden;
}

.ant-cascader-checkbox-wrapper {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  display: inline-flex;
  align-items: baseline;
  line-height: unset;
  cursor: pointer;
}

.ant-cascader-checkbox-wrapper:after {
  display: inline-block;
  width: 0;
  overflow: hidden;
  content: " ";
}

.ant-cascader-checkbox-wrapper.ant-cascader-checkbox-wrapper-disabled {
  cursor: not-allowed;
}

.ant-cascader-checkbox-wrapper + .ant-cascader-checkbox-wrapper {
  margin-left: 8px;
}

.ant-cascader-checkbox-wrapper.ant-cascader-checkbox-wrapper-in-form-item input[type=checkbox] {
  width: 14px;
  height: 14px;
}

.ant-cascader-checkbox + span {
  padding-right: 8px;
  padding-left: 8px;
}

.ant-cascader-checkbox-group {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  display: inline-block;
}

.ant-cascader-checkbox-group-item {
  margin-right: 8px;
}

.ant-cascader-checkbox-group-item:last-child {
  margin-right: 0;
}

.ant-cascader-checkbox-group-item + .ant-cascader-checkbox-group-item {
  margin-left: 0;
}

.ant-cascader-checkbox-indeterminate .ant-cascader-checkbox-inner {
  background-color: #fff;
  border-color: #d9d9d9;
}

.ant-cascader-checkbox-indeterminate .ant-cascader-checkbox-inner:after {
  top: 50%;
  left: 50%;
  width: 8px;
  height: 8px;
  background-color: #1890ff;
  border: 0;
  transform: translate(-50%, -50%) scale(1);
  opacity: 1;
  content: " ";
}

.ant-cascader-checkbox-indeterminate.ant-cascader-checkbox-disabled .ant-cascader-checkbox-inner:after {
  background-color: rgba(0, 0, 0, 0.25);
  border-color: rgba(0, 0, 0, 0.25);
}

.ant-cascader {
  width: 184px;
}

.ant-cascader-checkbox {
  top: 0;
  margin-right: 8px;
}

.ant-cascader-menus {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
}

.ant-cascader-menus.ant-cascader-menu-empty .ant-cascader-menu {
  width: 100%;
  height: auto;
}

.ant-cascader-menu {
  flex-grow: 1;
  min-width: 111px;
  height: 180px;
  margin: -4px 0;
  padding: 4px 0;
  overflow: auto;
  vertical-align: top;
  list-style: none;
  border-right: 1px solid #f0f0f0;
  -ms-overflow-style: -ms-autohiding-scrollbar;
}

.ant-cascader-menu-item {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  padding: 5px 12px;
  overflow: hidden;
  line-height: 22px;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  transition: all 0.3s;
}

.ant-cascader-menu-item:hover {
  background: #f5f5f5;
}

.ant-cascader-menu-item-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ant-cascader-menu-item-disabled:hover {
  background: transparent;
}

.ant-cascader-menu-empty .ant-cascader-menu-item {
  color: rgba(0, 0, 0, 0.25);
  cursor: default;
  pointer-events: none;
}

.ant-cascader-menu-item-active:not(.ant-cascader-menu-item-disabled), .ant-cascader-menu-item-active:not(.ant-cascader-menu-item-disabled):hover {
  font-weight: 600;
  background-color: #e6f7ff;
}

.ant-cascader-menu-item-content {
  flex: auto;
}

.ant-cascader-menu-item-expand .ant-cascader-menu-item-expand-icon, .ant-cascader-menu-item-loading-icon {
  margin-left: 4px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 10px;
}

.ant-cascader-menu-item-disabled.ant-cascader-menu-item-expand .ant-cascader-menu-item-expand-icon, .ant-cascader-menu-item-disabled.ant-cascader-menu-item-loading-icon {
  color: rgba(0, 0, 0, 0.25);
}

.ant-cascader-menu-item-keyword {
  color: #ff4d4f;
}

.ant-cascader-compact-item:not(.ant-cascader-compact-last-item):not(.ant-cascader-compact-item-rtl) {
  margin-right: -1px;
}

.ant-cascader-compact-item:not(.ant-cascader-compact-last-item).ant-cascader-compact-item-rtl {
  margin-left: -1px;
}

.ant-cascader-compact-item:active, .ant-cascader-compact-item:focus, .ant-cascader-compact-item:hover {
  z-index: 2;
}

.ant-cascader-compact-item[disabled] {
  z-index: 0;
}

.ant-cascader-compact-item:not(.ant-cascader-compact-first-item):not(.ant-cascader-compact-last-item).ant-cascader {
  border-radius: 0;
}

.ant-cascader-compact-item.ant-cascader.ant-cascader-compact-first-item:not(.ant-cascader-compact-last-item):not(.ant-cascader-compact-item-rtl) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-cascader-compact-item.ant-cascader.ant-cascader-compact-item-rtl.ant-cascader-compact-first-item:not(.ant-cascader-compact-last-item), .ant-cascader-compact-item.ant-cascader.ant-cascader-compact-last-item:not(.ant-cascader-compact-first-item):not(.ant-cascader-compact-item-rtl) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.ant-cascader-compact-item.ant-cascader.ant-cascader-compact-item-rtl.ant-cascader-compact-last-item:not(.ant-cascader-compact-first-item) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-cascader-rtl .ant-cascader-menu-item-expand-icon, .ant-cascader-rtl .ant-cascader-menu-item-loading-icon {
  margin-right: 4px;
  margin-left: 0;
}

.ant-cascader-rtl .ant-cascader-checkbox {
  top: 0;
  margin-right: 0;
  margin-left: 8px;
}

.ant-checkbox {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  top: 0.2em;
  line-height: 1;
  white-space: nowrap;
  outline: none;
  cursor: pointer;
}

.ant-checkbox-input:focus + .ant-checkbox-inner, .ant-checkbox-wrapper:hover .ant-checkbox-inner, .ant-checkbox:hover .ant-checkbox-inner {
  border-color: #1890ff;
}

.ant-checkbox-checked:after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid #1890ff;
  border-radius: 2px;
  visibility: hidden;
  animation: antCheckboxEffect 0.36s ease-in-out;
  animation-fill-mode: backwards;
  content: "";
}

.ant-checkbox-wrapper:hover .ant-checkbox:after, .ant-checkbox:hover:after {
  visibility: visible;
}

.ant-checkbox-inner {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  width: 16px;
  height: 16px;
  direction: ltr;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  border-collapse: separate;
  transition: all 0.3s;
}

.ant-checkbox-inner:after {
  position: absolute;
  top: 50%;
  left: 21.5%;
  display: table;
  width: 5.71428571px;
  height: 9.14285714px;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  transform: rotate(45deg) scale(0) translate(-50%, -50%);
  opacity: 0;
  transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6), opacity 0.1s;
  content: " ";
}

.ant-checkbox-input {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  cursor: pointer;
  opacity: 0;
}

.ant-checkbox-checked .ant-checkbox-inner:after {
  position: absolute;
  display: table;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  transform: rotate(45deg) scale(1) translate(-50%, -50%);
  opacity: 1;
  transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
  content: " ";
}

.ant-checkbox-checked .ant-checkbox-inner {
  background-color: #1890ff;
  border-color: #1890ff;
}

.ant-checkbox-disabled {
  cursor: not-allowed;
}

.ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner:after {
  border-color: rgba(0, 0, 0, 0.25);
  animation-name: none;
}

.ant-checkbox-disabled .ant-checkbox-input {
  cursor: not-allowed;
  pointer-events: none;
}

.ant-checkbox-disabled .ant-checkbox-inner {
  background-color: #f5f5f5;
  border-color: #d9d9d9 !important;
}

.ant-checkbox-disabled .ant-checkbox-inner:after {
  border-color: #f5f5f5;
  border-collapse: separate;
  animation-name: none;
}

.ant-checkbox-disabled + span {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ant-checkbox-disabled:hover:after, .ant-checkbox-wrapper:hover .ant-checkbox-disabled:after {
  visibility: hidden;
}

.ant-checkbox-wrapper {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  display: inline-flex;
  align-items: baseline;
  line-height: unset;
  cursor: pointer;
}

.ant-checkbox-wrapper:after {
  display: inline-block;
  width: 0;
  overflow: hidden;
  content: " ";
}

.ant-checkbox-wrapper.ant-checkbox-wrapper-disabled {
  cursor: not-allowed;
}

.ant-checkbox-wrapper + .ant-checkbox-wrapper {
  margin-left: 8px;
}

.ant-checkbox-wrapper.ant-checkbox-wrapper-in-form-item input[type=checkbox] {
  width: 14px;
  height: 14px;
}

.ant-checkbox + span {
  padding-right: 8px;
  padding-left: 8px;
}

.ant-checkbox-group {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  display: inline-block;
}

.ant-checkbox-group-item {
  margin-right: 8px;
}

.ant-checkbox-group-item:last-child {
  margin-right: 0;
}

.ant-checkbox-group-item + .ant-checkbox-group-item {
  margin-left: 0;
}

.ant-checkbox-indeterminate .ant-checkbox-inner {
  background-color: #fff;
  border-color: #d9d9d9;
}

.ant-checkbox-indeterminate .ant-checkbox-inner:after {
  top: 50%;
  left: 50%;
  width: 8px;
  height: 8px;
  background-color: #1890ff;
  border: 0;
  transform: translate(-50%, -50%) scale(1);
  opacity: 1;
  content: " ";
}

.ant-checkbox-indeterminate.ant-checkbox-disabled .ant-checkbox-inner:after {
  background-color: rgba(0, 0, 0, 0.25);
  border-color: rgba(0, 0, 0, 0.25);
}

.ant-checkbox-rtl {
  direction: rtl;
}

.ant-checkbox-group-rtl .ant-checkbox-group-item {
  margin-right: 0;
  margin-left: 8px;
}

.ant-checkbox-group-rtl .ant-checkbox-group-item:last-child {
  margin-left: 0 !important;
}

.ant-checkbox-group-rtl .ant-checkbox-group-item + .ant-checkbox-group-item {
  margin-left: 8px;
}

.ant-collapse {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  background-color: #fafafa;
  border: 1px solid #d9d9d9;
  border-bottom: 0;
  border-radius: 2px;
}

.ant-collapse > .ant-collapse-item {
  border-bottom: 1px solid #d9d9d9;
}

.ant-collapse > .ant-collapse-item:last-child, .ant-collapse > .ant-collapse-item:last-child > .ant-collapse-header {
  border-radius: 0 0 2px 2px;
}

.ant-collapse > .ant-collapse-item > .ant-collapse-header {
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  padding: 12px 16px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 1.5715;
  cursor: pointer;
  transition: all 0.3s, visibility 0s;
}

.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {
  display: inline-block;
  margin-right: 12px;
  font-size: 12px;
  vertical-align: -1px;
}

.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow svg {
  transition: transform 0.24s;
}

.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-header-text {
  flex: auto;
}

.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-extra {
  margin-left: auto;
}

.ant-collapse > .ant-collapse-item > .ant-collapse-header:focus {
  outline: none;
}

.ant-collapse > .ant-collapse-item .ant-collapse-header-collapsible-only {
  cursor: default;
}

.ant-collapse > .ant-collapse-item .ant-collapse-header-collapsible-only .ant-collapse-header-text {
  flex: none;
  cursor: pointer;
}

.ant-collapse > .ant-collapse-item .ant-collapse-icon-collapsible-only {
  cursor: default;
}

.ant-collapse > .ant-collapse-item .ant-collapse-icon-collapsible-only .ant-collapse-expand-icon {
  cursor: pointer;
}

.ant-collapse > .ant-collapse-item.ant-collapse-no-arrow > .ant-collapse-header {
  padding-left: 12px;
}

.ant-collapse-icon-position-end > .ant-collapse-item > .ant-collapse-header {
  position: relative;
  padding: 12px 40px 12px 16px;
}

.ant-collapse-icon-position-end > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {
  position: absolute;
  top: 50%;
  right: 16px;
  left: auto;
  margin: 0;
  transform: translateY(-50%);
}

.ant-collapse-content {
  color: rgba(0, 0, 0, 0.85);
  background-color: #fff;
  border-top: 1px solid #d9d9d9;
}

.ant-collapse-content > .ant-collapse-content-box {
  padding: 16px;
}

.ant-collapse-content-hidden {
  display: none;
}

.ant-collapse-item:last-child > .ant-collapse-content {
  border-radius: 0 0 2px 2px;
}

.ant-collapse-borderless {
  background-color: #fafafa;
  border: 0;
}

.ant-collapse-borderless > .ant-collapse-item {
  border-bottom: 1px solid #d9d9d9;
}

.ant-collapse-borderless > .ant-collapse-item:last-child, .ant-collapse-borderless > .ant-collapse-item:last-child .ant-collapse-header {
  border-radius: 0;
}

.ant-collapse-borderless > .ant-collapse-item:last-child {
  border-bottom: 0;
}

.ant-collapse-borderless > .ant-collapse-item > .ant-collapse-content {
  background-color: transparent;
  border-top: 0;
}

.ant-collapse-borderless > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {
  padding-top: 4px;
}

.ant-collapse-ghost {
  background-color: transparent;
  border: 0;
}

.ant-collapse-ghost > .ant-collapse-item {
  border-bottom: 0;
}

.ant-collapse-ghost > .ant-collapse-item > .ant-collapse-content {
  background-color: transparent;
  border-top: 0;
}

.ant-collapse-ghost > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {
  padding-top: 12px;
  padding-bottom: 12px;
}

.ant-collapse .ant-collapse-item-disabled > .ant-collapse-header, .ant-collapse .ant-collapse-item-disabled > .ant-collapse-header > .arrow {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ant-collapse-rtl {
  direction: rtl;
}

.ant-collapse-rtl.ant-collapse.ant-collapse-icon-position-end > .ant-collapse-item > .ant-collapse-header {
  position: relative;
  padding: 12px 16px 12px 40px;
}

.ant-collapse-rtl.ant-collapse.ant-collapse-icon-position-end > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {
  position: absolute;
  top: 50%;
  right: auto;
  left: 16px;
  margin: 0;
  transform: translateY(-50%);
}

.ant-collapse-rtl .ant-collapse > .ant-collapse-item > .ant-collapse-header {
  padding: 12px 40px 12px 16px;
}

.ant-collapse-rtl.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {
  margin-right: 0;
  margin-left: 12px;
}

.ant-collapse-rtl.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow svg {
  transform: rotate(180deg);
}

.ant-collapse-rtl.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-extra {
  margin-right: auto;
  margin-left: 0;
}

.ant-collapse-rtl.ant-collapse > .ant-collapse-item.ant-collapse-no-arrow > .ant-collapse-header {
  padding-right: 12px;
  padding-left: 0;
}

.ant-comment {
  position: relative;
  background-color: inherit;
}

.ant-comment-inner {
  display: flex;
  padding: 16px 0;
}

.ant-comment-avatar {
  position: relative;
  flex-shrink: 0;
  margin-right: 12px;
  cursor: pointer;
}

.ant-comment-avatar img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
}

.ant-comment-content {
  position: relative;
  flex: 1 1 auto;
  min-width: 1px;
  font-size: 14px;
  word-wrap: break-word;
}

.ant-comment-content-author {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-bottom: 4px;
  font-size: 14px;
}

.ant-comment-content-author > a, .ant-comment-content-author > span {
  padding-right: 8px;
  font-size: 12px;
  line-height: 18px;
}

.ant-comment-content-author-name {
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
  transition: color 0.3s;
}

.ant-comment-content-author-name > *, .ant-comment-content-author-name > :hover {
  color: rgba(0, 0, 0, 0.45);
}

.ant-comment-content-author-time {
  color: #ccc;
  white-space: nowrap;
  cursor: auto;
}

.ant-comment-content-detail p {
  margin-bottom: inherit;
  white-space: pre-wrap;
}

.ant-comment-actions {
  margin-top: 12px;
  margin-bottom: inherit;
  padding-left: 0;
}

.ant-comment-actions > li {
  display: inline-block;
  color: rgba(0, 0, 0, 0.45);
}

.ant-comment-actions > li > span {
  margin-right: 10px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
  cursor: pointer;
  transition: color 0.3s;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-comment-actions > li > span:hover {
  color: #595959;
}

.ant-comment-nested {
  margin-left: 44px;
}

.ant-comment-rtl {
  direction: rtl;
}

.ant-comment-rtl .ant-comment-avatar {
  margin-right: 0;
  margin-left: 12px;
}

.ant-comment-rtl .ant-comment-content-author > a, .ant-comment-rtl .ant-comment-content-author > span {
  padding-right: 0;
  padding-left: 8px;
}

.ant-comment-rtl .ant-comment-actions {
  padding-right: 0;
}

.ant-comment-rtl .ant-comment-actions > li > span {
  margin-right: 0;
  margin-left: 10px;
}

.ant-comment-rtl .ant-comment-nested {
  margin-right: 44px;
  margin-left: 0;
}

.ant-picker-status-error.ant-picker, .ant-picker-status-error.ant-picker:not([disabled]):hover {
  background-color: #fff;
  border-color: #ff4d4f;
}

.ant-picker-status-error.ant-picker-focused, .ant-picker-status-error.ant-picker:focus {
  border-color: #ff7875;
  box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-picker-status-error.ant-picker .ant-picker-active-bar {
  background: #ff7875;
}

.ant-picker-status-warning.ant-picker, .ant-picker-status-warning.ant-picker:not([disabled]):hover {
  background-color: #fff;
  border-color: #faad14;
}

.ant-picker-status-warning.ant-picker-focused, .ant-picker-status-warning.ant-picker:focus {
  border-color: #ffc53d;
  box-shadow: 0 0 0 2px rgba(250, 173, 20, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-picker-status-warning.ant-picker .ant-picker-active-bar {
  background: #ffc53d;
}

.ant-picker {
  box-sizing: border-box;
  margin: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  padding: 4px 11px;
  position: relative;
  display: inline-flex;
  align-items: center;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  transition: border 0.3s, box-shadow 0.3s;
}

.ant-picker-focused, .ant-picker:hover {
  border-color: #40a9ff;
  border-right-width: 1px;
}

.ant-picker-focused {
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  outline: 0;
}

.ant-picker.ant-picker-disabled {
  background: #f5f5f5;
  border-color: #d9d9d9;
  cursor: not-allowed;
}

.ant-picker.ant-picker-disabled .ant-picker-suffix {
  color: rgba(0, 0, 0, 0.25);
}

.ant-picker.ant-picker-borderless {
  background-color: transparent !important;
  border-color: transparent !important;
  box-shadow: none !important;
}

.ant-picker-input {
  position: relative;
  display: inline-flex;
  align-items: center;
  width: 100%;
}

.ant-picker-input > input {
  position: relative;
  display: inline-block;
  width: 100%;
  min-width: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  line-height: 1.5715;
  background-color: #fff;
  background-image: none;
  border-radius: 2px;
  transition: all 0.3s;
  flex: auto;
  min-width: 1px;
  height: auto;
  padding: 0;
  background: transparent;
  border: 0;
}

.ant-picker-input > input::-moz-placeholder {
  color: #bfbfbf;
  -moz-user-select: none;
  user-select: none;
}

.ant-picker-input > input:-ms-input-placeholder {
  color: #bfbfbf;
  -ms-user-select: none;
  user-select: none;
}

.ant-picker-input > input::placeholder {
  color: #bfbfbf;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-picker-input > input:-moz-placeholder-shown {
  text-overflow: ellipsis;
}

.ant-picker-input > input:-ms-input-placeholder {
  text-overflow: ellipsis;
}

.ant-picker-input > input:placeholder-shown {
  text-overflow: ellipsis;
}

.ant-picker-input > input:hover {
  border-color: #40a9ff;
  border-right-width: 1px;
}

.ant-picker-input > input-focused, .ant-picker-input > input:focus {
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-picker-input > input-disabled {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}

.ant-picker-input > input-disabled:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}

.ant-picker-input > input[disabled] {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}

.ant-picker-input > input[disabled]:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}

.ant-picker-input > input-borderless, .ant-picker-input > input-borderless-disabled, .ant-picker-input > input-borderless-focused, .ant-picker-input > input-borderless:focus, .ant-picker-input > input-borderless:hover, .ant-picker-input > input-borderless[disabled] {
  background-color: transparent;
  border: none;
  box-shadow: none;
}

textarea.ant-picker-input > input {
  max-width: 100%;
  height: auto;
  min-height: 32px;
  line-height: 1.5715;
  vertical-align: bottom;
  transition: all 0.3s, height 0s;
}

.ant-picker-input > input-lg {
  padding: 6.5px 11px;
  font-size: 16px;
}

.ant-picker-input > input-sm {
  padding: 0 7px;
}

.ant-picker-input > input:focus {
  box-shadow: none;
}

.ant-picker-input > input[disabled] {
  background: transparent;
}

.ant-picker-input:hover .ant-picker-clear {
  opacity: 1;
}

.ant-picker-input-placeholder > input {
  color: #bfbfbf;
}

.ant-picker-large {
  padding: 6.5px 11px;
}

.ant-picker-large .ant-picker-input > input {
  font-size: 16px;
}

.ant-picker-small {
  padding: 0 7px;
}

.ant-picker-suffix {
  display: flex;
  flex: none;
  align-self: center;
  margin-left: 4px;
  color: rgba(0, 0, 0, 0.25);
  line-height: 1;
  pointer-events: none;
}

.ant-picker-suffix > * {
  vertical-align: top;
}

.ant-picker-suffix > :not(:last-child) {
  margin-right: 8px;
}

.ant-picker-clear {
  position: absolute;
  top: 50%;
  right: 0;
  color: rgba(0, 0, 0, 0.25);
  line-height: 1;
  background: #fff;
  transform: translateY(-50%);
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.3s, color 0.3s;
}

.ant-picker-clear > * {
  vertical-align: top;
}

.ant-picker-clear:hover {
  color: rgba(0, 0, 0, 0.45);
}

.ant-picker-separator {
  position: relative;
  display: inline-block;
  width: 1em;
  height: 16px;
  color: rgba(0, 0, 0, 0.25);
  font-size: 16px;
  vertical-align: top;
  cursor: default;
}

.ant-picker-focused .ant-picker-separator {
  color: rgba(0, 0, 0, 0.45);
}

.ant-picker-disabled .ant-picker-range-separator .ant-picker-separator {
  cursor: not-allowed;
}

.ant-picker-range {
  position: relative;
  display: inline-flex;
}

.ant-picker-range .ant-picker-clear {
  right: 11px;
}

.ant-picker-range:hover .ant-picker-clear {
  opacity: 1;
}

.ant-picker-range .ant-picker-active-bar {
  bottom: -1px;
  height: 2px;
  margin-left: 11px;
  background: #1890ff;
  opacity: 0;
  transition: all 0.3s ease-out;
  pointer-events: none;
}

.ant-picker-range.ant-picker-focused .ant-picker-active-bar {
  opacity: 1;
}

.ant-picker-range-separator {
  align-items: center;
  padding: 0 8px;
  line-height: 1;
}

.ant-picker-range.ant-picker-small .ant-picker-clear {
  right: 7px;
}

.ant-picker-range.ant-picker-small .ant-picker-active-bar {
  margin-left: 7px;
}

.ant-picker-dropdown {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: absolute;
  top: -9999px;
  left: -9999px;
  z-index: 1050;
}

.ant-picker-dropdown-hidden {
  display: none;
}

.ant-picker-dropdown-placement-bottomLeft .ant-picker-range-arrow {
  top: 2.58561808px;
  display: block;
  transform: rotate(-135deg) translateY(1px);
}

.ant-picker-dropdown-placement-topLeft .ant-picker-range-arrow {
  bottom: 2.58561808px;
  display: block;
  transform: rotate(45deg);
}

.ant-picker-dropdown.ant-slide-up-appear.ant-slide-up-appear-active.ant-picker-dropdown-placement-topLeft, .ant-picker-dropdown.ant-slide-up-appear.ant-slide-up-appear-active.ant-picker-dropdown-placement-topRight, .ant-picker-dropdown.ant-slide-up-enter.ant-slide-up-enter-active.ant-picker-dropdown-placement-topLeft, .ant-picker-dropdown.ant-slide-up-enter.ant-slide-up-enter-active.ant-picker-dropdown-placement-topRight {
  animation-name: antSlideDownIn;
}

.ant-picker-dropdown.ant-slide-up-appear.ant-slide-up-appear-active.ant-picker-dropdown-placement-bottomLeft, .ant-picker-dropdown.ant-slide-up-appear.ant-slide-up-appear-active.ant-picker-dropdown-placement-bottomRight, .ant-picker-dropdown.ant-slide-up-enter.ant-slide-up-enter-active.ant-picker-dropdown-placement-bottomLeft, .ant-picker-dropdown.ant-slide-up-enter.ant-slide-up-enter-active.ant-picker-dropdown-placement-bottomRight {
  animation-name: antSlideUpIn;
}

.ant-picker-dropdown.ant-slide-up-leave.ant-slide-up-leave-active.ant-picker-dropdown-placement-topLeft, .ant-picker-dropdown.ant-slide-up-leave.ant-slide-up-leave-active.ant-picker-dropdown-placement-topRight {
  animation-name: antSlideDownOut;
}

.ant-picker-dropdown.ant-slide-up-leave.ant-slide-up-leave-active.ant-picker-dropdown-placement-bottomLeft, .ant-picker-dropdown.ant-slide-up-leave.ant-slide-up-leave-active.ant-picker-dropdown-placement-bottomRight {
  animation-name: antSlideUpOut;
}

.ant-picker-dropdown-range {
  padding: 7.54247233px 0;
}

.ant-picker-dropdown-range-hidden {
  display: none;
}

.ant-picker-dropdown .ant-picker-panel > .ant-picker-time-panel {
  padding-top: 4px;
}

.ant-picker-ranges {
  margin-bottom: 0;
  padding: 4px 12px;
  overflow: hidden;
  line-height: 34px;
  text-align: left;
  list-style: none;
}

.ant-picker-ranges > li {
  display: inline-block;
}

.ant-picker-ranges .ant-picker-preset > .ant-tag-blue {
  color: #1890ff;
  background: #e6f7ff;
  border-color: #91d5ff;
  cursor: pointer;
}

.ant-picker-ranges .ant-picker-ok {
  float: right;
  margin-left: 8px;
}

.ant-picker-range-wrapper {
  display: flex;
}

.ant-picker-range-arrow {
  position: absolute;
  z-index: 1;
  display: none;
  width: 11.3137085px;
  height: 11.3137085px;
  margin-left: 16.5px;
  box-shadow: 2px 2px 6px -2px rgba(0, 0, 0, 0.1);
  transition: left 0.3s ease-out;
  border-radius: 0 0 2px;
  pointer-events: none;
}

.ant-picker-range-arrow:before {
  position: absolute;
  top: -11.3137085px;
  left: -11.3137085px;
  width: 33.9411255px;
  height: 33.9411255px;
  background: #fff;
  background-repeat: no-repeat;
  background-position: -10px -10px;
  content: "";
  -webkit-clip-path: inset(33% 33%);
  clip-path: inset(33% 33%);
  -webkit-clip-path: path("M 9.849242404917499 24.091883092036785 A 5 5 0 0 1 13.384776310850237 22.627416997969522 L 20.627416997969522 22.627416997969522 A 2 2 0 0 0 22.627416997969522 20.627416997969522 L 22.627416997969522 13.384776310850237 A 5 5 0 0 1 24.091883092036785 9.849242404917499 L 23.091883092036785 9.849242404917499 L 9.849242404917499 23.091883092036785 Z");
  clip-path: path("M 9.849242404917499 24.091883092036785 A 5 5 0 0 1 13.384776310850237 22.627416997969522 L 20.627416997969522 22.627416997969522 A 2 2 0 0 0 22.627416997969522 20.627416997969522 L 22.627416997969522 13.384776310850237 A 5 5 0 0 1 24.091883092036785 9.849242404917499 L 23.091883092036785 9.849242404917499 L 9.849242404917499 23.091883092036785 Z");
}

.ant-picker-panel-container {
  overflow: hidden;
  vertical-align: top;
  background: #fff;
  border-radius: 2px;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
  transition: margin 0.3s;
}

.ant-picker-panel-container .ant-picker-panels {
  display: inline-flex;
  flex-wrap: nowrap;
  direction: ltr;
}

.ant-picker-panel-container .ant-picker-panel {
  vertical-align: top;
  background: transparent;
  border-width: 0 0 1px;
  border-radius: 0;
}

.ant-picker-panel-container .ant-picker-panel .ant-picker-content, .ant-picker-panel-container .ant-picker-panel table {
  text-align: center;
}

.ant-picker-panel-container .ant-picker-panel-focused {
  border-color: #f0f0f0;
}

.ant-picker-compact-item:not(.ant-picker-compact-last-item):not(.ant-picker-compact-item-rtl) {
  margin-right: -1px;
}

.ant-picker-compact-item:not(.ant-picker-compact-last-item).ant-picker-compact-item-rtl {
  margin-left: -1px;
}

.ant-picker-compact-item.ant-picker-focused, .ant-picker-compact-item:active, .ant-picker-compact-item:focus, .ant-picker-compact-item:hover {
  z-index: 2;
}

.ant-picker-compact-item[disabled] {
  z-index: 0;
}

.ant-picker-compact-item:not(.ant-picker-compact-first-item):not(.ant-picker-compact-last-item).ant-picker {
  border-radius: 0;
}

.ant-picker-compact-item.ant-picker.ant-picker-compact-first-item:not(.ant-picker-compact-last-item):not(.ant-picker-compact-item-rtl) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-picker-compact-item.ant-picker.ant-picker-compact-item-rtl.ant-picker-compact-first-item:not(.ant-picker-compact-last-item), .ant-picker-compact-item.ant-picker.ant-picker-compact-last-item:not(.ant-picker-compact-first-item):not(.ant-picker-compact-item-rtl) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.ant-picker-compact-item.ant-picker.ant-picker-compact-item-rtl.ant-picker-compact-last-item:not(.ant-picker-compact-first-item) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-picker-panel {
  display: inline-flex;
  flex-direction: column;
  text-align: center;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 2px;
  outline: none;
}

.ant-picker-panel-focused {
  border-color: #1890ff;
}

.ant-picker-date-panel, .ant-picker-decade-panel, .ant-picker-month-panel, .ant-picker-quarter-panel, .ant-picker-time-panel, .ant-picker-week-panel, .ant-picker-year-panel {
  display: flex;
  flex-direction: column;
  width: 280px;
}

.ant-picker-header {
  display: flex;
  padding: 0 8px;
  color: rgba(0, 0, 0, 0.85);
  border-bottom: 1px solid #f0f0f0;
}

.ant-picker-header > * {
  flex: none;
}

.ant-picker-header button {
  padding: 0;
  color: rgba(0, 0, 0, 0.25);
  line-height: 40px;
  background: transparent;
  border: 0;
  cursor: pointer;
  transition: color 0.3s;
}

.ant-picker-header > button {
  min-width: 1.6em;
  font-size: 14px;
}

.ant-picker-header > button:hover {
  color: rgba(0, 0, 0, 0.85);
}

.ant-picker-header-view {
  flex: auto;
  font-weight: 500;
  line-height: 40px;
}

.ant-picker-header-view button {
  color: inherit;
  font-weight: inherit;
}

.ant-picker-header-view button:not(:first-child) {
  margin-left: 8px;
}

.ant-picker-header-view button:hover {
  color: #1890ff;
}

.ant-picker-next-icon, .ant-picker-prev-icon, .ant-picker-super-next-icon, .ant-picker-super-prev-icon {
  position: relative;
  display: inline-block;
  width: 7px;
  height: 7px;
}

.ant-picker-next-icon:before, .ant-picker-prev-icon:before, .ant-picker-super-next-icon:before, .ant-picker-super-prev-icon:before {
  position: absolute;
  top: 0;
  left: 0;
  display: inline-block;
  width: 7px;
  height: 7px;
  border: 0 solid;
  border-width: 1.5px 0 0 1.5px;
  content: "";
}

.ant-picker-super-next-icon:after, .ant-picker-super-prev-icon:after {
  position: absolute;
  top: 4px;
  left: 4px;
  display: inline-block;
  width: 7px;
  height: 7px;
  border: 0 solid;
  border-width: 1.5px 0 0 1.5px;
  content: "";
}

.ant-picker-prev-icon, .ant-picker-super-prev-icon {
  transform: rotate(-45deg);
}

.ant-picker-next-icon, .ant-picker-super-next-icon {
  transform: rotate(135deg);
}

.ant-picker-content {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}

.ant-picker-content td, .ant-picker-content th {
  position: relative;
  min-width: 24px;
  font-weight: 400;
}

.ant-picker-content th {
  height: 30px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 30px;
}

.ant-picker-cell {
  padding: 3px 0;
  color: rgba(0, 0, 0, 0.25);
  cursor: pointer;
}

.ant-picker-cell-in-view {
  color: rgba(0, 0, 0, 0.85);
}

.ant-picker-cell:before {
  position: absolute;
  top: 50%;
  right: 0;
  left: 0;
  z-index: 1;
  height: 24px;
  transform: translateY(-50%);
  transition: all 0.3s;
  content: "";
}

.ant-picker-cell:hover:not(.ant-picker-cell-in-view) .ant-picker-cell-inner, .ant-picker-cell:hover:not(.ant-picker-cell-selected):not(.ant-picker-cell-range-start):not(.ant-picker-cell-range-end):not(.ant-picker-cell-range-hover-start):not(.ant-picker-cell-range-hover-end) .ant-picker-cell-inner {
  background: #f5f5f5;
}

.ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner:before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  border: 1px solid #1890ff;
  border-radius: 2px;
  content: "";
}

.ant-picker-cell-in-view.ant-picker-cell-in-range {
  position: relative;
}

.ant-picker-cell-in-view.ant-picker-cell-in-range:before {
  background: #e6f7ff;
}

.ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner, .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner, .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner {
  color: #fff;
  background: #1890ff;
}

.ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single):before, .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single):before {
  background: #e6f7ff;
}

.ant-picker-cell-in-view.ant-picker-cell-range-start:before {
  left: 50%;
}

.ant-picker-cell-in-view.ant-picker-cell-range-end:before {
  right: 50%;
}

.ant-picker-cell-in-view.ant-picker-cell-range-hover-end.ant-picker-cell-range-end-single:after, .ant-picker-cell-in-view.ant-picker-cell-range-hover-end.ant-picker-cell-range-start.ant-picker-cell-range-end.ant-picker-cell-range-start-near-hover:after, .ant-picker-cell-in-view.ant-picker-cell-range-hover-end:not(.ant-picker-cell-in-range):not(.ant-picker-cell-range-start):not(.ant-picker-cell-range-end):after, .ant-picker-cell-in-view.ant-picker-cell-range-hover-start.ant-picker-cell-range-start-single:after, .ant-picker-cell-in-view.ant-picker-cell-range-hover-start.ant-picker-cell-range-start.ant-picker-cell-range-end.ant-picker-cell-range-end-near-hover:after, .ant-picker-cell-in-view.ant-picker-cell-range-hover-start:not(.ant-picker-cell-in-range):not(.ant-picker-cell-range-start):not(.ant-picker-cell-range-end):after, .ant-picker-cell-in-view.ant-picker-cell-range-hover:not(.ant-picker-cell-in-range):after {
  position: absolute;
  top: 50%;
  z-index: 0;
  height: 24px;
  border-top: 1px dashed #7ec1ff;
  border-bottom: 1px dashed #7ec1ff;
  transform: translateY(-50%);
  transition: all 0.3s;
  content: "";
}

.ant-picker-cell-range-hover-end:after, .ant-picker-cell-range-hover-start:after, .ant-picker-cell-range-hover:after {
  right: 0;
  left: 2px;
}

.ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover:before, .ant-picker-cell-in-view.ant-picker-cell-range-end.ant-picker-cell-range-hover:before, .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single).ant-picker-cell-range-hover-end:before, .ant-picker-cell-in-view.ant-picker-cell-range-start.ant-picker-cell-range-hover:before, .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single).ant-picker-cell-range-hover-start:before, .ant-picker-panel > :not(.ant-picker-date-panel) .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-end:before, .ant-picker-panel > :not(.ant-picker-date-panel) .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-start:before {
  background: #cbe6ff;
}

.ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single):not(.ant-picker-cell-range-end) .ant-picker-cell-inner {
  border-radius: 2px 0 0 2px;
}

.ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single):not(.ant-picker-cell-range-start) .ant-picker-cell-inner {
  border-radius: 0 2px 2px 0;
}

.ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-end .ant-picker-cell-inner:after, .ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-start .ant-picker-cell-inner:after {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: -1;
  background: #cbe6ff;
  transition: all 0.3s;
  content: "";
}

.ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-start .ant-picker-cell-inner:after {
  right: -6px;
  left: 0;
}

.ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-end .ant-picker-cell-inner:after {
  right: 0;
  left: -6px;
}

.ant-picker-cell-range-hover.ant-picker-cell-range-start:after {
  right: 50%;
}

.ant-picker-cell-range-hover.ant-picker-cell-range-end:after {
  left: 50%;
}

.ant-picker-cell-in-view.ant-picker-cell-range-hover-edge-start:not(.ant-picker-cell-range-hover-edge-start-near-range):after, .ant-picker-cell-in-view.ant-picker-cell-range-hover-start:after, .ant-picker-cell-in-view.ant-picker-cell-start.ant-picker-cell-range-hover-edge-start.ant-picker-cell-range-hover-edge-start-near-range:after, tr > .ant-picker-cell-in-view.ant-picker-cell-range-hover-end:first-child:after, tr > .ant-picker-cell-in-view.ant-picker-cell-range-hover:first-child:after {
  left: 6px;
  border-left: 1px dashed #7ec1ff;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}

.ant-picker-cell-in-view.ant-picker-cell-end.ant-picker-cell-range-hover-edge-end.ant-picker-cell-range-hover-edge-end-near-range:after, .ant-picker-cell-in-view.ant-picker-cell-range-hover-edge-end:not(.ant-picker-cell-range-hover-edge-end-near-range):after, .ant-picker-cell-in-view.ant-picker-cell-range-hover-end:after, tr > .ant-picker-cell-in-view.ant-picker-cell-range-hover-start:last-child:after, tr > .ant-picker-cell-in-view.ant-picker-cell-range-hover:last-child:after {
  right: 6px;
  border-right: 1px dashed #7ec1ff;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
}

.ant-picker-cell-disabled {
  color: rgba(0, 0, 0, 0.25);
  pointer-events: none;
}

.ant-picker-cell-disabled .ant-picker-cell-inner {
  background: transparent;
}

.ant-picker-cell-disabled:before {
  background: rgba(0, 0, 0, 0.04);
}

.ant-picker-cell-disabled.ant-picker-cell-today .ant-picker-cell-inner:before {
  border-color: rgba(0, 0, 0, 0.25);
}

.ant-picker-decade-panel .ant-picker-content, .ant-picker-month-panel .ant-picker-content, .ant-picker-quarter-panel .ant-picker-content, .ant-picker-year-panel .ant-picker-content {
  height: 264px;
}

.ant-picker-decade-panel .ant-picker-cell-inner, .ant-picker-month-panel .ant-picker-cell-inner, .ant-picker-quarter-panel .ant-picker-cell-inner, .ant-picker-year-panel .ant-picker-cell-inner {
  padding: 0 8px;
}

.ant-picker-quarter-panel .ant-picker-content {
  height: 56px;
}

.ant-picker-footer {
  width: -moz-min-content;
  width: min-content;
  min-width: 100%;
  line-height: 38px;
  text-align: center;
  border-bottom: 1px solid transparent;
}

.ant-picker-panel .ant-picker-footer {
  border-top: 1px solid #f0f0f0;
}

.ant-picker-footer-extra {
  padding: 0 12px;
  line-height: 38px;
  text-align: left;
}

.ant-picker-footer-extra:not(:last-child) {
  border-bottom: 1px solid #f0f0f0;
}

.ant-picker-now {
  text-align: left;
}

.ant-picker-today-btn {
  color: #1890ff;
}

.ant-picker-today-btn:hover {
  color: #40a9ff;
}

.ant-picker-today-btn:active {
  color: #096dd9;
}

.ant-picker-today-btn.ant-picker-today-btn-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ant-picker-decade-panel .ant-picker-cell-inner {
  padding: 0 4px;
}

.ant-picker-decade-panel .ant-picker-cell:before {
  display: none;
}

.ant-picker-month-panel .ant-picker-body, .ant-picker-quarter-panel .ant-picker-body, .ant-picker-year-panel .ant-picker-body {
  padding: 0 8px;
}

.ant-picker-month-panel .ant-picker-cell-inner, .ant-picker-quarter-panel .ant-picker-cell-inner, .ant-picker-year-panel .ant-picker-cell-inner {
  width: 60px;
}

.ant-picker-month-panel .ant-picker-cell-range-hover-start:after, .ant-picker-quarter-panel .ant-picker-cell-range-hover-start:after, .ant-picker-year-panel .ant-picker-cell-range-hover-start:after {
  left: 14px;
  border-left: 1px dashed #7ec1ff;
  border-radius: 2px 0 0 2px;
}

.ant-picker-month-panel .ant-picker-cell-range-hover-end:after, .ant-picker-panel-rtl .ant-picker-month-panel .ant-picker-cell-range-hover-start:after, .ant-picker-panel-rtl .ant-picker-quarter-panel .ant-picker-cell-range-hover-start:after, .ant-picker-panel-rtl .ant-picker-year-panel .ant-picker-cell-range-hover-start:after, .ant-picker-quarter-panel .ant-picker-cell-range-hover-end:after, .ant-picker-year-panel .ant-picker-cell-range-hover-end:after {
  right: 14px;
  border-right: 1px dashed #7ec1ff;
  border-radius: 0 2px 2px 0;
}

.ant-picker-panel-rtl .ant-picker-month-panel .ant-picker-cell-range-hover-end:after, .ant-picker-panel-rtl .ant-picker-quarter-panel .ant-picker-cell-range-hover-end:after, .ant-picker-panel-rtl .ant-picker-year-panel .ant-picker-cell-range-hover-end:after {
  left: 14px;
  border-left: 1px dashed #7ec1ff;
  border-radius: 2px 0 0 2px;
}

.ant-picker-week-panel .ant-picker-body {
  padding: 8px 12px;
}

.ant-picker-week-panel .ant-picker-cell-selected .ant-picker-cell-inner, .ant-picker-week-panel .ant-picker-cell .ant-picker-cell-inner, .ant-picker-week-panel .ant-picker-cell:hover .ant-picker-cell-inner {
  background: transparent !important;
}

.ant-picker-week-panel-row td {
  transition: background 0.3s;
}

.ant-picker-week-panel-row:hover td {
  background: #f5f5f5;
}

.ant-picker-week-panel-row-selected:hover td, .ant-picker-week-panel-row-selected td {
  background: #1890ff;
}

.ant-picker-week-panel-row-selected:hover td.ant-picker-cell-week, .ant-picker-week-panel-row-selected td.ant-picker-cell-week {
  color: hsla(0, 0%, 100%, 0.5);
}

.ant-picker-week-panel-row-selected:hover td.ant-picker-cell-today .ant-picker-cell-inner:before, .ant-picker-week-panel-row-selected td.ant-picker-cell-today .ant-picker-cell-inner:before {
  border-color: #fff;
}

.ant-picker-week-panel-row-selected:hover td .ant-picker-cell-inner, .ant-picker-week-panel-row-selected td .ant-picker-cell-inner {
  color: #fff;
}

.ant-picker-date-panel .ant-picker-body {
  padding: 8px 12px;
}

.ant-picker-date-panel .ant-picker-content {
  width: 252px;
}

.ant-picker-date-panel .ant-picker-content th {
  width: 36px;
}

.ant-picker-datetime-panel {
  display: flex;
}

.ant-picker-datetime-panel .ant-picker-time-panel {
  border-left: 1px solid #f0f0f0;
}

.ant-picker-datetime-panel .ant-picker-date-panel, .ant-picker-datetime-panel .ant-picker-time-panel {
  transition: opacity 0.3s;
}

.ant-picker-datetime-panel-active .ant-picker-date-panel, .ant-picker-datetime-panel-active .ant-picker-time-panel {
  opacity: 0.3;
}

.ant-picker-datetime-panel-active .ant-picker-date-panel-active, .ant-picker-datetime-panel-active .ant-picker-time-panel-active {
  opacity: 1;
}

.ant-picker-time-panel {
  width: auto;
  min-width: auto;
}

.ant-picker-time-panel .ant-picker-content {
  display: flex;
  flex: auto;
  height: 224px;
}

.ant-picker-time-panel-column {
  flex: 1 0 auto;
  width: 56px;
  margin: 0;
  padding: 0;
  overflow-y: hidden;
  text-align: left;
  list-style: none;
  transition: background 0.3s;
}

.ant-picker-time-panel-column:after {
  display: block;
  height: 196px;
  content: "";
}

.ant-picker-datetime-panel .ant-picker-time-panel-column:after {
  height: 198px;
}

.ant-picker-time-panel-column:not(:first-child) {
  border-left: 1px solid #f0f0f0;
}

.ant-picker-time-panel-column-active {
  background: rgba(230, 247, 255, 0.2);
}

.ant-picker-time-panel-column:hover {
  overflow-y: auto;
}

.ant-picker-time-panel-column > li {
  margin: 0;
  padding: 0;
}

.ant-picker-time-panel-column > li.ant-picker-time-panel-cell .ant-picker-time-panel-cell-inner {
  display: block;
  width: 100%;
  height: 28px;
  margin: 0;
  padding: 0 0 0 14px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 28px;
  border-radius: 0;
  cursor: pointer;
  transition: background 0.3s;
}

.ant-picker-time-panel-column > li.ant-picker-time-panel-cell .ant-picker-time-panel-cell-inner:hover {
  background: #f5f5f5;
}

.ant-picker-time-panel-column > li.ant-picker-time-panel-cell-selected .ant-picker-time-panel-cell-inner {
  background: #e6f7ff;
}

.ant-picker-time-panel-column > li.ant-picker-time-panel-cell-disabled .ant-picker-time-panel-cell-inner {
  color: rgba(0, 0, 0, 0.25);
  background: transparent;
  cursor: not-allowed;
}

:root .ant-picker-range-wrapper .ant-picker-month-panel .ant-picker-cell, :root .ant-picker-range-wrapper .ant-picker-year-panel .ant-picker-cell, _:-ms-fullscreen .ant-picker-range-wrapper .ant-picker-month-panel .ant-picker-cell, _:-ms-fullscreen .ant-picker-range-wrapper .ant-picker-year-panel .ant-picker-cell {
  padding: 21px 0;
}

.ant-picker-rtl {
  direction: rtl;
}

.ant-picker-rtl .ant-picker-suffix {
  margin-right: 4px;
  margin-left: 0;
}

.ant-picker-rtl .ant-picker-clear {
  right: auto;
  left: 0;
}

.ant-picker-rtl .ant-picker-separator {
  transform: rotate(180deg);
}

.ant-picker-panel-rtl .ant-picker-header-view button:not(:first-child) {
  margin-right: 8px;
  margin-left: 0;
}

.ant-picker-rtl.ant-picker-range .ant-picker-clear {
  right: auto;
  left: 11px;
}

.ant-picker-rtl.ant-picker-range .ant-picker-active-bar {
  margin-right: 11px;
  margin-left: 0;
}

.ant-picker-rtl.ant-picker-range.ant-picker-small .ant-picker-active-bar {
  margin-right: 7px;
}

.ant-picker-dropdown-rtl .ant-picker-ranges {
  text-align: right;
}

.ant-picker-dropdown-rtl .ant-picker-ranges .ant-picker-ok {
  float: left;
  margin-right: 8px;
  margin-left: 0;
}

.ant-picker-panel-rtl {
  direction: rtl;
}

.ant-picker-panel-rtl .ant-picker-prev-icon, .ant-picker-panel-rtl .ant-picker-super-prev-icon {
  transform: rotate(135deg);
}

.ant-picker-panel-rtl .ant-picker-next-icon, .ant-picker-panel-rtl .ant-picker-super-next-icon {
  transform: rotate(-45deg);
}

.ant-picker-cell .ant-picker-cell-inner {
  position: relative;
  z-index: 2;
  display: inline-block;
  min-width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 2px;
  transition: background 0.3s, border 0.3s;
}

.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-range-start:before {
  right: 50%;
  left: 0;
}

.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-range-end:before {
  right: 0;
  left: 50%;
}

.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-range-start.ant-picker-cell-range-end:before {
  right: 50%;
  left: 50%;
}

.ant-picker-panel-rtl .ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-start .ant-picker-cell-inner:after {
  right: 0;
  left: -6px;
}

.ant-picker-panel-rtl .ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-end .ant-picker-cell-inner:after {
  right: -6px;
  left: 0;
}

.ant-picker-panel-rtl .ant-picker-cell-range-hover.ant-picker-cell-range-start:after {
  right: 0;
  left: 50%;
}

.ant-picker-panel-rtl .ant-picker-cell-range-hover.ant-picker-cell-range-end:after {
  right: 50%;
  left: 0;
}

.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single):not(.ant-picker-cell-range-end) .ant-picker-cell-inner {
  border-radius: 0 2px 2px 0;
}

.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single):not(.ant-picker-cell-range-start) .ant-picker-cell-inner {
  border-radius: 2px 0 0 2px;
}

.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-range-hover-edge-start:not(.ant-picker-cell-range-hover-edge-start-near-range):after, .ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-range-hover-start:after, .ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-start.ant-picker-cell-range-hover-edge-start.ant-picker-cell-range-hover-edge-start-near-range:after, .ant-picker-panel-rtl tr > .ant-picker-cell-in-view.ant-picker-cell-range-hover:not(.ant-picker-cell-selected):first-child:after {
  right: 6px;
  left: 0;
  border-right: 1px dashed #7ec1ff;
  border-left: none;
  border-radius: 0 2px 2px 0;
}

.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-end.ant-picker-cell-range-hover-edge-end.ant-picker-cell-range-hover-edge-end-near-range:after, .ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-range-hover-edge-end:not(.ant-picker-cell-range-hover-edge-end-near-range):after, .ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-range-hover-end:after, .ant-picker-panel-rtl tr > .ant-picker-cell-in-view.ant-picker-cell-range-hover:not(.ant-picker-cell-selected):last-child:after {
  right: 0;
  left: 6px;
  border-right: none;
  border-left: 1px dashed #7ec1ff;
  border-radius: 2px 0 0 2px;
}

.ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-end.ant-picker-cell-range-hover-start.ant-picker-cell-range-hover-edge-end:not(.ant-picker-cell-range-hover):after, .ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-start.ant-picker-cell-range-hover-edge-start:not(.ant-picker-cell-range-hover):after, .ant-picker-panel-rtl .ant-picker-cell-in-view.ant-picker-cell-start.ant-picker-cell-range-hover-end.ant-picker-cell-range-hover-edge-start:not(.ant-picker-cell-range-hover):after, .ant-picker-panel-rtl tr > .ant-picker-cell-in-view.ant-picker-cell-end.ant-picker-cell-range-hover.ant-picker-cell-range-hover-edge-end:first-child:after, .ant-picker-panel-rtl tr > .ant-picker-cell-in-view.ant-picker-cell-range-hover-end:first-child:after, .ant-picker-panel-rtl tr > .ant-picker-cell-in-view.ant-picker-cell-range-hover-start:last-child:after, .ant-picker-panel-rtl tr > .ant-picker-cell-in-view.ant-picker-cell-start.ant-picker-cell-range-hover.ant-picker-cell-range-hover-edge-start:last-child:after {
  right: 6px;
  left: 6px;
  border-right: 1px dashed #7ec1ff;
  border-left: 1px dashed #7ec1ff;
  border-radius: 2px;
}

.ant-picker-dropdown-rtl .ant-picker-footer-extra {
  direction: rtl;
  text-align: right;
}

.ant-picker-panel-rtl .ant-picker-time-panel {
  direction: ltr;
}

.ant-descriptions-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.ant-descriptions-title {
  flex: auto;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 700;
  font-size: 16px;
  line-height: 1.5715;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ant-descriptions-extra {
  margin-left: auto;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
}

.ant-descriptions-view {
  width: 100%;
  border-radius: 2px;
}

.ant-descriptions-view table {
  width: 100%;
  table-layout: fixed;
}

.ant-descriptions-row > td, .ant-descriptions-row > th {
  padding-bottom: 16px;
}

.ant-descriptions-row:last-child {
  border-bottom: none;
}

.ant-descriptions-item-label {
  color: rgba(0, 0, 0, 0.85);
  font-weight: 400;
  font-size: 14px;
  line-height: 1.5715;
  text-align: start;
}

.ant-descriptions-item-label:after {
  content: ":";
  position: relative;
  top: -0.5px;
  margin: 0 8px 0 2px;
}

.ant-descriptions-item-label.ant-descriptions-item-no-colon:after {
  content: " ";
}

.ant-descriptions-item-no-label:after {
  margin: 0;
  content: "";
}

.ant-descriptions-item-content {
  display: table-cell;
  flex: 1;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  line-height: 1.5715;
  word-break: break-word;
  overflow-wrap: break-word;
}

.ant-descriptions-item {
  padding-bottom: 0;
  vertical-align: top;
}

.ant-descriptions-item-container {
  display: flex;
}

.ant-descriptions-item-container .ant-descriptions-item-content, .ant-descriptions-item-container .ant-descriptions-item-label {
  display: inline-flex;
  align-items: baseline;
}

.ant-descriptions-middle .ant-descriptions-row > td, .ant-descriptions-middle .ant-descriptions-row > th {
  padding-bottom: 12px;
}

.ant-descriptions-small .ant-descriptions-row > td, .ant-descriptions-small .ant-descriptions-row > th {
  padding-bottom: 8px;
}

.ant-descriptions-bordered .ant-descriptions-view {
  border: 1px solid #f0f0f0;
}

.ant-descriptions-bordered .ant-descriptions-view > table {
  table-layout: auto;
  border-collapse: collapse;
}

.ant-descriptions-bordered .ant-descriptions-item-content, .ant-descriptions-bordered .ant-descriptions-item-label {
  padding: 16px 24px;
  border-right: 1px solid #f0f0f0;
}

.ant-descriptions-bordered .ant-descriptions-item-content:last-child, .ant-descriptions-bordered .ant-descriptions-item-label:last-child {
  border-right: none;
}

.ant-descriptions-bordered .ant-descriptions-item-label {
  background-color: #fafafa;
}

.ant-descriptions-bordered .ant-descriptions-item-label:after {
  display: none;
}

.ant-descriptions-bordered .ant-descriptions-row {
  border-bottom: 1px solid #f0f0f0;
}

.ant-descriptions-bordered .ant-descriptions-row:last-child {
  border-bottom: none;
}

.ant-descriptions-bordered.ant-descriptions-middle .ant-descriptions-item-content, .ant-descriptions-bordered.ant-descriptions-middle .ant-descriptions-item-label {
  padding: 12px 24px;
}

.ant-descriptions-bordered.ant-descriptions-small .ant-descriptions-item-content, .ant-descriptions-bordered.ant-descriptions-small .ant-descriptions-item-label {
  padding: 8px 16px;
}

.ant-descriptions-rtl {
  direction: rtl;
}

.ant-descriptions-rtl .ant-descriptions-item-label:after {
  margin: 0 2px 0 8px;
}

.ant-descriptions-rtl.ant-descriptions-bordered .ant-descriptions-item-content, .ant-descriptions-rtl.ant-descriptions-bordered .ant-descriptions-item-label {
  border-right: none;
  border-left: 1px solid #f0f0f0;
}

.ant-descriptions-rtl.ant-descriptions-bordered .ant-descriptions-item-content:last-child, .ant-descriptions-rtl.ant-descriptions-bordered .ant-descriptions-item-label:last-child {
  border-left: none;
}

.ant-divider {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.ant-divider-vertical {
  position: relative;
  top: -0.06em;
  display: inline-block;
  height: 0.9em;
  margin: 0 8px;
  vertical-align: middle;
  border-top: 0;
  border-left: 1px solid rgba(0, 0, 0, 0.06);
}

.ant-divider-horizontal {
  display: flex;
  clear: both;
  width: 100%;
  min-width: 100%;
  margin: 24px 0;
}

.ant-divider-horizontal.ant-divider-with-text {
  display: flex;
  align-items: center;
  margin: 16px 0;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  font-size: 16px;
  white-space: nowrap;
  text-align: center;
  border-top: 0;
  border-top-color: rgba(0, 0, 0, 0.06);
}

.ant-divider-horizontal.ant-divider-with-text:after, .ant-divider-horizontal.ant-divider-with-text:before {
  position: relative;
  width: 50%;
  border-top: 1px solid transparent;
  border-top-color: inherit;
  border-bottom: 0;
  transform: translateY(50%);
  content: "";
}

.ant-divider-horizontal.ant-divider-with-text-left:before {
  width: 5%;
}

.ant-divider-horizontal.ant-divider-with-text-left:after, .ant-divider-horizontal.ant-divider-with-text-right:before {
  width: 95%;
}

.ant-divider-horizontal.ant-divider-with-text-right:after {
  width: 5%;
}

.ant-divider-inner-text {
  display: inline-block;
  padding: 0 1em;
}

.ant-divider-dashed {
  background: none;
  border: dashed rgba(0, 0, 0, 0.06);
  border-width: 1px 0 0;
}

.ant-divider-horizontal.ant-divider-with-text.ant-divider-dashed:after, .ant-divider-horizontal.ant-divider-with-text.ant-divider-dashed:before {
  border-style: dashed none none;
}

.ant-divider-vertical.ant-divider-dashed {
  border-width: 0 0 0 1px;
}

.ant-divider-plain.ant-divider-with-text {
  color: rgba(0, 0, 0, 0.85);
  font-weight: 400;
  font-size: 14px;
}

.ant-divider-horizontal.ant-divider-with-text-left.ant-divider-no-default-orientation-margin-left:before {
  width: 0;
}

.ant-divider-horizontal.ant-divider-with-text-left.ant-divider-no-default-orientation-margin-left:after {
  width: 100%;
}

.ant-divider-horizontal.ant-divider-with-text-left.ant-divider-no-default-orientation-margin-left .ant-divider-inner-text {
  padding-left: 0;
}

.ant-divider-horizontal.ant-divider-with-text-right.ant-divider-no-default-orientation-margin-right:before {
  width: 100%;
}

.ant-divider-horizontal.ant-divider-with-text-right.ant-divider-no-default-orientation-margin-right:after {
  width: 0;
}

.ant-divider-horizontal.ant-divider-with-text-right.ant-divider-no-default-orientation-margin-right .ant-divider-inner-text {
  padding-right: 0;
}

.ant-divider-rtl {
  direction: rtl;
}

.ant-divider-rtl.ant-divider-horizontal.ant-divider-with-text-left:before {
  width: 95%;
}

.ant-divider-rtl.ant-divider-horizontal.ant-divider-with-text-left:after, .ant-divider-rtl.ant-divider-horizontal.ant-divider-with-text-right:before {
  width: 5%;
}

.ant-divider-rtl.ant-divider-horizontal.ant-divider-with-text-right:after {
  width: 95%;
}

.ant-drawer {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  pointer-events: none;
}

.ant-drawer-inline {
  position: absolute;
}

.ant-drawer-mask {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.45);
  pointer-events: auto;
}

.ant-drawer-content-wrapper {
  position: absolute;
  z-index: 1000;
  transition: all 0.3s;
}

.ant-drawer-content-wrapper-hidden {
  display: none;
}

.ant-drawer-left > .ant-drawer-content-wrapper {
  top: 0;
  bottom: 0;
  left: 0;
  box-shadow: 6px 0 16px -8px rgba(0, 0, 0, 0.08), 9px 0 28px 0 rgba(0, 0, 0, 0.05), 12px 0 48px 16px rgba(0, 0, 0, 0.03);
}

.ant-drawer-right > .ant-drawer-content-wrapper {
  top: 0;
  right: 0;
  bottom: 0;
  box-shadow: -6px 0 16px -8px rgba(0, 0, 0, 0.08), -9px 0 28px 0 rgba(0, 0, 0, 0.05), -12px 0 48px 16px rgba(0, 0, 0, 0.03);
}

.ant-drawer-top > .ant-drawer-content-wrapper {
  top: 0;
  right: 0;
  left: 0;
  box-shadow: 0 6px 16px -8px rgba(0, 0, 0, 0.08), 0 9px 28px 0 rgba(0, 0, 0, 0.05), 0 12px 48px 16px rgba(0, 0, 0, 0.03);
}

.ant-drawer-bottom > .ant-drawer-content-wrapper {
  right: 0;
  bottom: 0;
  left: 0;
  box-shadow: 0 -6px 16px -8px rgba(0, 0, 0, 0.08), 0 -9px 28px 0 rgba(0, 0, 0, 0.05), 0 -12px 48px 16px rgba(0, 0, 0, 0.03);
}

.ant-drawer-content {
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #fff;
  pointer-events: auto;
}

.ant-drawer-wrapper-body {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.ant-drawer-header {
  display: flex;
  flex: 0;
  align-items: center;
  padding: 16px 24px;
  font-size: 16px;
  line-height: 22px;
  border-bottom: 1px solid #f0f0f0;
}

.ant-drawer-header-title {
  display: flex;
  flex: 1;
  align-items: center;
  min-width: 0;
  min-height: 0;
}

.ant-drawer-extra {
  flex: none;
}

.ant-drawer-close {
  display: inline-block;
  margin-right: 12px;
  color: rgba(0, 0, 0, 0.45);
  font-weight: 700;
  font-size: 16px;
  font-style: normal;
  line-height: 1;
  text-align: center;
  text-transform: none;
  text-decoration: none;
  background: transparent;
  border: 0;
  outline: 0;
  cursor: pointer;
  transition: color 0.3s;
  text-rendering: auto;
}

.ant-drawer-close:focus, .ant-drawer-close:hover {
  color: rgba(0, 0, 0, 0.75);
  text-decoration: none;
}

.ant-drawer-title {
  flex: 1;
  margin: 0;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
}

.ant-drawer-body {
  flex: 1;
  min-width: 0;
  min-height: 0;
  padding: 24px;
  overflow: auto;
}

.ant-drawer-footer {
  flex-shrink: 0;
  padding: 10px 16px;
  border-top: 1px solid #f0f0f0;
}

.panel-motion-appear-start, .panel-motion-enter-start, .panel-motion-leave-start {
  transition: none;
}

.ant-drawer-mask-motion-appear-active, .ant-drawer-mask-motion-enter-active, .ant-drawer-mask-motion-leave-active, .panel-motion-appear-active, .panel-motion-enter-active, .panel-motion-leave-active {
  transition: all 0.3s;
}

.ant-drawer-mask-motion-appear, .ant-drawer-mask-motion-enter {
  opacity: 0;
}

.ant-drawer-mask-motion-appear-active, .ant-drawer-mask-motion-enter-active, .ant-drawer-mask-motion-leave {
  opacity: 1;
}

.ant-drawer-mask-motion-leave-active {
  opacity: 0;
}

.ant-drawer-panel-motion-left-appear-start, .ant-drawer-panel-motion-left-enter-start, .ant-drawer-panel-motion-left-leave-start {
  transition: none;
}

.ant-drawer-panel-motion-left-appear-active, .ant-drawer-panel-motion-left-enter-active, .ant-drawer-panel-motion-left-leave-active {
  transition: all 0.3s;
}

.ant-drawer-panel-motion-left-appear-start, .ant-drawer-panel-motion-left-enter-start {
  transform: translateX(-100%) !important;
}

.ant-drawer-panel-motion-left-appear-active, .ant-drawer-panel-motion-left-enter-active, .ant-drawer-panel-motion-left-leave {
  transform: translateX(0);
}

.ant-drawer-panel-motion-left-leave-active {
  transform: translateX(-100%);
}

.ant-drawer-panel-motion-right-appear-start, .ant-drawer-panel-motion-right-enter-start, .ant-drawer-panel-motion-right-leave-start {
  transition: none;
}

.ant-drawer-panel-motion-right-appear-active, .ant-drawer-panel-motion-right-enter-active, .ant-drawer-panel-motion-right-leave-active {
  transition: all 0.3s;
}

.ant-drawer-panel-motion-right-appear-start, .ant-drawer-panel-motion-right-enter-start {
  transform: translateX(100%) !important;
}

.ant-drawer-panel-motion-right-appear-active, .ant-drawer-panel-motion-right-enter-active, .ant-drawer-panel-motion-right-leave {
  transform: translateX(0);
}

.ant-drawer-panel-motion-right-leave-active {
  transform: translateX(100%);
}

.ant-drawer-panel-motion-top-appear-start, .ant-drawer-panel-motion-top-enter-start, .ant-drawer-panel-motion-top-leave-start {
  transition: none;
}

.ant-drawer-panel-motion-top-appear-active, .ant-drawer-panel-motion-top-enter-active, .ant-drawer-panel-motion-top-leave-active {
  transition: all 0.3s;
}

.ant-drawer-panel-motion-top-appear-start, .ant-drawer-panel-motion-top-enter-start {
  transform: translateY(-100%) !important;
}

.ant-drawer-panel-motion-top-appear-active, .ant-drawer-panel-motion-top-enter-active, .ant-drawer-panel-motion-top-leave {
  transform: translateY(0);
}

.ant-drawer-panel-motion-top-leave-active {
  transform: translateY(-100%);
}

.ant-drawer-panel-motion-bottom-appear-start, .ant-drawer-panel-motion-bottom-enter-start, .ant-drawer-panel-motion-bottom-leave-start {
  transition: none;
}

.ant-drawer-panel-motion-bottom-appear-active, .ant-drawer-panel-motion-bottom-enter-active, .ant-drawer-panel-motion-bottom-leave-active {
  transition: all 0.3s;
}

.ant-drawer-panel-motion-bottom-appear-start, .ant-drawer-panel-motion-bottom-enter-start {
  transform: translateY(100%) !important;
}

.ant-drawer-panel-motion-bottom-appear-active, .ant-drawer-panel-motion-bottom-enter-active, .ant-drawer-panel-motion-bottom-leave {
  transform: translateY(0);
}

.ant-drawer-panel-motion-bottom-leave-active {
  transform: translateY(100%);
}

.ant-drawer-rtl {
  direction: rtl;
}

.ant-drawer-rtl .ant-drawer-close {
  margin-right: 0;
  margin-left: 12px;
}

.ant-dropdown-menu-item.ant-dropdown-menu-item-danger {
  color: #ff4d4f;
}

.ant-dropdown-menu-item.ant-dropdown-menu-item-danger:hover {
  color: #fff;
  background-color: #ff4d4f;
}

.ant-dropdown {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: absolute;
  top: -9999px;
  left: -9999px;
  z-index: 1050;
  display: block;
}

.ant-dropdown:before {
  position: absolute;
  top: -4px;
  right: 0;
  bottom: -4px;
  left: -7px;
  z-index: -9999;
  opacity: 0.0001;
  content: " ";
}

.ant-dropdown-wrap {
  position: relative;
}

.ant-dropdown-wrap .ant-btn > .anticon-down {
  font-size: 10px;
}

.ant-dropdown-wrap .anticon-down:before {
  transition: transform 0.2s;
}

.ant-dropdown-wrap-open .anticon-down:before {
  transform: rotate(180deg);
}

.ant-dropdown-hidden, .ant-dropdown-menu-hidden, .ant-dropdown-menu-submenu-hidden {
  display: none;
}

.ant-dropdown-show-arrow.ant-dropdown-placement-top, .ant-dropdown-show-arrow.ant-dropdown-placement-topLeft, .ant-dropdown-show-arrow.ant-dropdown-placement-topRight {
  padding-bottom: 15.3137085px;
}

.ant-dropdown-show-arrow.ant-dropdown-placement-bottom, .ant-dropdown-show-arrow.ant-dropdown-placement-bottomLeft, .ant-dropdown-show-arrow.ant-dropdown-placement-bottomRight {
  padding-top: 15.3137085px;
}

.ant-dropdown-arrow {
  position: absolute;
  z-index: 1;
  display: block;
  width: 11.3137085px;
  height: 11.3137085px;
  border-radius: 0 0 2px;
  pointer-events: none;
}

.ant-dropdown-arrow:before {
  position: absolute;
  top: -11.3137085px;
  left: -11.3137085px;
  width: 33.9411255px;
  height: 33.9411255px;
  background: #fff;
  background-repeat: no-repeat;
  background-position: -10px -10px;
  content: "";
  -webkit-clip-path: inset(33% 33%);
  clip-path: inset(33% 33%);
  -webkit-clip-path: path("M 9.849242404917499 24.091883092036785 A 5 5 0 0 1 13.384776310850237 22.627416997969522 L 20.627416997969522 22.627416997969522 A 2 2 0 0 0 22.627416997969522 20.627416997969522 L 22.627416997969522 13.384776310850237 A 5 5 0 0 1 24.091883092036785 9.849242404917499 L 23.091883092036785 9.849242404917499 L 9.849242404917499 23.091883092036785 Z");
  clip-path: path("M 9.849242404917499 24.091883092036785 A 5 5 0 0 1 13.384776310850237 22.627416997969522 L 20.627416997969522 22.627416997969522 A 2 2 0 0 0 22.627416997969522 20.627416997969522 L 22.627416997969522 13.384776310850237 A 5 5 0 0 1 24.091883092036785 9.849242404917499 L 23.091883092036785 9.849242404917499 L 9.849242404917499 23.091883092036785 Z");
}

.ant-dropdown-placement-top > .ant-dropdown-arrow, .ant-dropdown-placement-topLeft > .ant-dropdown-arrow, .ant-dropdown-placement-topRight > .ant-dropdown-arrow {
  bottom: 10px;
  box-shadow: 3px 3px 7px -3px rgba(0, 0, 0, 0.1);
  transform: rotate(45deg);
}

.ant-dropdown-placement-top > .ant-dropdown-arrow {
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
}

.ant-dropdown-placement-topLeft > .ant-dropdown-arrow {
  left: 16px;
}

.ant-dropdown-placement-topRight > .ant-dropdown-arrow {
  right: 16px;
}

.ant-dropdown-placement-bottom > .ant-dropdown-arrow, .ant-dropdown-placement-bottomLeft > .ant-dropdown-arrow, .ant-dropdown-placement-bottomRight > .ant-dropdown-arrow {
  top: 9.41421356px;
  box-shadow: 2px 2px 5px -2px rgba(0, 0, 0, 0.1);
  transform: rotate(-135deg) translateY(-0.5px);
}

.ant-dropdown-placement-bottom > .ant-dropdown-arrow {
  left: 50%;
  transform: translateX(-50%) rotate(-135deg) translateY(-0.5px);
}

.ant-dropdown-placement-bottomLeft > .ant-dropdown-arrow {
  left: 16px;
}

.ant-dropdown-placement-bottomRight > .ant-dropdown-arrow {
  right: 16px;
}

.ant-dropdown-menu {
  position: relative;
  margin: 0;
  padding: 4px 0;
  text-align: left;
  list-style-type: none;
  background-color: #fff;
  background-clip: padding-box;
  border-radius: 2px;
  outline: none;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
}

.ant-dropdown-menu-item-group-title {
  padding: 5px 12px;
  color: rgba(0, 0, 0, 0.45);
  transition: all 0.3s;
}

.ant-dropdown-menu-submenu-popup {
  position: absolute;
  z-index: 1050;
  background: transparent;
  box-shadow: none;
  transform-origin: 0 0;
}

.ant-dropdown-menu-submenu-popup li, .ant-dropdown-menu-submenu-popup ul {
  list-style: none;
}

.ant-dropdown-menu-submenu-popup ul {
  margin-right: 0.3em;
  margin-left: 0.3em;
}

.ant-dropdown-menu-item {
  position: relative;
  display: flex;
  align-items: center;
}

.ant-dropdown-menu-item-icon {
  min-width: 12px;
  margin-right: 8px;
  font-size: 12px;
}

.ant-dropdown-menu-title-content {
  flex: auto;
}

.ant-dropdown-menu-title-content > a {
  color: inherit;
  transition: all 0.3s;
}

.ant-dropdown-menu-title-content > a:hover {
  color: inherit;
}

.ant-dropdown-menu-title-content > a:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  content: "";
}

.ant-dropdown-menu-item, .ant-dropdown-menu-submenu-title {
  clear: both;
  margin: 0;
  padding: 5px 12px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  cursor: pointer;
  transition: all 0.3s;
}

.ant-dropdown-menu-item-selected, .ant-dropdown-menu-submenu-title-selected {
  color: #1890ff;
  background-color: #e6f7ff;
}

.ant-dropdown-menu-item.ant-dropdown-menu-item-active, .ant-dropdown-menu-item.ant-dropdown-menu-submenu-title-active, .ant-dropdown-menu-item:hover, .ant-dropdown-menu-submenu-title.ant-dropdown-menu-item-active, .ant-dropdown-menu-submenu-title.ant-dropdown-menu-submenu-title-active, .ant-dropdown-menu-submenu-title:hover {
  background-color: #f5f5f5;
}

.ant-dropdown-menu-item.ant-dropdown-menu-item-disabled, .ant-dropdown-menu-item.ant-dropdown-menu-submenu-title-disabled, .ant-dropdown-menu-submenu-title.ant-dropdown-menu-item-disabled, .ant-dropdown-menu-submenu-title.ant-dropdown-menu-submenu-title-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ant-dropdown-menu-item.ant-dropdown-menu-item-disabled:hover, .ant-dropdown-menu-item.ant-dropdown-menu-submenu-title-disabled:hover, .ant-dropdown-menu-submenu-title.ant-dropdown-menu-item-disabled:hover, .ant-dropdown-menu-submenu-title.ant-dropdown-menu-submenu-title-disabled:hover {
  color: rgba(0, 0, 0, 0.25);
  background-color: #fff;
  cursor: not-allowed;
}

.ant-dropdown-menu-item.ant-dropdown-menu-item-disabled a, .ant-dropdown-menu-item.ant-dropdown-menu-submenu-title-disabled a, .ant-dropdown-menu-submenu-title.ant-dropdown-menu-item-disabled a, .ant-dropdown-menu-submenu-title.ant-dropdown-menu-submenu-title-disabled a {
  pointer-events: none;
}

.ant-dropdown-menu-item-divider, .ant-dropdown-menu-submenu-title-divider {
  height: 1px;
  margin: 4px 0;
  overflow: hidden;
  line-height: 0;
  background-color: #f0f0f0;
}

.ant-dropdown-menu-item .ant-dropdown-menu-submenu-expand-icon, .ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-expand-icon {
  position: absolute;
  right: 8px;
}

.ant-dropdown-menu-item .ant-dropdown-menu-submenu-expand-icon .ant-dropdown-menu-submenu-arrow-icon, .ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-expand-icon .ant-dropdown-menu-submenu-arrow-icon {
  margin-right: 0 !important;
  color: rgba(0, 0, 0, 0.45);
  font-size: 10px;
  font-style: normal;
}

.ant-dropdown-menu-item-group-list {
  margin: 0 8px;
  padding: 0;
  list-style: none;
}

.ant-dropdown-menu-submenu-title {
  padding-right: 24px;
}

.ant-dropdown-menu-submenu-vertical {
  position: relative;
}

.ant-dropdown-menu-submenu-vertical > .ant-dropdown-menu {
  position: absolute;
  top: 0;
  left: 100%;
  min-width: 100%;
  margin-left: 4px;
  transform-origin: 0 0;
}

.ant-dropdown-menu-submenu.ant-dropdown-menu-submenu-disabled .ant-dropdown-menu-submenu-title, .ant-dropdown-menu-submenu.ant-dropdown-menu-submenu-disabled .ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-arrow-icon {
  color: rgba(0, 0, 0, 0.25);
  background-color: #fff;
  cursor: not-allowed;
}

.ant-dropdown-menu-submenu-selected .ant-dropdown-menu-submenu-title {
  color: #1890ff;
}

.ant-dropdown.ant-slide-down-appear.ant-slide-down-appear-active.ant-dropdown-placement-bottom, .ant-dropdown.ant-slide-down-appear.ant-slide-down-appear-active.ant-dropdown-placement-bottomLeft, .ant-dropdown.ant-slide-down-appear.ant-slide-down-appear-active.ant-dropdown-placement-bottomRight, .ant-dropdown.ant-slide-down-enter.ant-slide-down-enter-active.ant-dropdown-placement-bottom, .ant-dropdown.ant-slide-down-enter.ant-slide-down-enter-active.ant-dropdown-placement-bottomLeft, .ant-dropdown.ant-slide-down-enter.ant-slide-down-enter-active.ant-dropdown-placement-bottomRight {
  animation-name: antSlideUpIn;
}

.ant-dropdown.ant-slide-up-appear.ant-slide-up-appear-active.ant-dropdown-placement-top, .ant-dropdown.ant-slide-up-appear.ant-slide-up-appear-active.ant-dropdown-placement-topLeft, .ant-dropdown.ant-slide-up-appear.ant-slide-up-appear-active.ant-dropdown-placement-topRight, .ant-dropdown.ant-slide-up-enter.ant-slide-up-enter-active.ant-dropdown-placement-top, .ant-dropdown.ant-slide-up-enter.ant-slide-up-enter-active.ant-dropdown-placement-topLeft, .ant-dropdown.ant-slide-up-enter.ant-slide-up-enter-active.ant-dropdown-placement-topRight {
  animation-name: antSlideDownIn;
}

.ant-dropdown.ant-slide-down-leave.ant-slide-down-leave-active.ant-dropdown-placement-bottom, .ant-dropdown.ant-slide-down-leave.ant-slide-down-leave-active.ant-dropdown-placement-bottomLeft, .ant-dropdown.ant-slide-down-leave.ant-slide-down-leave-active.ant-dropdown-placement-bottomRight {
  animation-name: antSlideUpOut;
}

.ant-dropdown.ant-slide-up-leave.ant-slide-up-leave-active.ant-dropdown-placement-top, .ant-dropdown.ant-slide-up-leave.ant-slide-up-leave-active.ant-dropdown-placement-topLeft, .ant-dropdown.ant-slide-up-leave.ant-slide-up-leave-active.ant-dropdown-placement-topRight {
  animation-name: antSlideDownOut;
}

.ant-dropdown-button > .anticon.anticon-down, .ant-dropdown-link > .anticon.anticon-down, .ant-dropdown-trigger > .anticon.anticon-down {
  font-size: 10px;
  vertical-align: baseline;
}

.ant-dropdown-button {
  white-space: nowrap;
}

.ant-dropdown-button.ant-btn-group > .ant-btn-loading, .ant-dropdown-button.ant-btn-group > .ant-btn-loading + .ant-btn {
  cursor: default;
  pointer-events: none;
}

.ant-dropdown-button.ant-btn-group > .ant-btn-loading + .ant-btn:before {
  display: block;
}

.ant-dropdown-button.ant-btn-group > .ant-btn:last-child:not(:first-child):not(.ant-btn-icon-only) {
  padding-right: 8px;
  padding-left: 8px;
}

.ant-dropdown-menu-dark, .ant-dropdown-menu-dark .ant-dropdown-menu {
  background: #001529;
}

.ant-dropdown-menu-dark .ant-dropdown-menu-item, .ant-dropdown-menu-dark .ant-dropdown-menu-item .ant-dropdown-menu-submenu-arrow:after, .ant-dropdown-menu-dark .ant-dropdown-menu-item > .anticon + span > a, .ant-dropdown-menu-dark .ant-dropdown-menu-item > .anticon + span > a .ant-dropdown-menu-submenu-arrow:after, .ant-dropdown-menu-dark .ant-dropdown-menu-item > a, .ant-dropdown-menu-dark .ant-dropdown-menu-item > a .ant-dropdown-menu-submenu-arrow:after, .ant-dropdown-menu-dark .ant-dropdown-menu-submenu-title, .ant-dropdown-menu-dark .ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-arrow:after {
  color: hsla(0, 0%, 100%, 0.65);
}

.ant-dropdown-menu-dark .ant-dropdown-menu-item:hover, .ant-dropdown-menu-dark .ant-dropdown-menu-item > .anticon + span > a:hover, .ant-dropdown-menu-dark .ant-dropdown-menu-item > a:hover, .ant-dropdown-menu-dark .ant-dropdown-menu-submenu-title:hover {
  color: #fff;
  background: transparent;
}

.ant-dropdown-menu-dark .ant-dropdown-menu-item-selected, .ant-dropdown-menu-dark .ant-dropdown-menu-item-selected:hover, .ant-dropdown-menu-dark .ant-dropdown-menu-item-selected > a {
  color: #fff;
  background: #1890ff;
}

.ant-dropdown-rtl {
  direction: rtl;
}

.ant-dropdown-rtl.ant-dropdown:before {
  right: -7px;
  left: 0;
}

.ant-dropdown-menu-submenu-rtl .ant-dropdown-menu-item-group-title, .ant-dropdown-menu.ant-dropdown-menu-rtl, .ant-dropdown-rtl .ant-dropdown-menu-item-group-title {
  direction: rtl;
  text-align: right;
}

.ant-dropdown-menu-submenu-popup.ant-dropdown-menu-submenu-rtl {
  transform-origin: 100% 0;
}

.ant-dropdown-rtl .ant-dropdown-menu-item, .ant-dropdown-rtl .ant-dropdown-menu-submenu-popup li, .ant-dropdown-rtl .ant-dropdown-menu-submenu-popup ul, .ant-dropdown-rtl .ant-dropdown-menu-submenu-title {
  text-align: right;
}

.ant-dropdown-rtl .ant-dropdown-menu-item > .anticon:first-child, .ant-dropdown-rtl .ant-dropdown-menu-item > span > .anticon:first-child, .ant-dropdown-rtl .ant-dropdown-menu-submenu-title > .anticon:first-child, .ant-dropdown-rtl .ant-dropdown-menu-submenu-title > span > .anticon:first-child {
  margin-right: 0;
  margin-left: 8px;
}

.ant-dropdown-rtl .ant-dropdown-menu-item .ant-dropdown-menu-submenu-expand-icon, .ant-dropdown-rtl .ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-expand-icon {
  right: auto;
  left: 8px;
}

.ant-dropdown-rtl .ant-dropdown-menu-item .ant-dropdown-menu-submenu-expand-icon .ant-dropdown-menu-submenu-arrow-icon, .ant-dropdown-rtl .ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-expand-icon .ant-dropdown-menu-submenu-arrow-icon {
  margin-left: 0 !important;
  transform: scaleX(-1);
}

.ant-dropdown-rtl .ant-dropdown-menu-submenu-title {
  padding-right: 12px;
  padding-left: 24px;
}

.ant-dropdown-rtl .ant-dropdown-menu-submenu-vertical > .ant-dropdown-menu {
  right: 100%;
  left: 0;
  margin-right: 4px;
  margin-left: 0;
}

.ant-empty {
  margin: 0 8px;
  font-size: 14px;
  line-height: 1.5715;
  text-align: center;
}

.ant-empty-image {
  height: 100px;
  margin-bottom: 8px;
}

.ant-empty-image img {
  height: 100%;
}

.ant-empty-image svg {
  height: 100%;
  margin: auto;
}

.ant-empty-footer {
  margin-top: 16px;
}

.ant-empty-normal {
  margin: 32px 0;
  color: rgba(0, 0, 0, 0.25);
}

.ant-empty-normal .ant-empty-image {
  height: 40px;
}

.ant-empty-small {
  margin: 8px 0;
  color: rgba(0, 0, 0, 0.25);
}

.ant-empty-small .ant-empty-image {
  height: 35px;
}

.ant-empty-img-default-ellipse {
  fill: #f5f5f5;
  fill-opacity: 0.8;
}

.ant-empty-img-default-path-1 {
  fill: #aeb8c2;
}

.ant-empty-img-default-path-2 {
  fill: url(#linearGradient-1);
}

.ant-empty-img-default-path-3 {
  fill: #f5f5f7;
}

.ant-empty-img-default-path-4, .ant-empty-img-default-path-5 {
  fill: #dce0e6;
}

.ant-empty-img-default-g {
  fill: #fff;
}

.ant-empty-img-simple-ellipse {
  fill: #f5f5f5;
}

.ant-empty-img-simple-g {
  stroke: #d9d9d9;
}

.ant-empty-img-simple-path {
  fill: #fafafa;
}

.ant-empty-rtl {
  direction: rtl;
}

.ant-form-item .ant-input-number + .ant-form-text {
  margin-left: 8px;
}

.ant-form-inline {
  display: flex;
  flex-wrap: wrap;
}

.ant-form-inline .ant-form-item {
  flex: none;
  flex-wrap: nowrap;
  margin-right: 16px;
  margin-bottom: 0;
}

.ant-form-inline .ant-form-item-with-help {
  margin-bottom: 24px;
}

.ant-form-inline .ant-form-item > .ant-form-item-control, .ant-form-inline .ant-form-item > .ant-form-item-label {
  display: inline-block;
  vertical-align: top;
}

.ant-form-inline .ant-form-item > .ant-form-item-label {
  flex: none;
}

.ant-form-inline .ant-form-item .ant-form-item-has-feedback, .ant-form-inline .ant-form-item .ant-form-text {
  display: inline-block;
}

.ant-form-horizontal .ant-form-item-label {
  flex-grow: 0;
}

.ant-form-horizontal .ant-form-item-control {
  flex: 1 1 0;
  min-width: 0;
}

.ant-form-horizontal .ant-form-item-label[class\$="-24"] + .ant-form-item-control, .ant-form-horizontal .ant-form-item-label[class*="-24 "] + .ant-form-item-control {
  min-width: unset;
}

.ant-form-vertical .ant-form-item-row {
  flex-direction: column;
}

.ant-form-vertical .ant-form-item-label > label {
  height: auto;
}

.ant-form-vertical .ant-form-item .ant-form-item-control {
  width: 100%;
}

.ant-col-24.ant-form-item-label, .ant-col-xl-24.ant-form-item-label, .ant-form-vertical .ant-form-item-label {
  padding: 0 0 8px;
  line-height: 1.5715;
  white-space: normal;
  text-align: left;
}

.ant-col-24.ant-form-item-label > label, .ant-col-xl-24.ant-form-item-label > label, .ant-form-vertical .ant-form-item-label > label {
  margin: 0;
}

.ant-col-24.ant-form-item-label > label:after, .ant-col-xl-24.ant-form-item-label > label:after, .ant-form-vertical .ant-form-item-label > label:after {
  display: none;
}

.ant-form-rtl.ant-col-24.ant-form-item-label, .ant-form-rtl.ant-col-xl-24.ant-form-item-label, .ant-form-rtl.ant-form-vertical .ant-form-item-label {
  text-align: right;
}

@media (max-width: 575px) {
  .ant-form-item .ant-form-item-label {
    padding: 0 0 8px;
    line-height: 1.5715;
    white-space: normal;
    text-align: left;
  }
  .ant-form-item .ant-form-item-label > label {
    margin: 0;
  }
  .ant-form-item .ant-form-item-label > label:after {
    display: none;
  }
  .ant-form-rtl.ant-form-item .ant-form-item-label {
    text-align: right;
  }
  .ant-form .ant-form-item {
    flex-wrap: wrap;
  }
  .ant-form .ant-form-item .ant-form-item-control, .ant-form .ant-form-item .ant-form-item-label {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .ant-col-xs-24.ant-form-item-label {
    padding: 0 0 8px;
    line-height: 1.5715;
    white-space: normal;
    text-align: left;
  }
  .ant-col-xs-24.ant-form-item-label > label {
    margin: 0;
  }
  .ant-col-xs-24.ant-form-item-label > label:after {
    display: none;
  }
  .ant-form-rtl.ant-col-xs-24.ant-form-item-label {
    text-align: right;
  }
}
@media (max-width: 767px) {
  .ant-col-sm-24.ant-form-item-label {
    padding: 0 0 8px;
    line-height: 1.5715;
    white-space: normal;
    text-align: left;
  }
  .ant-col-sm-24.ant-form-item-label > label {
    margin: 0;
  }
  .ant-col-sm-24.ant-form-item-label > label:after {
    display: none;
  }
  .ant-form-rtl.ant-col-sm-24.ant-form-item-label {
    text-align: right;
  }
}
@media (max-width: 991px) {
  .ant-col-md-24.ant-form-item-label {
    padding: 0 0 8px;
    line-height: 1.5715;
    white-space: normal;
    text-align: left;
  }
  .ant-col-md-24.ant-form-item-label > label {
    margin: 0;
  }
  .ant-col-md-24.ant-form-item-label > label:after {
    display: none;
  }
  .ant-form-rtl.ant-col-md-24.ant-form-item-label {
    text-align: right;
  }
}
@media (max-width: 1199px) {
  .ant-col-lg-24.ant-form-item-label {
    padding: 0 0 8px;
    line-height: 1.5715;
    white-space: normal;
    text-align: left;
  }
  .ant-col-lg-24.ant-form-item-label > label {
    margin: 0;
  }
  .ant-col-lg-24.ant-form-item-label > label:after {
    display: none;
  }
  .ant-form-rtl.ant-col-lg-24.ant-form-item-label {
    text-align: right;
  }
}
@media (max-width: 1599px) {
  .ant-col-xl-24.ant-form-item-label {
    padding: 0 0 8px;
    line-height: 1.5715;
    white-space: normal;
    text-align: left;
  }
  .ant-col-xl-24.ant-form-item-label > label {
    margin: 0;
  }
  .ant-col-xl-24.ant-form-item-label > label:after {
    display: none;
  }
  .ant-form-rtl.ant-col-xl-24.ant-form-item-label {
    text-align: right;
  }
}
.ant-form-item-explain-error {
  color: #ff4d4f;
}

.ant-form-item-explain-warning {
  color: #faad14;
}

.ant-form-item-has-feedback .ant-switch {
  margin: 2px 0 4px;
}

.ant-form-item-has-warning .ant-form-item-split {
  color: #faad14;
}

.ant-form-item-has-error .ant-form-item-split {
  color: #ff4d4f;
}

.ant-form {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
}

.ant-form legend {
  display: block;
  width: 100%;
  margin-bottom: 20px;
  padding: 0;
  color: rgba(0, 0, 0, 0.45);
  font-size: 16px;
  line-height: inherit;
  border: 0;
  border-bottom: 1px solid #d9d9d9;
}

.ant-form label {
  font-size: 14px;
}

.ant-form input[type=search] {
  box-sizing: border-box;
}

.ant-form input[type=checkbox], .ant-form input[type=radio] {
  line-height: normal;
}

.ant-form input[type=file] {
  display: block;
}

.ant-form input[type=range] {
  display: block;
  width: 100%;
}

.ant-form select[multiple], .ant-form select[size] {
  height: auto;
}

.ant-form input[type=checkbox]:focus, .ant-form input[type=file]:focus, .ant-form input[type=radio]:focus {
  outline: thin dotted;
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
}

.ant-form output {
  display: block;
  padding-top: 15px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  line-height: 1.5715;
}

.ant-form .ant-form-text {
  display: inline-block;
  padding-right: 8px;
}

.ant-form-small .ant-form-item-label > label {
  height: 24px;
}

.ant-form-small .ant-form-item-control-input {
  min-height: 24px;
}

.ant-form-large .ant-form-item-label > label {
  height: 40px;
}

.ant-form-large .ant-form-item-control-input {
  min-height: 40px;
}

.ant-form-item {
  box-sizing: border-box;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  margin: 0 0 24px;
  vertical-align: top;
}

.ant-form-item-with-help {
  transition: none;
}

.ant-form-item-hidden, .ant-form-item-hidden.ant-row {
  display: none;
}

.ant-form-item-label {
  display: inline-block;
  flex-grow: 0;
  overflow: hidden;
  white-space: nowrap;
  text-align: right;
  vertical-align: middle;
}

.ant-form-item-label-left {
  text-align: left;
}

.ant-form-item-label-wrap {
  overflow: unset;
  line-height: 1.3215em;
  white-space: unset;
}

.ant-form-item-label > label {
  position: relative;
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  height: 32px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
}

.ant-form-item-label > label > .anticon {
  font-size: 14px;
  vertical-align: top;
}

.ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional):before {
  display: inline-block;
  margin-right: 4px;
  color: #ff4d4f;
  font-size: 14px;
  font-family: SimSun, sans-serif;
  line-height: 1;
  content: "*";
}

.ant-form-hide-required-mark .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional):before {
  display: none;
}

.ant-form-item-label > label .ant-form-item-optional {
  display: inline-block;
  margin-left: 4px;
  color: rgba(0, 0, 0, 0.45);
}

.ant-form-hide-required-mark .ant-form-item-label > label .ant-form-item-optional {
  display: none;
}

.ant-form-item-label > label .ant-form-item-tooltip {
  color: rgba(0, 0, 0, 0.45);
  cursor: help;
  -ms-writing-mode: lr-tb;
  writing-mode: horizontal-tb;
  -webkit-margin-start: 4px;
  margin-inline-start: 4px;
}

.ant-form-item-label > label:after {
  content: ":";
  position: relative;
  top: -0.5px;
  margin: 0 8px 0 2px;
}

.ant-form-item-label > label.ant-form-item-no-colon:after {
  content: " ";
}

.ant-form-item-control {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.ant-form-item-control:first-child:not([class^=ant-col-]):not([class*=" ant-col-"]) {
  width: 100%;
}

.ant-form-item-control-input {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 32px;
}

.ant-form-item-control-input-content {
  flex: auto;
  max-width: 100%;
}

.ant-form-item-explain, .ant-form-item-extra {
  clear: both;
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
  line-height: 1.5715;
  transition: color 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
}

.ant-form-item-explain-connected {
  width: 100%;
}

.ant-form-item-extra {
  min-height: 24px;
}

.ant-form-item-with-help .ant-form-item-explain {
  height: auto;
  opacity: 1;
}

.ant-form-item-feedback-icon {
  font-size: 14px;
  text-align: center;
  visibility: visible;
  animation: zoomIn 0.3s cubic-bezier(0.12, 0.4, 0.29, 1.46);
  pointer-events: none;
}

.ant-form-item-feedback-icon-success {
  color: #52c41a;
}

.ant-form-item-feedback-icon-error {
  color: #ff4d4f;
}

.ant-form-item-feedback-icon-warning {
  color: #faad14;
}

.ant-form-item-feedback-icon-validating {
  color: #1890ff;
}

.ant-show-help {
  transition: opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-show-help-appear, .ant-show-help-enter {
  opacity: 0;
}

.ant-show-help-appear-active, .ant-show-help-enter-active, .ant-show-help-leave {
  opacity: 1;
}

.ant-show-help-leave-active {
  opacity: 0;
}

.ant-show-help-item {
  overflow: hidden;
  transition: height 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1) !important;
}

.ant-show-help-item-appear, .ant-show-help-item-enter {
  transform: translateY(-5px);
  opacity: 0;
}

.ant-show-help-item-appear-active, .ant-show-help-item-enter-active {
  transform: translateY(0);
  opacity: 1;
}

.ant-show-help-item-leave {
  transition: height 0.2s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.2s cubic-bezier(0.645, 0.045, 0.355, 1), transform 0.2s cubic-bezier(0.645, 0.045, 0.355, 1) !important;
}

.ant-show-help-item-leave-active {
  transform: translateY(-5px);
}

@keyframes diffZoomIn1 {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes diffZoomIn2 {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes diffZoomIn3 {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
.ant-form-rtl {
  direction: rtl;
}

.ant-form-rtl .ant-form-item-label {
  text-align: left;
}

.ant-form-rtl .ant-form-item-label > label.ant-form-item-required:before {
  margin-right: 0;
  margin-left: 4px;
}

.ant-form-rtl .ant-form-item-label > label:after {
  margin: 0 2px 0 8px;
}

.ant-form-rtl .ant-form-item-label > label .ant-form-item-optional {
  margin-right: 4px;
  margin-left: 0;
}

.ant-col-rtl .ant-form-item-control:first-child {
  width: 100%;
}

.ant-form-rtl .ant-form-item-has-feedback .ant-input {
  padding-right: 11px;
  padding-left: 24px;
}

.ant-form-rtl .ant-form-item-has-feedback .ant-input-affix-wrapper .ant-input-suffix {
  padding-right: 11px;
  padding-left: 18px;
}

.ant-form-rtl .ant-form-item-has-feedback .ant-input-affix-wrapper .ant-input, .ant-form-rtl .ant-form-item-has-feedback .ant-input-number-affix-wrapper .ant-input-number {
  padding: 0;
}

.ant-form-rtl .ant-form-item-has-feedback .ant-input-search:not(.ant-input-search-enter-button) .ant-input-suffix {
  right: auto;
  left: 28px;
}

.ant-form-rtl .ant-form-item-has-feedback .ant-input-number {
  padding-left: 18px;
}

.ant-form-rtl .ant-form-item-has-feedback :not(.ant-input-group-addon) > .ant-select .ant-select-arrow, .ant-form-rtl .ant-form-item-has-feedback :not(.ant-input-group-addon) > .ant-select .ant-select-clear, .ant-form-rtl .ant-form-item-has-feedback :not(.ant-input-number-group-addon) > .ant-select .ant-select-arrow, .ant-form-rtl .ant-form-item-has-feedback :not(.ant-input-number-group-addon) > .ant-select .ant-select-clear, .ant-form-rtl .ant-form-item-has-feedback > .ant-select .ant-select-arrow, .ant-form-rtl .ant-form-item-has-feedback > .ant-select .ant-select-clear {
  right: auto;
  left: 32px;
}

.ant-form-rtl .ant-form-item-has-feedback :not(.ant-input-group-addon) > .ant-select .ant-select-selection-selected-value, .ant-form-rtl .ant-form-item-has-feedback :not(.ant-input-number-group-addon) > .ant-select .ant-select-selection-selected-value, .ant-form-rtl .ant-form-item-has-feedback > .ant-select .ant-select-selection-selected-value {
  padding-right: 0;
  padding-left: 42px;
}

.ant-form-rtl .ant-form-item-has-feedback .ant-cascader-picker-arrow {
  margin-right: 0;
  margin-left: 19px;
}

.ant-form-rtl .ant-form-item-has-feedback .ant-cascader-picker-clear {
  right: auto;
  left: 32px;
}

.ant-form-rtl .ant-form-item-has-feedback .ant-picker, .ant-form-rtl .ant-form-item-has-feedback .ant-picker-large {
  padding-right: 11px;
  padding-left: 29.2px;
}

.ant-form-rtl .ant-form-item-has-feedback .ant-picker-small {
  padding-right: 7px;
  padding-left: 25.2px;
}

.ant-form-rtl .ant-form-item-has-feedback.ant-form-item-has-error .ant-form-item-children-icon, .ant-form-rtl .ant-form-item-has-feedback.ant-form-item-has-success .ant-form-item-children-icon, .ant-form-rtl .ant-form-item-has-feedback.ant-form-item-has-warning .ant-form-item-children-icon, .ant-form-rtl .ant-form-item-has-feedback.ant-form-item-is-validating .ant-form-item-children-icon {
  right: auto;
  left: 0;
}

.ant-form-rtl.ant-form-inline .ant-form-item {
  margin-right: 0;
  margin-left: 16px;
}

.ant-row {
  flex-flow: row wrap;
  min-width: 0;
}

.ant-row, .ant-row:after, .ant-row:before {
  display: flex;
}

.ant-row-no-wrap {
  flex-wrap: nowrap;
}

.ant-row-start {
  justify-content: flex-start;
}

.ant-row-center {
  justify-content: center;
}

.ant-row-end {
  justify-content: flex-end;
}

.ant-row-space-between {
  justify-content: space-between;
}

.ant-row-space-around {
  justify-content: space-around;
}

.ant-row-space-evenly {
  justify-content: space-evenly;
}

.ant-row-top {
  align-items: flex-start;
}

.ant-row-middle {
  align-items: center;
}

.ant-row-bottom {
  align-items: flex-end;
}

.ant-col {
  position: relative;
  max-width: 100%;
  min-height: 1px;
}

.ant-col-24 {
  display: block;
  flex: 0 0 100%;
  max-width: 100%;
}

.ant-col-push-24 {
  left: 100%;
}

.ant-col-pull-24 {
  right: 100%;
}

.ant-col-offset-24 {
  margin-left: 100%;
}

.ant-col-order-24 {
  order: 24;
}

.ant-col-23 {
  display: block;
  flex: 0 0 95.83333333%;
  max-width: 95.83333333%;
}

.ant-col-push-23 {
  left: 95.83333333%;
}

.ant-col-pull-23 {
  right: 95.83333333%;
}

.ant-col-offset-23 {
  margin-left: 95.83333333%;
}

.ant-col-order-23 {
  order: 23;
}

.ant-col-22 {
  display: block;
  flex: 0 0 91.66666667%;
  max-width: 91.66666667%;
}

.ant-col-push-22 {
  left: 91.66666667%;
}

.ant-col-pull-22 {
  right: 91.66666667%;
}

.ant-col-offset-22 {
  margin-left: 91.66666667%;
}

.ant-col-order-22 {
  order: 22;
}

.ant-col-21 {
  display: block;
  flex: 0 0 87.5%;
  max-width: 87.5%;
}

.ant-col-push-21 {
  left: 87.5%;
}

.ant-col-pull-21 {
  right: 87.5%;
}

.ant-col-offset-21 {
  margin-left: 87.5%;
}

.ant-col-order-21 {
  order: 21;
}

.ant-col-20 {
  display: block;
  flex: 0 0 83.33333333%;
  max-width: 83.33333333%;
}

.ant-col-push-20 {
  left: 83.33333333%;
}

.ant-col-pull-20 {
  right: 83.33333333%;
}

.ant-col-offset-20 {
  margin-left: 83.33333333%;
}

.ant-col-order-20 {
  order: 20;
}

.ant-col-19 {
  display: block;
  flex: 0 0 79.16666667%;
  max-width: 79.16666667%;
}

.ant-col-push-19 {
  left: 79.16666667%;
}

.ant-col-pull-19 {
  right: 79.16666667%;
}

.ant-col-offset-19 {
  margin-left: 79.16666667%;
}

.ant-col-order-19 {
  order: 19;
}

.ant-col-18 {
  display: block;
  flex: 0 0 75%;
  max-width: 75%;
}

.ant-col-push-18 {
  left: 75%;
}

.ant-col-pull-18 {
  right: 75%;
}

.ant-col-offset-18 {
  margin-left: 75%;
}

.ant-col-order-18 {
  order: 18;
}

.ant-col-17 {
  display: block;
  flex: 0 0 70.83333333%;
  max-width: 70.83333333%;
}

.ant-col-push-17 {
  left: 70.83333333%;
}

.ant-col-pull-17 {
  right: 70.83333333%;
}

.ant-col-offset-17 {
  margin-left: 70.83333333%;
}

.ant-col-order-17 {
  order: 17;
}

.ant-col-16 {
  display: block;
  flex: 0 0 66.66666667%;
  max-width: 66.66666667%;
}

.ant-col-push-16 {
  left: 66.66666667%;
}

.ant-col-pull-16 {
  right: 66.66666667%;
}

.ant-col-offset-16 {
  margin-left: 66.66666667%;
}

.ant-col-order-16 {
  order: 16;
}

.ant-col-15 {
  display: block;
  flex: 0 0 62.5%;
  max-width: 62.5%;
}

.ant-col-push-15 {
  left: 62.5%;
}

.ant-col-pull-15 {
  right: 62.5%;
}

.ant-col-offset-15 {
  margin-left: 62.5%;
}

.ant-col-order-15 {
  order: 15;
}

.ant-col-14 {
  display: block;
  flex: 0 0 58.33333333%;
  max-width: 58.33333333%;
}

.ant-col-push-14 {
  left: 58.33333333%;
}

.ant-col-pull-14 {
  right: 58.33333333%;
}

.ant-col-offset-14 {
  margin-left: 58.33333333%;
}

.ant-col-order-14 {
  order: 14;
}

.ant-col-13 {
  display: block;
  flex: 0 0 54.16666667%;
  max-width: 54.16666667%;
}

.ant-col-push-13 {
  left: 54.16666667%;
}

.ant-col-pull-13 {
  right: 54.16666667%;
}

.ant-col-offset-13 {
  margin-left: 54.16666667%;
}

.ant-col-order-13 {
  order: 13;
}

.ant-col-12 {
  display: block;
  flex: 0 0 50%;
  max-width: 50%;
}

.ant-col-push-12 {
  left: 50%;
}

.ant-col-pull-12 {
  right: 50%;
}

.ant-col-offset-12 {
  margin-left: 50%;
}

.ant-col-order-12 {
  order: 12;
}

.ant-col-11 {
  display: block;
  flex: 0 0 45.83333333%;
  max-width: 45.83333333%;
}

.ant-col-push-11 {
  left: 45.83333333%;
}

.ant-col-pull-11 {
  right: 45.83333333%;
}

.ant-col-offset-11 {
  margin-left: 45.83333333%;
}

.ant-col-order-11 {
  order: 11;
}

.ant-col-10 {
  display: block;
  flex: 0 0 41.66666667%;
  max-width: 41.66666667%;
}

.ant-col-push-10 {
  left: 41.66666667%;
}

.ant-col-pull-10 {
  right: 41.66666667%;
}

.ant-col-offset-10 {
  margin-left: 41.66666667%;
}

.ant-col-order-10 {
  order: 10;
}

.ant-col-9 {
  display: block;
  flex: 0 0 37.5%;
  max-width: 37.5%;
}

.ant-col-push-9 {
  left: 37.5%;
}

.ant-col-pull-9 {
  right: 37.5%;
}

.ant-col-offset-9 {
  margin-left: 37.5%;
}

.ant-col-order-9 {
  order: 9;
}

.ant-col-8 {
  display: block;
  flex: 0 0 33.33333333%;
  max-width: 33.33333333%;
}

.ant-col-push-8 {
  left: 33.33333333%;
}

.ant-col-pull-8 {
  right: 33.33333333%;
}

.ant-col-offset-8 {
  margin-left: 33.33333333%;
}

.ant-col-order-8 {
  order: 8;
}

.ant-col-7 {
  display: block;
  flex: 0 0 29.16666667%;
  max-width: 29.16666667%;
}

.ant-col-push-7 {
  left: 29.16666667%;
}

.ant-col-pull-7 {
  right: 29.16666667%;
}

.ant-col-offset-7 {
  margin-left: 29.16666667%;
}

.ant-col-order-7 {
  order: 7;
}

.ant-col-6 {
  display: block;
  flex: 0 0 25%;
  max-width: 25%;
}

.ant-col-push-6 {
  left: 25%;
}

.ant-col-pull-6 {
  right: 25%;
}

.ant-col-offset-6 {
  margin-left: 25%;
}

.ant-col-order-6 {
  order: 6;
}

.ant-col-5 {
  display: block;
  flex: 0 0 20.83333333%;
  max-width: 20.83333333%;
}

.ant-col-push-5 {
  left: 20.83333333%;
}

.ant-col-pull-5 {
  right: 20.83333333%;
}

.ant-col-offset-5 {
  margin-left: 20.83333333%;
}

.ant-col-order-5 {
  order: 5;
}

.ant-col-4 {
  display: block;
  flex: 0 0 16.66666667%;
  max-width: 16.66666667%;
}

.ant-col-push-4 {
  left: 16.66666667%;
}

.ant-col-pull-4 {
  right: 16.66666667%;
}

.ant-col-offset-4 {
  margin-left: 16.66666667%;
}

.ant-col-order-4 {
  order: 4;
}

.ant-col-3 {
  display: block;
  flex: 0 0 12.5%;
  max-width: 12.5%;
}

.ant-col-push-3 {
  left: 12.5%;
}

.ant-col-pull-3 {
  right: 12.5%;
}

.ant-col-offset-3 {
  margin-left: 12.5%;
}

.ant-col-order-3 {
  order: 3;
}

.ant-col-2 {
  display: block;
  flex: 0 0 8.33333333%;
  max-width: 8.33333333%;
}

.ant-col-push-2 {
  left: 8.33333333%;
}

.ant-col-pull-2 {
  right: 8.33333333%;
}

.ant-col-offset-2 {
  margin-left: 8.33333333%;
}

.ant-col-order-2 {
  order: 2;
}

.ant-col-1 {
  display: block;
  flex: 0 0 4.16666667%;
  max-width: 4.16666667%;
}

.ant-col-push-1 {
  left: 4.16666667%;
}

.ant-col-pull-1 {
  right: 4.16666667%;
}

.ant-col-offset-1 {
  margin-left: 4.16666667%;
}

.ant-col-order-1 {
  order: 1;
}

.ant-col-0 {
  display: none;
}

.ant-col-offset-0 {
  margin-left: 0;
}

.ant-col-order-0 {
  order: 0;
}

.ant-col-offset-0.ant-col-rtl {
  margin-right: 0;
}

.ant-col-push-1.ant-col-rtl {
  right: 4.16666667%;
  left: auto;
}

.ant-col-pull-1.ant-col-rtl {
  right: auto;
  left: 4.16666667%;
}

.ant-col-offset-1.ant-col-rtl {
  margin-right: 4.16666667%;
  margin-left: 0;
}

.ant-col-push-2.ant-col-rtl {
  right: 8.33333333%;
  left: auto;
}

.ant-col-pull-2.ant-col-rtl {
  right: auto;
  left: 8.33333333%;
}

.ant-col-offset-2.ant-col-rtl {
  margin-right: 8.33333333%;
  margin-left: 0;
}

.ant-col-push-3.ant-col-rtl {
  right: 12.5%;
  left: auto;
}

.ant-col-pull-3.ant-col-rtl {
  right: auto;
  left: 12.5%;
}

.ant-col-offset-3.ant-col-rtl {
  margin-right: 12.5%;
  margin-left: 0;
}

.ant-col-push-4.ant-col-rtl {
  right: 16.66666667%;
  left: auto;
}

.ant-col-pull-4.ant-col-rtl {
  right: auto;
  left: 16.66666667%;
}

.ant-col-offset-4.ant-col-rtl {
  margin-right: 16.66666667%;
  margin-left: 0;
}

.ant-col-push-5.ant-col-rtl {
  right: 20.83333333%;
  left: auto;
}

.ant-col-pull-5.ant-col-rtl {
  right: auto;
  left: 20.83333333%;
}

.ant-col-offset-5.ant-col-rtl {
  margin-right: 20.83333333%;
  margin-left: 0;
}

.ant-col-push-6.ant-col-rtl {
  right: 25%;
  left: auto;
}

.ant-col-pull-6.ant-col-rtl {
  right: auto;
  left: 25%;
}

.ant-col-offset-6.ant-col-rtl {
  margin-right: 25%;
  margin-left: 0;
}

.ant-col-push-7.ant-col-rtl {
  right: 29.16666667%;
  left: auto;
}

.ant-col-pull-7.ant-col-rtl {
  right: auto;
  left: 29.16666667%;
}

.ant-col-offset-7.ant-col-rtl {
  margin-right: 29.16666667%;
  margin-left: 0;
}

.ant-col-push-8.ant-col-rtl {
  right: 33.33333333%;
  left: auto;
}

.ant-col-pull-8.ant-col-rtl {
  right: auto;
  left: 33.33333333%;
}

.ant-col-offset-8.ant-col-rtl {
  margin-right: 33.33333333%;
  margin-left: 0;
}

.ant-col-push-9.ant-col-rtl {
  right: 37.5%;
  left: auto;
}

.ant-col-pull-9.ant-col-rtl {
  right: auto;
  left: 37.5%;
}

.ant-col-offset-9.ant-col-rtl {
  margin-right: 37.5%;
  margin-left: 0;
}

.ant-col-push-10.ant-col-rtl {
  right: 41.66666667%;
  left: auto;
}

.ant-col-pull-10.ant-col-rtl {
  right: auto;
  left: 41.66666667%;
}

.ant-col-offset-10.ant-col-rtl {
  margin-right: 41.66666667%;
  margin-left: 0;
}

.ant-col-push-11.ant-col-rtl {
  right: 45.83333333%;
  left: auto;
}

.ant-col-pull-11.ant-col-rtl {
  right: auto;
  left: 45.83333333%;
}

.ant-col-offset-11.ant-col-rtl {
  margin-right: 45.83333333%;
  margin-left: 0;
}

.ant-col-push-12.ant-col-rtl {
  right: 50%;
  left: auto;
}

.ant-col-pull-12.ant-col-rtl {
  right: auto;
  left: 50%;
}

.ant-col-offset-12.ant-col-rtl {
  margin-right: 50%;
  margin-left: 0;
}

.ant-col-push-13.ant-col-rtl {
  right: 54.16666667%;
  left: auto;
}

.ant-col-pull-13.ant-col-rtl {
  right: auto;
  left: 54.16666667%;
}

.ant-col-offset-13.ant-col-rtl {
  margin-right: 54.16666667%;
  margin-left: 0;
}

.ant-col-push-14.ant-col-rtl {
  right: 58.33333333%;
  left: auto;
}

.ant-col-pull-14.ant-col-rtl {
  right: auto;
  left: 58.33333333%;
}

.ant-col-offset-14.ant-col-rtl {
  margin-right: 58.33333333%;
  margin-left: 0;
}

.ant-col-push-15.ant-col-rtl {
  right: 62.5%;
  left: auto;
}

.ant-col-pull-15.ant-col-rtl {
  right: auto;
  left: 62.5%;
}

.ant-col-offset-15.ant-col-rtl {
  margin-right: 62.5%;
  margin-left: 0;
}

.ant-col-push-16.ant-col-rtl {
  right: 66.66666667%;
  left: auto;
}

.ant-col-pull-16.ant-col-rtl {
  right: auto;
  left: 66.66666667%;
}

.ant-col-offset-16.ant-col-rtl {
  margin-right: 66.66666667%;
  margin-left: 0;
}

.ant-col-push-17.ant-col-rtl {
  right: 70.83333333%;
  left: auto;
}

.ant-col-pull-17.ant-col-rtl {
  right: auto;
  left: 70.83333333%;
}

.ant-col-offset-17.ant-col-rtl {
  margin-right: 70.83333333%;
  margin-left: 0;
}

.ant-col-push-18.ant-col-rtl {
  right: 75%;
  left: auto;
}

.ant-col-pull-18.ant-col-rtl {
  right: auto;
  left: 75%;
}

.ant-col-offset-18.ant-col-rtl {
  margin-right: 75%;
  margin-left: 0;
}

.ant-col-push-19.ant-col-rtl {
  right: 79.16666667%;
  left: auto;
}

.ant-col-pull-19.ant-col-rtl {
  right: auto;
  left: 79.16666667%;
}

.ant-col-offset-19.ant-col-rtl {
  margin-right: 79.16666667%;
  margin-left: 0;
}

.ant-col-push-20.ant-col-rtl {
  right: 83.33333333%;
  left: auto;
}

.ant-col-pull-20.ant-col-rtl {
  right: auto;
  left: 83.33333333%;
}

.ant-col-offset-20.ant-col-rtl {
  margin-right: 83.33333333%;
  margin-left: 0;
}

.ant-col-push-21.ant-col-rtl {
  right: 87.5%;
  left: auto;
}

.ant-col-pull-21.ant-col-rtl {
  right: auto;
  left: 87.5%;
}

.ant-col-offset-21.ant-col-rtl {
  margin-right: 87.5%;
  margin-left: 0;
}

.ant-col-push-22.ant-col-rtl {
  right: 91.66666667%;
  left: auto;
}

.ant-col-pull-22.ant-col-rtl {
  right: auto;
  left: 91.66666667%;
}

.ant-col-offset-22.ant-col-rtl {
  margin-right: 91.66666667%;
  margin-left: 0;
}

.ant-col-push-23.ant-col-rtl {
  right: 95.83333333%;
  left: auto;
}

.ant-col-pull-23.ant-col-rtl {
  right: auto;
  left: 95.83333333%;
}

.ant-col-offset-23.ant-col-rtl {
  margin-right: 95.83333333%;
  margin-left: 0;
}

.ant-col-push-24.ant-col-rtl {
  right: 100%;
  left: auto;
}

.ant-col-pull-24.ant-col-rtl {
  right: auto;
  left: 100%;
}

.ant-col-offset-24.ant-col-rtl {
  margin-right: 100%;
  margin-left: 0;
}

.ant-col-xs-24 {
  display: block;
  flex: 0 0 100%;
  max-width: 100%;
}

.ant-col-xs-push-24 {
  left: 100%;
}

.ant-col-xs-pull-24 {
  right: 100%;
}

.ant-col-xs-offset-24 {
  margin-left: 100%;
}

.ant-col-xs-order-24 {
  order: 24;
}

.ant-col-xs-23 {
  display: block;
  flex: 0 0 95.83333333%;
  max-width: 95.83333333%;
}

.ant-col-xs-push-23 {
  left: 95.83333333%;
}

.ant-col-xs-pull-23 {
  right: 95.83333333%;
}

.ant-col-xs-offset-23 {
  margin-left: 95.83333333%;
}

.ant-col-xs-order-23 {
  order: 23;
}

.ant-col-xs-22 {
  display: block;
  flex: 0 0 91.66666667%;
  max-width: 91.66666667%;
}

.ant-col-xs-push-22 {
  left: 91.66666667%;
}

.ant-col-xs-pull-22 {
  right: 91.66666667%;
}

.ant-col-xs-offset-22 {
  margin-left: 91.66666667%;
}

.ant-col-xs-order-22 {
  order: 22;
}

.ant-col-xs-21 {
  display: block;
  flex: 0 0 87.5%;
  max-width: 87.5%;
}

.ant-col-xs-push-21 {
  left: 87.5%;
}

.ant-col-xs-pull-21 {
  right: 87.5%;
}

.ant-col-xs-offset-21 {
  margin-left: 87.5%;
}

.ant-col-xs-order-21 {
  order: 21;
}

.ant-col-xs-20 {
  display: block;
  flex: 0 0 83.33333333%;
  max-width: 83.33333333%;
}

.ant-col-xs-push-20 {
  left: 83.33333333%;
}

.ant-col-xs-pull-20 {
  right: 83.33333333%;
}

.ant-col-xs-offset-20 {
  margin-left: 83.33333333%;
}

.ant-col-xs-order-20 {
  order: 20;
}

.ant-col-xs-19 {
  display: block;
  flex: 0 0 79.16666667%;
  max-width: 79.16666667%;
}

.ant-col-xs-push-19 {
  left: 79.16666667%;
}

.ant-col-xs-pull-19 {
  right: 79.16666667%;
}

.ant-col-xs-offset-19 {
  margin-left: 79.16666667%;
}

.ant-col-xs-order-19 {
  order: 19;
}

.ant-col-xs-18 {
  display: block;
  flex: 0 0 75%;
  max-width: 75%;
}

.ant-col-xs-push-18 {
  left: 75%;
}

.ant-col-xs-pull-18 {
  right: 75%;
}

.ant-col-xs-offset-18 {
  margin-left: 75%;
}

.ant-col-xs-order-18 {
  order: 18;
}

.ant-col-xs-17 {
  display: block;
  flex: 0 0 70.83333333%;
  max-width: 70.83333333%;
}

.ant-col-xs-push-17 {
  left: 70.83333333%;
}

.ant-col-xs-pull-17 {
  right: 70.83333333%;
}

.ant-col-xs-offset-17 {
  margin-left: 70.83333333%;
}

.ant-col-xs-order-17 {
  order: 17;
}

.ant-col-xs-16 {
  display: block;
  flex: 0 0 66.66666667%;
  max-width: 66.66666667%;
}

.ant-col-xs-push-16 {
  left: 66.66666667%;
}

.ant-col-xs-pull-16 {
  right: 66.66666667%;
}

.ant-col-xs-offset-16 {
  margin-left: 66.66666667%;
}

.ant-col-xs-order-16 {
  order: 16;
}

.ant-col-xs-15 {
  display: block;
  flex: 0 0 62.5%;
  max-width: 62.5%;
}

.ant-col-xs-push-15 {
  left: 62.5%;
}

.ant-col-xs-pull-15 {
  right: 62.5%;
}

.ant-col-xs-offset-15 {
  margin-left: 62.5%;
}

.ant-col-xs-order-15 {
  order: 15;
}

.ant-col-xs-14 {
  display: block;
  flex: 0 0 58.33333333%;
  max-width: 58.33333333%;
}

.ant-col-xs-push-14 {
  left: 58.33333333%;
}

.ant-col-xs-pull-14 {
  right: 58.33333333%;
}

.ant-col-xs-offset-14 {
  margin-left: 58.33333333%;
}

.ant-col-xs-order-14 {
  order: 14;
}

.ant-col-xs-13 {
  display: block;
  flex: 0 0 54.16666667%;
  max-width: 54.16666667%;
}

.ant-col-xs-push-13 {
  left: 54.16666667%;
}

.ant-col-xs-pull-13 {
  right: 54.16666667%;
}

.ant-col-xs-offset-13 {
  margin-left: 54.16666667%;
}

.ant-col-xs-order-13 {
  order: 13;
}

.ant-col-xs-12 {
  display: block;
  flex: 0 0 50%;
  max-width: 50%;
}

.ant-col-xs-push-12 {
  left: 50%;
}

.ant-col-xs-pull-12 {
  right: 50%;
}

.ant-col-xs-offset-12 {
  margin-left: 50%;
}

.ant-col-xs-order-12 {
  order: 12;
}

.ant-col-xs-11 {
  display: block;
  flex: 0 0 45.83333333%;
  max-width: 45.83333333%;
}

.ant-col-xs-push-11 {
  left: 45.83333333%;
}

.ant-col-xs-pull-11 {
  right: 45.83333333%;
}

.ant-col-xs-offset-11 {
  margin-left: 45.83333333%;
}

.ant-col-xs-order-11 {
  order: 11;
}

.ant-col-xs-10 {
  display: block;
  flex: 0 0 41.66666667%;
  max-width: 41.66666667%;
}

.ant-col-xs-push-10 {
  left: 41.66666667%;
}

.ant-col-xs-pull-10 {
  right: 41.66666667%;
}

.ant-col-xs-offset-10 {
  margin-left: 41.66666667%;
}

.ant-col-xs-order-10 {
  order: 10;
}

.ant-col-xs-9 {
  display: block;
  flex: 0 0 37.5%;
  max-width: 37.5%;
}

.ant-col-xs-push-9 {
  left: 37.5%;
}

.ant-col-xs-pull-9 {
  right: 37.5%;
}

.ant-col-xs-offset-9 {
  margin-left: 37.5%;
}

.ant-col-xs-order-9 {
  order: 9;
}

.ant-col-xs-8 {
  display: block;
  flex: 0 0 33.33333333%;
  max-width: 33.33333333%;
}

.ant-col-xs-push-8 {
  left: 33.33333333%;
}

.ant-col-xs-pull-8 {
  right: 33.33333333%;
}

.ant-col-xs-offset-8 {
  margin-left: 33.33333333%;
}

.ant-col-xs-order-8 {
  order: 8;
}

.ant-col-xs-7 {
  display: block;
  flex: 0 0 29.16666667%;
  max-width: 29.16666667%;
}

.ant-col-xs-push-7 {
  left: 29.16666667%;
}

.ant-col-xs-pull-7 {
  right: 29.16666667%;
}

.ant-col-xs-offset-7 {
  margin-left: 29.16666667%;
}

.ant-col-xs-order-7 {
  order: 7;
}

.ant-col-xs-6 {
  display: block;
  flex: 0 0 25%;
  max-width: 25%;
}

.ant-col-xs-push-6 {
  left: 25%;
}

.ant-col-xs-pull-6 {
  right: 25%;
}

.ant-col-xs-offset-6 {
  margin-left: 25%;
}

.ant-col-xs-order-6 {
  order: 6;
}

.ant-col-xs-5 {
  display: block;
  flex: 0 0 20.83333333%;
  max-width: 20.83333333%;
}

.ant-col-xs-push-5 {
  left: 20.83333333%;
}

.ant-col-xs-pull-5 {
  right: 20.83333333%;
}

.ant-col-xs-offset-5 {
  margin-left: 20.83333333%;
}

.ant-col-xs-order-5 {
  order: 5;
}

.ant-col-xs-4 {
  display: block;
  flex: 0 0 16.66666667%;
  max-width: 16.66666667%;
}

.ant-col-xs-push-4 {
  left: 16.66666667%;
}

.ant-col-xs-pull-4 {
  right: 16.66666667%;
}

.ant-col-xs-offset-4 {
  margin-left: 16.66666667%;
}

.ant-col-xs-order-4 {
  order: 4;
}

.ant-col-xs-3 {
  display: block;
  flex: 0 0 12.5%;
  max-width: 12.5%;
}

.ant-col-xs-push-3 {
  left: 12.5%;
}

.ant-col-xs-pull-3 {
  right: 12.5%;
}

.ant-col-xs-offset-3 {
  margin-left: 12.5%;
}

.ant-col-xs-order-3 {
  order: 3;
}

.ant-col-xs-2 {
  display: block;
  flex: 0 0 8.33333333%;
  max-width: 8.33333333%;
}

.ant-col-xs-push-2 {
  left: 8.33333333%;
}

.ant-col-xs-pull-2 {
  right: 8.33333333%;
}

.ant-col-xs-offset-2 {
  margin-left: 8.33333333%;
}

.ant-col-xs-order-2 {
  order: 2;
}

.ant-col-xs-1 {
  display: block;
  flex: 0 0 4.16666667%;
  max-width: 4.16666667%;
}

.ant-col-xs-push-1 {
  left: 4.16666667%;
}

.ant-col-xs-pull-1 {
  right: 4.16666667%;
}

.ant-col-xs-offset-1 {
  margin-left: 4.16666667%;
}

.ant-col-xs-order-1 {
  order: 1;
}

.ant-col-xs-0 {
  display: none;
}

.ant-col-push-0 {
  left: auto;
}

.ant-col-pull-0 {
  right: auto;
}

.ant-col-xs-push-0 {
  left: auto;
}

.ant-col-xs-pull-0 {
  right: auto;
}

.ant-col-xs-offset-0 {
  margin-left: 0;
}

.ant-col-xs-order-0 {
  order: 0;
}

.ant-col-push-0.ant-col-rtl {
  right: auto;
}

.ant-col-pull-0.ant-col-rtl {
  left: auto;
}

.ant-col-xs-push-0.ant-col-rtl {
  right: auto;
}

.ant-col-xs-pull-0.ant-col-rtl {
  left: auto;
}

.ant-col-xs-offset-0.ant-col-rtl {
  margin-right: 0;
}

.ant-col-xs-push-1.ant-col-rtl {
  right: 4.16666667%;
  left: auto;
}

.ant-col-xs-pull-1.ant-col-rtl {
  right: auto;
  left: 4.16666667%;
}

.ant-col-xs-offset-1.ant-col-rtl {
  margin-right: 4.16666667%;
  margin-left: 0;
}

.ant-col-xs-push-2.ant-col-rtl {
  right: 8.33333333%;
  left: auto;
}

.ant-col-xs-pull-2.ant-col-rtl {
  right: auto;
  left: 8.33333333%;
}

.ant-col-xs-offset-2.ant-col-rtl {
  margin-right: 8.33333333%;
  margin-left: 0;
}

.ant-col-xs-push-3.ant-col-rtl {
  right: 12.5%;
  left: auto;
}

.ant-col-xs-pull-3.ant-col-rtl {
  right: auto;
  left: 12.5%;
}

.ant-col-xs-offset-3.ant-col-rtl {
  margin-right: 12.5%;
  margin-left: 0;
}

.ant-col-xs-push-4.ant-col-rtl {
  right: 16.66666667%;
  left: auto;
}

.ant-col-xs-pull-4.ant-col-rtl {
  right: auto;
  left: 16.66666667%;
}

.ant-col-xs-offset-4.ant-col-rtl {
  margin-right: 16.66666667%;
  margin-left: 0;
}

.ant-col-xs-push-5.ant-col-rtl {
  right: 20.83333333%;
  left: auto;
}

.ant-col-xs-pull-5.ant-col-rtl {
  right: auto;
  left: 20.83333333%;
}

.ant-col-xs-offset-5.ant-col-rtl {
  margin-right: 20.83333333%;
  margin-left: 0;
}

.ant-col-xs-push-6.ant-col-rtl {
  right: 25%;
  left: auto;
}

.ant-col-xs-pull-6.ant-col-rtl {
  right: auto;
  left: 25%;
}

.ant-col-xs-offset-6.ant-col-rtl {
  margin-right: 25%;
  margin-left: 0;
}

.ant-col-xs-push-7.ant-col-rtl {
  right: 29.16666667%;
  left: auto;
}

.ant-col-xs-pull-7.ant-col-rtl {
  right: auto;
  left: 29.16666667%;
}

.ant-col-xs-offset-7.ant-col-rtl {
  margin-right: 29.16666667%;
  margin-left: 0;
}

.ant-col-xs-push-8.ant-col-rtl {
  right: 33.33333333%;
  left: auto;
}

.ant-col-xs-pull-8.ant-col-rtl {
  right: auto;
  left: 33.33333333%;
}

.ant-col-xs-offset-8.ant-col-rtl {
  margin-right: 33.33333333%;
  margin-left: 0;
}

.ant-col-xs-push-9.ant-col-rtl {
  right: 37.5%;
  left: auto;
}

.ant-col-xs-pull-9.ant-col-rtl {
  right: auto;
  left: 37.5%;
}

.ant-col-xs-offset-9.ant-col-rtl {
  margin-right: 37.5%;
  margin-left: 0;
}

.ant-col-xs-push-10.ant-col-rtl {
  right: 41.66666667%;
  left: auto;
}

.ant-col-xs-pull-10.ant-col-rtl {
  right: auto;
  left: 41.66666667%;
}

.ant-col-xs-offset-10.ant-col-rtl {
  margin-right: 41.66666667%;
  margin-left: 0;
}

.ant-col-xs-push-11.ant-col-rtl {
  right: 45.83333333%;
  left: auto;
}

.ant-col-xs-pull-11.ant-col-rtl {
  right: auto;
  left: 45.83333333%;
}

.ant-col-xs-offset-11.ant-col-rtl {
  margin-right: 45.83333333%;
  margin-left: 0;
}

.ant-col-xs-push-12.ant-col-rtl {
  right: 50%;
  left: auto;
}

.ant-col-xs-pull-12.ant-col-rtl {
  right: auto;
  left: 50%;
}

.ant-col-xs-offset-12.ant-col-rtl {
  margin-right: 50%;
  margin-left: 0;
}

.ant-col-xs-push-13.ant-col-rtl {
  right: 54.16666667%;
  left: auto;
}

.ant-col-xs-pull-13.ant-col-rtl {
  right: auto;
  left: 54.16666667%;
}

.ant-col-xs-offset-13.ant-col-rtl {
  margin-right: 54.16666667%;
  margin-left: 0;
}

.ant-col-xs-push-14.ant-col-rtl {
  right: 58.33333333%;
  left: auto;
}

.ant-col-xs-pull-14.ant-col-rtl {
  right: auto;
  left: 58.33333333%;
}

.ant-col-xs-offset-14.ant-col-rtl {
  margin-right: 58.33333333%;
  margin-left: 0;
}

.ant-col-xs-push-15.ant-col-rtl {
  right: 62.5%;
  left: auto;
}

.ant-col-xs-pull-15.ant-col-rtl {
  right: auto;
  left: 62.5%;
}

.ant-col-xs-offset-15.ant-col-rtl {
  margin-right: 62.5%;
  margin-left: 0;
}

.ant-col-xs-push-16.ant-col-rtl {
  right: 66.66666667%;
  left: auto;
}

.ant-col-xs-pull-16.ant-col-rtl {
  right: auto;
  left: 66.66666667%;
}

.ant-col-xs-offset-16.ant-col-rtl {
  margin-right: 66.66666667%;
  margin-left: 0;
}

.ant-col-xs-push-17.ant-col-rtl {
  right: 70.83333333%;
  left: auto;
}

.ant-col-xs-pull-17.ant-col-rtl {
  right: auto;
  left: 70.83333333%;
}

.ant-col-xs-offset-17.ant-col-rtl {
  margin-right: 70.83333333%;
  margin-left: 0;
}

.ant-col-xs-push-18.ant-col-rtl {
  right: 75%;
  left: auto;
}

.ant-col-xs-pull-18.ant-col-rtl {
  right: auto;
  left: 75%;
}

.ant-col-xs-offset-18.ant-col-rtl {
  margin-right: 75%;
  margin-left: 0;
}

.ant-col-xs-push-19.ant-col-rtl {
  right: 79.16666667%;
  left: auto;
}

.ant-col-xs-pull-19.ant-col-rtl {
  right: auto;
  left: 79.16666667%;
}

.ant-col-xs-offset-19.ant-col-rtl {
  margin-right: 79.16666667%;
  margin-left: 0;
}

.ant-col-xs-push-20.ant-col-rtl {
  right: 83.33333333%;
  left: auto;
}

.ant-col-xs-pull-20.ant-col-rtl {
  right: auto;
  left: 83.33333333%;
}

.ant-col-xs-offset-20.ant-col-rtl {
  margin-right: 83.33333333%;
  margin-left: 0;
}

.ant-col-xs-push-21.ant-col-rtl {
  right: 87.5%;
  left: auto;
}

.ant-col-xs-pull-21.ant-col-rtl {
  right: auto;
  left: 87.5%;
}

.ant-col-xs-offset-21.ant-col-rtl {
  margin-right: 87.5%;
  margin-left: 0;
}

.ant-col-xs-push-22.ant-col-rtl {
  right: 91.66666667%;
  left: auto;
}

.ant-col-xs-pull-22.ant-col-rtl {
  right: auto;
  left: 91.66666667%;
}

.ant-col-xs-offset-22.ant-col-rtl {
  margin-right: 91.66666667%;
  margin-left: 0;
}

.ant-col-xs-push-23.ant-col-rtl {
  right: 95.83333333%;
  left: auto;
}

.ant-col-xs-pull-23.ant-col-rtl {
  right: auto;
  left: 95.83333333%;
}

.ant-col-xs-offset-23.ant-col-rtl {
  margin-right: 95.83333333%;
  margin-left: 0;
}

.ant-col-xs-push-24.ant-col-rtl {
  right: 100%;
  left: auto;
}

.ant-col-xs-pull-24.ant-col-rtl {
  right: auto;
  left: 100%;
}

.ant-col-xs-offset-24.ant-col-rtl {
  margin-right: 100%;
  margin-left: 0;
}

@media (min-width: 576px) {
  .ant-col-sm-24 {
    display: block;
    flex: 0 0 100%;
    max-width: 100%;
  }
  .ant-col-sm-push-24 {
    left: 100%;
  }
  .ant-col-sm-pull-24 {
    right: 100%;
  }
  .ant-col-sm-offset-24 {
    margin-left: 100%;
  }
  .ant-col-sm-order-24 {
    order: 24;
  }
  .ant-col-sm-23 {
    display: block;
    flex: 0 0 95.83333333%;
    max-width: 95.83333333%;
  }
  .ant-col-sm-push-23 {
    left: 95.83333333%;
  }
  .ant-col-sm-pull-23 {
    right: 95.83333333%;
  }
  .ant-col-sm-offset-23 {
    margin-left: 95.83333333%;
  }
  .ant-col-sm-order-23 {
    order: 23;
  }
  .ant-col-sm-22 {
    display: block;
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .ant-col-sm-push-22 {
    left: 91.66666667%;
  }
  .ant-col-sm-pull-22 {
    right: 91.66666667%;
  }
  .ant-col-sm-offset-22 {
    margin-left: 91.66666667%;
  }
  .ant-col-sm-order-22 {
    order: 22;
  }
  .ant-col-sm-21 {
    display: block;
    flex: 0 0 87.5%;
    max-width: 87.5%;
  }
  .ant-col-sm-push-21 {
    left: 87.5%;
  }
  .ant-col-sm-pull-21 {
    right: 87.5%;
  }
  .ant-col-sm-offset-21 {
    margin-left: 87.5%;
  }
  .ant-col-sm-order-21 {
    order: 21;
  }
  .ant-col-sm-20 {
    display: block;
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .ant-col-sm-push-20 {
    left: 83.33333333%;
  }
  .ant-col-sm-pull-20 {
    right: 83.33333333%;
  }
  .ant-col-sm-offset-20 {
    margin-left: 83.33333333%;
  }
  .ant-col-sm-order-20 {
    order: 20;
  }
  .ant-col-sm-19 {
    display: block;
    flex: 0 0 79.16666667%;
    max-width: 79.16666667%;
  }
  .ant-col-sm-push-19 {
    left: 79.16666667%;
  }
  .ant-col-sm-pull-19 {
    right: 79.16666667%;
  }
  .ant-col-sm-offset-19 {
    margin-left: 79.16666667%;
  }
  .ant-col-sm-order-19 {
    order: 19;
  }
  .ant-col-sm-18 {
    display: block;
    flex: 0 0 75%;
    max-width: 75%;
  }
  .ant-col-sm-push-18 {
    left: 75%;
  }
  .ant-col-sm-pull-18 {
    right: 75%;
  }
  .ant-col-sm-offset-18 {
    margin-left: 75%;
  }
  .ant-col-sm-order-18 {
    order: 18;
  }
  .ant-col-sm-17 {
    display: block;
    flex: 0 0 70.83333333%;
    max-width: 70.83333333%;
  }
  .ant-col-sm-push-17 {
    left: 70.83333333%;
  }
  .ant-col-sm-pull-17 {
    right: 70.83333333%;
  }
  .ant-col-sm-offset-17 {
    margin-left: 70.83333333%;
  }
  .ant-col-sm-order-17 {
    order: 17;
  }
  .ant-col-sm-16 {
    display: block;
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .ant-col-sm-push-16 {
    left: 66.66666667%;
  }
  .ant-col-sm-pull-16 {
    right: 66.66666667%;
  }
  .ant-col-sm-offset-16 {
    margin-left: 66.66666667%;
  }
  .ant-col-sm-order-16 {
    order: 16;
  }
  .ant-col-sm-15 {
    display: block;
    flex: 0 0 62.5%;
    max-width: 62.5%;
  }
  .ant-col-sm-push-15 {
    left: 62.5%;
  }
  .ant-col-sm-pull-15 {
    right: 62.5%;
  }
  .ant-col-sm-offset-15 {
    margin-left: 62.5%;
  }
  .ant-col-sm-order-15 {
    order: 15;
  }
  .ant-col-sm-14 {
    display: block;
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .ant-col-sm-push-14 {
    left: 58.33333333%;
  }
  .ant-col-sm-pull-14 {
    right: 58.33333333%;
  }
  .ant-col-sm-offset-14 {
    margin-left: 58.33333333%;
  }
  .ant-col-sm-order-14 {
    order: 14;
  }
  .ant-col-sm-13 {
    display: block;
    flex: 0 0 54.16666667%;
    max-width: 54.16666667%;
  }
  .ant-col-sm-push-13 {
    left: 54.16666667%;
  }
  .ant-col-sm-pull-13 {
    right: 54.16666667%;
  }
  .ant-col-sm-offset-13 {
    margin-left: 54.16666667%;
  }
  .ant-col-sm-order-13 {
    order: 13;
  }
  .ant-col-sm-12 {
    display: block;
    flex: 0 0 50%;
    max-width: 50%;
  }
  .ant-col-sm-push-12 {
    left: 50%;
  }
  .ant-col-sm-pull-12 {
    right: 50%;
  }
  .ant-col-sm-offset-12 {
    margin-left: 50%;
  }
  .ant-col-sm-order-12 {
    order: 12;
  }
  .ant-col-sm-11 {
    display: block;
    flex: 0 0 45.83333333%;
    max-width: 45.83333333%;
  }
  .ant-col-sm-push-11 {
    left: 45.83333333%;
  }
  .ant-col-sm-pull-11 {
    right: 45.83333333%;
  }
  .ant-col-sm-offset-11 {
    margin-left: 45.83333333%;
  }
  .ant-col-sm-order-11 {
    order: 11;
  }
  .ant-col-sm-10 {
    display: block;
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .ant-col-sm-push-10 {
    left: 41.66666667%;
  }
  .ant-col-sm-pull-10 {
    right: 41.66666667%;
  }
  .ant-col-sm-offset-10 {
    margin-left: 41.66666667%;
  }
  .ant-col-sm-order-10 {
    order: 10;
  }
  .ant-col-sm-9 {
    display: block;
    flex: 0 0 37.5%;
    max-width: 37.5%;
  }
  .ant-col-sm-push-9 {
    left: 37.5%;
  }
  .ant-col-sm-pull-9 {
    right: 37.5%;
  }
  .ant-col-sm-offset-9 {
    margin-left: 37.5%;
  }
  .ant-col-sm-order-9 {
    order: 9;
  }
  .ant-col-sm-8 {
    display: block;
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .ant-col-sm-push-8 {
    left: 33.33333333%;
  }
  .ant-col-sm-pull-8 {
    right: 33.33333333%;
  }
  .ant-col-sm-offset-8 {
    margin-left: 33.33333333%;
  }
  .ant-col-sm-order-8 {
    order: 8;
  }
  .ant-col-sm-7 {
    display: block;
    flex: 0 0 29.16666667%;
    max-width: 29.16666667%;
  }
  .ant-col-sm-push-7 {
    left: 29.16666667%;
  }
  .ant-col-sm-pull-7 {
    right: 29.16666667%;
  }
  .ant-col-sm-offset-7 {
    margin-left: 29.16666667%;
  }
  .ant-col-sm-order-7 {
    order: 7;
  }
  .ant-col-sm-6 {
    display: block;
    flex: 0 0 25%;
    max-width: 25%;
  }
  .ant-col-sm-push-6 {
    left: 25%;
  }
  .ant-col-sm-pull-6 {
    right: 25%;
  }
  .ant-col-sm-offset-6 {
    margin-left: 25%;
  }
  .ant-col-sm-order-6 {
    order: 6;
  }
  .ant-col-sm-5 {
    display: block;
    flex: 0 0 20.83333333%;
    max-width: 20.83333333%;
  }
  .ant-col-sm-push-5 {
    left: 20.83333333%;
  }
  .ant-col-sm-pull-5 {
    right: 20.83333333%;
  }
  .ant-col-sm-offset-5 {
    margin-left: 20.83333333%;
  }
  .ant-col-sm-order-5 {
    order: 5;
  }
  .ant-col-sm-4 {
    display: block;
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .ant-col-sm-push-4 {
    left: 16.66666667%;
  }
  .ant-col-sm-pull-4 {
    right: 16.66666667%;
  }
  .ant-col-sm-offset-4 {
    margin-left: 16.66666667%;
  }
  .ant-col-sm-order-4 {
    order: 4;
  }
  .ant-col-sm-3 {
    display: block;
    flex: 0 0 12.5%;
    max-width: 12.5%;
  }
  .ant-col-sm-push-3 {
    left: 12.5%;
  }
  .ant-col-sm-pull-3 {
    right: 12.5%;
  }
  .ant-col-sm-offset-3 {
    margin-left: 12.5%;
  }
  .ant-col-sm-order-3 {
    order: 3;
  }
  .ant-col-sm-2 {
    display: block;
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .ant-col-sm-push-2 {
    left: 8.33333333%;
  }
  .ant-col-sm-pull-2 {
    right: 8.33333333%;
  }
  .ant-col-sm-offset-2 {
    margin-left: 8.33333333%;
  }
  .ant-col-sm-order-2 {
    order: 2;
  }
  .ant-col-sm-1 {
    display: block;
    flex: 0 0 4.16666667%;
    max-width: 4.16666667%;
  }
  .ant-col-sm-push-1 {
    left: 4.16666667%;
  }
  .ant-col-sm-pull-1 {
    right: 4.16666667%;
  }
  .ant-col-sm-offset-1 {
    margin-left: 4.16666667%;
  }
  .ant-col-sm-order-1 {
    order: 1;
  }
  .ant-col-sm-0 {
    display: none;
  }
  .ant-col-push-0 {
    left: auto;
  }
  .ant-col-pull-0 {
    right: auto;
  }
  .ant-col-sm-push-0 {
    left: auto;
  }
  .ant-col-sm-pull-0 {
    right: auto;
  }
  .ant-col-sm-offset-0 {
    margin-left: 0;
  }
  .ant-col-sm-order-0 {
    order: 0;
  }
  .ant-col-push-0.ant-col-rtl {
    right: auto;
  }
  .ant-col-pull-0.ant-col-rtl {
    left: auto;
  }
  .ant-col-sm-push-0.ant-col-rtl {
    right: auto;
  }
  .ant-col-sm-pull-0.ant-col-rtl {
    left: auto;
  }
  .ant-col-sm-offset-0.ant-col-rtl {
    margin-right: 0;
  }
  .ant-col-sm-push-1.ant-col-rtl {
    right: 4.16666667%;
    left: auto;
  }
  .ant-col-sm-pull-1.ant-col-rtl {
    right: auto;
    left: 4.16666667%;
  }
  .ant-col-sm-offset-1.ant-col-rtl {
    margin-right: 4.16666667%;
    margin-left: 0;
  }
  .ant-col-sm-push-2.ant-col-rtl {
    right: 8.33333333%;
    left: auto;
  }
  .ant-col-sm-pull-2.ant-col-rtl {
    right: auto;
    left: 8.33333333%;
  }
  .ant-col-sm-offset-2.ant-col-rtl {
    margin-right: 8.33333333%;
    margin-left: 0;
  }
  .ant-col-sm-push-3.ant-col-rtl {
    right: 12.5%;
    left: auto;
  }
  .ant-col-sm-pull-3.ant-col-rtl {
    right: auto;
    left: 12.5%;
  }
  .ant-col-sm-offset-3.ant-col-rtl {
    margin-right: 12.5%;
    margin-left: 0;
  }
  .ant-col-sm-push-4.ant-col-rtl {
    right: 16.66666667%;
    left: auto;
  }
  .ant-col-sm-pull-4.ant-col-rtl {
    right: auto;
    left: 16.66666667%;
  }
  .ant-col-sm-offset-4.ant-col-rtl {
    margin-right: 16.66666667%;
    margin-left: 0;
  }
  .ant-col-sm-push-5.ant-col-rtl {
    right: 20.83333333%;
    left: auto;
  }
  .ant-col-sm-pull-5.ant-col-rtl {
    right: auto;
    left: 20.83333333%;
  }
  .ant-col-sm-offset-5.ant-col-rtl {
    margin-right: 20.83333333%;
    margin-left: 0;
  }
  .ant-col-sm-push-6.ant-col-rtl {
    right: 25%;
    left: auto;
  }
  .ant-col-sm-pull-6.ant-col-rtl {
    right: auto;
    left: 25%;
  }
  .ant-col-sm-offset-6.ant-col-rtl {
    margin-right: 25%;
    margin-left: 0;
  }
  .ant-col-sm-push-7.ant-col-rtl {
    right: 29.16666667%;
    left: auto;
  }
  .ant-col-sm-pull-7.ant-col-rtl {
    right: auto;
    left: 29.16666667%;
  }
  .ant-col-sm-offset-7.ant-col-rtl {
    margin-right: 29.16666667%;
    margin-left: 0;
  }
  .ant-col-sm-push-8.ant-col-rtl {
    right: 33.33333333%;
    left: auto;
  }
  .ant-col-sm-pull-8.ant-col-rtl {
    right: auto;
    left: 33.33333333%;
  }
  .ant-col-sm-offset-8.ant-col-rtl {
    margin-right: 33.33333333%;
    margin-left: 0;
  }
  .ant-col-sm-push-9.ant-col-rtl {
    right: 37.5%;
    left: auto;
  }
  .ant-col-sm-pull-9.ant-col-rtl {
    right: auto;
    left: 37.5%;
  }
  .ant-col-sm-offset-9.ant-col-rtl {
    margin-right: 37.5%;
    margin-left: 0;
  }
  .ant-col-sm-push-10.ant-col-rtl {
    right: 41.66666667%;
    left: auto;
  }
  .ant-col-sm-pull-10.ant-col-rtl {
    right: auto;
    left: 41.66666667%;
  }
  .ant-col-sm-offset-10.ant-col-rtl {
    margin-right: 41.66666667%;
    margin-left: 0;
  }
  .ant-col-sm-push-11.ant-col-rtl {
    right: 45.83333333%;
    left: auto;
  }
  .ant-col-sm-pull-11.ant-col-rtl {
    right: auto;
    left: 45.83333333%;
  }
  .ant-col-sm-offset-11.ant-col-rtl {
    margin-right: 45.83333333%;
    margin-left: 0;
  }
  .ant-col-sm-push-12.ant-col-rtl {
    right: 50%;
    left: auto;
  }
  .ant-col-sm-pull-12.ant-col-rtl {
    right: auto;
    left: 50%;
  }
  .ant-col-sm-offset-12.ant-col-rtl {
    margin-right: 50%;
    margin-left: 0;
  }
  .ant-col-sm-push-13.ant-col-rtl {
    right: 54.16666667%;
    left: auto;
  }
  .ant-col-sm-pull-13.ant-col-rtl {
    right: auto;
    left: 54.16666667%;
  }
  .ant-col-sm-offset-13.ant-col-rtl {
    margin-right: 54.16666667%;
    margin-left: 0;
  }
  .ant-col-sm-push-14.ant-col-rtl {
    right: 58.33333333%;
    left: auto;
  }
  .ant-col-sm-pull-14.ant-col-rtl {
    right: auto;
    left: 58.33333333%;
  }
  .ant-col-sm-offset-14.ant-col-rtl {
    margin-right: 58.33333333%;
    margin-left: 0;
  }
  .ant-col-sm-push-15.ant-col-rtl {
    right: 62.5%;
    left: auto;
  }
  .ant-col-sm-pull-15.ant-col-rtl {
    right: auto;
    left: 62.5%;
  }
  .ant-col-sm-offset-15.ant-col-rtl {
    margin-right: 62.5%;
    margin-left: 0;
  }
  .ant-col-sm-push-16.ant-col-rtl {
    right: 66.66666667%;
    left: auto;
  }
  .ant-col-sm-pull-16.ant-col-rtl {
    right: auto;
    left: 66.66666667%;
  }
  .ant-col-sm-offset-16.ant-col-rtl {
    margin-right: 66.66666667%;
    margin-left: 0;
  }
  .ant-col-sm-push-17.ant-col-rtl {
    right: 70.83333333%;
    left: auto;
  }
  .ant-col-sm-pull-17.ant-col-rtl {
    right: auto;
    left: 70.83333333%;
  }
  .ant-col-sm-offset-17.ant-col-rtl {
    margin-right: 70.83333333%;
    margin-left: 0;
  }
  .ant-col-sm-push-18.ant-col-rtl {
    right: 75%;
    left: auto;
  }
  .ant-col-sm-pull-18.ant-col-rtl {
    right: auto;
    left: 75%;
  }
  .ant-col-sm-offset-18.ant-col-rtl {
    margin-right: 75%;
    margin-left: 0;
  }
  .ant-col-sm-push-19.ant-col-rtl {
    right: 79.16666667%;
    left: auto;
  }
  .ant-col-sm-pull-19.ant-col-rtl {
    right: auto;
    left: 79.16666667%;
  }
  .ant-col-sm-offset-19.ant-col-rtl {
    margin-right: 79.16666667%;
    margin-left: 0;
  }
  .ant-col-sm-push-20.ant-col-rtl {
    right: 83.33333333%;
    left: auto;
  }
  .ant-col-sm-pull-20.ant-col-rtl {
    right: auto;
    left: 83.33333333%;
  }
  .ant-col-sm-offset-20.ant-col-rtl {
    margin-right: 83.33333333%;
    margin-left: 0;
  }
  .ant-col-sm-push-21.ant-col-rtl {
    right: 87.5%;
    left: auto;
  }
  .ant-col-sm-pull-21.ant-col-rtl {
    right: auto;
    left: 87.5%;
  }
  .ant-col-sm-offset-21.ant-col-rtl {
    margin-right: 87.5%;
    margin-left: 0;
  }
  .ant-col-sm-push-22.ant-col-rtl {
    right: 91.66666667%;
    left: auto;
  }
  .ant-col-sm-pull-22.ant-col-rtl {
    right: auto;
    left: 91.66666667%;
  }
  .ant-col-sm-offset-22.ant-col-rtl {
    margin-right: 91.66666667%;
    margin-left: 0;
  }
  .ant-col-sm-push-23.ant-col-rtl {
    right: 95.83333333%;
    left: auto;
  }
  .ant-col-sm-pull-23.ant-col-rtl {
    right: auto;
    left: 95.83333333%;
  }
  .ant-col-sm-offset-23.ant-col-rtl {
    margin-right: 95.83333333%;
    margin-left: 0;
  }
  .ant-col-sm-push-24.ant-col-rtl {
    right: 100%;
    left: auto;
  }
  .ant-col-sm-pull-24.ant-col-rtl {
    right: auto;
    left: 100%;
  }
  .ant-col-sm-offset-24.ant-col-rtl {
    margin-right: 100%;
    margin-left: 0;
  }
}
@media (min-width: 768px) {
  .ant-col-md-24 {
    display: block;
    flex: 0 0 100%;
    max-width: 100%;
  }
  .ant-col-md-push-24 {
    left: 100%;
  }
  .ant-col-md-pull-24 {
    right: 100%;
  }
  .ant-col-md-offset-24 {
    margin-left: 100%;
  }
  .ant-col-md-order-24 {
    order: 24;
  }
  .ant-col-md-23 {
    display: block;
    flex: 0 0 95.83333333%;
    max-width: 95.83333333%;
  }
  .ant-col-md-push-23 {
    left: 95.83333333%;
  }
  .ant-col-md-pull-23 {
    right: 95.83333333%;
  }
  .ant-col-md-offset-23 {
    margin-left: 95.83333333%;
  }
  .ant-col-md-order-23 {
    order: 23;
  }
  .ant-col-md-22 {
    display: block;
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .ant-col-md-push-22 {
    left: 91.66666667%;
  }
  .ant-col-md-pull-22 {
    right: 91.66666667%;
  }
  .ant-col-md-offset-22 {
    margin-left: 91.66666667%;
  }
  .ant-col-md-order-22 {
    order: 22;
  }
  .ant-col-md-21 {
    display: block;
    flex: 0 0 87.5%;
    max-width: 87.5%;
  }
  .ant-col-md-push-21 {
    left: 87.5%;
  }
  .ant-col-md-pull-21 {
    right: 87.5%;
  }
  .ant-col-md-offset-21 {
    margin-left: 87.5%;
  }
  .ant-col-md-order-21 {
    order: 21;
  }
  .ant-col-md-20 {
    display: block;
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .ant-col-md-push-20 {
    left: 83.33333333%;
  }
  .ant-col-md-pull-20 {
    right: 83.33333333%;
  }
  .ant-col-md-offset-20 {
    margin-left: 83.33333333%;
  }
  .ant-col-md-order-20 {
    order: 20;
  }
  .ant-col-md-19 {
    display: block;
    flex: 0 0 79.16666667%;
    max-width: 79.16666667%;
  }
  .ant-col-md-push-19 {
    left: 79.16666667%;
  }
  .ant-col-md-pull-19 {
    right: 79.16666667%;
  }
  .ant-col-md-offset-19 {
    margin-left: 79.16666667%;
  }
  .ant-col-md-order-19 {
    order: 19;
  }
  .ant-col-md-18 {
    display: block;
    flex: 0 0 75%;
    max-width: 75%;
  }
  .ant-col-md-push-18 {
    left: 75%;
  }
  .ant-col-md-pull-18 {
    right: 75%;
  }
  .ant-col-md-offset-18 {
    margin-left: 75%;
  }
  .ant-col-md-order-18 {
    order: 18;
  }
  .ant-col-md-17 {
    display: block;
    flex: 0 0 70.83333333%;
    max-width: 70.83333333%;
  }
  .ant-col-md-push-17 {
    left: 70.83333333%;
  }
  .ant-col-md-pull-17 {
    right: 70.83333333%;
  }
  .ant-col-md-offset-17 {
    margin-left: 70.83333333%;
  }
  .ant-col-md-order-17 {
    order: 17;
  }
  .ant-col-md-16 {
    display: block;
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .ant-col-md-push-16 {
    left: 66.66666667%;
  }
  .ant-col-md-pull-16 {
    right: 66.66666667%;
  }
  .ant-col-md-offset-16 {
    margin-left: 66.66666667%;
  }
  .ant-col-md-order-16 {
    order: 16;
  }
  .ant-col-md-15 {
    display: block;
    flex: 0 0 62.5%;
    max-width: 62.5%;
  }
  .ant-col-md-push-15 {
    left: 62.5%;
  }
  .ant-col-md-pull-15 {
    right: 62.5%;
  }
  .ant-col-md-offset-15 {
    margin-left: 62.5%;
  }
  .ant-col-md-order-15 {
    order: 15;
  }
  .ant-col-md-14 {
    display: block;
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .ant-col-md-push-14 {
    left: 58.33333333%;
  }
  .ant-col-md-pull-14 {
    right: 58.33333333%;
  }
  .ant-col-md-offset-14 {
    margin-left: 58.33333333%;
  }
  .ant-col-md-order-14 {
    order: 14;
  }
  .ant-col-md-13 {
    display: block;
    flex: 0 0 54.16666667%;
    max-width: 54.16666667%;
  }
  .ant-col-md-push-13 {
    left: 54.16666667%;
  }
  .ant-col-md-pull-13 {
    right: 54.16666667%;
  }
  .ant-col-md-offset-13 {
    margin-left: 54.16666667%;
  }
  .ant-col-md-order-13 {
    order: 13;
  }
  .ant-col-md-12 {
    display: block;
    flex: 0 0 50%;
    max-width: 50%;
  }
  .ant-col-md-push-12 {
    left: 50%;
  }
  .ant-col-md-pull-12 {
    right: 50%;
  }
  .ant-col-md-offset-12 {
    margin-left: 50%;
  }
  .ant-col-md-order-12 {
    order: 12;
  }
  .ant-col-md-11 {
    display: block;
    flex: 0 0 45.83333333%;
    max-width: 45.83333333%;
  }
  .ant-col-md-push-11 {
    left: 45.83333333%;
  }
  .ant-col-md-pull-11 {
    right: 45.83333333%;
  }
  .ant-col-md-offset-11 {
    margin-left: 45.83333333%;
  }
  .ant-col-md-order-11 {
    order: 11;
  }
  .ant-col-md-10 {
    display: block;
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .ant-col-md-push-10 {
    left: 41.66666667%;
  }
  .ant-col-md-pull-10 {
    right: 41.66666667%;
  }
  .ant-col-md-offset-10 {
    margin-left: 41.66666667%;
  }
  .ant-col-md-order-10 {
    order: 10;
  }
  .ant-col-md-9 {
    display: block;
    flex: 0 0 37.5%;
    max-width: 37.5%;
  }
  .ant-col-md-push-9 {
    left: 37.5%;
  }
  .ant-col-md-pull-9 {
    right: 37.5%;
  }
  .ant-col-md-offset-9 {
    margin-left: 37.5%;
  }
  .ant-col-md-order-9 {
    order: 9;
  }
  .ant-col-md-8 {
    display: block;
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .ant-col-md-push-8 {
    left: 33.33333333%;
  }
  .ant-col-md-pull-8 {
    right: 33.33333333%;
  }
  .ant-col-md-offset-8 {
    margin-left: 33.33333333%;
  }
  .ant-col-md-order-8 {
    order: 8;
  }
  .ant-col-md-7 {
    display: block;
    flex: 0 0 29.16666667%;
    max-width: 29.16666667%;
  }
  .ant-col-md-push-7 {
    left: 29.16666667%;
  }
  .ant-col-md-pull-7 {
    right: 29.16666667%;
  }
  .ant-col-md-offset-7 {
    margin-left: 29.16666667%;
  }
  .ant-col-md-order-7 {
    order: 7;
  }
  .ant-col-md-6 {
    display: block;
    flex: 0 0 25%;
    max-width: 25%;
  }
  .ant-col-md-push-6 {
    left: 25%;
  }
  .ant-col-md-pull-6 {
    right: 25%;
  }
  .ant-col-md-offset-6 {
    margin-left: 25%;
  }
  .ant-col-md-order-6 {
    order: 6;
  }
  .ant-col-md-5 {
    display: block;
    flex: 0 0 20.83333333%;
    max-width: 20.83333333%;
  }
  .ant-col-md-push-5 {
    left: 20.83333333%;
  }
  .ant-col-md-pull-5 {
    right: 20.83333333%;
  }
  .ant-col-md-offset-5 {
    margin-left: 20.83333333%;
  }
  .ant-col-md-order-5 {
    order: 5;
  }
  .ant-col-md-4 {
    display: block;
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .ant-col-md-push-4 {
    left: 16.66666667%;
  }
  .ant-col-md-pull-4 {
    right: 16.66666667%;
  }
  .ant-col-md-offset-4 {
    margin-left: 16.66666667%;
  }
  .ant-col-md-order-4 {
    order: 4;
  }
  .ant-col-md-3 {
    display: block;
    flex: 0 0 12.5%;
    max-width: 12.5%;
  }
  .ant-col-md-push-3 {
    left: 12.5%;
  }
  .ant-col-md-pull-3 {
    right: 12.5%;
  }
  .ant-col-md-offset-3 {
    margin-left: 12.5%;
  }
  .ant-col-md-order-3 {
    order: 3;
  }
  .ant-col-md-2 {
    display: block;
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .ant-col-md-push-2 {
    left: 8.33333333%;
  }
  .ant-col-md-pull-2 {
    right: 8.33333333%;
  }
  .ant-col-md-offset-2 {
    margin-left: 8.33333333%;
  }
  .ant-col-md-order-2 {
    order: 2;
  }
  .ant-col-md-1 {
    display: block;
    flex: 0 0 4.16666667%;
    max-width: 4.16666667%;
  }
  .ant-col-md-push-1 {
    left: 4.16666667%;
  }
  .ant-col-md-pull-1 {
    right: 4.16666667%;
  }
  .ant-col-md-offset-1 {
    margin-left: 4.16666667%;
  }
  .ant-col-md-order-1 {
    order: 1;
  }
  .ant-col-md-0 {
    display: none;
  }
  .ant-col-push-0 {
    left: auto;
  }
  .ant-col-pull-0 {
    right: auto;
  }
  .ant-col-md-push-0 {
    left: auto;
  }
  .ant-col-md-pull-0 {
    right: auto;
  }
  .ant-col-md-offset-0 {
    margin-left: 0;
  }
  .ant-col-md-order-0 {
    order: 0;
  }
  .ant-col-push-0.ant-col-rtl {
    right: auto;
  }
  .ant-col-pull-0.ant-col-rtl {
    left: auto;
  }
  .ant-col-md-push-0.ant-col-rtl {
    right: auto;
  }
  .ant-col-md-pull-0.ant-col-rtl {
    left: auto;
  }
  .ant-col-md-offset-0.ant-col-rtl {
    margin-right: 0;
  }
  .ant-col-md-push-1.ant-col-rtl {
    right: 4.16666667%;
    left: auto;
  }
  .ant-col-md-pull-1.ant-col-rtl {
    right: auto;
    left: 4.16666667%;
  }
  .ant-col-md-offset-1.ant-col-rtl {
    margin-right: 4.16666667%;
    margin-left: 0;
  }
  .ant-col-md-push-2.ant-col-rtl {
    right: 8.33333333%;
    left: auto;
  }
  .ant-col-md-pull-2.ant-col-rtl {
    right: auto;
    left: 8.33333333%;
  }
  .ant-col-md-offset-2.ant-col-rtl {
    margin-right: 8.33333333%;
    margin-left: 0;
  }
  .ant-col-md-push-3.ant-col-rtl {
    right: 12.5%;
    left: auto;
  }
  .ant-col-md-pull-3.ant-col-rtl {
    right: auto;
    left: 12.5%;
  }
  .ant-col-md-offset-3.ant-col-rtl {
    margin-right: 12.5%;
    margin-left: 0;
  }
  .ant-col-md-push-4.ant-col-rtl {
    right: 16.66666667%;
    left: auto;
  }
  .ant-col-md-pull-4.ant-col-rtl {
    right: auto;
    left: 16.66666667%;
  }
  .ant-col-md-offset-4.ant-col-rtl {
    margin-right: 16.66666667%;
    margin-left: 0;
  }
  .ant-col-md-push-5.ant-col-rtl {
    right: 20.83333333%;
    left: auto;
  }
  .ant-col-md-pull-5.ant-col-rtl {
    right: auto;
    left: 20.83333333%;
  }
  .ant-col-md-offset-5.ant-col-rtl {
    margin-right: 20.83333333%;
    margin-left: 0;
  }
  .ant-col-md-push-6.ant-col-rtl {
    right: 25%;
    left: auto;
  }
  .ant-col-md-pull-6.ant-col-rtl {
    right: auto;
    left: 25%;
  }
  .ant-col-md-offset-6.ant-col-rtl {
    margin-right: 25%;
    margin-left: 0;
  }
  .ant-col-md-push-7.ant-col-rtl {
    right: 29.16666667%;
    left: auto;
  }
  .ant-col-md-pull-7.ant-col-rtl {
    right: auto;
    left: 29.16666667%;
  }
  .ant-col-md-offset-7.ant-col-rtl {
    margin-right: 29.16666667%;
    margin-left: 0;
  }
  .ant-col-md-push-8.ant-col-rtl {
    right: 33.33333333%;
    left: auto;
  }
  .ant-col-md-pull-8.ant-col-rtl {
    right: auto;
    left: 33.33333333%;
  }
  .ant-col-md-offset-8.ant-col-rtl {
    margin-right: 33.33333333%;
    margin-left: 0;
  }
  .ant-col-md-push-9.ant-col-rtl {
    right: 37.5%;
    left: auto;
  }
  .ant-col-md-pull-9.ant-col-rtl {
    right: auto;
    left: 37.5%;
  }
  .ant-col-md-offset-9.ant-col-rtl {
    margin-right: 37.5%;
    margin-left: 0;
  }
  .ant-col-md-push-10.ant-col-rtl {
    right: 41.66666667%;
    left: auto;
  }
  .ant-col-md-pull-10.ant-col-rtl {
    right: auto;
    left: 41.66666667%;
  }
  .ant-col-md-offset-10.ant-col-rtl {
    margin-right: 41.66666667%;
    margin-left: 0;
  }
  .ant-col-md-push-11.ant-col-rtl {
    right: 45.83333333%;
    left: auto;
  }
  .ant-col-md-pull-11.ant-col-rtl {
    right: auto;
    left: 45.83333333%;
  }
  .ant-col-md-offset-11.ant-col-rtl {
    margin-right: 45.83333333%;
    margin-left: 0;
  }
  .ant-col-md-push-12.ant-col-rtl {
    right: 50%;
    left: auto;
  }
  .ant-col-md-pull-12.ant-col-rtl {
    right: auto;
    left: 50%;
  }
  .ant-col-md-offset-12.ant-col-rtl {
    margin-right: 50%;
    margin-left: 0;
  }
  .ant-col-md-push-13.ant-col-rtl {
    right: 54.16666667%;
    left: auto;
  }
  .ant-col-md-pull-13.ant-col-rtl {
    right: auto;
    left: 54.16666667%;
  }
  .ant-col-md-offset-13.ant-col-rtl {
    margin-right: 54.16666667%;
    margin-left: 0;
  }
  .ant-col-md-push-14.ant-col-rtl {
    right: 58.33333333%;
    left: auto;
  }
  .ant-col-md-pull-14.ant-col-rtl {
    right: auto;
    left: 58.33333333%;
  }
  .ant-col-md-offset-14.ant-col-rtl {
    margin-right: 58.33333333%;
    margin-left: 0;
  }
  .ant-col-md-push-15.ant-col-rtl {
    right: 62.5%;
    left: auto;
  }
  .ant-col-md-pull-15.ant-col-rtl {
    right: auto;
    left: 62.5%;
  }
  .ant-col-md-offset-15.ant-col-rtl {
    margin-right: 62.5%;
    margin-left: 0;
  }
  .ant-col-md-push-16.ant-col-rtl {
    right: 66.66666667%;
    left: auto;
  }
  .ant-col-md-pull-16.ant-col-rtl {
    right: auto;
    left: 66.66666667%;
  }
  .ant-col-md-offset-16.ant-col-rtl {
    margin-right: 66.66666667%;
    margin-left: 0;
  }
  .ant-col-md-push-17.ant-col-rtl {
    right: 70.83333333%;
    left: auto;
  }
  .ant-col-md-pull-17.ant-col-rtl {
    right: auto;
    left: 70.83333333%;
  }
  .ant-col-md-offset-17.ant-col-rtl {
    margin-right: 70.83333333%;
    margin-left: 0;
  }
  .ant-col-md-push-18.ant-col-rtl {
    right: 75%;
    left: auto;
  }
  .ant-col-md-pull-18.ant-col-rtl {
    right: auto;
    left: 75%;
  }
  .ant-col-md-offset-18.ant-col-rtl {
    margin-right: 75%;
    margin-left: 0;
  }
  .ant-col-md-push-19.ant-col-rtl {
    right: 79.16666667%;
    left: auto;
  }
  .ant-col-md-pull-19.ant-col-rtl {
    right: auto;
    left: 79.16666667%;
  }
  .ant-col-md-offset-19.ant-col-rtl {
    margin-right: 79.16666667%;
    margin-left: 0;
  }
  .ant-col-md-push-20.ant-col-rtl {
    right: 83.33333333%;
    left: auto;
  }
  .ant-col-md-pull-20.ant-col-rtl {
    right: auto;
    left: 83.33333333%;
  }
  .ant-col-md-offset-20.ant-col-rtl {
    margin-right: 83.33333333%;
    margin-left: 0;
  }
  .ant-col-md-push-21.ant-col-rtl {
    right: 87.5%;
    left: auto;
  }
  .ant-col-md-pull-21.ant-col-rtl {
    right: auto;
    left: 87.5%;
  }
  .ant-col-md-offset-21.ant-col-rtl {
    margin-right: 87.5%;
    margin-left: 0;
  }
  .ant-col-md-push-22.ant-col-rtl {
    right: 91.66666667%;
    left: auto;
  }
  .ant-col-md-pull-22.ant-col-rtl {
    right: auto;
    left: 91.66666667%;
  }
  .ant-col-md-offset-22.ant-col-rtl {
    margin-right: 91.66666667%;
    margin-left: 0;
  }
  .ant-col-md-push-23.ant-col-rtl {
    right: 95.83333333%;
    left: auto;
  }
  .ant-col-md-pull-23.ant-col-rtl {
    right: auto;
    left: 95.83333333%;
  }
  .ant-col-md-offset-23.ant-col-rtl {
    margin-right: 95.83333333%;
    margin-left: 0;
  }
  .ant-col-md-push-24.ant-col-rtl {
    right: 100%;
    left: auto;
  }
  .ant-col-md-pull-24.ant-col-rtl {
    right: auto;
    left: 100%;
  }
  .ant-col-md-offset-24.ant-col-rtl {
    margin-right: 100%;
    margin-left: 0;
  }
}
@media (min-width: 992px) {
  .ant-col-lg-24 {
    display: block;
    flex: 0 0 100%;
    max-width: 100%;
  }
  .ant-col-lg-push-24 {
    left: 100%;
  }
  .ant-col-lg-pull-24 {
    right: 100%;
  }
  .ant-col-lg-offset-24 {
    margin-left: 100%;
  }
  .ant-col-lg-order-24 {
    order: 24;
  }
  .ant-col-lg-23 {
    display: block;
    flex: 0 0 95.83333333%;
    max-width: 95.83333333%;
  }
  .ant-col-lg-push-23 {
    left: 95.83333333%;
  }
  .ant-col-lg-pull-23 {
    right: 95.83333333%;
  }
  .ant-col-lg-offset-23 {
    margin-left: 95.83333333%;
  }
  .ant-col-lg-order-23 {
    order: 23;
  }
  .ant-col-lg-22 {
    display: block;
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .ant-col-lg-push-22 {
    left: 91.66666667%;
  }
  .ant-col-lg-pull-22 {
    right: 91.66666667%;
  }
  .ant-col-lg-offset-22 {
    margin-left: 91.66666667%;
  }
  .ant-col-lg-order-22 {
    order: 22;
  }
  .ant-col-lg-21 {
    display: block;
    flex: 0 0 87.5%;
    max-width: 87.5%;
  }
  .ant-col-lg-push-21 {
    left: 87.5%;
  }
  .ant-col-lg-pull-21 {
    right: 87.5%;
  }
  .ant-col-lg-offset-21 {
    margin-left: 87.5%;
  }
  .ant-col-lg-order-21 {
    order: 21;
  }
  .ant-col-lg-20 {
    display: block;
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .ant-col-lg-push-20 {
    left: 83.33333333%;
  }
  .ant-col-lg-pull-20 {
    right: 83.33333333%;
  }
  .ant-col-lg-offset-20 {
    margin-left: 83.33333333%;
  }
  .ant-col-lg-order-20 {
    order: 20;
  }
  .ant-col-lg-19 {
    display: block;
    flex: 0 0 79.16666667%;
    max-width: 79.16666667%;
  }
  .ant-col-lg-push-19 {
    left: 79.16666667%;
  }
  .ant-col-lg-pull-19 {
    right: 79.16666667%;
  }
  .ant-col-lg-offset-19 {
    margin-left: 79.16666667%;
  }
  .ant-col-lg-order-19 {
    order: 19;
  }
  .ant-col-lg-18 {
    display: block;
    flex: 0 0 75%;
    max-width: 75%;
  }
  .ant-col-lg-push-18 {
    left: 75%;
  }
  .ant-col-lg-pull-18 {
    right: 75%;
  }
  .ant-col-lg-offset-18 {
    margin-left: 75%;
  }
  .ant-col-lg-order-18 {
    order: 18;
  }
  .ant-col-lg-17 {
    display: block;
    flex: 0 0 70.83333333%;
    max-width: 70.83333333%;
  }
  .ant-col-lg-push-17 {
    left: 70.83333333%;
  }
  .ant-col-lg-pull-17 {
    right: 70.83333333%;
  }
  .ant-col-lg-offset-17 {
    margin-left: 70.83333333%;
  }
  .ant-col-lg-order-17 {
    order: 17;
  }
  .ant-col-lg-16 {
    display: block;
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .ant-col-lg-push-16 {
    left: 66.66666667%;
  }
  .ant-col-lg-pull-16 {
    right: 66.66666667%;
  }
  .ant-col-lg-offset-16 {
    margin-left: 66.66666667%;
  }
  .ant-col-lg-order-16 {
    order: 16;
  }
  .ant-col-lg-15 {
    display: block;
    flex: 0 0 62.5%;
    max-width: 62.5%;
  }
  .ant-col-lg-push-15 {
    left: 62.5%;
  }
  .ant-col-lg-pull-15 {
    right: 62.5%;
  }
  .ant-col-lg-offset-15 {
    margin-left: 62.5%;
  }
  .ant-col-lg-order-15 {
    order: 15;
  }
  .ant-col-lg-14 {
    display: block;
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .ant-col-lg-push-14 {
    left: 58.33333333%;
  }
  .ant-col-lg-pull-14 {
    right: 58.33333333%;
  }
  .ant-col-lg-offset-14 {
    margin-left: 58.33333333%;
  }
  .ant-col-lg-order-14 {
    order: 14;
  }
  .ant-col-lg-13 {
    display: block;
    flex: 0 0 54.16666667%;
    max-width: 54.16666667%;
  }
  .ant-col-lg-push-13 {
    left: 54.16666667%;
  }
  .ant-col-lg-pull-13 {
    right: 54.16666667%;
  }
  .ant-col-lg-offset-13 {
    margin-left: 54.16666667%;
  }
  .ant-col-lg-order-13 {
    order: 13;
  }
  .ant-col-lg-12 {
    display: block;
    flex: 0 0 50%;
    max-width: 50%;
  }
  .ant-col-lg-push-12 {
    left: 50%;
  }
  .ant-col-lg-pull-12 {
    right: 50%;
  }
  .ant-col-lg-offset-12 {
    margin-left: 50%;
  }
  .ant-col-lg-order-12 {
    order: 12;
  }
  .ant-col-lg-11 {
    display: block;
    flex: 0 0 45.83333333%;
    max-width: 45.83333333%;
  }
  .ant-col-lg-push-11 {
    left: 45.83333333%;
  }
  .ant-col-lg-pull-11 {
    right: 45.83333333%;
  }
  .ant-col-lg-offset-11 {
    margin-left: 45.83333333%;
  }
  .ant-col-lg-order-11 {
    order: 11;
  }
  .ant-col-lg-10 {
    display: block;
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .ant-col-lg-push-10 {
    left: 41.66666667%;
  }
  .ant-col-lg-pull-10 {
    right: 41.66666667%;
  }
  .ant-col-lg-offset-10 {
    margin-left: 41.66666667%;
  }
  .ant-col-lg-order-10 {
    order: 10;
  }
  .ant-col-lg-9 {
    display: block;
    flex: 0 0 37.5%;
    max-width: 37.5%;
  }
  .ant-col-lg-push-9 {
    left: 37.5%;
  }
  .ant-col-lg-pull-9 {
    right: 37.5%;
  }
  .ant-col-lg-offset-9 {
    margin-left: 37.5%;
  }
  .ant-col-lg-order-9 {
    order: 9;
  }
  .ant-col-lg-8 {
    display: block;
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .ant-col-lg-push-8 {
    left: 33.33333333%;
  }
  .ant-col-lg-pull-8 {
    right: 33.33333333%;
  }
  .ant-col-lg-offset-8 {
    margin-left: 33.33333333%;
  }
  .ant-col-lg-order-8 {
    order: 8;
  }
  .ant-col-lg-7 {
    display: block;
    flex: 0 0 29.16666667%;
    max-width: 29.16666667%;
  }
  .ant-col-lg-push-7 {
    left: 29.16666667%;
  }
  .ant-col-lg-pull-7 {
    right: 29.16666667%;
  }
  .ant-col-lg-offset-7 {
    margin-left: 29.16666667%;
  }
  .ant-col-lg-order-7 {
    order: 7;
  }
  .ant-col-lg-6 {
    display: block;
    flex: 0 0 25%;
    max-width: 25%;
  }
  .ant-col-lg-push-6 {
    left: 25%;
  }
  .ant-col-lg-pull-6 {
    right: 25%;
  }
  .ant-col-lg-offset-6 {
    margin-left: 25%;
  }
  .ant-col-lg-order-6 {
    order: 6;
  }
  .ant-col-lg-5 {
    display: block;
    flex: 0 0 20.83333333%;
    max-width: 20.83333333%;
  }
  .ant-col-lg-push-5 {
    left: 20.83333333%;
  }
  .ant-col-lg-pull-5 {
    right: 20.83333333%;
  }
  .ant-col-lg-offset-5 {
    margin-left: 20.83333333%;
  }
  .ant-col-lg-order-5 {
    order: 5;
  }
  .ant-col-lg-4 {
    display: block;
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .ant-col-lg-push-4 {
    left: 16.66666667%;
  }
  .ant-col-lg-pull-4 {
    right: 16.66666667%;
  }
  .ant-col-lg-offset-4 {
    margin-left: 16.66666667%;
  }
  .ant-col-lg-order-4 {
    order: 4;
  }
  .ant-col-lg-3 {
    display: block;
    flex: 0 0 12.5%;
    max-width: 12.5%;
  }
  .ant-col-lg-push-3 {
    left: 12.5%;
  }
  .ant-col-lg-pull-3 {
    right: 12.5%;
  }
  .ant-col-lg-offset-3 {
    margin-left: 12.5%;
  }
  .ant-col-lg-order-3 {
    order: 3;
  }
  .ant-col-lg-2 {
    display: block;
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .ant-col-lg-push-2 {
    left: 8.33333333%;
  }
  .ant-col-lg-pull-2 {
    right: 8.33333333%;
  }
  .ant-col-lg-offset-2 {
    margin-left: 8.33333333%;
  }
  .ant-col-lg-order-2 {
    order: 2;
  }
  .ant-col-lg-1 {
    display: block;
    flex: 0 0 4.16666667%;
    max-width: 4.16666667%;
  }
  .ant-col-lg-push-1 {
    left: 4.16666667%;
  }
  .ant-col-lg-pull-1 {
    right: 4.16666667%;
  }
  .ant-col-lg-offset-1 {
    margin-left: 4.16666667%;
  }
  .ant-col-lg-order-1 {
    order: 1;
  }
  .ant-col-lg-0 {
    display: none;
  }
  .ant-col-push-0 {
    left: auto;
  }
  .ant-col-pull-0 {
    right: auto;
  }
  .ant-col-lg-push-0 {
    left: auto;
  }
  .ant-col-lg-pull-0 {
    right: auto;
  }
  .ant-col-lg-offset-0 {
    margin-left: 0;
  }
  .ant-col-lg-order-0 {
    order: 0;
  }
  .ant-col-push-0.ant-col-rtl {
    right: auto;
  }
  .ant-col-pull-0.ant-col-rtl {
    left: auto;
  }
  .ant-col-lg-push-0.ant-col-rtl {
    right: auto;
  }
  .ant-col-lg-pull-0.ant-col-rtl {
    left: auto;
  }
  .ant-col-lg-offset-0.ant-col-rtl {
    margin-right: 0;
  }
  .ant-col-lg-push-1.ant-col-rtl {
    right: 4.16666667%;
    left: auto;
  }
  .ant-col-lg-pull-1.ant-col-rtl {
    right: auto;
    left: 4.16666667%;
  }
  .ant-col-lg-offset-1.ant-col-rtl {
    margin-right: 4.16666667%;
    margin-left: 0;
  }
  .ant-col-lg-push-2.ant-col-rtl {
    right: 8.33333333%;
    left: auto;
  }
  .ant-col-lg-pull-2.ant-col-rtl {
    right: auto;
    left: 8.33333333%;
  }
  .ant-col-lg-offset-2.ant-col-rtl {
    margin-right: 8.33333333%;
    margin-left: 0;
  }
  .ant-col-lg-push-3.ant-col-rtl {
    right: 12.5%;
    left: auto;
  }
  .ant-col-lg-pull-3.ant-col-rtl {
    right: auto;
    left: 12.5%;
  }
  .ant-col-lg-offset-3.ant-col-rtl {
    margin-right: 12.5%;
    margin-left: 0;
  }
  .ant-col-lg-push-4.ant-col-rtl {
    right: 16.66666667%;
    left: auto;
  }
  .ant-col-lg-pull-4.ant-col-rtl {
    right: auto;
    left: 16.66666667%;
  }
  .ant-col-lg-offset-4.ant-col-rtl {
    margin-right: 16.66666667%;
    margin-left: 0;
  }
  .ant-col-lg-push-5.ant-col-rtl {
    right: 20.83333333%;
    left: auto;
  }
  .ant-col-lg-pull-5.ant-col-rtl {
    right: auto;
    left: 20.83333333%;
  }
  .ant-col-lg-offset-5.ant-col-rtl {
    margin-right: 20.83333333%;
    margin-left: 0;
  }
  .ant-col-lg-push-6.ant-col-rtl {
    right: 25%;
    left: auto;
  }
  .ant-col-lg-pull-6.ant-col-rtl {
    right: auto;
    left: 25%;
  }
  .ant-col-lg-offset-6.ant-col-rtl {
    margin-right: 25%;
    margin-left: 0;
  }
  .ant-col-lg-push-7.ant-col-rtl {
    right: 29.16666667%;
    left: auto;
  }
  .ant-col-lg-pull-7.ant-col-rtl {
    right: auto;
    left: 29.16666667%;
  }
  .ant-col-lg-offset-7.ant-col-rtl {
    margin-right: 29.16666667%;
    margin-left: 0;
  }
  .ant-col-lg-push-8.ant-col-rtl {
    right: 33.33333333%;
    left: auto;
  }
  .ant-col-lg-pull-8.ant-col-rtl {
    right: auto;
    left: 33.33333333%;
  }
  .ant-col-lg-offset-8.ant-col-rtl {
    margin-right: 33.33333333%;
    margin-left: 0;
  }
  .ant-col-lg-push-9.ant-col-rtl {
    right: 37.5%;
    left: auto;
  }
  .ant-col-lg-pull-9.ant-col-rtl {
    right: auto;
    left: 37.5%;
  }
  .ant-col-lg-offset-9.ant-col-rtl {
    margin-right: 37.5%;
    margin-left: 0;
  }
  .ant-col-lg-push-10.ant-col-rtl {
    right: 41.66666667%;
    left: auto;
  }
  .ant-col-lg-pull-10.ant-col-rtl {
    right: auto;
    left: 41.66666667%;
  }
  .ant-col-lg-offset-10.ant-col-rtl {
    margin-right: 41.66666667%;
    margin-left: 0;
  }
  .ant-col-lg-push-11.ant-col-rtl {
    right: 45.83333333%;
    left: auto;
  }
  .ant-col-lg-pull-11.ant-col-rtl {
    right: auto;
    left: 45.83333333%;
  }
  .ant-col-lg-offset-11.ant-col-rtl {
    margin-right: 45.83333333%;
    margin-left: 0;
  }
  .ant-col-lg-push-12.ant-col-rtl {
    right: 50%;
    left: auto;
  }
  .ant-col-lg-pull-12.ant-col-rtl {
    right: auto;
    left: 50%;
  }
  .ant-col-lg-offset-12.ant-col-rtl {
    margin-right: 50%;
    margin-left: 0;
  }
  .ant-col-lg-push-13.ant-col-rtl {
    right: 54.16666667%;
    left: auto;
  }
  .ant-col-lg-pull-13.ant-col-rtl {
    right: auto;
    left: 54.16666667%;
  }
  .ant-col-lg-offset-13.ant-col-rtl {
    margin-right: 54.16666667%;
    margin-left: 0;
  }
  .ant-col-lg-push-14.ant-col-rtl {
    right: 58.33333333%;
    left: auto;
  }
  .ant-col-lg-pull-14.ant-col-rtl {
    right: auto;
    left: 58.33333333%;
  }
  .ant-col-lg-offset-14.ant-col-rtl {
    margin-right: 58.33333333%;
    margin-left: 0;
  }
  .ant-col-lg-push-15.ant-col-rtl {
    right: 62.5%;
    left: auto;
  }
  .ant-col-lg-pull-15.ant-col-rtl {
    right: auto;
    left: 62.5%;
  }
  .ant-col-lg-offset-15.ant-col-rtl {
    margin-right: 62.5%;
    margin-left: 0;
  }
  .ant-col-lg-push-16.ant-col-rtl {
    right: 66.66666667%;
    left: auto;
  }
  .ant-col-lg-pull-16.ant-col-rtl {
    right: auto;
    left: 66.66666667%;
  }
  .ant-col-lg-offset-16.ant-col-rtl {
    margin-right: 66.66666667%;
    margin-left: 0;
  }
  .ant-col-lg-push-17.ant-col-rtl {
    right: 70.83333333%;
    left: auto;
  }
  .ant-col-lg-pull-17.ant-col-rtl {
    right: auto;
    left: 70.83333333%;
  }
  .ant-col-lg-offset-17.ant-col-rtl {
    margin-right: 70.83333333%;
    margin-left: 0;
  }
  .ant-col-lg-push-18.ant-col-rtl {
    right: 75%;
    left: auto;
  }
  .ant-col-lg-pull-18.ant-col-rtl {
    right: auto;
    left: 75%;
  }
  .ant-col-lg-offset-18.ant-col-rtl {
    margin-right: 75%;
    margin-left: 0;
  }
  .ant-col-lg-push-19.ant-col-rtl {
    right: 79.16666667%;
    left: auto;
  }
  .ant-col-lg-pull-19.ant-col-rtl {
    right: auto;
    left: 79.16666667%;
  }
  .ant-col-lg-offset-19.ant-col-rtl {
    margin-right: 79.16666667%;
    margin-left: 0;
  }
  .ant-col-lg-push-20.ant-col-rtl {
    right: 83.33333333%;
    left: auto;
  }
  .ant-col-lg-pull-20.ant-col-rtl {
    right: auto;
    left: 83.33333333%;
  }
  .ant-col-lg-offset-20.ant-col-rtl {
    margin-right: 83.33333333%;
    margin-left: 0;
  }
  .ant-col-lg-push-21.ant-col-rtl {
    right: 87.5%;
    left: auto;
  }
  .ant-col-lg-pull-21.ant-col-rtl {
    right: auto;
    left: 87.5%;
  }
  .ant-col-lg-offset-21.ant-col-rtl {
    margin-right: 87.5%;
    margin-left: 0;
  }
  .ant-col-lg-push-22.ant-col-rtl {
    right: 91.66666667%;
    left: auto;
  }
  .ant-col-lg-pull-22.ant-col-rtl {
    right: auto;
    left: 91.66666667%;
  }
  .ant-col-lg-offset-22.ant-col-rtl {
    margin-right: 91.66666667%;
    margin-left: 0;
  }
  .ant-col-lg-push-23.ant-col-rtl {
    right: 95.83333333%;
    left: auto;
  }
  .ant-col-lg-pull-23.ant-col-rtl {
    right: auto;
    left: 95.83333333%;
  }
  .ant-col-lg-offset-23.ant-col-rtl {
    margin-right: 95.83333333%;
    margin-left: 0;
  }
  .ant-col-lg-push-24.ant-col-rtl {
    right: 100%;
    left: auto;
  }
  .ant-col-lg-pull-24.ant-col-rtl {
    right: auto;
    left: 100%;
  }
  .ant-col-lg-offset-24.ant-col-rtl {
    margin-right: 100%;
    margin-left: 0;
  }
}
@media (min-width: 1200px) {
  .ant-col-xl-24 {
    display: block;
    flex: 0 0 100%;
    max-width: 100%;
  }
  .ant-col-xl-push-24 {
    left: 100%;
  }
  .ant-col-xl-pull-24 {
    right: 100%;
  }
  .ant-col-xl-offset-24 {
    margin-left: 100%;
  }
  .ant-col-xl-order-24 {
    order: 24;
  }
  .ant-col-xl-23 {
    display: block;
    flex: 0 0 95.83333333%;
    max-width: 95.83333333%;
  }
  .ant-col-xl-push-23 {
    left: 95.83333333%;
  }
  .ant-col-xl-pull-23 {
    right: 95.83333333%;
  }
  .ant-col-xl-offset-23 {
    margin-left: 95.83333333%;
  }
  .ant-col-xl-order-23 {
    order: 23;
  }
  .ant-col-xl-22 {
    display: block;
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .ant-col-xl-push-22 {
    left: 91.66666667%;
  }
  .ant-col-xl-pull-22 {
    right: 91.66666667%;
  }
  .ant-col-xl-offset-22 {
    margin-left: 91.66666667%;
  }
  .ant-col-xl-order-22 {
    order: 22;
  }
  .ant-col-xl-21 {
    display: block;
    flex: 0 0 87.5%;
    max-width: 87.5%;
  }
  .ant-col-xl-push-21 {
    left: 87.5%;
  }
  .ant-col-xl-pull-21 {
    right: 87.5%;
  }
  .ant-col-xl-offset-21 {
    margin-left: 87.5%;
  }
  .ant-col-xl-order-21 {
    order: 21;
  }
  .ant-col-xl-20 {
    display: block;
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .ant-col-xl-push-20 {
    left: 83.33333333%;
  }
  .ant-col-xl-pull-20 {
    right: 83.33333333%;
  }
  .ant-col-xl-offset-20 {
    margin-left: 83.33333333%;
  }
  .ant-col-xl-order-20 {
    order: 20;
  }
  .ant-col-xl-19 {
    display: block;
    flex: 0 0 79.16666667%;
    max-width: 79.16666667%;
  }
  .ant-col-xl-push-19 {
    left: 79.16666667%;
  }
  .ant-col-xl-pull-19 {
    right: 79.16666667%;
  }
  .ant-col-xl-offset-19 {
    margin-left: 79.16666667%;
  }
  .ant-col-xl-order-19 {
    order: 19;
  }
  .ant-col-xl-18 {
    display: block;
    flex: 0 0 75%;
    max-width: 75%;
  }
  .ant-col-xl-push-18 {
    left: 75%;
  }
  .ant-col-xl-pull-18 {
    right: 75%;
  }
  .ant-col-xl-offset-18 {
    margin-left: 75%;
  }
  .ant-col-xl-order-18 {
    order: 18;
  }
  .ant-col-xl-17 {
    display: block;
    flex: 0 0 70.83333333%;
    max-width: 70.83333333%;
  }
  .ant-col-xl-push-17 {
    left: 70.83333333%;
  }
  .ant-col-xl-pull-17 {
    right: 70.83333333%;
  }
  .ant-col-xl-offset-17 {
    margin-left: 70.83333333%;
  }
  .ant-col-xl-order-17 {
    order: 17;
  }
  .ant-col-xl-16 {
    display: block;
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .ant-col-xl-push-16 {
    left: 66.66666667%;
  }
  .ant-col-xl-pull-16 {
    right: 66.66666667%;
  }
  .ant-col-xl-offset-16 {
    margin-left: 66.66666667%;
  }
  .ant-col-xl-order-16 {
    order: 16;
  }
  .ant-col-xl-15 {
    display: block;
    flex: 0 0 62.5%;
    max-width: 62.5%;
  }
  .ant-col-xl-push-15 {
    left: 62.5%;
  }
  .ant-col-xl-pull-15 {
    right: 62.5%;
  }
  .ant-col-xl-offset-15 {
    margin-left: 62.5%;
  }
  .ant-col-xl-order-15 {
    order: 15;
  }
  .ant-col-xl-14 {
    display: block;
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .ant-col-xl-push-14 {
    left: 58.33333333%;
  }
  .ant-col-xl-pull-14 {
    right: 58.33333333%;
  }
  .ant-col-xl-offset-14 {
    margin-left: 58.33333333%;
  }
  .ant-col-xl-order-14 {
    order: 14;
  }
  .ant-col-xl-13 {
    display: block;
    flex: 0 0 54.16666667%;
    max-width: 54.16666667%;
  }
  .ant-col-xl-push-13 {
    left: 54.16666667%;
  }
  .ant-col-xl-pull-13 {
    right: 54.16666667%;
  }
  .ant-col-xl-offset-13 {
    margin-left: 54.16666667%;
  }
  .ant-col-xl-order-13 {
    order: 13;
  }
  .ant-col-xl-12 {
    display: block;
    flex: 0 0 50%;
    max-width: 50%;
  }
  .ant-col-xl-push-12 {
    left: 50%;
  }
  .ant-col-xl-pull-12 {
    right: 50%;
  }
  .ant-col-xl-offset-12 {
    margin-left: 50%;
  }
  .ant-col-xl-order-12 {
    order: 12;
  }
  .ant-col-xl-11 {
    display: block;
    flex: 0 0 45.83333333%;
    max-width: 45.83333333%;
  }
  .ant-col-xl-push-11 {
    left: 45.83333333%;
  }
  .ant-col-xl-pull-11 {
    right: 45.83333333%;
  }
  .ant-col-xl-offset-11 {
    margin-left: 45.83333333%;
  }
  .ant-col-xl-order-11 {
    order: 11;
  }
  .ant-col-xl-10 {
    display: block;
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .ant-col-xl-push-10 {
    left: 41.66666667%;
  }
  .ant-col-xl-pull-10 {
    right: 41.66666667%;
  }
  .ant-col-xl-offset-10 {
    margin-left: 41.66666667%;
  }
  .ant-col-xl-order-10 {
    order: 10;
  }
  .ant-col-xl-9 {
    display: block;
    flex: 0 0 37.5%;
    max-width: 37.5%;
  }
  .ant-col-xl-push-9 {
    left: 37.5%;
  }
  .ant-col-xl-pull-9 {
    right: 37.5%;
  }
  .ant-col-xl-offset-9 {
    margin-left: 37.5%;
  }
  .ant-col-xl-order-9 {
    order: 9;
  }
  .ant-col-xl-8 {
    display: block;
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .ant-col-xl-push-8 {
    left: 33.33333333%;
  }
  .ant-col-xl-pull-8 {
    right: 33.33333333%;
  }
  .ant-col-xl-offset-8 {
    margin-left: 33.33333333%;
  }
  .ant-col-xl-order-8 {
    order: 8;
  }
  .ant-col-xl-7 {
    display: block;
    flex: 0 0 29.16666667%;
    max-width: 29.16666667%;
  }
  .ant-col-xl-push-7 {
    left: 29.16666667%;
  }
  .ant-col-xl-pull-7 {
    right: 29.16666667%;
  }
  .ant-col-xl-offset-7 {
    margin-left: 29.16666667%;
  }
  .ant-col-xl-order-7 {
    order: 7;
  }
  .ant-col-xl-6 {
    display: block;
    flex: 0 0 25%;
    max-width: 25%;
  }
  .ant-col-xl-push-6 {
    left: 25%;
  }
  .ant-col-xl-pull-6 {
    right: 25%;
  }
  .ant-col-xl-offset-6 {
    margin-left: 25%;
  }
  .ant-col-xl-order-6 {
    order: 6;
  }
  .ant-col-xl-5 {
    display: block;
    flex: 0 0 20.83333333%;
    max-width: 20.83333333%;
  }
  .ant-col-xl-push-5 {
    left: 20.83333333%;
  }
  .ant-col-xl-pull-5 {
    right: 20.83333333%;
  }
  .ant-col-xl-offset-5 {
    margin-left: 20.83333333%;
  }
  .ant-col-xl-order-5 {
    order: 5;
  }
  .ant-col-xl-4 {
    display: block;
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .ant-col-xl-push-4 {
    left: 16.66666667%;
  }
  .ant-col-xl-pull-4 {
    right: 16.66666667%;
  }
  .ant-col-xl-offset-4 {
    margin-left: 16.66666667%;
  }
  .ant-col-xl-order-4 {
    order: 4;
  }
  .ant-col-xl-3 {
    display: block;
    flex: 0 0 12.5%;
    max-width: 12.5%;
  }
  .ant-col-xl-push-3 {
    left: 12.5%;
  }
  .ant-col-xl-pull-3 {
    right: 12.5%;
  }
  .ant-col-xl-offset-3 {
    margin-left: 12.5%;
  }
  .ant-col-xl-order-3 {
    order: 3;
  }
  .ant-col-xl-2 {
    display: block;
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .ant-col-xl-push-2 {
    left: 8.33333333%;
  }
  .ant-col-xl-pull-2 {
    right: 8.33333333%;
  }
  .ant-col-xl-offset-2 {
    margin-left: 8.33333333%;
  }
  .ant-col-xl-order-2 {
    order: 2;
  }
  .ant-col-xl-1 {
    display: block;
    flex: 0 0 4.16666667%;
    max-width: 4.16666667%;
  }
  .ant-col-xl-push-1 {
    left: 4.16666667%;
  }
  .ant-col-xl-pull-1 {
    right: 4.16666667%;
  }
  .ant-col-xl-offset-1 {
    margin-left: 4.16666667%;
  }
  .ant-col-xl-order-1 {
    order: 1;
  }
  .ant-col-xl-0 {
    display: none;
  }
  .ant-col-push-0 {
    left: auto;
  }
  .ant-col-pull-0 {
    right: auto;
  }
  .ant-col-xl-push-0 {
    left: auto;
  }
  .ant-col-xl-pull-0 {
    right: auto;
  }
  .ant-col-xl-offset-0 {
    margin-left: 0;
  }
  .ant-col-xl-order-0 {
    order: 0;
  }
  .ant-col-push-0.ant-col-rtl {
    right: auto;
  }
  .ant-col-pull-0.ant-col-rtl {
    left: auto;
  }
  .ant-col-xl-push-0.ant-col-rtl {
    right: auto;
  }
  .ant-col-xl-pull-0.ant-col-rtl {
    left: auto;
  }
  .ant-col-xl-offset-0.ant-col-rtl {
    margin-right: 0;
  }
  .ant-col-xl-push-1.ant-col-rtl {
    right: 4.16666667%;
    left: auto;
  }
  .ant-col-xl-pull-1.ant-col-rtl {
    right: auto;
    left: 4.16666667%;
  }
  .ant-col-xl-offset-1.ant-col-rtl {
    margin-right: 4.16666667%;
    margin-left: 0;
  }
  .ant-col-xl-push-2.ant-col-rtl {
    right: 8.33333333%;
    left: auto;
  }
  .ant-col-xl-pull-2.ant-col-rtl {
    right: auto;
    left: 8.33333333%;
  }
  .ant-col-xl-offset-2.ant-col-rtl {
    margin-right: 8.33333333%;
    margin-left: 0;
  }
  .ant-col-xl-push-3.ant-col-rtl {
    right: 12.5%;
    left: auto;
  }
  .ant-col-xl-pull-3.ant-col-rtl {
    right: auto;
    left: 12.5%;
  }
  .ant-col-xl-offset-3.ant-col-rtl {
    margin-right: 12.5%;
    margin-left: 0;
  }
  .ant-col-xl-push-4.ant-col-rtl {
    right: 16.66666667%;
    left: auto;
  }
  .ant-col-xl-pull-4.ant-col-rtl {
    right: auto;
    left: 16.66666667%;
  }
  .ant-col-xl-offset-4.ant-col-rtl {
    margin-right: 16.66666667%;
    margin-left: 0;
  }
  .ant-col-xl-push-5.ant-col-rtl {
    right: 20.83333333%;
    left: auto;
  }
  .ant-col-xl-pull-5.ant-col-rtl {
    right: auto;
    left: 20.83333333%;
  }
  .ant-col-xl-offset-5.ant-col-rtl {
    margin-right: 20.83333333%;
    margin-left: 0;
  }
  .ant-col-xl-push-6.ant-col-rtl {
    right: 25%;
    left: auto;
  }
  .ant-col-xl-pull-6.ant-col-rtl {
    right: auto;
    left: 25%;
  }
  .ant-col-xl-offset-6.ant-col-rtl {
    margin-right: 25%;
    margin-left: 0;
  }
  .ant-col-xl-push-7.ant-col-rtl {
    right: 29.16666667%;
    left: auto;
  }
  .ant-col-xl-pull-7.ant-col-rtl {
    right: auto;
    left: 29.16666667%;
  }
  .ant-col-xl-offset-7.ant-col-rtl {
    margin-right: 29.16666667%;
    margin-left: 0;
  }
  .ant-col-xl-push-8.ant-col-rtl {
    right: 33.33333333%;
    left: auto;
  }
  .ant-col-xl-pull-8.ant-col-rtl {
    right: auto;
    left: 33.33333333%;
  }
  .ant-col-xl-offset-8.ant-col-rtl {
    margin-right: 33.33333333%;
    margin-left: 0;
  }
  .ant-col-xl-push-9.ant-col-rtl {
    right: 37.5%;
    left: auto;
  }
  .ant-col-xl-pull-9.ant-col-rtl {
    right: auto;
    left: 37.5%;
  }
  .ant-col-xl-offset-9.ant-col-rtl {
    margin-right: 37.5%;
    margin-left: 0;
  }
  .ant-col-xl-push-10.ant-col-rtl {
    right: 41.66666667%;
    left: auto;
  }
  .ant-col-xl-pull-10.ant-col-rtl {
    right: auto;
    left: 41.66666667%;
  }
  .ant-col-xl-offset-10.ant-col-rtl {
    margin-right: 41.66666667%;
    margin-left: 0;
  }
  .ant-col-xl-push-11.ant-col-rtl {
    right: 45.83333333%;
    left: auto;
  }
  .ant-col-xl-pull-11.ant-col-rtl {
    right: auto;
    left: 45.83333333%;
  }
  .ant-col-xl-offset-11.ant-col-rtl {
    margin-right: 45.83333333%;
    margin-left: 0;
  }
  .ant-col-xl-push-12.ant-col-rtl {
    right: 50%;
    left: auto;
  }
  .ant-col-xl-pull-12.ant-col-rtl {
    right: auto;
    left: 50%;
  }
  .ant-col-xl-offset-12.ant-col-rtl {
    margin-right: 50%;
    margin-left: 0;
  }
  .ant-col-xl-push-13.ant-col-rtl {
    right: 54.16666667%;
    left: auto;
  }
  .ant-col-xl-pull-13.ant-col-rtl {
    right: auto;
    left: 54.16666667%;
  }
  .ant-col-xl-offset-13.ant-col-rtl {
    margin-right: 54.16666667%;
    margin-left: 0;
  }
  .ant-col-xl-push-14.ant-col-rtl {
    right: 58.33333333%;
    left: auto;
  }
  .ant-col-xl-pull-14.ant-col-rtl {
    right: auto;
    left: 58.33333333%;
  }
  .ant-col-xl-offset-14.ant-col-rtl {
    margin-right: 58.33333333%;
    margin-left: 0;
  }
  .ant-col-xl-push-15.ant-col-rtl {
    right: 62.5%;
    left: auto;
  }
  .ant-col-xl-pull-15.ant-col-rtl {
    right: auto;
    left: 62.5%;
  }
  .ant-col-xl-offset-15.ant-col-rtl {
    margin-right: 62.5%;
    margin-left: 0;
  }
  .ant-col-xl-push-16.ant-col-rtl {
    right: 66.66666667%;
    left: auto;
  }
  .ant-col-xl-pull-16.ant-col-rtl {
    right: auto;
    left: 66.66666667%;
  }
  .ant-col-xl-offset-16.ant-col-rtl {
    margin-right: 66.66666667%;
    margin-left: 0;
  }
  .ant-col-xl-push-17.ant-col-rtl {
    right: 70.83333333%;
    left: auto;
  }
  .ant-col-xl-pull-17.ant-col-rtl {
    right: auto;
    left: 70.83333333%;
  }
  .ant-col-xl-offset-17.ant-col-rtl {
    margin-right: 70.83333333%;
    margin-left: 0;
  }
  .ant-col-xl-push-18.ant-col-rtl {
    right: 75%;
    left: auto;
  }
  .ant-col-xl-pull-18.ant-col-rtl {
    right: auto;
    left: 75%;
  }
  .ant-col-xl-offset-18.ant-col-rtl {
    margin-right: 75%;
    margin-left: 0;
  }
  .ant-col-xl-push-19.ant-col-rtl {
    right: 79.16666667%;
    left: auto;
  }
  .ant-col-xl-pull-19.ant-col-rtl {
    right: auto;
    left: 79.16666667%;
  }
  .ant-col-xl-offset-19.ant-col-rtl {
    margin-right: 79.16666667%;
    margin-left: 0;
  }
  .ant-col-xl-push-20.ant-col-rtl {
    right: 83.33333333%;
    left: auto;
  }
  .ant-col-xl-pull-20.ant-col-rtl {
    right: auto;
    left: 83.33333333%;
  }
  .ant-col-xl-offset-20.ant-col-rtl {
    margin-right: 83.33333333%;
    margin-left: 0;
  }
  .ant-col-xl-push-21.ant-col-rtl {
    right: 87.5%;
    left: auto;
  }
  .ant-col-xl-pull-21.ant-col-rtl {
    right: auto;
    left: 87.5%;
  }
  .ant-col-xl-offset-21.ant-col-rtl {
    margin-right: 87.5%;
    margin-left: 0;
  }
  .ant-col-xl-push-22.ant-col-rtl {
    right: 91.66666667%;
    left: auto;
  }
  .ant-col-xl-pull-22.ant-col-rtl {
    right: auto;
    left: 91.66666667%;
  }
  .ant-col-xl-offset-22.ant-col-rtl {
    margin-right: 91.66666667%;
    margin-left: 0;
  }
  .ant-col-xl-push-23.ant-col-rtl {
    right: 95.83333333%;
    left: auto;
  }
  .ant-col-xl-pull-23.ant-col-rtl {
    right: auto;
    left: 95.83333333%;
  }
  .ant-col-xl-offset-23.ant-col-rtl {
    margin-right: 95.83333333%;
    margin-left: 0;
  }
  .ant-col-xl-push-24.ant-col-rtl {
    right: 100%;
    left: auto;
  }
  .ant-col-xl-pull-24.ant-col-rtl {
    right: auto;
    left: 100%;
  }
  .ant-col-xl-offset-24.ant-col-rtl {
    margin-right: 100%;
    margin-left: 0;
  }
}
@media (min-width: 1600px) {
  .ant-col-xxl-24 {
    display: block;
    flex: 0 0 100%;
    max-width: 100%;
  }
  .ant-col-xxl-push-24 {
    left: 100%;
  }
  .ant-col-xxl-pull-24 {
    right: 100%;
  }
  .ant-col-xxl-offset-24 {
    margin-left: 100%;
  }
  .ant-col-xxl-order-24 {
    order: 24;
  }
  .ant-col-xxl-23 {
    display: block;
    flex: 0 0 95.83333333%;
    max-width: 95.83333333%;
  }
  .ant-col-xxl-push-23 {
    left: 95.83333333%;
  }
  .ant-col-xxl-pull-23 {
    right: 95.83333333%;
  }
  .ant-col-xxl-offset-23 {
    margin-left: 95.83333333%;
  }
  .ant-col-xxl-order-23 {
    order: 23;
  }
  .ant-col-xxl-22 {
    display: block;
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .ant-col-xxl-push-22 {
    left: 91.66666667%;
  }
  .ant-col-xxl-pull-22 {
    right: 91.66666667%;
  }
  .ant-col-xxl-offset-22 {
    margin-left: 91.66666667%;
  }
  .ant-col-xxl-order-22 {
    order: 22;
  }
  .ant-col-xxl-21 {
    display: block;
    flex: 0 0 87.5%;
    max-width: 87.5%;
  }
  .ant-col-xxl-push-21 {
    left: 87.5%;
  }
  .ant-col-xxl-pull-21 {
    right: 87.5%;
  }
  .ant-col-xxl-offset-21 {
    margin-left: 87.5%;
  }
  .ant-col-xxl-order-21 {
    order: 21;
  }
  .ant-col-xxl-20 {
    display: block;
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .ant-col-xxl-push-20 {
    left: 83.33333333%;
  }
  .ant-col-xxl-pull-20 {
    right: 83.33333333%;
  }
  .ant-col-xxl-offset-20 {
    margin-left: 83.33333333%;
  }
  .ant-col-xxl-order-20 {
    order: 20;
  }
  .ant-col-xxl-19 {
    display: block;
    flex: 0 0 79.16666667%;
    max-width: 79.16666667%;
  }
  .ant-col-xxl-push-19 {
    left: 79.16666667%;
  }
  .ant-col-xxl-pull-19 {
    right: 79.16666667%;
  }
  .ant-col-xxl-offset-19 {
    margin-left: 79.16666667%;
  }
  .ant-col-xxl-order-19 {
    order: 19;
  }
  .ant-col-xxl-18 {
    display: block;
    flex: 0 0 75%;
    max-width: 75%;
  }
  .ant-col-xxl-push-18 {
    left: 75%;
  }
  .ant-col-xxl-pull-18 {
    right: 75%;
  }
  .ant-col-xxl-offset-18 {
    margin-left: 75%;
  }
  .ant-col-xxl-order-18 {
    order: 18;
  }
  .ant-col-xxl-17 {
    display: block;
    flex: 0 0 70.83333333%;
    max-width: 70.83333333%;
  }
  .ant-col-xxl-push-17 {
    left: 70.83333333%;
  }
  .ant-col-xxl-pull-17 {
    right: 70.83333333%;
  }
  .ant-col-xxl-offset-17 {
    margin-left: 70.83333333%;
  }
  .ant-col-xxl-order-17 {
    order: 17;
  }
  .ant-col-xxl-16 {
    display: block;
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .ant-col-xxl-push-16 {
    left: 66.66666667%;
  }
  .ant-col-xxl-pull-16 {
    right: 66.66666667%;
  }
  .ant-col-xxl-offset-16 {
    margin-left: 66.66666667%;
  }
  .ant-col-xxl-order-16 {
    order: 16;
  }
  .ant-col-xxl-15 {
    display: block;
    flex: 0 0 62.5%;
    max-width: 62.5%;
  }
  .ant-col-xxl-push-15 {
    left: 62.5%;
  }
  .ant-col-xxl-pull-15 {
    right: 62.5%;
  }
  .ant-col-xxl-offset-15 {
    margin-left: 62.5%;
  }
  .ant-col-xxl-order-15 {
    order: 15;
  }
  .ant-col-xxl-14 {
    display: block;
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .ant-col-xxl-push-14 {
    left: 58.33333333%;
  }
  .ant-col-xxl-pull-14 {
    right: 58.33333333%;
  }
  .ant-col-xxl-offset-14 {
    margin-left: 58.33333333%;
  }
  .ant-col-xxl-order-14 {
    order: 14;
  }
  .ant-col-xxl-13 {
    display: block;
    flex: 0 0 54.16666667%;
    max-width: 54.16666667%;
  }
  .ant-col-xxl-push-13 {
    left: 54.16666667%;
  }
  .ant-col-xxl-pull-13 {
    right: 54.16666667%;
  }
  .ant-col-xxl-offset-13 {
    margin-left: 54.16666667%;
  }
  .ant-col-xxl-order-13 {
    order: 13;
  }
  .ant-col-xxl-12 {
    display: block;
    flex: 0 0 50%;
    max-width: 50%;
  }
  .ant-col-xxl-push-12 {
    left: 50%;
  }
  .ant-col-xxl-pull-12 {
    right: 50%;
  }
  .ant-col-xxl-offset-12 {
    margin-left: 50%;
  }
  .ant-col-xxl-order-12 {
    order: 12;
  }
  .ant-col-xxl-11 {
    display: block;
    flex: 0 0 45.83333333%;
    max-width: 45.83333333%;
  }
  .ant-col-xxl-push-11 {
    left: 45.83333333%;
  }
  .ant-col-xxl-pull-11 {
    right: 45.83333333%;
  }
  .ant-col-xxl-offset-11 {
    margin-left: 45.83333333%;
  }
  .ant-col-xxl-order-11 {
    order: 11;
  }
  .ant-col-xxl-10 {
    display: block;
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .ant-col-xxl-push-10 {
    left: 41.66666667%;
  }
  .ant-col-xxl-pull-10 {
    right: 41.66666667%;
  }
  .ant-col-xxl-offset-10 {
    margin-left: 41.66666667%;
  }
  .ant-col-xxl-order-10 {
    order: 10;
  }
  .ant-col-xxl-9 {
    display: block;
    flex: 0 0 37.5%;
    max-width: 37.5%;
  }
  .ant-col-xxl-push-9 {
    left: 37.5%;
  }
  .ant-col-xxl-pull-9 {
    right: 37.5%;
  }
  .ant-col-xxl-offset-9 {
    margin-left: 37.5%;
  }
  .ant-col-xxl-order-9 {
    order: 9;
  }
  .ant-col-xxl-8 {
    display: block;
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .ant-col-xxl-push-8 {
    left: 33.33333333%;
  }
  .ant-col-xxl-pull-8 {
    right: 33.33333333%;
  }
  .ant-col-xxl-offset-8 {
    margin-left: 33.33333333%;
  }
  .ant-col-xxl-order-8 {
    order: 8;
  }
  .ant-col-xxl-7 {
    display: block;
    flex: 0 0 29.16666667%;
    max-width: 29.16666667%;
  }
  .ant-col-xxl-push-7 {
    left: 29.16666667%;
  }
  .ant-col-xxl-pull-7 {
    right: 29.16666667%;
  }
  .ant-col-xxl-offset-7 {
    margin-left: 29.16666667%;
  }
  .ant-col-xxl-order-7 {
    order: 7;
  }
  .ant-col-xxl-6 {
    display: block;
    flex: 0 0 25%;
    max-width: 25%;
  }
  .ant-col-xxl-push-6 {
    left: 25%;
  }
  .ant-col-xxl-pull-6 {
    right: 25%;
  }
  .ant-col-xxl-offset-6 {
    margin-left: 25%;
  }
  .ant-col-xxl-order-6 {
    order: 6;
  }
  .ant-col-xxl-5 {
    display: block;
    flex: 0 0 20.83333333%;
    max-width: 20.83333333%;
  }
  .ant-col-xxl-push-5 {
    left: 20.83333333%;
  }
  .ant-col-xxl-pull-5 {
    right: 20.83333333%;
  }
  .ant-col-xxl-offset-5 {
    margin-left: 20.83333333%;
  }
  .ant-col-xxl-order-5 {
    order: 5;
  }
  .ant-col-xxl-4 {
    display: block;
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .ant-col-xxl-push-4 {
    left: 16.66666667%;
  }
  .ant-col-xxl-pull-4 {
    right: 16.66666667%;
  }
  .ant-col-xxl-offset-4 {
    margin-left: 16.66666667%;
  }
  .ant-col-xxl-order-4 {
    order: 4;
  }
  .ant-col-xxl-3 {
    display: block;
    flex: 0 0 12.5%;
    max-width: 12.5%;
  }
  .ant-col-xxl-push-3 {
    left: 12.5%;
  }
  .ant-col-xxl-pull-3 {
    right: 12.5%;
  }
  .ant-col-xxl-offset-3 {
    margin-left: 12.5%;
  }
  .ant-col-xxl-order-3 {
    order: 3;
  }
  .ant-col-xxl-2 {
    display: block;
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .ant-col-xxl-push-2 {
    left: 8.33333333%;
  }
  .ant-col-xxl-pull-2 {
    right: 8.33333333%;
  }
  .ant-col-xxl-offset-2 {
    margin-left: 8.33333333%;
  }
  .ant-col-xxl-order-2 {
    order: 2;
  }
  .ant-col-xxl-1 {
    display: block;
    flex: 0 0 4.16666667%;
    max-width: 4.16666667%;
  }
  .ant-col-xxl-push-1 {
    left: 4.16666667%;
  }
  .ant-col-xxl-pull-1 {
    right: 4.16666667%;
  }
  .ant-col-xxl-offset-1 {
    margin-left: 4.16666667%;
  }
  .ant-col-xxl-order-1 {
    order: 1;
  }
  .ant-col-xxl-0 {
    display: none;
  }
  .ant-col-push-0 {
    left: auto;
  }
  .ant-col-pull-0 {
    right: auto;
  }
  .ant-col-xxl-push-0 {
    left: auto;
  }
  .ant-col-xxl-pull-0 {
    right: auto;
  }
  .ant-col-xxl-offset-0 {
    margin-left: 0;
  }
  .ant-col-xxl-order-0 {
    order: 0;
  }
  .ant-col-push-0.ant-col-rtl {
    right: auto;
  }
  .ant-col-pull-0.ant-col-rtl {
    left: auto;
  }
  .ant-col-xxl-push-0.ant-col-rtl {
    right: auto;
  }
  .ant-col-xxl-pull-0.ant-col-rtl {
    left: auto;
  }
  .ant-col-xxl-offset-0.ant-col-rtl {
    margin-right: 0;
  }
  .ant-col-xxl-push-1.ant-col-rtl {
    right: 4.16666667%;
    left: auto;
  }
  .ant-col-xxl-pull-1.ant-col-rtl {
    right: auto;
    left: 4.16666667%;
  }
  .ant-col-xxl-offset-1.ant-col-rtl {
    margin-right: 4.16666667%;
    margin-left: 0;
  }
  .ant-col-xxl-push-2.ant-col-rtl {
    right: 8.33333333%;
    left: auto;
  }
  .ant-col-xxl-pull-2.ant-col-rtl {
    right: auto;
    left: 8.33333333%;
  }
  .ant-col-xxl-offset-2.ant-col-rtl {
    margin-right: 8.33333333%;
    margin-left: 0;
  }
  .ant-col-xxl-push-3.ant-col-rtl {
    right: 12.5%;
    left: auto;
  }
  .ant-col-xxl-pull-3.ant-col-rtl {
    right: auto;
    left: 12.5%;
  }
  .ant-col-xxl-offset-3.ant-col-rtl {
    margin-right: 12.5%;
    margin-left: 0;
  }
  .ant-col-xxl-push-4.ant-col-rtl {
    right: 16.66666667%;
    left: auto;
  }
  .ant-col-xxl-pull-4.ant-col-rtl {
    right: auto;
    left: 16.66666667%;
  }
  .ant-col-xxl-offset-4.ant-col-rtl {
    margin-right: 16.66666667%;
    margin-left: 0;
  }
  .ant-col-xxl-push-5.ant-col-rtl {
    right: 20.83333333%;
    left: auto;
  }
  .ant-col-xxl-pull-5.ant-col-rtl {
    right: auto;
    left: 20.83333333%;
  }
  .ant-col-xxl-offset-5.ant-col-rtl {
    margin-right: 20.83333333%;
    margin-left: 0;
  }
  .ant-col-xxl-push-6.ant-col-rtl {
    right: 25%;
    left: auto;
  }
  .ant-col-xxl-pull-6.ant-col-rtl {
    right: auto;
    left: 25%;
  }
  .ant-col-xxl-offset-6.ant-col-rtl {
    margin-right: 25%;
    margin-left: 0;
  }
  .ant-col-xxl-push-7.ant-col-rtl {
    right: 29.16666667%;
    left: auto;
  }
  .ant-col-xxl-pull-7.ant-col-rtl {
    right: auto;
    left: 29.16666667%;
  }
  .ant-col-xxl-offset-7.ant-col-rtl {
    margin-right: 29.16666667%;
    margin-left: 0;
  }
  .ant-col-xxl-push-8.ant-col-rtl {
    right: 33.33333333%;
    left: auto;
  }
  .ant-col-xxl-pull-8.ant-col-rtl {
    right: auto;
    left: 33.33333333%;
  }
  .ant-col-xxl-offset-8.ant-col-rtl {
    margin-right: 33.33333333%;
    margin-left: 0;
  }
  .ant-col-xxl-push-9.ant-col-rtl {
    right: 37.5%;
    left: auto;
  }
  .ant-col-xxl-pull-9.ant-col-rtl {
    right: auto;
    left: 37.5%;
  }
  .ant-col-xxl-offset-9.ant-col-rtl {
    margin-right: 37.5%;
    margin-left: 0;
  }
  .ant-col-xxl-push-10.ant-col-rtl {
    right: 41.66666667%;
    left: auto;
  }
  .ant-col-xxl-pull-10.ant-col-rtl {
    right: auto;
    left: 41.66666667%;
  }
  .ant-col-xxl-offset-10.ant-col-rtl {
    margin-right: 41.66666667%;
    margin-left: 0;
  }
  .ant-col-xxl-push-11.ant-col-rtl {
    right: 45.83333333%;
    left: auto;
  }
  .ant-col-xxl-pull-11.ant-col-rtl {
    right: auto;
    left: 45.83333333%;
  }
  .ant-col-xxl-offset-11.ant-col-rtl {
    margin-right: 45.83333333%;
    margin-left: 0;
  }
  .ant-col-xxl-push-12.ant-col-rtl {
    right: 50%;
    left: auto;
  }
  .ant-col-xxl-pull-12.ant-col-rtl {
    right: auto;
    left: 50%;
  }
  .ant-col-xxl-offset-12.ant-col-rtl {
    margin-right: 50%;
    margin-left: 0;
  }
  .ant-col-xxl-push-13.ant-col-rtl {
    right: 54.16666667%;
    left: auto;
  }
  .ant-col-xxl-pull-13.ant-col-rtl {
    right: auto;
    left: 54.16666667%;
  }
  .ant-col-xxl-offset-13.ant-col-rtl {
    margin-right: 54.16666667%;
    margin-left: 0;
  }
  .ant-col-xxl-push-14.ant-col-rtl {
    right: 58.33333333%;
    left: auto;
  }
  .ant-col-xxl-pull-14.ant-col-rtl {
    right: auto;
    left: 58.33333333%;
  }
  .ant-col-xxl-offset-14.ant-col-rtl {
    margin-right: 58.33333333%;
    margin-left: 0;
  }
  .ant-col-xxl-push-15.ant-col-rtl {
    right: 62.5%;
    left: auto;
  }
  .ant-col-xxl-pull-15.ant-col-rtl {
    right: auto;
    left: 62.5%;
  }
  .ant-col-xxl-offset-15.ant-col-rtl {
    margin-right: 62.5%;
    margin-left: 0;
  }
  .ant-col-xxl-push-16.ant-col-rtl {
    right: 66.66666667%;
    left: auto;
  }
  .ant-col-xxl-pull-16.ant-col-rtl {
    right: auto;
    left: 66.66666667%;
  }
  .ant-col-xxl-offset-16.ant-col-rtl {
    margin-right: 66.66666667%;
    margin-left: 0;
  }
  .ant-col-xxl-push-17.ant-col-rtl {
    right: 70.83333333%;
    left: auto;
  }
  .ant-col-xxl-pull-17.ant-col-rtl {
    right: auto;
    left: 70.83333333%;
  }
  .ant-col-xxl-offset-17.ant-col-rtl {
    margin-right: 70.83333333%;
    margin-left: 0;
  }
  .ant-col-xxl-push-18.ant-col-rtl {
    right: 75%;
    left: auto;
  }
  .ant-col-xxl-pull-18.ant-col-rtl {
    right: auto;
    left: 75%;
  }
  .ant-col-xxl-offset-18.ant-col-rtl {
    margin-right: 75%;
    margin-left: 0;
  }
  .ant-col-xxl-push-19.ant-col-rtl {
    right: 79.16666667%;
    left: auto;
  }
  .ant-col-xxl-pull-19.ant-col-rtl {
    right: auto;
    left: 79.16666667%;
  }
  .ant-col-xxl-offset-19.ant-col-rtl {
    margin-right: 79.16666667%;
    margin-left: 0;
  }
  .ant-col-xxl-push-20.ant-col-rtl {
    right: 83.33333333%;
    left: auto;
  }
  .ant-col-xxl-pull-20.ant-col-rtl {
    right: auto;
    left: 83.33333333%;
  }
  .ant-col-xxl-offset-20.ant-col-rtl {
    margin-right: 83.33333333%;
    margin-left: 0;
  }
  .ant-col-xxl-push-21.ant-col-rtl {
    right: 87.5%;
    left: auto;
  }
  .ant-col-xxl-pull-21.ant-col-rtl {
    right: auto;
    left: 87.5%;
  }
  .ant-col-xxl-offset-21.ant-col-rtl {
    margin-right: 87.5%;
    margin-left: 0;
  }
  .ant-col-xxl-push-22.ant-col-rtl {
    right: 91.66666667%;
    left: auto;
  }
  .ant-col-xxl-pull-22.ant-col-rtl {
    right: auto;
    left: 91.66666667%;
  }
  .ant-col-xxl-offset-22.ant-col-rtl {
    margin-right: 91.66666667%;
    margin-left: 0;
  }
  .ant-col-xxl-push-23.ant-col-rtl {
    right: 95.83333333%;
    left: auto;
  }
  .ant-col-xxl-pull-23.ant-col-rtl {
    right: auto;
    left: 95.83333333%;
  }
  .ant-col-xxl-offset-23.ant-col-rtl {
    margin-right: 95.83333333%;
    margin-left: 0;
  }
  .ant-col-xxl-push-24.ant-col-rtl {
    right: 100%;
    left: auto;
  }
  .ant-col-xxl-pull-24.ant-col-rtl {
    right: auto;
    left: 100%;
  }
  .ant-col-xxl-offset-24.ant-col-rtl {
    margin-right: 100%;
    margin-left: 0;
  }
}
.ant-row-rtl {
  direction: rtl;
}

.ant-image {
  position: relative;
  display: inline-block;
}

.ant-image-img {
  width: 100%;
  height: auto;
  vertical-align: middle;
}

.ant-image-img-placeholder {
  background-color: #f5f5f5;
  background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTE0LjUgMi41aC0xM0EuNS41IDAgMDAxIDN2MTBhLjUuNSAwIDAwLjUuNWgxM2EuNS41IDAgMDAuNS0uNVYzYS41LjUgMCAwMC0uNS0uNXpNNS4yODEgNC43NWExIDEgMCAwMTAgMiAxIDEgMCAwMTAtMnptOC4wMyA2LjgzYS4xMjcuMTI3IDAgMDEtLjA4MS4wM0gyLjc2OWEuMTI1LjEyNSAwIDAxLS4wOTYtLjIwN2wyLjY2MS0zLjE1NmEuMTI2LjEyNiAwIDAxLjE3Ny0uMDE2bC4wMTYuMDE2TDcuMDggMTAuMDlsMi40Ny0yLjkzYS4xMjYuMTI2IDAgMDEuMTc3LS4wMTZsLjAxNS4wMTYgMy41ODggNC4yNDRhLjEyNy4xMjcgMCAwMS0uMDIuMTc1eiIgZmlsbD0iIzhDOEM4QyIvPjwvc3ZnPg==");
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 30%;
}

.ant-image-mask {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: rgba(0, 0, 0, 0.5);
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.3s;
}

.ant-image-mask-info {
  padding: 0 4px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ant-image-mask-info .anticon {
  -webkit-margin-end: 4px;
  margin-inline-end: 4px;
}

.ant-image-mask:hover {
  opacity: 1;
}

.ant-image-placeholder {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.ant-image-preview {
  pointer-events: none;
  height: 100%;
  text-align: center;
}

.ant-image-preview.ant-zoom-appear, .ant-image-preview.ant-zoom-enter {
  transform: none;
  opacity: 0;
  animation-duration: 0.3s;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-image-preview-mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.45);
}

.ant-image-preview-mask-hidden {
  display: none;
}

.ant-image-preview-wrap {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  outline: 0;
}

.ant-image-preview-body {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
}

.ant-image-preview-img {
  max-width: 100%;
  max-height: 100%;
  vertical-align: middle;
  transform: scaleX(1);
  cursor: grab;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  pointer-events: auto;
}

.ant-image-preview-img, .ant-image-preview-img-wrapper {
  transition: transform 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s;
}

.ant-image-preview-img-wrapper {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.ant-image-preview-img-wrapper:before {
  display: inline-block;
  width: 1px;
  height: 50%;
  margin-right: -1px;
  content: "";
}

.ant-image-preview-moving .ant-image-preview-img {
  cursor: grabbing;
}

.ant-image-preview-moving .ant-image-preview-img-wrapper {
  transition-duration: 0s;
}

.ant-image-preview-wrap {
  z-index: 1080;
}

.ant-image-preview-operations-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1081;
  width: 100%;
}

.ant-image-preview-operations {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  font-feature-settings: "tnum";
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  color: hsla(0, 0%, 100%, 0.85);
  list-style: none;
  background: rgba(0, 0, 0, 0.1);
  pointer-events: auto;
}

.ant-image-preview-operations-operation {
  margin-left: 12px;
  padding: 12px;
  cursor: pointer;
  transition: all 0.3s;
}

.ant-image-preview-operations-operation:hover {
  background: rgba(0, 0, 0, 0.2);
}

.ant-image-preview-operations-operation-disabled {
  color: hsla(0, 0%, 100%, 0.25);
  pointer-events: none;
}

.ant-image-preview-operations-operation:last-of-type {
  margin-left: 0;
}

.ant-image-preview-operations-progress {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.ant-image-preview-operations-icon {
  font-size: 18px;
}

.ant-image-preview-switch-left, .ant-image-preview-switch-right {
  position: fixed;
  top: 50%;
  right: 8px;
  z-index: 1081;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  color: hsla(0, 0%, 100%, 0.85);
  background: rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  transition: all 0.3s;
  pointer-events: auto;
}

.ant-image-preview-switch-left:hover, .ant-image-preview-switch-right:hover {
  background: rgba(0, 0, 0, 0.2);
}

.ant-image-preview-switch-left-disabled, .ant-image-preview-switch-left-disabled:hover, .ant-image-preview-switch-right-disabled, .ant-image-preview-switch-right-disabled:hover {
  color: hsla(0, 0%, 100%, 0.25);
  background: rgba(0, 0, 0, 0.1);
  cursor: not-allowed;
}

.ant-image-preview-switch-left-disabled:hover > .anticon, .ant-image-preview-switch-left-disabled > .anticon, .ant-image-preview-switch-right-disabled:hover > .anticon, .ant-image-preview-switch-right-disabled > .anticon {
  cursor: not-allowed;
}

.ant-image-preview-switch-left > .anticon, .ant-image-preview-switch-right > .anticon {
  font-size: 18px;
}

.ant-image-preview-switch-left {
  left: 8px;
}

.ant-image-preview-switch-right {
  right: 8px;
}

.ant-input-number-affix-wrapper {
  display: inline-block;
  width: 100%;
  min-width: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  line-height: 1.5715;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  transition: all 0.3s;
  position: relative;
  display: inline-flex;
  width: 90px;
  padding: 0;
  -webkit-padding-start: 11px;
  padding-inline-start: 11px;
}

.ant-input-number-affix-wrapper::-moz-placeholder {
  color: #bfbfbf;
  -moz-user-select: none;
  user-select: none;
}

.ant-input-number-affix-wrapper:-ms-input-placeholder {
  color: #bfbfbf;
  -ms-user-select: none;
  user-select: none;
}

.ant-input-number-affix-wrapper::placeholder {
  color: #bfbfbf;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-input-number-affix-wrapper:-moz-placeholder-shown {
  text-overflow: ellipsis;
}

.ant-input-number-affix-wrapper:-ms-input-placeholder {
  text-overflow: ellipsis;
}

.ant-input-number-affix-wrapper:placeholder-shown {
  text-overflow: ellipsis;
}

.ant-input-number-affix-wrapper:hover {
  border-color: #40a9ff;
  border-right-width: 1px;
}

.ant-input-number-affix-wrapper-focused, .ant-input-number-affix-wrapper:focus {
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-input-number-affix-wrapper-disabled {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}

.ant-input-number-affix-wrapper-disabled:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}

.ant-input-number-affix-wrapper[disabled] {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}

.ant-input-number-affix-wrapper[disabled]:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}

.ant-input-number-affix-wrapper-borderless, .ant-input-number-affix-wrapper-borderless-disabled, .ant-input-number-affix-wrapper-borderless-focused, .ant-input-number-affix-wrapper-borderless:focus, .ant-input-number-affix-wrapper-borderless:hover, .ant-input-number-affix-wrapper-borderless[disabled] {
  background-color: transparent;
  border: none;
  box-shadow: none;
}

textarea.ant-input-number-affix-wrapper {
  max-width: 100%;
  height: auto;
  min-height: 32px;
  line-height: 1.5715;
  vertical-align: bottom;
  transition: all 0.3s, height 0s;
}

.ant-input-number-affix-wrapper-lg {
  padding: 6.5px 11px;
  font-size: 16px;
}

.ant-input-number-affix-wrapper-sm {
  padding: 0 7px;
}

.ant-input-number-affix-wrapper:not(.ant-input-number-affix-wrapper-disabled):hover {
  border-color: #40a9ff;
  border-right-width: 1px;
  z-index: 1;
}

.ant-input-number-affix-wrapper-focused, .ant-input-number-affix-wrapper:focus {
  z-index: 1;
}

.ant-input-number-affix-wrapper-disabled .ant-input-number[disabled] {
  background: transparent;
}

.ant-input-number-affix-wrapper > div.ant-input-number {
  width: 100%;
  border: none;
  outline: none;
}

.ant-input-number-affix-wrapper > div.ant-input-number.ant-input-number-focused {
  box-shadow: none !important;
}

.ant-input-number-affix-wrapper input.ant-input-number-input {
  padding: 0;
}

.ant-input-number-affix-wrapper:before {
  width: 0;
  visibility: hidden;
  content: " ";
}

.ant-input-number-affix-wrapper .ant-input-number-handler-wrap {
  z-index: 2;
}

.ant-input-number-prefix, .ant-input-number-suffix {
  display: flex;
  flex: none;
  align-items: center;
  pointer-events: none;
}

.ant-input-number-prefix {
  -webkit-margin-end: 4px;
  margin-inline-end: 4px;
}

.ant-input-number-suffix {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  height: 100%;
  margin-right: 11px;
  margin-left: 4px;
}

.ant-input-number-group-wrapper .ant-input-number-affix-wrapper {
  width: 100%;
}

.ant-input-number-status-error:not(.ant-input-number-disabled):not(.ant-input-number-borderless).ant-input-number, .ant-input-number-status-error:not(.ant-input-number-disabled):not(.ant-input-number-borderless).ant-input-number:hover {
  background: #fff;
  border-color: #ff4d4f;
}

.ant-input-number-status-error:not(.ant-input-number-disabled):not(.ant-input-number-borderless).ant-input-number-focused, .ant-input-number-status-error:not(.ant-input-number-disabled):not(.ant-input-number-borderless).ant-input-number:focus {
  border-color: #ff7875;
  box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-input-number-status-error .ant-input-number-prefix {
  color: #ff4d4f;
}

.ant-input-number-status-warning:not(.ant-input-number-disabled):not(.ant-input-number-borderless).ant-input-number, .ant-input-number-status-warning:not(.ant-input-number-disabled):not(.ant-input-number-borderless).ant-input-number:hover {
  background: #fff;
  border-color: #faad14;
}

.ant-input-number-status-warning:not(.ant-input-number-disabled):not(.ant-input-number-borderless).ant-input-number-focused, .ant-input-number-status-warning:not(.ant-input-number-disabled):not(.ant-input-number-borderless).ant-input-number:focus {
  border-color: #ffc53d;
  box-shadow: 0 0 0 2px rgba(250, 173, 20, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-input-number-status-warning .ant-input-number-prefix {
  color: #faad14;
}

.ant-input-number-affix-wrapper-status-error:not(.ant-input-number-affix-wrapper-disabled):not(.ant-input-number-affix-wrapper-borderless).ant-input-number-affix-wrapper, .ant-input-number-affix-wrapper-status-error:not(.ant-input-number-affix-wrapper-disabled):not(.ant-input-number-affix-wrapper-borderless).ant-input-number-affix-wrapper:hover {
  background: #fff;
  border-color: #ff4d4f;
}

.ant-input-number-affix-wrapper-status-error:not(.ant-input-number-affix-wrapper-disabled):not(.ant-input-number-affix-wrapper-borderless).ant-input-number-affix-wrapper-focused, .ant-input-number-affix-wrapper-status-error:not(.ant-input-number-affix-wrapper-disabled):not(.ant-input-number-affix-wrapper-borderless).ant-input-number-affix-wrapper:focus {
  border-color: #ff7875;
  box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-input-number-affix-wrapper-status-error .ant-input-number-prefix {
  color: #ff4d4f;
}

.ant-input-number-affix-wrapper-status-warning:not(.ant-input-number-affix-wrapper-disabled):not(.ant-input-number-affix-wrapper-borderless).ant-input-number-affix-wrapper, .ant-input-number-affix-wrapper-status-warning:not(.ant-input-number-affix-wrapper-disabled):not(.ant-input-number-affix-wrapper-borderless).ant-input-number-affix-wrapper:hover {
  background: #fff;
  border-color: #faad14;
}

.ant-input-number-affix-wrapper-status-warning:not(.ant-input-number-affix-wrapper-disabled):not(.ant-input-number-affix-wrapper-borderless).ant-input-number-affix-wrapper-focused, .ant-input-number-affix-wrapper-status-warning:not(.ant-input-number-affix-wrapper-disabled):not(.ant-input-number-affix-wrapper-borderless).ant-input-number-affix-wrapper:focus {
  border-color: #ffc53d;
  box-shadow: 0 0 0 2px rgba(250, 173, 20, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-input-number-affix-wrapper-status-warning .ant-input-number-prefix {
  color: #faad14;
}

.ant-input-number-group-wrapper-status-error .ant-input-number-group-addon {
  color: #ff4d4f;
  border-color: #ff4d4f;
}

.ant-input-number-group-wrapper-status-warning .ant-input-number-group-addon {
  color: #faad14;
  border-color: #faad14;
}

.ant-input-number {
  box-sizing: border-box;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  width: 100%;
  min-width: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  line-height: 1.5715;
  background-color: #fff;
  background-image: none;
  transition: all 0.3s;
  display: inline-block;
  width: 90px;
  margin: 0;
  padding: 0;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
}

.ant-input-number::-moz-placeholder {
  color: #bfbfbf;
  -moz-user-select: none;
  user-select: none;
}

.ant-input-number:-ms-input-placeholder {
  color: #bfbfbf;
  -ms-user-select: none;
  user-select: none;
}

.ant-input-number::placeholder {
  color: #bfbfbf;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-input-number:-moz-placeholder-shown {
  text-overflow: ellipsis;
}

.ant-input-number:-ms-input-placeholder {
  text-overflow: ellipsis;
}

.ant-input-number:placeholder-shown {
  text-overflow: ellipsis;
}

.ant-input-number-focused, .ant-input-number:focus {
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-input-number[disabled] {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}

.ant-input-number[disabled]:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}

.ant-input-number-borderless, .ant-input-number-borderless-disabled, .ant-input-number-borderless-focused, .ant-input-number-borderless:focus, .ant-input-number-borderless:hover, .ant-input-number-borderless[disabled] {
  background-color: transparent;
  border: none;
  box-shadow: none;
}

textarea.ant-input-number {
  max-width: 100%;
  height: auto;
  min-height: 32px;
  line-height: 1.5715;
  vertical-align: bottom;
  transition: all 0.3s, height 0s;
}

.ant-input-number-lg {
  padding: 6.5px 11px;
}

.ant-input-number-sm {
  padding: 0 7px;
}

.ant-input-number-group {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  display: table;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.ant-input-number-group[class*=col-] {
  float: none;
  padding-right: 0;
  padding-left: 0;
}

.ant-input-number-group > [class*=col-] {
  padding-right: 8px;
}

.ant-input-number-group > [class*=col-]:last-child {
  padding-right: 0;
}

.ant-input-number-group-addon, .ant-input-number-group-wrap, .ant-input-number-group > .ant-input-number {
  display: table-cell;
}

.ant-input-number-group-addon:not(:first-child):not(:last-child), .ant-input-number-group-wrap:not(:first-child):not(:last-child), .ant-input-number-group > .ant-input-number:not(:first-child):not(:last-child) {
  border-radius: 0;
}

.ant-input-number-group-addon, .ant-input-number-group-wrap {
  width: 1px;
  white-space: nowrap;
  vertical-align: middle;
}

.ant-input-number-group-wrap > * {
  display: block !important;
}

.ant-input-number-group .ant-input-number {
  float: left;
  width: 100%;
  margin-bottom: 0;
  text-align: inherit;
}

.ant-input-number-group .ant-input-number:focus, .ant-input-number-group .ant-input-number:hover {
  z-index: 1;
  border-right-width: 1px;
}

.ant-input-search-with-button .ant-input-number-group .ant-input-number:hover {
  z-index: 0;
}

.ant-input-number-group-addon {
  position: relative;
  padding: 0 11px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 400;
  font-size: 14px;
  text-align: center;
  background-color: #fafafa;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  transition: all 0.3s;
}

.ant-input-number-group-addon .ant-select {
  margin: -5px -11px;
}

.ant-input-number-group-addon .ant-select.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
  background-color: inherit;
  border: 1px solid transparent;
  box-shadow: none;
}

.ant-input-number-group-addon .ant-select-focused .ant-select-selector, .ant-input-number-group-addon .ant-select-open .ant-select-selector {
  color: #1890ff;
}

.ant-input-number-group-addon .ant-cascader-picker {
  margin: -9px -12px;
  background-color: transparent;
}

.ant-input-number-group-addon .ant-cascader-picker .ant-cascader-input {
  text-align: left;
  border: 0;
  box-shadow: none;
}

.ant-input-number-group-addon:first-child, .ant-input-number-group-addon:first-child .ant-select .ant-select-selector, .ant-input-number-group > .ant-input-number:first-child, .ant-input-number-group > .ant-input-number:first-child .ant-select .ant-select-selector {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-input-number-group > .ant-input-number-affix-wrapper:not(:first-child) .ant-input-number {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.ant-input-number-group > .ant-input-number-affix-wrapper:not(:last-child) .ant-input-number {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-input-number-group-addon:first-child {
  border-right: 0;
}

.ant-input-number-group-addon:last-child {
  border-left: 0;
}

.ant-input-number-group-addon:last-child, .ant-input-number-group-addon:last-child .ant-select .ant-select-selector, .ant-input-number-group > .ant-input-number:last-child, .ant-input-number-group > .ant-input-number:last-child .ant-select .ant-select-selector {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.ant-input-number-group-lg .ant-input-number, .ant-input-number-group-lg > .ant-input-number-group-addon {
  padding: 6.5px 11px;
  font-size: 16px;
}

.ant-input-number-group-sm .ant-input-number, .ant-input-number-group-sm > .ant-input-number-group-addon {
  padding: 0 7px;
}

.ant-input-number-group-lg .ant-select-single .ant-select-selector {
  height: 40px;
}

.ant-input-number-group-sm .ant-select-single .ant-select-selector {
  height: 24px;
}

.ant-input-number-group .ant-input-number-affix-wrapper:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-input-search .ant-input-number-group .ant-input-number-affix-wrapper:not(:last-child) {
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}

.ant-input-number-group .ant-input-number-affix-wrapper:not(:first-child), .ant-input-search .ant-input-number-group .ant-input-number-affix-wrapper:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.ant-input-number-group.ant-input-number-group-compact {
  display: block;
}

.ant-input-number-group.ant-input-number-group-compact:before {
  display: table;
  content: "";
}

.ant-input-number-group.ant-input-number-group-compact:after {
  display: table;
  clear: both;
  content: "";
}

.ant-input-number-group.ant-input-number-group-compact-addon:not(:first-child):not(:last-child), .ant-input-number-group.ant-input-number-group-compact-wrap:not(:first-child):not(:last-child), .ant-input-number-group.ant-input-number-group-compact > .ant-input-number:not(:first-child):not(:last-child) {
  border-right-width: 1px;
}

.ant-input-number-group.ant-input-number-group-compact-addon:not(:first-child):not(:last-child):focus, .ant-input-number-group.ant-input-number-group-compact-addon:not(:first-child):not(:last-child):hover, .ant-input-number-group.ant-input-number-group-compact-wrap:not(:first-child):not(:last-child):focus, .ant-input-number-group.ant-input-number-group-compact-wrap:not(:first-child):not(:last-child):hover, .ant-input-number-group.ant-input-number-group-compact > .ant-input-number:not(:first-child):not(:last-child):focus, .ant-input-number-group.ant-input-number-group-compact > .ant-input-number:not(:first-child):not(:last-child):hover {
  z-index: 1;
}

.ant-input-number-group.ant-input-number-group-compact > * {
  display: inline-block;
  float: none;
  vertical-align: top;
  border-radius: 0;
}

.ant-input-number-group.ant-input-number-group-compact > .ant-input-number-affix-wrapper, .ant-input-number-group.ant-input-number-group-compact > .ant-picker-range {
  display: inline-flex;
}

.ant-input-number-group.ant-input-number-group-compact > :not(:last-child) {
  margin-right: -1px;
  border-right-width: 1px;
}

.ant-input-number-group.ant-input-number-group-compact .ant-input-number {
  float: none;
}

.ant-input-number-group.ant-input-number-group-compact > .ant-cascader-picker .ant-input, .ant-input-number-group.ant-input-number-group-compact > .ant-input-group-wrapper .ant-input, .ant-input-number-group.ant-input-number-group-compact > .ant-select-auto-complete .ant-input, .ant-input-number-group.ant-input-number-group-compact > .ant-select > .ant-select-selector {
  border-right-width: 1px;
  border-radius: 0;
}

.ant-input-number-group.ant-input-number-group-compact > .ant-cascader-picker .ant-input:focus, .ant-input-number-group.ant-input-number-group-compact > .ant-cascader-picker .ant-input:hover, .ant-input-number-group.ant-input-number-group-compact > .ant-input-group-wrapper .ant-input:focus, .ant-input-number-group.ant-input-number-group-compact > .ant-input-group-wrapper .ant-input:hover, .ant-input-number-group.ant-input-number-group-compact > .ant-select-auto-complete .ant-input:focus, .ant-input-number-group.ant-input-number-group-compact > .ant-select-auto-complete .ant-input:hover, .ant-input-number-group.ant-input-number-group-compact > .ant-select-focused, .ant-input-number-group.ant-input-number-group-compact > .ant-select > .ant-select-arrow, .ant-input-number-group.ant-input-number-group-compact > .ant-select > .ant-select-selector:focus, .ant-input-number-group.ant-input-number-group-compact > .ant-select > .ant-select-selector:hover {
  z-index: 1;
}

.ant-input-number-group.ant-input-number-group-compact > .ant-cascader-picker:first-child .ant-input, .ant-input-number-group.ant-input-number-group-compact > .ant-select-auto-complete:first-child .ant-input, .ant-input-number-group.ant-input-number-group-compact > .ant-select:first-child > .ant-select-selector, .ant-input-number-group.ant-input-number-group-compact > :first-child {
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}

.ant-input-number-group.ant-input-number-group-compact > .ant-cascader-picker-focused:last-child .ant-input, .ant-input-number-group.ant-input-number-group-compact > .ant-cascader-picker:last-child .ant-input, .ant-input-number-group.ant-input-number-group-compact > .ant-select:last-child > .ant-select-selector, .ant-input-number-group.ant-input-number-group-compact > :last-child {
  border-right-width: 1px;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
}

.ant-input-number-group.ant-input-number-group-compact > .ant-select-auto-complete .ant-input {
  vertical-align: top;
}

.ant-input-number-group.ant-input-number-group-compact .ant-input-group-wrapper + .ant-input-group-wrapper {
  margin-left: -1px;
}

.ant-input-number-group.ant-input-number-group-compact .ant-input-group-wrapper + .ant-input-group-wrapper .ant-input-affix-wrapper, .ant-input-number-group.ant-input-number-group-compact .ant-input-group-wrapper:not(:last-child).ant-input-search > .ant-input-group > .ant-input-group-addon > .ant-input-search-button {
  border-radius: 0;
}

.ant-input-number-group.ant-input-number-group-compact .ant-input-group-wrapper:not(:last-child).ant-input-search > .ant-input-group > .ant-input {
  border-radius: 2px 0 0 2px;
}

.ant-input-number-group > .ant-input-number-rtl:first-child {
  border-radius: 0 2px 2px 0;
}

.ant-input-number-group > .ant-input-number-rtl:last-child {
  border-radius: 2px 0 0 2px;
}

.ant-input-number-group-rtl .ant-input-number-group-addon:first-child {
  border-right: 1px solid #d9d9d9;
  border-left: 0;
  border-radius: 0 2px 2px 0;
}

.ant-input-number-group-rtl .ant-input-number-group-addon:last-child {
  border-right: 0;
  border-left: 1px solid #d9d9d9;
  border-radius: 2px 0 0 2px;
}

.ant-input-number-group-wrapper {
  display: inline-block;
  text-align: start;
  vertical-align: top;
}

.ant-input-number-handler {
  position: relative;
  display: block;
  width: 100%;
  height: 50%;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.45);
  font-weight: 700;
  line-height: 0;
  text-align: center;
  border-left: 1px solid #d9d9d9;
  transition: all 0.1s linear;
}

.ant-input-number-handler:active {
  background: #f4f4f4;
}

.ant-input-number-handler:hover .ant-input-number-handler-down-inner, .ant-input-number-handler:hover .ant-input-number-handler-up-inner {
  color: #40a9ff;
}

.ant-input-number-handler-down-inner, .ant-input-number-handler-up-inner {
  display: inline-block;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  right: 4px;
  width: 12px;
  height: 12px;
  color: rgba(0, 0, 0, 0.45);
  line-height: 12px;
  transition: all 0.1s linear;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-input-number-handler-down-inner > *, .ant-input-number-handler-up-inner > * {
  line-height: 1;
}

.ant-input-number-handler-down-inner svg, .ant-input-number-handler-up-inner svg {
  display: inline-block;
}

.ant-input-number-handler-down-inner:before, .ant-input-number-handler-up-inner:before {
  display: none;
}

.ant-input-number-handler-down-inner .ant-input-number-handler-down-inner-icon, .ant-input-number-handler-down-inner .ant-input-number-handler-up-inner-icon, .ant-input-number-handler-up-inner .ant-input-number-handler-down-inner-icon, .ant-input-number-handler-up-inner .ant-input-number-handler-up-inner-icon {
  display: block;
}

.ant-input-number:hover {
  border-color: #40a9ff;
  border-right-width: 1px;
}

.ant-input-number:hover + .ant-form-item-children-icon {
  opacity: 0;
  transition: opacity 0.24s linear 0.24s;
}

.ant-input-number-focused {
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-input-number-disabled {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}

.ant-input-number-disabled:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}

.ant-input-number-disabled .ant-input-number-input {
  cursor: not-allowed;
}

.ant-input-number-disabled .ant-input-number-handler-wrap, .ant-input-number-readonly .ant-input-number-handler-wrap {
  display: none;
}

.ant-input-number-input {
  width: 100%;
  height: 30px;
  padding: 0 11px;
  text-align: left;
  background-color: transparent;
  border: 0;
  border-radius: 2px;
  outline: 0;
  transition: all 0.3s linear;
  -webkit-appearance: textfield !important;
  -moz-appearance: textfield !important;
  appearance: textfield !important;
}

.ant-input-number-input::-moz-placeholder {
  color: #bfbfbf;
  -moz-user-select: none;
  user-select: none;
}

.ant-input-number-input:-ms-input-placeholder {
  color: #bfbfbf;
  -ms-user-select: none;
  user-select: none;
}

.ant-input-number-input::placeholder {
  color: #bfbfbf;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-input-number-input:-moz-placeholder-shown {
  text-overflow: ellipsis;
}

.ant-input-number-input:-ms-input-placeholder {
  text-overflow: ellipsis;
}

.ant-input-number-input:placeholder-shown {
  text-overflow: ellipsis;
}

.ant-input-number-input[type=number]::-webkit-inner-spin-button, .ant-input-number-input[type=number]::-webkit-outer-spin-button {
  margin: 0;
  -webkit-appearance: none;
  appearance: none;
}

.ant-input-number-lg {
  padding: 0;
  font-size: 16px;
}

.ant-input-number-lg input {
  height: 38px;
}

.ant-input-number-sm {
  padding: 0;
}

.ant-input-number-sm input {
  height: 22px;
  padding: 0 7px;
}

.ant-input-number-handler-wrap {
  position: absolute;
  top: 0;
  right: 0;
  width: 22px;
  height: 100%;
  background: #fff;
  border-radius: 0 2px 2px 0;
  opacity: 0;
  transition: opacity 0.24s linear 0.1s;
}

.ant-input-number-handler-wrap .ant-input-number-handler .ant-input-number-handler-down-inner, .ant-input-number-handler-wrap .ant-input-number-handler .ant-input-number-handler-up-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: auto;
  margin-right: 0;
  font-size: 7px;
}

.ant-input-number-borderless .ant-input-number-handler-wrap {
  border-left-width: 0;
}

.ant-input-number-handler-wrap:hover .ant-input-number-handler {
  height: 40%;
}

.ant-input-number-focused .ant-input-number-handler-wrap, .ant-input-number:hover .ant-input-number-handler-wrap {
  opacity: 1;
}

.ant-input-number-handler-up {
  border-top-right-radius: 2px;
  cursor: pointer;
}

.ant-input-number-handler-up-inner {
  top: 50%;
  margin-top: -5px;
  text-align: center;
}

.ant-input-number-handler-up:hover {
  height: 60% !important;
}

.ant-input-number-handler-down {
  top: 0;
  border-top: 1px solid #d9d9d9;
  border-bottom-right-radius: 2px;
  cursor: pointer;
}

.ant-input-number-handler-down-inner {
  top: 50%;
  text-align: center;
  transform: translateY(-50%);
}

.ant-input-number-handler-down:hover {
  height: 60% !important;
}

.ant-input-number-borderless .ant-input-number-handler-down {
  border-top-width: 0;
}

.ant-input-number-focused:not(.ant-input-number-borderless) .ant-input-number-handler-down, .ant-input-number:hover:not(.ant-input-number-borderless) .ant-input-number-handler-down {
  border-top: 1px solid #d9d9d9;
}

.ant-input-number-handler-down-disabled, .ant-input-number-handler-up-disabled {
  cursor: not-allowed;
}

.ant-input-number-handler-down-disabled:hover .ant-input-number-handler-down-inner, .ant-input-number-handler-up-disabled:hover .ant-input-number-handler-up-inner {
  color: rgba(0, 0, 0, 0.25);
}

.ant-input-number-borderless {
  box-shadow: none;
}

.ant-input-number-out-of-range input {
  color: #ff4d4f;
}

.ant-input-number-compact-item:not(.ant-input-number-compact-last-item):not(.ant-input-number-compact-item-rtl) {
  margin-right: -1px;
}

.ant-input-number-compact-item:not(.ant-input-number-compact-last-item).ant-input-number-compact-item-rtl {
  margin-left: -1px;
}

.ant-input-number-compact-item.ant-input-number-focused, .ant-input-number-compact-item:active, .ant-input-number-compact-item:focus, .ant-input-number-compact-item:hover {
  z-index: 2;
}

.ant-input-number-compact-item[disabled] {
  z-index: 0;
}

.ant-input-number-compact-item:not(.ant-input-number-compact-first-item):not(.ant-input-number-compact-last-item).ant-input-number {
  border-radius: 0;
}

.ant-input-number-compact-item.ant-input-number.ant-input-number-compact-first-item:not(.ant-input-number-compact-last-item):not(.ant-input-number-compact-item-rtl) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-input-number-compact-item.ant-input-number.ant-input-number-compact-item-rtl.ant-input-number-compact-first-item:not(.ant-input-number-compact-last-item), .ant-input-number-compact-item.ant-input-number.ant-input-number-compact-last-item:not(.ant-input-number-compact-first-item):not(.ant-input-number-compact-item-rtl) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.ant-input-number-compact-item.ant-input-number.ant-input-number-compact-item-rtl.ant-input-number-compact-last-item:not(.ant-input-number-compact-first-item) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-input-number-rtl {
  direction: rtl;
}

.ant-input-number-rtl .ant-input-number-handler {
  border-right: 1px solid #d9d9d9;
  border-left: 0;
}

.ant-input-number-rtl .ant-input-number-handler-wrap {
  right: auto;
  left: 0;
}

.ant-input-number-rtl.ant-input-number-borderless .ant-input-number-handler-wrap {
  border-right-width: 0;
}

.ant-input-number-rtl .ant-input-number-handler-up {
  border-top-right-radius: 0;
}

.ant-input-number-rtl .ant-input-number-handler-down {
  border-bottom-right-radius: 0;
}

.ant-input-number-rtl .ant-input-number-input {
  direction: ltr;
  text-align: right;
}

.ant-input-affix-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
  min-width: 0;
  padding: 4px 11px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  line-height: 1.5715;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  transition: all 0.3s;
  display: inline-flex;
}

.ant-input-affix-wrapper::-moz-placeholder {
  color: #bfbfbf;
  -moz-user-select: none;
  user-select: none;
}

.ant-input-affix-wrapper:-ms-input-placeholder {
  color: #bfbfbf;
  -ms-user-select: none;
  user-select: none;
}

.ant-input-affix-wrapper::placeholder {
  color: #bfbfbf;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-input-affix-wrapper:-moz-placeholder-shown {
  text-overflow: ellipsis;
}

.ant-input-affix-wrapper:-ms-input-placeholder {
  text-overflow: ellipsis;
}

.ant-input-affix-wrapper:placeholder-shown {
  text-overflow: ellipsis;
}

.ant-input-affix-wrapper:hover {
  border-color: #40a9ff;
  border-right-width: 1px;
}

.ant-input-rtl .ant-input-affix-wrapper:hover {
  border-right-width: 0;
  border-left-width: 1px !important;
}

.ant-input-affix-wrapper-focused, .ant-input-affix-wrapper:focus {
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-input-rtl .ant-input-affix-wrapper-focused, .ant-input-rtl .ant-input-affix-wrapper:focus {
  border-right-width: 0;
  border-left-width: 1px !important;
}

.ant-input-affix-wrapper-disabled {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}

.ant-input-affix-wrapper-disabled:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}

.ant-input-affix-wrapper[disabled] {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}

.ant-input-affix-wrapper[disabled]:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}

.ant-input-affix-wrapper-borderless, .ant-input-affix-wrapper-borderless-disabled, .ant-input-affix-wrapper-borderless-focused, .ant-input-affix-wrapper-borderless:focus, .ant-input-affix-wrapper-borderless:hover, .ant-input-affix-wrapper-borderless[disabled] {
  background-color: transparent;
  border: none;
  box-shadow: none;
}

textarea.ant-input-affix-wrapper {
  max-width: 100%;
  height: auto;
  min-height: 32px;
  line-height: 1.5715;
  vertical-align: bottom;
  transition: all 0.3s, height 0s;
}

.ant-input-affix-wrapper-lg {
  padding: 6.5px 11px;
  font-size: 16px;
}

.ant-input-affix-wrapper-sm {
  padding: 0 7px;
}

.ant-input-affix-wrapper-rtl {
  direction: rtl;
}

.ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {
  border-color: #40a9ff;
  border-right-width: 1px;
  z-index: 1;
}

.ant-input-rtl .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {
  border-right-width: 0;
  border-left-width: 1px !important;
}

.ant-input-search-with-button .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {
  z-index: 0;
}

.ant-input-affix-wrapper-focused, .ant-input-affix-wrapper:focus {
  z-index: 1;
}

.ant-input-affix-wrapper-disabled .ant-input[disabled] {
  background: hsla(0, 0%, 100%, 0);
}

.ant-input-affix-wrapper > .ant-input {
  font-size: inherit;
  border: none;
  outline: none;
}

.ant-input-affix-wrapper > .ant-input:focus {
  box-shadow: none !important;
}

.ant-input-affix-wrapper > .ant-input:not(textarea) {
  padding: 0;
}

.ant-input-affix-wrapper:before {
  width: 0;
  visibility: hidden;
  content: " ";
}

.ant-input-prefix, .ant-input-suffix {
  display: flex;
  flex: none;
  align-items: center;
}

.ant-input-prefix > :not(:last-child), .ant-input-suffix > :not(:last-child) {
  margin-right: 8px;
}

.ant-input-show-count-suffix {
  color: rgba(0, 0, 0, 0.45);
}

.ant-input-show-count-has-suffix {
  margin-right: 2px;
}

.ant-input-prefix {
  margin-right: 4px;
}

.ant-input-suffix {
  margin-left: 4px;
}

.ant-input-clear-icon, .anticon.ant-input-clear-icon {
  margin: 0;
  color: rgba(0, 0, 0, 0.25);
  font-size: 12px;
  vertical-align: -1px;
  cursor: pointer;
  transition: color 0.3s;
}

.ant-input-clear-icon:hover, .anticon.ant-input-clear-icon:hover {
  color: rgba(0, 0, 0, 0.45);
}

.ant-input-clear-icon:active, .anticon.ant-input-clear-icon:active {
  color: rgba(0, 0, 0, 0.85);
}

.ant-input-clear-icon-hidden, .anticon.ant-input-clear-icon-hidden {
  visibility: hidden;
}

.ant-input-clear-icon-has-suffix, .anticon.ant-input-clear-icon-has-suffix {
  margin: 0 4px;
}

.ant-input-affix-wrapper.ant-input-affix-wrapper-textarea-with-clear-btn {
  padding: 0;
}

.ant-input-affix-wrapper.ant-input-affix-wrapper-textarea-with-clear-btn .ant-input-clear-icon {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
}

.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input, .ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input:hover {
  background: #fff;
  border-color: #ff4d4f;
}

.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input-focused, .ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input:focus {
  border-color: #ff7875;
  box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-input-status-error .ant-input-prefix {
  color: #ff4d4f;
}

.ant-input-status-warning:not(.ant-input-disabled):not(.ant-input-borderless).ant-input, .ant-input-status-warning:not(.ant-input-disabled):not(.ant-input-borderless).ant-input:hover {
  background: #fff;
  border-color: #faad14;
}

.ant-input-status-warning:not(.ant-input-disabled):not(.ant-input-borderless).ant-input-focused, .ant-input-status-warning:not(.ant-input-disabled):not(.ant-input-borderless).ant-input:focus {
  border-color: #ffc53d;
  box-shadow: 0 0 0 2px rgba(250, 173, 20, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-input-status-warning .ant-input-prefix {
  color: #faad14;
}

.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper, .ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper:hover {
  background: #fff;
  border-color: #ff4d4f;
}

.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper-focused, .ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper:focus {
  border-color: #ff7875;
  box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-input-affix-wrapper-status-error .ant-input-prefix {
  color: #ff4d4f;
}

.ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper, .ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper:hover {
  background: #fff;
  border-color: #faad14;
}

.ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper-focused, .ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper:focus {
  border-color: #ffc53d;
  box-shadow: 0 0 0 2px rgba(250, 173, 20, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-input-affix-wrapper-status-warning .ant-input-prefix {
  color: #faad14;
}

.ant-input-textarea-status-error.ant-input-textarea-has-feedback .ant-input, .ant-input-textarea-status-success.ant-input-textarea-has-feedback .ant-input, .ant-input-textarea-status-validating.ant-input-textarea-has-feedback .ant-input, .ant-input-textarea-status-warning.ant-input-textarea-has-feedback .ant-input {
  padding-right: 24px;
}

.ant-input-group-wrapper-status-error .ant-input-group-addon {
  color: #ff4d4f;
  border-color: #ff4d4f;
}

.ant-input-group-wrapper-status-warning .ant-input-group-addon {
  color: #faad14;
  border-color: #faad14;
}

.ant-input {
  box-sizing: border-box;
  margin: 0;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  display: inline-block;
  width: 100%;
  min-width: 0;
  padding: 4px 11px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  line-height: 1.5715;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  transition: all 0.3s;
}

.ant-input::-moz-placeholder {
  color: #bfbfbf;
  -moz-user-select: none;
  user-select: none;
}

.ant-input:-ms-input-placeholder {
  color: #bfbfbf;
  -ms-user-select: none;
  user-select: none;
}

.ant-input::placeholder {
  color: #bfbfbf;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-input:-moz-placeholder-shown {
  text-overflow: ellipsis;
}

.ant-input:-ms-input-placeholder {
  text-overflow: ellipsis;
}

.ant-input:placeholder-shown {
  text-overflow: ellipsis;
}

.ant-input:hover {
  border-color: #40a9ff;
  border-right-width: 1px;
}

.ant-input-rtl .ant-input:hover {
  border-right-width: 0;
  border-left-width: 1px !important;
}

.ant-input-focused, .ant-input:focus {
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-input-rtl .ant-input-focused, .ant-input-rtl .ant-input:focus {
  border-right-width: 0;
  border-left-width: 1px !important;
}

.ant-input-disabled {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}

.ant-input-disabled:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}

.ant-input[disabled] {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}

.ant-input[disabled]:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}

.ant-input-borderless, .ant-input-borderless-disabled, .ant-input-borderless-focused, .ant-input-borderless:focus, .ant-input-borderless:hover, .ant-input-borderless[disabled] {
  background-color: transparent;
  border: none;
  box-shadow: none;
}

textarea.ant-input {
  max-width: 100%;
  height: auto;
  min-height: 32px;
  line-height: 1.5715;
  vertical-align: bottom;
  transition: all 0.3s, height 0s;
}

.ant-input-lg {
  padding: 6.5px 11px;
  font-size: 16px;
}

.ant-input-sm {
  padding: 0 7px;
}

.ant-input-rtl {
  direction: rtl;
}

.ant-input-group {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  display: table;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.ant-input-group[class*=col-] {
  float: none;
  padding-right: 0;
  padding-left: 0;
}

.ant-input-group > [class*=col-] {
  padding-right: 8px;
}

.ant-input-group > [class*=col-]:last-child {
  padding-right: 0;
}

.ant-input-group-addon, .ant-input-group-wrap, .ant-input-group > .ant-input {
  display: table-cell;
}

.ant-input-group-addon:not(:first-child):not(:last-child), .ant-input-group-wrap:not(:first-child):not(:last-child), .ant-input-group > .ant-input:not(:first-child):not(:last-child) {
  border-radius: 0;
}

.ant-input-group-addon, .ant-input-group-wrap {
  width: 1px;
  white-space: nowrap;
  vertical-align: middle;
}

.ant-input-group-wrap > * {
  display: block !important;
}

.ant-input-group .ant-input {
  float: left;
  width: 100%;
  margin-bottom: 0;
  text-align: inherit;
}

.ant-input-group .ant-input:focus, .ant-input-group .ant-input:hover {
  z-index: 1;
  border-right-width: 1px;
}

.ant-input-search-with-button .ant-input-group .ant-input:hover {
  z-index: 0;
}

.ant-input-group-addon {
  position: relative;
  padding: 0 11px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 400;
  font-size: 14px;
  text-align: center;
  background-color: #fafafa;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  transition: all 0.3s;
}

.ant-input-group-addon .ant-select {
  margin: -5px -11px;
}

.ant-input-group-addon .ant-select.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
  background-color: inherit;
  border: 1px solid transparent;
  box-shadow: none;
}

.ant-input-group-addon .ant-select-focused .ant-select-selector, .ant-input-group-addon .ant-select-open .ant-select-selector {
  color: #1890ff;
}

.ant-input-group-addon .ant-cascader-picker {
  margin: -9px -12px;
  background-color: transparent;
}

.ant-input-group-addon .ant-cascader-picker .ant-cascader-input {
  text-align: left;
  border: 0;
  box-shadow: none;
}

.ant-input-group-addon:first-child, .ant-input-group-addon:first-child .ant-select .ant-select-selector, .ant-input-group > .ant-input:first-child, .ant-input-group > .ant-input:first-child .ant-select .ant-select-selector {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-input-group > .ant-input-affix-wrapper:not(:first-child) .ant-input {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.ant-input-group > .ant-input-affix-wrapper:not(:last-child) .ant-input {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-input-group-addon:first-child {
  border-right: 0;
}

.ant-input-group-addon:last-child {
  border-left: 0;
}

.ant-input-group-addon:last-child, .ant-input-group-addon:last-child .ant-select .ant-select-selector, .ant-input-group > .ant-input:last-child, .ant-input-group > .ant-input:last-child .ant-select .ant-select-selector {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.ant-input-group-lg .ant-input, .ant-input-group-lg > .ant-input-group-addon {
  padding: 6.5px 11px;
  font-size: 16px;
}

.ant-input-group-sm .ant-input, .ant-input-group-sm > .ant-input-group-addon {
  padding: 0 7px;
}

.ant-input-group-lg .ant-select-single .ant-select-selector {
  height: 40px;
}

.ant-input-group-sm .ant-select-single .ant-select-selector {
  height: 24px;
}

.ant-input-group .ant-input-affix-wrapper:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-input-search .ant-input-group .ant-input-affix-wrapper:not(:last-child) {
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}

.ant-input-group .ant-input-affix-wrapper:not(:first-child), .ant-input-search .ant-input-group .ant-input-affix-wrapper:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.ant-input-group.ant-input-group-compact {
  display: block;
}

.ant-input-group.ant-input-group-compact:before {
  display: table;
  content: "";
}

.ant-input-group.ant-input-group-compact:after {
  display: table;
  clear: both;
  content: "";
}

.ant-input-group.ant-input-group-compact-addon:not(:first-child):not(:last-child), .ant-input-group.ant-input-group-compact-wrap:not(:first-child):not(:last-child), .ant-input-group.ant-input-group-compact > .ant-input:not(:first-child):not(:last-child) {
  border-right-width: 1px;
}

.ant-input-group.ant-input-group-compact-addon:not(:first-child):not(:last-child):focus, .ant-input-group.ant-input-group-compact-addon:not(:first-child):not(:last-child):hover, .ant-input-group.ant-input-group-compact-wrap:not(:first-child):not(:last-child):focus, .ant-input-group.ant-input-group-compact-wrap:not(:first-child):not(:last-child):hover, .ant-input-group.ant-input-group-compact > .ant-input:not(:first-child):not(:last-child):focus, .ant-input-group.ant-input-group-compact > .ant-input:not(:first-child):not(:last-child):hover {
  z-index: 1;
}

.ant-input-group.ant-input-group-compact > * {
  display: inline-block;
  float: none;
  vertical-align: top;
  border-radius: 0;
}

.ant-input-group.ant-input-group-compact > .ant-input-affix-wrapper, .ant-input-group.ant-input-group-compact > .ant-picker-range {
  display: inline-flex;
}

.ant-input-group.ant-input-group-compact > :not(:last-child) {
  margin-right: -1px;
  border-right-width: 1px;
}

.ant-input-group.ant-input-group-compact .ant-input {
  float: none;
}

.ant-input-group.ant-input-group-compact > .ant-cascader-picker .ant-input, .ant-input-group.ant-input-group-compact > .ant-input-group-wrapper .ant-input, .ant-input-group.ant-input-group-compact > .ant-select-auto-complete .ant-input, .ant-input-group.ant-input-group-compact > .ant-select > .ant-select-selector {
  border-right-width: 1px;
  border-radius: 0;
}

.ant-input-group.ant-input-group-compact > .ant-cascader-picker .ant-input:focus, .ant-input-group.ant-input-group-compact > .ant-cascader-picker .ant-input:hover, .ant-input-group.ant-input-group-compact > .ant-input-group-wrapper .ant-input:focus, .ant-input-group.ant-input-group-compact > .ant-input-group-wrapper .ant-input:hover, .ant-input-group.ant-input-group-compact > .ant-select-auto-complete .ant-input:focus, .ant-input-group.ant-input-group-compact > .ant-select-auto-complete .ant-input:hover, .ant-input-group.ant-input-group-compact > .ant-select-focused, .ant-input-group.ant-input-group-compact > .ant-select > .ant-select-arrow, .ant-input-group.ant-input-group-compact > .ant-select > .ant-select-selector:focus, .ant-input-group.ant-input-group-compact > .ant-select > .ant-select-selector:hover {
  z-index: 1;
}

.ant-input-group.ant-input-group-compact > .ant-cascader-picker:first-child .ant-input, .ant-input-group.ant-input-group-compact > .ant-select-auto-complete:first-child .ant-input, .ant-input-group.ant-input-group-compact > .ant-select:first-child > .ant-select-selector, .ant-input-group.ant-input-group-compact > :first-child {
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}

.ant-input-group.ant-input-group-compact > .ant-cascader-picker-focused:last-child .ant-input, .ant-input-group.ant-input-group-compact > .ant-cascader-picker:last-child .ant-input, .ant-input-group.ant-input-group-compact > .ant-select:last-child > .ant-select-selector, .ant-input-group.ant-input-group-compact > :last-child {
  border-right-width: 1px;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
}

.ant-input-group.ant-input-group-compact > .ant-select-auto-complete .ant-input {
  vertical-align: top;
}

.ant-input-group.ant-input-group-compact .ant-input-group-wrapper + .ant-input-group-wrapper {
  margin-left: -1px;
}

.ant-input-group.ant-input-group-compact .ant-input-group-wrapper + .ant-input-group-wrapper .ant-input-affix-wrapper, .ant-input-group.ant-input-group-compact .ant-input-group-wrapper:not(:last-child).ant-input-search > .ant-input-group > .ant-input-group-addon > .ant-input-search-button {
  border-radius: 0;
}

.ant-input-group.ant-input-group-compact .ant-input-group-wrapper:not(:last-child).ant-input-search > .ant-input-group > .ant-input {
  border-radius: 2px 0 0 2px;
}

.ant-input-group-rtl .ant-input-group-addon:first-child, .ant-input-group > .ant-input-rtl:first-child {
  border-radius: 0 2px 2px 0;
}

.ant-input-group-rtl .ant-input-group-addon:first-child {
  border-right: 1px solid #d9d9d9;
  border-left: 0;
}

.ant-input-group-rtl .ant-input-group-addon:last-child {
  border-right: 0;
  border-left: 1px solid #d9d9d9;
  border-radius: 2px 0 0 2px;
}

.ant-input-group-rtl.ant-input-group-addon:last-child, .ant-input-group-rtl.ant-input-group .ant-input-affix-wrapper:not(:first-child), .ant-input-group-rtl.ant-input-group > .ant-input:last-child {
  border-radius: 2px 0 0 2px;
}

.ant-input-group-rtl.ant-input-group .ant-input-affix-wrapper:not(:last-child) {
  border-radius: 0 2px 2px 0;
}

.ant-input-group-rtl.ant-input-group.ant-input-group-compact > :not(:last-child) {
  margin-right: 0;
  margin-left: -1px;
  border-left-width: 1px;
}

.ant-input-group-rtl.ant-input-group.ant-input-group-compact > .ant-cascader-picker:first-child .ant-input, .ant-input-group-rtl.ant-input-group.ant-input-group-compact > .ant-select-auto-complete:first-child .ant-input, .ant-input-group-rtl.ant-input-group.ant-input-group-compact > .ant-select:first-child > .ant-select-selector, .ant-input-group-rtl.ant-input-group.ant-input-group-compact > :first-child {
  border-radius: 0 2px 2px 0;
}

.ant-input-group-rtl.ant-input-group.ant-input-group-compact > .ant-cascader-picker-focused:last-child .ant-input, .ant-input-group-rtl.ant-input-group.ant-input-group-compact > .ant-cascader-picker:last-child .ant-input, .ant-input-group-rtl.ant-input-group.ant-input-group-compact > .ant-select-auto-complete:last-child .ant-input, .ant-input-group-rtl.ant-input-group.ant-input-group-compact > .ant-select:last-child > .ant-select-selector, .ant-input-group-rtl.ant-input-group.ant-input-group-compact > :last-child {
  border-left-width: 1px;
  border-radius: 2px 0 0 2px;
}

.ant-input-group.ant-input-group-compact .ant-input-group-wrapper-rtl + .ant-input-group-wrapper-rtl {
  margin-right: -1px;
  margin-left: 0;
}

.ant-input-group.ant-input-group-compact .ant-input-group-wrapper-rtl:not(:last-child).ant-input-search > .ant-input-group > .ant-input {
  border-radius: 0 2px 2px 0;
}

.ant-input-group-wrapper {
  display: inline-block;
  width: 100%;
  text-align: start;
  vertical-align: top;
}

.ant-input-password-icon.anticon {
  color: rgba(0, 0, 0, 0.45);
  cursor: pointer;
  transition: all 0.3s;
}

.ant-input-password-icon.anticon:hover {
  color: rgba(0, 0, 0, 0.85);
}

.ant-input[type=color] {
  height: 32px;
}

.ant-input[type=color].ant-input-lg {
  height: 40px;
}

.ant-input[type=color].ant-input-sm {
  height: 24px;
  padding-top: 3px;
  padding-bottom: 3px;
}

.ant-input-textarea-show-count > .ant-input {
  height: 100%;
}

.ant-input-textarea-show-count:after {
  float: right;
  color: rgba(0, 0, 0, 0.45);
  white-space: nowrap;
  content: attr(data-count);
  pointer-events: none;
}

.ant-input-textarea-show-count.ant-input-textarea-in-form-item:after {
  margin-bottom: -22px;
}

.ant-input-textarea-suffix {
  position: absolute;
  top: 0;
  right: 11px;
  bottom: 0;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  margin: auto;
}

.ant-input-compact-item:not(.ant-input-compact-last-item):not(.ant-input-compact-item-rtl) {
  margin-right: -1px;
}

.ant-input-compact-item:not(.ant-input-compact-last-item).ant-input-compact-item-rtl {
  margin-left: -1px;
}

.ant-input-compact-item:active, .ant-input-compact-item:focus, .ant-input-compact-item:hover {
  z-index: 2;
}

.ant-input-compact-item[disabled] {
  z-index: 0;
}

.ant-input-compact-item:not(.ant-input-compact-first-item):not(.ant-input-compact-last-item).ant-input {
  border-radius: 0;
}

.ant-input-compact-item.ant-input.ant-input-compact-first-item:not(.ant-input-compact-last-item):not(.ant-input-compact-item-rtl) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-input-compact-item.ant-input.ant-input-compact-item-rtl.ant-input-compact-first-item:not(.ant-input-compact-last-item), .ant-input-compact-item.ant-input.ant-input-compact-last-item:not(.ant-input-compact-first-item):not(.ant-input-compact-item-rtl) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.ant-input-compact-item.ant-input.ant-input-compact-item-rtl.ant-input-compact-last-item:not(.ant-input-compact-first-item) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-input-search .ant-input:focus, .ant-input-search .ant-input:hover {
  border-color: #40a9ff;
}

.ant-input-search .ant-input:focus + .ant-input-group-addon .ant-input-search-button:not(.ant-btn-primary), .ant-input-search .ant-input:hover + .ant-input-group-addon .ant-input-search-button:not(.ant-btn-primary) {
  border-left-color: #40a9ff;
}

.ant-input-search .ant-input-affix-wrapper {
  border-radius: 0;
}

.ant-input-search .ant-input-lg {
  line-height: 1.5713;
}

.ant-input-search > .ant-input-group > .ant-input-group-addon:last-child {
  left: -1px;
  padding: 0;
  border: 0;
}

.ant-input-search > .ant-input-group > .ant-input-group-addon:last-child .ant-input-search-button {
  padding-top: 0;
  padding-bottom: 0;
  border-radius: 0 2px 2px 0;
}

.ant-input-search > .ant-input-group > .ant-input-group-addon:last-child .ant-input-search-button:not(.ant-btn-primary) {
  color: rgba(0, 0, 0, 0.45);
}

.ant-input-search > .ant-input-group > .ant-input-group-addon:last-child .ant-input-search-button:not(.ant-btn-primary).ant-btn-loading:before {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.ant-input-search-button {
  height: 32px;
}

.ant-input-search-button:focus, .ant-input-search-button:hover {
  z-index: 1;
}

.ant-input-search-large .ant-input-search-button {
  height: 40px;
}

.ant-input-search-small .ant-input-search-button {
  height: 24px;
}

.ant-input-search.ant-input-compact-item:not(.ant-input-compact-item-rtl):not(.ant-input-compact-last-item) .ant-input-group-addon .ant-input-search-button {
  margin-right: -1px;
  border-radius: 0;
}

.ant-input-search.ant-input-compact-item:not(.ant-input-compact-first-item) .ant-input, .ant-input-search.ant-input-compact-item:not(.ant-input-compact-first-item) .ant-input-affix-wrapper {
  border-radius: 0;
}

.ant-input-search.ant-input-compact-item .ant-input-affix-wrapper:active, .ant-input-search.ant-input-compact-item .ant-input-affix-wrapper:focus, .ant-input-search.ant-input-compact-item .ant-input-affix-wrapper:hover, .ant-input-search.ant-input-compact-item > .ant-input-affix-wrapper-focused, .ant-input-search.ant-input-compact-item > .ant-input-group-addon .ant-input-search-button:active, .ant-input-search.ant-input-compact-item > .ant-input-group-addon .ant-input-search-button:focus, .ant-input-search.ant-input-compact-item > .ant-input-group-addon .ant-input-search-button:hover, .ant-input-search.ant-input-compact-item > .ant-input:active, .ant-input-search.ant-input-compact-item > .ant-input:focus, .ant-input-search.ant-input-compact-item > .ant-input:hover {
  z-index: 2;
}

.ant-input-search.ant-input-compact-item-rtl:not(.ant-input-compact-last-item) .ant-input-group-addon:last-child .ant-input-search-button {
  margin-left: -1px;
  border-radius: 0;
}

.ant-input-group-rtl, .ant-input-group-wrapper-rtl {
  direction: rtl;
}

.ant-input-affix-wrapper.ant-input-affix-wrapper-rtl > input.ant-input {
  border: none;
  outline: none;
}

.ant-input-affix-wrapper-rtl .ant-input-prefix {
  margin: 0 0 0 4px;
}

.ant-input-affix-wrapper-rtl .ant-input-suffix {
  margin: 0 4px 0 0;
}

.ant-input-textarea-rtl {
  direction: rtl;
}

.ant-input-textarea-rtl.ant-input-textarea-show-count:after {
  text-align: left;
}

.ant-input-affix-wrapper-rtl .ant-input-clear-icon-has-suffix {
  margin-right: 0;
  margin-left: 4px;
}

.ant-input-affix-wrapper-rtl .ant-input-clear-icon {
  right: auto;
  left: 8px;
}

.ant-input-search-rtl {
  direction: rtl;
}

.ant-input-search-rtl .ant-input:focus + .ant-input-group-addon .ant-input-search-button:not(.ant-btn-primary), .ant-input-search-rtl .ant-input:hover + .ant-input-group-addon .ant-input-search-button:not(.ant-btn-primary) {
  border-left-color: #d9d9d9;
}

.ant-input-search-rtl .ant-input:focus + .ant-input-group-addon .ant-input-search-button:not(.ant-btn-primary):hover, .ant-input-search-rtl .ant-input:hover + .ant-input-group-addon .ant-input-search-button:not(.ant-btn-primary):hover {
  border-left-color: #40a9ff;
}

.ant-input-search-rtl > .ant-input-group > .ant-input-affix-wrapper-focused, .ant-input-search-rtl > .ant-input-group > .ant-input-affix-wrapper:hover {
  border-right-color: #40a9ff;
}

.ant-input-search-rtl > .ant-input-group > .ant-input-group-addon:last-child {
  right: -1px;
  left: auto;
}

.ant-input-search-rtl > .ant-input-group > .ant-input-group-addon:last-child .ant-input-search-button {
  border-radius: 2px 0 0 2px;
}

@media (-ms-high-contrast: none), screen and (-ms-high-contrast: active) {
  .ant-input {
    height: 32px;
  }
  .ant-input-lg {
    height: 40px;
  }
  .ant-input-sm {
    height: 24px;
  }
  .ant-input-affix-wrapper > input.ant-input {
    height: auto;
  }
}
.ant-layout {
  display: flex;
  flex: auto;
  flex-direction: column;
  min-height: 0;
  background: #f0f2f5;
}

.ant-layout, .ant-layout * {
  box-sizing: border-box;
}

.ant-layout.ant-layout-has-sider {
  flex-direction: row;
}

.ant-layout.ant-layout-has-sider > .ant-layout, .ant-layout.ant-layout-has-sider > .ant-layout-content {
  width: 0;
}

.ant-layout-footer, .ant-layout-header {
  flex: 0 0 auto;
}

.ant-layout-header {
  height: 64px;
  padding: 0 50px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 64px;
  background: #001529;
}

.ant-layout-footer {
  padding: 24px 50px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  background: #f0f2f5;
}

.ant-layout-content {
  flex: auto;
  min-height: 0;
}

.ant-layout-sider {
  position: relative;
  min-width: 0;
  background: #001529;
  transition: all 0.2s;
}

.ant-layout-sider-children {
  height: 100%;
  margin-top: -0.1px;
  padding-top: 0.1px;
}

.ant-layout-sider-children .ant-menu.ant-menu-inline-collapsed {
  width: auto;
}

.ant-layout-sider-has-trigger {
  padding-bottom: 48px;
}

.ant-layout-sider-right {
  order: 1;
}

.ant-layout-sider-trigger {
  position: fixed;
  bottom: 0;
  z-index: 1;
  height: 48px;
  color: #fff;
  line-height: 48px;
  text-align: center;
  background: #002140;
  cursor: pointer;
  transition: all 0.2s;
}

.ant-layout-sider-zero-width > * {
  overflow: hidden;
}

.ant-layout-sider-zero-width-trigger {
  position: absolute;
  top: 64px;
  right: -36px;
  z-index: 1;
  width: 36px;
  height: 42px;
  color: #fff;
  font-size: 18px;
  line-height: 42px;
  text-align: center;
  background: #001529;
  border-radius: 0 2px 2px 0;
  cursor: pointer;
  transition: background 0.3s ease;
}

.ant-layout-sider-zero-width-trigger:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  transition: all 0.3s;
  content: "";
}

.ant-layout-sider-zero-width-trigger:hover:after {
  background: hsla(0, 0%, 100%, 0.1);
}

.ant-layout-sider-zero-width-trigger-right {
  left: -36px;
  border-radius: 2px 0 0 2px;
}

.ant-layout-sider-light {
  background: #fff;
}

.ant-layout-sider-light .ant-layout-sider-trigger, .ant-layout-sider-light .ant-layout-sider-zero-width-trigger {
  color: rgba(0, 0, 0, 0.85);
  background: #fff;
}

.ant-layout-rtl {
  direction: rtl;
}

.ant-list {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
}

.ant-list * {
  outline: none;
}

.ant-list-pagination {
  margin-top: 24px;
  text-align: right;
}

.ant-list-pagination .ant-pagination-options {
  text-align: left;
}

.ant-list-more {
  margin-top: 12px;
  text-align: center;
}

.ant-list-more button {
  padding-right: 32px;
  padding-left: 32px;
}

.ant-list-spin {
  min-height: 40px;
  text-align: center;
}

.ant-list-empty-text {
  padding: 16px;
  color: rgba(0, 0, 0, 0.25);
  font-size: 14px;
  text-align: center;
}

.ant-list-items {
  margin: 0;
  padding: 0;
  list-style: none;
}

.ant-list-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  color: rgba(0, 0, 0, 0.85);
}

.ant-list-item-meta {
  display: flex;
  flex: 1;
  align-items: flex-start;
  max-width: 100%;
}

.ant-list-item-meta-avatar {
  margin-right: 16px;
}

.ant-list-item-meta-content {
  flex: 1 0;
  width: 0;
  color: rgba(0, 0, 0, 0.85);
}

.ant-list-item-meta-title {
  margin-bottom: 4px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  line-height: 1.5715;
}

.ant-list-item-meta-title > a {
  color: rgba(0, 0, 0, 0.85);
  transition: all 0.3s;
}

.ant-list-item-meta-title > a:hover {
  color: #1890ff;
}

.ant-list-item-meta-description {
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
  line-height: 1.5715;
}

.ant-list-item-action {
  flex: 0 0 auto;
  margin-left: 48px;
  padding: 0;
  font-size: 0;
  list-style: none;
}

.ant-list-item-action > li {
  position: relative;
  display: inline-block;
  padding: 0 8px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
  line-height: 1.5715;
  text-align: center;
}

.ant-list-item-action > li:first-child {
  padding-left: 0;
}

.ant-list-item-action-split {
  position: absolute;
  top: 50%;
  right: 0;
  width: 1px;
  height: 14px;
  margin-top: -7px;
  background-color: #f0f0f0;
}

.ant-list-footer, .ant-list-header {
  background: transparent;
}

.ant-list-footer, .ant-list-header {
  padding-top: 12px;
  padding-bottom: 12px;
}

.ant-list-empty {
  padding: 16px 0;
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
  text-align: center;
}

.ant-list-split .ant-list-item {
  border-bottom: 1px solid #f0f0f0;
}

.ant-list-split .ant-list-item:last-child {
  border-bottom: none;
}

.ant-list-split .ant-list-header {
  border-bottom: 1px solid #f0f0f0;
}

.ant-list-split.ant-list-empty .ant-list-footer {
  border-top: 1px solid #f0f0f0;
}

.ant-list-loading .ant-list-spin-nested-loading {
  min-height: 32px;
}

.ant-list-split.ant-list-something-after-last-item .ant-spin-container > .ant-list-items > .ant-list-item:last-child {
  border-bottom: 1px solid #f0f0f0;
}

.ant-list-lg .ant-list-item {
  padding: 16px 24px;
}

.ant-list-sm .ant-list-item {
  padding: 8px 16px;
}

.ant-list-vertical .ant-list-item {
  align-items: normal;
}

.ant-list-vertical .ant-list-item-main {
  display: block;
  flex: 1;
}

.ant-list-vertical .ant-list-item-extra {
  margin-left: 40px;
}

.ant-list-vertical .ant-list-item-meta {
  margin-bottom: 16px;
}

.ant-list-vertical .ant-list-item-meta-title {
  margin-bottom: 12px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 16px;
  line-height: 24px;
}

.ant-list-vertical .ant-list-item-action {
  margin-top: 16px;
  margin-left: auto;
}

.ant-list-vertical .ant-list-item-action > li {
  padding: 0 16px;
}

.ant-list-vertical .ant-list-item-action > li:first-child {
  padding-left: 0;
}

.ant-list-grid .ant-col > .ant-list-item {
  display: block;
  max-width: 100%;
  margin-bottom: 16px;
  padding-top: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.ant-list-item-no-flex {
  display: block;
}

.ant-list:not(.ant-list-vertical) .ant-list-item-no-flex .ant-list-item-action {
  float: right;
}

.ant-list-bordered {
  border: 1px solid #d9d9d9;
  border-radius: 2px;
}

.ant-list-bordered .ant-list-footer, .ant-list-bordered .ant-list-header, .ant-list-bordered .ant-list-item {
  padding-right: 24px;
  padding-left: 24px;
}

.ant-list-bordered .ant-list-pagination {
  margin: 16px 24px;
}

.ant-list-bordered.ant-list-sm .ant-list-footer, .ant-list-bordered.ant-list-sm .ant-list-header, .ant-list-bordered.ant-list-sm .ant-list-item {
  padding: 8px 16px;
}

.ant-list-bordered.ant-list-lg .ant-list-footer, .ant-list-bordered.ant-list-lg .ant-list-header, .ant-list-bordered.ant-list-lg .ant-list-item {
  padding: 16px 24px;
}

@media screen and (max-width: 768px) {
  .ant-list-item-action, .ant-list-vertical .ant-list-item-extra {
    margin-left: 24px;
  }
}
@media screen and (max-width: 576px) {
  .ant-list-item {
    flex-wrap: wrap;
  }
  .ant-list-item-action {
    margin-left: 12px;
  }
  .ant-list-vertical .ant-list-item {
    flex-wrap: wrap-reverse;
  }
  .ant-list-vertical .ant-list-item-main {
    min-width: 220px;
  }
  .ant-list-vertical .ant-list-item-extra {
    margin: auto auto 16px;
  }
}
.ant-list-rtl {
  direction: rtl;
  text-align: right;
}

.ant-list-rtl .ReactVirtualized__List .ant-list-item {
  direction: rtl;
}

.ant-list-rtl .ant-list-pagination {
  text-align: left;
}

.ant-list-rtl .ant-list-item-meta-avatar {
  margin-right: 0;
  margin-left: 16px;
}

.ant-list-rtl .ant-list-item-action {
  margin-right: 48px;
  margin-left: 0;
}

.ant-list.ant-list-rtl .ant-list-item-action > li:first-child {
  padding-right: 0;
  padding-left: 16px;
}

.ant-list-rtl .ant-list-item-action-split {
  right: auto;
  left: 0;
}

.ant-list-rtl.ant-list-vertical .ant-list-item-extra {
  margin-right: 40px;
  margin-left: 0;
}

.ant-list-rtl.ant-list-vertical .ant-list-item-action {
  margin-right: auto;
}

.ant-list-rtl .ant-list-vertical .ant-list-item-action > li:first-child {
  padding-right: 0;
  padding-left: 16px;
}

.ant-list-rtl .ant-list:not(.ant-list-vertical) .ant-list-item-no-flex .ant-list-item-action {
  float: left;
}

@media screen and (max-width: 768px) {
  .ant-list-rtl .ant-list-item-action, .ant-list-rtl .ant-list-vertical .ant-list-item-extra {
    margin-right: 24px;
    margin-left: 0;
  }
}
@media screen and (max-width: 576px) {
  .ant-list-rtl .ant-list-item-action {
    margin-right: 22px;
    margin-left: 0;
  }
  .ant-list-rtl.ant-list-vertical .ant-list-item-extra {
    margin: auto auto 16px;
  }
}
.ant-mentions-status-error:not(.ant-mentions-disabled):not(.ant-mentions-borderless).ant-mentions, .ant-mentions-status-error:not(.ant-mentions-disabled):not(.ant-mentions-borderless).ant-mentions:hover {
  background: #fff;
  border-color: #ff4d4f;
}

.ant-mentions-status-error:not(.ant-mentions-disabled):not(.ant-mentions-borderless).ant-mentions-focused, .ant-mentions-status-error:not(.ant-mentions-disabled):not(.ant-mentions-borderless).ant-mentions:focus {
  border-color: #ff7875;
  box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-mentions-status-error .ant-input-prefix {
  color: #ff4d4f;
}

.ant-mentions-status-warning:not(.ant-mentions-disabled):not(.ant-mentions-borderless).ant-mentions, .ant-mentions-status-warning:not(.ant-mentions-disabled):not(.ant-mentions-borderless).ant-mentions:hover {
  background: #fff;
  border-color: #faad14;
}

.ant-mentions-status-warning:not(.ant-mentions-disabled):not(.ant-mentions-borderless).ant-mentions-focused, .ant-mentions-status-warning:not(.ant-mentions-disabled):not(.ant-mentions-borderless).ant-mentions:focus {
  border-color: #ffc53d;
  box-shadow: 0 0 0 2px rgba(250, 173, 20, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-mentions-status-warning .ant-input-prefix {
  color: #faad14;
}

.ant-mentions {
  box-sizing: border-box;
  margin: 0;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: "tnum";
  width: 100%;
  min-width: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  transition: all 0.3s;
  position: relative;
  display: inline-block;
  height: auto;
  padding: 0;
  overflow: hidden;
  line-height: 1.5715;
  white-space: pre-wrap;
  vertical-align: bottom;
}

.ant-mentions::-moz-placeholder {
  color: #bfbfbf;
  -moz-user-select: none;
  user-select: none;
}

.ant-mentions:-ms-input-placeholder {
  color: #bfbfbf;
  -ms-user-select: none;
  user-select: none;
}

.ant-mentions::placeholder {
  color: #bfbfbf;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-mentions:-moz-placeholder-shown {
  text-overflow: ellipsis;
}

.ant-mentions:-ms-input-placeholder {
  text-overflow: ellipsis;
}

.ant-mentions:placeholder-shown {
  text-overflow: ellipsis;
}

.ant-mentions-focused, .ant-mentions:focus, .ant-mentions:hover {
  border-color: #40a9ff;
  border-right-width: 1px;
}

.ant-mentions-focused, .ant-mentions:focus {
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  outline: 0;
}

.ant-mentions-disabled {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}

.ant-mentions-disabled:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}

.ant-mentions[disabled] {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}

.ant-mentions[disabled]:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}

.ant-mentions-borderless, .ant-mentions-borderless-disabled, .ant-mentions-borderless-focused, .ant-mentions-borderless:focus, .ant-mentions-borderless:hover, .ant-mentions-borderless[disabled] {
  background-color: transparent;
  border: none;
  box-shadow: none;
}

textarea.ant-mentions {
  max-width: 100%;
  height: auto;
  min-height: 32px;
  line-height: 1.5715;
  vertical-align: bottom;
  transition: all 0.3s, height 0s;
}

.ant-mentions-lg {
  padding: 6.5px 11px;
  font-size: 16px;
}

.ant-mentions-sm {
  padding: 0 7px;
}

.ant-mentions-disabled > textarea {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}

.ant-mentions-disabled > textarea:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}

.ant-mentions-focused {
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-mentions-measure, .ant-mentions > textarea {
  min-height: 30px;
  margin: 0;
  padding: 4px 11px;
  overflow: inherit;
  overflow-x: hidden;
  overflow-y: auto;
  font-weight: inherit;
  font-size: inherit;
  font-family: inherit;
  font-style: inherit;
  font-variant: inherit;
  font-size-adjust: inherit;
  font-stretch: inherit;
  line-height: inherit;
  direction: inherit;
  letter-spacing: inherit;
  white-space: inherit;
  text-align: inherit;
  vertical-align: top;
  word-wrap: break-word;
  word-break: inherit;
  -moz-tab-size: inherit;
  -o-tab-size: inherit;
  tab-size: inherit;
}

.ant-mentions > textarea {
  width: 100%;
  border: none;
  outline: none;
  resize: none;
}

.ant-mentions > textarea::-moz-placeholder {
  color: #bfbfbf;
  -moz-user-select: none;
  user-select: none;
}

.ant-mentions > textarea:-ms-input-placeholder {
  color: #bfbfbf;
  -ms-user-select: none;
  user-select: none;
}

.ant-mentions > textarea::placeholder {
  color: #bfbfbf;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-mentions > textarea:-moz-placeholder-shown {
  text-overflow: ellipsis;
}

.ant-mentions > textarea:-ms-input-placeholder {
  text-overflow: ellipsis;
}

.ant-mentions > textarea:placeholder-shown {
  text-overflow: ellipsis;
}

.ant-mentions-measure {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  color: transparent;
  pointer-events: none;
}

.ant-mentions-measure > span {
  display: inline-block;
  min-height: 1em;
}

.ant-mentions-dropdown {
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: absolute;
  top: -9999px;
  left: -9999px;
  z-index: 1050;
  box-sizing: border-box;
  font-size: 14px;
  font-variant: normal;
  background-color: #fff;
  border-radius: 2px;
  outline: none;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
}

.ant-mentions-dropdown-hidden {
  display: none;
}

.ant-mentions-dropdown-menu {
  max-height: 250px;
  margin-bottom: 0;
  padding-left: 0;
  overflow: auto;
  list-style: none;
  outline: none;
}

.ant-mentions-dropdown-menu-item {
  position: relative;
  display: block;
  min-width: 100px;
  padding: 5px 12px;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 400;
  line-height: 1.5715;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  transition: background 0.3s ease;
}

.ant-mentions-dropdown-menu-item:hover {
  background-color: #f5f5f5;
}

.ant-mentions-dropdown-menu-item:first-child {
  border-radius: 2px 2px 0 0;
}

.ant-mentions-dropdown-menu-item:last-child {
  border-radius: 0 0 2px 2px;
}

.ant-mentions-dropdown-menu-item-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ant-mentions-dropdown-menu-item-disabled:hover {
  color: rgba(0, 0, 0, 0.25);
  background-color: #fff;
  cursor: not-allowed;
}

.ant-mentions-dropdown-menu-item-selected {
  color: rgba(0, 0, 0, 0.85);
  font-weight: 600;
  background-color: #fafafa;
}

.ant-mentions-dropdown-menu-item-active {
  background-color: #f5f5f5;
}

.ant-mentions-suffix {
  position: absolute;
  top: 0;
  right: 11px;
  bottom: 0;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  margin: auto;
}

.ant-mentions-rtl {
  direction: rtl;
}

.ant-menu-item-danger.ant-menu-item, .ant-menu-item-danger.ant-menu-item-active, .ant-menu-item-danger.ant-menu-item:hover {
  color: #ff4d4f;
}

.ant-menu-item-danger.ant-menu-item:active {
  background: #fff1f0;
}

.ant-menu-item-danger.ant-menu-item-selected, .ant-menu-item-danger.ant-menu-item-selected > a, .ant-menu-item-danger.ant-menu-item-selected > a:hover {
  color: #ff4d4f;
}

.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-danger.ant-menu-item-selected {
  background-color: #fff1f0;
}

.ant-menu-inline .ant-menu-item-danger.ant-menu-item:after {
  border-right-color: #ff4d4f;
}

.ant-menu-dark .ant-menu-item-danger.ant-menu-item, .ant-menu-dark .ant-menu-item-danger.ant-menu-item:hover, .ant-menu-dark .ant-menu-item-danger.ant-menu-item > a {
  color: #ff4d4f;
}

.ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-danger.ant-menu-item-selected {
  color: #fff;
  background-color: #ff4d4f;
}

.ant-menu {
  box-sizing: border-box;
  font-variant: tabular-nums;
  line-height: 1.5715;
  font-feature-settings: "tnum";
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  line-height: 0;
  text-align: left;
  list-style: none;
  background: #fff;
  outline: none;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
  transition: background 0.3s, width 0.3s cubic-bezier(0.2, 0, 0, 1) 0s;
}

.ant-menu:after, .ant-menu:before {
  display: table;
  content: "";
}

.ant-menu:after {
  clear: both;
}

.ant-menu.ant-menu-root:focus-visible {
  box-shadow: 0 0 0 2px #bae7ff;
}

.ant-menu ol, .ant-menu ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.ant-menu-overflow {
  display: flex;
}

.ant-menu-overflow-item {
  flex: none;
}

.ant-menu-hidden, .ant-menu-submenu-hidden {
  display: none;
}

.ant-menu-item-group-title {
  height: 1.5715;
  padding: 8px 16px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
  line-height: 1.5715;
  transition: all 0.3s;
}

.ant-menu-horizontal .ant-menu-submenu {
  transition: border-color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-menu-submenu, .ant-menu-submenu-inline {
  transition: border-color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), padding 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-menu-submenu-selected {
  color: #1890ff;
}

.ant-menu-item:active, .ant-menu-submenu-title:active {
  background: #e6f7ff;
}

.ant-menu-submenu .ant-menu-sub {
  cursor: auto;
  transition: background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-menu-title-content {
  transition: color 0.3s;
}

.ant-menu-item a {
  color: rgba(0, 0, 0, 0.85);
}

.ant-menu-item a:hover {
  color: #1890ff;
}

.ant-menu-item a:before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: transparent;
  content: "";
}

.ant-menu-item > .ant-badge a {
  color: rgba(0, 0, 0, 0.85);
}

.ant-menu-item > .ant-badge a:hover {
  color: #1890ff;
}

.ant-menu-item-divider {
  overflow: hidden;
  line-height: 0;
  border: solid #f0f0f0;
  border-width: 1px 0 0;
}

.ant-menu-item-divider-dashed {
  border-style: dashed;
}

.ant-menu-horizontal .ant-menu-item, .ant-menu-horizontal .ant-menu-submenu {
  margin-top: -1px;
}

.ant-menu-horizontal > .ant-menu-item-active, .ant-menu-horizontal > .ant-menu-item:hover, .ant-menu-horizontal > .ant-menu-submenu .ant-menu-submenu-title:hover {
  background-color: transparent;
}

.ant-menu-item-selected, .ant-menu-item-selected a, .ant-menu-item-selected a:hover {
  color: #1890ff;
}

.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background-color: #e6f7ff;
}

.ant-menu-inline, .ant-menu-vertical, .ant-menu-vertical-left {
  border-right: 1px solid #f0f0f0;
}

.ant-menu-vertical-right {
  border-left: 1px solid #f0f0f0;
}

.ant-menu-vertical-left.ant-menu-sub, .ant-menu-vertical-right.ant-menu-sub, .ant-menu-vertical.ant-menu-sub {
  min-width: 160px;
  max-height: calc(100vh - 100px);
  padding: 0;
  overflow: hidden;
  border-right: 0;
}

.ant-menu-vertical-left.ant-menu-sub:not([class*=-active]), .ant-menu-vertical-right.ant-menu-sub:not([class*=-active]), .ant-menu-vertical.ant-menu-sub:not([class*=-active]) {
  overflow-x: hidden;
  overflow-y: auto;
}

.ant-menu-vertical-left.ant-menu-sub .ant-menu-item, .ant-menu-vertical-right.ant-menu-sub .ant-menu-item, .ant-menu-vertical.ant-menu-sub .ant-menu-item {
  left: 0;
  margin-left: 0;
  border-right: 0;
}

.ant-menu-vertical-left.ant-menu-sub .ant-menu-item:after, .ant-menu-vertical-right.ant-menu-sub .ant-menu-item:after, .ant-menu-vertical.ant-menu-sub .ant-menu-item:after {
  border-right: 0;
}

.ant-menu-vertical-left.ant-menu-sub > .ant-menu-item, .ant-menu-vertical-left.ant-menu-sub > .ant-menu-submenu, .ant-menu-vertical-right.ant-menu-sub > .ant-menu-item, .ant-menu-vertical-right.ant-menu-sub > .ant-menu-submenu, .ant-menu-vertical.ant-menu-sub > .ant-menu-item, .ant-menu-vertical.ant-menu-sub > .ant-menu-submenu {
  transform-origin: 0 0;
}

.ant-menu-horizontal.ant-menu-sub {
  min-width: 114px;
}

.ant-menu-horizontal .ant-menu-item, .ant-menu-horizontal .ant-menu-submenu-title {
  transition: border-color 0.3s, background 0.3s;
}

.ant-menu-item, .ant-menu-submenu-title {
  position: relative;
  display: block;
  margin: 0;
  padding: 0 20px;
  white-space: nowrap;
  cursor: pointer;
  transition: border-color 0.3s, background 0.3s, padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-menu-item .ant-menu-item-icon, .ant-menu-item .anticon, .ant-menu-submenu-title .ant-menu-item-icon, .ant-menu-submenu-title .anticon {
  min-width: 14px;
  font-size: 14px;
  transition: font-size 0.15s cubic-bezier(0.215, 0.61, 0.355, 1), margin 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), color 0.3s;
}

.ant-menu-item .ant-menu-item-icon + span, .ant-menu-item .anticon + span, .ant-menu-submenu-title .ant-menu-item-icon + span, .ant-menu-submenu-title .anticon + span {
  margin-left: 10px;
  opacity: 1;
  transition: opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), margin 0.3s, color 0.3s;
}

.ant-menu-item .ant-menu-item-icon.svg, .ant-menu-submenu-title .ant-menu-item-icon.svg {
  vertical-align: -0.125em;
}

.ant-menu-item.ant-menu-item-only-child > .ant-menu-item-icon, .ant-menu-item.ant-menu-item-only-child > .anticon, .ant-menu-submenu-title.ant-menu-item-only-child > .ant-menu-item-icon, .ant-menu-submenu-title.ant-menu-item-only-child > .anticon {
  margin-right: 0;
}

.ant-menu-item:not(.ant-menu-item-disabled):focus-visible, .ant-menu-submenu-title:not(.ant-menu-item-disabled):focus-visible {
  box-shadow: 0 0 0 2px #bae7ff;
}

.ant-menu > .ant-menu-item-divider {
  margin: 1px 0;
  padding: 0;
}

.ant-menu-submenu-popup {
  position: absolute;
  z-index: 1050;
  background: transparent;
  border-radius: 2px;
  box-shadow: none;
  transform-origin: 0 0;
}

.ant-menu-submenu-popup:before {
  position: absolute;
  top: -7px;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  opacity: 0.0001;
  content: " ";
}

.ant-menu-submenu-placement-rightTop:before {
  top: 0;
  left: -7px;
}

.ant-menu-submenu > .ant-menu {
  background-color: #fff;
  border-radius: 2px;
}

.ant-menu-submenu > .ant-menu-submenu-title:after {
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-menu-submenu-popup > .ant-menu {
  background-color: #fff;
}

.ant-menu-submenu-arrow, .ant-menu-submenu-expand-icon {
  position: absolute;
  top: 50%;
  right: 16px;
  width: 10px;
  color: rgba(0, 0, 0, 0.85);
  transform: translateY(-50%);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-menu-submenu-arrow:after, .ant-menu-submenu-arrow:before {
  position: absolute;
  width: 6px;
  height: 1.5px;
  background-color: currentcolor;
  border-radius: 2px;
  transition: background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), top 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  content: "";
}

.ant-menu-submenu-arrow:before {
  transform: rotate(45deg) translateY(-2.5px);
}

.ant-menu-submenu-arrow:after {
  transform: rotate(-45deg) translateY(2.5px);
}

.ant-menu-submenu:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow, .ant-menu-submenu:hover > .ant-menu-submenu-title > .ant-menu-submenu-expand-icon {
  color: #1890ff;
}

.ant-menu-inline-collapsed .ant-menu-submenu-arrow:before, .ant-menu-submenu-inline .ant-menu-submenu-arrow:before {
  transform: rotate(-45deg) translateX(2.5px);
}

.ant-menu-inline-collapsed .ant-menu-submenu-arrow:after, .ant-menu-submenu-inline .ant-menu-submenu-arrow:after {
  transform: rotate(45deg) translateX(-2.5px);
}

.ant-menu-submenu-horizontal .ant-menu-submenu-arrow {
  display: none;
}

.ant-menu-submenu-open.ant-menu-submenu-inline > .ant-menu-submenu-title > .ant-menu-submenu-arrow {
  transform: translateY(-2px);
}

.ant-menu-submenu-open.ant-menu-submenu-inline > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after {
  transform: rotate(-45deg) translateX(-2.5px);
}

.ant-menu-submenu-open.ant-menu-submenu-inline > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before {
  transform: rotate(45deg) translateX(2.5px);
}

.ant-menu-vertical-left .ant-menu-submenu-selected, .ant-menu-vertical-right .ant-menu-submenu-selected, .ant-menu-vertical .ant-menu-submenu-selected {
  color: #1890ff;
}

.ant-menu-horizontal {
  line-height: 46px;
  border: 0;
  border-bottom: 1px solid #f0f0f0;
  box-shadow: none;
}

.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu {
  margin-top: -1px;
  margin-bottom: 0;
  padding: 0 20px;
}

.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-active, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-open, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item:hover, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-active, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-open, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-selected, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu:hover {
  color: #1890ff;
}

.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-active:after, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-open:after, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected:after, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item:hover:after, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-active:after, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-open:after, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-selected:after, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu:hover:after {
  border-bottom: 2px solid #1890ff;
}

.ant-menu-horizontal > .ant-menu-item, .ant-menu-horizontal > .ant-menu-submenu {
  position: relative;
  top: 1px;
  display: inline-block;
  vertical-align: bottom;
}

.ant-menu-horizontal > .ant-menu-item:after, .ant-menu-horizontal > .ant-menu-submenu:after {
  position: absolute;
  right: 20px;
  bottom: 0;
  left: 20px;
  border-bottom: 2px solid transparent;
  transition: border-color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  content: "";
}

.ant-menu-horizontal > .ant-menu-submenu > .ant-menu-submenu-title {
  padding: 0;
}

.ant-menu-horizontal > .ant-menu-item a {
  color: rgba(0, 0, 0, 0.85);
}

.ant-menu-horizontal > .ant-menu-item a:hover {
  color: #1890ff;
}

.ant-menu-horizontal > .ant-menu-item a:before {
  bottom: -2px;
}

.ant-menu-horizontal > .ant-menu-item-selected a {
  color: #1890ff;
}

.ant-menu-horizontal:after {
  display: block;
  clear: both;
  height: 0;
  content: " ";
}

.ant-menu-inline .ant-menu-item, .ant-menu-vertical-left .ant-menu-item, .ant-menu-vertical-right .ant-menu-item, .ant-menu-vertical .ant-menu-item {
  position: relative;
}

.ant-menu-inline .ant-menu-item:after, .ant-menu-vertical-left .ant-menu-item:after, .ant-menu-vertical-right .ant-menu-item:after, .ant-menu-vertical .ant-menu-item:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  border-right: 3px solid #1890ff;
  transform: scaleY(0.0001);
  opacity: 0;
  transition: transform 0.15s cubic-bezier(0.215, 0.61, 0.355, 1), opacity 0.15s cubic-bezier(0.215, 0.61, 0.355, 1);
  content: "";
}

.ant-menu-inline .ant-menu-item, .ant-menu-inline .ant-menu-submenu-title, .ant-menu-vertical-left .ant-menu-item, .ant-menu-vertical-left .ant-menu-submenu-title, .ant-menu-vertical-right .ant-menu-item, .ant-menu-vertical-right .ant-menu-submenu-title, .ant-menu-vertical .ant-menu-item, .ant-menu-vertical .ant-menu-submenu-title {
  height: 40px;
  margin-top: 4px;
  margin-bottom: 4px;
  padding: 0 16px;
  overflow: hidden;
  line-height: 40px;
  text-overflow: ellipsis;
}

.ant-menu-inline .ant-menu-submenu, .ant-menu-vertical-left .ant-menu-submenu, .ant-menu-vertical-right .ant-menu-submenu, .ant-menu-vertical .ant-menu-submenu {
  padding-bottom: 0.02px;
}

.ant-menu-inline .ant-menu-item:not(:last-child), .ant-menu-vertical-left .ant-menu-item:not(:last-child), .ant-menu-vertical-right .ant-menu-item:not(:last-child), .ant-menu-vertical .ant-menu-item:not(:last-child) {
  margin-bottom: 8px;
}

.ant-menu-inline > .ant-menu-item, .ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title, .ant-menu-vertical-left > .ant-menu-item, .ant-menu-vertical-left > .ant-menu-submenu > .ant-menu-submenu-title, .ant-menu-vertical-right > .ant-menu-item, .ant-menu-vertical-right > .ant-menu-submenu > .ant-menu-submenu-title, .ant-menu-vertical > .ant-menu-item, .ant-menu-vertical > .ant-menu-submenu > .ant-menu-submenu-title {
  height: 40px;
  line-height: 40px;
}

.ant-menu-vertical .ant-menu-item-group-list .ant-menu-submenu-title, .ant-menu-vertical .ant-menu-submenu-title {
  padding-right: 34px;
}

.ant-menu-inline {
  width: 100%;
}

.ant-menu-inline .ant-menu-item-selected:after, .ant-menu-inline .ant-menu-selected:after {
  transform: scaleY(1);
  opacity: 1;
  transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-menu-inline .ant-menu-item, .ant-menu-inline .ant-menu-submenu-title {
  width: calc(100% + 1px);
}

.ant-menu-inline .ant-menu-item-group-list .ant-menu-submenu-title, .ant-menu-inline .ant-menu-submenu-title {
  padding-right: 34px;
}

.ant-menu-inline.ant-menu-root .ant-menu-item, .ant-menu-inline.ant-menu-root .ant-menu-submenu-title {
  display: flex;
  align-items: center;
  transition: border-color 0.3s, background 0.3s, padding 0.1s cubic-bezier(0.215, 0.61, 0.355, 1);
}

.ant-menu-inline.ant-menu-root .ant-menu-item > .ant-menu-title-content, .ant-menu-inline.ant-menu-root .ant-menu-submenu-title > .ant-menu-title-content {
  flex: auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ant-menu-inline.ant-menu-root .ant-menu-item > *, .ant-menu-inline.ant-menu-root .ant-menu-submenu-title > * {
  flex: none;
}

.ant-menu.ant-menu-inline-collapsed {
  width: 80px;
}

.ant-menu.ant-menu-inline-collapsed > .ant-menu-item, .ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item, .ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title, .ant-menu.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title {
  left: 0;
  padding: 0 calc(50% - 8px);
  text-overflow: clip;
}

.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .ant-menu-submenu-arrow, .ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-submenu-arrow, .ant-menu.ant-menu-inline-collapsed > .ant-menu-item .ant-menu-submenu-arrow, .ant-menu.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-submenu-arrow {
  opacity: 0;
}

.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .ant-menu-item-icon, .ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .anticon, .ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-item-icon, .ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title .anticon, .ant-menu.ant-menu-inline-collapsed > .ant-menu-item .ant-menu-item-icon, .ant-menu.ant-menu-inline-collapsed > .ant-menu-item .anticon, .ant-menu.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-item-icon, .ant-menu.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .anticon {
  margin: 0;
  font-size: 16px;
  line-height: 40px;
}

.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .ant-menu-item-icon + span, .ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .anticon + span, .ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-item-icon + span, .ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title .anticon + span, .ant-menu.ant-menu-inline-collapsed > .ant-menu-item .ant-menu-item-icon + span, .ant-menu.ant-menu-inline-collapsed > .ant-menu-item .anticon + span, .ant-menu.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-item-icon + span, .ant-menu.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .anticon + span {
  display: inline-block;
  opacity: 0;
}

.ant-menu.ant-menu-inline-collapsed .ant-menu-item-icon, .ant-menu.ant-menu-inline-collapsed .anticon {
  display: inline-block;
}

.ant-menu.ant-menu-inline-collapsed-tooltip {
  pointer-events: none;
}

.ant-menu.ant-menu-inline-collapsed-tooltip .ant-menu-item-icon, .ant-menu.ant-menu-inline-collapsed-tooltip .anticon {
  display: none;
}

.ant-menu.ant-menu-inline-collapsed-tooltip a {
  color: hsla(0, 0%, 100%, 0.85);
}

.ant-menu.ant-menu-inline-collapsed .ant-menu-item-group-title {
  padding-right: 4px;
  padding-left: 4px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ant-menu-item-group-list {
  margin: 0;
  padding: 0;
}

.ant-menu-item-group-list .ant-menu-item, .ant-menu-item-group-list .ant-menu-submenu-title {
  padding: 0 16px 0 28px;
}

.ant-menu-root.ant-menu-inline, .ant-menu-root.ant-menu-vertical, .ant-menu-root.ant-menu-vertical-left, .ant-menu-root.ant-menu-vertical-right {
  box-shadow: none;
}

.ant-menu-root.ant-menu-inline-collapsed .ant-menu-item > .ant-menu-inline-collapsed-noicon, .ant-menu-root.ant-menu-inline-collapsed .ant-menu-submenu .ant-menu-submenu-title > .ant-menu-inline-collapsed-noicon {
  font-size: 16px;
  text-align: center;
}

.ant-menu-sub.ant-menu-inline {
  padding: 0;
  background: #fafafa;
  border-radius: 0;
  box-shadow: none;
}

.ant-menu-sub.ant-menu-inline > .ant-menu-item, .ant-menu-sub.ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {
  height: 40px;
  line-height: 40px;
  list-style-position: inside;
  list-style-type: disc;
}

.ant-menu-sub.ant-menu-inline .ant-menu-item-group-title {
  padding-left: 32px;
}

.ant-menu-item-disabled, .ant-menu-submenu-disabled {
  color: rgba(0, 0, 0, 0.25) !important;
  background: none;
  cursor: not-allowed;
}

.ant-menu-item-disabled:after, .ant-menu-submenu-disabled:after {
  border-color: transparent !important;
}

.ant-menu-item-disabled a, .ant-menu-submenu-disabled a {
  color: rgba(0, 0, 0, 0.25) !important;
  pointer-events: none;
}

.ant-menu-item-disabled > .ant-menu-submenu-title, .ant-menu-submenu-disabled > .ant-menu-submenu-title {
  color: rgba(0, 0, 0, 0.25) !important;
  cursor: not-allowed;
}

.ant-menu-item-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after, .ant-menu-item-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before, .ant-menu-submenu-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after, .ant-menu-submenu-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before {
  background: rgba(0, 0, 0, 0.25) !important;
}

.ant-layout-header .ant-menu {
  line-height: inherit;
}

.ant-menu-inline-collapsed-tooltip a, .ant-menu-inline-collapsed-tooltip a:hover {
  color: #fff;
}

.ant-menu-light .ant-menu-item-active, .ant-menu-light .ant-menu-item:hover, .ant-menu-light .ant-menu-submenu-active, .ant-menu-light .ant-menu-submenu-title:hover, .ant-menu-light .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open {
  color: #1890ff;
}

.ant-menu-dark .ant-menu-item:focus-visible, .ant-menu-dark .ant-menu-submenu-title:focus-visible, .ant-menu.ant-menu-root:focus-visible {
  box-shadow: 0 0 0 2px #096dd9;
}

.ant-menu-dark .ant-menu-sub, .ant-menu.ant-menu-dark, .ant-menu.ant-menu-dark .ant-menu-sub {
  color: hsla(0, 0%, 100%, 0.65);
  background: #001529;
}

.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow, .ant-menu.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow, .ant-menu.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow {
  opacity: 0.45;
  transition: all 0.3s;
}

.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow:after, .ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow:before, .ant-menu.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow:after, .ant-menu.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow:before, .ant-menu.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow:after, .ant-menu.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow:before {
  background: #fff;
}

.ant-menu-dark.ant-menu-submenu-popup {
  background: transparent;
}

.ant-menu-dark .ant-menu-inline.ant-menu-sub {
  background: #000c17;
}

.ant-menu-dark.ant-menu-horizontal {
  border-bottom: 0;
}

.ant-menu-dark.ant-menu-horizontal > .ant-menu-item, .ant-menu-dark.ant-menu-horizontal > .ant-menu-submenu {
  top: 0;
  margin-top: 0;
  padding: 0 20px;
  border-color: #001529;
  border-bottom: 0;
}

.ant-menu-dark.ant-menu-horizontal > .ant-menu-item:hover {
  background-color: #1890ff;
}

.ant-menu-dark.ant-menu-horizontal > .ant-menu-item > a:before {
  bottom: 0;
}

.ant-menu-dark .ant-menu-item, .ant-menu-dark .ant-menu-item-group-title, .ant-menu-dark .ant-menu-item > a, .ant-menu-dark .ant-menu-item > span > a {
  color: hsla(0, 0%, 100%, 0.65);
}

.ant-menu-dark.ant-menu-inline, .ant-menu-dark.ant-menu-vertical, .ant-menu-dark.ant-menu-vertical-left, .ant-menu-dark.ant-menu-vertical-right {
  border-right: 0;
}

.ant-menu-dark.ant-menu-inline .ant-menu-item, .ant-menu-dark.ant-menu-vertical-left .ant-menu-item, .ant-menu-dark.ant-menu-vertical-right .ant-menu-item, .ant-menu-dark.ant-menu-vertical .ant-menu-item {
  left: 0;
  margin-left: 0;
  border-right: 0;
}

.ant-menu-dark.ant-menu-inline .ant-menu-item:after, .ant-menu-dark.ant-menu-vertical-left .ant-menu-item:after, .ant-menu-dark.ant-menu-vertical-right .ant-menu-item:after, .ant-menu-dark.ant-menu-vertical .ant-menu-item:after {
  border-right: 0;
}

.ant-menu-dark.ant-menu-inline .ant-menu-item, .ant-menu-dark.ant-menu-inline .ant-menu-submenu-title {
  width: 100%;
}

.ant-menu-dark .ant-menu-item-active, .ant-menu-dark .ant-menu-item:hover, .ant-menu-dark .ant-menu-submenu-active, .ant-menu-dark .ant-menu-submenu-open, .ant-menu-dark .ant-menu-submenu-selected, .ant-menu-dark .ant-menu-submenu-title:hover {
  color: #fff;
  background-color: transparent;
}

.ant-menu-dark .ant-menu-item-active > a, .ant-menu-dark .ant-menu-item-active > span > a, .ant-menu-dark .ant-menu-item:hover > a, .ant-menu-dark .ant-menu-item:hover > span > a, .ant-menu-dark .ant-menu-submenu-active > a, .ant-menu-dark .ant-menu-submenu-active > span > a, .ant-menu-dark .ant-menu-submenu-open > a, .ant-menu-dark .ant-menu-submenu-open > span > a, .ant-menu-dark .ant-menu-submenu-selected > a, .ant-menu-dark .ant-menu-submenu-selected > span > a, .ant-menu-dark .ant-menu-submenu-title:hover > a, .ant-menu-dark .ant-menu-submenu-title:hover > span > a {
  color: #fff;
}

.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow, .ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow, .ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow, .ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title > .ant-menu-submenu-arrow, .ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title > .ant-menu-submenu-arrow, .ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow {
  opacity: 1;
}

.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after, .ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before, .ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after, .ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before, .ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after, .ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before, .ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after, .ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before, .ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after, .ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before, .ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after, .ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before {
  background: #fff;
}

.ant-menu-dark .ant-menu-item:hover {
  background-color: transparent;
}

.ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background-color: #1890ff;
}

.ant-menu-dark .ant-menu-item-selected {
  color: #fff;
  border-right: 0;
}

.ant-menu-dark .ant-menu-item-selected:after {
  border-right: 0;
}

.ant-menu-dark .ant-menu-item-selected .ant-menu-item-icon, .ant-menu-dark .ant-menu-item-selected .ant-menu-item-icon + span, .ant-menu-dark .ant-menu-item-selected .anticon, .ant-menu-dark .ant-menu-item-selected .anticon + span, .ant-menu-dark .ant-menu-item-selected > a, .ant-menu-dark .ant-menu-item-selected > a:hover, .ant-menu-dark .ant-menu-item-selected > span > a, .ant-menu-dark .ant-menu-item-selected > span > a:hover {
  color: #fff;
}

.ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-selected, .ant-menu.ant-menu-dark .ant-menu-item-selected {
  background-color: #1890ff;
}

.ant-menu-dark .ant-menu-item-disabled, .ant-menu-dark .ant-menu-item-disabled > a, .ant-menu-dark .ant-menu-item-disabled > span > a, .ant-menu-dark .ant-menu-submenu-disabled, .ant-menu-dark .ant-menu-submenu-disabled > a, .ant-menu-dark .ant-menu-submenu-disabled > span > a {
  color: hsla(0, 0%, 100%, 0.35) !important;
  opacity: 0.8;
}

.ant-menu-dark .ant-menu-item-disabled > .ant-menu-submenu-title, .ant-menu-dark .ant-menu-submenu-disabled > .ant-menu-submenu-title {
  color: hsla(0, 0%, 100%, 0.35) !important;
}

.ant-menu-dark .ant-menu-item-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after, .ant-menu-dark .ant-menu-item-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before, .ant-menu-dark .ant-menu-submenu-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after, .ant-menu-dark .ant-menu-submenu-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before {
  background: hsla(0, 0%, 100%, 0.35) !important;
}

.ant-menu.ant-menu-rtl {
  direction: rtl;
  text-align: right;
}

.ant-menu-rtl .ant-menu-item-group-title {
  text-align: right;
}

.ant-menu-rtl.ant-menu-inline, .ant-menu-rtl.ant-menu-vertical {
  border-right: none;
  border-left: 1px solid #f0f0f0;
}

.ant-menu-rtl.ant-menu-dark.ant-menu-inline, .ant-menu-rtl.ant-menu-dark.ant-menu-vertical {
  border-left: none;
}

.ant-menu-rtl.ant-menu-vertical-left.ant-menu-sub > .ant-menu-item, .ant-menu-rtl.ant-menu-vertical-left.ant-menu-sub > .ant-menu-submenu, .ant-menu-rtl.ant-menu-vertical-right.ant-menu-sub > .ant-menu-item, .ant-menu-rtl.ant-menu-vertical-right.ant-menu-sub > .ant-menu-submenu, .ant-menu-rtl.ant-menu-vertical.ant-menu-sub > .ant-menu-item, .ant-menu-rtl.ant-menu-vertical.ant-menu-sub > .ant-menu-submenu {
  transform-origin: top right;
}

.ant-menu-rtl .ant-menu-item .ant-menu-item-icon, .ant-menu-rtl .ant-menu-item .anticon, .ant-menu-rtl .ant-menu-submenu-title .ant-menu-item-icon, .ant-menu-rtl .ant-menu-submenu-title .anticon {
  margin-right: auto;
  margin-left: 10px;
}

.ant-menu-rtl .ant-menu-item.ant-menu-item-only-child > .ant-menu-item-icon, .ant-menu-rtl .ant-menu-item.ant-menu-item-only-child > .anticon, .ant-menu-rtl .ant-menu-submenu-title.ant-menu-item-only-child > .ant-menu-item-icon, .ant-menu-rtl .ant-menu-submenu-title.ant-menu-item-only-child > .anticon {
  margin-left: 0;
}

.ant-menu-submenu-rtl.ant-menu-submenu-popup {
  transform-origin: 100% 0;
}

.ant-menu-rtl .ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow, .ant-menu-rtl .ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow, .ant-menu-rtl .ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow, .ant-menu-rtl .ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow {
  right: auto;
  left: 16px;
}

.ant-menu-rtl .ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow:before, .ant-menu-rtl .ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow:before, .ant-menu-rtl .ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow:before {
  transform: rotate(-45deg) translateY(-2px);
}

.ant-menu-rtl .ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow:after, .ant-menu-rtl .ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow:after, .ant-menu-rtl .ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow:after {
  transform: rotate(45deg) translateY(2px);
}

.ant-menu-rtl.ant-menu-inline .ant-menu-item:after, .ant-menu-rtl.ant-menu-vertical-left .ant-menu-item:after, .ant-menu-rtl.ant-menu-vertical-right .ant-menu-item:after, .ant-menu-rtl.ant-menu-vertical .ant-menu-item:after {
  right: auto;
  left: 0;
}

.ant-menu-rtl.ant-menu-inline .ant-menu-item, .ant-menu-rtl.ant-menu-inline .ant-menu-submenu-title, .ant-menu-rtl.ant-menu-vertical-left .ant-menu-item, .ant-menu-rtl.ant-menu-vertical-left .ant-menu-submenu-title, .ant-menu-rtl.ant-menu-vertical-right .ant-menu-item, .ant-menu-rtl.ant-menu-vertical-right .ant-menu-submenu-title, .ant-menu-rtl.ant-menu-vertical .ant-menu-item, .ant-menu-rtl.ant-menu-vertical .ant-menu-submenu-title {
  text-align: right;
}

.ant-menu-rtl.ant-menu-inline .ant-menu-submenu-title {
  padding-right: 0;
  padding-left: 34px;
}

.ant-menu-rtl.ant-menu-vertical .ant-menu-submenu-title {
  padding-right: 16px;
  padding-left: 34px;
}

.ant-menu-rtl.ant-menu-inline-collapsed.ant-menu-vertical .ant-menu-submenu-title {
  padding: 0 calc(50% - 8px);
}

.ant-menu-rtl .ant-menu-item-group-list .ant-menu-item, .ant-menu-rtl .ant-menu-item-group-list .ant-menu-submenu-title {
  padding: 0 28px 0 16px;
}

.ant-menu-sub.ant-menu-inline {
  border: 0;
}

.ant-menu-rtl.ant-menu-sub.ant-menu-inline .ant-menu-item-group-title {
  padding-right: 32px;
  padding-left: 0;
}

.ant-message {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: fixed;
  top: 8px;
  left: 0;
  z-index: 1010;
  width: 100%;
  pointer-events: none;
}

.ant-message-notice {
  padding: 8px;
  text-align: center;
}

.ant-message-notice-content {
  display: inline-block;
  padding: 10px 16px;
  background: #fff;
  border-radius: 2px;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
  pointer-events: all;
}

.ant-message-success .anticon {
  color: #52c41a;
}

.ant-message-error .anticon {
  color: #ff4d4f;
}

.ant-message-warning .anticon {
  color: #faad14;
}

.ant-message-info .anticon, .ant-message-loading .anticon {
  color: #1890ff;
}

.ant-message .anticon {
  position: relative;
  top: 1px;
  margin-right: 8px;
  font-size: 16px;
}

.ant-message-notice.ant-move-up-leave.ant-move-up-leave-active {
  animation-name: MessageMoveOut;
  animation-duration: 0.3s;
}

@keyframes MessageMoveOut {
  0% {
    max-height: 150px;
    padding: 8px;
    opacity: 1;
  }
  to {
    max-height: 0;
    padding: 0;
    opacity: 0;
  }
}
.ant-message-rtl, .ant-message-rtl span {
  direction: rtl;
}

.ant-message-rtl .anticon {
  margin-right: 0;
  margin-left: 8px;
}

.ant-modal {
  box-sizing: border-box;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  pointer-events: none;
  position: relative;
  top: 100px;
  width: auto;
  max-width: calc(100vw - 32px);
  margin: 0 auto;
  padding: 0 0 24px;
}

.ant-modal.ant-zoom-appear, .ant-modal.ant-zoom-enter {
  transform: none;
  opacity: 0;
  animation-duration: 0.3s;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-modal-mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.45);
}

.ant-modal-mask-hidden {
  display: none;
}

.ant-modal-wrap {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  outline: 0;
  z-index: 1000;
}

.ant-modal-title {
  margin: 0;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  word-wrap: break-word;
}

.ant-modal-content {
  position: relative;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  border-radius: 2px;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
  pointer-events: auto;
}

.ant-modal-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
  padding: 0;
  color: rgba(0, 0, 0, 0.45);
  font-weight: 700;
  line-height: 1;
  text-decoration: none;
  background: transparent;
  border: 0;
  outline: 0;
  cursor: pointer;
  transition: color 0.3s;
}

.ant-modal-close-x {
  display: block;
  width: 54px;
  height: 54px;
  font-size: 16px;
  font-style: normal;
  line-height: 54px;
  text-align: center;
  text-transform: none;
  text-rendering: auto;
}

.ant-modal-close:focus, .ant-modal-close:hover {
  color: rgba(0, 0, 0, 0.75);
  text-decoration: none;
}

.ant-modal-header {
  padding: 16px 24px;
  color: rgba(0, 0, 0, 0.85);
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
  border-radius: 2px 2px 0 0;
}

.ant-modal-body {
  padding: 24px;
  font-size: 14px;
  line-height: 1.5715;
  word-wrap: break-word;
}

.ant-modal-footer {
  padding: 10px 16px;
  text-align: right;
  background: transparent;
  border-top: 1px solid #f0f0f0;
  border-radius: 0 0 2px 2px;
}

.ant-modal-footer .ant-btn + .ant-btn:not(.ant-dropdown-trigger) {
  margin-bottom: 0;
  margin-left: 8px;
}

.ant-modal-open {
  overflow: hidden;
}

.ant-modal-centered {
  text-align: center;
}

.ant-modal-centered:before {
  display: inline-block;
  width: 0;
  height: 100%;
  vertical-align: middle;
  content: "";
}

.ant-modal-centered .ant-modal {
  top: 0;
  display: inline-block;
  padding-bottom: 0;
  text-align: left;
  vertical-align: middle;
}

@media (max-width: 767px) {
  .ant-modal {
    max-width: calc(100vw - 16px);
    margin: 8px auto;
  }
  .ant-modal-centered .ant-modal {
    flex: 1;
  }
}
.ant-modal-confirm .ant-modal-header {
  display: none;
}

.ant-modal-confirm .ant-modal-body {
  padding: 32px 32px 24px;
}

.ant-modal-confirm-body-wrapper:before {
  display: table;
  content: "";
}

.ant-modal-confirm-body-wrapper:after {
  display: table;
  clear: both;
  content: "";
}

.ant-modal-confirm-body .ant-modal-confirm-title {
  display: block;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  font-size: 16px;
  line-height: 1.4;
}

.ant-modal-confirm-body .ant-modal-confirm-content {
  margin-top: 8px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
}

.ant-modal-confirm-body > .anticon {
  float: left;
  margin-right: 16px;
  font-size: 22px;
}

.ant-modal-confirm-body > .anticon + .ant-modal-confirm-title + .ant-modal-confirm-content {
  margin-left: 38px;
}

.ant-modal-confirm .ant-modal-confirm-btns {
  margin-top: 24px;
  text-align: right;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn + .ant-btn {
  margin-bottom: 0;
  margin-left: 8px;
}

.ant-modal-confirm-error .ant-modal-confirm-body > .anticon {
  color: #ff4d4f;
}

.ant-modal-confirm-confirm .ant-modal-confirm-body > .anticon, .ant-modal-confirm-warning .ant-modal-confirm-body > .anticon {
  color: #faad14;
}

.ant-modal-confirm-info .ant-modal-confirm-body > .anticon {
  color: #1890ff;
}

.ant-modal-confirm-success .ant-modal-confirm-body > .anticon {
  color: #52c41a;
}

.ant-modal-confirm .ant-zoom-leave .ant-modal-confirm-btns {
  pointer-events: none;
}

.ant-modal-wrap-rtl {
  direction: rtl;
}

.ant-modal-wrap-rtl .ant-modal-close {
  right: auto;
  left: 0;
}

.ant-modal-wrap-rtl .ant-modal-footer {
  text-align: left;
}

.ant-modal-wrap-rtl .ant-modal-footer .ant-btn + .ant-btn {
  margin-right: 8px;
  margin-left: 0;
}

.ant-modal-wrap-rtl .ant-modal-confirm-body {
  direction: rtl;
}

.ant-modal-wrap-rtl .ant-modal-confirm-body > .anticon {
  float: right;
  margin-right: 0;
  margin-left: 16px;
}

.ant-modal-wrap-rtl .ant-modal-confirm-body > .anticon + .ant-modal-confirm-title + .ant-modal-confirm-content {
  margin-right: 38px;
  margin-left: 0;
}

.ant-modal-wrap-rtl .ant-modal-confirm-btns {
  text-align: left;
}

.ant-modal-wrap-rtl .ant-modal-confirm-btns .ant-btn + .ant-btn {
  margin-right: 8px;
  margin-left: 0;
}

.ant-modal-wrap-rtl.ant-modal-centered .ant-modal {
  text-align: right;
}

.ant-notification {
  box-sizing: border-box;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: fixed;
  z-index: 1010;
  margin: 0 24px 0 0;
}

.ant-notification-close-icon {
  font-size: 14px;
  cursor: pointer;
}

.ant-notification-hook-holder {
  position: relative;
}

.ant-notification-notice {
  position: relative;
  width: 384px;
  max-width: calc(100vw - 48px);
  margin-bottom: 16px;
  margin-left: auto;
  padding: 16px 24px;
  overflow: hidden;
  line-height: 1.5715;
  word-wrap: break-word;
  background: #fff;
  border-radius: 2px;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
}

.ant-notification-bottom .ant-notification-notice, .ant-notification-top .ant-notification-notice {
  margin-right: auto;
  margin-left: auto;
}

.ant-notification-bottomLeft .ant-notification-notice, .ant-notification-topLeft .ant-notification-notice {
  margin-right: auto;
  margin-left: 0;
}

.ant-notification-notice-message {
  margin-bottom: 8px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 16px;
  line-height: 24px;
}

.ant-notification-notice-message-single-line-auto-margin {
  display: block;
  width: calc(264px - 100%);
  max-width: 4px;
  background-color: transparent;
  pointer-events: none;
}

.ant-notification-notice-message-single-line-auto-margin:before {
  display: block;
  content: "";
}

.ant-notification-notice-description {
  font-size: 14px;
}

.ant-notification-notice-closable .ant-notification-notice-message {
  padding-right: 24px;
}

.ant-notification-notice-with-icon .ant-notification-notice-message {
  margin-bottom: 4px;
  margin-left: 48px;
  font-size: 16px;
}

.ant-notification-notice-with-icon .ant-notification-notice-description {
  margin-left: 48px;
  font-size: 14px;
}

.ant-notification-notice-icon {
  position: absolute;
  margin-left: 4px;
  font-size: 24px;
  line-height: 24px;
}

.anticon.ant-notification-notice-icon-success {
  color: #52c41a;
}

.anticon.ant-notification-notice-icon-info {
  color: #1890ff;
}

.anticon.ant-notification-notice-icon-warning {
  color: #faad14;
}

.anticon.ant-notification-notice-icon-error {
  color: #ff4d4f;
}

.ant-notification-notice-close {
  position: absolute;
  top: 16px;
  right: 22px;
  color: rgba(0, 0, 0, 0.45);
  outline: none;
}

.ant-notification-notice-close:hover {
  color: rgba(0, 0, 0, 0.67);
}

.ant-notification-notice-btn {
  float: right;
  margin-top: 16px;
}

.ant-notification .notification-fade-effect {
  animation-duration: 0.24s;
  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
  animation-fill-mode: both;
}

.ant-notification-fade-appear, .ant-notification-fade-enter {
  opacity: 0;
  animation-play-state: paused;
}

.ant-notification-fade-appear, .ant-notification-fade-enter, .ant-notification-fade-leave {
  animation-duration: 0.24s;
  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
  animation-fill-mode: both;
}

.ant-notification-fade-leave {
  animation-duration: 0.2s;
  animation-play-state: paused;
}

.ant-notification-fade-appear.ant-notification-fade-appear-active, .ant-notification-fade-enter.ant-notification-fade-enter-active {
  animation-name: NotificationFadeIn;
  animation-play-state: running;
}

.ant-notification-fade-leave.ant-notification-fade-leave-active {
  animation-name: NotificationFadeOut;
  animation-play-state: running;
}

@keyframes NotificationFadeIn {
  0% {
    left: 384px;
    opacity: 0;
  }
  to {
    left: 0;
    opacity: 1;
  }
}
@keyframes NotificationFadeOut {
  0% {
    max-height: 150px;
    margin-bottom: 16px;
    opacity: 1;
  }
  to {
    max-height: 0;
    margin-bottom: 0;
    padding-top: 0;
    padding-bottom: 0;
    opacity: 0;
  }
}
.ant-notification-rtl {
  direction: rtl;
}

.ant-notification-rtl .ant-notification-notice-closable .ant-notification-notice-message {
  padding-right: 0;
  padding-left: 24px;
}

.ant-notification-rtl .ant-notification-notice-with-icon .ant-notification-notice-description, .ant-notification-rtl .ant-notification-notice-with-icon .ant-notification-notice-message {
  margin-right: 48px;
  margin-left: 0;
}

.ant-notification-rtl .ant-notification-notice-icon {
  margin-right: 4px;
  margin-left: 0;
}

.ant-notification-rtl .ant-notification-notice-close {
  right: auto;
  left: 22px;
}

.ant-notification-rtl .ant-notification-notice-btn {
  float: left;
}

.ant-notification-bottom, .ant-notification-top {
  margin-right: 0;
  margin-left: 0;
}

.ant-notification-top .ant-notification-fade-appear.ant-notification-fade-appear-active, .ant-notification-top .ant-notification-fade-enter.ant-notification-fade-enter-active {
  animation-name: NotificationTopFadeIn;
}

.ant-notification-bottom .ant-notification-fade-appear.ant-notification-fade-appear-active, .ant-notification-bottom .ant-notification-fade-enter.ant-notification-fade-enter-active {
  animation-name: NotificationBottomFadeIn;
}

.ant-notification-bottomLeft, .ant-notification-topLeft {
  margin-right: 0;
  margin-left: 24px;
}

.ant-notification-bottomLeft .ant-notification-fade-appear.ant-notification-fade-appear-active, .ant-notification-bottomLeft .ant-notification-fade-enter.ant-notification-fade-enter-active, .ant-notification-topLeft .ant-notification-fade-appear.ant-notification-fade-appear-active, .ant-notification-topLeft .ant-notification-fade-enter.ant-notification-fade-enter-active {
  animation-name: NotificationLeftFadeIn;
}

@keyframes NotificationTopFadeIn {
  0% {
    margin-top: -100%;
    opacity: 0;
  }
  to {
    margin-top: 0;
    opacity: 1;
  }
}
@keyframes NotificationBottomFadeIn {
  0% {
    margin-bottom: -100%;
    opacity: 0;
  }
  to {
    margin-bottom: 0;
    opacity: 1;
  }
}
@keyframes NotificationLeftFadeIn {
  0% {
    right: 384px;
    opacity: 0;
  }
  to {
    right: 0;
    opacity: 1;
  }
}
.ant-page-header {
  box-sizing: border-box;
  margin: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  padding: 16px 24px;
  background-color: #fff;
}

.ant-page-header-ghost {
  background-color: inherit;
}

.ant-page-header.has-breadcrumb {
  padding-top: 12px;
}

.ant-page-header.has-footer {
  padding-bottom: 0;
}

.ant-page-header-back {
  margin-right: 16px;
  font-size: 16px;
  line-height: 1;
}

.ant-page-header-back-button {
  color: #1890ff;
  outline: none;
  cursor: pointer;
  transition: color 0.3s;
  color: #000;
}

.ant-page-header-back-button:focus-visible, .ant-page-header-back-button:hover {
  color: #40a9ff;
}

.ant-page-header-back-button:active {
  color: #096dd9;
}

.ant-page-header .ant-divider-vertical {
  height: 14px;
  margin: 0 12px;
  vertical-align: middle;
}

.ant-breadcrumb + .ant-page-header-heading {
  margin-top: 8px;
}

.ant-page-header-heading {
  display: flex;
  justify-content: space-between;
}

.ant-page-header-heading-left {
  display: flex;
  align-items: center;
  margin: 4px 0;
  overflow: hidden;
}

.ant-page-header-heading-title {
  margin-right: 12px;
  margin-bottom: 0;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 600;
  font-size: 20px;
  line-height: 32px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ant-page-header-heading .ant-avatar {
  margin-right: 12px;
}

.ant-page-header-heading-sub-title {
  margin-right: 12px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
  line-height: 1.5715;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ant-page-header-heading-extra {
  margin: 4px 0;
  white-space: nowrap;
}

.ant-page-header-heading-extra > * {
  white-space: unset;
}

.ant-page-header-content {
  padding-top: 12px;
}

.ant-page-header-footer {
  margin-top: 16px;
}

.ant-page-header-footer .ant-tabs > .ant-tabs-nav {
  margin: 0;
}

.ant-page-header-footer .ant-tabs > .ant-tabs-nav:before {
  border: none;
}

.ant-page-header-footer .ant-tabs .ant-tabs-tab {
  padding-top: 8px;
  padding-bottom: 8px;
  font-size: 16px;
}

.ant-page-header-compact .ant-page-header-heading {
  flex-wrap: wrap;
}

.ant-page-header-rtl {
  direction: rtl;
}

.ant-page-header-rtl .ant-page-header-back {
  float: right;
  margin-right: 0;
  margin-left: 16px;
}

.ant-page-header-rtl .ant-page-header-heading-title, .ant-page-header-rtl .ant-page-header-heading .ant-avatar {
  margin-right: 0;
  margin-left: 12px;
}

.ant-page-header-rtl .ant-page-header-heading-sub-title {
  float: right;
  margin-right: 0;
  margin-left: 12px;
}

.ant-page-header-rtl .ant-page-header-heading-tags {
  float: right;
}

.ant-page-header-rtl .ant-page-header-heading-extra {
  float: left;
}

.ant-page-header-rtl .ant-page-header-heading-extra > * {
  margin-right: 12px;
  margin-left: 0;
}

.ant-page-header-rtl .ant-page-header-heading-extra > :first-child {
  margin-right: 0;
}

.ant-page-header-rtl .ant-page-header-footer .ant-tabs-bar .ant-tabs-nav {
  float: right;
}

.ant-pagination {
  box-sizing: border-box;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  font-feature-settings: "tnum";
}

.ant-pagination, .ant-pagination ol, .ant-pagination ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.ant-pagination:after {
  display: block;
  clear: both;
  height: 0;
  overflow: hidden;
  visibility: hidden;
  content: " ";
}

.ant-pagination-item, .ant-pagination-total-text {
  display: inline-block;
  height: 32px;
  margin-right: 8px;
  line-height: 30px;
  vertical-align: middle;
}

.ant-pagination-item {
  min-width: 32px;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  text-align: center;
  list-style: none;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  outline: 0;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-pagination-item a {
  display: block;
  padding: 0 6px;
  color: rgba(0, 0, 0, 0.85);
  transition: none;
}

.ant-pagination-item a:hover {
  text-decoration: none;
}

.ant-pagination-item:hover {
  border-color: #1890ff;
  transition: all 0.3s;
}

.ant-pagination-item:hover a {
  color: #1890ff;
}

.ant-pagination-item:focus-visible {
  border-color: #1890ff;
  transition: all 0.3s;
}

.ant-pagination-item:focus-visible a {
  color: #1890ff;
}

.ant-pagination-item-active {
  font-weight: 500;
  background: #fff;
  border-color: #1890ff;
}

.ant-pagination-item-active a {
  color: #1890ff;
}

.ant-pagination-item-active:focus-visible, .ant-pagination-item-active:hover {
  border-color: #40a9ff;
}

.ant-pagination-item-active:focus-visible a, .ant-pagination-item-active:hover a {
  color: #40a9ff;
}

.ant-pagination-jump-next, .ant-pagination-jump-prev {
  outline: 0;
}

.ant-pagination-jump-next .ant-pagination-item-container, .ant-pagination-jump-prev .ant-pagination-item-container {
  position: relative;
}

.ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon, .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon {
  color: #1890ff;
  font-size: 12px;
  letter-spacing: -1px;
  opacity: 0;
  transition: all 0.2s;
}

.ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon-svg, .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon-svg {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}

.ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-ellipsis, .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-ellipsis {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: block;
  margin: auto;
  color: rgba(0, 0, 0, 0.25);
  font-family: Arial, Helvetica, sans-serif;
  letter-spacing: 2px;
  text-align: center;
  text-indent: 0.13em;
  opacity: 1;
  transition: all 0.2s;
}

.ant-pagination-jump-next:hover .ant-pagination-item-link-icon, .ant-pagination-jump-prev:hover .ant-pagination-item-link-icon {
  opacity: 1;
}

.ant-pagination-jump-next:hover .ant-pagination-item-ellipsis, .ant-pagination-jump-prev:hover .ant-pagination-item-ellipsis {
  opacity: 0;
}

.ant-pagination-jump-next:focus-visible .ant-pagination-item-link-icon, .ant-pagination-jump-prev:focus-visible .ant-pagination-item-link-icon {
  opacity: 1;
}

.ant-pagination-jump-next:focus-visible .ant-pagination-item-ellipsis, .ant-pagination-jump-prev:focus-visible .ant-pagination-item-ellipsis {
  opacity: 0;
}

.ant-pagination-jump-next, .ant-pagination-jump-prev, .ant-pagination-prev {
  margin-right: 8px;
}

.ant-pagination-jump-next, .ant-pagination-jump-prev, .ant-pagination-next, .ant-pagination-prev {
  display: inline-block;
  min-width: 32px;
  height: 32px;
  color: rgba(0, 0, 0, 0.85);
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  line-height: 32px;
  text-align: center;
  vertical-align: middle;
  list-style: none;
  border-radius: 2px;
  cursor: pointer;
  transition: all 0.3s;
}

.ant-pagination-next, .ant-pagination-prev {
  font-family: Arial, Helvetica, sans-serif;
  outline: 0;
}

.ant-pagination-next button, .ant-pagination-prev button {
  color: rgba(0, 0, 0, 0.85);
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-pagination-next:hover button, .ant-pagination-prev:hover button {
  border-color: #40a9ff;
}

.ant-pagination-next .ant-pagination-item-link, .ant-pagination-prev .ant-pagination-item-link {
  display: block;
  width: 100%;
  height: 100%;
  padding: 0;
  font-size: 12px;
  text-align: center;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  outline: none;
  transition: all 0.3s;
}

.ant-pagination-next:focus-visible .ant-pagination-item-link, .ant-pagination-next:hover .ant-pagination-item-link, .ant-pagination-prev:focus-visible .ant-pagination-item-link, .ant-pagination-prev:hover .ant-pagination-item-link {
  color: #1890ff;
  border-color: #1890ff;
}

.ant-pagination-disabled, .ant-pagination-disabled:hover {
  cursor: not-allowed;
}

.ant-pagination-disabled .ant-pagination-item-link, .ant-pagination-disabled:hover .ant-pagination-item-link {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  cursor: not-allowed;
}

.ant-pagination-disabled:focus-visible {
  cursor: not-allowed;
}

.ant-pagination-disabled:focus-visible .ant-pagination-item-link {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  cursor: not-allowed;
}

.ant-pagination-slash {
  margin: 0 10px 0 5px;
}

.ant-pagination-options {
  display: inline-block;
  margin-left: 16px;
  vertical-align: middle;
}

@media (-ms-high-contrast: none) {
  .ant-pagination-options, .ant-pagination-options ::-ms-backdrop {
    vertical-align: top;
  }
}
.ant-pagination-options-size-changer.ant-select {
  display: inline-block;
  width: auto;
}

.ant-pagination-options-quick-jumper {
  display: inline-block;
  height: 32px;
  margin-left: 8px;
  line-height: 32px;
  vertical-align: top;
}

.ant-pagination-options-quick-jumper input {
  position: relative;
  display: inline-block;
  width: 100%;
  min-width: 0;
  padding: 4px 11px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  line-height: 1.5715;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  transition: all 0.3s;
  width: 50px;
  height: 32px;
  margin: 0 8px;
}

.ant-pagination-options-quick-jumper input::-moz-placeholder {
  color: #bfbfbf;
  -moz-user-select: none;
  user-select: none;
}

.ant-pagination-options-quick-jumper input:-ms-input-placeholder {
  color: #bfbfbf;
  -ms-user-select: none;
  user-select: none;
}

.ant-pagination-options-quick-jumper input::placeholder {
  color: #bfbfbf;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-pagination-options-quick-jumper input:-moz-placeholder-shown {
  text-overflow: ellipsis;
}

.ant-pagination-options-quick-jumper input:-ms-input-placeholder {
  text-overflow: ellipsis;
}

.ant-pagination-options-quick-jumper input:placeholder-shown {
  text-overflow: ellipsis;
}

.ant-pagination-options-quick-jumper input:hover {
  border-color: #40a9ff;
  border-right-width: 1px;
}

.ant-pagination-options-quick-jumper input-focused, .ant-pagination-options-quick-jumper input:focus {
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-pagination-options-quick-jumper input-disabled {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}

.ant-pagination-options-quick-jumper input-disabled:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}

.ant-pagination-options-quick-jumper input[disabled] {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}

.ant-pagination-options-quick-jumper input[disabled]:hover {
  border-color: #d9d9d9;
  border-right-width: 1px;
}

.ant-pagination-options-quick-jumper input-borderless, .ant-pagination-options-quick-jumper input-borderless-disabled, .ant-pagination-options-quick-jumper input-borderless-focused, .ant-pagination-options-quick-jumper input-borderless:focus, .ant-pagination-options-quick-jumper input-borderless:hover, .ant-pagination-options-quick-jumper input-borderless[disabled] {
  background-color: transparent;
  border: none;
  box-shadow: none;
}

textarea.ant-pagination-options-quick-jumper input {
  max-width: 100%;
  height: auto;
  min-height: 32px;
  line-height: 1.5715;
  vertical-align: bottom;
  transition: all 0.3s, height 0s;
}

.ant-pagination-options-quick-jumper input-lg {
  padding: 6.5px 11px;
  font-size: 16px;
}

.ant-pagination-options-quick-jumper input-sm {
  padding: 0 7px;
}

.ant-pagination-simple .ant-pagination-next, .ant-pagination-simple .ant-pagination-prev {
  height: 24px;
  line-height: 24px;
  vertical-align: top;
}

.ant-pagination-simple .ant-pagination-next .ant-pagination-item-link, .ant-pagination-simple .ant-pagination-prev .ant-pagination-item-link {
  height: 24px;
  background-color: transparent;
  border: 0;
}

.ant-pagination-simple .ant-pagination-next .ant-pagination-item-link:after, .ant-pagination-simple .ant-pagination-prev .ant-pagination-item-link:after {
  height: 24px;
  line-height: 24px;
}

.ant-pagination-simple .ant-pagination-simple-pager {
  display: inline-block;
  height: 24px;
  margin-right: 8px;
}

.ant-pagination-simple .ant-pagination-simple-pager input {
  box-sizing: border-box;
  height: 100%;
  margin-right: 8px;
  padding: 0 6px;
  text-align: center;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  outline: none;
  transition: border-color 0.3s;
}

.ant-pagination-simple .ant-pagination-simple-pager input:hover {
  border-color: #1890ff;
}

.ant-pagination-simple .ant-pagination-simple-pager input:focus {
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.ant-pagination-simple .ant-pagination-simple-pager input[disabled] {
  color: rgba(0, 0, 0, 0.25);
  background: #f5f5f5;
  border-color: #d9d9d9;
  cursor: not-allowed;
}

.ant-pagination.ant-pagination-mini .ant-pagination-simple-pager, .ant-pagination.ant-pagination-mini .ant-pagination-total-text {
  height: 24px;
  line-height: 24px;
}

.ant-pagination.ant-pagination-mini .ant-pagination-item {
  min-width: 24px;
  height: 24px;
  margin: 0;
  line-height: 22px;
}

.ant-pagination.ant-pagination-mini .ant-pagination-item:not(.ant-pagination-item-active) {
  background: transparent;
  border-color: transparent;
}

.ant-pagination.ant-pagination-mini .ant-pagination-next, .ant-pagination.ant-pagination-mini .ant-pagination-prev {
  min-width: 24px;
  height: 24px;
  margin: 0;
  line-height: 24px;
}

.ant-pagination.ant-pagination-mini .ant-pagination-next .ant-pagination-item-link, .ant-pagination.ant-pagination-mini .ant-pagination-prev .ant-pagination-item-link {
  background: transparent;
  border-color: transparent;
}

.ant-pagination.ant-pagination-mini .ant-pagination-next .ant-pagination-item-link:after, .ant-pagination.ant-pagination-mini .ant-pagination-prev .ant-pagination-item-link:after {
  height: 24px;
  line-height: 24px;
}

.ant-pagination.ant-pagination-mini .ant-pagination-jump-next, .ant-pagination.ant-pagination-mini .ant-pagination-jump-prev {
  height: 24px;
  margin-right: 0;
  line-height: 24px;
}

.ant-pagination.ant-pagination-mini .ant-pagination-options {
  margin-left: 2px;
}

.ant-pagination.ant-pagination-mini .ant-pagination-options-size-changer {
  top: 0;
}

.ant-pagination.ant-pagination-mini .ant-pagination-options-quick-jumper {
  height: 24px;
  line-height: 24px;
}

.ant-pagination.ant-pagination-mini .ant-pagination-options-quick-jumper input {
  padding: 0 7px;
  width: 44px;
  height: 24px;
}

.ant-pagination.ant-pagination-disabled {
  cursor: not-allowed;
}

.ant-pagination.ant-pagination-disabled .ant-pagination-item {
  background: #f5f5f5;
  border-color: #d9d9d9;
  cursor: not-allowed;
}

.ant-pagination.ant-pagination-disabled .ant-pagination-item a {
  color: rgba(0, 0, 0, 0.25);
  background: transparent;
  border: none;
  cursor: not-allowed;
}

.ant-pagination.ant-pagination-disabled .ant-pagination-item-active {
  background: #e6e6e6;
}

.ant-pagination.ant-pagination-disabled .ant-pagination-item-active a {
  color: rgba(0, 0, 0, 0.25);
}

.ant-pagination.ant-pagination-disabled .ant-pagination-item-link {
  color: rgba(0, 0, 0, 0.25);
  background: #f5f5f5;
  border-color: #d9d9d9;
  cursor: not-allowed;
}

.ant-pagination-simple.ant-pagination.ant-pagination-disabled .ant-pagination-item-link {
  background: transparent;
}

.ant-pagination.ant-pagination-disabled .ant-pagination-item-link-icon {
  opacity: 0;
}

.ant-pagination.ant-pagination-disabled .ant-pagination-item-ellipsis {
  opacity: 1;
}

.ant-pagination.ant-pagination-disabled .ant-pagination-simple-pager {
  color: rgba(0, 0, 0, 0.25);
}

@media only screen and (max-width: 992px) {
  .ant-pagination-item-after-jump-prev, .ant-pagination-item-before-jump-next {
    display: none;
  }
}
@media only screen and (max-width: 576px) {
  .ant-pagination-options {
    display: none;
  }
}
.ant-pagination-rtl .ant-pagination-item, .ant-pagination-rtl .ant-pagination-jump-next, .ant-pagination-rtl .ant-pagination-jump-prev, .ant-pagination-rtl .ant-pagination-prev, .ant-pagination-rtl .ant-pagination-total-text {
  margin-right: 0;
  margin-left: 8px;
}

.ant-pagination-rtl .ant-pagination-slash {
  margin: 0 5px 0 10px;
}

.ant-pagination-rtl .ant-pagination-options {
  margin-right: 16px;
  margin-left: 0;
}

.ant-pagination-rtl .ant-pagination-options .ant-pagination-options-size-changer.ant-select {
  margin-right: 0;
  margin-left: 8px;
}

.ant-pagination-rtl .ant-pagination-options .ant-pagination-options-quick-jumper {
  margin-left: 0;
}

.ant-pagination-rtl.ant-pagination-simple .ant-pagination-simple-pager, .ant-pagination-rtl.ant-pagination-simple .ant-pagination-simple-pager input {
  margin-right: 0;
  margin-left: 8px;
}

.ant-pagination-rtl.ant-pagination.mini .ant-pagination-options {
  margin-right: 2px;
  margin-left: 0;
}

.ant-popconfirm {
  z-index: 1060;
}

.ant-popover {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1030;
  max-width: 100%;
  font-weight: 400;
  white-space: normal;
  text-align: left;
  cursor: auto;
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}

.ant-popover-content {
  position: relative;
}

.ant-popover:after {
  position: absolute;
  background: hsla(0, 0%, 100%, 0.01);
  content: "";
}

.ant-popover-hidden {
  display: none;
}

.ant-popover-placement-top, .ant-popover-placement-topLeft, .ant-popover-placement-topRight {
  padding-bottom: 15.3137085px;
}

.ant-popover-placement-right, .ant-popover-placement-rightBottom, .ant-popover-placement-rightTop {
  padding-left: 15.3137085px;
}

.ant-popover-placement-bottom, .ant-popover-placement-bottomLeft, .ant-popover-placement-bottomRight {
  padding-top: 15.3137085px;
}

.ant-popover-placement-left, .ant-popover-placement-leftBottom, .ant-popover-placement-leftTop {
  padding-right: 15.3137085px;
}

.ant-popover-inner {
  background-color: #fff;
  background-clip: padding-box;
  border-radius: 2px;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
}

@media (-ms-high-contrast: none), screen and (-ms-high-contrast: active) {
  .ant-popover-inner {
    box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
  }
}
.ant-popover-title {
  min-width: 177px;
  min-height: 32px;
  margin: 0;
  padding: 5px 16px 4px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  border-bottom: 1px solid #f0f0f0;
}

.ant-popover-inner-content {
  width: -moz-max-content;
  width: max-content;
  max-width: 100%;
  padding: 12px 16px;
  color: rgba(0, 0, 0, 0.85);
}

.ant-popover-message {
  display: flex;
  padding: 4px 0 12px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
}

.ant-popover-message-icon {
  display: inline-block;
  margin-right: 8px;
  color: #faad14;
  font-size: 14px;
}

.ant-popover-buttons {
  margin-bottom: 4px;
  text-align: right;
}

.ant-popover-buttons button:not(:first-child) {
  margin-left: 8px;
}

.ant-popover-arrow {
  position: absolute;
  display: block;
  width: 22px;
  height: 22px;
  overflow: hidden;
  background: transparent;
  pointer-events: none;
}

.ant-popover-arrow-content {
  --antd-arrow-background-color:#fff;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: block;
  width: 11.3137085px;
  height: 11.3137085px;
  margin: auto;
  content: "";
  pointer-events: auto;
  border-radius: 0 0 2px;
  pointer-events: none;
}

.ant-popover-arrow-content:before {
  position: absolute;
  top: -11.3137085px;
  left: -11.3137085px;
  width: 33.9411255px;
  height: 33.9411255px;
  background: var(--antd-arrow-background-color);
  background-repeat: no-repeat;
  background-position: -10px -10px;
  content: "";
  -webkit-clip-path: inset(33% 33%);
  clip-path: inset(33% 33%);
  -webkit-clip-path: path("M 9.849242404917499 24.091883092036785 A 5 5 0 0 1 13.384776310850237 22.627416997969522 L 20.627416997969522 22.627416997969522 A 2 2 0 0 0 22.627416997969522 20.627416997969522 L 22.627416997969522 13.384776310850237 A 5 5 0 0 1 24.091883092036785 9.849242404917499 L 23.091883092036785 9.849242404917499 L 9.849242404917499 23.091883092036785 Z");
  clip-path: path("M 9.849242404917499 24.091883092036785 A 5 5 0 0 1 13.384776310850237 22.627416997969522 L 20.627416997969522 22.627416997969522 A 2 2 0 0 0 22.627416997969522 20.627416997969522 L 22.627416997969522 13.384776310850237 A 5 5 0 0 1 24.091883092036785 9.849242404917499 L 23.091883092036785 9.849242404917499 L 9.849242404917499 23.091883092036785 Z");
}

.ant-popover-placement-top .ant-popover-arrow, .ant-popover-placement-topLeft .ant-popover-arrow, .ant-popover-placement-topRight .ant-popover-arrow {
  bottom: 0;
  transform: translateY(100%);
}

.ant-popover-placement-top .ant-popover-arrow-content, .ant-popover-placement-topLeft .ant-popover-arrow-content, .ant-popover-placement-topRight .ant-popover-arrow-content {
  box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.07);
  transform: translateY(-11px) rotate(45deg);
}

.ant-popover-placement-top .ant-popover-arrow {
  left: 50%;
  transform: translateY(100%) translateX(-50%);
}

.ant-popover-placement-topLeft .ant-popover-arrow {
  left: 16px;
}

.ant-popover-placement-topRight .ant-popover-arrow {
  right: 16px;
}

.ant-popover-placement-right .ant-popover-arrow, .ant-popover-placement-rightBottom .ant-popover-arrow, .ant-popover-placement-rightTop .ant-popover-arrow {
  left: 0;
  transform: translateX(-100%);
}

.ant-popover-placement-right .ant-popover-arrow-content, .ant-popover-placement-rightBottom .ant-popover-arrow-content, .ant-popover-placement-rightTop .ant-popover-arrow-content {
  box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.07);
  transform: translateX(11px) rotate(135deg);
}

.ant-popover-placement-right .ant-popover-arrow {
  top: 50%;
  transform: translateX(-100%) translateY(-50%);
}

.ant-popover-placement-rightTop .ant-popover-arrow {
  top: 12px;
}

.ant-popover-placement-rightBottom .ant-popover-arrow {
  bottom: 12px;
}

.ant-popover-placement-bottom .ant-popover-arrow, .ant-popover-placement-bottomLeft .ant-popover-arrow, .ant-popover-placement-bottomRight .ant-popover-arrow {
  top: 0;
  transform: translateY(-100%);
}

.ant-popover-placement-bottom .ant-popover-arrow-content, .ant-popover-placement-bottomLeft .ant-popover-arrow-content, .ant-popover-placement-bottomRight .ant-popover-arrow-content {
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.06);
  transform: translateY(11px) rotate(-135deg);
}

.ant-popover-placement-bottom .ant-popover-arrow {
  left: 50%;
  transform: translateY(-100%) translateX(-50%);
}

.ant-popover-placement-bottomLeft .ant-popover-arrow {
  left: 16px;
}

.ant-popover-placement-bottomRight .ant-popover-arrow {
  right: 16px;
}

.ant-popover-placement-left .ant-popover-arrow, .ant-popover-placement-leftBottom .ant-popover-arrow, .ant-popover-placement-leftTop .ant-popover-arrow {
  right: 0;
  transform: translateX(100%);
}

.ant-popover-placement-left .ant-popover-arrow-content, .ant-popover-placement-leftBottom .ant-popover-arrow-content, .ant-popover-placement-leftTop .ant-popover-arrow-content {
  box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.07);
  transform: translateX(-11px) rotate(-45deg);
}

.ant-popover-placement-left .ant-popover-arrow {
  top: 50%;
  transform: translateX(100%) translateY(-50%);
}

.ant-popover-placement-leftTop .ant-popover-arrow {
  top: 12px;
}

.ant-popover-placement-leftBottom .ant-popover-arrow {
  bottom: 12px;
}

.ant-popover-magenta .ant-popover-arrow-content, .ant-popover-magenta .ant-popover-inner, .ant-popover-pink .ant-popover-arrow-content, .ant-popover-pink .ant-popover-inner {
  background-color: #eb2f96;
}

.ant-popover-red .ant-popover-arrow-content, .ant-popover-red .ant-popover-inner {
  background-color: #f5222d;
}

.ant-popover-volcano .ant-popover-arrow-content, .ant-popover-volcano .ant-popover-inner {
  background-color: #fa541c;
}

.ant-popover-orange .ant-popover-arrow-content, .ant-popover-orange .ant-popover-inner {
  background-color: #fa8c16;
}

.ant-popover-yellow .ant-popover-arrow-content, .ant-popover-yellow .ant-popover-inner {
  background-color: #fadb14;
}

.ant-popover-gold .ant-popover-arrow-content, .ant-popover-gold .ant-popover-inner {
  background-color: #faad14;
}

.ant-popover-cyan .ant-popover-arrow-content, .ant-popover-cyan .ant-popover-inner {
  background-color: #13c2c2;
}

.ant-popover-lime .ant-popover-arrow-content, .ant-popover-lime .ant-popover-inner {
  background-color: #a0d911;
}

.ant-popover-green .ant-popover-arrow-content, .ant-popover-green .ant-popover-inner {
  background-color: #52c41a;
}

.ant-popover-blue .ant-popover-arrow-content, .ant-popover-blue .ant-popover-inner {
  background-color: #1890ff;
}

.ant-popover-geekblue .ant-popover-arrow-content, .ant-popover-geekblue .ant-popover-inner {
  background-color: #2f54eb;
}

.ant-popover-purple .ant-popover-arrow-content, .ant-popover-purple .ant-popover-inner {
  background-color: #722ed1;
}

.ant-popover-rtl {
  direction: rtl;
  text-align: right;
}

.ant-popover-rtl .ant-popover-message-icon {
  margin-right: 0;
  margin-left: 8px;
}

.ant-popover-rtl .ant-popover-message-title {
  padding-left: 16px;
}

.ant-popover-rtl .ant-popover-buttons {
  text-align: left;
}

.ant-popover-rtl .ant-popover-buttons button {
  margin-right: 8px;
  margin-left: 0;
}

.ant-progress {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  display: inline-block;
}

.ant-progress-line {
  position: relative;
  width: 100%;
  font-size: 14px;
}

.ant-progress-steps {
  display: inline-block;
}

.ant-progress-steps-outer {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.ant-progress-steps-item {
  flex-shrink: 0;
  min-width: 2px;
  margin-right: 2px;
  background: #f3f3f3;
  transition: all 0.3s;
}

.ant-progress-steps-item-active {
  background: #1890ff;
}

.ant-progress-small.ant-progress-line, .ant-progress-small.ant-progress-line .ant-progress-text .anticon {
  font-size: 12px;
}

.ant-progress-outer {
  display: inline-block;
  width: 100%;
  margin-right: 0;
  padding-right: 0;
}

.ant-progress-show-info .ant-progress-outer {
  margin-right: calc(-2em - 8px);
  padding-right: calc(2em + 8px);
}

.ant-progress-inner {
  position: relative;
  display: inline-block;
  width: 100%;
  overflow: hidden;
  vertical-align: middle;
  background-color: #f5f5f5;
  border-radius: 100px;
}

.ant-progress-circle-trail {
  stroke: #f5f5f5;
}

.ant-progress-circle-path {
  animation: ant-progress-appear 0.3s;
}

.ant-progress-inner:not(.ant-progress-circle-gradient) .ant-progress-circle-path {
  stroke: #1890ff;
}

.ant-progress-bg, .ant-progress-success-bg {
  position: relative;
  background-color: #1890ff;
  border-radius: 100px;
  transition: all 0.4s cubic-bezier(0.08, 0.82, 0.17, 1) 0s;
}

.ant-progress-success-bg {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #52c41a;
}

.ant-progress-text {
  display: inline-block;
  width: 2em;
  margin-left: 8px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 1em;
  line-height: 1;
  white-space: nowrap;
  text-align: left;
  vertical-align: middle;
  word-break: normal;
}

.ant-progress-text .anticon {
  font-size: 14px;
}

.ant-progress-status-active .ant-progress-bg:before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #fff;
  border-radius: 10px;
  opacity: 0;
  animation: ant-progress-active 2.4s cubic-bezier(0.23, 1, 0.32, 1) infinite;
  content: "";
}

.ant-progress-status-exception .ant-progress-bg {
  background-color: #ff4d4f;
}

.ant-progress-status-exception .ant-progress-text {
  color: #ff4d4f;
}

.ant-progress-status-exception .ant-progress-inner:not(.ant-progress-circle-gradient) .ant-progress-circle-path {
  stroke: #ff4d4f;
}

.ant-progress-status-success .ant-progress-bg {
  background-color: #52c41a;
}

.ant-progress-status-success .ant-progress-text {
  color: #52c41a;
}

.ant-progress-status-success .ant-progress-inner:not(.ant-progress-circle-gradient) .ant-progress-circle-path {
  stroke: #52c41a;
}

.ant-progress-circle .ant-progress-inner {
  position: relative;
  line-height: 1;
  background-color: transparent;
}

.ant-progress-circle .ant-progress-text {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 1em;
  line-height: 1;
  white-space: normal;
  text-align: center;
  transform: translate(-50%, -50%);
}

.ant-progress-circle .ant-progress-text .anticon {
  font-size: 1.16666667em;
}

.ant-progress-circle.ant-progress-status-exception .ant-progress-text {
  color: #ff4d4f;
}

.ant-progress-circle.ant-progress-status-success .ant-progress-text {
  color: #52c41a;
}

@keyframes ant-progress-active {
  0% {
    transform: translateX(-100%) scaleX(0);
    opacity: 0.1;
  }
  20% {
    transform: translateX(-100%) scaleX(0);
    opacity: 0.5;
  }
  to {
    transform: translateX(0) scaleX(1);
    opacity: 0;
  }
}
.ant-progress-rtl {
  direction: rtl;
}

.ant-progress-rtl.ant-progress-show-info .ant-progress-outer {
  margin-right: 0;
  margin-left: calc(-2em - 8px);
  padding-right: 0;
  padding-left: calc(2em + 8px);
}

.ant-progress-rtl .ant-progress-success-bg {
  right: 0;
  left: auto;
}

.ant-progress-rtl.ant-progress-line .ant-progress-text, .ant-progress-rtl.ant-progress-steps .ant-progress-text {
  margin-right: 8px;
  margin-left: 0;
  text-align: right;
}

.ant-radio-group {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  display: inline-block;
  font-size: 0;
}

.ant-radio-group .ant-badge-count {
  z-index: 1;
}

.ant-radio-group > .ant-badge:not(:first-child) > .ant-radio-button-wrapper {
  border-left: none;
}

.ant-radio-wrapper {
  box-sizing: border-box;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  display: inline-flex;
  align-items: baseline;
  margin: 0 8px 0 0;
  cursor: pointer;
}

.ant-radio-wrapper-disabled {
  cursor: not-allowed;
}

.ant-radio-wrapper:after {
  display: inline-block;
  width: 0;
  overflow: hidden;
  content: " ";
}

.ant-radio-wrapper.ant-radio-wrapper-in-form-item input[type=radio] {
  width: 14px;
  height: 14px;
}

.ant-radio {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  top: 0.2em;
  display: inline-block;
  outline: none;
  cursor: pointer;
}

.ant-radio-input:focus + .ant-radio-inner, .ant-radio-wrapper:hover .ant-radio, .ant-radio:hover .ant-radio-inner {
  border-color: #1890ff;
}

.ant-radio-input:focus + .ant-radio-inner {
  box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.12);
}

.ant-radio-checked:after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid #1890ff;
  border-radius: 50%;
  visibility: hidden;
  animation: antRadioEffect 0.36s ease-in-out;
  animation-fill-mode: both;
  content: "";
}

.ant-radio-wrapper:hover .ant-radio:after, .ant-radio:hover:after {
  visibility: visible;
}

.ant-radio-inner {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  width: 16px;
  height: 16px;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 50%;
  transition: all 0.3s;
}

.ant-radio-inner:after {
  position: absolute;
  top: 50%;
  left: 50%;
  display: block;
  width: 16px;
  height: 16px;
  margin-top: -8px;
  margin-left: -8px;
  background-color: #1890ff;
  border-top: 0;
  border-left: 0;
  border-radius: 16px;
  transform: scale(0);
  opacity: 0;
  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
  content: " ";
}

.ant-radio-input {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  cursor: pointer;
  opacity: 0;
}

.ant-radio.ant-radio-disabled .ant-radio-inner {
  border-color: #d9d9d9;
}

.ant-radio-checked .ant-radio-inner {
  border-color: #1890ff;
}

.ant-radio-checked .ant-radio-inner:after {
  transform: scale(0.5);
  opacity: 1;
  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
}

.ant-radio-disabled {
  cursor: not-allowed;
}

.ant-radio-disabled .ant-radio-inner {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.ant-radio-disabled .ant-radio-inner:after {
  background-color: rgba(0, 0, 0, 0.2);
}

.ant-radio-disabled .ant-radio-input {
  cursor: not-allowed;
}

.ant-radio-disabled + span {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

span.ant-radio + * {
  padding-right: 8px;
  padding-left: 8px;
}

.ant-radio-button-wrapper {
  position: relative;
  display: inline-block;
  height: 32px;
  margin: 0;
  padding: 0 15px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  line-height: 30px;
  background: #fff;
  border-color: #d9d9d9;
  border-style: solid;
  border-width: 1.02px 1px 1px 0;
  cursor: pointer;
  transition: color 0.3s, background 0.3s, border-color 0.3s, box-shadow 0.3s;
}

.ant-radio-button-wrapper a {
  color: rgba(0, 0, 0, 0.85);
}

.ant-radio-button-wrapper > .ant-radio-button {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
}

.ant-radio-group-large .ant-radio-button-wrapper {
  height: 40px;
  font-size: 16px;
  line-height: 38px;
}

.ant-radio-group-small .ant-radio-button-wrapper {
  height: 24px;
  padding: 0 7px;
  line-height: 22px;
}

.ant-radio-button-wrapper:not(:first-child):before {
  position: absolute;
  top: -1px;
  left: -1px;
  display: block;
  box-sizing: content-box;
  width: 1px;
  height: 100%;
  padding: 1px 0;
  background-color: #d9d9d9;
  transition: background-color 0.3s;
  content: "";
}

.ant-radio-button-wrapper:first-child {
  border-left: 1px solid #d9d9d9;
  border-radius: 2px 0 0 2px;
}

.ant-radio-button-wrapper:last-child {
  border-radius: 0 2px 2px 0;
}

.ant-radio-button-wrapper:first-child:last-child {
  border-radius: 2px;
}

.ant-radio-button-wrapper:hover {
  position: relative;
  color: #1890ff;
}

.ant-radio-button-wrapper:focus-within {
  box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.12);
}

.ant-radio-button-wrapper .ant-radio-inner, .ant-radio-button-wrapper input[type=checkbox], .ant-radio-button-wrapper input[type=radio] {
  width: 0;
  height: 0;
  opacity: 0;
  pointer-events: none;
}

.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  z-index: 1;
  color: #1890ff;
  background: #fff;
  border-color: #1890ff;
}

.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):before {
  background-color: #1890ff;
}

.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):first-child {
  border-color: #1890ff;
}

.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {
  color: #40a9ff;
  border-color: #40a9ff;
}

.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover:before {
  background-color: #40a9ff;
}

.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):active {
  color: #096dd9;
  border-color: #096dd9;
}

.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):active:before {
  background-color: #096dd9;
}

.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):focus-within {
  box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.12);
}

.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  color: #fff;
  background: #1890ff;
  border-color: #1890ff;
}

.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {
  color: #fff;
  background: #40a9ff;
  border-color: #40a9ff;
}

.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):active {
  color: #fff;
  background: #096dd9;
  border-color: #096dd9;
}

.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):focus-within {
  box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.12);
}

.ant-radio-button-wrapper-disabled {
  cursor: not-allowed;
}

.ant-radio-button-wrapper-disabled, .ant-radio-button-wrapper-disabled:first-child, .ant-radio-button-wrapper-disabled:hover {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
}

.ant-radio-button-wrapper-disabled:first-child {
  border-left-color: #d9d9d9;
}

.ant-radio-button-wrapper-disabled.ant-radio-button-wrapper-checked {
  color: rgba(0, 0, 0, 0.25);
  background-color: #e6e6e6;
  border-color: #d9d9d9;
  box-shadow: none;
}

@keyframes antRadioEffect {
  0% {
    transform: scale(1);
    opacity: 0.5;
  }
  to {
    transform: scale(1.6);
    opacity: 0;
  }
}
.ant-radio-group.ant-radio-group-rtl {
  direction: rtl;
}

.ant-radio-wrapper.ant-radio-wrapper-rtl {
  margin-right: 0;
  margin-left: 8px;
  direction: rtl;
}

.ant-radio-button-wrapper.ant-radio-button-wrapper-rtl {
  border-right-width: 0;
  border-left-width: 1px;
}

.ant-radio-button-wrapper.ant-radio-button-wrapper-rtl.ant-radio-button-wrapper:not(:first-child):before {
  right: -1px;
  left: 0;
}

.ant-radio-button-wrapper.ant-radio-button-wrapper-rtl.ant-radio-button-wrapper:first-child {
  border-right: 1px solid #d9d9d9;
  border-radius: 0 2px 2px 0;
}

.ant-radio-button-wrapper-checked:not([class*=" ant-radio-button-wrapper-disabled"]).ant-radio-button-wrapper:first-child {
  border-right-color: #40a9ff;
}

.ant-radio-button-wrapper.ant-radio-button-wrapper-rtl.ant-radio-button-wrapper:last-child {
  border-radius: 2px 0 0 2px;
}

.ant-radio-button-wrapper.ant-radio-button-wrapper-rtl.ant-radio-button-wrapper-disabled:first-child {
  border-right-color: #d9d9d9;
}

.ant-rate {
  box-sizing: border-box;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  font-feature-settings: "tnum";
  display: inline-block;
  margin: 0;
  padding: 0;
  color: #fadb14;
  font-size: 20px;
  line-height: unset;
  list-style: none;
  outline: none;
}

.ant-rate-disabled .ant-rate-star {
  cursor: default;
}

.ant-rate-disabled .ant-rate-star > div:hover {
  transform: scale(1);
}

.ant-rate-star {
  position: relative;
  display: inline-block;
  color: inherit;
  cursor: pointer;
}

.ant-rate-star:not(:last-child) {
  margin-right: 8px;
}

.ant-rate-star > div {
  transition: all 0.3s, outline 0s;
}

.ant-rate-star > div:hover {
  transform: scale(1.1);
}

.ant-rate-star > div:focus {
  outline: 0;
}

.ant-rate-star > div:focus-visible {
  outline: 1px dashed #fadb14;
  transform: scale(1.1);
}

.ant-rate-star-first, .ant-rate-star-second {
  color: #f0f0f0;
  transition: all 0.3s;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-rate-star-first .anticon, .ant-rate-star-second .anticon {
  vertical-align: middle;
}

.ant-rate-star-first {
  position: absolute;
  top: 0;
  left: 0;
  width: 50%;
  height: 100%;
  overflow: hidden;
  opacity: 0;
}

.ant-rate-star-half .ant-rate-star-first, .ant-rate-star-half .ant-rate-star-second {
  opacity: 1;
}

.ant-rate-star-full .ant-rate-star-second, .ant-rate-star-half .ant-rate-star-first {
  color: inherit;
}

.ant-rate-text {
  display: inline-block;
  margin: 0 8px;
  font-size: 14px;
}

.ant-rate-rtl {
  direction: rtl;
}

.ant-rate-rtl .ant-rate-star:not(:last-child) {
  margin-right: 0;
  margin-left: 8px;
}

.ant-rate-rtl .ant-rate-star-first {
  right: 0;
  left: auto;
}

.ant-result {
  padding: 48px 32px;
}

.ant-result-success .ant-result-icon > .anticon {
  color: #52c41a;
}

.ant-result-error .ant-result-icon > .anticon {
  color: #ff4d4f;
}

.ant-result-info .ant-result-icon > .anticon {
  color: #1890ff;
}

.ant-result-warning .ant-result-icon > .anticon {
  color: #faad14;
}

.ant-result-image {
  width: 250px;
  height: 295px;
  margin: auto;
}

.ant-result-icon {
  margin-bottom: 24px;
  text-align: center;
}

.ant-result-icon > .anticon {
  font-size: 72px;
}

.ant-result-title {
  color: rgba(0, 0, 0, 0.85);
  font-size: 24px;
  line-height: 1.8;
  text-align: center;
}

.ant-result-subtitle {
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
  line-height: 1.6;
  text-align: center;
}

.ant-result-extra {
  margin: 24px 0 0;
  text-align: center;
}

.ant-result-extra > * {
  margin-right: 8px;
}

.ant-result-extra > :last-child {
  margin-right: 0;
}

.ant-result-content {
  margin-top: 24px;
  padding: 24px 40px;
  background-color: #fafafa;
}

.ant-result-rtl {
  direction: rtl;
}

.ant-result-rtl .ant-result-extra > * {
  margin-right: 0;
  margin-left: 8px;
}

.ant-result-rtl .ant-result-extra > :last-child {
  margin-left: 0;
}

.segmented-disabled-item, .segmented-disabled-item:focus, .segmented-disabled-item:hover {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.segmented-item-selected {
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px -2px rgba(0, 0, 0, 0.05), 0 1px 4px -1px rgba(0, 0, 0, 0.07), 0 0 1px 0 rgba(0, 0, 0, 0.08);
}

.segmented-text-ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-break: keep-all;
}

.ant-segmented {
  box-sizing: border-box;
  margin: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  display: inline-block;
  padding: 2px;
  color: rgba(0, 0, 0, 0.65);
  background-color: rgba(0, 0, 0, 0.04);
  border-radius: 2px;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-segmented-group {
  position: relative;
  display: flex;
  align-items: stretch;
  justify-items: flex-start;
  width: 100%;
}

.ant-segmented.ant-segmented-block {
  display: flex;
}

.ant-segmented.ant-segmented-block .ant-segmented-item {
  flex: 1;
  min-width: 0;
}

.ant-segmented:not(.ant-segmented-disabled):focus, .ant-segmented:not(.ant-segmented-disabled):hover {
  background-color: rgba(0, 0, 0, 0.06);
}

.ant-segmented-item {
  position: relative;
  text-align: center;
  cursor: pointer;
  transition: color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-segmented-item-selected {
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px -2px rgba(0, 0, 0, 0.05), 0 1px 4px -1px rgba(0, 0, 0, 0.07), 0 0 1px 0 rgba(0, 0, 0, 0.08);
  color: #262626;
}

.ant-segmented-item:focus, .ant-segmented-item:hover {
  color: #262626;
}

.ant-segmented-item-label {
  min-height: 28px;
  padding: 0 11px;
  line-height: 28px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-break: keep-all;
}

.ant-segmented-item-icon + * {
  margin-left: 6px;
}

.ant-segmented-item-input {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  opacity: 0;
  pointer-events: none;
}

.ant-segmented.ant-segmented-lg .ant-segmented-item-label {
  min-height: 36px;
  padding: 0 11px;
  font-size: 16px;
  line-height: 36px;
}

.ant-segmented.ant-segmented-sm .ant-segmented-item-label {
  min-height: 20px;
  padding: 0 7px;
  line-height: 20px;
}

.ant-segmented-item-disabled, .ant-segmented-item-disabled:focus, .ant-segmented-item-disabled:hover {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ant-segmented-thumb {
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px -2px rgba(0, 0, 0, 0.05), 0 1px 4px -1px rgba(0, 0, 0, 0.07), 0 0 1px 0 rgba(0, 0, 0, 0.08);
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 100%;
  padding: 4px 0;
}

.ant-segmented-thumb-motion-appear-active {
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), width 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  will-change: transform, width;
}

.ant-segmented.ant-segmented-rtl {
  direction: rtl;
}

.ant-segmented.ant-segmented-rtl .ant-segmented-item-icon {
  margin-right: 0;
  margin-left: 6px;
}

.ant-select-single .ant-select-selector {
  display: flex;
}

.ant-select-single .ant-select-selector .ant-select-selection-search {
  position: absolute;
  top: 0;
  right: 11px;
  bottom: 0;
  left: 11px;
}

.ant-select-single .ant-select-selector .ant-select-selection-search-input {
  width: 100%;
}

.ant-select-single .ant-select-selector .ant-select-selection-item, .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
  padding: 0;
  line-height: 30px;
  transition: all 0.3s, visibility 0s;
}

.ant-select-single .ant-select-selector .ant-select-selection-item {
  position: relative;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-select-single .ant-select-selector .ant-select-selection-placeholder {
  transition: none;
  pointer-events: none;
}

.ant-select-single .ant-select-selector .ant-select-selection-item:after, .ant-select-single .ant-select-selector .ant-select-selection-placeholder:after, .ant-select-single .ant-select-selector:after {
  display: inline-block;
  width: 0;
  visibility: hidden;
  content: " ";
}

.ant-select-single.ant-select-show-arrow .ant-select-selection-search {
  right: 25px;
}

.ant-select-single.ant-select-show-arrow .ant-select-selection-item, .ant-select-single.ant-select-show-arrow .ant-select-selection-placeholder {
  padding-right: 18px;
}

.ant-select-single.ant-select-open .ant-select-selection-item {
  color: #bfbfbf;
}

.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
  width: 100%;
  height: 32px;
  padding: 0 11px;
}

.ant-select-single:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-search-input {
  height: 30px;
}

.ant-select-single:not(.ant-select-customize-input) .ant-select-selector:after {
  line-height: 30px;
}

.ant-select-single.ant-select-customize-input .ant-select-selector:after {
  display: none;
}

.ant-select-single.ant-select-customize-input .ant-select-selector .ant-select-selection-search {
  position: static;
  width: 100%;
}

.ant-select-single.ant-select-customize-input .ant-select-selector .ant-select-selection-placeholder {
  position: absolute;
  right: 0;
  left: 0;
  padding: 0 11px;
}

.ant-select-single.ant-select-customize-input .ant-select-selector .ant-select-selection-placeholder:after {
  display: none;
}

.ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector {
  height: 40px;
}

.ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-item, .ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-placeholder, .ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector:after {
  line-height: 38px;
}

.ant-select-single.ant-select-lg:not(.ant-select-customize-input):not(.ant-select-customize-input) .ant-select-selection-search-input {
  height: 38px;
}

.ant-select-single.ant-select-sm:not(.ant-select-customize-input) .ant-select-selector {
  height: 24px;
}

.ant-select-single.ant-select-sm:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-item, .ant-select-single.ant-select-sm:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-placeholder, .ant-select-single.ant-select-sm:not(.ant-select-customize-input) .ant-select-selector:after {
  line-height: 22px;
}

.ant-select-single.ant-select-sm:not(.ant-select-customize-input):not(.ant-select-customize-input) .ant-select-selection-search-input {
  height: 22px;
}

.ant-select-single.ant-select-sm:not(.ant-select-customize-input) .ant-select-selection-search {
  right: 7px;
  left: 7px;
}

.ant-select-single.ant-select-sm:not(.ant-select-customize-input) .ant-select-selector {
  padding: 0 7px;
}

.ant-select-single.ant-select-sm:not(.ant-select-customize-input).ant-select-show-arrow .ant-select-selection-search {
  right: 28px;
}

.ant-select-single.ant-select-sm:not(.ant-select-customize-input).ant-select-show-arrow .ant-select-selection-item, .ant-select-single.ant-select-sm:not(.ant-select-customize-input).ant-select-show-arrow .ant-select-selection-placeholder {
  padding-right: 21px;
}

.ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector {
  padding: 0 11px;
}

.ant-select-selection-overflow {
  position: relative;
  display: flex;
  flex: auto;
  flex-wrap: wrap;
  max-width: 100%;
}

.ant-select-selection-overflow-item {
  flex: none;
  align-self: center;
  max-width: 100%;
}

.ant-select-multiple .ant-select-selector {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 1px 4px;
}

.ant-select-show-search.ant-select-multiple .ant-select-selector {
  cursor: text;
}

.ant-select-disabled.ant-select-multiple .ant-select-selector {
  background: #f5f5f5;
  cursor: not-allowed;
}

.ant-select-multiple .ant-select-selector:after {
  display: inline-block;
  width: 0;
  margin: 2px 0;
  line-height: 24px;
  content: " ";
}

.ant-select-multiple.ant-select-allow-clear .ant-select-selector, .ant-select-multiple.ant-select-show-arrow .ant-select-selector {
  padding-right: 24px;
}

.ant-select-multiple .ant-select-selection-item {
  position: relative;
  display: flex;
  flex: none;
  box-sizing: border-box;
  max-width: 100%;
  height: 24px;
  margin-top: 2px;
  margin-bottom: 2px;
  line-height: 22px;
  background: #f5f5f5;
  border: 1px solid #f0f0f0;
  border-radius: 2px;
  cursor: default;
  transition: font-size 0.3s, line-height 0.3s, height 0.3s;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-margin-end: 4px;
  margin-inline-end: 4px;
  -webkit-padding-start: 8px;
  padding-inline-start: 8px;
  -webkit-padding-end: 4px;
  padding-inline-end: 4px;
}

.ant-select-disabled.ant-select-multiple .ant-select-selection-item {
  color: #bfbfbf;
  border-color: #d9d9d9;
  cursor: not-allowed;
}

.ant-select-multiple .ant-select-selection-item-content {
  display: inline-block;
  margin-right: 4px;
  overflow: hidden;
  white-space: pre;
  text-overflow: ellipsis;
}

.ant-select-multiple .ant-select-selection-item-remove {
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: inline-block;
  color: rgba(0, 0, 0, 0.45);
  font-weight: 700;
  font-size: 10px;
  line-height: inherit;
  cursor: pointer;
}

.ant-select-multiple .ant-select-selection-item-remove > * {
  line-height: 1;
}

.ant-select-multiple .ant-select-selection-item-remove svg {
  display: inline-block;
}

.ant-select-multiple .ant-select-selection-item-remove:before {
  display: none;
}

.ant-select-multiple .ant-select-selection-item-remove .ant-select-multiple .ant-select-selection-item-remove-icon {
  display: block;
}

.ant-select-multiple .ant-select-selection-item-remove > .anticon {
  vertical-align: middle;
}

.ant-select-multiple .ant-select-selection-item-remove:hover {
  color: rgba(0, 0, 0, 0.75);
}

.ant-select-multiple .ant-select-selection-overflow-item + .ant-select-selection-overflow-item .ant-select-selection-search {
  -webkit-margin-start: 0;
  margin-inline-start: 0;
}

.ant-select-multiple .ant-select-selection-search {
  position: relative;
  max-width: 100%;
  -webkit-margin-start: 7px;
  margin-inline-start: 7px;
}

.ant-select-multiple .ant-select-selection-search-input, .ant-select-multiple .ant-select-selection-search-mirror {
  height: 24px;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  line-height: 24px;
  transition: all 0.3s;
}

.ant-select-multiple .ant-select-selection-search-input {
  width: 100%;
  min-width: 4.1px;
}

.ant-select-multiple .ant-select-selection-search-mirror {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  white-space: pre;
  visibility: hidden;
}

.ant-select-multiple .ant-select-selection-placeholder {
  position: absolute;
  top: 50%;
  right: 11px;
  left: 11px;
  transform: translateY(-50%);
  transition: all 0.3s;
}

.ant-select-multiple.ant-select-lg .ant-select-selector:after {
  line-height: 32px;
}

.ant-select-multiple.ant-select-lg .ant-select-selection-item {
  line-height: 30px;
}

.ant-select-multiple.ant-select-lg .ant-select-selection-search {
  height: 32px;
  line-height: 32px;
}

.ant-select-multiple.ant-select-lg .ant-select-selection-search-input, .ant-select-multiple.ant-select-lg .ant-select-selection-search-mirror {
  height: 32px;
  line-height: 30px;
}

.ant-select-multiple.ant-select-sm .ant-select-selector:after {
  line-height: 16px;
}

.ant-select-multiple.ant-select-sm .ant-select-selection-item {
  height: 16px;
  line-height: 14px;
}

.ant-select-multiple.ant-select-sm .ant-select-selection-search {
  height: 16px;
  line-height: 16px;
}

.ant-select-multiple.ant-select-sm .ant-select-selection-search-input, .ant-select-multiple.ant-select-sm .ant-select-selection-search-mirror {
  height: 16px;
  line-height: 14px;
}

.ant-select-multiple.ant-select-sm .ant-select-selection-placeholder {
  left: 7px;
}

.ant-select-multiple.ant-select-sm .ant-select-selection-search {
  -webkit-margin-start: 3px;
  margin-inline-start: 3px;
}

.ant-select-multiple.ant-select-lg .ant-select-selection-item {
  height: 32px;
  line-height: 32px;
}

.ant-select-disabled .ant-select-selection-item-remove {
  display: none;
}

.ant-select-status-error.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer) .ant-select-selector {
  background-color: #fff;
  border-color: #ff4d4f !important;
}

.ant-select-status-error.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer).ant-select-focused .ant-select-selector, .ant-select-status-error.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer).ant-select-open .ant-select-selector {
  border-color: #ff7875;
  box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-select-status-warning.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer) .ant-select-selector {
  background-color: #fff;
  border-color: #faad14 !important;
}

.ant-select-status-warning.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer).ant-select-focused .ant-select-selector, .ant-select-status-warning.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer).ant-select-open .ant-select-selector {
  border-color: #ffc53d;
  box-shadow: 0 0 0 2px rgba(250, 173, 20, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-select-status-error.ant-select-has-feedback .ant-select-clear, .ant-select-status-success.ant-select-has-feedback .ant-select-clear, .ant-select-status-validating.ant-select-has-feedback .ant-select-clear, .ant-select-status-warning.ant-select-has-feedback .ant-select-clear {
  right: 32px;
}

.ant-select-status-error.ant-select-has-feedback .ant-select-selection-selected-value, .ant-select-status-success.ant-select-has-feedback .ant-select-selection-selected-value, .ant-select-status-validating.ant-select-has-feedback .ant-select-selection-selected-value, .ant-select-status-warning.ant-select-has-feedback .ant-select-selection-selected-value {
  padding-right: 42px;
}

.ant-select {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.ant-select:not(.ant-select-customize-input) .ant-select-selector {
  position: relative;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-select:not(.ant-select-customize-input) .ant-select-selector input {
  cursor: pointer;
}

.ant-select-show-search.ant-select:not(.ant-select-customize-input) .ant-select-selector {
  cursor: text;
}

.ant-select-show-search.ant-select:not(.ant-select-customize-input) .ant-select-selector input {
  cursor: auto;
}

.ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector {
  color: rgba(0, 0, 0, 0.25);
  background: #f5f5f5;
  cursor: not-allowed;
}

.ant-select-multiple.ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector {
  background: #f5f5f5;
}

.ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector input {
  cursor: not-allowed;
}

.ant-select:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-search-input {
  margin: 0;
  padding: 0;
  background: transparent;
  border: none;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.ant-select:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-search-input::-webkit-search-cancel-button {
  display: none;
  -webkit-appearance: none;
}

.ant-select:not(.ant-select-disabled):hover .ant-select-selector {
  border-color: #40a9ff;
  border-right-width: 1px;
}

.ant-select-selection-item {
  flex: 1;
  overflow: hidden;
  font-weight: 400;
  white-space: nowrap;
  text-overflow: ellipsis;
}

@media (-ms-high-contrast: none) {
  .ant-select-selection-item, .ant-select-selection-item ::-ms-backdrop {
    flex: auto;
  }
}
.ant-select-selection-placeholder {
  flex: 1;
  overflow: hidden;
  color: #bfbfbf;
  white-space: nowrap;
  text-overflow: ellipsis;
  pointer-events: none;
}

@media (-ms-high-contrast: none) {
  .ant-select-selection-placeholder, .ant-select-selection-placeholder ::-ms-backdrop {
    flex: auto;
  }
}
.ant-select-arrow {
  display: inline-block;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  top: 50%;
  right: 11px;
  display: flex;
  align-items: center;
  height: 12px;
  margin-top: -6px;
  color: rgba(0, 0, 0, 0.25);
  font-size: 12px;
  line-height: 1;
  text-align: center;
  pointer-events: none;
}

.ant-select-arrow > * {
  line-height: 1;
}

.ant-select-arrow svg {
  display: inline-block;
}

.ant-select-arrow:before {
  display: none;
}

.ant-select-arrow .ant-select-arrow-icon {
  display: block;
}

.ant-select-arrow .anticon {
  vertical-align: top;
  transition: transform 0.3s;
}

.ant-select-arrow .anticon > svg {
  vertical-align: top;
}

.ant-select-arrow .anticon:not(.ant-select-suffix) {
  pointer-events: auto;
}

.ant-select-disabled .ant-select-arrow {
  cursor: not-allowed;
}

.ant-select-arrow > :not(:last-child) {
  -webkit-margin-end: 8px;
  margin-inline-end: 8px;
}

.ant-select-clear {
  position: absolute;
  top: 50%;
  right: 11px;
  z-index: 1;
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-top: -6px;
  color: rgba(0, 0, 0, 0.25);
  font-size: 12px;
  font-style: normal;
  line-height: 1;
  text-align: center;
  text-transform: none;
  background: #fff;
  cursor: pointer;
  opacity: 0;
  transition: color 0.3s ease, opacity 0.15s ease;
  text-rendering: auto;
}

.ant-select-clear:before {
  display: block;
}

.ant-select-clear:hover {
  color: rgba(0, 0, 0, 0.45);
}

.ant-select:hover .ant-select-clear {
  opacity: 1;
}

.ant-select-dropdown {
  margin: 0;
  color: rgba(0, 0, 0, 0.85);
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: absolute;
  top: -9999px;
  left: -9999px;
  z-index: 1050;
  box-sizing: border-box;
  padding: 4px 0;
  overflow: hidden;
  font-size: 14px;
  font-variant: normal;
  background-color: #fff;
  border-radius: 2px;
  outline: none;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
}

.ant-select-dropdown.ant-slide-up-appear.ant-slide-up-appear-active.ant-select-dropdown-placement-bottomLeft, .ant-select-dropdown.ant-slide-up-enter.ant-slide-up-enter-active.ant-select-dropdown-placement-bottomLeft {
  animation-name: antSlideUpIn;
}

.ant-select-dropdown.ant-slide-up-appear.ant-slide-up-appear-active.ant-select-dropdown-placement-topLeft, .ant-select-dropdown.ant-slide-up-enter.ant-slide-up-enter-active.ant-select-dropdown-placement-topLeft {
  animation-name: antSlideDownIn;
}

.ant-select-dropdown.ant-slide-up-leave.ant-slide-up-leave-active.ant-select-dropdown-placement-bottomLeft {
  animation-name: antSlideUpOut;
}

.ant-select-dropdown.ant-slide-up-leave.ant-slide-up-leave-active.ant-select-dropdown-placement-topLeft {
  animation-name: antSlideDownOut;
}

.ant-select-dropdown-hidden {
  display: none;
}

.ant-select-dropdown-empty {
  color: rgba(0, 0, 0, 0.25);
}

.ant-select-item-empty {
  color: rgba(0, 0, 0, 0.85);
  color: rgba(0, 0, 0, 0.25);
}

.ant-select-item, .ant-select-item-empty {
  position: relative;
  display: block;
  min-height: 32px;
  padding: 5px 12px;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
}

.ant-select-item {
  color: rgba(0, 0, 0, 0.85);
  cursor: pointer;
  transition: background 0.3s ease;
}

.ant-select-item-group {
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
  cursor: default;
}

.ant-select-item-option {
  display: flex;
}

.ant-select-item-option-content {
  flex: auto;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ant-select-item-option-state {
  flex: none;
}

.ant-select-item-option-active:not(.ant-select-item-option-disabled) {
  background-color: #f5f5f5;
}

.ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
  color: rgba(0, 0, 0, 0.85);
  font-weight: 600;
  background-color: #e6f7ff;
}

.ant-select-item-option-selected:not(.ant-select-item-option-disabled) .ant-select-item-option-state {
  color: #1890ff;
}

.ant-select-item-option-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ant-select-item-option-disabled.ant-select-item-option-selected {
  background-color: #f5f5f5;
}

.ant-select-item-option-grouped {
  padding-left: 24px;
}

.ant-select-lg {
  font-size: 16px;
}

.ant-select-borderless .ant-select-selector {
  background-color: transparent !important;
  border-color: transparent !important;
  box-shadow: none !important;
}

.ant-select.ant-select-in-form-item {
  width: 100%;
}

.ant-select-compact-item:not(.ant-select-compact-last-item) {
  margin-right: -1px;
}

.ant-select-compact-item:not(.ant-select-compact-last-item).ant-select-compact-item-rtl {
  margin-right: 0;
  margin-left: -1px;
}

.ant-select-compact-item.ant-select-focused > *, .ant-select-compact-item:active > *, .ant-select-compact-item:focus > *, .ant-select-compact-item:hover > * {
  z-index: 2;
}

.ant-select-compact-item[disabled] > * {
  z-index: 0;
}

.ant-select-compact-item:not(.ant-select-compact-first-item):not(.ant-select-compact-last-item).ant-select > .ant-select-selector {
  border-radius: 0;
}

.ant-select-compact-item.ant-select-compact-first-item.ant-select:not(.ant-select-compact-last-item):not(.ant-select-compact-item-rtl) > .ant-select-selector {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-select-compact-item.ant-select-compact-last-item.ant-select:not(.ant-select-compact-first-item):not(.ant-select-compact-item-rtl) > .ant-select-selector, .ant-select-compact-item.ant-select.ant-select-compact-first-item.ant-select-compact-item-rtl:not(.ant-select-compact-last-item) > .ant-select-selector {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.ant-select-compact-item.ant-select.ant-select-compact-last-item.ant-select-compact-item-rtl:not(.ant-select-compact-first-item) > .ant-select-selector {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-select-rtl {
  direction: rtl;
}

.ant-select-rtl .ant-select-arrow, .ant-select-rtl .ant-select-clear {
  right: auto;
  left: 11px;
}

.ant-select-dropdown-rtl {
  direction: rtl;
}

.ant-select-dropdown-rtl .ant-select-item-option-grouped {
  padding-right: 24px;
  padding-left: 12px;
}

.ant-select-rtl.ant-select-multiple.ant-select-allow-clear .ant-select-selector, .ant-select-rtl.ant-select-multiple.ant-select-show-arrow .ant-select-selector {
  padding-right: 4px;
  padding-left: 24px;
}

.ant-select-rtl.ant-select-multiple .ant-select-selection-item {
  text-align: right;
}

.ant-select-rtl.ant-select-multiple .ant-select-selection-item-content {
  margin-right: 0;
  margin-left: 4px;
  text-align: right;
}

.ant-select-rtl.ant-select-multiple .ant-select-selection-search-mirror {
  right: 0;
  left: auto;
}

.ant-select-rtl.ant-select-multiple .ant-select-selection-placeholder {
  right: 11px;
  left: auto;
}

.ant-select-rtl.ant-select-multiple.ant-select-sm .ant-select-selection-placeholder {
  right: 7px;
}

.ant-select-rtl.ant-select-single .ant-select-selector .ant-select-selection-item, .ant-select-rtl.ant-select-single .ant-select-selector .ant-select-selection-placeholder {
  right: 0;
  left: 9px;
  text-align: right;
}

.ant-select-rtl.ant-select-single.ant-select-show-arrow .ant-select-selection-search {
  right: 11px;
  left: 25px;
}

.ant-select-rtl.ant-select-single.ant-select-show-arrow .ant-select-selection-item, .ant-select-rtl.ant-select-single.ant-select-show-arrow .ant-select-selection-placeholder {
  padding-right: 0;
  padding-left: 18px;
}

.ant-select-rtl.ant-select-single.ant-select-sm:not(.ant-select-customize-input).ant-select-show-arrow .ant-select-selection-search {
  right: 6px;
}

.ant-select-rtl.ant-select-single.ant-select-sm:not(.ant-select-customize-input).ant-select-show-arrow .ant-select-selection-item, .ant-select-rtl.ant-select-single.ant-select-sm:not(.ant-select-customize-input).ant-select-show-arrow .ant-select-selection-placeholder {
  padding-right: 0;
  padding-left: 21px;
}

.ant-skeleton {
  display: table;
  width: 100%;
}

.ant-skeleton-header {
  display: table-cell;
  padding-right: 16px;
  vertical-align: top;
}

.ant-skeleton-header .ant-skeleton-avatar {
  display: inline-block;
  vertical-align: top;
  background: hsla(0, 0%, 74.5%, 0.2);
  width: 32px;
  height: 32px;
  line-height: 32px;
}

.ant-skeleton-header .ant-skeleton-avatar.ant-skeleton-avatar-circle {
  border-radius: 50%;
}

.ant-skeleton-header .ant-skeleton-avatar-lg {
  width: 40px;
  height: 40px;
  line-height: 40px;
}

.ant-skeleton-header .ant-skeleton-avatar-lg.ant-skeleton-avatar-circle {
  border-radius: 50%;
}

.ant-skeleton-header .ant-skeleton-avatar-sm {
  width: 24px;
  height: 24px;
  line-height: 24px;
}

.ant-skeleton-header .ant-skeleton-avatar-sm.ant-skeleton-avatar-circle {
  border-radius: 50%;
}

.ant-skeleton-content {
  display: table-cell;
  width: 100%;
  vertical-align: top;
}

.ant-skeleton-content .ant-skeleton-title {
  width: 100%;
  height: 16px;
  background: hsla(0, 0%, 74.5%, 0.2);
  border-radius: 2px;
}

.ant-skeleton-content .ant-skeleton-title + .ant-skeleton-paragraph {
  margin-top: 24px;
}

.ant-skeleton-content .ant-skeleton-paragraph {
  padding: 0;
}

.ant-skeleton-content .ant-skeleton-paragraph > li {
  width: 100%;
  height: 16px;
  list-style: none;
  background: hsla(0, 0%, 74.5%, 0.2);
  border-radius: 2px;
}

.ant-skeleton-content .ant-skeleton-paragraph > li:last-child:not(:first-child):not(:nth-child(2)) {
  width: 61%;
}

.ant-skeleton-content .ant-skeleton-paragraph > li + li {
  margin-top: 16px;
}

.ant-skeleton-with-avatar .ant-skeleton-content .ant-skeleton-title {
  margin-top: 12px;
}

.ant-skeleton-with-avatar .ant-skeleton-content .ant-skeleton-title + .ant-skeleton-paragraph {
  margin-top: 28px;
}

.ant-skeleton-round .ant-skeleton-content .ant-skeleton-paragraph > li, .ant-skeleton-round .ant-skeleton-content .ant-skeleton-title {
  border-radius: 100px;
}

.ant-skeleton-active .ant-skeleton-avatar, .ant-skeleton-active .ant-skeleton-button, .ant-skeleton-active .ant-skeleton-image, .ant-skeleton-active .ant-skeleton-input, .ant-skeleton-active .ant-skeleton-paragraph > li, .ant-skeleton-active .ant-skeleton-title {
  position: relative;
  z-index: 0;
  overflow: hidden;
  background: transparent;
}

.ant-skeleton-active .ant-skeleton-avatar:after, .ant-skeleton-active .ant-skeleton-button:after, .ant-skeleton-active .ant-skeleton-image:after, .ant-skeleton-active .ant-skeleton-input:after, .ant-skeleton-active .ant-skeleton-paragraph > li:after, .ant-skeleton-active .ant-skeleton-title:after {
  position: absolute;
  top: 0;
  right: -150%;
  bottom: 0;
  left: -150%;
  background: linear-gradient(90deg, hsla(0, 0%, 74.5%, 0.2) 25%, hsla(0, 0%, 50.6%, 0.24) 37%, hsla(0, 0%, 74.5%, 0.2) 63%);
  animation: ant-skeleton-loading 1.4s ease infinite;
  content: "";
}

.ant-skeleton.ant-skeleton-block, .ant-skeleton.ant-skeleton-block .ant-skeleton-button, .ant-skeleton.ant-skeleton-block .ant-skeleton-input {
  width: 100%;
}

.ant-skeleton-element {
  display: inline-block;
  width: auto;
}

.ant-skeleton-element .ant-skeleton-button {
  display: inline-block;
  vertical-align: top;
  background: hsla(0, 0%, 74.5%, 0.2);
  border-radius: 2px;
  width: 64px;
  min-width: 64px;
  height: 32px;
  line-height: 32px;
}

.ant-skeleton-element .ant-skeleton-button.ant-skeleton-button-square {
  width: 32px;
  min-width: 32px;
}

.ant-skeleton-element .ant-skeleton-button.ant-skeleton-button-circle {
  width: 32px;
  min-width: 32px;
  border-radius: 50%;
}

.ant-skeleton-element .ant-skeleton-button.ant-skeleton-button-round {
  border-radius: 32px;
}

.ant-skeleton-element .ant-skeleton-button-lg {
  width: 80px;
  min-width: 80px;
  height: 40px;
  line-height: 40px;
}

.ant-skeleton-element .ant-skeleton-button-lg.ant-skeleton-button-square {
  width: 40px;
  min-width: 40px;
}

.ant-skeleton-element .ant-skeleton-button-lg.ant-skeleton-button-circle {
  width: 40px;
  min-width: 40px;
  border-radius: 50%;
}

.ant-skeleton-element .ant-skeleton-button-lg.ant-skeleton-button-round {
  border-radius: 40px;
}

.ant-skeleton-element .ant-skeleton-button-sm {
  width: 48px;
  min-width: 48px;
  height: 24px;
  line-height: 24px;
}

.ant-skeleton-element .ant-skeleton-button-sm.ant-skeleton-button-square {
  width: 24px;
  min-width: 24px;
}

.ant-skeleton-element .ant-skeleton-button-sm.ant-skeleton-button-circle {
  width: 24px;
  min-width: 24px;
  border-radius: 50%;
}

.ant-skeleton-element .ant-skeleton-button-sm.ant-skeleton-button-round {
  border-radius: 24px;
}

.ant-skeleton-element .ant-skeleton-avatar {
  display: inline-block;
  vertical-align: top;
  background: hsla(0, 0%, 74.5%, 0.2);
  width: 32px;
  height: 32px;
  line-height: 32px;
}

.ant-skeleton-element .ant-skeleton-avatar.ant-skeleton-avatar-circle {
  border-radius: 50%;
}

.ant-skeleton-element .ant-skeleton-avatar-lg {
  width: 40px;
  height: 40px;
  line-height: 40px;
}

.ant-skeleton-element .ant-skeleton-avatar-lg.ant-skeleton-avatar-circle {
  border-radius: 50%;
}

.ant-skeleton-element .ant-skeleton-avatar-sm {
  width: 24px;
  height: 24px;
  line-height: 24px;
}

.ant-skeleton-element .ant-skeleton-avatar-sm.ant-skeleton-avatar-circle {
  border-radius: 50%;
}

.ant-skeleton-element .ant-skeleton-input {
  display: inline-block;
  vertical-align: top;
  background: hsla(0, 0%, 74.5%, 0.2);
  width: 160px;
  min-width: 160px;
  height: 32px;
  line-height: 32px;
}

.ant-skeleton-element .ant-skeleton-input-lg {
  width: 200px;
  min-width: 200px;
  height: 40px;
  line-height: 40px;
}

.ant-skeleton-element .ant-skeleton-input-sm {
  width: 120px;
  min-width: 120px;
  height: 24px;
  line-height: 24px;
}

.ant-skeleton-element .ant-skeleton-image {
  display: flex;
  align-items: center;
  justify-content: center;
  vertical-align: top;
  background: hsla(0, 0%, 74.5%, 0.2);
  width: 96px;
  height: 96px;
  line-height: 96px;
}

.ant-skeleton-element .ant-skeleton-image.ant-skeleton-image-circle {
  border-radius: 50%;
}

.ant-skeleton-element .ant-skeleton-image-path {
  fill: #bfbfbf;
}

.ant-skeleton-element .ant-skeleton-image-svg {
  width: 48px;
  height: 48px;
  line-height: 48px;
  max-width: 192px;
  max-height: 192px;
}

.ant-skeleton-element .ant-skeleton-image-svg.ant-skeleton-image-circle {
  border-radius: 50%;
}

@keyframes ant-skeleton-loading {
  0% {
    transform: translateX(-37.5%);
  }
  to {
    transform: translateX(37.5%);
  }
}
.ant-skeleton-rtl {
  direction: rtl;
}

.ant-skeleton-rtl .ant-skeleton-header {
  padding-right: 0;
  padding-left: 16px;
}

.ant-skeleton-rtl.ant-skeleton.ant-skeleton-active .ant-skeleton-avatar, .ant-skeleton-rtl.ant-skeleton.ant-skeleton-active .ant-skeleton-content .ant-skeleton-paragraph > li, .ant-skeleton-rtl.ant-skeleton.ant-skeleton-active .ant-skeleton-content .ant-skeleton-title {
  animation-name: ant-skeleton-loading-rtl;
}

@keyframes ant-skeleton-loading-rtl {
  0% {
    background-position: 0 50%;
  }
  to {
    background-position: 100% 50%;
  }
}
.ant-slider {
  box-sizing: border-box;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  height: 12px;
  margin: 10px 6px;
  padding: 4px 0;
  cursor: pointer;
  touch-action: none;
}

.ant-slider-vertical {
  width: 12px;
  height: 100%;
  margin: 6px 10px;
  padding: 0 4px;
}

.ant-slider-vertical .ant-slider-rail {
  width: 4px;
  height: 100%;
}

.ant-slider-vertical .ant-slider-track {
  width: 4px;
}

.ant-slider-vertical .ant-slider-handle {
  margin-top: -6px;
  margin-left: -5px;
}

.ant-slider-vertical .ant-slider-mark {
  top: 0;
  left: 12px;
  width: 18px;
  height: 100%;
}

.ant-slider-vertical .ant-slider-mark-text {
  left: 4px;
  white-space: nowrap;
}

.ant-slider-vertical .ant-slider-step {
  width: 4px;
  height: 100%;
}

.ant-slider-vertical .ant-slider-dot {
  top: auto;
  margin-left: -2px;
}

.ant-slider-tooltip .ant-tooltip-inner {
  min-width: unset;
}

.ant-slider-rtl.ant-slider-vertical .ant-slider-handle {
  margin-right: -5px;
  margin-left: 0;
}

.ant-slider-rtl.ant-slider-vertical .ant-slider-mark {
  right: 12px;
  left: auto;
}

.ant-slider-rtl.ant-slider-vertical .ant-slider-mark-text {
  right: 4px;
  left: auto;
}

.ant-slider-rtl.ant-slider-vertical .ant-slider-dot {
  right: 2px;
  left: auto;
}

.ant-slider-with-marks {
  margin-bottom: 28px;
}

.ant-slider-rail {
  width: 100%;
  background-color: #f5f5f5;
}

.ant-slider-rail, .ant-slider-track {
  position: absolute;
  height: 4px;
  border-radius: 2px;
  transition: background-color 0.3s;
}

.ant-slider-track {
  background-color: #91d5ff;
}

.ant-slider-handle {
  position: absolute;
  width: 14px;
  height: 14px;
  margin-top: -5px;
  background-color: #fff;
  border: 2px solid #91d5ff;
  border-radius: 50%;
  box-shadow: 0;
  cursor: pointer;
  transition: border-color 0.3s, box-shadow 0.6s, transform 0.3s cubic-bezier(0.18, 0.89, 0.32, 1.28);
}

.ant-slider-handle-dragging {
  z-index: 1;
}

.ant-slider-handle:focus {
  border-color: #46a6ff;
  outline: none;
  box-shadow: 0 0 0 5px rgba(24, 144, 255, 0.12);
}

.ant-slider-handle.ant-tooltip-open {
  border-color: #1890ff;
}

.ant-slider-handle:after {
  position: absolute;
  top: -6px;
  right: -6px;
  bottom: -6px;
  left: -6px;
  content: "";
}

.ant-slider:hover .ant-slider-rail {
  background-color: #e1e1e1;
}

.ant-slider:hover .ant-slider-track {
  background-color: #69c0ff;
}

.ant-slider:hover .ant-slider-handle:not(.ant-tooltip-open) {
  border-color: #69c0ff;
}

.ant-slider-mark {
  position: absolute;
  top: 14px;
  left: 0;
  width: 100%;
  font-size: 14px;
}

.ant-slider-mark-text {
  position: absolute;
  display: inline-block;
  color: rgba(0, 0, 0, 0.45);
  text-align: center;
  word-break: keep-all;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-slider-mark-text-active {
  color: rgba(0, 0, 0, 0.85);
}

.ant-slider-step {
  position: absolute;
  width: 100%;
  height: 4px;
  background: transparent;
  pointer-events: none;
}

.ant-slider-dot {
  position: absolute;
  top: -2px;
  width: 8px;
  height: 8px;
  background-color: #fff;
  border: 2px solid #f0f0f0;
  border-radius: 50%;
  cursor: pointer;
}

.ant-slider-dot-active {
  border-color: #8cc8ff;
}

.ant-slider-disabled {
  cursor: not-allowed;
}

.ant-slider-disabled .ant-slider-rail {
  background-color: #f5f5f5 !important;
}

.ant-slider-disabled .ant-slider-track {
  background-color: rgba(0, 0, 0, 0.25) !important;
}

.ant-slider-disabled .ant-slider-dot, .ant-slider-disabled .ant-slider-handle {
  background-color: #fff;
  border-color: rgba(0, 0, 0, 0.25) !important;
  box-shadow: none;
  cursor: not-allowed;
}

.ant-slider-disabled .ant-slider-dot, .ant-slider-disabled .ant-slider-mark-text {
  cursor: not-allowed !important;
}

.ant-slider-rtl {
  direction: rtl;
}

.ant-slider-rtl .ant-slider-mark {
  right: 0;
  left: auto;
}

.ant-space {
  display: inline-flex;
}

.ant-space-vertical {
  flex-direction: column;
}

.ant-space-align-center {
  align-items: center;
}

.ant-space-align-start {
  align-items: flex-start;
}

.ant-space-align-end {
  align-items: flex-end;
}

.ant-space-align-baseline {
  align-items: baseline;
}

.ant-space-item:empty {
  display: none;
}

.ant-space-compact {
  display: inline-flex;
}

.ant-space-compact-block {
  display: flex;
  width: 100%;
}

.ant-space-compact-vertical {
  flex-direction: column;
}

.ant-space-compact-rtl, .ant-space-rtl {
  direction: rtl;
}

.ant-spin {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: absolute;
  display: none;
  color: #1890ff;
  text-align: center;
  vertical-align: middle;
  opacity: 0;
  transition: transform 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
}

.ant-spin-spinning {
  position: static;
  display: inline-block;
  opacity: 1;
}

.ant-spin-nested-loading {
  position: relative;
}

.ant-spin-nested-loading > div > .ant-spin {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 4;
  display: block;
  width: 100%;
  height: 100%;
  max-height: 400px;
}

.ant-spin-nested-loading > div > .ant-spin .ant-spin-dot {
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -10px;
}

.ant-spin-nested-loading > div > .ant-spin .ant-spin-text {
  position: absolute;
  top: 50%;
  width: 100%;
  padding-top: 5px;
  text-shadow: 0 1px 2px #fff;
}

.ant-spin-nested-loading > div > .ant-spin.ant-spin-show-text .ant-spin-dot {
  margin-top: -20px;
}

.ant-spin-nested-loading > div > .ant-spin-sm .ant-spin-dot {
  margin: -7px;
}

.ant-spin-nested-loading > div > .ant-spin-sm .ant-spin-text {
  padding-top: 2px;
}

.ant-spin-nested-loading > div > .ant-spin-sm.ant-spin-show-text .ant-spin-dot {
  margin-top: -17px;
}

.ant-spin-nested-loading > div > .ant-spin-lg .ant-spin-dot {
  margin: -16px;
}

.ant-spin-nested-loading > div > .ant-spin-lg .ant-spin-text {
  padding-top: 11px;
}

.ant-spin-nested-loading > div > .ant-spin-lg.ant-spin-show-text .ant-spin-dot {
  margin-top: -26px;
}

.ant-spin-container {
  position: relative;
  transition: opacity 0.3s;
}

.ant-spin-container:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  display: none\\9 ;
  width: 100%;
  height: 100%;
  background: #fff;
  opacity: 0;
  transition: all 0.3s;
  content: "";
  pointer-events: none;
}

.ant-spin-blur {
  clear: both;
  opacity: 0.5;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  pointer-events: none;
}

.ant-spin-blur:after {
  opacity: 0.4;
  pointer-events: auto;
}

.ant-spin-tip {
  color: rgba(0, 0, 0, 0.45);
}

.ant-spin-dot {
  position: relative;
  display: inline-block;
  font-size: 20px;
  width: 1em;
  height: 1em;
}

.ant-spin-dot-item {
  position: absolute;
  display: block;
  width: 9px;
  height: 9px;
  background-color: #1890ff;
  border-radius: 100%;
  transform: scale(0.75);
  transform-origin: 50% 50%;
  opacity: 0.3;
  animation: antSpinMove 1s linear infinite alternate;
}

.ant-spin-dot-item:first-child {
  top: 0;
  left: 0;
}

.ant-spin-dot-item:nth-child(2) {
  top: 0;
  right: 0;
  animation-delay: 0.4s;
}

.ant-spin-dot-item:nth-child(3) {
  right: 0;
  bottom: 0;
  animation-delay: 0.8s;
}

.ant-spin-dot-item:nth-child(4) {
  bottom: 0;
  left: 0;
  animation-delay: 1.2s;
}

.ant-spin-dot-spin {
  transform: rotate(0deg);
  animation: antRotate 1.2s linear infinite;
}

.ant-spin-sm .ant-spin-dot {
  font-size: 14px;
}

.ant-spin-sm .ant-spin-dot i {
  width: 6px;
  height: 6px;
}

.ant-spin-lg .ant-spin-dot {
  font-size: 32px;
}

.ant-spin-lg .ant-spin-dot i {
  width: 14px;
  height: 14px;
}

.ant-spin.ant-spin-show-text .ant-spin-text {
  display: block;
}

@media (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .ant-spin-blur {
    background: #fff;
    opacity: 0.5;
  }
}
@keyframes antSpinMove {
  to {
    opacity: 1;
  }
}
@keyframes antRotate {
  to {
    transform: rotate(1turn);
  }
}
.ant-spin-rtl {
  direction: rtl;
}

.ant-spin-rtl .ant-spin-dot-spin {
  transform: rotate(-45deg);
  animation-name: antRotateRtl;
}

@keyframes antRotateRtl {
  to {
    transform: rotate(-405deg);
  }
}
.ant-statistic {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
}

.ant-statistic-title {
  margin-bottom: 4px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
}

.ant-statistic-skeleton {
  padding-top: 16px;
}

.ant-statistic-content {
  color: rgba(0, 0, 0, 0.85);
  font-size: 24px;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
}

.ant-statistic-content-value {
  display: inline-block;
  direction: ltr;
}

.ant-statistic-content-prefix, .ant-statistic-content-suffix {
  display: inline-block;
}

.ant-statistic-content-prefix {
  margin-right: 4px;
}

.ant-statistic-content-suffix {
  margin-left: 4px;
}

.ant-statistic-rtl {
  direction: rtl;
}

.ant-statistic-rtl .ant-statistic-content-prefix {
  margin-right: 0;
  margin-left: 4px;
}

.ant-statistic-rtl .ant-statistic-content-suffix {
  margin-right: 4px;
  margin-left: 0;
}

.ant-steps {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  display: flex;
  width: 100%;
  font-size: 0;
  text-align: initial;
}

.ant-steps-item {
  position: relative;
  display: inline-block;
  flex: 1;
  overflow: hidden;
  vertical-align: top;
}

.ant-steps-item-container {
  outline: none;
}

.ant-steps-item:last-child {
  flex: none;
}

.ant-steps-item:last-child > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title:after, .ant-steps-item:last-child > .ant-steps-item-container > .ant-steps-item-tail {
  display: none;
}

.ant-steps-item-content, .ant-steps-item-icon {
  display: inline-block;
  vertical-align: top;
}

.ant-steps-item-icon {
  width: 32px;
  height: 32px;
  margin: 0 8px 0 0;
  font-size: 16px;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  line-height: 32px;
  text-align: center;
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 32px;
  transition: background-color 0.3s, border-color 0.3s;
}

.ant-steps-item-icon .ant-steps-icon {
  position: relative;
  top: -0.5px;
  color: #1890ff;
  line-height: 1;
}

.ant-steps-item-tail {
  position: absolute;
  top: 12px;
  left: 0;
  width: 100%;
  padding: 0 10px;
}

.ant-steps-item-tail:after {
  display: inline-block;
  width: 100%;
  height: 1px;
  background: #f0f0f0;
  border-radius: 1px;
  transition: background 0.3s;
  content: "";
}

.ant-steps-item-title {
  position: relative;
  display: inline-block;
  padding-right: 16px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 16px;
  line-height: 32px;
}

.ant-steps-item-title:after {
  position: absolute;
  top: 16px;
  left: 100%;
  display: block;
  width: 9999px;
  height: 1px;
  background: #f0f0f0;
  content: "";
}

.ant-steps-item-subtitle {
  display: inline;
  margin-left: 8px;
  font-weight: 400;
}

.ant-steps-item-description, .ant-steps-item-subtitle {
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
}

.ant-steps-item-wait .ant-steps-item-icon {
  background-color: #fff;
  border-color: rgba(0, 0, 0, 0.25);
}

.ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon {
  color: rgba(0, 0, 0, 0.25);
}

.ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {
  background: rgba(0, 0, 0, 0.25);
}

.ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {
  color: rgba(0, 0, 0, 0.45);
}

.ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title:after {
  background-color: #f0f0f0;
}

.ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-description {
  color: rgba(0, 0, 0, 0.45);
}

.ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-tail:after {
  background-color: #f0f0f0;
}

.ant-steps-item-process .ant-steps-item-icon {
  background-color: #fff;
  border-color: #1890ff;
}

.ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon {
  color: #1890ff;
}

.ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {
  background: #1890ff;
}

.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {
  color: rgba(0, 0, 0, 0.85);
}

.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title:after {
  background-color: #f0f0f0;
}

.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-description {
  color: rgba(0, 0, 0, 0.85);
}

.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-tail:after {
  background-color: #f0f0f0;
}

.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-icon {
  background: #1890ff;
}

.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-icon .ant-steps-icon {
  color: #fff;
}

.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-title {
  font-weight: 500;
}

.ant-steps-item-finish .ant-steps-item-icon {
  background-color: #fff;
  border-color: #1890ff;
}

.ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
  color: #1890ff;
}

.ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {
  background: #1890ff;
}

.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {
  color: rgba(0, 0, 0, 0.85);
}

.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title:after {
  background-color: #1890ff;
}

.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-description {
  color: rgba(0, 0, 0, 0.45);
}

.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail:after {
  background-color: #1890ff;
}

.ant-steps-item-error .ant-steps-item-icon {
  background-color: #fff;
  border-color: #ff4d4f;
}

.ant-steps-item-error .ant-steps-item-icon > .ant-steps-icon {
  color: #ff4d4f;
}

.ant-steps-item-error .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {
  background: #ff4d4f;
}

.ant-steps-item-error > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {
  color: #ff4d4f;
}

.ant-steps-item-error > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title:after {
  background-color: #f0f0f0;
}

.ant-steps-item-error > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-description {
  color: #ff4d4f;
}

.ant-steps-item-error > .ant-steps-item-container > .ant-steps-item-tail:after {
  background-color: #f0f0f0;
}

.ant-steps-item.ant-steps-next-error .ant-steps-item-title:after {
  background: #ff4d4f;
}

.ant-steps-item-disabled {
  cursor: not-allowed;
}

.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role=button] {
  cursor: pointer;
}

.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role=button] .ant-steps-item-description, .ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role=button] .ant-steps-item-icon .ant-steps-icon, .ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role=button] .ant-steps-item-subtitle, .ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role=button] .ant-steps-item-title {
  transition: color 0.3s;
}

.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role=button]:hover .ant-steps-item-description, .ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role=button]:hover .ant-steps-item-subtitle, .ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role=button]:hover .ant-steps-item-title {
  color: #1890ff;
}

.ant-steps .ant-steps-item:not(.ant-steps-item-active):not(.ant-steps-item-process) > .ant-steps-item-container[role=button]:hover .ant-steps-item-icon {
  border-color: #1890ff;
}

.ant-steps .ant-steps-item:not(.ant-steps-item-active):not(.ant-steps-item-process) > .ant-steps-item-container[role=button]:hover .ant-steps-item-icon .ant-steps-icon {
  color: #1890ff;
}

.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item {
  padding-left: 16px;
  white-space: nowrap;
}

.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:first-child {
  padding-left: 0;
}

.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:last-child .ant-steps-item-title {
  padding-right: 0;
}

.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item-tail {
  display: none;
}

.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item-description {
  max-width: 140px;
  white-space: normal;
}

.ant-steps-item-custom > .ant-steps-item-container > .ant-steps-item-icon {
  height: auto;
  background: none;
  border: 0;
}

.ant-steps-item-custom > .ant-steps-item-container > .ant-steps-item-icon > .ant-steps-icon {
  top: 0;
  left: 0.5px;
  width: 32px;
  height: 32px;
  font-size: 24px;
  line-height: 32px;
}

.ant-steps-item-custom.ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon {
  color: #1890ff;
}

.ant-steps:not(.ant-steps-vertical) .ant-steps-item-custom .ant-steps-item-icon {
  width: auto;
  background: none;
}

.ant-steps-small.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item {
  padding-left: 12px;
}

.ant-steps-small.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:first-child {
  padding-left: 0;
}

.ant-steps-small .ant-steps-item-icon {
  width: 24px;
  height: 24px;
  margin: 0 8px 0 0;
  font-size: 12px;
  line-height: 24px;
  text-align: center;
  border-radius: 24px;
}

.ant-steps-small .ant-steps-item-title {
  padding-right: 12px;
  font-size: 14px;
  line-height: 24px;
}

.ant-steps-small .ant-steps-item-title:after {
  top: 12px;
}

.ant-steps-small .ant-steps-item-description {
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
}

.ant-steps-small .ant-steps-item-tail {
  top: 8px;
}

.ant-steps-small .ant-steps-item-custom .ant-steps-item-icon {
  width: inherit;
  height: inherit;
  line-height: inherit;
  background: none;
  border: 0;
  border-radius: 0;
}

.ant-steps-small .ant-steps-item-custom .ant-steps-item-icon > .ant-steps-icon {
  font-size: 24px;
  line-height: 24px;
  transform: none;
}

.ant-steps-vertical {
  display: flex;
  flex-direction: column;
}

.ant-steps-vertical > .ant-steps-item {
  display: block;
  flex: 1 0 auto;
  padding-left: 0;
  overflow: visible;
}

.ant-steps-vertical > .ant-steps-item .ant-steps-item-icon {
  float: left;
  margin-right: 16px;
}

.ant-steps-vertical > .ant-steps-item .ant-steps-item-content {
  display: block;
  min-height: 48px;
  overflow: hidden;
}

.ant-steps-vertical > .ant-steps-item .ant-steps-item-title {
  line-height: 32px;
}

.ant-steps-vertical > .ant-steps-item .ant-steps-item-description {
  padding-bottom: 12px;
}

.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
  position: absolute;
  top: 0;
  left: 15px;
  width: 1px;
  height: 100%;
  padding: 38px 0 6px;
}

.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail:after {
  width: 1px;
  height: 100%;
}

.ant-steps-vertical > .ant-steps-item:not(:last-child) > .ant-steps-item-container > .ant-steps-item-tail {
  display: block;
}

.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title:after {
  display: none;
}

.ant-steps-vertical.ant-steps-small .ant-steps-item-container .ant-steps-item-tail {
  position: absolute;
  top: 0;
  left: 11px;
  padding: 30px 0 6px;
}

.ant-steps-vertical.ant-steps-small .ant-steps-item-container .ant-steps-item-title {
  line-height: 24px;
}

.ant-steps-label-vertical .ant-steps-item {
  overflow: visible;
}

.ant-steps-label-vertical .ant-steps-item-tail {
  margin-left: 58px;
  padding: 3.5px 24px;
}

.ant-steps-label-vertical .ant-steps-item-content {
  display: block;
  width: 116px;
  margin-top: 8px;
  text-align: center;
}

.ant-steps-label-vertical .ant-steps-item-icon {
  display: inline-block;
  margin-left: 42px;
}

.ant-steps-label-vertical .ant-steps-item-title {
  padding-right: 0;
  padding-left: 0;
}

.ant-steps-label-vertical .ant-steps-item-title:after {
  display: none;
}

.ant-steps-label-vertical .ant-steps-item-subtitle {
  display: block;
  margin-bottom: 4px;
  margin-left: 0;
  line-height: 1.5715;
}

.ant-steps-label-vertical.ant-steps-small:not(.ant-steps-dot) .ant-steps-item-icon {
  margin-left: 46px;
}

.ant-steps-dot .ant-steps-item-title, .ant-steps-dot.ant-steps-small .ant-steps-item-title {
  line-height: 1.5715;
}

.ant-steps-dot .ant-steps-item-tail, .ant-steps-dot.ant-steps-small .ant-steps-item-tail {
  top: 2px;
  width: 100%;
  margin: 0 0 0 70px;
  padding: 0;
}

.ant-steps-dot .ant-steps-item-tail:after, .ant-steps-dot.ant-steps-small .ant-steps-item-tail:after {
  width: calc(100% - 20px);
  height: 3px;
  margin-left: 12px;
}

.ant-steps-dot .ant-steps-item:first-child .ant-steps-icon-dot, .ant-steps-dot.ant-steps-small .ant-steps-item:first-child .ant-steps-icon-dot {
  left: 2px;
}

.ant-steps-dot .ant-steps-item-icon, .ant-steps-dot.ant-steps-small .ant-steps-item-icon {
  width: 8px;
  height: 8px;
  margin-left: 67px;
  padding-right: 0;
  line-height: 8px;
  background: transparent;
  border: 0;
}

.ant-steps-dot .ant-steps-item-icon .ant-steps-icon-dot, .ant-steps-dot.ant-steps-small .ant-steps-item-icon .ant-steps-icon-dot {
  position: relative;
  float: left;
  width: 100%;
  height: 100%;
  border-radius: 100px;
  transition: all 0.3s;
}

.ant-steps-dot .ant-steps-item-icon .ant-steps-icon-dot:after, .ant-steps-dot.ant-steps-small .ant-steps-item-icon .ant-steps-icon-dot:after {
  position: absolute;
  top: -12px;
  left: -26px;
  width: 60px;
  height: 32px;
  background: rgba(0, 0, 0, 0.001);
  content: "";
}

.ant-steps-dot .ant-steps-item-content, .ant-steps-dot.ant-steps-small .ant-steps-item-content {
  width: 140px;
}

.ant-steps-dot .ant-steps-item-process .ant-steps-item-icon, .ant-steps-dot.ant-steps-small .ant-steps-item-process .ant-steps-item-icon {
  position: relative;
  top: -1px;
  width: 10px;
  height: 10px;
  line-height: 10px;
  background: none;
}

.ant-steps-dot .ant-steps-item-process .ant-steps-icon:first-child .ant-steps-icon-dot, .ant-steps-dot.ant-steps-small .ant-steps-item-process .ant-steps-icon:first-child .ant-steps-icon-dot {
  left: 0;
}

.ant-steps-vertical.ant-steps-dot .ant-steps-item-icon {
  margin-top: 13px;
  margin-left: 0;
  background: none;
}

.ant-steps-vertical.ant-steps-dot .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
  top: 6.5px;
  left: -9px;
  margin: 0;
  padding: 22px 0 4px;
}

.ant-steps-vertical.ant-steps-dot.ant-steps-small .ant-steps-item-icon {
  margin-top: 10px;
}

.ant-steps-vertical.ant-steps-dot.ant-steps-small .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
  top: 3.5px;
}

.ant-steps-vertical.ant-steps-dot .ant-steps-item:first-child .ant-steps-icon-dot {
  left: 0;
}

.ant-steps-vertical.ant-steps-dot .ant-steps-item-content {
  width: inherit;
}

.ant-steps-vertical.ant-steps-dot .ant-steps-item-process .ant-steps-item-container .ant-steps-item-icon .ant-steps-icon-dot {
  top: -1px;
  left: -1px;
}

.ant-steps-navigation {
  padding-top: 12px;
}

.ant-steps-navigation.ant-steps-small .ant-steps-item-container {
  margin-left: -12px;
}

.ant-steps-navigation .ant-steps-item {
  overflow: visible;
  text-align: center;
}

.ant-steps-navigation .ant-steps-item-container {
  display: inline-block;
  height: 100%;
  margin-left: -16px;
  padding-bottom: 12px;
  text-align: left;
  transition: opacity 0.3s;
}

.ant-steps-navigation .ant-steps-item-container .ant-steps-item-content {
  max-width: auto;
}

.ant-steps-navigation .ant-steps-item-container .ant-steps-item-title {
  max-width: 100%;
  padding-right: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ant-steps-navigation .ant-steps-item-container .ant-steps-item-title:after {
  display: none;
}

.ant-steps-navigation .ant-steps-item:not(.ant-steps-item-active) .ant-steps-item-container[role=button] {
  cursor: pointer;
}

.ant-steps-navigation .ant-steps-item:not(.ant-steps-item-active) .ant-steps-item-container[role=button]:hover {
  opacity: 0.85;
}

.ant-steps-navigation .ant-steps-item:last-child {
  flex: 1;
}

.ant-steps-navigation .ant-steps-item:last-child:after {
  display: none;
}

.ant-steps-navigation .ant-steps-item:after {
  position: absolute;
  top: 50%;
  left: 100%;
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-top: -14px;
  margin-left: -2px;
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-bottom: none;
  border-left: none;
  transform: rotate(45deg);
  content: "";
}

.ant-steps-navigation .ant-steps-item:before {
  position: absolute;
  bottom: 0;
  left: 50%;
  display: inline-block;
  width: 0;
  height: 2px;
  background-color: #1890ff;
  transition: width 0.3s, left 0.3s;
  transition-timing-function: ease-out;
  content: "";
}

.ant-steps-navigation .ant-steps-item.ant-steps-item-active:before {
  left: 0;
  width: 100%;
}

.ant-steps-navigation.ant-steps-vertical > .ant-steps-item {
  margin-right: 0 !important;
}

.ant-steps-navigation.ant-steps-vertical > .ant-steps-item:before {
  display: none;
}

.ant-steps-navigation.ant-steps-vertical > .ant-steps-item.ant-steps-item-active:before {
  top: 0;
  right: 0;
  left: unset;
  display: block;
  width: 3px;
  height: calc(100% - 24px);
}

.ant-steps-navigation.ant-steps-vertical > .ant-steps-item:after {
  position: relative;
  top: -2px;
  left: 50%;
  display: block;
  width: 8px;
  height: 8px;
  margin-bottom: 8px;
  text-align: center;
  transform: rotate(135deg);
}

.ant-steps-navigation.ant-steps-horizontal > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail, .ant-steps-navigation.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
  visibility: hidden;
}

.ant-steps-rtl {
  direction: rtl;
}

.ant-steps.ant-steps-rtl .ant-steps-item-icon {
  margin-right: 0;
  margin-left: 8px;
}

.ant-steps-rtl .ant-steps-item-tail {
  right: 0;
  left: auto;
}

.ant-steps-rtl .ant-steps-item-title {
  padding-right: 0;
  padding-left: 16px;
}

.ant-steps-rtl .ant-steps-item-title .ant-steps-item-subtitle {
  float: left;
  margin-right: 8px;
  margin-left: 0;
}

.ant-steps-rtl .ant-steps-item-title:after {
  right: 100%;
  left: auto;
}

.ant-steps-rtl.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item {
  padding-right: 16px;
  padding-left: 0;
}

.ant-steps-rtl.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:first-child {
  padding-right: 0;
}

.ant-steps-rtl.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:last-child .ant-steps-item-title {
  padding-left: 0;
}

.ant-steps-rtl .ant-steps-item-custom .ant-steps-item-icon > .ant-steps-icon {
  right: 0.5px;
  left: auto;
}

.ant-steps-rtl.ant-steps-navigation.ant-steps-small .ant-steps-item-container {
  margin-right: -12px;
  margin-left: 0;
}

.ant-steps-rtl.ant-steps-navigation .ant-steps-item-container {
  margin-right: -16px;
  margin-left: 0;
  text-align: right;
}

.ant-steps-rtl.ant-steps-navigation .ant-steps-item-container .ant-steps-item-title {
  padding-left: 0;
}

.ant-steps-rtl.ant-steps-navigation .ant-steps-item:after {
  right: 100%;
  left: auto;
  margin-right: -2px;
  margin-left: 0;
  transform: rotate(225deg);
}

.ant-steps-rtl.ant-steps-small.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item {
  padding-right: 12px;
  padding-left: 0;
}

.ant-steps-rtl.ant-steps-small.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:first-child {
  padding-right: 0;
}

.ant-steps-rtl.ant-steps-small .ant-steps-item-title {
  padding-right: 0;
  padding-left: 12px;
}

.ant-steps-rtl.ant-steps-vertical > .ant-steps-item .ant-steps-item-icon {
  float: right;
  margin-right: 0;
  margin-left: 16px;
}

.ant-steps-rtl.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
  right: 16px;
  left: auto;
}

.ant-steps-rtl.ant-steps-vertical.ant-steps-small .ant-steps-item-container .ant-steps-item-tail {
  right: 12px;
  left: auto;
}

.ant-steps-rtl.ant-steps-label-vertical .ant-steps-item-title {
  padding-left: 0;
}

.ant-steps-rtl.ant-steps-dot .ant-steps-item-tail, .ant-steps-rtl.ant-steps-dot.ant-steps-small .ant-steps-item-tail {
  margin: 0 70px 0 0;
}

.ant-steps-rtl.ant-steps-dot .ant-steps-item-tail:after, .ant-steps-rtl.ant-steps-dot.ant-steps-small .ant-steps-item-tail:after {
  margin-right: 12px;
  margin-left: 0;
}

.ant-steps-rtl.ant-steps-dot .ant-steps-item:first-child .ant-steps-icon-dot, .ant-steps-rtl.ant-steps-dot.ant-steps-small .ant-steps-item:first-child .ant-steps-icon-dot {
  right: 2px;
  left: auto;
}

.ant-steps-rtl.ant-steps-dot .ant-steps-item-icon, .ant-steps-rtl.ant-steps-dot.ant-steps-small .ant-steps-item-icon {
  margin-right: 67px;
  margin-left: 0;
}

.ant-steps-rtl.ant-steps-dot .ant-steps-item-icon .ant-steps-icon-dot, .ant-steps-rtl.ant-steps-dot.ant-steps-small .ant-steps-item-icon .ant-steps-icon-dot {
  float: right;
}

.ant-steps-rtl.ant-steps-dot .ant-steps-item-icon .ant-steps-icon-dot:after, .ant-steps-rtl.ant-steps-dot.ant-steps-small .ant-steps-item-icon .ant-steps-icon-dot:after {
  right: -26px;
  left: auto;
}

.ant-steps-rtl.ant-steps-vertical.ant-steps-dot .ant-steps-item-icon {
  margin-right: 0;
  margin-left: 16px;
}

.ant-steps-rtl.ant-steps-vertical.ant-steps-dot .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
  right: -9px;
  left: auto;
}

.ant-steps-rtl.ant-steps-vertical.ant-steps-dot .ant-steps-item:first-child .ant-steps-icon-dot {
  right: 0;
  left: auto;
}

.ant-steps-rtl.ant-steps-vertical.ant-steps-dot .ant-steps-item-process .ant-steps-icon-dot {
  right: -2px;
  left: auto;
}

.ant-steps-rtl.ant-steps-with-progress.ant-steps-vertical > .ant-steps-item {
  padding-right: 4px;
}

.ant-steps-rtl.ant-steps-with-progress.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
  right: 19px;
}

.ant-steps-rtl.ant-steps-with-progress.ant-steps-small.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
  right: 15px;
}

.ant-steps-rtl.ant-steps-with-progress.ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item:first-child {
  padding-right: 4px;
  padding-left: 0;
}

.ant-steps-rtl.ant-steps-with-progress.ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item:first-child.ant-steps-item-active {
  padding-right: 4px;
}

.ant-steps-with-progress .ant-steps-item {
  padding-top: 4px;
}

.ant-steps-with-progress .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
  top: 4px;
  left: 19px;
}

.ant-steps-with-progress.ant-steps-horizontal .ant-steps-item:first-child, .ant-steps-with-progress.ant-steps-small.ant-steps-horizontal .ant-steps-item:first-child {
  padding-bottom: 4px;
  padding-left: 4px;
}

.ant-steps-with-progress.ant-steps-small > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
  left: 15px;
}

.ant-steps-with-progress.ant-steps-vertical .ant-steps-item {
  padding-left: 4px;
}

.ant-steps-with-progress.ant-steps-label-vertical .ant-steps-item .ant-steps-item-tail {
  top: 14px !important;
}

.ant-steps-with-progress .ant-steps-item-icon {
  position: relative;
}

.ant-steps-with-progress .ant-steps-item-icon .ant-progress {
  position: absolute;
  top: -5px;
  right: -5px;
  bottom: -5px;
  left: -5px;
}

.ant-switch {
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  min-width: 44px;
  height: 22px;
  line-height: 22px;
  vertical-align: middle;
  background-color: rgba(0, 0, 0, 0.25);
  border: 0;
  border-radius: 100px;
  cursor: pointer;
  transition: all 0.2s;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-switch:focus {
  outline: 0;
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
}

.ant-switch-checked:focus {
  box-shadow: 0 0 0 2px #e6f7ff;
}

.ant-switch:focus:hover {
  box-shadow: none;
}

.ant-switch-checked {
  background-color: #1890ff;
}

.ant-switch-disabled, .ant-switch-loading {
  cursor: not-allowed;
  opacity: 0.4;
}

.ant-switch-disabled *, .ant-switch-loading * {
  box-shadow: none;
  cursor: not-allowed;
}

.ant-switch-inner {
  display: block;
  margin: 0 7px 0 25px;
  color: #fff;
  font-size: 12px;
  transition: margin 0.2s;
}

.ant-switch-checked .ant-switch-inner {
  margin: 0 25px 0 7px;
}

.ant-switch-handle {
  top: 2px;
  left: 2px;
  width: 18px;
  height: 18px;
}

.ant-switch-handle, .ant-switch-handle:before {
  position: absolute;
  transition: all 0.2s ease-in-out;
}

.ant-switch-handle:before {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: #fff;
  border-radius: 9px;
  box-shadow: 0 2px 4px 0 rgba(0, 35, 11, 0.2);
  content: "";
}

.ant-switch-checked .ant-switch-handle {
  left: calc(100% - 20px);
}

.ant-switch:not(.ant-switch-disabled):active .ant-switch-handle:before {
  right: -30%;
  left: 0;
}

.ant-switch:not(.ant-switch-disabled):active.ant-switch-checked .ant-switch-handle:before {
  right: 0;
  left: -30%;
}

.ant-switch-loading-icon.anticon {
  position: relative;
  top: 2px;
  color: rgba(0, 0, 0, 0.65);
  vertical-align: top;
}

.ant-switch-checked .ant-switch-loading-icon {
  color: #1890ff;
}

.ant-switch-small {
  min-width: 28px;
  height: 16px;
  line-height: 16px;
}

.ant-switch-small .ant-switch-inner {
  margin: 0 5px 0 18px;
  font-size: 12px;
}

.ant-switch-small .ant-switch-handle {
  width: 12px;
  height: 12px;
}

.ant-switch-small .ant-switch-loading-icon {
  top: 1.5px;
  font-size: 9px;
}

.ant-switch-small.ant-switch-checked .ant-switch-inner {
  margin: 0 18px 0 5px;
}

.ant-switch-small.ant-switch-checked .ant-switch-handle {
  left: calc(100% - 14px);
}

.ant-switch-rtl {
  direction: rtl;
}

.ant-switch-rtl .ant-switch-inner {
  margin: 0 25px 0 7px;
}

.ant-switch-rtl .ant-switch-handle {
  right: 2px;
  left: auto;
}

.ant-switch-rtl:not(.ant-switch-rtl-disabled):active .ant-switch-handle:before {
  right: 0;
  left: -30%;
}

.ant-switch-rtl:not(.ant-switch-rtl-disabled):active.ant-switch-checked .ant-switch-handle:before {
  right: -30%;
  left: 0;
}

.ant-switch-rtl.ant-switch-checked .ant-switch-inner {
  margin: 0 7px 0 25px;
}

.ant-switch-rtl.ant-switch-checked .ant-switch-handle {
  right: calc(100% - 20px);
}

.ant-switch-rtl.ant-switch-small.ant-switch-checked .ant-switch-handle {
  right: calc(100% - 14px);
}

.ant-table.ant-table-middle {
  font-size: 14px;
}

.ant-table.ant-table-middle .ant-table-footer, .ant-table.ant-table-middle .ant-table-tbody > tr > td, .ant-table.ant-table-middle .ant-table-thead > tr > th, .ant-table.ant-table-middle .ant-table-title, .ant-table.ant-table-middle tfoot > tr > td, .ant-table.ant-table-middle tfoot > tr > th {
  padding: 12px 8px;
}

.ant-table.ant-table-middle .ant-table-filter-trigger {
  margin-right: -4px;
}

.ant-table.ant-table-middle .ant-table-expanded-row-fixed {
  margin: -12px -8px;
}

.ant-table.ant-table-middle .ant-table-tbody .ant-table-wrapper:only-child .ant-table {
  margin: -12px -8px -12px 40px;
}

.ant-table.ant-table-middle .ant-table-selection-column {
  -webkit-padding-start: 2px;
  padding-inline-start: 2px;
}

.ant-table.ant-table-small {
  font-size: 14px;
}

.ant-table.ant-table-small .ant-table-footer, .ant-table.ant-table-small .ant-table-tbody > tr > td, .ant-table.ant-table-small .ant-table-thead > tr > th, .ant-table.ant-table-small .ant-table-title, .ant-table.ant-table-small tfoot > tr > td, .ant-table.ant-table-small tfoot > tr > th {
  padding: 8px;
}

.ant-table.ant-table-small .ant-table-filter-trigger {
  margin-right: -4px;
}

.ant-table.ant-table-small .ant-table-expanded-row-fixed {
  margin: -8px;
}

.ant-table.ant-table-small .ant-table-tbody .ant-table-wrapper:only-child .ant-table {
  margin: -8px -8px -8px 40px;
}

.ant-table.ant-table-small .ant-table-selection-column {
  -webkit-padding-start: 2px;
  padding-inline-start: 2px;
}

.ant-table.ant-table-bordered > .ant-table-title {
  border: 1px solid #f0f0f0;
  border-bottom: 0;
}

.ant-table.ant-table-bordered > .ant-table-container {
  border-left: 1px solid #f0f0f0;
}

.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tbody > tr > td, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tfoot > tr > td, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tfoot > tr > th, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > thead > tr > th, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tbody > tr > td, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tfoot > tr > td, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tfoot > tr > th, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > thead > tr > th, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tbody > tr > td, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tfoot > tr > td, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tfoot > tr > th, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > thead > tr > th, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tbody > tr > td, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tfoot > tr > td, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tfoot > tr > th, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > thead > tr > th {
  border-right: 1px solid #f0f0f0;
}

.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > thead > tr:not(:last-child) > th, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > thead > tr:not(:last-child) > th, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > thead > tr:not(:last-child) > th, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > thead > tr:not(:last-child) > th {
  border-bottom: 1px solid #f0f0f0;
}

.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > thead > tr > th:before, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > thead > tr > th:before, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > thead > tr > th:before, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > thead > tr > th:before {
  background-color: transparent !important;
}

.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tbody > tr > .ant-table-cell-fix-right-first:after, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tfoot > tr > .ant-table-cell-fix-right-first:after, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > thead > tr > .ant-table-cell-fix-right-first:after, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tbody > tr > .ant-table-cell-fix-right-first:after, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tfoot > tr > .ant-table-cell-fix-right-first:after, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > thead > tr > .ant-table-cell-fix-right-first:after, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tbody > tr > .ant-table-cell-fix-right-first:after, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tfoot > tr > .ant-table-cell-fix-right-first:after, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > thead > tr > .ant-table-cell-fix-right-first:after, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tbody > tr > .ant-table-cell-fix-right-first:after, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tfoot > tr > .ant-table-cell-fix-right-first:after, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > thead > tr > .ant-table-cell-fix-right-first:after {
  border-right: 1px solid #f0f0f0;
}

.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tbody > tr > td > .ant-table-expanded-row-fixed, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tbody > tr > td > .ant-table-expanded-row-fixed, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tbody > tr > td > .ant-table-expanded-row-fixed, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tbody > tr > td > .ant-table-expanded-row-fixed {
  margin: -16px -17px;
}

.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tbody > tr > td > .ant-table-expanded-row-fixed:after, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tbody > tr > td > .ant-table-expanded-row-fixed:after, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tbody > tr > td > .ant-table-expanded-row-fixed:after, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tbody > tr > td > .ant-table-expanded-row-fixed:after {
  position: absolute;
  top: 0;
  right: 1px;
  bottom: 0;
  border-right: 1px solid #f0f0f0;
  content: "";
}

.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table {
  border-top: 1px solid #f0f0f0;
}

.ant-table.ant-table-bordered.ant-table-scroll-horizontal > .ant-table-container > .ant-table-body > table > tbody > tr.ant-table-expanded-row > td, .ant-table.ant-table-bordered.ant-table-scroll-horizontal > .ant-table-container > .ant-table-body > table > tbody > tr.ant-table-placeholder > td {
  border-right: 0;
}

.ant-table.ant-table-bordered.ant-table-middle > .ant-table-container > .ant-table-body > table > tbody > tr > td > .ant-table-expanded-row-fixed, .ant-table.ant-table-bordered.ant-table-middle > .ant-table-container > .ant-table-content > table > tbody > tr > td > .ant-table-expanded-row-fixed {
  margin: -12px -9px;
}

.ant-table.ant-table-bordered.ant-table-small > .ant-table-container > .ant-table-body > table > tbody > tr > td > .ant-table-expanded-row-fixed, .ant-table.ant-table-bordered.ant-table-small > .ant-table-container > .ant-table-content > table > tbody > tr > td > .ant-table-expanded-row-fixed {
  margin: -8px -9px;
}

.ant-table.ant-table-bordered > .ant-table-footer {
  border: 1px solid #f0f0f0;
  border-top: 0;
}

.ant-table-cell .ant-table-container:first-child {
  border-top: 0;
}

.ant-table-cell-scrollbar:not([rowspan]) {
  box-shadow: 0 1px 0 1px #fafafa;
}

.ant-table-wrapper {
  clear: both;
  max-width: 100%;
}

.ant-table-wrapper:before {
  display: table;
  content: "";
}

.ant-table-wrapper:after {
  display: table;
  clear: both;
  content: "";
}

.ant-table {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  font-size: 14px;
  background: #fff;
  border-radius: 2px;
}

.ant-table table {
  width: 100%;
  text-align: left;
  border-radius: 2px 2px 0 0;
  border-collapse: separate;
  border-spacing: 0;
}

.ant-table-tbody > tr > td, .ant-table-thead > tr > th, .ant-table tfoot > tr > td, .ant-table tfoot > tr > th {
  position: relative;
  padding: 16px;
  overflow-wrap: break-word;
}

.ant-table-cell-ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-break: keep-all;
}

.ant-table-cell-ellipsis.ant-table-cell-fix-left-last, .ant-table-cell-ellipsis.ant-table-cell-fix-right-first {
  overflow: visible;
}

.ant-table-cell-ellipsis.ant-table-cell-fix-left-last .ant-table-cell-content, .ant-table-cell-ellipsis.ant-table-cell-fix-right-first .ant-table-cell-content {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ant-table-cell-ellipsis .ant-table-column-title {
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: keep-all;
}

.ant-table-title {
  padding: 16px;
}

.ant-table-footer {
  padding: 16px;
  color: rgba(0, 0, 0, 0.85);
  background: #fafafa;
}

.ant-table-thead > tr > th {
  position: relative;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  text-align: left;
  background: #fafafa;
  border-bottom: 1px solid #f0f0f0;
  transition: background 0.3s ease;
}

.ant-table-thead > tr > th[colspan]:not([colspan="1"]) {
  text-align: center;
}

.ant-table-thead > tr > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan]):before {
  position: absolute;
  top: 50%;
  right: 0;
  width: 1px;
  height: 1.6em;
  background-color: rgba(0, 0, 0, 0.06);
  transform: translateY(-50%);
  transition: background-color 0.3s;
  content: "";
}

.ant-table-thead > tr:not(:last-child) > th[colspan] {
  border-bottom: 0;
}

.ant-table-tbody > tr > td {
  border-bottom: 1px solid #f0f0f0;
  transition: background 0.3s;
}

.ant-table-tbody > tr > td > .ant-table-expanded-row-fixed > .ant-table-wrapper:only-child .ant-table, .ant-table-tbody > tr > td > .ant-table-wrapper:only-child .ant-table {
  margin: -16px -16px -16px 32px;
}

.ant-table-tbody > tr > td > .ant-table-expanded-row-fixed > .ant-table-wrapper:only-child .ant-table-tbody > tr:last-child > td, .ant-table-tbody > tr > td > .ant-table-wrapper:only-child .ant-table-tbody > tr:last-child > td {
  border-bottom: 0;
}

.ant-table-tbody > tr > td > .ant-table-expanded-row-fixed > .ant-table-wrapper:only-child .ant-table-tbody > tr:last-child > td:first-child, .ant-table-tbody > tr > td > .ant-table-expanded-row-fixed > .ant-table-wrapper:only-child .ant-table-tbody > tr:last-child > td:last-child, .ant-table-tbody > tr > td > .ant-table-wrapper:only-child .ant-table-tbody > tr:last-child > td:first-child, .ant-table-tbody > tr > td > .ant-table-wrapper:only-child .ant-table-tbody > tr:last-child > td:last-child {
  border-radius: 0;
}

.ant-table-tbody > tr.ant-table-row:hover > td, .ant-table-tbody > tr > td.ant-table-cell-row-hover {
  background: #fafafa;
}

.ant-table-tbody > tr.ant-table-row-selected > td {
  background: #e6f7ff;
  border-color: rgba(0, 0, 0, 0.03);
}

.ant-table-tbody > tr.ant-table-row-selected:hover > td {
  background: #dcf4ff;
}

.ant-table-summary {
  position: relative;
  z-index: 2;
  background: #fff;
}

div.ant-table-summary {
  box-shadow: 0 -1px 0 #f0f0f0;
}

.ant-table-summary > tr > td, .ant-table-summary > tr > th {
  border-bottom: 1px solid #f0f0f0;
}

.ant-table-pagination.ant-pagination {
  margin: 16px 0;
}

.ant-table-pagination {
  display: flex;
  flex-wrap: wrap;
  row-gap: 8px;
}

.ant-table-pagination > * {
  flex: none;
}

.ant-table-pagination-left {
  justify-content: flex-start;
}

.ant-table-pagination-center {
  justify-content: center;
}

.ant-table-pagination-right {
  justify-content: flex-end;
}

.ant-table-thead th.ant-table-column-has-sorters {
  outline: none;
  cursor: pointer;
  transition: all 0.3s;
}

.ant-table-thead th.ant-table-column-has-sorters:hover {
  background: rgba(0, 0, 0, 0.04);
}

.ant-table-thead th.ant-table-column-has-sorters:hover:before {
  background-color: transparent !important;
}

.ant-table-thead th.ant-table-column-has-sorters:focus-visible {
  color: #1890ff;
}

.ant-table-thead th.ant-table-column-has-sorters.ant-table-cell-fix-left:hover, .ant-table-thead th.ant-table-column-has-sorters.ant-table-cell-fix-right:hover, .ant-table-thead th.ant-table-column-sort {
  background: #f5f5f5;
}

.ant-table-thead th.ant-table-column-sort:before {
  background-color: transparent !important;
}

td.ant-table-column-sort {
  background: #fafafa;
}

.ant-table-column-title {
  position: relative;
  z-index: 1;
  flex: 1;
}

.ant-table-column-sorters {
  display: flex;
  flex: auto;
  align-items: center;
  justify-content: space-between;
}

.ant-table-column-sorters:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  content: "";
}

.ant-table-column-sorter {
  margin-left: 4px;
  color: #bfbfbf;
  font-size: 0;
  transition: color 0.3s;
}

.ant-table-column-sorter-inner {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
}

.ant-table-column-sorter-down, .ant-table-column-sorter-up {
  font-size: 11px;
}

.ant-table-column-sorter-down.active, .ant-table-column-sorter-up.active {
  color: #1890ff;
}

.ant-table-column-sorter-up + .ant-table-column-sorter-down {
  margin-top: -0.3em;
}

.ant-table-column-sorters:hover .ant-table-column-sorter {
  color: #a6a6a6;
}

.ant-table-filter-column {
  display: flex;
  justify-content: space-between;
}

.ant-table-filter-trigger {
  position: relative;
  display: flex;
  align-items: center;
  margin: -4px -8px -4px 4px;
  padding: 0 4px;
  color: #bfbfbf;
  font-size: 12px;
  border-radius: 2px;
  cursor: pointer;
  transition: all 0.3s;
}

.ant-table-filter-trigger:hover {
  color: rgba(0, 0, 0, 0.45);
  background: rgba(0, 0, 0, 0.04);
}

.ant-table-filter-trigger.active {
  color: #1890ff;
}

.ant-table-filter-dropdown {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  min-width: 120px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
}

.ant-table-filter-dropdown .ant-dropdown-menu {
  max-height: 264px;
  overflow-x: hidden;
  border: 0;
  box-shadow: none;
}

.ant-table-filter-dropdown .ant-dropdown-menu:empty:after {
  display: block;
  padding: 8px 0;
  color: rgba(0, 0, 0, 0.25);
  font-size: 12px;
  text-align: center;
  content: "Not Found";
}

.ant-table-filter-dropdown-tree {
  padding: 8px 8px 0;
}

.ant-table-filter-dropdown-tree .ant-tree-treenode .ant-tree-node-content-wrapper:hover {
  background-color: #f5f5f5;
}

.ant-table-filter-dropdown-tree .ant-tree-treenode-checkbox-checked .ant-tree-node-content-wrapper, .ant-table-filter-dropdown-tree .ant-tree-treenode-checkbox-checked .ant-tree-node-content-wrapper:hover {
  background-color: #bae7ff;
}

.ant-table-filter-dropdown-search {
  padding: 8px;
  border-bottom: 1px solid #f0f0f0;
}

.ant-table-filter-dropdown-search-input input {
  min-width: 140px;
}

.ant-table-filter-dropdown-search-input .anticon {
  color: rgba(0, 0, 0, 0.25);
}

.ant-table-filter-dropdown-checkall {
  width: 100%;
  margin-bottom: 4px;
  margin-left: 4px;
}

.ant-table-filter-dropdown-submenu > ul {
  max-height: calc(100vh - 130px);
  overflow-x: hidden;
  overflow-y: auto;
}

.ant-table-filter-dropdown-submenu .ant-checkbox-wrapper + span, .ant-table-filter-dropdown .ant-checkbox-wrapper + span {
  padding-left: 8px;
}

.ant-table-filter-dropdown-btns {
  display: flex;
  justify-content: space-between;
  padding: 7px 8px;
  overflow: hidden;
  background-color: inherit;
  border-top: 1px solid #f0f0f0;
}

.ant-table-selection-col {
  width: 32px;
}

.ant-table-bordered .ant-table-selection-col {
  width: 50px;
}

table tr td.ant-table-selection-column, table tr th.ant-table-selection-column {
  padding-right: 8px;
  padding-left: 8px;
  text-align: center;
}

table tr td.ant-table-selection-column .ant-radio-wrapper, table tr th.ant-table-selection-column .ant-radio-wrapper {
  margin-right: 0;
}

table tr th.ant-table-selection-column.ant-table-cell-fix-left {
  z-index: 3;
}

table tr th.ant-table-selection-column:after {
  background-color: transparent !important;
}

.ant-table-selection {
  position: relative;
  display: inline-flex;
  flex-direction: column;
}

.ant-table-selection-extra {
  position: absolute;
  top: 0;
  z-index: 1;
  cursor: pointer;
  transition: all 0.3s;
  -webkit-margin-start: 100%;
  margin-inline-start: 100%;
  -webkit-padding-start: 4px;
  padding-inline-start: 4px;
}

.ant-table-selection-extra .anticon {
  color: #bfbfbf;
  font-size: 10px;
}

.ant-table-selection-extra .anticon:hover {
  color: #a6a6a6;
}

.ant-table-expand-icon-col {
  width: 48px;
}

.ant-table-row-expand-icon-cell {
  text-align: center;
}

.ant-table-row-expand-icon-cell .ant-table-row-expand-icon {
  display: inline-flex;
  float: none;
  vertical-align: sub;
}

.ant-table-row-indent {
  float: left;
  height: 1px;
}

.ant-table-row-expand-icon {
  color: #1890ff;
  outline: none;
  cursor: pointer;
  transition: color 0.3s;
  position: relative;
  float: left;
  box-sizing: border-box;
  width: 17px;
  height: 17px;
  padding: 0;
  color: inherit;
  line-height: 17px;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 2px;
  transform: scale(0.94117647);
  transition: all 0.3s;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-table-row-expand-icon:focus-visible, .ant-table-row-expand-icon:hover {
  color: #40a9ff;
}

.ant-table-row-expand-icon:active {
  color: #096dd9;
}

.ant-table-row-expand-icon:active, .ant-table-row-expand-icon:focus, .ant-table-row-expand-icon:hover {
  border-color: currentcolor;
}

.ant-table-row-expand-icon:after, .ant-table-row-expand-icon:before {
  position: absolute;
  background: currentcolor;
  transition: transform 0.3s ease-out;
  content: "";
}

.ant-table-row-expand-icon:before {
  top: 7px;
  right: 3px;
  left: 3px;
  height: 1px;
}

.ant-table-row-expand-icon:after {
  top: 3px;
  bottom: 3px;
  left: 7px;
  width: 1px;
  transform: rotate(90deg);
}

.ant-table-row-expand-icon-collapsed:before {
  transform: rotate(-180deg);
}

.ant-table-row-expand-icon-collapsed:after {
  transform: rotate(0deg);
}

.ant-table-row-expand-icon-spaced {
  background: transparent;
  border: 0;
  visibility: hidden;
}

.ant-table-row-expand-icon-spaced:after, .ant-table-row-expand-icon-spaced:before {
  display: none;
  content: none;
}

.ant-table-row-indent + .ant-table-row-expand-icon {
  margin-top: 2.5005px;
  margin-right: 8px;
}

tr.ant-table-expanded-row:hover > td, tr.ant-table-expanded-row > td {
  background: #fbfbfb;
}

tr.ant-table-expanded-row .ant-descriptions-view {
  display: flex;
}

tr.ant-table-expanded-row .ant-descriptions-view table {
  flex: auto;
  width: auto;
}

.ant-table .ant-table-expanded-row-fixed {
  position: relative;
  margin: -16px;
  padding: 16px;
}

.ant-table-tbody > tr.ant-table-placeholder {
  text-align: center;
}

.ant-table-empty .ant-table-tbody > tr.ant-table-placeholder {
  color: rgba(0, 0, 0, 0.25);
}

.ant-table-tbody > tr.ant-table-placeholder:hover > td {
  background: #fff;
}

.ant-table-cell-fix-left, .ant-table-cell-fix-right {
  position: sticky !important;
  z-index: 2;
  background: #fff;
}

.ant-table-cell-fix-left-first:after, .ant-table-cell-fix-left-last:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: -1px;
  width: 30px;
  transform: translateX(100%);
  transition: box-shadow 0.3s;
  content: "";
  pointer-events: none;
}

.ant-table-cell-fix-left-all:after {
  display: none;
}

.ant-table-cell-fix-right-first:after, .ant-table-cell-fix-right-last:after {
  position: absolute;
  top: 0;
  bottom: -1px;
  left: 0;
  width: 30px;
  transform: translateX(-100%);
  transition: box-shadow 0.3s;
  content: "";
  pointer-events: none;
}

.ant-table .ant-table-container:after, .ant-table .ant-table-container:before {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 4;
  width: 30px;
  transition: box-shadow 0.3s;
  content: "";
  pointer-events: none;
}

.ant-table .ant-table-container:before {
  left: 0;
}

.ant-table .ant-table-container:after {
  right: 0;
}

.ant-table-ping-left:not(.ant-table-has-fix-left) > .ant-table-container {
  position: relative;
}

.ant-table-ping-left .ant-table-cell-fix-left-first:after, .ant-table-ping-left .ant-table-cell-fix-left-last:after, .ant-table-ping-left:not(.ant-table-has-fix-left) > .ant-table-container:before {
  box-shadow: inset 10px 0 8px -8px rgba(0, 0, 0, 0.15);
}

.ant-table-ping-left .ant-table-cell-fix-left-last:before {
  background-color: transparent !important;
}

.ant-table-ping-right:not(.ant-table-has-fix-right) > .ant-table-container {
  position: relative;
}

.ant-table-ping-right .ant-table-cell-fix-right-first:after, .ant-table-ping-right .ant-table-cell-fix-right-last:after, .ant-table-ping-right:not(.ant-table-has-fix-right) > .ant-table-container:after {
  box-shadow: inset -10px 0 8px -8px rgba(0, 0, 0, 0.15);
}

.ant-table-sticky-holder, .ant-table-sticky-scroll {
  position: sticky;
  z-index: 3;
  background: #fff;
}

.ant-table-sticky-scroll {
  bottom: 0;
  display: flex;
  align-items: center;
  border-top: 1px solid #f0f0f0;
  opacity: 0.6;
}

.ant-table-sticky-scroll:hover {
  transform-origin: center bottom;
}

.ant-table-sticky-scroll-bar {
  height: 8px;
  background-color: rgba(0, 0, 0, 0.35);
  border-radius: 4px;
}

.ant-table-sticky-scroll-bar-active, .ant-table-sticky-scroll-bar:hover {
  background-color: rgba(0, 0, 0, 0.8);
}

@media (-ms-high-contrast: none) {
  .ant-table-ping-left .ant-table-cell-fix-left-last:after, .ant-table-ping-right .ant-table-cell-fix-right-first:after {
    box-shadow: none !important;
  }
}
.ant-table-title {
  border-radius: 2px 2px 0 0;
}

.ant-table-title + .ant-table-container {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.ant-table-title + .ant-table-container table, .ant-table-title + .ant-table-container table > thead > tr:first-child th:first-child, .ant-table-title + .ant-table-container table > thead > tr:first-child th:last-child {
  border-radius: 0;
}

.ant-table-container {
  border-top-right-radius: 2px;
}

.ant-table-container, .ant-table-container table > thead > tr:first-child th:first-child {
  border-top-left-radius: 2px;
}

.ant-table-container table > thead > tr:first-child th:last-child {
  border-top-right-radius: 2px;
}

.ant-table-footer {
  border-radius: 0 0 2px 2px;
}

.ant-table-rtl, .ant-table-wrapper-rtl {
  direction: rtl;
}

.ant-table-wrapper-rtl .ant-table table {
  text-align: right;
}

.ant-table-wrapper-rtl .ant-table-thead > tr > th[colspan]:not([colspan="1"]) {
  text-align: center;
}

.ant-table-wrapper-rtl .ant-table-thead > tr > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan]):before {
  right: auto;
  left: 0;
}

.ant-table-wrapper-rtl .ant-table-thead > tr > th {
  text-align: right;
}

.ant-table-tbody > tr .ant-table-wrapper:only-child .ant-table.ant-table-rtl {
  margin: -16px 33px -16px -16px;
}

.ant-table-wrapper.ant-table-wrapper-rtl .ant-table-pagination-left {
  justify-content: flex-end;
}

.ant-table-wrapper.ant-table-wrapper-rtl .ant-table-pagination-right {
  justify-content: flex-start;
}

.ant-table-wrapper-rtl .ant-table-column-sorter {
  margin-right: 4px;
  margin-left: 0;
}

.ant-table-wrapper-rtl .ant-table-filter-column-title {
  padding: 16px 16px 16px 2.3em;
}

.ant-table-rtl .ant-table-thead tr th.ant-table-column-has-sorters .ant-table-filter-column-title {
  padding: 0 0 0 2.3em;
}

.ant-table-wrapper-rtl .ant-table-filter-trigger {
  margin: -4px 4px -4px -8px;
}

.ant-dropdown-menu-submenu-rtl.ant-table-filter-dropdown-submenu .ant-checkbox-wrapper + span, .ant-dropdown-menu-submenu-rtl.ant-table-filter-dropdown .ant-checkbox-wrapper + span, .ant-dropdown-rtl .ant-table-filter-dropdown-submenu .ant-checkbox-wrapper + span, .ant-dropdown-rtl .ant-table-filter-dropdown .ant-checkbox-wrapper + span {
  padding-right: 8px;
  padding-left: 0;
}

.ant-table-wrapper-rtl .ant-table-selection {
  text-align: center;
}

.ant-table-wrapper-rtl .ant-table-row-expand-icon, .ant-table-wrapper-rtl .ant-table-row-indent {
  float: right;
}

.ant-table-wrapper-rtl .ant-table-row-indent + .ant-table-row-expand-icon {
  margin-right: 0;
  margin-left: 8px;
}

.ant-table-wrapper-rtl .ant-table-row-expand-icon:after {
  transform: rotate(-90deg);
}

.ant-table-wrapper-rtl .ant-table-row-expand-icon-collapsed:before {
  transform: rotate(180deg);
}

.ant-table-wrapper-rtl .ant-table-row-expand-icon-collapsed:after {
  transform: rotate(0deg);
}

.ant-tabs-small > .ant-tabs-nav .ant-tabs-tab {
  padding: 8px 0;
  font-size: 14px;
}

.ant-tabs-large > .ant-tabs-nav .ant-tabs-tab {
  padding: 16px 0;
  font-size: 16px;
}

.ant-tabs-card.ant-tabs-small > .ant-tabs-nav .ant-tabs-tab {
  padding: 6px 16px;
}

.ant-tabs-card.ant-tabs-large > .ant-tabs-nav .ant-tabs-tab {
  padding: 7px 16px 6px;
}

.ant-tabs-rtl {
  direction: rtl;
}

.ant-tabs-rtl .ant-tabs-nav .ant-tabs-tab {
  margin: 0 0 0 32px;
}

.ant-tabs-rtl .ant-tabs-nav .ant-tabs-tab:last-of-type {
  margin-left: 0;
}

.ant-tabs-rtl .ant-tabs-nav .ant-tabs-tab .anticon {
  margin-right: 0;
  margin-left: 12px;
}

.ant-tabs-rtl .ant-tabs-nav .ant-tabs-tab .ant-tabs-tab-remove {
  margin-right: 8px;
  margin-left: -4px;
}

.ant-tabs-rtl .ant-tabs-nav .ant-tabs-tab .ant-tabs-tab-remove .anticon {
  margin: 0;
}

.ant-tabs-rtl.ant-tabs-left > .ant-tabs-nav {
  order: 1;
}

.ant-tabs-rtl.ant-tabs-left > .ant-tabs-content-holder, .ant-tabs-rtl.ant-tabs-right > .ant-tabs-nav {
  order: 0;
}

.ant-tabs-rtl.ant-tabs-right > .ant-tabs-content-holder {
  order: 1;
}

.ant-tabs-rtl.ant-tabs-card.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-nav-add, .ant-tabs-rtl.ant-tabs-card.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab, .ant-tabs-rtl.ant-tabs-card.ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-nav-add, .ant-tabs-rtl.ant-tabs-card.ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab, .ant-tabs-rtl.ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-nav-add, .ant-tabs-rtl.ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab, .ant-tabs-rtl.ant-tabs-card.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-nav-add, .ant-tabs-rtl.ant-tabs-card.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab {
  margin-right: 2px;
  margin-left: 0;
}

.ant-tabs-dropdown-rtl {
  direction: rtl;
}

.ant-tabs-dropdown-rtl .ant-tabs-dropdown-menu-item {
  text-align: right;
}

.ant-tabs-bottom, .ant-tabs-top {
  flex-direction: column;
}

.ant-tabs-bottom > .ant-tabs-nav, .ant-tabs-bottom > div > .ant-tabs-nav, .ant-tabs-top > .ant-tabs-nav, .ant-tabs-top > div > .ant-tabs-nav {
  margin: 0 0 16px;
}

.ant-tabs-bottom > .ant-tabs-nav:before, .ant-tabs-bottom > div > .ant-tabs-nav:before, .ant-tabs-top > .ant-tabs-nav:before, .ant-tabs-top > div > .ant-tabs-nav:before {
  position: absolute;
  right: 0;
  left: 0;
  border-bottom: 1px solid #f0f0f0;
  content: "";
}

.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-ink-bar, .ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-ink-bar, .ant-tabs-top > .ant-tabs-nav .ant-tabs-ink-bar, .ant-tabs-top > div > .ant-tabs-nav .ant-tabs-ink-bar {
  height: 2px;
}

.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-ink-bar-animated, .ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-ink-bar-animated, .ant-tabs-top > .ant-tabs-nav .ant-tabs-ink-bar-animated, .ant-tabs-top > div > .ant-tabs-nav .ant-tabs-ink-bar-animated {
  transition: width 0.3s, left 0.3s, right 0.3s;
}

.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-nav-wrap:after, .ant-tabs-bottom > .ant-tabs-nav .ant-tabs-nav-wrap:before, .ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-nav-wrap:after, .ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-nav-wrap:before, .ant-tabs-top > .ant-tabs-nav .ant-tabs-nav-wrap:after, .ant-tabs-top > .ant-tabs-nav .ant-tabs-nav-wrap:before, .ant-tabs-top > div > .ant-tabs-nav .ant-tabs-nav-wrap:after, .ant-tabs-top > div > .ant-tabs-nav .ant-tabs-nav-wrap:before {
  top: 0;
  bottom: 0;
  width: 30px;
}

.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-nav-wrap:before, .ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-nav-wrap:before, .ant-tabs-top > .ant-tabs-nav .ant-tabs-nav-wrap:before, .ant-tabs-top > div > .ant-tabs-nav .ant-tabs-nav-wrap:before {
  left: 0;
  box-shadow: inset 10px 0 8px -8px rgba(0, 0, 0, 0.08);
}

.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-nav-wrap:after, .ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-nav-wrap:after, .ant-tabs-top > .ant-tabs-nav .ant-tabs-nav-wrap:after, .ant-tabs-top > div > .ant-tabs-nav .ant-tabs-nav-wrap:after {
  right: 0;
  box-shadow: inset -10px 0 8px -8px rgba(0, 0, 0, 0.08);
}

.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-left:before, .ant-tabs-bottom > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-right:after, .ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-left:before, .ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-right:after, .ant-tabs-top > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-left:before, .ant-tabs-top > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-right:after, .ant-tabs-top > div > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-left:before, .ant-tabs-top > div > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-right:after {
  opacity: 1;
}

.ant-tabs-top > .ant-tabs-nav .ant-tabs-ink-bar, .ant-tabs-top > .ant-tabs-nav:before, .ant-tabs-top > div > .ant-tabs-nav .ant-tabs-ink-bar, .ant-tabs-top > div > .ant-tabs-nav:before {
  bottom: 0;
}

.ant-tabs-bottom > .ant-tabs-nav, .ant-tabs-bottom > div > .ant-tabs-nav {
  order: 1;
  margin-top: 16px;
  margin-bottom: 0;
}

.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-ink-bar, .ant-tabs-bottom > .ant-tabs-nav:before, .ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-ink-bar, .ant-tabs-bottom > div > .ant-tabs-nav:before {
  top: 0;
}

.ant-tabs-bottom > .ant-tabs-content-holder, .ant-tabs-bottom > div > .ant-tabs-content-holder {
  order: 0;
}

.ant-tabs-left > .ant-tabs-nav, .ant-tabs-left > div > .ant-tabs-nav, .ant-tabs-right > .ant-tabs-nav, .ant-tabs-right > div > .ant-tabs-nav {
  flex-direction: column;
  min-width: 50px;
}

.ant-tabs-left > .ant-tabs-nav .ant-tabs-tab, .ant-tabs-left > div > .ant-tabs-nav .ant-tabs-tab, .ant-tabs-right > .ant-tabs-nav .ant-tabs-tab, .ant-tabs-right > div > .ant-tabs-nav .ant-tabs-tab {
  padding: 8px 24px;
  text-align: center;
}

.ant-tabs-left > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab, .ant-tabs-left > div > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab, .ant-tabs-right > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab, .ant-tabs-right > div > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab {
  margin: 16px 0 0;
}

.ant-tabs-left > .ant-tabs-nav .ant-tabs-nav-wrap, .ant-tabs-left > div > .ant-tabs-nav .ant-tabs-nav-wrap, .ant-tabs-right > .ant-tabs-nav .ant-tabs-nav-wrap, .ant-tabs-right > div > .ant-tabs-nav .ant-tabs-nav-wrap {
  flex-direction: column;
}

.ant-tabs-left > .ant-tabs-nav .ant-tabs-nav-wrap:after, .ant-tabs-left > .ant-tabs-nav .ant-tabs-nav-wrap:before, .ant-tabs-left > div > .ant-tabs-nav .ant-tabs-nav-wrap:after, .ant-tabs-left > div > .ant-tabs-nav .ant-tabs-nav-wrap:before, .ant-tabs-right > .ant-tabs-nav .ant-tabs-nav-wrap:after, .ant-tabs-right > .ant-tabs-nav .ant-tabs-nav-wrap:before, .ant-tabs-right > div > .ant-tabs-nav .ant-tabs-nav-wrap:after, .ant-tabs-right > div > .ant-tabs-nav .ant-tabs-nav-wrap:before {
  right: 0;
  left: 0;
  height: 30px;
}

.ant-tabs-left > .ant-tabs-nav .ant-tabs-nav-wrap:before, .ant-tabs-left > div > .ant-tabs-nav .ant-tabs-nav-wrap:before, .ant-tabs-right > .ant-tabs-nav .ant-tabs-nav-wrap:before, .ant-tabs-right > div > .ant-tabs-nav .ant-tabs-nav-wrap:before {
  top: 0;
  box-shadow: inset 0 10px 8px -8px rgba(0, 0, 0, 0.08);
}

.ant-tabs-left > .ant-tabs-nav .ant-tabs-nav-wrap:after, .ant-tabs-left > div > .ant-tabs-nav .ant-tabs-nav-wrap:after, .ant-tabs-right > .ant-tabs-nav .ant-tabs-nav-wrap:after, .ant-tabs-right > div > .ant-tabs-nav .ant-tabs-nav-wrap:after {
  bottom: 0;
  box-shadow: inset 0 -10px 8px -8px rgba(0, 0, 0, 0.08);
}

.ant-tabs-left > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-bottom:after, .ant-tabs-left > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-top:before, .ant-tabs-left > div > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-bottom:after, .ant-tabs-left > div > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-top:before, .ant-tabs-right > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-bottom:after, .ant-tabs-right > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-top:before, .ant-tabs-right > div > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-bottom:after, .ant-tabs-right > div > .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-top:before {
  opacity: 1;
}

.ant-tabs-left > .ant-tabs-nav .ant-tabs-ink-bar, .ant-tabs-left > div > .ant-tabs-nav .ant-tabs-ink-bar, .ant-tabs-right > .ant-tabs-nav .ant-tabs-ink-bar, .ant-tabs-right > div > .ant-tabs-nav .ant-tabs-ink-bar {
  width: 2px;
}

.ant-tabs-left > .ant-tabs-nav .ant-tabs-ink-bar-animated, .ant-tabs-left > div > .ant-tabs-nav .ant-tabs-ink-bar-animated, .ant-tabs-right > .ant-tabs-nav .ant-tabs-ink-bar-animated, .ant-tabs-right > div > .ant-tabs-nav .ant-tabs-ink-bar-animated {
  transition: height 0.3s, top 0.3s;
}

.ant-tabs-left > .ant-tabs-nav .ant-tabs-nav-list, .ant-tabs-left > .ant-tabs-nav .ant-tabs-nav-operations, .ant-tabs-left > div > .ant-tabs-nav .ant-tabs-nav-list, .ant-tabs-left > div > .ant-tabs-nav .ant-tabs-nav-operations, .ant-tabs-right > .ant-tabs-nav .ant-tabs-nav-list, .ant-tabs-right > .ant-tabs-nav .ant-tabs-nav-operations, .ant-tabs-right > div > .ant-tabs-nav .ant-tabs-nav-list, .ant-tabs-right > div > .ant-tabs-nav .ant-tabs-nav-operations {
  flex: 1 0 auto;
  flex-direction: column;
}

.ant-tabs-left > .ant-tabs-nav .ant-tabs-ink-bar, .ant-tabs-left > div > .ant-tabs-nav .ant-tabs-ink-bar {
  right: 0;
}

.ant-tabs-left > .ant-tabs-content-holder, .ant-tabs-left > div > .ant-tabs-content-holder {
  margin-left: -1px;
  border-left: 1px solid #f0f0f0;
}

.ant-tabs-left > .ant-tabs-content-holder > .ant-tabs-content > .ant-tabs-tabpane, .ant-tabs-left > div > .ant-tabs-content-holder > .ant-tabs-content > .ant-tabs-tabpane {
  padding-left: 24px;
}

.ant-tabs-right > .ant-tabs-nav, .ant-tabs-right > div > .ant-tabs-nav {
  order: 1;
}

.ant-tabs-right > .ant-tabs-nav .ant-tabs-ink-bar, .ant-tabs-right > div > .ant-tabs-nav .ant-tabs-ink-bar {
  left: 0;
}

.ant-tabs-right > .ant-tabs-content-holder, .ant-tabs-right > div > .ant-tabs-content-holder {
  order: 0;
  margin-right: -1px;
  border-right: 1px solid #f0f0f0;
}

.ant-tabs-right > .ant-tabs-content-holder > .ant-tabs-content > .ant-tabs-tabpane, .ant-tabs-right > div > .ant-tabs-content-holder > .ant-tabs-content > .ant-tabs-tabpane {
  padding-right: 24px;
}

.ant-tabs-dropdown {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: absolute;
  top: -9999px;
  left: -9999px;
  z-index: 1050;
  display: block;
}

.ant-tabs-dropdown-hidden {
  display: none;
}

.ant-tabs-dropdown-menu {
  max-height: 200px;
  margin: 0;
  padding: 4px 0;
  overflow-x: hidden;
  overflow-y: auto;
  text-align: left;
  list-style-type: none;
  background-color: #fff;
  background-clip: padding-box;
  border-radius: 2px;
  outline: none;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
}

.ant-tabs-dropdown-menu-item {
  display: flex;
  align-items: center;
  min-width: 120px;
  margin: 0;
  padding: 5px 12px;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  transition: all 0.3s;
}

.ant-tabs-dropdown-menu-item > span {
  flex: 1;
  white-space: nowrap;
}

.ant-tabs-dropdown-menu-item-remove {
  flex: none;
  margin-left: 12px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
  background: transparent;
  border: 0;
  cursor: pointer;
}

.ant-tabs-dropdown-menu-item-remove:hover {
  color: #40a9ff;
}

.ant-tabs-dropdown-menu-item:hover {
  background: #f5f5f5;
}

.ant-tabs-dropdown-menu-item-disabled, .ant-tabs-dropdown-menu-item-disabled:hover {
  color: rgba(0, 0, 0, 0.25);
  background: transparent;
  cursor: not-allowed;
}

.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab, .ant-tabs-card > div > .ant-tabs-nav .ant-tabs-tab {
  margin: 0;
  padding: 8px 16px;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab-active, .ant-tabs-card > div > .ant-tabs-nav .ant-tabs-tab-active {
  color: #1890ff;
  background: #fff;
}

.ant-tabs-card > .ant-tabs-nav .ant-tabs-ink-bar, .ant-tabs-card > div > .ant-tabs-nav .ant-tabs-ink-bar {
  visibility: hidden;
}

.ant-tabs-card.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab, .ant-tabs-card.ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab, .ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab, .ant-tabs-card.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab {
  margin-left: 2px;
}

.ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab, .ant-tabs-card.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-tab {
  border-radius: 2px 2px 0 0;
}

.ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab-active, .ant-tabs-card.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-tab-active {
  border-bottom-color: #fff;
}

.ant-tabs-card.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-tab, .ant-tabs-card.ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-tab {
  border-radius: 0 0 2px 2px;
}

.ant-tabs-card.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-tab-active, .ant-tabs-card.ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-tab-active {
  border-top-color: #fff;
}

.ant-tabs-card.ant-tabs-left > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab, .ant-tabs-card.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab, .ant-tabs-card.ant-tabs-right > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab, .ant-tabs-card.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab {
  margin-top: 2px;
}

.ant-tabs-card.ant-tabs-left > .ant-tabs-nav .ant-tabs-tab, .ant-tabs-card.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-tab {
  border-radius: 2px 0 0 2px;
}

.ant-tabs-card.ant-tabs-left > .ant-tabs-nav .ant-tabs-tab-active, .ant-tabs-card.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-tab-active {
  border-right-color: #fff;
}

.ant-tabs-card.ant-tabs-right > .ant-tabs-nav .ant-tabs-tab, .ant-tabs-card.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-tab {
  border-radius: 0 2px 2px 0;
}

.ant-tabs-card.ant-tabs-right > .ant-tabs-nav .ant-tabs-tab-active, .ant-tabs-card.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-tab-active {
  border-left-color: #fff;
}

.ant-tabs {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  display: flex;
}

.ant-tabs > .ant-tabs-nav, .ant-tabs > div > .ant-tabs-nav {
  position: relative;
  display: flex;
  flex: none;
  align-items: center;
}

.ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap, .ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-wrap {
  position: relative;
  display: inline-block;
  display: flex;
  flex: auto;
  align-self: stretch;
  overflow: hidden;
  white-space: nowrap;
  transform: translate(0);
}

.ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap:after, .ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap:before, .ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-wrap:after, .ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-wrap:before {
  position: absolute;
  z-index: 1;
  opacity: 0;
  transition: opacity 0.3s;
  content: "";
  pointer-events: none;
}

.ant-tabs > .ant-tabs-nav .ant-tabs-nav-list, .ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-list {
  position: relative;
  display: flex;
  transition: transform 0.3s;
}

.ant-tabs > .ant-tabs-nav .ant-tabs-nav-operations, .ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-operations {
  display: flex;
  align-self: stretch;
}

.ant-tabs > .ant-tabs-nav .ant-tabs-nav-operations-hidden, .ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-operations-hidden {
  position: absolute;
  visibility: hidden;
  pointer-events: none;
}

.ant-tabs > .ant-tabs-nav .ant-tabs-nav-more, .ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-more {
  position: relative;
  padding: 8px 16px;
  background: transparent;
  border: 0;
}

.ant-tabs > .ant-tabs-nav .ant-tabs-nav-more:after, .ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-more:after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 5px;
  transform: translateY(100%);
  content: "";
}

.ant-tabs > .ant-tabs-nav .ant-tabs-nav-add, .ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-add {
  min-width: 40px;
  margin-left: 2px;
  padding: 0 8px;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 2px 2px 0 0;
  outline: none;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-tabs > .ant-tabs-nav .ant-tabs-nav-add:hover, .ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-add:hover {
  color: #40a9ff;
}

.ant-tabs > .ant-tabs-nav .ant-tabs-nav-add:active, .ant-tabs > .ant-tabs-nav .ant-tabs-nav-add:focus, .ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-add:active, .ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-add:focus {
  color: #096dd9;
}

.ant-tabs-extra-content {
  flex: none;
}

.ant-tabs-centered > .ant-tabs-nav .ant-tabs-nav-wrap:not([class*=ant-tabs-nav-wrap-ping]), .ant-tabs-centered > div > .ant-tabs-nav .ant-tabs-nav-wrap:not([class*=ant-tabs-nav-wrap-ping]) {
  justify-content: center;
}

.ant-tabs-ink-bar {
  position: absolute;
  background: #1890ff;
  pointer-events: none;
}

.ant-tabs-tab {
  position: relative;
  display: inline-flex;
  align-items: center;
  padding: 12px 0;
  font-size: 14px;
  background: transparent;
  border: 0;
  outline: none;
  cursor: pointer;
}

.ant-tabs-tab-btn:active, .ant-tabs-tab-btn:focus, .ant-tabs-tab-remove:active, .ant-tabs-tab-remove:focus {
  color: #096dd9;
}

.ant-tabs-tab-btn, .ant-tabs-tab-remove {
  outline: none;
  transition: all 0.3s;
}

.ant-tabs-tab-remove {
  flex: none;
  margin-right: -4px;
  margin-left: 8px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
  background: transparent;
  border: none;
  cursor: pointer;
}

.ant-tabs-tab-remove:hover {
  color: rgba(0, 0, 0, 0.85);
}

.ant-tabs-tab:hover {
  color: #40a9ff;
}

.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #1890ff;
  text-shadow: 0 0 0.25px currentcolor;
}

.ant-tabs-tab.ant-tabs-tab-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ant-tabs-tab.ant-tabs-tab-disabled .ant-tabs-tab-btn:active, .ant-tabs-tab.ant-tabs-tab-disabled .ant-tabs-tab-btn:focus, .ant-tabs-tab.ant-tabs-tab-disabled .ant-tabs-tab-remove:active, .ant-tabs-tab.ant-tabs-tab-disabled .ant-tabs-tab-remove:focus {
  color: rgba(0, 0, 0, 0.25);
}

.ant-tabs-tab .ant-tabs-tab-remove .anticon {
  margin: 0;
}

.ant-tabs-tab .anticon {
  margin-right: 12px;
}

.ant-tabs-tab + .ant-tabs-tab {
  margin: 0 0 0 32px;
}

.ant-tabs-content {
  position: relative;
  width: 100%;
}

.ant-tabs-content-holder {
  flex: auto;
  min-width: 0;
  min-height: 0;
}

.ant-tabs-tabpane {
  outline: none;
}

.ant-tabs-tabpane-hidden {
  display: none;
}

.ant-tabs-switch-appear, .ant-tabs-switch-enter {
  transition: none;
}

.ant-tabs-switch-appear-start, .ant-tabs-switch-enter-start {
  opacity: 0;
}

.ant-tabs-switch-appear-active, .ant-tabs-switch-enter-active {
  opacity: 1;
  transition: opacity 0.3s;
}

.ant-tabs-switch-leave {
  position: absolute;
  transition: none;
  inset: 0;
}

.ant-tabs-switch-leave-start {
  opacity: 1;
}

.ant-tabs-switch-leave-active {
  opacity: 0;
  transition: opacity 0.3s;
}

.ant-tag {
  box-sizing: border-box;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  display: inline-block;
  height: auto;
  margin: 0 8px 0 0;
  padding: 0 7px;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
  background: #fafafa;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  opacity: 1;
  transition: all 0.3s;
}

.ant-tag, .ant-tag a, .ant-tag a:hover {
  color: rgba(0, 0, 0, 0.85);
}

.ant-tag > a:first-child:last-child {
  display: inline-block;
  margin: 0 -8px;
  padding: 0 8px;
}

.ant-tag-close-icon {
  margin-left: 3px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 10px;
  cursor: pointer;
  transition: all 0.3s;
}

.ant-tag-close-icon:hover {
  color: rgba(0, 0, 0, 0.85);
}

.ant-tag-has-color {
  border-color: transparent;
}

.ant-tag-has-color, .ant-tag-has-color .anticon-close, .ant-tag-has-color .anticon-close:hover, .ant-tag-has-color a, .ant-tag-has-color a:hover {
  color: #fff;
}

.ant-tag-checkable {
  background-color: transparent;
  border-color: transparent;
  cursor: pointer;
}

.ant-tag-checkable:not(.ant-tag-checkable-checked):hover {
  color: #1890ff;
}

.ant-tag-checkable-checked, .ant-tag-checkable:active {
  color: #fff;
}

.ant-tag-checkable-checked {
  background-color: #1890ff;
}

.ant-tag-checkable:active {
  background-color: #096dd9;
}

.ant-tag-hidden {
  display: none;
}

.ant-tag-pink {
  color: #c41d7f;
  background: #fff0f6;
  border-color: #ffadd2;
}

.ant-tag-pink-inverse {
  color: #fff;
  background: #eb2f96;
  border-color: #eb2f96;
}

.ant-tag-magenta {
  color: #c41d7f;
  background: #fff0f6;
  border-color: #ffadd2;
}

.ant-tag-magenta-inverse {
  color: #fff;
  background: #eb2f96;
  border-color: #eb2f96;
}

.ant-tag-red {
  color: #cf1322;
  background: #fff1f0;
  border-color: #ffa39e;
}

.ant-tag-red-inverse {
  color: #fff;
  background: #f5222d;
  border-color: #f5222d;
}

.ant-tag-volcano {
  color: #d4380d;
  background: #fff2e8;
  border-color: #ffbb96;
}

.ant-tag-volcano-inverse {
  color: #fff;
  background: #fa541c;
  border-color: #fa541c;
}

.ant-tag-orange {
  color: #d46b08;
  background: #fff7e6;
  border-color: #ffd591;
}

.ant-tag-orange-inverse {
  color: #fff;
  background: #fa8c16;
  border-color: #fa8c16;
}

.ant-tag-yellow {
  color: #d4b106;
  background: #feffe6;
  border-color: #fffb8f;
}

.ant-tag-yellow-inverse {
  color: #fff;
  background: #fadb14;
  border-color: #fadb14;
}

.ant-tag-gold {
  color: #d48806;
  background: #fffbe6;
  border-color: #ffe58f;
}

.ant-tag-gold-inverse {
  color: #fff;
  background: #faad14;
  border-color: #faad14;
}

.ant-tag-cyan {
  color: #08979c;
  background: #e6fffb;
  border-color: #87e8de;
}

.ant-tag-cyan-inverse {
  color: #fff;
  background: #13c2c2;
  border-color: #13c2c2;
}

.ant-tag-lime {
  color: #7cb305;
  background: #fcffe6;
  border-color: #eaff8f;
}

.ant-tag-lime-inverse {
  color: #fff;
  background: #a0d911;
  border-color: #a0d911;
}

.ant-tag-green {
  color: #389e0d;
  background: #f6ffed;
  border-color: #b7eb8f;
}

.ant-tag-green-inverse {
  color: #fff;
  background: #52c41a;
  border-color: #52c41a;
}

.ant-tag-blue {
  color: #096dd9;
  background: #e6f7ff;
  border-color: #91d5ff;
}

.ant-tag-blue-inverse {
  color: #fff;
  background: #1890ff;
  border-color: #1890ff;
}

.ant-tag-geekblue {
  color: #1d39c4;
  background: #f0f5ff;
  border-color: #adc6ff;
}

.ant-tag-geekblue-inverse {
  color: #fff;
  background: #2f54eb;
  border-color: #2f54eb;
}

.ant-tag-purple {
  color: #531dab;
  background: #f9f0ff;
  border-color: #d3adf7;
}

.ant-tag-purple-inverse {
  color: #fff;
  background: #722ed1;
  border-color: #722ed1;
}

.ant-tag-success {
  color: #52c41a;
  background: #f6ffed;
  border-color: #b7eb8f;
}

.ant-tag-processing {
  color: #1890ff;
  background: #e6f7ff;
  border-color: #91d5ff;
}

.ant-tag-error {
  color: #ff4d4f;
  background: #fff2f0;
  border-color: #ffccc7;
}

.ant-tag-warning {
  color: #faad14;
  background: #fffbe6;
  border-color: #ffe58f;
}

.ant-tag > .anticon + span, .ant-tag > span + .anticon {
  margin-left: 7px;
}

.ant-tag.ant-tag-rtl {
  margin-right: 0;
  margin-left: 8px;
  direction: rtl;
  text-align: right;
}

.ant-tag-rtl .ant-tag-close-icon {
  margin-right: 3px;
  margin-left: 0;
}

.ant-tag-rtl.ant-tag > .anticon + span, .ant-tag-rtl.ant-tag > span + .anticon {
  margin-right: 7px;
  margin-left: 0;
}

.ant-timeline {
  box-sizing: border-box;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  font-feature-settings: "tnum";
  margin: 0;
  padding: 0;
  list-style: none;
}

.ant-timeline-item {
  position: relative;
  margin: 0;
  padding-bottom: 20px;
  font-size: 14px;
  list-style: none;
}

.ant-timeline-item-tail {
  position: absolute;
  top: 10px;
  left: 4px;
  height: calc(100% - 10px);
  border-left: 2px solid #f0f0f0;
}

.ant-timeline-item-pending .ant-timeline-item-head {
  font-size: 12px;
  background-color: transparent;
}

.ant-timeline-item-pending .ant-timeline-item-tail {
  display: none;
}

.ant-timeline-item-head {
  position: absolute;
  width: 10px;
  height: 10px;
  background-color: #fff;
  border: 2px solid transparent;
  border-radius: 100px;
}

.ant-timeline-item-head-blue {
  color: #1890ff;
  border-color: #1890ff;
}

.ant-timeline-item-head-red {
  color: #ff4d4f;
  border-color: #ff4d4f;
}

.ant-timeline-item-head-green {
  color: #52c41a;
  border-color: #52c41a;
}

.ant-timeline-item-head-gray {
  color: rgba(0, 0, 0, 0.25);
  border-color: rgba(0, 0, 0, 0.25);
}

.ant-timeline-item-head-custom {
  position: absolute;
  top: 5.5px;
  left: 5px;
  width: auto;
  height: auto;
  margin-top: 0;
  padding: 3px 1px;
  line-height: 1;
  text-align: center;
  border: 0;
  border-radius: 0;
  transform: translate(-50%, -50%);
}

.ant-timeline-item-content {
  position: relative;
  top: -7.001px;
  margin: 0 0 0 26px;
  word-break: break-word;
}

.ant-timeline-item-last > .ant-timeline-item-tail {
  display: none;
}

.ant-timeline-item-last > .ant-timeline-item-content {
  min-height: 48px;
}

.ant-timeline.ant-timeline-alternate .ant-timeline-item-head, .ant-timeline.ant-timeline-alternate .ant-timeline-item-head-custom, .ant-timeline.ant-timeline-alternate .ant-timeline-item-tail, .ant-timeline.ant-timeline-label .ant-timeline-item-head, .ant-timeline.ant-timeline-label .ant-timeline-item-head-custom, .ant-timeline.ant-timeline-label .ant-timeline-item-tail, .ant-timeline.ant-timeline-right .ant-timeline-item-head, .ant-timeline.ant-timeline-right .ant-timeline-item-head-custom, .ant-timeline.ant-timeline-right .ant-timeline-item-tail {
  left: 50%;
}

.ant-timeline.ant-timeline-alternate .ant-timeline-item-head, .ant-timeline.ant-timeline-label .ant-timeline-item-head, .ant-timeline.ant-timeline-right .ant-timeline-item-head {
  margin-left: -4px;
}

.ant-timeline.ant-timeline-alternate .ant-timeline-item-head-custom, .ant-timeline.ant-timeline-label .ant-timeline-item-head-custom, .ant-timeline.ant-timeline-right .ant-timeline-item-head-custom {
  margin-left: 1px;
}

.ant-timeline.ant-timeline-alternate .ant-timeline-item-left .ant-timeline-item-content, .ant-timeline.ant-timeline-label .ant-timeline-item-left .ant-timeline-item-content, .ant-timeline.ant-timeline-right .ant-timeline-item-left .ant-timeline-item-content {
  left: calc(50% - 4px);
  width: calc(50% - 14px);
  text-align: left;
}

.ant-timeline.ant-timeline-alternate .ant-timeline-item-right .ant-timeline-item-content, .ant-timeline.ant-timeline-label .ant-timeline-item-right .ant-timeline-item-content, .ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-content {
  width: calc(50% - 12px);
  margin: 0;
  text-align: right;
}

.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-head, .ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-head-custom, .ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-tail {
  left: calc(100% - 6px);
}

.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-content {
  width: calc(100% - 18px);
}

.ant-timeline.ant-timeline-pending .ant-timeline-item-last .ant-timeline-item-tail {
  display: block;
  height: calc(100% - 14px);
  border-left: 2px dotted #f0f0f0;
}

.ant-timeline.ant-timeline-reverse .ant-timeline-item-last .ant-timeline-item-tail {
  display: none;
}

.ant-timeline.ant-timeline-reverse .ant-timeline-item-pending .ant-timeline-item-tail {
  top: 15px;
  display: block;
  height: calc(100% - 15px);
  border-left: 2px dotted #f0f0f0;
}

.ant-timeline.ant-timeline-reverse .ant-timeline-item-pending .ant-timeline-item-content {
  min-height: 48px;
}

.ant-timeline.ant-timeline-label .ant-timeline-item-label {
  position: absolute;
  top: -7.001px;
  width: calc(50% - 12px);
  text-align: right;
}

.ant-timeline.ant-timeline-label .ant-timeline-item-right .ant-timeline-item-label {
  left: calc(50% + 14px);
  width: calc(50% - 14px);
  text-align: left;
}

.ant-timeline-rtl {
  direction: rtl;
}

.ant-timeline-rtl .ant-timeline-item-tail {
  right: 4px;
  left: auto;
  border-right: 2px solid #f0f0f0;
  border-left: none;
}

.ant-timeline-rtl .ant-timeline-item-head-custom {
  right: 5px;
  left: auto;
  transform: translate(50%, -50%);
}

.ant-timeline-rtl .ant-timeline-item-content {
  margin: 0 18px 0 0;
}

.ant-timeline-rtl.ant-timeline.ant-timeline-alternate .ant-timeline-item-head, .ant-timeline-rtl.ant-timeline.ant-timeline-alternate .ant-timeline-item-head-custom, .ant-timeline-rtl.ant-timeline.ant-timeline-alternate .ant-timeline-item-tail, .ant-timeline-rtl.ant-timeline.ant-timeline-label .ant-timeline-item-head, .ant-timeline-rtl.ant-timeline.ant-timeline-label .ant-timeline-item-head-custom, .ant-timeline-rtl.ant-timeline.ant-timeline-label .ant-timeline-item-tail, .ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-head, .ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-head-custom, .ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-tail {
  right: 50%;
  left: auto;
}

.ant-timeline-rtl.ant-timeline.ant-timeline-alternate .ant-timeline-item-head, .ant-timeline-rtl.ant-timeline.ant-timeline-label .ant-timeline-item-head, .ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-head {
  margin-right: -4px;
  margin-left: 0;
}

.ant-timeline-rtl.ant-timeline.ant-timeline-alternate .ant-timeline-item-head-custom, .ant-timeline-rtl.ant-timeline.ant-timeline-label .ant-timeline-item-head-custom, .ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-head-custom {
  margin-right: 1px;
  margin-left: 0;
}

.ant-timeline-rtl.ant-timeline.ant-timeline-alternate .ant-timeline-item-left .ant-timeline-item-content, .ant-timeline-rtl.ant-timeline.ant-timeline-label .ant-timeline-item-left .ant-timeline-item-content, .ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-left .ant-timeline-item-content {
  right: calc(50% - 4px);
  left: auto;
  text-align: right;
}

.ant-timeline-rtl.ant-timeline.ant-timeline-alternate .ant-timeline-item-right .ant-timeline-item-content, .ant-timeline-rtl.ant-timeline.ant-timeline-label .ant-timeline-item-right .ant-timeline-item-content, .ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-content {
  text-align: left;
}

.ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-head, .ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-head-custom, .ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-tail {
  right: 0;
  left: auto;
}

.ant-timeline-rtl.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-content {
  width: 100%;
  margin-right: 18px;
  text-align: right;
}

.ant-timeline-rtl.ant-timeline.ant-timeline-pending .ant-timeline-item-last .ant-timeline-item-tail, .ant-timeline-rtl.ant-timeline.ant-timeline-reverse .ant-timeline-item-pending .ant-timeline-item-tail {
  border-right: 2px dotted #f0f0f0;
  border-left: none;
}

.ant-timeline-rtl.ant-timeline.ant-timeline-label .ant-timeline-item-label {
  text-align: left;
}

.ant-timeline-rtl.ant-timeline.ant-timeline-label .ant-timeline-item-right .ant-timeline-item-label {
  right: calc(50% + 14px);
  text-align: right;
}

.ant-tooltip {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: absolute;
  z-index: 1070;
  display: block;
  width: -moz-max-content;
  width: max-content;
  width: intrinsic;
  max-width: 250px;
  visibility: visible;
}

.ant-tooltip-content {
  position: relative;
}

.ant-tooltip-hidden {
  display: none;
}

.ant-tooltip-placement-top, .ant-tooltip-placement-topLeft, .ant-tooltip-placement-topRight {
  padding-bottom: 14.3137085px;
}

.ant-tooltip-placement-right, .ant-tooltip-placement-rightBottom, .ant-tooltip-placement-rightTop {
  padding-left: 14.3137085px;
}

.ant-tooltip-placement-bottom, .ant-tooltip-placement-bottomLeft, .ant-tooltip-placement-bottomRight {
  padding-top: 14.3137085px;
}

.ant-tooltip-placement-left, .ant-tooltip-placement-leftBottom, .ant-tooltip-placement-leftTop {
  padding-right: 14.3137085px;
}

.ant-tooltip-inner {
  min-width: 30px;
  min-height: 32px;
  padding: 6px 8px;
  color: #fff;
  text-align: left;
  text-decoration: none;
  word-wrap: break-word;
  background-color: rgba(0, 0, 0, 0.75);
  border-radius: 2px;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
}

.ant-tooltip-arrow {
  position: absolute;
  z-index: 2;
  display: block;
  width: 22px;
  height: 22px;
  overflow: hidden;
  background: transparent;
  pointer-events: none;
}

.ant-tooltip-arrow-content {
  --antd-arrow-background-color:linear-gradient(to right bottom,rgba(0,0,0,0.65),rgba(0,0,0,0.75));
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: block;
  width: 11.3137085px;
  height: 11.3137085px;
  margin: auto;
  content: "";
  pointer-events: auto;
  border-radius: 0 0 2px;
  pointer-events: none;
}

.ant-tooltip-arrow-content:before {
  position: absolute;
  top: -11.3137085px;
  left: -11.3137085px;
  width: 33.9411255px;
  height: 33.9411255px;
  background: var(--antd-arrow-background-color);
  background-repeat: no-repeat;
  background-position: -10px -10px;
  content: "";
  -webkit-clip-path: inset(33% 33%);
  clip-path: inset(33% 33%);
  -webkit-clip-path: path("M 9.849242404917499 24.091883092036785 A 5 5 0 0 1 13.384776310850237 22.627416997969522 L 20.627416997969522 22.627416997969522 A 2 2 0 0 0 22.627416997969522 20.627416997969522 L 22.627416997969522 13.384776310850237 A 5 5 0 0 1 24.091883092036785 9.849242404917499 L 23.091883092036785 9.849242404917499 L 9.849242404917499 23.091883092036785 Z");
  clip-path: path("M 9.849242404917499 24.091883092036785 A 5 5 0 0 1 13.384776310850237 22.627416997969522 L 20.627416997969522 22.627416997969522 A 2 2 0 0 0 22.627416997969522 20.627416997969522 L 22.627416997969522 13.384776310850237 A 5 5 0 0 1 24.091883092036785 9.849242404917499 L 23.091883092036785 9.849242404917499 L 9.849242404917499 23.091883092036785 Z");
}

.ant-tooltip-placement-top .ant-tooltip-arrow, .ant-tooltip-placement-topLeft .ant-tooltip-arrow, .ant-tooltip-placement-topRight .ant-tooltip-arrow {
  bottom: 0;
  transform: translateY(100%);
}

.ant-tooltip-placement-top .ant-tooltip-arrow-content, .ant-tooltip-placement-topLeft .ant-tooltip-arrow-content, .ant-tooltip-placement-topRight .ant-tooltip-arrow-content {
  box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.07);
  transform: translateY(-11px) rotate(45deg);
}

.ant-tooltip-placement-top .ant-tooltip-arrow {
  left: 50%;
  transform: translateY(100%) translateX(-50%);
}

.ant-tooltip-placement-topLeft .ant-tooltip-arrow {
  left: 13px;
}

.ant-tooltip-placement-topRight .ant-tooltip-arrow {
  right: 13px;
}

.ant-tooltip-placement-right .ant-tooltip-arrow, .ant-tooltip-placement-rightBottom .ant-tooltip-arrow, .ant-tooltip-placement-rightTop .ant-tooltip-arrow {
  left: 0;
  transform: translateX(-100%);
}

.ant-tooltip-placement-right .ant-tooltip-arrow-content, .ant-tooltip-placement-rightBottom .ant-tooltip-arrow-content, .ant-tooltip-placement-rightTop .ant-tooltip-arrow-content {
  box-shadow: -3px 3px 7px rgba(0, 0, 0, 0.07);
  transform: translateX(11px) rotate(135deg);
}

.ant-tooltip-placement-right .ant-tooltip-arrow {
  top: 50%;
  transform: translateX(-100%) translateY(-50%);
}

.ant-tooltip-placement-rightTop .ant-tooltip-arrow {
  top: 5px;
}

.ant-tooltip-placement-rightBottom .ant-tooltip-arrow {
  bottom: 5px;
}

.ant-tooltip-placement-left .ant-tooltip-arrow, .ant-tooltip-placement-leftBottom .ant-tooltip-arrow, .ant-tooltip-placement-leftTop .ant-tooltip-arrow {
  right: 0;
  transform: translateX(100%);
}

.ant-tooltip-placement-left .ant-tooltip-arrow-content, .ant-tooltip-placement-leftBottom .ant-tooltip-arrow-content, .ant-tooltip-placement-leftTop .ant-tooltip-arrow-content {
  box-shadow: 3px -3px 7px rgba(0, 0, 0, 0.07);
  transform: translateX(-11px) rotate(315deg);
}

.ant-tooltip-placement-left .ant-tooltip-arrow {
  top: 50%;
  transform: translateX(100%) translateY(-50%);
}

.ant-tooltip-placement-leftTop .ant-tooltip-arrow {
  top: 5px;
}

.ant-tooltip-placement-leftBottom .ant-tooltip-arrow {
  bottom: 5px;
}

.ant-tooltip-placement-bottom .ant-tooltip-arrow, .ant-tooltip-placement-bottomLeft .ant-tooltip-arrow, .ant-tooltip-placement-bottomRight .ant-tooltip-arrow {
  top: 0;
  transform: translateY(-100%);
}

.ant-tooltip-placement-bottom .ant-tooltip-arrow-content, .ant-tooltip-placement-bottomLeft .ant-tooltip-arrow-content, .ant-tooltip-placement-bottomRight .ant-tooltip-arrow-content {
  box-shadow: -3px -3px 7px rgba(0, 0, 0, 0.07);
  transform: translateY(11px) rotate(225deg);
}

.ant-tooltip-placement-bottom .ant-tooltip-arrow {
  left: 50%;
  transform: translateY(-100%) translateX(-50%);
}

.ant-tooltip-placement-bottomLeft .ant-tooltip-arrow {
  left: 13px;
}

.ant-tooltip-placement-bottomRight .ant-tooltip-arrow {
  right: 13px;
}

.ant-tooltip-pink .ant-tooltip-inner {
  background-color: #eb2f96;
}

.ant-tooltip-pink .ant-tooltip-arrow-content:before {
  background: #eb2f96;
}

.ant-tooltip-magenta .ant-tooltip-inner {
  background-color: #eb2f96;
}

.ant-tooltip-magenta .ant-tooltip-arrow-content:before {
  background: #eb2f96;
}

.ant-tooltip-red .ant-tooltip-inner {
  background-color: #f5222d;
}

.ant-tooltip-red .ant-tooltip-arrow-content:before {
  background: #f5222d;
}

.ant-tooltip-volcano .ant-tooltip-inner {
  background-color: #fa541c;
}

.ant-tooltip-volcano .ant-tooltip-arrow-content:before {
  background: #fa541c;
}

.ant-tooltip-orange .ant-tooltip-inner {
  background-color: #fa8c16;
}

.ant-tooltip-orange .ant-tooltip-arrow-content:before {
  background: #fa8c16;
}

.ant-tooltip-yellow .ant-tooltip-inner {
  background-color: #fadb14;
}

.ant-tooltip-yellow .ant-tooltip-arrow-content:before {
  background: #fadb14;
}

.ant-tooltip-gold .ant-tooltip-inner {
  background-color: #faad14;
}

.ant-tooltip-gold .ant-tooltip-arrow-content:before {
  background: #faad14;
}

.ant-tooltip-cyan .ant-tooltip-inner {
  background-color: #13c2c2;
}

.ant-tooltip-cyan .ant-tooltip-arrow-content:before {
  background: #13c2c2;
}

.ant-tooltip-lime .ant-tooltip-inner {
  background-color: #a0d911;
}

.ant-tooltip-lime .ant-tooltip-arrow-content:before {
  background: #a0d911;
}

.ant-tooltip-green .ant-tooltip-inner {
  background-color: #52c41a;
}

.ant-tooltip-green .ant-tooltip-arrow-content:before {
  background: #52c41a;
}

.ant-tooltip-blue .ant-tooltip-inner {
  background-color: #1890ff;
}

.ant-tooltip-blue .ant-tooltip-arrow-content:before {
  background: #1890ff;
}

.ant-tooltip-geekblue .ant-tooltip-inner {
  background-color: #2f54eb;
}

.ant-tooltip-geekblue .ant-tooltip-arrow-content:before {
  background: #2f54eb;
}

.ant-tooltip-purple .ant-tooltip-inner {
  background-color: #722ed1;
}

.ant-tooltip-purple .ant-tooltip-arrow-content:before {
  background: #722ed1;
}

.ant-tooltip-rtl {
  direction: rtl;
}

.ant-tooltip-rtl .ant-tooltip-inner {
  text-align: right;
}

.ant-transfer-customize-list .ant-transfer-list {
  flex: 1 1 50%;
  width: auto;
  height: auto;
  min-height: 200px;
}

.ant-transfer-customize-list .ant-table-wrapper .ant-table-small {
  border: 0;
  border-radius: 0;
}

.ant-transfer-customize-list .ant-table-wrapper .ant-table-small .ant-table-selection-column {
  width: 40px;
  min-width: 40px;
}

.ant-transfer-customize-list .ant-table-wrapper .ant-table-small > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th {
  background: #fafafa;
}

.ant-transfer-customize-list .ant-table-wrapper .ant-table-small > .ant-table-content .ant-table-row:last-child td {
  border-bottom: 1px solid #f0f0f0;
}

.ant-transfer-customize-list .ant-table-wrapper .ant-table-small .ant-table-body {
  margin: 0;
}

.ant-transfer-customize-list .ant-table-wrapper .ant-table-pagination.ant-pagination {
  margin: 16px 0 4px;
}

.ant-transfer-customize-list .ant-input[disabled] {
  background-color: transparent;
}

.ant-transfer-status-error .ant-transfer-list {
  border-color: #ff4d4f;
}

.ant-transfer-status-error .ant-transfer-list-search:not([disabled]) {
  border-color: #d9d9d9;
}

.ant-transfer-status-error .ant-transfer-list-search:not([disabled]):hover {
  border-color: #40a9ff;
  border-right-width: 1px;
}

.ant-transfer-status-error .ant-transfer-list-search:not([disabled]):focus {
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-transfer-status-warning .ant-transfer-list {
  border-color: #faad14;
}

.ant-transfer-status-warning .ant-transfer-list-search:not([disabled]) {
  border-color: #d9d9d9;
}

.ant-transfer-status-warning .ant-transfer-list-search:not([disabled]):hover {
  border-color: #40a9ff;
  border-right-width: 1px;
}

.ant-transfer-status-warning .ant-transfer-list-search:not([disabled]):focus {
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  border-right-width: 1px;
  outline: 0;
}

.ant-transfer {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  display: flex;
  align-items: stretch;
}

.ant-transfer-disabled .ant-transfer-list {
  background: #f5f5f5;
}

.ant-transfer-list {
  display: flex;
  flex-direction: column;
  width: 180px;
  height: 200px;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
}

.ant-transfer-list-with-pagination {
  width: 250px;
  height: auto;
}

.ant-transfer-list-search .anticon-search {
  color: rgba(0, 0, 0, 0.25);
}

.ant-transfer-list-header {
  display: flex;
  flex: none;
  align-items: center;
  height: 40px;
  padding: 8px 12px 9px;
  color: rgba(0, 0, 0, 0.85);
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
  border-radius: 2px 2px 0 0;
}

.ant-transfer-list-header > :not(:last-child) {
  margin-right: 4px;
}

.ant-transfer-list-header > * {
  flex: none;
}

.ant-transfer-list-header-title {
  flex: auto;
  overflow: hidden;
  white-space: nowrap;
  text-align: right;
  text-overflow: ellipsis;
}

.ant-transfer-list-header-dropdown {
  font-size: 10px;
  transform: translateY(10%);
  cursor: pointer;
}

.ant-transfer-list-header-dropdown[disabled] {
  cursor: not-allowed;
}

.ant-transfer-list-body {
  display: flex;
  flex: auto;
  flex-direction: column;
  overflow: hidden;
  font-size: 14px;
}

.ant-transfer-list-body-search-wrapper {
  position: relative;
  flex: none;
  padding: 12px;
}

.ant-transfer-list-content {
  flex: auto;
  margin: 0;
  padding: 0;
  overflow: auto;
  list-style: none;
}

.ant-transfer-list-content-item {
  display: flex;
  align-items: center;
  min-height: 32px;
  padding: 6px 12px;
  line-height: 20px;
  transition: all 0.3s;
}

.ant-transfer-list-content-item > :not(:last-child) {
  margin-right: 8px;
}

.ant-transfer-list-content-item > * {
  flex: none;
}

.ant-transfer-list-content-item-text {
  flex: auto;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ant-transfer-list-content-item-remove {
  position: relative;
  color: #d9d9d9;
  cursor: pointer;
  transition: all 0.3s;
}

.ant-transfer-list-content-item-remove:hover {
  color: #40a9ff;
}

.ant-transfer-list-content-item-remove:after {
  position: absolute;
  top: -6px;
  right: -50%;
  bottom: -6px;
  left: -50%;
  content: "";
}

.ant-transfer-list-content-item:not(.ant-transfer-list-content-item-disabled):hover {
  background-color: #f5f5f5;
  cursor: pointer;
}

.ant-transfer-list-content-item:not(.ant-transfer-list-content-item-disabled).ant-transfer-list-content-item-checked:hover {
  background-color: #dcf4ff;
}

.ant-transfer-list-content-show-remove .ant-transfer-list-content-item:not(.ant-transfer-list-content-item-disabled):hover {
  background: transparent;
  cursor: default;
}

.ant-transfer-list-content-item-checked {
  background-color: #e6f7ff;
}

.ant-transfer-list-content-item-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ant-transfer-list-pagination {
  padding: 8px 0;
  text-align: right;
  border-top: 1px solid #f0f0f0;
}

.ant-transfer-list-body-not-found {
  flex: none;
  width: 100%;
  margin: auto 0;
  color: rgba(0, 0, 0, 0.25);
  text-align: center;
}

.ant-transfer-list-footer {
  border-top: 1px solid #f0f0f0;
}

.ant-transfer-operation {
  display: flex;
  flex: none;
  flex-direction: column;
  align-self: center;
  margin: 0 8px;
  vertical-align: middle;
}

.ant-transfer-operation .ant-btn {
  display: block;
}

.ant-transfer-operation .ant-btn:first-child {
  margin-bottom: 4px;
}

.ant-transfer-operation .ant-btn .anticon {
  font-size: 12px;
}

.ant-transfer .ant-empty-image {
  max-height: -2px;
}

.ant-transfer-rtl {
  direction: rtl;
}

.ant-transfer-rtl .ant-transfer-list-search {
  padding-right: 8px;
  padding-left: 24px;
}

.ant-transfer-rtl .ant-transfer-list-search-action {
  right: auto;
  left: 12px;
}

.ant-transfer-rtl .ant-transfer-list-header > :not(:last-child) {
  margin-right: 0;
  margin-left: 4px;
}

.ant-transfer-rtl .ant-transfer-list-header {
  right: 0;
  left: auto;
}

.ant-transfer-rtl .ant-transfer-list-header-title {
  text-align: left;
}

.ant-transfer-rtl .ant-transfer-list-content-item > :not(:last-child) {
  margin-right: 0;
  margin-left: 8px;
}

.ant-transfer-rtl .ant-transfer-list-pagination {
  text-align: left;
}

.ant-transfer-rtl .ant-transfer-list-footer {
  right: 0;
  left: auto;
}

.ant-select-tree-checkbox {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  top: 0.2em;
  line-height: 1;
  white-space: nowrap;
  outline: none;
  cursor: pointer;
}

.ant-select-tree-checkbox-input:focus + .ant-select-tree-checkbox-inner, .ant-select-tree-checkbox-wrapper:hover .ant-select-tree-checkbox-inner, .ant-select-tree-checkbox:hover .ant-select-tree-checkbox-inner {
  border-color: #1890ff;
}

.ant-select-tree-checkbox-checked:after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid #1890ff;
  border-radius: 2px;
  visibility: hidden;
  animation: antCheckboxEffect 0.36s ease-in-out;
  animation-fill-mode: backwards;
  content: "";
}

.ant-select-tree-checkbox-wrapper:hover .ant-select-tree-checkbox:after, .ant-select-tree-checkbox:hover:after {
  visibility: visible;
}

.ant-select-tree-checkbox-inner {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  width: 16px;
  height: 16px;
  direction: ltr;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  border-collapse: separate;
  transition: all 0.3s;
}

.ant-select-tree-checkbox-inner:after {
  position: absolute;
  top: 50%;
  left: 21.5%;
  display: table;
  width: 5.71428571px;
  height: 9.14285714px;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  transform: rotate(45deg) scale(0) translate(-50%, -50%);
  opacity: 0;
  transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6), opacity 0.1s;
  content: " ";
}

.ant-select-tree-checkbox-input {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  cursor: pointer;
  opacity: 0;
}

.ant-select-tree-checkbox-checked .ant-select-tree-checkbox-inner:after {
  position: absolute;
  display: table;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  transform: rotate(45deg) scale(1) translate(-50%, -50%);
  opacity: 1;
  transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
  content: " ";
}

.ant-select-tree-checkbox-checked .ant-select-tree-checkbox-inner {
  background-color: #1890ff;
  border-color: #1890ff;
}

.ant-select-tree-checkbox-disabled {
  cursor: not-allowed;
}

.ant-select-tree-checkbox-disabled.ant-select-tree-checkbox-checked .ant-select-tree-checkbox-inner:after {
  border-color: rgba(0, 0, 0, 0.25);
  animation-name: none;
}

.ant-select-tree-checkbox-disabled .ant-select-tree-checkbox-input {
  cursor: not-allowed;
  pointer-events: none;
}

.ant-select-tree-checkbox-disabled .ant-select-tree-checkbox-inner {
  background-color: #f5f5f5;
  border-color: #d9d9d9 !important;
}

.ant-select-tree-checkbox-disabled .ant-select-tree-checkbox-inner:after {
  border-color: #f5f5f5;
  border-collapse: separate;
  animation-name: none;
}

.ant-select-tree-checkbox-disabled + span {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ant-select-tree-checkbox-disabled:hover:after, .ant-select-tree-checkbox-wrapper:hover .ant-select-tree-checkbox-disabled:after {
  visibility: hidden;
}

.ant-select-tree-checkbox-wrapper {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  display: inline-flex;
  align-items: baseline;
  line-height: unset;
  cursor: pointer;
}

.ant-select-tree-checkbox-wrapper:after {
  display: inline-block;
  width: 0;
  overflow: hidden;
  content: " ";
}

.ant-select-tree-checkbox-wrapper.ant-select-tree-checkbox-wrapper-disabled {
  cursor: not-allowed;
}

.ant-select-tree-checkbox-wrapper + .ant-select-tree-checkbox-wrapper {
  margin-left: 8px;
}

.ant-select-tree-checkbox-wrapper.ant-select-tree-checkbox-wrapper-in-form-item input[type=checkbox] {
  width: 14px;
  height: 14px;
}

.ant-select-tree-checkbox + span {
  padding-right: 8px;
  padding-left: 8px;
}

.ant-select-tree-checkbox-group {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  display: inline-block;
}

.ant-select-tree-checkbox-group-item {
  margin-right: 8px;
}

.ant-select-tree-checkbox-group-item:last-child {
  margin-right: 0;
}

.ant-select-tree-checkbox-group-item + .ant-select-tree-checkbox-group-item {
  margin-left: 0;
}

.ant-select-tree-checkbox-indeterminate .ant-select-tree-checkbox-inner {
  background-color: #fff;
  border-color: #d9d9d9;
}

.ant-select-tree-checkbox-indeterminate .ant-select-tree-checkbox-inner:after {
  top: 50%;
  left: 50%;
  width: 8px;
  height: 8px;
  background-color: #1890ff;
  border: 0;
  transform: translate(-50%, -50%) scale(1);
  opacity: 1;
  content: " ";
}

.ant-select-tree-checkbox-indeterminate.ant-select-tree-checkbox-disabled .ant-select-tree-checkbox-inner:after {
  background-color: rgba(0, 0, 0, 0.25);
  border-color: rgba(0, 0, 0, 0.25);
}

.ant-tree-select-dropdown {
  padding: 8px 4px;
}

.ant-tree-select-dropdown-rtl {
  direction: rtl;
}

.ant-tree-select-dropdown .ant-select-tree {
  border-radius: 0;
}

.ant-tree-select-dropdown .ant-select-tree-list-holder-inner {
  align-items: stretch;
}

.ant-tree-select-dropdown .ant-select-tree-list-holder-inner .ant-select-tree-treenode .ant-select-tree-node-content-wrapper {
  flex: auto;
}

.ant-select-tree {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  background: #fff;
  border-radius: 2px;
  transition: background-color 0.3s;
}

.ant-select-tree-focused:not(:hover):not(.ant-select-tree-active-focused) {
  background: #e6f7ff;
}

.ant-select-tree-list-holder-inner {
  align-items: flex-start;
}

.ant-select-tree.ant-select-tree-block-node .ant-select-tree-list-holder-inner {
  align-items: stretch;
}

.ant-select-tree.ant-select-tree-block-node .ant-select-tree-list-holder-inner .ant-select-tree-node-content-wrapper {
  flex: auto;
}

.ant-select-tree.ant-select-tree-block-node .ant-select-tree-list-holder-inner .ant-select-tree-treenode.dragging {
  position: relative;
}

.ant-select-tree.ant-select-tree-block-node .ant-select-tree-list-holder-inner .ant-select-tree-treenode.dragging:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 4px;
  left: 0;
  border: 1px solid #1890ff;
  opacity: 0;
  animation: ant-tree-node-fx-do-not-use 0.3s;
  animation-play-state: running;
  animation-fill-mode: forwards;
  content: "";
  pointer-events: none;
}

.ant-select-tree .ant-select-tree-treenode {
  display: flex;
  align-items: flex-start;
  padding: 0 0 4px;
  outline: none;
}

.ant-select-tree .ant-select-tree-treenode-disabled .ant-select-tree-node-content-wrapper {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ant-select-tree .ant-select-tree-treenode-disabled .ant-select-tree-node-content-wrapper:hover {
  background: transparent;
}

.ant-select-tree .ant-select-tree-treenode-active .ant-select-tree-node-content-wrapper {
  background: #f5f5f5;
}

.ant-select-tree .ant-select-tree-treenode:not(.ant-select-tree .ant-select-tree-treenode-disabled).filter-node .ant-select-tree-title {
  color: inherit;
  font-weight: 500;
}

.ant-select-tree .ant-select-tree-treenode-draggable .ant-select-tree-draggable-icon {
  width: 24px;
  line-height: 24px;
  text-align: center;
  visibility: visible;
  opacity: 0.2;
  transition: opacity 0.3s;
}

.ant-select-tree-treenode:hover .ant-select-tree .ant-select-tree-treenode-draggable .ant-select-tree-draggable-icon {
  opacity: 0.45;
}

.ant-select-tree .ant-select-tree-treenode-draggable.ant-select-tree-treenode-disabled .ant-select-tree-draggable-icon {
  visibility: hidden;
}

.ant-select-tree-indent {
  align-self: stretch;
  white-space: nowrap;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-select-tree-indent-unit {
  display: inline-block;
  width: 24px;
}

.ant-select-tree-draggable-icon {
  visibility: hidden;
}

.ant-select-tree-switcher {
  position: relative;
  flex: none;
  align-self: stretch;
  width: 24px;
  margin: 0;
  line-height: 24px;
  text-align: center;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-select-tree-switcher .ant-select-tree-switcher-icon, .ant-select-tree-switcher .ant-tree-switcher-icon {
  display: inline-block;
  font-size: 10px;
  vertical-align: baseline;
}

.ant-select-tree-switcher .ant-select-tree-switcher-icon svg, .ant-select-tree-switcher .ant-tree-switcher-icon svg {
  transition: transform 0.3s;
}

.ant-select-tree-switcher-noop {
  cursor: default;
}

.ant-select-tree-switcher_close .ant-select-tree-switcher-icon svg {
  transform: rotate(-90deg);
}

.ant-select-tree-switcher-loading-icon {
  color: #1890ff;
}

.ant-select-tree-switcher-leaf-line {
  position: relative;
  z-index: 1;
  display: inline-block;
  width: 100%;
  height: 100%;
}

.ant-select-tree-switcher-leaf-line:before {
  position: absolute;
  top: 0;
  right: 12px;
  bottom: -4px;
  margin-left: -1px;
  border-right: 1px solid #d9d9d9;
  content: " ";
}

.ant-select-tree-switcher-leaf-line:after {
  position: absolute;
  width: 10px;
  height: 14px;
  border-bottom: 1px solid #d9d9d9;
  content: " ";
}

.ant-select-tree-checkbox {
  top: auto;
  margin: 4px 8px 0 0;
}

.ant-select-tree .ant-select-tree-node-content-wrapper {
  position: relative;
  z-index: auto;
  min-height: 24px;
  margin: 0;
  padding: 0 4px;
  color: inherit;
  line-height: 24px;
  background: transparent;
  border-radius: 2px;
  cursor: pointer;
  transition: all 0.3s, border 0s, line-height 0s, box-shadow 0s;
}

.ant-select-tree .ant-select-tree-node-content-wrapper:hover {
  background-color: #f5f5f5;
}

.ant-select-tree .ant-select-tree-node-content-wrapper.ant-select-tree-node-selected {
  background-color: #bae7ff;
}

.ant-select-tree .ant-select-tree-node-content-wrapper .ant-select-tree-iconEle {
  display: inline-block;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  vertical-align: top;
}

.ant-select-tree .ant-select-tree-node-content-wrapper .ant-select-tree-iconEle:empty {
  display: none;
}

.ant-select-tree-unselectable .ant-select-tree-node-content-wrapper:hover {
  background-color: transparent;
}

.ant-select-tree-node-content-wrapper {
  line-height: 24px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-select-tree-node-content-wrapper .ant-tree-drop-indicator {
  position: absolute;
  z-index: 1;
  height: 2px;
  background-color: #1890ff;
  border-radius: 1px;
  pointer-events: none;
}

.ant-select-tree-node-content-wrapper .ant-tree-drop-indicator:after {
  position: absolute;
  top: -3px;
  left: -6px;
  width: 8px;
  height: 8px;
  background-color: transparent;
  border: 2px solid #1890ff;
  border-radius: 50%;
  content: "";
}

.ant-select-tree .ant-select-tree-treenode.drop-container > [draggable] {
  box-shadow: 0 0 0 2px #1890ff;
}

.ant-select-tree-show-line .ant-select-tree-indent-unit {
  position: relative;
  height: 100%;
}

.ant-select-tree-show-line .ant-select-tree-indent-unit:before {
  position: absolute;
  top: 0;
  right: 12px;
  bottom: -4px;
  border-right: 1px solid #d9d9d9;
  content: "";
}

.ant-select-tree-show-line .ant-select-tree-indent-unit-end:before {
  display: none;
}

.ant-select-tree-show-line .ant-select-tree-switcher {
  background: #fff;
}

.ant-select-tree-show-line .ant-select-tree-switcher-line-icon {
  vertical-align: -0.15em;
}

.ant-select-tree .ant-select-tree-treenode-leaf-last .ant-select-tree-switcher-leaf-line:before {
  top: auto !important;
  bottom: auto !important;
  height: 14px !important;
}

.ant-tree-select-dropdown-rtl .ant-select-tree .ant-select-tree-switcher_close .ant-select-tree-switcher-icon svg {
  transform: rotate(90deg);
}

.ant-tree-select-dropdown-rtl .ant-select-tree .ant-select-tree-switcher-loading-icon {
  transform: scaleY(-1);
}

@keyframes antCheckboxEffect {
  0% {
    transform: scale(1);
    opacity: 0.5;
  }
  to {
    transform: scale(1.6);
    opacity: 0;
  }
}
@keyframes ant-tree-node-fx-do-not-use {
  0% {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.ant-tree.ant-tree-directory .ant-tree-treenode {
  position: relative;
}

.ant-tree.ant-tree-directory .ant-tree-treenode:before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 4px;
  left: 0;
  transition: background-color 0.3s;
  content: "";
  pointer-events: none;
}

.ant-tree.ant-tree-directory .ant-tree-treenode:hover:before {
  background: #f5f5f5;
}

.ant-tree.ant-tree-directory .ant-tree-treenode > * {
  z-index: 1;
}

.ant-tree.ant-tree-directory .ant-tree-treenode .ant-tree-switcher {
  transition: color 0.3s;
}

.ant-tree.ant-tree-directory .ant-tree-treenode .ant-tree-node-content-wrapper {
  border-radius: 0;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-tree.ant-tree-directory .ant-tree-treenode .ant-tree-node-content-wrapper:hover {
  background: transparent;
}

.ant-tree.ant-tree-directory .ant-tree-treenode .ant-tree-node-content-wrapper.ant-tree-node-selected {
  color: #fff;
  background: transparent;
}

.ant-tree.ant-tree-directory .ant-tree-treenode-selected:before, .ant-tree.ant-tree-directory .ant-tree-treenode-selected:hover:before {
  background: #1890ff;
}

.ant-tree.ant-tree-directory .ant-tree-treenode-selected .ant-tree-switcher {
  color: #fff;
}

.ant-tree.ant-tree-directory .ant-tree-treenode-selected .ant-tree-node-content-wrapper {
  color: #fff;
  background: transparent;
}

.ant-tree-checkbox {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  top: 0.2em;
  line-height: 1;
  white-space: nowrap;
  outline: none;
  cursor: pointer;
}

.ant-tree-checkbox-input:focus + .ant-tree-checkbox-inner, .ant-tree-checkbox-wrapper:hover .ant-tree-checkbox-inner, .ant-tree-checkbox:hover .ant-tree-checkbox-inner {
  border-color: #1890ff;
}

.ant-tree-checkbox-checked:after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid #1890ff;
  border-radius: 2px;
  visibility: hidden;
  animation: antCheckboxEffect 0.36s ease-in-out;
  animation-fill-mode: backwards;
  content: "";
}

.ant-tree-checkbox-wrapper:hover .ant-tree-checkbox:after, .ant-tree-checkbox:hover:after {
  visibility: visible;
}

.ant-tree-checkbox-inner {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  width: 16px;
  height: 16px;
  direction: ltr;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  border-collapse: separate;
  transition: all 0.3s;
}

.ant-tree-checkbox-inner:after {
  position: absolute;
  top: 50%;
  left: 21.5%;
  display: table;
  width: 5.71428571px;
  height: 9.14285714px;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  transform: rotate(45deg) scale(0) translate(-50%, -50%);
  opacity: 0;
  transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6), opacity 0.1s;
  content: " ";
}

.ant-tree-checkbox-input {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  cursor: pointer;
  opacity: 0;
}

.ant-tree-checkbox-checked .ant-tree-checkbox-inner:after {
  position: absolute;
  display: table;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  transform: rotate(45deg) scale(1) translate(-50%, -50%);
  opacity: 1;
  transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
  content: " ";
}

.ant-tree-checkbox-checked .ant-tree-checkbox-inner {
  background-color: #1890ff;
  border-color: #1890ff;
}

.ant-tree-checkbox-disabled {
  cursor: not-allowed;
}

.ant-tree-checkbox-disabled.ant-tree-checkbox-checked .ant-tree-checkbox-inner:after {
  border-color: rgba(0, 0, 0, 0.25);
  animation-name: none;
}

.ant-tree-checkbox-disabled .ant-tree-checkbox-input {
  cursor: not-allowed;
  pointer-events: none;
}

.ant-tree-checkbox-disabled .ant-tree-checkbox-inner {
  background-color: #f5f5f5;
  border-color: #d9d9d9 !important;
}

.ant-tree-checkbox-disabled .ant-tree-checkbox-inner:after {
  border-color: #f5f5f5;
  border-collapse: separate;
  animation-name: none;
}

.ant-tree-checkbox-disabled + span {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ant-tree-checkbox-disabled:hover:after, .ant-tree-checkbox-wrapper:hover .ant-tree-checkbox-disabled:after {
  visibility: hidden;
}

.ant-tree-checkbox-wrapper {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  display: inline-flex;
  align-items: baseline;
  line-height: unset;
  cursor: pointer;
}

.ant-tree-checkbox-wrapper:after {
  display: inline-block;
  width: 0;
  overflow: hidden;
  content: " ";
}

.ant-tree-checkbox-wrapper.ant-tree-checkbox-wrapper-disabled {
  cursor: not-allowed;
}

.ant-tree-checkbox-wrapper + .ant-tree-checkbox-wrapper {
  margin-left: 8px;
}

.ant-tree-checkbox-wrapper.ant-tree-checkbox-wrapper-in-form-item input[type=checkbox] {
  width: 14px;
  height: 14px;
}

.ant-tree-checkbox + span {
  padding-right: 8px;
  padding-left: 8px;
}

.ant-tree-checkbox-group {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  display: inline-block;
}

.ant-tree-checkbox-group-item {
  margin-right: 8px;
}

.ant-tree-checkbox-group-item:last-child {
  margin-right: 0;
}

.ant-tree-checkbox-group-item + .ant-tree-checkbox-group-item {
  margin-left: 0;
}

.ant-tree-checkbox-indeterminate .ant-tree-checkbox-inner {
  background-color: #fff;
  border-color: #d9d9d9;
}

.ant-tree-checkbox-indeterminate .ant-tree-checkbox-inner:after {
  top: 50%;
  left: 50%;
  width: 8px;
  height: 8px;
  background-color: #1890ff;
  border: 0;
  transform: translate(-50%, -50%) scale(1);
  opacity: 1;
  content: " ";
}

.ant-tree-checkbox-indeterminate.ant-tree-checkbox-disabled .ant-tree-checkbox-inner:after {
  background-color: rgba(0, 0, 0, 0.25);
  border-color: rgba(0, 0, 0, 0.25);
}

.ant-tree {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  background: #fff;
  border-radius: 2px;
  transition: background-color 0.3s;
}

.ant-tree-focused:not(:hover):not(.ant-tree-active-focused) {
  background: #e6f7ff;
}

.ant-tree-list-holder-inner {
  align-items: flex-start;
}

.ant-tree.ant-tree-block-node .ant-tree-list-holder-inner {
  align-items: stretch;
}

.ant-tree.ant-tree-block-node .ant-tree-list-holder-inner .ant-tree-node-content-wrapper {
  flex: auto;
}

.ant-tree.ant-tree-block-node .ant-tree-list-holder-inner .ant-tree-treenode.dragging {
  position: relative;
}

.ant-tree.ant-tree-block-node .ant-tree-list-holder-inner .ant-tree-treenode.dragging:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 4px;
  left: 0;
  border: 1px solid #1890ff;
  opacity: 0;
  animation: ant-tree-node-fx-do-not-use 0.3s;
  animation-play-state: running;
  animation-fill-mode: forwards;
  content: "";
  pointer-events: none;
}

.ant-tree .ant-tree-treenode {
  display: flex;
  align-items: flex-start;
  padding: 0 0 4px;
  outline: none;
}

.ant-tree .ant-tree-treenode-disabled .ant-tree-node-content-wrapper {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ant-tree .ant-tree-treenode-disabled .ant-tree-node-content-wrapper:hover {
  background: transparent;
}

.ant-tree .ant-tree-treenode-active .ant-tree-node-content-wrapper {
  background: #f5f5f5;
}

.ant-tree .ant-tree-treenode:not(.ant-tree .ant-tree-treenode-disabled).filter-node .ant-tree-title {
  color: inherit;
  font-weight: 500;
}

.ant-tree .ant-tree-treenode-draggable .ant-tree-draggable-icon {
  width: 24px;
  line-height: 24px;
  text-align: center;
  visibility: visible;
  opacity: 0.2;
  transition: opacity 0.3s;
}

.ant-tree-treenode:hover .ant-tree .ant-tree-treenode-draggable .ant-tree-draggable-icon {
  opacity: 0.45;
}

.ant-tree .ant-tree-treenode-draggable.ant-tree-treenode-disabled .ant-tree-draggable-icon {
  visibility: hidden;
}

.ant-tree-indent {
  align-self: stretch;
  white-space: nowrap;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-tree-indent-unit {
  display: inline-block;
  width: 24px;
}

.ant-tree-draggable-icon {
  visibility: hidden;
}

.ant-tree-switcher {
  position: relative;
  flex: none;
  align-self: stretch;
  width: 24px;
  margin: 0;
  line-height: 24px;
  text-align: center;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-tree-switcher .ant-select-tree-switcher-icon, .ant-tree-switcher .ant-tree-switcher-icon {
  display: inline-block;
  font-size: 10px;
  vertical-align: baseline;
}

.ant-tree-switcher .ant-select-tree-switcher-icon svg, .ant-tree-switcher .ant-tree-switcher-icon svg {
  transition: transform 0.3s;
}

.ant-tree-switcher-noop {
  cursor: default;
}

.ant-tree-switcher_close .ant-tree-switcher-icon svg {
  transform: rotate(-90deg);
}

.ant-tree-switcher-loading-icon {
  color: #1890ff;
}

.ant-tree-switcher-leaf-line {
  position: relative;
  z-index: 1;
  display: inline-block;
  width: 100%;
  height: 100%;
}

.ant-tree-switcher-leaf-line:before {
  position: absolute;
  top: 0;
  right: 12px;
  bottom: -4px;
  margin-left: -1px;
  border-right: 1px solid #d9d9d9;
  content: " ";
}

.ant-tree-switcher-leaf-line:after {
  position: absolute;
  width: 10px;
  height: 14px;
  border-bottom: 1px solid #d9d9d9;
  content: " ";
}

.ant-tree-checkbox {
  top: auto;
  margin: 4px 8px 0 0;
}

.ant-tree .ant-tree-node-content-wrapper {
  position: relative;
  z-index: auto;
  min-height: 24px;
  margin: 0;
  padding: 0 4px;
  color: inherit;
  line-height: 24px;
  background: transparent;
  border-radius: 2px;
  cursor: pointer;
  transition: all 0.3s, border 0s, line-height 0s, box-shadow 0s;
}

.ant-tree .ant-tree-node-content-wrapper:hover {
  background-color: #f5f5f5;
}

.ant-tree .ant-tree-node-content-wrapper.ant-tree-node-selected {
  background-color: #bae7ff;
}

.ant-tree .ant-tree-node-content-wrapper .ant-tree-iconEle {
  display: inline-block;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  vertical-align: top;
}

.ant-tree .ant-tree-node-content-wrapper .ant-tree-iconEle:empty {
  display: none;
}

.ant-tree-unselectable .ant-tree-node-content-wrapper:hover {
  background-color: transparent;
}

.ant-tree-node-content-wrapper {
  line-height: 24px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-tree-node-content-wrapper .ant-tree-drop-indicator {
  position: absolute;
  z-index: 1;
  height: 2px;
  background-color: #1890ff;
  border-radius: 1px;
  pointer-events: none;
}

.ant-tree-node-content-wrapper .ant-tree-drop-indicator:after {
  position: absolute;
  top: -3px;
  left: -6px;
  width: 8px;
  height: 8px;
  background-color: transparent;
  border: 2px solid #1890ff;
  border-radius: 50%;
  content: "";
}

.ant-tree .ant-tree-treenode.drop-container > [draggable] {
  box-shadow: 0 0 0 2px #1890ff;
}

.ant-tree-show-line .ant-tree-indent-unit {
  position: relative;
  height: 100%;
}

.ant-tree-show-line .ant-tree-indent-unit:before {
  position: absolute;
  top: 0;
  right: 12px;
  bottom: -4px;
  border-right: 1px solid #d9d9d9;
  content: "";
}

.ant-tree-show-line .ant-tree-indent-unit-end:before {
  display: none;
}

.ant-tree-show-line .ant-tree-switcher {
  background: #fff;
}

.ant-tree-show-line .ant-tree-switcher-line-icon {
  vertical-align: -0.15em;
}

.ant-tree .ant-tree-treenode-leaf-last .ant-tree-switcher-leaf-line:before {
  top: auto !important;
  bottom: auto !important;
  height: 14px !important;
}

.ant-tree-rtl {
  direction: rtl;
}

.ant-tree-rtl .ant-tree-node-content-wrapper[draggable=true] .ant-tree-drop-indicator:after {
  right: -6px;
  left: unset;
}

.ant-tree .ant-tree-treenode-rtl {
  direction: rtl;
}

.ant-tree-rtl .ant-tree-switcher_close .ant-tree-switcher-icon svg {
  transform: rotate(90deg);
}

.ant-tree-rtl.ant-tree-show-line .ant-tree-indent-unit:before {
  right: auto;
  left: -13px;
  border-right: none;
  border-left: 1px solid #d9d9d9;
}

.ant-tree-rtl .ant-tree-checkbox, .ant-tree-select-dropdown-rtl .ant-select-tree-checkbox {
  margin: 4px 0 0 8px;
}

.ant-typography {
  color: rgba(0, 0, 0, 0.85);
  word-break: break-word;
}

.ant-typography.ant-typography-secondary {
  color: rgba(0, 0, 0, 0.45);
}

.ant-typography.ant-typography-success {
  color: #52c41a;
}

.ant-typography.ant-typography-warning {
  color: #faad14;
}

.ant-typography.ant-typography-danger {
  color: #ff4d4f;
}

a.ant-typography.ant-typography-danger:active, a.ant-typography.ant-typography-danger:focus {
  color: #d9363e;
}

a.ant-typography.ant-typography-danger:hover {
  color: #ff7875;
}

.ant-typography.ant-typography-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ant-typography p, div.ant-typography {
  margin-bottom: 1em;
}

.ant-typography h1, div.ant-typography-h1, div.ant-typography-h1 > textarea, h1.ant-typography {
  margin-bottom: 0.5em;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 600;
  font-size: 38px;
  line-height: 1.23;
}

.ant-typography h2, div.ant-typography-h2, div.ant-typography-h2 > textarea, h2.ant-typography {
  margin-bottom: 0.5em;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 600;
  font-size: 30px;
  line-height: 1.35;
}

.ant-typography h3, div.ant-typography-h3, div.ant-typography-h3 > textarea, h3.ant-typography {
  margin-bottom: 0.5em;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 600;
  font-size: 24px;
  line-height: 1.35;
}

.ant-typography h4, div.ant-typography-h4, div.ant-typography-h4 > textarea, h4.ant-typography {
  margin-bottom: 0.5em;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 600;
  font-size: 20px;
  line-height: 1.4;
}

.ant-typography h5, div.ant-typography-h5, div.ant-typography-h5 > textarea, h5.ant-typography {
  margin-bottom: 0.5em;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 600;
  font-size: 16px;
  line-height: 1.5;
}

.ant-typography + h1.ant-typography, .ant-typography + h2.ant-typography, .ant-typography + h3.ant-typography, .ant-typography + h4.ant-typography, .ant-typography + h5.ant-typography, .ant-typography div + h1, .ant-typography div + h2, .ant-typography div + h3, .ant-typography div + h4, .ant-typography div + h5, .ant-typography h1 + h1, .ant-typography h1 + h2, .ant-typography h1 + h3, .ant-typography h1 + h4, .ant-typography h1 + h5, .ant-typography h2 + h1, .ant-typography h2 + h2, .ant-typography h2 + h3, .ant-typography h2 + h4, .ant-typography h2 + h5, .ant-typography h3 + h1, .ant-typography h3 + h2, .ant-typography h3 + h3, .ant-typography h3 + h4, .ant-typography h3 + h5, .ant-typography h4 + h1, .ant-typography h4 + h2, .ant-typography h4 + h3, .ant-typography h4 + h4, .ant-typography h4 + h5, .ant-typography h5 + h1, .ant-typography h5 + h2, .ant-typography h5 + h3, .ant-typography h5 + h4, .ant-typography h5 + h5, .ant-typography li + h1, .ant-typography li + h2, .ant-typography li + h3, .ant-typography li + h4, .ant-typography li + h5, .ant-typography p + h1, .ant-typography p + h2, .ant-typography p + h3, .ant-typography p + h4, .ant-typography p + h5, .ant-typography ul + h1, .ant-typography ul + h2, .ant-typography ul + h3, .ant-typography ul + h4, .ant-typography ul + h5 {
  margin-top: 1.2em;
}

a.ant-typography-ellipsis, span.ant-typography-ellipsis {
  display: inline-block;
  max-width: 100%;
}

.ant-typography a, a.ant-typography {
  color: #1890ff;
  outline: none;
  cursor: pointer;
  transition: color 0.3s;
  text-decoration: none;
}

.ant-typography a:focus-visible, .ant-typography a:hover, a.ant-typography:focus-visible, a.ant-typography:hover {
  color: #40a9ff;
}

.ant-typography a:active, a.ant-typography:active {
  color: #096dd9;
}

.ant-typography a:active, .ant-typography a:hover, a.ant-typography:active, a.ant-typography:hover {
  text-decoration: none;
}

.ant-typography a.ant-typography-disabled, .ant-typography a[disabled], a.ant-typography.ant-typography-disabled, a.ant-typography[disabled] {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ant-typography a.ant-typography-disabled:active, .ant-typography a.ant-typography-disabled:hover, .ant-typography a[disabled]:active, .ant-typography a[disabled]:hover, a.ant-typography.ant-typography-disabled:active, a.ant-typography.ant-typography-disabled:hover, a.ant-typography[disabled]:active, a.ant-typography[disabled]:hover {
  color: rgba(0, 0, 0, 0.25);
}

.ant-typography a.ant-typography-disabled:active, .ant-typography a[disabled]:active, a.ant-typography.ant-typography-disabled:active, a.ant-typography[disabled]:active {
  pointer-events: none;
}

.ant-typography code {
  margin: 0 0.2em;
  padding: 0.2em 0.4em 0.1em;
  font-size: 85%;
  background: hsla(0, 0%, 58.8%, 0.1);
  border: 1px solid hsla(0, 0%, 39.2%, 0.2);
  border-radius: 3px;
}

.ant-typography kbd {
  margin: 0 0.2em;
  padding: 0.15em 0.4em 0.1em;
  font-size: 90%;
  background: hsla(0, 0%, 58.8%, 0.06);
  border: solid hsla(0, 0%, 39.2%, 0.2);
  border-width: 1px 1px 2px;
  border-radius: 3px;
}

.ant-typography mark {
  padding: 0;
  background-color: #ffe58f;
}

.ant-typography ins, .ant-typography u {
  text-decoration: underline;
  -webkit-text-decoration-skip: ink;
  text-decoration-skip-ink: auto;
}

.ant-typography del, .ant-typography s {
  text-decoration: line-through;
}

.ant-typography strong {
  font-weight: 600;
}

.ant-typography-copy, .ant-typography-edit, .ant-typography-expand {
  color: #1890ff;
  outline: none;
  cursor: pointer;
  transition: color 0.3s;
  margin-left: 4px;
}

.ant-typography-copy:focus-visible, .ant-typography-copy:hover, .ant-typography-edit:focus-visible, .ant-typography-edit:hover, .ant-typography-expand:focus-visible, .ant-typography-expand:hover {
  color: #40a9ff;
}

.ant-typography-copy:active, .ant-typography-edit:active, .ant-typography-expand:active {
  color: #096dd9;
}

.ant-typography-copy-success, .ant-typography-copy-success:focus, .ant-typography-copy-success:hover {
  color: #52c41a;
}

.ant-typography-edit-content {
  position: relative;
}

div.ant-typography-edit-content {
  left: -12px;
  margin-top: -5px;
  margin-bottom: calc(1em - 5px);
}

.ant-typography-edit-content-confirm {
  position: absolute;
  right: 10px;
  bottom: 8px;
  color: rgba(0, 0, 0, 0.45);
  font-weight: 400;
  font-size: 14px;
  font-style: normal;
  pointer-events: none;
}

.ant-typography-edit-content textarea {
  height: 1em;
  margin: 0 !important;
  -moz-transition: none;
}

.ant-typography ol, .ant-typography ul {
  margin: 0 0 1em;
  padding: 0;
}

.ant-typography ol li, .ant-typography ul li {
  margin: 0 0 0 20px;
  padding: 0 0 0 4px;
}

.ant-typography ul {
  list-style-type: circle;
}

.ant-typography ul ul {
  list-style-type: disc;
}

.ant-typography ol {
  list-style-type: decimal;
}

.ant-typography blockquote, .ant-typography pre {
  margin: 1em 0;
}

.ant-typography pre {
  padding: 0.4em 0.6em;
  white-space: pre-wrap;
  word-wrap: break-word;
  background: hsla(0, 0%, 58.8%, 0.1);
  border: 1px solid hsla(0, 0%, 39.2%, 0.2);
  border-radius: 3px;
}

.ant-typography pre code {
  display: inline;
  margin: 0;
  padding: 0;
  font-size: inherit;
  font-family: inherit;
  background: transparent;
  border: 0;
}

.ant-typography blockquote {
  padding: 0 0 0 0.6em;
  border-left: 4px solid hsla(0, 0%, 39.2%, 0.2);
  opacity: 0.85;
}

.ant-typography-single-line {
  white-space: nowrap;
}

.ant-typography-ellipsis-single-line {
  overflow: hidden;
  text-overflow: ellipsis;
}

a.ant-typography-ellipsis-single-line, span.ant-typography-ellipsis-single-line {
  vertical-align: bottom;
}

.ant-typography-ellipsis-multiple-line {
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 3;
  /*! autoprefixer: ignore next */
  -webkit-box-orient: vertical;
}

.ant-typography-rtl {
  direction: rtl;
}

.ant-typography-rtl .ant-typography-copy, .ant-typography-rtl .ant-typography-edit, .ant-typography-rtl .ant-typography-expand {
  margin-right: 4px;
  margin-left: 0;
}

.ant-typography-rtl .ant-typography-expand {
  float: left;
}

div.ant-typography-edit-content.ant-typography-rtl {
  right: -12px;
  left: auto;
}

.ant-typography-rtl .ant-typography-edit-content-confirm {
  right: auto;
  left: 10px;
}

.ant-typography-rtl.ant-typography ol li, .ant-typography-rtl.ant-typography ul li {
  margin: 0 20px 0 0;
  padding: 0 4px 0 0;
}

.ant-upload {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  outline: 0;
}

.ant-upload p {
  margin: 0;
}

.ant-upload-btn {
  display: block;
  width: 100%;
  outline: none;
}

.ant-upload input[type=file] {
  cursor: pointer;
}

.ant-upload.ant-upload-select {
  display: inline-block;
}

.ant-upload.ant-upload-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ant-upload.ant-upload-select-picture-card {
  width: 104px;
  height: 104px;
  margin-right: 8px;
  margin-bottom: 8px;
  text-align: center;
  vertical-align: top;
  background-color: #fafafa;
  border: 1px dashed #d9d9d9;
  border-radius: 2px;
  cursor: pointer;
  transition: border-color 0.3s;
}

.ant-upload.ant-upload-select-picture-card > .ant-upload {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
}

.ant-upload.ant-upload-select-picture-card:hover {
  border-color: #1890ff;
}

.ant-upload-disabled.ant-upload.ant-upload-select-picture-card:hover {
  border-color: #d9d9d9;
}

.ant-upload.ant-upload-drag {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  background: #fafafa;
  border: 1px dashed #d9d9d9;
  border-radius: 2px;
  cursor: pointer;
  transition: border-color 0.3s;
}

.ant-upload.ant-upload-drag .ant-upload {
  padding: 16px 0;
}

.ant-upload.ant-upload-drag.ant-upload-drag-hover:not(.ant-upload-disabled) {
  border-color: #096dd9;
}

.ant-upload.ant-upload-drag.ant-upload-disabled {
  cursor: not-allowed;
}

.ant-upload.ant-upload-drag .ant-upload-btn {
  display: table;
  height: 100%;
}

.ant-upload.ant-upload-drag .ant-upload-drag-container {
  display: table-cell;
  vertical-align: middle;
}

.ant-upload.ant-upload-drag:not(.ant-upload-disabled):hover {
  border-color: #40a9ff;
}

.ant-upload.ant-upload-drag p.ant-upload-drag-icon {
  margin-bottom: 20px;
}

.ant-upload.ant-upload-drag p.ant-upload-drag-icon .anticon {
  color: #40a9ff;
  font-size: 48px;
}

.ant-upload.ant-upload-drag p.ant-upload-text {
  margin: 0 0 4px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 16px;
}

.ant-upload.ant-upload-drag p.ant-upload-hint {
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
}

.ant-upload.ant-upload-drag .anticon-plus {
  color: rgba(0, 0, 0, 0.25);
  font-size: 30px;
  transition: all 0.3s;
}

.ant-upload.ant-upload-drag .anticon-plus:hover, .ant-upload.ant-upload-drag:hover .anticon-plus {
  color: rgba(0, 0, 0, 0.45);
}

.ant-upload-picture-card-wrapper {
  display: inline-block;
  width: 100%;
}

.ant-upload-picture-card-wrapper:before {
  display: table;
  content: "";
}

.ant-upload-picture-card-wrapper:after {
  display: table;
  clear: both;
  content: "";
}

.ant-upload-list {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: "tnum";
  line-height: 1.5715;
}

.ant-upload-list:after, .ant-upload-list:before {
  display: table;
  content: "";
}

.ant-upload-list:after {
  clear: both;
}

.ant-upload-list-item {
  position: relative;
  height: 22.001px;
  margin-top: 8px;
  font-size: 14px;
}

.ant-upload-list-item-name {
  display: inline-block;
  width: 100%;
  padding-left: 22px;
  overflow: hidden;
  line-height: 1.5715;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ant-upload-list-item-card-actions {
  position: absolute;
  right: 0;
}

.ant-upload-list-item-card-actions-btn {
  opacity: 0;
}

.ant-upload-list-item-card-actions-btn.ant-btn-sm {
  height: 22.001px;
  line-height: 1;
  vertical-align: top;
}

.ant-upload-list-item-card-actions.picture {
  top: 22px;
  line-height: 0;
}

.ant-upload-list-item-card-actions-btn:focus, .ant-upload-list-item-card-actions.picture .ant-upload-list-item-card-actions-btn {
  opacity: 1;
}

.ant-upload-list-item-card-actions .anticon {
  color: rgba(0, 0, 0, 0.45);
  transition: all 0.3s;
}

.ant-upload-list-item-card-actions:hover .anticon {
  color: rgba(0, 0, 0, 0.85);
}

.ant-upload-list-item-info {
  height: 100%;
  transition: background-color 0.3s;
}

.ant-upload-list-item-info > span {
  display: block;
  width: 100%;
  height: 100%;
}

.ant-upload-list-item-info .ant-upload-text-icon .anticon, .ant-upload-list-item-info .anticon-loading .anticon {
  position: absolute;
  top: 5px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
}

.ant-upload-list-item:hover .ant-upload-list-item-info {
  background-color: #f5f5f5;
}

.ant-upload-list-item:hover .ant-upload-list-item-card-actions-btn {
  opacity: 1;
}

.ant-upload-list-item-error, .ant-upload-list-item-error .ant-upload-list-item-card-actions .anticon, .ant-upload-list-item-error .ant-upload-list-item-name, .ant-upload-list-item-error .ant-upload-text-icon > .anticon {
  color: #ff4d4f;
}

.ant-upload-list-item-error .ant-upload-list-item-card-actions-btn {
  opacity: 1;
}

.ant-upload-list-item-progress {
  position: absolute;
  bottom: -12px;
  width: 100%;
  padding-left: 26px;
  font-size: 14px;
  line-height: 0;
}

.ant-upload-list-picture-card .ant-upload-list-item, .ant-upload-list-picture .ant-upload-list-item {
  position: relative;
  height: 66px;
  padding: 8px;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
}

.ant-upload-list-picture-card .ant-upload-list-item:hover, .ant-upload-list-picture .ant-upload-list-item:hover {
  background: transparent;
}

.ant-upload-list-picture-card .ant-upload-list-item-error, .ant-upload-list-picture .ant-upload-list-item-error {
  border-color: #ff4d4f;
}

.ant-upload-list-picture-card .ant-upload-list-item:hover .ant-upload-list-item-info, .ant-upload-list-picture .ant-upload-list-item:hover .ant-upload-list-item-info {
  background: transparent;
}

.ant-upload-list-picture-card .ant-upload-list-item-uploading, .ant-upload-list-picture .ant-upload-list-item-uploading {
  border-style: dashed;
}

.ant-upload-list-picture-card .ant-upload-list-item-thumbnail, .ant-upload-list-picture .ant-upload-list-item-thumbnail {
  width: 48px;
  height: 48px;
  line-height: 60px;
  text-align: center;
  opacity: 0.8;
}

.ant-upload-list-picture-card .ant-upload-list-item-thumbnail .anticon, .ant-upload-list-picture .ant-upload-list-item-thumbnail .anticon {
  font-size: 26px;
}

.ant-upload-list-picture-card .ant-upload-list-item-error .ant-upload-list-item-thumbnail .anticon svg path[fill="#e6f7ff"], .ant-upload-list-picture .ant-upload-list-item-error .ant-upload-list-item-thumbnail .anticon svg path[fill="#e6f7ff"] {
  fill: #fff2f0;
}

.ant-upload-list-picture-card .ant-upload-list-item-error .ant-upload-list-item-thumbnail .anticon svg path[fill="#1890ff"], .ant-upload-list-picture .ant-upload-list-item-error .ant-upload-list-item-thumbnail .anticon svg path[fill="#1890ff"] {
  fill: #ff4d4f;
}

.ant-upload-list-picture-card .ant-upload-list-item-icon, .ant-upload-list-picture .ant-upload-list-item-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  font-size: 26px;
  transform: translate(-50%, -50%);
}

.ant-upload-list-picture-card .ant-upload-list-item-icon .anticon, .ant-upload-list-picture .ant-upload-list-item-icon .anticon {
  font-size: 26px;
}

.ant-upload-list-picture-card .ant-upload-list-item-image, .ant-upload-list-picture .ant-upload-list-item-image {
  max-width: 100%;
}

.ant-upload-list-picture-card .ant-upload-list-item-thumbnail img, .ant-upload-list-picture .ant-upload-list-item-thumbnail img {
  display: block;
  width: 48px;
  height: 48px;
  overflow: hidden;
}

.ant-upload-list-picture-card .ant-upload-list-item-name, .ant-upload-list-picture .ant-upload-list-item-name {
  display: inline-block;
  box-sizing: border-box;
  max-width: 100%;
  margin: 0 0 0 8px;
  padding-right: 8px;
  padding-left: 48px;
  overflow: hidden;
  line-height: 44px;
  white-space: nowrap;
  text-overflow: ellipsis;
  transition: all 0.3s;
}

.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-name, .ant-upload-list-picture .ant-upload-list-item-uploading .ant-upload-list-item-name {
  margin-bottom: 12px;
}

.ant-upload-list-picture-card .ant-upload-list-item-progress, .ant-upload-list-picture .ant-upload-list-item-progress {
  bottom: 14px;
  width: calc(100% - 24px);
  margin-top: 0;
  padding-left: 56px;
}

.ant-upload-list-picture-card-container {
  display: inline-block;
  width: 104px;
  height: 104px;
  margin: 0 8px 8px 0;
  vertical-align: top;
}

.ant-upload-list-picture-card .ant-upload-list-item {
  height: 100%;
  margin: 0;
}

.ant-upload-list-picture-card .ant-upload-list-item-info {
  position: relative;
  height: 100%;
  overflow: hidden;
}

.ant-upload-list-picture-card .ant-upload-list-item-info:before {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: all 0.3s;
  content: " ";
}

.ant-upload-list-picture-card .ant-upload-list-item:hover .ant-upload-list-item-info:before {
  opacity: 1;
}

.ant-upload-list-picture-card .ant-upload-list-item-actions {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 10;
  white-space: nowrap;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: all 0.3s;
}

.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-delete, .ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-download, .ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-eye {
  z-index: 10;
  width: 16px;
  margin: 0 4px;
  color: hsla(0, 0%, 100%, 0.85);
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;
}

.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-delete:hover, .ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-download:hover, .ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-eye:hover {
  color: #fff;
}

.ant-upload-list-picture-card .ant-upload-list-item-actions:hover, .ant-upload-list-picture-card .ant-upload-list-item-info:hover + .ant-upload-list-item-actions {
  opacity: 1;
}

.ant-upload-list-picture-card .ant-upload-list-item-thumbnail, .ant-upload-list-picture-card .ant-upload-list-item-thumbnail img {
  position: static;
  display: block;
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
  object-fit: contain;
}

.ant-upload-list-picture-card .ant-upload-list-item-name {
  display: none;
  margin: 8px 0 0;
  padding: 0;
  line-height: 1.5715;
  text-align: center;
}

.ant-upload-list-picture-card .ant-upload-list-item-file + .ant-upload-list-item-name {
  position: absolute;
  bottom: 10px;
  display: block;
}

.ant-upload-list-picture-card .ant-upload-list-item-uploading.ant-upload-list-item {
  background-color: #fafafa;
}

.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-info {
  height: auto;
}

.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-info .anticon-delete, .ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-info .anticon-eye, .ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-info:before {
  display: none;
}

.ant-upload-list-picture-card .ant-upload-list-item-progress {
  bottom: 32px;
  width: calc(100% - 14px);
  padding-left: 0;
}

.ant-upload-list-picture-container, .ant-upload-list-text-container {
  transition: opacity 0.3s, height 0.3s;
}

.ant-upload-list-picture-container:before, .ant-upload-list-text-container:before {
  display: table;
  width: 0;
  height: 0;
  content: "";
}

.ant-upload-list-picture-container .ant-upload-span, .ant-upload-list-text-container .ant-upload-span {
  display: block;
  flex: auto;
}

.ant-upload-list-picture .ant-upload-span, .ant-upload-list-text .ant-upload-span {
  display: flex;
  align-items: center;
}

.ant-upload-list-picture .ant-upload-span > *, .ant-upload-list-text .ant-upload-span > * {
  flex: none;
}

.ant-upload-list-picture .ant-upload-list-item-name, .ant-upload-list-text .ant-upload-list-item-name {
  flex: auto;
  margin: 0;
  padding: 0 8px;
}

.ant-upload-list-picture .ant-upload-list-item-card-actions, .ant-upload-list-text .ant-upload-list-item-card-actions, .ant-upload-list-text .ant-upload-text-icon .anticon {
  position: static;
}

.ant-upload-list .ant-upload-animate-inline-appear, .ant-upload-list .ant-upload-animate-inline-enter, .ant-upload-list .ant-upload-animate-inline-leave {
  animation-duration: 0.3s;
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
  animation-fill-mode: forwards;
}

.ant-upload-list .ant-upload-animate-inline-appear, .ant-upload-list .ant-upload-animate-inline-enter {
  animation-name: uploadAnimateInlineIn;
}

.ant-upload-list .ant-upload-animate-inline-leave {
  animation-name: uploadAnimateInlineOut;
}

@keyframes uploadAnimateInlineIn {
  0% {
    width: 0;
    height: 0;
    margin: 0;
    padding: 0;
    opacity: 0;
  }
}
@keyframes uploadAnimateInlineOut {
  to {
    width: 0;
    height: 0;
    margin: 0;
    padding: 0;
    opacity: 0;
  }
}
.ant-upload-rtl {
  direction: rtl;
}

.ant-upload-rtl.ant-upload.ant-upload-select-picture-card {
  margin-right: auto;
  margin-left: 8px;
}

.ant-upload-list-rtl {
  direction: rtl;
}

.ant-upload-list-rtl .ant-upload-list-item-list-type-text:hover .ant-upload-list-item-name-icon-count-1 {
  padding-right: 22px;
  padding-left: 14px;
}

.ant-upload-list-rtl .ant-upload-list-item-list-type-text:hover .ant-upload-list-item-name-icon-count-2 {
  padding-right: 22px;
  padding-left: 28px;
}

.ant-upload-list-rtl .ant-upload-list-item-name {
  padding-right: 22px;
  padding-left: 0;
}

.ant-upload-list-rtl .ant-upload-list-item-name-icon-count-1 {
  padding-left: 14px;
}

.ant-upload-list-rtl .ant-upload-list-item-card-actions {
  right: auto;
  left: 0;
}

.ant-upload-list-rtl .ant-upload-list-item-card-actions .anticon {
  padding-right: 0;
  padding-left: 5px;
}

.ant-upload-list-rtl .ant-upload-list-item-info {
  padding: 0 4px 0 12px;
}

.ant-upload-list-rtl .ant-upload-list-item-error .ant-upload-list-item-card-actions .anticon {
  padding-right: 0;
  padding-left: 5px;
}

.ant-upload-list-rtl .ant-upload-list-item-progress {
  padding-right: 26px;
  padding-left: 0;
}

.ant-upload-list-picture-card .ant-upload-list-item-info, .ant-upload-list-picture .ant-upload-list-item-info {
  padding: 0;
}

.ant-upload-list-rtl.ant-upload-list-picture-card .ant-upload-list-item-thumbnail, .ant-upload-list-rtl.ant-upload-list-picture .ant-upload-list-item-thumbnail {
  right: 8px;
  left: auto;
}

.ant-upload-list-rtl.ant-upload-list-picture-card .ant-upload-list-item-icon, .ant-upload-list-rtl.ant-upload-list-picture .ant-upload-list-item-icon {
  right: 50%;
  left: auto;
  transform: translate(50%, -50%);
}

.ant-upload-list-rtl.ant-upload-list-picture-card .ant-upload-list-item-name, .ant-upload-list-rtl.ant-upload-list-picture .ant-upload-list-item-name {
  margin: 0 8px 0 0;
  padding-right: 48px;
  padding-left: 8px;
}

.ant-upload-list-rtl.ant-upload-list-picture-card .ant-upload-list-item-name-icon-count-1, .ant-upload-list-rtl.ant-upload-list-picture .ant-upload-list-item-name-icon-count-1 {
  padding-right: 48px;
  padding-left: 18px;
}

.ant-upload-list-rtl.ant-upload-list-picture-card .ant-upload-list-item-name-icon-count-2, .ant-upload-list-rtl.ant-upload-list-picture .ant-upload-list-item-name-icon-count-2 {
  padding-right: 48px;
  padding-left: 36px;
}

.ant-upload-list-rtl.ant-upload-list-picture-card .ant-upload-list-item-progress, .ant-upload-list-rtl.ant-upload-list-picture .ant-upload-list-item-progress {
  padding-right: 0;
  padding-left: 0;
}

.ant-upload-list-rtl .ant-upload-list-picture-card-container {
  margin: 0 0 8px 8px;
}

.ant-upload-list-rtl.ant-upload-list-picture-card .ant-upload-list-item-actions {
  right: 50%;
  left: auto;
  transform: translate(50%, -50%);
}

.ant-upload-list-rtl.ant-upload-list-picture-card .ant-upload-list-item-file + .ant-upload-list-item-name {
  margin: 8px 0 0;
  padding: 0;
}


*,
*::before,
*::after {
  box-sizing: inherit;
}

#application-manger-ui-root {
  box-sizing: border-box;
  font-family: "Open Sans", sans-serif !important;
  background-color: #f0f3f7;
  min-height: 100vh;
  margin: 0;
  font-size: 16px;
  line-height: 1.5;
  scroll-behavior: smooth;
  text-rendering: optimizeSpeed;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: transparent;
}

/*** ================= FUNCTIONS ================= ***/
/*

This .scss loop will create "margin helpers" and "padding helpers" 
It will generate several classes such as:
.m-r-10 which gives margin-right 10 pixels.
.m-r-15 gives MARGIN to the RIGHT 15 pixels.
.m-t-15 gives MARGIN to the TOP 15 pixels and so on.
.p-b-5 gives PADDING to the BOTTOM of 5 pixels
.p-l-40 gives PADDING to the LEFT of 40 pixels
The first letter is "m" or "p" for MARGIN or PADDING
Second letter is "t", "b", "l", or "r" for TOP, BOTTOM, LEFT, or RIGHT
Third letter is the number of spacing in pixels. Adjust the amounts generated by editing the \$spaceamounts variable below.

*/
.m-t-5 {
  margin-top: 5px !important;
}

.p-t-5 {
  padding-top: 5px !important;
}

.m-b-5 {
  margin-bottom: 5px !important;
}

.p-b-5 {
  padding-bottom: 5px !important;
}

.m-l-5 {
  margin-left: 5px !important;
}

.p-l-5 {
  padding-left: 5px !important;
}

.m-r-5 {
  margin-right: 5px !important;
}

.p-r-5 {
  padding-right: 5px !important;
}

.m-t-10 {
  margin-top: 10px !important;
}

.p-t-10 {
  padding-top: 10px !important;
}

.m-b-10 {
  margin-bottom: 10px !important;
}

.p-b-10 {
  padding-bottom: 10px !important;
}

.m-l-10 {
  margin-left: 10px !important;
}

.p-l-10 {
  padding-left: 10px !important;
}

.m-r-10 {
  margin-right: 10px !important;
}

.p-r-10 {
  padding-right: 10px !important;
}

.m-t-15 {
  margin-top: 15px !important;
}

.p-t-15 {
  padding-top: 15px !important;
}

.m-b-15 {
  margin-bottom: 15px !important;
}

.p-b-15 {
  padding-bottom: 15px !important;
}

.m-l-15 {
  margin-left: 15px !important;
}

.p-l-15 {
  padding-left: 15px !important;
}

.m-r-15 {
  margin-right: 15px !important;
}

.p-r-15 {
  padding-right: 15px !important;
}

.m-t-20 {
  margin-top: 20px !important;
}

.p-t-20 {
  padding-top: 20px !important;
}

.m-b-20 {
  margin-bottom: 20px !important;
}

.p-b-20 {
  padding-bottom: 20px !important;
}

.m-l-20 {
  margin-left: 20px !important;
}

.p-l-20 {
  padding-left: 20px !important;
}

.m-r-20 {
  margin-right: 20px !important;
}

.p-r-20 {
  padding-right: 20px !important;
}

.m-t-25 {
  margin-top: 25px !important;
}

.p-t-25 {
  padding-top: 25px !important;
}

.m-b-25 {
  margin-bottom: 25px !important;
}

.p-b-25 {
  padding-bottom: 25px !important;
}

.m-l-25 {
  margin-left: 25px !important;
}

.p-l-25 {
  padding-left: 25px !important;
}

.m-r-25 {
  margin-right: 25px !important;
}

.p-r-25 {
  padding-right: 25px !important;
}

.m-t-30 {
  margin-top: 30px !important;
}

.p-t-30 {
  padding-top: 30px !important;
}

.m-b-30 {
  margin-bottom: 30px !important;
}

.p-b-30 {
  padding-bottom: 30px !important;
}

.m-l-30 {
  margin-left: 30px !important;
}

.p-l-30 {
  padding-left: 30px !important;
}

.m-r-30 {
  margin-right: 30px !important;
}

.p-r-30 {
  padding-right: 30px !important;
}

.m-t-35 {
  margin-top: 35px !important;
}

.p-t-35 {
  padding-top: 35px !important;
}

.m-b-35 {
  margin-bottom: 35px !important;
}

.p-b-35 {
  padding-bottom: 35px !important;
}

.m-l-35 {
  margin-left: 35px !important;
}

.p-l-35 {
  padding-left: 35px !important;
}

.m-r-35 {
  margin-right: 35px !important;
}

.p-r-35 {
  padding-right: 35px !important;
}

.m-t-40 {
  margin-top: 40px !important;
}

.p-t-40 {
  padding-top: 40px !important;
}

.m-b-40 {
  margin-bottom: 40px !important;
}

.p-b-40 {
  padding-bottom: 40px !important;
}

.m-l-40 {
  margin-left: 40px !important;
}

.p-l-40 {
  padding-left: 40px !important;
}

.m-r-40 {
  margin-right: 40px !important;
}

.p-r-40 {
  padding-right: 40px !important;
}

.m-t-45 {
  margin-top: 45px !important;
}

.p-t-45 {
  padding-top: 45px !important;
}

.m-b-45 {
  margin-bottom: 45px !important;
}

.p-b-45 {
  padding-bottom: 45px !important;
}

.m-l-45 {
  margin-left: 45px !important;
}

.p-l-45 {
  padding-left: 45px !important;
}

.m-r-45 {
  margin-right: 45px !important;
}

.p-r-45 {
  padding-right: 45px !important;
}

.m-t-50 {
  margin-top: 50px !important;
}

.p-t-50 {
  padding-top: 50px !important;
}

.m-b-50 {
  margin-bottom: 50px !important;
}

.p-b-50 {
  padding-bottom: 50px !important;
}

.m-l-50 {
  margin-left: 50px !important;
}

.p-l-50 {
  padding-left: 50px !important;
}

.m-r-50 {
  margin-right: 50px !important;
}

.p-r-50 {
  padding-right: 50px !important;
}

.m-t-75 {
  margin-top: 75px !important;
}

.p-t-75 {
  padding-top: 75px !important;
}

.m-b-75 {
  margin-bottom: 75px !important;
}

.p-b-75 {
  padding-bottom: 75px !important;
}

.m-l-75 {
  margin-left: 75px !important;
}

.p-l-75 {
  padding-left: 75px !important;
}

.m-r-75 {
  margin-right: 75px !important;
}

.p-r-75 {
  padding-right: 75px !important;
}

.m-t-100 {
  margin-top: 100px !important;
}

.p-t-100 {
  padding-top: 100px !important;
}

.m-b-100 {
  margin-bottom: 100px !important;
}

.p-b-100 {
  padding-bottom: 100px !important;
}

.m-l-100 {
  margin-left: 100px !important;
}

.p-l-100 {
  padding-left: 100px !important;
}

.m-r-100 {
  margin-right: 100px !important;
}

.p-r-100 {
  padding-right: 100px !important;
}

/* if you want it for all sides like m-10 p-10 */
.m-5 {
  margin: 5px !important;
}

.p-5 {
  padding: 5px !important;
}

.m-10 {
  margin: 10px !important;
}

.p-10 {
  padding: 10px !important;
}

.m-15 {
  margin: 15px !important;
}

.p-15 {
  padding: 15px !important;
}

.m-20 {
  margin: 20px !important;
}

.p-20 {
  padding: 20px !important;
}

.m-25 {
  margin: 25px !important;
}

.p-25 {
  padding: 25px !important;
}

.m-30 {
  margin: 30px !important;
}

.p-30 {
  padding: 30px !important;
}

.m-35 {
  margin: 35px !important;
}

.p-35 {
  padding: 35px !important;
}

.m-40 {
  margin: 40px !important;
}

.p-40 {
  padding: 40px !important;
}

.m-45 {
  margin: 45px !important;
}

.p-45 {
  padding: 45px !important;
}

.m-50 {
  margin: 50px !important;
}

.p-50 {
  padding: 50px !important;
}

.m-75 {
  margin: 75px !important;
}

.p-75 {
  padding: 75px !important;
}

.m-100 {
  margin: 100px !important;
}

.p-100 {
  padding: 100px !important;
}

/*** ================= FUNCTIONS ENDS ================= ***/
.page-title {
  padding-left: 40px;
}

.data-import-header {
  border-top: 1px solid #c6c6c6;
  width: 100%;
}
.data-import-header-not-selected {
  display: flex;
  border-width: 5px;
}
.data-import-header-not-selected button {
  height: 48px;
  width: 180px;
  background: linear-gradient(180deg, #ffb65a 0%, #ffb65a 0%, #fe9527 100%);
}
.data-import-header-not-selected-label {
  width: calc(100% - 180px);
  padding: 10px 20px;
}
.data-import-header-not-selected-label span {
  color: #8c8c8c;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  letter-spacing: 0.16px;
}
.data-import-header-selected {
  display: flex;
  height: 48px;
  width: 100%;
  background: linear-gradient(180deg, #0f2757 0%, #0a2251 0%, #091734 100%);
}
.data-import-header-selected-label {
  padding: 10px 20px;
  height: 18px;
  width: calc(100% - 460px);
  color: #fff;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  letter-spacing: 0.16px;
  line-height: 18px;
}
.data-import-header-selected button {
  height: 48px;
  width: 115px;
  background: linear-gradient(180deg, #0f2757 0%, #0a2251 0%, #091734 100%);
  color: #fff;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
}
.data-import .new-data-import-btn {
  color: #000;
  background-image: linear-gradient(180deg, rgb(255, 182, 90) 0%, #ffa53c 100%);
  font-size: 16px;
  line-height: 24px;
}

.lor-tooltip {
  padding: 3px;
}
.lor-tooltip h4 {
  color: white;
  font-weight: bold;
}
.lor-tooltip .lor-stats {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 2px;
}

.ant-tooltip .ant-tooltip-content {
  width: 250px;
}

.ant-tooltip-inner {
  color: whitesmoke;
  background-color: #3a3b3d;
}

.lor-text {
  border-bottom: 1px dashed #272728;
}

.ant-tooltip-arrow-content {
  background-color: #3a3b3d;
}

.mainPerformTimeWrapper {
  background-color: #fff;
  padding: 20px;
}
.mainPerformTimeWrapper .pagepara {
  color: #272728;
  font-family: "IBM Plex Sans";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 22px;
  margin: 0;
}
.mainPerformTimeWrapper .labelName {
  color: #171717;
  font-family: "IBM Plex Sans";
  font-size: 20px;
  letter-spacing: 0;
  line-height: 26px;
  margin: 20px 0 20px 0;
  display: inline-block;
}
.mainPerformTimeWrapper .mainSelectRow {
  margin-bottom: 20px;
}
.mainPerformTimeWrapper .selectLabel {
  color: #515152;
  font-family: "IBM Plex Sans";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 20px;
  margin-bottom: 5px;
}
.mainPerformTimeWrapper .subSections > .subSection {
  padding: 30px 0px;
}
.mainPerformTimeWrapper .subSections > .subSection:first-child {
  padding-top: 0px;
}
.mainPerformTimeWrapper .subSections > .subSection:last-child {
  padding-bottom: 0px;
}

.mainConfigSection {
  height: 100vh;
}
.mainConfigSection .mainPerformTimeWrapper {
  margin: 0px 30px;
  padding: 30px 20px;
}
.mainConfigSection .mainPerformTimeWrapper .configLink {
  color: #3b7bc6;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 19px;
}
.mainConfigSection .mainPerformTimeWrapper .configText {
  color: #2d2d2d;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 20px;
}
.mainConfigSection .mainPerformTimeWrapper .updateTime {
  color: #2d2d2d;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 20px;
}

textarea.ant-input,
.drawerInput {
  background-color: #edeff5;
  border: transparent;
  padding: 5px 11px;
  border-bottom: 1px solid #8e8e90;
  font-family: "IBM Plex Sans";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 22px;
  width: 100%;
  margin-top: 5px;
}
textarea.ant-input:hover, textarea.ant-input:focus,
.drawerInput:hover,
.drawerInput:focus {
  border-bottom: 1px solid #8e8e90;
  box-shadow: none;
  outline: none;
}
textarea.ant-input::placeholder,
.drawerInput::placeholder {
  color: #a2a2a4;
}

.loading_container {
  text-align: center;
  margin: 50px 0px 20px 0px;
}

.validation-error-message {
  display: flex;
  align-items: flex-start;
  margin-top: 4px;
}
.validation-error-message svg {
  width: 25px !important;
}
.validation-error-message span {
  margin-top: -4px;
  color: red;
}

.main-content {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.new-data-import .main-header-sec {
  padding-top: 0;
  padding-right: 30px;
}
.new-data-import .btnsSection {
  padding: 30px 0;
}
.new-data-import .section {
  margin-top: 20px;
}
.new-data-import .section .labelName {
  color: #171717;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  letter-spacing: 0.16px;
  line-height: 18px;
}
.new-data-import .section .uploadPara {
  color: rgba(0, 0, 0, 0.87);
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
}
.new-data-import .section .uploadPara span {
  display: block;
}
.new-data-import .section strong {
  color: rgba(0, 0, 0, 0.87);
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  font-style: italic;
  letter-spacing: 0;
  line-height: 22px;
}
.new-data-import .section strong a {
  color: #141497;
  text-decoration: underline;
}
.new-data-import .section .uploadHeading {
  color: #171717;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 22px;
  padding: 15px 0 3px 0;
}
.new-data-import .section .uploadcont {
  color: #515152;
  font-family: "IBM Plex Sans";
  font-size: 14px;
  letter-spacing: 0;
  line-height: 18px;
}
.new-data-import .section .uploadSection {
  padding: 0px 12px;
}
.new-data-import .section .infoHeading {
  padding: 8px 0;
  margin: 0px;
  font-size: 18px;
  font-weight: bold;
}
.new-data-import .section .radioValue {
  padding-left: 10px;
}
.new-data-import .section .radioValue .radio-item {
  display: inline-block;
  margin-bottom: 12px;
}
.new-data-import .section .radioImport {
  padding-left: 10px;
}
.new-data-import .section .fileUploadbtn {
  padding-top: 15px;
}
.new-data-import .section .fileUploadbtn button {
  background: linear-gradient(180deg, #2626e3 0%, #141497 100%);
  border: none;
  border-radius: 4px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  -ms-border-radius: 4px;
  -o-border-radius: 4px;
  color: #fff;
  font-family: "IBM Plex Sans";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 20px;
  cursor: pointer;
  padding: 5px 10px;
}
.new-data-import .section .fileUploadbtn button:focus {
  outline: none;
}
.new-data-import .imprtRules .ant-checkbox-wrapper {
  padding-left: 10px;
  line-height: 28px;
}
.new-data-import .imprtRules .checkbox .ant-checkbox .ant-checkbox-inner {
  border-color: #000;
}
.new-data-import .imprtRules .checkbox .ant-checkbox-checked .ant-checkbox-inner {
  background-image: none;
  background-color: #000;
}
.new-data-import .mainUploadFileSection {
  background: #ededfd;
  margin-top: 30px;
  margin-bottom: 20px;
  padding: 15px 20px 25px 20px;
}
.new-data-import .ant-divider-horizontal {
  margin: 0 0 12px 0;
  border-top: 2px solid #c6c6c6;
}
.new-data-import .main-header-sec {
  padding-right: 30px;
}
.new-data-import .mainWhitebgWrapper {
  background: #fff;
  padding: 25px 20px 0px 30px;
  margin: 0 30px 30px 30px;
}
.new-data-import .mainWhitebgWrapper .ant-select-selector {
  background-color: #edeff5;
  border: transparent;
  padding: 5px 11px;
  height: 40px;
  border-bottom: 1px solid #000;
  border-radius: 0px 0px 0px 0px;
  -webkit-border-radius: 0px 0px 0px 0px;
  -moz-border-radius: 0px 0px 0px 0px;
  -ms-border-radius: 0px 0px 0px 0px;
  -o-border-radius: 0px 0px 0px 0px;
}
.new-data-import .mainWhitebgWrapper .ant-select-arrow {
  color: #141497;
}
.new-data-import .mainWhitebgWrapper .ant-select-arrow .anticon-down {
  vertical-align: middle;
}
.new-data-import .mainWhitebgWrapper .ant-select-arrow .anticon-down svg {
  transform: scale(1.3, 1);
  height: 10px;
  width: 14px;
}
.new-data-import .mainWhitebgWrapper .ant-select-selection-placeholder {
  color: #666666;
}
.new-data-import .mainWhitebgWrapper .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {
  box-shadow: none;
  outline: none;
}
.new-data-import .mainWhitebgWrapper .ant-select:hover .ant-select-selector, .new-data-import .mainWhitebgWrapper .ant-select:focus .ant-select-selector {
  border-color: #000;
}
.new-data-import .mainWhitebgWrapper .pageTitle {
  color: #2d2d2d;
  font-family: "Open Sans", sans-serif;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0.45px;
  line-height: 22px;
}
.new-data-import .text-input {
  outline: none;
  border: none;
  background-color: #edeff5;
  padding: 9px 10px 9px 10px;
  margin-top: 5px;
  width: 100%;
  max-width: 100%;
}
.new-data-import .text-input::placeholder {
  color: #666666;
}
.new-data-import .select {
  padding-top: 5px;
  width: 100%;
}
.new-data-import .mainDataImportTable table thead tr th {
  padding: 15px 12px 8px 12px;
  width: 50px;
}
.new-data-import .mainDataImportTable table thead tr th:nth-child(3), .new-data-import .mainDataImportTable table thead tr th:nth-child(4) {
  width: 245px;
}
.new-data-import .mainDataImportTable table thead tr th:nth-child(5) {
  width: 70px;
}
.new-data-import .mainDataImportTable table thead tr th:nth-child(6) {
  width: 102px;
}
.new-data-import .mainDataImportTable table thead tr th:nth-child(7) {
  width: 330px;
}
.new-data-import .mainDataImportTable table thead tr th:nth-child(8) {
  width: 60px;
}
.new-data-import .mainDataImportTable table thead tr th:nth-child(9) {
  width: 80px;
}
.new-data-import .mainDataImportTable table tbody tr td {
  color: #272728;
  font-family: "IBM Plex Sans";
  font-size: 14px;
  letter-spacing: 0;
  line-height: 15px;
  border-top: 1px solid #d6d6d6;
  padding: 7px 12px 0 12px;
  height: 40px;
  position: relative;
}
.new-data-import .mainDataImportTable table tbody tr td:first-child {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 160px;
}
.new-data-import .mainDataImportTable table tbody tr td span {
  padding-left: 8px;
}
.new-data-import .mainDataImportTable table tbody tr td span svg {
  height: 23px;
  position: absolute;
  top: 14px;
  left: 0;
  bottom: 0;
  margin: auto !important;
  width: auto !important;
}

.new-data-import .sisImportTable table tbody tr td {
  padding-top: 0px;
}
.new-data-import .sisImportTable table tbody tr td span {
  padding-left: 0px;
}
.new-data-import .sisImportTable table tbody tr td span.status svg {
  top: 10px;
}
.new-data-import .sisImportTable table tbody tr td span.status span {
  margin-left: 8px;
}

.lor-tooltip {
  padding: 3px;
}
.lor-tooltip h4 {
  color: #fff;
  font-weight: bold;
}
.lor-tooltip .lor-stats {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 2px;
}

.ant-tooltip .ant-tooltip-content {
  width: 250px;
}

.ant-tooltip-inner {
  color: whitesmoke;
  background-color: #3a3b3d;
}

.lor-text {
  border-bottom: 1px dashed #272728;
}

.ant-tooltip-arrow-content {
  background-color: #3a3b3d;
}

.radio-item {
  vertical-align: middle;
  color: #272728;
  font-family: "IBM Plex Sans";
  font-size: 14px;
  letter-spacing: 0;
  line-height: 34px;
}
.radio-item.vertical {
  display: block;
}
.radio-item .ant-radio-inner::after {
  background-color: #141497;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}
.radio-item .ant-radio-wrapper:hover .ant-radio,
.radio-item .ant-radio:hover .ant-radio-inner,
.radio-item .ant-radio-input:focus + .ant-radio-inner {
  border-color: #141497;
}
.radio-item .ant-radio-checked::after,
.radio-item .ant-radio-checked .ant-radio-inner {
  border-color: #141497;
}
.radio-item .ant-radio-input:focus + .ant-radio-inner {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.radio-item .ant-radio-inner {
  height: 18px;
  width: 18px;
  border-color: #141497;
}

.continue-btn {
  background: linear-gradient(180deg, #ffb65a 0%, #ffb65a 0%, #fe9527 100%);
  border: none;
  padding: 11px 18px;
  transition-duration: 0.4s;
  cursor: pointer;
  border-radius: 4px;
  color: #272728;
  font-family: "IBM Plex Sans";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 20px;
  text-align: center;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  -ms-border-radius: 4px;
  -o-border-radius: 4px;
}
.continue-btn:focus {
  outline: none;
}

.button.button-blue {
  background: #141497;
  color: white;
}
.button.button-blue:hover {
  border: 1px solid #141497;
  background-color: #fff;
  color: #141497;
}
.button.button-blue:hover svg path {
  fill: #141497;
}
.button.button-blue:disabled, .button.button-blue[disabled] {
  background-image: none;
  background-color: #b5b5b5;
  color: #fff;
  cursor: not-allowed;
  border-color: transparent;
}
.button.button-blue:disabled:hover, .button.button-blue[disabled]:hover {
  background-color: #b5b5b5;
}

.cancel-save-continue-btn-group .continue-btn {
  background: #141497;
  color: #fff;
  border: 1px solid #fff;
}
.cancel-save-continue-btn-group .continue-btn:hover {
  border: 1px solid #141497;
  background-color: #fff;
  color: #141497;
}
.cancel-save-continue-btn-group .continue-btn:hover svg path {
  fill: #141497;
}
.cancel-save-continue-btn-group .cancel-button {
  border: none;
  color: #565656;
}
.cancel-save-continue-btn-group .cancel-button:hover {
  background-color: #565656;
  color: #fff;
}
.cancel-save-continue-btn-group .cancel-button:hover svg path {
  fill: #fff;
}

button:disabled,
button[disabled] {
  background-image: none;
  background-color: #b5b5b5;
  color: #fff;
  cursor: not-allowed;
  border-color: transparent;
}
button:disabled:hover,
button[disabled]:hover {
  background-color: #b5b5b5;
}

.button {
  padding: 9px 18px;
  margin: 0px;
  transition-duration: 0.4s;
  cursor: pointer;
  border: 1px solid #141497;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 0.05);
  color: #141497;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 22px;
  height: auto;
}
.button:hover {
  background-color: #141497;
  color: #fff;
}
.button:hover svg path {
  fill: #fff;
}
.button:focus {
  outline: none;
}

.dropdown_button > .ant-btn {
  padding: 9px 18px;
  margin: 0px;
  transition-duration: 0.4s;
  cursor: pointer;
  border: 1px solid #141497;
  background-color: rgba(255, 255, 255, 0.05);
  color: #141497;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 22px;
}
.dropdown_button > .ant-btn:first-child {
  border-radius: 4px 0px 0px 4px !important;
}
.dropdown_button > .ant-btn:last-child {
  border-radius: 0px 4px 4px 0px !important;
}
.dropdown_button > .ant-btn:hover {
  background-color: #141497;
  color: #fff;
}
.dropdown_button > .ant-btn:hover svg path {
  fill: #fff;
}
.dropdown_button > .ant-btn:focus {
  outline: none;
}

.buttonSolid {
  background: linear-gradient(180deg, #2626e3 0%, #141497 100%);
  padding: 9px 18px;
  margin: 0px;
  transition-duration: 0.4s;
  cursor: pointer;
  border: 1px solid transparent;
  border-radius: 4px;
  color: #fff;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 22px;
  height: auto;
}
.buttonSolid:focus {
  outline: none;
}

.buttonBottomGutter {
  margin-bottom: 10px;
}

.buttonTopGutterLarge {
  margin-top: 30px;
}

.main-header-sec {
  padding: 30px 0px 0px 30px;
}
.main-header-sec .ant-breadcrumb {
  padding-bottom: 10px;
  position: unset;
  z-index: auto;
}
.main-header-sec .ant-breadcrumb a {
  color: #141499;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  letter-spacing: 0.16px;
  line-height: 18px;
}
.main-header-sec .ant-breadcrumb-separator {
  color: #000000;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  letter-spacing: 0.16px;
  line-height: 18px;
}
.main-header-sec .ant-breadcrumb > span:last-child a {
  color: #000000;
}
.main-header-sec .css-checkbox-row {
  padding: 5px 0 20px 40px;
  background-color: #f0f2f5;
  align-items: center;
}
.main-header-sec .css-checkbox-row .left-border-col {
  border-left: 1px solid #979797;
  align-content: space-between;
  padding-left: 10px;
}
.main-header-sec .css-checkbox-row .global-filter-offset {
  margin-top: 10px;
  margin-left: 10px;
}
.main-header-sec .css-checkbox-row .class-year-label {
  height: 22px;
  width: 87px;
  color: #171717;
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 2;
  margin-right: 10px;
}
.main-header-sec .css-checkbox-row .header-filter-col {
  height: 22px;
  width: auto;
  display: inherit;
}
.main-header-sec .css-checkbox-row .cselect-dropdown .ant-select-multiple .ant-select-selection-item-content {
  width: 275px;
}
.main-header-sec .css-checkbox-row .cselect-dropdown .ant-select-selector .selected-item {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 250px;
}
.main-header-sec .css-checkbox-row .ant-col.ant-col-6 {
  display: inline-flex;
  align-self: center;
}
.main-header-sec .css-checkbox-row .ant-col.ant-col-6 label {
  padding: 0 12px;
  color: #171717;
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 22px;
}
.main-header-sec .css-checkbox-row .ant-col.ant-col-6 .anticon.anticon-down {
  color: #000000;
}
.main-header-sec .css-checkbox-row .select-dropdown .ant-select-selector {
  background-color: transparent !important;
  height: 30px;
  padding-left: 0;
}
.main-header-sec .css-checkbox-row .select-dropdown .ant-select-selector .ant-select-selection-item {
  background-color: transparent !important;
  padding-left: 0;
}
.main-header-sec .css-checkbox-row .select-dropdown .ant-select-selector .ant-select-selection-item .ant-tag {
  padding: 3px 0px;
  width: 50px;
  height: 25px;
  display: inline-block;
  text-align: center;
}
.main-header-sec .css-checkbox-row .select-dropdown .ant-select-selector .ant-select-selection-item .ant-tag .anticon + span,
.main-header-sec .css-checkbox-row .select-dropdown .ant-select-selector .ant-select-selection-item .ant-tag span + .anticon {
  margin-left: 3px;
}

.checkbox .ant-checkbox .ant-checkbox-inner {
  border-color: #141497;
  border-width: 1.5px;
  border-radius: 0px;
  background: transparent;
  -webkit-border-radius: 0px;
  -moz-border-radius: 0px;
  -ms-border-radius: 0px;
  -o-border-radius: 0px;
}
.checkbox .ant-checkbox.ant-checkbox-disabled .ant-checkbox-inner {
  border-color: #8e8e90 !important;
}
.checkbox .ant-checkbox + span {
  color: #000;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 22px;
}
.checkbox .ant-checkbox-disabled + span {
  color: #656567;
}
.checkbox .ant-checkbox-checked .ant-checkbox-inner {
  border: none;
  background: linear-gradient(180deg, #2626e3 0%, #141497 100%);
}
.checkbox .ant-checkbox-checked:after {
  border: none;
}

.mainMatchFieldsSection {
  height: auto;
}
.mainMatchFieldsSection .main-header-sec {
  padding-right: 30px;
  padding-top: 0;
}
.mainMatchFieldsSection .spinner {
  margin: 20px 0;
  margin-bottom: 20px;
  padding: 30px 50px;
  text-align: center;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}
.mainMatchFieldsSection .reviewNappingText {
  height: 32px;
  width: 544px;
  color: #515152;
  font-family: "IBM Plex Sans";
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 20px;
}
.mainMatchFieldsSection .titleImprName,
.mainMatchFieldsSection .titleImpralumni,
.mainMatchFieldsSection .titleMatchField,
.mainMatchFieldsSection .titleStudent {
  font-family: "Open Sans", sans-serif;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 20px;
  margin: 0;
}
.mainMatchFieldsSection .titleImprName {
  font-size: 20px;
}
.mainMatchFieldsSection .titleImpralumni {
  font-size: 14px;
  padding: 7px 0 10px 0;
}
.mainMatchFieldsSection .titleMatchField {
  font-size: 16px;
  padding-bottom: 5px;
}
.mainMatchFieldsSection .titleStudent {
  font-size: 16px;
  font-weight: 600;
}
.mainMatchFieldsSection .divider-data {
  margin-top: 12px;
}
.mainMatchFieldsSection .mainWhitebgWrapper {
  padding: 0;
  background: transparent;
  margin: 0 30px 40px 30px;
}
.mainMatchFieldsSection .mainWhitebgWrapper .imprNameSection {
  background-color: #fff;
  padding: 15px 20px;
}
.mainMatchFieldsSection .mainWhitebgWrapper .select {
  padding-top: 0;
}
.mainMatchFieldsSection .mainWhitebgWrapper .select .ant-select-selector {
  background-color: #fff;
  height: 30px;
  padding: 0 11px;
  border-bottom-color: #8e8e90;
  border-radius: 4px 4px 0 0;
  -webkit-border-radius: 4px 4px 0 0;
  -moz-border-radius: 4px 4px 0 0;
  -ms-border-radius: 4px 4px 0 0;
  -o-border-radius: 4px 4px 0 0;
}
.mainMatchFieldsSection ul.listFields {
  list-style: none;
  padding-left: 35px;
}
.mainMatchFieldsSection ul.listFields li {
  color: rgba(0, 0, 0, 0.87);
  font-family: "Open Sans", sans-serif;
  font-size: 13px;
  letter-spacing: 0;
  line-height: 20px;
  position: relative;
}
.mainMatchFieldsSection ul.listFields li:before {
  content: "";
  position: absolute;
  background-color: rgba(0, 0, 0, 0.87);
  height: 4px;
  width: 4px;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  top: 0;
  bottom: 0;
  left: -25px;
  margin: auto;
}
.mainMatchFieldsSection table {
  width: 100%;
}
.mainMatchFieldsSection table thead tr th {
  background-color: #ebebeb;
  color: #171717;
  font-family: "IBM Plex Sans";
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 18px;
  padding: 15px 15px 8px 15px;
}
.mainMatchFieldsSection table thead tr th:nth-child(2) {
  width: 50%;
}
.mainMatchFieldsSection table thead tr th.clearField {
  color: #4a90e2;
  font-family: "Open Sans", sans-serif;
  font-weight: 500;
  cursor: pointer;
  text-decoration: underline;
}
.mainMatchFieldsSection table tbody tr td {
  border-top: 1px solid #d6d6d6;
  color: #272728;
  font-family: "IBM Plex Sans";
  font-size: 14px;
  letter-spacing: 0;
  line-height: 15px;
  padding: 0px 15px;
  height: 40px;
}
.mainMatchFieldsSection table tbody tr:nth-child(even) td {
  background-color: #f5f5f5;
}
.mainMatchFieldsSection .reqField,
.mainMatchFieldsSection .matField,
.mainMatchFieldsSection .ummField {
  color: #171717;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 18px;
  display: inline-block;
  padding: 10px 0 3px 0;
}
.mainMatchFieldsSection .reqField svg,
.mainMatchFieldsSection .matField svg,
.mainMatchFieldsSection .ummField svg {
  width: 22px !important;
  vertical-align: -webkit-baseline-middle !important;
  margin-right: -8px;
}
.mainMatchFieldsSection .mainPerformTimeWrapper .select:hover .ant-select-selector {
  border-color: #8e8e90;
}
.mainMatchFieldsSection .mainPerformTimeWrapper .select .ant-select-selector {
  background-color: #edeff5;
  border: transparent;
  padding: 5px 11px;
  height: 40px;
  border-bottom: 1px solid #8e8e90;
}
.mainMatchFieldsSection .mainPerformTimeWrapper .select.select-responsive .ant-select-selector {
  height: 100%;
}
.mainMatchFieldsSection .mainPerformTimeWrapper table thead tr th {
  width: 100px;
}
.mainMatchFieldsSection .mainPerformTimeWrapper table thead tr th:nth-child(2) {
  width: 100px;
}
.mainMatchFieldsSection .mainPerformTimeWrapper table tbody tr:nth-child(odd) td {
  background-color: #f5f5f5;
}
.mainMatchFieldsSection .mainPerformTimeWrapper table tbody tr:nth-child(even) td {
  background-color: unset;
}
.mainMatchFieldsSection .mainPerformTimeWrapper .ant-select-selection-placeholder {
  color: #272728;
  font-family: "IBM Plex Sans";
}

.ant-select-item-option-selected.selectOptions {
  background-color: #ededed;
}

.ant-divider-horizontal {
  margin: 0 0 12px 0;
  border-top: 2px solid #c6c6c6;
}

.main-header-sec .titleCol {
  padding-left: 20px;
}
.main-header-sec .titleField {
  color: rgba(0, 0, 0, 0.87);
  font-family: "Open Sans", sans-serif;
  font-size: 32px;
  letter-spacing: 0;
  line-height: 40px;
  margin: 0 !important;
  padding-bottom: 5px;
}

.defineCodeSec .divider-data {
  margin-top: 0;
}
.defineCodeSec .mtchpara {
  color: rgba(0, 0, 0, 0.87);
  font-family: "Open Sans";
  font-size: 14px;
  letter-spacing: 0;
  line-height: 20px;
  margin-bottom: 30px;
}
.defineCodeSec .spinner {
  margin: 20px 0;
  margin-bottom: 20px;
  padding: 30px 50px;
  text-align: center;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}
.defineCodeSec .imprtSection p {
  margin: 0;
}
.defineCodeSec .imprtSection p strong {
  font-size: 16px;
}
.defineCodeSec .mainDataTableSection .titleMatchField {
  margin-top: 30px;
}
.defineCodeSec .mainDataTableSection table {
  width: 100%;
}
.defineCodeSec .mainDataTableSection table thead tr th {
  width: 250px;
}
.defineCodeSec .mainDataTableSection table thead tr th:nth-child(2) {
  width: 150px;
}
.defineCodeSec .mainDataTableSection table tbody tr:nth-child(odd) td {
  background-color: unset;
}
.defineCodeSec .mainDataTableSection table tbody tr:nth-child(even) td {
  background-color: #f5f5f5;
}
.defineCodeSec .mainDataTableSection table tbody tr td {
  padding: 0 10px;
}
.defineCodeSec .mainDataTableSection table tbody tr td .text-input {
  margin-top: 0;
  height: 32px;
  border-bottom: 1px solid #717374;
  border-radius: 4px 4px 0 0;
  -webkit-border-radius: 4px 4px 0 0;
  -moz-border-radius: 4px 4px 0 0;
  -ms-border-radius: 4px 4px 0 0;
  -o-border-radius: 4px 4px 0 0;
}
.defineCodeSec .mainDataTableSection table tbody tr td .text-input:focus {
  box-shadow: none;
}
.defineCodeSec .mainDataTableSection table tbody tr td .radio-item .ant-radio-inner {
  background: transparent;
}

.mainSaveImportSettings {
  height: 100vh;
}

.actionsIcon svg {
  width: 20px !important;
}

.edit-action {
  margin-right: 18px;
  margin-left: 4px;
  width: 24px;
}

.edit-action {
  margin-right: 18px;
  margin-left: 4px;
}
.edit-action > svg {
  width: 24px !important;
}
.edit-action[disabled] {
  pointer-events: none;
}

.delete-action svg {
  width: 18px;
  vertical-align: bottom;
  margin-left: 5px;
}

.disable-action svg {
  margin-bottom: 4px;
}
.disable-action[disabled] {
  pointer-events: none;
}

.mainDrawerSection {
  margin-top: 80px;
}
.mainDrawerSection .mainDrawer .drawerTitle {
  color: #111111;
  font-family: "Open Sans";
  font-size: 28px;
  letter-spacing: 0;
  line-height: 36px;
  margin-bottom: 20px;
  font-weight: 500;
}
.mainDrawerSection .mainDrawer .drawerSubTitle {
  color: #272728;
  font-family: "Open Sans";
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0.19px;
  line-height: 24px;
}
.mainDrawerSection .mainDrawer .drawerDescription {
  color: #272728;
  font-family: "Open Sans";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 22px;
  margin-bottom: 20px;
}
.mainDrawerSection .mainDrawer .drawerLableText {
  color: #565656;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  letter-spacing: 0.43px;
  line-height: 20px;
  margin-bottom: 0;
  display: flex;
  justify-content: space-between;
}
.mainDrawerSection .mainDrawer .boldDrawerLabelText {
  font-weight: bold;
}
.mainDrawerSection .mainDrawer .ant-select-selection-placeholder {
  color: #a2a2a4 !important;
  font-size: 16px;
}
.mainDrawerSection .mainDrawer .addBtn.button {
  margin: 25px 0 0 0;
}
.mainDrawerSection .mainDrawer .drawerTopGutter {
  margin-top: 30px;
}
.mainDrawerSection .mainDrawer .lineTopGutter {
  margin-top: 5px;
}
.mainDrawerSection .mainDrawer .modal {
  top: "55%";
  left: "50%";
  right: "auto";
  bottom: "auto";
  width: "60%";
  color: #10d097;
  transform: "translate(-40%, -10%)";
}
.mainDrawerSection .mainDrawer .drawerInput {
  height: 40px;
  margin: 0;
  padding: 5px 10px;
}
.mainDrawerSection .mainDrawer .drawerInvalidInput {
  border: 2px solid #d91e28;
  border-radius: 5px;
}
.mainDrawerSection .mainDrawer .inputErrorIcon {
  color: #d91e28;
  margin-top: -2rem;
  position: absolute;
  right: 0;
  font-size: 1rem;
}
.mainDrawerSection .mainDrawer input[type=text],
.mainDrawerSection .mainDrawer input[type=password] {
  max-width: 290px;
}
.mainDrawerSection .mainDrawer input[type=text].drawerInputFull,
.mainDrawerSection .mainDrawer input[type=password].drawerInputFull {
  max-width: 100%;
}
.mainDrawerSection .mainDrawer .drawerShowLink {
  color: #141497;
  font-size: 13px;
}
.mainDrawerSection .mainDrawer .note {
  background-color: #fffde5;
  padding: 15px 20px;
  position: relative;
}
.mainDrawerSection .mainDrawer .note::before {
  content: "";
  position: absolute;
  height: 54px;
  width: 3px;
  background-color: #fcd703;
  top: 0;
  left: 0;
}
.mainDrawerSection .mainDrawer .note .drawerLableText {
  color: #272728;
  font-size: 14px;
}
.mainDrawerSection .mainDrawer .note strong {
  color: #272728;
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: 600;
}
.mainDrawerSection .mainDrawer .note strong svg {
  width: 30px !important;
  margin: 0 !important;
}
.mainDrawerSection .mainDrawer .successBanner {
  background-color: #daf9e9;
  padding: 10px 20px;
  margin-bottom: 20px;
  display: flex;
}
.mainDrawerSection .mainDrawer .successBanner::before {
  content: "";
  position: absolute;
  height: 60px;
  width: 3px;
  background-color: #10d097;
  top: 0;
  left: 0;
}
.mainDrawerSection .mainDrawer .successBanner .drawerLableText {
  color: #272728;
  font-size: 16px;
}
.mainDrawerSection .mainDrawer .successBanner :nth-last-child(2) {
  flex-grow: 1;
}
.mainDrawerSection .mainDrawer .successBanner strong {
  color: #272728;
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: 600;
}
.mainDrawerSection .mainDrawer .successBanner strong svg {
  width: 30px !important;
  margin: 10px 0 0 0 !important;
}
.mainDrawerSection .mainDrawer .errorBanner {
  background-color: #fdc9cb;
  padding: 10px 20px;
  margin-bottom: 20px;
  display: flex;
}
.mainDrawerSection .mainDrawer .errorBanner::before {
  content: "";
  position: absolute;
  height: 60px;
  width: 3px;
  background-color: #da1e28;
  top: 0;
  left: 0;
}
.mainDrawerSection .mainDrawer .errorBanner .drawerLableText {
  color: #272728;
  font-size: 16px;
}
.mainDrawerSection .mainDrawer .errorBanner :nth-last-child(2) {
  flex-grow: 1;
}
.mainDrawerSection .mainDrawer .errorBanner strong {
  color: #272728;
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: 600;
}
.mainDrawerSection .mainDrawer .errorBanner strong svg {
  width: 30px !important;
  margin: 10px 0 0 0 !important;
}
.mainDrawerSection .mainDrawer .gencred a {
  text-decoration: underline;
}
.mainDrawerSection .mainDrawer .gencred .drawerLableText {
  margin-top: 10px;
  color: #656567;
  font-size: 14px;
}
.mainDrawerSection .mainDrawer .drawerAlertClose {
  display: flex;
  justify-content: flex-end;
}
.mainDrawerSection .mainDrawer .drawerAlertClose svg {
  width: 24px !important;
}
.mainDrawerSection .mainDrawer .drawerAlertClose svg path {
  fill: #272728;
}
.mainDrawerSection .mainDrawer .drawerSelectDropdown .select {
  padding-top: 5px;
  width: 100%;
}
.mainDrawerSection .mainDrawer .drawerSelectDropdown .select .ant-select-selector {
  background-color: #edeff5;
  border: transparent;
  padding: 5px 11px;
  height: 40px;
  border-bottom: 1px solid #000;
  border-radius: 0px 0px 0px 0px;
  -webkit-border-radius: 0px 0px 0px 0px;
  -moz-border-radius: 0px 0px 0px 0px;
  -ms-border-radius: 0px 0px 0px 0px;
  -o-border-radius: 0px 0px 0px 0px;
  box-shadow: none;
}
.mainDrawerSection .mainDrawer .drawerSelectDropdown .select .ant-select-arrow {
  color: #141497;
}
.mainDrawerSection .mainDrawer .drawerSelectDropdown .select .ant-select-arrow .anticon-down {
  vertical-align: middle;
}
.mainDrawerSection .mainDrawer .drawerSelectDropdown .select .ant-select-arrow .anticon-down svg {
  transform: scale(1.3, 1);
  height: 10px;
  width: 14px;
}
.mainDrawerSection .mainDrawer .drawerSelectDropdown .select .ant-select-selection-placeholder {
  color: #666666;
}
.mainDrawerSection .mainDrawer .drawerSelectDropdown .select .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {
  box-shadow: none;
  outline: none;
}
.mainDrawerSection .mainDrawer .drawerSelectDropdown .select .ant-select:hover .ant-select-selector, .mainDrawerSection .mainDrawer .drawerSelectDropdown .select .ant-select:focus .ant-select-selector {
  border-color: #000;
}
.mainDrawerSection .mainDrawer .drawerTableIcons {
  text-align: right;
}
.mainDrawerSection .mainDrawer .drawerTableIcons svg {
  width: 20px !important;
}
.mainDrawerSection .mainDrawer .drawerTableIcons svg path {
  fill: #3d3d3e;
}
.mainDrawerSection .mainDrawer .drawerSelectContainer {
  display: flex;
  justify-content: flex-start;
  gap: 12px;
  align-items: center;
  margin-bottom: 20px;
}
.mainDrawerSection .mainDrawer .drawerSelectContainer .disabled {
  color: #a2a2a4;
}
.mainDrawerSection .mainDrawer .drawerLinkContainer {
  display: flex;
  gap: 4px;
}
.mainDrawerSection .mainDrawer .drawerLinkContainer > * {
  font-size: 14px;
}
.mainDrawerSection .ant-drawer-content {
  border: 1px solid #bac2d0;
}
.mainDrawerSection .ant-drawer-content .ant-drawer-body {
  margin-bottom: 80px;
}
.mainDrawerSection .ant-drawer-content .ant-drawer-header {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.24);
  padding: 26px 20px;
}
.mainDrawerSection .ant-drawer-content .ant-drawer-header .ant-drawer-close {
  right: unset;
  left: 0;
  color: #141497;
  padding: 25px 20px;
  font-size: 20px;
}
.mainDrawerSection .ant-drawer-content .ant-drawer-header .ant-drawer-title {
  padding-left: 25px;
  color: #141497;
  font-family: "Open Sans";
  font-size: 14px;
  letter-spacing: 0;
  line-height: 18px;
}
.mainDrawerSection .mainMatchFieldsSection {
  height: auto;
}

.mainLogsSection {
  height: auto;
}
.mainLogsSection .spinner {
  margin: 20px 0;
  margin-bottom: 20px;
  padding: 30px 50px;
  text-align: center;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}
.mainLogsSection .main-header-sec {
  padding-right: 30px;
  padding-top: 0;
}
.mainLogsSection .mainWhitebgWrapper {
  margin: 0 30px 30px 30px;
  padding: 15px 20px;
  height: 100vh;
}
.mainLogsSection .bckBtn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}
.mainLogsSection .bckBtn svg {
  width: 26px;
}
.mainLogsSection .backbtn {
  color: #3b7bc6;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 19px;
  margin-top: -12px;
  text-decoration: underline;
}
.mainLogsSection .impDetails ul {
  padding: 0;
  list-style: none;
}
.mainLogsSection .impDetails ul li {
  display: inline-block;
  width: 50%;
}
.mainLogsSection .darkText {
  color: #000;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  letter-spacing: 0.18px;
  line-height: 22px;
}
.mainLogsSection .lightText {
  color: #000;
  font-family: "Open Sans", sans-serif;
  font-size: 13px;
  letter-spacing: 0.15px;
  line-height: 18px;
}
.mainLogsSection .impSummary ul {
  list-style: none;
  padding: 0px;
}
.mainLogsSection .nedAttention h5 {
  display: inline-block;
}
.mainLogsSection .nedAttention span {
  padding-left: 5px;
}
.mainLogsSection .paddedH1 {
  padding-top: 10px;
}
.mainLogsSection .mainPerformTimeWrapper .viewLogTable tr:first-of-type td {
  border-top: 1px solid #d6d6d6;
}
.mainLogsSection .mainPerformTimeWrapper .viewLogTable tr td {
  background: unset;
  border-bottom: 1px solid #d6d6d6;
  vertical-align: top;
}

.main-footer {
  display: flex;
  justify-content: space-between;
  margin-top: auto;
}

.footer-content {
  display: flex;
  flex-direction: column;
  font-size: 12px;
}

.sidebar-content {
  background: #f0f2f5;
}

.wizard-header {
  background: #071d4e;
  color: white;
  text-align: center;
  height: auto;
  line-height: 30px;
  padding: 8px 0px;
}
.wizard-header > h2,
.wizard-header > h4 {
  color: white;
  margin: 0px;
}

.wizard-steps {
  margin-top: 20px;
  margin-left: 20px;
}
.wizard-steps .ant-steps-item-tail {
  left: -6px !important;
  top: 4px !important;
}
.wizard-steps .ant-steps-item-tail:after {
  background-color: #5a6872 !important;
}
.wizard-steps .wizard-step-process .circle-icon {
  background: #1890ff;
  border-color: #1890ff;
}
.wizard-steps .wizard-step-process .ant-steps-item-title {
  color: #1890ff !important;
}
.wizard-steps .wizard-step-wait .ant-steps-item-title {
  color: #5a6872 !important;
}

.circle-icon {
  background: white;
  border: 2px solid #5a6872;
  position: relative;
  float: left;
  width: 100%;
  height: 100%;
  border-radius: 100px;
  height: 12px;
  width: 12px;
}

.wizard-footer {
  background: white;
  border-top: 1px solid #f0f2f5;
}
.wizard-footer .wizard-footer-main {
  display: flex;
  justify-content: space-between;
}

.wizard-content-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
}

.wizard-layout {
  min-height: 100vh;
}
.wizard-layout > .main-content {
  min-height: 100%;
}

.sisRow {
  background-color: #edeff5;
}

.defineCodes table tbody tr td:nth-of-type(2) {
  padding-right: 0;
  padding-left: 0;
}

.defineCodes table tbody tr td:last-child {
  padding-right: 0;
  padding-left: 0;
}

.button:not([disabled]) {
  box-sizing: border-box !important;
  border: 1px solid #141497 !important;
  border-radius: 4px !important;
}

.cancel-save-continue-btn-group .cancel-button {
  border: none !important;
  color: #565656 !important;
}

.button:not([disabled]):active,
.dropdown_button > .ant-btn:not([disabled]):active {
  border-radius: 4px !important;
  color: #141497 !important;
  background-color: #ece6f6 !important;
  box-shadow: inset 0 0 5px 0 rgba(206, 194, 234, 0.5) !important;
}

.button:not([disabled]):hover,
.dropdown_button > .ant-btn:not([disabled]):hover {
  background-color: #ece6f6 !important;
  color: #141497 !important;
  border-color: #ece6f6 !important;
  border-radius: 4px !important;
}

.button:not([disabled]):focus-visible,
.dropdown_button > .ant-btn:not([disabled]) focus-visible {
  background-color: #ece5f6 !important;
  color: #141497 !important;
  box-sizing: border-box;
  border: 2px solid #ffffff !important;
  outline: 1px solid #141497 !important;
}

.dropdown_button > .ant-btn:not([disabled]):hover svg path,
.button:not([disabled]):hover svg path,
.dropdown_button > .ant-btn:not([disabled]):active svg path,
.button:not([disabled]):active svg path {
  fill: #141497 !important;
}

.dropdown_button > .ant-btn-icon-only {
  height: unset;
  width: unset;
}

.button[disabled] {
  background-color: #fff !important;
  color: #141497 !important;
}

.button-blue:not([disabled]) {
  background-color: linear-gradient(180deg, #2626e3 0%, #141497 100%) !important;
  color: #fff !important;
}

.button-blue:not([disabled]):hover {
  background-color: #141497 !important;
  color: #fff !important;
}

.button-blue:not([disabled]):active {
  background-color: #1a1ac7 !important;
  box-shadow: inset 0 0 8px 0 rgba(14, 14, 108, 0.7) !important;
}

.button-blue:not([disabled]):focus-visible {
  box-sizing: border-box !important;
  border: 2px solid #fff !important;
  outline: 1px solid #141497 !important;
  background-color: linear-gradient(180deg, #2626e3 0%, #141497 100%) !important;
}

.button-blue[disabled] {
  background-color: rgba(20, 20, 151, 0.1) !important;
  color: #8e8e90 !important;
}

.counselorTable .ant-input-affix-wrapper,
.counselorTable .ant-input {
  background-color: #edeff5;
  border: transparent;
}

.counselorTable .ant-input {
  max-width: none;
}

.counselorTable .ant-input-affix-wrapper {
  border-bottom: 1px solid #8e8e90 !important;
  padding: 5px 11px;
}

.counselorTable td:nth-of-type(2) {
  padding-top: 5px;
}

.schoolMatching > .ant-select-selector {
  height: auto !important;
}

.alert .ant-alert-content {
  display: block !important;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL1VzZXJzL2RpeGl0LmphaW4vZGF0YS1pbmdlc3QvYXBwcy9kYXRhLWluZ2VzdC11aS9zcmMvYXBwIiwic291cmNlcyI6WyIuLi9hc3NldHMvc2Fzcy9zdHlsZS5zY3NzIiwiLi4vLi4vLi4vLi4vbm9kZV9tb2R1bGVzL2FudGQvZGlzdC9hbnRkLm1pbi5jc3MiLCIuLi9hc3NldHMvc2Fzcy9wYXJ0aWFscy9fZ2xvYmFsLnNjc3MiLCIuLi9hc3NldHMvc2Fzcy9oZWxwZXJzL192YXJpYWJsZXMuc2NzcyIsIi4uL2Fzc2V0cy9zYXNzL2NvbXBvbmVudHMvX2RhdGEtaW1wb3J0LnNjc3MiLCIuLi9hc3NldHMvc2Fzcy9jb21wb25lbnRzL19uZXctZGF0YS1pbXBvcnQuc2NzcyIsIi4uL2Fzc2V0cy9zYXNzL2NvbXBvbmVudHMvX2hlYWRlci5zY3NzIiwiLi4vYXNzZXRzL3Nhc3MvY29tcG9uZW50cy9fY2hlY2tib3guc2NzcyIsIi4uL2Fzc2V0cy9zYXNzL2NvbXBvbmVudHMvX21hdGNoLWZpZWxkcy5zY3NzIiwiLi4vYXNzZXRzL3Nhc3MvY29tcG9uZW50cy9fZGVmaW5lc2NvZGUuc2NzcyIsIi4uL2Fzc2V0cy9zYXNzL2NvbXBvbmVudHMvX3NhdmVpbXBvcnRzZXR0aW5ncy5zY3NzIiwiLi4vYXNzZXRzL3Nhc3MvY29tcG9uZW50cy9fZHJhd2VyLnNjc3MiLCIuLi9hc3NldHMvc2Fzcy9jb21wb25lbnRzL19sb2dzLnNjc3MiLCIuLi9hc3NldHMvc2Fzcy9jb21wb25lbnRzL19mb290ZXIuc2NzcyIsIi4uL2Fzc2V0cy9zYXNzL2NvbXBvbmVudHMvX3dpemFyZC5zY3NzIiwiYXBwLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFRO0FBQ0E7QUNEUjtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBT0c7RUFBZ0w7OztBQUFhO0VBQVU7RUFBVzs7O0FBQVk7RUFBbUM7OztBQUFhO0VBQWlCOzs7QUFBc0I7RUFBSztFQUF1QjtFQUFpQjtFQUE4QjtFQUEwQjtFQUE2Qjs7O0FBQTBDO0VBQWM7O0FBQW1CO0VBQUs7RUFBUztFQUFzQjtFQUFlO0VBQXlLO0VBQTBCO0VBQW1CO0VBQXNCOzs7QUFBNkI7RUFBc0I7OztBQUF1QjtFQUFHO0VBQXVCO0VBQVM7OztBQUFpQjtFQUFrQjtFQUFhO0VBQW1CO0VBQXNCOzs7QUFBZ0I7RUFBRTtFQUFhOzs7QUFBa0I7RUFBc0M7RUFBMEI7RUFBeUM7RUFBaUM7RUFBZ0I7OztBQUFZO0VBQVE7RUFBa0I7RUFBa0I7OztBQUFvQjtFQUFrRTs7O0FBQXdCO0VBQVM7RUFBYTs7O0FBQWtCO0VBQXdCOzs7QUFBZ0I7RUFBRzs7O0FBQWdCO0VBQUc7RUFBbUI7OztBQUFjO0VBQVc7OztBQUFlO0VBQUk7OztBQUFrQjtFQUFTOzs7QUFBbUI7RUFBTTs7O0FBQWM7RUFBUTtFQUFrQjtFQUFjO0VBQWM7OztBQUF3QjtFQUFJOzs7QUFBYztFQUFJOzs7QUFBVTtFQUFFO0VBQWM7RUFBcUI7RUFBNkI7RUFBYTtFQUFlO0VBQXFCOzs7QUFBcUM7RUFBUTs7O0FBQWM7RUFBUzs7O0FBQWM7RUFBeUI7RUFBcUI7OztBQUFVO0VBQVk7RUFBc0I7OztBQUFtQjtFQUFrQjtFQUFjOzs7QUFBNEU7RUFBSTtFQUFhO0VBQWtCOzs7QUFBYztFQUFPOzs7QUFBZTtFQUFJO0VBQXNCOzs7QUFBa0I7RUFBa0Y7OztBQUEwQjtFQUFNOzs7QUFBeUI7RUFBUTtFQUFrQjtFQUFvQjtFQUFzQjtFQUFnQjs7O0FBQW9CO0VBQXNDO0VBQVM7RUFBYztFQUFrQjtFQUFvQjs7O0FBQW9CO0VBQWE7OztBQUFpQjtFQUFjOzs7QUFBb0I7RUFBcUQ7OztBQUEwQjtFQUF3SDtFQUFVOzs7QUFBa0I7RUFBdUM7RUFBc0I7OztBQUFVO0VBQStFOzs7QUFBMkI7RUFBUztFQUFjOzs7QUFBZ0I7RUFBUztFQUFZO0VBQVM7RUFBVTs7O0FBQVM7RUFBTztFQUFjO0VBQVc7RUFBZTtFQUFtQjtFQUFVO0VBQWM7RUFBZ0I7RUFBb0I7OztBQUFtQjtFQUFTOzs7QUFBd0I7RUFBa0Y7OztBQUFZO0VBQWM7RUFBb0I7OztBQUF3QjtFQUFxRjs7O0FBQXdCO0VBQTZCO0VBQWE7OztBQUEwQjtFQUFPOzs7QUFBcUI7RUFBUTs7O0FBQWtCO0VBQVM7OztBQUFhO0VBQVM7OztBQUF1QjtFQUFLO0VBQWE7OztBQUF5QjtFQUFpQjtFQUFXOzs7QUFBbUI7RUFBWTtFQUFXOzs7QUFBbUI7RUFBaUM7RUFBYzs7O0FBQVc7RUFBZ0I7OztBQUFXO0VBQVM7RUFBcUI7RUFBYztFQUFrQjtFQUFjO0VBQWtCO0VBQW9CO0VBQXVCO0VBQWtDO0VBQW1DOzs7QUFBa0M7RUFBVzs7O0FBQWM7RUFBYTs7O0FBQXFCO0VBQWdCOzs7QUFBYTtFQUF1Qjs7O0FBQWM7RUFBa0I7RUFBYzs7O0FBQWlCO0VBQW1COzs7QUFBZTtFQUFtQztFQUFxQjs7O0FBQTJDO0VBQWlEO0VBQXVCO0VBQXlCOzs7QUFBNEI7RUFBOEU7RUFBeUI7OztBQUE2QjtFQUFzQztFQUEwQjtFQUE2Qjs7O0FBQW9CO0VBQWlDO0VBQVU7OztBQUFpQztFQUFnQjs7O0FBQWlDO0VBQXFCO0lBQUc7O0VBQVU7SUFBRzs7O0FBQVc7RUFBc0I7SUFBRzs7RUFBVTtJQUFHOzs7QUFBVztFQUEwRDtFQUF1QjtFQUF5Qjs7O0FBQTRCO0VBQTBGO0VBQTJCOzs7QUFBNkI7RUFBNEM7RUFBNEI7RUFBNkI7OztBQUFvQjtFQUF1QztFQUFVOzs7QUFBc0Q7RUFBbUI7OztBQUF1RDtFQUFnRTtFQUF1QjtFQUF5Qjs7O0FBQTRCO0VBQWtHO0VBQTZCOzs7QUFBNkI7RUFBZ0Q7RUFBOEI7RUFBNkI7OztBQUFvQjtFQUEyQztFQUFVOzs7QUFBc0Q7RUFBcUI7OztBQUF1RDtFQUFnRTtFQUF1QjtFQUF5Qjs7O0FBQTRCO0VBQWtHO0VBQTZCOzs7QUFBNkI7RUFBZ0Q7RUFBOEI7RUFBNkI7OztBQUFvQjtFQUEyQztFQUFVOzs7QUFBc0Q7RUFBcUI7OztBQUF1RDtFQUFtRTtFQUF1QjtFQUF5Qjs7O0FBQTRCO0VBQXNHO0VBQThCOzs7QUFBNkI7RUFBa0Q7RUFBK0I7RUFBNkI7OztBQUFvQjtFQUE2QztFQUFVOzs7QUFBc0Q7RUFBc0I7OztBQUF1RDtFQUF5QjtJQUFHO0lBQTJCO0lBQXFCOztFQUFVO0lBQUc7SUFBd0I7SUFBcUI7OztBQUFXO0VBQTBCO0lBQUc7SUFBd0I7SUFBcUI7O0VBQVU7SUFBRztJQUEyQjtJQUFxQjs7O0FBQVc7RUFBeUI7SUFBRztJQUE0QjtJQUFxQjs7RUFBVTtJQUFHO0lBQXdCO0lBQXFCOzs7QUFBVztFQUEwQjtJQUFHO0lBQXdCO0lBQXFCOztFQUFVO0lBQUc7SUFBNEI7SUFBcUI7OztBQUFXO0VBQTBCO0lBQUc7SUFBMkI7SUFBcUI7O0VBQVU7SUFBRztJQUF3QjtJQUFxQjs7O0FBQVc7RUFBMkI7SUFBRztJQUF3QjtJQUFxQjs7RUFBVTtJQUFHO0lBQTJCO0lBQXFCOzs7QUFBVztFQUF1QjtJQUFHO0lBQTRCO0lBQXFCOztFQUFVO0lBQUc7SUFBd0I7SUFBcUI7OztBQUFXO0VBQXdCO0lBQUc7SUFBd0I7SUFBcUI7O0VBQVU7SUFBRztJQUE0QjtJQUFxQjs7O0FBQVc7RUFBeUI7SUFBRzs7O0FBQXlCO0VBQXlFOzs7QUFBa0I7RUFBSztFQUFpQzs7O0FBQWU7RUFBOEU7RUFBa0I7RUFBTTtFQUFRO0VBQVM7RUFBTztFQUFjO0VBQXNCO0VBQTJCO0VBQWlEO0VBQVc7RUFBK0Y7RUFBNkI7RUFBVzs7O0FBQW9CO0VBQXNCO0lBQUc7SUFBeUI7OztBQUFvRDtFQUFzQjtJQUFHOzs7QUFBVztFQUE2RDtFQUF1QjtFQUF5Qjs7O0FBQTRCO0VBQThGO0VBQTRCOzs7QUFBNkI7RUFBOEM7RUFBNkI7RUFBNkI7OztBQUFvQjtFQUF5QztFQUFtQjtFQUFxQjtFQUFVOzs7QUFBb0Q7RUFBb0I7OztBQUEwRDtFQUFtRTtFQUF1QjtFQUF5Qjs7O0FBQTRCO0VBQXNHO0VBQThCOzs7QUFBNkI7RUFBa0Q7RUFBK0I7RUFBNkI7OztBQUFvQjtFQUE2QztFQUFtQjtFQUFxQjtFQUFVOzs7QUFBb0Q7RUFBc0I7OztBQUEwRDtFQUFtRTtFQUF1QjtFQUF5Qjs7O0FBQTRCO0VBQXNHO0VBQThCOzs7QUFBNkI7RUFBa0Q7RUFBK0I7RUFBNkI7OztBQUFvQjtFQUE2QztFQUFtQjtFQUFxQjtFQUFVOzs7QUFBb0Q7RUFBc0I7OztBQUEwRDtFQUFzRTtFQUF1QjtFQUF5Qjs7O0FBQTRCO0VBQTBHO0VBQStCOzs7QUFBNkI7RUFBb0Q7RUFBZ0M7RUFBNkI7OztBQUFvQjtFQUErQztFQUFtQjtFQUFxQjtFQUFVOzs7QUFBb0Q7RUFBdUI7OztBQUEwRDtFQUF3QjtJQUFHO0lBQXFCO0lBQXFCOztFQUFVO0lBQUc7SUFBb0I7SUFBcUI7OztBQUFXO0VBQXlCO0lBQUc7SUFBb0I7SUFBcUI7O0VBQVU7SUFBRztJQUFxQjtJQUFxQjs7O0FBQVc7RUFBMEI7SUFBRztJQUFxQjtJQUEyQjs7RUFBVTtJQUFHO0lBQW9CO0lBQTJCOzs7QUFBVztFQUEyQjtJQUFHO0lBQW9CO0lBQTJCOztFQUFVO0lBQUc7SUFBcUI7SUFBMkI7OztBQUFXO0VBQTBCO0lBQUc7SUFBcUI7SUFBcUI7O0VBQVU7SUFBRztJQUFvQjtJQUFxQjs7O0FBQVc7RUFBMkI7SUFBRztJQUFvQjtJQUFxQjs7RUFBVTtJQUFHO0lBQXFCO0lBQXFCOzs7QUFBVztFQUEyQjtJQUFHO0lBQXFCO0lBQXdCOztFQUFVO0lBQUc7SUFBb0I7SUFBd0I7OztBQUFXO0VBQTRCO0lBQUc7SUFBb0I7SUFBd0I7O0VBQVU7SUFBRztJQUFxQjtJQUF3Qjs7O0FBQVc7RUFBaUQ7RUFBdUI7RUFBeUI7OztBQUE0QjtFQUE4RTtFQUF5Qjs7O0FBQTZCO0VBQXNDO0VBQTBCO0VBQTZCOzs7QUFBb0I7RUFBaUM7RUFBbUI7RUFBVTs7O0FBQXNEO0VBQWlEOzs7QUFBZTtFQUFnQjs7O0FBQXdEO0VBQTZEO0VBQXVCO0VBQXlCOzs7QUFBNEI7RUFBOEY7RUFBNEI7OztBQUE2QjtFQUE4QztFQUE2QjtFQUE2Qjs7O0FBQW9CO0VBQXlDO0VBQW1CO0VBQVU7OztBQUFzRDtFQUF5RDs7O0FBQWU7RUFBb0I7OztBQUF3RDtFQUE0RTtFQUF1QjtFQUF5Qjs7O0FBQTRCO0VBQWtIO0VBQTRCOzs7QUFBNkI7RUFBd0Q7RUFBNkI7RUFBNkI7OztBQUFvQjtFQUFtRDtFQUFtQjtFQUFVOzs7QUFBc0Q7RUFBbUU7OztBQUFlO0VBQXlCOzs7QUFBd0Q7RUFBMEQ7RUFBdUI7RUFBeUI7OztBQUE0QjtFQUEwRjtFQUEyQjs7O0FBQTZCO0VBQTRDO0VBQTRCO0VBQTZCOzs7QUFBb0I7RUFBdUM7RUFBbUI7RUFBVTs7O0FBQXNEO0VBQXVEOzs7QUFBZTtFQUFtQjs7O0FBQXdEO0VBQWdFO0VBQXVCO0VBQXlCOzs7QUFBNEI7RUFBa0c7RUFBNkI7OztBQUE2QjtFQUFnRDtFQUE4QjtFQUE2Qjs7O0FBQW9CO0VBQTJDO0VBQW1CO0VBQVU7OztBQUFzRDtFQUEyRDs7O0FBQWU7RUFBcUI7OztBQUF3RDtFQUFnRTtFQUF1QjtFQUF5Qjs7O0FBQTRCO0VBQWtHO0VBQTZCOzs7QUFBNkI7RUFBZ0Q7RUFBOEI7RUFBNkI7OztBQUFvQjtFQUEyQztFQUFtQjtFQUFVOzs7QUFBc0Q7RUFBMkQ7OztBQUFlO0VBQXFCOzs7QUFBd0Q7RUFBbUU7RUFBdUI7RUFBeUI7OztBQUE0QjtFQUFzRztFQUE4Qjs7O0FBQTZCO0VBQWtEO0VBQStCO0VBQTZCOzs7QUFBb0I7RUFBNkM7RUFBbUI7RUFBVTs7O0FBQXNEO0VBQTZEOzs7QUFBZTtFQUFzQjs7O0FBQXdEO0VBQXFCO0lBQUc7SUFBb0I7O0VBQVU7SUFBRztJQUFtQjs7O0FBQVc7RUFBc0I7SUFBRzs7RUFBbUI7SUFBRztJQUFvQjs7O0FBQVc7RUFBd0I7SUFBRztJQUFvQjs7RUFBVTtJQUFHO0lBQW1COzs7QUFBVztFQUF5QjtJQUFHOztFQUFtQjtJQUFHO0lBQW9COzs7QUFBVztFQUF1QjtJQUFHO0lBQW9CO0lBQXVCOztFQUFVO0lBQUc7SUFBbUI7OztBQUF3QjtFQUF3QjtJQUFHO0lBQW1COztFQUF1QjtJQUFHO0lBQW9CO0lBQXVCOzs7QUFBVztFQUF5QjtJQUFHO0lBQW9CO0lBQXVCOztFQUFVO0lBQUc7SUFBbUI7OztBQUF3QjtFQUEwQjtJQUFHO0lBQW1COztFQUF1QjtJQUFHO0lBQW9CO0lBQXVCOzs7QUFBVztFQUEwQjtJQUFHO0lBQW9CO0lBQTBCOztFQUFVO0lBQUc7SUFBbUI7OztBQUEyQjtFQUEyQjtJQUFHO0lBQW1COztFQUEwQjtJQUFHO0lBQW9CO0lBQTBCOzs7QUFBVztFQUF5QjtJQUFHO0lBQW9CO0lBQTBCOztFQUFVO0lBQUc7SUFBbUI7OztBQUEyQjtFQUEwQjtJQUFHO0lBQW1COztFQUEwQjtJQUFHO0lBQW9CO0lBQTBCOzs7QUFBVztFQUE0Qjs7O0FBQWdCO0VBQXdEOzs7QUFBMEc7RUFBcUI7OztBQUFnQjtFQUFXO0VBQWU7OztBQUFXO0VBQVc7RUFBc0I7RUFBUztFQUFzQjtFQUFlO0VBQTBCO0VBQW1CO0VBQWdCO0VBQTZCO0VBQWtCO0VBQWE7RUFBbUI7RUFBaUI7RUFBcUI7OztBQUFrQjtFQUFtQjtFQUFPOzs7QUFBWTtFQUFnQjs7O0FBQWlCO0VBQXVCO0VBQWE7RUFBZTs7O0FBQWlCO0VBQW1CO0VBQXlCOzs7QUFBeUI7RUFBbUM7OztBQUFjO0VBQWdCO0VBQXlCOzs7QUFBeUI7RUFBZ0M7OztBQUFjO0VBQW1CO0VBQXlCOzs7QUFBeUI7RUFBbUM7OztBQUFjO0VBQWlCO0VBQXlCOzs7QUFBeUI7RUFBaUM7OztBQUFjO0VBQTRDO0VBQVM7OztBQUFVO0VBQWtCOzs7QUFBZ0I7RUFBc0I7RUFBZ0I7RUFBVTtFQUFnQjtFQUFlO0VBQWlCO0VBQTZCO0VBQVk7RUFBYTs7O0FBQWU7RUFBcUM7RUFBc0I7OztBQUFxQjtFQUEyQzs7O0FBQXNCO0VBQXNCO0VBQXNCOzs7QUFBcUI7RUFBNEI7OztBQUFzQjtFQUE0QjtFQUF1Qjs7O0FBQTRCO0VBQThDOzs7QUFBYTtFQUE0QztFQUFrQjs7O0FBQWU7RUFBK0M7RUFBYztFQUFrQjtFQUFzQjs7O0FBQWU7RUFBbUI7OztBQUFzQjtFQUFtRDs7O0FBQWM7RUFBa0M7RUFBZ0I7RUFBVTs7O0FBQWlQO0VBQXlDO0VBQWE7RUFBMEI7RUFBYztFQUFpQjs7O0FBQVU7RUFBa0I7RUFBZ0I7RUFBUzs7O0FBQWdCO0VBQXlCOzs7QUFBYztFQUErQjtFQUFrQjs7O0FBQWdCO0VBQXNFO0VBQWlCOzs7QUFBaUI7RUFBMEM7RUFBbUI7OztBQUFrQjtFQUEwRDtFQUFrQjs7O0FBQWlCO0VBQVk7RUFBc0I7RUFBUztFQUFzQjtFQUFlO0VBQTBCO0VBQW1CO0VBQWdCO0VBQTZCO0VBQWtCOzs7QUFBa0I7RUFBb0I7RUFBaUI7RUFBaUI7RUFBYzs7O0FBQTZCO0VBQWdCO0VBQWtCO0VBQU07RUFBTzs7O0FBQVk7RUFBdUI7RUFBa0I7RUFBYztFQUFVO0VBQVk7RUFBYztFQUF5Qjs7O0FBQVk7RUFBcUI7RUFBa0I7RUFBUztFQUFhO0VBQVU7RUFBVztFQUFzQjtFQUF5QjtFQUFrQjtFQUEyQjs7O0FBQStCO0VBQWlEOzs7QUFBcUI7RUFBdUQ7OztBQUFhO0VBQWlCOzs7QUFBdUI7RUFBdUI7RUFBa0I7RUFBYztFQUFrQjtFQUFnQjtFQUFzQjtFQUFtQjtFQUF1Qjs7O0FBQW1CO0VBQWtDOzs7QUFBZ0I7RUFBK0M7OztBQUFjO0VBQWtDO0VBQWdCOzs7QUFBbUI7RUFBZ0I7OztBQUFjO0VBQW1DO0VBQWtCO0VBQWM7RUFBa0I7OztBQUFlO0VBQWdDO0VBQVE7OztBQUFVO0VBQXFDO0VBQVU7RUFBTzs7O0FBQTBCO0VBQWlDOzs7QUFBdUI7RUFBMEI7RUFBc0I7RUFBUztFQUFVO0VBQXNCO0VBQWU7RUFBMEI7RUFBbUI7RUFBZ0I7OztBQUE2QjtFQUE0Qzs7O0FBQVc7RUFBWTtFQUFzQjtFQUFTO0VBQVU7RUFBc0I7RUFBZTtFQUEwQjtFQUFtQjtFQUFnQjtFQUE2QjtFQUFrQjtFQUFxQjtFQUFnQjtFQUFXO0VBQW1CO0VBQWtCO0VBQXNCO0VBQWdCO0VBQVc7RUFBWTtFQUFpQjs7O0FBQWtCO0VBQWtCOzs7QUFBdUI7RUFBMkI7OztBQUFjO0VBQW1CO0VBQWtCO0VBQVM7OztBQUEwQjtFQUE0Qjs7O0FBQWU7RUFBcUM7OztBQUFTO0VBQWU7RUFBVztFQUFZO0VBQWlCOzs7QUFBa0I7RUFBc0I7RUFBa0I7RUFBUzs7O0FBQTBCO0VBQStCOzs7QUFBZTtFQUF3Qzs7O0FBQVM7RUFBZTtFQUFXO0VBQVk7RUFBaUI7OztBQUFrQjtFQUFzQjtFQUFrQjtFQUFTOzs7QUFBMEI7RUFBK0I7OztBQUFlO0VBQXdDOzs7QUFBUztFQUFtQjs7O0FBQWtCO0VBQWdCO0VBQWM7RUFBVztFQUFZO0VBQW9COzs7QUFBaUI7RUFBa0I7OztBQUFvQjtFQUE4Qjs7O0FBQXNCO0VBQWdEOzs7QUFBaUI7RUFBa0Q7OztBQUFnQjtFQUFvRDtFQUFrQjs7O0FBQWM7RUFBa0U7RUFBaUI7OztBQUFjO0VBQWM7RUFBc0I7RUFBUztFQUFVO0VBQXNCO0VBQWU7RUFBMEI7RUFBbUI7RUFBZ0I7RUFBNkI7RUFBZTtFQUFZO0VBQVk7RUFBVztFQUFXO0VBQVk7OztBQUFlO0VBQW9COzs7QUFBYTtFQUFrQjtFQUFXO0VBQVc7OztBQUFjO0VBQXNCO0VBQVc7RUFBWTtFQUFnQjtFQUFXO0VBQWtCO0VBQWlDO0VBQW1COzs7QUFBbUI7RUFBNEI7RUFBaUM7OztBQUFtQjtFQUFtQjtFQUFlOzs7QUFBaUI7RUFBb0M7SUFBYzs7RUFBVztJQUFrQjtJQUFXOzs7QUFBVztFQUFvQztJQUFjOztFQUFXO0lBQWtCO0lBQVc7OztBQUFXO0VBQVc7RUFBc0I7RUFBUztFQUFVO0VBQXNCO0VBQWU7RUFBMEI7RUFBbUI7RUFBZ0I7RUFBNkI7RUFBa0I7RUFBcUI7OztBQUFjO0VBQWlCO0VBQWE7RUFBZTtFQUFZO0VBQWM7RUFBVztFQUFnQjtFQUFlO0VBQWlCO0VBQW1CO0VBQWtCO0VBQW1CO0VBQW1COzs7QUFBMEI7RUFBNEM7OztBQUFXO0VBQW9CO0VBQWU7RUFBWTtFQUFVO0VBQWU7RUFBaUI7OztBQUFrQjtFQUEwQjs7O0FBQWM7RUFBZTtFQUFhO0VBQVU7RUFBYztFQUFXO0VBQW1CO0VBQW1COzs7QUFBMEI7RUFBaUM7OztBQUEyQjtFQUErRTtFQUFrQjtFQUFNO0VBQVE7RUFBOEI7OztBQUF3QjtFQUFzSDs7O0FBQW1EO0VBQWtCO0VBQW9COzs7QUFBd0I7RUFBc0I7RUFBa0I7RUFBUztFQUFxQjtFQUFVO0VBQVc7RUFBc0I7OztBQUFrQjtFQUEwQjs7O0FBQXlCO0VBQTZCO0VBQWtCOzs7QUFBeUI7RUFBbUM7RUFBa0I7RUFBTTtFQUFPO0VBQVc7RUFBWTtFQUF5QjtFQUFrQjtFQUF3RDs7O0FBQVc7RUFBMEI7OztBQUF5QjtFQUF3Qjs7O0FBQXlCO0VBQTBCOzs7QUFBeUI7RUFBaUQ7OztBQUFtQjtFQUFzQjs7O0FBQW1CO0VBQTBCOzs7QUFBbUI7RUFBeUI7OztBQUFtQjtFQUF5Qjs7O0FBQW1CO0VBQXVCOzs7QUFBbUI7RUFBdUI7OztBQUFtQjtFQUF1Qjs7O0FBQW1CO0VBQXdCOzs7QUFBbUI7RUFBdUI7OztBQUFtQjtFQUEyQjs7O0FBQW1CO0VBQXlCOzs7QUFBbUI7RUFBdUI7RUFBZ0I7RUFBc0I7OztBQUFlO0VBQTZDO0VBQTJEOzs7QUFBeUI7RUFBc0I7RUFBNEQ7OztBQUF5QjtFQUErRjs7O0FBQW9FO0VBQStDOzs7QUFBcUU7RUFBZ0Q7OztBQUFzQjtFQUF1Rzs7O0FBQWU7RUFBeUc7RUFBa0I7RUFBUztFQUFjOzs7QUFBeUI7RUFBK0I7SUFBRztJQUFvQjs7RUFBVztJQUFHO0lBQXFCOzs7QUFBVztFQUFtQjtFQUFnQjs7O0FBQWM7RUFBd0I7RUFBa0I7RUFBcUI7OztBQUFrRDtFQUE4RTtFQUFZO0VBQW9DOzs7QUFBbUM7RUFBc0Q7OztBQUFTO0VBQTBCOzs7QUFBbUI7RUFBMEI7SUFBRztJQUF1Qzs7RUFBVTtJQUFHOzs7QUFBd0M7RUFBMkI7SUFBRzs7RUFBdUM7SUFBRztJQUF1Qzs7O0FBQVc7RUFBbUM7SUFBRztJQUFtQjs7RUFBVTtJQUFHOzs7QUFBb0I7RUFBb0M7SUFBRzs7RUFBbUI7SUFBRztJQUFtQjs7O0FBQVc7RUFBaUM7SUFBRzs7RUFBcUI7SUFBRztJQUE0Qzs7O0FBQXNCO0VBQW9COzs7QUFBa0I7RUFBWTtFQUFzQjtFQUFTO0VBQXNCO0VBQWU7RUFBMEI7RUFBbUI7RUFBZ0I7RUFBNkI7RUFBa0I7RUFBUTtFQUFZO0VBQWM7RUFBVztFQUFpQjtFQUFtQjtFQUF5Qjs7O0FBQWtCO0VBQWlCOzs7QUFBVztFQUFtQjtFQUFrQjtFQUFTO0VBQVU7RUFBVztFQUFtQjtFQUFpQjtFQUFzQjs7O0FBQXFCO0VBQXlCO0VBQWtCO0VBQVM7RUFBVTtFQUFjO0VBQWU7RUFBc0I7RUFBZTs7O0FBQVc7RUFBaUQ7RUFBYzs7O0FBQW1CO0VBQXNCO0VBQWM7OztBQUFtQjtFQUEwQjtFQUFjOzs7QUFBbUI7RUFBeUI7RUFBYzs7O0FBQW1CO0VBQXlCO0VBQWM7OztBQUFtQjtFQUF1QjtFQUFjOzs7QUFBbUI7RUFBdUI7RUFBYzs7O0FBQW1CO0VBQXVCO0VBQWM7OztBQUFtQjtFQUF3QjtFQUFjOzs7QUFBbUI7RUFBdUI7RUFBYzs7O0FBQW1CO0VBQTJCO0VBQWM7OztBQUFtQjtFQUF5QjtFQUFjOzs7QUFBbUI7RUFBcUM7RUFBVzs7O0FBQTZCO0VBQXdEO0VBQVE7OztBQUErRDtFQUF1QztFQUFVOzs7QUFBNEI7RUFBMEQ7RUFBTzs7O0FBQStEO0VBQWU7OztBQUFjO0VBQXlPO0VBQVc7RUFBTztFQUFjO0VBQStCOzs7QUFBcUI7RUFBMkY7RUFBVztFQUFPO0VBQStCOzs7QUFBcUI7RUFBc0M7RUFBaUI7OztBQUFjO0VBQTJKOzs7QUFBaUM7RUFBNkU7OztBQUFrQztFQUFnQjs7O0FBQWM7RUFBeUM7RUFBWTtFQUFVO0VBQStCOzs7QUFBNEI7RUFBNEQ7RUFBWTs7O0FBQU87RUFBOEg7OztBQUErRDtFQUEyQztFQUFXO0VBQVc7RUFBNkI7OztBQUE4QjtFQUE4RDtFQUFROzs7QUFBVztFQUFrSTs7O0FBQStEO0VBQTZCO0lBQUc7SUFBd0M7O0VBQVU7SUFBRzs7O0FBQXlDO0VBQThCO0lBQUc7O0VBQXdDO0lBQUc7SUFBd0M7OztBQUFXO0VBQWdCO0VBQXNCO0VBQVM7RUFBVTtFQUFzQjtFQUEwQjtFQUFtQjtFQUFnQjtFQUE2QjtFQUFzQjs7O0FBQWU7RUFBeUI7OztBQUFlO0VBQW1CO0VBQWE7RUFBZTtFQUFTO0VBQVU7OztBQUFnQjtFQUFrQjtFQUFzQjs7O0FBQXFCO0VBQXNGOzs7QUFBc0I7RUFBd0M7OztBQUFhO0VBQTBCO0VBQWE7OztBQUFzQjtFQUF5Rzs7O0FBQWdCO0VBQW9COzs7QUFBYztFQUEyQjtFQUFjOzs7QUFBVztFQUEwQjtFQUFjO0VBQVc7OztBQUFXO0VBQXlCOzs7QUFBWTtFQUFxSztFQUFpQjs7O0FBQWM7RUFBUztFQUFtQjtFQUFrQjtFQUFxQjtFQUFnQjtFQUFtQjtFQUFrQjtFQUFzQjtFQUFvQztFQUFlO0VBQWtEO0VBQXlCO0VBQXNCO0VBQXFCO0VBQWlCO0VBQTBCO0VBQVk7RUFBaUI7RUFBZTtFQUFrQjtFQUFzQjtFQUF5Qjs7O0FBQWdCO0VBQWtCOzs7QUFBYztFQUF3Qzs7O0FBQVU7RUFBK0I7OztBQUFxQjtFQUFnQztFQUFVOzs7QUFBZ0I7RUFBbUI7OztBQUFtQjtFQUFxQjs7O0FBQW9CO0VBQVk7RUFBWTtFQUFtQjtFQUFlOzs7QUFBa0I7RUFBWTtFQUFZO0VBQWM7RUFBZTs7O0FBQWtCO0VBQXNCOzs7QUFBbUI7RUFBNEI7RUFBa0I7RUFBTTtFQUFRO0VBQVM7RUFBTztFQUF1Qjs7O0FBQVc7RUFBOEI7RUFBYztFQUFxQjs7O0FBQWdCO0VBQXdEOzs7QUFBbUI7RUFBb0U7RUFBa0I7RUFBTTtFQUFRO0VBQVM7RUFBTztFQUF1Qjs7O0FBQVc7RUFBZ0I7RUFBYztFQUFxQjs7O0FBQWdCO0VBQTZCOzs7QUFBbUI7RUFBbUM7RUFBa0I7RUFBTTtFQUFRO0VBQVM7RUFBTztFQUF1Qjs7O0FBQVc7RUFBK0Y7RUFBc0I7RUFBcUI7RUFBbUI7RUFBaUI7OztBQUFnQjtFQUFtSjs7O0FBQW1CO0VBQTJLO0VBQWtCO0VBQU07RUFBUTtFQUFTO0VBQU87RUFBdUI7OztBQUFXO0VBQThDO0VBQXFCOzs7QUFBZ0I7RUFBYzs7O0FBQXFCO0VBQWlCO0VBQVc7RUFBcUI7RUFBbUI7RUFBcUM7OztBQUFvQztFQUE4Qjs7O0FBQW1CO0VBQW9DO0VBQWtCO0VBQU07RUFBUTtFQUFTO0VBQU87RUFBdUI7OztBQUFXO0VBQThDO0VBQVc7RUFBcUI7OztBQUFtQjtFQUF3RTs7O0FBQW1CO0VBQW9GO0VBQWtCO0VBQU07RUFBUTtFQUFTO0VBQU87RUFBdUI7OztBQUFXO0VBQXdCO0VBQVc7RUFBcUI7OztBQUFtQjtFQUFxQzs7O0FBQW1CO0VBQTJDO0VBQWtCO0VBQU07RUFBUTtFQUFTO0VBQU87RUFBdUI7OztBQUFXO0VBQStIO0VBQXNCO0VBQXFCO0VBQW1CO0VBQWlCOzs7QUFBZ0I7RUFBbUw7OztBQUFtQjtFQUEyTTtFQUFrQjtFQUFNO0VBQVE7RUFBUztFQUFPO0VBQXVCOzs7QUFBVztFQUFtRTtFQUEyQjs7O0FBQTBCO0VBQTRFOzs7QUFBcUI7RUFBNkQ7OztBQUEyQjtFQUF1RTs7O0FBQTJCO0VBQThHOzs7QUFBMEI7RUFBa0k7OztBQUEwQjtFQUFlO0VBQXNCO0VBQXFCOzs7QUFBdUI7RUFBNEI7OztBQUFtQjtFQUFrQztFQUFrQjtFQUFNO0VBQVE7RUFBUztFQUFPO0VBQXVCOzs7QUFBVztFQUEwQztFQUFjO0VBQXFCOzs7QUFBdUI7RUFBb0U7OztBQUFtQjtFQUFnRjtFQUFrQjtFQUFNO0VBQVE7RUFBUztFQUFPO0VBQXVCOzs7QUFBVztFQUFzQjtFQUFjO0VBQXFCOzs7QUFBdUI7RUFBbUM7OztBQUFtQjtFQUF5QztFQUFrQjtFQUFNO0VBQVE7RUFBUztFQUFPO0VBQXVCOzs7QUFBVztFQUF1SDtFQUFzQjtFQUFxQjtFQUFtQjtFQUFpQjs7O0FBQWdCO0VBQTJLOzs7QUFBbUI7RUFBbU07RUFBa0I7RUFBTTtFQUFRO0VBQVM7RUFBTztFQUF1Qjs7O0FBQVc7RUFBZ0I7RUFBc0I7RUFBcUI7RUFBZ0I7OztBQUFvQjtFQUE2Qjs7O0FBQW1CO0VBQW1DO0VBQWtCO0VBQU07RUFBUTtFQUFTO0VBQU87RUFBdUI7OztBQUFXO0VBQTRDO0VBQWM7RUFBcUI7OztBQUFnQjtFQUFzRTs7O0FBQW1CO0VBQWtGO0VBQWtCO0VBQU07RUFBUTtFQUFTO0VBQU87RUFBdUI7OztBQUFXO0VBQXVCO0VBQWM7RUFBcUI7OztBQUFnQjtFQUFvQzs7O0FBQW1CO0VBQTBDO0VBQWtCO0VBQU07RUFBUTtFQUFTO0VBQU87RUFBdUI7OztBQUFXO0VBQTJIO0VBQXNCO0VBQXFCO0VBQW1CO0VBQWlCOzs7QUFBZ0I7RUFBK0s7OztBQUFtQjtFQUF1TTtFQUFrQjtFQUFNO0VBQVE7RUFBUztFQUFPO0VBQXVCOzs7QUFBVztFQUFnQjtFQUFXO0VBQXFCO0VBQW1CO0VBQXFDOzs7QUFBb0M7RUFBNkI7OztBQUFtQjtFQUFtQztFQUFrQjtFQUFNO0VBQVE7RUFBUztFQUFPO0VBQXVCOzs7QUFBVztFQUE0QztFQUFXO0VBQXFCOzs7QUFBbUI7RUFBc0U7OztBQUFtQjtFQUFrRjtFQUFrQjtFQUFNO0VBQVE7RUFBUztFQUFPO0VBQXVCOzs7QUFBVztFQUF1QjtFQUFXO0VBQXFCOzs7QUFBbUI7RUFBb0M7OztBQUFtQjtFQUEwQztFQUFrQjtFQUFNO0VBQVE7RUFBUztFQUFPO0VBQXVCOzs7QUFBVztFQUEySDtFQUFzQjtFQUFxQjtFQUFtQjtFQUFpQjs7O0FBQWdCO0VBQStLOzs7QUFBbUI7RUFBdU07RUFBa0I7RUFBTTtFQUFRO0VBQVM7RUFBTztFQUF1Qjs7O0FBQVc7RUFBYztFQUFjO0VBQXlCO0VBQXVCOzs7QUFBZ0I7RUFBMkI7OztBQUFtQjtFQUFpQztFQUFrQjtFQUFNO0VBQVE7RUFBUztFQUFPO0VBQXVCOzs7QUFBVztFQUF3QztFQUFjO0VBQXFCOzs7QUFBdUI7RUFBa0U7OztBQUFtQjtFQUE4RTtFQUFrQjtFQUFNO0VBQVE7RUFBUztFQUFPO0VBQXVCOzs7QUFBVztFQUFxQjtFQUFjO0VBQXFCOzs7QUFBdUI7RUFBa0M7OztBQUFtQjtFQUF3QztFQUFrQjtFQUFNO0VBQVE7RUFBUztFQUFPO0VBQXVCOzs7QUFBVztFQUFtSDtFQUFxQjs7O0FBQW1CO0VBQW9COzs7QUFBdUI7RUFBNkQ7OztBQUF5QjtFQUFtSDtFQUFzQjtFQUF5QjtFQUF1QjtFQUFpQjs7O0FBQWdCO0VBQXVLOzs7QUFBbUI7RUFBK0w7RUFBa0I7RUFBTTtFQUFRO0VBQVM7RUFBTztFQUF1Qjs7O0FBQVc7RUFBYztFQUFzQjtFQUF5QjtFQUF1Qjs7O0FBQWdCO0VBQTJCOzs7QUFBbUI7RUFBaUM7RUFBa0I7RUFBTTtFQUFRO0VBQVM7RUFBTztFQUF1Qjs7O0FBQVc7RUFBd0M7RUFBYztFQUFxQjs7O0FBQXVCO0VBQWtFOzs7QUFBbUI7RUFBOEU7RUFBa0I7RUFBTTtFQUFRO0VBQVM7RUFBTztFQUF1Qjs7O0FBQVc7RUFBcUI7RUFBYztFQUFxQjs7O0FBQXVCO0VBQWtDOzs7QUFBbUI7RUFBd0M7RUFBa0I7RUFBTTtFQUFRO0VBQVM7RUFBTztFQUF1Qjs7O0FBQVc7RUFBbUg7RUFBcUI7OztBQUFtQjtFQUF3QztFQUFzQjtFQUE0Qjs7O0FBQXlCO0VBQXFCO0VBQXNCO0VBQTRCOzs7QUFBeUI7RUFBbUg7RUFBc0I7RUFBeUI7RUFBdUI7RUFBaUI7OztBQUFnQjtFQUF1Szs7O0FBQW1CO0VBQStMO0VBQWtCO0VBQU07RUFBUTtFQUFTO0VBQU87RUFBdUI7OztBQUFXO0VBQW1CO0VBQWM7RUFBcUI7OztBQUFnQjtFQUFnQzs7O0FBQW1CO0VBQXNDO0VBQWtCO0VBQU07RUFBUTtFQUFTO0VBQU87RUFBdUI7OztBQUFXO0VBQWtEO0VBQWM7RUFBcUI7OztBQUFnQjtFQUE0RTs7O0FBQW1CO0VBQXdGO0VBQWtCO0VBQU07RUFBUTtFQUFTO0VBQU87RUFBdUI7OztBQUFXO0VBQTBCO0VBQWM7RUFBcUI7OztBQUFnQjtFQUF1Qzs7O0FBQW1CO0VBQTZDO0VBQWtCO0VBQU07RUFBUTtFQUFTO0VBQU87RUFBdUI7OztBQUFXO0VBQXVJO0VBQXNCO0VBQXFCO0VBQW1CO0VBQWlCOzs7QUFBZ0I7RUFBMkw7OztBQUFtQjtFQUFtTjtFQUFrQjtFQUFNO0VBQVE7RUFBUztFQUFPO0VBQXVCOzs7QUFBVztFQUFtQztFQUFXO0VBQXFCO0VBQW1CO0VBQXFDOzs7QUFBb0M7RUFBZ0Q7OztBQUFtQjtFQUFzRDtFQUFrQjtFQUFNO0VBQVE7RUFBUztFQUFPO0VBQXVCOzs7QUFBVztFQUFrRjtFQUFXO0VBQXFCOzs7QUFBbUI7RUFBNEc7OztBQUFtQjtFQUF3SDtFQUFrQjtFQUFNO0VBQVE7RUFBUztFQUFPO0VBQXVCOzs7QUFBVztFQUEwQztFQUFXO0VBQXFCOzs7QUFBbUI7RUFBdUQ7OztBQUFtQjtFQUE2RDtFQUFrQjtFQUFNO0VBQVE7RUFBUztFQUFPO0VBQXVCOzs7QUFBVztFQUF1TTtFQUFzQjtFQUFxQjtFQUFtQjtFQUFpQjs7O0FBQWdCO0VBQTJQOzs7QUFBbUI7RUFBbVI7RUFBa0I7RUFBTTtFQUFRO0VBQVM7RUFBTztFQUF1Qjs7O0FBQVc7RUFBZ0M7RUFBYztFQUF5QjtFQUF1Qjs7O0FBQWdCO0VBQTZDOzs7QUFBbUI7RUFBbUQ7RUFBa0I7RUFBTTtFQUFRO0VBQVM7RUFBTztFQUF1Qjs7O0FBQVc7RUFBNEU7RUFBYzs7O0FBQXFCO0VBQXVDO0VBQWM7OztBQUFxQjtFQUEyTDtFQUFxQjs7O0FBQW1CO0VBQTRFO0VBQWM7RUFBeUI7OztBQUF1QjtFQUFzRzs7O0FBQW1CO0VBQWtIO0VBQWtCO0VBQU07RUFBUTtFQUFTO0VBQU87RUFBdUI7OztBQUFXO0VBQXVDO0VBQWM7RUFBeUI7OztBQUF1QjtFQUFvRDs7O0FBQW1CO0VBQTBEO0VBQWtCO0VBQU07RUFBUTtFQUFTO0VBQU87RUFBdUI7OztBQUFXO0VBQTJMO0VBQXNCO0VBQXlCO0VBQXVCO0VBQWlCOzs7QUFBZ0I7RUFBK087OztBQUFtQjtFQUF1UTtFQUFrQjtFQUFNO0VBQVE7RUFBUztFQUFPO0VBQXVCOzs7QUFBVztFQUFnQztFQUFjO0VBQXlCO0VBQXVCOzs7QUFBZ0I7RUFBNkM7OztBQUFtQjtFQUFtRDtFQUFrQjtFQUFNO0VBQVE7RUFBUztFQUFPO0VBQXVCOzs7QUFBVztFQUE0RTtFQUFjO0VBQXFCOzs7QUFBdUI7RUFBdUM7RUFBYztFQUFxQjs7O0FBQXVCO0VBQTJMO0VBQXFCOzs7QUFBbUI7RUFBNEU7RUFBYztFQUF5Qjs7O0FBQTRCO0VBQXNHOzs7QUFBbUI7RUFBa0g7RUFBa0I7RUFBTTtFQUFRO0VBQVM7RUFBTztFQUF1Qjs7O0FBQVc7RUFBdUM7RUFBYztFQUF5Qjs7O0FBQTRCO0VBQW9EOzs7QUFBbUI7RUFBMEQ7RUFBa0I7RUFBTTtFQUFRO0VBQVM7RUFBTztFQUF1Qjs7O0FBQVc7RUFBMkw7RUFBc0I7RUFBeUI7RUFBdUI7RUFBaUI7OztBQUFnQjtFQUErTzs7O0FBQW1CO0VBQXVRO0VBQWtCO0VBQU07RUFBUTtFQUFTO0VBQU87RUFBdUI7OztBQUFXO0VBQW1CO0VBQVc7RUFBWTtFQUFnQjtFQUFlO0VBQWtCOzs7QUFBb0I7RUFBcUI7OztBQUFlO0VBQThCO0VBQVc7RUFBWTtFQUFnQjtFQUFlOzs7QUFBa0I7RUFBZ0M7OztBQUFlO0VBQThCO0VBQVc7RUFBWTtFQUFVO0VBQWU7OztBQUFrQjtFQUFnQzs7O0FBQWU7RUFBNEI7RUFBYTs7O0FBQXVCO0VBQW9DOzs7QUFBb0I7RUFBb0I7OztBQUFvQjtFQUE2Qjs7O0FBQWU7RUFBZTtFQUFZO0VBQWlCO0VBQWU7OztBQUFtQjtFQUEwQjtFQUFZO0VBQW1CO0VBQWU7OztBQUFtQjtFQUEwQjtFQUFZO0VBQWU7RUFBZTs7O0FBQW1CO0VBQWlDOzs7QUFBVztFQUFnQjtFQUFlO0VBQWdCO0VBQWU7RUFBa0I7OztBQUFrQjtFQUEyQjtFQUFlOzs7QUFBa0I7RUFBMkI7RUFBZTs7O0FBQWtCO0VBQWdCO0VBQWtCO0VBQVM7RUFBVztFQUFZO0VBQVU7RUFBVTtFQUFhO0VBQWdCO0VBQXNCO0VBQVk7RUFBdUI7RUFBVzs7O0FBQW9CO0VBQWtCOzs7QUFBMEQ7RUFBdUU7OztBQUE4QjtFQUF5QjtFQUFrQjs7O0FBQWU7RUFBZ0M7OztBQUFjO0VBQStCOzs7QUFBK0Y7RUFBd0M7RUFBa0I7OztBQUFlO0VBQTRDOzs7QUFBMkM7RUFBZTs7O0FBQW9CO0VBQW9FOzs7QUFBa0I7RUFBcU07OztBQUFVO0VBQXlFOzs7QUFBVTtFQUFrQzs7O0FBQWU7RUFBa007OztBQUFpQjtFQUErRTs7O0FBQThCO0VBQXdCOzs7QUFBZ0I7RUFBNkU7OztBQUFjO0VBQTJFOzs7QUFBa0I7RUFBK0c7RUFBMkI7OztBQUE4QjtFQUErRztFQUE0Qjs7O0FBQStCO0VBQWlGOzs7QUFBa0I7RUFBcUg7RUFBMkI7OztBQUE4QjtFQUFxSDtFQUE0Qjs7O0FBQStCO0VBQThCOzs7QUFBVztFQUEwRTs7O0FBQWdCO0VBQStFO0VBQWtCO0VBQTBCOzs7QUFBNkI7RUFBZ0Y7RUFBaUI7RUFBeUI7OztBQUE0QjtFQUFzbEI7RUFBa0I7OztBQUFpQjtFQUFpQzs7O0FBQWM7RUFBbUo7OztBQUEwQjtFQUFtSjs7O0FBQTBCO0VBQXlKOzs7QUFBMEI7RUFBeUo7OztBQUEwQjtFQUF5Qzs7O0FBQWtCO0VBQThDOzs7QUFBZ0I7RUFBa0M7RUFBVzs7O0FBQWtCO0VBQTJKOzs7QUFBdUI7RUFBZ0Y7RUFBYzs7O0FBQXFCO0VBQXlDO0VBQWM7OztBQUFxQjtFQUE0QztFQUFzQjtFQUF1Qjs7O0FBQXFCO0VBQTBDO0VBQWM7RUFBcUI7OztBQUFpQjtFQUF1RDs7O0FBQW1CO0VBQTZEO0VBQWtCO0VBQU07RUFBUTtFQUFTO0VBQU87RUFBdUI7OztBQUFXO0VBQWdHO0VBQWM7OztBQUFxQjtFQUEwSDs7O0FBQW1CO0VBQXNJO0VBQWtCO0VBQU07RUFBUTtFQUFTO0VBQU87RUFBdUI7OztBQUFXO0VBQWlEO0VBQWM7OztBQUFxQjtFQUE4RDs7O0FBQW1CO0VBQW9FO0VBQWtCO0VBQU07RUFBUTtFQUFTO0VBQU87RUFBdUI7OztBQUFXO0VBQW1PO0VBQXNCO0VBQXFCO0VBQW1CO0VBQWlCOzs7QUFBZ0I7RUFBdVI7OztBQUFtQjtFQUErUztFQUFrQjtFQUFNO0VBQVE7RUFBUztFQUFPO0VBQXVCOzs7QUFBVztFQUF5QztFQUFjO0VBQXFCOzs7QUFBaUI7RUFBc0Q7OztBQUFtQjtFQUE0RDtFQUFrQjtFQUFNO0VBQVE7RUFBUztFQUFPO0VBQXVCOzs7QUFBVztFQUE4RjtFQUFjOzs7QUFBcUI7RUFBd0g7OztBQUFtQjtFQUFvSTtFQUFrQjtFQUFNO0VBQVE7RUFBUztFQUFPO0VBQXVCOzs7QUFBVztFQUFnRDtFQUFjOzs7QUFBcUI7RUFBNkQ7OztBQUFtQjtFQUFtRTtFQUFrQjtFQUFNO0VBQVE7RUFBUztFQUFPO0VBQXVCOzs7QUFBVztFQUErTjtFQUFzQjtFQUFxQjtFQUFtQjtFQUFpQjs7O0FBQWdCO0VBQW1SOzs7QUFBbUI7RUFBMlM7RUFBa0I7RUFBTTtFQUFRO0VBQVM7RUFBTztFQUF1Qjs7O0FBQVc7RUFBNEM7RUFBYztFQUFxQjs7O0FBQWlCO0VBQXlEOzs7QUFBbUI7RUFBK0Q7RUFBa0I7RUFBTTtFQUFRO0VBQVM7RUFBTztFQUF1Qjs7O0FBQVc7RUFBb0c7RUFBYzs7O0FBQXFCO0VBQThIOzs7QUFBbUI7RUFBMEk7RUFBa0I7RUFBTTtFQUFRO0VBQVM7RUFBTztFQUF1Qjs7O0FBQVc7RUFBbUQ7RUFBYzs7O0FBQXFCO0VBQWdFOzs7QUFBbUI7RUFBc0U7RUFBa0I7RUFBTTtFQUFRO0VBQVM7RUFBTztFQUF1Qjs7O0FBQVc7RUFBMk87RUFBc0I7RUFBcUI7RUFBbUI7RUFBaUI7OztBQUFnQjtFQUErUjs7O0FBQW1CO0VBQXVUO0VBQWtCO0VBQU07RUFBUTtFQUFTO0VBQU87RUFBdUI7OztBQUFXO0VBQXlEO0VBQWM7RUFBeUI7OztBQUFpQjtFQUFzRTs7O0FBQW1CO0VBQTRFO0VBQWtCO0VBQU07RUFBUTtFQUFTO0VBQU87RUFBdUI7OztBQUFXO0VBQThIO0VBQWM7OztBQUF5QjtFQUF3Sjs7O0FBQW1CO0VBQW9LO0VBQWtCO0VBQU07RUFBUTtFQUFTO0VBQU87RUFBdUI7OztBQUFXO0VBQWdFO0VBQWM7OztBQUF5QjtFQUE2RTs7O0FBQW1CO0VBQW1GO0VBQWtCO0VBQU07RUFBUTtFQUFTO0VBQU87RUFBdUI7OztBQUFXO0VBQStSO0VBQXNCO0VBQXFCO0VBQW1CO0VBQWlCOzs7QUFBZ0I7RUFBbVY7OztBQUFtQjtFQUEyVztFQUFrQjtFQUFNO0VBQVE7RUFBUztFQUFPO0VBQXVCOzs7QUFBVztFQUF3Qzs7O0FBQXFCO0VBQTBDO0VBQW9COzs7QUFBcUI7RUFBdUI7OztBQUFXO0VBQWU7RUFBcUI7RUFBUTtFQUFrQjs7O0FBQWM7RUFBVTtFQUE0Qjs7O0FBQWlCO0VBQW1COzs7QUFBbUI7RUFBcUI7OztBQUFvQjtFQUErRjtFQUFzQjtFQUF5QjtFQUF1QjtFQUFpQjs7O0FBQWdCO0VBQW1KOzs7QUFBbUI7RUFBMks7RUFBa0I7RUFBTTtFQUFRO0VBQVM7RUFBTztFQUF1Qjs7O0FBQVc7RUFBYTs7O0FBQWlCO0VBQWE7OztBQUFpQjtFQUFxRjs7O0FBQWtCO0VBQStFOzs7QUFBaUI7RUFBcUY7OztBQUFVO0VBQWdDOzs7QUFBVTtFQUErRjs7O0FBQWdCO0VBQXdIO0VBQTBCOzs7QUFBNkI7RUFBME87RUFBeUI7OztBQUE0QjtFQUFrSDtFQUEwQjs7O0FBQTZCO0VBQXdDOzs7QUFBVTtFQUE0Rzs7O0FBQWtCO0VBQWtIO0VBQWtCO0VBQVM7RUFBVTtFQUFxQjtFQUFVO0VBQXdCO0VBQXlCOzs7QUFBWTtFQUE4RztFQUF5Qjs7O0FBQTRCO0VBQThHO0VBQTBCOzs7QUFBNkI7RUFBb0k7RUFBeUI7OztBQUE0QjtFQUFvSTtFQUEwQjs7O0FBQTZCO0VBQTBIOzs7QUFBVztFQUF3RTs7O0FBQW1CO0VBQWdIOzs7QUFBVTtFQUF5Qzs7O0FBQVU7RUFBa0g7OztBQUFnQjtFQUE0RztFQUE2Qjs7O0FBQTRCO0VBQTRHO0VBQXlCOzs7QUFBMEI7RUFBOEg7OztBQUFrQjtFQUFvSTtFQUFrQjtFQUFTO0VBQVU7RUFBcUI7RUFBdUI7RUFBVztFQUF5Qjs7O0FBQVk7RUFBYTs7O0FBQWM7RUFBa0o7RUFBMkI7OztBQUEwQjtFQUFzSztFQUEyQjs7O0FBQTBCO0VBQW9EO0VBQWdCOzs7QUFBaUI7RUFBc0U7RUFBaUI7OztBQUFjO0VBQXFCO0VBQXNCO0VBQVM7RUFBVTtFQUFzQjtFQUFlO0VBQTBCO0VBQW1CO0VBQWdCO0VBQTZCOzs7QUFBZ0I7RUFBNEI7RUFBYTtFQUF5Qjs7O0FBQWU7RUFBNkQ7OztBQUFlO0VBQThEO0VBQWU7OztBQUFnQjtFQUE2RDs7O0FBQWdCO0VBQXVDO0VBQWdCO0VBQVM7RUFBNkI7OztBQUFnQjtFQUE2SDs7O0FBQVc7RUFBd0Q7OztBQUFjO0VBQTJEOzs7QUFBVztFQUEwQjs7O0FBQWtCO0VBQXNEO0VBQWtCOzs7QUFBaUI7RUFBNEM7OztBQUEwQjtFQUE4Qzs7O0FBQWE7RUFBaUQ7RUFBWTtFQUFVOzs7QUFBaUI7RUFBa0Q7OztBQUFvQjtFQUE0QztFQUFjO0VBQVc7RUFBaUI7RUFBZ0I7OztBQUFTO0VBQWdJOzs7QUFBVTtFQUFnRTtFQUFZO0VBQXFCOzs7QUFBaUI7RUFBb0U7OztBQUFhO0VBQTZGOzs7QUFBbUI7RUFBb0c7OztBQUFhO0VBQXdaOzs7QUFBbUI7RUFBd2hCOzs7QUFBYztFQUFzRTtFQUFjO0VBQVc7RUFBWTtFQUFhO0VBQWtCO0VBQVM7RUFBNkI7RUFBZ0I7OztBQUEwQjtFQUE0RTtFQUFpQjs7O0FBQXFCO0VBQThFO0VBQWdCO0VBQVc7RUFBWTtFQUFnQjtFQUFzQjtFQUFtQjs7O0FBQWdCO0VBQTRFOzs7QUFBcUI7RUFBNEc7OztBQUFzQjtFQUF5QztJQUE0Qjs7RUFBYztJQUE2RDs7RUFBVTtJQUE4RDs7RUFBc0I7SUFBNkQ7SUFBVztJQUFlOztFQUFjO0lBQW1FO0lBQVU7OztBQUFtQjtFQUF5Qjs7O0FBQWM7RUFBNks7RUFBaUI7OztBQUFjO0VBQW9FOzs7QUFBZ0I7RUFBd0Y7OztBQUFxQjtFQUFzRzs7O0FBQWlCO0VBQVU7RUFBc0I7RUFBUztFQUFVO0VBQXNCO0VBQWU7RUFBMEI7RUFBbUI7RUFBZ0I7RUFBNkI7RUFBa0I7RUFBZ0I7OztBQUFrQjtFQUFjOzs7QUFBYztFQUFvQjtFQUFlOzs7QUFBMkM7RUFBMEI7RUFBeUI7OztBQUFxRztFQUFtQjs7O0FBQXlCO0VBQWU7RUFBZ0I7RUFBbUI7RUFBZTtFQUFzQjtFQUFnQjtFQUFlO0VBQXVCO0VBQWdDOzs7QUFBMEI7RUFBMkM7RUFBYzs7O0FBQVc7RUFBcUI7OztBQUFXO0VBQXVCO0VBQWE7OztBQUFtQjtFQUFxQjtFQUFxQjtFQUFPO0VBQWU7RUFBZ0I7RUFBbUI7OztBQUF1QjtFQUF1RjtFQUFPO0VBQWE7OztBQUFnQjtFQUE2QjtFQUFXO0VBQW9CO0VBQXNCO0VBQWdCOzs7QUFBZTtFQUFpQzs7O0FBQWdDO0VBQWdCO0VBQWlCO0VBQWU7RUFBc0I7RUFBZ0I7OztBQUFlO0VBQThCO0VBQWtCOzs7QUFBYztFQUFlOzs7QUFBYTtFQUEyQztFQUFjOzs7QUFBVztFQUFxQjs7O0FBQVc7RUFBc0M7RUFBYTs7O0FBQWU7RUFBNkQ7RUFBcUI7OztBQUFVO0VBQWU7RUFBYTtFQUFhO0VBQVM7RUFBZ0I7RUFBbUg7OztBQUFtQjtFQUErQjtFQUFrQjtFQUFVOzs7QUFBcUc7RUFBMkQ7RUFBZ0I7OztBQUFpQjtFQUFzRDs7O0FBQWlCO0VBQW1DO0VBQWdCO0VBQWtCOzs7QUFBaUI7RUFBa0I7RUFBYzs7O0FBQVc7RUFBb0I7OztBQUEwQjtFQUFrQjtFQUFhO0VBQVM7RUFBVTtFQUFnQjtFQUFnQjs7O0FBQTZCO0VBQWlEO0VBQWM7OztBQUFXO0VBQXdCOzs7QUFBVztFQUFxQjtFQUFjO0VBQXNCOzs7QUFBa0I7RUFBMEI7RUFBa0I7RUFBYztFQUFlO0VBQWU7RUFBbUI7OztBQUFlO0VBQWdDO0VBQWM7OztBQUFxQjtFQUE2RTtFQUFxQjtFQUFXO0VBQXNCO0VBQWlCOzs7QUFBcUI7RUFBeUY7OztBQUFjO0VBQW1DO0VBQWU7OztBQUFpQjtFQUFzQzs7O0FBQStCO0VBQW9EO0VBQWtCOzs7QUFBOEI7RUFBb0M7RUFBZTs7O0FBQW1CO0VBQTBDO0VBQWU7OztBQUFlO0VBQW9DOzs7QUFBa0I7RUFBcUM7OztBQUFpQjtFQUFlO0VBQWE7OztBQUFjO0VBQTJDO0VBQWM7OztBQUFXO0VBQXFCOzs7QUFBVztFQUFzQjs7O0FBQW1CO0VBQW9DO0VBQWdCOzs7QUFBa0I7RUFBc0I7RUFBTzs7O0FBQWdCO0VBQTJDOzs7QUFBa0I7RUFBcUI7RUFBZ0I7RUFBc0I7RUFBZ0I7RUFBZTtFQUFtQjs7O0FBQXVCO0VBQTJCOzs7QUFBc0I7RUFBa0I7OztBQUFnQjtFQUFpQztFQUF5QjtFQUFzQjtFQUFxQjs7O0FBQWlCO0VBQStCO0VBQWdCO0VBQWU7OztBQUFlO0VBQTJFOzs7QUFBYztFQUFzRTtFQUFjOzs7QUFBZTtFQUErQjs7O0FBQWE7RUFBYztFQUFzQjtFQUFTO0VBQVU7RUFBc0I7RUFBZTtFQUEwQjtFQUFtQjtFQUFnQjs7O0FBQTZCO0VBQTRCO0VBQWtCO0VBQWM7RUFBc0I7RUFBbUI7RUFBMkI7OztBQUF3QztFQUEwQjtFQUFrQjtFQUFjO0VBQVM7RUFBVTs7O0FBQWdCO0VBQWdDOzs7QUFBYTtFQUFtQzs7O0FBQWU7RUFBdUM7OztBQUFvQjtFQUE2SDs7O0FBQWtCO0VBQW9EOzs7QUFBb0I7RUFBdUo7OztBQUFtQjtFQUErQzs7O0FBQXNCO0VBQWlGO0VBQXdCOzs7QUFBbUI7RUFBMkI7RUFBa0I7RUFBTTtFQUFPOzs7QUFBYztFQUFtRTtFQUFjOzs7QUFBVztFQUFpQzs7O0FBQVc7RUFBMEM7OztBQUFrQjtFQUEyQjtFQUFhO0VBQVc7RUFBWTs7O0FBQWU7RUFBK0I7OztBQUFjO0VBQTZDOzs7QUFBYTtFQUF3Qzs7O0FBQW9CO0VBQThDOzs7QUFBYztFQUEwQzs7O0FBQWtCO0VBQTJDO0VBQWM7OztBQUFZO0VBQXdDOzs7QUFBYTtFQUFvRDtFQUFrQjtFQUFRO0VBQWM7RUFBVztFQUFZO0VBQWlCO0VBQVU7RUFBWTtFQUFjO0VBQVM7OztBQUFlO0VBQW9MO0VBQWtCO0VBQXVCOzs7QUFBYTtFQUE0Sjs7O0FBQVU7RUFBZ0c7OztBQUFZO0VBQTBCOzs7QUFBVztFQUFpQzs7O0FBQVk7RUFBMEI7OztBQUFZO0VBQWlDOzs7QUFBWTtFQUEwQjtFQUFrQjtFQUFRO0VBQVM7RUFBTztFQUFXO0VBQXVCO0VBQXVCO0VBQWlCO0VBQWdCO0VBQWdCO0VBQWU7OztBQUFnQjtFQUFpQzs7O0FBQVk7RUFBOEI7RUFBUzs7O0FBQVk7RUFBNkI7RUFBa0I7RUFBcUI7RUFBYztFQUF1QjtFQUFXO0VBQVc7RUFBYTtFQUFVO0VBQWtCO0VBQW1CO0VBQW1COzs7QUFBbUI7RUFBb0M7RUFBa0I7RUFBYztFQUFXO0VBQVc7RUFBVTtFQUFrQjtFQUFZO0VBQWdCO0VBQVM7RUFBa0I7RUFBYTtFQUFlO0VBQVc7OztBQUFtQjtFQUFvRjs7O0FBQVk7RUFBMEM7RUFBa0I7RUFBUztFQUFXO0VBQVk7RUFBVTs7O0FBQVc7RUFBMEM7OztBQUFXO0VBQWlEO0VBQWdCOzs7QUFBVTtFQUFnRzs7O0FBQVU7RUFBbUM7RUFBUTtFQUFZO0VBQXNCO0VBQVU7RUFBWTtFQUFTOzs7QUFBMkI7RUFBd0M7RUFBVzs7O0FBQVU7RUFBeUM7RUFBVzs7O0FBQVU7RUFBc0M7RUFBVTtFQUFZO0VBQWE7OztBQUF3QjtFQUE2QztFQUFVOzs7QUFBWTtFQUE2RztFQUFVOzs7QUFBWTtFQUFrQjs7O0FBQWM7RUFBNkM7RUFBUTs7O0FBQVU7RUFBNEM7RUFBWTs7O0FBQVU7RUFBbUQ7OztBQUFZO0VBQTRDO0VBQVc7OztBQUFXO0VBQW1EOzs7QUFBWTtFQUEyQzs7O0FBQTJCO0VBQW9EOzs7QUFBc0I7RUFBdUI7RUFBc0I7RUFBUztFQUFVO0VBQXNCO0VBQWU7RUFBMEI7RUFBbUI7RUFBZ0I7RUFBNkI7RUFBa0I7RUFBUztFQUFjO0VBQW1CO0VBQWE7OztBQUFlO0VBQTRMOzs7QUFBcUI7RUFBcUM7RUFBa0I7RUFBTTtFQUFPO0VBQVc7RUFBWTtFQUF5QjtFQUFrQjtFQUFrQjtFQUE2QztFQUE4Qjs7O0FBQVc7RUFBcUc7OztBQUFtQjtFQUE2QjtFQUFrQjtFQUFNO0VBQU87RUFBYztFQUFXO0VBQVk7RUFBYztFQUFzQjtFQUF5QjtFQUFrQjtFQUF5Qjs7O0FBQW1CO0VBQW1DO0VBQWtCO0VBQVE7RUFBVztFQUFjO0VBQW1CO0VBQW9CO0VBQXNCO0VBQWE7RUFBYztFQUFzRDtFQUFVO0VBQTZEOzs7QUFBWTtFQUE2QjtFQUFrQjtFQUFNO0VBQVE7RUFBUztFQUFPO0VBQVU7RUFBVztFQUFZO0VBQWU7OztBQUFVO0VBQWtFO0VBQWtCO0VBQWM7RUFBc0I7RUFBYTtFQUFjO0VBQXNEO0VBQVU7RUFBcUQ7OztBQUFZO0VBQTREO0VBQXlCOzs7QUFBcUI7RUFBZ0M7OztBQUFtQjtFQUFpRztFQUE2Qjs7O0FBQW9CO0VBQTZEO0VBQW1COzs7QUFBb0I7RUFBNkQ7RUFBeUI7OztBQUErQjtFQUFtRTtFQUFxQjtFQUF5Qjs7O0FBQW9CO0VBQXFDO0VBQXNCOzs7QUFBbUI7RUFBdUg7OztBQUFrQjtFQUErQjtFQUFzQjtFQUFTO0VBQVU7RUFBc0I7RUFBZTtFQUEwQjtFQUFtQjtFQUFnQjtFQUE2QjtFQUFvQjtFQUFxQjtFQUFrQjs7O0FBQWU7RUFBcUM7RUFBcUI7RUFBUTtFQUFnQjs7O0FBQWM7RUFBc0U7OztBQUFtQjtFQUE4RDs7O0FBQWdCO0VBQStGO0VBQVc7OztBQUFZO0VBQTRCO0VBQWtCOzs7QUFBaUI7RUFBNkI7RUFBc0I7RUFBUztFQUFVO0VBQXNCO0VBQWU7RUFBMEI7RUFBbUI7RUFBZ0I7RUFBNkI7OztBQUFxQjtFQUFrQzs7O0FBQWlCO0VBQTZDOzs7QUFBZTtFQUFvRTs7O0FBQWM7RUFBa0U7RUFBc0I7OztBQUFxQjtFQUF3RTtFQUFRO0VBQVM7RUFBVTtFQUFXO0VBQXlCO0VBQVM7RUFBd0M7RUFBVTs7O0FBQVk7RUFBdUc7RUFBaUM7OztBQUE2QjtFQUFjOzs7QUFBWTtFQUF1QjtFQUFNOzs7QUFBaUI7RUFBb0I7RUFBYTtFQUFpQjs7O0FBQXVCO0VBQStEO0VBQVc7OztBQUFZO0VBQW1CO0VBQVk7RUFBZ0I7RUFBYTtFQUFjO0VBQWM7RUFBYztFQUFtQjtFQUFnQjtFQUErQjs7O0FBQTRDO0VBQXdCO0VBQWE7RUFBaUI7RUFBbUI7RUFBaUI7RUFBZ0I7RUFBaUI7RUFBbUI7RUFBdUI7RUFBZTs7O0FBQW1CO0VBQThCOzs7QUFBbUI7RUFBaUM7RUFBc0I7OztBQUFtQjtFQUF1Qzs7O0FBQXVCO0VBQWlEO0VBQXNCO0VBQWU7OztBQUFvQjtFQUFnSjtFQUFnQjs7O0FBQXlCO0VBQWdDOzs7QUFBVTtFQUF3RztFQUFnQjtFQUFzQjs7O0FBQWU7RUFBd0s7OztBQUFzQjtFQUFnQzs7O0FBQWM7RUFBb0c7OztBQUFrQjtFQUE4Rjs7O0FBQWlCO0VBQW9HOzs7QUFBVTtFQUFxQzs7O0FBQVU7RUFBbUg7OztBQUFnQjtFQUFpSjtFQUEwQjs7O0FBQTZCO0VBQTRSO0VBQXlCOzs7QUFBNEI7RUFBMkk7RUFBMEI7OztBQUE2QjtFQUE2RztFQUFpQjs7O0FBQWM7RUFBeUM7RUFBTTtFQUFlOzs7QUFBZ0I7RUFBYztFQUFzQjtFQUFTO0VBQVU7RUFBc0I7RUFBZTtFQUEwQjtFQUFtQjtFQUFnQjtFQUE2QjtFQUFrQjtFQUFTO0VBQWM7RUFBbUI7RUFBYTs7O0FBQWU7RUFBc0k7OztBQUFxQjtFQUE0QjtFQUFrQjtFQUFNO0VBQU87RUFBVztFQUFZO0VBQXlCO0VBQWtCO0VBQWtCO0VBQTZDO0VBQThCOzs7QUFBVztFQUEwRTs7O0FBQW1CO0VBQW9CO0VBQWtCO0VBQU07RUFBTztFQUFjO0VBQVc7RUFBWTtFQUFjO0VBQXNCO0VBQXlCO0VBQWtCO0VBQXlCOzs7QUFBbUI7RUFBMEI7RUFBa0I7RUFBUTtFQUFXO0VBQWM7RUFBbUI7RUFBb0I7RUFBc0I7RUFBYTtFQUFjO0VBQXNEO0VBQVU7RUFBNkQ7OztBQUFZO0VBQW9CO0VBQWtCO0VBQU07RUFBUTtFQUFTO0VBQU87RUFBVTtFQUFXO0VBQVk7RUFBZTs7O0FBQVU7RUFBZ0Q7RUFBa0I7RUFBYztFQUFzQjtFQUFhO0VBQWM7RUFBc0Q7RUFBVTtFQUFxRDs7O0FBQVk7RUFBMEM7RUFBeUI7OztBQUFxQjtFQUF1Qjs7O0FBQW1CO0VBQXNFO0VBQTZCOzs7QUFBb0I7RUFBMkM7RUFBbUI7OztBQUFvQjtFQUEyQztFQUF5Qjs7O0FBQStCO0VBQWlEO0VBQXFCO0VBQXlCOzs7QUFBb0I7RUFBNEI7RUFBc0I7OztBQUFtQjtFQUE0Rjs7O0FBQWtCO0VBQXNCO0VBQXNCO0VBQVM7RUFBVTtFQUFzQjtFQUFlO0VBQTBCO0VBQW1CO0VBQWdCO0VBQTZCO0VBQW9CO0VBQXFCO0VBQWtCOzs7QUFBZTtFQUE0QjtFQUFxQjtFQUFRO0VBQWdCOzs7QUFBYztFQUFvRDs7O0FBQW1CO0VBQTRDOzs7QUFBZ0I7RUFBNkU7RUFBVzs7O0FBQVk7RUFBbUI7RUFBa0I7OztBQUFpQjtFQUFvQjtFQUFzQjtFQUFTO0VBQVU7RUFBc0I7RUFBZTtFQUEwQjtFQUFtQjtFQUFnQjtFQUE2Qjs7O0FBQXFCO0VBQXlCOzs7QUFBaUI7RUFBb0M7OztBQUFlO0VBQWtEOzs7QUFBYztFQUFnRDtFQUFzQjs7O0FBQXFCO0VBQXNEO0VBQVE7RUFBUztFQUFVO0VBQVc7RUFBeUI7RUFBUztFQUF3QztFQUFVOzs7QUFBWTtFQUE0RTtFQUFpQzs7O0FBQTZCO0VBQWtCOzs7QUFBYztFQUFpRDtFQUFlOzs7QUFBZ0I7RUFBNEQ7OztBQUF3QjtFQUEwRTs7O0FBQWdCO0VBQWM7RUFBc0I7RUFBUztFQUFVO0VBQXNCO0VBQWU7RUFBMEI7RUFBbUI7RUFBZ0I7RUFBNkI7RUFBeUI7RUFBeUI7RUFBZ0I7OztBQUFrQjtFQUFpQzs7O0FBQWdDO0VBQTZHOzs7QUFBMEI7RUFBc0Q7RUFBa0I7RUFBYTtFQUFpQjtFQUF1QjtFQUFrQjtFQUFzQjtFQUFtQjtFQUFlOzs7QUFBaUM7RUFBMEU7RUFBcUI7RUFBa0I7RUFBZTs7O0FBQW9CO0VBQThFOzs7QUFBMEI7RUFBZ0Y7OztBQUFVO0VBQTBFOzs7QUFBaUI7RUFBNEQ7OztBQUFhO0VBQXVFOzs7QUFBZTtFQUFpRztFQUFVOzs7QUFBZTtFQUFxRTs7O0FBQWU7RUFBK0Y7OztBQUFlO0VBQTRFOzs7QUFBa0I7RUFBd0U7RUFBa0I7OztBQUE0QjtFQUE0RjtFQUFrQjtFQUFRO0VBQVc7RUFBVTtFQUFTOzs7QUFBMkI7RUFBc0I7RUFBc0I7RUFBc0I7OztBQUE2QjtFQUFnRDs7O0FBQWE7RUFBNkI7OztBQUFhO0VBQW9EOzs7QUFBMEI7RUFBeUI7RUFBeUI7OztBQUFTO0VBQTRDOzs7QUFBZ0M7RUFBbUk7OztBQUFnQjtFQUF1RDs7O0FBQWdCO0VBQWtFO0VBQTZCOzs7QUFBYTtFQUE0Rjs7O0FBQWdCO0VBQW9CO0VBQTZCOzs7QUFBUztFQUF1Qzs7O0FBQWdCO0VBQTZEO0VBQTZCOzs7QUFBYTtFQUF1RjtFQUFpQjs7O0FBQW9CO0VBQXFJO0VBQXNCOzs7QUFBbUI7RUFBa0I7OztBQUFjO0VBQXNHO0VBQWtCOzs7QUFBNEI7RUFBMEg7RUFBa0I7RUFBUTtFQUFXO0VBQVU7RUFBUzs7O0FBQTJCO0VBQXdFOzs7QUFBNEI7RUFBMkY7RUFBZTs7O0FBQWlCO0VBQStGOzs7QUFBeUI7RUFBMkY7RUFBa0I7OztBQUFjO0VBQTZGO0VBQW1COzs7QUFBZTtFQUFhO0VBQWtCOzs7QUFBeUI7RUFBbUI7RUFBYTs7O0FBQWU7RUFBb0I7RUFBa0I7RUFBYztFQUFrQjs7O0FBQWU7RUFBd0I7RUFBVztFQUFZOzs7QUFBa0I7RUFBcUI7RUFBa0I7RUFBYztFQUFjO0VBQWU7OztBQUFxQjtFQUE0QjtFQUFhO0VBQWU7RUFBMkI7RUFBa0I7OztBQUFlO0VBQStEO0VBQWtCO0VBQWU7OztBQUFpQjtFQUFpQztFQUFzQjtFQUFlOzs7QUFBcUI7RUFBMkU7OztBQUFzQjtFQUFpQztFQUFXO0VBQW1COzs7QUFBWTtFQUE4QjtFQUFzQjs7O0FBQXFCO0VBQXFCO0VBQWdCO0VBQXNCOzs7QUFBZTtFQUF3QjtFQUFxQjs7O0FBQXNCO0VBQTZCO0VBQWtCO0VBQXNCO0VBQWU7RUFBZTtFQUFxQjtFQUF5QjtFQUFzQjtFQUFxQjs7O0FBQWlCO0VBQW1DOzs7QUFBYztFQUFvQjs7O0FBQWlCO0VBQWlCOzs7QUFBYztFQUFxQztFQUFlOzs7QUFBaUI7RUFBaUc7RUFBZ0I7OztBQUFpQjtFQUFzQzs7O0FBQWdCO0VBQThDO0VBQWU7OztBQUFpQjtFQUFxQztFQUFrQjs7O0FBQWM7RUFBOEY7RUFBc0I7OztBQUFxQjtFQUFzRjtFQUFxQjtFQUF3QztFQUF1Qjs7O0FBQVU7RUFBMkQ7OztBQUFtQjtFQUFrRztFQUFzQjs7O0FBQXFCO0VBQTBGO0VBQXFCO0VBQXlDO0VBQXVCOzs7QUFBVTtFQUE2RDs7O0FBQW1CO0VBQVk7RUFBc0I7RUFBUztFQUFzQjtFQUFlO0VBQTBCO0VBQW1CO0VBQWdCO0VBQTZCO0VBQWlCO0VBQWtCO0VBQW9CO0VBQW1CO0VBQWdCO0VBQXlCO0VBQWtCOzs7QUFBcUM7RUFBc0M7RUFBcUI7OztBQUF1QjtFQUFvQjtFQUF5Qzs7O0FBQVU7RUFBZ0M7RUFBbUI7RUFBcUI7OztBQUFtQjtFQUFtRDs7O0FBQXNCO0VBQWtDO0VBQXVDO0VBQW1DOzs7QUFBMEI7RUFBa0I7RUFBa0I7RUFBb0I7RUFBbUI7OztBQUFXO0VBQXdCO0VBQWtCO0VBQXFCO0VBQVc7RUFBWTtFQUFzQjtFQUFlO0VBQW1CO0VBQXNCO0VBQXNCO0VBQWtCO0VBQW1CO0VBQVU7RUFBYztFQUFZO0VBQVU7RUFBdUI7OztBQUFTO0VBQTBDO0VBQWM7RUFBc0I7OztBQUFpQjtFQUE4QztFQUFjO0VBQXFCOzs7QUFBaUI7RUFBcUM7RUFBYztFQUF5QjtFQUFzQjtFQUFxQjs7O0FBQWlCO0VBQStDOzs7QUFBdUI7RUFBOEM7OztBQUF1QjtFQUEwQzs7O0FBQXVCO0VBQThCO0VBQXFCOzs7QUFBdUI7RUFBOEQ7RUFBcUI7RUFBeUM7RUFBdUI7OztBQUFVO0VBQWlDO0VBQXNCO0VBQXlCO0VBQXFCO0VBQWdCO0VBQW1COzs7QUFBVTtFQUF1QztFQUFxQjs7O0FBQXVCO0VBQWtDO0VBQXNCO0VBQXlCO0VBQXFCO0VBQWdCO0VBQW1COzs7QUFBVTtFQUF3QztFQUFxQjs7O0FBQXVCO0VBQXlQO0VBQTZCO0VBQVk7OztBQUFnQjtFQUFnQztFQUFlO0VBQVk7RUFBZ0I7RUFBbUI7RUFBc0I7OztBQUE2QjtFQUEyQjtFQUFtQjs7O0FBQWU7RUFBMkI7OztBQUFjO0VBQThCOzs7QUFBZ0I7RUFBa0M7OztBQUF1QjtFQUEwQzs7O0FBQVU7RUFBb0M7OztBQUFjO0VBQWtCOzs7QUFBbUI7RUFBMEM7OztBQUFlO0VBQWtCOzs7QUFBYztFQUFtQjtFQUFhO0VBQVU7RUFBa0I7RUFBZ0I7RUFBc0I7RUFBYzs7O0FBQW9CO0VBQXFCOzs7QUFBbUI7RUFBcUM7OztBQUFpQjtFQUFrQjtFQUFrQjtFQUFRO0VBQVE7RUFBc0I7RUFBYztFQUFnQjtFQUEyQjtFQUFlO0VBQVU7OztBQUFpQztFQUFvQjs7O0FBQW1CO0VBQXdCOzs7QUFBc0I7RUFBc0I7RUFBa0I7RUFBcUI7RUFBVTtFQUFZO0VBQXNCO0VBQWU7RUFBbUI7OztBQUFlO0VBQTBDOzs7QUFBc0I7RUFBdUU7OztBQUFtQjtFQUFrQjtFQUFrQjs7O0FBQW9CO0VBQW9DOzs7QUFBVztFQUEwQzs7O0FBQVU7RUFBeUM7RUFBWTtFQUFXO0VBQWlCO0VBQW1CO0VBQVU7RUFBNEI7OztBQUFvQjtFQUE0RDs7O0FBQVU7RUFBNEI7RUFBbUI7RUFBYzs7O0FBQWM7RUFBcUQ7OztBQUFVO0VBQTBEOzs7QUFBZ0I7RUFBcUI7RUFBc0I7RUFBUztFQUFVO0VBQXNCO0VBQWU7RUFBMEI7RUFBbUI7RUFBZ0I7RUFBNkI7RUFBa0I7RUFBWTtFQUFhOzs7QUFBYTtFQUE0Qjs7O0FBQWE7RUFBa0U7RUFBaUI7RUFBYzs7O0FBQTBDO0VBQStEO0VBQW9CO0VBQWM7OztBQUF3QjtFQUFzYTs7O0FBQThCO0VBQWtiOzs7QUFBNEI7RUFBaU47OztBQUErQjtFQUF1Tjs7O0FBQTZCO0VBQTJCOzs7QUFBdUI7RUFBa0M7OztBQUFhO0VBQThEOzs7QUFBZ0I7RUFBbUI7RUFBZ0I7RUFBaUI7RUFBZ0I7RUFBaUI7RUFBZ0I7OztBQUFnQjtFQUFzQjs7O0FBQXFCO0VBQW9EO0VBQWM7RUFBbUI7RUFBcUI7OztBQUFlO0VBQWtDO0VBQVk7OztBQUFnQjtFQUEwQjs7O0FBQWE7RUFBd0I7RUFBa0I7RUFBVTtFQUFhO0VBQW1CO0VBQW9CO0VBQW1CO0VBQTJDO0VBQTZCO0VBQXNCOzs7QUFBb0I7RUFBK0I7RUFBa0I7RUFBa0I7RUFBbUI7RUFBbUI7RUFBb0I7RUFBZ0I7RUFBNEI7RUFBZ0M7RUFBVztFQUFpQztFQUF5QjtFQUFzWDs7O0FBQThXO0VBQTRCO0VBQWdCO0VBQW1CO0VBQWdCO0VBQWtCO0VBQXNHOzs7QUFBc0I7RUFBK0M7RUFBb0I7RUFBaUI7OztBQUFjO0VBQThDO0VBQW1CO0VBQXVCO0VBQXFCOzs7QUFBZ0I7RUFBc0g7OztBQUFrQjtFQUFzRDs7O0FBQXFCO0VBQThGOzs7QUFBa0I7RUFBd0Y7OztBQUFpQjtFQUEwSTs7O0FBQVU7RUFBbUM7OztBQUFVO0VBQTJHOzs7QUFBZ0I7RUFBdUk7RUFBMEI7OztBQUE2QjtFQUF3UTtFQUF5Qjs7O0FBQTRCO0VBQWlJO0VBQTBCOzs7QUFBNkI7RUFBa0I7RUFBb0I7RUFBc0I7RUFBa0I7RUFBZ0I7RUFBeUI7RUFBa0I7OztBQUFhO0VBQTBCOzs7QUFBcUI7RUFBdUs7RUFBYTtFQUFzQjs7O0FBQVk7RUFBbUI7RUFBYTtFQUFjO0VBQXNCOzs7QUFBZ0M7RUFBcUI7OztBQUFVO0VBQTBCO0VBQVU7RUFBc0I7RUFBaUI7RUFBdUI7RUFBUztFQUFlOzs7QUFBcUI7RUFBMEI7RUFBZ0I7OztBQUFlO0VBQWdDOzs7QUFBc0I7RUFBd0I7RUFBVTtFQUFnQjs7O0FBQWlCO0VBQStCO0VBQWM7OztBQUFvQjtFQUFpRDs7O0FBQWdCO0VBQXFDOzs7QUFBYztFQUFvRztFQUFrQjtFQUFxQjtFQUFVOzs7QUFBVztFQUFnSTtFQUFrQjtFQUFNO0VBQU87RUFBcUI7RUFBVTtFQUFXO0VBQWU7RUFBNkI7OztBQUFXO0VBQW9FO0VBQWtCO0VBQVE7RUFBUztFQUFxQjtFQUFVO0VBQVc7RUFBZTtFQUE2Qjs7O0FBQVc7RUFBa0Q7OztBQUF5QjtFQUFrRDs7O0FBQXlCO0VBQW9CO0VBQVc7RUFBbUI7OztBQUF5QjtFQUE4QztFQUFrQjtFQUFlOzs7QUFBZ0I7RUFBdUI7RUFBWTtFQUFzQjs7O0FBQWlCO0VBQWlCO0VBQWM7RUFBc0I7OztBQUFlO0VBQXlCOzs7QUFBc0I7RUFBd0I7RUFBa0I7RUFBUTtFQUFRO0VBQU87RUFBVTtFQUFZO0VBQTJCO0VBQW1COzs7QUFBVztFQUF5Uzs7O0FBQW1CO0VBQTZFO0VBQWtCO0VBQU07RUFBUTtFQUFTO0VBQU87RUFBVTtFQUF5QjtFQUFrQjs7O0FBQVc7RUFBa0Q7OztBQUFrQjtFQUF5RDs7O0FBQW1CO0VBQStOO0VBQVc7OztBQUFtQjtFQUFzTTs7O0FBQW1CO0VBQTREOzs7QUFBUztFQUEwRDs7O0FBQVU7RUFBdzVCO0VBQWtCO0VBQVE7RUFBVTtFQUFZO0VBQThCO0VBQWlDO0VBQTJCO0VBQW1COzs7QUFBVztFQUFtSDtFQUFROzs7QUFBUztFQUE2eEI7OztBQUFtQjtFQUFxSjs7O0FBQTBCO0VBQW1KOzs7QUFBMEI7RUFBOFE7RUFBa0I7RUFBTTtFQUFTO0VBQVc7RUFBbUI7RUFBbUI7OztBQUFXO0VBQXdJO0VBQVc7OztBQUFPO0VBQXNJO0VBQVE7OztBQUFVO0VBQStEOzs7QUFBVTtFQUE2RDs7O0FBQVM7RUFBcWU7RUFBUztFQUErQjtFQUEyQjs7O0FBQThCO0VBQXlkO0VBQVU7RUFBZ0M7RUFBNEI7OztBQUErQjtFQUEwQjtFQUFzQjs7O0FBQW9CO0VBQWlEOzs7QUFBdUI7RUFBaUM7OztBQUEyQjtFQUE4RTs7O0FBQTZCO0VBQWtMOzs7QUFBYTtFQUE4TDs7O0FBQWM7RUFBOEM7OztBQUFZO0VBQW1CO0VBQXVCO0VBQWtCO0VBQWU7RUFBaUI7RUFBa0I7OztBQUFvQztFQUFxQzs7O0FBQTZCO0VBQXlCO0VBQWU7RUFBaUI7OztBQUFnQjtFQUEwQzs7O0FBQWdDO0VBQWdCOzs7QUFBZ0I7RUFBc0I7OztBQUFjO0VBQTRCOzs7QUFBYztFQUE2Qjs7O0FBQWM7RUFBb0Q7RUFBc0I7OztBQUFtQjtFQUFnRDs7O0FBQWM7RUFBaUQ7OztBQUFhO0VBQTRIOzs7QUFBYztFQUE4STs7O0FBQVc7RUFBb007RUFBVTtFQUErQjs7O0FBQTBCO0VBQW9jO0VBQVc7RUFBZ0M7OztBQUEwQjtFQUFnUTtFQUFVO0VBQStCOzs7QUFBMEI7RUFBd0M7OztBQUFpQjtFQUE0TTs7O0FBQWlDO0VBQThCOzs7QUFBMEI7RUFBb0M7OztBQUFtQjtFQUFvRjs7O0FBQW1CO0VBQThIOzs7QUFBeUI7RUFBNEw7OztBQUFrQjtFQUFrSTs7O0FBQVc7RUFBd0M7OztBQUFpQjtFQUEyQzs7O0FBQVk7RUFBOEM7OztBQUFXO0VBQTJCOzs7QUFBYTtFQUFrRDs7O0FBQThCO0VBQW9HOzs7QUFBdUI7RUFBa0g7OztBQUFXO0VBQWdJOzs7QUFBVTtFQUF1QjtFQUFXOzs7QUFBZTtFQUEyQztFQUFhO0VBQVU7OztBQUFhO0VBQThCO0VBQWM7RUFBVztFQUFTO0VBQVU7RUFBa0I7RUFBZ0I7RUFBZ0I7OztBQUEwQjtFQUFvQztFQUFjO0VBQWE7OztBQUFXO0VBQStEOzs7QUFBYTtFQUFnRDs7O0FBQThCO0VBQXFDOzs7QUFBZ0M7RUFBb0M7OztBQUFnQjtFQUFpQztFQUFTOzs7QUFBVTtFQUE4RjtFQUFjO0VBQVc7RUFBWTtFQUFTO0VBQW1CO0VBQXNCO0VBQWlCO0VBQWdCO0VBQWU7OztBQUEwQjtFQUFvRzs7O0FBQW1CO0VBQXVHOzs7QUFBbUI7RUFBdUc7RUFBc0I7RUFBdUI7OztBQUFtQjtFQUF3VDs7O0FBQWU7RUFBZ0I7OztBQUFjO0VBQW1DO0VBQWlCOzs7QUFBYztFQUFrQztFQUFXOzs7QUFBTztFQUFzQzs7O0FBQXlCO0VBQXVFO0VBQWlCOzs7QUFBYztFQUFtRDtFQUFXOzs7QUFBVTtFQUF3RDtFQUFrQjs7O0FBQWM7RUFBeUU7OztBQUFpQjtFQUE0Qzs7O0FBQWlCO0VBQTJEO0VBQVc7RUFBaUI7OztBQUFjO0VBQXNCOzs7QUFBYztFQUE4Rjs7O0FBQXlCO0VBQThGOzs7QUFBeUI7RUFBd0M7RUFBa0I7RUFBVTtFQUFxQjtFQUFlO0VBQVk7RUFBaUI7RUFBa0I7OztBQUFxQztFQUFrRjtFQUFVOzs7QUFBTztFQUFnRjtFQUFROzs7QUFBUztFQUE0RztFQUFVOzs7QUFBUztFQUE4SjtFQUFROzs7QUFBVTtFQUE0SjtFQUFXOzs7QUFBTztFQUFxRjtFQUFROzs7QUFBUztFQUFtRjtFQUFVOzs7QUFBTztFQUEySzs7O0FBQTBCO0VBQXlLOzs7QUFBMEI7RUFBOGdCO0VBQVU7RUFBTztFQUFnQztFQUFpQjs7O0FBQTBCO0VBQWlnQjtFQUFRO0VBQVM7RUFBa0I7RUFBK0I7OztBQUEwQjtFQUF3L0I7RUFBVTtFQUFTO0VBQWdDO0VBQStCOzs7QUFBa0I7RUFBa0Q7RUFBYzs7O0FBQWlCO0VBQTZDOzs7QUFBYztFQUF5QjtFQUFhO0VBQW1COzs7QUFBbUI7RUFBd0I7RUFBVTtFQUFnQjtFQUFzQjtFQUFnQjtFQUFlO0VBQW1CO0VBQW1COzs7QUFBdUI7RUFBd0I7RUFBaUI7RUFBc0I7OztBQUFlO0VBQXVCO0VBQVc7OztBQUFrQjtFQUE2QjtFQUFXOzs7QUFBbUI7RUFBa0Q7OztBQUFvQjtFQUFpQzs7O0FBQW1CO0VBQTZCO0VBQXNCO0VBQWdCO0VBQWU7RUFBbUI7OztBQUFpQjtFQUFtQztFQUFZO0VBQWtCO0VBQVU7OztBQUFtQjtFQUFrRTs7O0FBQVk7RUFBc0M7RUFBUzs7O0FBQVc7RUFBK0I7RUFBbUI7RUFBTztFQUFzQjtFQUFlO0VBQW1CO0VBQXNCOzs7QUFBeUI7RUFBdUI7RUFBaUI7OztBQUFtQjtFQUFpQzs7O0FBQWE7RUFBOEg7RUFBb0I7OztBQUFxQjtFQUFvRzs7O0FBQW9CO0VBQWtHOzs7QUFBbUI7RUFBa0Q7OztBQUF5QjtFQUF3RDtFQUFrQjs7O0FBQXlCO0VBQWtIO0VBQWtCOzs7QUFBK0I7RUFBd0k7OztBQUFrQjtFQUF3RDs7O0FBQXlCO0VBQThEOzs7QUFBYTtFQUFpRDs7O0FBQWdDO0VBQTREOzs7QUFBbUI7RUFBa0s7OztBQUFrQjtFQUFnSzs7O0FBQWlCO0VBQXNCOzs7QUFBYztFQUF5RDs7O0FBQW1CO0VBQTRKO0VBQWtCOzs7QUFBOEI7RUFBa0w7OztBQUFpQjtFQUFhO0VBQXNCO0VBQVM7RUFBVTtFQUFzQjtFQUFlO0VBQTBCO0VBQW1CO0VBQWdCO0VBQTZCOzs7QUFBcUM7RUFBc0I7RUFBa0I7RUFBVztFQUFxQjtFQUFZO0VBQWE7RUFBc0I7RUFBYTs7O0FBQXNDO0VBQXdCO0VBQWE7RUFBVztFQUFXO0VBQWU7OztBQUFjO0VBQThDO0VBQWE7RUFBbUI7RUFBYztFQUFzQjtFQUFnQjtFQUFlO0VBQW1CO0VBQWtCO0VBQWE7OztBQUFpQztFQUF5RztFQUFrQjtFQUFVO0VBQWlDO0VBQXlCO0VBQWdCO0VBQTBCOzs7QUFBVztFQUEwRDs7O0FBQVM7RUFBb0g7OztBQUFVO0VBQTBEOzs7QUFBUztFQUF3QjtFQUFxQjs7O0FBQWM7RUFBb0I7RUFBZ0I7RUFBOEI7OztBQUFxQjtFQUErSTs7O0FBQThCO0VBQXlDOzs7QUFBdUI7RUFBeUM7RUFBc0I7RUFBZ0I7OztBQUFlO0VBQXlHOzs7QUFBUTtFQUF3Rzs7O0FBQVc7RUFBMEg7OztBQUFlO0VBQTJHOzs7QUFBVztFQUEwRzs7O0FBQVE7RUFBNEg7OztBQUFnQjtFQUFpQjs7O0FBQWM7RUFBMEU7OztBQUFVO0VBQW9KOzs7QUFBUztFQUEwRTs7O0FBQVU7RUFBWTtFQUFlO0VBQU07RUFBUTtFQUFTO0VBQU87RUFBYTs7O0FBQW9CO0VBQW1COzs7QUFBa0I7RUFBaUI7RUFBa0I7RUFBTTtFQUFRO0VBQVM7RUFBTztFQUFhO0VBQTJCOzs7QUFBb0I7RUFBNEI7RUFBa0I7RUFBYTs7O0FBQW1CO0VBQW1DOzs7QUFBYTtFQUE2QztFQUFNO0VBQVM7RUFBTzs7O0FBQXlHO0VBQThDO0VBQU07RUFBUTtFQUFTOzs7QUFBNEc7RUFBNEM7RUFBTTtFQUFRO0VBQU87OztBQUF5RztFQUErQztFQUFRO0VBQVM7RUFBTzs7O0FBQTRHO0VBQW9CO0VBQVc7RUFBWTtFQUFjO0VBQWdCOzs7QUFBb0I7RUFBeUI7RUFBYTtFQUFzQjtFQUFXOzs7QUFBWTtFQUFtQjtFQUFhO0VBQU87RUFBbUI7RUFBa0I7RUFBZTtFQUFpQjs7O0FBQWdDO0VBQXlCO0VBQWE7RUFBTztFQUFtQjtFQUFZOzs7QUFBYTtFQUFrQjs7O0FBQVU7RUFBa0I7RUFBcUI7RUFBa0I7RUFBc0I7RUFBZ0I7RUFBZTtFQUFrQjtFQUFjO0VBQWtCO0VBQW9CO0VBQXFCO0VBQXVCO0VBQVM7RUFBVTtFQUFlO0VBQXFCOzs7QUFBb0I7RUFBZ0Q7RUFBc0I7OztBQUFxQjtFQUFrQjtFQUFPO0VBQVM7RUFBc0I7RUFBZ0I7RUFBZTs7O0FBQWlCO0VBQWlCO0VBQU87RUFBWTtFQUFhO0VBQWE7OztBQUFjO0VBQW1CO0VBQWM7RUFBa0I7OztBQUE2QjtFQUErRTs7O0FBQWdCO0VBQWtNOzs7QUFBbUI7RUFBNkQ7OztBQUFVO0VBQXlHOzs7QUFBVTtFQUFxQzs7O0FBQVU7RUFBK0g7OztBQUFnQjtFQUFrSTs7O0FBQW1CO0VBQXFGOzs7QUFBc0M7RUFBMkg7OztBQUF3QjtFQUEyQzs7O0FBQTRCO0VBQWtJOzs7QUFBZ0I7RUFBcUk7OztBQUFtQjtFQUF1Rjs7O0FBQXFDO0VBQThIOzs7QUFBd0I7RUFBNEM7OztBQUEyQjtFQUE0SDs7O0FBQWdCO0VBQStIOzs7QUFBbUI7RUFBbUY7OztBQUFzQztFQUF3SDs7O0FBQXdCO0VBQTBDOzs7QUFBNEI7RUFBcUk7OztBQUFnQjtFQUF3STs7O0FBQW1CO0VBQXlGOzs7QUFBcUM7RUFBaUk7OztBQUF3QjtFQUE2Qzs7O0FBQTJCO0VBQWdCOzs7QUFBYztFQUFrQztFQUFlOzs7QUFBaUI7RUFBc0Q7OztBQUFjO0VBQTREO0VBQVc7OztBQUF5QjtFQUFjO0VBQXNCO0VBQVM7RUFBVTtFQUFzQjtFQUFlO0VBQTBCO0VBQW1CO0VBQWdCO0VBQTZCO0VBQWtCO0VBQVk7RUFBYTtFQUFhOzs7QUFBYztFQUFxQjtFQUFrQjtFQUFTO0VBQVE7RUFBWTtFQUFVO0VBQWM7RUFBYzs7O0FBQVk7RUFBbUI7OztBQUFrQjtFQUEwQzs7O0FBQWU7RUFBd0M7OztBQUF5QjtFQUE2Qzs7O0FBQXlCO0VBQWlGOzs7QUFBYTtFQUFxSzs7O0FBQTRCO0VBQThLOzs7QUFBeUI7RUFBb0I7RUFBa0I7RUFBVTtFQUFjO0VBQW1CO0VBQW9CO0VBQXNCOzs7QUFBb0I7RUFBMkI7RUFBa0I7RUFBa0I7RUFBbUI7RUFBbUI7RUFBb0I7RUFBZ0I7RUFBNEI7RUFBZ0M7RUFBVztFQUFpQztFQUF5QjtFQUFzWDs7O0FBQThXO0VBQXlKO0VBQVk7RUFBMkM7OztBQUF3QjtFQUFnRDtFQUFTOzs7QUFBeUM7RUFBb0Q7OztBQUFVO0VBQXFEOzs7QUFBVztFQUFrSztFQUFpQjtFQUEyQzs7O0FBQTRDO0VBQW1EO0VBQVM7OztBQUE2RDtFQUF1RDs7O0FBQVU7RUFBd0Q7OztBQUFXO0VBQW1CO0VBQWtCO0VBQVM7RUFBYztFQUFnQjtFQUFxQjtFQUFzQjtFQUE0QjtFQUFrQjtFQUFhOzs7QUFBc0c7RUFBb0M7RUFBaUI7RUFBc0I7OztBQUFtQjtFQUFpQztFQUFrQjtFQUFhO0VBQXVCO0VBQWdCOzs7QUFBcUI7RUFBd0U7OztBQUFnQjtFQUFvQztFQUFrQjs7O0FBQWlCO0VBQXdCO0VBQWtCO0VBQWE7OztBQUFtQjtFQUE2QjtFQUFlO0VBQWlCOzs7QUFBZTtFQUFpQzs7O0FBQVU7RUFBbUM7RUFBYzs7O0FBQW1CO0VBQXlDOzs7QUFBYztFQUF5QztFQUFrQjtFQUFNO0VBQVE7RUFBUztFQUFPOzs7QUFBVztFQUF5RDtFQUFXO0VBQVM7RUFBaUI7RUFBc0I7RUFBZ0I7RUFBZTtFQUFpQjtFQUFlOzs7QUFBbUI7RUFBMkU7RUFBYzs7O0FBQXlCO0VBQWlVOzs7QUFBeUI7RUFBb1E7RUFBc0I7OztBQUFtQjtFQUE0UjtFQUFzQjtFQUFzQjs7O0FBQW1CO0VBQTRROzs7QUFBb0I7RUFBeUU7RUFBVztFQUFhO0VBQWdCO0VBQWM7OztBQUF5QjtFQUF1STtFQUFrQjs7O0FBQVU7RUFBbU47RUFBeUI7RUFBc0I7RUFBZTs7O0FBQWtCO0VBQW1DO0VBQWE7RUFBVTs7O0FBQWdCO0VBQWlDOzs7QUFBbUI7RUFBb0M7OztBQUFrQjtFQUF1RDtFQUFrQjtFQUFNO0VBQVU7RUFBZTtFQUFnQjs7O0FBQXFCO0VBQW9PO0VBQXNCO0VBQXNCOzs7QUFBbUI7RUFBcUU7OztBQUFjO0VBQXNrQjs7O0FBQTRCO0VBQTRoQjs7O0FBQThCO0VBQWdTOzs7QUFBNkI7RUFBMlE7OztBQUErQjtFQUFnSTtFQUFlOzs7QUFBd0I7RUFBcUI7OztBQUFtQjtFQUFpSDtFQUFlOzs7QUFBb0I7RUFBb0U7OztBQUFjO0VBQWlHO0VBQWtCOzs7QUFBaUI7RUFBbUU7OztBQUFtQjtFQUFrbEI7OztBQUEwQjtFQUFtUDtFQUFXOzs7QUFBdUI7RUFBbUw7RUFBVzs7O0FBQW1CO0VBQWtCOzs7QUFBYztFQUFzQztFQUFXOzs7QUFBTztFQUFrSztFQUFjOzs7QUFBaUI7RUFBK0Q7OztBQUF3QjtFQUF5TTs7O0FBQWlCO0VBQXdSO0VBQWU7OztBQUFnQjtFQUEySztFQUFXOzs7QUFBUztFQUF1UDtFQUF3Qjs7O0FBQXFCO0VBQW1EO0VBQW1COzs7QUFBa0I7RUFBeUU7RUFBVztFQUFPO0VBQWlCOzs7QUFBYztFQUFXO0VBQWE7RUFBZTtFQUFtQjs7O0FBQWtCO0VBQWlCO0VBQWE7OztBQUFrQjtFQUFxQjs7O0FBQVk7RUFBcUI7RUFBWTs7O0FBQVk7RUFBa0I7OztBQUFnQjtFQUFrQjtFQUFjOzs7QUFBc0I7RUFBbUM7OztBQUFZO0VBQWlCO0VBQWE7OztBQUFzQjtFQUFrQzs7O0FBQVk7RUFBK0I7RUFBYTs7O0FBQWdCO0VBQThCOzs7QUFBYTtFQUE4Qjs7O0FBQTRCO0VBQThCOzs7QUFBYTtFQUE0RDs7O0FBQWE7RUFBeUI7OztBQUFVO0VBQThCOzs7QUFBYTtFQUF3Qjs7O0FBQWU7RUFBMkI7OztBQUFhO0VBQWU7OztBQUFjO0VBQWdEOzs7QUFBZ0I7RUFBaUI7RUFBYTs7O0FBQWU7RUFBZ0M7RUFBVTtFQUFpQjtFQUFrQjs7O0FBQWdCO0VBQTBDOzs7QUFBbUI7RUFBNEc7RUFBcUI7OztBQUFtQjtFQUFxRDs7O0FBQVU7RUFBMkc7OztBQUFxQjtFQUEwQzs7O0FBQVk7RUFBNEM7RUFBVzs7O0FBQVk7RUFBK0o7OztBQUFnQjtFQUFzQzs7O0FBQXNCO0VBQThDOzs7QUFBWTtFQUF5RDs7O0FBQVc7RUFBMkc7RUFBZ0I7RUFBbUI7RUFBbUI7OztBQUFnQjtFQUE2SDs7O0FBQVM7RUFBK0k7OztBQUFhO0VBQWtKOzs7QUFBaUI7RUFBeUI7SUFBb0M7SUFBZ0I7SUFBbUI7SUFBbUI7O0VBQWdCO0lBQTBDOztFQUFTO0lBQWdEOztFQUFhO0lBQWlEOztFQUFpQjtJQUF5Qjs7RUFBZTtJQUE4RjtJQUFjOztFQUFlO0lBQW1DO0lBQWdCO0lBQW1CO0lBQW1COztFQUFnQjtJQUF5Qzs7RUFBUztJQUErQzs7RUFBYTtJQUFnRDs7O0FBQWtCO0VBQXlCO0lBQW1DO0lBQWdCO0lBQW1CO0lBQW1COztFQUFnQjtJQUF5Qzs7RUFBUztJQUErQzs7RUFBYTtJQUFnRDs7O0FBQWtCO0VBQXlCO0lBQW1DO0lBQWdCO0lBQW1CO0lBQW1COztFQUFnQjtJQUF5Qzs7RUFBUztJQUErQzs7RUFBYTtJQUFnRDs7O0FBQWtCO0VBQTBCO0lBQW1DO0lBQWdCO0lBQW1CO0lBQW1COztFQUFnQjtJQUF5Qzs7RUFBUztJQUErQzs7RUFBYTtJQUFnRDs7O0FBQWtCO0VBQTBCO0lBQW1DO0lBQWdCO0lBQW1CO0lBQW1COztFQUFnQjtJQUF5Qzs7RUFBUztJQUErQzs7RUFBYTtJQUFnRDs7O0FBQWtCO0VBQTZCOzs7QUFBYztFQUErQjs7O0FBQWM7RUFBd0M7OztBQUFpQjtFQUFnRDs7O0FBQWM7RUFBOEM7OztBQUFjO0VBQVU7RUFBc0I7RUFBUztFQUFVO0VBQXNCO0VBQWU7RUFBMEI7RUFBbUI7RUFBZ0I7OztBQUE2QjtFQUFpQjtFQUFjO0VBQVc7RUFBbUI7RUFBVTtFQUFzQjtFQUFlO0VBQW9CO0VBQVM7OztBQUFnQztFQUFnQjs7O0FBQWU7RUFBNkI7OztBQUFzQjtFQUEyRDs7O0FBQW1CO0VBQTJCOzs7QUFBYztFQUE0QjtFQUFjOzs7QUFBVztFQUFrRDs7O0FBQVk7RUFBd0c7RUFBb0I7RUFBMEM7OztBQUFvQjtFQUFpQjtFQUFjO0VBQWlCO0VBQXNCO0VBQWU7OztBQUFtQjtFQUF5QjtFQUFxQjs7O0FBQWtCO0VBQTJDOzs7QUFBWTtFQUE2Qzs7O0FBQWdCO0VBQTJDOzs7QUFBWTtFQUE2Qzs7O0FBQWdCO0VBQWU7RUFBc0I7RUFBVTtFQUFzQjtFQUFlO0VBQTBCO0VBQW1CO0VBQWdCO0VBQTZCO0VBQWdCOzs7QUFBbUI7RUFBeUI7OztBQUFnQjtFQUFvRDs7O0FBQWE7RUFBcUI7RUFBcUI7RUFBWTtFQUFnQjtFQUFtQjtFQUFpQjs7O0FBQXNCO0VBQTBCOzs7QUFBZ0I7RUFBMEI7RUFBZTtFQUFxQjs7O0FBQWtCO0VBQTJCO0VBQWtCO0VBQW9CO0VBQW1CO0VBQWU7RUFBWTtFQUFzQjs7O0FBQWU7RUFBb0M7RUFBZTs7O0FBQW1CO0VBQW9HO0VBQXFCO0VBQWlCO0VBQWM7RUFBZTtFQUE4QjtFQUFjOzs7QUFBWTtFQUFpSTs7O0FBQWE7RUFBbUQ7RUFBcUI7RUFBZ0I7OztBQUFzQjtFQUFnRjs7O0FBQWE7RUFBa0Q7RUFBc0I7RUFBWTtFQUF1QjtFQUEyQjtFQUF5Qjs7O0FBQXdCO0VBQWlDO0VBQVk7RUFBa0I7RUFBVTs7O0FBQW1CO0VBQXdEOzs7QUFBWTtFQUF1QjtFQUFhO0VBQXNCOzs7QUFBWTtFQUFvRjs7O0FBQVc7RUFBNkI7RUFBa0I7RUFBYTtFQUFtQjs7O0FBQWdCO0VBQXFDO0VBQVU7OztBQUFlO0VBQTRDO0VBQVc7RUFBc0I7RUFBZTtFQUFtQjs7O0FBQW1EO0VBQWlDOzs7QUFBVztFQUFxQjs7O0FBQWdCO0VBQWdEO0VBQVk7OztBQUFVO0VBQTZCO0VBQWU7RUFBa0I7RUFBbUI7RUFBbUQ7OztBQUFvQjtFQUFxQzs7O0FBQWM7RUFBbUM7OztBQUFjO0VBQXFDOzs7QUFBYztFQUF3Qzs7O0FBQWM7RUFBZTs7O0FBQXNEO0VBQTJDOzs7QUFBVTtFQUE4RTs7O0FBQVU7RUFBNEI7OztBQUFVO0VBQW9CO0VBQWdCOzs7QUFBdUo7RUFBcUQ7RUFBMkI7OztBQUFVO0VBQW1FO0VBQXdCOzs7QUFBVTtFQUEwQjs7O0FBQXVKO0VBQWlDOzs7QUFBMkI7RUFBdUI7SUFBRztJQUFtQjs7RUFBVTtJQUFHO0lBQW1COzs7QUFBVztFQUF1QjtJQUFHO0lBQW1COztFQUFVO0lBQUc7SUFBbUI7OztBQUFXO0VBQXVCO0lBQUc7SUFBbUI7O0VBQVU7SUFBRztJQUFtQjs7O0FBQVc7RUFBYzs7O0FBQWM7RUFBbUM7OztBQUFnQjtFQUF1RTtFQUFlOzs7QUFBZ0I7RUFBK0M7OztBQUFtQjtFQUFpRTtFQUFpQjs7O0FBQWM7RUFBZ0Q7OztBQUFXO0VBQXFEO0VBQW1COzs7QUFBa0I7RUFBcUY7RUFBbUI7OztBQUFrQjtFQUEwSzs7O0FBQVU7RUFBa0g7RUFBVzs7O0FBQVU7RUFBNEQ7OztBQUFrQjtFQUFrakI7RUFBVzs7O0FBQVU7RUFBa1Y7RUFBZ0I7OztBQUFrQjtFQUFxRTtFQUFlOzs7QUFBaUI7RUFBcUU7RUFBVzs7O0FBQVU7RUFBa0g7RUFBbUI7OztBQUFvQjtFQUE0RDtFQUFrQjs7O0FBQW9CO0VBQW9ZO0VBQVc7OztBQUFPO0VBQTZDO0VBQWU7OztBQUFpQjtFQUFTO0VBQW1COzs7QUFBWTtFQUF3Qzs7O0FBQWE7RUFBaUI7OztBQUFpQjtFQUFlOzs7QUFBMkI7RUFBZ0I7OztBQUF1QjtFQUFhOzs7QUFBeUI7RUFBdUI7OztBQUE4QjtFQUFzQjs7O0FBQTZCO0VBQXNCOzs7QUFBNkI7RUFBYTs7O0FBQXVCO0VBQWdCOzs7QUFBbUI7RUFBZ0I7OztBQUFxQjtFQUFTO0VBQWtCO0VBQWU7OztBQUFlO0VBQVk7RUFBYztFQUFjOzs7QUFBZTtFQUFpQjs7O0FBQVU7RUFBaUI7OztBQUFXO0VBQW1COzs7QUFBaUI7RUFBa0I7OztBQUFTO0VBQVk7RUFBYztFQUFzQjs7O0FBQXVCO0VBQWlCOzs7QUFBa0I7RUFBaUI7OztBQUFtQjtFQUFtQjs7O0FBQXlCO0VBQWtCOzs7QUFBUztFQUFZO0VBQWM7RUFBc0I7OztBQUF1QjtFQUFpQjs7O0FBQWtCO0VBQWlCOzs7QUFBbUI7RUFBbUI7OztBQUF5QjtFQUFrQjs7O0FBQVM7RUFBWTtFQUFjO0VBQWU7OztBQUFnQjtFQUFpQjs7O0FBQVc7RUFBaUI7OztBQUFZO0VBQW1COzs7QUFBa0I7RUFBa0I7OztBQUFTO0VBQVk7RUFBYztFQUFzQjs7O0FBQXVCO0VBQWlCOzs7QUFBa0I7RUFBaUI7OztBQUFtQjtFQUFtQjs7O0FBQXlCO0VBQWtCOzs7QUFBUztFQUFZO0VBQWM7RUFBc0I7OztBQUF1QjtFQUFpQjs7O0FBQWtCO0VBQWlCOzs7QUFBbUI7RUFBbUI7OztBQUF5QjtFQUFrQjs7O0FBQVM7RUFBWTtFQUFjO0VBQWE7OztBQUFjO0VBQWlCOzs7QUFBUztFQUFpQjs7O0FBQVU7RUFBbUI7OztBQUFnQjtFQUFrQjs7O0FBQVM7RUFBWTtFQUFjO0VBQXNCOzs7QUFBdUI7RUFBaUI7OztBQUFrQjtFQUFpQjs7O0FBQW1CO0VBQW1COzs7QUFBeUI7RUFBa0I7OztBQUFTO0VBQVk7RUFBYztFQUFzQjs7O0FBQXVCO0VBQWlCOzs7QUFBa0I7RUFBaUI7OztBQUFtQjtFQUFtQjs7O0FBQXlCO0VBQWtCOzs7QUFBUztFQUFZO0VBQWM7RUFBZTs7O0FBQWdCO0VBQWlCOzs7QUFBVztFQUFpQjs7O0FBQVk7RUFBbUI7OztBQUFrQjtFQUFrQjs7O0FBQVM7RUFBWTtFQUFjO0VBQXNCOzs7QUFBdUI7RUFBaUI7OztBQUFrQjtFQUFpQjs7O0FBQW1CO0VBQW1COzs7QUFBeUI7RUFBa0I7OztBQUFTO0VBQVk7RUFBYztFQUFzQjs7O0FBQXVCO0VBQWlCOzs7QUFBa0I7RUFBaUI7OztBQUFtQjtFQUFtQjs7O0FBQXlCO0VBQWtCOzs7QUFBUztFQUFZO0VBQWM7RUFBYTs7O0FBQWM7RUFBaUI7OztBQUFTO0VBQWlCOzs7QUFBVTtFQUFtQjs7O0FBQWdCO0VBQWtCOzs7QUFBUztFQUFZO0VBQWM7RUFBc0I7OztBQUF1QjtFQUFpQjs7O0FBQWtCO0VBQWlCOzs7QUFBbUI7RUFBbUI7OztBQUF5QjtFQUFrQjs7O0FBQVM7RUFBWTtFQUFjO0VBQXNCOzs7QUFBdUI7RUFBaUI7OztBQUFrQjtFQUFpQjs7O0FBQW1CO0VBQW1COzs7QUFBeUI7RUFBa0I7OztBQUFTO0VBQVc7RUFBYztFQUFlOzs7QUFBZ0I7RUFBZ0I7OztBQUFXO0VBQWdCOzs7QUFBWTtFQUFrQjs7O0FBQWtCO0VBQWlCOzs7QUFBUTtFQUFXO0VBQWM7RUFBc0I7OztBQUF1QjtFQUFnQjs7O0FBQWtCO0VBQWdCOzs7QUFBbUI7RUFBa0I7OztBQUF5QjtFQUFpQjs7O0FBQVE7RUFBVztFQUFjO0VBQXNCOzs7QUFBdUI7RUFBZ0I7OztBQUFrQjtFQUFnQjs7O0FBQW1CO0VBQWtCOzs7QUFBeUI7RUFBaUI7OztBQUFRO0VBQVc7RUFBYztFQUFhOzs7QUFBYztFQUFnQjs7O0FBQVM7RUFBZ0I7OztBQUFVO0VBQWtCOzs7QUFBZ0I7RUFBaUI7OztBQUFRO0VBQVc7RUFBYztFQUFzQjs7O0FBQXVCO0VBQWdCOzs7QUFBa0I7RUFBZ0I7OztBQUFtQjtFQUFrQjs7O0FBQXlCO0VBQWlCOzs7QUFBUTtFQUFXO0VBQWM7RUFBc0I7OztBQUF1QjtFQUFnQjs7O0FBQWtCO0VBQWdCOzs7QUFBbUI7RUFBa0I7OztBQUF5QjtFQUFpQjs7O0FBQVE7RUFBVztFQUFjO0VBQWU7OztBQUFnQjtFQUFnQjs7O0FBQVc7RUFBZ0I7OztBQUFZO0VBQWtCOzs7QUFBa0I7RUFBaUI7OztBQUFRO0VBQVc7RUFBYztFQUFxQjs7O0FBQXNCO0VBQWdCOzs7QUFBaUI7RUFBZ0I7OztBQUFrQjtFQUFrQjs7O0FBQXdCO0VBQWlCOzs7QUFBUTtFQUFXO0VBQWM7RUFBcUI7OztBQUFzQjtFQUFnQjs7O0FBQWlCO0VBQWdCOzs7QUFBa0I7RUFBa0I7OztBQUF3QjtFQUFpQjs7O0FBQVE7RUFBVzs7O0FBQWE7RUFBa0I7OztBQUFjO0VBQWlCOzs7QUFBUTtFQUE4Qjs7O0FBQWU7RUFBNEI7RUFBa0I7OztBQUFVO0VBQTRCO0VBQVc7OztBQUFpQjtFQUE4QjtFQUF5Qjs7O0FBQWM7RUFBNEI7RUFBa0I7OztBQUFVO0VBQTRCO0VBQVc7OztBQUFpQjtFQUE4QjtFQUF5Qjs7O0FBQWM7RUFBNEI7RUFBWTs7O0FBQVU7RUFBNEI7RUFBVzs7O0FBQVc7RUFBOEI7RUFBbUI7OztBQUFjO0VBQTRCO0VBQW1COzs7QUFBVTtFQUE0QjtFQUFXOzs7QUFBa0I7RUFBOEI7RUFBMEI7OztBQUFjO0VBQTRCO0VBQW1COzs7QUFBVTtFQUE0QjtFQUFXOzs7QUFBa0I7RUFBOEI7RUFBMEI7OztBQUFjO0VBQTRCO0VBQVU7OztBQUFVO0VBQTRCO0VBQVc7OztBQUFTO0VBQThCO0VBQWlCOzs7QUFBYztFQUE0QjtFQUFtQjs7O0FBQVU7RUFBNEI7RUFBVzs7O0FBQWtCO0VBQThCO0VBQTBCOzs7QUFBYztFQUE0QjtFQUFtQjs7O0FBQVU7RUFBNEI7RUFBVzs7O0FBQWtCO0VBQThCO0VBQTBCOzs7QUFBYztFQUE0QjtFQUFZOzs7QUFBVTtFQUE0QjtFQUFXOzs7QUFBVztFQUE4QjtFQUFtQjs7O0FBQWM7RUFBNkI7RUFBbUI7OztBQUFVO0VBQTZCO0VBQVc7OztBQUFrQjtFQUErQjtFQUEwQjs7O0FBQWM7RUFBNkI7RUFBbUI7OztBQUFVO0VBQTZCO0VBQVc7OztBQUFrQjtFQUErQjtFQUEwQjs7O0FBQWM7RUFBNkI7RUFBVTs7O0FBQVU7RUFBNkI7RUFBVzs7O0FBQVM7RUFBK0I7RUFBaUI7OztBQUFjO0VBQTZCO0VBQW1COzs7QUFBVTtFQUE2QjtFQUFXOzs7QUFBa0I7RUFBK0I7RUFBMEI7OztBQUFjO0VBQTZCO0VBQW1COzs7QUFBVTtFQUE2QjtFQUFXOzs7QUFBa0I7RUFBK0I7RUFBMEI7OztBQUFjO0VBQTZCO0VBQVk7OztBQUFVO0VBQTZCO0VBQVc7OztBQUFXO0VBQStCO0VBQW1COzs7QUFBYztFQUE2QjtFQUFtQjs7O0FBQVU7RUFBNkI7RUFBVzs7O0FBQWtCO0VBQStCO0VBQTBCOzs7QUFBYztFQUE2QjtFQUFtQjs7O0FBQVU7RUFBNkI7RUFBVzs7O0FBQWtCO0VBQStCO0VBQTBCOzs7QUFBYztFQUE2QjtFQUFVOzs7QUFBVTtFQUE2QjtFQUFXOzs7QUFBUztFQUErQjtFQUFpQjs7O0FBQWM7RUFBNkI7RUFBbUI7OztBQUFVO0VBQTZCO0VBQVc7OztBQUFrQjtFQUErQjtFQUEwQjs7O0FBQWM7RUFBNkI7RUFBbUI7OztBQUFVO0VBQTZCO0VBQVc7OztBQUFrQjtFQUErQjtFQUEwQjs7O0FBQWM7RUFBNkI7RUFBWTs7O0FBQVU7RUFBNkI7RUFBVzs7O0FBQVc7RUFBK0I7RUFBbUI7OztBQUFjO0VBQTZCO0VBQW1COzs7QUFBVTtFQUE2QjtFQUFXOzs7QUFBa0I7RUFBK0I7RUFBMEI7OztBQUFjO0VBQTZCO0VBQW1COzs7QUFBVTtFQUE2QjtFQUFXOzs7QUFBa0I7RUFBK0I7RUFBMEI7OztBQUFjO0VBQTZCO0VBQVc7OztBQUFVO0VBQTZCO0VBQVc7OztBQUFVO0VBQStCO0VBQWtCOzs7QUFBYztFQUFlO0VBQWM7RUFBYzs7O0FBQWU7RUFBb0I7OztBQUFVO0VBQW9COzs7QUFBVztFQUFzQjs7O0FBQWlCO0VBQXFCOzs7QUFBUztFQUFlO0VBQWM7RUFBc0I7OztBQUF1QjtFQUFvQjs7O0FBQWtCO0VBQW9COzs7QUFBbUI7RUFBc0I7OztBQUF5QjtFQUFxQjs7O0FBQVM7RUFBZTtFQUFjO0VBQXNCOzs7QUFBdUI7RUFBb0I7OztBQUFrQjtFQUFvQjs7O0FBQW1CO0VBQXNCOzs7QUFBeUI7RUFBcUI7OztBQUFTO0VBQWU7RUFBYztFQUFlOzs7QUFBZ0I7RUFBb0I7OztBQUFXO0VBQW9COzs7QUFBWTtFQUFzQjs7O0FBQWtCO0VBQXFCOzs7QUFBUztFQUFlO0VBQWM7RUFBc0I7OztBQUF1QjtFQUFvQjs7O0FBQWtCO0VBQW9COzs7QUFBbUI7RUFBc0I7OztBQUF5QjtFQUFxQjs7O0FBQVM7RUFBZTtFQUFjO0VBQXNCOzs7QUFBdUI7RUFBb0I7OztBQUFrQjtFQUFvQjs7O0FBQW1CO0VBQXNCOzs7QUFBeUI7RUFBcUI7OztBQUFTO0VBQWU7RUFBYztFQUFhOzs7QUFBYztFQUFvQjs7O0FBQVM7RUFBb0I7OztBQUFVO0VBQXNCOzs7QUFBZ0I7RUFBcUI7OztBQUFTO0VBQWU7RUFBYztFQUFzQjs7O0FBQXVCO0VBQW9COzs7QUFBa0I7RUFBb0I7OztBQUFtQjtFQUFzQjs7O0FBQXlCO0VBQXFCOzs7QUFBUztFQUFlO0VBQWM7RUFBc0I7OztBQUF1QjtFQUFvQjs7O0FBQWtCO0VBQW9COzs7QUFBbUI7RUFBc0I7OztBQUF5QjtFQUFxQjs7O0FBQVM7RUFBZTtFQUFjO0VBQWU7OztBQUFnQjtFQUFvQjs7O0FBQVc7RUFBb0I7OztBQUFZO0VBQXNCOzs7QUFBa0I7RUFBcUI7OztBQUFTO0VBQWU7RUFBYztFQUFzQjs7O0FBQXVCO0VBQW9COzs7QUFBa0I7RUFBb0I7OztBQUFtQjtFQUFzQjs7O0FBQXlCO0VBQXFCOzs7QUFBUztFQUFlO0VBQWM7RUFBc0I7OztBQUF1QjtFQUFvQjs7O0FBQWtCO0VBQW9COzs7QUFBbUI7RUFBc0I7OztBQUF5QjtFQUFxQjs7O0FBQVM7RUFBZTtFQUFjO0VBQWE7OztBQUFjO0VBQW9COzs7QUFBUztFQUFvQjs7O0FBQVU7RUFBc0I7OztBQUFnQjtFQUFxQjs7O0FBQVM7RUFBZTtFQUFjO0VBQXNCOzs7QUFBdUI7RUFBb0I7OztBQUFrQjtFQUFvQjs7O0FBQW1CO0VBQXNCOzs7QUFBeUI7RUFBcUI7OztBQUFTO0VBQWU7RUFBYztFQUFzQjs7O0FBQXVCO0VBQW9COzs7QUFBa0I7RUFBb0I7OztBQUFtQjtFQUFzQjs7O0FBQXlCO0VBQXFCOzs7QUFBUztFQUFjO0VBQWM7RUFBZTs7O0FBQWdCO0VBQW1COzs7QUFBVztFQUFtQjs7O0FBQVk7RUFBcUI7OztBQUFrQjtFQUFvQjs7O0FBQVE7RUFBYztFQUFjO0VBQXNCOzs7QUFBdUI7RUFBbUI7OztBQUFrQjtFQUFtQjs7O0FBQW1CO0VBQXFCOzs7QUFBeUI7RUFBb0I7OztBQUFRO0VBQWM7RUFBYztFQUFzQjs7O0FBQXVCO0VBQW1COzs7QUFBa0I7RUFBbUI7OztBQUFtQjtFQUFxQjs7O0FBQXlCO0VBQW9COzs7QUFBUTtFQUFjO0VBQWM7RUFBYTs7O0FBQWM7RUFBbUI7OztBQUFTO0VBQW1COzs7QUFBVTtFQUFxQjs7O0FBQWdCO0VBQW9COzs7QUFBUTtFQUFjO0VBQWM7RUFBc0I7OztBQUF1QjtFQUFtQjs7O0FBQWtCO0VBQW1COzs7QUFBbUI7RUFBcUI7OztBQUF5QjtFQUFvQjs7O0FBQVE7RUFBYztFQUFjO0VBQXNCOzs7QUFBdUI7RUFBbUI7OztBQUFrQjtFQUFtQjs7O0FBQW1CO0VBQXFCOzs7QUFBeUI7RUFBb0I7OztBQUFRO0VBQWM7RUFBYztFQUFlOzs7QUFBZ0I7RUFBbUI7OztBQUFXO0VBQW1COzs7QUFBWTtFQUFxQjs7O0FBQWtCO0VBQW9COzs7QUFBUTtFQUFjO0VBQWM7RUFBcUI7OztBQUFzQjtFQUFtQjs7O0FBQWlCO0VBQW1COzs7QUFBa0I7RUFBcUI7OztBQUF3QjtFQUFvQjs7O0FBQVE7RUFBYztFQUFjO0VBQXFCOzs7QUFBc0I7RUFBbUI7OztBQUFpQjtFQUFtQjs7O0FBQWtCO0VBQXFCOzs7QUFBd0I7RUFBb0I7OztBQUFRO0VBQWM7OztBQUFhO0VBQWdCOzs7QUFBVTtFQUFnQjs7O0FBQVc7RUFBbUI7OztBQUFVO0VBQW1COzs7QUFBVztFQUFxQjs7O0FBQWM7RUFBb0I7OztBQUFRO0VBQTRCOzs7QUFBVztFQUE0Qjs7O0FBQVU7RUFBK0I7OztBQUFXO0VBQStCOzs7QUFBVTtFQUFpQzs7O0FBQWU7RUFBK0I7RUFBa0I7OztBQUFVO0VBQStCO0VBQVc7OztBQUFpQjtFQUFpQztFQUF5Qjs7O0FBQWM7RUFBK0I7RUFBa0I7OztBQUFVO0VBQStCO0VBQVc7OztBQUFpQjtFQUFpQztFQUF5Qjs7O0FBQWM7RUFBK0I7RUFBWTs7O0FBQVU7RUFBK0I7RUFBVzs7O0FBQVc7RUFBaUM7RUFBbUI7OztBQUFjO0VBQStCO0VBQW1COzs7QUFBVTtFQUErQjtFQUFXOzs7QUFBa0I7RUFBaUM7RUFBMEI7OztBQUFjO0VBQStCO0VBQW1COzs7QUFBVTtFQUErQjtFQUFXOzs7QUFBa0I7RUFBaUM7RUFBMEI7OztBQUFjO0VBQStCO0VBQVU7OztBQUFVO0VBQStCO0VBQVc7OztBQUFTO0VBQWlDO0VBQWlCOzs7QUFBYztFQUErQjtFQUFtQjs7O0FBQVU7RUFBK0I7RUFBVzs7O0FBQWtCO0VBQWlDO0VBQTBCOzs7QUFBYztFQUErQjtFQUFtQjs7O0FBQVU7RUFBK0I7RUFBVzs7O0FBQWtCO0VBQWlDO0VBQTBCOzs7QUFBYztFQUErQjtFQUFZOzs7QUFBVTtFQUErQjtFQUFXOzs7QUFBVztFQUFpQztFQUFtQjs7O0FBQWM7RUFBZ0M7RUFBbUI7OztBQUFVO0VBQWdDO0VBQVc7OztBQUFrQjtFQUFrQztFQUEwQjs7O0FBQWM7RUFBZ0M7RUFBbUI7OztBQUFVO0VBQWdDO0VBQVc7OztBQUFrQjtFQUFrQztFQUEwQjs7O0FBQWM7RUFBZ0M7RUFBVTs7O0FBQVU7RUFBZ0M7RUFBVzs7O0FBQVM7RUFBa0M7RUFBaUI7OztBQUFjO0VBQWdDO0VBQW1COzs7QUFBVTtFQUFnQztFQUFXOzs7QUFBa0I7RUFBa0M7RUFBMEI7OztBQUFjO0VBQWdDO0VBQW1COzs7QUFBVTtFQUFnQztFQUFXOzs7QUFBa0I7RUFBa0M7RUFBMEI7OztBQUFjO0VBQWdDO0VBQVk7OztBQUFVO0VBQWdDO0VBQVc7OztBQUFXO0VBQWtDO0VBQW1COzs7QUFBYztFQUFnQztFQUFtQjs7O0FBQVU7RUFBZ0M7RUFBVzs7O0FBQWtCO0VBQWtDO0VBQTBCOzs7QUFBYztFQUFnQztFQUFtQjs7O0FBQVU7RUFBZ0M7RUFBVzs7O0FBQWtCO0VBQWtDO0VBQTBCOzs7QUFBYztFQUFnQztFQUFVOzs7QUFBVTtFQUFnQztFQUFXOzs7QUFBUztFQUFrQztFQUFpQjs7O0FBQWM7RUFBZ0M7RUFBbUI7OztBQUFVO0VBQWdDO0VBQVc7OztBQUFrQjtFQUFrQztFQUEwQjs7O0FBQWM7RUFBZ0M7RUFBbUI7OztBQUFVO0VBQWdDO0VBQVc7OztBQUFrQjtFQUFrQztFQUEwQjs7O0FBQWM7RUFBZ0M7RUFBWTs7O0FBQVU7RUFBZ0M7RUFBVzs7O0FBQVc7RUFBa0M7RUFBbUI7OztBQUFjO0VBQWdDO0VBQW1COzs7QUFBVTtFQUFnQztFQUFXOzs7QUFBa0I7RUFBa0M7RUFBMEI7OztBQUFjO0VBQWdDO0VBQW1COzs7QUFBVTtFQUFnQztFQUFXOzs7QUFBa0I7RUFBa0M7RUFBMEI7OztBQUFjO0VBQWdDO0VBQVc7OztBQUFVO0VBQWdDO0VBQVc7OztBQUFVO0VBQWtDO0VBQWtCOzs7QUFBYztFQUF5QjtJQUFlO0lBQWM7SUFBYzs7RUFBZTtJQUFvQjs7RUFBVTtJQUFvQjs7RUFBVztJQUFzQjs7RUFBaUI7SUFBcUI7O0VBQVM7SUFBZTtJQUFjO0lBQXNCOztFQUF1QjtJQUFvQjs7RUFBa0I7SUFBb0I7O0VBQW1CO0lBQXNCOztFQUF5QjtJQUFxQjs7RUFBUztJQUFlO0lBQWM7SUFBc0I7O0VBQXVCO0lBQW9COztFQUFrQjtJQUFvQjs7RUFBbUI7SUFBc0I7O0VBQXlCO0lBQXFCOztFQUFTO0lBQWU7SUFBYztJQUFlOztFQUFnQjtJQUFvQjs7RUFBVztJQUFvQjs7RUFBWTtJQUFzQjs7RUFBa0I7SUFBcUI7O0VBQVM7SUFBZTtJQUFjO0lBQXNCOztFQUF1QjtJQUFvQjs7RUFBa0I7SUFBb0I7O0VBQW1CO0lBQXNCOztFQUF5QjtJQUFxQjs7RUFBUztJQUFlO0lBQWM7SUFBc0I7O0VBQXVCO0lBQW9COztFQUFrQjtJQUFvQjs7RUFBbUI7SUFBc0I7O0VBQXlCO0lBQXFCOztFQUFTO0lBQWU7SUFBYztJQUFhOztFQUFjO0lBQW9COztFQUFTO0lBQW9COztFQUFVO0lBQXNCOztFQUFnQjtJQUFxQjs7RUFBUztJQUFlO0lBQWM7SUFBc0I7O0VBQXVCO0lBQW9COztFQUFrQjtJQUFvQjs7RUFBbUI7SUFBc0I7O0VBQXlCO0lBQXFCOztFQUFTO0lBQWU7SUFBYztJQUFzQjs7RUFBdUI7SUFBb0I7O0VBQWtCO0lBQW9COztFQUFtQjtJQUFzQjs7RUFBeUI7SUFBcUI7O0VBQVM7SUFBZTtJQUFjO0lBQWU7O0VBQWdCO0lBQW9COztFQUFXO0lBQW9COztFQUFZO0lBQXNCOztFQUFrQjtJQUFxQjs7RUFBUztJQUFlO0lBQWM7SUFBc0I7O0VBQXVCO0lBQW9COztFQUFrQjtJQUFvQjs7RUFBbUI7SUFBc0I7O0VBQXlCO0lBQXFCOztFQUFTO0lBQWU7SUFBYztJQUFzQjs7RUFBdUI7SUFBb0I7O0VBQWtCO0lBQW9COztFQUFtQjtJQUFzQjs7RUFBeUI7SUFBcUI7O0VBQVM7SUFBZTtJQUFjO0lBQWE7O0VBQWM7SUFBb0I7O0VBQVM7SUFBb0I7O0VBQVU7SUFBc0I7O0VBQWdCO0lBQXFCOztFQUFTO0lBQWU7SUFBYztJQUFzQjs7RUFBdUI7SUFBb0I7O0VBQWtCO0lBQW9COztFQUFtQjtJQUFzQjs7RUFBeUI7SUFBcUI7O0VBQVM7SUFBZTtJQUFjO0lBQXNCOztFQUF1QjtJQUFvQjs7RUFBa0I7SUFBb0I7O0VBQW1CO0lBQXNCOztFQUF5QjtJQUFxQjs7RUFBUztJQUFjO0lBQWM7SUFBZTs7RUFBZ0I7SUFBbUI7O0VBQVc7SUFBbUI7O0VBQVk7SUFBcUI7O0VBQWtCO0lBQW9COztFQUFRO0lBQWM7SUFBYztJQUFzQjs7RUFBdUI7SUFBbUI7O0VBQWtCO0lBQW1COztFQUFtQjtJQUFxQjs7RUFBeUI7SUFBb0I7O0VBQVE7SUFBYztJQUFjO0lBQXNCOztFQUF1QjtJQUFtQjs7RUFBa0I7SUFBbUI7O0VBQW1CO0lBQXFCOztFQUF5QjtJQUFvQjs7RUFBUTtJQUFjO0lBQWM7SUFBYTs7RUFBYztJQUFtQjs7RUFBUztJQUFtQjs7RUFBVTtJQUFxQjs7RUFBZ0I7SUFBb0I7O0VBQVE7SUFBYztJQUFjO0lBQXNCOztFQUF1QjtJQUFtQjs7RUFBa0I7SUFBbUI7O0VBQW1CO0lBQXFCOztFQUF5QjtJQUFvQjs7RUFBUTtJQUFjO0lBQWM7SUFBc0I7O0VBQXVCO0lBQW1COztFQUFrQjtJQUFtQjs7RUFBbUI7SUFBcUI7O0VBQXlCO0lBQW9COztFQUFRO0lBQWM7SUFBYztJQUFlOztFQUFnQjtJQUFtQjs7RUFBVztJQUFtQjs7RUFBWTtJQUFxQjs7RUFBa0I7SUFBb0I7O0VBQVE7SUFBYztJQUFjO0lBQXFCOztFQUFzQjtJQUFtQjs7RUFBaUI7SUFBbUI7O0VBQWtCO0lBQXFCOztFQUF3QjtJQUFvQjs7RUFBUTtJQUFjO0lBQWM7SUFBcUI7O0VBQXNCO0lBQW1COztFQUFpQjtJQUFtQjs7RUFBa0I7SUFBcUI7O0VBQXdCO0lBQW9COztFQUFRO0lBQWM7O0VBQWE7SUFBZ0I7O0VBQVU7SUFBZ0I7O0VBQVc7SUFBbUI7O0VBQVU7SUFBbUI7O0VBQVc7SUFBcUI7O0VBQWM7SUFBb0I7O0VBQVE7SUFBNEI7O0VBQVc7SUFBNEI7O0VBQVU7SUFBK0I7O0VBQVc7SUFBK0I7O0VBQVU7SUFBaUM7O0VBQWU7SUFBK0I7SUFBa0I7O0VBQVU7SUFBK0I7SUFBVzs7RUFBaUI7SUFBaUM7SUFBeUI7O0VBQWM7SUFBK0I7SUFBa0I7O0VBQVU7SUFBK0I7SUFBVzs7RUFBaUI7SUFBaUM7SUFBeUI7O0VBQWM7SUFBK0I7SUFBWTs7RUFBVTtJQUErQjtJQUFXOztFQUFXO0lBQWlDO0lBQW1COztFQUFjO0lBQStCO0lBQW1COztFQUFVO0lBQStCO0lBQVc7O0VBQWtCO0lBQWlDO0lBQTBCOztFQUFjO0lBQStCO0lBQW1COztFQUFVO0lBQStCO0lBQVc7O0VBQWtCO0lBQWlDO0lBQTBCOztFQUFjO0lBQStCO0lBQVU7O0VBQVU7SUFBK0I7SUFBVzs7RUFBUztJQUFpQztJQUFpQjs7RUFBYztJQUErQjtJQUFtQjs7RUFBVTtJQUErQjtJQUFXOztFQUFrQjtJQUFpQztJQUEwQjs7RUFBYztJQUErQjtJQUFtQjs7RUFBVTtJQUErQjtJQUFXOztFQUFrQjtJQUFpQztJQUEwQjs7RUFBYztJQUErQjtJQUFZOztFQUFVO0lBQStCO0lBQVc7O0VBQVc7SUFBaUM7SUFBbUI7O0VBQWM7SUFBZ0M7SUFBbUI7O0VBQVU7SUFBZ0M7SUFBVzs7RUFBa0I7SUFBa0M7SUFBMEI7O0VBQWM7SUFBZ0M7SUFBbUI7O0VBQVU7SUFBZ0M7SUFBVzs7RUFBa0I7SUFBa0M7SUFBMEI7O0VBQWM7SUFBZ0M7SUFBVTs7RUFBVTtJQUFnQztJQUFXOztFQUFTO0lBQWtDO0lBQWlCOztFQUFjO0lBQWdDO0lBQW1COztFQUFVO0lBQWdDO0lBQVc7O0VBQWtCO0lBQWtDO0lBQTBCOztFQUFjO0lBQWdDO0lBQW1COztFQUFVO0lBQWdDO0lBQVc7O0VBQWtCO0lBQWtDO0lBQTBCOztFQUFjO0lBQWdDO0lBQVk7O0VBQVU7SUFBZ0M7SUFBVzs7RUFBVztJQUFrQztJQUFtQjs7RUFBYztJQUFnQztJQUFtQjs7RUFBVTtJQUFnQztJQUFXOztFQUFrQjtJQUFrQztJQUEwQjs7RUFBYztJQUFnQztJQUFtQjs7RUFBVTtJQUFnQztJQUFXOztFQUFrQjtJQUFrQztJQUEwQjs7RUFBYztJQUFnQztJQUFVOztFQUFVO0lBQWdDO0lBQVc7O0VBQVM7SUFBa0M7SUFBaUI7O0VBQWM7SUFBZ0M7SUFBbUI7O0VBQVU7SUFBZ0M7SUFBVzs7RUFBa0I7SUFBa0M7SUFBMEI7O0VBQWM7SUFBZ0M7SUFBbUI7O0VBQVU7SUFBZ0M7SUFBVzs7RUFBa0I7SUFBa0M7SUFBMEI7O0VBQWM7SUFBZ0M7SUFBWTs7RUFBVTtJQUFnQztJQUFXOztFQUFXO0lBQWtDO0lBQW1COztFQUFjO0lBQWdDO0lBQW1COztFQUFVO0lBQWdDO0lBQVc7O0VBQWtCO0lBQWtDO0lBQTBCOztFQUFjO0lBQWdDO0lBQW1COztFQUFVO0lBQWdDO0lBQVc7O0VBQWtCO0lBQWtDO0lBQTBCOztFQUFjO0lBQWdDO0lBQVc7O0VBQVU7SUFBZ0M7SUFBVzs7RUFBVTtJQUFrQztJQUFrQjs7O0FBQWU7RUFBeUI7SUFBZTtJQUFjO0lBQWM7O0VBQWU7SUFBb0I7O0VBQVU7SUFBb0I7O0VBQVc7SUFBc0I7O0VBQWlCO0lBQXFCOztFQUFTO0lBQWU7SUFBYztJQUFzQjs7RUFBdUI7SUFBb0I7O0VBQWtCO0lBQW9COztFQUFtQjtJQUFzQjs7RUFBeUI7SUFBcUI7O0VBQVM7SUFBZTtJQUFjO0lBQXNCOztFQUF1QjtJQUFvQjs7RUFBa0I7SUFBb0I7O0VBQW1CO0lBQXNCOztFQUF5QjtJQUFxQjs7RUFBUztJQUFlO0lBQWM7SUFBZTs7RUFBZ0I7SUFBb0I7O0VBQVc7SUFBb0I7O0VBQVk7SUFBc0I7O0VBQWtCO0lBQXFCOztFQUFTO0lBQWU7SUFBYztJQUFzQjs7RUFBdUI7SUFBb0I7O0VBQWtCO0lBQW9COztFQUFtQjtJQUFzQjs7RUFBeUI7SUFBcUI7O0VBQVM7SUFBZTtJQUFjO0lBQXNCOztFQUF1QjtJQUFvQjs7RUFBa0I7SUFBb0I7O0VBQW1CO0lBQXNCOztFQUF5QjtJQUFxQjs7RUFBUztJQUFlO0lBQWM7SUFBYTs7RUFBYztJQUFvQjs7RUFBUztJQUFvQjs7RUFBVTtJQUFzQjs7RUFBZ0I7SUFBcUI7O0VBQVM7SUFBZTtJQUFjO0lBQXNCOztFQUF1QjtJQUFvQjs7RUFBa0I7SUFBb0I7O0VBQW1CO0lBQXNCOztFQUF5QjtJQUFxQjs7RUFBUztJQUFlO0lBQWM7SUFBc0I7O0VBQXVCO0lBQW9COztFQUFrQjtJQUFvQjs7RUFBbUI7SUFBc0I7O0VBQXlCO0lBQXFCOztFQUFTO0lBQWU7SUFBYztJQUFlOztFQUFnQjtJQUFvQjs7RUFBVztJQUFvQjs7RUFBWTtJQUFzQjs7RUFBa0I7SUFBcUI7O0VBQVM7SUFBZTtJQUFjO0lBQXNCOztFQUF1QjtJQUFvQjs7RUFBa0I7SUFBb0I7O0VBQW1CO0lBQXNCOztFQUF5QjtJQUFxQjs7RUFBUztJQUFlO0lBQWM7SUFBc0I7O0VBQXVCO0lBQW9COztFQUFrQjtJQUFvQjs7RUFBbUI7SUFBc0I7O0VBQXlCO0lBQXFCOztFQUFTO0lBQWU7SUFBYztJQUFhOztFQUFjO0lBQW9COztFQUFTO0lBQW9COztFQUFVO0lBQXNCOztFQUFnQjtJQUFxQjs7RUFBUztJQUFlO0lBQWM7SUFBc0I7O0VBQXVCO0lBQW9COztFQUFrQjtJQUFvQjs7RUFBbUI7SUFBc0I7O0VBQXlCO0lBQXFCOztFQUFTO0lBQWU7SUFBYztJQUFzQjs7RUFBdUI7SUFBb0I7O0VBQWtCO0lBQW9COztFQUFtQjtJQUFzQjs7RUFBeUI7SUFBcUI7O0VBQVM7SUFBYztJQUFjO0lBQWU7O0VBQWdCO0lBQW1COztFQUFXO0lBQW1COztFQUFZO0lBQXFCOztFQUFrQjtJQUFvQjs7RUFBUTtJQUFjO0lBQWM7SUFBc0I7O0VBQXVCO0lBQW1COztFQUFrQjtJQUFtQjs7RUFBbUI7SUFBcUI7O0VBQXlCO0lBQW9COztFQUFRO0lBQWM7SUFBYztJQUFzQjs7RUFBdUI7SUFBbUI7O0VBQWtCO0lBQW1COztFQUFtQjtJQUFxQjs7RUFBeUI7SUFBb0I7O0VBQVE7SUFBYztJQUFjO0lBQWE7O0VBQWM7SUFBbUI7O0VBQVM7SUFBbUI7O0VBQVU7SUFBcUI7O0VBQWdCO0lBQW9COztFQUFRO0lBQWM7SUFBYztJQUFzQjs7RUFBdUI7SUFBbUI7O0VBQWtCO0lBQW1COztFQUFtQjtJQUFxQjs7RUFBeUI7SUFBb0I7O0VBQVE7SUFBYztJQUFjO0lBQXNCOztFQUF1QjtJQUFtQjs7RUFBa0I7SUFBbUI7O0VBQW1CO0lBQXFCOztFQUF5QjtJQUFvQjs7RUFBUTtJQUFjO0lBQWM7SUFBZTs7RUFBZ0I7SUFBbUI7O0VBQVc7SUFBbUI7O0VBQVk7SUFBcUI7O0VBQWtCO0lBQW9COztFQUFRO0lBQWM7SUFBYztJQUFxQjs7RUFBc0I7SUFBbUI7O0VBQWlCO0lBQW1COztFQUFrQjtJQUFxQjs7RUFBd0I7SUFBb0I7O0VBQVE7SUFBYztJQUFjO0lBQXFCOztFQUFzQjtJQUFtQjs7RUFBaUI7SUFBbUI7O0VBQWtCO0lBQXFCOztFQUF3QjtJQUFvQjs7RUFBUTtJQUFjOztFQUFhO0lBQWdCOztFQUFVO0lBQWdCOztFQUFXO0lBQW1COztFQUFVO0lBQW1COztFQUFXO0lBQXFCOztFQUFjO0lBQW9COztFQUFRO0lBQTRCOztFQUFXO0lBQTRCOztFQUFVO0lBQStCOztFQUFXO0lBQStCOztFQUFVO0lBQWlDOztFQUFlO0lBQStCO0lBQWtCOztFQUFVO0lBQStCO0lBQVc7O0VBQWlCO0lBQWlDO0lBQXlCOztFQUFjO0lBQStCO0lBQWtCOztFQUFVO0lBQStCO0lBQVc7O0VBQWlCO0lBQWlDO0lBQXlCOztFQUFjO0lBQStCO0lBQVk7O0VBQVU7SUFBK0I7SUFBVzs7RUFBVztJQUFpQztJQUFtQjs7RUFBYztJQUErQjtJQUFtQjs7RUFBVTtJQUErQjtJQUFXOztFQUFrQjtJQUFpQztJQUEwQjs7RUFBYztJQUErQjtJQUFtQjs7RUFBVTtJQUErQjtJQUFXOztFQUFrQjtJQUFpQztJQUEwQjs7RUFBYztJQUErQjtJQUFVOztFQUFVO0lBQStCO0lBQVc7O0VBQVM7SUFBaUM7SUFBaUI7O0VBQWM7SUFBK0I7SUFBbUI7O0VBQVU7SUFBK0I7SUFBVzs7RUFBa0I7SUFBaUM7SUFBMEI7O0VBQWM7SUFBK0I7SUFBbUI7O0VBQVU7SUFBK0I7SUFBVzs7RUFBa0I7SUFBaUM7SUFBMEI7O0VBQWM7SUFBK0I7SUFBWTs7RUFBVTtJQUErQjtJQUFXOztFQUFXO0lBQWlDO0lBQW1COztFQUFjO0lBQWdDO0lBQW1COztFQUFVO0lBQWdDO0lBQVc7O0VBQWtCO0lBQWtDO0lBQTBCOztFQUFjO0lBQWdDO0lBQW1COztFQUFVO0lBQWdDO0lBQVc7O0VBQWtCO0lBQWtDO0lBQTBCOztFQUFjO0lBQWdDO0lBQVU7O0VBQVU7SUFBZ0M7SUFBVzs7RUFBUztJQUFrQztJQUFpQjs7RUFBYztJQUFnQztJQUFtQjs7RUFBVTtJQUFnQztJQUFXOztFQUFrQjtJQUFrQztJQUEwQjs7RUFBYztJQUFnQztJQUFtQjs7RUFBVTtJQUFnQztJQUFXOztFQUFrQjtJQUFrQztJQUEwQjs7RUFBYztJQUFnQztJQUFZOztFQUFVO0lBQWdDO0lBQVc7O0VBQVc7SUFBa0M7SUFBbUI7O0VBQWM7SUFBZ0M7SUFBbUI7O0VBQVU7SUFBZ0M7SUFBVzs7RUFBa0I7SUFBa0M7SUFBMEI7O0VBQWM7SUFBZ0M7SUFBbUI7O0VBQVU7SUFBZ0M7SUFBVzs7RUFBa0I7SUFBa0M7SUFBMEI7O0VBQWM7SUFBZ0M7SUFBVTs7RUFBVTtJQUFnQztJQUFXOztFQUFTO0lBQWtDO0lBQWlCOztFQUFjO0lBQWdDO0lBQW1COztFQUFVO0lBQWdDO0lBQVc7O0VBQWtCO0lBQWtDO0lBQTBCOztFQUFjO0lBQWdDO0lBQW1COztFQUFVO0lBQWdDO0lBQVc7O0VBQWtCO0lBQWtDO0lBQTBCOztFQUFjO0lBQWdDO0lBQVk7O0VBQVU7SUFBZ0M7SUFBVzs7RUFBVztJQUFrQztJQUFtQjs7RUFBYztJQUFnQztJQUFtQjs7RUFBVTtJQUFnQztJQUFXOztFQUFrQjtJQUFrQztJQUEwQjs7RUFBYztJQUFnQztJQUFtQjs7RUFBVTtJQUFnQztJQUFXOztFQUFrQjtJQUFrQztJQUEwQjs7RUFBYztJQUFnQztJQUFXOztFQUFVO0lBQWdDO0lBQVc7O0VBQVU7SUFBa0M7SUFBa0I7OztBQUFlO0VBQXlCO0lBQWU7SUFBYztJQUFjOztFQUFlO0lBQW9COztFQUFVO0lBQW9COztFQUFXO0lBQXNCOztFQUFpQjtJQUFxQjs7RUFBUztJQUFlO0lBQWM7SUFBc0I7O0VBQXVCO0lBQW9COztFQUFrQjtJQUFvQjs7RUFBbUI7SUFBc0I7O0VBQXlCO0lBQXFCOztFQUFTO0lBQWU7SUFBYztJQUFzQjs7RUFBdUI7SUFBb0I7O0VBQWtCO0lBQW9COztFQUFtQjtJQUFzQjs7RUFBeUI7SUFBcUI7O0VBQVM7SUFBZTtJQUFjO0lBQWU7O0VBQWdCO0lBQW9COztFQUFXO0lBQW9COztFQUFZO0lBQXNCOztFQUFrQjtJQUFxQjs7RUFBUztJQUFlO0lBQWM7SUFBc0I7O0VBQXVCO0lBQW9COztFQUFrQjtJQUFvQjs7RUFBbUI7SUFBc0I7O0VBQXlCO0lBQXFCOztFQUFTO0lBQWU7SUFBYztJQUFzQjs7RUFBdUI7SUFBb0I7O0VBQWtCO0lBQW9COztFQUFtQjtJQUFzQjs7RUFBeUI7SUFBcUI7O0VBQVM7SUFBZTtJQUFjO0lBQWE7O0VBQWM7SUFBb0I7O0VBQVM7SUFBb0I7O0VBQVU7SUFBc0I7O0VBQWdCO0lBQXFCOztFQUFTO0lBQWU7SUFBYztJQUFzQjs7RUFBdUI7SUFBb0I7O0VBQWtCO0lBQW9COztFQUFtQjtJQUFzQjs7RUFBeUI7SUFBcUI7O0VBQVM7SUFBZTtJQUFjO0lBQXNCOztFQUF1QjtJQUFvQjs7RUFBa0I7SUFBb0I7O0VBQW1CO0lBQXNCOztFQUF5QjtJQUFxQjs7RUFBUztJQUFlO0lBQWM7SUFBZTs7RUFBZ0I7SUFBb0I7O0VBQVc7SUFBb0I7O0VBQVk7SUFBc0I7O0VBQWtCO0lBQXFCOztFQUFTO0lBQWU7SUFBYztJQUFzQjs7RUFBdUI7SUFBb0I7O0VBQWtCO0lBQW9COztFQUFtQjtJQUFzQjs7RUFBeUI7SUFBcUI7O0VBQVM7SUFBZTtJQUFjO0lBQXNCOztFQUF1QjtJQUFvQjs7RUFBa0I7SUFBb0I7O0VBQW1CO0lBQXNCOztFQUF5QjtJQUFxQjs7RUFBUztJQUFlO0lBQWM7SUFBYTs7RUFBYztJQUFvQjs7RUFBUztJQUFvQjs7RUFBVTtJQUFzQjs7RUFBZ0I7SUFBcUI7O0VBQVM7SUFBZTtJQUFjO0lBQXNCOztFQUF1QjtJQUFvQjs7RUFBa0I7SUFBb0I7O0VBQW1CO0lBQXNCOztFQUF5QjtJQUFxQjs7RUFBUztJQUFlO0lBQWM7SUFBc0I7O0VBQXVCO0lBQW9COztFQUFrQjtJQUFvQjs7RUFBbUI7SUFBc0I7O0VBQXlCO0lBQXFCOztFQUFTO0lBQWM7SUFBYztJQUFlOztFQUFnQjtJQUFtQjs7RUFBVztJQUFtQjs7RUFBWTtJQUFxQjs7RUFBa0I7SUFBb0I7O0VBQVE7SUFBYztJQUFjO0lBQXNCOztFQUF1QjtJQUFtQjs7RUFBa0I7SUFBbUI7O0VBQW1CO0lBQXFCOztFQUF5QjtJQUFvQjs7RUFBUTtJQUFjO0lBQWM7SUFBc0I7O0VBQXVCO0lBQW1COztFQUFrQjtJQUFtQjs7RUFBbUI7SUFBcUI7O0VBQXlCO0lBQW9COztFQUFRO0lBQWM7SUFBYztJQUFhOztFQUFjO0lBQW1COztFQUFTO0lBQW1COztFQUFVO0lBQXFCOztFQUFnQjtJQUFvQjs7RUFBUTtJQUFjO0lBQWM7SUFBc0I7O0VBQXVCO0lBQW1COztFQUFrQjtJQUFtQjs7RUFBbUI7SUFBcUI7O0VBQXlCO0lBQW9COztFQUFRO0lBQWM7SUFBYztJQUFzQjs7RUFBdUI7SUFBbUI7O0VBQWtCO0lBQW1COztFQUFtQjtJQUFxQjs7RUFBeUI7SUFBb0I7O0VBQVE7SUFBYztJQUFjO0lBQWU7O0VBQWdCO0lBQW1COztFQUFXO0lBQW1COztFQUFZO0lBQXFCOztFQUFrQjtJQUFvQjs7RUFBUTtJQUFjO0lBQWM7SUFBcUI7O0VBQXNCO0lBQW1COztFQUFpQjtJQUFtQjs7RUFBa0I7SUFBcUI7O0VBQXdCO0lBQW9COztFQUFRO0lBQWM7SUFBYztJQUFxQjs7RUFBc0I7SUFBbUI7O0VBQWlCO0lBQW1COztFQUFrQjtJQUFxQjs7RUFBd0I7SUFBb0I7O0VBQVE7SUFBYzs7RUFBYTtJQUFnQjs7RUFBVTtJQUFnQjs7RUFBVztJQUFtQjs7RUFBVTtJQUFtQjs7RUFBVztJQUFxQjs7RUFBYztJQUFvQjs7RUFBUTtJQUE0Qjs7RUFBVztJQUE0Qjs7RUFBVTtJQUErQjs7RUFBVztJQUErQjs7RUFBVTtJQUFpQzs7RUFBZTtJQUErQjtJQUFrQjs7RUFBVTtJQUErQjtJQUFXOztFQUFpQjtJQUFpQztJQUF5Qjs7RUFBYztJQUErQjtJQUFrQjs7RUFBVTtJQUErQjtJQUFXOztFQUFpQjtJQUFpQztJQUF5Qjs7RUFBYztJQUErQjtJQUFZOztFQUFVO0lBQStCO0lBQVc7O0VBQVc7SUFBaUM7SUFBbUI7O0VBQWM7SUFBK0I7SUFBbUI7O0VBQVU7SUFBK0I7SUFBVzs7RUFBa0I7SUFBaUM7SUFBMEI7O0VBQWM7SUFBK0I7SUFBbUI7O0VBQVU7SUFBK0I7SUFBVzs7RUFBa0I7SUFBaUM7SUFBMEI7O0VBQWM7SUFBK0I7SUFBVTs7RUFBVTtJQUErQjtJQUFXOztFQUFTO0lBQWlDO0lBQWlCOztFQUFjO0lBQStCO0lBQW1COztFQUFVO0lBQStCO0lBQVc7O0VBQWtCO0lBQWlDO0lBQTBCOztFQUFjO0lBQStCO0lBQW1COztFQUFVO0lBQStCO0lBQVc7O0VBQWtCO0lBQWlDO0lBQTBCOztFQUFjO0lBQStCO0lBQVk7O0VBQVU7SUFBK0I7SUFBVzs7RUFBVztJQUFpQztJQUFtQjs7RUFBYztJQUFnQztJQUFtQjs7RUFBVTtJQUFnQztJQUFXOztFQUFrQjtJQUFrQztJQUEwQjs7RUFBYztJQUFnQztJQUFtQjs7RUFBVTtJQUFnQztJQUFXOztFQUFrQjtJQUFrQztJQUEwQjs7RUFBYztJQUFnQztJQUFVOztFQUFVO0lBQWdDO0lBQVc7O0VBQVM7SUFBa0M7SUFBaUI7O0VBQWM7SUFBZ0M7SUFBbUI7O0VBQVU7SUFBZ0M7SUFBVzs7RUFBa0I7SUFBa0M7SUFBMEI7O0VBQWM7SUFBZ0M7SUFBbUI7O0VBQVU7SUFBZ0M7SUFBVzs7RUFBa0I7SUFBa0M7SUFBMEI7O0VBQWM7SUFBZ0M7SUFBWTs7RUFBVTtJQUFnQztJQUFXOztFQUFXO0lBQWtDO0lBQW1COztFQUFjO0lBQWdDO0lBQW1COztFQUFVO0lBQWdDO0lBQVc7O0VBQWtCO0lBQWtDO0lBQTBCOztFQUFjO0lBQWdDO0lBQW1COztFQUFVO0lBQWdDO0lBQVc7O0VBQWtCO0lBQWtDO0lBQTBCOztFQUFjO0lBQWdDO0lBQVU7O0VBQVU7SUFBZ0M7SUFBVzs7RUFBUztJQUFrQztJQUFpQjs7RUFBYztJQUFnQztJQUFtQjs7RUFBVTtJQUFnQztJQUFXOztFQUFrQjtJQUFrQztJQUEwQjs7RUFBYztJQUFnQztJQUFtQjs7RUFBVTtJQUFnQztJQUFXOztFQUFrQjtJQUFrQztJQUEwQjs7RUFBYztJQUFnQztJQUFZOztFQUFVO0lBQWdDO0lBQVc7O0VBQVc7SUFBa0M7SUFBbUI7O0VBQWM7SUFBZ0M7SUFBbUI7O0VBQVU7SUFBZ0M7SUFBVzs7RUFBa0I7SUFBa0M7SUFBMEI7O0VBQWM7SUFBZ0M7SUFBbUI7O0VBQVU7SUFBZ0M7SUFBVzs7RUFBa0I7SUFBa0M7SUFBMEI7O0VBQWM7SUFBZ0M7SUFBVzs7RUFBVTtJQUFnQztJQUFXOztFQUFVO0lBQWtDO0lBQWtCOzs7QUFBZTtFQUEwQjtJQUFlO0lBQWM7SUFBYzs7RUFBZTtJQUFvQjs7RUFBVTtJQUFvQjs7RUFBVztJQUFzQjs7RUFBaUI7SUFBcUI7O0VBQVM7SUFBZTtJQUFjO0lBQXNCOztFQUF1QjtJQUFvQjs7RUFBa0I7SUFBb0I7O0VBQW1CO0lBQXNCOztFQUF5QjtJQUFxQjs7RUFBUztJQUFlO0lBQWM7SUFBc0I7O0VBQXVCO0lBQW9COztFQUFrQjtJQUFvQjs7RUFBbUI7SUFBc0I7O0VBQXlCO0lBQXFCOztFQUFTO0lBQWU7SUFBYztJQUFlOztFQUFnQjtJQUFvQjs7RUFBVztJQUFvQjs7RUFBWTtJQUFzQjs7RUFBa0I7SUFBcUI7O0VBQVM7SUFBZTtJQUFjO0lBQXNCOztFQUF1QjtJQUFvQjs7RUFBa0I7SUFBb0I7O0VBQW1CO0lBQXNCOztFQUF5QjtJQUFxQjs7RUFBUztJQUFlO0lBQWM7SUFBc0I7O0VBQXVCO0lBQW9COztFQUFrQjtJQUFvQjs7RUFBbUI7SUFBc0I7O0VBQXlCO0lBQXFCOztFQUFTO0lBQWU7SUFBYztJQUFhOztFQUFjO0lBQW9COztFQUFTO0lBQW9COztFQUFVO0lBQXNCOztFQUFnQjtJQUFxQjs7RUFBUztJQUFlO0lBQWM7SUFBc0I7O0VBQXVCO0lBQW9COztFQUFrQjtJQUFvQjs7RUFBbUI7SUFBc0I7O0VBQXlCO0lBQXFCOztFQUFTO0lBQWU7SUFBYztJQUFzQjs7RUFBdUI7SUFBb0I7O0VBQWtCO0lBQW9COztFQUFtQjtJQUFzQjs7RUFBeUI7SUFBcUI7O0VBQVM7SUFBZTtJQUFjO0lBQWU7O0VBQWdCO0lBQW9COztFQUFXO0lBQW9COztFQUFZO0lBQXNCOztFQUFrQjtJQUFxQjs7RUFBUztJQUFlO0lBQWM7SUFBc0I7O0VBQXVCO0lBQW9COztFQUFrQjtJQUFvQjs7RUFBbUI7SUFBc0I7O0VBQXlCO0lBQXFCOztFQUFTO0lBQWU7SUFBYztJQUFzQjs7RUFBdUI7SUFBb0I7O0VBQWtCO0lBQW9COztFQUFtQjtJQUFzQjs7RUFBeUI7SUFBcUI7O0VBQVM7SUFBZTtJQUFjO0lBQWE7O0VBQWM7SUFBb0I7O0VBQVM7SUFBb0I7O0VBQVU7SUFBc0I7O0VBQWdCO0lBQXFCOztFQUFTO0lBQWU7SUFBYztJQUFzQjs7RUFBdUI7SUFBb0I7O0VBQWtCO0lBQW9COztFQUFtQjtJQUFzQjs7RUFBeUI7SUFBcUI7O0VBQVM7SUFBZTtJQUFjO0lBQXNCOztFQUF1QjtJQUFvQjs7RUFBa0I7SUFBb0I7O0VBQW1CO0lBQXNCOztFQUF5QjtJQUFxQjs7RUFBUztJQUFjO0lBQWM7SUFBZTs7RUFBZ0I7SUFBbUI7O0VBQVc7SUFBbUI7O0VBQVk7SUFBcUI7O0VBQWtCO0lBQW9COztFQUFRO0lBQWM7SUFBYztJQUFzQjs7RUFBdUI7SUFBbUI7O0VBQWtCO0lBQW1COztFQUFtQjtJQUFxQjs7RUFBeUI7SUFBb0I7O0VBQVE7SUFBYztJQUFjO0lBQXNCOztFQUF1QjtJQUFtQjs7RUFBa0I7SUFBbUI7O0VBQW1CO0lBQXFCOztFQUF5QjtJQUFvQjs7RUFBUTtJQUFjO0lBQWM7SUFBYTs7RUFBYztJQUFtQjs7RUFBUztJQUFtQjs7RUFBVTtJQUFxQjs7RUFBZ0I7SUFBb0I7O0VBQVE7SUFBYztJQUFjO0lBQXNCOztFQUF1QjtJQUFtQjs7RUFBa0I7SUFBbUI7O0VBQW1CO0lBQXFCOztFQUF5QjtJQUFvQjs7RUFBUTtJQUFjO0lBQWM7SUFBc0I7O0VBQXVCO0lBQW1COztFQUFrQjtJQUFtQjs7RUFBbUI7SUFBcUI7O0VBQXlCO0lBQW9COztFQUFRO0lBQWM7SUFBYztJQUFlOztFQUFnQjtJQUFtQjs7RUFBVztJQUFtQjs7RUFBWTtJQUFxQjs7RUFBa0I7SUFBb0I7O0VBQVE7SUFBYztJQUFjO0lBQXFCOztFQUFzQjtJQUFtQjs7RUFBaUI7SUFBbUI7O0VBQWtCO0lBQXFCOztFQUF3QjtJQUFvQjs7RUFBUTtJQUFjO0lBQWM7SUFBcUI7O0VBQXNCO0lBQW1COztFQUFpQjtJQUFtQjs7RUFBa0I7SUFBcUI7O0VBQXdCO0lBQW9COztFQUFRO0lBQWM7O0VBQWE7SUFBZ0I7O0VBQVU7SUFBZ0I7O0VBQVc7SUFBbUI7O0VBQVU7SUFBbUI7O0VBQVc7SUFBcUI7O0VBQWM7SUFBb0I7O0VBQVE7SUFBNEI7O0VBQVc7SUFBNEI7O0VBQVU7SUFBK0I7O0VBQVc7SUFBK0I7O0VBQVU7SUFBaUM7O0VBQWU7SUFBK0I7SUFBa0I7O0VBQVU7SUFBK0I7SUFBVzs7RUFBaUI7SUFBaUM7SUFBeUI7O0VBQWM7SUFBK0I7SUFBa0I7O0VBQVU7SUFBK0I7SUFBVzs7RUFBaUI7SUFBaUM7SUFBeUI7O0VBQWM7SUFBK0I7SUFBWTs7RUFBVTtJQUErQjtJQUFXOztFQUFXO0lBQWlDO0lBQW1COztFQUFjO0lBQStCO0lBQW1COztFQUFVO0lBQStCO0lBQVc7O0VBQWtCO0lBQWlDO0lBQTBCOztFQUFjO0lBQStCO0lBQW1COztFQUFVO0lBQStCO0lBQVc7O0VBQWtCO0lBQWlDO0lBQTBCOztFQUFjO0lBQStCO0lBQVU7O0VBQVU7SUFBK0I7SUFBVzs7RUFBUztJQUFpQztJQUFpQjs7RUFBYztJQUErQjtJQUFtQjs7RUFBVTtJQUErQjtJQUFXOztFQUFrQjtJQUFpQztJQUEwQjs7RUFBYztJQUErQjtJQUFtQjs7RUFBVTtJQUErQjtJQUFXOztFQUFrQjtJQUFpQztJQUEwQjs7RUFBYztJQUErQjtJQUFZOztFQUFVO0lBQStCO0lBQVc7O0VBQVc7SUFBaUM7SUFBbUI7O0VBQWM7SUFBZ0M7SUFBbUI7O0VBQVU7SUFBZ0M7SUFBVzs7RUFBa0I7SUFBa0M7SUFBMEI7O0VBQWM7SUFBZ0M7SUFBbUI7O0VBQVU7SUFBZ0M7SUFBVzs7RUFBa0I7SUFBa0M7SUFBMEI7O0VBQWM7SUFBZ0M7SUFBVTs7RUFBVTtJQUFnQztJQUFXOztFQUFTO0lBQWtDO0lBQWlCOztFQUFjO0lBQWdDO0lBQW1COztFQUFVO0lBQWdDO0lBQVc7O0VBQWtCO0lBQWtDO0lBQTBCOztFQUFjO0lBQWdDO0lBQW1COztFQUFVO0lBQWdDO0lBQVc7O0VBQWtCO0lBQWtDO0lBQTBCOztFQUFjO0lBQWdDO0lBQVk7O0VBQVU7SUFBZ0M7SUFBVzs7RUFBVztJQUFrQztJQUFtQjs7RUFBYztJQUFnQztJQUFtQjs7RUFBVTtJQUFnQztJQUFXOztFQUFrQjtJQUFrQztJQUEwQjs7RUFBYztJQUFnQztJQUFtQjs7RUFBVTtJQUFnQztJQUFXOztFQUFrQjtJQUFrQztJQUEwQjs7RUFBYztJQUFnQztJQUFVOztFQUFVO0lBQWdDO0lBQVc7O0VBQVM7SUFBa0M7SUFBaUI7O0VBQWM7SUFBZ0M7SUFBbUI7O0VBQVU7SUFBZ0M7SUFBVzs7RUFBa0I7SUFBa0M7SUFBMEI7O0VBQWM7SUFBZ0M7SUFBbUI7O0VBQVU7SUFBZ0M7SUFBVzs7RUFBa0I7SUFBa0M7SUFBMEI7O0VBQWM7SUFBZ0M7SUFBWTs7RUFBVTtJQUFnQztJQUFXOztFQUFXO0lBQWtDO0lBQW1COztFQUFjO0lBQWdDO0lBQW1COztFQUFVO0lBQWdDO0lBQVc7O0VBQWtCO0lBQWtDO0lBQTBCOztFQUFjO0lBQWdDO0lBQW1COztFQUFVO0lBQWdDO0lBQVc7O0VBQWtCO0lBQWtDO0lBQTBCOztFQUFjO0lBQWdDO0lBQVc7O0VBQVU7SUFBZ0M7SUFBVzs7RUFBVTtJQUFrQztJQUFrQjs7O0FBQWU7RUFBMEI7SUFBZ0I7SUFBYztJQUFjOztFQUFlO0lBQXFCOztFQUFVO0lBQXFCOztFQUFXO0lBQXVCOztFQUFpQjtJQUFzQjs7RUFBUztJQUFnQjtJQUFjO0lBQXNCOztFQUF1QjtJQUFxQjs7RUFBa0I7SUFBcUI7O0VBQW1CO0lBQXVCOztFQUF5QjtJQUFzQjs7RUFBUztJQUFnQjtJQUFjO0lBQXNCOztFQUF1QjtJQUFxQjs7RUFBa0I7SUFBcUI7O0VBQW1CO0lBQXVCOztFQUF5QjtJQUFzQjs7RUFBUztJQUFnQjtJQUFjO0lBQWU7O0VBQWdCO0lBQXFCOztFQUFXO0lBQXFCOztFQUFZO0lBQXVCOztFQUFrQjtJQUFzQjs7RUFBUztJQUFnQjtJQUFjO0lBQXNCOztFQUF1QjtJQUFxQjs7RUFBa0I7SUFBcUI7O0VBQW1CO0lBQXVCOztFQUF5QjtJQUFzQjs7RUFBUztJQUFnQjtJQUFjO0lBQXNCOztFQUF1QjtJQUFxQjs7RUFBa0I7SUFBcUI7O0VBQW1CO0lBQXVCOztFQUF5QjtJQUFzQjs7RUFBUztJQUFnQjtJQUFjO0lBQWE7O0VBQWM7SUFBcUI7O0VBQVM7SUFBcUI7O0VBQVU7SUFBdUI7O0VBQWdCO0lBQXNCOztFQUFTO0lBQWdCO0lBQWM7SUFBc0I7O0VBQXVCO0lBQXFCOztFQUFrQjtJQUFxQjs7RUFBbUI7SUFBdUI7O0VBQXlCO0lBQXNCOztFQUFTO0lBQWdCO0lBQWM7SUFBc0I7O0VBQXVCO0lBQXFCOztFQUFrQjtJQUFxQjs7RUFBbUI7SUFBdUI7O0VBQXlCO0lBQXNCOztFQUFTO0lBQWdCO0lBQWM7SUFBZTs7RUFBZ0I7SUFBcUI7O0VBQVc7SUFBcUI7O0VBQVk7SUFBdUI7O0VBQWtCO0lBQXNCOztFQUFTO0lBQWdCO0lBQWM7SUFBc0I7O0VBQXVCO0lBQXFCOztFQUFrQjtJQUFxQjs7RUFBbUI7SUFBdUI7O0VBQXlCO0lBQXNCOztFQUFTO0lBQWdCO0lBQWM7SUFBc0I7O0VBQXVCO0lBQXFCOztFQUFrQjtJQUFxQjs7RUFBbUI7SUFBdUI7O0VBQXlCO0lBQXNCOztFQUFTO0lBQWdCO0lBQWM7SUFBYTs7RUFBYztJQUFxQjs7RUFBUztJQUFxQjs7RUFBVTtJQUF1Qjs7RUFBZ0I7SUFBc0I7O0VBQVM7SUFBZ0I7SUFBYztJQUFzQjs7RUFBdUI7SUFBcUI7O0VBQWtCO0lBQXFCOztFQUFtQjtJQUF1Qjs7RUFBeUI7SUFBc0I7O0VBQVM7SUFBZ0I7SUFBYztJQUFzQjs7RUFBdUI7SUFBcUI7O0VBQWtCO0lBQXFCOztFQUFtQjtJQUF1Qjs7RUFBeUI7SUFBc0I7O0VBQVM7SUFBZTtJQUFjO0lBQWU7O0VBQWdCO0lBQW9COztFQUFXO0lBQW9COztFQUFZO0lBQXNCOztFQUFrQjtJQUFxQjs7RUFBUTtJQUFlO0lBQWM7SUFBc0I7O0VBQXVCO0lBQW9COztFQUFrQjtJQUFvQjs7RUFBbUI7SUFBc0I7O0VBQXlCO0lBQXFCOztFQUFRO0lBQWU7SUFBYztJQUFzQjs7RUFBdUI7SUFBb0I7O0VBQWtCO0lBQW9COztFQUFtQjtJQUFzQjs7RUFBeUI7SUFBcUI7O0VBQVE7SUFBZTtJQUFjO0lBQWE7O0VBQWM7SUFBb0I7O0VBQVM7SUFBb0I7O0VBQVU7SUFBc0I7O0VBQWdCO0lBQXFCOztFQUFRO0lBQWU7SUFBYztJQUFzQjs7RUFBdUI7SUFBb0I7O0VBQWtCO0lBQW9COztFQUFtQjtJQUFzQjs7RUFBeUI7SUFBcUI7O0VBQVE7SUFBZTtJQUFjO0lBQXNCOztFQUF1QjtJQUFvQjs7RUFBa0I7SUFBb0I7O0VBQW1CO0lBQXNCOztFQUF5QjtJQUFxQjs7RUFBUTtJQUFlO0lBQWM7SUFBZTs7RUFBZ0I7SUFBb0I7O0VBQVc7SUFBb0I7O0VBQVk7SUFBc0I7O0VBQWtCO0lBQXFCOztFQUFRO0lBQWU7SUFBYztJQUFxQjs7RUFBc0I7SUFBb0I7O0VBQWlCO0lBQW9COztFQUFrQjtJQUFzQjs7RUFBd0I7SUFBcUI7O0VBQVE7SUFBZTtJQUFjO0lBQXFCOztFQUFzQjtJQUFvQjs7RUFBaUI7SUFBb0I7O0VBQWtCO0lBQXNCOztFQUF3QjtJQUFxQjs7RUFBUTtJQUFlOztFQUFhO0lBQWdCOztFQUFVO0lBQWdCOztFQUFXO0lBQW9COztFQUFVO0lBQW9COztFQUFXO0lBQXNCOztFQUFjO0lBQXFCOztFQUFRO0lBQTRCOztFQUFXO0lBQTRCOztFQUFVO0lBQWdDOztFQUFXO0lBQWdDOztFQUFVO0lBQWtDOztFQUFlO0lBQWdDO0lBQWtCOztFQUFVO0lBQWdDO0lBQVc7O0VBQWlCO0lBQWtDO0lBQXlCOztFQUFjO0lBQWdDO0lBQWtCOztFQUFVO0lBQWdDO0lBQVc7O0VBQWlCO0lBQWtDO0lBQXlCOztFQUFjO0lBQWdDO0lBQVk7O0VBQVU7SUFBZ0M7SUFBVzs7RUFBVztJQUFrQztJQUFtQjs7RUFBYztJQUFnQztJQUFtQjs7RUFBVTtJQUFnQztJQUFXOztFQUFrQjtJQUFrQztJQUEwQjs7RUFBYztJQUFnQztJQUFtQjs7RUFBVTtJQUFnQztJQUFXOztFQUFrQjtJQUFrQztJQUEwQjs7RUFBYztJQUFnQztJQUFVOztFQUFVO0lBQWdDO0lBQVc7O0VBQVM7SUFBa0M7SUFBaUI7O0VBQWM7SUFBZ0M7SUFBbUI7O0VBQVU7SUFBZ0M7SUFBVzs7RUFBa0I7SUFBa0M7SUFBMEI7O0VBQWM7SUFBZ0M7SUFBbUI7O0VBQVU7SUFBZ0M7SUFBVzs7RUFBa0I7SUFBa0M7SUFBMEI7O0VBQWM7SUFBZ0M7SUFBWTs7RUFBVTtJQUFnQztJQUFXOztFQUFXO0lBQWtDO0lBQW1COztFQUFjO0lBQWlDO0lBQW1COztFQUFVO0lBQWlDO0lBQVc7O0VBQWtCO0lBQW1DO0lBQTBCOztFQUFjO0lBQWlDO0lBQW1COztFQUFVO0lBQWlDO0lBQVc7O0VBQWtCO0lBQW1DO0lBQTBCOztFQUFjO0lBQWlDO0lBQVU7O0VBQVU7SUFBaUM7SUFBVzs7RUFBUztJQUFtQztJQUFpQjs7RUFBYztJQUFpQztJQUFtQjs7RUFBVTtJQUFpQztJQUFXOztFQUFrQjtJQUFtQztJQUEwQjs7RUFBYztJQUFpQztJQUFtQjs7RUFBVTtJQUFpQztJQUFXOztFQUFrQjtJQUFtQztJQUEwQjs7RUFBYztJQUFpQztJQUFZOztFQUFVO0lBQWlDO0lBQVc7O0VBQVc7SUFBbUM7SUFBbUI7O0VBQWM7SUFBaUM7SUFBbUI7O0VBQVU7SUFBaUM7SUFBVzs7RUFBa0I7SUFBbUM7SUFBMEI7O0VBQWM7SUFBaUM7SUFBbUI7O0VBQVU7SUFBaUM7SUFBVzs7RUFBa0I7SUFBbUM7SUFBMEI7O0VBQWM7SUFBaUM7SUFBVTs7RUFBVTtJQUFpQztJQUFXOztFQUFTO0lBQW1DO0lBQWlCOztFQUFjO0lBQWlDO0lBQW1COztFQUFVO0lBQWlDO0lBQVc7O0VBQWtCO0lBQW1DO0lBQTBCOztFQUFjO0lBQWlDO0lBQW1COztFQUFVO0lBQWlDO0lBQVc7O0VBQWtCO0lBQW1DO0lBQTBCOztFQUFjO0lBQWlDO0lBQVk7O0VBQVU7SUFBaUM7SUFBVzs7RUFBVztJQUFtQztJQUFtQjs7RUFBYztJQUFpQztJQUFtQjs7RUFBVTtJQUFpQztJQUFXOztFQUFrQjtJQUFtQztJQUEwQjs7RUFBYztJQUFpQztJQUFtQjs7RUFBVTtJQUFpQztJQUFXOztFQUFrQjtJQUFtQztJQUEwQjs7RUFBYztJQUFpQztJQUFXOztFQUFVO0lBQWlDO0lBQVc7O0VBQVU7SUFBbUM7SUFBa0I7OztBQUFlO0VBQWE7OztBQUFjO0VBQVc7RUFBa0I7OztBQUFxQjtFQUFlO0VBQVc7RUFBWTs7O0FBQXNCO0VBQTJCO0VBQXlCO0VBQW1sQjtFQUE0QjtFQUF3Qjs7O0FBQW9CO0VBQWdCO0VBQWtCO0VBQU07RUFBUTtFQUFTO0VBQU87RUFBYTtFQUFtQjtFQUF1QjtFQUFXO0VBQTBCO0VBQWU7RUFBVTs7O0FBQXVCO0VBQXFCO0VBQWM7RUFBZ0I7RUFBbUI7OztBQUF1QjtFQUE4QjtFQUF1Qjs7O0FBQXNCO0VBQXNCOzs7QUFBVTtFQUF1QjtFQUFrQjtFQUFNO0VBQVE7RUFBUzs7O0FBQU87RUFBbUI7RUFBb0I7RUFBWTs7O0FBQWtCO0VBQXFFO0VBQWU7RUFBVTtFQUF1QjtFQUF5QjtFQUFzQjtFQUFxQjs7O0FBQWlCO0VBQXdCO0VBQWU7RUFBTTtFQUFRO0VBQVM7RUFBTztFQUFhO0VBQVk7OztBQUFpQztFQUErQjs7O0FBQWE7RUFBd0I7RUFBZTtFQUFNO0VBQVE7RUFBUztFQUFPO0VBQWM7OztBQUFVO0VBQXdCO0VBQWtCO0VBQU07RUFBUTtFQUFTO0VBQU87OztBQUFnQjtFQUF1QjtFQUFlO0VBQWdCO0VBQXNCO0VBQW9CO0VBQVk7RUFBeUI7RUFBc0I7RUFBcUI7RUFBaUI7OztBQUFvQjtFQUFzRDs7O0FBQTBEO0VBQStCO0VBQWtCO0VBQU07RUFBUTtFQUFTOzs7QUFBTztFQUFzQztFQUFxQjtFQUFVO0VBQVc7RUFBa0I7OztBQUFXO0VBQWlEOzs7QUFBZ0I7RUFBeUQ7OztBQUF1QjtFQUF3Qjs7O0FBQWE7RUFBc0M7RUFBZTtFQUFNO0VBQVE7RUFBYTs7O0FBQVc7RUFBOEI7RUFBc0I7RUFBUztFQUFVO0VBQXNCO0VBQWU7RUFBMEI7RUFBbUI7RUFBNkI7RUFBYTtFQUEyQjtFQUFtQjtFQUEwQjtFQUFnQjtFQUEwQjs7O0FBQW9CO0VBQXdDO0VBQWlCO0VBQWE7RUFBZTs7O0FBQW1CO0VBQThDOzs7QUFBMEI7RUFBaUQ7RUFBMEI7OztBQUFvQjtFQUFxRDs7O0FBQWM7RUFBdUM7RUFBa0I7RUFBUzs7O0FBQTJCO0VBQW1DOzs7QUFBZTtFQUErRDtFQUFlO0VBQVE7RUFBVTtFQUFhO0VBQWE7RUFBbUI7RUFBdUI7RUFBVztFQUFZO0VBQTBCO0VBQTBCO0VBQWtCO0VBQTJCO0VBQWU7RUFBbUI7OztBQUFvQjtFQUEyRTs7O0FBQTBCO0VBQThLO0VBQTBCO0VBQTBCOzs7QUFBbUI7RUFBa047OztBQUFtQjtFQUFpRjs7O0FBQWU7RUFBK0I7OztBQUFTO0VBQWdDOzs7QUFBVTtFQUFnQztFQUFxQjtFQUFXO0VBQVk7RUFBc0I7RUFBZTtFQUFtQjtFQUFzQjtFQUFzQjtFQUF5QjtFQUFrQjtFQUFtQjtFQUFrQjtFQUFvQjtFQUFXO0VBQVU7RUFBMkI7OztBQUEwQjtFQUFrRDtFQUFjO0VBQXNCOzs7QUFBaUI7RUFBc0Q7RUFBYztFQUFxQjs7O0FBQWlCO0VBQTZDO0VBQWM7RUFBeUI7RUFBc0I7RUFBcUI7OztBQUFpQjtFQUF1RDs7O0FBQXVCO0VBQXNEOzs7QUFBdUI7RUFBa0Q7OztBQUF1QjtFQUFzQztFQUFxQjs7O0FBQXVCO0VBQThFO0VBQXFCO0VBQXlDO0VBQXVCOzs7QUFBVTtFQUF5QztFQUFzQjtFQUF5QjtFQUFxQjtFQUFnQjtFQUFtQjs7O0FBQVU7RUFBK0M7RUFBcUI7OztBQUF1QjtFQUEwQztFQUFzQjtFQUF5QjtFQUFxQjtFQUFnQjtFQUFtQjs7O0FBQVU7RUFBZ0Q7RUFBcUI7OztBQUF1QjtFQUF5UztFQUE2QjtFQUFZOzs7QUFBZ0I7RUFBd0M7RUFBZTtFQUFZO0VBQWdCO0VBQW1CO0VBQXNCOzs7QUFBNkI7RUFBbUM7RUFBbUI7OztBQUFlO0VBQW1DOzs7QUFBYztFQUFvRjtFQUFxQjtFQUF1Qjs7O0FBQVU7RUFBOEU7OztBQUFVO0VBQXFFOzs7QUFBdUI7RUFBcUQ7RUFBVztFQUFZOzs7QUFBYTtFQUE4RTs7O0FBQTBCO0VBQTZEOzs7QUFBVTtFQUF1QztFQUFRO0VBQWtCOzs7QUFBYztFQUErRDs7O0FBQVU7RUFBa0Q7RUFBYTtFQUFVO0VBQW1COzs7QUFBb0I7RUFBeUI7RUFBdUI7OztBQUFzQjtFQUF5QjtFQUFrQjtFQUFNO0VBQVE7RUFBVTtFQUFZO0VBQWtCOzs7QUFBZ0I7RUFBZ0U7OztBQUFXO0VBQTBPO0VBQWdCOzs7QUFBcUI7RUFBa1A7RUFBcUI7RUFBd0M7RUFBdUI7OztBQUFVO0VBQXdEOzs7QUFBYztFQUE4TztFQUFnQjs7O0FBQXFCO0VBQXNQO0VBQXFCO0VBQXlDO0VBQXVCOzs7QUFBVTtFQUEwRDs7O0FBQWM7RUFBMFY7RUFBZ0I7OztBQUFxQjtFQUFrVztFQUFxQjtFQUF3QztFQUF1Qjs7O0FBQVU7RUFBc0U7OztBQUFjO0VBQThWO0VBQWdCOzs7QUFBcUI7RUFBc1c7RUFBcUI7RUFBeUM7RUFBdUI7OztBQUFVO0VBQXdFOzs7QUFBYztFQUEyRTtFQUFjOzs7QUFBcUI7RUFBNkU7RUFBYzs7O0FBQXFCO0VBQWtCO0VBQXNCO0VBQTBCO0VBQWdCO0VBQTZCO0VBQWtCO0VBQVc7RUFBWTtFQUFzQjtFQUFlO0VBQW1CO0VBQXNCO0VBQXNCO0VBQW1CO0VBQXFCO0VBQVc7RUFBUztFQUFVO0VBQXlCOzs7QUFBa0I7RUFBb0M7RUFBYztFQUFzQjs7O0FBQWlCO0VBQXdDO0VBQWM7RUFBcUI7OztBQUFpQjtFQUErQjtFQUFjO0VBQXlCO0VBQXNCO0VBQXFCOzs7QUFBaUI7RUFBeUM7OztBQUF1QjtFQUF3Qzs7O0FBQXVCO0VBQW9DOzs7QUFBdUI7RUFBa0Q7RUFBcUI7RUFBeUM7RUFBdUI7OztBQUFVO0VBQTRCO0VBQXNCO0VBQXlCO0VBQXFCO0VBQWdCO0VBQW1COzs7QUFBVTtFQUFrQztFQUFxQjs7O0FBQXVCO0VBQXFOO0VBQTZCO0VBQVk7OztBQUFnQjtFQUEwQjtFQUFlO0VBQVk7RUFBZ0I7RUFBbUI7RUFBc0I7OztBQUE2QjtFQUFxQjs7O0FBQW1CO0VBQXFCOzs7QUFBYztFQUF3QjtFQUFzQjtFQUFTO0VBQVU7RUFBc0I7RUFBZTtFQUEwQjtFQUFtQjtFQUFnQjtFQUE2QjtFQUFrQjtFQUFjO0VBQVc7RUFBeUI7OztBQUFpQjtFQUFxQztFQUFXO0VBQWdCOzs7QUFBZTtFQUFzQzs7O0FBQWtCO0VBQWlEOzs7QUFBZ0I7RUFBcUc7OztBQUFtQjtFQUE4TTs7O0FBQWdCO0VBQTJEO0VBQVU7RUFBbUI7OztBQUFzQjtFQUErQjs7O0FBQXdCO0VBQTBDO0VBQVc7RUFBVztFQUFnQjs7O0FBQW1CO0VBQWdHO0VBQVU7OztBQUF1QjtFQUE4RTs7O0FBQVU7RUFBOEI7RUFBa0I7RUFBZTtFQUFzQjtFQUFnQjtFQUFlO0VBQWtCO0VBQXlCO0VBQXlCO0VBQWtCOzs7QUFBbUI7RUFBMEM7OztBQUFrQjtFQUFrSDtFQUF5QjtFQUE2Qjs7O0FBQWdCO0VBQTJJOzs7QUFBYztFQUFtRDtFQUFrQjs7O0FBQTZCO0VBQXVFO0VBQWdCO0VBQVM7OztBQUFnQjtFQUFrUTtFQUEwQjs7O0FBQTZCO0VBQTRGO0VBQXlCOzs7QUFBNEI7RUFBMkY7RUFBMEI7OztBQUE2QjtFQUEwQzs7O0FBQWU7RUFBeUM7OztBQUFjO0VBQThQO0VBQXlCOzs7QUFBNEI7RUFBc0c7RUFBbUI7OztBQUFlO0VBQXNHOzs7QUFBYztFQUFtRTs7O0FBQVk7RUFBbUU7OztBQUFZO0VBQXlFO0VBQTBCOzs7QUFBNkI7RUFBMkY7RUFBMkI7OztBQUE4QjtFQUFzSztFQUF5Qjs7O0FBQTRCO0VBQXVEOzs7QUFBYztFQUE4RDtFQUFjOzs7QUFBVztFQUE2RDtFQUFjO0VBQVc7OztBQUFXO0VBQTJTOzs7QUFBdUI7RUFBMG5COzs7QUFBVTtFQUF5RDtFQUFxQjtFQUFXO0VBQW1COzs7QUFBZ0I7RUFBZ0s7OztBQUFvQjtFQUF5RTtFQUFrQjs7O0FBQXVCO0VBQXlFOzs7QUFBVztFQUFzVztFQUF1Qjs7O0FBQWdCO0VBQTQ1Qjs7O0FBQVU7RUFBbVg7RUFBMkI7OztBQUE4QjtFQUFrWDtFQUF1QjtFQUE0Qjs7O0FBQStCO0VBQTRGOzs7QUFBbUI7RUFBeUc7OztBQUFpQjtFQUFxVDs7O0FBQWdCO0VBQThJOzs7QUFBMEI7RUFBMEQ7OztBQUEwQjtFQUF5RDs7O0FBQTBCO0VBQXNFO0VBQStCO0VBQWM7OztBQUEwQjtFQUFxRTtFQUFlO0VBQThCOzs7QUFBMEI7RUFBZ0M7RUFBcUI7RUFBaUI7OztBQUFtQjtFQUEwQjtFQUFrQjtFQUFjO0VBQVc7RUFBVztFQUFnQjtFQUFzQjtFQUFnQjtFQUFjO0VBQWtCO0VBQThCOzs7QUFBMEI7RUFBaUM7OztBQUFtQjtFQUF3STs7O0FBQWM7RUFBd0U7RUFBcUI7RUFBYztFQUFrQjtFQUFjO0VBQWtCO0VBQW9CO0VBQXVCO0VBQWtDO0VBQW1DO0VBQWtDO0VBQWtCO0VBQVU7RUFBVztFQUFZO0VBQXNCO0VBQWlCO0VBQTBCO0VBQXlCO0VBQXNCO0VBQXFCOzs7QUFBaUI7RUFBNEU7OztBQUFjO0VBQWdGOzs7QUFBcUI7RUFBc0Y7OztBQUFhO0VBQW9UOzs7QUFBYztFQUF3QjtFQUFxQjs7O0FBQXVCO0VBQXFEO0VBQVU7OztBQUFvQztFQUEwQjtFQUFxQjtFQUF5QztFQUF1Qjs7O0FBQVU7RUFBMkI7RUFBc0I7RUFBeUI7RUFBcUI7RUFBZ0I7RUFBbUI7OztBQUFVO0VBQWlDO0VBQXFCOzs7QUFBdUI7RUFBbUQ7OztBQUFtQjtFQUFvSDs7O0FBQWE7RUFBd0I7RUFBVztFQUFZO0VBQWU7RUFBZ0I7RUFBNkI7RUFBUztFQUFrQjtFQUFVO0VBQTBCO0VBQXVDO0VBQW9DOzs7QUFBK0I7RUFBMEM7RUFBYztFQUFzQjs7O0FBQWlCO0VBQThDO0VBQWM7RUFBcUI7OztBQUFpQjtFQUFxQztFQUFjO0VBQXlCO0VBQXNCO0VBQXFCOzs7QUFBaUI7RUFBK0M7OztBQUF1QjtFQUE4Qzs7O0FBQXVCO0VBQTBDOzs7QUFBdUI7RUFBZ0k7RUFBUztFQUF3Qjs7O0FBQWdCO0VBQXFCO0VBQVU7OztBQUFlO0VBQTJCOzs7QUFBWTtFQUFxQjs7O0FBQVU7RUFBMkI7RUFBWTs7O0FBQWM7RUFBK0I7RUFBa0I7RUFBTTtFQUFRO0VBQVc7RUFBWTtFQUFnQjtFQUEwQjtFQUFVOzs7QUFBbUM7RUFBMEw7RUFBYTtFQUFtQjtFQUF1QjtFQUFlO0VBQWU7OztBQUFjO0VBQTREOzs7QUFBb0I7RUFBK0Q7OztBQUFXO0VBQWdIOzs7QUFBVTtFQUE2QjtFQUE0Qjs7O0FBQWU7RUFBbUM7RUFBUTtFQUFnQjs7O0FBQWtCO0VBQW1DOzs7QUFBcUI7RUFBK0I7RUFBTTtFQUE2QjtFQUErQjs7O0FBQWU7RUFBcUM7RUFBUTtFQUFrQjs7O0FBQTJCO0VBQXFDOzs7QUFBcUI7RUFBNEQ7OztBQUFtQjtFQUFvTDs7O0FBQTZCO0VBQThFOzs7QUFBbUI7RUFBa0s7OztBQUFzQjtFQUE2Qjs7O0FBQWdCO0VBQXFDOzs7QUFBYztFQUFnSDs7O0FBQWtCO0VBQTBHOzs7QUFBaUI7RUFBd0s7OztBQUFVO0VBQXlDOzs7QUFBVTtFQUFtSTs7O0FBQWdCO0VBQXFLO0VBQTBCOzs7QUFBNkI7RUFBb1U7RUFBeUI7OztBQUE0QjtFQUErSjtFQUEwQjs7O0FBQTZCO0VBQXNCOzs7QUFBYztFQUFnRDtFQUErQjs7O0FBQWM7RUFBcUQ7RUFBVzs7O0FBQU87RUFBaUY7OztBQUFxQjtFQUFtRDs7O0FBQTBCO0VBQXFEOzs7QUFBNkI7RUFBOEM7RUFBYzs7O0FBQWlCO0VBQXlCO0VBQWtCO0VBQXFCO0VBQVc7RUFBWTtFQUFpQjtFQUFzQjtFQUFlO0VBQW1CO0VBQXNCO0VBQXNCO0VBQXlCO0VBQWtCO0VBQW1COzs7QUFBb0I7RUFBMkM7RUFBYztFQUFzQjs7O0FBQWlCO0VBQStDO0VBQWM7RUFBcUI7OztBQUFpQjtFQUFzQztFQUFjO0VBQXlCO0VBQXNCO0VBQXFCOzs7QUFBaUI7RUFBZ0Q7OztBQUF1QjtFQUErQzs7O0FBQXVCO0VBQTJDOzs7QUFBdUI7RUFBK0I7RUFBcUI7OztBQUF1QjtFQUE4QztFQUFxQjs7O0FBQWdDO0VBQWdFO0VBQXFCO0VBQXlDO0VBQXVCOzs7QUFBVTtFQUE4RjtFQUFxQjs7O0FBQWdDO0VBQWtDO0VBQXNCO0VBQXlCO0VBQXFCO0VBQWdCO0VBQW1COzs7QUFBVTtFQUF3QztFQUFxQjs7O0FBQXVCO0VBQW1DO0VBQXNCO0VBQXlCO0VBQXFCO0VBQWdCO0VBQW1COzs7QUFBVTtFQUF5QztFQUFxQjs7O0FBQXVCO0VBQStQO0VBQTZCO0VBQVk7OztBQUFnQjtFQUFpQztFQUFlO0VBQVk7RUFBZ0I7RUFBbUI7RUFBc0I7OztBQUE2QjtFQUE0QjtFQUFtQjs7O0FBQWU7RUFBNEI7OztBQUFjO0VBQTZCOzs7QUFBYztFQUFzRTtFQUFxQjtFQUF1Qjs7O0FBQVU7RUFBcUY7RUFBcUI7OztBQUFnQztFQUFvRzs7O0FBQVU7RUFBZ0U7OztBQUFVO0VBQXVEOzs7QUFBNkI7RUFBb0M7RUFBa0I7RUFBWTs7O0FBQWE7RUFBMEM7OztBQUEwQjtFQUFrRDs7O0FBQVU7RUFBZ0M7RUFBUTtFQUFrQjs7O0FBQWM7RUFBb0M7RUFBYTtFQUFVOzs7QUFBbUI7RUFBd0U7OztBQUFpQjtFQUE2Qjs7O0FBQXNCO0VBQWlDOzs7QUFBaUI7RUFBa0I7OztBQUFpQjtFQUFrQjs7O0FBQWdCO0VBQW9EO0VBQVM7RUFBc0I7RUFBZTtFQUFvQjtFQUFlOzs7QUFBcUI7RUFBZ0U7OztBQUFzQjtFQUFrRTs7O0FBQXNCO0VBQWtFOzs7QUFBa0I7RUFBMEU7OztBQUFhO0VBQXlFOzs7QUFBVTtFQUErRjtFQUFrQjtFQUFRO0VBQVU7OztBQUFVO0VBQWtMO0VBQWdCOzs7QUFBcUI7RUFBMEw7RUFBcUI7RUFBd0M7RUFBdUI7OztBQUFVO0VBQTBDOzs7QUFBYztFQUFzTDtFQUFnQjs7O0FBQXFCO0VBQThMO0VBQXFCO0VBQXlDO0VBQXVCOzs7QUFBVTtFQUE0Qzs7O0FBQWM7RUFBa1M7RUFBZ0I7OztBQUFxQjtFQUEwUztFQUFxQjtFQUF3QztFQUF1Qjs7O0FBQVU7RUFBd0Q7OztBQUFjO0VBQXNTO0VBQWdCOzs7QUFBcUI7RUFBOFM7RUFBcUI7RUFBeUM7RUFBdUI7OztBQUFVO0VBQTBEOzs7QUFBYztFQUF5VDs7O0FBQW1CO0VBQTZEO0VBQWM7OztBQUFxQjtFQUErRDtFQUFjOzs7QUFBcUI7RUFBVztFQUFzQjtFQUFTO0VBQTBCO0VBQWdCO0VBQTZCO0VBQWtCO0VBQXFCO0VBQVc7RUFBWTtFQUFpQjtFQUFzQjtFQUFlO0VBQW1CO0VBQXNCO0VBQXNCO0VBQXlCO0VBQWtCOzs7QUFBbUI7RUFBNkI7RUFBYztFQUFzQjs7O0FBQWlCO0VBQWlDO0VBQWM7RUFBcUI7OztBQUFpQjtFQUF3QjtFQUFjO0VBQXlCO0VBQXNCO0VBQXFCOzs7QUFBaUI7RUFBa0M7OztBQUF1QjtFQUFpQzs7O0FBQXVCO0VBQTZCOzs7QUFBdUI7RUFBaUI7RUFBcUI7OztBQUF1QjtFQUFnQztFQUFxQjs7O0FBQWdDO0VBQW9DO0VBQXFCO0VBQXlDO0VBQXVCOzs7QUFBVTtFQUFrRTtFQUFxQjs7O0FBQWdDO0VBQW9CO0VBQXNCO0VBQXlCO0VBQXFCO0VBQWdCO0VBQW1COzs7QUFBVTtFQUEwQjtFQUFxQjs7O0FBQXVCO0VBQXFCO0VBQXNCO0VBQXlCO0VBQXFCO0VBQWdCO0VBQW1COzs7QUFBVTtFQUEyQjtFQUFxQjs7O0FBQXVCO0VBQTJLO0VBQTZCO0VBQVk7OztBQUFnQjtFQUFtQjtFQUFlO0VBQVk7RUFBZ0I7RUFBbUI7RUFBc0I7OztBQUE2QjtFQUFjO0VBQW1COzs7QUFBZTtFQUFjOzs7QUFBYztFQUFlOzs7QUFBYztFQUFpQjtFQUFzQjtFQUFTO0VBQVU7RUFBc0I7RUFBZTtFQUEwQjtFQUFtQjtFQUFnQjtFQUE2QjtFQUFrQjtFQUFjO0VBQVc7RUFBeUI7OztBQUFpQjtFQUE4QjtFQUFXO0VBQWdCOzs7QUFBZTtFQUErQjs7O0FBQWtCO0VBQTBDOzs7QUFBZ0I7RUFBeUU7OztBQUFtQjtFQUFrTDs7O0FBQWdCO0VBQTZDO0VBQVU7RUFBbUI7OztBQUFzQjtFQUF3Qjs7O0FBQXdCO0VBQTRCO0VBQVc7RUFBVztFQUFnQjs7O0FBQW1CO0VBQW9FO0VBQVU7OztBQUF1QjtFQUFnRTs7O0FBQVU7RUFBdUI7RUFBa0I7RUFBZTtFQUFzQjtFQUFnQjtFQUFlO0VBQWtCO0VBQXlCO0VBQXlCO0VBQWtCOzs7QUFBbUI7RUFBbUM7OztBQUFrQjtFQUEyRztFQUF5QjtFQUE2Qjs7O0FBQWdCO0VBQTZIOzs7QUFBYztFQUE0QztFQUFrQjs7O0FBQTZCO0VBQWdFO0VBQWdCO0VBQVM7OztBQUFnQjtFQUF3TjtFQUEwQjs7O0FBQTZCO0VBQXVFO0VBQXlCOzs7QUFBNEI7RUFBc0U7RUFBMEI7OztBQUE2QjtFQUFtQzs7O0FBQWU7RUFBa0M7OztBQUFjO0VBQW9OO0VBQXlCOzs7QUFBNEI7RUFBMEU7RUFBbUI7OztBQUFlO0VBQTBFOzs7QUFBYztFQUE0RDs7O0FBQVk7RUFBNEQ7OztBQUFZO0VBQTJEO0VBQTBCOzs7QUFBNkI7RUFBNkU7RUFBMkI7OztBQUE4QjtFQUEwSTtFQUF5Qjs7O0FBQTRCO0VBQXlDOzs7QUFBYztFQUFnRDtFQUFjOzs7QUFBVztFQUErQztFQUFjO0VBQVc7OztBQUFXO0VBQTBQOzs7QUFBdUI7RUFBd2hCOzs7QUFBVTtFQUEyQztFQUFxQjtFQUFXO0VBQW1COzs7QUFBZ0I7RUFBNkg7OztBQUFvQjtFQUEyRDtFQUFrQjs7O0FBQXVCO0VBQW9EOzs7QUFBVztFQUE4UztFQUF1Qjs7O0FBQWdCO0VBQWd4Qjs7O0FBQVU7RUFBMlQ7RUFBMkI7OztBQUE4QjtFQUEwVDtFQUF1QjtFQUE0Qjs7O0FBQStCO0VBQThFOzs7QUFBbUI7RUFBMkY7OztBQUFpQjtFQUF5Ujs7O0FBQWdCO0VBQWdJOzs7QUFBMEI7RUFBb0c7OztBQUEwQjtFQUF3RDtFQUErQjs7O0FBQWM7RUFBdUQ7RUFBZTtFQUE4Qjs7O0FBQTBCO0VBQWlNOzs7QUFBMEI7RUFBK0U7OztBQUEwQjtFQUErRTtFQUFlO0VBQWlCOzs7QUFBc0I7RUFBMlk7OztBQUEwQjtFQUF1ZjtFQUFzQjs7O0FBQTBCO0VBQW1HO0VBQWtCOzs7QUFBYztFQUFvSTs7O0FBQTBCO0VBQXlCO0VBQXFCO0VBQVc7RUFBaUI7OztBQUFtQjtFQUFpQztFQUFzQjtFQUFlOzs7QUFBbUI7RUFBdUM7OztBQUFzQjtFQUF1Qjs7O0FBQVk7RUFBb0M7OztBQUFZO0VBQW9DO0VBQVk7RUFBZ0I7OztBQUFtQjtFQUEwQzs7O0FBQVk7RUFBcUM7RUFBWTtFQUFzQjtFQUFtQjtFQUF5Qjs7O0FBQW9CO0VBQXFFOzs7QUFBb0I7RUFBMkI7RUFBa0I7RUFBTTtFQUFXO0VBQVM7RUFBVTtFQUFvQjtFQUFtQjs7O0FBQVk7RUFBMkY7OztBQUFrQjtFQUFxRjs7O0FBQWlCO0VBQTJGOzs7QUFBVTtFQUFrQzs7O0FBQVU7RUFBdUc7OztBQUFnQjtFQUFrSTtFQUEwQjs7O0FBQTZCO0VBQThQO0VBQXlCOzs7QUFBNEI7RUFBNEg7RUFBMEI7OztBQUE2QjtFQUFzRTs7O0FBQXFCO0VBQWtOOzs7QUFBMEI7RUFBMkM7OztBQUFnQjtFQUFnQzs7O0FBQW1CO0VBQXFFO0VBQVU7RUFBVTs7O0FBQVM7RUFBOEY7RUFBYztFQUFpQjs7O0FBQTBCO0VBQW9IOzs7QUFBc0I7RUFBMkk7RUFBTTtFQUFRO0VBQVM7OztBQUFPO0VBQXlCOzs7QUFBWTtFQUE4RDs7O0FBQVU7RUFBaUQ7OztBQUFZO0VBQWlEOzs7QUFBWTtFQUE0SjtFQUFrQjs7O0FBQWdCO0VBQTRMOzs7QUFBZ0I7RUFBZ3ZCOzs7QUFBVTtFQUEwSTtFQUFpQjs7O0FBQWdCO0VBQWtEOzs7QUFBYztFQUFxRTtFQUFZOzs7QUFBYTtFQUErQzs7O0FBQWlCO0VBQStDOzs7QUFBaUI7RUFBd0I7OztBQUFjO0VBQTREOzs7QUFBZ0I7RUFBOEQ7RUFBZTs7O0FBQWdCO0VBQW1EO0VBQVc7OztBQUFTO0VBQXNCOzs7QUFBYztFQUEwTjs7O0FBQTBCO0VBQXNPOzs7QUFBMEI7RUFBOEk7OztBQUEyQjtFQUF5RTtFQUFXOzs7QUFBVTtFQUFrRzs7O0FBQTBCO0VBQXNFO0lBQVc7O0VBQVk7SUFBYzs7RUFBWTtJQUFjOztFQUFZO0lBQXlDOzs7QUFBYTtFQUFZO0VBQWE7RUFBVTtFQUFzQjtFQUFhOzs7QUFBbUI7RUFBMEI7OztBQUFzQjtFQUFpQzs7O0FBQW1CO0VBQWtHOzs7QUFBUTtFQUFzQzs7O0FBQWM7RUFBbUI7RUFBWTtFQUFlO0VBQXNCO0VBQWlCOzs7QUFBbUI7RUFBbUI7RUFBa0I7RUFBc0I7RUFBZTs7O0FBQW1CO0VBQW9CO0VBQVU7OztBQUFhO0VBQWtCO0VBQWtCO0VBQVk7RUFBbUI7OztBQUFtQjtFQUEyQjtFQUFZO0VBQWlCOzs7QUFBaUI7RUFBK0Q7OztBQUFXO0VBQThCOzs7QUFBb0I7RUFBd0I7OztBQUFRO0VBQTBCO0VBQWU7RUFBUztFQUFVO0VBQVk7RUFBVztFQUFpQjtFQUFrQjtFQUFtQjtFQUFlOzs7QUFBbUI7RUFBK0I7OztBQUFnQjtFQUFxQztFQUFrQjtFQUFTO0VBQVk7RUFBVTtFQUFXO0VBQVk7RUFBVztFQUFlO0VBQWlCO0VBQWtCO0VBQW1CO0VBQTBCO0VBQWU7OztBQUErQjtFQUEyQztFQUFrQjtFQUFNO0VBQVE7RUFBUztFQUFPO0VBQXVCO0VBQW1COzs7QUFBVztFQUFpRDs7O0FBQThCO0VBQTJDO0VBQVc7OztBQUEwQjtFQUF3Qjs7O0FBQWdCO0VBQStHO0VBQXNCOzs7QUFBZ0I7RUFBZ0I7OztBQUFjO0VBQVU7RUFBc0I7RUFBUztFQUFVO0VBQXNCO0VBQWU7RUFBMEI7RUFBbUI7RUFBZ0I7RUFBNkI7OztBQUFrQjtFQUFZOzs7QUFBYTtFQUFxQjtFQUFnQjs7O0FBQWlCO0VBQTZDOzs7QUFBZ0I7RUFBZTtFQUFnQjs7O0FBQWtCO0VBQXNCO0VBQW1COzs7QUFBa0I7RUFBZTtFQUFnQjs7O0FBQWtCO0VBQXFCO0VBQWE7RUFBc0I7RUFBZTs7O0FBQWtCO0VBQWdCO0VBQVM7RUFBVTs7O0FBQWdCO0VBQWU7RUFBYTtFQUFtQjtFQUE4QjtFQUFlOzs7QUFBc0I7RUFBb0I7RUFBYTtFQUFPO0VBQXVCOzs7QUFBZTtFQUEyQjs7O0FBQWtCO0VBQTRCO0VBQVM7RUFBUTs7O0FBQXNCO0VBQTBCO0VBQWtCO0VBQXNCO0VBQWU7OztBQUFtQjtFQUE0QjtFQUFzQjs7O0FBQW1CO0VBQWtDOzs7QUFBYztFQUFnQztFQUFzQjtFQUFlOzs7QUFBbUI7RUFBc0I7RUFBYztFQUFpQjtFQUFVO0VBQVk7OztBQUFnQjtFQUF5QjtFQUFrQjtFQUFxQjtFQUFjO0VBQXNCO0VBQWU7RUFBbUI7OztBQUFrQjtFQUFxQzs7O0FBQWU7RUFBNEI7RUFBa0I7RUFBUTtFQUFRO0VBQVU7RUFBWTtFQUFnQjs7O0FBQXlCO0VBQWtDOzs7QUFBdUI7RUFBa0M7RUFBaUI7OztBQUFvQjtFQUFnQjtFQUFlO0VBQXNCO0VBQWU7OztBQUFrQjtFQUErQjs7O0FBQWdDO0VBQTBDOzs7QUFBbUI7RUFBaUM7OztBQUFnQztFQUFnRDs7O0FBQTZCO0VBQWdEOzs7QUFBZ0I7RUFBaUg7OztBQUFnQztFQUE0Qjs7O0FBQWtCO0VBQTRCOzs7QUFBaUI7RUFBa0M7OztBQUFtQjtFQUF1QztFQUFjOzs7QUFBTztFQUF3Qzs7O0FBQWlCO0VBQXVDOzs7QUFBbUI7RUFBNkM7RUFBbUI7RUFBc0I7RUFBZTs7O0FBQWlCO0VBQXlDO0VBQWdCOzs7QUFBaUI7RUFBNEM7OztBQUFlO0VBQXdEOzs7QUFBZTtFQUF1QztFQUFjO0VBQWU7RUFBbUI7RUFBYztFQUFpQjs7O0FBQW1CO0VBQXVCOzs7QUFBYztFQUErRTs7O0FBQVk7RUFBbUI7RUFBeUI7OztBQUFrQjtFQUEwRztFQUFtQjs7O0FBQWtCO0VBQXdDOzs7QUFBaUI7RUFBOEk7OztBQUFpQjtFQUE4STs7O0FBQWtCO0VBQW9DO0lBQThEOzs7QUFBa0I7RUFBb0M7SUFBZTs7RUFBZTtJQUFzQjs7RUFBaUI7SUFBa0M7O0VBQXVCO0lBQXVDOztFQUFnQjtJQUF3Qzs7O0FBQXVCO0VBQWM7RUFBYzs7O0FBQWlCO0VBQXFEOzs7QUFBYztFQUFtQzs7O0FBQWdCO0VBQXlDO0VBQWU7OztBQUFpQjtFQUFvQztFQUFrQjs7O0FBQWM7RUFBNEQ7RUFBZ0I7OztBQUFrQjtFQUEwQztFQUFXOzs7QUFBTztFQUFxRDtFQUFrQjs7O0FBQWM7RUFBc0Q7OztBQUFrQjtFQUFzRTtFQUFnQjs7O0FBQWtCO0VBQTZGOzs7QUFBVztFQUFvQztJQUEwRjtJQUFrQjs7O0FBQWU7RUFBb0M7SUFBb0M7SUFBa0I7O0VBQWM7SUFBcUQ7OztBQUF1QjtFQUEwTTtFQUFnQjs7O0FBQXFCO0VBQWtOO0VBQXFCO0VBQXdDO0VBQXVCOzs7QUFBVTtFQUE2Qzs7O0FBQWM7RUFBOE07RUFBZ0I7OztBQUFxQjtFQUFzTjtFQUFxQjtFQUF5QztFQUF1Qjs7O0FBQVU7RUFBK0M7OztBQUFjO0VBQWM7RUFBc0I7RUFBUztFQUEwQjtFQUFnQjtFQUE2QjtFQUFXO0VBQVk7RUFBc0I7RUFBZTtFQUFzQjtFQUFzQjtFQUF5QjtFQUFrQjtFQUFtQjtFQUFrQjtFQUFxQjtFQUFZO0VBQVU7RUFBZ0I7RUFBbUI7RUFBcUI7OztBQUFzQjtFQUFnQztFQUFjO0VBQXNCOzs7QUFBaUI7RUFBb0M7RUFBYztFQUFxQjs7O0FBQWlCO0VBQTJCO0VBQWM7RUFBeUI7RUFBc0I7RUFBcUI7OztBQUFpQjtFQUFxQzs7O0FBQXVCO0VBQW9DOzs7QUFBdUI7RUFBZ0M7OztBQUF1QjtFQUE4RDtFQUFxQjs7O0FBQXVCO0VBQTBDO0VBQXlDOzs7QUFBVTtFQUF1QjtFQUFzQjtFQUF5QjtFQUFxQjtFQUFnQjtFQUFtQjs7O0FBQVU7RUFBNkI7RUFBcUI7OztBQUF1QjtFQUF3QjtFQUFzQjtFQUF5QjtFQUFxQjtFQUFnQjtFQUFtQjs7O0FBQVU7RUFBOEI7RUFBcUI7OztBQUF1QjtFQUE2TDtFQUE2QjtFQUFZOzs7QUFBZ0I7RUFBc0I7RUFBZTtFQUFZO0VBQWdCO0VBQW1CO0VBQXNCOzs7QUFBNkI7RUFBaUI7RUFBbUI7OztBQUFlO0VBQWlCOzs7QUFBYztFQUFnQztFQUFzQjtFQUF5QjtFQUFxQjtFQUFnQjtFQUFtQjs7O0FBQVU7RUFBc0M7RUFBcUI7OztBQUF1QjtFQUFzQjtFQUFxQjtFQUF5QztFQUF1Qjs7O0FBQVU7RUFBNkM7RUFBZ0I7RUFBUztFQUFpQjtFQUFpQjtFQUFrQjtFQUFnQjtFQUFvQjtFQUFrQjtFQUFvQjtFQUFtQjtFQUFxQjtFQUF5QjtFQUFxQjtFQUFvQjtFQUFrQjtFQUF1QjtFQUFvQjtFQUFtQjtFQUFtQjtFQUFxQjtFQUFtQjtFQUFzQjtFQUFvQjs7O0FBQWlCO0VBQXVCO0VBQVc7RUFBWTtFQUFhOzs7QUFBWTtFQUF5QztFQUFjO0VBQXNCOzs7QUFBaUI7RUFBNkM7RUFBYztFQUFxQjs7O0FBQWlCO0VBQW9DO0VBQWM7RUFBeUI7RUFBc0I7RUFBcUI7OztBQUFpQjtFQUE4Qzs7O0FBQXVCO0VBQTZDOzs7QUFBdUI7RUFBeUM7OztBQUF1QjtFQUFzQjtFQUFrQjtFQUFNO0VBQVE7RUFBUztFQUFPO0VBQVc7RUFBa0I7OztBQUFvQjtFQUEyQjtFQUFxQjs7O0FBQWU7RUFBdUI7RUFBUztFQUFVO0VBQXNCO0VBQTBCO0VBQW1CO0VBQWdCO0VBQTZCO0VBQWtCO0VBQVk7RUFBYTtFQUFhO0VBQXNCO0VBQWU7RUFBb0I7RUFBc0I7RUFBa0I7RUFBYTs7O0FBQXNHO0VBQThCOzs7QUFBYTtFQUE0QjtFQUFpQjtFQUFnQjtFQUFlO0VBQWM7RUFBZ0I7OztBQUFhO0VBQWlDO0VBQWtCO0VBQWM7RUFBZ0I7RUFBaUI7RUFBZ0I7RUFBc0I7RUFBZ0I7RUFBbUI7RUFBbUI7RUFBdUI7RUFBZTs7O0FBQStCO0VBQXVDOzs7QUFBeUI7RUFBNkM7OztBQUEwQjtFQUE0Qzs7O0FBQTBCO0VBQTBDO0VBQXNCOzs7QUFBbUI7RUFBZ0Q7RUFBc0I7RUFBc0I7OztBQUFtQjtFQUEwQztFQUFzQjtFQUFnQjs7O0FBQXlCO0VBQXdDOzs7QUFBeUI7RUFBcUI7RUFBa0I7RUFBTTtFQUFXO0VBQVM7RUFBVTtFQUFvQjtFQUFtQjs7O0FBQVk7RUFBa0I7OztBQUFjO0VBQXlIOzs7QUFBYztFQUEyQzs7O0FBQW1CO0VBQWlKOzs7QUFBYztFQUFpRjs7O0FBQXlCO0VBQTJEOzs7QUFBMkI7RUFBaUs7OztBQUFjO0VBQW9HO0VBQVc7OztBQUF5QjtFQUFVO0VBQXNCO0VBQTBCO0VBQW1CO0VBQTZCO0VBQVM7RUFBVTtFQUFzQjtFQUFlO0VBQWM7RUFBZ0I7RUFBZ0I7RUFBZ0I7RUFBYTtFQUFzRzs7O0FBQThEO0VBQWlDO0VBQWM7OztBQUFXO0VBQWdCOzs7QUFBVztFQUFzQzs7O0FBQTZCO0VBQTBCO0VBQVM7RUFBVTs7O0FBQWdCO0VBQW1COzs7QUFBYTtFQUF3Qjs7O0FBQVU7RUFBMEM7OztBQUFhO0VBQTJCO0VBQWM7RUFBaUI7RUFBc0I7RUFBZTtFQUFtQjs7O0FBQW1CO0VBQXVDOzs7QUFBeUc7RUFBMkM7OztBQUFxSjtFQUEyQjs7O0FBQWM7RUFBcUQ7OztBQUFtQjtFQUFnQztFQUFZOzs7QUFBb0c7RUFBd0I7OztBQUFxQjtFQUFpQjs7O0FBQXNCO0VBQXVCOzs7QUFBYztFQUF3QjtFQUFrQjtFQUFNO0VBQVE7RUFBUztFQUFPO0VBQTZCOzs7QUFBVztFQUE0Qjs7O0FBQXNCO0VBQWtDOzs7QUFBYztFQUF1QjtFQUFnQjtFQUFjO0VBQXFCOzs7QUFBcUI7RUFBOEI7OztBQUFvQjtFQUEyRTs7O0FBQWdCO0VBQTBKOzs7QUFBNkI7RUFBa0Y7OztBQUFjO0VBQTREOzs7QUFBeUI7RUFBNEQ7OztBQUErQjtFQUF5Qjs7O0FBQThCO0VBQTJHO0VBQWdCO0VBQStCO0VBQVU7RUFBZ0I7OztBQUFlO0VBQTZLO0VBQWtCOzs7QUFBZ0I7RUFBd0o7RUFBTztFQUFjOzs7QUFBZTtFQUEwSzs7O0FBQWU7RUFBeVQ7OztBQUFxQjtFQUFrQzs7O0FBQWdCO0VBQWlGOzs7QUFBMkM7RUFBdUM7RUFBa0I7RUFBYztFQUFTO0VBQWU7RUFBbUI7RUFBZTs7O0FBQXNGO0VBQXdJO0VBQWU7RUFBZTs7O0FBQTRHO0VBQTRKO0VBQWlCO0VBQVU7OztBQUEyRTtFQUF1Rjs7O0FBQXVCO0VBQTRPOzs7QUFBZTtFQUE2SDs7O0FBQTZCO0VBQWlDO0VBQWE7OztBQUFVO0VBQXdCO0VBQWtCO0VBQWE7RUFBdUI7RUFBa0I7RUFBZ0I7OztBQUFxQjtFQUErQjtFQUFrQjtFQUFTO0VBQVE7RUFBUztFQUFPO0VBQVc7RUFBVztFQUFZO0VBQWM7OztBQUFZO0VBQTRDO0VBQU07OztBQUFVO0VBQTRCO0VBQXNCOzs7QUFBa0I7RUFBZ0Q7OztBQUF3RDtFQUFrQzs7O0FBQXNCO0VBQXNEO0VBQWtCO0VBQVE7RUFBVztFQUFXO0VBQXNCO0VBQTJCOzs7QUFBd0Q7RUFBNkQ7RUFBa0I7RUFBVTtFQUFhO0VBQThCO0VBQWtCO0VBQXNMOzs7QUFBVztFQUErQjs7O0FBQTJDO0VBQThCOzs7QUFBMkM7RUFBc0o7OztBQUFjO0VBQWtIOzs7QUFBMkM7RUFBZ0g7OztBQUEyQztFQUFxRDs7O0FBQWE7RUFBK0Y7OztBQUEyQjtFQUFxRzs7O0FBQTRDO0VBQXNHOzs7QUFBMEM7RUFBcUo7OztBQUFjO0VBQXFCO0VBQWlCO0VBQVM7RUFBZ0M7OztBQUFnQjtFQUFtSDtFQUFnQjtFQUFnQjs7O0FBQWU7RUFBa2dCOzs7QUFBYztFQUFrakI7OztBQUFnQztFQUEyRTtFQUFrQjtFQUFRO0VBQXFCOzs7QUFBc0I7RUFBdUY7RUFBa0I7RUFBVztFQUFTO0VBQVU7RUFBb0M7RUFBMkQ7OztBQUFXO0VBQStEOzs7QUFBVTtFQUFzQzs7O0FBQXNCO0VBQTRDOzs7QUFBYztFQUE2Qzs7O0FBQVk7RUFBK0M7OztBQUFjO0VBQTJCO0VBQWM7RUFBVztFQUFTOzs7QUFBYztFQUFpSjs7O0FBQWtCO0VBQXlLO0VBQWtCO0VBQU07RUFBUTtFQUFTO0VBQStCO0VBQXdCO0VBQVU7RUFBbUc7OztBQUFXO0VBQXNVO0VBQVk7RUFBZTtFQUFrQjtFQUFlO0VBQWdCO0VBQWlCOzs7QUFBdUI7RUFBNko7OztBQUFxQjtFQUFxTjs7O0FBQWtCO0VBQThZO0VBQVk7OztBQUFpQjtFQUFnSDs7O0FBQW1CO0VBQWlCOzs7QUFBVztFQUF5RjtFQUFvQjtFQUFVOzs7QUFBcUc7RUFBeUU7OztBQUF1QjtFQUE0Rzs7O0FBQW1CO0VBQXFHO0VBQWE7RUFBbUI7OztBQUFxRjtFQUFxSjtFQUFVO0VBQVk7RUFBZ0I7OztBQUF1QjtFQUF5Rzs7O0FBQVU7RUFBb0M7OztBQUFXO0VBQWdXO0VBQU87RUFBMEI7OztBQUFtQjtFQUFnYzs7O0FBQVU7RUFBb3pCO0VBQVM7RUFBZTs7O0FBQWlCO0VBQTQxQjtFQUFxQjs7O0FBQVU7RUFBcUc7OztBQUFxQjtFQUE0Qzs7O0FBQW9CO0VBQXFIOzs7QUFBYTtFQUE4Qzs7O0FBQTBCO0VBQStEO0VBQWtCO0VBQWlCO0VBQWdCO0VBQW1COzs7QUFBdUI7RUFBMEI7RUFBUzs7O0FBQVU7RUFBMkY7OztBQUFzQjtFQUE2STs7O0FBQWdCO0VBQStNO0VBQWU7OztBQUFrQjtFQUE4QjtFQUFVO0VBQW1CO0VBQWdCOzs7QUFBZ0I7RUFBcUg7RUFBWTtFQUFpQjtFQUEyQjs7O0FBQXFCO0VBQXlEOzs7QUFBa0I7RUFBbUQ7RUFBZ0M7RUFBZ0I7OztBQUFtQjtFQUErRDs7O0FBQW1DO0VBQXVEO0VBQWdDOzs7QUFBb0I7RUFBbUc7RUFBZ0M7OztBQUFtQjtFQUFnVTs7O0FBQXFDO0VBQTZCOzs7QUFBb0I7RUFBZ0Y7OztBQUFXO0VBQXlPOzs7QUFBYztFQUF1STs7O0FBQTZCO0VBQTJGO0VBQTBCOzs7QUFBbUI7RUFBMk87RUFBWTs7O0FBQW1CO0VBQTZmOzs7QUFBZ0I7RUFBc0M7OztBQUF1QjtFQUE2Qzs7O0FBQW1CO0VBQW1DOzs7QUFBZ0I7RUFBdUc7RUFBTTtFQUFhO0VBQWU7RUFBcUI7OztBQUFnQjtFQUF3RDs7O0FBQXlCO0VBQTJEOzs7QUFBUztFQUE2STs7O0FBQTBCO0VBQTZJOzs7QUFBZTtFQUF5TTtFQUFPO0VBQWM7OztBQUFlO0VBQWlPOzs7QUFBZTtFQUFxRzs7O0FBQVc7RUFBOE87RUFBVzs7O0FBQTZCO0VBQWtoQjs7O0FBQVc7RUFBOGdCOzs7QUFBVTtFQUEwbUM7OztBQUFnQjtFQUFvQzs7O0FBQTZCO0VBQStFOzs7QUFBeUI7RUFBdUM7RUFBVzs7O0FBQWU7RUFBNkM7OztBQUFlO0VBQTBaOzs7QUFBVztFQUE4Rzs7O0FBQXlCO0VBQXFRO0VBQW9DOzs7QUFBVztFQUFpSTs7O0FBQW9DO0VBQTRYOzs7QUFBeUM7RUFBdUI7RUFBYzs7O0FBQWlCO0VBQXlDOzs7QUFBaUI7RUFBOEQ7RUFBa0I7OztBQUE4QjtFQUEwRjs7O0FBQWlCO0VBQXVZOzs7QUFBMkI7RUFBZ007RUFBa0I7OztBQUFpQjtFQUFvUzs7O0FBQWM7RUFBNkM7OztBQUF3QjtFQUE2VztFQUFXOzs7QUFBVTtFQUEyUzs7O0FBQTBDO0VBQXdTOzs7QUFBd0M7RUFBNk47RUFBVzs7O0FBQU87RUFBOGE7OztBQUFpQjtFQUFzRDtFQUFnQjs7O0FBQWtCO0VBQXdEO0VBQW1COzs7QUFBa0I7RUFBa0Y7OztBQUEwQjtFQUF1SDs7O0FBQXNCO0VBQThCOzs7QUFBUztFQUFzRTtFQUFtQjs7O0FBQWU7RUFBYTtFQUFzQjtFQUFTO0VBQVU7RUFBc0I7RUFBZTtFQUEwQjtFQUFtQjtFQUFnQjtFQUE2QjtFQUFlO0VBQVE7RUFBTztFQUFhO0VBQVc7OztBQUFvQjtFQUFvQjtFQUFZOzs7QUFBa0I7RUFBNEI7RUFBcUI7RUFBa0I7RUFBZ0I7RUFBa0I7RUFBc0c7OztBQUFtQjtFQUE4Qjs7O0FBQWM7RUFBNEI7OztBQUFjO0VBQThCOzs7QUFBYztFQUF5RDs7O0FBQWM7RUFBc0I7RUFBa0I7RUFBUTtFQUFpQjs7O0FBQWU7RUFBK0Q7RUFBOEI7OztBQUF1QjtFQUEwQjtJQUFHO0lBQWlCO0lBQVk7O0VBQVU7SUFBRztJQUFhO0lBQVU7OztBQUFXO0VBQXVDOzs7QUFBYztFQUEwQjtFQUFlOzs7QUFBZ0I7RUFBVztFQUFzQjtFQUFzQjtFQUFlO0VBQTBCO0VBQW1CO0VBQWdCO0VBQTZCO0VBQW9CO0VBQWtCO0VBQVU7RUFBVztFQUE2QjtFQUFjOzs7QUFBaUI7RUFBcUQ7RUFBZTtFQUFVO0VBQXVCO0VBQXlCO0VBQXNCO0VBQXFCOzs7QUFBaUI7RUFBZ0I7RUFBZTtFQUFNO0VBQVE7RUFBUztFQUFPO0VBQWE7RUFBWTs7O0FBQWlDO0VBQXVCOzs7QUFBYTtFQUFnQjtFQUFlO0VBQU07RUFBUTtFQUFTO0VBQU87RUFBYztFQUFVOzs7QUFBYTtFQUFpQjtFQUFTO0VBQXNCO0VBQWdCO0VBQWU7RUFBaUI7OztBQUFxQjtFQUFtQjtFQUFrQjtFQUFzQjtFQUE0QjtFQUFTO0VBQWtCO0VBQXNHOzs7QUFBb0I7RUFBaUI7RUFBa0I7RUFBTTtFQUFRO0VBQVc7RUFBVTtFQUFzQjtFQUFnQjtFQUFjO0VBQXFCO0VBQXVCO0VBQVM7RUFBVTtFQUFlOzs7QUFBcUI7RUFBbUI7RUFBYztFQUFXO0VBQVk7RUFBZTtFQUFrQjtFQUFpQjtFQUFrQjtFQUFvQjs7O0FBQW9CO0VBQThDO0VBQXNCOzs7QUFBcUI7RUFBa0I7RUFBa0I7RUFBc0I7RUFBZ0I7RUFBZ0M7OztBQUEwQjtFQUFnQjtFQUFhO0VBQWU7RUFBbUI7OztBQUFxQjtFQUFrQjtFQUFrQjtFQUFpQjtFQUF1QjtFQUE2Qjs7O0FBQTBCO0VBQStEO0VBQWdCOzs7QUFBZ0I7RUFBZ0I7OztBQUFnQjtFQUFvQjs7O0FBQWtCO0VBQTJCO0VBQXFCO0VBQVE7RUFBWTtFQUFzQjs7O0FBQVc7RUFBK0I7RUFBTTtFQUFxQjtFQUFpQjtFQUFnQjs7O0FBQXNCO0VBQXlCO0lBQVc7SUFBNkI7O0VBQWdCO0lBQStCOzs7QUFBUTtFQUFxQzs7O0FBQWE7RUFBbUM7OztBQUF1QjtFQUF1QztFQUFjOzs7QUFBVztFQUFzQztFQUFjO0VBQVc7OztBQUFXO0VBQWlEO0VBQWM7RUFBZ0I7RUFBc0I7RUFBZ0I7RUFBZTs7O0FBQWdCO0VBQW1EO0VBQWU7RUFBc0I7OztBQUFlO0VBQWlDO0VBQVc7RUFBa0I7OztBQUFlO0VBQXFGOzs7QUFBaUI7RUFBMkM7RUFBZ0I7OztBQUFpQjtFQUE2RDtFQUFnQjs7O0FBQWdCO0VBQTBEOzs7QUFBYztFQUF3SDs7O0FBQWM7RUFBeUQ7OztBQUFjO0VBQTREOzs7QUFBYztFQUEyRDs7O0FBQW9CO0VBQW9COzs7QUFBYztFQUFxQztFQUFXOzs7QUFBTztFQUFzQzs7O0FBQWdCO0VBQXdEO0VBQWlCOzs7QUFBYztFQUE0Qzs7O0FBQWM7RUFBcUQ7RUFBWTtFQUFlOzs7QUFBaUI7RUFBeUc7RUFBa0I7OztBQUFjO0VBQTRDOzs7QUFBZ0I7RUFBOEQ7RUFBaUI7OztBQUFjO0VBQWtEOzs7QUFBaUI7RUFBa0I7RUFBc0I7RUFBVTtFQUFzQjtFQUFlO0VBQTBCO0VBQW1CO0VBQWdCO0VBQTZCO0VBQWU7RUFBYTs7O0FBQWtCO0VBQTZCO0VBQWU7OztBQUFlO0VBQThCOzs7QUFBa0I7RUFBeUI7RUFBa0I7RUFBWTtFQUE2QjtFQUFtQjtFQUFpQjtFQUFrQjtFQUFnQjtFQUFtQjtFQUFxQjtFQUFnQjtFQUFrQjs7O0FBQXNHO0VBQWlHO0VBQWtCOzs7QUFBaUI7RUFBeUc7RUFBa0I7OztBQUFjO0VBQWlDO0VBQWtCO0VBQXNCO0VBQWU7OztBQUFpQjtFQUF5RDtFQUFjO0VBQXlCO0VBQWM7RUFBNkI7OztBQUFvQjtFQUFnRTtFQUFjOzs7QUFBVztFQUFxQzs7O0FBQWU7RUFBbUU7OztBQUFtQjtFQUFvRTtFQUFrQjtFQUFpQjs7O0FBQWU7RUFBd0U7RUFBaUI7OztBQUFlO0VBQThCO0VBQWtCO0VBQWdCO0VBQWU7OztBQUFpQjtFQUE4Qzs7O0FBQWM7RUFBMkM7OztBQUFjO0VBQThDOzs7QUFBYztFQUE0Qzs7O0FBQWM7RUFBK0I7RUFBa0I7RUFBUztFQUFXO0VBQXNCOzs7QUFBYTtFQUFxQzs7O0FBQXNCO0VBQTZCO0VBQVk7OztBQUFnQjtFQUE0QztFQUF3QjtFQUF5RDs7O0FBQXlCO0VBQTJEO0VBQVU7OztBQUE0QjtFQUF3RjtFQUF3QjtFQUF5RDs7O0FBQXlCO0VBQTZCO0VBQXVCOzs7QUFBNEI7RUFBa0k7RUFBa0M7OztBQUE2QjtFQUFnRTtFQUFtQzs7O0FBQTZCO0VBQThCO0lBQUc7SUFBVzs7RUFBVTtJQUFHO0lBQU87OztBQUFXO0VBQStCO0lBQUc7SUFBaUI7SUFBbUI7O0VBQVU7SUFBRztJQUFhO0lBQWdCO0lBQWM7SUFBaUI7OztBQUFXO0VBQXNCOzs7QUFBYztFQUF5RjtFQUFnQjs7O0FBQWtCO0VBQXdMO0VBQWtCOzs7QUFBYztFQUFvRDtFQUFpQjs7O0FBQWM7RUFBcUQ7RUFBVzs7O0FBQVU7RUFBbUQ7OztBQUFXO0VBQStDO0VBQWU7OztBQUFjO0VBQThLOzs7QUFBcUM7RUFBb0w7OztBQUF3QztFQUF1RDtFQUFlOzs7QUFBaUI7RUFBa1g7OztBQUFzQztFQUFpQztJQUFHO0lBQWlCOztFQUFVO0lBQUc7SUFBYTs7O0FBQVc7RUFBb0M7SUFBRztJQUFvQjs7RUFBVTtJQUFHO0lBQWdCOzs7QUFBVztFQUFrQztJQUFHO0lBQVk7O0VBQVU7SUFBRztJQUFROzs7QUFBVztFQUFpQjtFQUFzQjtFQUFTO0VBQXNCO0VBQWU7RUFBMEI7RUFBbUI7RUFBZ0I7RUFBNkI7RUFBa0I7RUFBa0I7OztBQUFzQjtFQUF1Qjs7O0FBQXlCO0VBQWdDOzs7QUFBaUI7RUFBNEI7OztBQUFpQjtFQUFzQjtFQUFrQjtFQUFlOzs7QUFBYztFQUE2QjtFQUFjO0VBQWE7RUFBZTtFQUFxQjs7O0FBQVc7RUFBOEU7OztBQUFjO0VBQW9DOzs7QUFBYztFQUF1QztFQUFZO0VBQWM7OztBQUFzQjtFQUF5Qzs7O0FBQWU7RUFBeUI7RUFBYTs7O0FBQThCO0VBQThCO0VBQWE7RUFBbUI7RUFBYTs7O0FBQWdCO0VBQStCO0VBQWtCO0VBQWdCO0VBQXNCO0VBQWdCO0VBQWU7RUFBaUI7RUFBZ0I7RUFBbUI7OztBQUF1QjtFQUFxQzs7O0FBQWtCO0VBQW1DO0VBQWtCO0VBQXNCO0VBQWU7RUFBbUI7RUFBZ0I7RUFBbUI7OztBQUF1QjtFQUErQjtFQUFhOzs7QUFBbUI7RUFBaUM7OztBQUFrQjtFQUF5Qjs7O0FBQWlCO0VBQXdCOzs7QUFBZ0I7RUFBZ0Q7OztBQUFTO0VBQXVEOzs7QUFBWTtFQUFnRDtFQUFnQjtFQUFtQjs7O0FBQWU7RUFBa0Q7OztBQUFlO0VBQXFCOzs7QUFBYztFQUEyQztFQUFZO0VBQWU7OztBQUFpQjtFQUE4RztFQUFlOzs7QUFBaUI7RUFBd0Q7RUFBWTtFQUFlOzs7QUFBaUI7RUFBbUQ7OztBQUFZO0VBQW9EOzs7QUFBVztFQUFzRDtFQUFrQjs7O0FBQWM7RUFBaUU7OztBQUFlO0VBQXlFOzs7QUFBWTtFQUFnQjtFQUFzQjtFQUFzQjtFQUFlO0VBQTBCO0VBQW1COzs7QUFBNkI7RUFBc0Q7RUFBUztFQUFVOzs7QUFBZ0I7RUFBc0I7RUFBYztFQUFXO0VBQVM7RUFBZ0I7RUFBa0I7OztBQUFZO0VBQWdEO0VBQXFCO0VBQVk7RUFBaUI7RUFBaUI7OztBQUFzQjtFQUFxQjtFQUFlO0VBQXlLO0VBQWtCO0VBQWdCO0VBQXNCO0VBQXlCO0VBQWtCO0VBQVU7RUFBZTtFQUF5QjtFQUFzQjtFQUFxQjs7O0FBQWlCO0VBQXVCO0VBQWM7RUFBYztFQUFzQjs7O0FBQWdCO0VBQTZCOzs7QUFBcUI7RUFBMkI7RUFBcUI7OztBQUFtQjtFQUE2Qjs7O0FBQWM7RUFBbUM7RUFBcUI7OztBQUFtQjtFQUFxQzs7O0FBQWM7RUFBNEI7RUFBZ0I7RUFBZ0I7OztBQUFxQjtFQUE4Qjs7O0FBQWM7RUFBNEU7OztBQUFxQjtFQUFnRjs7O0FBQWM7RUFBb0Q7OztBQUFVO0VBQWtIOzs7QUFBa0I7RUFBZ0w7RUFBYztFQUFlO0VBQW9CO0VBQVU7OztBQUFtQjtFQUF3TDtFQUFNO0VBQVE7RUFBUztFQUFPOzs7QUFBWTtFQUE4SztFQUFrQjtFQUFNO0VBQVE7RUFBUztFQUFPO0VBQWM7RUFBWTtFQUFzQjtFQUF1QztFQUFtQjtFQUFrQjtFQUFrQjtFQUFVOzs7QUFBbUI7RUFBOEg7OztBQUFVO0VBQTRIOzs7QUFBVTtFQUE4STs7O0FBQVU7RUFBNEk7OztBQUFVO0VBQXlFOzs7QUFBaUI7RUFBOEY7RUFBcUI7RUFBZTtFQUFZO0VBQXNCO0VBQXlLO0VBQWlCO0VBQWtCO0VBQXNCO0VBQWdCO0VBQWtCO0VBQWU7OztBQUFtQjtFQUEwQztFQUF1Qzs7O0FBQVU7RUFBd0Q7RUFBc0I7RUFBZTtFQUF5QjtFQUFzQjtFQUFxQjs7O0FBQWlCO0VBQW9FOzs7QUFBcUI7RUFBOEY7RUFBYztFQUFXO0VBQVk7RUFBVTtFQUFlO0VBQWtCO0VBQXNCO0VBQXlCO0VBQWtCO0VBQWE7OztBQUFtQjtFQUFvTztFQUFjOzs7QUFBcUI7RUFBd0Q7OztBQUFtQjtFQUE0RztFQUFzQjtFQUFxQjs7O0FBQW1CO0VBQXVDOzs7QUFBbUI7RUFBaUU7RUFBc0I7RUFBcUI7OztBQUFtQjtFQUFzQjs7O0FBQW9CO0VBQXdCO0VBQXFCO0VBQWlCOzs7QUFBc0I7RUFBZ0M7SUFBK0Q7OztBQUFvQjtFQUFnRDtFQUFxQjs7O0FBQVc7RUFBcUM7RUFBcUI7RUFBWTtFQUFnQjtFQUFpQjs7O0FBQW1CO0VBQTJDO0VBQWtCO0VBQXFCO0VBQVc7RUFBWTtFQUFpQjtFQUFzQjtFQUFlO0VBQW1CO0VBQXNCO0VBQXNCO0VBQXlCO0VBQWtCO0VBQW1CO0VBQVc7RUFBWTs7O0FBQWE7RUFBNkQ7RUFBYztFQUFzQjs7O0FBQWlCO0VBQWlFO0VBQWM7RUFBcUI7OztBQUFpQjtFQUF3RDtFQUFjO0VBQXlCO0VBQXNCO0VBQXFCOzs7QUFBaUI7RUFBa0U7OztBQUF1QjtFQUFpRTs7O0FBQXVCO0VBQTZEOzs7QUFBdUI7RUFBaUQ7RUFBcUI7OztBQUF1QjtFQUFvRztFQUFxQjtFQUF5QztFQUF1Qjs7O0FBQVU7RUFBb0Q7RUFBc0I7RUFBeUI7RUFBcUI7RUFBZ0I7RUFBbUI7OztBQUFVO0VBQTBEO0VBQXFCOzs7QUFBdUI7RUFBcUQ7RUFBc0I7RUFBeUI7RUFBcUI7RUFBZ0I7RUFBbUI7OztBQUFVO0VBQTJEO0VBQXFCOzs7QUFBdUI7RUFBMlc7RUFBNkI7RUFBWTs7O0FBQWdCO0VBQW1EO0VBQWU7RUFBWTtFQUFnQjtFQUFtQjtFQUFzQjs7O0FBQTZCO0VBQThDO0VBQW1COzs7QUFBZTtFQUE4Qzs7O0FBQWM7RUFBd0Y7RUFBWTtFQUFpQjs7O0FBQW1CO0VBQTRJO0VBQVk7RUFBNkI7OztBQUFTO0VBQXdKO0VBQVk7OztBQUFpQjtFQUFvRDtFQUFxQjtFQUFZOzs7QUFBaUI7RUFBMEQ7RUFBc0I7RUFBWTtFQUFpQjtFQUFjO0VBQWtCO0VBQXNCO0VBQXlCO0VBQWtCO0VBQWE7OztBQUE0QjtFQUFnRTs7O0FBQXFCO0VBQWdFO0VBQXFCOzs7QUFBeUM7RUFBb0U7RUFBc0I7RUFBbUI7RUFBcUI7OztBQUFtQjtFQUFnSTtFQUFZOzs7QUFBaUI7RUFBeUQ7RUFBZTtFQUFZO0VBQVM7OztBQUFpQjtFQUEwRjtFQUF1Qjs7O0FBQXlCO0VBQWtIO0VBQWU7RUFBWTtFQUFTOzs7QUFBaUI7RUFBc0s7RUFBdUI7OztBQUF5QjtFQUFrTDtFQUFZOzs7QUFBaUI7RUFBNEg7RUFBWTtFQUFlOzs7QUFBaUI7RUFBNEQ7OztBQUFnQjtFQUF5RTs7O0FBQU07RUFBeUU7RUFBWTs7O0FBQWlCO0VBQStFO0VBQWM7RUFBVzs7O0FBQVk7RUFBd0M7OztBQUFtQjtFQUE2RDtFQUFtQjtFQUFxQjs7O0FBQW1CO0VBQStEO0VBQXNCO0VBQXVCO0VBQVk7OztBQUFtQjtFQUFvRTs7O0FBQW1CO0VBQXNFOzs7QUFBc0I7RUFBa0U7RUFBc0I7RUFBbUI7RUFBcUI7OztBQUFtQjtFQUF3Rjs7O0FBQXVCO0VBQXVFOzs7QUFBVTtFQUFzRTs7O0FBQVU7RUFBcUU7OztBQUFzQjtFQUF5QztJQUEyRTs7O0FBQWM7RUFBeUM7SUFBd0I7OztBQUFjO0VBQTZOO0VBQWU7OztBQUFnQjtFQUEwQzs7O0FBQW9CO0VBQTRDO0VBQWtCOzs7QUFBYztFQUE0RjtFQUFlOzs7QUFBZ0I7RUFBaUY7OztBQUFjO0VBQW9KO0VBQWU7OztBQUFnQjtFQUFnRTtFQUFpQjs7O0FBQWM7RUFBZ0I7OztBQUFhO0VBQWE7RUFBc0I7RUFBUztFQUFVO0VBQXNCO0VBQWU7RUFBMEI7RUFBbUI7RUFBZ0I7RUFBNkI7RUFBa0I7RUFBTTtFQUFPO0VBQWE7RUFBZTtFQUFnQjtFQUFtQjtFQUFnQjtFQUFZO0VBQXlCO0VBQXNCO0VBQXFCOzs7QUFBaUI7RUFBcUI7OztBQUFrQjtFQUFtQjtFQUFrQjtFQUErQjs7O0FBQVc7RUFBb0I7OztBQUFhO0VBQTBGOzs7QUFBNEI7RUFBZ0c7OztBQUEwQjtFQUFtRzs7O0FBQXlCO0VBQTZGOzs7QUFBMkI7RUFBbUI7RUFBc0I7RUFBNEI7RUFBa0I7OztBQUFzRztFQUFzRTtJQUFtQjs7O0FBQXVHO0VBQW1CO0VBQWdCO0VBQWdCO0VBQVM7RUFBcUI7RUFBc0I7RUFBZ0I7OztBQUFnQztFQUEyQjtFQUF1QjtFQUFrQjtFQUFlO0VBQWtCOzs7QUFBc0I7RUFBcUI7RUFBYTtFQUFtQjtFQUFzQjs7O0FBQWU7RUFBMEI7RUFBcUI7RUFBaUI7RUFBYzs7O0FBQWU7RUFBcUI7RUFBa0I7OztBQUFpQjtFQUE4Qzs7O0FBQWdCO0VBQW1CO0VBQWtCO0VBQWM7RUFBVztFQUFZO0VBQWdCO0VBQXVCOzs7QUFBb0I7RUFBMkI7RUFBbUM7RUFBa0I7RUFBTTtFQUFRO0VBQVM7RUFBTztFQUFjO0VBQW1CO0VBQW9CO0VBQVk7RUFBVztFQUFvQjtFQUFzQjs7O0FBQW9CO0VBQWtDO0VBQWtCO0VBQWtCO0VBQW1CO0VBQW1CO0VBQW9CO0VBQThDO0VBQTRCO0VBQWdDO0VBQVc7RUFBaUM7RUFBeUI7RUFBc1g7OztBQUE4VztFQUFtSjtFQUFTOzs7QUFBMkI7RUFBMks7RUFBdUM7OztBQUEwQztFQUE4QztFQUFTOzs7QUFBNEM7RUFBa0Q7OztBQUFVO0VBQW1EOzs7QUFBVztFQUF5SjtFQUFPOzs7QUFBNEI7RUFBaUw7RUFBdUM7OztBQUEwQztFQUFnRDtFQUFROzs7QUFBNkM7RUFBbUQ7OztBQUFTO0VBQXNEOzs7QUFBWTtFQUE0SjtFQUFNOzs7QUFBNEI7RUFBb0w7RUFBdUM7OztBQUEyQztFQUFpRDtFQUFTOzs7QUFBNkM7RUFBcUQ7OztBQUFVO0VBQXNEOzs7QUFBVztFQUFzSjtFQUFROzs7QUFBMkI7RUFBOEs7RUFBdUM7OztBQUEyQztFQUErQztFQUFROzs7QUFBNEM7RUFBa0Q7OztBQUFTO0VBQXFEOzs7QUFBWTtFQUEwSzs7O0FBQXlCO0VBQWdGOzs7QUFBeUI7RUFBd0Y7OztBQUF5QjtFQUFzRjs7O0FBQXlCO0VBQXNGOzs7QUFBeUI7RUFBa0Y7OztBQUF5QjtFQUFrRjs7O0FBQXlCO0VBQWtGOzs7QUFBeUI7RUFBb0Y7OztBQUF5QjtFQUFrRjs7O0FBQXlCO0VBQTBGOzs7QUFBeUI7RUFBc0Y7OztBQUF5QjtFQUFpQjtFQUFjOzs7QUFBaUI7RUFBMkM7RUFBZTs7O0FBQWdCO0VBQTRDOzs7QUFBa0I7RUFBc0M7OztBQUFnQjtFQUE2QztFQUFpQjs7O0FBQWM7RUFBYztFQUFzQjtFQUFTO0VBQVU7RUFBc0I7RUFBZTtFQUEwQjtFQUFtQjtFQUFnQjtFQUE2Qjs7O0FBQXFCO0VBQW1CO0VBQWtCO0VBQVc7OztBQUFlO0VBQW9COzs7QUFBcUI7RUFBMEI7RUFBYTtFQUFtQjs7O0FBQW1CO0VBQXlCO0VBQWM7RUFBYztFQUFpQjtFQUFtQjs7O0FBQW1CO0VBQWdDOzs7QUFBbUI7RUFBd0c7OztBQUFlO0VBQW9CO0VBQXFCO0VBQVc7RUFBZTs7O0FBQWdCO0VBQTRDO0VBQThCOzs7QUFBOEI7RUFBb0I7RUFBa0I7RUFBcUI7RUFBVztFQUFnQjtFQUFzQjtFQUF5Qjs7O0FBQW9CO0VBQTJCOzs7QUFBZTtFQUEwQjs7O0FBQWtDO0VBQWlGOzs7QUFBZTtFQUEwQztFQUFrQjtFQUF5QjtFQUFvQjs7O0FBQWtEO0VBQXlCO0VBQWtCO0VBQU07RUFBTzs7O0FBQXlCO0VBQW1CO0VBQXFCO0VBQVU7RUFBZ0I7RUFBc0I7RUFBYztFQUFjO0VBQW1CO0VBQWdCO0VBQXNCOzs7QUFBa0I7RUFBNEI7OztBQUFlO0VBQW9EO0VBQWtCO0VBQU07RUFBUTtFQUFTO0VBQU87RUFBZ0I7RUFBbUI7RUFBVTtFQUFzRTs7O0FBQVc7RUFBZ0Q7OztBQUF5QjtFQUFrRDs7O0FBQWM7RUFBZ0g7OztBQUFlO0VBQThDOzs7QUFBeUI7RUFBZ0Q7OztBQUFjO0VBQThHOzs7QUFBZTtFQUF5QztFQUFrQjtFQUFjOzs7QUFBNkI7RUFBd0M7RUFBa0I7RUFBUTtFQUFTO0VBQVc7RUFBUztFQUFVO0VBQXNCO0VBQWM7RUFBYztFQUFtQjtFQUFrQjs7O0FBQStCO0VBQWlEOzs7QUFBdUI7RUFBc0U7OztBQUFjO0VBQW9FOzs7QUFBYztFQUErQjtJQUFHO0lBQXNDOztFQUFXO0lBQUk7SUFBc0M7O0VBQVc7SUFBRztJQUFrQzs7O0FBQVc7RUFBa0I7OztBQUFjO0VBQTZEO0VBQWU7RUFBNkI7RUFBZ0I7OztBQUE2QjtFQUEyQztFQUFROzs7QUFBVTtFQUErRztFQUFpQjtFQUFjOzs7QUFBaUI7RUFBaUI7RUFBc0I7RUFBUztFQUFVO0VBQXNCO0VBQWU7RUFBMEI7RUFBbUI7RUFBZ0I7RUFBNkI7RUFBcUI7OztBQUFZO0VBQWtDOzs7QUFBVTtFQUF3RTs7O0FBQWlCO0VBQW1CO0VBQXNCO0VBQVU7RUFBc0I7RUFBZTtFQUEwQjtFQUFtQjtFQUFnQjtFQUE2QjtFQUFrQjtFQUFvQjtFQUFxQjtFQUFpQjs7O0FBQWU7RUFBNEI7OztBQUFtQjtFQUF5QjtFQUFxQjtFQUFRO0VBQWdCOzs7QUFBYztFQUFvRTtFQUFXOzs7QUFBWTtFQUFXO0VBQXNCO0VBQVM7RUFBVTtFQUFzQjtFQUFlO0VBQTBCO0VBQW1CO0VBQWdCO0VBQTZCO0VBQWtCO0VBQVM7RUFBcUI7RUFBYTs7O0FBQWU7RUFBOEc7OztBQUFxQjtFQUF3Qzs7O0FBQTBDO0VBQXlCO0VBQWtCO0VBQU07RUFBTztFQUFXO0VBQVk7RUFBeUI7RUFBa0I7RUFBa0I7RUFBMEM7RUFBeUI7OztBQUFXO0VBQWlFOzs7QUFBbUI7RUFBaUI7RUFBa0I7RUFBTTtFQUFPO0VBQWM7RUFBVztFQUFZO0VBQXNCO0VBQXlCO0VBQWtCOzs7QUFBbUI7RUFBdUI7RUFBa0I7RUFBUTtFQUFTO0VBQWM7RUFBVztFQUFZO0VBQWdCO0VBQWlCO0VBQXlCO0VBQWE7RUFBYztFQUFtQjtFQUFtQjtFQUFVO0VBQWlEOzs7QUFBWTtFQUFpQjtFQUFrQjtFQUFNO0VBQVE7RUFBUztFQUFPO0VBQVU7RUFBZTs7O0FBQVU7RUFBK0M7OztBQUFxQjtFQUFvQzs7O0FBQXFCO0VBQTBDO0VBQW9CO0VBQVU7OztBQUFpRDtFQUFvQjs7O0FBQW1CO0VBQXFDO0VBQXlCOzs7QUFBbUI7RUFBMkM7OztBQUFnQztFQUFxQzs7O0FBQW1CO0VBQXlCO0VBQXNCOzs7QUFBbUI7RUFBaUI7RUFBa0I7OztBQUFpQjtFQUEwQjtFQUFrQjtFQUFxQjtFQUFZO0VBQVM7RUFBZTtFQUFzQjtFQUFlO0VBQWlCO0VBQWdCO0VBQXFCO0VBQW1CO0VBQThCO0VBQWU7OztBQUFvRTtFQUE0Qjs7O0FBQXNCO0VBQTRDO0VBQWtCO0VBQU07RUFBTztFQUFXO0VBQVc7OztBQUFZO0VBQWlEO0VBQVk7RUFBZTs7O0FBQWlCO0VBQWlEO0VBQVk7RUFBYzs7O0FBQWlCO0VBQW1EO0VBQWtCO0VBQVM7RUFBVTtFQUFjO0VBQXVCO0VBQVU7RUFBWTtFQUFjO0VBQXlCO0VBQWdDOzs7QUFBVztFQUFzQztFQUE4Qjs7O0FBQTBCO0VBQXFDOzs7QUFBMEI7RUFBaUQ7OztBQUFrQjtFQUFnQztFQUFrQjs7O0FBQWM7RUFBdUM7OztBQUEwQztFQUFzSTtFQUFRO0VBQVM7RUFBVTs7O0FBQW9CO0VBQTBFO0VBQVU7RUFBYztFQUFnQjs7O0FBQXFCO0VBQWlGOzs7QUFBeUI7RUFBc0Y7OztBQUFxQjtFQUFnRjtFQUFjOzs7QUFBcUI7RUFBdUY7OztBQUF5QjtFQUFpRjtFQUFjOzs7QUFBcUI7RUFBd0Y7OztBQUF5QjtFQUF1Rjs7O0FBQTBDO0VBQWlHO0VBQVc7RUFBbUI7OztBQUFxQjtFQUF1RztFQUFXO0VBQW1COzs7QUFBcUI7RUFBd0c7RUFBVztFQUFtQjs7O0FBQXFCO0VBQThHOzs7QUFBMEM7RUFBbUM7OztBQUFtQjtFQUEySDtFQUFzQjtFQUF5Qjs7O0FBQXFCO0VBQStDOzs7QUFBMEI7RUFBb0U7RUFBc0I7RUFBeUI7RUFBcUI7OztBQUFnQjtFQUEwQjtJQUFHO0lBQW1COztFQUFXO0lBQUc7SUFBcUI7OztBQUFXO0VBQXFDOzs7QUFBYztFQUF5QztFQUFlO0VBQWdCOzs7QUFBYztFQUF1RDtFQUFxQjs7O0FBQXNCO0VBQXlHO0VBQVc7OztBQUFPO0VBQTRGO0VBQStCOzs7QUFBMEI7RUFBMEg7OztBQUEyQjtFQUEyRjs7O0FBQTBCO0VBQXFHOzs7QUFBMkI7RUFBVTtFQUFzQjtFQUFzQjtFQUFlO0VBQTBCO0VBQW1CO0VBQTZCO0VBQXFCO0VBQVM7RUFBVTtFQUFjO0VBQWU7RUFBa0I7RUFBZ0I7OztBQUFhO0VBQWtDOzs7QUFBZTtFQUE0Qzs7O0FBQW1CO0VBQWU7RUFBa0I7RUFBcUI7RUFBYzs7O0FBQWU7RUFBZ0M7OztBQUFpQjtFQUFtQjs7O0FBQThCO0VBQXlCOzs7QUFBcUI7RUFBeUI7OztBQUFVO0VBQWlDO0VBQTJCOzs7QUFBcUI7RUFBMkM7RUFBYztFQUFtQjtFQUF5QjtFQUFzQjtFQUFxQjs7O0FBQWlCO0VBQTZEOzs7QUFBc0I7RUFBcUI7RUFBa0I7RUFBTTtFQUFPO0VBQVU7RUFBWTtFQUFnQjs7O0FBQVU7RUFBbUY7OztBQUFVO0VBQW1GOzs7QUFBYztFQUFlO0VBQXFCO0VBQWE7OztBQUFlO0VBQWM7OztBQUFjO0VBQThDO0VBQWU7OztBQUFnQjtFQUFtQztFQUFROzs7QUFBVTtFQUFZOzs7QUFBa0I7RUFBOEM7OztBQUFjO0VBQTRDOzs7QUFBYztFQUEyQzs7O0FBQWM7RUFBOEM7OztBQUFjO0VBQWtCO0VBQVk7RUFBYTs7O0FBQVk7RUFBaUI7RUFBbUI7OztBQUFrQjtFQUEwQjs7O0FBQWU7RUFBa0I7RUFBc0I7RUFBZTtFQUFnQjs7O0FBQWtCO0VBQXFCO0VBQXNCO0VBQWU7RUFBZ0I7OztBQUFrQjtFQUFrQjtFQUFnQjs7O0FBQWtCO0VBQW9COzs7QUFBaUI7RUFBOEI7OztBQUFlO0VBQW9CO0VBQWdCO0VBQWtCOzs7QUFBeUI7RUFBZ0I7OztBQUFjO0VBQW9DO0VBQWU7OztBQUFnQjtFQUE4Qzs7O0FBQWM7RUFBdUY7RUFBc0I7OztBQUFtQjtFQUF5QjtFQUFzQjtFQUFrQjs7O0FBQW1HO0VBQXlCO0VBQWdCO0VBQW1CO0VBQXVCOzs7QUFBb0I7RUFBZTtFQUFzQjtFQUFTO0VBQXNCO0VBQWU7RUFBMEI7RUFBbUI7RUFBZ0I7RUFBNkI7RUFBcUI7RUFBWTtFQUFzQjtFQUFpQztFQUFrQjs7O0FBQWtEO0VBQXFCO0VBQWtCO0VBQWE7RUFBb0I7RUFBeUI7OztBQUFXO0VBQW1DOzs7QUFBYTtFQUF1RDtFQUFPOzs7QUFBWTtFQUFvRzs7O0FBQWlDO0VBQW9CO0VBQWtCO0VBQWtCO0VBQWU7OztBQUFvRDtFQUE2QjtFQUFzQjtFQUFrQjtFQUFtRzs7O0FBQWM7RUFBb0Q7OztBQUFjO0VBQTBCO0VBQWdCO0VBQWU7RUFBaUI7RUFBZ0I7RUFBbUI7RUFBdUI7OztBQUFvQjtFQUEyQjs7O0FBQWdCO0VBQTBCO0VBQWtCO0VBQU07RUFBTztFQUFRO0VBQVM7RUFBVTs7O0FBQW9CO0VBQTBEO0VBQWdCO0VBQWU7RUFBZTs7O0FBQWlCO0VBQTBEO0VBQWdCO0VBQWM7OztBQUFpQjtFQUFtRztFQUFzQjs7O0FBQW1CO0VBQXFCO0VBQXNCO0VBQWtCO0VBQW1HO0VBQWtCO0VBQU07RUFBTztFQUFRO0VBQVk7OztBQUFjO0VBQTBDO0VBQWlHOzs7QUFBNEI7RUFBaUM7OztBQUFjO0VBQTBEO0VBQWU7OztBQUFnQjtFQUF3Qzs7O0FBQWE7RUFBcUU7RUFBa0I7RUFBTTtFQUFXO0VBQVM7OztBQUFVO0VBQTJFOzs7QUFBVztFQUE2STtFQUFVO0VBQWlCOzs7QUFBaUM7RUFBbUU7RUFBa0I7RUFBeUI7RUFBc0I7RUFBcUI7OztBQUFpQjtFQUEwRTtFQUFnQjs7O0FBQW9CO0VBQXVNO0VBQXFCO0VBQVE7RUFBa0I7OztBQUFjO0VBQXNFOzs7QUFBVztFQUErSTs7O0FBQW1CO0VBQThEOzs7QUFBYztFQUF5RTtFQUFXO0VBQVk7OztBQUFlO0VBQTRHOzs7QUFBWTtFQUErRTs7O0FBQWlCO0VBQXlFOzs7QUFBYTtFQUFnRztFQUFnQjs7O0FBQVc7RUFBcUc7RUFBa0I7RUFBUTtFQUFPOzs7QUFBZTtFQUEyRzs7O0FBQWE7RUFBdUY7OztBQUFZO0VBQXdVOzs7QUFBaUI7RUFBc0k7OztBQUFZO0VBQXVGOzs7QUFBWTtFQUF3VTs7O0FBQWlCO0VBQXNJOzs7QUFBWTtFQUErRjtFQUFVOzs7QUFBUztFQUF1Rjs7O0FBQWM7RUFBcUg7OztBQUFXO0VBQTZPOzs7QUFBbUI7RUFBdUY7OztBQUFlO0VBQStCO0VBQWtCO0VBQWE7RUFBVTtFQUFlOzs7QUFBZTtFQUFvQztFQUFVO0VBQWtCOzs7QUFBZTtFQUEwQztFQUFhO0VBQWU7RUFBbUI7OztBQUFnQjtFQUFpRTs7O0FBQVk7RUFBOEQ7RUFBbUI7OztBQUFtQjtFQUFnRDtFQUFxQjtFQUFRO0VBQWE7RUFBaUI7OztBQUFjO0VBQWlJOzs7QUFBbUI7RUFBZ0Q7RUFBa0I7RUFBYTtFQUFVO0VBQXNCO0VBQWU7RUFBWTtFQUFlO0VBQWtCO0VBQWlCO0VBQW1CO0VBQXlCO0VBQWtCO0VBQWU7RUFBb0Q7RUFBeUI7RUFBc0I7RUFBcUI7RUFBaUI7RUFBdUI7RUFBc0I7RUFBMEI7RUFBeUI7RUFBd0I7OztBQUF1QjtFQUFvRTtFQUFjO0VBQXFCOzs7QUFBbUI7RUFBd0Q7RUFBcUI7RUFBaUI7RUFBZ0I7RUFBZ0I7OztBQUF1QjtFQUF1RDtFQUFjO0VBQWtCO0VBQWM7RUFBa0I7RUFBb0I7RUFBdUI7RUFBa0M7RUFBbUM7RUFBa0M7RUFBcUI7RUFBc0I7RUFBZ0I7RUFBZTtFQUFvQjs7O0FBQWU7RUFBeUQ7OztBQUFjO0VBQTJEOzs7QUFBcUI7RUFBOEQ7OztBQUFhO0VBQW1IOzs7QUFBYztFQUFnRTs7O0FBQXNCO0VBQTZEOzs7QUFBc0I7RUFBMEg7RUFBdUI7OztBQUFzQjtFQUFrRDtFQUFrQjtFQUFlO0VBQXlCOzs7QUFBd0I7RUFBaUg7RUFBWTtFQUF5SztFQUFpQjs7O0FBQW1CO0VBQXdEO0VBQVc7OztBQUFnQjtFQUF5RDtFQUFrQjtFQUFNO0VBQU87RUFBWTtFQUFnQjs7O0FBQWtCO0VBQXVEO0VBQWtCO0VBQVE7RUFBVztFQUFVO0VBQTJCOzs7QUFBbUI7RUFBOEQ7OztBQUFpQjtFQUE4RDs7O0FBQWlCO0VBQWdFO0VBQVk7OztBQUFpQjtFQUE2STtFQUFZOzs7QUFBaUI7RUFBOEQ7OztBQUFpQjtFQUE4RDtFQUFZOzs7QUFBaUI7RUFBZ0U7RUFBWTs7O0FBQWlCO0VBQTZJO0VBQVk7OztBQUFpQjtFQUFxRTs7O0FBQVM7RUFBZ0U7RUFBeUI7OztBQUF3QjtFQUE4RDtFQUFZOzs7QUFBaUI7RUFBdUQ7OztBQUFhO0VBQXNKO0VBQXNCOzs7QUFBK0I7RUFBK1U7RUFBcUI7RUFBd0M7RUFBdUI7OztBQUFVO0VBQXdKO0VBQXNCOzs7QUFBK0I7RUFBbVY7RUFBcUI7RUFBeUM7RUFBdUI7OztBQUFVO0VBQXFSOzs7QUFBVztFQUFpVzs7O0FBQW1CO0VBQVk7RUFBc0I7RUFBUztFQUFVO0VBQXNCO0VBQWU7RUFBMEI7RUFBbUI7RUFBZ0I7RUFBNkI7RUFBa0I7RUFBcUI7OztBQUFlO0VBQWtFO0VBQWtCO0VBQXNCO0VBQXlCO0VBQWtCOzs7QUFBa0Q7RUFBd0U7OztBQUFlO0VBQXlGOzs7QUFBWTtFQUErRjs7O0FBQVk7RUFBK0c7RUFBcUI7RUFBeUM7RUFBdUI7OztBQUFVO0VBQXNGO0VBQXNCO0VBQW1COzs7QUFBbUI7RUFBMEc7OztBQUFtQjtFQUE0Rjs7O0FBQW1CO0VBQXFHO0VBQVM7RUFBVTtFQUF1QjtFQUFZO0VBQWE7RUFBd0I7RUFBcUI7OztBQUFnQjtFQUFtSTtFQUFhOzs7QUFBd0I7RUFBaUU7RUFBcUI7OztBQUF1QjtFQUEyQjtFQUFPO0VBQWdCO0VBQWdCO0VBQW1COzs7QUFBdUI7RUFBZ0M7SUFBcUU7OztBQUFXO0VBQWtDO0VBQU87RUFBZ0I7RUFBYztFQUFtQjtFQUF1Qjs7O0FBQW9CO0VBQWdDO0lBQW1GOzs7QUFBVztFQUFrQjtFQUFxQjtFQUFjO0VBQWtCO0VBQWM7RUFBb0I7RUFBdUI7RUFBa0M7RUFBbUM7RUFBa0M7RUFBa0I7RUFBUTtFQUFXO0VBQWE7RUFBbUI7RUFBWTtFQUFnQjtFQUFzQjtFQUFlO0VBQWM7RUFBa0I7OztBQUFvQjtFQUFvQjs7O0FBQWM7RUFBc0I7OztBQUFxQjtFQUF5Qjs7O0FBQWE7RUFBeUM7OztBQUFjO0VBQTJCO0VBQW1COzs7QUFBeUI7RUFBK0I7OztBQUFtQjtFQUFtRDs7O0FBQW9CO0VBQXVDOzs7QUFBbUI7RUFBb0M7RUFBdUI7OztBQUFzQjtFQUFrQjtFQUFrQjtFQUFRO0VBQVc7RUFBVTtFQUFxQjtFQUFXO0VBQVk7RUFBZ0I7RUFBc0I7RUFBZTtFQUFrQjtFQUFjO0VBQWtCO0VBQW9CO0VBQWdCO0VBQWU7RUFBVTtFQUE0Qzs7O0FBQW9CO0VBQXlCOzs7QUFBYztFQUF3Qjs7O0FBQXNCO0VBQW9DOzs7QUFBVTtFQUFxQjtFQUFTO0VBQXNCO0VBQTBCO0VBQW1CO0VBQWdCO0VBQTZCO0VBQWtCO0VBQVk7RUFBYTtFQUFhO0VBQXNCO0VBQWM7RUFBZ0I7RUFBZTtFQUFvQjtFQUFzQjtFQUFrQjtFQUFhOzs7QUFBc0c7RUFBd047OztBQUE0QjtFQUFrTjs7O0FBQThCO0VBQTJHOzs7QUFBNkI7RUFBd0c7OztBQUErQjtFQUE0Qjs7O0FBQWE7RUFBMkI7OztBQUFzQjtFQUF1QjtFQUFzQjs7O0FBQXNCO0VBQXdDO0VBQWtCO0VBQWM7RUFBZ0I7RUFBaUI7RUFBZ0I7RUFBZTs7O0FBQWlCO0VBQWlCO0VBQXNCO0VBQWU7OztBQUErQjtFQUF1QjtFQUFzQjtFQUFlOzs7QUFBZTtFQUF3Qjs7O0FBQWE7RUFBZ0M7RUFBVTtFQUFnQjtFQUFtQjs7O0FBQXVCO0VBQThCOzs7QUFBVTtFQUFxRTs7O0FBQXlCO0VBQXVFO0VBQXNCO0VBQWdCOzs7QUFBeUI7RUFBcUc7OztBQUFjO0VBQWlDO0VBQXNCOzs7QUFBbUI7RUFBaUU7OztBQUF5QjtFQUFnQzs7O0FBQWtCO0VBQWU7OztBQUFlO0VBQTRDO0VBQXVDO0VBQW1DOzs7QUFBMEI7RUFBb0M7OztBQUFXO0VBQTREOzs7QUFBa0I7RUFBd0Y7RUFBZTs7O0FBQWlCO0VBQWtKOzs7QUFBVTtFQUFxQzs7O0FBQVU7RUFBZ0k7OztBQUFnQjtFQUE0SjtFQUEwQjs7O0FBQTZCO0VBQWtUO0VBQXlCOzs7QUFBNEI7RUFBc0o7RUFBMEI7OztBQUE2QjtFQUFnQjs7O0FBQWM7RUFBb0U7RUFBVzs7O0FBQVU7RUFBeUI7OztBQUFjO0VBQXlEO0VBQW1COzs7QUFBa0I7RUFBK0o7RUFBa0I7OztBQUFrQjtFQUErRDs7O0FBQWlCO0VBQXVFO0VBQWU7RUFBZ0I7OztBQUFpQjtFQUF3RTtFQUFROzs7QUFBVTtFQUFzRTtFQUFXOzs7QUFBVTtFQUFvRjs7O0FBQVU7RUFBMks7RUFBUTtFQUFTOzs7QUFBaUI7RUFBcUY7RUFBVzs7O0FBQVU7RUFBNks7RUFBZ0I7OztBQUFrQjtFQUFvSTs7O0FBQVU7RUFBMlE7RUFBZ0I7OztBQUFrQjtFQUFjO0VBQWM7OztBQUFXO0VBQXFCO0VBQW1CO0VBQW1COzs7QUFBbUI7RUFBMEM7RUFBcUI7RUFBbUI7RUFBK0I7RUFBVztFQUFZOzs7QUFBaUI7RUFBcUU7OztBQUFrQjtFQUE2QztFQUFXO0VBQVk7OztBQUFpQjtFQUF3RTs7O0FBQWtCO0VBQTZDO0VBQVc7RUFBWTs7O0FBQWlCO0VBQXdFOzs7QUFBa0I7RUFBc0I7RUFBbUI7RUFBVzs7O0FBQW1CO0VBQTBDO0VBQVc7RUFBWTtFQUErQjs7O0FBQWtCO0VBQWtFOzs7QUFBZ0I7RUFBOEM7OztBQUFVO0VBQWlEO0VBQVc7RUFBWTtFQUFnQjtFQUErQjs7O0FBQWtCO0VBQWlHOzs7QUFBVTtFQUFvRDs7O0FBQWdCO0VBQW9FOzs7QUFBZ0I7RUFBNEY7OztBQUFnQjtFQUFtSTs7O0FBQW9CO0VBQStQO0VBQWtCO0VBQVU7RUFBZ0I7OztBQUF1QjtFQUFtUztFQUFrQjtFQUFNO0VBQVk7RUFBUztFQUFXO0VBQTJHO0VBQWtEOzs7QUFBVztFQUE0STs7O0FBQVc7RUFBc0I7RUFBcUI7OztBQUFXO0VBQTJDO0VBQXFCO0VBQW1CO0VBQStCO0VBQWtCO0VBQVc7RUFBZTtFQUFZOzs7QUFBaUI7RUFBc0U7RUFBVzs7O0FBQWU7RUFBc0U7RUFBVztFQUFlOzs7QUFBa0I7RUFBcUU7OztBQUFtQjtFQUE4QztFQUFXO0VBQWU7RUFBWTs7O0FBQWlCO0VBQXlFO0VBQVc7OztBQUFlO0VBQXlFO0VBQVc7RUFBZTs7O0FBQWtCO0VBQXdFOzs7QUFBbUI7RUFBOEM7RUFBVztFQUFlO0VBQVk7OztBQUFpQjtFQUF5RTtFQUFXOzs7QUFBZTtFQUF5RTtFQUFXO0VBQWU7OztBQUFrQjtFQUF3RTs7O0FBQW1CO0VBQTJDO0VBQXFCO0VBQW1CO0VBQStCO0VBQVc7RUFBWTs7O0FBQWlCO0VBQXNFOzs7QUFBa0I7RUFBOEM7RUFBVztFQUFZOzs7QUFBaUI7RUFBeUU7OztBQUFrQjtFQUE4QztFQUFXO0VBQVk7OztBQUFpQjtFQUF5RTs7O0FBQWtCO0VBQTBDO0VBQXFCO0VBQW1CO0VBQStCO0VBQVk7RUFBZ0I7RUFBWTs7O0FBQWlCO0VBQTZDO0VBQVk7RUFBZ0I7RUFBWTs7O0FBQWlCO0VBQTZDO0VBQVk7RUFBZ0I7RUFBWTs7O0FBQWlCO0VBQTBDO0VBQWE7RUFBbUI7RUFBdUI7RUFBbUI7RUFBK0I7RUFBVztFQUFZOzs7QUFBaUI7RUFBb0U7OztBQUFrQjtFQUErQzs7O0FBQWE7RUFBOEM7RUFBVztFQUFZO0VBQWlCO0VBQWdCOzs7QUFBaUI7RUFBd0U7OztBQUFrQjtFQUFnQztJQUFHOztFQUE2QjtJQUFHOzs7QUFBNkI7RUFBa0I7OztBQUFjO0VBQXVDO0VBQWdCOzs7QUFBa0I7RUFBeVE7OztBQUF3QztFQUFvQztJQUFHOztFQUEwQjtJQUFHOzs7QUFBOEI7RUFBWTtFQUFzQjtFQUFzQjtFQUFlO0VBQTBCO0VBQW1CO0VBQWdCO0VBQTZCO0VBQWtCO0VBQVk7RUFBZ0I7RUFBYztFQUFlOzs7QUFBa0I7RUFBcUI7RUFBVztFQUFZO0VBQWdCOzs7QUFBYztFQUFzQztFQUFVOzs7QUFBWTtFQUF1Qzs7O0FBQVU7RUFBd0M7RUFBZ0I7OztBQUFpQjtFQUFzQztFQUFNO0VBQVU7RUFBVzs7O0FBQVk7RUFBMkM7RUFBUzs7O0FBQW1CO0VBQXNDO0VBQVU7OztBQUFZO0VBQXFDO0VBQVM7OztBQUFpQjtFQUF1Qzs7O0FBQWdCO0VBQXVEO0VBQWtCOzs7QUFBYztFQUFxRDtFQUFXOzs7QUFBVTtFQUEwRDtFQUFVOzs7QUFBVTtFQUFvRDtFQUFVOzs7QUFBVTtFQUF1Qjs7O0FBQW1CO0VBQWlCO0VBQVc7OztBQUF5QjtFQUFtQztFQUFrQjtFQUFXO0VBQWtCOzs7QUFBZ0M7RUFBa0I7OztBQUF5QjtFQUFtQjtFQUFrQjtFQUFXO0VBQVk7RUFBZ0I7RUFBc0I7RUFBeUI7RUFBa0I7RUFBYTtFQUFlOzs7QUFBd0Y7RUFBNEI7OztBQUFVO0VBQXlCO0VBQXFCO0VBQWE7OztBQUEwQztFQUFvQzs7O0FBQXFCO0VBQXlCO0VBQWtCO0VBQVM7RUFBVztFQUFZO0VBQVU7OztBQUFXO0VBQW1DOzs7QUFBeUI7RUFBb0M7OztBQUF5QjtFQUE0RDs7O0FBQXFCO0VBQWlCO0VBQWtCO0VBQVM7RUFBTztFQUFXOzs7QUFBZTtFQUFzQjtFQUFrQjtFQUFxQjtFQUFzQjtFQUFrQjtFQUFvQjtFQUFlO0VBQXlCO0VBQXNCO0VBQXFCOzs7QUFBaUI7RUFBNkI7OztBQUFzQjtFQUFpQjtFQUFrQjtFQUFXO0VBQVc7RUFBdUI7OztBQUFvQjtFQUFnQjtFQUFrQjtFQUFTO0VBQVU7RUFBVztFQUFzQjtFQUF5QjtFQUFrQjs7O0FBQWU7RUFBdUI7OztBQUFxQjtFQUFxQjs7O0FBQW1CO0VBQXNDOzs7QUFBbUM7RUFBdUM7OztBQUEyQztFQUE2RTtFQUFzQjtFQUF1QztFQUFnQjs7O0FBQW1CO0VBQWdGOzs7QUFBNkI7RUFBZ0I7OztBQUFjO0VBQWlDO0VBQVE7OztBQUFVO0VBQVc7OztBQUFvQjtFQUFvQjs7O0FBQXNCO0VBQXdCOzs7QUFBbUI7RUFBdUI7OztBQUF1QjtFQUFxQjs7O0FBQXFCO0VBQTBCOzs7QUFBcUI7RUFBc0I7OztBQUFhO0VBQW1COzs7QUFBb0I7RUFBeUI7RUFBYTs7O0FBQVc7RUFBNEI7OztBQUFzQjtFQUFzQzs7O0FBQWM7RUFBVTtFQUFzQjtFQUFTO0VBQVU7RUFBc0I7RUFBZTtFQUEwQjtFQUFtQjtFQUFnQjtFQUE2QjtFQUFrQjtFQUFhO0VBQWM7RUFBa0I7RUFBc0I7RUFBVTs7O0FBQXVEO0VBQW1CO0VBQWdCO0VBQXFCOzs7QUFBVTtFQUF5Qjs7O0FBQWtCO0VBQXVDO0VBQWtCO0VBQU07RUFBTztFQUFVO0VBQWM7RUFBVztFQUFZOzs7QUFBaUI7RUFBcUQ7RUFBa0I7RUFBUTtFQUFTOzs7QUFBYTtFQUFzRDtFQUFrQjtFQUFRO0VBQVc7RUFBZ0I7OztBQUEyQjtFQUF3RTs7O0FBQWlCO0VBQXdEOzs7QUFBWTtFQUF5RDs7O0FBQWdCO0VBQTJFOzs7QUFBaUI7RUFBd0Q7OztBQUFhO0VBQXlEOzs7QUFBaUI7RUFBMkU7OztBQUFpQjtFQUFvQjtFQUFrQjs7O0FBQXVCO0VBQTBCO0VBQWtCO0VBQU07RUFBUTtFQUFTO0VBQU87RUFBVztFQUFlO0VBQVc7RUFBWTtFQUFnQjtFQUFVO0VBQW1CO0VBQVc7OztBQUFvQjtFQUFlO0VBQVc7RUFBVztFQUF5QjtFQUFzQjtFQUFxQjtFQUFpQjs7O0FBQW9CO0VBQXFCO0VBQVc7OztBQUFvQjtFQUFjOzs7QUFBc0I7RUFBYztFQUFrQjtFQUFxQjtFQUFlO0VBQVU7OztBQUFXO0VBQW1CO0VBQWtCO0VBQWM7RUFBVTtFQUFXO0VBQXlCO0VBQW1CO0VBQXFCO0VBQXlCO0VBQVc7OztBQUFtRDtFQUErQjtFQUFNOzs7QUFBTztFQUFnQztFQUFNO0VBQVE7OztBQUFvQjtFQUFnQztFQUFRO0VBQVM7OztBQUFvQjtFQUFnQztFQUFTO0VBQU87OztBQUFxQjtFQUFtQjtFQUF1Qjs7O0FBQXlDO0VBQTJCOzs7QUFBZTtFQUE2QjtFQUFVOzs7QUFBVztFQUEyQjs7O0FBQWU7RUFBNkI7RUFBVzs7O0FBQVk7RUFBNEM7OztBQUFjO0VBQTJEO0lBQWU7SUFBZ0I7OztBQUFZO0VBQXVCO0lBQUc7OztBQUFXO0VBQXFCO0lBQUc7OztBQUF5QjtFQUFjOzs7QUFBYztFQUFpQztFQUF5Qjs7O0FBQTRCO0VBQXdCO0lBQUc7OztBQUEyQjtFQUFlO0VBQXNCO0VBQVM7RUFBVTtFQUFzQjtFQUFlO0VBQTBCO0VBQW1CO0VBQWdCOzs7QUFBNkI7RUFBcUI7RUFBa0I7RUFBc0I7OztBQUFlO0VBQXdCOzs7QUFBaUI7RUFBdUI7RUFBc0I7RUFBZTs7O0FBQXlLO0VBQTZCO0VBQXFCOzs7QUFBYztFQUE0RDs7O0FBQXFCO0VBQThCOzs7QUFBaUI7RUFBOEI7OztBQUFnQjtFQUFtQjs7O0FBQWM7RUFBaUQ7RUFBZTs7O0FBQWdCO0VBQWlEO0VBQWlCOzs7QUFBYztFQUFXO0VBQXNCO0VBQVM7RUFBVTtFQUFzQjtFQUFlO0VBQTBCO0VBQW1CO0VBQWdCO0VBQTZCO0VBQWE7RUFBVztFQUFZOzs7QUFBbUI7RUFBZ0I7RUFBa0I7RUFBcUI7RUFBTztFQUFnQjs7O0FBQW1CO0VBQTBCOzs7QUFBYTtFQUEyQjs7O0FBQVU7RUFBbUw7OztBQUFhO0VBQTZDO0VBQXFCOzs7QUFBbUI7RUFBcUI7RUFBVztFQUFZO0VBQWlCO0VBQWU7RUFBeUs7RUFBaUI7RUFBa0I7RUFBaUM7RUFBbUI7OztBQUFpRDtFQUFxQztFQUFrQjtFQUFVO0VBQWM7OztBQUFjO0VBQXFCO0VBQWtCO0VBQVM7RUFBTztFQUFXOzs7QUFBZTtFQUEyQjtFQUFxQjtFQUFXO0VBQVc7RUFBbUI7RUFBa0I7RUFBMEI7OztBQUFXO0VBQXNCO0VBQWtCO0VBQXFCO0VBQW1CO0VBQXNCO0VBQWU7OztBQUFpQjtFQUE0QjtFQUFrQjtFQUFTO0VBQVU7RUFBYztFQUFhO0VBQVc7RUFBbUI7OztBQUFXO0VBQXlCO0VBQWU7RUFBZ0I7OztBQUFnQjtFQUFxRDtFQUFzQjs7O0FBQWU7RUFBMEM7RUFBc0I7OztBQUE2QjtFQUEwRDs7O0FBQXNCO0VBQThFOzs7QUFBMkI7RUFBNkY7OztBQUFzQjtFQUFtRzs7O0FBQXlCO0VBQW1HOzs7QUFBc0I7RUFBMEU7OztBQUF5QjtFQUE2QztFQUFzQjs7O0FBQXFCO0VBQTZEOzs7QUFBYztFQUFpRjs7O0FBQW1CO0VBQWdHOzs7QUFBc0I7RUFBc0c7OztBQUF5QjtFQUFzRzs7O0FBQXNCO0VBQTZFOzs7QUFBeUI7RUFBdUU7OztBQUFtQjtFQUF1Rjs7O0FBQVc7RUFBd0U7OztBQUFnQjtFQUE0QztFQUFzQjs7O0FBQXFCO0VBQTREOzs7QUFBYztFQUFnRjs7O0FBQW1CO0VBQStGOzs7QUFBc0I7RUFBcUc7OztBQUF5QjtFQUFxRzs7O0FBQXNCO0VBQTRFOzs7QUFBeUI7RUFBMkM7RUFBc0I7OztBQUFxQjtFQUEyRDs7O0FBQWM7RUFBK0U7OztBQUFtQjtFQUE4Rjs7O0FBQWM7RUFBb0c7OztBQUF5QjtFQUFvRzs7O0FBQWM7RUFBMkU7OztBQUF5QjtFQUFpRTs7O0FBQW1CO0VBQXlCOzs7QUFBbUI7RUFBOEY7OztBQUFlO0VBQXdlOzs7QUFBcUI7RUFBdVg7OztBQUFjO0VBQXNKOzs7QUFBcUI7RUFBc0s7OztBQUFjO0VBQXFFO0VBQWtCOzs7QUFBbUI7RUFBaUY7OztBQUFlO0VBQXNHOzs7QUFBZ0I7RUFBMEU7OztBQUFhO0VBQWlGO0VBQWdCOzs7QUFBbUI7RUFBc0U7RUFBWTtFQUFnQjs7O0FBQVM7RUFBc0Y7RUFBTTtFQUFVO0VBQVc7RUFBWTtFQUFlOzs7QUFBaUI7RUFBbUY7OztBQUFjO0VBQWdGO0VBQVc7OztBQUFnQjtFQUFxRjs7O0FBQWtCO0VBQWlHOzs7QUFBZTtFQUFzQztFQUFXO0VBQVk7RUFBaUI7RUFBZTtFQUFpQjtFQUFrQjs7O0FBQW1CO0VBQXVDO0VBQW1CO0VBQWU7OztBQUFpQjtFQUE2Qzs7O0FBQVM7RUFBNkM7RUFBc0I7OztBQUFlO0VBQXNDOzs7QUFBUTtFQUE2RDtFQUFjO0VBQWU7RUFBb0I7RUFBZ0I7RUFBUzs7O0FBQWdCO0VBQTZFO0VBQWU7RUFBaUI7OztBQUFlO0VBQW9CO0VBQWE7OztBQUFzQjtFQUFvQztFQUFjO0VBQWM7RUFBZTs7O0FBQWlCO0VBQXlEO0VBQVc7OztBQUFrQjtFQUE0RDtFQUFjO0VBQWdCOzs7QUFBZ0I7RUFBMEQ7OztBQUFpQjtFQUFnRTs7O0FBQW9CO0VBQW1GO0VBQWtCO0VBQU07RUFBVTtFQUFVO0VBQVk7OztBQUFtQjtFQUF5RjtFQUFVOzs7QUFBWTtFQUFvRzs7O0FBQWM7RUFBa0g7OztBQUFhO0VBQW1GO0VBQWtCO0VBQU07RUFBVTs7O0FBQW1CO0VBQW9GOzs7QUFBaUI7RUFBMEM7OztBQUFpQjtFQUErQztFQUFpQjs7O0FBQW1CO0VBQWtEO0VBQWM7RUFBWTtFQUFlOzs7QUFBa0I7RUFBK0M7RUFBcUI7OztBQUFpQjtFQUFnRDtFQUFnQjs7O0FBQWU7RUFBc0Q7OztBQUFhO0VBQW1EO0VBQWM7RUFBa0I7RUFBYzs7O0FBQW1CO0VBQW1GOzs7QUFBaUI7RUFBMEY7OztBQUFtQjtFQUF3RjtFQUFRO0VBQVc7RUFBa0I7OztBQUFVO0VBQW9HO0VBQXdCO0VBQVc7OztBQUFpQjtFQUE4STs7O0FBQVM7RUFBd0Y7RUFBVTtFQUFXO0VBQWlCO0VBQWdCO0VBQWdCO0VBQXVCOzs7QUFBUztFQUFnSTtFQUFrQjtFQUFXO0VBQVc7RUFBWTtFQUFvQjs7O0FBQW1CO0VBQTRJO0VBQWtCO0VBQVU7RUFBVztFQUFXO0VBQVk7RUFBNEI7OztBQUFXO0VBQThGOzs7QUFBWTtFQUF3STtFQUFrQjtFQUFTO0VBQVc7RUFBWTtFQUFpQjs7O0FBQWdCO0VBQThMOzs7QUFBTztFQUF1RDtFQUFnQjtFQUFjOzs7QUFBZ0I7RUFBaUc7RUFBVTtFQUFVO0VBQVM7OztBQUFtQjtFQUF1RTs7O0FBQWdCO0VBQWlIOzs7QUFBVTtFQUFrRjs7O0FBQU87RUFBMEQ7OztBQUFjO0VBQTZIO0VBQVM7OztBQUFVO0VBQXNCOzs7QUFBaUI7RUFBZ0U7OztBQUFrQjtFQUFzQztFQUFpQjs7O0FBQWtCO0VBQWdEO0VBQXFCO0VBQVk7RUFBa0I7RUFBb0I7RUFBZ0I7OztBQUF1QjtFQUF3RTs7O0FBQWU7RUFBc0U7RUFBZTtFQUFnQjtFQUFnQjtFQUFtQjs7O0FBQXVCO0VBQTRFOzs7QUFBYTtFQUF5Rzs7O0FBQWU7RUFBK0c7OztBQUFZO0VBQWlEOzs7QUFBTztFQUF1RDs7O0FBQWE7RUFBNEM7RUFBa0I7RUFBUTtFQUFVO0VBQXFCO0VBQVc7RUFBWTtFQUFpQjtFQUFpQjtFQUFpQztFQUFtQjtFQUFpQjtFQUF3Qjs7O0FBQVc7RUFBNkM7RUFBa0I7RUFBUztFQUFTO0VBQXFCO0VBQVE7RUFBVztFQUF5QjtFQUE4QjtFQUFvQzs7O0FBQVc7RUFBbUU7RUFBTzs7O0FBQVc7RUFBeUQ7OztBQUF5QjtFQUFnRTs7O0FBQWE7RUFBc0Y7RUFBTTtFQUFRO0VBQVc7RUFBYztFQUFVOzs7QUFBeUI7RUFBK0Q7RUFBa0I7RUFBUztFQUFTO0VBQWM7RUFBVTtFQUFXO0VBQWtCO0VBQWtCOzs7QUFBeUI7RUFBa047OztBQUFrQjtFQUFlOzs7QUFBYztFQUE4QztFQUFlOzs7QUFBZ0I7RUFBb0M7RUFBUTs7O0FBQVU7RUFBcUM7RUFBZ0I7OztBQUFrQjtFQUE4RDtFQUFXO0VBQWlCOzs7QUFBYztFQUEyQztFQUFXOzs7QUFBVTtFQUFtRjtFQUFtQjs7O0FBQWU7RUFBK0Y7OztBQUFnQjtFQUFvSDs7O0FBQWU7RUFBMkU7RUFBVzs7O0FBQVU7RUFBOEU7RUFBbUI7OztBQUFjO0VBQThEO0VBQW1CO0VBQWM7OztBQUFpQjtFQUFvRjs7O0FBQWU7RUFBMEQ7RUFBVztFQUFVO0VBQWtCO0VBQWM7OztBQUF5QjtFQUFtRztFQUFtQjs7O0FBQWU7RUFBK0c7OztBQUFnQjtFQUFxRDtFQUFnQjs7O0FBQWtCO0VBQXVFO0VBQVk7RUFBZTs7O0FBQWlCO0VBQWlHO0VBQVc7OztBQUFVO0VBQWlHO0VBQVc7OztBQUFVO0VBQThEOzs7QUFBZTtFQUFvSDs7O0FBQWtCO0VBQWdJO0VBQWtCOzs7QUFBYztFQUEwSztFQUFVOzs7QUFBVTtFQUFvSDtFQUFrQjs7O0FBQWM7RUFBNEo7OztBQUFZO0VBQXdLO0VBQVk7OztBQUFVO0VBQXFFO0VBQWU7OztBQUFpQjtFQUErRztFQUFXOzs7QUFBVTtFQUFnRztFQUFROzs7QUFBVTtFQUE0RjtFQUFXOzs7QUFBVTtFQUEwRTs7O0FBQWtCO0VBQXlIOzs7QUFBVztFQUF5STs7O0FBQVc7RUFBbUg7RUFBa0I7OztBQUFlO0VBQXlJOzs7QUFBa0I7RUFBeUM7OztBQUFnQjtFQUF3RjtFQUFROzs7QUFBVTtFQUFvSztFQUFtQjs7O0FBQWlCO0VBQXdHOzs7QUFBVTtFQUE0RDs7O0FBQWlCO0VBQXVGOzs7QUFBbUI7RUFBOEM7OztBQUFrQjtFQUE0RDtFQUFrQjtFQUFTO0VBQVc7RUFBWTs7O0FBQVU7RUFBWTtFQUFTO0VBQVU7RUFBc0I7RUFBZTtFQUEwQjtFQUFtQjtFQUFnQjtFQUE2QjtFQUFrQjtFQUFxQjtFQUFzQjtFQUFlO0VBQVk7RUFBaUI7RUFBc0I7RUFBaUM7RUFBUztFQUFvQjtFQUFlO0VBQW1CO0VBQXlCO0VBQXNCO0VBQXFCOzs7QUFBaUI7RUFBa0I7RUFBVTs7O0FBQW9DO0VBQTBCOzs7QUFBNkI7RUFBd0I7OztBQUFnQjtFQUFvQjs7O0FBQXlCO0VBQXlDO0VBQW1COzs7QUFBVztFQUE2QztFQUFnQjs7O0FBQW1CO0VBQWtCO0VBQWM7RUFBb0I7RUFBVztFQUFlOzs7QUFBc0I7RUFBc0M7OztBQUFvQjtFQUFtQjtFQUFRO0VBQVM7RUFBVzs7O0FBQVk7RUFBNkM7RUFBa0I7OztBQUErQjtFQUEwQjtFQUFNO0VBQVE7RUFBUztFQUFPO0VBQXNCO0VBQWtCO0VBQXdDOzs7QUFBVztFQUF1Qzs7O0FBQXVCO0VBQXVFO0VBQVc7OztBQUFPO0VBQTBGO0VBQVE7OztBQUFVO0VBQWlDO0VBQWtCO0VBQVE7RUFBc0I7OztBQUFtQjtFQUE2Qzs7O0FBQWM7RUFBa0I7RUFBZTtFQUFZOzs7QUFBaUI7RUFBb0M7RUFBb0I7OztBQUFlO0VBQXFDO0VBQVc7OztBQUFZO0VBQTJDO0VBQVU7OztBQUFjO0VBQXVEOzs7QUFBb0I7RUFBd0Q7OztBQUF1QjtFQUFnQjs7O0FBQWM7RUFBa0M7OztBQUFvQjtFQUFtQztFQUFVOzs7QUFBVTtFQUErRTtFQUFROzs7QUFBVTtFQUFrRztFQUFXOzs7QUFBTztFQUFxRDs7O0FBQW9CO0VBQXNEOzs7QUFBd0I7RUFBdUU7OztBQUF3QjtFQUE0Qjs7O0FBQWU7RUFBaVI7OztBQUFpQjtFQUFzRDs7O0FBQWtCO0VBQTBEOzs7QUFBa0I7RUFBc0Y7OztBQUE2QjtFQUF3RDtFQUEwQjs7O0FBQXlCO0VBQTJCOzs7QUFBZTtFQUEyUTs7O0FBQVk7RUFBcUQ7OztBQUFrQjtFQUF5RDs7O0FBQVk7RUFBcUY7OztBQUEyQjtFQUF1RDtFQUEwQjs7O0FBQXlCO0VBQStDO0VBQXlCOzs7QUFBZ0I7RUFBbUQ7OztBQUE4QjtFQUFnM0M7OztBQUErQjtFQUFnYTs7O0FBQWdDO0VBQXdYOzs7QUFBdUM7RUFBdzdDOzs7QUFBK0I7RUFBb2Q7OztBQUFtQjtFQUE0ZTtFQUFrQjtFQUFNO0VBQVU7RUFBUztFQUErQjs7O0FBQVc7RUFBdUo7OztBQUE2QjtFQUErUTs7O0FBQWU7RUFBMlE7OztBQUFrQjtFQUF5UTs7O0FBQWlCO0VBQWdEO0VBQXlCOzs7QUFBYTtFQUFpRDs7O0FBQWE7RUFBeUM7OztBQUErQjtFQUFtQjtFQUFXOzs7QUFBZTtFQUEwQjtFQUFjOzs7QUFBVztFQUF5QjtFQUFjO0VBQVc7OztBQUFXO0VBQVc7RUFBc0I7RUFBUztFQUFVO0VBQXNCO0VBQTBCO0VBQW1CO0VBQWdCO0VBQTZCO0VBQWtCO0VBQWU7RUFBZ0I7OztBQUFrQjtFQUFpQjtFQUFXO0VBQWdCO0VBQTBCO0VBQXlCOzs7QUFBaUI7RUFBNEY7RUFBa0I7RUFBYTs7O0FBQXlCO0VBQXlCO0VBQWdCO0VBQW1CO0VBQXVCOzs7QUFBb0I7RUFBOEc7OztBQUFpQjtFQUE4SjtFQUFjO0VBQWdCOzs7QUFBdUI7RUFBaUQ7RUFBZ0I7RUFBdUI7OztBQUFvQjtFQUFpQjs7O0FBQWE7RUFBa0I7RUFBYTtFQUFzQjs7O0FBQW1CO0VBQXVCO0VBQWtCO0VBQXNCO0VBQWdCO0VBQWdCO0VBQW1CO0VBQWdDOzs7QUFBK0I7RUFBbUQ7OztBQUFrQjtFQUFvSTtFQUFrQjtFQUFRO0VBQVE7RUFBVTtFQUFhO0VBQWlDO0VBQTJCO0VBQWdDOzs7QUFBVztFQUFpRDs7O0FBQWdCO0VBQXVCO0VBQWdDOzs7QUFBMEI7RUFBOEo7OztBQUE4QjtFQUE0TTs7O0FBQWdCO0VBQXNjOzs7QUFBZ0I7RUFBMkY7OztBQUFtQjtFQUE4QztFQUFtQjs7O0FBQTZCO0VBQW9EOzs7QUFBbUI7RUFBbUI7RUFBa0I7RUFBVTs7O0FBQWdCO0VBQXNCOzs7QUFBNEI7RUFBa0Q7OztBQUFnQztFQUFxQzs7O0FBQWM7RUFBc0I7RUFBYTtFQUFlOzs7QUFBWTtFQUF3Qjs7O0FBQVU7RUFBMkI7OztBQUEyQjtFQUE2Qjs7O0FBQXVCO0VBQTRCOzs7QUFBeUI7RUFBaUQ7RUFBYTtFQUFlOzs7QUFBbUI7RUFBdUQ7OztBQUEyQjtFQUE4RDs7O0FBQXVDO0VBQStEOzs7QUFBYztFQUF5TTs7O0FBQW1CO0VBQWlEOzs7QUFBdUM7RUFBeUI7OztBQUFtQjtFQUF3QjtFQUFrQjtFQUFVOzs7QUFBTztFQUEwQjtFQUFhO0VBQVU7RUFBbUI7OztBQUE4QjtFQUFnQztFQUFrQjtFQUFNO0VBQVE7RUFBUztFQUFPO0VBQVc7RUFBWTs7O0FBQVc7RUFBeUI7RUFBZ0I7RUFBYztFQUFZOzs7QUFBcUI7RUFBK0I7RUFBb0I7RUFBc0I7OztBQUFtQjtFQUEwRDs7O0FBQWU7RUFBd0U7OztBQUFjO0VBQTBEOzs7QUFBaUI7RUFBeUQ7OztBQUFjO0VBQXlCO0VBQWE7OztBQUE4QjtFQUEwQjtFQUFrQjtFQUFhO0VBQW1CO0VBQTBCO0VBQWM7RUFBYztFQUFlO0VBQWtCO0VBQWU7OztBQUFtQjtFQUFnQztFQUFzQjs7O0FBQTJCO0VBQWlDOzs7QUFBYztFQUEyQjtFQUFzQjtFQUFTO0VBQVU7RUFBc0I7RUFBZTtFQUEwQjtFQUFtQjtFQUFnQjtFQUE2QjtFQUFnQjtFQUFzQjtFQUFrQjs7O0FBQXNHO0VBQThDO0VBQWlCO0VBQWtCO0VBQVM7OztBQUFnQjtFQUEwRDtFQUFjO0VBQWM7RUFBc0I7RUFBZTtFQUFrQjs7O0FBQW9CO0VBQWdDOzs7QUFBa0I7RUFBd0Y7OztBQUF5QjtFQUE0TTs7O0FBQXlCO0VBQWtDO0VBQVk7OztBQUFnQztFQUE4Qzs7O0FBQWdCO0VBQWlEOzs7QUFBc0I7RUFBb0M7RUFBVztFQUFrQjs7O0FBQWdCO0VBQXNDO0VBQStCO0VBQWtCOzs7QUFBZ0I7RUFBb0g7OztBQUFpQjtFQUFnQztFQUFhO0VBQThCO0VBQWdCO0VBQWdCO0VBQXlCOzs7QUFBNkI7RUFBeUI7OztBQUFXO0VBQTZDOzs7QUFBVztFQUE4RTtFQUFrQjtFQUFpQjs7O0FBQWtCO0VBQW9IOzs7QUFBZTtFQUErRDs7O0FBQVU7RUFBNkM7OztBQUF1QztFQUFxQjtFQUFrQjtFQUFvQjs7O0FBQXNCO0VBQTJCO0VBQWtCO0VBQU07RUFBVTtFQUFlO0VBQW1CO0VBQTBCO0VBQXlCO0VBQTBCOzs7QUFBeUI7RUFBb0M7RUFBYzs7O0FBQWU7RUFBMEM7OztBQUFjO0VBQTJCOzs7QUFBVztFQUFnQzs7O0FBQWtCO0VBQTJEO0VBQW9CO0VBQVc7OztBQUFtQjtFQUFzQjtFQUFXOzs7QUFBVztFQUEyQjtFQUFjO0VBQWE7RUFBZTtFQUFxQjtFQUFrQjtFQUFXO0VBQXNCO0VBQVc7RUFBWTtFQUFVO0VBQWM7RUFBaUI7RUFBZ0I7RUFBeUI7RUFBa0I7RUFBMkI7RUFBbUI7RUFBeUI7RUFBc0I7RUFBcUI7OztBQUFpQjtFQUEwRTs7O0FBQWM7RUFBa0M7OztBQUFjO0VBQW9HOzs7QUFBMEI7RUFBbUU7RUFBa0I7RUFBd0I7RUFBa0M7OztBQUFXO0VBQWtDO0VBQVE7RUFBVTtFQUFTOzs7QUFBVztFQUFpQztFQUFRO0VBQVc7RUFBUztFQUFVOzs7QUFBd0I7RUFBNEM7OztBQUEwQjtFQUEyQzs7O0FBQXVCO0VBQWtDO0VBQXVCO0VBQVM7OztBQUFrQjtFQUFpRjtFQUFhOzs7QUFBYTtFQUFpRDtFQUFvQjs7O0FBQWlCO0VBQWdFOzs7QUFBbUI7RUFBaUQ7OztBQUFhO0VBQXVEO0VBQVU7OztBQUFXO0VBQXlDO0VBQWtCO0VBQWE7OztBQUFhO0VBQTBDOzs7QUFBa0I7RUFBMkQ7OztBQUFzQjtFQUFtRDs7O0FBQWdCO0VBQW1EO0VBQTBCO0VBQVU7OztBQUFnQjtFQUF5RTtFQUFrQjtFQUFNO0VBQVE7RUFBWTtFQUFXO0VBQTJCO0VBQTBCO0VBQVc7OztBQUFvQjtFQUFtQzs7O0FBQWE7RUFBMkU7RUFBa0I7RUFBTTtFQUFZO0VBQU87RUFBVztFQUE0QjtFQUEwQjtFQUFXOzs7QUFBb0I7RUFBNkU7RUFBa0I7RUFBTTtFQUFTO0VBQVU7RUFBVztFQUEwQjtFQUFXOzs7QUFBb0I7RUFBdUM7OztBQUFPO0VBQXNDOzs7QUFBUTtFQUF1RTs7O0FBQWtCO0VBQWlNOzs7QUFBaUQ7RUFBMEQ7OztBQUF1QztFQUF5RTs7O0FBQWtCO0VBQXNNOzs7QUFBa0Q7RUFBa0Q7RUFBZ0I7RUFBVTs7O0FBQWdCO0VBQXlCO0VBQVM7RUFBYTtFQUFtQjtFQUE2Qjs7O0FBQVc7RUFBK0I7OztBQUErQjtFQUE2QjtFQUFXO0VBQWlDOzs7QUFBa0I7RUFBdUU7OztBQUFnQztFQUFnQztJQUFxSDs7O0FBQTJCO0VBQWlCOzs7QUFBMEI7RUFBc0M7RUFBeUI7OztBQUEwQjtFQUEyTTs7O0FBQWdCO0VBQXFCOzs7QUFBNEI7RUFBb0Y7OztBQUEyQjtFQUE4RDs7O0FBQTRCO0VBQWtCOzs7QUFBMEI7RUFBc0M7OztBQUFjO0VBQXdDOzs7QUFBaUI7RUFBMEU7OztBQUFrQjtFQUEySjtFQUFXOzs7QUFBTztFQUE4Qzs7O0FBQWlCO0VBQTJFOzs7QUFBOEI7RUFBb0U7OztBQUF5QjtFQUFxRTs7O0FBQTJCO0VBQWdEO0VBQWlCOzs7QUFBYztFQUFzRDs7O0FBQTZCO0VBQWtHOzs7QUFBb0I7RUFBaUQ7OztBQUEwQjtFQUF3VTtFQUFrQjs7O0FBQWU7RUFBNEM7OztBQUFrQjtFQUErRjs7O0FBQVk7RUFBd0U7RUFBZTs7O0FBQWdCO0VBQXdEOzs7QUFBeUI7RUFBbUU7OztBQUF5QjtFQUFrRTs7O0FBQXVCO0VBQTRDO0VBQWM7OztBQUFlO0VBQTRDO0VBQWU7OztBQUFlO0VBQTBEOzs7QUFBaUI7RUFBMEQ7OztBQUFxQjtFQUFjOzs7QUFBYztFQUEwQzs7O0FBQWtCO0VBQXVEOzs7QUFBYztFQUFtRDtFQUFlOzs7QUFBaUI7RUFBK0Q7RUFBaUI7OztBQUFpQjtFQUF3RTs7O0FBQVM7RUFBMEM7OztBQUFRO0VBQWdHOzs7QUFBUTtFQUFzRDs7O0FBQVE7RUFBNG9CO0VBQWlCOzs7QUFBYztFQUF1Qjs7O0FBQWM7RUFBb0Q7OztBQUFpQjtFQUErQjs7O0FBQXNCO0VBQThIOzs7QUFBZ0I7RUFBMEo7RUFBa0I7RUFBUTtFQUFPO0VBQWdDOzs7QUFBVztFQUFzTTs7O0FBQVc7RUFBME87OztBQUF3QztFQUF3YztFQUFNO0VBQVM7OztBQUFXO0VBQXNPO0VBQU87OztBQUFpRDtFQUFrTztFQUFROzs7QUFBa0Q7RUFBNHFCOzs7QUFBVTtFQUEwSzs7O0FBQVM7RUFBa0U7RUFBUTtFQUFnQjs7O0FBQWdCO0VBQXNMOzs7QUFBTTtFQUF3Rjs7O0FBQVE7RUFBOEg7RUFBc0I7OztBQUFlO0VBQXNMO0VBQWlCOzs7QUFBa0I7RUFBOE87OztBQUFnQjtFQUEwTTs7O0FBQXNCO0VBQXdjO0VBQVE7RUFBTzs7O0FBQVk7RUFBc087RUFBTTs7O0FBQWlEO0VBQWtPO0VBQVM7OztBQUFrRDtFQUE0cUI7OztBQUFVO0VBQXNNOzs7QUFBVTtFQUEwTzs7O0FBQThCO0VBQTRhO0VBQWM7OztBQUFzQjtFQUFrRzs7O0FBQVE7RUFBb0Y7RUFBaUI7OztBQUE4QjtFQUE0Sjs7O0FBQWtCO0VBQWdFOzs7QUFBUTtFQUFvRzs7O0FBQU87RUFBc0Y7RUFBUTtFQUFrQjs7O0FBQStCO0VBQThKOzs7QUFBbUI7RUFBbUI7RUFBc0I7RUFBUztFQUFVO0VBQXNCO0VBQWU7RUFBMEI7RUFBbUI7RUFBZ0I7RUFBNkI7RUFBa0I7RUFBWTtFQUFhO0VBQWE7OztBQUFjO0VBQTBCOzs7QUFBYTtFQUF3QjtFQUFpQjtFQUFTO0VBQWM7RUFBa0I7RUFBZ0I7RUFBZ0I7RUFBcUI7RUFBc0I7RUFBNEI7RUFBa0I7RUFBYTs7O0FBQXNHO0VBQTZCO0VBQWE7RUFBbUI7RUFBZ0I7RUFBUztFQUFpQjtFQUFnQjtFQUFzQjtFQUFnQjtFQUFlO0VBQWlCO0VBQW1CO0VBQXVCO0VBQWU7OztBQUFtQjtFQUFrQztFQUFPOzs7QUFBbUI7RUFBb0M7RUFBVTtFQUFpQjtFQUFzQjtFQUFlO0VBQXVCO0VBQVM7OztBQUFlO0VBQTBDOzs7QUFBYztFQUFtQzs7O0FBQW1CO0VBQWtGO0VBQXNCO0VBQXVCOzs7QUFBbUI7RUFBMEY7RUFBUztFQUFpQjtFQUFtQjtFQUF5Qjs7O0FBQWtEO0VBQXdHO0VBQWM7OztBQUFnQjtFQUFrRzs7O0FBQWtCO0VBQXNTOzs7QUFBZ0I7RUFBb0g7OztBQUEwQjtFQUFrSTs7O0FBQXlCO0VBQTBIOzs7QUFBMEI7RUFBd0k7OztBQUFzQjtFQUFzUzs7O0FBQWU7RUFBc0g7OztBQUEwQjtFQUFvSTs7O0FBQXdCO0VBQXdIOzs7QUFBMEI7RUFBc0k7OztBQUF1QjtFQUFVO0VBQXNCO0VBQVM7RUFBVTtFQUFzQjtFQUFlO0VBQTBCO0VBQW1CO0VBQWdCO0VBQTZCOzs7QUFBYTtFQUFvRDtFQUFrQjtFQUFhO0VBQVU7OztBQUFtQjtFQUEwRjtFQUFrQjtFQUFxQjtFQUFhO0VBQVU7RUFBbUI7RUFBZ0I7RUFBbUI7OztBQUF1QjtFQUE4TTtFQUFrQjtFQUFVO0VBQVU7RUFBdUI7RUFBVzs7O0FBQW9CO0VBQTBGO0VBQWtCO0VBQWE7OztBQUF5QjtFQUFzRztFQUFhOzs7QUFBbUI7RUFBb0g7RUFBa0I7RUFBa0I7OztBQUFvQjtFQUEwRjtFQUFrQjtFQUFpQjtFQUF1Qjs7O0FBQVM7RUFBc0c7RUFBa0I7RUFBUTtFQUFTO0VBQU87RUFBVztFQUEyQjs7O0FBQVc7RUFBd0Y7RUFBZTtFQUFnQjtFQUFjO0VBQW1CO0VBQXlCO0VBQTBCO0VBQWE7RUFBZTs7O0FBQWtEO0VBQW9HOzs7QUFBYztFQUEwTTs7O0FBQWM7RUFBd0I7OztBQUFVO0VBQXNMOzs7QUFBdUI7RUFBa0I7RUFBa0I7RUFBbUI7OztBQUFvQjtFQUFjO0VBQWtCO0VBQW9CO0VBQW1CO0VBQWU7RUFBZTtFQUF1QjtFQUFTO0VBQWE7OztBQUFlO0VBQXdHOzs7QUFBYztFQUF1QztFQUFhOzs7QUFBbUI7RUFBcUI7RUFBVTtFQUFrQjtFQUFnQjtFQUFzQjtFQUFlO0VBQXVCO0VBQVk7OztBQUFlO0VBQTJCOzs7QUFBc0I7RUFBb0I7OztBQUFjO0VBQW9EO0VBQWM7OztBQUFtQztFQUFvQztFQUFzQjs7O0FBQW1CO0VBQXdQOzs7QUFBc0I7RUFBNEM7OztBQUFTO0VBQXVCOzs7QUFBa0I7RUFBNEI7OztBQUFrQjtFQUFrQjtFQUFrQjs7O0FBQVc7RUFBeUI7RUFBVTtFQUFZOzs7QUFBYTtFQUFrQjs7O0FBQWE7RUFBeUI7OztBQUFhO0VBQStDOzs7QUFBZ0I7RUFBMkQ7OztBQUFVO0VBQTZEO0VBQVU7OztBQUF1QjtFQUF1QjtFQUFrQjtFQUFnQjs7O0FBQVE7RUFBNkI7OztBQUFVO0VBQThCO0VBQVU7OztBQUF1QjtFQUFTO0VBQXNCO0VBQWU7RUFBMEI7RUFBbUI7RUFBZ0I7RUFBNkI7RUFBcUI7RUFBWTtFQUFpQjtFQUFjO0VBQWU7RUFBaUI7RUFBbUI7RUFBbUI7RUFBeUI7RUFBa0I7RUFBVTs7O0FBQW1CO0VBQXFDOzs7QUFBc0I7RUFBa0M7RUFBcUI7RUFBYzs7O0FBQWM7RUFBb0I7RUFBZ0I7RUFBc0I7RUFBZTtFQUFlOzs7QUFBbUI7RUFBMEI7OztBQUFzQjtFQUFtQjs7O0FBQXlCO0VBQTZJOzs7QUFBVztFQUFtQjtFQUE2QjtFQUF5Qjs7O0FBQWU7RUFBeUQ7OztBQUFjO0VBQXFEOzs7QUFBVztFQUEyQjs7O0FBQXlCO0VBQTBCOzs7QUFBeUI7RUFBZ0I7OztBQUFhO0VBQWM7RUFBYztFQUFtQjs7O0FBQXFCO0VBQXNCO0VBQVc7RUFBbUI7OztBQUFxQjtFQUFpQjtFQUFjO0VBQW1COzs7QUFBcUI7RUFBeUI7RUFBVztFQUFtQjs7O0FBQXFCO0VBQWE7RUFBYztFQUFtQjs7O0FBQXFCO0VBQXFCO0VBQVc7RUFBbUI7OztBQUFxQjtFQUFpQjtFQUFjO0VBQW1COzs7QUFBcUI7RUFBeUI7RUFBVztFQUFtQjs7O0FBQXFCO0VBQWdCO0VBQWM7RUFBbUI7OztBQUFxQjtFQUF3QjtFQUFXO0VBQW1COzs7QUFBcUI7RUFBZ0I7RUFBYztFQUFtQjs7O0FBQXFCO0VBQXdCO0VBQVc7RUFBbUI7OztBQUFxQjtFQUFjO0VBQWM7RUFBbUI7OztBQUFxQjtFQUFzQjtFQUFXO0VBQW1COzs7QUFBcUI7RUFBYztFQUFjO0VBQW1COzs7QUFBcUI7RUFBc0I7RUFBVztFQUFtQjs7O0FBQXFCO0VBQWM7RUFBYztFQUFtQjs7O0FBQXFCO0VBQXNCO0VBQVc7RUFBbUI7OztBQUFxQjtFQUFlO0VBQWM7RUFBbUI7OztBQUFxQjtFQUF1QjtFQUFXO0VBQW1COzs7QUFBcUI7RUFBYztFQUFjO0VBQW1COzs7QUFBcUI7RUFBc0I7RUFBVztFQUFtQjs7O0FBQXFCO0VBQWtCO0VBQWM7RUFBbUI7OztBQUFxQjtFQUEwQjtFQUFXO0VBQW1COzs7QUFBcUI7RUFBZ0I7RUFBYztFQUFtQjs7O0FBQXFCO0VBQXdCO0VBQVc7RUFBbUI7OztBQUFxQjtFQUFpQjtFQUFjO0VBQW1COzs7QUFBcUI7RUFBb0I7RUFBYztFQUFtQjs7O0FBQXFCO0VBQWU7RUFBYztFQUFtQjs7O0FBQXFCO0VBQWlCO0VBQWM7RUFBbUI7OztBQUFxQjtFQUE4Qzs7O0FBQWdCO0VBQXFCO0VBQWU7RUFBZ0I7RUFBYzs7O0FBQWlCO0VBQWlDO0VBQWlCOzs7QUFBYztFQUFzRTtFQUFpQjs7O0FBQWM7RUFBYztFQUFzQjtFQUFzQjtFQUFlO0VBQTBCO0VBQW1CO0VBQTZCO0VBQVM7RUFBVTs7O0FBQWdCO0VBQW1CO0VBQWtCO0VBQVM7RUFBb0I7RUFBZTs7O0FBQWdCO0VBQXdCO0VBQWtCO0VBQVM7RUFBUztFQUF5Qjs7O0FBQThCO0VBQW1EO0VBQWU7OztBQUE2QjtFQUFtRDs7O0FBQWE7RUFBd0I7RUFBa0I7RUFBVztFQUFZO0VBQXNCO0VBQTZCOzs7QUFBb0I7RUFBNkI7RUFBYzs7O0FBQXFCO0VBQTRCO0VBQWM7OztBQUFxQjtFQUE4QjtFQUFjOzs7QUFBcUI7RUFBNkI7RUFBc0I7OztBQUE2QjtFQUErQjtFQUFrQjtFQUFVO0VBQVM7RUFBVztFQUFZO0VBQWE7RUFBZ0I7RUFBYztFQUFrQjtFQUFTO0VBQWdCOzs7QUFBK0I7RUFBMkI7RUFBa0I7RUFBYTtFQUFrQjs7O0FBQXNCO0VBQWdEOzs7QUFBYTtFQUFtRDs7O0FBQWdCO0VBQWtpQjs7O0FBQVM7RUFBK0s7OztBQUFpQjtFQUFvTTs7O0FBQWdCO0VBQWdRO0VBQXFCO0VBQXVCOzs7QUFBZ0I7RUFBbVE7RUFBdUI7RUFBUzs7O0FBQWlCO0VBQTZQOzs7QUFBc0I7RUFBcUY7OztBQUF3QjtFQUFtRjtFQUFjO0VBQXlCOzs7QUFBK0I7RUFBbUY7OztBQUFhO0VBQXNGO0VBQVM7RUFBYztFQUF5Qjs7O0FBQStCO0VBQXlGOzs7QUFBZ0I7RUFBMEQ7RUFBa0I7RUFBYTtFQUF1Qjs7O0FBQWlCO0VBQW1GO0VBQXNCO0VBQXVCOzs7QUFBZ0I7RUFBa0I7OztBQUFjO0VBQTBDO0VBQVU7RUFBVTtFQUErQjs7O0FBQWlCO0VBQWlEO0VBQVU7RUFBVTs7O0FBQThCO0VBQTZDOzs7QUFBa0I7RUFBMnJCO0VBQVU7OztBQUFVO0VBQWtPO0VBQWtCOzs7QUFBYztFQUF1UDtFQUFpQjs7O0FBQWM7RUFBbVQ7RUFBc0I7RUFBVTs7O0FBQWlCO0VBQXNUOzs7QUFBZ0I7RUFBZ1Q7RUFBUTs7O0FBQVU7RUFBc0c7RUFBVztFQUFrQjs7O0FBQWlCO0VBQTJNO0VBQWdDOzs7QUFBaUI7RUFBMkU7OztBQUFnQjtFQUFvRztFQUF1Qjs7O0FBQWlCO0VBQWE7RUFBc0I7RUFBUztFQUFVO0VBQXNCO0VBQWU7RUFBMEI7RUFBbUI7RUFBZ0I7RUFBNkI7RUFBa0I7RUFBYTtFQUFjO0VBQXVCO0VBQWtCO0VBQWdCO0VBQWdCOzs7QUFBbUI7RUFBcUI7OztBQUFrQjtFQUFvQjs7O0FBQWE7RUFBMEY7OztBQUE0QjtFQUFnRzs7O0FBQTBCO0VBQW1HOzs7QUFBeUI7RUFBNkY7OztBQUEyQjtFQUFtQjtFQUFlO0VBQWdCO0VBQWdCO0VBQVc7RUFBZ0I7RUFBcUI7RUFBcUI7RUFBaUM7RUFBa0I7OztBQUFzRztFQUFtQjtFQUFrQjtFQUFVO0VBQWM7RUFBVztFQUFZO0VBQWdCO0VBQXVCOzs7QUFBb0I7RUFBMkI7RUFBaUc7RUFBa0I7RUFBTTtFQUFRO0VBQVM7RUFBTztFQUFjO0VBQW1CO0VBQW9CO0VBQVk7RUFBVztFQUFvQjtFQUFzQjs7O0FBQW9CO0VBQWtDO0VBQWtCO0VBQWtCO0VBQW1CO0VBQW1CO0VBQW9CO0VBQThDO0VBQTRCO0VBQWdDO0VBQVc7RUFBaUM7RUFBeUI7RUFBc1g7OztBQUE4VztFQUFtSjtFQUFTOzs7QUFBMkI7RUFBMks7RUFBdUM7OztBQUEwQztFQUE4QztFQUFTOzs7QUFBNEM7RUFBa0Q7OztBQUFVO0VBQW1EOzs7QUFBVztFQUF5SjtFQUFPOzs7QUFBNEI7RUFBaUw7RUFBd0M7OztBQUEwQztFQUFnRDtFQUFROzs7QUFBNkM7RUFBbUQ7OztBQUFRO0VBQXNEOzs7QUFBVztFQUFzSjtFQUFROzs7QUFBMkI7RUFBOEs7RUFBd0M7OztBQUEyQztFQUErQztFQUFROzs7QUFBNEM7RUFBa0Q7OztBQUFRO0VBQXFEOzs7QUFBVztFQUE0SjtFQUFNOzs7QUFBNEI7RUFBb0w7RUFBeUM7OztBQUEwQztFQUFpRDtFQUFTOzs7QUFBNkM7RUFBcUQ7OztBQUFVO0VBQXNEOzs7QUFBVztFQUFxQzs7O0FBQXlCO0VBQW9EOzs7QUFBbUI7RUFBd0M7OztBQUF5QjtFQUF1RDs7O0FBQW1CO0VBQW9DOzs7QUFBeUI7RUFBbUQ7OztBQUFtQjtFQUF3Qzs7O0FBQXlCO0VBQXVEOzs7QUFBbUI7RUFBdUM7OztBQUF5QjtFQUFzRDs7O0FBQW1CO0VBQXVDOzs7QUFBeUI7RUFBc0Q7OztBQUFtQjtFQUFxQzs7O0FBQXlCO0VBQW9EOzs7QUFBbUI7RUFBcUM7OztBQUF5QjtFQUFvRDs7O0FBQW1CO0VBQXFDOzs7QUFBeUI7RUFBb0Q7OztBQUFtQjtFQUFzQzs7O0FBQXlCO0VBQXFEOzs7QUFBbUI7RUFBcUM7OztBQUF5QjtFQUFvRDs7O0FBQW1CO0VBQXlDOzs7QUFBeUI7RUFBd0Q7OztBQUFtQjtFQUF1Qzs7O0FBQXlCO0VBQXNEOzs7QUFBbUI7RUFBaUI7OztBQUFjO0VBQW9DOzs7QUFBaUI7RUFBZ0Q7RUFBYTtFQUFXO0VBQVk7OztBQUFpQjtFQUFpRTtFQUFTOzs7QUFBZ0I7RUFBNkY7RUFBVzs7O0FBQWU7RUFBaUk7OztBQUFtQjtFQUFpSDs7O0FBQWdDO0VBQWlGOzs7QUFBUztFQUFxRjs7O0FBQWtCO0VBQWtEOzs7QUFBNkI7RUFBOEM7OztBQUFxQjtFQUFxRTs7O0FBQXFCO0VBQTJFO0VBQXFCOzs7QUFBdUI7RUFBMkU7RUFBcUI7RUFBeUM7RUFBdUI7OztBQUFVO0VBQWdEOzs7QUFBcUI7RUFBdUU7OztBQUFxQjtFQUE2RTtFQUFxQjs7O0FBQXVCO0VBQTZFO0VBQXFCO0VBQXlDO0VBQXVCOzs7QUFBVTtFQUFjO0VBQXNCO0VBQVM7RUFBVTtFQUFzQjtFQUFlO0VBQTBCO0VBQW1CO0VBQWdCO0VBQTZCO0VBQWtCO0VBQWE7OztBQUFvQjtFQUEwQzs7O0FBQW1CO0VBQW1CO0VBQWE7RUFBc0I7RUFBWTtFQUFhO0VBQXlCOzs7QUFBa0I7RUFBbUM7RUFBWTs7O0FBQVk7RUFBMEM7OztBQUFzQjtFQUEwQjtFQUFhO0VBQVU7RUFBbUI7RUFBWTtFQUFxQjtFQUFzQjtFQUFnQjtFQUFnQzs7O0FBQTBCO0VBQTRDOzs7QUFBaUI7RUFBNEI7OztBQUFVO0VBQWdDO0VBQVU7RUFBZ0I7RUFBbUI7RUFBaUI7OztBQUF1QjtFQUFtQztFQUFlO0VBQTBCOzs7QUFBZTtFQUE2Qzs7O0FBQW1CO0VBQXdCO0VBQWE7RUFBVTtFQUFzQjtFQUFnQjs7O0FBQWU7RUFBdUM7RUFBa0I7RUFBVTs7O0FBQWE7RUFBMkI7RUFBVTtFQUFTO0VBQVU7RUFBYzs7O0FBQWdCO0VBQWdDO0VBQWE7RUFBbUI7RUFBZ0I7RUFBaUI7RUFBaUI7OztBQUFtQjtFQUFrRDs7O0FBQWlCO0VBQWtDOzs7QUFBVTtFQUFxQztFQUFVO0VBQWdCO0VBQW1COzs7QUFBdUI7RUFBdUM7RUFBa0I7RUFBYztFQUFlOzs7QUFBbUI7RUFBNkM7OztBQUFjO0VBQTZDO0VBQWtCO0VBQVM7RUFBVztFQUFZO0VBQVU7OztBQUFXO0VBQW9GO0VBQXlCOzs7QUFBZTtFQUEySDs7O0FBQXlCO0VBQTJIO0VBQXVCOzs7QUFBZTtFQUF3Qzs7O0FBQXlCO0VBQXlDO0VBQXNCOzs7QUFBbUI7RUFBOEI7RUFBYztFQUFpQjs7O0FBQTZCO0VBQWtDO0VBQVU7RUFBVztFQUFjO0VBQXNCOzs7QUFBa0I7RUFBMEI7OztBQUE2QjtFQUF3QjtFQUFhO0VBQVU7RUFBc0I7RUFBa0I7RUFBYTs7O0FBQXNCO0VBQWlDOzs7QUFBYztFQUE2Qzs7O0FBQWtCO0VBQTBDOzs7QUFBZTtFQUErQjs7O0FBQWdCO0VBQWtCOzs7QUFBYztFQUE0QztFQUFrQjs7O0FBQWtCO0VBQW1EO0VBQVc7OztBQUFVO0VBQThEO0VBQWU7OztBQUFnQjtFQUE0QztFQUFROzs7QUFBVTtFQUFrRDs7O0FBQWdCO0VBQW9FO0VBQWU7OztBQUFnQjtFQUFnRDs7O0FBQWdCO0VBQTRDO0VBQVE7OztBQUFVO0VBQTBCO0VBQXNCO0VBQVM7RUFBVTtFQUFzQjtFQUFlO0VBQTBCO0VBQW1CO0VBQWdCO0VBQTZCO0VBQWtCO0VBQVM7RUFBYztFQUFtQjtFQUFhOzs7QUFBZTtFQUE4TTs7O0FBQXFCO0VBQXdDO0VBQWtCO0VBQU07RUFBTztFQUFXO0VBQVk7RUFBeUI7RUFBa0I7RUFBa0I7RUFBNkM7RUFBOEI7OztBQUFXO0VBQThHOzs7QUFBbUI7RUFBZ0M7RUFBa0I7RUFBTTtFQUFPO0VBQWM7RUFBVztFQUFZO0VBQWM7RUFBc0I7RUFBeUI7RUFBa0I7RUFBeUI7OztBQUFtQjtFQUFzQztFQUFrQjtFQUFRO0VBQVc7RUFBYztFQUFtQjtFQUFvQjtFQUFzQjtFQUFhO0VBQWM7RUFBc0Q7RUFBVTtFQUE2RDs7O0FBQVk7RUFBZ0M7RUFBa0I7RUFBTTtFQUFRO0VBQVM7RUFBTztFQUFVO0VBQVc7RUFBWTtFQUFlOzs7QUFBVTtFQUF3RTtFQUFrQjtFQUFjO0VBQXNCO0VBQWE7RUFBYztFQUFzRDtFQUFVO0VBQXFEOzs7QUFBWTtFQUFrRTtFQUF5Qjs7O0FBQXFCO0VBQW1DOzs7QUFBbUI7RUFBMEc7RUFBNkI7OztBQUFvQjtFQUFtRTtFQUFtQjs7O0FBQW9CO0VBQW1FO0VBQXlCOzs7QUFBK0I7RUFBeUU7RUFBcUI7RUFBeUI7OztBQUFvQjtFQUF3QztFQUFzQjs7O0FBQW1CO0VBQWdJOzs7QUFBa0I7RUFBa0M7RUFBc0I7RUFBUztFQUFVO0VBQXNCO0VBQWU7RUFBMEI7RUFBbUI7RUFBZ0I7RUFBNkI7RUFBb0I7RUFBcUI7RUFBa0I7OztBQUFlO0VBQXdDO0VBQXFCO0VBQVE7RUFBZ0I7OztBQUFjO0VBQTRFOzs7QUFBbUI7RUFBb0U7OztBQUFnQjtFQUFxRztFQUFXOzs7QUFBWTtFQUErQjtFQUFrQjs7O0FBQWlCO0VBQWdDO0VBQXNCO0VBQVM7RUFBVTtFQUFzQjtFQUFlO0VBQTBCO0VBQW1CO0VBQWdCO0VBQTZCOzs7QUFBcUI7RUFBcUM7OztBQUFpQjtFQUFnRDs7O0FBQWU7RUFBMEU7OztBQUFjO0VBQXdFO0VBQXNCOzs7QUFBcUI7RUFBOEU7RUFBUTtFQUFTO0VBQVU7RUFBVztFQUF5QjtFQUFTO0VBQXdDO0VBQVU7OztBQUFZO0VBQWdIO0VBQWlDOzs7QUFBNkI7RUFBMEI7OztBQUFnQjtFQUE4Qjs7O0FBQWM7RUFBMkM7OztBQUFnQjtFQUE2RDs7O0FBQW9CO0VBQTZIOzs7QUFBVTtFQUFpQjtFQUFzQjtFQUFTO0VBQVU7RUFBc0I7RUFBZTtFQUEwQjtFQUFtQjtFQUFnQjtFQUE2QjtFQUFnQjtFQUFrQjs7O0FBQWdDO0VBQTBFOzs7QUFBbUI7RUFBbUM7OztBQUF1QjtFQUErRTs7O0FBQW9CO0VBQXFIOzs7QUFBVTtFQUFrSDs7O0FBQWtCO0VBQXdIO0VBQWtCO0VBQU07RUFBUTtFQUFXO0VBQU87RUFBeUI7RUFBVTtFQUEwQztFQUE2QjtFQUE2QjtFQUFXOzs7QUFBb0I7RUFBMkM7RUFBYTtFQUF1QjtFQUFnQjs7O0FBQWE7RUFBMEY7RUFBc0I7OztBQUFtQjtFQUFnRzs7O0FBQXVCO0VBQXdGOzs7QUFBbUI7RUFBdUk7RUFBYzs7O0FBQWdCO0VBQXFGO0VBQVc7RUFBaUI7RUFBa0I7RUFBbUI7RUFBVzs7O0FBQXVCO0VBQXFIOzs7QUFBWTtFQUF1SDs7O0FBQWtCO0VBQXdCO0VBQW1CO0VBQW1CO0VBQXlCO0VBQXNCO0VBQXFCOzs7QUFBaUI7RUFBNkI7RUFBcUI7OztBQUFXO0VBQWdDOzs7QUFBa0I7RUFBMEI7RUFBa0I7RUFBVTtFQUFtQjtFQUFXO0VBQVM7RUFBaUI7RUFBa0I7RUFBZTtFQUF5QjtFQUFzQjtFQUFxQjs7O0FBQWlCO0VBQTJHO0VBQXFCO0VBQWU7OztBQUF3QjtFQUFtSDs7O0FBQXlCO0VBQStCOzs7QUFBZTtFQUFtRTs7O0FBQXlCO0VBQXVDOzs7QUFBYztFQUFvQztFQUFrQjtFQUFVO0VBQXFCO0VBQVc7OztBQUFZO0VBQTJDO0VBQWtCO0VBQU07RUFBVztFQUFZO0VBQWlCO0VBQStCOzs7QUFBWTtFQUEwQztFQUFrQjtFQUFXO0VBQVk7RUFBZ0M7OztBQUFZO0VBQTBCO0VBQVM7OztBQUFtQjtFQUF1RDtFQUFrQjtFQUFhO0VBQWdCO0VBQVM7RUFBYztFQUFjO0VBQWlCO0VBQXVCO0VBQWtCO0VBQWU7OztBQUEwRDtFQUE2RDs7O0FBQXlCO0VBQXFGOzs7QUFBeUI7RUFBZ0Y7RUFBcUI7RUFBVztFQUFZO0VBQWlCO0VBQWtCOzs7QUFBbUI7RUFBc0Y7OztBQUFhO0VBQTBFOzs7QUFBNkI7RUFBc0M7RUFBaUI7RUFBeUI7RUFBc0I7RUFBcUI7OztBQUFpQjtFQUErRDtFQUFrQjtFQUFVO0VBQVc7RUFBeUI7RUFBa0I7OztBQUFvQjtFQUFxRTtFQUFrQjtFQUFTO0VBQVU7RUFBVTtFQUFXO0VBQTZCO0VBQXlCO0VBQWtCOzs7QUFBVztFQUFzRTs7O0FBQTZCO0VBQXdEO0VBQWtCOzs7QUFBWTtFQUErRDtFQUFrQjtFQUFNO0VBQVc7RUFBWTtFQUErQjs7O0FBQVc7RUFBbUU7OztBQUFhO0VBQXFEOzs7QUFBZ0I7RUFBK0Q7OztBQUFzQjtFQUFnRztFQUFtQjtFQUFzQjs7O0FBQXNCO0VBQWtIOzs7QUFBd0I7RUFBc0Y7OztBQUFxQjtFQUE2QjtJQUFHO0lBQW1COztFQUFXO0lBQUc7SUFBcUI7OztBQUFXO0VBQXVDO0lBQUc7O0VBQVU7SUFBRzs7O0FBQVc7RUFBZ0Q7OztBQUFrQjtFQUF1RDtFQUFrQjtFQUFNO0VBQVE7RUFBVztFQUFPO0VBQWdDO0VBQVc7OztBQUFvQjtFQUE2RDs7O0FBQW1CO0VBQWtEOzs7QUFBVTtFQUFtRTs7O0FBQXFCO0VBQStFO0VBQWdCO0VBQXlCO0VBQXNCO0VBQXFCOzs7QUFBaUI7RUFBcUY7OztBQUF1QjtFQUFzRztFQUFXOzs7QUFBdUI7RUFBc0k7OztBQUFtQjtFQUE0RTs7O0FBQVc7RUFBd0Y7RUFBVzs7O0FBQXVCO0VBQW1CO0VBQXNCO0VBQVM7RUFBVTtFQUFzQjtFQUFlO0VBQTBCO0VBQW1CO0VBQWdCO0VBQTZCO0VBQWtCO0VBQVM7RUFBYztFQUFtQjtFQUFhOzs7QUFBZTtFQUFvSzs7O0FBQXFCO0VBQWlDO0VBQWtCO0VBQU07RUFBTztFQUFXO0VBQVk7RUFBeUI7RUFBa0I7RUFBa0I7RUFBNkM7RUFBOEI7OztBQUFXO0VBQXlGOzs7QUFBbUI7RUFBeUI7RUFBa0I7RUFBTTtFQUFPO0VBQWM7RUFBVztFQUFZO0VBQWM7RUFBc0I7RUFBeUI7RUFBa0I7RUFBeUI7OztBQUFtQjtFQUErQjtFQUFrQjtFQUFRO0VBQVc7RUFBYztFQUFtQjtFQUFvQjtFQUFzQjtFQUFhO0VBQWM7RUFBc0Q7RUFBVTtFQUE2RDs7O0FBQVk7RUFBeUI7RUFBa0I7RUFBTTtFQUFRO0VBQVM7RUFBTztFQUFVO0VBQVc7RUFBWTtFQUFlOzs7QUFBVTtFQUEwRDtFQUFrQjtFQUFjO0VBQXNCO0VBQWE7RUFBYztFQUFzRDtFQUFVO0VBQXFEOzs7QUFBWTtFQUFvRDtFQUF5Qjs7O0FBQXFCO0VBQTRCOzs7QUFBbUI7RUFBcUY7RUFBNkI7OztBQUFvQjtFQUFxRDtFQUFtQjs7O0FBQW9CO0VBQXFEO0VBQXlCOzs7QUFBK0I7RUFBMkQ7RUFBcUI7RUFBeUI7OztBQUFvQjtFQUFpQztFQUFzQjs7O0FBQW1CO0VBQTJHOzs7QUFBa0I7RUFBMkI7RUFBc0I7RUFBUztFQUFVO0VBQXNCO0VBQWU7RUFBMEI7RUFBbUI7RUFBZ0I7RUFBNkI7RUFBb0I7RUFBcUI7RUFBa0I7OztBQUFlO0VBQWlDO0VBQXFCO0VBQVE7RUFBZ0I7OztBQUFjO0VBQThEOzs7QUFBbUI7RUFBc0Q7OztBQUFnQjtFQUF1RjtFQUFXOzs7QUFBWTtFQUF3QjtFQUFrQjs7O0FBQWlCO0VBQXlCO0VBQXNCO0VBQVM7RUFBVTtFQUFzQjtFQUFlO0VBQTBCO0VBQW1CO0VBQWdCO0VBQTZCOzs7QUFBcUI7RUFBOEI7OztBQUFpQjtFQUF5Qzs7O0FBQWU7RUFBNEQ7OztBQUFjO0VBQTBEO0VBQXNCOzs7QUFBcUI7RUFBZ0U7RUFBUTtFQUFTO0VBQVU7RUFBVztFQUF5QjtFQUFTO0VBQXdDO0VBQVU7OztBQUFZO0VBQTJGO0VBQWlDOzs7QUFBNkI7RUFBVTtFQUFzQjtFQUFTO0VBQVU7RUFBc0I7RUFBZTtFQUEwQjtFQUFtQjtFQUFnQjtFQUE2QjtFQUFnQjtFQUFrQjs7O0FBQWdDO0VBQTREOzs7QUFBbUI7RUFBNEI7OztBQUF1QjtFQUEwRDs7O0FBQW9CO0VBQXlGOzs7QUFBVTtFQUFzRjs7O0FBQWtCO0VBQTRGO0VBQWtCO0VBQU07RUFBUTtFQUFXO0VBQU87RUFBeUI7RUFBVTtFQUEwQztFQUE2QjtFQUE2QjtFQUFXOzs7QUFBb0I7RUFBNkI7RUFBYTtFQUF1QjtFQUFnQjs7O0FBQWE7RUFBcUU7RUFBc0I7OztBQUFtQjtFQUEyRTs7O0FBQXVCO0VBQW1FOzs7QUFBbUI7RUFBb0c7RUFBYzs7O0FBQWdCO0VBQWdFO0VBQVc7RUFBaUI7RUFBa0I7RUFBbUI7RUFBVzs7O0FBQXVCO0VBQXlGOzs7QUFBWTtFQUEyRjs7O0FBQWtCO0VBQWlCO0VBQW1CO0VBQW1CO0VBQXlCO0VBQXNCO0VBQXFCOzs7QUFBaUI7RUFBc0I7RUFBcUI7OztBQUFXO0VBQXlCOzs7QUFBa0I7RUFBbUI7RUFBa0I7RUFBVTtFQUFtQjtFQUFXO0VBQVM7RUFBaUI7RUFBa0I7RUFBZTtFQUF5QjtFQUFzQjtFQUFxQjs7O0FBQWlCO0VBQTZGO0VBQXFCO0VBQWU7OztBQUF3QjtFQUFxRzs7O0FBQXlCO0VBQXdCOzs7QUFBZTtFQUFxRDs7O0FBQXlCO0VBQWdDOzs7QUFBYztFQUE2QjtFQUFrQjtFQUFVO0VBQXFCO0VBQVc7OztBQUFZO0VBQW9DO0VBQWtCO0VBQU07RUFBVztFQUFZO0VBQWlCO0VBQStCOzs7QUFBWTtFQUFtQztFQUFrQjtFQUFXO0VBQVk7RUFBZ0M7OztBQUFZO0VBQW1CO0VBQVM7OztBQUFtQjtFQUF5QztFQUFrQjtFQUFhO0VBQWdCO0VBQVM7RUFBYztFQUFjO0VBQWlCO0VBQXVCO0VBQWtCO0VBQWU7OztBQUEwRDtFQUErQzs7O0FBQXlCO0VBQWdFOzs7QUFBeUI7RUFBMkQ7RUFBcUI7RUFBVztFQUFZO0VBQWlCO0VBQWtCOzs7QUFBbUI7RUFBaUU7OztBQUFhO0VBQTREOzs7QUFBNkI7RUFBK0I7RUFBaUI7RUFBeUI7RUFBc0I7RUFBcUI7OztBQUFpQjtFQUF3RDtFQUFrQjtFQUFVO0VBQVc7RUFBeUI7RUFBa0I7OztBQUFvQjtFQUE4RDtFQUFrQjtFQUFTO0VBQVU7RUFBVTtFQUFXO0VBQTZCO0VBQXlCO0VBQWtCOzs7QUFBVztFQUF3RDs7O0FBQTZCO0VBQTBDO0VBQWtCOzs7QUFBWTtFQUFpRDtFQUFrQjtFQUFNO0VBQVc7RUFBWTtFQUErQjs7O0FBQVc7RUFBcUQ7OztBQUFhO0VBQXVDOzs7QUFBZ0I7RUFBaUQ7OztBQUFzQjtFQUEyRTtFQUFtQjtFQUFzQjs7O0FBQXNCO0VBQWM7OztBQUFjO0VBQTRGO0VBQVc7OztBQUFXO0VBQWlDOzs7QUFBYztFQUFtRTs7O0FBQXdCO0VBQThEO0VBQVc7RUFBVztFQUFrQjs7O0FBQThCO0VBQXlGOzs7QUFBbUI7RUFBZ0I7RUFBc0I7OztBQUFzQjtFQUF5Qzs7O0FBQXNCO0VBQXVDOzs7QUFBYztFQUF1Qzs7O0FBQWM7RUFBc0M7OztBQUFjO0VBQTJGOzs7QUFBYztFQUE2Qzs7O0FBQWM7RUFBd0M7RUFBc0I7RUFBbUI7RUFBeUI7RUFBc0I7RUFBcUI7OztBQUFpQjtFQUFxQzs7O0FBQWtCO0VBQTBGO0VBQW1CO0VBQXNCO0VBQWdCO0VBQWU7OztBQUFpQjtFQUEwRjtFQUFtQjtFQUFzQjtFQUFnQjtFQUFlOzs7QUFBaUI7RUFBMEY7RUFBbUI7RUFBc0I7RUFBZ0I7RUFBZTs7O0FBQWlCO0VBQTBGO0VBQW1CO0VBQXNCO0VBQWdCO0VBQWU7OztBQUFnQjtFQUEwRjtFQUFtQjtFQUFzQjtFQUFnQjtFQUFlOzs7QUFBZ0I7RUFBd29DOzs7QUFBaUI7RUFBdUQ7RUFBcUI7OztBQUFlO0VBQW1DO0VBQWM7RUFBYTtFQUFlO0VBQXFCOzs7QUFBcUI7RUFBOEc7OztBQUFjO0VBQWlEOzs7QUFBYztFQUFnRzs7O0FBQXFCO0VBQTBJO0VBQXNCOzs7QUFBbUI7RUFBd1U7OztBQUFzQjtFQUFzSzs7O0FBQW9CO0VBQXFCO0VBQWM7RUFBdUI7RUFBYztFQUErQjtFQUFxQzs7O0FBQWtCO0VBQW9CO0VBQWM7RUFBd0I7RUFBYztFQUFnQztFQUFpQztFQUF5Qjs7O0FBQWtCO0VBQXFCO0VBQVU7OztBQUF5QjtFQUFzQztFQUEwQjtFQUFpQzs7O0FBQThCO0VBQXNDOzs7QUFBNkI7RUFBdUI7OztBQUFnQjtFQUFpRTtFQUFjO0VBQWE7RUFBZTtFQUFxQjs7O0FBQWdCO0VBQThMOzs7QUFBYztFQUFzRjs7O0FBQWM7RUFBbUc7OztBQUFjO0VBQTZCOzs7QUFBa0I7RUFBZ0M7RUFBVztFQUFnQjs7O0FBQThCO0VBQXFDO0VBQWtCO0VBQVc7RUFBVztFQUFzQjtFQUFnQjtFQUFlO0VBQWtCOzs7QUFBb0I7RUFBc0M7RUFBVztFQUFtQjs7O0FBQXFCO0VBQXNDO0VBQWU7OztBQUFVO0VBQTRDO0VBQWtCOzs7QUFBa0I7RUFBbUI7OztBQUF1QjtFQUFzQjs7O0FBQXFCO0VBQW1COzs7QUFBd0I7RUFBK0M7OztBQUFhO0VBQW9CO0VBQWtCO0VBQXFCO0VBQXFCO0VBQStCO0VBQXFDOzs7QUFBa0I7RUFBeUI7RUFBZTtFQUFTO0VBQVU7RUFBa0I7RUFBb0I7RUFBdUI7OztBQUFTO0VBQTJCO0VBQW1CO0VBQTBDOzs7QUFBWTtFQUE0Qjs7O0FBQW1CO0VBQXFDO0VBQWdCOzs7QUFBdUI7RUFBK0U7OztBQUFzQjtFQUF1QztFQUFvQjtFQUFnQjtBQUMveWxoQjtFQUFnQzs7O0FBQTRCO0VBQW9COzs7QUFBYztFQUE2SDtFQUFpQjs7O0FBQWM7RUFBMkM7OztBQUFXO0VBQW1EO0VBQVk7OztBQUFVO0VBQXlEO0VBQVc7OztBQUFVO0VBQWtGO0VBQWtCOzs7QUFBa0I7RUFBWTtFQUFzQjtFQUFTO0VBQVU7RUFBc0I7RUFBZTtFQUEwQjtFQUFtQjtFQUFnQjtFQUE2Qjs7O0FBQVU7RUFBYzs7O0FBQVM7RUFBZ0I7RUFBYztFQUFXOzs7QUFBYTtFQUE2Qjs7O0FBQWU7RUFBOEI7OztBQUFxQjtFQUFnQztFQUFzQjs7O0FBQW1CO0VBQTJDO0VBQVk7RUFBYTtFQUFpQjtFQUFrQjtFQUFrQjtFQUFtQjtFQUF5QjtFQUEwQjtFQUFrQjtFQUFlOzs7QUFBNEI7RUFBdUQ7RUFBYTtFQUFtQjtFQUF1QjtFQUFZOzs7QUFBa0I7RUFBaUQ7OztBQUFxQjtFQUFxRTs7O0FBQXFCO0VBQTRCO0VBQWtCO0VBQVc7RUFBWTtFQUFrQjtFQUFtQjtFQUEwQjtFQUFrQjtFQUFlOzs7QUFBNEI7RUFBd0M7OztBQUFlO0VBQTRFOzs7QUFBcUI7RUFBZ0Q7OztBQUFtQjtFQUE0QztFQUFjOzs7QUFBWTtFQUF1RDtFQUFtQjs7O0FBQXNCO0VBQTREOzs7QUFBcUI7RUFBbUQ7OztBQUFtQjtFQUE0RDtFQUFjOzs7QUFBZTtFQUE4QztFQUFlO0VBQXNCOzs7QUFBZTtFQUE4QztFQUFzQjs7O0FBQWU7RUFBMEM7RUFBc0I7RUFBZTs7O0FBQW1CO0VBQWdHOzs7QUFBc0I7RUFBaUM7RUFBcUI7OztBQUFXO0VBQXdDO0VBQWM7OztBQUFXO0VBQXVDO0VBQWM7RUFBVzs7O0FBQVc7RUFBaUI7RUFBc0I7RUFBUztFQUFVO0VBQXNCO0VBQWU7RUFBMEI7RUFBZ0I7RUFBNkI7OztBQUFtQjtFQUErQztFQUFjOzs7QUFBVztFQUF1Qjs7O0FBQVc7RUFBc0I7RUFBa0I7RUFBZ0I7RUFBZTs7O0FBQWU7RUFBMkI7RUFBcUI7RUFBVztFQUFrQjtFQUFnQjtFQUFtQjtFQUFtQjs7O0FBQXVCO0VBQW1DO0VBQWtCOzs7QUFBUTtFQUF1Qzs7O0FBQVU7RUFBa0Q7RUFBZ0I7RUFBYzs7O0FBQW1CO0VBQTJDO0VBQVM7OztBQUFjO0VBQStIOzs7QUFBVTtFQUE0QztFQUFzQjs7O0FBQW1CO0VBQWtEOzs7QUFBc0I7RUFBMkI7RUFBWTs7O0FBQWdDO0VBQWdDO0VBQWM7RUFBVzs7O0FBQVk7RUFBK0c7RUFBa0I7RUFBUTtFQUFzQjs7O0FBQWU7RUFBdUQ7OztBQUF5QjtFQUFtRTs7O0FBQVU7RUFBc047OztBQUFjO0VBQW1FOzs7QUFBVTtFQUErQjtFQUFrQjtFQUFhO0VBQVc7RUFBa0I7RUFBZTs7O0FBQWM7RUFBbUc7RUFBa0I7RUFBWTtFQUFZO0VBQXlCOzs7QUFBa0I7RUFBK0c7OztBQUF1QjtFQUErRzs7O0FBQXFCO0VBQXFLOzs7QUFBdUI7RUFBdUg7OztBQUFvQjtFQUF1SDtFQUFXO0VBQVk7RUFBaUI7RUFBa0I7OztBQUFXO0VBQXlJOzs7QUFBZTtFQUFtUDs7O0FBQWE7RUFBbVA7OztBQUFhO0VBQTZHO0VBQWtCO0VBQVE7RUFBUztFQUFlOzs7QUFBK0I7RUFBK0g7OztBQUFlO0VBQStHOzs7QUFBZTtFQUErSDtFQUFjO0VBQVc7RUFBWTs7O0FBQWdCO0VBQTZHO0VBQXFCO0VBQXNCO0VBQWU7RUFBaUI7RUFBa0I7RUFBa0I7RUFBZ0I7RUFBaUI7RUFBbUI7RUFBdUI7OztBQUFtQjtFQUE2Szs7O0FBQW1CO0VBQXFIO0VBQVk7RUFBd0I7RUFBYTs7O0FBQWtCO0VBQXdDO0VBQXFCO0VBQVk7RUFBYTtFQUFtQjs7O0FBQW1CO0VBQW9EO0VBQVk7OztBQUFTO0VBQXlEO0VBQWtCO0VBQVk7OztBQUFnQjtFQUFnRTtFQUFrQjtFQUFVO0VBQVc7RUFBWTtFQUFnQztFQUFVO0VBQW1COzs7QUFBWTtFQUE0Rjs7O0FBQVU7RUFBNEQ7RUFBa0I7RUFBUTtFQUFTO0VBQVc7RUFBbUI7RUFBK0I7RUFBVTs7O0FBQW1CO0VBQW1PO0VBQVc7RUFBVztFQUFhO0VBQTBCO0VBQWU7RUFBZTs7O0FBQW1CO0VBQXFQOzs7QUFBVztFQUErSjs7O0FBQVU7RUFBZ0k7RUFBZ0I7RUFBYztFQUFXO0VBQVk7RUFBc0I7OztBQUFtQjtFQUF5RDtFQUFhO0VBQWU7RUFBVTtFQUFtQjs7O0FBQWtCO0VBQW9GO0VBQWtCO0VBQVk7OztBQUFjO0VBQW1GOzs7QUFBeUI7RUFBeUY7OztBQUFZO0VBQStTOzs7QUFBYTtFQUE2RDtFQUFZO0VBQXdCOzs7QUFBZTtFQUFtRTs7O0FBQWtDO0VBQWlGO0VBQWM7RUFBUTtFQUFTOzs7QUFBVztFQUFxRztFQUFjOzs7QUFBVTtFQUFpRjtFQUFhOzs7QUFBbUI7RUFBcUY7OztBQUFVO0VBQXFHO0VBQVU7RUFBUzs7O0FBQWM7RUFBMEs7OztBQUFnQjtFQUF1SjtFQUF1QjtFQUF3RDs7O0FBQTZCO0VBQXFHOzs7QUFBcUM7RUFBa0Q7OztBQUFzQztFQUFpQztJQUFHO0lBQVE7SUFBUztJQUFTO0lBQVU7OztBQUFXO0VBQWtDO0lBQUc7SUFBUTtJQUFTO0lBQVM7SUFBVTs7O0FBQVc7RUFBZ0I7OztBQUFjO0VBQTBEO0VBQWtCOzs7QUFBZ0I7RUFBcUI7OztBQUFjO0VBQXdHO0VBQW1COzs7QUFBa0I7RUFBd0c7RUFBbUI7OztBQUFrQjtFQUFnRDtFQUFtQjs7O0FBQWU7RUFBNkQ7OztBQUFrQjtFQUF3RDtFQUFXOzs7QUFBTztFQUFpRTtFQUFnQjs7O0FBQWlCO0VBQWdEOzs7QUFBcUI7RUFBNkY7RUFBZ0I7OztBQUFpQjtFQUFvRDtFQUFtQjs7O0FBQWU7RUFBNkc7OztBQUFVO0VBQStKO0VBQVU7OztBQUFVO0VBQXFKO0VBQVU7RUFBVTs7O0FBQThCO0VBQXFKO0VBQWlCO0VBQW1COzs7QUFBaUI7RUFBK0s7RUFBbUI7OztBQUFrQjtFQUErSztFQUFtQjs7O0FBQWtCO0VBQTZKO0VBQWdCOzs7QUFBZTtFQUE2RDs7O0FBQW1CO0VBQWdGO0VBQVU7RUFBVTs7O0FBQThCO0VBQXdHO0VBQWU7Ozs7QUNDNzljO0FBQUE7QUFBQTtFQUdFOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQSxrQkNYVztFRFlYO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOzs7QUFHRjtBQUVBOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBOztBQUFBO0FBaUJJO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUxGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUtOO0FBR0U7RUFDRTs7O0FBRUY7RUFDRTs7O0FBSkY7RUFDRTs7O0FBRUY7RUFDRTs7O0FBSkY7RUFDRTs7O0FBRUY7RUFDRTs7O0FBSkY7RUFDRTs7O0FBRUY7RUFDRTs7O0FBSkY7RUFDRTs7O0FBRUY7RUFDRTs7O0FBSkY7RUFDRTs7O0FBRUY7RUFDRTs7O0FBSkY7RUFDRTs7O0FBRUY7RUFDRTs7O0FBSkY7RUFDRTs7O0FBRUY7RUFDRTs7O0FBSkY7RUFDRTs7O0FBRUY7RUFDRTs7O0FBSkY7RUFDRTs7O0FBRUY7RUFDRTs7O0FBSkY7RUFDRTs7O0FBRUY7RUFDRTs7O0FBSkY7RUFDRTs7O0FBRUY7RUFDRTs7O0FBSUo7QUFNQTtFQUNFOzs7QUU3RUE7RUFDRTtFQUNBOztBQUNBO0VBQ0U7RUFDQTs7QUFDQTtFQUNFO0VBQ0E7RUFDQTs7QUFHRjtFQUNFO0VBQ0E7O0FBQ0E7RUFDRTtFQUNBLGFEdUJLO0VDdEJMLFdEMkNJO0VDMUNKOztBQUlOO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7O0FBQ0E7RUFDRTtFQUNBO0VBQ0E7RUFDQSxPRHpCQTtFQzBCQSxhRE9PO0VDTlAsV0QyQk07RUMxQk47RUFDQTs7QUFFRjtFQUNFO0VBQ0E7RUFDQTtFQUVBLE9EcENBO0VDcUNBLGFESk87RUNLUDtFQUNBO0VBQ0E7O0FBS047RUFDRSxPRDdDSTtFQzhDSjtFQUNBLFdEVlU7RUNXVjs7O0FBc0NKO0VBQ0U7O0FBQ0E7RUFDRTtFQUNBOztBQUVGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7OztBQUlKO0VBQ0U7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRSxrQkR2SE07RUN3SE47O0FBQ0E7RUFDRTtFQUNBLGFEeEZPO0VDeUZQLFdEdEZVO0VDdUZWO0VBQ0E7RUFDQTs7QUFHRjtFQUNFO0VBQ0EsYURqR087RUNrR1A7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFRjtFQUNFOztBQUdGO0VBQ0U7RUFDQSxhRDlHTztFQytHUCxXRDVHVTtFQzZHVjtFQUNBO0VBQ0E7O0FBSUE7RUFDRTs7QUFFQTtFQUNFOztBQUdGO0VBQ0U7OztBQU1SO0VBQ0U7O0FBQ0E7RUFDRTtFQUNBOztBQUNBO0VBQ0U7RUFDQSxhRDdJUztFQzhJVCxXRHpIUTtFQzBIUjtFQUNBO0VBQ0E7O0FBRUY7RUFDRTtFQUNBLGFEckpTO0VDc0pULFdEaklRO0VDa0lSO0VBQ0E7O0FBRUY7RUFDRTtFQUNBLGFENUpTO0VDNkpULFdEeElRO0VDeUlSO0VBQ0E7OztBQUtOO0FBQUE7RUFFRTtFQUNBO0VBQ0E7RUFDQTtFQUNBLGFEeEtTO0VDeUtULFdEdEtZO0VDdUtaO0VBQ0E7RUFDQTtFQUNBOztBQUNBO0FBQUE7QUFBQTtFQUVFO0VBQ0E7RUFDQTs7QUFFRjtBQUFBO0VBQ0U7OztBQUlKO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7O0FBQ0E7RUFDRTs7QUFFRjtFQUNFO0VBQ0E7OztBQ2xQSjtFQUNFO0VBQ0E7RUFDQTs7O0FBSUE7RUFDRTtFQUNBOztBQUVGO0VBQ0U7O0FBR0Y7RUFDRTs7QUFDQTtFQUNFLE9Ga0JTO0VFakJULGFGc0JTO0VFckJULFdGMENRO0VFekNSO0VBQ0E7O0FBRUY7RUFDRTtFQUNBLGFGZVM7RUVkVCxXRm1CUTtFRWxCUjtFQUNBOztBQUNBO0VBQ0U7O0FBR0o7RUFDRTtFQUNBLGFGS1M7RUVKVCxXRlNRO0VFUlI7RUFDQTtFQUNBOztBQUNBO0VBQ0UsT0ZpQlU7RUVoQlY7O0FBR0o7RUFDRSxPRlhTO0VFWVQsYUZQUztFRVFULFdGSFE7RUVJUjtFQUNBO0VBQ0E7RUFDQTs7QUFFRjtFQUNFO0VBQ0EsYUZkSztFRWVMLFdGSVE7RUVIUjtFQUNBOztBQUVGO0VBQ0U7O0FBRUY7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7QUFFRjtFQUNFOztBQUNBO0VBQ0U7RUFDQTs7QUFHSjtFQUNFOztBQUVGO0VBQ0U7O0FBQ0E7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBLE9GbkZBO0VFb0ZBLGFGakRHO0VFa0RILFdGL0NNO0VFZ0ROO0VBQ0E7RUFDQTtFQUNBOztBQUNBO0VBQ0U7O0FBTU47RUFDRTtFQUNBOztBQUVGO0VBQ0UsY0ZyR0U7O0FFdUdKO0VBQ0U7RUFDQSxrQkZ6R0U7O0FFNkdOO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7O0FBR0Y7RUFDRTtFQUNBOztBQUdGO0VBQ0U7O0FBR0Y7RUFDRSxZRi9ISTtFRWdJSjtFQUNBOztBQUVFO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUY7RUFDRSxPRjdGVTs7QUU4RlY7RUFDRTs7QUFDQTtFQUNFO0VBQ0E7RUFDQTs7QUFLSjtFQUNFOztBQUlGO0VBQ0U7RUFDQTs7QUFLRjtFQUNFLGNGdktGOztBRTJLSjtFQUNFO0VBQ0EsYUY3SVM7RUU4SVQ7RUFDQTtFQUNBO0VBQ0E7O0FBSUo7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFDQTtFQUNFOztBQUlKO0VBQ0U7RUFDQTs7QUFNTTtFQUNFO0VBQ0E7O0FBQ0E7RUFFRTs7QUFFRjtFQUNFOztBQUVGO0VBQ0U7O0FBRUY7RUFDRTs7QUFFRjtFQUNFOztBQUVGO0VBQ0U7O0FBT0o7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBQ0E7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7QUFFRjtFQUNFOztBQUNBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQWNSO0VBQ0U7O0FBRUE7RUFDRTs7QUFLRTtFQUNFOztBQUdGO0VBQ0U7OztBQVVoQjtFQUNFOztBQUNBO0VBQ0UsT0Z4U0k7RUV5U0o7O0FBRUY7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7O0FBSUo7RUFDRTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQSxhRnBTUztFRXFTVCxXRmxSWTtFRW1SWjtFQUNBOztBQUNBO0VBQ0U7O0FBRUY7RUFDRSxrQkY1UmM7RUU2UmQ7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFRjtBQUFBO0FBQUE7RUFHRSxjRnRTYzs7QUV3U2hCO0FBQUE7RUFFRSxjRjFTYzs7QUU0U2hCO0VBQ0U7RUFDQTs7QUFFRjtFQUNFO0VBQ0E7RUFDQSxjRm5UYzs7O0FFdVRsQjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0EsYUYvVVM7RUVnVlQsV0Y3VVk7RUU4VVo7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBQ0E7RUFDRTs7O0FBSUo7RUFDRSxZRjlVZ0I7RUUrVWhCOztBQUVBO0VBQ0U7RUFDQSxrQkZ0WUk7RUV1WUosT0ZwVmM7O0FFcVZkO0VBQ0UsTUZ0Vlk7O0FFMFZoQjtFQUVFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBQ0E7RUFDRTs7O0FBTUo7RUFDRSxZRnpXYztFRTBXZCxPRjdaSTtFRThaSjs7QUFFQTtFQUNFO0VBQ0Esa0JGbGFFO0VFbWFGLE9GaFhZOztBRWlYWjtFQUNFLE1GbFhVOztBRXVYaEI7RUFDRTtFQUNBLE9GN1pTOztBRStaVDtFQUNFLGtCRmhhTztFRWlhUCxPRmhiRTs7QUVpYkY7RUFDRSxNRmxiQTs7O0FFd2JSO0FBQUE7RUFFRTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUNBO0FBQUE7RUFDRTs7O0FBR0o7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBLE9GeFpnQjtFRXlaaEIsYUYzYWE7RUU0YWIsV0Z2YVk7RUV3YVo7RUFDQTtFQUNBOztBQUNBO0VBQ0Usa0JGL1pjO0VFZ2FkLE9GbmRJOztBRW9kSjtFQUNFLE1GcmRFOztBRXdkTjtFQUNFOzs7QUFLRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBLE9GbGJjO0VFbWJkLGFGcmNXO0VFc2NYLFdGamNVO0VFa2NWO0VBQ0E7O0FBRUE7RUFDRTs7QUFFRjtFQUNFOztBQUdGO0VBQ0Usa0JGaGNZO0VFaWNaLE9GcGZFOztBRXFmRjtFQUNFLE1GdGZBOztBRXlmSjtFQUNFOzs7QUFLTjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0EsT0Z2Z0JNO0VFd2dCTixhRnZlYTtFRXdlYixXRm5lWTtFRW9lWjtFQUNBO0VBQ0E7O0FBQ0E7RUFDRTs7O0FBSUo7RUFDRTs7O0FBR0Y7RUFDRTs7O0FDL2hCRjtFQUNFOztBQUVBO0VBQ0U7RUFDQTtFQUNBOztBQUdGO0VBQ0UsT0hnRFk7RUcvQ1osYUg4Q1M7RUc3Q1QsV0hrRFU7RUdqRFY7RUFDQTs7QUFHRjtFQUNFLE9IMENVO0VHekNWLGFIc0NTO0VHckNULFdIMENVO0VHekNWO0VBQ0E7O0FBRUY7RUFDRSxPSG1DVTs7QUdoQ1o7RUFDRTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTtFQUNBO0VBQ0E7O0FBRUY7RUFDRTtFQUNBOztBQUVGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUVGO0VBQ0U7RUFDQTtFQUNBOztBQUdBO0VBQ0U7O0FBRUY7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7QUFJSjtFQUNFO0VBQ0E7O0FBQ0E7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFRjtFQUNFLE9IdkJNOztBRzBCVjtFQUNFO0VBQ0E7RUFDQTs7QUFDQTtFQUNFO0VBQ0E7O0FBQ0E7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUNBO0FBQUE7RUFFRTs7O0FDbkdSO0VBQ0UsY0p3RFk7RUl2RFo7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBSUE7RUFDRTs7QUFLTjtFQUNFLE9KWkk7RUlhSixhSm1CVztFSWxCWDtFQUNBO0VBQ0E7O0FBR0Y7RUFDRTs7QUFJQTtFQUNFO0VBQ0E7O0FBR0Y7RUFDRTs7O0FDdkNOO0VBQ0U7O0FBRUE7RUFDRTtFQUNBOztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFHRjtBQUFBO0FBQUE7QUFBQTtFQUlFLGFMU1c7RUtSWDtFQUNBO0VBQ0E7RUFDQTs7QUFFRjtFQUNFOztBQUVGO0VBQ0UsV0xvQlU7RUtuQlY7O0FBRUY7RUFDRTtFQUNBOztBQUVGO0VBQ0U7RUFDQTs7QUFHRjtFQUNFOztBQUVGO0VBQ0U7RUFDQTtFQUNBOztBQUNBO0VBQ0Usa0JMdERFO0VLdURGOztBQUVGO0VBQ0U7O0FBQ0E7RUFDRSxrQkw1REE7RUs2REE7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFJTjtFQUNFO0VBQ0E7O0FBQ0E7RUFDRTtFQUNBLGFMNUNTO0VLNkNUO0VBQ0E7RUFDQTtFQUNBOztBQUNBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFJTjtFQUNFOztBQUdJO0VBQ0U7RUFDQSxPTHJEWTtFS3NEWixhTHhFQztFS3lFRCxXTHRESTtFS3VESjtFQUNBO0VBQ0E7RUFDQTs7QUFDQTtFQUNFOztBQUdKO0VBQ0U7RUFDQSxhTHRGSztFS3VGTDtFQUNBO0VBQ0E7O0FBTUY7RUFDRTtFQUNBO0VBQ0EsYUxoR0M7RUtpR0QsV0w5RUk7RUsrRUo7RUFDQTtFQUNBO0VBQ0E7O0FBR0E7RUFDRTs7QUFNVjtBQUFBO0FBQUE7RUFHRSxPTGhHa0I7RUtpR2xCLGFMckhXO0VLc0hYLFdMakdVO0VLa0dWO0VBQ0E7RUFDQTtFQUNBOztBQUNBO0FBQUE7QUFBQTtFQUNFO0VBQ0E7RUFDQTs7QUFNRTtFQUNFOztBQUdKO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFHQTtFQUNFOztBQU9BO0VBQ0U7O0FBQ0E7RUFDRTs7QUFRRjtFQUNFOztBQUlGO0VBQ0U7O0FBTVY7RUFDRTtFQUNBOzs7QUFJTjtFQUNFOzs7QUFFRjtFQUNFO0VBQ0E7OztBQUdBO0VBQ0U7O0FBRUY7RUFDRTtFQUNBLGFMbE1XO0VLbU1YO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQy9PRjtFQUNFOztBQUVGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUVGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUdBO0VBQ0U7O0FBQ0E7RUFDRTs7QUFLSjtFQUNFOztBQUVGO0VBQ0U7O0FBR0k7RUFDRTs7QUFDQTtFQUNFOztBQVFGO0VBQ0U7O0FBSUY7RUFDRTs7QUFHSjtFQUNFOztBQUNBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFDQTtFQUNFOztBQUdKO0VBQ0U7OztBQ3hFZDtFQUNFOzs7QUFJQTtFQUNFOzs7QUFJSjtFQUNFO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBOztBQUVBO0VBQ0U7O0FBR0Y7RUFDRTs7O0FBS0Y7RUFDRTtFQUNBO0VBQ0E7OztBQUtGO0VBQ0U7O0FBR0Y7RUFDRTs7O0FDM0NKO0VBQ0U7O0FBR0U7RUFDRTtFQUNBLGFSc0NJO0VRckNKO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUY7RUFDRTtFQUNBLGFSNkJJO0VRNUJKO0VBQ0E7RUFDQTtFQUNBOztBQUVGO0VBQ0U7RUFDQSxhUnFCSTtFUXBCSixXUnNCUTtFUXJCUjtFQUNBO0VBQ0E7O0FBRUY7RUFDRSxPUlBPO0VRUVAsYVJVUztFUVRULFdSY1E7RVFiUjtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUVGO0VBQ0U7O0FBRUY7RUFDRTtFQUNBLFdSRVE7O0FRQVY7RUFDRTs7QUFFRjtFQUNFOztBQUVGO0VBQ0U7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFHRjtFQUNFO0VBQ0E7RUFDQTs7QUFFRjtFQUNFO0VBQ0E7O0FBRUY7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUVGO0FBQUE7RUFFRTs7QUFFQTtBQUFBO0VBQ0U7O0FBR0o7RUFDRSxPUmhDWTtFUWlDWjs7QUFFRjtFQUNFO0VBQ0E7RUFDQTs7QUFDQTtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUVGO0VBQ0U7RUFDQSxXUi9DTTs7QVFpRFI7RUFDRTtFQUNBLGFSckVFO0VRc0VGLFdScEVNO0VRcUVOOztBQUNBO0VBQ0U7RUFDQTs7QUFJTjtFQUNFO0VBQ0E7RUFDQTtFQUNBOztBQUNBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUY7RUFDRTtFQUNBLFdSNUZNOztBUThGUjtFQUNFOztBQUVGO0VBQ0U7RUFDQSxhUnJHRTtFUXNHRixXUnBHTTtFUXFHTjs7QUFDQTtFQUNFO0VBQ0E7O0FBSU47RUFDRTtFQUNBO0VBQ0E7RUFDQTs7QUFDQTtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUVGO0VBQ0U7RUFDQSxXUjVITTs7QVE4SFI7RUFDRTs7QUFFRjtFQUNFO0VBQ0EsYVJySUU7RVFzSUYsV1JwSU07RVFxSU47O0FBQ0E7RUFDRTtFQUNBOztBQUtKO0VBQ0U7O0FBRUY7RUFDRTtFQUNBO0VBQ0EsV1JuSU07O0FRc0lWO0VBQ0U7RUFDQTs7QUFDQTtFQUNFOztBQUNBO0VBQ0U7O0FBS0o7RUFDRTtFQUNBOztBQUVFO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFRjtFQUNFLE9SdEtNOztBUXVLTjtFQUNFOztBQUNBO0VBQ0U7RUFDQTtFQUNBOztBQUtKO0VBQ0U7O0FBSUY7RUFDRTtFQUNBOztBQUtGO0VBQ0UsY1JoUE47O0FRc1BKO0VBQ0U7O0FBQ0E7RUFDRTs7QUFDQTtFQUNFOztBQUlOO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQUNFOztBQUdKO0VBQ0U7RUFDQTs7QUFFQTtFQUNFLFdSMU5NOztBUThOWjtFQUNFOztBQUNBO0VBQ0U7O0FBRUY7RUFDRTtFQUNBOztBQUNBO0VBQ0U7RUFDQTtFQUNBLE9SNU9VO0VRNk9WO0VBQ0E7O0FBRUY7RUFDRTtFQUNBLE9SbFBVO0VRbVBWLGFSbFFFO0VRbVFGLFdSalBNO0VRa1BOO0VBQ0E7O0FBSU47RUFDRTs7O0FDdFRKO0VBQ0U7O0FBRUE7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBR0Y7RUFDRTtFQUNBOztBQUVGO0VBQ0U7RUFDQTtFQUNBOztBQUVGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7O0FBQ0E7RUFDRTs7QUFHSjtFQUNFO0VBQ0EsYVRTVztFU1JYLFdUNkJVO0VTNUJWO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBR0E7RUFDRTtFQUNBOztBQUNBO0VBQ0U7RUFDQTs7QUFJTjtFQUNFLE9UMUNJO0VTMkNKLGFUWFc7RVNZWCxXVFBVO0VTUVY7RUFDQTs7QUFFRjtFQUNFLE9UakRJO0VTa0RKLGFUbEJXO0VTbUJYO0VBQ0E7RUFDQTs7QUFHQTtFQUNFO0VBQ0E7O0FBSUY7RUFDRTs7QUFFRjtFQUNFOztBQUlKO0VBQ0U7O0FBT007RUFDRTs7QUFHSjtFQUNFO0VBQ0E7RUFDQTs7O0FDOUZWO0VBQ0U7RUFDQTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTs7O0FDVEY7RUFDRTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7QUFBQTtFQUVFO0VBQ0E7OztBQUlKO0VBQ0U7RUFDQTs7QUFFQTtFQUNFO0VBQ0E7O0FBRUE7RUFDRTs7QUFLRjtFQUNFO0VBQ0E7O0FBRUY7RUFDRTs7QUFLRjtFQUNFOzs7QUFLTjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBOztBQUVBO0VBQ0U7RUFDQTs7O0FBSUo7RUFDRTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7O0FBRUE7RUFDRTs7O0FDN0VKO0VBQ0U7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFHRjtBQUFBO0VBRUU7RUFDQTtFQUNBO0VBQ0E7OztBQUdGO0FBQUE7RUFFRTtFQUNBO0VBQ0E7RUFDQTs7O0FBR0Y7QUFBQTtFQUVFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQUdGO0FBQUE7QUFBQTtBQUFBO0VBSUU7OztBQUVGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7OztBQUdGO0FBQUE7RUFFRTtFQUNBOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0UiLCJzb3VyY2VzQ29udGVudCI6WyJAaW1wb3J0IHVybCgnaHR0cHM6Ly9mb250cy5nb29nbGVhcGlzLmNvbS9jc3MyP2ZhbWlseT1PcGVuK1NhbnM6d2dodEAzMDA7NDAwOzYwMDs3MDA7ODAwJmRpc3BsYXk9c3dhcCcpO1xuQGltcG9ydCB1cmwoJ2h0dHBzOi8vZm9udHMuZ29vZ2xlYXBpcy5jb20vY3NzMj9mYW1pbHk9SUJNK1BsZXgrU2Fuczp3Z2h0QDMwMDs0MDA7NjAwJmRpc3BsYXk9c3dhcCcpO1xuXG4vLz09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT1cbi8vIC1IZWxwZXJzIFN0YXJ0XG4vLz09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT1cblxuQGltcG9ydCAnaGVscGVycy92YXJpYWJsZXMnO1xuQGltcG9ydCAnaGVscGVycy9taXhpbnMnO1xuXG4vLz09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT1cbi8vIC1IZWxwZXJzIEVuZFxuLy89PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09XG5cbi8vPT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PVxuLy8gLVBhcnRpYWxzIFN0YXJ0XG4vLz09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT1cblxuQGltcG9ydCAncGFydGlhbHMvZ2xvYmFsJztcblxuLy89PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09XG4vLyAtUGFydGlhbHMgRW5kXG4vLz09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT1cblxuLy89PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09XG4vLyAtY29tcG9uZW50cyBTdGFydFxuLy89PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09XG5cbkBpbXBvcnQgJ2NvbXBvbmVudHMvZGF0YS1pbXBvcnQnO1xuQGltcG9ydCAnY29tcG9uZW50cy9uZXctZGF0YS1pbXBvcnQnO1xuQGltcG9ydCAnY29tcG9uZW50cy9oZWFkZXInO1xuQGltcG9ydCAnY29tcG9uZW50cy9jaGVja2JveCc7XG5AaW1wb3J0ICdjb21wb25lbnRzL21hdGNoLWZpZWxkcyc7XG5AaW1wb3J0ICdjb21wb25lbnRzL2RlZmluZXNjb2RlJztcbkBpbXBvcnQgJ2NvbXBvbmVudHMvc2F2ZWltcG9ydHNldHRpbmdzJztcbkBpbXBvcnQgJ2NvbXBvbmVudHMvZHJhd2VyJztcbkBpbXBvcnQgJ2NvbXBvbmVudHMvbG9ncyc7XG5AaW1wb3J0ICdjb21wb25lbnRzL2Zvb3Rlcic7XG5AaW1wb3J0ICdjb21wb25lbnRzL3dpemFyZCc7XG4vLz09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT1cbi8vIC1jb21wb25lbnRzIEVuZFxuLy89PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09XG5cbi8vPT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PVxuLy8gLVBhZ2VzIFN0YXJ0XG4vLz09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT1cblxuLy89PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09XG4vLyAtUGFnZXMgRW5kXG4vLz09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT1cbiIsIi8qIVxuICogXG4gKiBhbnRkIHY0LjI0LjEwXG4gKiBcbiAqIENvcHlyaWdodCAyMDE1LXByZXNlbnQsIEFsaXBheSwgSW5jLlxuICogQWxsIHJpZ2h0cyByZXNlcnZlZC5cbiAqICAgICAgIFxuICovW2NsYXNzKj1hbnQtXTo6LW1zLWNsZWFyLFtjbGFzcyo9YW50LV0gaW5wdXQ6Oi1tcy1jbGVhcixbY2xhc3MqPWFudC1dIGlucHV0OjotbXMtcmV2ZWFsLFtjbGFzc149YW50LV06Oi1tcy1jbGVhcixbY2xhc3NePWFudC1dIGlucHV0OjotbXMtY2xlYXIsW2NsYXNzXj1hbnQtXSBpbnB1dDo6LW1zLXJldmVhbHtkaXNwbGF5Om5vbmV9Ym9keSxodG1se3dpZHRoOjEwMCU7aGVpZ2h0OjEwMCV9aW5wdXQ6Oi1tcy1jbGVhcixpbnB1dDo6LW1zLXJldmVhbHtkaXNwbGF5Om5vbmV9Kiw6YWZ0ZXIsOmJlZm9yZXtib3gtc2l6aW5nOmJvcmRlci1ib3h9aHRtbHtmb250LWZhbWlseTpzYW5zLXNlcmlmO2xpbmUtaGVpZ2h0OjEuMTU7LXdlYmtpdC10ZXh0LXNpemUtYWRqdXN0OjEwMCU7LW1zLXRleHQtc2l6ZS1hZGp1c3Q6MTAwJTstbXMtb3ZlcmZsb3ctc3R5bGU6c2Nyb2xsYmFyOy13ZWJraXQtdGFwLWhpZ2hsaWdodC1jb2xvcjpyZ2JhKDAsMCwwLDApfUAtbXMtdmlld3BvcnR7d2lkdGg6ZGV2aWNlLXdpZHRofWJvZHl7bWFyZ2luOjA7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtc2l6ZToxNHB4O2ZvbnQtZmFtaWx5Oi1hcHBsZS1zeXN0ZW0sQmxpbmtNYWNTeXN0ZW1Gb250LFNlZ29lIFVJLFJvYm90byxIZWx2ZXRpY2EgTmV1ZSxBcmlhbCxOb3RvIFNhbnMsc2Fucy1zZXJpZixBcHBsZSBDb2xvciBFbW9qaSxTZWdvZSBVSSBFbW9qaSxTZWdvZSBVSSBTeW1ib2wsTm90byBDb2xvciBFbW9qaTtmb250LXZhcmlhbnQ6dGFidWxhci1udW1zO2xpbmUtaGVpZ2h0OjEuNTcxNTtiYWNrZ3JvdW5kLWNvbG9yOiNmZmY7Zm9udC1mZWF0dXJlLXNldHRpbmdzOlwidG51bVwifVt0YWJpbmRleD1cIi0xXCJdOmZvY3Vze291dGxpbmU6bm9uZSFpbXBvcnRhbnR9aHJ7Ym94LXNpemluZzpjb250ZW50LWJveDtoZWlnaHQ6MDtvdmVyZmxvdzp2aXNpYmxlfWgxLGgyLGgzLGg0LGg1LGg2e21hcmdpbi10b3A6MDttYXJnaW4tYm90dG9tOi41ZW07Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtd2VpZ2h0OjUwMH1we21hcmdpbi10b3A6MDttYXJnaW4tYm90dG9tOjFlbX1hYmJyW2RhdGEtb3JpZ2luYWwtdGl0bGVdLGFiYnJbdGl0bGVde3RleHQtZGVjb3JhdGlvbjp1bmRlcmxpbmU7LXdlYmtpdC10ZXh0LWRlY29yYXRpb246dW5kZXJsaW5lIGRvdHRlZDt0ZXh0LWRlY29yYXRpb246dW5kZXJsaW5lIGRvdHRlZDtib3JkZXItYm90dG9tOjA7Y3Vyc29yOmhlbHB9YWRkcmVzc3ttYXJnaW4tYm90dG9tOjFlbTtmb250LXN0eWxlOm5vcm1hbDtsaW5lLWhlaWdodDppbmhlcml0fWlucHV0W3R5cGU9bnVtYmVyXSxpbnB1dFt0eXBlPXBhc3N3b3JkXSxpbnB1dFt0eXBlPXRleHRdLHRleHRhcmVhey13ZWJraXQtYXBwZWFyYW5jZTpub25lfWRsLG9sLHVse21hcmdpbi10b3A6MDttYXJnaW4tYm90dG9tOjFlbX1vbCBvbCxvbCB1bCx1bCBvbCx1bCB1bHttYXJnaW4tYm90dG9tOjB9ZHR7Zm9udC13ZWlnaHQ6NTAwfWRke21hcmdpbi1ib3R0b206LjVlbTttYXJnaW4tbGVmdDowfWJsb2NrcXVvdGV7bWFyZ2luOjAgMCAxZW19ZGZue2ZvbnQtc3R5bGU6aXRhbGljfWIsc3Ryb25ne2ZvbnQtd2VpZ2h0OmJvbGRlcn1zbWFsbHtmb250LXNpemU6ODAlfXN1YixzdXB7cG9zaXRpb246cmVsYXRpdmU7Zm9udC1zaXplOjc1JTtsaW5lLWhlaWdodDowO3ZlcnRpY2FsLWFsaWduOmJhc2VsaW5lfXN1Yntib3R0b206LS4yNWVtfXN1cHt0b3A6LS41ZW19YXtjb2xvcjojMTg5MGZmO3RleHQtZGVjb3JhdGlvbjpub25lO2JhY2tncm91bmQtY29sb3I6dHJhbnNwYXJlbnQ7b3V0bGluZTpub25lO2N1cnNvcjpwb2ludGVyO3RyYW5zaXRpb246Y29sb3IgLjNzOy13ZWJraXQtdGV4dC1kZWNvcmF0aW9uLXNraXA6b2JqZWN0c31hOmhvdmVye2NvbG9yOiM0MGE5ZmZ9YTphY3RpdmV7Y29sb3I6IzA5NmRkOX1hOmFjdGl2ZSxhOmZvY3VzLGE6aG92ZXJ7dGV4dC1kZWNvcmF0aW9uOm5vbmU7b3V0bGluZTowfWFbZGlzYWJsZWRde2NvbG9yOnJnYmEoMCwwLDAsLjI1KTtjdXJzb3I6bm90LWFsbG93ZWR9Y29kZSxrYmQscHJlLHNhbXB7Zm9udC1zaXplOjFlbTtmb250LWZhbWlseTpTRk1vbm8tUmVndWxhcixDb25zb2xhcyxMaWJlcmF0aW9uIE1vbm8sTWVubG8sQ291cmllcixtb25vc3BhY2V9cHJle21hcmdpbi10b3A6MDttYXJnaW4tYm90dG9tOjFlbTtvdmVyZmxvdzphdXRvfWZpZ3VyZXttYXJnaW46MCAwIDFlbX1pbWd7dmVydGljYWwtYWxpZ246bWlkZGxlO2JvcmRlci1zdHlsZTpub25lfVtyb2xlPWJ1dHRvbl0sYSxhcmVhLGJ1dHRvbixpbnB1dDpub3QoW3R5cGU9cmFuZ2VdKSxsYWJlbCxzZWxlY3Qsc3VtbWFyeSx0ZXh0YXJlYXt0b3VjaC1hY3Rpb246bWFuaXB1bGF0aW9ufXRhYmxle2JvcmRlci1jb2xsYXBzZTpjb2xsYXBzZX1jYXB0aW9ue3BhZGRpbmctdG9wOi43NWVtO3BhZGRpbmctYm90dG9tOi4zZW07Y29sb3I6cmdiYSgwLDAsMCwuNDUpO3RleHQtYWxpZ246bGVmdDtjYXB0aW9uLXNpZGU6Ym90dG9tfWJ1dHRvbixpbnB1dCxvcHRncm91cCxzZWxlY3QsdGV4dGFyZWF7bWFyZ2luOjA7Y29sb3I6aW5oZXJpdDtmb250LXNpemU6aW5oZXJpdDtmb250LWZhbWlseTppbmhlcml0O2xpbmUtaGVpZ2h0OmluaGVyaXR9YnV0dG9uLGlucHV0e292ZXJmbG93OnZpc2libGV9YnV0dG9uLHNlbGVjdHt0ZXh0LXRyYW5zZm9ybTpub25lfVt0eXBlPXJlc2V0XSxbdHlwZT1zdWJtaXRdLGJ1dHRvbixodG1sIFt0eXBlPWJ1dHRvbl17LXdlYmtpdC1hcHBlYXJhbmNlOmJ1dHRvbn1bdHlwZT1idXR0b25dOjotbW96LWZvY3VzLWlubmVyLFt0eXBlPXJlc2V0XTo6LW1vei1mb2N1cy1pbm5lcixbdHlwZT1zdWJtaXRdOjotbW96LWZvY3VzLWlubmVyLGJ1dHRvbjo6LW1vei1mb2N1cy1pbm5lcntwYWRkaW5nOjA7Ym9yZGVyLXN0eWxlOm5vbmV9aW5wdXRbdHlwZT1jaGVja2JveF0saW5wdXRbdHlwZT1yYWRpb117Ym94LXNpemluZzpib3JkZXItYm94O3BhZGRpbmc6MH1pbnB1dFt0eXBlPWRhdGVdLGlucHV0W3R5cGU9ZGF0ZXRpbWUtbG9jYWxdLGlucHV0W3R5cGU9bW9udGhdLGlucHV0W3R5cGU9dGltZV17LXdlYmtpdC1hcHBlYXJhbmNlOmxpc3Rib3h9dGV4dGFyZWF7b3ZlcmZsb3c6YXV0bztyZXNpemU6dmVydGljYWx9ZmllbGRzZXR7bWluLXdpZHRoOjA7bWFyZ2luOjA7cGFkZGluZzowO2JvcmRlcjowfWxlZ2VuZHtkaXNwbGF5OmJsb2NrO3dpZHRoOjEwMCU7bWF4LXdpZHRoOjEwMCU7bWFyZ2luLWJvdHRvbTouNWVtO3BhZGRpbmc6MDtjb2xvcjppbmhlcml0O2ZvbnQtc2l6ZToxLjVlbTtsaW5lLWhlaWdodDppbmhlcml0O3doaXRlLXNwYWNlOm5vcm1hbH1wcm9ncmVzc3t2ZXJ0aWNhbC1hbGlnbjpiYXNlbGluZX1bdHlwZT1udW1iZXJdOjotd2Via2l0LWlubmVyLXNwaW4tYnV0dG9uLFt0eXBlPW51bWJlcl06Oi13ZWJraXQtb3V0ZXItc3Bpbi1idXR0b257aGVpZ2h0OmF1dG99W3R5cGU9c2VhcmNoXXtvdXRsaW5lLW9mZnNldDotMnB4Oy13ZWJraXQtYXBwZWFyYW5jZTpub25lfVt0eXBlPXNlYXJjaF06Oi13ZWJraXQtc2VhcmNoLWNhbmNlbC1idXR0b24sW3R5cGU9c2VhcmNoXTo6LXdlYmtpdC1zZWFyY2gtZGVjb3JhdGlvbnstd2Via2l0LWFwcGVhcmFuY2U6bm9uZX06Oi13ZWJraXQtZmlsZS11cGxvYWQtYnV0dG9ue2ZvbnQ6aW5oZXJpdDstd2Via2l0LWFwcGVhcmFuY2U6YnV0dG9ufW91dHB1dHtkaXNwbGF5OmlubGluZS1ibG9ja31zdW1tYXJ5e2Rpc3BsYXk6bGlzdC1pdGVtfXRlbXBsYXRle2Rpc3BsYXk6bm9uZX1baGlkZGVuXXtkaXNwbGF5Om5vbmUhaW1wb3J0YW50fW1hcmt7cGFkZGluZzouMmVtO2JhY2tncm91bmQtY29sb3I6I2ZlZmZlNn06Oi1tb3otc2VsZWN0aW9ue2NvbG9yOiNmZmY7YmFja2dyb3VuZDojMTg5MGZmfTo6c2VsZWN0aW9ue2NvbG9yOiNmZmY7YmFja2dyb3VuZDojMTg5MGZmfS5jbGVhcmZpeDphZnRlciwuY2xlYXJmaXg6YmVmb3Jle2Rpc3BsYXk6dGFibGU7Y29udGVudDpcIlwifS5jbGVhcmZpeDphZnRlcntjbGVhcjpib3RofS5hbnRpY29ue2Rpc3BsYXk6aW5saW5lLWJsb2NrO2NvbG9yOmluaGVyaXQ7Zm9udC1zdHlsZTpub3JtYWw7bGluZS1oZWlnaHQ6MDt0ZXh0LWFsaWduOmNlbnRlcjt0ZXh0LXRyYW5zZm9ybTpub25lO3ZlcnRpY2FsLWFsaWduOi0uMTI1ZW07dGV4dC1yZW5kZXJpbmc6b3B0aW1pemVsZWdpYmlsaXR5Oy13ZWJraXQtZm9udC1zbW9vdGhpbmc6YW50aWFsaWFzZWQ7LW1vei1vc3gtZm9udC1zbW9vdGhpbmc6Z3JheXNjYWxlfS5hbnRpY29uPip7bGluZS1oZWlnaHQ6MX0uYW50aWNvbiBzdmd7ZGlzcGxheTppbmxpbmUtYmxvY2t9LmFudGljb246YmVmb3Jle2Rpc3BsYXk6bm9uZX0uYW50aWNvbiAuYW50aWNvbi1pY29ue2Rpc3BsYXk6YmxvY2t9LmFudGljb24+LmFudGljb257bGluZS1oZWlnaHQ6MDt2ZXJ0aWNhbC1hbGlnbjowfS5hbnRpY29uW3RhYmluZGV4XXtjdXJzb3I6cG9pbnRlcn0uYW50aWNvbi1zcGluLC5hbnRpY29uLXNwaW46YmVmb3Jle2Rpc3BsYXk6aW5saW5lLWJsb2NrO2FuaW1hdGlvbjpsb2FkaW5nQ2lyY2xlIDFzIGxpbmVhciBpbmZpbml0ZX0uYW50LWZhZGUtYXBwZWFyLC5hbnQtZmFkZS1lbnRlciwuYW50LWZhZGUtbGVhdmV7YW5pbWF0aW9uLWR1cmF0aW9uOi4yczthbmltYXRpb24tZmlsbC1tb2RlOmJvdGg7YW5pbWF0aW9uLXBsYXktc3RhdGU6cGF1c2VkfS5hbnQtZmFkZS1hcHBlYXIuYW50LWZhZGUtYXBwZWFyLWFjdGl2ZSwuYW50LWZhZGUtZW50ZXIuYW50LWZhZGUtZW50ZXItYWN0aXZle2FuaW1hdGlvbi1uYW1lOmFudEZhZGVJbjthbmltYXRpb24tcGxheS1zdGF0ZTpydW5uaW5nfS5hbnQtZmFkZS1sZWF2ZS5hbnQtZmFkZS1sZWF2ZS1hY3RpdmV7YW5pbWF0aW9uLW5hbWU6YW50RmFkZU91dDthbmltYXRpb24tcGxheS1zdGF0ZTpydW5uaW5nO3BvaW50ZXItZXZlbnRzOm5vbmV9LmFudC1mYWRlLWFwcGVhciwuYW50LWZhZGUtZW50ZXJ7b3BhY2l0eTowO2FuaW1hdGlvbi10aW1pbmctZnVuY3Rpb246bGluZWFyfS5hbnQtZmFkZS1sZWF2ZXthbmltYXRpb24tdGltaW5nLWZ1bmN0aW9uOmxpbmVhcn1Aa2V5ZnJhbWVzIGFudEZhZGVJbnswJXtvcGFjaXR5OjB9dG97b3BhY2l0eToxfX1Aa2V5ZnJhbWVzIGFudEZhZGVPdXR7MCV7b3BhY2l0eToxfXRve29wYWNpdHk6MH19LmFudC1tb3ZlLXVwLWFwcGVhciwuYW50LW1vdmUtdXAtZW50ZXIsLmFudC1tb3ZlLXVwLWxlYXZle2FuaW1hdGlvbi1kdXJhdGlvbjouMnM7YW5pbWF0aW9uLWZpbGwtbW9kZTpib3RoO2FuaW1hdGlvbi1wbGF5LXN0YXRlOnBhdXNlZH0uYW50LW1vdmUtdXAtYXBwZWFyLmFudC1tb3ZlLXVwLWFwcGVhci1hY3RpdmUsLmFudC1tb3ZlLXVwLWVudGVyLmFudC1tb3ZlLXVwLWVudGVyLWFjdGl2ZXthbmltYXRpb24tbmFtZTphbnRNb3ZlVXBJbjthbmltYXRpb24tcGxheS1zdGF0ZTpydW5uaW5nfS5hbnQtbW92ZS11cC1sZWF2ZS5hbnQtbW92ZS11cC1sZWF2ZS1hY3RpdmV7YW5pbWF0aW9uLW5hbWU6YW50TW92ZVVwT3V0O2FuaW1hdGlvbi1wbGF5LXN0YXRlOnJ1bm5pbmc7cG9pbnRlci1ldmVudHM6bm9uZX0uYW50LW1vdmUtdXAtYXBwZWFyLC5hbnQtbW92ZS11cC1lbnRlcntvcGFjaXR5OjA7YW5pbWF0aW9uLXRpbWluZy1mdW5jdGlvbjpjdWJpYy1iZXppZXIoLjA4LC44MiwuMTcsMSl9LmFudC1tb3ZlLXVwLWxlYXZle2FuaW1hdGlvbi10aW1pbmctZnVuY3Rpb246Y3ViaWMtYmV6aWVyKC42LC4wNCwuOTgsLjM0KX0uYW50LW1vdmUtZG93bi1hcHBlYXIsLmFudC1tb3ZlLWRvd24tZW50ZXIsLmFudC1tb3ZlLWRvd24tbGVhdmV7YW5pbWF0aW9uLWR1cmF0aW9uOi4yczthbmltYXRpb24tZmlsbC1tb2RlOmJvdGg7YW5pbWF0aW9uLXBsYXktc3RhdGU6cGF1c2VkfS5hbnQtbW92ZS1kb3duLWFwcGVhci5hbnQtbW92ZS1kb3duLWFwcGVhci1hY3RpdmUsLmFudC1tb3ZlLWRvd24tZW50ZXIuYW50LW1vdmUtZG93bi1lbnRlci1hY3RpdmV7YW5pbWF0aW9uLW5hbWU6YW50TW92ZURvd25JbjthbmltYXRpb24tcGxheS1zdGF0ZTpydW5uaW5nfS5hbnQtbW92ZS1kb3duLWxlYXZlLmFudC1tb3ZlLWRvd24tbGVhdmUtYWN0aXZle2FuaW1hdGlvbi1uYW1lOmFudE1vdmVEb3duT3V0O2FuaW1hdGlvbi1wbGF5LXN0YXRlOnJ1bm5pbmc7cG9pbnRlci1ldmVudHM6bm9uZX0uYW50LW1vdmUtZG93bi1hcHBlYXIsLmFudC1tb3ZlLWRvd24tZW50ZXJ7b3BhY2l0eTowO2FuaW1hdGlvbi10aW1pbmctZnVuY3Rpb246Y3ViaWMtYmV6aWVyKC4wOCwuODIsLjE3LDEpfS5hbnQtbW92ZS1kb3duLWxlYXZle2FuaW1hdGlvbi10aW1pbmctZnVuY3Rpb246Y3ViaWMtYmV6aWVyKC42LC4wNCwuOTgsLjM0KX0uYW50LW1vdmUtbGVmdC1hcHBlYXIsLmFudC1tb3ZlLWxlZnQtZW50ZXIsLmFudC1tb3ZlLWxlZnQtbGVhdmV7YW5pbWF0aW9uLWR1cmF0aW9uOi4yczthbmltYXRpb24tZmlsbC1tb2RlOmJvdGg7YW5pbWF0aW9uLXBsYXktc3RhdGU6cGF1c2VkfS5hbnQtbW92ZS1sZWZ0LWFwcGVhci5hbnQtbW92ZS1sZWZ0LWFwcGVhci1hY3RpdmUsLmFudC1tb3ZlLWxlZnQtZW50ZXIuYW50LW1vdmUtbGVmdC1lbnRlci1hY3RpdmV7YW5pbWF0aW9uLW5hbWU6YW50TW92ZUxlZnRJbjthbmltYXRpb24tcGxheS1zdGF0ZTpydW5uaW5nfS5hbnQtbW92ZS1sZWZ0LWxlYXZlLmFudC1tb3ZlLWxlZnQtbGVhdmUtYWN0aXZle2FuaW1hdGlvbi1uYW1lOmFudE1vdmVMZWZ0T3V0O2FuaW1hdGlvbi1wbGF5LXN0YXRlOnJ1bm5pbmc7cG9pbnRlci1ldmVudHM6bm9uZX0uYW50LW1vdmUtbGVmdC1hcHBlYXIsLmFudC1tb3ZlLWxlZnQtZW50ZXJ7b3BhY2l0eTowO2FuaW1hdGlvbi10aW1pbmctZnVuY3Rpb246Y3ViaWMtYmV6aWVyKC4wOCwuODIsLjE3LDEpfS5hbnQtbW92ZS1sZWZ0LWxlYXZle2FuaW1hdGlvbi10aW1pbmctZnVuY3Rpb246Y3ViaWMtYmV6aWVyKC42LC4wNCwuOTgsLjM0KX0uYW50LW1vdmUtcmlnaHQtYXBwZWFyLC5hbnQtbW92ZS1yaWdodC1lbnRlciwuYW50LW1vdmUtcmlnaHQtbGVhdmV7YW5pbWF0aW9uLWR1cmF0aW9uOi4yczthbmltYXRpb24tZmlsbC1tb2RlOmJvdGg7YW5pbWF0aW9uLXBsYXktc3RhdGU6cGF1c2VkfS5hbnQtbW92ZS1yaWdodC1hcHBlYXIuYW50LW1vdmUtcmlnaHQtYXBwZWFyLWFjdGl2ZSwuYW50LW1vdmUtcmlnaHQtZW50ZXIuYW50LW1vdmUtcmlnaHQtZW50ZXItYWN0aXZle2FuaW1hdGlvbi1uYW1lOmFudE1vdmVSaWdodEluO2FuaW1hdGlvbi1wbGF5LXN0YXRlOnJ1bm5pbmd9LmFudC1tb3ZlLXJpZ2h0LWxlYXZlLmFudC1tb3ZlLXJpZ2h0LWxlYXZlLWFjdGl2ZXthbmltYXRpb24tbmFtZTphbnRNb3ZlUmlnaHRPdXQ7YW5pbWF0aW9uLXBsYXktc3RhdGU6cnVubmluZztwb2ludGVyLWV2ZW50czpub25lfS5hbnQtbW92ZS1yaWdodC1hcHBlYXIsLmFudC1tb3ZlLXJpZ2h0LWVudGVye29wYWNpdHk6MDthbmltYXRpb24tdGltaW5nLWZ1bmN0aW9uOmN1YmljLWJlemllciguMDgsLjgyLC4xNywxKX0uYW50LW1vdmUtcmlnaHQtbGVhdmV7YW5pbWF0aW9uLXRpbWluZy1mdW5jdGlvbjpjdWJpYy1iZXppZXIoLjYsLjA0LC45OCwuMzQpfUBrZXlmcmFtZXMgYW50TW92ZURvd25JbnswJXt0cmFuc2Zvcm06dHJhbnNsYXRlWSgxMDAlKTt0cmFuc2Zvcm0tb3JpZ2luOjAgMDtvcGFjaXR5OjB9dG97dHJhbnNmb3JtOnRyYW5zbGF0ZVkoMCk7dHJhbnNmb3JtLW9yaWdpbjowIDA7b3BhY2l0eToxfX1Aa2V5ZnJhbWVzIGFudE1vdmVEb3duT3V0ezAle3RyYW5zZm9ybTp0cmFuc2xhdGVZKDApO3RyYW5zZm9ybS1vcmlnaW46MCAwO29wYWNpdHk6MX10b3t0cmFuc2Zvcm06dHJhbnNsYXRlWSgxMDAlKTt0cmFuc2Zvcm0tb3JpZ2luOjAgMDtvcGFjaXR5OjB9fUBrZXlmcmFtZXMgYW50TW92ZUxlZnRJbnswJXt0cmFuc2Zvcm06dHJhbnNsYXRlWCgtMTAwJSk7dHJhbnNmb3JtLW9yaWdpbjowIDA7b3BhY2l0eTowfXRve3RyYW5zZm9ybTp0cmFuc2xhdGVYKDApO3RyYW5zZm9ybS1vcmlnaW46MCAwO29wYWNpdHk6MX19QGtleWZyYW1lcyBhbnRNb3ZlTGVmdE91dHswJXt0cmFuc2Zvcm06dHJhbnNsYXRlWCgwKTt0cmFuc2Zvcm0tb3JpZ2luOjAgMDtvcGFjaXR5OjF9dG97dHJhbnNmb3JtOnRyYW5zbGF0ZVgoLTEwMCUpO3RyYW5zZm9ybS1vcmlnaW46MCAwO29wYWNpdHk6MH19QGtleWZyYW1lcyBhbnRNb3ZlUmlnaHRJbnswJXt0cmFuc2Zvcm06dHJhbnNsYXRlWCgxMDAlKTt0cmFuc2Zvcm0tb3JpZ2luOjAgMDtvcGFjaXR5OjB9dG97dHJhbnNmb3JtOnRyYW5zbGF0ZVgoMCk7dHJhbnNmb3JtLW9yaWdpbjowIDA7b3BhY2l0eToxfX1Aa2V5ZnJhbWVzIGFudE1vdmVSaWdodE91dHswJXt0cmFuc2Zvcm06dHJhbnNsYXRlWCgwKTt0cmFuc2Zvcm0tb3JpZ2luOjAgMDtvcGFjaXR5OjF9dG97dHJhbnNmb3JtOnRyYW5zbGF0ZVgoMTAwJSk7dHJhbnNmb3JtLW9yaWdpbjowIDA7b3BhY2l0eTowfX1Aa2V5ZnJhbWVzIGFudE1vdmVVcEluezAle3RyYW5zZm9ybTp0cmFuc2xhdGVZKC0xMDAlKTt0cmFuc2Zvcm0tb3JpZ2luOjAgMDtvcGFjaXR5OjB9dG97dHJhbnNmb3JtOnRyYW5zbGF0ZVkoMCk7dHJhbnNmb3JtLW9yaWdpbjowIDA7b3BhY2l0eToxfX1Aa2V5ZnJhbWVzIGFudE1vdmVVcE91dHswJXt0cmFuc2Zvcm06dHJhbnNsYXRlWSgwKTt0cmFuc2Zvcm0tb3JpZ2luOjAgMDtvcGFjaXR5OjF9dG97dHJhbnNmb3JtOnRyYW5zbGF0ZVkoLTEwMCUpO3RyYW5zZm9ybS1vcmlnaW46MCAwO29wYWNpdHk6MH19QGtleWZyYW1lcyBsb2FkaW5nQ2lyY2xle3Rve3RyYW5zZm9ybTpyb3RhdGUoMXR1cm4pfX1bYW50LWNsaWNrLWFuaW1hdGluZy13aXRob3V0LWV4dHJhLW5vZGU9dHJ1ZV0sW2FudC1jbGljay1hbmltYXRpbmc9dHJ1ZV17cG9zaXRpb246cmVsYXRpdmV9aHRtbHstLWFudGQtd2F2ZS1zaGFkb3ctY29sb3I6IzE4OTBmZjstLXNjcm9sbC1iYXI6MH0uYW50LWNsaWNrLWFuaW1hdGluZy1ub2RlLFthbnQtY2xpY2stYW5pbWF0aW5nLXdpdGhvdXQtZXh0cmEtbm9kZT10cnVlXTphZnRlcntwb3NpdGlvbjphYnNvbHV0ZTt0b3A6MDtyaWdodDowO2JvdHRvbTowO2xlZnQ6MDtkaXNwbGF5OmJsb2NrO2JvcmRlci1yYWRpdXM6aW5oZXJpdDtib3gtc2hhZG93OjAgMCAwIDAgIzE4OTBmZjtib3gtc2hhZG93OjAgMCAwIDAgdmFyKC0tYW50ZC13YXZlLXNoYWRvdy1jb2xvcik7b3BhY2l0eTouMjthbmltYXRpb246ZmFkZUVmZmVjdCAycyBjdWJpYy1iZXppZXIoLjA4LC44MiwuMTcsMSksd2F2ZUVmZmVjdCAuNHMgY3ViaWMtYmV6aWVyKC4wOCwuODIsLjE3LDEpO2FuaW1hdGlvbi1maWxsLW1vZGU6Zm9yd2FyZHM7Y29udGVudDpcIlwiO3BvaW50ZXItZXZlbnRzOm5vbmV9QGtleWZyYW1lcyB3YXZlRWZmZWN0e3Rve2JveC1zaGFkb3c6MCAwIDAgIzE4OTBmZjtib3gtc2hhZG93OjAgMCAwIDZweCB2YXIoLS1hbnRkLXdhdmUtc2hhZG93LWNvbG9yKX19QGtleWZyYW1lcyBmYWRlRWZmZWN0e3Rve29wYWNpdHk6MH19LmFudC1zbGlkZS11cC1hcHBlYXIsLmFudC1zbGlkZS11cC1lbnRlciwuYW50LXNsaWRlLXVwLWxlYXZle2FuaW1hdGlvbi1kdXJhdGlvbjouMnM7YW5pbWF0aW9uLWZpbGwtbW9kZTpib3RoO2FuaW1hdGlvbi1wbGF5LXN0YXRlOnBhdXNlZH0uYW50LXNsaWRlLXVwLWFwcGVhci5hbnQtc2xpZGUtdXAtYXBwZWFyLWFjdGl2ZSwuYW50LXNsaWRlLXVwLWVudGVyLmFudC1zbGlkZS11cC1lbnRlci1hY3RpdmV7YW5pbWF0aW9uLW5hbWU6YW50U2xpZGVVcEluO2FuaW1hdGlvbi1wbGF5LXN0YXRlOnJ1bm5pbmd9LmFudC1zbGlkZS11cC1sZWF2ZS5hbnQtc2xpZGUtdXAtbGVhdmUtYWN0aXZle2FuaW1hdGlvbi1uYW1lOmFudFNsaWRlVXBPdXQ7YW5pbWF0aW9uLXBsYXktc3RhdGU6cnVubmluZztwb2ludGVyLWV2ZW50czpub25lfS5hbnQtc2xpZGUtdXAtYXBwZWFyLC5hbnQtc2xpZGUtdXAtZW50ZXJ7dHJhbnNmb3JtOnNjYWxlKDApO3RyYW5zZm9ybS1vcmlnaW46MCAwO29wYWNpdHk6MDthbmltYXRpb24tdGltaW5nLWZ1bmN0aW9uOmN1YmljLWJlemllciguMjMsMSwuMzIsMSl9LmFudC1zbGlkZS11cC1sZWF2ZXthbmltYXRpb24tdGltaW5nLWZ1bmN0aW9uOmN1YmljLWJlemllciguNzU1LC4wNSwuODU1LC4wNil9LmFudC1zbGlkZS1kb3duLWFwcGVhciwuYW50LXNsaWRlLWRvd24tZW50ZXIsLmFudC1zbGlkZS1kb3duLWxlYXZle2FuaW1hdGlvbi1kdXJhdGlvbjouMnM7YW5pbWF0aW9uLWZpbGwtbW9kZTpib3RoO2FuaW1hdGlvbi1wbGF5LXN0YXRlOnBhdXNlZH0uYW50LXNsaWRlLWRvd24tYXBwZWFyLmFudC1zbGlkZS1kb3duLWFwcGVhci1hY3RpdmUsLmFudC1zbGlkZS1kb3duLWVudGVyLmFudC1zbGlkZS1kb3duLWVudGVyLWFjdGl2ZXthbmltYXRpb24tbmFtZTphbnRTbGlkZURvd25JbjthbmltYXRpb24tcGxheS1zdGF0ZTpydW5uaW5nfS5hbnQtc2xpZGUtZG93bi1sZWF2ZS5hbnQtc2xpZGUtZG93bi1sZWF2ZS1hY3RpdmV7YW5pbWF0aW9uLW5hbWU6YW50U2xpZGVEb3duT3V0O2FuaW1hdGlvbi1wbGF5LXN0YXRlOnJ1bm5pbmc7cG9pbnRlci1ldmVudHM6bm9uZX0uYW50LXNsaWRlLWRvd24tYXBwZWFyLC5hbnQtc2xpZGUtZG93bi1lbnRlcnt0cmFuc2Zvcm06c2NhbGUoMCk7dHJhbnNmb3JtLW9yaWdpbjowIDA7b3BhY2l0eTowO2FuaW1hdGlvbi10aW1pbmctZnVuY3Rpb246Y3ViaWMtYmV6aWVyKC4yMywxLC4zMiwxKX0uYW50LXNsaWRlLWRvd24tbGVhdmV7YW5pbWF0aW9uLXRpbWluZy1mdW5jdGlvbjpjdWJpYy1iZXppZXIoLjc1NSwuMDUsLjg1NSwuMDYpfS5hbnQtc2xpZGUtbGVmdC1hcHBlYXIsLmFudC1zbGlkZS1sZWZ0LWVudGVyLC5hbnQtc2xpZGUtbGVmdC1sZWF2ZXthbmltYXRpb24tZHVyYXRpb246LjJzO2FuaW1hdGlvbi1maWxsLW1vZGU6Ym90aDthbmltYXRpb24tcGxheS1zdGF0ZTpwYXVzZWR9LmFudC1zbGlkZS1sZWZ0LWFwcGVhci5hbnQtc2xpZGUtbGVmdC1hcHBlYXItYWN0aXZlLC5hbnQtc2xpZGUtbGVmdC1lbnRlci5hbnQtc2xpZGUtbGVmdC1lbnRlci1hY3RpdmV7YW5pbWF0aW9uLW5hbWU6YW50U2xpZGVMZWZ0SW47YW5pbWF0aW9uLXBsYXktc3RhdGU6cnVubmluZ30uYW50LXNsaWRlLWxlZnQtbGVhdmUuYW50LXNsaWRlLWxlZnQtbGVhdmUtYWN0aXZle2FuaW1hdGlvbi1uYW1lOmFudFNsaWRlTGVmdE91dDthbmltYXRpb24tcGxheS1zdGF0ZTpydW5uaW5nO3BvaW50ZXItZXZlbnRzOm5vbmV9LmFudC1zbGlkZS1sZWZ0LWFwcGVhciwuYW50LXNsaWRlLWxlZnQtZW50ZXJ7dHJhbnNmb3JtOnNjYWxlKDApO3RyYW5zZm9ybS1vcmlnaW46MCAwO29wYWNpdHk6MDthbmltYXRpb24tdGltaW5nLWZ1bmN0aW9uOmN1YmljLWJlemllciguMjMsMSwuMzIsMSl9LmFudC1zbGlkZS1sZWZ0LWxlYXZle2FuaW1hdGlvbi10aW1pbmctZnVuY3Rpb246Y3ViaWMtYmV6aWVyKC43NTUsLjA1LC44NTUsLjA2KX0uYW50LXNsaWRlLXJpZ2h0LWFwcGVhciwuYW50LXNsaWRlLXJpZ2h0LWVudGVyLC5hbnQtc2xpZGUtcmlnaHQtbGVhdmV7YW5pbWF0aW9uLWR1cmF0aW9uOi4yczthbmltYXRpb24tZmlsbC1tb2RlOmJvdGg7YW5pbWF0aW9uLXBsYXktc3RhdGU6cGF1c2VkfS5hbnQtc2xpZGUtcmlnaHQtYXBwZWFyLmFudC1zbGlkZS1yaWdodC1hcHBlYXItYWN0aXZlLC5hbnQtc2xpZGUtcmlnaHQtZW50ZXIuYW50LXNsaWRlLXJpZ2h0LWVudGVyLWFjdGl2ZXthbmltYXRpb24tbmFtZTphbnRTbGlkZVJpZ2h0SW47YW5pbWF0aW9uLXBsYXktc3RhdGU6cnVubmluZ30uYW50LXNsaWRlLXJpZ2h0LWxlYXZlLmFudC1zbGlkZS1yaWdodC1sZWF2ZS1hY3RpdmV7YW5pbWF0aW9uLW5hbWU6YW50U2xpZGVSaWdodE91dDthbmltYXRpb24tcGxheS1zdGF0ZTpydW5uaW5nO3BvaW50ZXItZXZlbnRzOm5vbmV9LmFudC1zbGlkZS1yaWdodC1hcHBlYXIsLmFudC1zbGlkZS1yaWdodC1lbnRlcnt0cmFuc2Zvcm06c2NhbGUoMCk7dHJhbnNmb3JtLW9yaWdpbjowIDA7b3BhY2l0eTowO2FuaW1hdGlvbi10aW1pbmctZnVuY3Rpb246Y3ViaWMtYmV6aWVyKC4yMywxLC4zMiwxKX0uYW50LXNsaWRlLXJpZ2h0LWxlYXZle2FuaW1hdGlvbi10aW1pbmctZnVuY3Rpb246Y3ViaWMtYmV6aWVyKC43NTUsLjA1LC44NTUsLjA2KX1Aa2V5ZnJhbWVzIGFudFNsaWRlVXBJbnswJXt0cmFuc2Zvcm06c2NhbGVZKC44KTt0cmFuc2Zvcm0tb3JpZ2luOjAgMDtvcGFjaXR5OjB9dG97dHJhbnNmb3JtOnNjYWxlWSgxKTt0cmFuc2Zvcm0tb3JpZ2luOjAgMDtvcGFjaXR5OjF9fUBrZXlmcmFtZXMgYW50U2xpZGVVcE91dHswJXt0cmFuc2Zvcm06c2NhbGVZKDEpO3RyYW5zZm9ybS1vcmlnaW46MCAwO29wYWNpdHk6MX10b3t0cmFuc2Zvcm06c2NhbGVZKC44KTt0cmFuc2Zvcm0tb3JpZ2luOjAgMDtvcGFjaXR5OjB9fUBrZXlmcmFtZXMgYW50U2xpZGVEb3duSW57MCV7dHJhbnNmb3JtOnNjYWxlWSguOCk7dHJhbnNmb3JtLW9yaWdpbjoxMDAlIDEwMCU7b3BhY2l0eTowfXRve3RyYW5zZm9ybTpzY2FsZVkoMSk7dHJhbnNmb3JtLW9yaWdpbjoxMDAlIDEwMCU7b3BhY2l0eToxfX1Aa2V5ZnJhbWVzIGFudFNsaWRlRG93bk91dHswJXt0cmFuc2Zvcm06c2NhbGVZKDEpO3RyYW5zZm9ybS1vcmlnaW46MTAwJSAxMDAlO29wYWNpdHk6MX10b3t0cmFuc2Zvcm06c2NhbGVZKC44KTt0cmFuc2Zvcm0tb3JpZ2luOjEwMCUgMTAwJTtvcGFjaXR5OjB9fUBrZXlmcmFtZXMgYW50U2xpZGVMZWZ0SW57MCV7dHJhbnNmb3JtOnNjYWxlWCguOCk7dHJhbnNmb3JtLW9yaWdpbjowIDA7b3BhY2l0eTowfXRve3RyYW5zZm9ybTpzY2FsZVgoMSk7dHJhbnNmb3JtLW9yaWdpbjowIDA7b3BhY2l0eToxfX1Aa2V5ZnJhbWVzIGFudFNsaWRlTGVmdE91dHswJXt0cmFuc2Zvcm06c2NhbGVYKDEpO3RyYW5zZm9ybS1vcmlnaW46MCAwO29wYWNpdHk6MX10b3t0cmFuc2Zvcm06c2NhbGVYKC44KTt0cmFuc2Zvcm0tb3JpZ2luOjAgMDtvcGFjaXR5OjB9fUBrZXlmcmFtZXMgYW50U2xpZGVSaWdodEluezAle3RyYW5zZm9ybTpzY2FsZVgoLjgpO3RyYW5zZm9ybS1vcmlnaW46MTAwJSAwO29wYWNpdHk6MH10b3t0cmFuc2Zvcm06c2NhbGVYKDEpO3RyYW5zZm9ybS1vcmlnaW46MTAwJSAwO29wYWNpdHk6MX19QGtleWZyYW1lcyBhbnRTbGlkZVJpZ2h0T3V0ezAle3RyYW5zZm9ybTpzY2FsZVgoMSk7dHJhbnNmb3JtLW9yaWdpbjoxMDAlIDA7b3BhY2l0eToxfXRve3RyYW5zZm9ybTpzY2FsZVgoLjgpO3RyYW5zZm9ybS1vcmlnaW46MTAwJSAwO29wYWNpdHk6MH19LmFudC16b29tLWFwcGVhciwuYW50LXpvb20tZW50ZXIsLmFudC16b29tLWxlYXZle2FuaW1hdGlvbi1kdXJhdGlvbjouMnM7YW5pbWF0aW9uLWZpbGwtbW9kZTpib3RoO2FuaW1hdGlvbi1wbGF5LXN0YXRlOnBhdXNlZH0uYW50LXpvb20tYXBwZWFyLmFudC16b29tLWFwcGVhci1hY3RpdmUsLmFudC16b29tLWVudGVyLmFudC16b29tLWVudGVyLWFjdGl2ZXthbmltYXRpb24tbmFtZTphbnRab29tSW47YW5pbWF0aW9uLXBsYXktc3RhdGU6cnVubmluZ30uYW50LXpvb20tbGVhdmUuYW50LXpvb20tbGVhdmUtYWN0aXZle2FuaW1hdGlvbi1uYW1lOmFudFpvb21PdXQ7YW5pbWF0aW9uLXBsYXktc3RhdGU6cnVubmluZztwb2ludGVyLWV2ZW50czpub25lfS5hbnQtem9vbS1hcHBlYXIsLmFudC16b29tLWVudGVye3RyYW5zZm9ybTpzY2FsZSgwKTtvcGFjaXR5OjA7YW5pbWF0aW9uLXRpbWluZy1mdW5jdGlvbjpjdWJpYy1iZXppZXIoLjA4LC44MiwuMTcsMSl9LmFudC16b29tLWFwcGVhci1wcmVwYXJlLC5hbnQtem9vbS1lbnRlci1wcmVwYXJle3RyYW5zZm9ybTpub25lfS5hbnQtem9vbS1sZWF2ZXthbmltYXRpb24tdGltaW5nLWZ1bmN0aW9uOmN1YmljLWJlemllciguNzgsLjE0LC4xNSwuODYpfS5hbnQtem9vbS1iaWctYXBwZWFyLC5hbnQtem9vbS1iaWctZW50ZXIsLmFudC16b29tLWJpZy1sZWF2ZXthbmltYXRpb24tZHVyYXRpb246LjJzO2FuaW1hdGlvbi1maWxsLW1vZGU6Ym90aDthbmltYXRpb24tcGxheS1zdGF0ZTpwYXVzZWR9LmFudC16b29tLWJpZy1hcHBlYXIuYW50LXpvb20tYmlnLWFwcGVhci1hY3RpdmUsLmFudC16b29tLWJpZy1lbnRlci5hbnQtem9vbS1iaWctZW50ZXItYWN0aXZle2FuaW1hdGlvbi1uYW1lOmFudFpvb21CaWdJbjthbmltYXRpb24tcGxheS1zdGF0ZTpydW5uaW5nfS5hbnQtem9vbS1iaWctbGVhdmUuYW50LXpvb20tYmlnLWxlYXZlLWFjdGl2ZXthbmltYXRpb24tbmFtZTphbnRab29tQmlnT3V0O2FuaW1hdGlvbi1wbGF5LXN0YXRlOnJ1bm5pbmc7cG9pbnRlci1ldmVudHM6bm9uZX0uYW50LXpvb20tYmlnLWFwcGVhciwuYW50LXpvb20tYmlnLWVudGVye3RyYW5zZm9ybTpzY2FsZSgwKTtvcGFjaXR5OjA7YW5pbWF0aW9uLXRpbWluZy1mdW5jdGlvbjpjdWJpYy1iZXppZXIoLjA4LC44MiwuMTcsMSl9LmFudC16b29tLWJpZy1hcHBlYXItcHJlcGFyZSwuYW50LXpvb20tYmlnLWVudGVyLXByZXBhcmV7dHJhbnNmb3JtOm5vbmV9LmFudC16b29tLWJpZy1sZWF2ZXthbmltYXRpb24tdGltaW5nLWZ1bmN0aW9uOmN1YmljLWJlemllciguNzgsLjE0LC4xNSwuODYpfS5hbnQtem9vbS1iaWctZmFzdC1hcHBlYXIsLmFudC16b29tLWJpZy1mYXN0LWVudGVyLC5hbnQtem9vbS1iaWctZmFzdC1sZWF2ZXthbmltYXRpb24tZHVyYXRpb246LjFzO2FuaW1hdGlvbi1maWxsLW1vZGU6Ym90aDthbmltYXRpb24tcGxheS1zdGF0ZTpwYXVzZWR9LmFudC16b29tLWJpZy1mYXN0LWFwcGVhci5hbnQtem9vbS1iaWctZmFzdC1hcHBlYXItYWN0aXZlLC5hbnQtem9vbS1iaWctZmFzdC1lbnRlci5hbnQtem9vbS1iaWctZmFzdC1lbnRlci1hY3RpdmV7YW5pbWF0aW9uLW5hbWU6YW50Wm9vbUJpZ0luO2FuaW1hdGlvbi1wbGF5LXN0YXRlOnJ1bm5pbmd9LmFudC16b29tLWJpZy1mYXN0LWxlYXZlLmFudC16b29tLWJpZy1mYXN0LWxlYXZlLWFjdGl2ZXthbmltYXRpb24tbmFtZTphbnRab29tQmlnT3V0O2FuaW1hdGlvbi1wbGF5LXN0YXRlOnJ1bm5pbmc7cG9pbnRlci1ldmVudHM6bm9uZX0uYW50LXpvb20tYmlnLWZhc3QtYXBwZWFyLC5hbnQtem9vbS1iaWctZmFzdC1lbnRlcnt0cmFuc2Zvcm06c2NhbGUoMCk7b3BhY2l0eTowO2FuaW1hdGlvbi10aW1pbmctZnVuY3Rpb246Y3ViaWMtYmV6aWVyKC4wOCwuODIsLjE3LDEpfS5hbnQtem9vbS1iaWctZmFzdC1hcHBlYXItcHJlcGFyZSwuYW50LXpvb20tYmlnLWZhc3QtZW50ZXItcHJlcGFyZXt0cmFuc2Zvcm06bm9uZX0uYW50LXpvb20tYmlnLWZhc3QtbGVhdmV7YW5pbWF0aW9uLXRpbWluZy1mdW5jdGlvbjpjdWJpYy1iZXppZXIoLjc4LC4xNCwuMTUsLjg2KX0uYW50LXpvb20tdXAtYXBwZWFyLC5hbnQtem9vbS11cC1lbnRlciwuYW50LXpvb20tdXAtbGVhdmV7YW5pbWF0aW9uLWR1cmF0aW9uOi4yczthbmltYXRpb24tZmlsbC1tb2RlOmJvdGg7YW5pbWF0aW9uLXBsYXktc3RhdGU6cGF1c2VkfS5hbnQtem9vbS11cC1hcHBlYXIuYW50LXpvb20tdXAtYXBwZWFyLWFjdGl2ZSwuYW50LXpvb20tdXAtZW50ZXIuYW50LXpvb20tdXAtZW50ZXItYWN0aXZle2FuaW1hdGlvbi1uYW1lOmFudFpvb21VcEluO2FuaW1hdGlvbi1wbGF5LXN0YXRlOnJ1bm5pbmd9LmFudC16b29tLXVwLWxlYXZlLmFudC16b29tLXVwLWxlYXZlLWFjdGl2ZXthbmltYXRpb24tbmFtZTphbnRab29tVXBPdXQ7YW5pbWF0aW9uLXBsYXktc3RhdGU6cnVubmluZztwb2ludGVyLWV2ZW50czpub25lfS5hbnQtem9vbS11cC1hcHBlYXIsLmFudC16b29tLXVwLWVudGVye3RyYW5zZm9ybTpzY2FsZSgwKTtvcGFjaXR5OjA7YW5pbWF0aW9uLXRpbWluZy1mdW5jdGlvbjpjdWJpYy1iZXppZXIoLjA4LC44MiwuMTcsMSl9LmFudC16b29tLXVwLWFwcGVhci1wcmVwYXJlLC5hbnQtem9vbS11cC1lbnRlci1wcmVwYXJle3RyYW5zZm9ybTpub25lfS5hbnQtem9vbS11cC1sZWF2ZXthbmltYXRpb24tdGltaW5nLWZ1bmN0aW9uOmN1YmljLWJlemllciguNzgsLjE0LC4xNSwuODYpfS5hbnQtem9vbS1kb3duLWFwcGVhciwuYW50LXpvb20tZG93bi1lbnRlciwuYW50LXpvb20tZG93bi1sZWF2ZXthbmltYXRpb24tZHVyYXRpb246LjJzO2FuaW1hdGlvbi1maWxsLW1vZGU6Ym90aDthbmltYXRpb24tcGxheS1zdGF0ZTpwYXVzZWR9LmFudC16b29tLWRvd24tYXBwZWFyLmFudC16b29tLWRvd24tYXBwZWFyLWFjdGl2ZSwuYW50LXpvb20tZG93bi1lbnRlci5hbnQtem9vbS1kb3duLWVudGVyLWFjdGl2ZXthbmltYXRpb24tbmFtZTphbnRab29tRG93bkluO2FuaW1hdGlvbi1wbGF5LXN0YXRlOnJ1bm5pbmd9LmFudC16b29tLWRvd24tbGVhdmUuYW50LXpvb20tZG93bi1sZWF2ZS1hY3RpdmV7YW5pbWF0aW9uLW5hbWU6YW50Wm9vbURvd25PdXQ7YW5pbWF0aW9uLXBsYXktc3RhdGU6cnVubmluZztwb2ludGVyLWV2ZW50czpub25lfS5hbnQtem9vbS1kb3duLWFwcGVhciwuYW50LXpvb20tZG93bi1lbnRlcnt0cmFuc2Zvcm06c2NhbGUoMCk7b3BhY2l0eTowO2FuaW1hdGlvbi10aW1pbmctZnVuY3Rpb246Y3ViaWMtYmV6aWVyKC4wOCwuODIsLjE3LDEpfS5hbnQtem9vbS1kb3duLWFwcGVhci1wcmVwYXJlLC5hbnQtem9vbS1kb3duLWVudGVyLXByZXBhcmV7dHJhbnNmb3JtOm5vbmV9LmFudC16b29tLWRvd24tbGVhdmV7YW5pbWF0aW9uLXRpbWluZy1mdW5jdGlvbjpjdWJpYy1iZXppZXIoLjc4LC4xNCwuMTUsLjg2KX0uYW50LXpvb20tbGVmdC1hcHBlYXIsLmFudC16b29tLWxlZnQtZW50ZXIsLmFudC16b29tLWxlZnQtbGVhdmV7YW5pbWF0aW9uLWR1cmF0aW9uOi4yczthbmltYXRpb24tZmlsbC1tb2RlOmJvdGg7YW5pbWF0aW9uLXBsYXktc3RhdGU6cGF1c2VkfS5hbnQtem9vbS1sZWZ0LWFwcGVhci5hbnQtem9vbS1sZWZ0LWFwcGVhci1hY3RpdmUsLmFudC16b29tLWxlZnQtZW50ZXIuYW50LXpvb20tbGVmdC1lbnRlci1hY3RpdmV7YW5pbWF0aW9uLW5hbWU6YW50Wm9vbUxlZnRJbjthbmltYXRpb24tcGxheS1zdGF0ZTpydW5uaW5nfS5hbnQtem9vbS1sZWZ0LWxlYXZlLmFudC16b29tLWxlZnQtbGVhdmUtYWN0aXZle2FuaW1hdGlvbi1uYW1lOmFudFpvb21MZWZ0T3V0O2FuaW1hdGlvbi1wbGF5LXN0YXRlOnJ1bm5pbmc7cG9pbnRlci1ldmVudHM6bm9uZX0uYW50LXpvb20tbGVmdC1hcHBlYXIsLmFudC16b29tLWxlZnQtZW50ZXJ7dHJhbnNmb3JtOnNjYWxlKDApO29wYWNpdHk6MDthbmltYXRpb24tdGltaW5nLWZ1bmN0aW9uOmN1YmljLWJlemllciguMDgsLjgyLC4xNywxKX0uYW50LXpvb20tbGVmdC1hcHBlYXItcHJlcGFyZSwuYW50LXpvb20tbGVmdC1lbnRlci1wcmVwYXJle3RyYW5zZm9ybTpub25lfS5hbnQtem9vbS1sZWZ0LWxlYXZle2FuaW1hdGlvbi10aW1pbmctZnVuY3Rpb246Y3ViaWMtYmV6aWVyKC43OCwuMTQsLjE1LC44Nil9LmFudC16b29tLXJpZ2h0LWFwcGVhciwuYW50LXpvb20tcmlnaHQtZW50ZXIsLmFudC16b29tLXJpZ2h0LWxlYXZle2FuaW1hdGlvbi1kdXJhdGlvbjouMnM7YW5pbWF0aW9uLWZpbGwtbW9kZTpib3RoO2FuaW1hdGlvbi1wbGF5LXN0YXRlOnBhdXNlZH0uYW50LXpvb20tcmlnaHQtYXBwZWFyLmFudC16b29tLXJpZ2h0LWFwcGVhci1hY3RpdmUsLmFudC16b29tLXJpZ2h0LWVudGVyLmFudC16b29tLXJpZ2h0LWVudGVyLWFjdGl2ZXthbmltYXRpb24tbmFtZTphbnRab29tUmlnaHRJbjthbmltYXRpb24tcGxheS1zdGF0ZTpydW5uaW5nfS5hbnQtem9vbS1yaWdodC1sZWF2ZS5hbnQtem9vbS1yaWdodC1sZWF2ZS1hY3RpdmV7YW5pbWF0aW9uLW5hbWU6YW50Wm9vbVJpZ2h0T3V0O2FuaW1hdGlvbi1wbGF5LXN0YXRlOnJ1bm5pbmc7cG9pbnRlci1ldmVudHM6bm9uZX0uYW50LXpvb20tcmlnaHQtYXBwZWFyLC5hbnQtem9vbS1yaWdodC1lbnRlcnt0cmFuc2Zvcm06c2NhbGUoMCk7b3BhY2l0eTowO2FuaW1hdGlvbi10aW1pbmctZnVuY3Rpb246Y3ViaWMtYmV6aWVyKC4wOCwuODIsLjE3LDEpfS5hbnQtem9vbS1yaWdodC1hcHBlYXItcHJlcGFyZSwuYW50LXpvb20tcmlnaHQtZW50ZXItcHJlcGFyZXt0cmFuc2Zvcm06bm9uZX0uYW50LXpvb20tcmlnaHQtbGVhdmV7YW5pbWF0aW9uLXRpbWluZy1mdW5jdGlvbjpjdWJpYy1iZXppZXIoLjc4LC4xNCwuMTUsLjg2KX1Aa2V5ZnJhbWVzIGFudFpvb21JbnswJXt0cmFuc2Zvcm06c2NhbGUoLjIpO29wYWNpdHk6MH10b3t0cmFuc2Zvcm06c2NhbGUoMSk7b3BhY2l0eToxfX1Aa2V5ZnJhbWVzIGFudFpvb21PdXR7MCV7dHJhbnNmb3JtOnNjYWxlKDEpfXRve3RyYW5zZm9ybTpzY2FsZSguMik7b3BhY2l0eTowfX1Aa2V5ZnJhbWVzIGFudFpvb21CaWdJbnswJXt0cmFuc2Zvcm06c2NhbGUoLjgpO29wYWNpdHk6MH10b3t0cmFuc2Zvcm06c2NhbGUoMSk7b3BhY2l0eToxfX1Aa2V5ZnJhbWVzIGFudFpvb21CaWdPdXR7MCV7dHJhbnNmb3JtOnNjYWxlKDEpfXRve3RyYW5zZm9ybTpzY2FsZSguOCk7b3BhY2l0eTowfX1Aa2V5ZnJhbWVzIGFudFpvb21VcEluezAle3RyYW5zZm9ybTpzY2FsZSguOCk7dHJhbnNmb3JtLW9yaWdpbjo1MCUgMDtvcGFjaXR5OjB9dG97dHJhbnNmb3JtOnNjYWxlKDEpO3RyYW5zZm9ybS1vcmlnaW46NTAlIDB9fUBrZXlmcmFtZXMgYW50Wm9vbVVwT3V0ezAle3RyYW5zZm9ybTpzY2FsZSgxKTt0cmFuc2Zvcm0tb3JpZ2luOjUwJSAwfXRve3RyYW5zZm9ybTpzY2FsZSguOCk7dHJhbnNmb3JtLW9yaWdpbjo1MCUgMDtvcGFjaXR5OjB9fUBrZXlmcmFtZXMgYW50Wm9vbUxlZnRJbnswJXt0cmFuc2Zvcm06c2NhbGUoLjgpO3RyYW5zZm9ybS1vcmlnaW46MCA1MCU7b3BhY2l0eTowfXRve3RyYW5zZm9ybTpzY2FsZSgxKTt0cmFuc2Zvcm0tb3JpZ2luOjAgNTAlfX1Aa2V5ZnJhbWVzIGFudFpvb21MZWZ0T3V0ezAle3RyYW5zZm9ybTpzY2FsZSgxKTt0cmFuc2Zvcm0tb3JpZ2luOjAgNTAlfXRve3RyYW5zZm9ybTpzY2FsZSguOCk7dHJhbnNmb3JtLW9yaWdpbjowIDUwJTtvcGFjaXR5OjB9fUBrZXlmcmFtZXMgYW50Wm9vbVJpZ2h0SW57MCV7dHJhbnNmb3JtOnNjYWxlKC44KTt0cmFuc2Zvcm0tb3JpZ2luOjEwMCUgNTAlO29wYWNpdHk6MH10b3t0cmFuc2Zvcm06c2NhbGUoMSk7dHJhbnNmb3JtLW9yaWdpbjoxMDAlIDUwJX19QGtleWZyYW1lcyBhbnRab29tUmlnaHRPdXR7MCV7dHJhbnNmb3JtOnNjYWxlKDEpO3RyYW5zZm9ybS1vcmlnaW46MTAwJSA1MCV9dG97dHJhbnNmb3JtOnNjYWxlKC44KTt0cmFuc2Zvcm0tb3JpZ2luOjEwMCUgNTAlO29wYWNpdHk6MH19QGtleWZyYW1lcyBhbnRab29tRG93bkluezAle3RyYW5zZm9ybTpzY2FsZSguOCk7dHJhbnNmb3JtLW9yaWdpbjo1MCUgMTAwJTtvcGFjaXR5OjB9dG97dHJhbnNmb3JtOnNjYWxlKDEpO3RyYW5zZm9ybS1vcmlnaW46NTAlIDEwMCV9fUBrZXlmcmFtZXMgYW50Wm9vbURvd25PdXR7MCV7dHJhbnNmb3JtOnNjYWxlKDEpO3RyYW5zZm9ybS1vcmlnaW46NTAlIDEwMCV9dG97dHJhbnNmb3JtOnNjYWxlKC44KTt0cmFuc2Zvcm0tb3JpZ2luOjUwJSAxMDAlO29wYWNpdHk6MH19LmFudC1tb3Rpb24tY29sbGFwc2UtbGVnYWN5e292ZXJmbG93OmhpZGRlbn0uYW50LW1vdGlvbi1jb2xsYXBzZSwuYW50LW1vdGlvbi1jb2xsYXBzZS1sZWdhY3ktYWN0aXZle3RyYW5zaXRpb246aGVpZ2h0IC4ycyBjdWJpYy1iZXppZXIoLjY0NSwuMDQ1LC4zNTUsMSksb3BhY2l0eSAuMnMgY3ViaWMtYmV6aWVyKC42NDUsLjA0NSwuMzU1LDEpIWltcG9ydGFudH0uYW50LW1vdGlvbi1jb2xsYXBzZXtvdmVyZmxvdzpoaWRkZW59LmFudC1hZmZpeHtwb3NpdGlvbjpmaXhlZDt6LWluZGV4OjEwfS5hbnQtYWxlcnR7Ym94LXNpemluZzpib3JkZXItYm94O21hcmdpbjowO2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtmb250LXNpemU6MTRweDtmb250LXZhcmlhbnQ6dGFidWxhci1udW1zO2xpbmUtaGVpZ2h0OjEuNTcxNTtsaXN0LXN0eWxlOm5vbmU7Zm9udC1mZWF0dXJlLXNldHRpbmdzOlwidG51bVwiO3Bvc2l0aW9uOnJlbGF0aXZlO2Rpc3BsYXk6ZmxleDthbGlnbi1pdGVtczpjZW50ZXI7cGFkZGluZzo4cHggMTVweDt3b3JkLXdyYXA6YnJlYWstd29yZDtib3JkZXItcmFkaXVzOjJweH0uYW50LWFsZXJ0LWNvbnRlbnR7ZmxleDoxO21pbi13aWR0aDowfS5hbnQtYWxlcnQtaWNvbnttYXJnaW4tcmlnaHQ6OHB4fS5hbnQtYWxlcnQtZGVzY3JpcHRpb257ZGlzcGxheTpub25lO2ZvbnQtc2l6ZToxNHB4O2xpbmUtaGVpZ2h0OjIycHh9LmFudC1hbGVydC1zdWNjZXNze2JhY2tncm91bmQtY29sb3I6I2Y2ZmZlZDtib3JkZXI6MXB4IHNvbGlkICNiN2ViOGZ9LmFudC1hbGVydC1zdWNjZXNzIC5hbnQtYWxlcnQtaWNvbntjb2xvcjojNTJjNDFhfS5hbnQtYWxlcnQtaW5mb3tiYWNrZ3JvdW5kLWNvbG9yOiNlNmY3ZmY7Ym9yZGVyOjFweCBzb2xpZCAjOTFkNWZmfS5hbnQtYWxlcnQtaW5mbyAuYW50LWFsZXJ0LWljb257Y29sb3I6IzE4OTBmZn0uYW50LWFsZXJ0LXdhcm5pbmd7YmFja2dyb3VuZC1jb2xvcjojZmZmYmU2O2JvcmRlcjoxcHggc29saWQgI2ZmZTU4Zn0uYW50LWFsZXJ0LXdhcm5pbmcgLmFudC1hbGVydC1pY29ue2NvbG9yOiNmYWFkMTR9LmFudC1hbGVydC1lcnJvcntiYWNrZ3JvdW5kLWNvbG9yOiNmZmYyZjA7Ym9yZGVyOjFweCBzb2xpZCAjZmZjY2M3fS5hbnQtYWxlcnQtZXJyb3IgLmFudC1hbGVydC1pY29ue2NvbG9yOiNmZjRkNGZ9LmFudC1hbGVydC1lcnJvciAuYW50LWFsZXJ0LWRlc2NyaXB0aW9uPnByZXttYXJnaW46MDtwYWRkaW5nOjB9LmFudC1hbGVydC1hY3Rpb257bWFyZ2luLWxlZnQ6OHB4fS5hbnQtYWxlcnQtY2xvc2UtaWNvbnttYXJnaW4tbGVmdDo4cHg7cGFkZGluZzowO292ZXJmbG93OmhpZGRlbjtmb250LXNpemU6MTJweDtsaW5lLWhlaWdodDoxMnB4O2JhY2tncm91bmQtY29sb3I6dHJhbnNwYXJlbnQ7Ym9yZGVyOm5vbmU7b3V0bGluZTpub25lO2N1cnNvcjpwb2ludGVyfS5hbnQtYWxlcnQtY2xvc2UtaWNvbiAuYW50aWNvbi1jbG9zZXtjb2xvcjpyZ2JhKDAsMCwwLC40NSk7dHJhbnNpdGlvbjpjb2xvciAuM3N9LmFudC1hbGVydC1jbG9zZS1pY29uIC5hbnRpY29uLWNsb3NlOmhvdmVye2NvbG9yOnJnYmEoMCwwLDAsLjc1KX0uYW50LWFsZXJ0LWNsb3NlLXRleHR7Y29sb3I6cmdiYSgwLDAsMCwuNDUpO3RyYW5zaXRpb246Y29sb3IgLjNzfS5hbnQtYWxlcnQtY2xvc2UtdGV4dDpob3Zlcntjb2xvcjpyZ2JhKDAsMCwwLC43NSl9LmFudC1hbGVydC13aXRoLWRlc2NyaXB0aW9ue2FsaWduLWl0ZW1zOmZsZXgtc3RhcnQ7cGFkZGluZzoxNXB4IDE1cHggMTVweCAyNHB4fS5hbnQtYWxlcnQtd2l0aC1kZXNjcmlwdGlvbi5hbnQtYWxlcnQtbm8taWNvbntwYWRkaW5nOjE1cHh9LmFudC1hbGVydC13aXRoLWRlc2NyaXB0aW9uIC5hbnQtYWxlcnQtaWNvbnttYXJnaW4tcmlnaHQ6MTVweDtmb250LXNpemU6MjRweH0uYW50LWFsZXJ0LXdpdGgtZGVzY3JpcHRpb24gLmFudC1hbGVydC1tZXNzYWdle2Rpc3BsYXk6YmxvY2s7bWFyZ2luLWJvdHRvbTo0cHg7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtc2l6ZToxNnB4fS5hbnQtYWxlcnQtbWVzc2FnZXtjb2xvcjpyZ2JhKDAsMCwwLC44NSl9LmFudC1hbGVydC13aXRoLWRlc2NyaXB0aW9uIC5hbnQtYWxlcnQtZGVzY3JpcHRpb257ZGlzcGxheTpibG9ja30uYW50LWFsZXJ0LmFudC1hbGVydC1tb3Rpb24tbGVhdmV7b3ZlcmZsb3c6aGlkZGVuO29wYWNpdHk6MTt0cmFuc2l0aW9uOm1heC1oZWlnaHQgLjNzIGN1YmljLWJlemllciguNzgsLjE0LC4xNSwuODYpLG9wYWNpdHkgLjNzIGN1YmljLWJlemllciguNzgsLjE0LC4xNSwuODYpLHBhZGRpbmctdG9wIC4zcyBjdWJpYy1iZXppZXIoLjc4LC4xNCwuMTUsLjg2KSxwYWRkaW5nLWJvdHRvbSAuM3MgY3ViaWMtYmV6aWVyKC43OCwuMTQsLjE1LC44NiksbWFyZ2luLWJvdHRvbSAuM3MgY3ViaWMtYmV6aWVyKC43OCwuMTQsLjE1LC44Nil9LmFudC1hbGVydC5hbnQtYWxlcnQtbW90aW9uLWxlYXZlLWFjdGl2ZXttYXgtaGVpZ2h0OjA7bWFyZ2luLWJvdHRvbTowIWltcG9ydGFudDtwYWRkaW5nLXRvcDowO3BhZGRpbmctYm90dG9tOjA7b3BhY2l0eTowfS5hbnQtYWxlcnQtYmFubmVye21hcmdpbi1ib3R0b206MDtib3JkZXI6MDtib3JkZXItcmFkaXVzOjB9LmFudC1hbGVydC5hbnQtYWxlcnQtcnRse2RpcmVjdGlvbjpydGx9LmFudC1hbGVydC1ydGwgLmFudC1hbGVydC1pY29ue21hcmdpbi1yaWdodDphdXRvO21hcmdpbi1sZWZ0OjhweH0uYW50LWFsZXJ0LXJ0bCAuYW50LWFsZXJ0LWFjdGlvbiwuYW50LWFsZXJ0LXJ0bCAuYW50LWFsZXJ0LWNsb3NlLWljb257bWFyZ2luLXJpZ2h0OjhweDttYXJnaW4tbGVmdDphdXRvfS5hbnQtYWxlcnQtcnRsLmFudC1hbGVydC13aXRoLWRlc2NyaXB0aW9ue3BhZGRpbmctcmlnaHQ6MjRweDtwYWRkaW5nLWxlZnQ6MTVweH0uYW50LWFsZXJ0LXJ0bC5hbnQtYWxlcnQtd2l0aC1kZXNjcmlwdGlvbiAuYW50LWFsZXJ0LWljb257bWFyZ2luLXJpZ2h0OmF1dG87bWFyZ2luLWxlZnQ6MTVweH0uYW50LWFuY2hvcntib3gtc2l6aW5nOmJvcmRlci1ib3g7bWFyZ2luOjA7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtc2l6ZToxNHB4O2ZvbnQtdmFyaWFudDp0YWJ1bGFyLW51bXM7bGluZS1oZWlnaHQ6MS41NzE1O2xpc3Qtc3R5bGU6bm9uZTtmb250LWZlYXR1cmUtc2V0dGluZ3M6XCJ0bnVtXCI7cG9zaXRpb246cmVsYXRpdmU7cGFkZGluZzowIDAgMCAycHh9LmFudC1hbmNob3Itd3JhcHBlcnttYXJnaW4tbGVmdDotNHB4O3BhZGRpbmctbGVmdDo0cHg7b3ZlcmZsb3c6YXV0bztiYWNrZ3JvdW5kLWNvbG9yOnRyYW5zcGFyZW50fS5hbnQtYW5jaG9yLWlua3twb3NpdGlvbjphYnNvbHV0ZTt0b3A6MDtsZWZ0OjA7aGVpZ2h0OjEwMCV9LmFudC1hbmNob3ItaW5rOmJlZm9yZXtwb3NpdGlvbjpyZWxhdGl2ZTtkaXNwbGF5OmJsb2NrO3dpZHRoOjJweDtoZWlnaHQ6MTAwJTttYXJnaW46MCBhdXRvO2JhY2tncm91bmQtY29sb3I6I2YwZjBmMDtjb250ZW50OlwiIFwifS5hbnQtYW5jaG9yLWluay1iYWxse3Bvc2l0aW9uOmFic29sdXRlO2xlZnQ6NTAlO2Rpc3BsYXk6bm9uZTt3aWR0aDo4cHg7aGVpZ2h0OjhweDtiYWNrZ3JvdW5kLWNvbG9yOiNmZmY7Ym9yZGVyOjJweCBzb2xpZCAjMTg5MGZmO2JvcmRlci1yYWRpdXM6OHB4O3RyYW5zZm9ybTp0cmFuc2xhdGVYKC01MCUpO3RyYW5zaXRpb246dG9wIC4zcyBlYXNlLWluLW91dH0uYW50LWFuY2hvci1pbmstYmFsbC5hbnQtYW5jaG9yLWluay1iYWxsLXZpc2libGV7ZGlzcGxheTppbmxpbmUtYmxvY2t9LmFudC1hbmNob3ItZml4ZWQgLmFudC1hbmNob3ItaW5rIC5hbnQtYW5jaG9yLWluay1iYWxse2Rpc3BsYXk6bm9uZX0uYW50LWFuY2hvci1saW5re3BhZGRpbmc6NHB4IDAgNHB4IDE2cHh9LmFudC1hbmNob3ItbGluay10aXRsZXtwb3NpdGlvbjpyZWxhdGl2ZTtkaXNwbGF5OmJsb2NrO21hcmdpbi1ib3R0b206M3B4O292ZXJmbG93OmhpZGRlbjtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7d2hpdGUtc3BhY2U6bm93cmFwO3RleHQtb3ZlcmZsb3c6ZWxsaXBzaXM7dHJhbnNpdGlvbjphbGwgLjNzfS5hbnQtYW5jaG9yLWxpbmstdGl0bGU6b25seS1jaGlsZHttYXJnaW4tYm90dG9tOjB9LmFudC1hbmNob3ItbGluay1hY3RpdmU+LmFudC1hbmNob3ItbGluay10aXRsZXtjb2xvcjojMTg5MGZmfS5hbnQtYW5jaG9yLWxpbmsgLmFudC1hbmNob3ItbGlua3twYWRkaW5nLXRvcDoycHg7cGFkZGluZy1ib3R0b206MnB4fS5hbnQtYW5jaG9yLXJ0bHtkaXJlY3Rpb246cnRsfS5hbnQtYW5jaG9yLXJ0bC5hbnQtYW5jaG9yLXdyYXBwZXJ7bWFyZ2luLXJpZ2h0Oi00cHg7bWFyZ2luLWxlZnQ6MDtwYWRkaW5nLXJpZ2h0OjRweDtwYWRkaW5nLWxlZnQ6MH0uYW50LWFuY2hvci1ydGwgLmFudC1hbmNob3ItaW5re3JpZ2h0OjA7bGVmdDphdXRvfS5hbnQtYW5jaG9yLXJ0bCAuYW50LWFuY2hvci1pbmstYmFsbHtyaWdodDo1MCU7bGVmdDowO3RyYW5zZm9ybTp0cmFuc2xhdGVYKDUwJSl9LmFudC1hbmNob3ItcnRsIC5hbnQtYW5jaG9yLWxpbmt7cGFkZGluZzo0cHggMTZweCA0cHggMH0uYW50LXNlbGVjdC1hdXRvLWNvbXBsZXRle2JveC1zaXppbmc6Ym9yZGVyLWJveDttYXJnaW46MDtwYWRkaW5nOjA7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtc2l6ZToxNHB4O2ZvbnQtdmFyaWFudDp0YWJ1bGFyLW51bXM7bGluZS1oZWlnaHQ6MS41NzE1O2xpc3Qtc3R5bGU6bm9uZTtmb250LWZlYXR1cmUtc2V0dGluZ3M6XCJ0bnVtXCJ9LmFudC1zZWxlY3QtYXV0by1jb21wbGV0ZSAuYW50LXNlbGVjdC1jbGVhcntyaWdodDoxM3B4fS5hbnQtYXZhdGFye2JveC1zaXppbmc6Ym9yZGVyLWJveDttYXJnaW46MDtwYWRkaW5nOjA7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtc2l6ZToxNHB4O2ZvbnQtdmFyaWFudDp0YWJ1bGFyLW51bXM7bGluZS1oZWlnaHQ6MS41NzE1O2xpc3Qtc3R5bGU6bm9uZTtmb250LWZlYXR1cmUtc2V0dGluZ3M6XCJ0bnVtXCI7cG9zaXRpb246cmVsYXRpdmU7ZGlzcGxheTppbmxpbmUtYmxvY2s7b3ZlcmZsb3c6aGlkZGVuO2NvbG9yOiNmZmY7d2hpdGUtc3BhY2U6bm93cmFwO3RleHQtYWxpZ246Y2VudGVyO3ZlcnRpY2FsLWFsaWduOm1pZGRsZTtiYWNrZ3JvdW5kOiNjY2M7d2lkdGg6MzJweDtoZWlnaHQ6MzJweDtsaW5lLWhlaWdodDozMnB4O2JvcmRlci1yYWRpdXM6NTAlfS5hbnQtYXZhdGFyLWltYWdle2JhY2tncm91bmQ6dHJhbnNwYXJlbnR9LmFudC1hdmF0YXIgLmFudC1pbWFnZS1pbWd7ZGlzcGxheTpibG9ja30uYW50LWF2YXRhci1zdHJpbmd7cG9zaXRpb246YWJzb2x1dGU7bGVmdDo1MCU7dHJhbnNmb3JtLW9yaWdpbjowIGNlbnRlcn0uYW50LWF2YXRhci5hbnQtYXZhdGFyLWljb257Zm9udC1zaXplOjE4cHh9LmFudC1hdmF0YXIuYW50LWF2YXRhci1pY29uPi5hbnRpY29ue21hcmdpbjowfS5hbnQtYXZhdGFyLWxne3dpZHRoOjQwcHg7aGVpZ2h0OjQwcHg7bGluZS1oZWlnaHQ6NDBweDtib3JkZXItcmFkaXVzOjUwJX0uYW50LWF2YXRhci1sZy1zdHJpbmd7cG9zaXRpb246YWJzb2x1dGU7bGVmdDo1MCU7dHJhbnNmb3JtLW9yaWdpbjowIGNlbnRlcn0uYW50LWF2YXRhci1sZy5hbnQtYXZhdGFyLWljb257Zm9udC1zaXplOjI0cHh9LmFudC1hdmF0YXItbGcuYW50LWF2YXRhci1pY29uPi5hbnRpY29ue21hcmdpbjowfS5hbnQtYXZhdGFyLXNte3dpZHRoOjI0cHg7aGVpZ2h0OjI0cHg7bGluZS1oZWlnaHQ6MjRweDtib3JkZXItcmFkaXVzOjUwJX0uYW50LWF2YXRhci1zbS1zdHJpbmd7cG9zaXRpb246YWJzb2x1dGU7bGVmdDo1MCU7dHJhbnNmb3JtLW9yaWdpbjowIGNlbnRlcn0uYW50LWF2YXRhci1zbS5hbnQtYXZhdGFyLWljb257Zm9udC1zaXplOjE0cHh9LmFudC1hdmF0YXItc20uYW50LWF2YXRhci1pY29uPi5hbnRpY29ue21hcmdpbjowfS5hbnQtYXZhdGFyLXNxdWFyZXtib3JkZXItcmFkaXVzOjJweH0uYW50LWF2YXRhcj5pbWd7ZGlzcGxheTpibG9jazt3aWR0aDoxMDAlO2hlaWdodDoxMDAlOy1vLW9iamVjdC1maXQ6Y292ZXI7b2JqZWN0LWZpdDpjb3Zlcn0uYW50LWF2YXRhci1ncm91cHtkaXNwbGF5OmlubGluZS1mbGV4fS5hbnQtYXZhdGFyLWdyb3VwIC5hbnQtYXZhdGFye2JvcmRlcjoxcHggc29saWQgI2ZmZn0uYW50LWF2YXRhci1ncm91cCAuYW50LWF2YXRhcjpub3QoOmZpcnN0LWNoaWxkKXttYXJnaW4tbGVmdDotOHB4fS5hbnQtYXZhdGFyLWdyb3VwLXBvcG92ZXIgLmFudC1hdmF0YXIrLmFudC1hdmF0YXJ7bWFyZ2luLWxlZnQ6M3B4fS5hbnQtYXZhdGFyLWdyb3VwLXJ0bCAuYW50LWF2YXRhcjpub3QoOmZpcnN0LWNoaWxkKXttYXJnaW4tcmlnaHQ6LThweDttYXJnaW4tbGVmdDowfS5hbnQtYXZhdGFyLWdyb3VwLXBvcG92ZXIuYW50LXBvcG92ZXItcnRsIC5hbnQtYXZhdGFyKy5hbnQtYXZhdGFye21hcmdpbi1yaWdodDozcHg7bWFyZ2luLWxlZnQ6MH0uYW50LWJhY2stdG9we2JveC1zaXppbmc6Ym9yZGVyLWJveDttYXJnaW46MDtwYWRkaW5nOjA7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtc2l6ZToxNHB4O2ZvbnQtdmFyaWFudDp0YWJ1bGFyLW51bXM7bGluZS1oZWlnaHQ6MS41NzE1O2xpc3Qtc3R5bGU6bm9uZTtmb250LWZlYXR1cmUtc2V0dGluZ3M6XCJ0bnVtXCI7cG9zaXRpb246Zml4ZWQ7cmlnaHQ6MTAwcHg7Ym90dG9tOjUwcHg7ei1pbmRleDoxMDt3aWR0aDo0MHB4O2hlaWdodDo0MHB4O2N1cnNvcjpwb2ludGVyfS5hbnQtYmFjay10b3A6ZW1wdHl7ZGlzcGxheTpub25lfS5hbnQtYmFjay10b3AtcnRse3JpZ2h0OmF1dG87bGVmdDoxMDBweDtkaXJlY3Rpb246cnRsfS5hbnQtYmFjay10b3AtY29udGVudHt3aWR0aDo0MHB4O2hlaWdodDo0MHB4O292ZXJmbG93OmhpZGRlbjtjb2xvcjojZmZmO3RleHQtYWxpZ246Y2VudGVyO2JhY2tncm91bmQtY29sb3I6cmdiYSgwLDAsMCwuNDUpO2JvcmRlci1yYWRpdXM6MjBweDt0cmFuc2l0aW9uOmFsbCAuM3N9LmFudC1iYWNrLXRvcC1jb250ZW50OmhvdmVye2JhY2tncm91bmQtY29sb3I6cmdiYSgwLDAsMCwuODUpO3RyYW5zaXRpb246YWxsIC4zc30uYW50LWJhY2stdG9wLWljb257Zm9udC1zaXplOjI0cHg7bGluZS1oZWlnaHQ6NDBweH1AbWVkaWEgc2NyZWVuIGFuZCAobWF4LXdpZHRoOjc2OHB4KXsuYW50LWJhY2stdG9we3JpZ2h0OjYwcHh9LmFudC1iYWNrLXRvcC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjYwcHh9fUBtZWRpYSBzY3JlZW4gYW5kIChtYXgtd2lkdGg6NDgwcHgpey5hbnQtYmFjay10b3B7cmlnaHQ6MjBweH0uYW50LWJhY2stdG9wLXJ0bHtyaWdodDphdXRvO2xlZnQ6MjBweH19LmFudC1iYWRnZXtib3gtc2l6aW5nOmJvcmRlci1ib3g7bWFyZ2luOjA7cGFkZGluZzowO2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtmb250LXNpemU6MTRweDtmb250LXZhcmlhbnQ6dGFidWxhci1udW1zO2xpbmUtaGVpZ2h0OjEuNTcxNTtsaXN0LXN0eWxlOm5vbmU7Zm9udC1mZWF0dXJlLXNldHRpbmdzOlwidG51bVwiO3Bvc2l0aW9uOnJlbGF0aXZlO2Rpc3BsYXk6aW5saW5lLWJsb2NrO2xpbmUtaGVpZ2h0OjF9LmFudC1iYWRnZS1jb3VudHt6LWluZGV4OmF1dG87bWluLXdpZHRoOjIwcHg7aGVpZ2h0OjIwcHg7cGFkZGluZzowIDZweDtjb2xvcjojZmZmO2ZvbnQtd2VpZ2h0OjQwMDtmb250LXNpemU6MTJweDtsaW5lLWhlaWdodDoyMHB4O3doaXRlLXNwYWNlOm5vd3JhcDt0ZXh0LWFsaWduOmNlbnRlcjtiYWNrZ3JvdW5kOiNmZjRkNGY7Ym9yZGVyLXJhZGl1czoxMHB4O2JveC1zaGFkb3c6MCAwIDAgMXB4ICNmZmZ9LmFudC1iYWRnZS1jb3VudCBhLC5hbnQtYmFkZ2UtY291bnQgYTpob3Zlcntjb2xvcjojZmZmfS5hbnQtYmFkZ2UtY291bnQtc217bWluLXdpZHRoOjE0cHg7aGVpZ2h0OjE0cHg7cGFkZGluZzowO2ZvbnQtc2l6ZToxMnB4O2xpbmUtaGVpZ2h0OjE0cHg7Ym9yZGVyLXJhZGl1czo3cHh9LmFudC1iYWRnZS1tdWx0aXBsZS13b3Jkc3twYWRkaW5nOjAgOHB4fS5hbnQtYmFkZ2UtZG90e3otaW5kZXg6YXV0bzt3aWR0aDo2cHg7bWluLXdpZHRoOjZweDtoZWlnaHQ6NnB4O2JhY2tncm91bmQ6I2ZmNGQ0Zjtib3JkZXItcmFkaXVzOjEwMCU7Ym94LXNoYWRvdzowIDAgMCAxcHggI2ZmZn0uYW50LWJhZGdlLWRvdC5hbnQtc2Nyb2xsLW51bWJlcnt0cmFuc2l0aW9uOmJhY2tncm91bmQgMS41c30uYW50LWJhZGdlLWNvdW50LC5hbnQtYmFkZ2UtZG90LC5hbnQtYmFkZ2UgLmFudC1zY3JvbGwtbnVtYmVyLWN1c3RvbS1jb21wb25lbnR7cG9zaXRpb246YWJzb2x1dGU7dG9wOjA7cmlnaHQ6MDt0cmFuc2Zvcm06dHJhbnNsYXRlKDUwJSwtNTAlKTt0cmFuc2Zvcm0tb3JpZ2luOjEwMCUgMH0uYW50LWJhZGdlLWNvdW50LmFudGljb24tc3BpbiwuYW50LWJhZGdlLWRvdC5hbnRpY29uLXNwaW4sLmFudC1iYWRnZSAuYW50LXNjcm9sbC1udW1iZXItY3VzdG9tLWNvbXBvbmVudC5hbnRpY29uLXNwaW57YW5pbWF0aW9uOmFudEJhZGdlTG9hZGluZ0NpcmNsZSAxcyBsaW5lYXIgaW5maW5pdGV9LmFudC1iYWRnZS1zdGF0dXN7bGluZS1oZWlnaHQ6aW5oZXJpdDt2ZXJ0aWNhbC1hbGlnbjpiYXNlbGluZX0uYW50LWJhZGdlLXN0YXR1cy1kb3R7cG9zaXRpb246cmVsYXRpdmU7dG9wOi0xcHg7ZGlzcGxheTppbmxpbmUtYmxvY2s7d2lkdGg6NnB4O2hlaWdodDo2cHg7dmVydGljYWwtYWxpZ246bWlkZGxlO2JvcmRlci1yYWRpdXM6NTAlfS5hbnQtYmFkZ2Utc3RhdHVzLXN1Y2Nlc3N7YmFja2dyb3VuZC1jb2xvcjojNTJjNDFhfS5hbnQtYmFkZ2Utc3RhdHVzLXByb2Nlc3Npbmd7cG9zaXRpb246cmVsYXRpdmU7YmFja2dyb3VuZC1jb2xvcjojMTg5MGZmfS5hbnQtYmFkZ2Utc3RhdHVzLXByb2Nlc3Npbmc6YWZ0ZXJ7cG9zaXRpb246YWJzb2x1dGU7dG9wOjA7bGVmdDowO3dpZHRoOjEwMCU7aGVpZ2h0OjEwMCU7Ym9yZGVyOjFweCBzb2xpZCAjMTg5MGZmO2JvcmRlci1yYWRpdXM6NTAlO2FuaW1hdGlvbjphbnRTdGF0dXNQcm9jZXNzaW5nIDEuMnMgZWFzZS1pbi1vdXQgaW5maW5pdGU7Y29udGVudDpcIlwifS5hbnQtYmFkZ2Utc3RhdHVzLWRlZmF1bHR7YmFja2dyb3VuZC1jb2xvcjojZDlkOWQ5fS5hbnQtYmFkZ2Utc3RhdHVzLWVycm9ye2JhY2tncm91bmQtY29sb3I6I2ZmNGQ0Zn0uYW50LWJhZGdlLXN0YXR1cy13YXJuaW5ne2JhY2tncm91bmQtY29sb3I6I2ZhYWQxNH0uYW50LWJhZGdlLXN0YXR1cy1tYWdlbnRhLC5hbnQtYmFkZ2Utc3RhdHVzLXBpbmt7YmFja2dyb3VuZDojZWIyZjk2fS5hbnQtYmFkZ2Utc3RhdHVzLXJlZHtiYWNrZ3JvdW5kOiNmNTIyMmR9LmFudC1iYWRnZS1zdGF0dXMtdm9sY2Fub3tiYWNrZ3JvdW5kOiNmYTU0MWN9LmFudC1iYWRnZS1zdGF0dXMtb3Jhbmdle2JhY2tncm91bmQ6I2ZhOGMxNn0uYW50LWJhZGdlLXN0YXR1cy15ZWxsb3d7YmFja2dyb3VuZDojZmFkYjE0fS5hbnQtYmFkZ2Utc3RhdHVzLWdvbGR7YmFja2dyb3VuZDojZmFhZDE0fS5hbnQtYmFkZ2Utc3RhdHVzLWN5YW57YmFja2dyb3VuZDojMTNjMmMyfS5hbnQtYmFkZ2Utc3RhdHVzLWxpbWV7YmFja2dyb3VuZDojYTBkOTExfS5hbnQtYmFkZ2Utc3RhdHVzLWdyZWVue2JhY2tncm91bmQ6IzUyYzQxYX0uYW50LWJhZGdlLXN0YXR1cy1ibHVle2JhY2tncm91bmQ6IzE4OTBmZn0uYW50LWJhZGdlLXN0YXR1cy1nZWVrYmx1ZXtiYWNrZ3JvdW5kOiMyZjU0ZWJ9LmFudC1iYWRnZS1zdGF0dXMtcHVycGxle2JhY2tncm91bmQ6IzcyMmVkMX0uYW50LWJhZGdlLXN0YXR1cy10ZXh0e21hcmdpbi1sZWZ0OjhweDtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7Zm9udC1zaXplOjE0cHh9LmFudC1iYWRnZS16b29tLWFwcGVhciwuYW50LWJhZGdlLXpvb20tZW50ZXJ7YW5pbWF0aW9uOmFudFpvb21CYWRnZUluIC4zcyBjdWJpYy1iZXppZXIoLjEyLC40LC4yOSwxLjQ2KTthbmltYXRpb24tZmlsbC1tb2RlOmJvdGh9LmFudC1iYWRnZS16b29tLWxlYXZle2FuaW1hdGlvbjphbnRab29tQmFkZ2VPdXQgLjNzIGN1YmljLWJlemllciguNzEsLS40NiwuODgsLjYpO2FuaW1hdGlvbi1maWxsLW1vZGU6Ym90aH0uYW50LWJhZGdlLW5vdC1hLXdyYXBwZXIgLmFudC1iYWRnZS16b29tLWFwcGVhciwuYW50LWJhZGdlLW5vdC1hLXdyYXBwZXIgLmFudC1iYWRnZS16b29tLWVudGVye2FuaW1hdGlvbjphbnROb1dyYXBwZXJab29tQmFkZ2VJbiAuM3MgY3ViaWMtYmV6aWVyKC4xMiwuNCwuMjksMS40Nil9LmFudC1iYWRnZS1ub3QtYS13cmFwcGVyIC5hbnQtYmFkZ2Utem9vbS1sZWF2ZXthbmltYXRpb246YW50Tm9XcmFwcGVyWm9vbUJhZGdlT3V0IC4zcyBjdWJpYy1iZXppZXIoLjcxLC0uNDYsLjg4LC42KX0uYW50LWJhZGdlLW5vdC1hLXdyYXBwZXI6bm90KC5hbnQtYmFkZ2Utc3RhdHVzKXt2ZXJ0aWNhbC1hbGlnbjptaWRkbGV9LmFudC1iYWRnZS1ub3QtYS13cmFwcGVyIC5hbnQtYmFkZ2UtY291bnQsLmFudC1iYWRnZS1ub3QtYS13cmFwcGVyIC5hbnQtc2Nyb2xsLW51bWJlci1jdXN0b20tY29tcG9uZW50e3RyYW5zZm9ybTpub25lfS5hbnQtYmFkZ2Utbm90LWEtd3JhcHBlciAuYW50LXNjcm9sbC1udW1iZXIsLmFudC1iYWRnZS1ub3QtYS13cmFwcGVyIC5hbnQtc2Nyb2xsLW51bWJlci1jdXN0b20tY29tcG9uZW50e3Bvc2l0aW9uOnJlbGF0aXZlO3RvcDphdXRvO2Rpc3BsYXk6YmxvY2s7dHJhbnNmb3JtLW9yaWdpbjo1MCUgNTAlfUBrZXlmcmFtZXMgYW50U3RhdHVzUHJvY2Vzc2luZ3swJXt0cmFuc2Zvcm06c2NhbGUoLjgpO29wYWNpdHk6LjV9dG97dHJhbnNmb3JtOnNjYWxlKDIuNCk7b3BhY2l0eTowfX0uYW50LXNjcm9sbC1udW1iZXJ7b3ZlcmZsb3c6aGlkZGVuO2RpcmVjdGlvbjpsdHJ9LmFudC1zY3JvbGwtbnVtYmVyLW9ubHl7cG9zaXRpb246cmVsYXRpdmU7ZGlzcGxheTppbmxpbmUtYmxvY2s7dHJhbnNpdGlvbjphbGwgLjNzIGN1YmljLWJlemllciguNjQ1LC4wNDUsLjM1NSwxKX0uYW50LXNjcm9sbC1udW1iZXItb25seSwuYW50LXNjcm9sbC1udW1iZXItb25seT5wLmFudC1zY3JvbGwtbnVtYmVyLW9ubHktdW5pdHtoZWlnaHQ6MjBweDstd2Via2l0LXRyYW5zZm9ybS1zdHlsZTpwcmVzZXJ2ZS0zZDstd2Via2l0LWJhY2tmYWNlLXZpc2liaWxpdHk6aGlkZGVufS5hbnQtc2Nyb2xsLW51bWJlci1vbmx5PnAuYW50LXNjcm9sbC1udW1iZXItb25seS11bml0e21hcmdpbjowfS5hbnQtc2Nyb2xsLW51bWJlci1zeW1ib2x7dmVydGljYWwtYWxpZ246dG9wfUBrZXlmcmFtZXMgYW50Wm9vbUJhZGdlSW57MCV7dHJhbnNmb3JtOnNjYWxlKDApIHRyYW5zbGF0ZSg1MCUsLTUwJSk7b3BhY2l0eTowfXRve3RyYW5zZm9ybTpzY2FsZSgxKSB0cmFuc2xhdGUoNTAlLC01MCUpfX1Aa2V5ZnJhbWVzIGFudFpvb21CYWRnZU91dHswJXt0cmFuc2Zvcm06c2NhbGUoMSkgdHJhbnNsYXRlKDUwJSwtNTAlKX10b3t0cmFuc2Zvcm06c2NhbGUoMCkgdHJhbnNsYXRlKDUwJSwtNTAlKTtvcGFjaXR5OjB9fUBrZXlmcmFtZXMgYW50Tm9XcmFwcGVyWm9vbUJhZGdlSW57MCV7dHJhbnNmb3JtOnNjYWxlKDApO29wYWNpdHk6MH10b3t0cmFuc2Zvcm06c2NhbGUoMSl9fUBrZXlmcmFtZXMgYW50Tm9XcmFwcGVyWm9vbUJhZGdlT3V0ezAle3RyYW5zZm9ybTpzY2FsZSgxKX10b3t0cmFuc2Zvcm06c2NhbGUoMCk7b3BhY2l0eTowfX1Aa2V5ZnJhbWVzIGFudEJhZGdlTG9hZGluZ0NpcmNsZXswJXt0cmFuc2Zvcm0tb3JpZ2luOjUwJX10b3t0cmFuc2Zvcm06dHJhbnNsYXRlKDUwJSwtNTAlKSByb3RhdGUoMXR1cm4pO3RyYW5zZm9ybS1vcmlnaW46NTAlfX0uYW50LXJpYmJvbi13cmFwcGVye3Bvc2l0aW9uOnJlbGF0aXZlfS5hbnQtcmliYm9ue2JveC1zaXppbmc6Ym9yZGVyLWJveDttYXJnaW46MDtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7Zm9udC1zaXplOjE0cHg7Zm9udC12YXJpYW50OnRhYnVsYXItbnVtcztsaW5lLWhlaWdodDoxLjU3MTU7bGlzdC1zdHlsZTpub25lO2ZvbnQtZmVhdHVyZS1zZXR0aW5nczpcInRudW1cIjtwb3NpdGlvbjphYnNvbHV0ZTt0b3A6OHB4O2hlaWdodDoyMnB4O3BhZGRpbmc6MCA4cHg7Y29sb3I6I2ZmZjtsaW5lLWhlaWdodDoyMnB4O3doaXRlLXNwYWNlOm5vd3JhcDtiYWNrZ3JvdW5kLWNvbG9yOiMxODkwZmY7Ym9yZGVyLXJhZGl1czoycHh9LmFudC1yaWJib24tdGV4dHtjb2xvcjojZmZmfS5hbnQtcmliYm9uLWNvcm5lcntwb3NpdGlvbjphYnNvbHV0ZTt0b3A6MTAwJTt3aWR0aDo4cHg7aGVpZ2h0OjhweDtjb2xvcjpjdXJyZW50Y29sb3I7Ym9yZGVyOjRweCBzb2xpZDt0cmFuc2Zvcm06c2NhbGVZKC43NSk7dHJhbnNmb3JtLW9yaWdpbjp0b3B9LmFudC1yaWJib24tY29ybmVyOmFmdGVye3Bvc2l0aW9uOmFic29sdXRlO3RvcDotNHB4O2xlZnQ6LTRweDt3aWR0aDppbmhlcml0O2hlaWdodDppbmhlcml0O2NvbG9yOnJnYmEoMCwwLDAsLjI1KTtib3JkZXI6aW5oZXJpdDtjb250ZW50OlwiXCJ9LmFudC1yaWJib24tY29sb3ItbWFnZW50YSwuYW50LXJpYmJvbi1jb2xvci1waW5re2NvbG9yOiNlYjJmOTY7YmFja2dyb3VuZDojZWIyZjk2fS5hbnQtcmliYm9uLWNvbG9yLXJlZHtjb2xvcjojZjUyMjJkO2JhY2tncm91bmQ6I2Y1MjIyZH0uYW50LXJpYmJvbi1jb2xvci12b2xjYW5ve2NvbG9yOiNmYTU0MWM7YmFja2dyb3VuZDojZmE1NDFjfS5hbnQtcmliYm9uLWNvbG9yLW9yYW5nZXtjb2xvcjojZmE4YzE2O2JhY2tncm91bmQ6I2ZhOGMxNn0uYW50LXJpYmJvbi1jb2xvci15ZWxsb3d7Y29sb3I6I2ZhZGIxNDtiYWNrZ3JvdW5kOiNmYWRiMTR9LmFudC1yaWJib24tY29sb3ItZ29sZHtjb2xvcjojZmFhZDE0O2JhY2tncm91bmQ6I2ZhYWQxNH0uYW50LXJpYmJvbi1jb2xvci1jeWFue2NvbG9yOiMxM2MyYzI7YmFja2dyb3VuZDojMTNjMmMyfS5hbnQtcmliYm9uLWNvbG9yLWxpbWV7Y29sb3I6I2EwZDkxMTtiYWNrZ3JvdW5kOiNhMGQ5MTF9LmFudC1yaWJib24tY29sb3ItZ3JlZW57Y29sb3I6IzUyYzQxYTtiYWNrZ3JvdW5kOiM1MmM0MWF9LmFudC1yaWJib24tY29sb3ItYmx1ZXtjb2xvcjojMTg5MGZmO2JhY2tncm91bmQ6IzE4OTBmZn0uYW50LXJpYmJvbi1jb2xvci1nZWVrYmx1ZXtjb2xvcjojMmY1NGViO2JhY2tncm91bmQ6IzJmNTRlYn0uYW50LXJpYmJvbi1jb2xvci1wdXJwbGV7Y29sb3I6IzcyMmVkMTtiYWNrZ3JvdW5kOiM3MjJlZDF9LmFudC1yaWJib24uYW50LXJpYmJvbi1wbGFjZW1lbnQtZW5ke3JpZ2h0Oi04cHg7Ym9yZGVyLWJvdHRvbS1yaWdodC1yYWRpdXM6MH0uYW50LXJpYmJvbi5hbnQtcmliYm9uLXBsYWNlbWVudC1lbmQgLmFudC1yaWJib24tY29ybmVye3JpZ2h0OjA7Ym9yZGVyLWNvbG9yOmN1cnJlbnRjb2xvciB0cmFuc3BhcmVudCB0cmFuc3BhcmVudCBjdXJyZW50Y29sb3J9LmFudC1yaWJib24uYW50LXJpYmJvbi1wbGFjZW1lbnQtc3RhcnR7bGVmdDotOHB4O2JvcmRlci1ib3R0b20tbGVmdC1yYWRpdXM6MH0uYW50LXJpYmJvbi5hbnQtcmliYm9uLXBsYWNlbWVudC1zdGFydCAuYW50LXJpYmJvbi1jb3JuZXJ7bGVmdDowO2JvcmRlci1jb2xvcjpjdXJyZW50Y29sb3IgY3VycmVudGNvbG9yIHRyYW5zcGFyZW50IHRyYW5zcGFyZW50fS5hbnQtYmFkZ2UtcnRse2RpcmVjdGlvbjpydGx9LmFudC1iYWRnZS1ydGwuYW50LWJhZGdlOm5vdCguYW50LWJhZGdlLW5vdC1hLXdyYXBwZXIpIC5hbnQtYmFkZ2UtY291bnQsLmFudC1iYWRnZS1ydGwuYW50LWJhZGdlOm5vdCguYW50LWJhZGdlLW5vdC1hLXdyYXBwZXIpIC5hbnQtYmFkZ2UtZG90LC5hbnQtYmFkZ2UtcnRsLmFudC1iYWRnZTpub3QoLmFudC1iYWRnZS1ub3QtYS13cmFwcGVyKSAuYW50LXNjcm9sbC1udW1iZXItY3VzdG9tLWNvbXBvbmVudHtyaWdodDphdXRvO2xlZnQ6MDtkaXJlY3Rpb246bHRyO3RyYW5zZm9ybTp0cmFuc2xhdGUoLTUwJSwtNTAlKTt0cmFuc2Zvcm0tb3JpZ2luOjAgMH0uYW50LWJhZGdlLXJ0bC5hbnQtYmFkZ2U6bm90KC5hbnQtYmFkZ2Utbm90LWEtd3JhcHBlcikgLmFudC1zY3JvbGwtbnVtYmVyLWN1c3RvbS1jb21wb25lbnR7cmlnaHQ6YXV0bztsZWZ0OjA7dHJhbnNmb3JtOnRyYW5zbGF0ZSgtNTAlLC01MCUpO3RyYW5zZm9ybS1vcmlnaW46MCAwfS5hbnQtYmFkZ2UtcnRsIC5hbnQtYmFkZ2Utc3RhdHVzLXRleHR7bWFyZ2luLXJpZ2h0OjhweDttYXJnaW4tbGVmdDowfS5hbnQtYmFkZ2U6bm90KC5hbnQtYmFkZ2Utbm90LWEtd3JhcHBlcikuYW50LWJhZGdlLXJ0bCAuYW50LWJhZGdlLXpvb20tYXBwZWFyLC5hbnQtYmFkZ2U6bm90KC5hbnQtYmFkZ2Utbm90LWEtd3JhcHBlcikuYW50LWJhZGdlLXJ0bCAuYW50LWJhZGdlLXpvb20tZW50ZXJ7YW5pbWF0aW9uLW5hbWU6YW50Wm9vbUJhZGdlSW5SdGx9LmFudC1iYWRnZTpub3QoLmFudC1iYWRnZS1ub3QtYS13cmFwcGVyKS5hbnQtYmFkZ2UtcnRsIC5hbnQtYmFkZ2Utem9vbS1sZWF2ZXthbmltYXRpb24tbmFtZTphbnRab29tQmFkZ2VPdXRSdGx9LmFudC1yaWJib24tcnRse2RpcmVjdGlvbjpydGx9LmFudC1yaWJib24tcnRsLmFudC1yaWJib24tcGxhY2VtZW50LWVuZHtyaWdodDp1bnNldDtsZWZ0Oi04cHg7Ym9yZGVyLWJvdHRvbS1yaWdodC1yYWRpdXM6MnB4O2JvcmRlci1ib3R0b20tbGVmdC1yYWRpdXM6MH0uYW50LXJpYmJvbi1ydGwuYW50LXJpYmJvbi1wbGFjZW1lbnQtZW5kIC5hbnQtcmliYm9uLWNvcm5lcntyaWdodDp1bnNldDtsZWZ0OjB9LmFudC1yaWJib24tcnRsLmFudC1yaWJib24tcGxhY2VtZW50LWVuZCAuYW50LXJpYmJvbi1jb3JuZXIsLmFudC1yaWJib24tcnRsLmFudC1yaWJib24tcGxhY2VtZW50LWVuZCAuYW50LXJpYmJvbi1jb3JuZXI6YWZ0ZXJ7Ym9yZGVyLWNvbG9yOmN1cnJlbnRjb2xvciBjdXJyZW50Y29sb3IgdHJhbnNwYXJlbnQgdHJhbnNwYXJlbnR9LmFudC1yaWJib24tcnRsLmFudC1yaWJib24tcGxhY2VtZW50LXN0YXJ0e3JpZ2h0Oi04cHg7bGVmdDp1bnNldDtib3JkZXItYm90dG9tLXJpZ2h0LXJhZGl1czowO2JvcmRlci1ib3R0b20tbGVmdC1yYWRpdXM6MnB4fS5hbnQtcmliYm9uLXJ0bC5hbnQtcmliYm9uLXBsYWNlbWVudC1zdGFydCAuYW50LXJpYmJvbi1jb3JuZXJ7cmlnaHQ6MDtsZWZ0OnVuc2V0fS5hbnQtcmliYm9uLXJ0bC5hbnQtcmliYm9uLXBsYWNlbWVudC1zdGFydCAuYW50LXJpYmJvbi1jb3JuZXIsLmFudC1yaWJib24tcnRsLmFudC1yaWJib24tcGxhY2VtZW50LXN0YXJ0IC5hbnQtcmliYm9uLWNvcm5lcjphZnRlcntib3JkZXItY29sb3I6Y3VycmVudGNvbG9yIHRyYW5zcGFyZW50IHRyYW5zcGFyZW50IGN1cnJlbnRjb2xvcn1Aa2V5ZnJhbWVzIGFudFpvb21CYWRnZUluUnRsezAle3RyYW5zZm9ybTpzY2FsZSgwKSB0cmFuc2xhdGUoLTUwJSwtNTAlKTtvcGFjaXR5OjB9dG97dHJhbnNmb3JtOnNjYWxlKDEpIHRyYW5zbGF0ZSgtNTAlLC01MCUpfX1Aa2V5ZnJhbWVzIGFudFpvb21CYWRnZU91dFJ0bHswJXt0cmFuc2Zvcm06c2NhbGUoMSkgdHJhbnNsYXRlKC01MCUsLTUwJSl9dG97dHJhbnNmb3JtOnNjYWxlKDApIHRyYW5zbGF0ZSgtNTAlLC01MCUpO29wYWNpdHk6MH19LmFudC1icmVhZGNydW1ie2JveC1zaXppbmc6Ym9yZGVyLWJveDttYXJnaW46MDtwYWRkaW5nOjA7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtdmFyaWFudDp0YWJ1bGFyLW51bXM7bGluZS1oZWlnaHQ6MS41NzE1O2xpc3Qtc3R5bGU6bm9uZTtmb250LWZlYXR1cmUtc2V0dGluZ3M6XCJ0bnVtXCI7Y29sb3I6cmdiYSgwLDAsMCwuNDUpO2ZvbnQtc2l6ZToxNHB4fS5hbnQtYnJlYWRjcnVtYiAuYW50aWNvbntmb250LXNpemU6MTRweH0uYW50LWJyZWFkY3J1bWIgb2x7ZGlzcGxheTpmbGV4O2ZsZXgtd3JhcDp3cmFwO21hcmdpbjowO3BhZGRpbmc6MDtsaXN0LXN0eWxlOm5vbmV9LmFudC1icmVhZGNydW1iIGF7Y29sb3I6cmdiYSgwLDAsMCwuNDUpO3RyYW5zaXRpb246Y29sb3IgLjNzfS5hbnQtYnJlYWRjcnVtYiBhOmhvdmVyLC5hbnQtYnJlYWRjcnVtYiBsaTpsYXN0LWNoaWxkLC5hbnQtYnJlYWRjcnVtYiBsaTpsYXN0LWNoaWxkIGF7Y29sb3I6cmdiYSgwLDAsMCwuODUpfWxpOmxhc3QtY2hpbGQ+LmFudC1icmVhZGNydW1iLXNlcGFyYXRvcntkaXNwbGF5Om5vbmV9LmFudC1icmVhZGNydW1iLXNlcGFyYXRvcnttYXJnaW46MCA4cHg7Y29sb3I6cmdiYSgwLDAsMCwuNDUpfS5hbnQtYnJlYWRjcnVtYi1saW5rPi5hbnRpY29uK2EsLmFudC1icmVhZGNydW1iLWxpbms+LmFudGljb24rc3BhbiwuYW50LWJyZWFkY3J1bWItb3ZlcmxheS1saW5rPi5hbnRpY29ue21hcmdpbi1sZWZ0OjRweH0uYW50LWJyZWFkY3J1bWItcnRse2RpcmVjdGlvbjpydGx9LmFudC1icmVhZGNydW1iLXJ0bDpiZWZvcmV7ZGlzcGxheTp0YWJsZTtjb250ZW50OlwiXCJ9LmFudC1icmVhZGNydW1iLXJ0bDphZnRlcntkaXNwbGF5OnRhYmxlO2NsZWFyOmJvdGg7Y29udGVudDpcIlwifS5hbnQtYnJlYWRjcnVtYi1ydGw+c3BhbntmbG9hdDpyaWdodH0uYW50LWJyZWFkY3J1bWItcnRsIC5hbnQtYnJlYWRjcnVtYi1saW5rPi5hbnRpY29uK2EsLmFudC1icmVhZGNydW1iLXJ0bCAuYW50LWJyZWFkY3J1bWItbGluaz4uYW50aWNvbitzcGFuLC5hbnQtYnJlYWRjcnVtYi1ydGwgLmFudC1icmVhZGNydW1iLW92ZXJsYXktbGluaz4uYW50aWNvbnttYXJnaW4tcmlnaHQ6NHB4O21hcmdpbi1sZWZ0OjB9LmFudC1idG57bGluZS1oZWlnaHQ6MS41NzE1O3Bvc2l0aW9uOnJlbGF0aXZlO2Rpc3BsYXk6aW5saW5lLWJsb2NrO2ZvbnQtd2VpZ2h0OjQwMDt3aGl0ZS1zcGFjZTpub3dyYXA7dGV4dC1hbGlnbjpjZW50ZXI7YmFja2dyb3VuZC1pbWFnZTpub25lO2JveC1zaGFkb3c6MCAycHggMCByZ2JhKDAsMCwwLC4wMTUpO2N1cnNvcjpwb2ludGVyO3RyYW5zaXRpb246YWxsIC4zcyBjdWJpYy1iZXppZXIoLjY0NSwuMDQ1LC4zNTUsMSk7LXdlYmtpdC11c2VyLXNlbGVjdDpub25lOy1tb3otdXNlci1zZWxlY3Q6bm9uZTstbXMtdXNlci1zZWxlY3Q6bm9uZTt1c2VyLXNlbGVjdDpub25lO3RvdWNoLWFjdGlvbjptYW5pcHVsYXRpb247aGVpZ2h0OjMycHg7cGFkZGluZzo0cHggMTVweDtmb250LXNpemU6MTRweDtib3JkZXItcmFkaXVzOjJweDtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7Ym9yZGVyOjFweCBzb2xpZCAjZDlkOWQ5O2JhY2tncm91bmQ6I2ZmZn0uYW50LWJ0bj4uYW50aWNvbntsaW5lLWhlaWdodDoxfS5hbnQtYnRuLC5hbnQtYnRuOmFjdGl2ZSwuYW50LWJ0bjpmb2N1c3tvdXRsaW5lOjB9LmFudC1idG46bm90KFtkaXNhYmxlZF0pOmhvdmVye3RleHQtZGVjb3JhdGlvbjpub25lfS5hbnQtYnRuOm5vdChbZGlzYWJsZWRdKTphY3RpdmV7b3V0bGluZTowO2JveC1zaGFkb3c6bm9uZX0uYW50LWJ0bltkaXNhYmxlZF17Y3Vyc29yOm5vdC1hbGxvd2VkfS5hbnQtYnRuW2Rpc2FibGVkXT4qe3BvaW50ZXItZXZlbnRzOm5vbmV9LmFudC1idG4tbGd7aGVpZ2h0OjQwcHg7cGFkZGluZzo2LjRweCAxNXB4O2ZvbnQtc2l6ZToxNnB4O2JvcmRlci1yYWRpdXM6MnB4fS5hbnQtYnRuLXNte2hlaWdodDoyNHB4O3BhZGRpbmc6MCA3cHg7Zm9udC1zaXplOjE0cHg7Ym9yZGVyLXJhZGl1czoycHh9LmFudC1idG4+YTpvbmx5LWNoaWxke2NvbG9yOmN1cnJlbnRjb2xvcn0uYW50LWJ0bj5hOm9ubHktY2hpbGQ6YWZ0ZXJ7cG9zaXRpb246YWJzb2x1dGU7dG9wOjA7cmlnaHQ6MDtib3R0b206MDtsZWZ0OjA7YmFja2dyb3VuZDp0cmFuc3BhcmVudDtjb250ZW50OlwiXCJ9LmFudC1idG46Zm9jdXMsLmFudC1idG46aG92ZXJ7Y29sb3I6IzQwYTlmZjtib3JkZXItY29sb3I6IzQwYTlmZjtiYWNrZ3JvdW5kOiNmZmZ9LmFudC1idG46Zm9jdXM+YTpvbmx5LWNoaWxkLC5hbnQtYnRuOmhvdmVyPmE6b25seS1jaGlsZHtjb2xvcjpjdXJyZW50Y29sb3J9LmFudC1idG46Zm9jdXM+YTpvbmx5LWNoaWxkOmFmdGVyLC5hbnQtYnRuOmhvdmVyPmE6b25seS1jaGlsZDphZnRlcntwb3NpdGlvbjphYnNvbHV0ZTt0b3A6MDtyaWdodDowO2JvdHRvbTowO2xlZnQ6MDtiYWNrZ3JvdW5kOnRyYW5zcGFyZW50O2NvbnRlbnQ6XCJcIn0uYW50LWJ0bjphY3RpdmV7Y29sb3I6IzA5NmRkOTtib3JkZXItY29sb3I6IzA5NmRkOTtiYWNrZ3JvdW5kOiNmZmZ9LmFudC1idG46YWN0aXZlPmE6b25seS1jaGlsZHtjb2xvcjpjdXJyZW50Y29sb3J9LmFudC1idG46YWN0aXZlPmE6b25seS1jaGlsZDphZnRlcntwb3NpdGlvbjphYnNvbHV0ZTt0b3A6MDtyaWdodDowO2JvdHRvbTowO2xlZnQ6MDtiYWNrZ3JvdW5kOnRyYW5zcGFyZW50O2NvbnRlbnQ6XCJcIn0uYW50LWJ0bltkaXNhYmxlZF0sLmFudC1idG5bZGlzYWJsZWRdOmFjdGl2ZSwuYW50LWJ0bltkaXNhYmxlZF06Zm9jdXMsLmFudC1idG5bZGlzYWJsZWRdOmhvdmVye2NvbG9yOnJnYmEoMCwwLDAsLjI1KTtib3JkZXItY29sb3I6I2Q5ZDlkOTtiYWNrZ3JvdW5kOiNmNWY1ZjU7dGV4dC1zaGFkb3c6bm9uZTtib3gtc2hhZG93Om5vbmV9LmFudC1idG5bZGlzYWJsZWRdOmFjdGl2ZT5hOm9ubHktY2hpbGQsLmFudC1idG5bZGlzYWJsZWRdOmZvY3VzPmE6b25seS1jaGlsZCwuYW50LWJ0bltkaXNhYmxlZF06aG92ZXI+YTpvbmx5LWNoaWxkLC5hbnQtYnRuW2Rpc2FibGVkXT5hOm9ubHktY2hpbGR7Y29sb3I6Y3VycmVudGNvbG9yfS5hbnQtYnRuW2Rpc2FibGVkXTphY3RpdmU+YTpvbmx5LWNoaWxkOmFmdGVyLC5hbnQtYnRuW2Rpc2FibGVkXTpmb2N1cz5hOm9ubHktY2hpbGQ6YWZ0ZXIsLmFudC1idG5bZGlzYWJsZWRdOmhvdmVyPmE6b25seS1jaGlsZDphZnRlciwuYW50LWJ0bltkaXNhYmxlZF0+YTpvbmx5LWNoaWxkOmFmdGVye3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO3JpZ2h0OjA7Ym90dG9tOjA7bGVmdDowO2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7Y29udGVudDpcIlwifS5hbnQtYnRuOmFjdGl2ZSwuYW50LWJ0bjpmb2N1cywuYW50LWJ0bjpob3Zlcnt0ZXh0LWRlY29yYXRpb246bm9uZTtiYWNrZ3JvdW5kOiNmZmZ9LmFudC1idG4+c3BhbntkaXNwbGF5OmlubGluZS1ibG9ja30uYW50LWJ0bi1wcmltYXJ5e2NvbG9yOiNmZmY7Ym9yZGVyLWNvbG9yOiMxODkwZmY7YmFja2dyb3VuZDojMTg5MGZmO3RleHQtc2hhZG93OjAgLTFweCAwIHJnYmEoMCwwLDAsLjEyKTtib3gtc2hhZG93OjAgMnB4IDAgcmdiYSgwLDAsMCwuMDQ1KX0uYW50LWJ0bi1wcmltYXJ5PmE6b25seS1jaGlsZHtjb2xvcjpjdXJyZW50Y29sb3J9LmFudC1idG4tcHJpbWFyeT5hOm9ubHktY2hpbGQ6YWZ0ZXJ7cG9zaXRpb246YWJzb2x1dGU7dG9wOjA7cmlnaHQ6MDtib3R0b206MDtsZWZ0OjA7YmFja2dyb3VuZDp0cmFuc3BhcmVudDtjb250ZW50OlwiXCJ9LmFudC1idG4tcHJpbWFyeTpmb2N1cywuYW50LWJ0bi1wcmltYXJ5OmhvdmVye2NvbG9yOiNmZmY7Ym9yZGVyLWNvbG9yOiM0MGE5ZmY7YmFja2dyb3VuZDojNDBhOWZmfS5hbnQtYnRuLXByaW1hcnk6Zm9jdXM+YTpvbmx5LWNoaWxkLC5hbnQtYnRuLXByaW1hcnk6aG92ZXI+YTpvbmx5LWNoaWxke2NvbG9yOmN1cnJlbnRjb2xvcn0uYW50LWJ0bi1wcmltYXJ5OmZvY3VzPmE6b25seS1jaGlsZDphZnRlciwuYW50LWJ0bi1wcmltYXJ5OmhvdmVyPmE6b25seS1jaGlsZDphZnRlcntwb3NpdGlvbjphYnNvbHV0ZTt0b3A6MDtyaWdodDowO2JvdHRvbTowO2xlZnQ6MDtiYWNrZ3JvdW5kOnRyYW5zcGFyZW50O2NvbnRlbnQ6XCJcIn0uYW50LWJ0bi1wcmltYXJ5OmFjdGl2ZXtjb2xvcjojZmZmO2JvcmRlci1jb2xvcjojMDk2ZGQ5O2JhY2tncm91bmQ6IzA5NmRkOX0uYW50LWJ0bi1wcmltYXJ5OmFjdGl2ZT5hOm9ubHktY2hpbGR7Y29sb3I6Y3VycmVudGNvbG9yfS5hbnQtYnRuLXByaW1hcnk6YWN0aXZlPmE6b25seS1jaGlsZDphZnRlcntwb3NpdGlvbjphYnNvbHV0ZTt0b3A6MDtyaWdodDowO2JvdHRvbTowO2xlZnQ6MDtiYWNrZ3JvdW5kOnRyYW5zcGFyZW50O2NvbnRlbnQ6XCJcIn0uYW50LWJ0bi1wcmltYXJ5W2Rpc2FibGVkXSwuYW50LWJ0bi1wcmltYXJ5W2Rpc2FibGVkXTphY3RpdmUsLmFudC1idG4tcHJpbWFyeVtkaXNhYmxlZF06Zm9jdXMsLmFudC1idG4tcHJpbWFyeVtkaXNhYmxlZF06aG92ZXJ7Y29sb3I6cmdiYSgwLDAsMCwuMjUpO2JvcmRlci1jb2xvcjojZDlkOWQ5O2JhY2tncm91bmQ6I2Y1ZjVmNTt0ZXh0LXNoYWRvdzpub25lO2JveC1zaGFkb3c6bm9uZX0uYW50LWJ0bi1wcmltYXJ5W2Rpc2FibGVkXTphY3RpdmU+YTpvbmx5LWNoaWxkLC5hbnQtYnRuLXByaW1hcnlbZGlzYWJsZWRdOmZvY3VzPmE6b25seS1jaGlsZCwuYW50LWJ0bi1wcmltYXJ5W2Rpc2FibGVkXTpob3Zlcj5hOm9ubHktY2hpbGQsLmFudC1idG4tcHJpbWFyeVtkaXNhYmxlZF0+YTpvbmx5LWNoaWxke2NvbG9yOmN1cnJlbnRjb2xvcn0uYW50LWJ0bi1wcmltYXJ5W2Rpc2FibGVkXTphY3RpdmU+YTpvbmx5LWNoaWxkOmFmdGVyLC5hbnQtYnRuLXByaW1hcnlbZGlzYWJsZWRdOmZvY3VzPmE6b25seS1jaGlsZDphZnRlciwuYW50LWJ0bi1wcmltYXJ5W2Rpc2FibGVkXTpob3Zlcj5hOm9ubHktY2hpbGQ6YWZ0ZXIsLmFudC1idG4tcHJpbWFyeVtkaXNhYmxlZF0+YTpvbmx5LWNoaWxkOmFmdGVye3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO3JpZ2h0OjA7Ym90dG9tOjA7bGVmdDowO2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7Y29udGVudDpcIlwifS5hbnQtYnRuLWdyb3VwIC5hbnQtYnRuLXByaW1hcnk6bm90KDpmaXJzdC1jaGlsZCk6bm90KDpsYXN0LWNoaWxkKXtib3JkZXItcmlnaHQtY29sb3I6IzQwYTlmZjtib3JkZXItbGVmdC1jb2xvcjojNDBhOWZmfS5hbnQtYnRuLWdyb3VwIC5hbnQtYnRuLXByaW1hcnk6bm90KDpmaXJzdC1jaGlsZCk6bm90KDpsYXN0LWNoaWxkKTpkaXNhYmxlZHtib3JkZXItY29sb3I6I2Q5ZDlkOX0uYW50LWJ0bi1ncm91cCAuYW50LWJ0bi1wcmltYXJ5OmZpcnN0LWNoaWxkOm5vdCg6bGFzdC1jaGlsZCl7Ym9yZGVyLXJpZ2h0LWNvbG9yOiM0MGE5ZmZ9LmFudC1idG4tZ3JvdXAgLmFudC1idG4tcHJpbWFyeTpmaXJzdC1jaGlsZDpub3QoOmxhc3QtY2hpbGQpW2Rpc2FibGVkXXtib3JkZXItcmlnaHQtY29sb3I6I2Q5ZDlkOX0uYW50LWJ0bi1ncm91cCAuYW50LWJ0bi1wcmltYXJ5Ky5hbnQtYnRuLXByaW1hcnksLmFudC1idG4tZ3JvdXAgLmFudC1idG4tcHJpbWFyeTpsYXN0LWNoaWxkOm5vdCg6Zmlyc3QtY2hpbGQpe2JvcmRlci1sZWZ0LWNvbG9yOiM0MGE5ZmZ9LmFudC1idG4tZ3JvdXAgLmFudC1idG4tcHJpbWFyeSsuYW50LWJ0bi1wcmltYXJ5W2Rpc2FibGVkXSwuYW50LWJ0bi1ncm91cCAuYW50LWJ0bi1wcmltYXJ5Omxhc3QtY2hpbGQ6bm90KDpmaXJzdC1jaGlsZClbZGlzYWJsZWRde2JvcmRlci1sZWZ0LWNvbG9yOiNkOWQ5ZDl9LmFudC1idG4tZ2hvc3R7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2JvcmRlci1jb2xvcjojZDlkOWQ5O2JhY2tncm91bmQ6dHJhbnNwYXJlbnR9LmFudC1idG4tZ2hvc3Q+YTpvbmx5LWNoaWxke2NvbG9yOmN1cnJlbnRjb2xvcn0uYW50LWJ0bi1naG9zdD5hOm9ubHktY2hpbGQ6YWZ0ZXJ7cG9zaXRpb246YWJzb2x1dGU7dG9wOjA7cmlnaHQ6MDtib3R0b206MDtsZWZ0OjA7YmFja2dyb3VuZDp0cmFuc3BhcmVudDtjb250ZW50OlwiXCJ9LmFudC1idG4tZ2hvc3Q6Zm9jdXMsLmFudC1idG4tZ2hvc3Q6aG92ZXJ7Y29sb3I6IzQwYTlmZjtib3JkZXItY29sb3I6IzQwYTlmZjtiYWNrZ3JvdW5kOnRyYW5zcGFyZW50fS5hbnQtYnRuLWdob3N0OmZvY3VzPmE6b25seS1jaGlsZCwuYW50LWJ0bi1naG9zdDpob3Zlcj5hOm9ubHktY2hpbGR7Y29sb3I6Y3VycmVudGNvbG9yfS5hbnQtYnRuLWdob3N0OmZvY3VzPmE6b25seS1jaGlsZDphZnRlciwuYW50LWJ0bi1naG9zdDpob3Zlcj5hOm9ubHktY2hpbGQ6YWZ0ZXJ7cG9zaXRpb246YWJzb2x1dGU7dG9wOjA7cmlnaHQ6MDtib3R0b206MDtsZWZ0OjA7YmFja2dyb3VuZDp0cmFuc3BhcmVudDtjb250ZW50OlwiXCJ9LmFudC1idG4tZ2hvc3Q6YWN0aXZle2NvbG9yOiMwOTZkZDk7Ym9yZGVyLWNvbG9yOiMwOTZkZDk7YmFja2dyb3VuZDp0cmFuc3BhcmVudH0uYW50LWJ0bi1naG9zdDphY3RpdmU+YTpvbmx5LWNoaWxke2NvbG9yOmN1cnJlbnRjb2xvcn0uYW50LWJ0bi1naG9zdDphY3RpdmU+YTpvbmx5LWNoaWxkOmFmdGVye3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO3JpZ2h0OjA7Ym90dG9tOjA7bGVmdDowO2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7Y29udGVudDpcIlwifS5hbnQtYnRuLWdob3N0W2Rpc2FibGVkXSwuYW50LWJ0bi1naG9zdFtkaXNhYmxlZF06YWN0aXZlLC5hbnQtYnRuLWdob3N0W2Rpc2FibGVkXTpmb2N1cywuYW50LWJ0bi1naG9zdFtkaXNhYmxlZF06aG92ZXJ7Y29sb3I6cmdiYSgwLDAsMCwuMjUpO2JvcmRlci1jb2xvcjojZDlkOWQ5O2JhY2tncm91bmQ6I2Y1ZjVmNTt0ZXh0LXNoYWRvdzpub25lO2JveC1zaGFkb3c6bm9uZX0uYW50LWJ0bi1naG9zdFtkaXNhYmxlZF06YWN0aXZlPmE6b25seS1jaGlsZCwuYW50LWJ0bi1naG9zdFtkaXNhYmxlZF06Zm9jdXM+YTpvbmx5LWNoaWxkLC5hbnQtYnRuLWdob3N0W2Rpc2FibGVkXTpob3Zlcj5hOm9ubHktY2hpbGQsLmFudC1idG4tZ2hvc3RbZGlzYWJsZWRdPmE6b25seS1jaGlsZHtjb2xvcjpjdXJyZW50Y29sb3J9LmFudC1idG4tZ2hvc3RbZGlzYWJsZWRdOmFjdGl2ZT5hOm9ubHktY2hpbGQ6YWZ0ZXIsLmFudC1idG4tZ2hvc3RbZGlzYWJsZWRdOmZvY3VzPmE6b25seS1jaGlsZDphZnRlciwuYW50LWJ0bi1naG9zdFtkaXNhYmxlZF06aG92ZXI+YTpvbmx5LWNoaWxkOmFmdGVyLC5hbnQtYnRuLWdob3N0W2Rpc2FibGVkXT5hOm9ubHktY2hpbGQ6YWZ0ZXJ7cG9zaXRpb246YWJzb2x1dGU7dG9wOjA7cmlnaHQ6MDtib3R0b206MDtsZWZ0OjA7YmFja2dyb3VuZDp0cmFuc3BhcmVudDtjb250ZW50OlwiXCJ9LmFudC1idG4tZGFzaGVke2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtib3JkZXItY29sb3I6I2Q5ZDlkOTtiYWNrZ3JvdW5kOiNmZmY7Ym9yZGVyLXN0eWxlOmRhc2hlZH0uYW50LWJ0bi1kYXNoZWQ+YTpvbmx5LWNoaWxke2NvbG9yOmN1cnJlbnRjb2xvcn0uYW50LWJ0bi1kYXNoZWQ+YTpvbmx5LWNoaWxkOmFmdGVye3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO3JpZ2h0OjA7Ym90dG9tOjA7bGVmdDowO2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7Y29udGVudDpcIlwifS5hbnQtYnRuLWRhc2hlZDpmb2N1cywuYW50LWJ0bi1kYXNoZWQ6aG92ZXJ7Y29sb3I6IzQwYTlmZjtib3JkZXItY29sb3I6IzQwYTlmZjtiYWNrZ3JvdW5kOiNmZmZ9LmFudC1idG4tZGFzaGVkOmZvY3VzPmE6b25seS1jaGlsZCwuYW50LWJ0bi1kYXNoZWQ6aG92ZXI+YTpvbmx5LWNoaWxke2NvbG9yOmN1cnJlbnRjb2xvcn0uYW50LWJ0bi1kYXNoZWQ6Zm9jdXM+YTpvbmx5LWNoaWxkOmFmdGVyLC5hbnQtYnRuLWRhc2hlZDpob3Zlcj5hOm9ubHktY2hpbGQ6YWZ0ZXJ7cG9zaXRpb246YWJzb2x1dGU7dG9wOjA7cmlnaHQ6MDtib3R0b206MDtsZWZ0OjA7YmFja2dyb3VuZDp0cmFuc3BhcmVudDtjb250ZW50OlwiXCJ9LmFudC1idG4tZGFzaGVkOmFjdGl2ZXtjb2xvcjojMDk2ZGQ5O2JvcmRlci1jb2xvcjojMDk2ZGQ5O2JhY2tncm91bmQ6I2ZmZn0uYW50LWJ0bi1kYXNoZWQ6YWN0aXZlPmE6b25seS1jaGlsZHtjb2xvcjpjdXJyZW50Y29sb3J9LmFudC1idG4tZGFzaGVkOmFjdGl2ZT5hOm9ubHktY2hpbGQ6YWZ0ZXJ7cG9zaXRpb246YWJzb2x1dGU7dG9wOjA7cmlnaHQ6MDtib3R0b206MDtsZWZ0OjA7YmFja2dyb3VuZDp0cmFuc3BhcmVudDtjb250ZW50OlwiXCJ9LmFudC1idG4tZGFzaGVkW2Rpc2FibGVkXSwuYW50LWJ0bi1kYXNoZWRbZGlzYWJsZWRdOmFjdGl2ZSwuYW50LWJ0bi1kYXNoZWRbZGlzYWJsZWRdOmZvY3VzLC5hbnQtYnRuLWRhc2hlZFtkaXNhYmxlZF06aG92ZXJ7Y29sb3I6cmdiYSgwLDAsMCwuMjUpO2JvcmRlci1jb2xvcjojZDlkOWQ5O2JhY2tncm91bmQ6I2Y1ZjVmNTt0ZXh0LXNoYWRvdzpub25lO2JveC1zaGFkb3c6bm9uZX0uYW50LWJ0bi1kYXNoZWRbZGlzYWJsZWRdOmFjdGl2ZT5hOm9ubHktY2hpbGQsLmFudC1idG4tZGFzaGVkW2Rpc2FibGVkXTpmb2N1cz5hOm9ubHktY2hpbGQsLmFudC1idG4tZGFzaGVkW2Rpc2FibGVkXTpob3Zlcj5hOm9ubHktY2hpbGQsLmFudC1idG4tZGFzaGVkW2Rpc2FibGVkXT5hOm9ubHktY2hpbGR7Y29sb3I6Y3VycmVudGNvbG9yfS5hbnQtYnRuLWRhc2hlZFtkaXNhYmxlZF06YWN0aXZlPmE6b25seS1jaGlsZDphZnRlciwuYW50LWJ0bi1kYXNoZWRbZGlzYWJsZWRdOmZvY3VzPmE6b25seS1jaGlsZDphZnRlciwuYW50LWJ0bi1kYXNoZWRbZGlzYWJsZWRdOmhvdmVyPmE6b25seS1jaGlsZDphZnRlciwuYW50LWJ0bi1kYXNoZWRbZGlzYWJsZWRdPmE6b25seS1jaGlsZDphZnRlcntwb3NpdGlvbjphYnNvbHV0ZTt0b3A6MDtyaWdodDowO2JvdHRvbTowO2xlZnQ6MDtiYWNrZ3JvdW5kOnRyYW5zcGFyZW50O2NvbnRlbnQ6XCJcIn0uYW50LWJ0bi1kYW5nZXJ7Y29sb3I6I2ZmZjtib3JkZXItY29sb3I6I2ZmNGQ0ZjtiYWNrZ3JvdW5kOiNmZjRkNGY7dGV4dC1zaGFkb3c6MCAtMXB4IDAgcmdiYSgwLDAsMCwuMTIpO2JveC1zaGFkb3c6MCAycHggMCByZ2JhKDAsMCwwLC4wNDUpfS5hbnQtYnRuLWRhbmdlcj5hOm9ubHktY2hpbGR7Y29sb3I6Y3VycmVudGNvbG9yfS5hbnQtYnRuLWRhbmdlcj5hOm9ubHktY2hpbGQ6YWZ0ZXJ7cG9zaXRpb246YWJzb2x1dGU7dG9wOjA7cmlnaHQ6MDtib3R0b206MDtsZWZ0OjA7YmFja2dyb3VuZDp0cmFuc3BhcmVudDtjb250ZW50OlwiXCJ9LmFudC1idG4tZGFuZ2VyOmZvY3VzLC5hbnQtYnRuLWRhbmdlcjpob3Zlcntjb2xvcjojZmZmO2JvcmRlci1jb2xvcjojZmY3ODc1O2JhY2tncm91bmQ6I2ZmNzg3NX0uYW50LWJ0bi1kYW5nZXI6Zm9jdXM+YTpvbmx5LWNoaWxkLC5hbnQtYnRuLWRhbmdlcjpob3Zlcj5hOm9ubHktY2hpbGR7Y29sb3I6Y3VycmVudGNvbG9yfS5hbnQtYnRuLWRhbmdlcjpmb2N1cz5hOm9ubHktY2hpbGQ6YWZ0ZXIsLmFudC1idG4tZGFuZ2VyOmhvdmVyPmE6b25seS1jaGlsZDphZnRlcntwb3NpdGlvbjphYnNvbHV0ZTt0b3A6MDtyaWdodDowO2JvdHRvbTowO2xlZnQ6MDtiYWNrZ3JvdW5kOnRyYW5zcGFyZW50O2NvbnRlbnQ6XCJcIn0uYW50LWJ0bi1kYW5nZXI6YWN0aXZle2NvbG9yOiNmZmY7Ym9yZGVyLWNvbG9yOiNkOTM2M2U7YmFja2dyb3VuZDojZDkzNjNlfS5hbnQtYnRuLWRhbmdlcjphY3RpdmU+YTpvbmx5LWNoaWxke2NvbG9yOmN1cnJlbnRjb2xvcn0uYW50LWJ0bi1kYW5nZXI6YWN0aXZlPmE6b25seS1jaGlsZDphZnRlcntwb3NpdGlvbjphYnNvbHV0ZTt0b3A6MDtyaWdodDowO2JvdHRvbTowO2xlZnQ6MDtiYWNrZ3JvdW5kOnRyYW5zcGFyZW50O2NvbnRlbnQ6XCJcIn0uYW50LWJ0bi1kYW5nZXJbZGlzYWJsZWRdLC5hbnQtYnRuLWRhbmdlcltkaXNhYmxlZF06YWN0aXZlLC5hbnQtYnRuLWRhbmdlcltkaXNhYmxlZF06Zm9jdXMsLmFudC1idG4tZGFuZ2VyW2Rpc2FibGVkXTpob3Zlcntjb2xvcjpyZ2JhKDAsMCwwLC4yNSk7Ym9yZGVyLWNvbG9yOiNkOWQ5ZDk7YmFja2dyb3VuZDojZjVmNWY1O3RleHQtc2hhZG93Om5vbmU7Ym94LXNoYWRvdzpub25lfS5hbnQtYnRuLWRhbmdlcltkaXNhYmxlZF06YWN0aXZlPmE6b25seS1jaGlsZCwuYW50LWJ0bi1kYW5nZXJbZGlzYWJsZWRdOmZvY3VzPmE6b25seS1jaGlsZCwuYW50LWJ0bi1kYW5nZXJbZGlzYWJsZWRdOmhvdmVyPmE6b25seS1jaGlsZCwuYW50LWJ0bi1kYW5nZXJbZGlzYWJsZWRdPmE6b25seS1jaGlsZHtjb2xvcjpjdXJyZW50Y29sb3J9LmFudC1idG4tZGFuZ2VyW2Rpc2FibGVkXTphY3RpdmU+YTpvbmx5LWNoaWxkOmFmdGVyLC5hbnQtYnRuLWRhbmdlcltkaXNhYmxlZF06Zm9jdXM+YTpvbmx5LWNoaWxkOmFmdGVyLC5hbnQtYnRuLWRhbmdlcltkaXNhYmxlZF06aG92ZXI+YTpvbmx5LWNoaWxkOmFmdGVyLC5hbnQtYnRuLWRhbmdlcltkaXNhYmxlZF0+YTpvbmx5LWNoaWxkOmFmdGVye3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO3JpZ2h0OjA7Ym90dG9tOjA7bGVmdDowO2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7Y29udGVudDpcIlwifS5hbnQtYnRuLWxpbmt7Y29sb3I6IzE4OTBmZjtib3JkZXItY29sb3I6dHJhbnNwYXJlbnQ7YmFja2dyb3VuZDp0cmFuc3BhcmVudDtib3gtc2hhZG93Om5vbmV9LmFudC1idG4tbGluaz5hOm9ubHktY2hpbGR7Y29sb3I6Y3VycmVudGNvbG9yfS5hbnQtYnRuLWxpbms+YTpvbmx5LWNoaWxkOmFmdGVye3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO3JpZ2h0OjA7Ym90dG9tOjA7bGVmdDowO2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7Y29udGVudDpcIlwifS5hbnQtYnRuLWxpbms6Zm9jdXMsLmFudC1idG4tbGluazpob3Zlcntjb2xvcjojNDBhOWZmO2JvcmRlci1jb2xvcjojNDBhOWZmO2JhY2tncm91bmQ6dHJhbnNwYXJlbnR9LmFudC1idG4tbGluazpmb2N1cz5hOm9ubHktY2hpbGQsLmFudC1idG4tbGluazpob3Zlcj5hOm9ubHktY2hpbGR7Y29sb3I6Y3VycmVudGNvbG9yfS5hbnQtYnRuLWxpbms6Zm9jdXM+YTpvbmx5LWNoaWxkOmFmdGVyLC5hbnQtYnRuLWxpbms6aG92ZXI+YTpvbmx5LWNoaWxkOmFmdGVye3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO3JpZ2h0OjA7Ym90dG9tOjA7bGVmdDowO2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7Y29udGVudDpcIlwifS5hbnQtYnRuLWxpbms6YWN0aXZle2NvbG9yOiMwOTZkZDk7Ym9yZGVyLWNvbG9yOiMwOTZkZDk7YmFja2dyb3VuZDp0cmFuc3BhcmVudH0uYW50LWJ0bi1saW5rOmFjdGl2ZT5hOm9ubHktY2hpbGR7Y29sb3I6Y3VycmVudGNvbG9yfS5hbnQtYnRuLWxpbms6YWN0aXZlPmE6b25seS1jaGlsZDphZnRlcntwb3NpdGlvbjphYnNvbHV0ZTt0b3A6MDtyaWdodDowO2JvdHRvbTowO2xlZnQ6MDtiYWNrZ3JvdW5kOnRyYW5zcGFyZW50O2NvbnRlbnQ6XCJcIn0uYW50LWJ0bi1saW5rW2Rpc2FibGVkXSwuYW50LWJ0bi1saW5rW2Rpc2FibGVkXTphY3RpdmUsLmFudC1idG4tbGlua1tkaXNhYmxlZF06Zm9jdXMsLmFudC1idG4tbGlua1tkaXNhYmxlZF06aG92ZXJ7Ym9yZGVyLWNvbG9yOiNkOWQ5ZDk7YmFja2dyb3VuZDojZjVmNWY1fS5hbnQtYnRuLWxpbms6aG92ZXJ7YmFja2dyb3VuZDp0cmFuc3BhcmVudH0uYW50LWJ0bi1saW5rOmFjdGl2ZSwuYW50LWJ0bi1saW5rOmZvY3VzLC5hbnQtYnRuLWxpbms6aG92ZXJ7Ym9yZGVyLWNvbG9yOnRyYW5zcGFyZW50fS5hbnQtYnRuLWxpbmtbZGlzYWJsZWRdLC5hbnQtYnRuLWxpbmtbZGlzYWJsZWRdOmFjdGl2ZSwuYW50LWJ0bi1saW5rW2Rpc2FibGVkXTpmb2N1cywuYW50LWJ0bi1saW5rW2Rpc2FibGVkXTpob3Zlcntjb2xvcjpyZ2JhKDAsMCwwLC4yNSk7Ym9yZGVyLWNvbG9yOnRyYW5zcGFyZW50O2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7dGV4dC1zaGFkb3c6bm9uZTtib3gtc2hhZG93Om5vbmV9LmFudC1idG4tbGlua1tkaXNhYmxlZF06YWN0aXZlPmE6b25seS1jaGlsZCwuYW50LWJ0bi1saW5rW2Rpc2FibGVkXTpmb2N1cz5hOm9ubHktY2hpbGQsLmFudC1idG4tbGlua1tkaXNhYmxlZF06aG92ZXI+YTpvbmx5LWNoaWxkLC5hbnQtYnRuLWxpbmtbZGlzYWJsZWRdPmE6b25seS1jaGlsZHtjb2xvcjpjdXJyZW50Y29sb3J9LmFudC1idG4tbGlua1tkaXNhYmxlZF06YWN0aXZlPmE6b25seS1jaGlsZDphZnRlciwuYW50LWJ0bi1saW5rW2Rpc2FibGVkXTpmb2N1cz5hOm9ubHktY2hpbGQ6YWZ0ZXIsLmFudC1idG4tbGlua1tkaXNhYmxlZF06aG92ZXI+YTpvbmx5LWNoaWxkOmFmdGVyLC5hbnQtYnRuLWxpbmtbZGlzYWJsZWRdPmE6b25seS1jaGlsZDphZnRlcntwb3NpdGlvbjphYnNvbHV0ZTt0b3A6MDtyaWdodDowO2JvdHRvbTowO2xlZnQ6MDtiYWNrZ3JvdW5kOnRyYW5zcGFyZW50O2NvbnRlbnQ6XCJcIn0uYW50LWJ0bi10ZXh0e2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtib3JkZXItY29sb3I6dHJhbnNwYXJlbnQ7YmFja2dyb3VuZDp0cmFuc3BhcmVudDtib3gtc2hhZG93Om5vbmV9LmFudC1idG4tdGV4dD5hOm9ubHktY2hpbGR7Y29sb3I6Y3VycmVudGNvbG9yfS5hbnQtYnRuLXRleHQ+YTpvbmx5LWNoaWxkOmFmdGVye3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO3JpZ2h0OjA7Ym90dG9tOjA7bGVmdDowO2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7Y29udGVudDpcIlwifS5hbnQtYnRuLXRleHQ6Zm9jdXMsLmFudC1idG4tdGV4dDpob3Zlcntjb2xvcjojNDBhOWZmO2JvcmRlci1jb2xvcjojNDBhOWZmO2JhY2tncm91bmQ6dHJhbnNwYXJlbnR9LmFudC1idG4tdGV4dDpmb2N1cz5hOm9ubHktY2hpbGQsLmFudC1idG4tdGV4dDpob3Zlcj5hOm9ubHktY2hpbGR7Y29sb3I6Y3VycmVudGNvbG9yfS5hbnQtYnRuLXRleHQ6Zm9jdXM+YTpvbmx5LWNoaWxkOmFmdGVyLC5hbnQtYnRuLXRleHQ6aG92ZXI+YTpvbmx5LWNoaWxkOmFmdGVye3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO3JpZ2h0OjA7Ym90dG9tOjA7bGVmdDowO2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7Y29udGVudDpcIlwifS5hbnQtYnRuLXRleHQ6YWN0aXZle2NvbG9yOiMwOTZkZDk7Ym9yZGVyLWNvbG9yOiMwOTZkZDk7YmFja2dyb3VuZDp0cmFuc3BhcmVudH0uYW50LWJ0bi10ZXh0OmFjdGl2ZT5hOm9ubHktY2hpbGR7Y29sb3I6Y3VycmVudGNvbG9yfS5hbnQtYnRuLXRleHQ6YWN0aXZlPmE6b25seS1jaGlsZDphZnRlcntwb3NpdGlvbjphYnNvbHV0ZTt0b3A6MDtyaWdodDowO2JvdHRvbTowO2xlZnQ6MDtiYWNrZ3JvdW5kOnRyYW5zcGFyZW50O2NvbnRlbnQ6XCJcIn0uYW50LWJ0bi10ZXh0W2Rpc2FibGVkXSwuYW50LWJ0bi10ZXh0W2Rpc2FibGVkXTphY3RpdmUsLmFudC1idG4tdGV4dFtkaXNhYmxlZF06Zm9jdXMsLmFudC1idG4tdGV4dFtkaXNhYmxlZF06aG92ZXJ7Ym9yZGVyLWNvbG9yOiNkOWQ5ZDk7YmFja2dyb3VuZDojZjVmNWY1fS5hbnQtYnRuLXRleHQ6Zm9jdXMsLmFudC1idG4tdGV4dDpob3Zlcntjb2xvcjpyZ2JhKDAsMCwwLC44NSk7YmFja2dyb3VuZDpyZ2JhKDAsMCwwLC4wMTgpO2JvcmRlci1jb2xvcjp0cmFuc3BhcmVudH0uYW50LWJ0bi10ZXh0OmFjdGl2ZXtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7YmFja2dyb3VuZDpyZ2JhKDAsMCwwLC4wMjgpO2JvcmRlci1jb2xvcjp0cmFuc3BhcmVudH0uYW50LWJ0bi10ZXh0W2Rpc2FibGVkXSwuYW50LWJ0bi10ZXh0W2Rpc2FibGVkXTphY3RpdmUsLmFudC1idG4tdGV4dFtkaXNhYmxlZF06Zm9jdXMsLmFudC1idG4tdGV4dFtkaXNhYmxlZF06aG92ZXJ7Y29sb3I6cmdiYSgwLDAsMCwuMjUpO2JvcmRlci1jb2xvcjp0cmFuc3BhcmVudDtiYWNrZ3JvdW5kOnRyYW5zcGFyZW50O3RleHQtc2hhZG93Om5vbmU7Ym94LXNoYWRvdzpub25lfS5hbnQtYnRuLXRleHRbZGlzYWJsZWRdOmFjdGl2ZT5hOm9ubHktY2hpbGQsLmFudC1idG4tdGV4dFtkaXNhYmxlZF06Zm9jdXM+YTpvbmx5LWNoaWxkLC5hbnQtYnRuLXRleHRbZGlzYWJsZWRdOmhvdmVyPmE6b25seS1jaGlsZCwuYW50LWJ0bi10ZXh0W2Rpc2FibGVkXT5hOm9ubHktY2hpbGR7Y29sb3I6Y3VycmVudGNvbG9yfS5hbnQtYnRuLXRleHRbZGlzYWJsZWRdOmFjdGl2ZT5hOm9ubHktY2hpbGQ6YWZ0ZXIsLmFudC1idG4tdGV4dFtkaXNhYmxlZF06Zm9jdXM+YTpvbmx5LWNoaWxkOmFmdGVyLC5hbnQtYnRuLXRleHRbZGlzYWJsZWRdOmhvdmVyPmE6b25seS1jaGlsZDphZnRlciwuYW50LWJ0bi10ZXh0W2Rpc2FibGVkXT5hOm9ubHktY2hpbGQ6YWZ0ZXJ7cG9zaXRpb246YWJzb2x1dGU7dG9wOjA7cmlnaHQ6MDtib3R0b206MDtsZWZ0OjA7YmFja2dyb3VuZDp0cmFuc3BhcmVudDtjb250ZW50OlwiXCJ9LmFudC1idG4tZGFuZ2Vyb3Vze2NvbG9yOiNmZjRkNGY7Ym9yZGVyLWNvbG9yOiNmZjRkNGY7YmFja2dyb3VuZDojZmZmfS5hbnQtYnRuLWRhbmdlcm91cz5hOm9ubHktY2hpbGR7Y29sb3I6Y3VycmVudGNvbG9yfS5hbnQtYnRuLWRhbmdlcm91cz5hOm9ubHktY2hpbGQ6YWZ0ZXJ7cG9zaXRpb246YWJzb2x1dGU7dG9wOjA7cmlnaHQ6MDtib3R0b206MDtsZWZ0OjA7YmFja2dyb3VuZDp0cmFuc3BhcmVudDtjb250ZW50OlwiXCJ9LmFudC1idG4tZGFuZ2Vyb3VzOmZvY3VzLC5hbnQtYnRuLWRhbmdlcm91czpob3Zlcntjb2xvcjojZmY3ODc1O2JvcmRlci1jb2xvcjojZmY3ODc1O2JhY2tncm91bmQ6I2ZmZn0uYW50LWJ0bi1kYW5nZXJvdXM6Zm9jdXM+YTpvbmx5LWNoaWxkLC5hbnQtYnRuLWRhbmdlcm91czpob3Zlcj5hOm9ubHktY2hpbGR7Y29sb3I6Y3VycmVudGNvbG9yfS5hbnQtYnRuLWRhbmdlcm91czpmb2N1cz5hOm9ubHktY2hpbGQ6YWZ0ZXIsLmFudC1idG4tZGFuZ2Vyb3VzOmhvdmVyPmE6b25seS1jaGlsZDphZnRlcntwb3NpdGlvbjphYnNvbHV0ZTt0b3A6MDtyaWdodDowO2JvdHRvbTowO2xlZnQ6MDtiYWNrZ3JvdW5kOnRyYW5zcGFyZW50O2NvbnRlbnQ6XCJcIn0uYW50LWJ0bi1kYW5nZXJvdXM6YWN0aXZle2NvbG9yOiNkOTM2M2U7Ym9yZGVyLWNvbG9yOiNkOTM2M2U7YmFja2dyb3VuZDojZmZmfS5hbnQtYnRuLWRhbmdlcm91czphY3RpdmU+YTpvbmx5LWNoaWxke2NvbG9yOmN1cnJlbnRjb2xvcn0uYW50LWJ0bi1kYW5nZXJvdXM6YWN0aXZlPmE6b25seS1jaGlsZDphZnRlcntwb3NpdGlvbjphYnNvbHV0ZTt0b3A6MDtyaWdodDowO2JvdHRvbTowO2xlZnQ6MDtiYWNrZ3JvdW5kOnRyYW5zcGFyZW50O2NvbnRlbnQ6XCJcIn0uYW50LWJ0bi1kYW5nZXJvdXNbZGlzYWJsZWRdLC5hbnQtYnRuLWRhbmdlcm91c1tkaXNhYmxlZF06YWN0aXZlLC5hbnQtYnRuLWRhbmdlcm91c1tkaXNhYmxlZF06Zm9jdXMsLmFudC1idG4tZGFuZ2Vyb3VzW2Rpc2FibGVkXTpob3Zlcntjb2xvcjpyZ2JhKDAsMCwwLC4yNSk7Ym9yZGVyLWNvbG9yOiNkOWQ5ZDk7YmFja2dyb3VuZDojZjVmNWY1O3RleHQtc2hhZG93Om5vbmU7Ym94LXNoYWRvdzpub25lfS5hbnQtYnRuLWRhbmdlcm91c1tkaXNhYmxlZF06YWN0aXZlPmE6b25seS1jaGlsZCwuYW50LWJ0bi1kYW5nZXJvdXNbZGlzYWJsZWRdOmZvY3VzPmE6b25seS1jaGlsZCwuYW50LWJ0bi1kYW5nZXJvdXNbZGlzYWJsZWRdOmhvdmVyPmE6b25seS1jaGlsZCwuYW50LWJ0bi1kYW5nZXJvdXNbZGlzYWJsZWRdPmE6b25seS1jaGlsZHtjb2xvcjpjdXJyZW50Y29sb3J9LmFudC1idG4tZGFuZ2Vyb3VzW2Rpc2FibGVkXTphY3RpdmU+YTpvbmx5LWNoaWxkOmFmdGVyLC5hbnQtYnRuLWRhbmdlcm91c1tkaXNhYmxlZF06Zm9jdXM+YTpvbmx5LWNoaWxkOmFmdGVyLC5hbnQtYnRuLWRhbmdlcm91c1tkaXNhYmxlZF06aG92ZXI+YTpvbmx5LWNoaWxkOmFmdGVyLC5hbnQtYnRuLWRhbmdlcm91c1tkaXNhYmxlZF0+YTpvbmx5LWNoaWxkOmFmdGVye3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO3JpZ2h0OjA7Ym90dG9tOjA7bGVmdDowO2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7Y29udGVudDpcIlwifS5hbnQtYnRuLWRhbmdlcm91cy5hbnQtYnRuLXByaW1hcnl7Y29sb3I6I2ZmZjtib3JkZXItY29sb3I6I2ZmNGQ0ZjtiYWNrZ3JvdW5kOiNmZjRkNGY7dGV4dC1zaGFkb3c6MCAtMXB4IDAgcmdiYSgwLDAsMCwuMTIpO2JveC1zaGFkb3c6MCAycHggMCByZ2JhKDAsMCwwLC4wNDUpfS5hbnQtYnRuLWRhbmdlcm91cy5hbnQtYnRuLXByaW1hcnk+YTpvbmx5LWNoaWxke2NvbG9yOmN1cnJlbnRjb2xvcn0uYW50LWJ0bi1kYW5nZXJvdXMuYW50LWJ0bi1wcmltYXJ5PmE6b25seS1jaGlsZDphZnRlcntwb3NpdGlvbjphYnNvbHV0ZTt0b3A6MDtyaWdodDowO2JvdHRvbTowO2xlZnQ6MDtiYWNrZ3JvdW5kOnRyYW5zcGFyZW50O2NvbnRlbnQ6XCJcIn0uYW50LWJ0bi1kYW5nZXJvdXMuYW50LWJ0bi1wcmltYXJ5OmZvY3VzLC5hbnQtYnRuLWRhbmdlcm91cy5hbnQtYnRuLXByaW1hcnk6aG92ZXJ7Y29sb3I6I2ZmZjtib3JkZXItY29sb3I6I2ZmNzg3NTtiYWNrZ3JvdW5kOiNmZjc4NzV9LmFudC1idG4tZGFuZ2Vyb3VzLmFudC1idG4tcHJpbWFyeTpmb2N1cz5hOm9ubHktY2hpbGQsLmFudC1idG4tZGFuZ2Vyb3VzLmFudC1idG4tcHJpbWFyeTpob3Zlcj5hOm9ubHktY2hpbGR7Y29sb3I6Y3VycmVudGNvbG9yfS5hbnQtYnRuLWRhbmdlcm91cy5hbnQtYnRuLXByaW1hcnk6Zm9jdXM+YTpvbmx5LWNoaWxkOmFmdGVyLC5hbnQtYnRuLWRhbmdlcm91cy5hbnQtYnRuLXByaW1hcnk6aG92ZXI+YTpvbmx5LWNoaWxkOmFmdGVye3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO3JpZ2h0OjA7Ym90dG9tOjA7bGVmdDowO2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7Y29udGVudDpcIlwifS5hbnQtYnRuLWRhbmdlcm91cy5hbnQtYnRuLXByaW1hcnk6YWN0aXZle2NvbG9yOiNmZmY7Ym9yZGVyLWNvbG9yOiNkOTM2M2U7YmFja2dyb3VuZDojZDkzNjNlfS5hbnQtYnRuLWRhbmdlcm91cy5hbnQtYnRuLXByaW1hcnk6YWN0aXZlPmE6b25seS1jaGlsZHtjb2xvcjpjdXJyZW50Y29sb3J9LmFudC1idG4tZGFuZ2Vyb3VzLmFudC1idG4tcHJpbWFyeTphY3RpdmU+YTpvbmx5LWNoaWxkOmFmdGVye3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO3JpZ2h0OjA7Ym90dG9tOjA7bGVmdDowO2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7Y29udGVudDpcIlwifS5hbnQtYnRuLWRhbmdlcm91cy5hbnQtYnRuLXByaW1hcnlbZGlzYWJsZWRdLC5hbnQtYnRuLWRhbmdlcm91cy5hbnQtYnRuLXByaW1hcnlbZGlzYWJsZWRdOmFjdGl2ZSwuYW50LWJ0bi1kYW5nZXJvdXMuYW50LWJ0bi1wcmltYXJ5W2Rpc2FibGVkXTpmb2N1cywuYW50LWJ0bi1kYW5nZXJvdXMuYW50LWJ0bi1wcmltYXJ5W2Rpc2FibGVkXTpob3Zlcntjb2xvcjpyZ2JhKDAsMCwwLC4yNSk7Ym9yZGVyLWNvbG9yOiNkOWQ5ZDk7YmFja2dyb3VuZDojZjVmNWY1O3RleHQtc2hhZG93Om5vbmU7Ym94LXNoYWRvdzpub25lfS5hbnQtYnRuLWRhbmdlcm91cy5hbnQtYnRuLXByaW1hcnlbZGlzYWJsZWRdOmFjdGl2ZT5hOm9ubHktY2hpbGQsLmFudC1idG4tZGFuZ2Vyb3VzLmFudC1idG4tcHJpbWFyeVtkaXNhYmxlZF06Zm9jdXM+YTpvbmx5LWNoaWxkLC5hbnQtYnRuLWRhbmdlcm91cy5hbnQtYnRuLXByaW1hcnlbZGlzYWJsZWRdOmhvdmVyPmE6b25seS1jaGlsZCwuYW50LWJ0bi1kYW5nZXJvdXMuYW50LWJ0bi1wcmltYXJ5W2Rpc2FibGVkXT5hOm9ubHktY2hpbGR7Y29sb3I6Y3VycmVudGNvbG9yfS5hbnQtYnRuLWRhbmdlcm91cy5hbnQtYnRuLXByaW1hcnlbZGlzYWJsZWRdOmFjdGl2ZT5hOm9ubHktY2hpbGQ6YWZ0ZXIsLmFudC1idG4tZGFuZ2Vyb3VzLmFudC1idG4tcHJpbWFyeVtkaXNhYmxlZF06Zm9jdXM+YTpvbmx5LWNoaWxkOmFmdGVyLC5hbnQtYnRuLWRhbmdlcm91cy5hbnQtYnRuLXByaW1hcnlbZGlzYWJsZWRdOmhvdmVyPmE6b25seS1jaGlsZDphZnRlciwuYW50LWJ0bi1kYW5nZXJvdXMuYW50LWJ0bi1wcmltYXJ5W2Rpc2FibGVkXT5hOm9ubHktY2hpbGQ6YWZ0ZXJ7cG9zaXRpb246YWJzb2x1dGU7dG9wOjA7cmlnaHQ6MDtib3R0b206MDtsZWZ0OjA7YmFja2dyb3VuZDp0cmFuc3BhcmVudDtjb250ZW50OlwiXCJ9LmFudC1idG4tZGFuZ2Vyb3VzLmFudC1idG4tbGlua3tjb2xvcjojZmY0ZDRmO2JvcmRlci1jb2xvcjp0cmFuc3BhcmVudDtiYWNrZ3JvdW5kOnRyYW5zcGFyZW50O2JveC1zaGFkb3c6bm9uZX0uYW50LWJ0bi1kYW5nZXJvdXMuYW50LWJ0bi1saW5rPmE6b25seS1jaGlsZHtjb2xvcjpjdXJyZW50Y29sb3J9LmFudC1idG4tZGFuZ2Vyb3VzLmFudC1idG4tbGluaz5hOm9ubHktY2hpbGQ6YWZ0ZXJ7cG9zaXRpb246YWJzb2x1dGU7dG9wOjA7cmlnaHQ6MDtib3R0b206MDtsZWZ0OjA7YmFja2dyb3VuZDp0cmFuc3BhcmVudDtjb250ZW50OlwiXCJ9LmFudC1idG4tZGFuZ2Vyb3VzLmFudC1idG4tbGluazpmb2N1cywuYW50LWJ0bi1kYW5nZXJvdXMuYW50LWJ0bi1saW5rOmhvdmVye2NvbG9yOiM0MGE5ZmY7Ym9yZGVyLWNvbG9yOiM0MGE5ZmZ9LmFudC1idG4tZGFuZ2Vyb3VzLmFudC1idG4tbGluazphY3RpdmV7Y29sb3I6IzA5NmRkOTtib3JkZXItY29sb3I6IzA5NmRkOX0uYW50LWJ0bi1kYW5nZXJvdXMuYW50LWJ0bi1saW5rW2Rpc2FibGVkXSwuYW50LWJ0bi1kYW5nZXJvdXMuYW50LWJ0bi1saW5rW2Rpc2FibGVkXTphY3RpdmUsLmFudC1idG4tZGFuZ2Vyb3VzLmFudC1idG4tbGlua1tkaXNhYmxlZF06Zm9jdXMsLmFudC1idG4tZGFuZ2Vyb3VzLmFudC1idG4tbGlua1tkaXNhYmxlZF06aG92ZXJ7Ym9yZGVyLWNvbG9yOiNkOWQ5ZDk7YmFja2dyb3VuZDojZjVmNWY1fS5hbnQtYnRuLWRhbmdlcm91cy5hbnQtYnRuLWxpbms6Zm9jdXMsLmFudC1idG4tZGFuZ2Vyb3VzLmFudC1idG4tbGluazpob3Zlcntjb2xvcjojZmY3ODc1O2JvcmRlci1jb2xvcjp0cmFuc3BhcmVudDtiYWNrZ3JvdW5kOnRyYW5zcGFyZW50fS5hbnQtYnRuLWRhbmdlcm91cy5hbnQtYnRuLWxpbms6Zm9jdXM+YTpvbmx5LWNoaWxkLC5hbnQtYnRuLWRhbmdlcm91cy5hbnQtYnRuLWxpbms6aG92ZXI+YTpvbmx5LWNoaWxke2NvbG9yOmN1cnJlbnRjb2xvcn0uYW50LWJ0bi1kYW5nZXJvdXMuYW50LWJ0bi1saW5rOmZvY3VzPmE6b25seS1jaGlsZDphZnRlciwuYW50LWJ0bi1kYW5nZXJvdXMuYW50LWJ0bi1saW5rOmhvdmVyPmE6b25seS1jaGlsZDphZnRlcntwb3NpdGlvbjphYnNvbHV0ZTt0b3A6MDtyaWdodDowO2JvdHRvbTowO2xlZnQ6MDtiYWNrZ3JvdW5kOnRyYW5zcGFyZW50O2NvbnRlbnQ6XCJcIn0uYW50LWJ0bi1kYW5nZXJvdXMuYW50LWJ0bi1saW5rOmFjdGl2ZXtjb2xvcjojZDkzNjNlO2JvcmRlci1jb2xvcjp0cmFuc3BhcmVudDtiYWNrZ3JvdW5kOnRyYW5zcGFyZW50fS5hbnQtYnRuLWRhbmdlcm91cy5hbnQtYnRuLWxpbms6YWN0aXZlPmE6b25seS1jaGlsZHtjb2xvcjpjdXJyZW50Y29sb3J9LmFudC1idG4tZGFuZ2Vyb3VzLmFudC1idG4tbGluazphY3RpdmU+YTpvbmx5LWNoaWxkOmFmdGVye3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO3JpZ2h0OjA7Ym90dG9tOjA7bGVmdDowO2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7Y29udGVudDpcIlwifS5hbnQtYnRuLWRhbmdlcm91cy5hbnQtYnRuLWxpbmtbZGlzYWJsZWRdLC5hbnQtYnRuLWRhbmdlcm91cy5hbnQtYnRuLWxpbmtbZGlzYWJsZWRdOmFjdGl2ZSwuYW50LWJ0bi1kYW5nZXJvdXMuYW50LWJ0bi1saW5rW2Rpc2FibGVkXTpmb2N1cywuYW50LWJ0bi1kYW5nZXJvdXMuYW50LWJ0bi1saW5rW2Rpc2FibGVkXTpob3Zlcntjb2xvcjpyZ2JhKDAsMCwwLC4yNSk7Ym9yZGVyLWNvbG9yOnRyYW5zcGFyZW50O2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7dGV4dC1zaGFkb3c6bm9uZTtib3gtc2hhZG93Om5vbmV9LmFudC1idG4tZGFuZ2Vyb3VzLmFudC1idG4tbGlua1tkaXNhYmxlZF06YWN0aXZlPmE6b25seS1jaGlsZCwuYW50LWJ0bi1kYW5nZXJvdXMuYW50LWJ0bi1saW5rW2Rpc2FibGVkXTpmb2N1cz5hOm9ubHktY2hpbGQsLmFudC1idG4tZGFuZ2Vyb3VzLmFudC1idG4tbGlua1tkaXNhYmxlZF06aG92ZXI+YTpvbmx5LWNoaWxkLC5hbnQtYnRuLWRhbmdlcm91cy5hbnQtYnRuLWxpbmtbZGlzYWJsZWRdPmE6b25seS1jaGlsZHtjb2xvcjpjdXJyZW50Y29sb3J9LmFudC1idG4tZGFuZ2Vyb3VzLmFudC1idG4tbGlua1tkaXNhYmxlZF06YWN0aXZlPmE6b25seS1jaGlsZDphZnRlciwuYW50LWJ0bi1kYW5nZXJvdXMuYW50LWJ0bi1saW5rW2Rpc2FibGVkXTpmb2N1cz5hOm9ubHktY2hpbGQ6YWZ0ZXIsLmFudC1idG4tZGFuZ2Vyb3VzLmFudC1idG4tbGlua1tkaXNhYmxlZF06aG92ZXI+YTpvbmx5LWNoaWxkOmFmdGVyLC5hbnQtYnRuLWRhbmdlcm91cy5hbnQtYnRuLWxpbmtbZGlzYWJsZWRdPmE6b25seS1jaGlsZDphZnRlcntwb3NpdGlvbjphYnNvbHV0ZTt0b3A6MDtyaWdodDowO2JvdHRvbTowO2xlZnQ6MDtiYWNrZ3JvdW5kOnRyYW5zcGFyZW50O2NvbnRlbnQ6XCJcIn0uYW50LWJ0bi1kYW5nZXJvdXMuYW50LWJ0bi10ZXh0e2NvbG9yOiNmZjRkNGY7Ym9yZGVyLWNvbG9yOnRyYW5zcGFyZW50O2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7Ym94LXNoYWRvdzpub25lfS5hbnQtYnRuLWRhbmdlcm91cy5hbnQtYnRuLXRleHQ+YTpvbmx5LWNoaWxke2NvbG9yOmN1cnJlbnRjb2xvcn0uYW50LWJ0bi1kYW5nZXJvdXMuYW50LWJ0bi10ZXh0PmE6b25seS1jaGlsZDphZnRlcntwb3NpdGlvbjphYnNvbHV0ZTt0b3A6MDtyaWdodDowO2JvdHRvbTowO2xlZnQ6MDtiYWNrZ3JvdW5kOnRyYW5zcGFyZW50O2NvbnRlbnQ6XCJcIn0uYW50LWJ0bi1kYW5nZXJvdXMuYW50LWJ0bi10ZXh0OmZvY3VzLC5hbnQtYnRuLWRhbmdlcm91cy5hbnQtYnRuLXRleHQ6aG92ZXJ7Y29sb3I6IzQwYTlmZjtib3JkZXItY29sb3I6IzQwYTlmZjtiYWNrZ3JvdW5kOnRyYW5zcGFyZW50fS5hbnQtYnRuLWRhbmdlcm91cy5hbnQtYnRuLXRleHQ6YWN0aXZle2NvbG9yOiMwOTZkZDk7Ym9yZGVyLWNvbG9yOiMwOTZkZDk7YmFja2dyb3VuZDp0cmFuc3BhcmVudH0uYW50LWJ0bi1kYW5nZXJvdXMuYW50LWJ0bi10ZXh0W2Rpc2FibGVkXSwuYW50LWJ0bi1kYW5nZXJvdXMuYW50LWJ0bi10ZXh0W2Rpc2FibGVkXTphY3RpdmUsLmFudC1idG4tZGFuZ2Vyb3VzLmFudC1idG4tdGV4dFtkaXNhYmxlZF06Zm9jdXMsLmFudC1idG4tZGFuZ2Vyb3VzLmFudC1idG4tdGV4dFtkaXNhYmxlZF06aG92ZXJ7Ym9yZGVyLWNvbG9yOiNkOWQ5ZDk7YmFja2dyb3VuZDojZjVmNWY1fS5hbnQtYnRuLWRhbmdlcm91cy5hbnQtYnRuLXRleHQ6Zm9jdXMsLmFudC1idG4tZGFuZ2Vyb3VzLmFudC1idG4tdGV4dDpob3Zlcntjb2xvcjojZmY3ODc1O2JvcmRlci1jb2xvcjp0cmFuc3BhcmVudDtiYWNrZ3JvdW5kOnJnYmEoMCwwLDAsLjAxOCl9LmFudC1idG4tZGFuZ2Vyb3VzLmFudC1idG4tdGV4dDpmb2N1cz5hOm9ubHktY2hpbGQsLmFudC1idG4tZGFuZ2Vyb3VzLmFudC1idG4tdGV4dDpob3Zlcj5hOm9ubHktY2hpbGR7Y29sb3I6Y3VycmVudGNvbG9yfS5hbnQtYnRuLWRhbmdlcm91cy5hbnQtYnRuLXRleHQ6Zm9jdXM+YTpvbmx5LWNoaWxkOmFmdGVyLC5hbnQtYnRuLWRhbmdlcm91cy5hbnQtYnRuLXRleHQ6aG92ZXI+YTpvbmx5LWNoaWxkOmFmdGVye3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO3JpZ2h0OjA7Ym90dG9tOjA7bGVmdDowO2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7Y29udGVudDpcIlwifS5hbnQtYnRuLWRhbmdlcm91cy5hbnQtYnRuLXRleHQ6YWN0aXZle2NvbG9yOiNkOTM2M2U7Ym9yZGVyLWNvbG9yOnRyYW5zcGFyZW50O2JhY2tncm91bmQ6cmdiYSgwLDAsMCwuMDI4KX0uYW50LWJ0bi1kYW5nZXJvdXMuYW50LWJ0bi10ZXh0OmFjdGl2ZT5hOm9ubHktY2hpbGR7Y29sb3I6Y3VycmVudGNvbG9yfS5hbnQtYnRuLWRhbmdlcm91cy5hbnQtYnRuLXRleHQ6YWN0aXZlPmE6b25seS1jaGlsZDphZnRlcntwb3NpdGlvbjphYnNvbHV0ZTt0b3A6MDtyaWdodDowO2JvdHRvbTowO2xlZnQ6MDtiYWNrZ3JvdW5kOnRyYW5zcGFyZW50O2NvbnRlbnQ6XCJcIn0uYW50LWJ0bi1kYW5nZXJvdXMuYW50LWJ0bi10ZXh0W2Rpc2FibGVkXSwuYW50LWJ0bi1kYW5nZXJvdXMuYW50LWJ0bi10ZXh0W2Rpc2FibGVkXTphY3RpdmUsLmFudC1idG4tZGFuZ2Vyb3VzLmFudC1idG4tdGV4dFtkaXNhYmxlZF06Zm9jdXMsLmFudC1idG4tZGFuZ2Vyb3VzLmFudC1idG4tdGV4dFtkaXNhYmxlZF06aG92ZXJ7Y29sb3I6cmdiYSgwLDAsMCwuMjUpO2JvcmRlci1jb2xvcjp0cmFuc3BhcmVudDtiYWNrZ3JvdW5kOnRyYW5zcGFyZW50O3RleHQtc2hhZG93Om5vbmU7Ym94LXNoYWRvdzpub25lfS5hbnQtYnRuLWRhbmdlcm91cy5hbnQtYnRuLXRleHRbZGlzYWJsZWRdOmFjdGl2ZT5hOm9ubHktY2hpbGQsLmFudC1idG4tZGFuZ2Vyb3VzLmFudC1idG4tdGV4dFtkaXNhYmxlZF06Zm9jdXM+YTpvbmx5LWNoaWxkLC5hbnQtYnRuLWRhbmdlcm91cy5hbnQtYnRuLXRleHRbZGlzYWJsZWRdOmhvdmVyPmE6b25seS1jaGlsZCwuYW50LWJ0bi1kYW5nZXJvdXMuYW50LWJ0bi10ZXh0W2Rpc2FibGVkXT5hOm9ubHktY2hpbGR7Y29sb3I6Y3VycmVudGNvbG9yfS5hbnQtYnRuLWRhbmdlcm91cy5hbnQtYnRuLXRleHRbZGlzYWJsZWRdOmFjdGl2ZT5hOm9ubHktY2hpbGQ6YWZ0ZXIsLmFudC1idG4tZGFuZ2Vyb3VzLmFudC1idG4tdGV4dFtkaXNhYmxlZF06Zm9jdXM+YTpvbmx5LWNoaWxkOmFmdGVyLC5hbnQtYnRuLWRhbmdlcm91cy5hbnQtYnRuLXRleHRbZGlzYWJsZWRdOmhvdmVyPmE6b25seS1jaGlsZDphZnRlciwuYW50LWJ0bi1kYW5nZXJvdXMuYW50LWJ0bi10ZXh0W2Rpc2FibGVkXT5hOm9ubHktY2hpbGQ6YWZ0ZXJ7cG9zaXRpb246YWJzb2x1dGU7dG9wOjA7cmlnaHQ6MDtib3R0b206MDtsZWZ0OjA7YmFja2dyb3VuZDp0cmFuc3BhcmVudDtjb250ZW50OlwiXCJ9LmFudC1idG4taWNvbi1vbmx5e3dpZHRoOjMycHg7aGVpZ2h0OjMycHg7cGFkZGluZzoyLjRweCAwO2ZvbnQtc2l6ZToxNnB4O2JvcmRlci1yYWRpdXM6MnB4O3ZlcnRpY2FsLWFsaWduOi0zcHh9LmFudC1idG4taWNvbi1vbmx5Pip7Zm9udC1zaXplOjE2cHh9LmFudC1idG4taWNvbi1vbmx5LmFudC1idG4tbGd7d2lkdGg6NDBweDtoZWlnaHQ6NDBweDtwYWRkaW5nOjQuOXB4IDA7Zm9udC1zaXplOjE4cHg7Ym9yZGVyLXJhZGl1czoycHh9LmFudC1idG4taWNvbi1vbmx5LmFudC1idG4tbGc+Kntmb250LXNpemU6MThweH0uYW50LWJ0bi1pY29uLW9ubHkuYW50LWJ0bi1zbXt3aWR0aDoyNHB4O2hlaWdodDoyNHB4O3BhZGRpbmc6MDtmb250LXNpemU6MTRweDtib3JkZXItcmFkaXVzOjJweH0uYW50LWJ0bi1pY29uLW9ubHkuYW50LWJ0bi1zbT4qe2ZvbnQtc2l6ZToxNHB4fS5hbnQtYnRuLWljb24tb25seT4uYW50aWNvbntkaXNwbGF5OmZsZXg7anVzdGlmeS1jb250ZW50OmNlbnRlcn0uYW50LWJ0bi1pY29uLW9ubHkgLmFudGljb24tbG9hZGluZ3twYWRkaW5nOjAhaW1wb3J0YW50fWEuYW50LWJ0bi1pY29uLW9ubHl7dmVydGljYWwtYWxpZ246LTFweH1hLmFudC1idG4taWNvbi1vbmx5Pi5hbnRpY29ue2Rpc3BsYXk6aW5saW5lfS5hbnQtYnRuLXJvdW5ke2hlaWdodDozMnB4O3BhZGRpbmc6NHB4IDE2cHg7Zm9udC1zaXplOjE0cHg7Ym9yZGVyLXJhZGl1czozMnB4fS5hbnQtYnRuLXJvdW5kLmFudC1idG4tbGd7aGVpZ2h0OjQwcHg7cGFkZGluZzo2LjRweCAyMHB4O2ZvbnQtc2l6ZToxNnB4O2JvcmRlci1yYWRpdXM6NDBweH0uYW50LWJ0bi1yb3VuZC5hbnQtYnRuLXNte2hlaWdodDoyNHB4O3BhZGRpbmc6MCAxMnB4O2ZvbnQtc2l6ZToxNHB4O2JvcmRlci1yYWRpdXM6MjRweH0uYW50LWJ0bi1yb3VuZC5hbnQtYnRuLWljb24tb25seXt3aWR0aDphdXRvfS5hbnQtYnRuLWNpcmNsZXttaW4td2lkdGg6MzJweDtwYWRkaW5nLXJpZ2h0OjA7cGFkZGluZy1sZWZ0OjA7dGV4dC1hbGlnbjpjZW50ZXI7Ym9yZGVyLXJhZGl1czo1MCV9LmFudC1idG4tY2lyY2xlLmFudC1idG4tbGd7bWluLXdpZHRoOjQwcHg7Ym9yZGVyLXJhZGl1czo1MCV9LmFudC1idG4tY2lyY2xlLmFudC1idG4tc217bWluLXdpZHRoOjI0cHg7Ym9yZGVyLXJhZGl1czo1MCV9LmFudC1idG46YmVmb3Jle3Bvc2l0aW9uOmFic29sdXRlO3RvcDotMXB4O3JpZ2h0Oi0xcHg7Ym90dG9tOi0xcHg7bGVmdDotMXB4O3otaW5kZXg6MTtkaXNwbGF5Om5vbmU7YmFja2dyb3VuZDojZmZmO2JvcmRlci1yYWRpdXM6aW5oZXJpdDtvcGFjaXR5Oi4zNTt0cmFuc2l0aW9uOm9wYWNpdHkgLjJzO2NvbnRlbnQ6XCJcIjtwb2ludGVyLWV2ZW50czpub25lfS5hbnQtYnRuIC5hbnRpY29ue3RyYW5zaXRpb246bWFyZ2luLWxlZnQgLjNzIGN1YmljLWJlemllciguNjQ1LC4wNDUsLjM1NSwxKX0uYW50LWJ0biAuYW50aWNvbi5hbnRpY29uLW1pbnVzPnN2ZywuYW50LWJ0biAuYW50aWNvbi5hbnRpY29uLXBsdXM+c3Zne3NoYXBlLXJlbmRlcmluZzpvcHRpbWl6ZXNwZWVkfS5hbnQtYnRuLmFudC1idG4tbG9hZGluZ3twb3NpdGlvbjpyZWxhdGl2ZTtjdXJzb3I6ZGVmYXVsdH0uYW50LWJ0bi5hbnQtYnRuLWxvYWRpbmc6YmVmb3Jle2Rpc3BsYXk6YmxvY2t9LmFudC1idG4+LmFudC1idG4tbG9hZGluZy1pY29ue3RyYW5zaXRpb246d2lkdGggLjNzIGN1YmljLWJlemllciguNjQ1LC4wNDUsLjM1NSwxKSxvcGFjaXR5IC4zcyBjdWJpYy1iZXppZXIoLjY0NSwuMDQ1LC4zNTUsMSl9LmFudC1idG4+LmFudC1idG4tbG9hZGluZy1pY29uIC5hbnRpY29ue3BhZGRpbmctcmlnaHQ6OHB4O2FuaW1hdGlvbjpub25lfS5hbnQtYnRuPi5hbnQtYnRuLWxvYWRpbmctaWNvbiAuYW50aWNvbiBzdmd7YW5pbWF0aW9uOmxvYWRpbmdDaXJjbGUgMXMgbGluZWFyIGluZmluaXRlfS5hbnQtYnRuLWdyb3Vwe2Rpc3BsYXk6aW5saW5lLWZsZXh9LmFudC1idG4tZ3JvdXAsLmFudC1idG4tZ3JvdXA+LmFudC1idG4sLmFudC1idG4tZ3JvdXA+c3Bhbj4uYW50LWJ0bntwb3NpdGlvbjpyZWxhdGl2ZX0uYW50LWJ0bi1ncm91cD4uYW50LWJ0bjphY3RpdmUsLmFudC1idG4tZ3JvdXA+LmFudC1idG46Zm9jdXMsLmFudC1idG4tZ3JvdXA+LmFudC1idG46aG92ZXIsLmFudC1idG4tZ3JvdXA+c3Bhbj4uYW50LWJ0bjphY3RpdmUsLmFudC1idG4tZ3JvdXA+c3Bhbj4uYW50LWJ0bjpmb2N1cywuYW50LWJ0bi1ncm91cD5zcGFuPi5hbnQtYnRuOmhvdmVye3otaW5kZXg6Mn0uYW50LWJ0bi1ncm91cD4uYW50LWJ0bltkaXNhYmxlZF0sLmFudC1idG4tZ3JvdXA+c3Bhbj4uYW50LWJ0bltkaXNhYmxlZF17ei1pbmRleDowfS5hbnQtYnRuLWdyb3VwIC5hbnQtYnRuLWljb24tb25seXtmb250LXNpemU6MTRweH0uYW50LWJ0bisuYW50LWJ0bi1ncm91cCwuYW50LWJ0bi1ncm91cCsuYW50LWJ0biwuYW50LWJ0bi1ncm91cCsuYW50LWJ0bi1ncm91cCwuYW50LWJ0bi1ncm91cCAuYW50LWJ0bisuYW50LWJ0biwuYW50LWJ0bi1ncm91cCAuYW50LWJ0bitzcGFuLC5hbnQtYnRuLWdyb3VwPnNwYW4rc3BhbiwuYW50LWJ0bi1ncm91cCBzcGFuKy5hbnQtYnRue21hcmdpbi1sZWZ0Oi0xcHh9LmFudC1idG4tZ3JvdXAgLmFudC1idG4tcHJpbWFyeSsuYW50LWJ0bjpub3QoLmFudC1idG4tcHJpbWFyeSk6bm90KFtkaXNhYmxlZF0pe2JvcmRlci1sZWZ0LWNvbG9yOnRyYW5zcGFyZW50fS5hbnQtYnRuLWdyb3VwIC5hbnQtYnRue2JvcmRlci1yYWRpdXM6MH0uYW50LWJ0bi1ncm91cD4uYW50LWJ0bjpmaXJzdC1jaGlsZCwuYW50LWJ0bi1ncm91cD5zcGFuOmZpcnN0LWNoaWxkPi5hbnQtYnRue21hcmdpbi1sZWZ0OjB9LmFudC1idG4tZ3JvdXA+LmFudC1idG46b25seS1jaGlsZCwuYW50LWJ0bi1ncm91cD5zcGFuOm9ubHktY2hpbGQ+LmFudC1idG57Ym9yZGVyLXJhZGl1czoycHh9LmFudC1idG4tZ3JvdXA+LmFudC1idG46Zmlyc3QtY2hpbGQ6bm90KDpsYXN0LWNoaWxkKSwuYW50LWJ0bi1ncm91cD5zcGFuOmZpcnN0LWNoaWxkOm5vdCg6bGFzdC1jaGlsZCk+LmFudC1idG57Ym9yZGVyLXRvcC1sZWZ0LXJhZGl1czoycHg7Ym9yZGVyLWJvdHRvbS1sZWZ0LXJhZGl1czoycHh9LmFudC1idG4tZ3JvdXA+LmFudC1idG46bGFzdC1jaGlsZDpub3QoOmZpcnN0LWNoaWxkKSwuYW50LWJ0bi1ncm91cD5zcGFuOmxhc3QtY2hpbGQ6bm90KDpmaXJzdC1jaGlsZCk+LmFudC1idG57Ym9yZGVyLXRvcC1yaWdodC1yYWRpdXM6MnB4O2JvcmRlci1ib3R0b20tcmlnaHQtcmFkaXVzOjJweH0uYW50LWJ0bi1ncm91cC1zbT4uYW50LWJ0bjpvbmx5LWNoaWxkLC5hbnQtYnRuLWdyb3VwLXNtPnNwYW46b25seS1jaGlsZD4uYW50LWJ0bntib3JkZXItcmFkaXVzOjJweH0uYW50LWJ0bi1ncm91cC1zbT4uYW50LWJ0bjpmaXJzdC1jaGlsZDpub3QoOmxhc3QtY2hpbGQpLC5hbnQtYnRuLWdyb3VwLXNtPnNwYW46Zmlyc3QtY2hpbGQ6bm90KDpsYXN0LWNoaWxkKT4uYW50LWJ0bntib3JkZXItdG9wLWxlZnQtcmFkaXVzOjJweDtib3JkZXItYm90dG9tLWxlZnQtcmFkaXVzOjJweH0uYW50LWJ0bi1ncm91cC1zbT4uYW50LWJ0bjpsYXN0LWNoaWxkOm5vdCg6Zmlyc3QtY2hpbGQpLC5hbnQtYnRuLWdyb3VwLXNtPnNwYW46bGFzdC1jaGlsZDpub3QoOmZpcnN0LWNoaWxkKT4uYW50LWJ0bntib3JkZXItdG9wLXJpZ2h0LXJhZGl1czoycHg7Ym9yZGVyLWJvdHRvbS1yaWdodC1yYWRpdXM6MnB4fS5hbnQtYnRuLWdyb3VwPi5hbnQtYnRuLWdyb3Vwe2Zsb2F0OmxlZnR9LmFudC1idG4tZ3JvdXA+LmFudC1idG4tZ3JvdXA6bm90KDpmaXJzdC1jaGlsZCk6bm90KDpsYXN0LWNoaWxkKT4uYW50LWJ0bntib3JkZXItcmFkaXVzOjB9LmFudC1idG4tZ3JvdXA+LmFudC1idG4tZ3JvdXA6Zmlyc3QtY2hpbGQ6bm90KDpsYXN0LWNoaWxkKT4uYW50LWJ0bjpsYXN0LWNoaWxke3BhZGRpbmctcmlnaHQ6OHB4O2JvcmRlci10b3AtcmlnaHQtcmFkaXVzOjA7Ym9yZGVyLWJvdHRvbS1yaWdodC1yYWRpdXM6MH0uYW50LWJ0bi1ncm91cD4uYW50LWJ0bi1ncm91cDpsYXN0LWNoaWxkOm5vdCg6Zmlyc3QtY2hpbGQpPi5hbnQtYnRuOmZpcnN0LWNoaWxke3BhZGRpbmctbGVmdDo4cHg7Ym9yZGVyLXRvcC1sZWZ0LXJhZGl1czowO2JvcmRlci1ib3R0b20tbGVmdC1yYWRpdXM6MH0uYW50LWJ0bi1ncm91cC1ydGwuYW50LWJ0bisuYW50LWJ0bi1ncm91cCwuYW50LWJ0bi1ncm91cC1ydGwuYW50LWJ0bi1ncm91cCsuYW50LWJ0biwuYW50LWJ0bi1ncm91cC1ydGwuYW50LWJ0bi1ncm91cCsuYW50LWJ0bi1ncm91cCwuYW50LWJ0bi1ncm91cC1ydGwuYW50LWJ0bi1ncm91cCAuYW50LWJ0bisuYW50LWJ0biwuYW50LWJ0bi1ncm91cC1ydGwuYW50LWJ0bi1ncm91cCAuYW50LWJ0bitzcGFuLC5hbnQtYnRuLWdyb3VwLXJ0bC5hbnQtYnRuLWdyb3VwPnNwYW4rc3BhbiwuYW50LWJ0bi1ncm91cC1ydGwuYW50LWJ0bi1ncm91cCBzcGFuKy5hbnQtYnRuLC5hbnQtYnRuLXJ0bC5hbnQtYnRuKy5hbnQtYnRuLWdyb3VwLC5hbnQtYnRuLXJ0bC5hbnQtYnRuLWdyb3VwKy5hbnQtYnRuLC5hbnQtYnRuLXJ0bC5hbnQtYnRuLWdyb3VwKy5hbnQtYnRuLWdyb3VwLC5hbnQtYnRuLXJ0bC5hbnQtYnRuLWdyb3VwIC5hbnQtYnRuKy5hbnQtYnRuLC5hbnQtYnRuLXJ0bC5hbnQtYnRuLWdyb3VwIC5hbnQtYnRuK3NwYW4sLmFudC1idG4tcnRsLmFudC1idG4tZ3JvdXA+c3BhbitzcGFuLC5hbnQtYnRuLXJ0bC5hbnQtYnRuLWdyb3VwIHNwYW4rLmFudC1idG57bWFyZ2luLXJpZ2h0Oi0xcHg7bWFyZ2luLWxlZnQ6YXV0b30uYW50LWJ0bi1ncm91cC5hbnQtYnRuLWdyb3VwLXJ0bHtkaXJlY3Rpb246cnRsfS5hbnQtYnRuLWdyb3VwLXJ0bC5hbnQtYnRuLWdyb3VwPi5hbnQtYnRuOmZpcnN0LWNoaWxkOm5vdCg6bGFzdC1jaGlsZCksLmFudC1idG4tZ3JvdXAtcnRsLmFudC1idG4tZ3JvdXA+c3BhbjpmaXJzdC1jaGlsZDpub3QoOmxhc3QtY2hpbGQpPi5hbnQtYnRue2JvcmRlci1yYWRpdXM6MCAycHggMnB4IDB9LmFudC1idG4tZ3JvdXAtcnRsLmFudC1idG4tZ3JvdXA+LmFudC1idG46bGFzdC1jaGlsZDpub3QoOmZpcnN0LWNoaWxkKSwuYW50LWJ0bi1ncm91cC1ydGwuYW50LWJ0bi1ncm91cD5zcGFuOmxhc3QtY2hpbGQ6bm90KDpmaXJzdC1jaGlsZCk+LmFudC1idG57Ym9yZGVyLXJhZGl1czoycHggMCAwIDJweH0uYW50LWJ0bi1ncm91cC1ydGwuYW50LWJ0bi1ncm91cC1zbT4uYW50LWJ0bjpmaXJzdC1jaGlsZDpub3QoOmxhc3QtY2hpbGQpLC5hbnQtYnRuLWdyb3VwLXJ0bC5hbnQtYnRuLWdyb3VwLXNtPnNwYW46Zmlyc3QtY2hpbGQ6bm90KDpsYXN0LWNoaWxkKT4uYW50LWJ0bntib3JkZXItcmFkaXVzOjAgMnB4IDJweCAwfS5hbnQtYnRuLWdyb3VwLXJ0bC5hbnQtYnRuLWdyb3VwLXNtPi5hbnQtYnRuOmxhc3QtY2hpbGQ6bm90KDpmaXJzdC1jaGlsZCksLmFudC1idG4tZ3JvdXAtcnRsLmFudC1idG4tZ3JvdXAtc20+c3BhbjpsYXN0LWNoaWxkOm5vdCg6Zmlyc3QtY2hpbGQpPi5hbnQtYnRue2JvcmRlci1yYWRpdXM6MnB4IDAgMCAycHh9LmFudC1idG46YWN0aXZlPnNwYW4sLmFudC1idG46Zm9jdXM+c3Bhbntwb3NpdGlvbjpyZWxhdGl2ZX0uYW50LWJ0bj4uYW50aWNvbitzcGFuLC5hbnQtYnRuPnNwYW4rLmFudGljb257bWFyZ2luLWxlZnQ6OHB4fS5hbnQtYnRuLmFudC1idG4tYmFja2dyb3VuZC1naG9zdHtjb2xvcjojZmZmO2JvcmRlci1jb2xvcjojZmZmfS5hbnQtYnRuLmFudC1idG4tYmFja2dyb3VuZC1naG9zdCwuYW50LWJ0bi5hbnQtYnRuLWJhY2tncm91bmQtZ2hvc3Q6YWN0aXZlLC5hbnQtYnRuLmFudC1idG4tYmFja2dyb3VuZC1naG9zdDpmb2N1cywuYW50LWJ0bi5hbnQtYnRuLWJhY2tncm91bmQtZ2hvc3Q6aG92ZXJ7YmFja2dyb3VuZDp0cmFuc3BhcmVudH0uYW50LWJ0bi5hbnQtYnRuLWJhY2tncm91bmQtZ2hvc3Q6Zm9jdXMsLmFudC1idG4uYW50LWJ0bi1iYWNrZ3JvdW5kLWdob3N0OmhvdmVye2NvbG9yOiM0MGE5ZmY7Ym9yZGVyLWNvbG9yOiM0MGE5ZmZ9LmFudC1idG4uYW50LWJ0bi1iYWNrZ3JvdW5kLWdob3N0OmFjdGl2ZXtjb2xvcjojMDk2ZGQ5O2JvcmRlci1jb2xvcjojMDk2ZGQ5fS5hbnQtYnRuLmFudC1idG4tYmFja2dyb3VuZC1naG9zdFtkaXNhYmxlZF17Y29sb3I6cmdiYSgwLDAsMCwuMjUpO2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7Ym9yZGVyLWNvbG9yOiNkOWQ5ZDl9LmFudC1idG4tYmFja2dyb3VuZC1naG9zdC5hbnQtYnRuLXByaW1hcnl7Y29sb3I6IzE4OTBmZjtib3JkZXItY29sb3I6IzE4OTBmZjt0ZXh0LXNoYWRvdzpub25lfS5hbnQtYnRuLWJhY2tncm91bmQtZ2hvc3QuYW50LWJ0bi1wcmltYXJ5PmE6b25seS1jaGlsZHtjb2xvcjpjdXJyZW50Y29sb3J9LmFudC1idG4tYmFja2dyb3VuZC1naG9zdC5hbnQtYnRuLXByaW1hcnk+YTpvbmx5LWNoaWxkOmFmdGVye3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO3JpZ2h0OjA7Ym90dG9tOjA7bGVmdDowO2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7Y29udGVudDpcIlwifS5hbnQtYnRuLWJhY2tncm91bmQtZ2hvc3QuYW50LWJ0bi1wcmltYXJ5OmZvY3VzLC5hbnQtYnRuLWJhY2tncm91bmQtZ2hvc3QuYW50LWJ0bi1wcmltYXJ5OmhvdmVye2NvbG9yOiM0MGE5ZmY7Ym9yZGVyLWNvbG9yOiM0MGE5ZmZ9LmFudC1idG4tYmFja2dyb3VuZC1naG9zdC5hbnQtYnRuLXByaW1hcnk6Zm9jdXM+YTpvbmx5LWNoaWxkLC5hbnQtYnRuLWJhY2tncm91bmQtZ2hvc3QuYW50LWJ0bi1wcmltYXJ5OmhvdmVyPmE6b25seS1jaGlsZHtjb2xvcjpjdXJyZW50Y29sb3J9LmFudC1idG4tYmFja2dyb3VuZC1naG9zdC5hbnQtYnRuLXByaW1hcnk6Zm9jdXM+YTpvbmx5LWNoaWxkOmFmdGVyLC5hbnQtYnRuLWJhY2tncm91bmQtZ2hvc3QuYW50LWJ0bi1wcmltYXJ5OmhvdmVyPmE6b25seS1jaGlsZDphZnRlcntwb3NpdGlvbjphYnNvbHV0ZTt0b3A6MDtyaWdodDowO2JvdHRvbTowO2xlZnQ6MDtiYWNrZ3JvdW5kOnRyYW5zcGFyZW50O2NvbnRlbnQ6XCJcIn0uYW50LWJ0bi1iYWNrZ3JvdW5kLWdob3N0LmFudC1idG4tcHJpbWFyeTphY3RpdmV7Y29sb3I6IzA5NmRkOTtib3JkZXItY29sb3I6IzA5NmRkOX0uYW50LWJ0bi1iYWNrZ3JvdW5kLWdob3N0LmFudC1idG4tcHJpbWFyeTphY3RpdmU+YTpvbmx5LWNoaWxke2NvbG9yOmN1cnJlbnRjb2xvcn0uYW50LWJ0bi1iYWNrZ3JvdW5kLWdob3N0LmFudC1idG4tcHJpbWFyeTphY3RpdmU+YTpvbmx5LWNoaWxkOmFmdGVye3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO3JpZ2h0OjA7Ym90dG9tOjA7bGVmdDowO2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7Y29udGVudDpcIlwifS5hbnQtYnRuLWJhY2tncm91bmQtZ2hvc3QuYW50LWJ0bi1wcmltYXJ5W2Rpc2FibGVkXSwuYW50LWJ0bi1iYWNrZ3JvdW5kLWdob3N0LmFudC1idG4tcHJpbWFyeVtkaXNhYmxlZF06YWN0aXZlLC5hbnQtYnRuLWJhY2tncm91bmQtZ2hvc3QuYW50LWJ0bi1wcmltYXJ5W2Rpc2FibGVkXTpmb2N1cywuYW50LWJ0bi1iYWNrZ3JvdW5kLWdob3N0LmFudC1idG4tcHJpbWFyeVtkaXNhYmxlZF06aG92ZXJ7Y29sb3I6cmdiYSgwLDAsMCwuMjUpO2JvcmRlci1jb2xvcjojZDlkOWQ5O2JhY2tncm91bmQ6I2Y1ZjVmNTt0ZXh0LXNoYWRvdzpub25lO2JveC1zaGFkb3c6bm9uZX0uYW50LWJ0bi1iYWNrZ3JvdW5kLWdob3N0LmFudC1idG4tcHJpbWFyeVtkaXNhYmxlZF06YWN0aXZlPmE6b25seS1jaGlsZCwuYW50LWJ0bi1iYWNrZ3JvdW5kLWdob3N0LmFudC1idG4tcHJpbWFyeVtkaXNhYmxlZF06Zm9jdXM+YTpvbmx5LWNoaWxkLC5hbnQtYnRuLWJhY2tncm91bmQtZ2hvc3QuYW50LWJ0bi1wcmltYXJ5W2Rpc2FibGVkXTpob3Zlcj5hOm9ubHktY2hpbGQsLmFudC1idG4tYmFja2dyb3VuZC1naG9zdC5hbnQtYnRuLXByaW1hcnlbZGlzYWJsZWRdPmE6b25seS1jaGlsZHtjb2xvcjpjdXJyZW50Y29sb3J9LmFudC1idG4tYmFja2dyb3VuZC1naG9zdC5hbnQtYnRuLXByaW1hcnlbZGlzYWJsZWRdOmFjdGl2ZT5hOm9ubHktY2hpbGQ6YWZ0ZXIsLmFudC1idG4tYmFja2dyb3VuZC1naG9zdC5hbnQtYnRuLXByaW1hcnlbZGlzYWJsZWRdOmZvY3VzPmE6b25seS1jaGlsZDphZnRlciwuYW50LWJ0bi1iYWNrZ3JvdW5kLWdob3N0LmFudC1idG4tcHJpbWFyeVtkaXNhYmxlZF06aG92ZXI+YTpvbmx5LWNoaWxkOmFmdGVyLC5hbnQtYnRuLWJhY2tncm91bmQtZ2hvc3QuYW50LWJ0bi1wcmltYXJ5W2Rpc2FibGVkXT5hOm9ubHktY2hpbGQ6YWZ0ZXJ7cG9zaXRpb246YWJzb2x1dGU7dG9wOjA7cmlnaHQ6MDtib3R0b206MDtsZWZ0OjA7YmFja2dyb3VuZDp0cmFuc3BhcmVudDtjb250ZW50OlwiXCJ9LmFudC1idG4tYmFja2dyb3VuZC1naG9zdC5hbnQtYnRuLWRhbmdlcntjb2xvcjojZmY0ZDRmO2JvcmRlci1jb2xvcjojZmY0ZDRmO3RleHQtc2hhZG93Om5vbmV9LmFudC1idG4tYmFja2dyb3VuZC1naG9zdC5hbnQtYnRuLWRhbmdlcj5hOm9ubHktY2hpbGR7Y29sb3I6Y3VycmVudGNvbG9yfS5hbnQtYnRuLWJhY2tncm91bmQtZ2hvc3QuYW50LWJ0bi1kYW5nZXI+YTpvbmx5LWNoaWxkOmFmdGVye3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO3JpZ2h0OjA7Ym90dG9tOjA7bGVmdDowO2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7Y29udGVudDpcIlwifS5hbnQtYnRuLWJhY2tncm91bmQtZ2hvc3QuYW50LWJ0bi1kYW5nZXI6Zm9jdXMsLmFudC1idG4tYmFja2dyb3VuZC1naG9zdC5hbnQtYnRuLWRhbmdlcjpob3Zlcntjb2xvcjojZmY3ODc1O2JvcmRlci1jb2xvcjojZmY3ODc1fS5hbnQtYnRuLWJhY2tncm91bmQtZ2hvc3QuYW50LWJ0bi1kYW5nZXI6Zm9jdXM+YTpvbmx5LWNoaWxkLC5hbnQtYnRuLWJhY2tncm91bmQtZ2hvc3QuYW50LWJ0bi1kYW5nZXI6aG92ZXI+YTpvbmx5LWNoaWxke2NvbG9yOmN1cnJlbnRjb2xvcn0uYW50LWJ0bi1iYWNrZ3JvdW5kLWdob3N0LmFudC1idG4tZGFuZ2VyOmZvY3VzPmE6b25seS1jaGlsZDphZnRlciwuYW50LWJ0bi1iYWNrZ3JvdW5kLWdob3N0LmFudC1idG4tZGFuZ2VyOmhvdmVyPmE6b25seS1jaGlsZDphZnRlcntwb3NpdGlvbjphYnNvbHV0ZTt0b3A6MDtyaWdodDowO2JvdHRvbTowO2xlZnQ6MDtiYWNrZ3JvdW5kOnRyYW5zcGFyZW50O2NvbnRlbnQ6XCJcIn0uYW50LWJ0bi1iYWNrZ3JvdW5kLWdob3N0LmFudC1idG4tZGFuZ2VyOmFjdGl2ZXtjb2xvcjojZDkzNjNlO2JvcmRlci1jb2xvcjojZDkzNjNlfS5hbnQtYnRuLWJhY2tncm91bmQtZ2hvc3QuYW50LWJ0bi1kYW5nZXI6YWN0aXZlPmE6b25seS1jaGlsZHtjb2xvcjpjdXJyZW50Y29sb3J9LmFudC1idG4tYmFja2dyb3VuZC1naG9zdC5hbnQtYnRuLWRhbmdlcjphY3RpdmU+YTpvbmx5LWNoaWxkOmFmdGVye3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO3JpZ2h0OjA7Ym90dG9tOjA7bGVmdDowO2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7Y29udGVudDpcIlwifS5hbnQtYnRuLWJhY2tncm91bmQtZ2hvc3QuYW50LWJ0bi1kYW5nZXJbZGlzYWJsZWRdLC5hbnQtYnRuLWJhY2tncm91bmQtZ2hvc3QuYW50LWJ0bi1kYW5nZXJbZGlzYWJsZWRdOmFjdGl2ZSwuYW50LWJ0bi1iYWNrZ3JvdW5kLWdob3N0LmFudC1idG4tZGFuZ2VyW2Rpc2FibGVkXTpmb2N1cywuYW50LWJ0bi1iYWNrZ3JvdW5kLWdob3N0LmFudC1idG4tZGFuZ2VyW2Rpc2FibGVkXTpob3Zlcntjb2xvcjpyZ2JhKDAsMCwwLC4yNSk7Ym9yZGVyLWNvbG9yOiNkOWQ5ZDk7YmFja2dyb3VuZDojZjVmNWY1O3RleHQtc2hhZG93Om5vbmU7Ym94LXNoYWRvdzpub25lfS5hbnQtYnRuLWJhY2tncm91bmQtZ2hvc3QuYW50LWJ0bi1kYW5nZXJbZGlzYWJsZWRdOmFjdGl2ZT5hOm9ubHktY2hpbGQsLmFudC1idG4tYmFja2dyb3VuZC1naG9zdC5hbnQtYnRuLWRhbmdlcltkaXNhYmxlZF06Zm9jdXM+YTpvbmx5LWNoaWxkLC5hbnQtYnRuLWJhY2tncm91bmQtZ2hvc3QuYW50LWJ0bi1kYW5nZXJbZGlzYWJsZWRdOmhvdmVyPmE6b25seS1jaGlsZCwuYW50LWJ0bi1iYWNrZ3JvdW5kLWdob3N0LmFudC1idG4tZGFuZ2VyW2Rpc2FibGVkXT5hOm9ubHktY2hpbGR7Y29sb3I6Y3VycmVudGNvbG9yfS5hbnQtYnRuLWJhY2tncm91bmQtZ2hvc3QuYW50LWJ0bi1kYW5nZXJbZGlzYWJsZWRdOmFjdGl2ZT5hOm9ubHktY2hpbGQ6YWZ0ZXIsLmFudC1idG4tYmFja2dyb3VuZC1naG9zdC5hbnQtYnRuLWRhbmdlcltkaXNhYmxlZF06Zm9jdXM+YTpvbmx5LWNoaWxkOmFmdGVyLC5hbnQtYnRuLWJhY2tncm91bmQtZ2hvc3QuYW50LWJ0bi1kYW5nZXJbZGlzYWJsZWRdOmhvdmVyPmE6b25seS1jaGlsZDphZnRlciwuYW50LWJ0bi1iYWNrZ3JvdW5kLWdob3N0LmFudC1idG4tZGFuZ2VyW2Rpc2FibGVkXT5hOm9ubHktY2hpbGQ6YWZ0ZXJ7cG9zaXRpb246YWJzb2x1dGU7dG9wOjA7cmlnaHQ6MDtib3R0b206MDtsZWZ0OjA7YmFja2dyb3VuZDp0cmFuc3BhcmVudDtjb250ZW50OlwiXCJ9LmFudC1idG4tYmFja2dyb3VuZC1naG9zdC5hbnQtYnRuLWRhbmdlcm91c3tjb2xvcjojZmY0ZDRmO2JvcmRlci1jb2xvcjojZmY0ZDRmO3RleHQtc2hhZG93Om5vbmV9LmFudC1idG4tYmFja2dyb3VuZC1naG9zdC5hbnQtYnRuLWRhbmdlcm91cz5hOm9ubHktY2hpbGR7Y29sb3I6Y3VycmVudGNvbG9yfS5hbnQtYnRuLWJhY2tncm91bmQtZ2hvc3QuYW50LWJ0bi1kYW5nZXJvdXM+YTpvbmx5LWNoaWxkOmFmdGVye3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO3JpZ2h0OjA7Ym90dG9tOjA7bGVmdDowO2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7Y29udGVudDpcIlwifS5hbnQtYnRuLWJhY2tncm91bmQtZ2hvc3QuYW50LWJ0bi1kYW5nZXJvdXM6Zm9jdXMsLmFudC1idG4tYmFja2dyb3VuZC1naG9zdC5hbnQtYnRuLWRhbmdlcm91czpob3Zlcntjb2xvcjojZmY3ODc1O2JvcmRlci1jb2xvcjojZmY3ODc1fS5hbnQtYnRuLWJhY2tncm91bmQtZ2hvc3QuYW50LWJ0bi1kYW5nZXJvdXM6Zm9jdXM+YTpvbmx5LWNoaWxkLC5hbnQtYnRuLWJhY2tncm91bmQtZ2hvc3QuYW50LWJ0bi1kYW5nZXJvdXM6aG92ZXI+YTpvbmx5LWNoaWxke2NvbG9yOmN1cnJlbnRjb2xvcn0uYW50LWJ0bi1iYWNrZ3JvdW5kLWdob3N0LmFudC1idG4tZGFuZ2Vyb3VzOmZvY3VzPmE6b25seS1jaGlsZDphZnRlciwuYW50LWJ0bi1iYWNrZ3JvdW5kLWdob3N0LmFudC1idG4tZGFuZ2Vyb3VzOmhvdmVyPmE6b25seS1jaGlsZDphZnRlcntwb3NpdGlvbjphYnNvbHV0ZTt0b3A6MDtyaWdodDowO2JvdHRvbTowO2xlZnQ6MDtiYWNrZ3JvdW5kOnRyYW5zcGFyZW50O2NvbnRlbnQ6XCJcIn0uYW50LWJ0bi1iYWNrZ3JvdW5kLWdob3N0LmFudC1idG4tZGFuZ2Vyb3VzOmFjdGl2ZXtjb2xvcjojZDkzNjNlO2JvcmRlci1jb2xvcjojZDkzNjNlfS5hbnQtYnRuLWJhY2tncm91bmQtZ2hvc3QuYW50LWJ0bi1kYW5nZXJvdXM6YWN0aXZlPmE6b25seS1jaGlsZHtjb2xvcjpjdXJyZW50Y29sb3J9LmFudC1idG4tYmFja2dyb3VuZC1naG9zdC5hbnQtYnRuLWRhbmdlcm91czphY3RpdmU+YTpvbmx5LWNoaWxkOmFmdGVye3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO3JpZ2h0OjA7Ym90dG9tOjA7bGVmdDowO2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7Y29udGVudDpcIlwifS5hbnQtYnRuLWJhY2tncm91bmQtZ2hvc3QuYW50LWJ0bi1kYW5nZXJvdXNbZGlzYWJsZWRdLC5hbnQtYnRuLWJhY2tncm91bmQtZ2hvc3QuYW50LWJ0bi1kYW5nZXJvdXNbZGlzYWJsZWRdOmFjdGl2ZSwuYW50LWJ0bi1iYWNrZ3JvdW5kLWdob3N0LmFudC1idG4tZGFuZ2Vyb3VzW2Rpc2FibGVkXTpmb2N1cywuYW50LWJ0bi1iYWNrZ3JvdW5kLWdob3N0LmFudC1idG4tZGFuZ2Vyb3VzW2Rpc2FibGVkXTpob3Zlcntjb2xvcjpyZ2JhKDAsMCwwLC4yNSk7Ym9yZGVyLWNvbG9yOiNkOWQ5ZDk7YmFja2dyb3VuZDojZjVmNWY1O3RleHQtc2hhZG93Om5vbmU7Ym94LXNoYWRvdzpub25lfS5hbnQtYnRuLWJhY2tncm91bmQtZ2hvc3QuYW50LWJ0bi1kYW5nZXJvdXNbZGlzYWJsZWRdOmFjdGl2ZT5hOm9ubHktY2hpbGQsLmFudC1idG4tYmFja2dyb3VuZC1naG9zdC5hbnQtYnRuLWRhbmdlcm91c1tkaXNhYmxlZF06Zm9jdXM+YTpvbmx5LWNoaWxkLC5hbnQtYnRuLWJhY2tncm91bmQtZ2hvc3QuYW50LWJ0bi1kYW5nZXJvdXNbZGlzYWJsZWRdOmhvdmVyPmE6b25seS1jaGlsZCwuYW50LWJ0bi1iYWNrZ3JvdW5kLWdob3N0LmFudC1idG4tZGFuZ2Vyb3VzW2Rpc2FibGVkXT5hOm9ubHktY2hpbGR7Y29sb3I6Y3VycmVudGNvbG9yfS5hbnQtYnRuLWJhY2tncm91bmQtZ2hvc3QuYW50LWJ0bi1kYW5nZXJvdXNbZGlzYWJsZWRdOmFjdGl2ZT5hOm9ubHktY2hpbGQ6YWZ0ZXIsLmFudC1idG4tYmFja2dyb3VuZC1naG9zdC5hbnQtYnRuLWRhbmdlcm91c1tkaXNhYmxlZF06Zm9jdXM+YTpvbmx5LWNoaWxkOmFmdGVyLC5hbnQtYnRuLWJhY2tncm91bmQtZ2hvc3QuYW50LWJ0bi1kYW5nZXJvdXNbZGlzYWJsZWRdOmhvdmVyPmE6b25seS1jaGlsZDphZnRlciwuYW50LWJ0bi1iYWNrZ3JvdW5kLWdob3N0LmFudC1idG4tZGFuZ2Vyb3VzW2Rpc2FibGVkXT5hOm9ubHktY2hpbGQ6YWZ0ZXJ7cG9zaXRpb246YWJzb2x1dGU7dG9wOjA7cmlnaHQ6MDtib3R0b206MDtsZWZ0OjA7YmFja2dyb3VuZDp0cmFuc3BhcmVudDtjb250ZW50OlwiXCJ9LmFudC1idG4tYmFja2dyb3VuZC1naG9zdC5hbnQtYnRuLWRhbmdlcm91cy5hbnQtYnRuLWxpbmt7Y29sb3I6I2ZmNGQ0Zjtib3JkZXItY29sb3I6dHJhbnNwYXJlbnQ7dGV4dC1zaGFkb3c6bm9uZX0uYW50LWJ0bi1iYWNrZ3JvdW5kLWdob3N0LmFudC1idG4tZGFuZ2Vyb3VzLmFudC1idG4tbGluaz5hOm9ubHktY2hpbGR7Y29sb3I6Y3VycmVudGNvbG9yfS5hbnQtYnRuLWJhY2tncm91bmQtZ2hvc3QuYW50LWJ0bi1kYW5nZXJvdXMuYW50LWJ0bi1saW5rPmE6b25seS1jaGlsZDphZnRlcntwb3NpdGlvbjphYnNvbHV0ZTt0b3A6MDtyaWdodDowO2JvdHRvbTowO2xlZnQ6MDtiYWNrZ3JvdW5kOnRyYW5zcGFyZW50O2NvbnRlbnQ6XCJcIn0uYW50LWJ0bi1iYWNrZ3JvdW5kLWdob3N0LmFudC1idG4tZGFuZ2Vyb3VzLmFudC1idG4tbGluazpmb2N1cywuYW50LWJ0bi1iYWNrZ3JvdW5kLWdob3N0LmFudC1idG4tZGFuZ2Vyb3VzLmFudC1idG4tbGluazpob3Zlcntjb2xvcjojZmY3ODc1O2JvcmRlci1jb2xvcjp0cmFuc3BhcmVudH0uYW50LWJ0bi1iYWNrZ3JvdW5kLWdob3N0LmFudC1idG4tZGFuZ2Vyb3VzLmFudC1idG4tbGluazpmb2N1cz5hOm9ubHktY2hpbGQsLmFudC1idG4tYmFja2dyb3VuZC1naG9zdC5hbnQtYnRuLWRhbmdlcm91cy5hbnQtYnRuLWxpbms6aG92ZXI+YTpvbmx5LWNoaWxke2NvbG9yOmN1cnJlbnRjb2xvcn0uYW50LWJ0bi1iYWNrZ3JvdW5kLWdob3N0LmFudC1idG4tZGFuZ2Vyb3VzLmFudC1idG4tbGluazpmb2N1cz5hOm9ubHktY2hpbGQ6YWZ0ZXIsLmFudC1idG4tYmFja2dyb3VuZC1naG9zdC5hbnQtYnRuLWRhbmdlcm91cy5hbnQtYnRuLWxpbms6aG92ZXI+YTpvbmx5LWNoaWxkOmFmdGVye3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO3JpZ2h0OjA7Ym90dG9tOjA7bGVmdDowO2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7Y29udGVudDpcIlwifS5hbnQtYnRuLWJhY2tncm91bmQtZ2hvc3QuYW50LWJ0bi1kYW5nZXJvdXMuYW50LWJ0bi1saW5rOmFjdGl2ZXtjb2xvcjojZDkzNjNlO2JvcmRlci1jb2xvcjp0cmFuc3BhcmVudH0uYW50LWJ0bi1iYWNrZ3JvdW5kLWdob3N0LmFudC1idG4tZGFuZ2Vyb3VzLmFudC1idG4tbGluazphY3RpdmU+YTpvbmx5LWNoaWxke2NvbG9yOmN1cnJlbnRjb2xvcn0uYW50LWJ0bi1iYWNrZ3JvdW5kLWdob3N0LmFudC1idG4tZGFuZ2Vyb3VzLmFudC1idG4tbGluazphY3RpdmU+YTpvbmx5LWNoaWxkOmFmdGVye3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO3JpZ2h0OjA7Ym90dG9tOjA7bGVmdDowO2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7Y29udGVudDpcIlwifS5hbnQtYnRuLWJhY2tncm91bmQtZ2hvc3QuYW50LWJ0bi1kYW5nZXJvdXMuYW50LWJ0bi1saW5rW2Rpc2FibGVkXSwuYW50LWJ0bi1iYWNrZ3JvdW5kLWdob3N0LmFudC1idG4tZGFuZ2Vyb3VzLmFudC1idG4tbGlua1tkaXNhYmxlZF06YWN0aXZlLC5hbnQtYnRuLWJhY2tncm91bmQtZ2hvc3QuYW50LWJ0bi1kYW5nZXJvdXMuYW50LWJ0bi1saW5rW2Rpc2FibGVkXTpmb2N1cywuYW50LWJ0bi1iYWNrZ3JvdW5kLWdob3N0LmFudC1idG4tZGFuZ2Vyb3VzLmFudC1idG4tbGlua1tkaXNhYmxlZF06aG92ZXJ7Y29sb3I6cmdiYSgwLDAsMCwuMjUpO2JvcmRlci1jb2xvcjojZDlkOWQ5O2JhY2tncm91bmQ6I2Y1ZjVmNTt0ZXh0LXNoYWRvdzpub25lO2JveC1zaGFkb3c6bm9uZX0uYW50LWJ0bi1iYWNrZ3JvdW5kLWdob3N0LmFudC1idG4tZGFuZ2Vyb3VzLmFudC1idG4tbGlua1tkaXNhYmxlZF06YWN0aXZlPmE6b25seS1jaGlsZCwuYW50LWJ0bi1iYWNrZ3JvdW5kLWdob3N0LmFudC1idG4tZGFuZ2Vyb3VzLmFudC1idG4tbGlua1tkaXNhYmxlZF06Zm9jdXM+YTpvbmx5LWNoaWxkLC5hbnQtYnRuLWJhY2tncm91bmQtZ2hvc3QuYW50LWJ0bi1kYW5nZXJvdXMuYW50LWJ0bi1saW5rW2Rpc2FibGVkXTpob3Zlcj5hOm9ubHktY2hpbGQsLmFudC1idG4tYmFja2dyb3VuZC1naG9zdC5hbnQtYnRuLWRhbmdlcm91cy5hbnQtYnRuLWxpbmtbZGlzYWJsZWRdPmE6b25seS1jaGlsZHtjb2xvcjpjdXJyZW50Y29sb3J9LmFudC1idG4tYmFja2dyb3VuZC1naG9zdC5hbnQtYnRuLWRhbmdlcm91cy5hbnQtYnRuLWxpbmtbZGlzYWJsZWRdOmFjdGl2ZT5hOm9ubHktY2hpbGQ6YWZ0ZXIsLmFudC1idG4tYmFja2dyb3VuZC1naG9zdC5hbnQtYnRuLWRhbmdlcm91cy5hbnQtYnRuLWxpbmtbZGlzYWJsZWRdOmZvY3VzPmE6b25seS1jaGlsZDphZnRlciwuYW50LWJ0bi1iYWNrZ3JvdW5kLWdob3N0LmFudC1idG4tZGFuZ2Vyb3VzLmFudC1idG4tbGlua1tkaXNhYmxlZF06aG92ZXI+YTpvbmx5LWNoaWxkOmFmdGVyLC5hbnQtYnRuLWJhY2tncm91bmQtZ2hvc3QuYW50LWJ0bi1kYW5nZXJvdXMuYW50LWJ0bi1saW5rW2Rpc2FibGVkXT5hOm9ubHktY2hpbGQ6YWZ0ZXJ7cG9zaXRpb246YWJzb2x1dGU7dG9wOjA7cmlnaHQ6MDtib3R0b206MDtsZWZ0OjA7YmFja2dyb3VuZDp0cmFuc3BhcmVudDtjb250ZW50OlwiXCJ9LmFudC1idG4tdHdvLWNoaW5lc2UtY2hhcnM6Zmlyc3QtbGV0dGVye2xldHRlci1zcGFjaW5nOi4zNGVtfS5hbnQtYnRuLXR3by1jaGluZXNlLWNoYXJzPjpub3QoLmFudGljb24pe21hcmdpbi1yaWdodDotLjM0ZW07bGV0dGVyLXNwYWNpbmc6LjM0ZW19LmFudC1idG4uYW50LWJ0bi1ibG9ja3t3aWR0aDoxMDAlfS5hbnQtYnRuOmVtcHR5e2Rpc3BsYXk6aW5saW5lLWJsb2NrO3dpZHRoOjA7dmlzaWJpbGl0eTpoaWRkZW47Y29udGVudDpcIlxcYTBcIn1hLmFudC1idG57cGFkZGluZy10b3A6LjAxcHghaW1wb3J0YW50O2xpbmUtaGVpZ2h0OjMwcHh9YS5hbnQtYnRuLWRpc2FibGVke2N1cnNvcjpub3QtYWxsb3dlZH1hLmFudC1idG4tZGlzYWJsZWQ+Kntwb2ludGVyLWV2ZW50czpub25lfWEuYW50LWJ0bi1kaXNhYmxlZCxhLmFudC1idG4tZGlzYWJsZWQ6YWN0aXZlLGEuYW50LWJ0bi1kaXNhYmxlZDpmb2N1cyxhLmFudC1idG4tZGlzYWJsZWQ6aG92ZXJ7Y29sb3I6cmdiYSgwLDAsMCwuMjUpO2JvcmRlci1jb2xvcjp0cmFuc3BhcmVudDtiYWNrZ3JvdW5kOnRyYW5zcGFyZW50O3RleHQtc2hhZG93Om5vbmU7Ym94LXNoYWRvdzpub25lfWEuYW50LWJ0bi1kaXNhYmxlZDphY3RpdmU+YTpvbmx5LWNoaWxkLGEuYW50LWJ0bi1kaXNhYmxlZDpmb2N1cz5hOm9ubHktY2hpbGQsYS5hbnQtYnRuLWRpc2FibGVkOmhvdmVyPmE6b25seS1jaGlsZCxhLmFudC1idG4tZGlzYWJsZWQ+YTpvbmx5LWNoaWxke2NvbG9yOmN1cnJlbnRjb2xvcn1hLmFudC1idG4tZGlzYWJsZWQ6YWN0aXZlPmE6b25seS1jaGlsZDphZnRlcixhLmFudC1idG4tZGlzYWJsZWQ6Zm9jdXM+YTpvbmx5LWNoaWxkOmFmdGVyLGEuYW50LWJ0bi1kaXNhYmxlZDpob3Zlcj5hOm9ubHktY2hpbGQ6YWZ0ZXIsYS5hbnQtYnRuLWRpc2FibGVkPmE6b25seS1jaGlsZDphZnRlcntwb3NpdGlvbjphYnNvbHV0ZTt0b3A6MDtyaWdodDowO2JvdHRvbTowO2xlZnQ6MDtiYWNrZ3JvdW5kOnRyYW5zcGFyZW50O2NvbnRlbnQ6XCJcIn1hLmFudC1idG4tbGd7bGluZS1oZWlnaHQ6MzhweH1hLmFudC1idG4tc217bGluZS1oZWlnaHQ6MjJweH0uYW50LWJ0bi1jb21wYWN0LWl0ZW06bm90KC5hbnQtYnRuLWNvbXBhY3QtbGFzdC1pdGVtKTpub3QoLmFudC1idG4tY29tcGFjdC1pdGVtLXJ0bCl7bWFyZ2luLXJpZ2h0Oi0xcHh9LmFudC1idG4tY29tcGFjdC1pdGVtOm5vdCguYW50LWJ0bi1jb21wYWN0LWxhc3QtaXRlbSkuYW50LWJ0bi1jb21wYWN0LWl0ZW0tcnRse21hcmdpbi1sZWZ0Oi0xcHh9LmFudC1idG4tY29tcGFjdC1pdGVtOmFjdGl2ZSwuYW50LWJ0bi1jb21wYWN0LWl0ZW06Zm9jdXMsLmFudC1idG4tY29tcGFjdC1pdGVtOmhvdmVye3otaW5kZXg6Mn0uYW50LWJ0bi1jb21wYWN0LWl0ZW1bZGlzYWJsZWRde3otaW5kZXg6MH0uYW50LWJ0bi1jb21wYWN0LWl0ZW06bm90KC5hbnQtYnRuLWNvbXBhY3QtZmlyc3QtaXRlbSk6bm90KC5hbnQtYnRuLWNvbXBhY3QtbGFzdC1pdGVtKS5hbnQtYnRue2JvcmRlci1yYWRpdXM6MH0uYW50LWJ0bi1jb21wYWN0LWl0ZW0uYW50LWJ0bi5hbnQtYnRuLWNvbXBhY3QtZmlyc3QtaXRlbTpub3QoLmFudC1idG4tY29tcGFjdC1sYXN0LWl0ZW0pOm5vdCguYW50LWJ0bi1jb21wYWN0LWl0ZW0tcnRsKXtib3JkZXItdG9wLXJpZ2h0LXJhZGl1czowO2JvcmRlci1ib3R0b20tcmlnaHQtcmFkaXVzOjB9LmFudC1idG4tY29tcGFjdC1pdGVtLmFudC1idG4uYW50LWJ0bi1jb21wYWN0LWl0ZW0tcnRsLmFudC1idG4tY29tcGFjdC1maXJzdC1pdGVtOm5vdCguYW50LWJ0bi1jb21wYWN0LWxhc3QtaXRlbSksLmFudC1idG4tY29tcGFjdC1pdGVtLmFudC1idG4uYW50LWJ0bi1jb21wYWN0LWxhc3QtaXRlbTpub3QoLmFudC1idG4tY29tcGFjdC1maXJzdC1pdGVtKTpub3QoLmFudC1idG4tY29tcGFjdC1pdGVtLXJ0bCl7Ym9yZGVyLXRvcC1sZWZ0LXJhZGl1czowO2JvcmRlci1ib3R0b20tbGVmdC1yYWRpdXM6MH0uYW50LWJ0bi1jb21wYWN0LWl0ZW0uYW50LWJ0bi5hbnQtYnRuLWNvbXBhY3QtaXRlbS1ydGwuYW50LWJ0bi1jb21wYWN0LWxhc3QtaXRlbTpub3QoLmFudC1idG4tY29tcGFjdC1maXJzdC1pdGVtKXtib3JkZXItdG9wLXJpZ2h0LXJhZGl1czowO2JvcmRlci1ib3R0b20tcmlnaHQtcmFkaXVzOjB9LmFudC1idG4taWNvbi1vbmx5LmFudC1idG4tY29tcGFjdC1pdGVte2ZsZXg6bm9uZX0uYW50LWJ0bi1jb21wYWN0LWl0ZW0uYW50LWJ0bi1wcmltYXJ5Om5vdChbZGlzYWJsZWRdKSsuYW50LWJ0bi1jb21wYWN0LWl0ZW0uYW50LWJ0bi1wcmltYXJ5Om5vdChbZGlzYWJsZWRdKXtwb3NpdGlvbjpyZWxhdGl2ZX0uYW50LWJ0bi1jb21wYWN0LWl0ZW0uYW50LWJ0bi1wcmltYXJ5Om5vdChbZGlzYWJsZWRdKSsuYW50LWJ0bi1jb21wYWN0LWl0ZW0uYW50LWJ0bi1wcmltYXJ5Om5vdChbZGlzYWJsZWRdKTphZnRlcntwb3NpdGlvbjphYnNvbHV0ZTt0b3A6LTFweDtsZWZ0Oi0xcHg7ZGlzcGxheTppbmxpbmUtYmxvY2s7d2lkdGg6MXB4O2hlaWdodDpjYWxjKDEwMCUgKyAycHgpO2JhY2tncm91bmQtY29sb3I6IzQwYTlmZjtjb250ZW50OlwiIFwifS5hbnQtYnRuLWNvbXBhY3QtaXRlbS1ydGwuYW50LWJ0bi1jb21wYWN0LWZpcnN0LWl0ZW0uYW50LWJ0bi1jb21wYWN0LWl0ZW0tcnRsOm5vdCguYW50LWJ0bi1jb21wYWN0LWxhc3QtaXRlbSl7Ym9yZGVyLXRvcC1sZWZ0LXJhZGl1czowO2JvcmRlci1ib3R0b20tbGVmdC1yYWRpdXM6MH0uYW50LWJ0bi1jb21wYWN0LWl0ZW0tcnRsLmFudC1idG4tY29tcGFjdC1sYXN0LWl0ZW0uYW50LWJ0bi1jb21wYWN0LWl0ZW0tcnRsOm5vdCguYW50LWJ0bi1jb21wYWN0LWZpcnN0LWl0ZW0pe2JvcmRlci10b3AtcmlnaHQtcmFkaXVzOjA7Ym9yZGVyLWJvdHRvbS1yaWdodC1yYWRpdXM6MH0uYW50LWJ0bi1jb21wYWN0LWl0ZW0tcnRsLmFudC1idG4tc20uYW50LWJ0bi1jb21wYWN0LWZpcnN0LWl0ZW0uYW50LWJ0bi1jb21wYWN0LWl0ZW0tcnRsLmFudC1idG4tc206bm90KC5hbnQtYnRuLWNvbXBhY3QtbGFzdC1pdGVtKXtib3JkZXItdG9wLWxlZnQtcmFkaXVzOjA7Ym9yZGVyLWJvdHRvbS1sZWZ0LXJhZGl1czowfS5hbnQtYnRuLWNvbXBhY3QtaXRlbS1ydGwuYW50LWJ0bi1zbS5hbnQtYnRuLWNvbXBhY3QtbGFzdC1pdGVtLmFudC1idG4tY29tcGFjdC1pdGVtLXJ0bC5hbnQtYnRuLXNtOm5vdCguYW50LWJ0bi1jb21wYWN0LWZpcnN0LWl0ZW0pe2JvcmRlci10b3AtcmlnaHQtcmFkaXVzOjA7Ym9yZGVyLWJvdHRvbS1yaWdodC1yYWRpdXM6MH0uYW50LWJ0bi1jb21wYWN0LWl0ZW0tcnRsLmFudC1idG4tcHJpbWFyeTpub3QoW2Rpc2FibGVkXSkrLmFudC1idG4tY29tcGFjdC1pdGVtLXJ0bC5hbnQtYnRuLXByaW1hcnk6bm90KFtkaXNhYmxlZF0pOmFmdGVye3JpZ2h0Oi0xcHh9LmFudC1idG4tY29tcGFjdC12ZXJ0aWNhbC1pdGVtOm5vdCguYW50LWJ0bi1jb21wYWN0LXZlcnRpY2FsLWxhc3QtaXRlbSl7bWFyZ2luLWJvdHRvbTotMXB4fS5hbnQtYnRuLWNvbXBhY3QtdmVydGljYWwtaXRlbTphY3RpdmUsLmFudC1idG4tY29tcGFjdC12ZXJ0aWNhbC1pdGVtOmZvY3VzLC5hbnQtYnRuLWNvbXBhY3QtdmVydGljYWwtaXRlbTpob3Zlcnt6LWluZGV4OjJ9LmFudC1idG4tY29tcGFjdC12ZXJ0aWNhbC1pdGVtW2Rpc2FibGVkXXt6LWluZGV4OjB9LmFudC1idG4tY29tcGFjdC12ZXJ0aWNhbC1pdGVtOm5vdCguYW50LWJ0bi1jb21wYWN0LXZlcnRpY2FsLWZpcnN0LWl0ZW0pOm5vdCguYW50LWJ0bi1jb21wYWN0LXZlcnRpY2FsLWxhc3QtaXRlbSl7Ym9yZGVyLXJhZGl1czowfS5hbnQtYnRuLWNvbXBhY3QtdmVydGljYWwtaXRlbS5hbnQtYnRuLWNvbXBhY3QtdmVydGljYWwtZmlyc3QtaXRlbTpub3QoLmFudC1idG4tY29tcGFjdC12ZXJ0aWNhbC1sYXN0LWl0ZW0pe2JvcmRlci1ib3R0b20tcmlnaHQtcmFkaXVzOjA7Ym9yZGVyLWJvdHRvbS1sZWZ0LXJhZGl1czowfS5hbnQtYnRuLWNvbXBhY3QtdmVydGljYWwtaXRlbS5hbnQtYnRuLWNvbXBhY3QtdmVydGljYWwtbGFzdC1pdGVtOm5vdCguYW50LWJ0bi1jb21wYWN0LXZlcnRpY2FsLWZpcnN0LWl0ZW0pe2JvcmRlci10b3AtbGVmdC1yYWRpdXM6MDtib3JkZXItdG9wLXJpZ2h0LXJhZGl1czowfS5hbnQtYnRuLWNvbXBhY3QtdmVydGljYWwtaXRlbS5hbnQtYnRuLXByaW1hcnk6bm90KFtkaXNhYmxlZF0pKy5hbnQtYnRuLWNvbXBhY3QtdmVydGljYWwtaXRlbS5hbnQtYnRuLXByaW1hcnk6bm90KFtkaXNhYmxlZF0pe3Bvc2l0aW9uOnJlbGF0aXZlfS5hbnQtYnRuLWNvbXBhY3QtdmVydGljYWwtaXRlbS5hbnQtYnRuLXByaW1hcnk6bm90KFtkaXNhYmxlZF0pKy5hbnQtYnRuLWNvbXBhY3QtdmVydGljYWwtaXRlbS5hbnQtYnRuLXByaW1hcnk6bm90KFtkaXNhYmxlZF0pOmFmdGVye3Bvc2l0aW9uOmFic29sdXRlO3RvcDotMXB4O2xlZnQ6LTFweDtkaXNwbGF5OmlubGluZS1ibG9jazt3aWR0aDpjYWxjKDEwMCUgKyAycHgpO2hlaWdodDoxcHg7YmFja2dyb3VuZC1jb2xvcjojNDBhOWZmO2NvbnRlbnQ6XCIgXCJ9LmFudC1idG4tcnRse2RpcmVjdGlvbjpydGx9LmFudC1idG4tZ3JvdXAtcnRsLmFudC1idG4tZ3JvdXAgLmFudC1idG4tcHJpbWFyeSsuYW50LWJ0bi1wcmltYXJ5LC5hbnQtYnRuLWdyb3VwLXJ0bC5hbnQtYnRuLWdyb3VwIC5hbnQtYnRuLXByaW1hcnk6bGFzdC1jaGlsZDpub3QoOmZpcnN0LWNoaWxkKXtib3JkZXItcmlnaHQtY29sb3I6IzQwYTlmZjtib3JkZXItbGVmdC1jb2xvcjojZDlkOWQ5fS5hbnQtYnRuLWdyb3VwLXJ0bC5hbnQtYnRuLWdyb3VwIC5hbnQtYnRuLXByaW1hcnkrLmFudC1idG4tcHJpbWFyeVtkaXNhYmxlZF0sLmFudC1idG4tZ3JvdXAtcnRsLmFudC1idG4tZ3JvdXAgLmFudC1idG4tcHJpbWFyeTpsYXN0LWNoaWxkOm5vdCg6Zmlyc3QtY2hpbGQpW2Rpc2FibGVkXXtib3JkZXItcmlnaHQtY29sb3I6I2Q5ZDlkOTtib3JkZXItbGVmdC1jb2xvcjojNDBhOWZmfS5hbnQtYnRuLXJ0bC5hbnQtYnRuPi5hbnQtYnRuLWxvYWRpbmctaWNvbiAuYW50aWNvbntwYWRkaW5nLXJpZ2h0OjA7cGFkZGluZy1sZWZ0OjhweH0uYW50LWJ0bi1ydGwuYW50LWJ0bj4uYW50aWNvbitzcGFuLC5hbnQtYnRuLXJ0bC5hbnQtYnRuPnNwYW4rLmFudGljb257bWFyZ2luLXJpZ2h0OjhweDttYXJnaW4tbGVmdDowfS5hbnQtcGlja2VyLWNhbGVuZGFye2JveC1zaXppbmc6Ym9yZGVyLWJveDttYXJnaW46MDtwYWRkaW5nOjA7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtc2l6ZToxNHB4O2ZvbnQtdmFyaWFudDp0YWJ1bGFyLW51bXM7bGluZS1oZWlnaHQ6MS41NzE1O2xpc3Qtc3R5bGU6bm9uZTtmb250LWZlYXR1cmUtc2V0dGluZ3M6XCJ0bnVtXCI7YmFja2dyb3VuZDojZmZmfS5hbnQtcGlja2VyLWNhbGVuZGFyLWhlYWRlcntkaXNwbGF5OmZsZXg7anVzdGlmeS1jb250ZW50OmZsZXgtZW5kO3BhZGRpbmc6MTJweCAwfS5hbnQtcGlja2VyLWNhbGVuZGFyLWhlYWRlciAuYW50LXBpY2tlci1jYWxlbmRhci15ZWFyLXNlbGVjdHttaW4td2lkdGg6ODBweH0uYW50LXBpY2tlci1jYWxlbmRhci1oZWFkZXIgLmFudC1waWNrZXItY2FsZW5kYXItbW9udGgtc2VsZWN0e21pbi13aWR0aDo3MHB4O21hcmdpbi1sZWZ0OjhweH0uYW50LXBpY2tlci1jYWxlbmRhci1oZWFkZXIgLmFudC1waWNrZXItY2FsZW5kYXItbW9kZS1zd2l0Y2h7bWFyZ2luLWxlZnQ6OHB4fS5hbnQtcGlja2VyLWNhbGVuZGFyIC5hbnQtcGlja2VyLXBhbmVse2JhY2tncm91bmQ6I2ZmZjtib3JkZXI6MDtib3JkZXItdG9wOjFweCBzb2xpZCAjZjBmMGYwO2JvcmRlci1yYWRpdXM6MH0uYW50LXBpY2tlci1jYWxlbmRhciAuYW50LXBpY2tlci1wYW5lbCAuYW50LXBpY2tlci1kYXRlLXBhbmVsLC5hbnQtcGlja2VyLWNhbGVuZGFyIC5hbnQtcGlja2VyLXBhbmVsIC5hbnQtcGlja2VyLW1vbnRoLXBhbmVse3dpZHRoOmF1dG99LmFudC1waWNrZXItY2FsZW5kYXIgLmFudC1waWNrZXItcGFuZWwgLmFudC1waWNrZXItYm9keXtwYWRkaW5nOjhweCAwfS5hbnQtcGlja2VyLWNhbGVuZGFyIC5hbnQtcGlja2VyLXBhbmVsIC5hbnQtcGlja2VyLWNvbnRlbnR7d2lkdGg6MTAwJX0uYW50LXBpY2tlci1jYWxlbmRhci1taW5pe2JvcmRlci1yYWRpdXM6MnB4fS5hbnQtcGlja2VyLWNhbGVuZGFyLW1pbmkgLmFudC1waWNrZXItY2FsZW5kYXItaGVhZGVye3BhZGRpbmctcmlnaHQ6OHB4O3BhZGRpbmctbGVmdDo4cHh9LmFudC1waWNrZXItY2FsZW5kYXItbWluaSAuYW50LXBpY2tlci1wYW5lbHtib3JkZXItcmFkaXVzOjAgMCAycHggMnB4fS5hbnQtcGlja2VyLWNhbGVuZGFyLW1pbmkgLmFudC1waWNrZXItY29udGVudHtoZWlnaHQ6MjU2cHh9LmFudC1waWNrZXItY2FsZW5kYXItbWluaSAuYW50LXBpY2tlci1jb250ZW50IHRoe2hlaWdodDphdXRvO3BhZGRpbmc6MDtsaW5lLWhlaWdodDoxOHB4fS5hbnQtcGlja2VyLWNhbGVuZGFyLW1pbmkgLmFudC1waWNrZXItY2VsbDpiZWZvcmV7cG9pbnRlci1ldmVudHM6bm9uZX0uYW50LXBpY2tlci1jYWxlbmRhci1mdWxsIC5hbnQtcGlja2VyLXBhbmVse2Rpc3BsYXk6YmxvY2s7d2lkdGg6MTAwJTt0ZXh0LWFsaWduOnJpZ2h0O2JhY2tncm91bmQ6I2ZmZjtib3JkZXI6MH0uYW50LXBpY2tlci1jYWxlbmRhci1mdWxsIC5hbnQtcGlja2VyLXBhbmVsIC5hbnQtcGlja2VyLWJvZHkgdGQsLmFudC1waWNrZXItY2FsZW5kYXItZnVsbCAuYW50LXBpY2tlci1wYW5lbCAuYW50LXBpY2tlci1ib2R5IHRoe3BhZGRpbmc6MH0uYW50LXBpY2tlci1jYWxlbmRhci1mdWxsIC5hbnQtcGlja2VyLXBhbmVsIC5hbnQtcGlja2VyLWJvZHkgdGh7aGVpZ2h0OmF1dG87cGFkZGluZzowIDEycHggNXB4IDA7bGluZS1oZWlnaHQ6MThweH0uYW50LXBpY2tlci1jYWxlbmRhci1mdWxsIC5hbnQtcGlja2VyLXBhbmVsIC5hbnQtcGlja2VyLWNlbGw6YmVmb3Jle2Rpc3BsYXk6bm9uZX0uYW50LXBpY2tlci1jYWxlbmRhci1mdWxsIC5hbnQtcGlja2VyLXBhbmVsIC5hbnQtcGlja2VyLWNlbGw6aG92ZXIgLmFudC1waWNrZXItY2FsZW5kYXItZGF0ZXtiYWNrZ3JvdW5kOiNmNWY1ZjV9LmFudC1waWNrZXItY2FsZW5kYXItZnVsbCAuYW50LXBpY2tlci1wYW5lbCAuYW50LXBpY2tlci1jZWxsIC5hbnQtcGlja2VyLWNhbGVuZGFyLWRhdGUtdG9kYXk6YmVmb3Jle2Rpc3BsYXk6bm9uZX0uYW50LXBpY2tlci1jYWxlbmRhci1mdWxsIC5hbnQtcGlja2VyLXBhbmVsIC5hbnQtcGlja2VyLWNlbGwtc2VsZWN0ZWQgLmFudC1waWNrZXItY2FsZW5kYXItZGF0ZSwuYW50LXBpY2tlci1jYWxlbmRhci1mdWxsIC5hbnQtcGlja2VyLXBhbmVsIC5hbnQtcGlja2VyLWNlbGwtc2VsZWN0ZWQgLmFudC1waWNrZXItY2FsZW5kYXItZGF0ZS10b2RheSwuYW50LXBpY2tlci1jYWxlbmRhci1mdWxsIC5hbnQtcGlja2VyLXBhbmVsIC5hbnQtcGlja2VyLWNlbGwtc2VsZWN0ZWQ6aG92ZXIgLmFudC1waWNrZXItY2FsZW5kYXItZGF0ZSwuYW50LXBpY2tlci1jYWxlbmRhci1mdWxsIC5hbnQtcGlja2VyLXBhbmVsIC5hbnQtcGlja2VyLWNlbGwtc2VsZWN0ZWQ6aG92ZXIgLmFudC1waWNrZXItY2FsZW5kYXItZGF0ZS10b2RheXtiYWNrZ3JvdW5kOiNlNmY3ZmZ9LmFudC1waWNrZXItY2FsZW5kYXItZnVsbCAuYW50LXBpY2tlci1wYW5lbCAuYW50LXBpY2tlci1jZWxsLXNlbGVjdGVkIC5hbnQtcGlja2VyLWNhbGVuZGFyLWRhdGUtdG9kYXkgLmFudC1waWNrZXItY2FsZW5kYXItZGF0ZS12YWx1ZSwuYW50LXBpY2tlci1jYWxlbmRhci1mdWxsIC5hbnQtcGlja2VyLXBhbmVsIC5hbnQtcGlja2VyLWNlbGwtc2VsZWN0ZWQgLmFudC1waWNrZXItY2FsZW5kYXItZGF0ZSAuYW50LXBpY2tlci1jYWxlbmRhci1kYXRlLXZhbHVlLC5hbnQtcGlja2VyLWNhbGVuZGFyLWZ1bGwgLmFudC1waWNrZXItcGFuZWwgLmFudC1waWNrZXItY2VsbC1zZWxlY3RlZDpob3ZlciAuYW50LXBpY2tlci1jYWxlbmRhci1kYXRlLXRvZGF5IC5hbnQtcGlja2VyLWNhbGVuZGFyLWRhdGUtdmFsdWUsLmFudC1waWNrZXItY2FsZW5kYXItZnVsbCAuYW50LXBpY2tlci1wYW5lbCAuYW50LXBpY2tlci1jZWxsLXNlbGVjdGVkOmhvdmVyIC5hbnQtcGlja2VyLWNhbGVuZGFyLWRhdGUgLmFudC1waWNrZXItY2FsZW5kYXItZGF0ZS12YWx1ZXtjb2xvcjojMTg5MGZmfS5hbnQtcGlja2VyLWNhbGVuZGFyLWZ1bGwgLmFudC1waWNrZXItcGFuZWwgLmFudC1waWNrZXItY2FsZW5kYXItZGF0ZXtkaXNwbGF5OmJsb2NrO3dpZHRoOmF1dG87aGVpZ2h0OmF1dG87bWFyZ2luOjAgNHB4O3BhZGRpbmc6NHB4IDhweCAwO2JvcmRlcjowO2JvcmRlci10b3A6MnB4IHNvbGlkICNmMGYwZjA7Ym9yZGVyLXJhZGl1czowO3RyYW5zaXRpb246YmFja2dyb3VuZCAuM3N9LmFudC1waWNrZXItY2FsZW5kYXItZnVsbCAuYW50LXBpY2tlci1wYW5lbCAuYW50LXBpY2tlci1jYWxlbmRhci1kYXRlLXZhbHVle2xpbmUtaGVpZ2h0OjI0cHg7dHJhbnNpdGlvbjpjb2xvciAuM3N9LmFudC1waWNrZXItY2FsZW5kYXItZnVsbCAuYW50LXBpY2tlci1wYW5lbCAuYW50LXBpY2tlci1jYWxlbmRhci1kYXRlLWNvbnRlbnR7cG9zaXRpb246c3RhdGljO3dpZHRoOmF1dG87aGVpZ2h0Ojg2cHg7b3ZlcmZsb3cteTphdXRvO2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtsaW5lLWhlaWdodDoxLjU3MTU7dGV4dC1hbGlnbjpsZWZ0fS5hbnQtcGlja2VyLWNhbGVuZGFyLWZ1bGwgLmFudC1waWNrZXItcGFuZWwgLmFudC1waWNrZXItY2FsZW5kYXItZGF0ZS10b2RheXtib3JkZXItY29sb3I6IzE4OTBmZn0uYW50LXBpY2tlci1jYWxlbmRhci1mdWxsIC5hbnQtcGlja2VyLXBhbmVsIC5hbnQtcGlja2VyLWNhbGVuZGFyLWRhdGUtdG9kYXkgLmFudC1waWNrZXItY2FsZW5kYXItZGF0ZS12YWx1ZXtjb2xvcjpyZ2JhKDAsMCwwLC44NSl9QG1lZGlhIG9ubHkgc2NyZWVuIGFuZCAobWF4LXdpZHRoOjQ4MHB4KXsuYW50LXBpY2tlci1jYWxlbmRhci1oZWFkZXJ7ZGlzcGxheTpibG9ja30uYW50LXBpY2tlci1jYWxlbmRhci1oZWFkZXIgLmFudC1waWNrZXItY2FsZW5kYXIteWVhci1zZWxlY3R7d2lkdGg6NTAlfS5hbnQtcGlja2VyLWNhbGVuZGFyLWhlYWRlciAuYW50LXBpY2tlci1jYWxlbmRhci1tb250aC1zZWxlY3R7d2lkdGg6Y2FsYyg1MCUgLSA4cHgpfS5hbnQtcGlja2VyLWNhbGVuZGFyLWhlYWRlciAuYW50LXBpY2tlci1jYWxlbmRhci1tb2RlLXN3aXRjaHt3aWR0aDoxMDAlO21hcmdpbi10b3A6OHB4O21hcmdpbi1sZWZ0OjB9LmFudC1waWNrZXItY2FsZW5kYXItaGVhZGVyIC5hbnQtcGlja2VyLWNhbGVuZGFyLW1vZGUtc3dpdGNoPmxhYmVse3dpZHRoOjUwJTt0ZXh0LWFsaWduOmNlbnRlcn19LmFudC1waWNrZXItY2FsZW5kYXItcnRse2RpcmVjdGlvbjpydGx9LmFudC1waWNrZXItY2FsZW5kYXItcnRsIC5hbnQtcGlja2VyLWNhbGVuZGFyLWhlYWRlciAuYW50LXBpY2tlci1jYWxlbmRhci1tb2RlLXN3aXRjaCwuYW50LXBpY2tlci1jYWxlbmRhci1ydGwgLmFudC1waWNrZXItY2FsZW5kYXItaGVhZGVyIC5hbnQtcGlja2VyLWNhbGVuZGFyLW1vbnRoLXNlbGVjdHttYXJnaW4tcmlnaHQ6OHB4O21hcmdpbi1sZWZ0OjB9LmFudC1waWNrZXItY2FsZW5kYXItcnRsLmFudC1waWNrZXItY2FsZW5kYXItZnVsbCAuYW50LXBpY2tlci1wYW5lbHt0ZXh0LWFsaWduOmxlZnR9LmFudC1waWNrZXItY2FsZW5kYXItcnRsLmFudC1waWNrZXItY2FsZW5kYXItZnVsbCAuYW50LXBpY2tlci1wYW5lbCAuYW50LXBpY2tlci1ib2R5IHRoe3BhZGRpbmc6MCAwIDVweCAxMnB4fS5hbnQtcGlja2VyLWNhbGVuZGFyLXJ0bC5hbnQtcGlja2VyLWNhbGVuZGFyLWZ1bGwgLmFudC1waWNrZXItcGFuZWwgLmFudC1waWNrZXItY2FsZW5kYXItZGF0ZS1jb250ZW50e3RleHQtYWxpZ246cmlnaHR9LmFudC1jYXJke2JveC1zaXppbmc6Ym9yZGVyLWJveDttYXJnaW46MDtwYWRkaW5nOjA7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtc2l6ZToxNHB4O2ZvbnQtdmFyaWFudDp0YWJ1bGFyLW51bXM7bGluZS1oZWlnaHQ6MS41NzE1O2xpc3Qtc3R5bGU6bm9uZTtmb250LWZlYXR1cmUtc2V0dGluZ3M6XCJ0bnVtXCI7cG9zaXRpb246cmVsYXRpdmU7YmFja2dyb3VuZDojZmZmO2JvcmRlci1yYWRpdXM6MnB4fS5hbnQtY2FyZC1ydGx7ZGlyZWN0aW9uOnJ0bH0uYW50LWNhcmQtaG92ZXJhYmxle2N1cnNvcjpwb2ludGVyO3RyYW5zaXRpb246Ym94LXNoYWRvdyAuM3MsYm9yZGVyLWNvbG9yIC4zc30uYW50LWNhcmQtaG92ZXJhYmxlOmhvdmVye2JvcmRlci1jb2xvcjp0cmFuc3BhcmVudDtib3gtc2hhZG93OjAgMXB4IDJweCAtMnB4IHJnYmEoMCwwLDAsLjE2KSwwIDNweCA2cHggMCByZ2JhKDAsMCwwLC4xMiksMCA1cHggMTJweCA0cHggcmdiYSgwLDAsMCwuMDkpfS5hbnQtY2FyZC1ib3JkZXJlZHtib3JkZXI6MXB4IHNvbGlkICNmMGYwZjB9LmFudC1jYXJkLWhlYWR7bWluLWhlaWdodDo0OHB4O21hcmdpbi1ib3R0b206LTFweDtwYWRkaW5nOjAgMjRweDtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7Zm9udC13ZWlnaHQ6NTAwO2ZvbnQtc2l6ZToxNnB4O2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7Ym9yZGVyLWJvdHRvbToxcHggc29saWQgI2YwZjBmMDtib3JkZXItcmFkaXVzOjJweCAycHggMCAwfS5hbnQtY2FyZC1oZWFkOmFmdGVyLC5hbnQtY2FyZC1oZWFkOmJlZm9yZXtkaXNwbGF5OnRhYmxlO2NvbnRlbnQ6XCJcIn0uYW50LWNhcmQtaGVhZDphZnRlcntjbGVhcjpib3RofS5hbnQtY2FyZC1oZWFkLXdyYXBwZXJ7ZGlzcGxheTpmbGV4O2FsaWduLWl0ZW1zOmNlbnRlcn0uYW50LWNhcmQtaGVhZC10aXRsZXtkaXNwbGF5OmlubGluZS1ibG9jaztmbGV4OjE7cGFkZGluZzoxNnB4IDA7b3ZlcmZsb3c6aGlkZGVuO3doaXRlLXNwYWNlOm5vd3JhcDt0ZXh0LW92ZXJmbG93OmVsbGlwc2lzfS5hbnQtY2FyZC1oZWFkLXRpdGxlPi5hbnQtdHlwb2dyYXBoeSwuYW50LWNhcmQtaGVhZC10aXRsZT4uYW50LXR5cG9ncmFwaHktZWRpdC1jb250ZW50e2xlZnQ6MDttYXJnaW4tdG9wOjA7bWFyZ2luLWJvdHRvbTowfS5hbnQtY2FyZC1oZWFkIC5hbnQtdGFicy10b3B7Y2xlYXI6Ym90aDttYXJnaW4tYm90dG9tOi0xN3B4O2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtmb250LXdlaWdodDo0MDA7Zm9udC1zaXplOjE0cHh9LmFudC1jYXJkLWhlYWQgLmFudC10YWJzLXRvcC1iYXJ7Ym9yZGVyLWJvdHRvbToxcHggc29saWQgI2YwZjBmMH0uYW50LWNhcmQtZXh0cmF7bWFyZ2luLWxlZnQ6YXV0bztwYWRkaW5nOjE2cHggMDtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7Zm9udC13ZWlnaHQ6NDAwO2ZvbnQtc2l6ZToxNHB4fS5hbnQtY2FyZC1ydGwgLmFudC1jYXJkLWV4dHJhe21hcmdpbi1yaWdodDphdXRvO21hcmdpbi1sZWZ0OjB9LmFudC1jYXJkLWJvZHl7cGFkZGluZzoyNHB4fS5hbnQtY2FyZC1ib2R5OmFmdGVyLC5hbnQtY2FyZC1ib2R5OmJlZm9yZXtkaXNwbGF5OnRhYmxlO2NvbnRlbnQ6XCJcIn0uYW50LWNhcmQtYm9keTphZnRlcntjbGVhcjpib3RofS5hbnQtY2FyZC1jb250YWluLWdyaWQgLmFudC1jYXJkLWJvZHl7ZGlzcGxheTpmbGV4O2ZsZXgtd3JhcDp3cmFwfS5hbnQtY2FyZC1jb250YWluLWdyaWQ6bm90KC5hbnQtY2FyZC1sb2FkaW5nKSAuYW50LWNhcmQtYm9keXttYXJnaW46LTFweCAwIDAgLTFweDtwYWRkaW5nOjB9LmFudC1jYXJkLWdyaWR7d2lkdGg6MzMuMzMlO3BhZGRpbmc6MjRweDtib3JkZXI6MDtib3JkZXItcmFkaXVzOjA7Ym94LXNoYWRvdzoxcHggMCAwIDAgI2YwZjBmMCwwIDFweCAwIDAgI2YwZjBmMCwxcHggMXB4IDAgMCAjZjBmMGYwLGluc2V0IDFweCAwIDAgMCAjZjBmMGYwLGluc2V0IDAgMXB4IDAgMCAjZjBmMGYwO3RyYW5zaXRpb246YWxsIC4zc30uYW50LWNhcmQtZ3JpZC1ob3ZlcmFibGU6aG92ZXJ7cG9zaXRpb246cmVsYXRpdmU7ei1pbmRleDoxO2JveC1zaGFkb3c6MCAxcHggMnB4IC0ycHggcmdiYSgwLDAsMCwuMTYpLDAgM3B4IDZweCAwIHJnYmEoMCwwLDAsLjEyKSwwIDVweCAxMnB4IDRweCByZ2JhKDAsMCwwLC4wOSl9LmFudC1jYXJkLWNvbnRhaW4tdGFicz4uYW50LWNhcmQtaGVhZCAuYW50LWNhcmQtaGVhZC10aXRsZXttaW4taGVpZ2h0OjMycHg7cGFkZGluZy1ib3R0b206MH0uYW50LWNhcmQtY29udGFpbi10YWJzPi5hbnQtY2FyZC1oZWFkIC5hbnQtY2FyZC1leHRyYXtwYWRkaW5nLWJvdHRvbTowfS5hbnQtY2FyZC1ib3JkZXJlZCAuYW50LWNhcmQtY292ZXJ7bWFyZ2luLXRvcDotMXB4O21hcmdpbi1yaWdodDotMXB4O21hcmdpbi1sZWZ0Oi0xcHh9LmFudC1jYXJkLWNvdmVyPip7ZGlzcGxheTpibG9jazt3aWR0aDoxMDAlfS5hbnQtY2FyZC1jb3ZlciBpbWd7Ym9yZGVyLXJhZGl1czoycHggMnB4IDAgMH0uYW50LWNhcmQtYWN0aW9uc3tkaXNwbGF5OmZsZXg7bWFyZ2luOjA7cGFkZGluZzowO2xpc3Qtc3R5bGU6bm9uZTtiYWNrZ3JvdW5kOiNmZmY7Ym9yZGVyLXRvcDoxcHggc29saWQgI2YwZjBmMH0uYW50LWNhcmQtYWN0aW9uczphZnRlciwuYW50LWNhcmQtYWN0aW9uczpiZWZvcmV7ZGlzcGxheTp0YWJsZTtjb250ZW50OlwiXCJ9LmFudC1jYXJkLWFjdGlvbnM6YWZ0ZXJ7Y2xlYXI6Ym90aH0uYW50LWNhcmQtYWN0aW9ucz5saXttYXJnaW46MTJweCAwO2NvbG9yOnJnYmEoMCwwLDAsLjQ1KTt0ZXh0LWFsaWduOmNlbnRlcn0uYW50LWNhcmQtYWN0aW9ucz5saT5zcGFue3Bvc2l0aW9uOnJlbGF0aXZlO2Rpc3BsYXk6YmxvY2s7bWluLXdpZHRoOjMycHg7Zm9udC1zaXplOjE0cHg7bGluZS1oZWlnaHQ6MS41NzE1O2N1cnNvcjpwb2ludGVyfS5hbnQtY2FyZC1hY3Rpb25zPmxpPnNwYW46aG92ZXJ7Y29sb3I6IzE4OTBmZjt0cmFuc2l0aW9uOmNvbG9yIC4zc30uYW50LWNhcmQtYWN0aW9ucz5saT5zcGFuPi5hbnRpY29uLC5hbnQtY2FyZC1hY3Rpb25zPmxpPnNwYW4gYTpub3QoLmFudC1idG4pe2Rpc3BsYXk6aW5saW5lLWJsb2NrO3dpZHRoOjEwMCU7Y29sb3I6cmdiYSgwLDAsMCwuNDUpO2xpbmUtaGVpZ2h0OjIycHg7dHJhbnNpdGlvbjpjb2xvciAuM3N9LmFudC1jYXJkLWFjdGlvbnM+bGk+c3Bhbj4uYW50aWNvbjpob3ZlciwuYW50LWNhcmQtYWN0aW9ucz5saT5zcGFuIGE6bm90KC5hbnQtYnRuKTpob3Zlcntjb2xvcjojMTg5MGZmfS5hbnQtY2FyZC1hY3Rpb25zPmxpPnNwYW4+LmFudGljb257Zm9udC1zaXplOjE2cHg7bGluZS1oZWlnaHQ6MjJweH0uYW50LWNhcmQtYWN0aW9ucz5saTpub3QoOmxhc3QtY2hpbGQpe2JvcmRlci1yaWdodDoxcHggc29saWQgI2YwZjBmMH0uYW50LWNhcmQtcnRsIC5hbnQtY2FyZC1hY3Rpb25zPmxpOm5vdCg6bGFzdC1jaGlsZCl7Ym9yZGVyLXJpZ2h0Om5vbmU7Ym9yZGVyLWxlZnQ6MXB4IHNvbGlkICNmMGYwZjB9LmFudC1jYXJkLXR5cGUtaW5uZXIgLmFudC1jYXJkLWhlYWR7cGFkZGluZzowIDI0cHg7YmFja2dyb3VuZDojZmFmYWZhfS5hbnQtY2FyZC10eXBlLWlubmVyIC5hbnQtY2FyZC1oZWFkLXRpdGxle3BhZGRpbmc6MTJweCAwO2ZvbnQtc2l6ZToxNHB4fS5hbnQtY2FyZC10eXBlLWlubmVyIC5hbnQtY2FyZC1ib2R5e3BhZGRpbmc6MTZweCAyNHB4fS5hbnQtY2FyZC10eXBlLWlubmVyIC5hbnQtY2FyZC1leHRyYXtwYWRkaW5nOjEzLjVweCAwfS5hbnQtY2FyZC1tZXRhe2Rpc3BsYXk6ZmxleDttYXJnaW46LTRweCAwfS5hbnQtY2FyZC1tZXRhOmFmdGVyLC5hbnQtY2FyZC1tZXRhOmJlZm9yZXtkaXNwbGF5OnRhYmxlO2NvbnRlbnQ6XCJcIn0uYW50LWNhcmQtbWV0YTphZnRlcntjbGVhcjpib3RofS5hbnQtY2FyZC1tZXRhLWF2YXRhcntwYWRkaW5nLXJpZ2h0OjE2cHh9LmFudC1jYXJkLXJ0bCAuYW50LWNhcmQtbWV0YS1hdmF0YXJ7cGFkZGluZy1yaWdodDowO3BhZGRpbmctbGVmdDoxNnB4fS5hbnQtY2FyZC1tZXRhLWRldGFpbHtmbGV4OjE7b3ZlcmZsb3c6aGlkZGVufS5hbnQtY2FyZC1tZXRhLWRldGFpbD5kaXY6bm90KDpsYXN0LWNoaWxkKXttYXJnaW4tYm90dG9tOjhweH0uYW50LWNhcmQtbWV0YS10aXRsZXtvdmVyZmxvdzpoaWRkZW47Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtd2VpZ2h0OjUwMDtmb250LXNpemU6MTZweDt3aGl0ZS1zcGFjZTpub3dyYXA7dGV4dC1vdmVyZmxvdzplbGxpcHNpc30uYW50LWNhcmQtbWV0YS1kZXNjcmlwdGlvbntjb2xvcjpyZ2JhKDAsMCwwLC40NSl9LmFudC1jYXJkLWxvYWRpbmd7b3ZlcmZsb3c6aGlkZGVufS5hbnQtY2FyZC1sb2FkaW5nIC5hbnQtY2FyZC1ib2R5ey13ZWJraXQtdXNlci1zZWxlY3Q6bm9uZTstbW96LXVzZXItc2VsZWN0Om5vbmU7LW1zLXVzZXItc2VsZWN0Om5vbmU7dXNlci1zZWxlY3Q6bm9uZX0uYW50LWNhcmQtc21hbGw+LmFudC1jYXJkLWhlYWR7bWluLWhlaWdodDozNnB4O3BhZGRpbmc6MCAxMnB4O2ZvbnQtc2l6ZToxNHB4fS5hbnQtY2FyZC1zbWFsbD4uYW50LWNhcmQtaGVhZD4uYW50LWNhcmQtaGVhZC13cmFwcGVyPi5hbnQtY2FyZC1oZWFkLXRpdGxle3BhZGRpbmc6OHB4IDB9LmFudC1jYXJkLXNtYWxsPi5hbnQtY2FyZC1oZWFkPi5hbnQtY2FyZC1oZWFkLXdyYXBwZXI+LmFudC1jYXJkLWV4dHJhe3BhZGRpbmc6OHB4IDA7Zm9udC1zaXplOjE0cHh9LmFudC1jYXJkLXNtYWxsPi5hbnQtY2FyZC1ib2R5e3BhZGRpbmc6MTJweH0uYW50LWNhcm91c2Vse2JveC1zaXppbmc6Ym9yZGVyLWJveDttYXJnaW46MDtwYWRkaW5nOjA7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtc2l6ZToxNHB4O2ZvbnQtdmFyaWFudDp0YWJ1bGFyLW51bXM7bGluZS1oZWlnaHQ6MS41NzE1O2xpc3Qtc3R5bGU6bm9uZTtmb250LWZlYXR1cmUtc2V0dGluZ3M6XCJ0bnVtXCJ9LmFudC1jYXJvdXNlbCAuc2xpY2stc2xpZGVye3Bvc2l0aW9uOnJlbGF0aXZlO2Rpc3BsYXk6YmxvY2s7Ym94LXNpemluZzpib3JkZXItYm94O3RvdWNoLWFjdGlvbjpwYW4teTstd2Via2l0LXRvdWNoLWNhbGxvdXQ6bm9uZTstd2Via2l0LXRhcC1oaWdobGlnaHQtY29sb3I6dHJhbnNwYXJlbnR9LmFudC1jYXJvdXNlbCAuc2xpY2stbGlzdHtwb3NpdGlvbjpyZWxhdGl2ZTtkaXNwbGF5OmJsb2NrO21hcmdpbjowO3BhZGRpbmc6MDtvdmVyZmxvdzpoaWRkZW59LmFudC1jYXJvdXNlbCAuc2xpY2stbGlzdDpmb2N1c3tvdXRsaW5lOm5vbmV9LmFudC1jYXJvdXNlbCAuc2xpY2stbGlzdC5kcmFnZ2luZ3tjdXJzb3I6cG9pbnRlcn0uYW50LWNhcm91c2VsIC5zbGljay1saXN0IC5zbGljay1zbGlkZXtwb2ludGVyLWV2ZW50czpub25lfS5hbnQtY2Fyb3VzZWwgLnNsaWNrLWxpc3QgLnNsaWNrLXNsaWRlIGlucHV0LmFudC1jaGVja2JveC1pbnB1dCwuYW50LWNhcm91c2VsIC5zbGljay1saXN0IC5zbGljay1zbGlkZSBpbnB1dC5hbnQtcmFkaW8taW5wdXR7dmlzaWJpbGl0eTpoaWRkZW59LmFudC1jYXJvdXNlbCAuc2xpY2stbGlzdCAuc2xpY2stc2xpZGUuc2xpY2stYWN0aXZle3BvaW50ZXItZXZlbnRzOmF1dG99LmFudC1jYXJvdXNlbCAuc2xpY2stbGlzdCAuc2xpY2stc2xpZGUuc2xpY2stYWN0aXZlIGlucHV0LmFudC1jaGVja2JveC1pbnB1dCwuYW50LWNhcm91c2VsIC5zbGljay1saXN0IC5zbGljay1zbGlkZS5zbGljay1hY3RpdmUgaW5wdXQuYW50LXJhZGlvLWlucHV0e3Zpc2liaWxpdHk6dmlzaWJsZX0uYW50LWNhcm91c2VsIC5zbGljay1saXN0IC5zbGljay1zbGlkZT5kaXY+ZGl2e3ZlcnRpY2FsLWFsaWduOmJvdHRvbX0uYW50LWNhcm91c2VsIC5zbGljay1zbGlkZXIgLnNsaWNrLWxpc3QsLmFudC1jYXJvdXNlbCAuc2xpY2stc2xpZGVyIC5zbGljay10cmFja3t0cmFuc2Zvcm06dHJhbnNsYXRlWigwKTt0b3VjaC1hY3Rpb246cGFuLXl9LmFudC1jYXJvdXNlbCAuc2xpY2stdHJhY2t7cG9zaXRpb246cmVsYXRpdmU7dG9wOjA7bGVmdDowO2Rpc3BsYXk6YmxvY2t9LmFudC1jYXJvdXNlbCAuc2xpY2stdHJhY2s6YWZ0ZXIsLmFudC1jYXJvdXNlbCAuc2xpY2stdHJhY2s6YmVmb3Jle2Rpc3BsYXk6dGFibGU7Y29udGVudDpcIlwifS5hbnQtY2Fyb3VzZWwgLnNsaWNrLXRyYWNrOmFmdGVye2NsZWFyOmJvdGh9LnNsaWNrLWxvYWRpbmcgLmFudC1jYXJvdXNlbCAuc2xpY2stdHJhY2t7dmlzaWJpbGl0eTpoaWRkZW59LmFudC1jYXJvdXNlbCAuc2xpY2stc2xpZGV7ZGlzcGxheTpub25lO2Zsb2F0OmxlZnQ7aGVpZ2h0OjEwMCU7bWluLWhlaWdodDoxcHh9LmFudC1jYXJvdXNlbCAuc2xpY2stc2xpZGUgaW1ne2Rpc3BsYXk6YmxvY2t9LmFudC1jYXJvdXNlbCAuc2xpY2stc2xpZGUuc2xpY2stbG9hZGluZyBpbWd7ZGlzcGxheTpub25lfS5hbnQtY2Fyb3VzZWwgLnNsaWNrLXNsaWRlLmRyYWdnaW5nIGltZ3twb2ludGVyLWV2ZW50czpub25lfS5hbnQtY2Fyb3VzZWwgLnNsaWNrLWluaXRpYWxpemVkIC5zbGljay1zbGlkZXtkaXNwbGF5OmJsb2NrfS5hbnQtY2Fyb3VzZWwgLnNsaWNrLWxvYWRpbmcgLnNsaWNrLXNsaWRle3Zpc2liaWxpdHk6aGlkZGVufS5hbnQtY2Fyb3VzZWwgLnNsaWNrLXZlcnRpY2FsIC5zbGljay1zbGlkZXtkaXNwbGF5OmJsb2NrO2hlaWdodDphdXRvfS5hbnQtY2Fyb3VzZWwgLnNsaWNrLWFycm93LnNsaWNrLWhpZGRlbntkaXNwbGF5Om5vbmV9LmFudC1jYXJvdXNlbCAuc2xpY2stbmV4dCwuYW50LWNhcm91c2VsIC5zbGljay1wcmV2e3Bvc2l0aW9uOmFic29sdXRlO3RvcDo1MCU7ZGlzcGxheTpibG9jazt3aWR0aDoyMHB4O2hlaWdodDoyMHB4O21hcmdpbi10b3A6LTEwcHg7cGFkZGluZzowO2ZvbnQtc2l6ZTowO2xpbmUtaGVpZ2h0OjA7Ym9yZGVyOjA7Y3Vyc29yOnBvaW50ZXJ9LmFudC1jYXJvdXNlbCAuc2xpY2stbmV4dCwuYW50LWNhcm91c2VsIC5zbGljay1uZXh0OmZvY3VzLC5hbnQtY2Fyb3VzZWwgLnNsaWNrLW5leHQ6aG92ZXIsLmFudC1jYXJvdXNlbCAuc2xpY2stcHJldiwuYW50LWNhcm91c2VsIC5zbGljay1wcmV2OmZvY3VzLC5hbnQtY2Fyb3VzZWwgLnNsaWNrLXByZXY6aG92ZXJ7Y29sb3I6dHJhbnNwYXJlbnQ7YmFja2dyb3VuZDp0cmFuc3BhcmVudDtvdXRsaW5lOm5vbmV9LmFudC1jYXJvdXNlbCAuc2xpY2stbmV4dDpmb2N1czpiZWZvcmUsLmFudC1jYXJvdXNlbCAuc2xpY2stbmV4dDpob3ZlcjpiZWZvcmUsLmFudC1jYXJvdXNlbCAuc2xpY2stcHJldjpmb2N1czpiZWZvcmUsLmFudC1jYXJvdXNlbCAuc2xpY2stcHJldjpob3ZlcjpiZWZvcmV7b3BhY2l0eToxfS5hbnQtY2Fyb3VzZWwgLnNsaWNrLW5leHQuc2xpY2stZGlzYWJsZWQ6YmVmb3JlLC5hbnQtY2Fyb3VzZWwgLnNsaWNrLXByZXYuc2xpY2stZGlzYWJsZWQ6YmVmb3Jle29wYWNpdHk6LjI1fS5hbnQtY2Fyb3VzZWwgLnNsaWNrLXByZXZ7bGVmdDotMjVweH0uYW50LWNhcm91c2VsIC5zbGljay1wcmV2OmJlZm9yZXtjb250ZW50Olwi4oaQXCJ9LmFudC1jYXJvdXNlbCAuc2xpY2stbmV4dHtyaWdodDotMjVweH0uYW50LWNhcm91c2VsIC5zbGljay1uZXh0OmJlZm9yZXtjb250ZW50Olwi4oaSXCJ9LmFudC1jYXJvdXNlbCAuc2xpY2stZG90c3twb3NpdGlvbjphYnNvbHV0ZTtyaWdodDowO2JvdHRvbTowO2xlZnQ6MDt6LWluZGV4OjE1O2Rpc3BsYXk6ZmxleCFpbXBvcnRhbnQ7anVzdGlmeS1jb250ZW50OmNlbnRlcjttYXJnaW4tcmlnaHQ6MTUlO21hcmdpbi1ib3R0b206MDttYXJnaW4tbGVmdDoxNSU7cGFkZGluZy1sZWZ0OjA7bGlzdC1zdHlsZTpub25lfS5hbnQtY2Fyb3VzZWwgLnNsaWNrLWRvdHMtYm90dG9te2JvdHRvbToxMnB4fS5hbnQtY2Fyb3VzZWwgLnNsaWNrLWRvdHMtdG9we3RvcDoxMnB4O2JvdHRvbTphdXRvfS5hbnQtY2Fyb3VzZWwgLnNsaWNrLWRvdHMgbGl7cG9zaXRpb246cmVsYXRpdmU7ZGlzcGxheTppbmxpbmUtYmxvY2s7ZmxleDowIDEgYXV0bztib3gtc2l6aW5nOmNvbnRlbnQtYm94O3dpZHRoOjE2cHg7aGVpZ2h0OjNweDttYXJnaW46MCA0cHg7cGFkZGluZzowO3RleHQtYWxpZ246Y2VudGVyO3RleHQtaW5kZW50Oi05OTlweDt2ZXJ0aWNhbC1hbGlnbjp0b3A7dHJhbnNpdGlvbjphbGwgLjVzfS5hbnQtY2Fyb3VzZWwgLnNsaWNrLWRvdHMgbGkgYnV0dG9ue3Bvc2l0aW9uOnJlbGF0aXZlO2Rpc3BsYXk6YmxvY2s7d2lkdGg6MTAwJTtoZWlnaHQ6M3B4O3BhZGRpbmc6MDtjb2xvcjp0cmFuc3BhcmVudDtmb250LXNpemU6MDtiYWNrZ3JvdW5kOiNmZmY7Ym9yZGVyOjA7Ym9yZGVyLXJhZGl1czoxcHg7b3V0bGluZTpub25lO2N1cnNvcjpwb2ludGVyO29wYWNpdHk6LjM7dHJhbnNpdGlvbjphbGwgLjVzfS5hbnQtY2Fyb3VzZWwgLnNsaWNrLWRvdHMgbGkgYnV0dG9uOmZvY3VzLC5hbnQtY2Fyb3VzZWwgLnNsaWNrLWRvdHMgbGkgYnV0dG9uOmhvdmVye29wYWNpdHk6Ljc1fS5hbnQtY2Fyb3VzZWwgLnNsaWNrLWRvdHMgbGkgYnV0dG9uOmFmdGVye3Bvc2l0aW9uOmFic29sdXRlO3RvcDotNHB4O3JpZ2h0Oi00cHg7Ym90dG9tOi00cHg7bGVmdDotNHB4O2NvbnRlbnQ6XCJcIn0uYW50LWNhcm91c2VsIC5zbGljay1kb3RzIGxpLnNsaWNrLWFjdGl2ZXt3aWR0aDoyNHB4fS5hbnQtY2Fyb3VzZWwgLnNsaWNrLWRvdHMgbGkuc2xpY2stYWN0aXZlIGJ1dHRvbntiYWNrZ3JvdW5kOiNmZmY7b3BhY2l0eToxfS5hbnQtY2Fyb3VzZWwgLnNsaWNrLWRvdHMgbGkuc2xpY2stYWN0aXZlOmZvY3VzLC5hbnQtY2Fyb3VzZWwgLnNsaWNrLWRvdHMgbGkuc2xpY2stYWN0aXZlOmhvdmVye29wYWNpdHk6MX0uYW50LWNhcm91c2VsLXZlcnRpY2FsIC5zbGljay1kb3Rze3RvcDo1MCU7Ym90dG9tOmF1dG87ZmxleC1kaXJlY3Rpb246Y29sdW1uO3dpZHRoOjNweDtoZWlnaHQ6YXV0bzttYXJnaW46MDt0cmFuc2Zvcm06dHJhbnNsYXRlWSgtNTAlKX0uYW50LWNhcm91c2VsLXZlcnRpY2FsIC5zbGljay1kb3RzLWxlZnR7cmlnaHQ6YXV0bztsZWZ0OjEycHh9LmFudC1jYXJvdXNlbC12ZXJ0aWNhbCAuc2xpY2stZG90cy1yaWdodHtyaWdodDoxMnB4O2xlZnQ6YXV0b30uYW50LWNhcm91c2VsLXZlcnRpY2FsIC5zbGljay1kb3RzIGxpe3dpZHRoOjNweDtoZWlnaHQ6MTZweDttYXJnaW46NHB4IDA7dmVydGljYWwtYWxpZ246YmFzZWxpbmV9LmFudC1jYXJvdXNlbC12ZXJ0aWNhbCAuc2xpY2stZG90cyBsaSBidXR0b257d2lkdGg6M3B4O2hlaWdodDoxNnB4fS5hbnQtY2Fyb3VzZWwtdmVydGljYWwgLnNsaWNrLWRvdHMgbGkuc2xpY2stYWN0aXZlLC5hbnQtY2Fyb3VzZWwtdmVydGljYWwgLnNsaWNrLWRvdHMgbGkuc2xpY2stYWN0aXZlIGJ1dHRvbnt3aWR0aDozcHg7aGVpZ2h0OjI0cHh9LmFudC1jYXJvdXNlbC1ydGx7ZGlyZWN0aW9uOnJ0bH0uYW50LWNhcm91c2VsLXJ0bCAuYW50LWNhcm91c2VsIC5zbGljay10cmFja3tyaWdodDowO2xlZnQ6YXV0b30uYW50LWNhcm91c2VsLXJ0bCAuYW50LWNhcm91c2VsIC5zbGljay1wcmV2e3JpZ2h0Oi0yNXB4O2xlZnQ6YXV0b30uYW50LWNhcm91c2VsLXJ0bCAuYW50LWNhcm91c2VsIC5zbGljay1wcmV2OmJlZm9yZXtjb250ZW50Olwi4oaSXCJ9LmFudC1jYXJvdXNlbC1ydGwgLmFudC1jYXJvdXNlbCAuc2xpY2stbmV4dHtyaWdodDphdXRvO2xlZnQ6LTI1cHh9LmFudC1jYXJvdXNlbC1ydGwgLmFudC1jYXJvdXNlbCAuc2xpY2stbmV4dDpiZWZvcmV7Y29udGVudDpcIuKGkFwifS5hbnQtY2Fyb3VzZWwtcnRsLmFudC1jYXJvdXNlbCAuc2xpY2stZG90c3tmbGV4LWRpcmVjdGlvbjpyb3ctcmV2ZXJzZX0uYW50LWNhcm91c2VsLXJ0bC5hbnQtY2Fyb3VzZWwtdmVydGljYWwgLnNsaWNrLWRvdHN7ZmxleC1kaXJlY3Rpb246Y29sdW1ufS5hbnQtY2FzY2FkZXItY2hlY2tib3h7Ym94LXNpemluZzpib3JkZXItYm94O21hcmdpbjowO3BhZGRpbmc6MDtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7Zm9udC1zaXplOjE0cHg7Zm9udC12YXJpYW50OnRhYnVsYXItbnVtcztsaW5lLWhlaWdodDoxLjU3MTU7bGlzdC1zdHlsZTpub25lO2ZvbnQtZmVhdHVyZS1zZXR0aW5nczpcInRudW1cIjtwb3NpdGlvbjpyZWxhdGl2ZTt0b3A6LjJlbTtsaW5lLWhlaWdodDoxO3doaXRlLXNwYWNlOm5vd3JhcDtvdXRsaW5lOm5vbmU7Y3Vyc29yOnBvaW50ZXJ9LmFudC1jYXNjYWRlci1jaGVja2JveC1pbnB1dDpmb2N1cysuYW50LWNhc2NhZGVyLWNoZWNrYm94LWlubmVyLC5hbnQtY2FzY2FkZXItY2hlY2tib3gtd3JhcHBlcjpob3ZlciAuYW50LWNhc2NhZGVyLWNoZWNrYm94LWlubmVyLC5hbnQtY2FzY2FkZXItY2hlY2tib3g6aG92ZXIgLmFudC1jYXNjYWRlci1jaGVja2JveC1pbm5lcntib3JkZXItY29sb3I6IzE4OTBmZn0uYW50LWNhc2NhZGVyLWNoZWNrYm94LWNoZWNrZWQ6YWZ0ZXJ7cG9zaXRpb246YWJzb2x1dGU7dG9wOjA7bGVmdDowO3dpZHRoOjEwMCU7aGVpZ2h0OjEwMCU7Ym9yZGVyOjFweCBzb2xpZCAjMTg5MGZmO2JvcmRlci1yYWRpdXM6MnB4O3Zpc2liaWxpdHk6aGlkZGVuO2FuaW1hdGlvbjphbnRDaGVja2JveEVmZmVjdCAuMzZzIGVhc2UtaW4tb3V0O2FuaW1hdGlvbi1maWxsLW1vZGU6YmFja3dhcmRzO2NvbnRlbnQ6XCJcIn0uYW50LWNhc2NhZGVyLWNoZWNrYm94LXdyYXBwZXI6aG92ZXIgLmFudC1jYXNjYWRlci1jaGVja2JveDphZnRlciwuYW50LWNhc2NhZGVyLWNoZWNrYm94OmhvdmVyOmFmdGVye3Zpc2liaWxpdHk6dmlzaWJsZX0uYW50LWNhc2NhZGVyLWNoZWNrYm94LWlubmVye3Bvc2l0aW9uOnJlbGF0aXZlO3RvcDowO2xlZnQ6MDtkaXNwbGF5OmJsb2NrO3dpZHRoOjE2cHg7aGVpZ2h0OjE2cHg7ZGlyZWN0aW9uOmx0cjtiYWNrZ3JvdW5kLWNvbG9yOiNmZmY7Ym9yZGVyOjFweCBzb2xpZCAjZDlkOWQ5O2JvcmRlci1yYWRpdXM6MnB4O2JvcmRlci1jb2xsYXBzZTpzZXBhcmF0ZTt0cmFuc2l0aW9uOmFsbCAuM3N9LmFudC1jYXNjYWRlci1jaGVja2JveC1pbm5lcjphZnRlcntwb3NpdGlvbjphYnNvbHV0ZTt0b3A6NTAlO2xlZnQ6MjEuNSU7ZGlzcGxheTp0YWJsZTt3aWR0aDo1LjcxNDI4NTcxcHg7aGVpZ2h0OjkuMTQyODU3MTRweDtib3JkZXI6MnB4IHNvbGlkICNmZmY7Ym9yZGVyLXRvcDowO2JvcmRlci1sZWZ0OjA7dHJhbnNmb3JtOnJvdGF0ZSg0NWRlZykgc2NhbGUoMCkgdHJhbnNsYXRlKC01MCUsLTUwJSk7b3BhY2l0eTowO3RyYW5zaXRpb246YWxsIC4xcyBjdWJpYy1iZXppZXIoLjcxLC0uNDYsLjg4LC42KSxvcGFjaXR5IC4xcztjb250ZW50OlwiIFwifS5hbnQtY2FzY2FkZXItY2hlY2tib3gtaW5wdXR7cG9zaXRpb246YWJzb2x1dGU7dG9wOjA7cmlnaHQ6MDtib3R0b206MDtsZWZ0OjA7ei1pbmRleDoxO3dpZHRoOjEwMCU7aGVpZ2h0OjEwMCU7Y3Vyc29yOnBvaW50ZXI7b3BhY2l0eTowfS5hbnQtY2FzY2FkZXItY2hlY2tib3gtY2hlY2tlZCAuYW50LWNhc2NhZGVyLWNoZWNrYm94LWlubmVyOmFmdGVye3Bvc2l0aW9uOmFic29sdXRlO2Rpc3BsYXk6dGFibGU7Ym9yZGVyOjJweCBzb2xpZCAjZmZmO2JvcmRlci10b3A6MDtib3JkZXItbGVmdDowO3RyYW5zZm9ybTpyb3RhdGUoNDVkZWcpIHNjYWxlKDEpIHRyYW5zbGF0ZSgtNTAlLC01MCUpO29wYWNpdHk6MTt0cmFuc2l0aW9uOmFsbCAuMnMgY3ViaWMtYmV6aWVyKC4xMiwuNCwuMjksMS40NikgLjFzO2NvbnRlbnQ6XCIgXCJ9LmFudC1jYXNjYWRlci1jaGVja2JveC1jaGVja2VkIC5hbnQtY2FzY2FkZXItY2hlY2tib3gtaW5uZXJ7YmFja2dyb3VuZC1jb2xvcjojMTg5MGZmO2JvcmRlci1jb2xvcjojMTg5MGZmfS5hbnQtY2FzY2FkZXItY2hlY2tib3gtZGlzYWJsZWR7Y3Vyc29yOm5vdC1hbGxvd2VkfS5hbnQtY2FzY2FkZXItY2hlY2tib3gtZGlzYWJsZWQuYW50LWNhc2NhZGVyLWNoZWNrYm94LWNoZWNrZWQgLmFudC1jYXNjYWRlci1jaGVja2JveC1pbm5lcjphZnRlcntib3JkZXItY29sb3I6cmdiYSgwLDAsMCwuMjUpO2FuaW1hdGlvbi1uYW1lOm5vbmV9LmFudC1jYXNjYWRlci1jaGVja2JveC1kaXNhYmxlZCAuYW50LWNhc2NhZGVyLWNoZWNrYm94LWlucHV0e2N1cnNvcjpub3QtYWxsb3dlZDtwb2ludGVyLWV2ZW50czpub25lfS5hbnQtY2FzY2FkZXItY2hlY2tib3gtZGlzYWJsZWQgLmFudC1jYXNjYWRlci1jaGVja2JveC1pbm5lcntiYWNrZ3JvdW5kLWNvbG9yOiNmNWY1ZjU7Ym9yZGVyLWNvbG9yOiNkOWQ5ZDkhaW1wb3J0YW50fS5hbnQtY2FzY2FkZXItY2hlY2tib3gtZGlzYWJsZWQgLmFudC1jYXNjYWRlci1jaGVja2JveC1pbm5lcjphZnRlcntib3JkZXItY29sb3I6I2Y1ZjVmNTtib3JkZXItY29sbGFwc2U6c2VwYXJhdGU7YW5pbWF0aW9uLW5hbWU6bm9uZX0uYW50LWNhc2NhZGVyLWNoZWNrYm94LWRpc2FibGVkK3NwYW57Y29sb3I6cmdiYSgwLDAsMCwuMjUpO2N1cnNvcjpub3QtYWxsb3dlZH0uYW50LWNhc2NhZGVyLWNoZWNrYm94LWRpc2FibGVkOmhvdmVyOmFmdGVyLC5hbnQtY2FzY2FkZXItY2hlY2tib3gtd3JhcHBlcjpob3ZlciAuYW50LWNhc2NhZGVyLWNoZWNrYm94LWRpc2FibGVkOmFmdGVye3Zpc2liaWxpdHk6aGlkZGVufS5hbnQtY2FzY2FkZXItY2hlY2tib3gtd3JhcHBlcntib3gtc2l6aW5nOmJvcmRlci1ib3g7bWFyZ2luOjA7cGFkZGluZzowO2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtmb250LXNpemU6MTRweDtmb250LXZhcmlhbnQ6dGFidWxhci1udW1zO2xpbmUtaGVpZ2h0OjEuNTcxNTtsaXN0LXN0eWxlOm5vbmU7Zm9udC1mZWF0dXJlLXNldHRpbmdzOlwidG51bVwiO2Rpc3BsYXk6aW5saW5lLWZsZXg7YWxpZ24taXRlbXM6YmFzZWxpbmU7bGluZS1oZWlnaHQ6dW5zZXQ7Y3Vyc29yOnBvaW50ZXJ9LmFudC1jYXNjYWRlci1jaGVja2JveC13cmFwcGVyOmFmdGVye2Rpc3BsYXk6aW5saW5lLWJsb2NrO3dpZHRoOjA7b3ZlcmZsb3c6aGlkZGVuO2NvbnRlbnQ6XCJcXGEwXCJ9LmFudC1jYXNjYWRlci1jaGVja2JveC13cmFwcGVyLmFudC1jYXNjYWRlci1jaGVja2JveC13cmFwcGVyLWRpc2FibGVke2N1cnNvcjpub3QtYWxsb3dlZH0uYW50LWNhc2NhZGVyLWNoZWNrYm94LXdyYXBwZXIrLmFudC1jYXNjYWRlci1jaGVja2JveC13cmFwcGVye21hcmdpbi1sZWZ0OjhweH0uYW50LWNhc2NhZGVyLWNoZWNrYm94LXdyYXBwZXIuYW50LWNhc2NhZGVyLWNoZWNrYm94LXdyYXBwZXItaW4tZm9ybS1pdGVtIGlucHV0W3R5cGU9Y2hlY2tib3hde3dpZHRoOjE0cHg7aGVpZ2h0OjE0cHh9LmFudC1jYXNjYWRlci1jaGVja2JveCtzcGFue3BhZGRpbmctcmlnaHQ6OHB4O3BhZGRpbmctbGVmdDo4cHh9LmFudC1jYXNjYWRlci1jaGVja2JveC1ncm91cHtib3gtc2l6aW5nOmJvcmRlci1ib3g7bWFyZ2luOjA7cGFkZGluZzowO2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtmb250LXNpemU6MTRweDtmb250LXZhcmlhbnQ6dGFidWxhci1udW1zO2xpbmUtaGVpZ2h0OjEuNTcxNTtsaXN0LXN0eWxlOm5vbmU7Zm9udC1mZWF0dXJlLXNldHRpbmdzOlwidG51bVwiO2Rpc3BsYXk6aW5saW5lLWJsb2NrfS5hbnQtY2FzY2FkZXItY2hlY2tib3gtZ3JvdXAtaXRlbXttYXJnaW4tcmlnaHQ6OHB4fS5hbnQtY2FzY2FkZXItY2hlY2tib3gtZ3JvdXAtaXRlbTpsYXN0LWNoaWxke21hcmdpbi1yaWdodDowfS5hbnQtY2FzY2FkZXItY2hlY2tib3gtZ3JvdXAtaXRlbSsuYW50LWNhc2NhZGVyLWNoZWNrYm94LWdyb3VwLWl0ZW17bWFyZ2luLWxlZnQ6MH0uYW50LWNhc2NhZGVyLWNoZWNrYm94LWluZGV0ZXJtaW5hdGUgLmFudC1jYXNjYWRlci1jaGVja2JveC1pbm5lcntiYWNrZ3JvdW5kLWNvbG9yOiNmZmY7Ym9yZGVyLWNvbG9yOiNkOWQ5ZDl9LmFudC1jYXNjYWRlci1jaGVja2JveC1pbmRldGVybWluYXRlIC5hbnQtY2FzY2FkZXItY2hlY2tib3gtaW5uZXI6YWZ0ZXJ7dG9wOjUwJTtsZWZ0OjUwJTt3aWR0aDo4cHg7aGVpZ2h0OjhweDtiYWNrZ3JvdW5kLWNvbG9yOiMxODkwZmY7Ym9yZGVyOjA7dHJhbnNmb3JtOnRyYW5zbGF0ZSgtNTAlLC01MCUpIHNjYWxlKDEpO29wYWNpdHk6MTtjb250ZW50OlwiIFwifS5hbnQtY2FzY2FkZXItY2hlY2tib3gtaW5kZXRlcm1pbmF0ZS5hbnQtY2FzY2FkZXItY2hlY2tib3gtZGlzYWJsZWQgLmFudC1jYXNjYWRlci1jaGVja2JveC1pbm5lcjphZnRlcntiYWNrZ3JvdW5kLWNvbG9yOnJnYmEoMCwwLDAsLjI1KTtib3JkZXItY29sb3I6cmdiYSgwLDAsMCwuMjUpfS5hbnQtY2FzY2FkZXJ7d2lkdGg6MTg0cHh9LmFudC1jYXNjYWRlci1jaGVja2JveHt0b3A6MDttYXJnaW4tcmlnaHQ6OHB4fS5hbnQtY2FzY2FkZXItbWVudXN7ZGlzcGxheTpmbGV4O2ZsZXgtd3JhcDpub3dyYXA7YWxpZ24taXRlbXM6ZmxleC1zdGFydH0uYW50LWNhc2NhZGVyLW1lbnVzLmFudC1jYXNjYWRlci1tZW51LWVtcHR5IC5hbnQtY2FzY2FkZXItbWVudXt3aWR0aDoxMDAlO2hlaWdodDphdXRvfS5hbnQtY2FzY2FkZXItbWVudXtmbGV4LWdyb3c6MTttaW4td2lkdGg6MTExcHg7aGVpZ2h0OjE4MHB4O21hcmdpbjotNHB4IDA7cGFkZGluZzo0cHggMDtvdmVyZmxvdzphdXRvO3ZlcnRpY2FsLWFsaWduOnRvcDtsaXN0LXN0eWxlOm5vbmU7Ym9yZGVyLXJpZ2h0OjFweCBzb2xpZCAjZjBmMGYwOy1tcy1vdmVyZmxvdy1zdHlsZTotbXMtYXV0b2hpZGluZy1zY3JvbGxiYXJ9LmFudC1jYXNjYWRlci1tZW51LWl0ZW17ZGlzcGxheTpmbGV4O2ZsZXgtd3JhcDpub3dyYXA7YWxpZ24taXRlbXM6Y2VudGVyO3BhZGRpbmc6NXB4IDEycHg7b3ZlcmZsb3c6aGlkZGVuO2xpbmUtaGVpZ2h0OjIycHg7d2hpdGUtc3BhY2U6bm93cmFwO3RleHQtb3ZlcmZsb3c6ZWxsaXBzaXM7Y3Vyc29yOnBvaW50ZXI7dHJhbnNpdGlvbjphbGwgLjNzfS5hbnQtY2FzY2FkZXItbWVudS1pdGVtOmhvdmVye2JhY2tncm91bmQ6I2Y1ZjVmNX0uYW50LWNhc2NhZGVyLW1lbnUtaXRlbS1kaXNhYmxlZHtjb2xvcjpyZ2JhKDAsMCwwLC4yNSk7Y3Vyc29yOm5vdC1hbGxvd2VkfS5hbnQtY2FzY2FkZXItbWVudS1pdGVtLWRpc2FibGVkOmhvdmVye2JhY2tncm91bmQ6dHJhbnNwYXJlbnR9LmFudC1jYXNjYWRlci1tZW51LWVtcHR5IC5hbnQtY2FzY2FkZXItbWVudS1pdGVte2NvbG9yOnJnYmEoMCwwLDAsLjI1KTtjdXJzb3I6ZGVmYXVsdDtwb2ludGVyLWV2ZW50czpub25lfS5hbnQtY2FzY2FkZXItbWVudS1pdGVtLWFjdGl2ZTpub3QoLmFudC1jYXNjYWRlci1tZW51LWl0ZW0tZGlzYWJsZWQpLC5hbnQtY2FzY2FkZXItbWVudS1pdGVtLWFjdGl2ZTpub3QoLmFudC1jYXNjYWRlci1tZW51LWl0ZW0tZGlzYWJsZWQpOmhvdmVye2ZvbnQtd2VpZ2h0OjYwMDtiYWNrZ3JvdW5kLWNvbG9yOiNlNmY3ZmZ9LmFudC1jYXNjYWRlci1tZW51LWl0ZW0tY29udGVudHtmbGV4OmF1dG99LmFudC1jYXNjYWRlci1tZW51LWl0ZW0tZXhwYW5kIC5hbnQtY2FzY2FkZXItbWVudS1pdGVtLWV4cGFuZC1pY29uLC5hbnQtY2FzY2FkZXItbWVudS1pdGVtLWxvYWRpbmctaWNvbnttYXJnaW4tbGVmdDo0cHg7Y29sb3I6cmdiYSgwLDAsMCwuNDUpO2ZvbnQtc2l6ZToxMHB4fS5hbnQtY2FzY2FkZXItbWVudS1pdGVtLWRpc2FibGVkLmFudC1jYXNjYWRlci1tZW51LWl0ZW0tZXhwYW5kIC5hbnQtY2FzY2FkZXItbWVudS1pdGVtLWV4cGFuZC1pY29uLC5hbnQtY2FzY2FkZXItbWVudS1pdGVtLWRpc2FibGVkLmFudC1jYXNjYWRlci1tZW51LWl0ZW0tbG9hZGluZy1pY29ue2NvbG9yOnJnYmEoMCwwLDAsLjI1KX0uYW50LWNhc2NhZGVyLW1lbnUtaXRlbS1rZXl3b3Jke2NvbG9yOiNmZjRkNGZ9LmFudC1jYXNjYWRlci1jb21wYWN0LWl0ZW06bm90KC5hbnQtY2FzY2FkZXItY29tcGFjdC1sYXN0LWl0ZW0pOm5vdCguYW50LWNhc2NhZGVyLWNvbXBhY3QtaXRlbS1ydGwpe21hcmdpbi1yaWdodDotMXB4fS5hbnQtY2FzY2FkZXItY29tcGFjdC1pdGVtOm5vdCguYW50LWNhc2NhZGVyLWNvbXBhY3QtbGFzdC1pdGVtKS5hbnQtY2FzY2FkZXItY29tcGFjdC1pdGVtLXJ0bHttYXJnaW4tbGVmdDotMXB4fS5hbnQtY2FzY2FkZXItY29tcGFjdC1pdGVtOmFjdGl2ZSwuYW50LWNhc2NhZGVyLWNvbXBhY3QtaXRlbTpmb2N1cywuYW50LWNhc2NhZGVyLWNvbXBhY3QtaXRlbTpob3Zlcnt6LWluZGV4OjJ9LmFudC1jYXNjYWRlci1jb21wYWN0LWl0ZW1bZGlzYWJsZWRde3otaW5kZXg6MH0uYW50LWNhc2NhZGVyLWNvbXBhY3QtaXRlbTpub3QoLmFudC1jYXNjYWRlci1jb21wYWN0LWZpcnN0LWl0ZW0pOm5vdCguYW50LWNhc2NhZGVyLWNvbXBhY3QtbGFzdC1pdGVtKS5hbnQtY2FzY2FkZXJ7Ym9yZGVyLXJhZGl1czowfS5hbnQtY2FzY2FkZXItY29tcGFjdC1pdGVtLmFudC1jYXNjYWRlci5hbnQtY2FzY2FkZXItY29tcGFjdC1maXJzdC1pdGVtOm5vdCguYW50LWNhc2NhZGVyLWNvbXBhY3QtbGFzdC1pdGVtKTpub3QoLmFudC1jYXNjYWRlci1jb21wYWN0LWl0ZW0tcnRsKXtib3JkZXItdG9wLXJpZ2h0LXJhZGl1czowO2JvcmRlci1ib3R0b20tcmlnaHQtcmFkaXVzOjB9LmFudC1jYXNjYWRlci1jb21wYWN0LWl0ZW0uYW50LWNhc2NhZGVyLmFudC1jYXNjYWRlci1jb21wYWN0LWl0ZW0tcnRsLmFudC1jYXNjYWRlci1jb21wYWN0LWZpcnN0LWl0ZW06bm90KC5hbnQtY2FzY2FkZXItY29tcGFjdC1sYXN0LWl0ZW0pLC5hbnQtY2FzY2FkZXItY29tcGFjdC1pdGVtLmFudC1jYXNjYWRlci5hbnQtY2FzY2FkZXItY29tcGFjdC1sYXN0LWl0ZW06bm90KC5hbnQtY2FzY2FkZXItY29tcGFjdC1maXJzdC1pdGVtKTpub3QoLmFudC1jYXNjYWRlci1jb21wYWN0LWl0ZW0tcnRsKXtib3JkZXItdG9wLWxlZnQtcmFkaXVzOjA7Ym9yZGVyLWJvdHRvbS1sZWZ0LXJhZGl1czowfS5hbnQtY2FzY2FkZXItY29tcGFjdC1pdGVtLmFudC1jYXNjYWRlci5hbnQtY2FzY2FkZXItY29tcGFjdC1pdGVtLXJ0bC5hbnQtY2FzY2FkZXItY29tcGFjdC1sYXN0LWl0ZW06bm90KC5hbnQtY2FzY2FkZXItY29tcGFjdC1maXJzdC1pdGVtKXtib3JkZXItdG9wLXJpZ2h0LXJhZGl1czowO2JvcmRlci1ib3R0b20tcmlnaHQtcmFkaXVzOjB9LmFudC1jYXNjYWRlci1ydGwgLmFudC1jYXNjYWRlci1tZW51LWl0ZW0tZXhwYW5kLWljb24sLmFudC1jYXNjYWRlci1ydGwgLmFudC1jYXNjYWRlci1tZW51LWl0ZW0tbG9hZGluZy1pY29ue21hcmdpbi1yaWdodDo0cHg7bWFyZ2luLWxlZnQ6MH0uYW50LWNhc2NhZGVyLXJ0bCAuYW50LWNhc2NhZGVyLWNoZWNrYm94e3RvcDowO21hcmdpbi1yaWdodDowO21hcmdpbi1sZWZ0OjhweH0uYW50LWNoZWNrYm94e2JveC1zaXppbmc6Ym9yZGVyLWJveDttYXJnaW46MDtwYWRkaW5nOjA7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtc2l6ZToxNHB4O2ZvbnQtdmFyaWFudDp0YWJ1bGFyLW51bXM7bGluZS1oZWlnaHQ6MS41NzE1O2xpc3Qtc3R5bGU6bm9uZTtmb250LWZlYXR1cmUtc2V0dGluZ3M6XCJ0bnVtXCI7cG9zaXRpb246cmVsYXRpdmU7dG9wOi4yZW07bGluZS1oZWlnaHQ6MTt3aGl0ZS1zcGFjZTpub3dyYXA7b3V0bGluZTpub25lO2N1cnNvcjpwb2ludGVyfS5hbnQtY2hlY2tib3gtaW5wdXQ6Zm9jdXMrLmFudC1jaGVja2JveC1pbm5lciwuYW50LWNoZWNrYm94LXdyYXBwZXI6aG92ZXIgLmFudC1jaGVja2JveC1pbm5lciwuYW50LWNoZWNrYm94OmhvdmVyIC5hbnQtY2hlY2tib3gtaW5uZXJ7Ym9yZGVyLWNvbG9yOiMxODkwZmZ9LmFudC1jaGVja2JveC1jaGVja2VkOmFmdGVye3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO2xlZnQ6MDt3aWR0aDoxMDAlO2hlaWdodDoxMDAlO2JvcmRlcjoxcHggc29saWQgIzE4OTBmZjtib3JkZXItcmFkaXVzOjJweDt2aXNpYmlsaXR5OmhpZGRlbjthbmltYXRpb246YW50Q2hlY2tib3hFZmZlY3QgLjM2cyBlYXNlLWluLW91dDthbmltYXRpb24tZmlsbC1tb2RlOmJhY2t3YXJkcztjb250ZW50OlwiXCJ9LmFudC1jaGVja2JveC13cmFwcGVyOmhvdmVyIC5hbnQtY2hlY2tib3g6YWZ0ZXIsLmFudC1jaGVja2JveDpob3ZlcjphZnRlcnt2aXNpYmlsaXR5OnZpc2libGV9LmFudC1jaGVja2JveC1pbm5lcntwb3NpdGlvbjpyZWxhdGl2ZTt0b3A6MDtsZWZ0OjA7ZGlzcGxheTpibG9jazt3aWR0aDoxNnB4O2hlaWdodDoxNnB4O2RpcmVjdGlvbjpsdHI7YmFja2dyb3VuZC1jb2xvcjojZmZmO2JvcmRlcjoxcHggc29saWQgI2Q5ZDlkOTtib3JkZXItcmFkaXVzOjJweDtib3JkZXItY29sbGFwc2U6c2VwYXJhdGU7dHJhbnNpdGlvbjphbGwgLjNzfS5hbnQtY2hlY2tib3gtaW5uZXI6YWZ0ZXJ7cG9zaXRpb246YWJzb2x1dGU7dG9wOjUwJTtsZWZ0OjIxLjUlO2Rpc3BsYXk6dGFibGU7d2lkdGg6NS43MTQyODU3MXB4O2hlaWdodDo5LjE0Mjg1NzE0cHg7Ym9yZGVyOjJweCBzb2xpZCAjZmZmO2JvcmRlci10b3A6MDtib3JkZXItbGVmdDowO3RyYW5zZm9ybTpyb3RhdGUoNDVkZWcpIHNjYWxlKDApIHRyYW5zbGF0ZSgtNTAlLC01MCUpO29wYWNpdHk6MDt0cmFuc2l0aW9uOmFsbCAuMXMgY3ViaWMtYmV6aWVyKC43MSwtLjQ2LC44OCwuNiksb3BhY2l0eSAuMXM7Y29udGVudDpcIiBcIn0uYW50LWNoZWNrYm94LWlucHV0e3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO3JpZ2h0OjA7Ym90dG9tOjA7bGVmdDowO3otaW5kZXg6MTt3aWR0aDoxMDAlO2hlaWdodDoxMDAlO2N1cnNvcjpwb2ludGVyO29wYWNpdHk6MH0uYW50LWNoZWNrYm94LWNoZWNrZWQgLmFudC1jaGVja2JveC1pbm5lcjphZnRlcntwb3NpdGlvbjphYnNvbHV0ZTtkaXNwbGF5OnRhYmxlO2JvcmRlcjoycHggc29saWQgI2ZmZjtib3JkZXItdG9wOjA7Ym9yZGVyLWxlZnQ6MDt0cmFuc2Zvcm06cm90YXRlKDQ1ZGVnKSBzY2FsZSgxKSB0cmFuc2xhdGUoLTUwJSwtNTAlKTtvcGFjaXR5OjE7dHJhbnNpdGlvbjphbGwgLjJzIGN1YmljLWJlemllciguMTIsLjQsLjI5LDEuNDYpIC4xcztjb250ZW50OlwiIFwifS5hbnQtY2hlY2tib3gtY2hlY2tlZCAuYW50LWNoZWNrYm94LWlubmVye2JhY2tncm91bmQtY29sb3I6IzE4OTBmZjtib3JkZXItY29sb3I6IzE4OTBmZn0uYW50LWNoZWNrYm94LWRpc2FibGVke2N1cnNvcjpub3QtYWxsb3dlZH0uYW50LWNoZWNrYm94LWRpc2FibGVkLmFudC1jaGVja2JveC1jaGVja2VkIC5hbnQtY2hlY2tib3gtaW5uZXI6YWZ0ZXJ7Ym9yZGVyLWNvbG9yOnJnYmEoMCwwLDAsLjI1KTthbmltYXRpb24tbmFtZTpub25lfS5hbnQtY2hlY2tib3gtZGlzYWJsZWQgLmFudC1jaGVja2JveC1pbnB1dHtjdXJzb3I6bm90LWFsbG93ZWQ7cG9pbnRlci1ldmVudHM6bm9uZX0uYW50LWNoZWNrYm94LWRpc2FibGVkIC5hbnQtY2hlY2tib3gtaW5uZXJ7YmFja2dyb3VuZC1jb2xvcjojZjVmNWY1O2JvcmRlci1jb2xvcjojZDlkOWQ5IWltcG9ydGFudH0uYW50LWNoZWNrYm94LWRpc2FibGVkIC5hbnQtY2hlY2tib3gtaW5uZXI6YWZ0ZXJ7Ym9yZGVyLWNvbG9yOiNmNWY1ZjU7Ym9yZGVyLWNvbGxhcHNlOnNlcGFyYXRlO2FuaW1hdGlvbi1uYW1lOm5vbmV9LmFudC1jaGVja2JveC1kaXNhYmxlZCtzcGFue2NvbG9yOnJnYmEoMCwwLDAsLjI1KTtjdXJzb3I6bm90LWFsbG93ZWR9LmFudC1jaGVja2JveC1kaXNhYmxlZDpob3ZlcjphZnRlciwuYW50LWNoZWNrYm94LXdyYXBwZXI6aG92ZXIgLmFudC1jaGVja2JveC1kaXNhYmxlZDphZnRlcnt2aXNpYmlsaXR5OmhpZGRlbn0uYW50LWNoZWNrYm94LXdyYXBwZXJ7Ym94LXNpemluZzpib3JkZXItYm94O21hcmdpbjowO3BhZGRpbmc6MDtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7Zm9udC1zaXplOjE0cHg7Zm9udC12YXJpYW50OnRhYnVsYXItbnVtcztsaW5lLWhlaWdodDoxLjU3MTU7bGlzdC1zdHlsZTpub25lO2ZvbnQtZmVhdHVyZS1zZXR0aW5nczpcInRudW1cIjtkaXNwbGF5OmlubGluZS1mbGV4O2FsaWduLWl0ZW1zOmJhc2VsaW5lO2xpbmUtaGVpZ2h0OnVuc2V0O2N1cnNvcjpwb2ludGVyfS5hbnQtY2hlY2tib3gtd3JhcHBlcjphZnRlcntkaXNwbGF5OmlubGluZS1ibG9jazt3aWR0aDowO292ZXJmbG93OmhpZGRlbjtjb250ZW50OlwiXFxhMFwifS5hbnQtY2hlY2tib3gtd3JhcHBlci5hbnQtY2hlY2tib3gtd3JhcHBlci1kaXNhYmxlZHtjdXJzb3I6bm90LWFsbG93ZWR9LmFudC1jaGVja2JveC13cmFwcGVyKy5hbnQtY2hlY2tib3gtd3JhcHBlcnttYXJnaW4tbGVmdDo4cHh9LmFudC1jaGVja2JveC13cmFwcGVyLmFudC1jaGVja2JveC13cmFwcGVyLWluLWZvcm0taXRlbSBpbnB1dFt0eXBlPWNoZWNrYm94XXt3aWR0aDoxNHB4O2hlaWdodDoxNHB4fS5hbnQtY2hlY2tib3grc3BhbntwYWRkaW5nLXJpZ2h0OjhweDtwYWRkaW5nLWxlZnQ6OHB4fS5hbnQtY2hlY2tib3gtZ3JvdXB7Ym94LXNpemluZzpib3JkZXItYm94O21hcmdpbjowO3BhZGRpbmc6MDtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7Zm9udC1zaXplOjE0cHg7Zm9udC12YXJpYW50OnRhYnVsYXItbnVtcztsaW5lLWhlaWdodDoxLjU3MTU7bGlzdC1zdHlsZTpub25lO2ZvbnQtZmVhdHVyZS1zZXR0aW5nczpcInRudW1cIjtkaXNwbGF5OmlubGluZS1ibG9ja30uYW50LWNoZWNrYm94LWdyb3VwLWl0ZW17bWFyZ2luLXJpZ2h0OjhweH0uYW50LWNoZWNrYm94LWdyb3VwLWl0ZW06bGFzdC1jaGlsZHttYXJnaW4tcmlnaHQ6MH0uYW50LWNoZWNrYm94LWdyb3VwLWl0ZW0rLmFudC1jaGVja2JveC1ncm91cC1pdGVte21hcmdpbi1sZWZ0OjB9LmFudC1jaGVja2JveC1pbmRldGVybWluYXRlIC5hbnQtY2hlY2tib3gtaW5uZXJ7YmFja2dyb3VuZC1jb2xvcjojZmZmO2JvcmRlci1jb2xvcjojZDlkOWQ5fS5hbnQtY2hlY2tib3gtaW5kZXRlcm1pbmF0ZSAuYW50LWNoZWNrYm94LWlubmVyOmFmdGVye3RvcDo1MCU7bGVmdDo1MCU7d2lkdGg6OHB4O2hlaWdodDo4cHg7YmFja2dyb3VuZC1jb2xvcjojMTg5MGZmO2JvcmRlcjowO3RyYW5zZm9ybTp0cmFuc2xhdGUoLTUwJSwtNTAlKSBzY2FsZSgxKTtvcGFjaXR5OjE7Y29udGVudDpcIiBcIn0uYW50LWNoZWNrYm94LWluZGV0ZXJtaW5hdGUuYW50LWNoZWNrYm94LWRpc2FibGVkIC5hbnQtY2hlY2tib3gtaW5uZXI6YWZ0ZXJ7YmFja2dyb3VuZC1jb2xvcjpyZ2JhKDAsMCwwLC4yNSk7Ym9yZGVyLWNvbG9yOnJnYmEoMCwwLDAsLjI1KX0uYW50LWNoZWNrYm94LXJ0bHtkaXJlY3Rpb246cnRsfS5hbnQtY2hlY2tib3gtZ3JvdXAtcnRsIC5hbnQtY2hlY2tib3gtZ3JvdXAtaXRlbXttYXJnaW4tcmlnaHQ6MDttYXJnaW4tbGVmdDo4cHh9LmFudC1jaGVja2JveC1ncm91cC1ydGwgLmFudC1jaGVja2JveC1ncm91cC1pdGVtOmxhc3QtY2hpbGR7bWFyZ2luLWxlZnQ6MCFpbXBvcnRhbnR9LmFudC1jaGVja2JveC1ncm91cC1ydGwgLmFudC1jaGVja2JveC1ncm91cC1pdGVtKy5hbnQtY2hlY2tib3gtZ3JvdXAtaXRlbXttYXJnaW4tbGVmdDo4cHh9LmFudC1jb2xsYXBzZXtib3gtc2l6aW5nOmJvcmRlci1ib3g7bWFyZ2luOjA7cGFkZGluZzowO2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtmb250LXNpemU6MTRweDtmb250LXZhcmlhbnQ6dGFidWxhci1udW1zO2xpbmUtaGVpZ2h0OjEuNTcxNTtsaXN0LXN0eWxlOm5vbmU7Zm9udC1mZWF0dXJlLXNldHRpbmdzOlwidG51bVwiO2JhY2tncm91bmQtY29sb3I6I2ZhZmFmYTtib3JkZXI6MXB4IHNvbGlkICNkOWQ5ZDk7Ym9yZGVyLWJvdHRvbTowO2JvcmRlci1yYWRpdXM6MnB4fS5hbnQtY29sbGFwc2U+LmFudC1jb2xsYXBzZS1pdGVte2JvcmRlci1ib3R0b206MXB4IHNvbGlkICNkOWQ5ZDl9LmFudC1jb2xsYXBzZT4uYW50LWNvbGxhcHNlLWl0ZW06bGFzdC1jaGlsZCwuYW50LWNvbGxhcHNlPi5hbnQtY29sbGFwc2UtaXRlbTpsYXN0LWNoaWxkPi5hbnQtY29sbGFwc2UtaGVhZGVye2JvcmRlci1yYWRpdXM6MCAwIDJweCAycHh9LmFudC1jb2xsYXBzZT4uYW50LWNvbGxhcHNlLWl0ZW0+LmFudC1jb2xsYXBzZS1oZWFkZXJ7cG9zaXRpb246cmVsYXRpdmU7ZGlzcGxheTpmbGV4O2ZsZXgtd3JhcDpub3dyYXA7YWxpZ24taXRlbXM6ZmxleC1zdGFydDtwYWRkaW5nOjEycHggMTZweDtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7bGluZS1oZWlnaHQ6MS41NzE1O2N1cnNvcjpwb2ludGVyO3RyYW5zaXRpb246YWxsIC4zcyx2aXNpYmlsaXR5IDBzfS5hbnQtY29sbGFwc2U+LmFudC1jb2xsYXBzZS1pdGVtPi5hbnQtY29sbGFwc2UtaGVhZGVyIC5hbnQtY29sbGFwc2UtYXJyb3d7ZGlzcGxheTppbmxpbmUtYmxvY2s7bWFyZ2luLXJpZ2h0OjEycHg7Zm9udC1zaXplOjEycHg7dmVydGljYWwtYWxpZ246LTFweH0uYW50LWNvbGxhcHNlPi5hbnQtY29sbGFwc2UtaXRlbT4uYW50LWNvbGxhcHNlLWhlYWRlciAuYW50LWNvbGxhcHNlLWFycm93IHN2Z3t0cmFuc2l0aW9uOnRyYW5zZm9ybSAuMjRzfS5hbnQtY29sbGFwc2U+LmFudC1jb2xsYXBzZS1pdGVtPi5hbnQtY29sbGFwc2UtaGVhZGVyIC5hbnQtY29sbGFwc2UtaGVhZGVyLXRleHR7ZmxleDphdXRvfS5hbnQtY29sbGFwc2U+LmFudC1jb2xsYXBzZS1pdGVtPi5hbnQtY29sbGFwc2UtaGVhZGVyIC5hbnQtY29sbGFwc2UtZXh0cmF7bWFyZ2luLWxlZnQ6YXV0b30uYW50LWNvbGxhcHNlPi5hbnQtY29sbGFwc2UtaXRlbT4uYW50LWNvbGxhcHNlLWhlYWRlcjpmb2N1c3tvdXRsaW5lOm5vbmV9LmFudC1jb2xsYXBzZT4uYW50LWNvbGxhcHNlLWl0ZW0gLmFudC1jb2xsYXBzZS1oZWFkZXItY29sbGFwc2libGUtb25seXtjdXJzb3I6ZGVmYXVsdH0uYW50LWNvbGxhcHNlPi5hbnQtY29sbGFwc2UtaXRlbSAuYW50LWNvbGxhcHNlLWhlYWRlci1jb2xsYXBzaWJsZS1vbmx5IC5hbnQtY29sbGFwc2UtaGVhZGVyLXRleHR7ZmxleDpub25lO2N1cnNvcjpwb2ludGVyfS5hbnQtY29sbGFwc2U+LmFudC1jb2xsYXBzZS1pdGVtIC5hbnQtY29sbGFwc2UtaWNvbi1jb2xsYXBzaWJsZS1vbmx5e2N1cnNvcjpkZWZhdWx0fS5hbnQtY29sbGFwc2U+LmFudC1jb2xsYXBzZS1pdGVtIC5hbnQtY29sbGFwc2UtaWNvbi1jb2xsYXBzaWJsZS1vbmx5IC5hbnQtY29sbGFwc2UtZXhwYW5kLWljb257Y3Vyc29yOnBvaW50ZXJ9LmFudC1jb2xsYXBzZT4uYW50LWNvbGxhcHNlLWl0ZW0uYW50LWNvbGxhcHNlLW5vLWFycm93Pi5hbnQtY29sbGFwc2UtaGVhZGVye3BhZGRpbmctbGVmdDoxMnB4fS5hbnQtY29sbGFwc2UtaWNvbi1wb3NpdGlvbi1lbmQ+LmFudC1jb2xsYXBzZS1pdGVtPi5hbnQtY29sbGFwc2UtaGVhZGVye3Bvc2l0aW9uOnJlbGF0aXZlO3BhZGRpbmc6MTJweCA0MHB4IDEycHggMTZweH0uYW50LWNvbGxhcHNlLWljb24tcG9zaXRpb24tZW5kPi5hbnQtY29sbGFwc2UtaXRlbT4uYW50LWNvbGxhcHNlLWhlYWRlciAuYW50LWNvbGxhcHNlLWFycm93e3Bvc2l0aW9uOmFic29sdXRlO3RvcDo1MCU7cmlnaHQ6MTZweDtsZWZ0OmF1dG87bWFyZ2luOjA7dHJhbnNmb3JtOnRyYW5zbGF0ZVkoLTUwJSl9LmFudC1jb2xsYXBzZS1jb250ZW50e2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtiYWNrZ3JvdW5kLWNvbG9yOiNmZmY7Ym9yZGVyLXRvcDoxcHggc29saWQgI2Q5ZDlkOX0uYW50LWNvbGxhcHNlLWNvbnRlbnQ+LmFudC1jb2xsYXBzZS1jb250ZW50LWJveHtwYWRkaW5nOjE2cHh9LmFudC1jb2xsYXBzZS1jb250ZW50LWhpZGRlbntkaXNwbGF5Om5vbmV9LmFudC1jb2xsYXBzZS1pdGVtOmxhc3QtY2hpbGQ+LmFudC1jb2xsYXBzZS1jb250ZW50e2JvcmRlci1yYWRpdXM6MCAwIDJweCAycHh9LmFudC1jb2xsYXBzZS1ib3JkZXJsZXNze2JhY2tncm91bmQtY29sb3I6I2ZhZmFmYTtib3JkZXI6MH0uYW50LWNvbGxhcHNlLWJvcmRlcmxlc3M+LmFudC1jb2xsYXBzZS1pdGVte2JvcmRlci1ib3R0b206MXB4IHNvbGlkICNkOWQ5ZDl9LmFudC1jb2xsYXBzZS1ib3JkZXJsZXNzPi5hbnQtY29sbGFwc2UtaXRlbTpsYXN0LWNoaWxkLC5hbnQtY29sbGFwc2UtYm9yZGVybGVzcz4uYW50LWNvbGxhcHNlLWl0ZW06bGFzdC1jaGlsZCAuYW50LWNvbGxhcHNlLWhlYWRlcntib3JkZXItcmFkaXVzOjB9LmFudC1jb2xsYXBzZS1ib3JkZXJsZXNzPi5hbnQtY29sbGFwc2UtaXRlbTpsYXN0LWNoaWxke2JvcmRlci1ib3R0b206MH0uYW50LWNvbGxhcHNlLWJvcmRlcmxlc3M+LmFudC1jb2xsYXBzZS1pdGVtPi5hbnQtY29sbGFwc2UtY29udGVudHtiYWNrZ3JvdW5kLWNvbG9yOnRyYW5zcGFyZW50O2JvcmRlci10b3A6MH0uYW50LWNvbGxhcHNlLWJvcmRlcmxlc3M+LmFudC1jb2xsYXBzZS1pdGVtPi5hbnQtY29sbGFwc2UtY29udGVudD4uYW50LWNvbGxhcHNlLWNvbnRlbnQtYm94e3BhZGRpbmctdG9wOjRweH0uYW50LWNvbGxhcHNlLWdob3N0e2JhY2tncm91bmQtY29sb3I6dHJhbnNwYXJlbnQ7Ym9yZGVyOjB9LmFudC1jb2xsYXBzZS1naG9zdD4uYW50LWNvbGxhcHNlLWl0ZW17Ym9yZGVyLWJvdHRvbTowfS5hbnQtY29sbGFwc2UtZ2hvc3Q+LmFudC1jb2xsYXBzZS1pdGVtPi5hbnQtY29sbGFwc2UtY29udGVudHtiYWNrZ3JvdW5kLWNvbG9yOnRyYW5zcGFyZW50O2JvcmRlci10b3A6MH0uYW50LWNvbGxhcHNlLWdob3N0Pi5hbnQtY29sbGFwc2UtaXRlbT4uYW50LWNvbGxhcHNlLWNvbnRlbnQ+LmFudC1jb2xsYXBzZS1jb250ZW50LWJveHtwYWRkaW5nLXRvcDoxMnB4O3BhZGRpbmctYm90dG9tOjEycHh9LmFudC1jb2xsYXBzZSAuYW50LWNvbGxhcHNlLWl0ZW0tZGlzYWJsZWQ+LmFudC1jb2xsYXBzZS1oZWFkZXIsLmFudC1jb2xsYXBzZSAuYW50LWNvbGxhcHNlLWl0ZW0tZGlzYWJsZWQ+LmFudC1jb2xsYXBzZS1oZWFkZXI+LmFycm93e2NvbG9yOnJnYmEoMCwwLDAsLjI1KTtjdXJzb3I6bm90LWFsbG93ZWR9LmFudC1jb2xsYXBzZS1ydGx7ZGlyZWN0aW9uOnJ0bH0uYW50LWNvbGxhcHNlLXJ0bC5hbnQtY29sbGFwc2UuYW50LWNvbGxhcHNlLWljb24tcG9zaXRpb24tZW5kPi5hbnQtY29sbGFwc2UtaXRlbT4uYW50LWNvbGxhcHNlLWhlYWRlcntwb3NpdGlvbjpyZWxhdGl2ZTtwYWRkaW5nOjEycHggMTZweCAxMnB4IDQwcHh9LmFudC1jb2xsYXBzZS1ydGwuYW50LWNvbGxhcHNlLmFudC1jb2xsYXBzZS1pY29uLXBvc2l0aW9uLWVuZD4uYW50LWNvbGxhcHNlLWl0ZW0+LmFudC1jb2xsYXBzZS1oZWFkZXIgLmFudC1jb2xsYXBzZS1hcnJvd3twb3NpdGlvbjphYnNvbHV0ZTt0b3A6NTAlO3JpZ2h0OmF1dG87bGVmdDoxNnB4O21hcmdpbjowO3RyYW5zZm9ybTp0cmFuc2xhdGVZKC01MCUpfS5hbnQtY29sbGFwc2UtcnRsIC5hbnQtY29sbGFwc2U+LmFudC1jb2xsYXBzZS1pdGVtPi5hbnQtY29sbGFwc2UtaGVhZGVye3BhZGRpbmc6MTJweCA0MHB4IDEycHggMTZweH0uYW50LWNvbGxhcHNlLXJ0bC5hbnQtY29sbGFwc2U+LmFudC1jb2xsYXBzZS1pdGVtPi5hbnQtY29sbGFwc2UtaGVhZGVyIC5hbnQtY29sbGFwc2UtYXJyb3d7bWFyZ2luLXJpZ2h0OjA7bWFyZ2luLWxlZnQ6MTJweH0uYW50LWNvbGxhcHNlLXJ0bC5hbnQtY29sbGFwc2U+LmFudC1jb2xsYXBzZS1pdGVtPi5hbnQtY29sbGFwc2UtaGVhZGVyIC5hbnQtY29sbGFwc2UtYXJyb3cgc3Zne3RyYW5zZm9ybTpyb3RhdGUoMTgwZGVnKX0uYW50LWNvbGxhcHNlLXJ0bC5hbnQtY29sbGFwc2U+LmFudC1jb2xsYXBzZS1pdGVtPi5hbnQtY29sbGFwc2UtaGVhZGVyIC5hbnQtY29sbGFwc2UtZXh0cmF7bWFyZ2luLXJpZ2h0OmF1dG87bWFyZ2luLWxlZnQ6MH0uYW50LWNvbGxhcHNlLXJ0bC5hbnQtY29sbGFwc2U+LmFudC1jb2xsYXBzZS1pdGVtLmFudC1jb2xsYXBzZS1uby1hcnJvdz4uYW50LWNvbGxhcHNlLWhlYWRlcntwYWRkaW5nLXJpZ2h0OjEycHg7cGFkZGluZy1sZWZ0OjB9LmFudC1jb21tZW50e3Bvc2l0aW9uOnJlbGF0aXZlO2JhY2tncm91bmQtY29sb3I6aW5oZXJpdH0uYW50LWNvbW1lbnQtaW5uZXJ7ZGlzcGxheTpmbGV4O3BhZGRpbmc6MTZweCAwfS5hbnQtY29tbWVudC1hdmF0YXJ7cG9zaXRpb246cmVsYXRpdmU7ZmxleC1zaHJpbms6MDttYXJnaW4tcmlnaHQ6MTJweDtjdXJzb3I6cG9pbnRlcn0uYW50LWNvbW1lbnQtYXZhdGFyIGltZ3t3aWR0aDozMnB4O2hlaWdodDozMnB4O2JvcmRlci1yYWRpdXM6NTAlfS5hbnQtY29tbWVudC1jb250ZW50e3Bvc2l0aW9uOnJlbGF0aXZlO2ZsZXg6MSAxIGF1dG87bWluLXdpZHRoOjFweDtmb250LXNpemU6MTRweDt3b3JkLXdyYXA6YnJlYWstd29yZH0uYW50LWNvbW1lbnQtY29udGVudC1hdXRob3J7ZGlzcGxheTpmbGV4O2ZsZXgtd3JhcDp3cmFwO2p1c3RpZnktY29udGVudDpmbGV4LXN0YXJ0O21hcmdpbi1ib3R0b206NHB4O2ZvbnQtc2l6ZToxNHB4fS5hbnQtY29tbWVudC1jb250ZW50LWF1dGhvcj5hLC5hbnQtY29tbWVudC1jb250ZW50LWF1dGhvcj5zcGFue3BhZGRpbmctcmlnaHQ6OHB4O2ZvbnQtc2l6ZToxMnB4O2xpbmUtaGVpZ2h0OjE4cHh9LmFudC1jb21tZW50LWNvbnRlbnQtYXV0aG9yLW5hbWV7Y29sb3I6cmdiYSgwLDAsMCwuNDUpO2ZvbnQtc2l6ZToxNHB4O3RyYW5zaXRpb246Y29sb3IgLjNzfS5hbnQtY29tbWVudC1jb250ZW50LWF1dGhvci1uYW1lPiosLmFudC1jb21tZW50LWNvbnRlbnQtYXV0aG9yLW5hbWU+OmhvdmVye2NvbG9yOnJnYmEoMCwwLDAsLjQ1KX0uYW50LWNvbW1lbnQtY29udGVudC1hdXRob3ItdGltZXtjb2xvcjojY2NjO3doaXRlLXNwYWNlOm5vd3JhcDtjdXJzb3I6YXV0b30uYW50LWNvbW1lbnQtY29udGVudC1kZXRhaWwgcHttYXJnaW4tYm90dG9tOmluaGVyaXQ7d2hpdGUtc3BhY2U6cHJlLXdyYXB9LmFudC1jb21tZW50LWFjdGlvbnN7bWFyZ2luLXRvcDoxMnB4O21hcmdpbi1ib3R0b206aW5oZXJpdDtwYWRkaW5nLWxlZnQ6MH0uYW50LWNvbW1lbnQtYWN0aW9ucz5saXtkaXNwbGF5OmlubGluZS1ibG9jaztjb2xvcjpyZ2JhKDAsMCwwLC40NSl9LmFudC1jb21tZW50LWFjdGlvbnM+bGk+c3BhbnttYXJnaW4tcmlnaHQ6MTBweDtjb2xvcjpyZ2JhKDAsMCwwLC40NSk7Zm9udC1zaXplOjEycHg7Y3Vyc29yOnBvaW50ZXI7dHJhbnNpdGlvbjpjb2xvciAuM3M7LXdlYmtpdC11c2VyLXNlbGVjdDpub25lOy1tb3otdXNlci1zZWxlY3Q6bm9uZTstbXMtdXNlci1zZWxlY3Q6bm9uZTt1c2VyLXNlbGVjdDpub25lfS5hbnQtY29tbWVudC1hY3Rpb25zPmxpPnNwYW46aG92ZXJ7Y29sb3I6IzU5NTk1OX0uYW50LWNvbW1lbnQtbmVzdGVke21hcmdpbi1sZWZ0OjQ0cHh9LmFudC1jb21tZW50LXJ0bHtkaXJlY3Rpb246cnRsfS5hbnQtY29tbWVudC1ydGwgLmFudC1jb21tZW50LWF2YXRhcnttYXJnaW4tcmlnaHQ6MDttYXJnaW4tbGVmdDoxMnB4fS5hbnQtY29tbWVudC1ydGwgLmFudC1jb21tZW50LWNvbnRlbnQtYXV0aG9yPmEsLmFudC1jb21tZW50LXJ0bCAuYW50LWNvbW1lbnQtY29udGVudC1hdXRob3I+c3BhbntwYWRkaW5nLXJpZ2h0OjA7cGFkZGluZy1sZWZ0OjhweH0uYW50LWNvbW1lbnQtcnRsIC5hbnQtY29tbWVudC1hY3Rpb25ze3BhZGRpbmctcmlnaHQ6MH0uYW50LWNvbW1lbnQtcnRsIC5hbnQtY29tbWVudC1hY3Rpb25zPmxpPnNwYW57bWFyZ2luLXJpZ2h0OjA7bWFyZ2luLWxlZnQ6MTBweH0uYW50LWNvbW1lbnQtcnRsIC5hbnQtY29tbWVudC1uZXN0ZWR7bWFyZ2luLXJpZ2h0OjQ0cHg7bWFyZ2luLWxlZnQ6MH0uYW50LXBpY2tlci1zdGF0dXMtZXJyb3IuYW50LXBpY2tlciwuYW50LXBpY2tlci1zdGF0dXMtZXJyb3IuYW50LXBpY2tlcjpub3QoW2Rpc2FibGVkXSk6aG92ZXJ7YmFja2dyb3VuZC1jb2xvcjojZmZmO2JvcmRlci1jb2xvcjojZmY0ZDRmfS5hbnQtcGlja2VyLXN0YXR1cy1lcnJvci5hbnQtcGlja2VyLWZvY3VzZWQsLmFudC1waWNrZXItc3RhdHVzLWVycm9yLmFudC1waWNrZXI6Zm9jdXN7Ym9yZGVyLWNvbG9yOiNmZjc4NzU7Ym94LXNoYWRvdzowIDAgMCAycHggcmdiYSgyNTUsNzcsNzksLjIpO2JvcmRlci1yaWdodC13aWR0aDoxcHg7b3V0bGluZTowfS5hbnQtcGlja2VyLXN0YXR1cy1lcnJvci5hbnQtcGlja2VyIC5hbnQtcGlja2VyLWFjdGl2ZS1iYXJ7YmFja2dyb3VuZDojZmY3ODc1fS5hbnQtcGlja2VyLXN0YXR1cy13YXJuaW5nLmFudC1waWNrZXIsLmFudC1waWNrZXItc3RhdHVzLXdhcm5pbmcuYW50LXBpY2tlcjpub3QoW2Rpc2FibGVkXSk6aG92ZXJ7YmFja2dyb3VuZC1jb2xvcjojZmZmO2JvcmRlci1jb2xvcjojZmFhZDE0fS5hbnQtcGlja2VyLXN0YXR1cy13YXJuaW5nLmFudC1waWNrZXItZm9jdXNlZCwuYW50LXBpY2tlci1zdGF0dXMtd2FybmluZy5hbnQtcGlja2VyOmZvY3Vze2JvcmRlci1jb2xvcjojZmZjNTNkO2JveC1zaGFkb3c6MCAwIDAgMnB4IHJnYmEoMjUwLDE3MywyMCwuMik7Ym9yZGVyLXJpZ2h0LXdpZHRoOjFweDtvdXRsaW5lOjB9LmFudC1waWNrZXItc3RhdHVzLXdhcm5pbmcuYW50LXBpY2tlciAuYW50LXBpY2tlci1hY3RpdmUtYmFye2JhY2tncm91bmQ6I2ZmYzUzZH0uYW50LXBpY2tlcntib3gtc2l6aW5nOmJvcmRlci1ib3g7bWFyZ2luOjA7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtc2l6ZToxNHB4O2ZvbnQtdmFyaWFudDp0YWJ1bGFyLW51bXM7bGluZS1oZWlnaHQ6MS41NzE1O2xpc3Qtc3R5bGU6bm9uZTtmb250LWZlYXR1cmUtc2V0dGluZ3M6XCJ0bnVtXCI7cGFkZGluZzo0cHggMTFweDtwb3NpdGlvbjpyZWxhdGl2ZTtkaXNwbGF5OmlubGluZS1mbGV4O2FsaWduLWl0ZW1zOmNlbnRlcjtiYWNrZ3JvdW5kOiNmZmY7Ym9yZGVyOjFweCBzb2xpZCAjZDlkOWQ5O2JvcmRlci1yYWRpdXM6MnB4O3RyYW5zaXRpb246Ym9yZGVyIC4zcyxib3gtc2hhZG93IC4zc30uYW50LXBpY2tlci1mb2N1c2VkLC5hbnQtcGlja2VyOmhvdmVye2JvcmRlci1jb2xvcjojNDBhOWZmO2JvcmRlci1yaWdodC13aWR0aDoxcHh9LmFudC1waWNrZXItZm9jdXNlZHtib3gtc2hhZG93OjAgMCAwIDJweCByZ2JhKDI0LDE0NCwyNTUsLjIpO291dGxpbmU6MH0uYW50LXBpY2tlci5hbnQtcGlja2VyLWRpc2FibGVke2JhY2tncm91bmQ6I2Y1ZjVmNTtib3JkZXItY29sb3I6I2Q5ZDlkOTtjdXJzb3I6bm90LWFsbG93ZWR9LmFudC1waWNrZXIuYW50LXBpY2tlci1kaXNhYmxlZCAuYW50LXBpY2tlci1zdWZmaXh7Y29sb3I6cmdiYSgwLDAsMCwuMjUpfS5hbnQtcGlja2VyLmFudC1waWNrZXItYm9yZGVybGVzc3tiYWNrZ3JvdW5kLWNvbG9yOnRyYW5zcGFyZW50IWltcG9ydGFudDtib3JkZXItY29sb3I6dHJhbnNwYXJlbnQhaW1wb3J0YW50O2JveC1zaGFkb3c6bm9uZSFpbXBvcnRhbnR9LmFudC1waWNrZXItaW5wdXR7cG9zaXRpb246cmVsYXRpdmU7ZGlzcGxheTppbmxpbmUtZmxleDthbGlnbi1pdGVtczpjZW50ZXI7d2lkdGg6MTAwJX0uYW50LXBpY2tlci1pbnB1dD5pbnB1dHtwb3NpdGlvbjpyZWxhdGl2ZTtkaXNwbGF5OmlubGluZS1ibG9jazt3aWR0aDoxMDAlO21pbi13aWR0aDowO2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtmb250LXNpemU6MTRweDtsaW5lLWhlaWdodDoxLjU3MTU7YmFja2dyb3VuZC1jb2xvcjojZmZmO2JhY2tncm91bmQtaW1hZ2U6bm9uZTtib3JkZXItcmFkaXVzOjJweDt0cmFuc2l0aW9uOmFsbCAuM3M7ZmxleDphdXRvO21pbi13aWR0aDoxcHg7aGVpZ2h0OmF1dG87cGFkZGluZzowO2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7Ym9yZGVyOjB9LmFudC1waWNrZXItaW5wdXQ+aW5wdXQ6Oi1tb3otcGxhY2Vob2xkZXJ7Y29sb3I6I2JmYmZiZjstbW96LXVzZXItc2VsZWN0Om5vbmU7dXNlci1zZWxlY3Q6bm9uZX0uYW50LXBpY2tlci1pbnB1dD5pbnB1dDotbXMtaW5wdXQtcGxhY2Vob2xkZXJ7Y29sb3I6I2JmYmZiZjstbXMtdXNlci1zZWxlY3Q6bm9uZTt1c2VyLXNlbGVjdDpub25lfS5hbnQtcGlja2VyLWlucHV0PmlucHV0OjpwbGFjZWhvbGRlcntjb2xvcjojYmZiZmJmOy13ZWJraXQtdXNlci1zZWxlY3Q6bm9uZTstbW96LXVzZXItc2VsZWN0Om5vbmU7LW1zLXVzZXItc2VsZWN0Om5vbmU7dXNlci1zZWxlY3Q6bm9uZX0uYW50LXBpY2tlci1pbnB1dD5pbnB1dDotbW96LXBsYWNlaG9sZGVyLXNob3due3RleHQtb3ZlcmZsb3c6ZWxsaXBzaXN9LmFudC1waWNrZXItaW5wdXQ+aW5wdXQ6LW1zLWlucHV0LXBsYWNlaG9sZGVye3RleHQtb3ZlcmZsb3c6ZWxsaXBzaXN9LmFudC1waWNrZXItaW5wdXQ+aW5wdXQ6cGxhY2Vob2xkZXItc2hvd257dGV4dC1vdmVyZmxvdzplbGxpcHNpc30uYW50LXBpY2tlci1pbnB1dD5pbnB1dDpob3Zlcntib3JkZXItY29sb3I6IzQwYTlmZjtib3JkZXItcmlnaHQtd2lkdGg6MXB4fS5hbnQtcGlja2VyLWlucHV0PmlucHV0LWZvY3VzZWQsLmFudC1waWNrZXItaW5wdXQ+aW5wdXQ6Zm9jdXN7Ym9yZGVyLWNvbG9yOiM0MGE5ZmY7Ym94LXNoYWRvdzowIDAgMCAycHggcmdiYSgyNCwxNDQsMjU1LC4yKTtib3JkZXItcmlnaHQtd2lkdGg6MXB4O291dGxpbmU6MH0uYW50LXBpY2tlci1pbnB1dD5pbnB1dC1kaXNhYmxlZHtjb2xvcjpyZ2JhKDAsMCwwLC4yNSk7YmFja2dyb3VuZC1jb2xvcjojZjVmNWY1O2JvcmRlci1jb2xvcjojZDlkOWQ5O2JveC1zaGFkb3c6bm9uZTtjdXJzb3I6bm90LWFsbG93ZWQ7b3BhY2l0eToxfS5hbnQtcGlja2VyLWlucHV0PmlucHV0LWRpc2FibGVkOmhvdmVye2JvcmRlci1jb2xvcjojZDlkOWQ5O2JvcmRlci1yaWdodC13aWR0aDoxcHh9LmFudC1waWNrZXItaW5wdXQ+aW5wdXRbZGlzYWJsZWRde2NvbG9yOnJnYmEoMCwwLDAsLjI1KTtiYWNrZ3JvdW5kLWNvbG9yOiNmNWY1ZjU7Ym9yZGVyLWNvbG9yOiNkOWQ5ZDk7Ym94LXNoYWRvdzpub25lO2N1cnNvcjpub3QtYWxsb3dlZDtvcGFjaXR5OjF9LmFudC1waWNrZXItaW5wdXQ+aW5wdXRbZGlzYWJsZWRdOmhvdmVye2JvcmRlci1jb2xvcjojZDlkOWQ5O2JvcmRlci1yaWdodC13aWR0aDoxcHh9LmFudC1waWNrZXItaW5wdXQ+aW5wdXQtYm9yZGVybGVzcywuYW50LXBpY2tlci1pbnB1dD5pbnB1dC1ib3JkZXJsZXNzLWRpc2FibGVkLC5hbnQtcGlja2VyLWlucHV0PmlucHV0LWJvcmRlcmxlc3MtZm9jdXNlZCwuYW50LXBpY2tlci1pbnB1dD5pbnB1dC1ib3JkZXJsZXNzOmZvY3VzLC5hbnQtcGlja2VyLWlucHV0PmlucHV0LWJvcmRlcmxlc3M6aG92ZXIsLmFudC1waWNrZXItaW5wdXQ+aW5wdXQtYm9yZGVybGVzc1tkaXNhYmxlZF17YmFja2dyb3VuZC1jb2xvcjp0cmFuc3BhcmVudDtib3JkZXI6bm9uZTtib3gtc2hhZG93Om5vbmV9dGV4dGFyZWEuYW50LXBpY2tlci1pbnB1dD5pbnB1dHttYXgtd2lkdGg6MTAwJTtoZWlnaHQ6YXV0bzttaW4taGVpZ2h0OjMycHg7bGluZS1oZWlnaHQ6MS41NzE1O3ZlcnRpY2FsLWFsaWduOmJvdHRvbTt0cmFuc2l0aW9uOmFsbCAuM3MsaGVpZ2h0IDBzfS5hbnQtcGlja2VyLWlucHV0PmlucHV0LWxne3BhZGRpbmc6Ni41cHggMTFweDtmb250LXNpemU6MTZweH0uYW50LXBpY2tlci1pbnB1dD5pbnB1dC1zbXtwYWRkaW5nOjAgN3B4fS5hbnQtcGlja2VyLWlucHV0PmlucHV0OmZvY3Vze2JveC1zaGFkb3c6bm9uZX0uYW50LXBpY2tlci1pbnB1dD5pbnB1dFtkaXNhYmxlZF17YmFja2dyb3VuZDp0cmFuc3BhcmVudH0uYW50LXBpY2tlci1pbnB1dDpob3ZlciAuYW50LXBpY2tlci1jbGVhcntvcGFjaXR5OjF9LmFudC1waWNrZXItaW5wdXQtcGxhY2Vob2xkZXI+aW5wdXR7Y29sb3I6I2JmYmZiZn0uYW50LXBpY2tlci1sYXJnZXtwYWRkaW5nOjYuNXB4IDExcHh9LmFudC1waWNrZXItbGFyZ2UgLmFudC1waWNrZXItaW5wdXQ+aW5wdXR7Zm9udC1zaXplOjE2cHh9LmFudC1waWNrZXItc21hbGx7cGFkZGluZzowIDdweH0uYW50LXBpY2tlci1zdWZmaXh7ZGlzcGxheTpmbGV4O2ZsZXg6bm9uZTthbGlnbi1zZWxmOmNlbnRlcjttYXJnaW4tbGVmdDo0cHg7Y29sb3I6cmdiYSgwLDAsMCwuMjUpO2xpbmUtaGVpZ2h0OjE7cG9pbnRlci1ldmVudHM6bm9uZX0uYW50LXBpY2tlci1zdWZmaXg+Knt2ZXJ0aWNhbC1hbGlnbjp0b3B9LmFudC1waWNrZXItc3VmZml4Pjpub3QoOmxhc3QtY2hpbGQpe21hcmdpbi1yaWdodDo4cHh9LmFudC1waWNrZXItY2xlYXJ7cG9zaXRpb246YWJzb2x1dGU7dG9wOjUwJTtyaWdodDowO2NvbG9yOnJnYmEoMCwwLDAsLjI1KTtsaW5lLWhlaWdodDoxO2JhY2tncm91bmQ6I2ZmZjt0cmFuc2Zvcm06dHJhbnNsYXRlWSgtNTAlKTtjdXJzb3I6cG9pbnRlcjtvcGFjaXR5OjA7dHJhbnNpdGlvbjpvcGFjaXR5IC4zcyxjb2xvciAuM3N9LmFudC1waWNrZXItY2xlYXI+Knt2ZXJ0aWNhbC1hbGlnbjp0b3B9LmFudC1waWNrZXItY2xlYXI6aG92ZXJ7Y29sb3I6cmdiYSgwLDAsMCwuNDUpfS5hbnQtcGlja2VyLXNlcGFyYXRvcntwb3NpdGlvbjpyZWxhdGl2ZTtkaXNwbGF5OmlubGluZS1ibG9jazt3aWR0aDoxZW07aGVpZ2h0OjE2cHg7Y29sb3I6cmdiYSgwLDAsMCwuMjUpO2ZvbnQtc2l6ZToxNnB4O3ZlcnRpY2FsLWFsaWduOnRvcDtjdXJzb3I6ZGVmYXVsdH0uYW50LXBpY2tlci1mb2N1c2VkIC5hbnQtcGlja2VyLXNlcGFyYXRvcntjb2xvcjpyZ2JhKDAsMCwwLC40NSl9LmFudC1waWNrZXItZGlzYWJsZWQgLmFudC1waWNrZXItcmFuZ2Utc2VwYXJhdG9yIC5hbnQtcGlja2VyLXNlcGFyYXRvcntjdXJzb3I6bm90LWFsbG93ZWR9LmFudC1waWNrZXItcmFuZ2V7cG9zaXRpb246cmVsYXRpdmU7ZGlzcGxheTppbmxpbmUtZmxleH0uYW50LXBpY2tlci1yYW5nZSAuYW50LXBpY2tlci1jbGVhcntyaWdodDoxMXB4fS5hbnQtcGlja2VyLXJhbmdlOmhvdmVyIC5hbnQtcGlja2VyLWNsZWFye29wYWNpdHk6MX0uYW50LXBpY2tlci1yYW5nZSAuYW50LXBpY2tlci1hY3RpdmUtYmFye2JvdHRvbTotMXB4O2hlaWdodDoycHg7bWFyZ2luLWxlZnQ6MTFweDtiYWNrZ3JvdW5kOiMxODkwZmY7b3BhY2l0eTowO3RyYW5zaXRpb246YWxsIC4zcyBlYXNlLW91dDtwb2ludGVyLWV2ZW50czpub25lfS5hbnQtcGlja2VyLXJhbmdlLmFudC1waWNrZXItZm9jdXNlZCAuYW50LXBpY2tlci1hY3RpdmUtYmFye29wYWNpdHk6MX0uYW50LXBpY2tlci1yYW5nZS1zZXBhcmF0b3J7YWxpZ24taXRlbXM6Y2VudGVyO3BhZGRpbmc6MCA4cHg7bGluZS1oZWlnaHQ6MX0uYW50LXBpY2tlci1yYW5nZS5hbnQtcGlja2VyLXNtYWxsIC5hbnQtcGlja2VyLWNsZWFye3JpZ2h0OjdweH0uYW50LXBpY2tlci1yYW5nZS5hbnQtcGlja2VyLXNtYWxsIC5hbnQtcGlja2VyLWFjdGl2ZS1iYXJ7bWFyZ2luLWxlZnQ6N3B4fS5hbnQtcGlja2VyLWRyb3Bkb3due2JveC1zaXppbmc6Ym9yZGVyLWJveDttYXJnaW46MDtwYWRkaW5nOjA7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtc2l6ZToxNHB4O2ZvbnQtdmFyaWFudDp0YWJ1bGFyLW51bXM7bGluZS1oZWlnaHQ6MS41NzE1O2xpc3Qtc3R5bGU6bm9uZTtmb250LWZlYXR1cmUtc2V0dGluZ3M6XCJ0bnVtXCI7cG9zaXRpb246YWJzb2x1dGU7dG9wOi05OTk5cHg7bGVmdDotOTk5OXB4O3otaW5kZXg6MTA1MH0uYW50LXBpY2tlci1kcm9wZG93bi1oaWRkZW57ZGlzcGxheTpub25lfS5hbnQtcGlja2VyLWRyb3Bkb3duLXBsYWNlbWVudC1ib3R0b21MZWZ0IC5hbnQtcGlja2VyLXJhbmdlLWFycm93e3RvcDoyLjU4NTYxODA4cHg7ZGlzcGxheTpibG9jazt0cmFuc2Zvcm06cm90YXRlKC0xMzVkZWcpIHRyYW5zbGF0ZVkoMXB4KX0uYW50LXBpY2tlci1kcm9wZG93bi1wbGFjZW1lbnQtdG9wTGVmdCAuYW50LXBpY2tlci1yYW5nZS1hcnJvd3tib3R0b206Mi41ODU2MTgwOHB4O2Rpc3BsYXk6YmxvY2s7dHJhbnNmb3JtOnJvdGF0ZSg0NWRlZyl9LmFudC1waWNrZXItZHJvcGRvd24uYW50LXNsaWRlLXVwLWFwcGVhci5hbnQtc2xpZGUtdXAtYXBwZWFyLWFjdGl2ZS5hbnQtcGlja2VyLWRyb3Bkb3duLXBsYWNlbWVudC10b3BMZWZ0LC5hbnQtcGlja2VyLWRyb3Bkb3duLmFudC1zbGlkZS11cC1hcHBlYXIuYW50LXNsaWRlLXVwLWFwcGVhci1hY3RpdmUuYW50LXBpY2tlci1kcm9wZG93bi1wbGFjZW1lbnQtdG9wUmlnaHQsLmFudC1waWNrZXItZHJvcGRvd24uYW50LXNsaWRlLXVwLWVudGVyLmFudC1zbGlkZS11cC1lbnRlci1hY3RpdmUuYW50LXBpY2tlci1kcm9wZG93bi1wbGFjZW1lbnQtdG9wTGVmdCwuYW50LXBpY2tlci1kcm9wZG93bi5hbnQtc2xpZGUtdXAtZW50ZXIuYW50LXNsaWRlLXVwLWVudGVyLWFjdGl2ZS5hbnQtcGlja2VyLWRyb3Bkb3duLXBsYWNlbWVudC10b3BSaWdodHthbmltYXRpb24tbmFtZTphbnRTbGlkZURvd25Jbn0uYW50LXBpY2tlci1kcm9wZG93bi5hbnQtc2xpZGUtdXAtYXBwZWFyLmFudC1zbGlkZS11cC1hcHBlYXItYWN0aXZlLmFudC1waWNrZXItZHJvcGRvd24tcGxhY2VtZW50LWJvdHRvbUxlZnQsLmFudC1waWNrZXItZHJvcGRvd24uYW50LXNsaWRlLXVwLWFwcGVhci5hbnQtc2xpZGUtdXAtYXBwZWFyLWFjdGl2ZS5hbnQtcGlja2VyLWRyb3Bkb3duLXBsYWNlbWVudC1ib3R0b21SaWdodCwuYW50LXBpY2tlci1kcm9wZG93bi5hbnQtc2xpZGUtdXAtZW50ZXIuYW50LXNsaWRlLXVwLWVudGVyLWFjdGl2ZS5hbnQtcGlja2VyLWRyb3Bkb3duLXBsYWNlbWVudC1ib3R0b21MZWZ0LC5hbnQtcGlja2VyLWRyb3Bkb3duLmFudC1zbGlkZS11cC1lbnRlci5hbnQtc2xpZGUtdXAtZW50ZXItYWN0aXZlLmFudC1waWNrZXItZHJvcGRvd24tcGxhY2VtZW50LWJvdHRvbVJpZ2h0e2FuaW1hdGlvbi1uYW1lOmFudFNsaWRlVXBJbn0uYW50LXBpY2tlci1kcm9wZG93bi5hbnQtc2xpZGUtdXAtbGVhdmUuYW50LXNsaWRlLXVwLWxlYXZlLWFjdGl2ZS5hbnQtcGlja2VyLWRyb3Bkb3duLXBsYWNlbWVudC10b3BMZWZ0LC5hbnQtcGlja2VyLWRyb3Bkb3duLmFudC1zbGlkZS11cC1sZWF2ZS5hbnQtc2xpZGUtdXAtbGVhdmUtYWN0aXZlLmFudC1waWNrZXItZHJvcGRvd24tcGxhY2VtZW50LXRvcFJpZ2h0e2FuaW1hdGlvbi1uYW1lOmFudFNsaWRlRG93bk91dH0uYW50LXBpY2tlci1kcm9wZG93bi5hbnQtc2xpZGUtdXAtbGVhdmUuYW50LXNsaWRlLXVwLWxlYXZlLWFjdGl2ZS5hbnQtcGlja2VyLWRyb3Bkb3duLXBsYWNlbWVudC1ib3R0b21MZWZ0LC5hbnQtcGlja2VyLWRyb3Bkb3duLmFudC1zbGlkZS11cC1sZWF2ZS5hbnQtc2xpZGUtdXAtbGVhdmUtYWN0aXZlLmFudC1waWNrZXItZHJvcGRvd24tcGxhY2VtZW50LWJvdHRvbVJpZ2h0e2FuaW1hdGlvbi1uYW1lOmFudFNsaWRlVXBPdXR9LmFudC1waWNrZXItZHJvcGRvd24tcmFuZ2V7cGFkZGluZzo3LjU0MjQ3MjMzcHggMH0uYW50LXBpY2tlci1kcm9wZG93bi1yYW5nZS1oaWRkZW57ZGlzcGxheTpub25lfS5hbnQtcGlja2VyLWRyb3Bkb3duIC5hbnQtcGlja2VyLXBhbmVsPi5hbnQtcGlja2VyLXRpbWUtcGFuZWx7cGFkZGluZy10b3A6NHB4fS5hbnQtcGlja2VyLXJhbmdlc3ttYXJnaW4tYm90dG9tOjA7cGFkZGluZzo0cHggMTJweDtvdmVyZmxvdzpoaWRkZW47bGluZS1oZWlnaHQ6MzRweDt0ZXh0LWFsaWduOmxlZnQ7bGlzdC1zdHlsZTpub25lfS5hbnQtcGlja2VyLXJhbmdlcz5saXtkaXNwbGF5OmlubGluZS1ibG9ja30uYW50LXBpY2tlci1yYW5nZXMgLmFudC1waWNrZXItcHJlc2V0Pi5hbnQtdGFnLWJsdWV7Y29sb3I6IzE4OTBmZjtiYWNrZ3JvdW5kOiNlNmY3ZmY7Ym9yZGVyLWNvbG9yOiM5MWQ1ZmY7Y3Vyc29yOnBvaW50ZXJ9LmFudC1waWNrZXItcmFuZ2VzIC5hbnQtcGlja2VyLW9re2Zsb2F0OnJpZ2h0O21hcmdpbi1sZWZ0OjhweH0uYW50LXBpY2tlci1yYW5nZS13cmFwcGVye2Rpc3BsYXk6ZmxleH0uYW50LXBpY2tlci1yYW5nZS1hcnJvd3twb3NpdGlvbjphYnNvbHV0ZTt6LWluZGV4OjE7ZGlzcGxheTpub25lO3dpZHRoOjExLjMxMzcwODVweDtoZWlnaHQ6MTEuMzEzNzA4NXB4O21hcmdpbi1sZWZ0OjE2LjVweDtib3gtc2hhZG93OjJweCAycHggNnB4IC0ycHggcmdiYSgwLDAsMCwuMSk7dHJhbnNpdGlvbjpsZWZ0IC4zcyBlYXNlLW91dDtib3JkZXItcmFkaXVzOjAgMCAycHg7cG9pbnRlci1ldmVudHM6bm9uZX0uYW50LXBpY2tlci1yYW5nZS1hcnJvdzpiZWZvcmV7cG9zaXRpb246YWJzb2x1dGU7dG9wOi0xMS4zMTM3MDg1cHg7bGVmdDotMTEuMzEzNzA4NXB4O3dpZHRoOjMzLjk0MTEyNTVweDtoZWlnaHQ6MzMuOTQxMTI1NXB4O2JhY2tncm91bmQ6I2ZmZjtiYWNrZ3JvdW5kLXJlcGVhdDpuby1yZXBlYXQ7YmFja2dyb3VuZC1wb3NpdGlvbjotMTBweCAtMTBweDtjb250ZW50OlwiXCI7LXdlYmtpdC1jbGlwLXBhdGg6aW5zZXQoMzMlIDMzJSk7Y2xpcC1wYXRoOmluc2V0KDMzJSAzMyUpOy13ZWJraXQtY2xpcC1wYXRoOnBhdGgoXCJNIDkuODQ5MjQyNDA0OTE3NDk5IDI0LjA5MTg4MzA5MjAzNjc4NSBBIDUgNSAwIDAgMSAxMy4zODQ3NzYzMTA4NTAyMzcgMjIuNjI3NDE2OTk3OTY5NTIyIEwgMjAuNjI3NDE2OTk3OTY5NTIyIDIyLjYyNzQxNjk5Nzk2OTUyMiBBIDIgMiAwIDAgMCAyMi42Mjc0MTY5OTc5Njk1MjIgMjAuNjI3NDE2OTk3OTY5NTIyIEwgMjIuNjI3NDE2OTk3OTY5NTIyIDEzLjM4NDc3NjMxMDg1MDIzNyBBIDUgNSAwIDAgMSAyNC4wOTE4ODMwOTIwMzY3ODUgOS44NDkyNDI0MDQ5MTc0OTkgTCAyMy4wOTE4ODMwOTIwMzY3ODUgOS44NDkyNDI0MDQ5MTc0OTkgTCA5Ljg0OTI0MjQwNDkxNzQ5OSAyMy4wOTE4ODMwOTIwMzY3ODUgWlwiKTtjbGlwLXBhdGg6cGF0aChcIk0gOS44NDkyNDI0MDQ5MTc0OTkgMjQuMDkxODgzMDkyMDM2Nzg1IEEgNSA1IDAgMCAxIDEzLjM4NDc3NjMxMDg1MDIzNyAyMi42Mjc0MTY5OTc5Njk1MjIgTCAyMC42Mjc0MTY5OTc5Njk1MjIgMjIuNjI3NDE2OTk3OTY5NTIyIEEgMiAyIDAgMCAwIDIyLjYyNzQxNjk5Nzk2OTUyMiAyMC42Mjc0MTY5OTc5Njk1MjIgTCAyMi42Mjc0MTY5OTc5Njk1MjIgMTMuMzg0Nzc2MzEwODUwMjM3IEEgNSA1IDAgMCAxIDI0LjA5MTg4MzA5MjAzNjc4NSA5Ljg0OTI0MjQwNDkxNzQ5OSBMIDIzLjA5MTg4MzA5MjAzNjc4NSA5Ljg0OTI0MjQwNDkxNzQ5OSBMIDkuODQ5MjQyNDA0OTE3NDk5IDIzLjA5MTg4MzA5MjAzNjc4NSBaXCIpfS5hbnQtcGlja2VyLXBhbmVsLWNvbnRhaW5lcntvdmVyZmxvdzpoaWRkZW47dmVydGljYWwtYWxpZ246dG9wO2JhY2tncm91bmQ6I2ZmZjtib3JkZXItcmFkaXVzOjJweDtib3gtc2hhZG93OjAgM3B4IDZweCAtNHB4IHJnYmEoMCwwLDAsLjEyKSwwIDZweCAxNnB4IDAgcmdiYSgwLDAsMCwuMDgpLDAgOXB4IDI4cHggOHB4IHJnYmEoMCwwLDAsLjA1KTt0cmFuc2l0aW9uOm1hcmdpbiAuM3N9LmFudC1waWNrZXItcGFuZWwtY29udGFpbmVyIC5hbnQtcGlja2VyLXBhbmVsc3tkaXNwbGF5OmlubGluZS1mbGV4O2ZsZXgtd3JhcDpub3dyYXA7ZGlyZWN0aW9uOmx0cn0uYW50LXBpY2tlci1wYW5lbC1jb250YWluZXIgLmFudC1waWNrZXItcGFuZWx7dmVydGljYWwtYWxpZ246dG9wO2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7Ym9yZGVyLXdpZHRoOjAgMCAxcHg7Ym9yZGVyLXJhZGl1czowfS5hbnQtcGlja2VyLXBhbmVsLWNvbnRhaW5lciAuYW50LXBpY2tlci1wYW5lbCAuYW50LXBpY2tlci1jb250ZW50LC5hbnQtcGlja2VyLXBhbmVsLWNvbnRhaW5lciAuYW50LXBpY2tlci1wYW5lbCB0YWJsZXt0ZXh0LWFsaWduOmNlbnRlcn0uYW50LXBpY2tlci1wYW5lbC1jb250YWluZXIgLmFudC1waWNrZXItcGFuZWwtZm9jdXNlZHtib3JkZXItY29sb3I6I2YwZjBmMH0uYW50LXBpY2tlci1jb21wYWN0LWl0ZW06bm90KC5hbnQtcGlja2VyLWNvbXBhY3QtbGFzdC1pdGVtKTpub3QoLmFudC1waWNrZXItY29tcGFjdC1pdGVtLXJ0bCl7bWFyZ2luLXJpZ2h0Oi0xcHh9LmFudC1waWNrZXItY29tcGFjdC1pdGVtOm5vdCguYW50LXBpY2tlci1jb21wYWN0LWxhc3QtaXRlbSkuYW50LXBpY2tlci1jb21wYWN0LWl0ZW0tcnRse21hcmdpbi1sZWZ0Oi0xcHh9LmFudC1waWNrZXItY29tcGFjdC1pdGVtLmFudC1waWNrZXItZm9jdXNlZCwuYW50LXBpY2tlci1jb21wYWN0LWl0ZW06YWN0aXZlLC5hbnQtcGlja2VyLWNvbXBhY3QtaXRlbTpmb2N1cywuYW50LXBpY2tlci1jb21wYWN0LWl0ZW06aG92ZXJ7ei1pbmRleDoyfS5hbnQtcGlja2VyLWNvbXBhY3QtaXRlbVtkaXNhYmxlZF17ei1pbmRleDowfS5hbnQtcGlja2VyLWNvbXBhY3QtaXRlbTpub3QoLmFudC1waWNrZXItY29tcGFjdC1maXJzdC1pdGVtKTpub3QoLmFudC1waWNrZXItY29tcGFjdC1sYXN0LWl0ZW0pLmFudC1waWNrZXJ7Ym9yZGVyLXJhZGl1czowfS5hbnQtcGlja2VyLWNvbXBhY3QtaXRlbS5hbnQtcGlja2VyLmFudC1waWNrZXItY29tcGFjdC1maXJzdC1pdGVtOm5vdCguYW50LXBpY2tlci1jb21wYWN0LWxhc3QtaXRlbSk6bm90KC5hbnQtcGlja2VyLWNvbXBhY3QtaXRlbS1ydGwpe2JvcmRlci10b3AtcmlnaHQtcmFkaXVzOjA7Ym9yZGVyLWJvdHRvbS1yaWdodC1yYWRpdXM6MH0uYW50LXBpY2tlci1jb21wYWN0LWl0ZW0uYW50LXBpY2tlci5hbnQtcGlja2VyLWNvbXBhY3QtaXRlbS1ydGwuYW50LXBpY2tlci1jb21wYWN0LWZpcnN0LWl0ZW06bm90KC5hbnQtcGlja2VyLWNvbXBhY3QtbGFzdC1pdGVtKSwuYW50LXBpY2tlci1jb21wYWN0LWl0ZW0uYW50LXBpY2tlci5hbnQtcGlja2VyLWNvbXBhY3QtbGFzdC1pdGVtOm5vdCguYW50LXBpY2tlci1jb21wYWN0LWZpcnN0LWl0ZW0pOm5vdCguYW50LXBpY2tlci1jb21wYWN0LWl0ZW0tcnRsKXtib3JkZXItdG9wLWxlZnQtcmFkaXVzOjA7Ym9yZGVyLWJvdHRvbS1sZWZ0LXJhZGl1czowfS5hbnQtcGlja2VyLWNvbXBhY3QtaXRlbS5hbnQtcGlja2VyLmFudC1waWNrZXItY29tcGFjdC1pdGVtLXJ0bC5hbnQtcGlja2VyLWNvbXBhY3QtbGFzdC1pdGVtOm5vdCguYW50LXBpY2tlci1jb21wYWN0LWZpcnN0LWl0ZW0pe2JvcmRlci10b3AtcmlnaHQtcmFkaXVzOjA7Ym9yZGVyLWJvdHRvbS1yaWdodC1yYWRpdXM6MH0uYW50LXBpY2tlci1wYW5lbHtkaXNwbGF5OmlubGluZS1mbGV4O2ZsZXgtZGlyZWN0aW9uOmNvbHVtbjt0ZXh0LWFsaWduOmNlbnRlcjtiYWNrZ3JvdW5kOiNmZmY7Ym9yZGVyOjFweCBzb2xpZCAjZjBmMGYwO2JvcmRlci1yYWRpdXM6MnB4O291dGxpbmU6bm9uZX0uYW50LXBpY2tlci1wYW5lbC1mb2N1c2Vke2JvcmRlci1jb2xvcjojMTg5MGZmfS5hbnQtcGlja2VyLWRhdGUtcGFuZWwsLmFudC1waWNrZXItZGVjYWRlLXBhbmVsLC5hbnQtcGlja2VyLW1vbnRoLXBhbmVsLC5hbnQtcGlja2VyLXF1YXJ0ZXItcGFuZWwsLmFudC1waWNrZXItdGltZS1wYW5lbCwuYW50LXBpY2tlci13ZWVrLXBhbmVsLC5hbnQtcGlja2VyLXllYXItcGFuZWx7ZGlzcGxheTpmbGV4O2ZsZXgtZGlyZWN0aW9uOmNvbHVtbjt3aWR0aDoyODBweH0uYW50LXBpY2tlci1oZWFkZXJ7ZGlzcGxheTpmbGV4O3BhZGRpbmc6MCA4cHg7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2JvcmRlci1ib3R0b206MXB4IHNvbGlkICNmMGYwZjB9LmFudC1waWNrZXItaGVhZGVyPip7ZmxleDpub25lfS5hbnQtcGlja2VyLWhlYWRlciBidXR0b257cGFkZGluZzowO2NvbG9yOnJnYmEoMCwwLDAsLjI1KTtsaW5lLWhlaWdodDo0MHB4O2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7Ym9yZGVyOjA7Y3Vyc29yOnBvaW50ZXI7dHJhbnNpdGlvbjpjb2xvciAuM3N9LmFudC1waWNrZXItaGVhZGVyPmJ1dHRvbnttaW4td2lkdGg6MS42ZW07Zm9udC1zaXplOjE0cHh9LmFudC1waWNrZXItaGVhZGVyPmJ1dHRvbjpob3Zlcntjb2xvcjpyZ2JhKDAsMCwwLC44NSl9LmFudC1waWNrZXItaGVhZGVyLXZpZXd7ZmxleDphdXRvO2ZvbnQtd2VpZ2h0OjUwMDtsaW5lLWhlaWdodDo0MHB4fS5hbnQtcGlja2VyLWhlYWRlci12aWV3IGJ1dHRvbntjb2xvcjppbmhlcml0O2ZvbnQtd2VpZ2h0OmluaGVyaXR9LmFudC1waWNrZXItaGVhZGVyLXZpZXcgYnV0dG9uOm5vdCg6Zmlyc3QtY2hpbGQpe21hcmdpbi1sZWZ0OjhweH0uYW50LXBpY2tlci1oZWFkZXItdmlldyBidXR0b246aG92ZXJ7Y29sb3I6IzE4OTBmZn0uYW50LXBpY2tlci1uZXh0LWljb24sLmFudC1waWNrZXItcHJldi1pY29uLC5hbnQtcGlja2VyLXN1cGVyLW5leHQtaWNvbiwuYW50LXBpY2tlci1zdXBlci1wcmV2LWljb257cG9zaXRpb246cmVsYXRpdmU7ZGlzcGxheTppbmxpbmUtYmxvY2s7d2lkdGg6N3B4O2hlaWdodDo3cHh9LmFudC1waWNrZXItbmV4dC1pY29uOmJlZm9yZSwuYW50LXBpY2tlci1wcmV2LWljb246YmVmb3JlLC5hbnQtcGlja2VyLXN1cGVyLW5leHQtaWNvbjpiZWZvcmUsLmFudC1waWNrZXItc3VwZXItcHJldi1pY29uOmJlZm9yZXtwb3NpdGlvbjphYnNvbHV0ZTt0b3A6MDtsZWZ0OjA7ZGlzcGxheTppbmxpbmUtYmxvY2s7d2lkdGg6N3B4O2hlaWdodDo3cHg7Ym9yZGVyOjAgc29saWQ7Ym9yZGVyLXdpZHRoOjEuNXB4IDAgMCAxLjVweDtjb250ZW50OlwiXCJ9LmFudC1waWNrZXItc3VwZXItbmV4dC1pY29uOmFmdGVyLC5hbnQtcGlja2VyLXN1cGVyLXByZXYtaWNvbjphZnRlcntwb3NpdGlvbjphYnNvbHV0ZTt0b3A6NHB4O2xlZnQ6NHB4O2Rpc3BsYXk6aW5saW5lLWJsb2NrO3dpZHRoOjdweDtoZWlnaHQ6N3B4O2JvcmRlcjowIHNvbGlkO2JvcmRlci13aWR0aDoxLjVweCAwIDAgMS41cHg7Y29udGVudDpcIlwifS5hbnQtcGlja2VyLXByZXYtaWNvbiwuYW50LXBpY2tlci1zdXBlci1wcmV2LWljb257dHJhbnNmb3JtOnJvdGF0ZSgtNDVkZWcpfS5hbnQtcGlja2VyLW5leHQtaWNvbiwuYW50LXBpY2tlci1zdXBlci1uZXh0LWljb257dHJhbnNmb3JtOnJvdGF0ZSgxMzVkZWcpfS5hbnQtcGlja2VyLWNvbnRlbnR7d2lkdGg6MTAwJTt0YWJsZS1sYXlvdXQ6Zml4ZWQ7Ym9yZGVyLWNvbGxhcHNlOmNvbGxhcHNlfS5hbnQtcGlja2VyLWNvbnRlbnQgdGQsLmFudC1waWNrZXItY29udGVudCB0aHtwb3NpdGlvbjpyZWxhdGl2ZTttaW4td2lkdGg6MjRweDtmb250LXdlaWdodDo0MDB9LmFudC1waWNrZXItY29udGVudCB0aHtoZWlnaHQ6MzBweDtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7bGluZS1oZWlnaHQ6MzBweH0uYW50LXBpY2tlci1jZWxse3BhZGRpbmc6M3B4IDA7Y29sb3I6cmdiYSgwLDAsMCwuMjUpO2N1cnNvcjpwb2ludGVyfS5hbnQtcGlja2VyLWNlbGwtaW4tdmlld3tjb2xvcjpyZ2JhKDAsMCwwLC44NSl9LmFudC1waWNrZXItY2VsbDpiZWZvcmV7cG9zaXRpb246YWJzb2x1dGU7dG9wOjUwJTtyaWdodDowO2xlZnQ6MDt6LWluZGV4OjE7aGVpZ2h0OjI0cHg7dHJhbnNmb3JtOnRyYW5zbGF0ZVkoLTUwJSk7dHJhbnNpdGlvbjphbGwgLjNzO2NvbnRlbnQ6XCJcIn0uYW50LXBpY2tlci1jZWxsOmhvdmVyOm5vdCguYW50LXBpY2tlci1jZWxsLWluLXZpZXcpIC5hbnQtcGlja2VyLWNlbGwtaW5uZXIsLmFudC1waWNrZXItY2VsbDpob3Zlcjpub3QoLmFudC1waWNrZXItY2VsbC1zZWxlY3RlZCk6bm90KC5hbnQtcGlja2VyLWNlbGwtcmFuZ2Utc3RhcnQpOm5vdCguYW50LXBpY2tlci1jZWxsLXJhbmdlLWVuZCk6bm90KC5hbnQtcGlja2VyLWNlbGwtcmFuZ2UtaG92ZXItc3RhcnQpOm5vdCguYW50LXBpY2tlci1jZWxsLXJhbmdlLWhvdmVyLWVuZCkgLmFudC1waWNrZXItY2VsbC1pbm5lcntiYWNrZ3JvdW5kOiNmNWY1ZjV9LmFudC1waWNrZXItY2VsbC1pbi12aWV3LmFudC1waWNrZXItY2VsbC10b2RheSAuYW50LXBpY2tlci1jZWxsLWlubmVyOmJlZm9yZXtwb3NpdGlvbjphYnNvbHV0ZTt0b3A6MDtyaWdodDowO2JvdHRvbTowO2xlZnQ6MDt6LWluZGV4OjE7Ym9yZGVyOjFweCBzb2xpZCAjMTg5MGZmO2JvcmRlci1yYWRpdXM6MnB4O2NvbnRlbnQ6XCJcIn0uYW50LXBpY2tlci1jZWxsLWluLXZpZXcuYW50LXBpY2tlci1jZWxsLWluLXJhbmdle3Bvc2l0aW9uOnJlbGF0aXZlfS5hbnQtcGlja2VyLWNlbGwtaW4tdmlldy5hbnQtcGlja2VyLWNlbGwtaW4tcmFuZ2U6YmVmb3Jle2JhY2tncm91bmQ6I2U2ZjdmZn0uYW50LXBpY2tlci1jZWxsLWluLXZpZXcuYW50LXBpY2tlci1jZWxsLXJhbmdlLWVuZCAuYW50LXBpY2tlci1jZWxsLWlubmVyLC5hbnQtcGlja2VyLWNlbGwtaW4tdmlldy5hbnQtcGlja2VyLWNlbGwtcmFuZ2Utc3RhcnQgLmFudC1waWNrZXItY2VsbC1pbm5lciwuYW50LXBpY2tlci1jZWxsLWluLXZpZXcuYW50LXBpY2tlci1jZWxsLXNlbGVjdGVkIC5hbnQtcGlja2VyLWNlbGwtaW5uZXJ7Y29sb3I6I2ZmZjtiYWNrZ3JvdW5kOiMxODkwZmZ9LmFudC1waWNrZXItY2VsbC1pbi12aWV3LmFudC1waWNrZXItY2VsbC1yYW5nZS1lbmQ6bm90KC5hbnQtcGlja2VyLWNlbGwtcmFuZ2UtZW5kLXNpbmdsZSk6YmVmb3JlLC5hbnQtcGlja2VyLWNlbGwtaW4tdmlldy5hbnQtcGlja2VyLWNlbGwtcmFuZ2Utc3RhcnQ6bm90KC5hbnQtcGlja2VyLWNlbGwtcmFuZ2Utc3RhcnQtc2luZ2xlKTpiZWZvcmV7YmFja2dyb3VuZDojZTZmN2ZmfS5hbnQtcGlja2VyLWNlbGwtaW4tdmlldy5hbnQtcGlja2VyLWNlbGwtcmFuZ2Utc3RhcnQ6YmVmb3Jle2xlZnQ6NTAlfS5hbnQtcGlja2VyLWNlbGwtaW4tdmlldy5hbnQtcGlja2VyLWNlbGwtcmFuZ2UtZW5kOmJlZm9yZXtyaWdodDo1MCV9LmFudC1waWNrZXItY2VsbC1pbi12aWV3LmFudC1waWNrZXItY2VsbC1yYW5nZS1ob3Zlci1lbmQuYW50LXBpY2tlci1jZWxsLXJhbmdlLWVuZC1zaW5nbGU6YWZ0ZXIsLmFudC1waWNrZXItY2VsbC1pbi12aWV3LmFudC1waWNrZXItY2VsbC1yYW5nZS1ob3Zlci1lbmQuYW50LXBpY2tlci1jZWxsLXJhbmdlLXN0YXJ0LmFudC1waWNrZXItY2VsbC1yYW5nZS1lbmQuYW50LXBpY2tlci1jZWxsLXJhbmdlLXN0YXJ0LW5lYXItaG92ZXI6YWZ0ZXIsLmFudC1waWNrZXItY2VsbC1pbi12aWV3LmFudC1waWNrZXItY2VsbC1yYW5nZS1ob3Zlci1lbmQ6bm90KC5hbnQtcGlja2VyLWNlbGwtaW4tcmFuZ2UpOm5vdCguYW50LXBpY2tlci1jZWxsLXJhbmdlLXN0YXJ0KTpub3QoLmFudC1waWNrZXItY2VsbC1yYW5nZS1lbmQpOmFmdGVyLC5hbnQtcGlja2VyLWNlbGwtaW4tdmlldy5hbnQtcGlja2VyLWNlbGwtcmFuZ2UtaG92ZXItc3RhcnQuYW50LXBpY2tlci1jZWxsLXJhbmdlLXN0YXJ0LXNpbmdsZTphZnRlciwuYW50LXBpY2tlci1jZWxsLWluLXZpZXcuYW50LXBpY2tlci1jZWxsLXJhbmdlLWhvdmVyLXN0YXJ0LmFudC1waWNrZXItY2VsbC1yYW5nZS1zdGFydC5hbnQtcGlja2VyLWNlbGwtcmFuZ2UtZW5kLmFudC1waWNrZXItY2VsbC1yYW5nZS1lbmQtbmVhci1ob3ZlcjphZnRlciwuYW50LXBpY2tlci1jZWxsLWluLXZpZXcuYW50LXBpY2tlci1jZWxsLXJhbmdlLWhvdmVyLXN0YXJ0Om5vdCguYW50LXBpY2tlci1jZWxsLWluLXJhbmdlKTpub3QoLmFudC1waWNrZXItY2VsbC1yYW5nZS1zdGFydCk6bm90KC5hbnQtcGlja2VyLWNlbGwtcmFuZ2UtZW5kKTphZnRlciwuYW50LXBpY2tlci1jZWxsLWluLXZpZXcuYW50LXBpY2tlci1jZWxsLXJhbmdlLWhvdmVyOm5vdCguYW50LXBpY2tlci1jZWxsLWluLXJhbmdlKTphZnRlcntwb3NpdGlvbjphYnNvbHV0ZTt0b3A6NTAlO3otaW5kZXg6MDtoZWlnaHQ6MjRweDtib3JkZXItdG9wOjFweCBkYXNoZWQgIzdlYzFmZjtib3JkZXItYm90dG9tOjFweCBkYXNoZWQgIzdlYzFmZjt0cmFuc2Zvcm06dHJhbnNsYXRlWSgtNTAlKTt0cmFuc2l0aW9uOmFsbCAuM3M7Y29udGVudDpcIlwifS5hbnQtcGlja2VyLWNlbGwtcmFuZ2UtaG92ZXItZW5kOmFmdGVyLC5hbnQtcGlja2VyLWNlbGwtcmFuZ2UtaG92ZXItc3RhcnQ6YWZ0ZXIsLmFudC1waWNrZXItY2VsbC1yYW5nZS1ob3ZlcjphZnRlcntyaWdodDowO2xlZnQ6MnB4fS5hbnQtcGlja2VyLWNlbGwtaW4tdmlldy5hbnQtcGlja2VyLWNlbGwtaW4tcmFuZ2UuYW50LXBpY2tlci1jZWxsLXJhbmdlLWhvdmVyOmJlZm9yZSwuYW50LXBpY2tlci1jZWxsLWluLXZpZXcuYW50LXBpY2tlci1jZWxsLXJhbmdlLWVuZC5hbnQtcGlja2VyLWNlbGwtcmFuZ2UtaG92ZXI6YmVmb3JlLC5hbnQtcGlja2VyLWNlbGwtaW4tdmlldy5hbnQtcGlja2VyLWNlbGwtcmFuZ2UtZW5kOm5vdCguYW50LXBpY2tlci1jZWxsLXJhbmdlLWVuZC1zaW5nbGUpLmFudC1waWNrZXItY2VsbC1yYW5nZS1ob3Zlci1lbmQ6YmVmb3JlLC5hbnQtcGlja2VyLWNlbGwtaW4tdmlldy5hbnQtcGlja2VyLWNlbGwtcmFuZ2Utc3RhcnQuYW50LXBpY2tlci1jZWxsLXJhbmdlLWhvdmVyOmJlZm9yZSwuYW50LXBpY2tlci1jZWxsLWluLXZpZXcuYW50LXBpY2tlci1jZWxsLXJhbmdlLXN0YXJ0Om5vdCguYW50LXBpY2tlci1jZWxsLXJhbmdlLXN0YXJ0LXNpbmdsZSkuYW50LXBpY2tlci1jZWxsLXJhbmdlLWhvdmVyLXN0YXJ0OmJlZm9yZSwuYW50LXBpY2tlci1wYW5lbD46bm90KC5hbnQtcGlja2VyLWRhdGUtcGFuZWwpIC5hbnQtcGlja2VyLWNlbGwtaW4tdmlldy5hbnQtcGlja2VyLWNlbGwtaW4tcmFuZ2UuYW50LXBpY2tlci1jZWxsLXJhbmdlLWhvdmVyLWVuZDpiZWZvcmUsLmFudC1waWNrZXItcGFuZWw+Om5vdCguYW50LXBpY2tlci1kYXRlLXBhbmVsKSAuYW50LXBpY2tlci1jZWxsLWluLXZpZXcuYW50LXBpY2tlci1jZWxsLWluLXJhbmdlLmFudC1waWNrZXItY2VsbC1yYW5nZS1ob3Zlci1zdGFydDpiZWZvcmV7YmFja2dyb3VuZDojY2JlNmZmfS5hbnQtcGlja2VyLWNlbGwtaW4tdmlldy5hbnQtcGlja2VyLWNlbGwtcmFuZ2Utc3RhcnQ6bm90KC5hbnQtcGlja2VyLWNlbGwtcmFuZ2Utc3RhcnQtc2luZ2xlKTpub3QoLmFudC1waWNrZXItY2VsbC1yYW5nZS1lbmQpIC5hbnQtcGlja2VyLWNlbGwtaW5uZXJ7Ym9yZGVyLXJhZGl1czoycHggMCAwIDJweH0uYW50LXBpY2tlci1jZWxsLWluLXZpZXcuYW50LXBpY2tlci1jZWxsLXJhbmdlLWVuZDpub3QoLmFudC1waWNrZXItY2VsbC1yYW5nZS1lbmQtc2luZ2xlKTpub3QoLmFudC1waWNrZXItY2VsbC1yYW5nZS1zdGFydCkgLmFudC1waWNrZXItY2VsbC1pbm5lcntib3JkZXItcmFkaXVzOjAgMnB4IDJweCAwfS5hbnQtcGlja2VyLWRhdGUtcGFuZWwgLmFudC1waWNrZXItY2VsbC1pbi12aWV3LmFudC1waWNrZXItY2VsbC1pbi1yYW5nZS5hbnQtcGlja2VyLWNlbGwtcmFuZ2UtaG92ZXItZW5kIC5hbnQtcGlja2VyLWNlbGwtaW5uZXI6YWZ0ZXIsLmFudC1waWNrZXItZGF0ZS1wYW5lbCAuYW50LXBpY2tlci1jZWxsLWluLXZpZXcuYW50LXBpY2tlci1jZWxsLWluLXJhbmdlLmFudC1waWNrZXItY2VsbC1yYW5nZS1ob3Zlci1zdGFydCAuYW50LXBpY2tlci1jZWxsLWlubmVyOmFmdGVye3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO2JvdHRvbTowO3otaW5kZXg6LTE7YmFja2dyb3VuZDojY2JlNmZmO3RyYW5zaXRpb246YWxsIC4zcztjb250ZW50OlwiXCJ9LmFudC1waWNrZXItZGF0ZS1wYW5lbCAuYW50LXBpY2tlci1jZWxsLWluLXZpZXcuYW50LXBpY2tlci1jZWxsLWluLXJhbmdlLmFudC1waWNrZXItY2VsbC1yYW5nZS1ob3Zlci1zdGFydCAuYW50LXBpY2tlci1jZWxsLWlubmVyOmFmdGVye3JpZ2h0Oi02cHg7bGVmdDowfS5hbnQtcGlja2VyLWRhdGUtcGFuZWwgLmFudC1waWNrZXItY2VsbC1pbi12aWV3LmFudC1waWNrZXItY2VsbC1pbi1yYW5nZS5hbnQtcGlja2VyLWNlbGwtcmFuZ2UtaG92ZXItZW5kIC5hbnQtcGlja2VyLWNlbGwtaW5uZXI6YWZ0ZXJ7cmlnaHQ6MDtsZWZ0Oi02cHh9LmFudC1waWNrZXItY2VsbC1yYW5nZS1ob3Zlci5hbnQtcGlja2VyLWNlbGwtcmFuZ2Utc3RhcnQ6YWZ0ZXJ7cmlnaHQ6NTAlfS5hbnQtcGlja2VyLWNlbGwtcmFuZ2UtaG92ZXIuYW50LXBpY2tlci1jZWxsLXJhbmdlLWVuZDphZnRlcntsZWZ0OjUwJX0uYW50LXBpY2tlci1jZWxsLWluLXZpZXcuYW50LXBpY2tlci1jZWxsLXJhbmdlLWhvdmVyLWVkZ2Utc3RhcnQ6bm90KC5hbnQtcGlja2VyLWNlbGwtcmFuZ2UtaG92ZXItZWRnZS1zdGFydC1uZWFyLXJhbmdlKTphZnRlciwuYW50LXBpY2tlci1jZWxsLWluLXZpZXcuYW50LXBpY2tlci1jZWxsLXJhbmdlLWhvdmVyLXN0YXJ0OmFmdGVyLC5hbnQtcGlja2VyLWNlbGwtaW4tdmlldy5hbnQtcGlja2VyLWNlbGwtc3RhcnQuYW50LXBpY2tlci1jZWxsLXJhbmdlLWhvdmVyLWVkZ2Utc3RhcnQuYW50LXBpY2tlci1jZWxsLXJhbmdlLWhvdmVyLWVkZ2Utc3RhcnQtbmVhci1yYW5nZTphZnRlcix0cj4uYW50LXBpY2tlci1jZWxsLWluLXZpZXcuYW50LXBpY2tlci1jZWxsLXJhbmdlLWhvdmVyLWVuZDpmaXJzdC1jaGlsZDphZnRlcix0cj4uYW50LXBpY2tlci1jZWxsLWluLXZpZXcuYW50LXBpY2tlci1jZWxsLXJhbmdlLWhvdmVyOmZpcnN0LWNoaWxkOmFmdGVye2xlZnQ6NnB4O2JvcmRlci1sZWZ0OjFweCBkYXNoZWQgIzdlYzFmZjtib3JkZXItdG9wLWxlZnQtcmFkaXVzOjJweDtib3JkZXItYm90dG9tLWxlZnQtcmFkaXVzOjJweH0uYW50LXBpY2tlci1jZWxsLWluLXZpZXcuYW50LXBpY2tlci1jZWxsLWVuZC5hbnQtcGlja2VyLWNlbGwtcmFuZ2UtaG92ZXItZWRnZS1lbmQuYW50LXBpY2tlci1jZWxsLXJhbmdlLWhvdmVyLWVkZ2UtZW5kLW5lYXItcmFuZ2U6YWZ0ZXIsLmFudC1waWNrZXItY2VsbC1pbi12aWV3LmFudC1waWNrZXItY2VsbC1yYW5nZS1ob3Zlci1lZGdlLWVuZDpub3QoLmFudC1waWNrZXItY2VsbC1yYW5nZS1ob3Zlci1lZGdlLWVuZC1uZWFyLXJhbmdlKTphZnRlciwuYW50LXBpY2tlci1jZWxsLWluLXZpZXcuYW50LXBpY2tlci1jZWxsLXJhbmdlLWhvdmVyLWVuZDphZnRlcix0cj4uYW50LXBpY2tlci1jZWxsLWluLXZpZXcuYW50LXBpY2tlci1jZWxsLXJhbmdlLWhvdmVyLXN0YXJ0Omxhc3QtY2hpbGQ6YWZ0ZXIsdHI+LmFudC1waWNrZXItY2VsbC1pbi12aWV3LmFudC1waWNrZXItY2VsbC1yYW5nZS1ob3ZlcjpsYXN0LWNoaWxkOmFmdGVye3JpZ2h0OjZweDtib3JkZXItcmlnaHQ6MXB4IGRhc2hlZCAjN2VjMWZmO2JvcmRlci10b3AtcmlnaHQtcmFkaXVzOjJweDtib3JkZXItYm90dG9tLXJpZ2h0LXJhZGl1czoycHh9LmFudC1waWNrZXItY2VsbC1kaXNhYmxlZHtjb2xvcjpyZ2JhKDAsMCwwLC4yNSk7cG9pbnRlci1ldmVudHM6bm9uZX0uYW50LXBpY2tlci1jZWxsLWRpc2FibGVkIC5hbnQtcGlja2VyLWNlbGwtaW5uZXJ7YmFja2dyb3VuZDp0cmFuc3BhcmVudH0uYW50LXBpY2tlci1jZWxsLWRpc2FibGVkOmJlZm9yZXtiYWNrZ3JvdW5kOnJnYmEoMCwwLDAsLjA0KX0uYW50LXBpY2tlci1jZWxsLWRpc2FibGVkLmFudC1waWNrZXItY2VsbC10b2RheSAuYW50LXBpY2tlci1jZWxsLWlubmVyOmJlZm9yZXtib3JkZXItY29sb3I6cmdiYSgwLDAsMCwuMjUpfS5hbnQtcGlja2VyLWRlY2FkZS1wYW5lbCAuYW50LXBpY2tlci1jb250ZW50LC5hbnQtcGlja2VyLW1vbnRoLXBhbmVsIC5hbnQtcGlja2VyLWNvbnRlbnQsLmFudC1waWNrZXItcXVhcnRlci1wYW5lbCAuYW50LXBpY2tlci1jb250ZW50LC5hbnQtcGlja2VyLXllYXItcGFuZWwgLmFudC1waWNrZXItY29udGVudHtoZWlnaHQ6MjY0cHh9LmFudC1waWNrZXItZGVjYWRlLXBhbmVsIC5hbnQtcGlja2VyLWNlbGwtaW5uZXIsLmFudC1waWNrZXItbW9udGgtcGFuZWwgLmFudC1waWNrZXItY2VsbC1pbm5lciwuYW50LXBpY2tlci1xdWFydGVyLXBhbmVsIC5hbnQtcGlja2VyLWNlbGwtaW5uZXIsLmFudC1waWNrZXIteWVhci1wYW5lbCAuYW50LXBpY2tlci1jZWxsLWlubmVye3BhZGRpbmc6MCA4cHh9LmFudC1waWNrZXItcXVhcnRlci1wYW5lbCAuYW50LXBpY2tlci1jb250ZW50e2hlaWdodDo1NnB4fS5hbnQtcGlja2VyLWZvb3Rlcnt3aWR0aDotbW96LW1pbi1jb250ZW50O3dpZHRoOm1pbi1jb250ZW50O21pbi13aWR0aDoxMDAlO2xpbmUtaGVpZ2h0OjM4cHg7dGV4dC1hbGlnbjpjZW50ZXI7Ym9yZGVyLWJvdHRvbToxcHggc29saWQgdHJhbnNwYXJlbnR9LmFudC1waWNrZXItcGFuZWwgLmFudC1waWNrZXItZm9vdGVye2JvcmRlci10b3A6MXB4IHNvbGlkICNmMGYwZjB9LmFudC1waWNrZXItZm9vdGVyLWV4dHJhe3BhZGRpbmc6MCAxMnB4O2xpbmUtaGVpZ2h0OjM4cHg7dGV4dC1hbGlnbjpsZWZ0fS5hbnQtcGlja2VyLWZvb3Rlci1leHRyYTpub3QoOmxhc3QtY2hpbGQpe2JvcmRlci1ib3R0b206MXB4IHNvbGlkICNmMGYwZjB9LmFudC1waWNrZXItbm93e3RleHQtYWxpZ246bGVmdH0uYW50LXBpY2tlci10b2RheS1idG57Y29sb3I6IzE4OTBmZn0uYW50LXBpY2tlci10b2RheS1idG46aG92ZXJ7Y29sb3I6IzQwYTlmZn0uYW50LXBpY2tlci10b2RheS1idG46YWN0aXZle2NvbG9yOiMwOTZkZDl9LmFudC1waWNrZXItdG9kYXktYnRuLmFudC1waWNrZXItdG9kYXktYnRuLWRpc2FibGVke2NvbG9yOnJnYmEoMCwwLDAsLjI1KTtjdXJzb3I6bm90LWFsbG93ZWR9LmFudC1waWNrZXItZGVjYWRlLXBhbmVsIC5hbnQtcGlja2VyLWNlbGwtaW5uZXJ7cGFkZGluZzowIDRweH0uYW50LXBpY2tlci1kZWNhZGUtcGFuZWwgLmFudC1waWNrZXItY2VsbDpiZWZvcmV7ZGlzcGxheTpub25lfS5hbnQtcGlja2VyLW1vbnRoLXBhbmVsIC5hbnQtcGlja2VyLWJvZHksLmFudC1waWNrZXItcXVhcnRlci1wYW5lbCAuYW50LXBpY2tlci1ib2R5LC5hbnQtcGlja2VyLXllYXItcGFuZWwgLmFudC1waWNrZXItYm9keXtwYWRkaW5nOjAgOHB4fS5hbnQtcGlja2VyLW1vbnRoLXBhbmVsIC5hbnQtcGlja2VyLWNlbGwtaW5uZXIsLmFudC1waWNrZXItcXVhcnRlci1wYW5lbCAuYW50LXBpY2tlci1jZWxsLWlubmVyLC5hbnQtcGlja2VyLXllYXItcGFuZWwgLmFudC1waWNrZXItY2VsbC1pbm5lcnt3aWR0aDo2MHB4fS5hbnQtcGlja2VyLW1vbnRoLXBhbmVsIC5hbnQtcGlja2VyLWNlbGwtcmFuZ2UtaG92ZXItc3RhcnQ6YWZ0ZXIsLmFudC1waWNrZXItcXVhcnRlci1wYW5lbCAuYW50LXBpY2tlci1jZWxsLXJhbmdlLWhvdmVyLXN0YXJ0OmFmdGVyLC5hbnQtcGlja2VyLXllYXItcGFuZWwgLmFudC1waWNrZXItY2VsbC1yYW5nZS1ob3Zlci1zdGFydDphZnRlcntsZWZ0OjE0cHg7Ym9yZGVyLWxlZnQ6MXB4IGRhc2hlZCAjN2VjMWZmO2JvcmRlci1yYWRpdXM6MnB4IDAgMCAycHh9LmFudC1waWNrZXItbW9udGgtcGFuZWwgLmFudC1waWNrZXItY2VsbC1yYW5nZS1ob3Zlci1lbmQ6YWZ0ZXIsLmFudC1waWNrZXItcGFuZWwtcnRsIC5hbnQtcGlja2VyLW1vbnRoLXBhbmVsIC5hbnQtcGlja2VyLWNlbGwtcmFuZ2UtaG92ZXItc3RhcnQ6YWZ0ZXIsLmFudC1waWNrZXItcGFuZWwtcnRsIC5hbnQtcGlja2VyLXF1YXJ0ZXItcGFuZWwgLmFudC1waWNrZXItY2VsbC1yYW5nZS1ob3Zlci1zdGFydDphZnRlciwuYW50LXBpY2tlci1wYW5lbC1ydGwgLmFudC1waWNrZXIteWVhci1wYW5lbCAuYW50LXBpY2tlci1jZWxsLXJhbmdlLWhvdmVyLXN0YXJ0OmFmdGVyLC5hbnQtcGlja2VyLXF1YXJ0ZXItcGFuZWwgLmFudC1waWNrZXItY2VsbC1yYW5nZS1ob3Zlci1lbmQ6YWZ0ZXIsLmFudC1waWNrZXIteWVhci1wYW5lbCAuYW50LXBpY2tlci1jZWxsLXJhbmdlLWhvdmVyLWVuZDphZnRlcntyaWdodDoxNHB4O2JvcmRlci1yaWdodDoxcHggZGFzaGVkICM3ZWMxZmY7Ym9yZGVyLXJhZGl1czowIDJweCAycHggMH0uYW50LXBpY2tlci1wYW5lbC1ydGwgLmFudC1waWNrZXItbW9udGgtcGFuZWwgLmFudC1waWNrZXItY2VsbC1yYW5nZS1ob3Zlci1lbmQ6YWZ0ZXIsLmFudC1waWNrZXItcGFuZWwtcnRsIC5hbnQtcGlja2VyLXF1YXJ0ZXItcGFuZWwgLmFudC1waWNrZXItY2VsbC1yYW5nZS1ob3Zlci1lbmQ6YWZ0ZXIsLmFudC1waWNrZXItcGFuZWwtcnRsIC5hbnQtcGlja2VyLXllYXItcGFuZWwgLmFudC1waWNrZXItY2VsbC1yYW5nZS1ob3Zlci1lbmQ6YWZ0ZXJ7bGVmdDoxNHB4O2JvcmRlci1sZWZ0OjFweCBkYXNoZWQgIzdlYzFmZjtib3JkZXItcmFkaXVzOjJweCAwIDAgMnB4fS5hbnQtcGlja2VyLXdlZWstcGFuZWwgLmFudC1waWNrZXItYm9keXtwYWRkaW5nOjhweCAxMnB4fS5hbnQtcGlja2VyLXdlZWstcGFuZWwgLmFudC1waWNrZXItY2VsbC1zZWxlY3RlZCAuYW50LXBpY2tlci1jZWxsLWlubmVyLC5hbnQtcGlja2VyLXdlZWstcGFuZWwgLmFudC1waWNrZXItY2VsbCAuYW50LXBpY2tlci1jZWxsLWlubmVyLC5hbnQtcGlja2VyLXdlZWstcGFuZWwgLmFudC1waWNrZXItY2VsbDpob3ZlciAuYW50LXBpY2tlci1jZWxsLWlubmVye2JhY2tncm91bmQ6dHJhbnNwYXJlbnQhaW1wb3J0YW50fS5hbnQtcGlja2VyLXdlZWstcGFuZWwtcm93IHRke3RyYW5zaXRpb246YmFja2dyb3VuZCAuM3N9LmFudC1waWNrZXItd2Vlay1wYW5lbC1yb3c6aG92ZXIgdGR7YmFja2dyb3VuZDojZjVmNWY1fS5hbnQtcGlja2VyLXdlZWstcGFuZWwtcm93LXNlbGVjdGVkOmhvdmVyIHRkLC5hbnQtcGlja2VyLXdlZWstcGFuZWwtcm93LXNlbGVjdGVkIHRke2JhY2tncm91bmQ6IzE4OTBmZn0uYW50LXBpY2tlci13ZWVrLXBhbmVsLXJvdy1zZWxlY3RlZDpob3ZlciB0ZC5hbnQtcGlja2VyLWNlbGwtd2VlaywuYW50LXBpY2tlci13ZWVrLXBhbmVsLXJvdy1zZWxlY3RlZCB0ZC5hbnQtcGlja2VyLWNlbGwtd2Vla3tjb2xvcjpoc2xhKDAsMCUsMTAwJSwuNSl9LmFudC1waWNrZXItd2Vlay1wYW5lbC1yb3ctc2VsZWN0ZWQ6aG92ZXIgdGQuYW50LXBpY2tlci1jZWxsLXRvZGF5IC5hbnQtcGlja2VyLWNlbGwtaW5uZXI6YmVmb3JlLC5hbnQtcGlja2VyLXdlZWstcGFuZWwtcm93LXNlbGVjdGVkIHRkLmFudC1waWNrZXItY2VsbC10b2RheSAuYW50LXBpY2tlci1jZWxsLWlubmVyOmJlZm9yZXtib3JkZXItY29sb3I6I2ZmZn0uYW50LXBpY2tlci13ZWVrLXBhbmVsLXJvdy1zZWxlY3RlZDpob3ZlciB0ZCAuYW50LXBpY2tlci1jZWxsLWlubmVyLC5hbnQtcGlja2VyLXdlZWstcGFuZWwtcm93LXNlbGVjdGVkIHRkIC5hbnQtcGlja2VyLWNlbGwtaW5uZXJ7Y29sb3I6I2ZmZn0uYW50LXBpY2tlci1kYXRlLXBhbmVsIC5hbnQtcGlja2VyLWJvZHl7cGFkZGluZzo4cHggMTJweH0uYW50LXBpY2tlci1kYXRlLXBhbmVsIC5hbnQtcGlja2VyLWNvbnRlbnR7d2lkdGg6MjUycHh9LmFudC1waWNrZXItZGF0ZS1wYW5lbCAuYW50LXBpY2tlci1jb250ZW50IHRoe3dpZHRoOjM2cHh9LmFudC1waWNrZXItZGF0ZXRpbWUtcGFuZWx7ZGlzcGxheTpmbGV4fS5hbnQtcGlja2VyLWRhdGV0aW1lLXBhbmVsIC5hbnQtcGlja2VyLXRpbWUtcGFuZWx7Ym9yZGVyLWxlZnQ6MXB4IHNvbGlkICNmMGYwZjB9LmFudC1waWNrZXItZGF0ZXRpbWUtcGFuZWwgLmFudC1waWNrZXItZGF0ZS1wYW5lbCwuYW50LXBpY2tlci1kYXRldGltZS1wYW5lbCAuYW50LXBpY2tlci10aW1lLXBhbmVse3RyYW5zaXRpb246b3BhY2l0eSAuM3N9LmFudC1waWNrZXItZGF0ZXRpbWUtcGFuZWwtYWN0aXZlIC5hbnQtcGlja2VyLWRhdGUtcGFuZWwsLmFudC1waWNrZXItZGF0ZXRpbWUtcGFuZWwtYWN0aXZlIC5hbnQtcGlja2VyLXRpbWUtcGFuZWx7b3BhY2l0eTouM30uYW50LXBpY2tlci1kYXRldGltZS1wYW5lbC1hY3RpdmUgLmFudC1waWNrZXItZGF0ZS1wYW5lbC1hY3RpdmUsLmFudC1waWNrZXItZGF0ZXRpbWUtcGFuZWwtYWN0aXZlIC5hbnQtcGlja2VyLXRpbWUtcGFuZWwtYWN0aXZle29wYWNpdHk6MX0uYW50LXBpY2tlci10aW1lLXBhbmVse3dpZHRoOmF1dG87bWluLXdpZHRoOmF1dG99LmFudC1waWNrZXItdGltZS1wYW5lbCAuYW50LXBpY2tlci1jb250ZW50e2Rpc3BsYXk6ZmxleDtmbGV4OmF1dG87aGVpZ2h0OjIyNHB4fS5hbnQtcGlja2VyLXRpbWUtcGFuZWwtY29sdW1ue2ZsZXg6MSAwIGF1dG87d2lkdGg6NTZweDttYXJnaW46MDtwYWRkaW5nOjA7b3ZlcmZsb3cteTpoaWRkZW47dGV4dC1hbGlnbjpsZWZ0O2xpc3Qtc3R5bGU6bm9uZTt0cmFuc2l0aW9uOmJhY2tncm91bmQgLjNzfS5hbnQtcGlja2VyLXRpbWUtcGFuZWwtY29sdW1uOmFmdGVye2Rpc3BsYXk6YmxvY2s7aGVpZ2h0OjE5NnB4O2NvbnRlbnQ6XCJcIn0uYW50LXBpY2tlci1kYXRldGltZS1wYW5lbCAuYW50LXBpY2tlci10aW1lLXBhbmVsLWNvbHVtbjphZnRlcntoZWlnaHQ6MTk4cHh9LmFudC1waWNrZXItdGltZS1wYW5lbC1jb2x1bW46bm90KDpmaXJzdC1jaGlsZCl7Ym9yZGVyLWxlZnQ6MXB4IHNvbGlkICNmMGYwZjB9LmFudC1waWNrZXItdGltZS1wYW5lbC1jb2x1bW4tYWN0aXZle2JhY2tncm91bmQ6cmdiYSgyMzAsMjQ3LDI1NSwuMil9LmFudC1waWNrZXItdGltZS1wYW5lbC1jb2x1bW46aG92ZXJ7b3ZlcmZsb3cteTphdXRvfS5hbnQtcGlja2VyLXRpbWUtcGFuZWwtY29sdW1uPmxpe21hcmdpbjowO3BhZGRpbmc6MH0uYW50LXBpY2tlci10aW1lLXBhbmVsLWNvbHVtbj5saS5hbnQtcGlja2VyLXRpbWUtcGFuZWwtY2VsbCAuYW50LXBpY2tlci10aW1lLXBhbmVsLWNlbGwtaW5uZXJ7ZGlzcGxheTpibG9jazt3aWR0aDoxMDAlO2hlaWdodDoyOHB4O21hcmdpbjowO3BhZGRpbmc6MCAwIDAgMTRweDtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7bGluZS1oZWlnaHQ6MjhweDtib3JkZXItcmFkaXVzOjA7Y3Vyc29yOnBvaW50ZXI7dHJhbnNpdGlvbjpiYWNrZ3JvdW5kIC4zc30uYW50LXBpY2tlci10aW1lLXBhbmVsLWNvbHVtbj5saS5hbnQtcGlja2VyLXRpbWUtcGFuZWwtY2VsbCAuYW50LXBpY2tlci10aW1lLXBhbmVsLWNlbGwtaW5uZXI6aG92ZXJ7YmFja2dyb3VuZDojZjVmNWY1fS5hbnQtcGlja2VyLXRpbWUtcGFuZWwtY29sdW1uPmxpLmFudC1waWNrZXItdGltZS1wYW5lbC1jZWxsLXNlbGVjdGVkIC5hbnQtcGlja2VyLXRpbWUtcGFuZWwtY2VsbC1pbm5lcntiYWNrZ3JvdW5kOiNlNmY3ZmZ9LmFudC1waWNrZXItdGltZS1wYW5lbC1jb2x1bW4+bGkuYW50LXBpY2tlci10aW1lLXBhbmVsLWNlbGwtZGlzYWJsZWQgLmFudC1waWNrZXItdGltZS1wYW5lbC1jZWxsLWlubmVye2NvbG9yOnJnYmEoMCwwLDAsLjI1KTtiYWNrZ3JvdW5kOnRyYW5zcGFyZW50O2N1cnNvcjpub3QtYWxsb3dlZH06cm9vdCAuYW50LXBpY2tlci1yYW5nZS13cmFwcGVyIC5hbnQtcGlja2VyLW1vbnRoLXBhbmVsIC5hbnQtcGlja2VyLWNlbGwsOnJvb3QgLmFudC1waWNrZXItcmFuZ2Utd3JhcHBlciAuYW50LXBpY2tlci15ZWFyLXBhbmVsIC5hbnQtcGlja2VyLWNlbGwsXzotbXMtZnVsbHNjcmVlbiAuYW50LXBpY2tlci1yYW5nZS13cmFwcGVyIC5hbnQtcGlja2VyLW1vbnRoLXBhbmVsIC5hbnQtcGlja2VyLWNlbGwsXzotbXMtZnVsbHNjcmVlbiAuYW50LXBpY2tlci1yYW5nZS13cmFwcGVyIC5hbnQtcGlja2VyLXllYXItcGFuZWwgLmFudC1waWNrZXItY2VsbHtwYWRkaW5nOjIxcHggMH0uYW50LXBpY2tlci1ydGx7ZGlyZWN0aW9uOnJ0bH0uYW50LXBpY2tlci1ydGwgLmFudC1waWNrZXItc3VmZml4e21hcmdpbi1yaWdodDo0cHg7bWFyZ2luLWxlZnQ6MH0uYW50LXBpY2tlci1ydGwgLmFudC1waWNrZXItY2xlYXJ7cmlnaHQ6YXV0bztsZWZ0OjB9LmFudC1waWNrZXItcnRsIC5hbnQtcGlja2VyLXNlcGFyYXRvcnt0cmFuc2Zvcm06cm90YXRlKDE4MGRlZyl9LmFudC1waWNrZXItcGFuZWwtcnRsIC5hbnQtcGlja2VyLWhlYWRlci12aWV3IGJ1dHRvbjpub3QoOmZpcnN0LWNoaWxkKXttYXJnaW4tcmlnaHQ6OHB4O21hcmdpbi1sZWZ0OjB9LmFudC1waWNrZXItcnRsLmFudC1waWNrZXItcmFuZ2UgLmFudC1waWNrZXItY2xlYXJ7cmlnaHQ6YXV0bztsZWZ0OjExcHh9LmFudC1waWNrZXItcnRsLmFudC1waWNrZXItcmFuZ2UgLmFudC1waWNrZXItYWN0aXZlLWJhcnttYXJnaW4tcmlnaHQ6MTFweDttYXJnaW4tbGVmdDowfS5hbnQtcGlja2VyLXJ0bC5hbnQtcGlja2VyLXJhbmdlLmFudC1waWNrZXItc21hbGwgLmFudC1waWNrZXItYWN0aXZlLWJhcnttYXJnaW4tcmlnaHQ6N3B4fS5hbnQtcGlja2VyLWRyb3Bkb3duLXJ0bCAuYW50LXBpY2tlci1yYW5nZXN7dGV4dC1hbGlnbjpyaWdodH0uYW50LXBpY2tlci1kcm9wZG93bi1ydGwgLmFudC1waWNrZXItcmFuZ2VzIC5hbnQtcGlja2VyLW9re2Zsb2F0OmxlZnQ7bWFyZ2luLXJpZ2h0OjhweDttYXJnaW4tbGVmdDowfS5hbnQtcGlja2VyLXBhbmVsLXJ0bHtkaXJlY3Rpb246cnRsfS5hbnQtcGlja2VyLXBhbmVsLXJ0bCAuYW50LXBpY2tlci1wcmV2LWljb24sLmFudC1waWNrZXItcGFuZWwtcnRsIC5hbnQtcGlja2VyLXN1cGVyLXByZXYtaWNvbnt0cmFuc2Zvcm06cm90YXRlKDEzNWRlZyl9LmFudC1waWNrZXItcGFuZWwtcnRsIC5hbnQtcGlja2VyLW5leHQtaWNvbiwuYW50LXBpY2tlci1wYW5lbC1ydGwgLmFudC1waWNrZXItc3VwZXItbmV4dC1pY29ue3RyYW5zZm9ybTpyb3RhdGUoLTQ1ZGVnKX0uYW50LXBpY2tlci1jZWxsIC5hbnQtcGlja2VyLWNlbGwtaW5uZXJ7cG9zaXRpb246cmVsYXRpdmU7ei1pbmRleDoyO2Rpc3BsYXk6aW5saW5lLWJsb2NrO21pbi13aWR0aDoyNHB4O2hlaWdodDoyNHB4O2xpbmUtaGVpZ2h0OjI0cHg7Ym9yZGVyLXJhZGl1czoycHg7dHJhbnNpdGlvbjpiYWNrZ3JvdW5kIC4zcyxib3JkZXIgLjNzfS5hbnQtcGlja2VyLXBhbmVsLXJ0bCAuYW50LXBpY2tlci1jZWxsLWluLXZpZXcuYW50LXBpY2tlci1jZWxsLXJhbmdlLXN0YXJ0OmJlZm9yZXtyaWdodDo1MCU7bGVmdDowfS5hbnQtcGlja2VyLXBhbmVsLXJ0bCAuYW50LXBpY2tlci1jZWxsLWluLXZpZXcuYW50LXBpY2tlci1jZWxsLXJhbmdlLWVuZDpiZWZvcmV7cmlnaHQ6MDtsZWZ0OjUwJX0uYW50LXBpY2tlci1wYW5lbC1ydGwgLmFudC1waWNrZXItY2VsbC1pbi12aWV3LmFudC1waWNrZXItY2VsbC1yYW5nZS1zdGFydC5hbnQtcGlja2VyLWNlbGwtcmFuZ2UtZW5kOmJlZm9yZXtyaWdodDo1MCU7bGVmdDo1MCV9LmFudC1waWNrZXItcGFuZWwtcnRsIC5hbnQtcGlja2VyLWRhdGUtcGFuZWwgLmFudC1waWNrZXItY2VsbC1pbi12aWV3LmFudC1waWNrZXItY2VsbC1pbi1yYW5nZS5hbnQtcGlja2VyLWNlbGwtcmFuZ2UtaG92ZXItc3RhcnQgLmFudC1waWNrZXItY2VsbC1pbm5lcjphZnRlcntyaWdodDowO2xlZnQ6LTZweH0uYW50LXBpY2tlci1wYW5lbC1ydGwgLmFudC1waWNrZXItZGF0ZS1wYW5lbCAuYW50LXBpY2tlci1jZWxsLWluLXZpZXcuYW50LXBpY2tlci1jZWxsLWluLXJhbmdlLmFudC1waWNrZXItY2VsbC1yYW5nZS1ob3Zlci1lbmQgLmFudC1waWNrZXItY2VsbC1pbm5lcjphZnRlcntyaWdodDotNnB4O2xlZnQ6MH0uYW50LXBpY2tlci1wYW5lbC1ydGwgLmFudC1waWNrZXItY2VsbC1yYW5nZS1ob3Zlci5hbnQtcGlja2VyLWNlbGwtcmFuZ2Utc3RhcnQ6YWZ0ZXJ7cmlnaHQ6MDtsZWZ0OjUwJX0uYW50LXBpY2tlci1wYW5lbC1ydGwgLmFudC1waWNrZXItY2VsbC1yYW5nZS1ob3Zlci5hbnQtcGlja2VyLWNlbGwtcmFuZ2UtZW5kOmFmdGVye3JpZ2h0OjUwJTtsZWZ0OjB9LmFudC1waWNrZXItcGFuZWwtcnRsIC5hbnQtcGlja2VyLWNlbGwtaW4tdmlldy5hbnQtcGlja2VyLWNlbGwtcmFuZ2Utc3RhcnQ6bm90KC5hbnQtcGlja2VyLWNlbGwtcmFuZ2Utc3RhcnQtc2luZ2xlKTpub3QoLmFudC1waWNrZXItY2VsbC1yYW5nZS1lbmQpIC5hbnQtcGlja2VyLWNlbGwtaW5uZXJ7Ym9yZGVyLXJhZGl1czowIDJweCAycHggMH0uYW50LXBpY2tlci1wYW5lbC1ydGwgLmFudC1waWNrZXItY2VsbC1pbi12aWV3LmFudC1waWNrZXItY2VsbC1yYW5nZS1lbmQ6bm90KC5hbnQtcGlja2VyLWNlbGwtcmFuZ2UtZW5kLXNpbmdsZSk6bm90KC5hbnQtcGlja2VyLWNlbGwtcmFuZ2Utc3RhcnQpIC5hbnQtcGlja2VyLWNlbGwtaW5uZXJ7Ym9yZGVyLXJhZGl1czoycHggMCAwIDJweH0uYW50LXBpY2tlci1wYW5lbC1ydGwgLmFudC1waWNrZXItY2VsbC1pbi12aWV3LmFudC1waWNrZXItY2VsbC1yYW5nZS1ob3Zlci1lZGdlLXN0YXJ0Om5vdCguYW50LXBpY2tlci1jZWxsLXJhbmdlLWhvdmVyLWVkZ2Utc3RhcnQtbmVhci1yYW5nZSk6YWZ0ZXIsLmFudC1waWNrZXItcGFuZWwtcnRsIC5hbnQtcGlja2VyLWNlbGwtaW4tdmlldy5hbnQtcGlja2VyLWNlbGwtcmFuZ2UtaG92ZXItc3RhcnQ6YWZ0ZXIsLmFudC1waWNrZXItcGFuZWwtcnRsIC5hbnQtcGlja2VyLWNlbGwtaW4tdmlldy5hbnQtcGlja2VyLWNlbGwtc3RhcnQuYW50LXBpY2tlci1jZWxsLXJhbmdlLWhvdmVyLWVkZ2Utc3RhcnQuYW50LXBpY2tlci1jZWxsLXJhbmdlLWhvdmVyLWVkZ2Utc3RhcnQtbmVhci1yYW5nZTphZnRlciwuYW50LXBpY2tlci1wYW5lbC1ydGwgdHI+LmFudC1waWNrZXItY2VsbC1pbi12aWV3LmFudC1waWNrZXItY2VsbC1yYW5nZS1ob3Zlcjpub3QoLmFudC1waWNrZXItY2VsbC1zZWxlY3RlZCk6Zmlyc3QtY2hpbGQ6YWZ0ZXJ7cmlnaHQ6NnB4O2xlZnQ6MDtib3JkZXItcmlnaHQ6MXB4IGRhc2hlZCAjN2VjMWZmO2JvcmRlci1sZWZ0Om5vbmU7Ym9yZGVyLXJhZGl1czowIDJweCAycHggMH0uYW50LXBpY2tlci1wYW5lbC1ydGwgLmFudC1waWNrZXItY2VsbC1pbi12aWV3LmFudC1waWNrZXItY2VsbC1lbmQuYW50LXBpY2tlci1jZWxsLXJhbmdlLWhvdmVyLWVkZ2UtZW5kLmFudC1waWNrZXItY2VsbC1yYW5nZS1ob3Zlci1lZGdlLWVuZC1uZWFyLXJhbmdlOmFmdGVyLC5hbnQtcGlja2VyLXBhbmVsLXJ0bCAuYW50LXBpY2tlci1jZWxsLWluLXZpZXcuYW50LXBpY2tlci1jZWxsLXJhbmdlLWhvdmVyLWVkZ2UtZW5kOm5vdCguYW50LXBpY2tlci1jZWxsLXJhbmdlLWhvdmVyLWVkZ2UtZW5kLW5lYXItcmFuZ2UpOmFmdGVyLC5hbnQtcGlja2VyLXBhbmVsLXJ0bCAuYW50LXBpY2tlci1jZWxsLWluLXZpZXcuYW50LXBpY2tlci1jZWxsLXJhbmdlLWhvdmVyLWVuZDphZnRlciwuYW50LXBpY2tlci1wYW5lbC1ydGwgdHI+LmFudC1waWNrZXItY2VsbC1pbi12aWV3LmFudC1waWNrZXItY2VsbC1yYW5nZS1ob3Zlcjpub3QoLmFudC1waWNrZXItY2VsbC1zZWxlY3RlZCk6bGFzdC1jaGlsZDphZnRlcntyaWdodDowO2xlZnQ6NnB4O2JvcmRlci1yaWdodDpub25lO2JvcmRlci1sZWZ0OjFweCBkYXNoZWQgIzdlYzFmZjtib3JkZXItcmFkaXVzOjJweCAwIDAgMnB4fS5hbnQtcGlja2VyLXBhbmVsLXJ0bCAuYW50LXBpY2tlci1jZWxsLWluLXZpZXcuYW50LXBpY2tlci1jZWxsLWVuZC5hbnQtcGlja2VyLWNlbGwtcmFuZ2UtaG92ZXItc3RhcnQuYW50LXBpY2tlci1jZWxsLXJhbmdlLWhvdmVyLWVkZ2UtZW5kOm5vdCguYW50LXBpY2tlci1jZWxsLXJhbmdlLWhvdmVyKTphZnRlciwuYW50LXBpY2tlci1wYW5lbC1ydGwgLmFudC1waWNrZXItY2VsbC1pbi12aWV3LmFudC1waWNrZXItY2VsbC1zdGFydC5hbnQtcGlja2VyLWNlbGwtcmFuZ2UtaG92ZXItZWRnZS1zdGFydDpub3QoLmFudC1waWNrZXItY2VsbC1yYW5nZS1ob3Zlcik6YWZ0ZXIsLmFudC1waWNrZXItcGFuZWwtcnRsIC5hbnQtcGlja2VyLWNlbGwtaW4tdmlldy5hbnQtcGlja2VyLWNlbGwtc3RhcnQuYW50LXBpY2tlci1jZWxsLXJhbmdlLWhvdmVyLWVuZC5hbnQtcGlja2VyLWNlbGwtcmFuZ2UtaG92ZXItZWRnZS1zdGFydDpub3QoLmFudC1waWNrZXItY2VsbC1yYW5nZS1ob3Zlcik6YWZ0ZXIsLmFudC1waWNrZXItcGFuZWwtcnRsIHRyPi5hbnQtcGlja2VyLWNlbGwtaW4tdmlldy5hbnQtcGlja2VyLWNlbGwtZW5kLmFudC1waWNrZXItY2VsbC1yYW5nZS1ob3Zlci5hbnQtcGlja2VyLWNlbGwtcmFuZ2UtaG92ZXItZWRnZS1lbmQ6Zmlyc3QtY2hpbGQ6YWZ0ZXIsLmFudC1waWNrZXItcGFuZWwtcnRsIHRyPi5hbnQtcGlja2VyLWNlbGwtaW4tdmlldy5hbnQtcGlja2VyLWNlbGwtcmFuZ2UtaG92ZXItZW5kOmZpcnN0LWNoaWxkOmFmdGVyLC5hbnQtcGlja2VyLXBhbmVsLXJ0bCB0cj4uYW50LXBpY2tlci1jZWxsLWluLXZpZXcuYW50LXBpY2tlci1jZWxsLXJhbmdlLWhvdmVyLXN0YXJ0Omxhc3QtY2hpbGQ6YWZ0ZXIsLmFudC1waWNrZXItcGFuZWwtcnRsIHRyPi5hbnQtcGlja2VyLWNlbGwtaW4tdmlldy5hbnQtcGlja2VyLWNlbGwtc3RhcnQuYW50LXBpY2tlci1jZWxsLXJhbmdlLWhvdmVyLmFudC1waWNrZXItY2VsbC1yYW5nZS1ob3Zlci1lZGdlLXN0YXJ0Omxhc3QtY2hpbGQ6YWZ0ZXJ7cmlnaHQ6NnB4O2xlZnQ6NnB4O2JvcmRlci1yaWdodDoxcHggZGFzaGVkICM3ZWMxZmY7Ym9yZGVyLWxlZnQ6MXB4IGRhc2hlZCAjN2VjMWZmO2JvcmRlci1yYWRpdXM6MnB4fS5hbnQtcGlja2VyLWRyb3Bkb3duLXJ0bCAuYW50LXBpY2tlci1mb290ZXItZXh0cmF7ZGlyZWN0aW9uOnJ0bDt0ZXh0LWFsaWduOnJpZ2h0fS5hbnQtcGlja2VyLXBhbmVsLXJ0bCAuYW50LXBpY2tlci10aW1lLXBhbmVse2RpcmVjdGlvbjpsdHJ9LmFudC1kZXNjcmlwdGlvbnMtaGVhZGVye2Rpc3BsYXk6ZmxleDthbGlnbi1pdGVtczpjZW50ZXI7bWFyZ2luLWJvdHRvbToyMHB4fS5hbnQtZGVzY3JpcHRpb25zLXRpdGxle2ZsZXg6YXV0bztvdmVyZmxvdzpoaWRkZW47Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtd2VpZ2h0OjcwMDtmb250LXNpemU6MTZweDtsaW5lLWhlaWdodDoxLjU3MTU7d2hpdGUtc3BhY2U6bm93cmFwO3RleHQtb3ZlcmZsb3c6ZWxsaXBzaXN9LmFudC1kZXNjcmlwdGlvbnMtZXh0cmF7bWFyZ2luLWxlZnQ6YXV0bztjb2xvcjpyZ2JhKDAsMCwwLC44NSk7Zm9udC1zaXplOjE0cHh9LmFudC1kZXNjcmlwdGlvbnMtdmlld3t3aWR0aDoxMDAlO2JvcmRlci1yYWRpdXM6MnB4fS5hbnQtZGVzY3JpcHRpb25zLXZpZXcgdGFibGV7d2lkdGg6MTAwJTt0YWJsZS1sYXlvdXQ6Zml4ZWR9LmFudC1kZXNjcmlwdGlvbnMtcm93PnRkLC5hbnQtZGVzY3JpcHRpb25zLXJvdz50aHtwYWRkaW5nLWJvdHRvbToxNnB4fS5hbnQtZGVzY3JpcHRpb25zLXJvdzpsYXN0LWNoaWxke2JvcmRlci1ib3R0b206bm9uZX0uYW50LWRlc2NyaXB0aW9ucy1pdGVtLWxhYmVse2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtmb250LXdlaWdodDo0MDA7Zm9udC1zaXplOjE0cHg7bGluZS1oZWlnaHQ6MS41NzE1O3RleHQtYWxpZ246c3RhcnR9LmFudC1kZXNjcmlwdGlvbnMtaXRlbS1sYWJlbDphZnRlcntjb250ZW50OlwiOlwiO3Bvc2l0aW9uOnJlbGF0aXZlO3RvcDotLjVweDttYXJnaW46MCA4cHggMCAycHh9LmFudC1kZXNjcmlwdGlvbnMtaXRlbS1sYWJlbC5hbnQtZGVzY3JpcHRpb25zLWl0ZW0tbm8tY29sb246YWZ0ZXJ7Y29udGVudDpcIiBcIn0uYW50LWRlc2NyaXB0aW9ucy1pdGVtLW5vLWxhYmVsOmFmdGVye21hcmdpbjowO2NvbnRlbnQ6XCJcIn0uYW50LWRlc2NyaXB0aW9ucy1pdGVtLWNvbnRlbnR7ZGlzcGxheTp0YWJsZS1jZWxsO2ZsZXg6MTtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7Zm9udC1zaXplOjE0cHg7bGluZS1oZWlnaHQ6MS41NzE1O3dvcmQtYnJlYWs6YnJlYWstd29yZDtvdmVyZmxvdy13cmFwOmJyZWFrLXdvcmR9LmFudC1kZXNjcmlwdGlvbnMtaXRlbXtwYWRkaW5nLWJvdHRvbTowO3ZlcnRpY2FsLWFsaWduOnRvcH0uYW50LWRlc2NyaXB0aW9ucy1pdGVtLWNvbnRhaW5lcntkaXNwbGF5OmZsZXh9LmFudC1kZXNjcmlwdGlvbnMtaXRlbS1jb250YWluZXIgLmFudC1kZXNjcmlwdGlvbnMtaXRlbS1jb250ZW50LC5hbnQtZGVzY3JpcHRpb25zLWl0ZW0tY29udGFpbmVyIC5hbnQtZGVzY3JpcHRpb25zLWl0ZW0tbGFiZWx7ZGlzcGxheTppbmxpbmUtZmxleDthbGlnbi1pdGVtczpiYXNlbGluZX0uYW50LWRlc2NyaXB0aW9ucy1taWRkbGUgLmFudC1kZXNjcmlwdGlvbnMtcm93PnRkLC5hbnQtZGVzY3JpcHRpb25zLW1pZGRsZSAuYW50LWRlc2NyaXB0aW9ucy1yb3c+dGh7cGFkZGluZy1ib3R0b206MTJweH0uYW50LWRlc2NyaXB0aW9ucy1zbWFsbCAuYW50LWRlc2NyaXB0aW9ucy1yb3c+dGQsLmFudC1kZXNjcmlwdGlvbnMtc21hbGwgLmFudC1kZXNjcmlwdGlvbnMtcm93PnRoe3BhZGRpbmctYm90dG9tOjhweH0uYW50LWRlc2NyaXB0aW9ucy1ib3JkZXJlZCAuYW50LWRlc2NyaXB0aW9ucy12aWV3e2JvcmRlcjoxcHggc29saWQgI2YwZjBmMH0uYW50LWRlc2NyaXB0aW9ucy1ib3JkZXJlZCAuYW50LWRlc2NyaXB0aW9ucy12aWV3PnRhYmxle3RhYmxlLWxheW91dDphdXRvO2JvcmRlci1jb2xsYXBzZTpjb2xsYXBzZX0uYW50LWRlc2NyaXB0aW9ucy1ib3JkZXJlZCAuYW50LWRlc2NyaXB0aW9ucy1pdGVtLWNvbnRlbnQsLmFudC1kZXNjcmlwdGlvbnMtYm9yZGVyZWQgLmFudC1kZXNjcmlwdGlvbnMtaXRlbS1sYWJlbHtwYWRkaW5nOjE2cHggMjRweDtib3JkZXItcmlnaHQ6MXB4IHNvbGlkICNmMGYwZjB9LmFudC1kZXNjcmlwdGlvbnMtYm9yZGVyZWQgLmFudC1kZXNjcmlwdGlvbnMtaXRlbS1jb250ZW50Omxhc3QtY2hpbGQsLmFudC1kZXNjcmlwdGlvbnMtYm9yZGVyZWQgLmFudC1kZXNjcmlwdGlvbnMtaXRlbS1sYWJlbDpsYXN0LWNoaWxke2JvcmRlci1yaWdodDpub25lfS5hbnQtZGVzY3JpcHRpb25zLWJvcmRlcmVkIC5hbnQtZGVzY3JpcHRpb25zLWl0ZW0tbGFiZWx7YmFja2dyb3VuZC1jb2xvcjojZmFmYWZhfS5hbnQtZGVzY3JpcHRpb25zLWJvcmRlcmVkIC5hbnQtZGVzY3JpcHRpb25zLWl0ZW0tbGFiZWw6YWZ0ZXJ7ZGlzcGxheTpub25lfS5hbnQtZGVzY3JpcHRpb25zLWJvcmRlcmVkIC5hbnQtZGVzY3JpcHRpb25zLXJvd3tib3JkZXItYm90dG9tOjFweCBzb2xpZCAjZjBmMGYwfS5hbnQtZGVzY3JpcHRpb25zLWJvcmRlcmVkIC5hbnQtZGVzY3JpcHRpb25zLXJvdzpsYXN0LWNoaWxke2JvcmRlci1ib3R0b206bm9uZX0uYW50LWRlc2NyaXB0aW9ucy1ib3JkZXJlZC5hbnQtZGVzY3JpcHRpb25zLW1pZGRsZSAuYW50LWRlc2NyaXB0aW9ucy1pdGVtLWNvbnRlbnQsLmFudC1kZXNjcmlwdGlvbnMtYm9yZGVyZWQuYW50LWRlc2NyaXB0aW9ucy1taWRkbGUgLmFudC1kZXNjcmlwdGlvbnMtaXRlbS1sYWJlbHtwYWRkaW5nOjEycHggMjRweH0uYW50LWRlc2NyaXB0aW9ucy1ib3JkZXJlZC5hbnQtZGVzY3JpcHRpb25zLXNtYWxsIC5hbnQtZGVzY3JpcHRpb25zLWl0ZW0tY29udGVudCwuYW50LWRlc2NyaXB0aW9ucy1ib3JkZXJlZC5hbnQtZGVzY3JpcHRpb25zLXNtYWxsIC5hbnQtZGVzY3JpcHRpb25zLWl0ZW0tbGFiZWx7cGFkZGluZzo4cHggMTZweH0uYW50LWRlc2NyaXB0aW9ucy1ydGx7ZGlyZWN0aW9uOnJ0bH0uYW50LWRlc2NyaXB0aW9ucy1ydGwgLmFudC1kZXNjcmlwdGlvbnMtaXRlbS1sYWJlbDphZnRlcnttYXJnaW46MCAycHggMCA4cHh9LmFudC1kZXNjcmlwdGlvbnMtcnRsLmFudC1kZXNjcmlwdGlvbnMtYm9yZGVyZWQgLmFudC1kZXNjcmlwdGlvbnMtaXRlbS1jb250ZW50LC5hbnQtZGVzY3JpcHRpb25zLXJ0bC5hbnQtZGVzY3JpcHRpb25zLWJvcmRlcmVkIC5hbnQtZGVzY3JpcHRpb25zLWl0ZW0tbGFiZWx7Ym9yZGVyLXJpZ2h0Om5vbmU7Ym9yZGVyLWxlZnQ6MXB4IHNvbGlkICNmMGYwZjB9LmFudC1kZXNjcmlwdGlvbnMtcnRsLmFudC1kZXNjcmlwdGlvbnMtYm9yZGVyZWQgLmFudC1kZXNjcmlwdGlvbnMtaXRlbS1jb250ZW50Omxhc3QtY2hpbGQsLmFudC1kZXNjcmlwdGlvbnMtcnRsLmFudC1kZXNjcmlwdGlvbnMtYm9yZGVyZWQgLmFudC1kZXNjcmlwdGlvbnMtaXRlbS1sYWJlbDpsYXN0LWNoaWxke2JvcmRlci1sZWZ0Om5vbmV9LmFudC1kaXZpZGVye2JveC1zaXppbmc6Ym9yZGVyLWJveDttYXJnaW46MDtwYWRkaW5nOjA7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtc2l6ZToxNHB4O2ZvbnQtdmFyaWFudDp0YWJ1bGFyLW51bXM7bGluZS1oZWlnaHQ6MS41NzE1O2xpc3Qtc3R5bGU6bm9uZTtmb250LWZlYXR1cmUtc2V0dGluZ3M6XCJ0bnVtXCI7Ym9yZGVyLXRvcDoxcHggc29saWQgcmdiYSgwLDAsMCwuMDYpfS5hbnQtZGl2aWRlci12ZXJ0aWNhbHtwb3NpdGlvbjpyZWxhdGl2ZTt0b3A6LS4wNmVtO2Rpc3BsYXk6aW5saW5lLWJsb2NrO2hlaWdodDouOWVtO21hcmdpbjowIDhweDt2ZXJ0aWNhbC1hbGlnbjptaWRkbGU7Ym9yZGVyLXRvcDowO2JvcmRlci1sZWZ0OjFweCBzb2xpZCByZ2JhKDAsMCwwLC4wNil9LmFudC1kaXZpZGVyLWhvcml6b250YWx7ZGlzcGxheTpmbGV4O2NsZWFyOmJvdGg7d2lkdGg6MTAwJTttaW4td2lkdGg6MTAwJTttYXJnaW46MjRweCAwfS5hbnQtZGl2aWRlci1ob3Jpem9udGFsLmFudC1kaXZpZGVyLXdpdGgtdGV4dHtkaXNwbGF5OmZsZXg7YWxpZ24taXRlbXM6Y2VudGVyO21hcmdpbjoxNnB4IDA7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtd2VpZ2h0OjUwMDtmb250LXNpemU6MTZweDt3aGl0ZS1zcGFjZTpub3dyYXA7dGV4dC1hbGlnbjpjZW50ZXI7Ym9yZGVyLXRvcDowO2JvcmRlci10b3AtY29sb3I6cmdiYSgwLDAsMCwuMDYpfS5hbnQtZGl2aWRlci1ob3Jpem9udGFsLmFudC1kaXZpZGVyLXdpdGgtdGV4dDphZnRlciwuYW50LWRpdmlkZXItaG9yaXpvbnRhbC5hbnQtZGl2aWRlci13aXRoLXRleHQ6YmVmb3Jle3Bvc2l0aW9uOnJlbGF0aXZlO3dpZHRoOjUwJTtib3JkZXItdG9wOjFweCBzb2xpZCB0cmFuc3BhcmVudDtib3JkZXItdG9wLWNvbG9yOmluaGVyaXQ7Ym9yZGVyLWJvdHRvbTowO3RyYW5zZm9ybTp0cmFuc2xhdGVZKDUwJSk7Y29udGVudDpcIlwifS5hbnQtZGl2aWRlci1ob3Jpem9udGFsLmFudC1kaXZpZGVyLXdpdGgtdGV4dC1sZWZ0OmJlZm9yZXt3aWR0aDo1JX0uYW50LWRpdmlkZXItaG9yaXpvbnRhbC5hbnQtZGl2aWRlci13aXRoLXRleHQtbGVmdDphZnRlciwuYW50LWRpdmlkZXItaG9yaXpvbnRhbC5hbnQtZGl2aWRlci13aXRoLXRleHQtcmlnaHQ6YmVmb3Jle3dpZHRoOjk1JX0uYW50LWRpdmlkZXItaG9yaXpvbnRhbC5hbnQtZGl2aWRlci13aXRoLXRleHQtcmlnaHQ6YWZ0ZXJ7d2lkdGg6NSV9LmFudC1kaXZpZGVyLWlubmVyLXRleHR7ZGlzcGxheTppbmxpbmUtYmxvY2s7cGFkZGluZzowIDFlbX0uYW50LWRpdmlkZXItZGFzaGVke2JhY2tncm91bmQ6bm9uZTtib3JkZXI6ZGFzaGVkIHJnYmEoMCwwLDAsLjA2KTtib3JkZXItd2lkdGg6MXB4IDAgMH0uYW50LWRpdmlkZXItaG9yaXpvbnRhbC5hbnQtZGl2aWRlci13aXRoLXRleHQuYW50LWRpdmlkZXItZGFzaGVkOmFmdGVyLC5hbnQtZGl2aWRlci1ob3Jpem9udGFsLmFudC1kaXZpZGVyLXdpdGgtdGV4dC5hbnQtZGl2aWRlci1kYXNoZWQ6YmVmb3Jle2JvcmRlci1zdHlsZTpkYXNoZWQgbm9uZSBub25lfS5hbnQtZGl2aWRlci12ZXJ0aWNhbC5hbnQtZGl2aWRlci1kYXNoZWR7Ym9yZGVyLXdpZHRoOjAgMCAwIDFweH0uYW50LWRpdmlkZXItcGxhaW4uYW50LWRpdmlkZXItd2l0aC10ZXh0e2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtmb250LXdlaWdodDo0MDA7Zm9udC1zaXplOjE0cHh9LmFudC1kaXZpZGVyLWhvcml6b250YWwuYW50LWRpdmlkZXItd2l0aC10ZXh0LWxlZnQuYW50LWRpdmlkZXItbm8tZGVmYXVsdC1vcmllbnRhdGlvbi1tYXJnaW4tbGVmdDpiZWZvcmV7d2lkdGg6MH0uYW50LWRpdmlkZXItaG9yaXpvbnRhbC5hbnQtZGl2aWRlci13aXRoLXRleHQtbGVmdC5hbnQtZGl2aWRlci1uby1kZWZhdWx0LW9yaWVudGF0aW9uLW1hcmdpbi1sZWZ0OmFmdGVye3dpZHRoOjEwMCV9LmFudC1kaXZpZGVyLWhvcml6b250YWwuYW50LWRpdmlkZXItd2l0aC10ZXh0LWxlZnQuYW50LWRpdmlkZXItbm8tZGVmYXVsdC1vcmllbnRhdGlvbi1tYXJnaW4tbGVmdCAuYW50LWRpdmlkZXItaW5uZXItdGV4dHtwYWRkaW5nLWxlZnQ6MH0uYW50LWRpdmlkZXItaG9yaXpvbnRhbC5hbnQtZGl2aWRlci13aXRoLXRleHQtcmlnaHQuYW50LWRpdmlkZXItbm8tZGVmYXVsdC1vcmllbnRhdGlvbi1tYXJnaW4tcmlnaHQ6YmVmb3Jle3dpZHRoOjEwMCV9LmFudC1kaXZpZGVyLWhvcml6b250YWwuYW50LWRpdmlkZXItd2l0aC10ZXh0LXJpZ2h0LmFudC1kaXZpZGVyLW5vLWRlZmF1bHQtb3JpZW50YXRpb24tbWFyZ2luLXJpZ2h0OmFmdGVye3dpZHRoOjB9LmFudC1kaXZpZGVyLWhvcml6b250YWwuYW50LWRpdmlkZXItd2l0aC10ZXh0LXJpZ2h0LmFudC1kaXZpZGVyLW5vLWRlZmF1bHQtb3JpZW50YXRpb24tbWFyZ2luLXJpZ2h0IC5hbnQtZGl2aWRlci1pbm5lci10ZXh0e3BhZGRpbmctcmlnaHQ6MH0uYW50LWRpdmlkZXItcnRse2RpcmVjdGlvbjpydGx9LmFudC1kaXZpZGVyLXJ0bC5hbnQtZGl2aWRlci1ob3Jpem9udGFsLmFudC1kaXZpZGVyLXdpdGgtdGV4dC1sZWZ0OmJlZm9yZXt3aWR0aDo5NSV9LmFudC1kaXZpZGVyLXJ0bC5hbnQtZGl2aWRlci1ob3Jpem9udGFsLmFudC1kaXZpZGVyLXdpdGgtdGV4dC1sZWZ0OmFmdGVyLC5hbnQtZGl2aWRlci1ydGwuYW50LWRpdmlkZXItaG9yaXpvbnRhbC5hbnQtZGl2aWRlci13aXRoLXRleHQtcmlnaHQ6YmVmb3Jle3dpZHRoOjUlfS5hbnQtZGl2aWRlci1ydGwuYW50LWRpdmlkZXItaG9yaXpvbnRhbC5hbnQtZGl2aWRlci13aXRoLXRleHQtcmlnaHQ6YWZ0ZXJ7d2lkdGg6OTUlfS5hbnQtZHJhd2Vye3Bvc2l0aW9uOmZpeGVkO3RvcDowO3JpZ2h0OjA7Ym90dG9tOjA7bGVmdDowO3otaW5kZXg6MTAwMDtwb2ludGVyLWV2ZW50czpub25lfS5hbnQtZHJhd2VyLWlubGluZXtwb3NpdGlvbjphYnNvbHV0ZX0uYW50LWRyYXdlci1tYXNre3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO3JpZ2h0OjA7Ym90dG9tOjA7bGVmdDowO3otaW5kZXg6MTAwMDtiYWNrZ3JvdW5kOnJnYmEoMCwwLDAsLjQ1KTtwb2ludGVyLWV2ZW50czphdXRvfS5hbnQtZHJhd2VyLWNvbnRlbnQtd3JhcHBlcntwb3NpdGlvbjphYnNvbHV0ZTt6LWluZGV4OjEwMDA7dHJhbnNpdGlvbjphbGwgLjNzfS5hbnQtZHJhd2VyLWNvbnRlbnQtd3JhcHBlci1oaWRkZW57ZGlzcGxheTpub25lfS5hbnQtZHJhd2VyLWxlZnQ+LmFudC1kcmF3ZXItY29udGVudC13cmFwcGVye3RvcDowO2JvdHRvbTowO2xlZnQ6MDtib3gtc2hhZG93OjZweCAwIDE2cHggLThweCByZ2JhKDAsMCwwLC4wOCksOXB4IDAgMjhweCAwIHJnYmEoMCwwLDAsLjA1KSwxMnB4IDAgNDhweCAxNnB4IHJnYmEoMCwwLDAsLjAzKX0uYW50LWRyYXdlci1yaWdodD4uYW50LWRyYXdlci1jb250ZW50LXdyYXBwZXJ7dG9wOjA7cmlnaHQ6MDtib3R0b206MDtib3gtc2hhZG93Oi02cHggMCAxNnB4IC04cHggcmdiYSgwLDAsMCwuMDgpLC05cHggMCAyOHB4IDAgcmdiYSgwLDAsMCwuMDUpLC0xMnB4IDAgNDhweCAxNnB4IHJnYmEoMCwwLDAsLjAzKX0uYW50LWRyYXdlci10b3A+LmFudC1kcmF3ZXItY29udGVudC13cmFwcGVye3RvcDowO3JpZ2h0OjA7bGVmdDowO2JveC1zaGFkb3c6MCA2cHggMTZweCAtOHB4IHJnYmEoMCwwLDAsLjA4KSwwIDlweCAyOHB4IDAgcmdiYSgwLDAsMCwuMDUpLDAgMTJweCA0OHB4IDE2cHggcmdiYSgwLDAsMCwuMDMpfS5hbnQtZHJhd2VyLWJvdHRvbT4uYW50LWRyYXdlci1jb250ZW50LXdyYXBwZXJ7cmlnaHQ6MDtib3R0b206MDtsZWZ0OjA7Ym94LXNoYWRvdzowIC02cHggMTZweCAtOHB4IHJnYmEoMCwwLDAsLjA4KSwwIC05cHggMjhweCAwIHJnYmEoMCwwLDAsLjA1KSwwIC0xMnB4IDQ4cHggMTZweCByZ2JhKDAsMCwwLC4wMyl9LmFudC1kcmF3ZXItY29udGVudHt3aWR0aDoxMDAlO2hlaWdodDoxMDAlO292ZXJmbG93OmF1dG87YmFja2dyb3VuZDojZmZmO3BvaW50ZXItZXZlbnRzOmF1dG99LmFudC1kcmF3ZXItd3JhcHBlci1ib2R5e2Rpc3BsYXk6ZmxleDtmbGV4LWRpcmVjdGlvbjpjb2x1bW47d2lkdGg6MTAwJTtoZWlnaHQ6MTAwJX0uYW50LWRyYXdlci1oZWFkZXJ7ZGlzcGxheTpmbGV4O2ZsZXg6MDthbGlnbi1pdGVtczpjZW50ZXI7cGFkZGluZzoxNnB4IDI0cHg7Zm9udC1zaXplOjE2cHg7bGluZS1oZWlnaHQ6MjJweDtib3JkZXItYm90dG9tOjFweCBzb2xpZCAjZjBmMGYwfS5hbnQtZHJhd2VyLWhlYWRlci10aXRsZXtkaXNwbGF5OmZsZXg7ZmxleDoxO2FsaWduLWl0ZW1zOmNlbnRlcjttaW4td2lkdGg6MDttaW4taGVpZ2h0OjB9LmFudC1kcmF3ZXItZXh0cmF7ZmxleDpub25lfS5hbnQtZHJhd2VyLWNsb3Nle2Rpc3BsYXk6aW5saW5lLWJsb2NrO21hcmdpbi1yaWdodDoxMnB4O2NvbG9yOnJnYmEoMCwwLDAsLjQ1KTtmb250LXdlaWdodDo3MDA7Zm9udC1zaXplOjE2cHg7Zm9udC1zdHlsZTpub3JtYWw7bGluZS1oZWlnaHQ6MTt0ZXh0LWFsaWduOmNlbnRlcjt0ZXh0LXRyYW5zZm9ybTpub25lO3RleHQtZGVjb3JhdGlvbjpub25lO2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7Ym9yZGVyOjA7b3V0bGluZTowO2N1cnNvcjpwb2ludGVyO3RyYW5zaXRpb246Y29sb3IgLjNzO3RleHQtcmVuZGVyaW5nOmF1dG99LmFudC1kcmF3ZXItY2xvc2U6Zm9jdXMsLmFudC1kcmF3ZXItY2xvc2U6aG92ZXJ7Y29sb3I6cmdiYSgwLDAsMCwuNzUpO3RleHQtZGVjb3JhdGlvbjpub25lfS5hbnQtZHJhd2VyLXRpdGxle2ZsZXg6MTttYXJnaW46MDtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7Zm9udC13ZWlnaHQ6NTAwO2ZvbnQtc2l6ZToxNnB4O2xpbmUtaGVpZ2h0OjIycHh9LmFudC1kcmF3ZXItYm9keXtmbGV4OjE7bWluLXdpZHRoOjA7bWluLWhlaWdodDowO3BhZGRpbmc6MjRweDtvdmVyZmxvdzphdXRvfS5hbnQtZHJhd2VyLWZvb3RlcntmbGV4LXNocmluazowO3BhZGRpbmc6MTBweCAxNnB4O2JvcmRlci10b3A6MXB4IHNvbGlkICNmMGYwZjB9LnBhbmVsLW1vdGlvbi1hcHBlYXItc3RhcnQsLnBhbmVsLW1vdGlvbi1lbnRlci1zdGFydCwucGFuZWwtbW90aW9uLWxlYXZlLXN0YXJ0e3RyYW5zaXRpb246bm9uZX0uYW50LWRyYXdlci1tYXNrLW1vdGlvbi1hcHBlYXItYWN0aXZlLC5hbnQtZHJhd2VyLW1hc2stbW90aW9uLWVudGVyLWFjdGl2ZSwuYW50LWRyYXdlci1tYXNrLW1vdGlvbi1sZWF2ZS1hY3RpdmUsLnBhbmVsLW1vdGlvbi1hcHBlYXItYWN0aXZlLC5wYW5lbC1tb3Rpb24tZW50ZXItYWN0aXZlLC5wYW5lbC1tb3Rpb24tbGVhdmUtYWN0aXZle3RyYW5zaXRpb246YWxsIC4zc30uYW50LWRyYXdlci1tYXNrLW1vdGlvbi1hcHBlYXIsLmFudC1kcmF3ZXItbWFzay1tb3Rpb24tZW50ZXJ7b3BhY2l0eTowfS5hbnQtZHJhd2VyLW1hc2stbW90aW9uLWFwcGVhci1hY3RpdmUsLmFudC1kcmF3ZXItbWFzay1tb3Rpb24tZW50ZXItYWN0aXZlLC5hbnQtZHJhd2VyLW1hc2stbW90aW9uLWxlYXZle29wYWNpdHk6MX0uYW50LWRyYXdlci1tYXNrLW1vdGlvbi1sZWF2ZS1hY3RpdmV7b3BhY2l0eTowfS5hbnQtZHJhd2VyLXBhbmVsLW1vdGlvbi1sZWZ0LWFwcGVhci1zdGFydCwuYW50LWRyYXdlci1wYW5lbC1tb3Rpb24tbGVmdC1lbnRlci1zdGFydCwuYW50LWRyYXdlci1wYW5lbC1tb3Rpb24tbGVmdC1sZWF2ZS1zdGFydHt0cmFuc2l0aW9uOm5vbmV9LmFudC1kcmF3ZXItcGFuZWwtbW90aW9uLWxlZnQtYXBwZWFyLWFjdGl2ZSwuYW50LWRyYXdlci1wYW5lbC1tb3Rpb24tbGVmdC1lbnRlci1hY3RpdmUsLmFudC1kcmF3ZXItcGFuZWwtbW90aW9uLWxlZnQtbGVhdmUtYWN0aXZle3RyYW5zaXRpb246YWxsIC4zc30uYW50LWRyYXdlci1wYW5lbC1tb3Rpb24tbGVmdC1hcHBlYXItc3RhcnQsLmFudC1kcmF3ZXItcGFuZWwtbW90aW9uLWxlZnQtZW50ZXItc3RhcnR7dHJhbnNmb3JtOnRyYW5zbGF0ZVgoLTEwMCUpIWltcG9ydGFudH0uYW50LWRyYXdlci1wYW5lbC1tb3Rpb24tbGVmdC1hcHBlYXItYWN0aXZlLC5hbnQtZHJhd2VyLXBhbmVsLW1vdGlvbi1sZWZ0LWVudGVyLWFjdGl2ZSwuYW50LWRyYXdlci1wYW5lbC1tb3Rpb24tbGVmdC1sZWF2ZXt0cmFuc2Zvcm06dHJhbnNsYXRlWCgwKX0uYW50LWRyYXdlci1wYW5lbC1tb3Rpb24tbGVmdC1sZWF2ZS1hY3RpdmV7dHJhbnNmb3JtOnRyYW5zbGF0ZVgoLTEwMCUpfS5hbnQtZHJhd2VyLXBhbmVsLW1vdGlvbi1yaWdodC1hcHBlYXItc3RhcnQsLmFudC1kcmF3ZXItcGFuZWwtbW90aW9uLXJpZ2h0LWVudGVyLXN0YXJ0LC5hbnQtZHJhd2VyLXBhbmVsLW1vdGlvbi1yaWdodC1sZWF2ZS1zdGFydHt0cmFuc2l0aW9uOm5vbmV9LmFudC1kcmF3ZXItcGFuZWwtbW90aW9uLXJpZ2h0LWFwcGVhci1hY3RpdmUsLmFudC1kcmF3ZXItcGFuZWwtbW90aW9uLXJpZ2h0LWVudGVyLWFjdGl2ZSwuYW50LWRyYXdlci1wYW5lbC1tb3Rpb24tcmlnaHQtbGVhdmUtYWN0aXZle3RyYW5zaXRpb246YWxsIC4zc30uYW50LWRyYXdlci1wYW5lbC1tb3Rpb24tcmlnaHQtYXBwZWFyLXN0YXJ0LC5hbnQtZHJhd2VyLXBhbmVsLW1vdGlvbi1yaWdodC1lbnRlci1zdGFydHt0cmFuc2Zvcm06dHJhbnNsYXRlWCgxMDAlKSFpbXBvcnRhbnR9LmFudC1kcmF3ZXItcGFuZWwtbW90aW9uLXJpZ2h0LWFwcGVhci1hY3RpdmUsLmFudC1kcmF3ZXItcGFuZWwtbW90aW9uLXJpZ2h0LWVudGVyLWFjdGl2ZSwuYW50LWRyYXdlci1wYW5lbC1tb3Rpb24tcmlnaHQtbGVhdmV7dHJhbnNmb3JtOnRyYW5zbGF0ZVgoMCl9LmFudC1kcmF3ZXItcGFuZWwtbW90aW9uLXJpZ2h0LWxlYXZlLWFjdGl2ZXt0cmFuc2Zvcm06dHJhbnNsYXRlWCgxMDAlKX0uYW50LWRyYXdlci1wYW5lbC1tb3Rpb24tdG9wLWFwcGVhci1zdGFydCwuYW50LWRyYXdlci1wYW5lbC1tb3Rpb24tdG9wLWVudGVyLXN0YXJ0LC5hbnQtZHJhd2VyLXBhbmVsLW1vdGlvbi10b3AtbGVhdmUtc3RhcnR7dHJhbnNpdGlvbjpub25lfS5hbnQtZHJhd2VyLXBhbmVsLW1vdGlvbi10b3AtYXBwZWFyLWFjdGl2ZSwuYW50LWRyYXdlci1wYW5lbC1tb3Rpb24tdG9wLWVudGVyLWFjdGl2ZSwuYW50LWRyYXdlci1wYW5lbC1tb3Rpb24tdG9wLWxlYXZlLWFjdGl2ZXt0cmFuc2l0aW9uOmFsbCAuM3N9LmFudC1kcmF3ZXItcGFuZWwtbW90aW9uLXRvcC1hcHBlYXItc3RhcnQsLmFudC1kcmF3ZXItcGFuZWwtbW90aW9uLXRvcC1lbnRlci1zdGFydHt0cmFuc2Zvcm06dHJhbnNsYXRlWSgtMTAwJSkhaW1wb3J0YW50fS5hbnQtZHJhd2VyLXBhbmVsLW1vdGlvbi10b3AtYXBwZWFyLWFjdGl2ZSwuYW50LWRyYXdlci1wYW5lbC1tb3Rpb24tdG9wLWVudGVyLWFjdGl2ZSwuYW50LWRyYXdlci1wYW5lbC1tb3Rpb24tdG9wLWxlYXZle3RyYW5zZm9ybTp0cmFuc2xhdGVZKDApfS5hbnQtZHJhd2VyLXBhbmVsLW1vdGlvbi10b3AtbGVhdmUtYWN0aXZle3RyYW5zZm9ybTp0cmFuc2xhdGVZKC0xMDAlKX0uYW50LWRyYXdlci1wYW5lbC1tb3Rpb24tYm90dG9tLWFwcGVhci1zdGFydCwuYW50LWRyYXdlci1wYW5lbC1tb3Rpb24tYm90dG9tLWVudGVyLXN0YXJ0LC5hbnQtZHJhd2VyLXBhbmVsLW1vdGlvbi1ib3R0b20tbGVhdmUtc3RhcnR7dHJhbnNpdGlvbjpub25lfS5hbnQtZHJhd2VyLXBhbmVsLW1vdGlvbi1ib3R0b20tYXBwZWFyLWFjdGl2ZSwuYW50LWRyYXdlci1wYW5lbC1tb3Rpb24tYm90dG9tLWVudGVyLWFjdGl2ZSwuYW50LWRyYXdlci1wYW5lbC1tb3Rpb24tYm90dG9tLWxlYXZlLWFjdGl2ZXt0cmFuc2l0aW9uOmFsbCAuM3N9LmFudC1kcmF3ZXItcGFuZWwtbW90aW9uLWJvdHRvbS1hcHBlYXItc3RhcnQsLmFudC1kcmF3ZXItcGFuZWwtbW90aW9uLWJvdHRvbS1lbnRlci1zdGFydHt0cmFuc2Zvcm06dHJhbnNsYXRlWSgxMDAlKSFpbXBvcnRhbnR9LmFudC1kcmF3ZXItcGFuZWwtbW90aW9uLWJvdHRvbS1hcHBlYXItYWN0aXZlLC5hbnQtZHJhd2VyLXBhbmVsLW1vdGlvbi1ib3R0b20tZW50ZXItYWN0aXZlLC5hbnQtZHJhd2VyLXBhbmVsLW1vdGlvbi1ib3R0b20tbGVhdmV7dHJhbnNmb3JtOnRyYW5zbGF0ZVkoMCl9LmFudC1kcmF3ZXItcGFuZWwtbW90aW9uLWJvdHRvbS1sZWF2ZS1hY3RpdmV7dHJhbnNmb3JtOnRyYW5zbGF0ZVkoMTAwJSl9LmFudC1kcmF3ZXItcnRse2RpcmVjdGlvbjpydGx9LmFudC1kcmF3ZXItcnRsIC5hbnQtZHJhd2VyLWNsb3Nle21hcmdpbi1yaWdodDowO21hcmdpbi1sZWZ0OjEycHh9LmFudC1kcm9wZG93bi1tZW51LWl0ZW0uYW50LWRyb3Bkb3duLW1lbnUtaXRlbS1kYW5nZXJ7Y29sb3I6I2ZmNGQ0Zn0uYW50LWRyb3Bkb3duLW1lbnUtaXRlbS5hbnQtZHJvcGRvd24tbWVudS1pdGVtLWRhbmdlcjpob3Zlcntjb2xvcjojZmZmO2JhY2tncm91bmQtY29sb3I6I2ZmNGQ0Zn0uYW50LWRyb3Bkb3due2JveC1zaXppbmc6Ym9yZGVyLWJveDttYXJnaW46MDtwYWRkaW5nOjA7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtc2l6ZToxNHB4O2ZvbnQtdmFyaWFudDp0YWJ1bGFyLW51bXM7bGluZS1oZWlnaHQ6MS41NzE1O2xpc3Qtc3R5bGU6bm9uZTtmb250LWZlYXR1cmUtc2V0dGluZ3M6XCJ0bnVtXCI7cG9zaXRpb246YWJzb2x1dGU7dG9wOi05OTk5cHg7bGVmdDotOTk5OXB4O3otaW5kZXg6MTA1MDtkaXNwbGF5OmJsb2NrfS5hbnQtZHJvcGRvd246YmVmb3Jle3Bvc2l0aW9uOmFic29sdXRlO3RvcDotNHB4O3JpZ2h0OjA7Ym90dG9tOi00cHg7bGVmdDotN3B4O3otaW5kZXg6LTk5OTk7b3BhY2l0eTouMDAwMTtjb250ZW50OlwiIFwifS5hbnQtZHJvcGRvd24td3JhcHtwb3NpdGlvbjpyZWxhdGl2ZX0uYW50LWRyb3Bkb3duLXdyYXAgLmFudC1idG4+LmFudGljb24tZG93bntmb250LXNpemU6MTBweH0uYW50LWRyb3Bkb3duLXdyYXAgLmFudGljb24tZG93bjpiZWZvcmV7dHJhbnNpdGlvbjp0cmFuc2Zvcm0gLjJzfS5hbnQtZHJvcGRvd24td3JhcC1vcGVuIC5hbnRpY29uLWRvd246YmVmb3Jle3RyYW5zZm9ybTpyb3RhdGUoMTgwZGVnKX0uYW50LWRyb3Bkb3duLWhpZGRlbiwuYW50LWRyb3Bkb3duLW1lbnUtaGlkZGVuLC5hbnQtZHJvcGRvd24tbWVudS1zdWJtZW51LWhpZGRlbntkaXNwbGF5Om5vbmV9LmFudC1kcm9wZG93bi1zaG93LWFycm93LmFudC1kcm9wZG93bi1wbGFjZW1lbnQtdG9wLC5hbnQtZHJvcGRvd24tc2hvdy1hcnJvdy5hbnQtZHJvcGRvd24tcGxhY2VtZW50LXRvcExlZnQsLmFudC1kcm9wZG93bi1zaG93LWFycm93LmFudC1kcm9wZG93bi1wbGFjZW1lbnQtdG9wUmlnaHR7cGFkZGluZy1ib3R0b206MTUuMzEzNzA4NXB4fS5hbnQtZHJvcGRvd24tc2hvdy1hcnJvdy5hbnQtZHJvcGRvd24tcGxhY2VtZW50LWJvdHRvbSwuYW50LWRyb3Bkb3duLXNob3ctYXJyb3cuYW50LWRyb3Bkb3duLXBsYWNlbWVudC1ib3R0b21MZWZ0LC5hbnQtZHJvcGRvd24tc2hvdy1hcnJvdy5hbnQtZHJvcGRvd24tcGxhY2VtZW50LWJvdHRvbVJpZ2h0e3BhZGRpbmctdG9wOjE1LjMxMzcwODVweH0uYW50LWRyb3Bkb3duLWFycm93e3Bvc2l0aW9uOmFic29sdXRlO3otaW5kZXg6MTtkaXNwbGF5OmJsb2NrO3dpZHRoOjExLjMxMzcwODVweDtoZWlnaHQ6MTEuMzEzNzA4NXB4O2JvcmRlci1yYWRpdXM6MCAwIDJweDtwb2ludGVyLWV2ZW50czpub25lfS5hbnQtZHJvcGRvd24tYXJyb3c6YmVmb3Jle3Bvc2l0aW9uOmFic29sdXRlO3RvcDotMTEuMzEzNzA4NXB4O2xlZnQ6LTExLjMxMzcwODVweDt3aWR0aDozMy45NDExMjU1cHg7aGVpZ2h0OjMzLjk0MTEyNTVweDtiYWNrZ3JvdW5kOiNmZmY7YmFja2dyb3VuZC1yZXBlYXQ6bm8tcmVwZWF0O2JhY2tncm91bmQtcG9zaXRpb246LTEwcHggLTEwcHg7Y29udGVudDpcIlwiOy13ZWJraXQtY2xpcC1wYXRoOmluc2V0KDMzJSAzMyUpO2NsaXAtcGF0aDppbnNldCgzMyUgMzMlKTstd2Via2l0LWNsaXAtcGF0aDpwYXRoKFwiTSA5Ljg0OTI0MjQwNDkxNzQ5OSAyNC4wOTE4ODMwOTIwMzY3ODUgQSA1IDUgMCAwIDEgMTMuMzg0Nzc2MzEwODUwMjM3IDIyLjYyNzQxNjk5Nzk2OTUyMiBMIDIwLjYyNzQxNjk5Nzk2OTUyMiAyMi42Mjc0MTY5OTc5Njk1MjIgQSAyIDIgMCAwIDAgMjIuNjI3NDE2OTk3OTY5NTIyIDIwLjYyNzQxNjk5Nzk2OTUyMiBMIDIyLjYyNzQxNjk5Nzk2OTUyMiAxMy4zODQ3NzYzMTA4NTAyMzcgQSA1IDUgMCAwIDEgMjQuMDkxODgzMDkyMDM2Nzg1IDkuODQ5MjQyNDA0OTE3NDk5IEwgMjMuMDkxODgzMDkyMDM2Nzg1IDkuODQ5MjQyNDA0OTE3NDk5IEwgOS44NDkyNDI0MDQ5MTc0OTkgMjMuMDkxODgzMDkyMDM2Nzg1IFpcIik7Y2xpcC1wYXRoOnBhdGgoXCJNIDkuODQ5MjQyNDA0OTE3NDk5IDI0LjA5MTg4MzA5MjAzNjc4NSBBIDUgNSAwIDAgMSAxMy4zODQ3NzYzMTA4NTAyMzcgMjIuNjI3NDE2OTk3OTY5NTIyIEwgMjAuNjI3NDE2OTk3OTY5NTIyIDIyLjYyNzQxNjk5Nzk2OTUyMiBBIDIgMiAwIDAgMCAyMi42Mjc0MTY5OTc5Njk1MjIgMjAuNjI3NDE2OTk3OTY5NTIyIEwgMjIuNjI3NDE2OTk3OTY5NTIyIDEzLjM4NDc3NjMxMDg1MDIzNyBBIDUgNSAwIDAgMSAyNC4wOTE4ODMwOTIwMzY3ODUgOS44NDkyNDI0MDQ5MTc0OTkgTCAyMy4wOTE4ODMwOTIwMzY3ODUgOS44NDkyNDI0MDQ5MTc0OTkgTCA5Ljg0OTI0MjQwNDkxNzQ5OSAyMy4wOTE4ODMwOTIwMzY3ODUgWlwiKX0uYW50LWRyb3Bkb3duLXBsYWNlbWVudC10b3A+LmFudC1kcm9wZG93bi1hcnJvdywuYW50LWRyb3Bkb3duLXBsYWNlbWVudC10b3BMZWZ0Pi5hbnQtZHJvcGRvd24tYXJyb3csLmFudC1kcm9wZG93bi1wbGFjZW1lbnQtdG9wUmlnaHQ+LmFudC1kcm9wZG93bi1hcnJvd3tib3R0b206MTBweDtib3gtc2hhZG93OjNweCAzcHggN3B4IC0zcHggcmdiYSgwLDAsMCwuMSk7dHJhbnNmb3JtOnJvdGF0ZSg0NWRlZyl9LmFudC1kcm9wZG93bi1wbGFjZW1lbnQtdG9wPi5hbnQtZHJvcGRvd24tYXJyb3d7bGVmdDo1MCU7dHJhbnNmb3JtOnRyYW5zbGF0ZVgoLTUwJSkgcm90YXRlKDQ1ZGVnKX0uYW50LWRyb3Bkb3duLXBsYWNlbWVudC10b3BMZWZ0Pi5hbnQtZHJvcGRvd24tYXJyb3d7bGVmdDoxNnB4fS5hbnQtZHJvcGRvd24tcGxhY2VtZW50LXRvcFJpZ2h0Pi5hbnQtZHJvcGRvd24tYXJyb3d7cmlnaHQ6MTZweH0uYW50LWRyb3Bkb3duLXBsYWNlbWVudC1ib3R0b20+LmFudC1kcm9wZG93bi1hcnJvdywuYW50LWRyb3Bkb3duLXBsYWNlbWVudC1ib3R0b21MZWZ0Pi5hbnQtZHJvcGRvd24tYXJyb3csLmFudC1kcm9wZG93bi1wbGFjZW1lbnQtYm90dG9tUmlnaHQ+LmFudC1kcm9wZG93bi1hcnJvd3t0b3A6OS40MTQyMTM1NnB4O2JveC1zaGFkb3c6MnB4IDJweCA1cHggLTJweCByZ2JhKDAsMCwwLC4xKTt0cmFuc2Zvcm06cm90YXRlKC0xMzVkZWcpIHRyYW5zbGF0ZVkoLS41cHgpfS5hbnQtZHJvcGRvd24tcGxhY2VtZW50LWJvdHRvbT4uYW50LWRyb3Bkb3duLWFycm93e2xlZnQ6NTAlO3RyYW5zZm9ybTp0cmFuc2xhdGVYKC01MCUpIHJvdGF0ZSgtMTM1ZGVnKSB0cmFuc2xhdGVZKC0uNXB4KX0uYW50LWRyb3Bkb3duLXBsYWNlbWVudC1ib3R0b21MZWZ0Pi5hbnQtZHJvcGRvd24tYXJyb3d7bGVmdDoxNnB4fS5hbnQtZHJvcGRvd24tcGxhY2VtZW50LWJvdHRvbVJpZ2h0Pi5hbnQtZHJvcGRvd24tYXJyb3d7cmlnaHQ6MTZweH0uYW50LWRyb3Bkb3duLW1lbnV7cG9zaXRpb246cmVsYXRpdmU7bWFyZ2luOjA7cGFkZGluZzo0cHggMDt0ZXh0LWFsaWduOmxlZnQ7bGlzdC1zdHlsZS10eXBlOm5vbmU7YmFja2dyb3VuZC1jb2xvcjojZmZmO2JhY2tncm91bmQtY2xpcDpwYWRkaW5nLWJveDtib3JkZXItcmFkaXVzOjJweDtvdXRsaW5lOm5vbmU7Ym94LXNoYWRvdzowIDNweCA2cHggLTRweCByZ2JhKDAsMCwwLC4xMiksMCA2cHggMTZweCAwIHJnYmEoMCwwLDAsLjA4KSwwIDlweCAyOHB4IDhweCByZ2JhKDAsMCwwLC4wNSl9LmFudC1kcm9wZG93bi1tZW51LWl0ZW0tZ3JvdXAtdGl0bGV7cGFkZGluZzo1cHggMTJweDtjb2xvcjpyZ2JhKDAsMCwwLC40NSk7dHJhbnNpdGlvbjphbGwgLjNzfS5hbnQtZHJvcGRvd24tbWVudS1zdWJtZW51LXBvcHVwe3Bvc2l0aW9uOmFic29sdXRlO3otaW5kZXg6MTA1MDtiYWNrZ3JvdW5kOnRyYW5zcGFyZW50O2JveC1zaGFkb3c6bm9uZTt0cmFuc2Zvcm0tb3JpZ2luOjAgMH0uYW50LWRyb3Bkb3duLW1lbnUtc3VibWVudS1wb3B1cCBsaSwuYW50LWRyb3Bkb3duLW1lbnUtc3VibWVudS1wb3B1cCB1bHtsaXN0LXN0eWxlOm5vbmV9LmFudC1kcm9wZG93bi1tZW51LXN1Ym1lbnUtcG9wdXAgdWx7bWFyZ2luLXJpZ2h0Oi4zZW07bWFyZ2luLWxlZnQ6LjNlbX0uYW50LWRyb3Bkb3duLW1lbnUtaXRlbXtwb3NpdGlvbjpyZWxhdGl2ZTtkaXNwbGF5OmZsZXg7YWxpZ24taXRlbXM6Y2VudGVyfS5hbnQtZHJvcGRvd24tbWVudS1pdGVtLWljb257bWluLXdpZHRoOjEycHg7bWFyZ2luLXJpZ2h0OjhweDtmb250LXNpemU6MTJweH0uYW50LWRyb3Bkb3duLW1lbnUtdGl0bGUtY29udGVudHtmbGV4OmF1dG99LmFudC1kcm9wZG93bi1tZW51LXRpdGxlLWNvbnRlbnQ+YXtjb2xvcjppbmhlcml0O3RyYW5zaXRpb246YWxsIC4zc30uYW50LWRyb3Bkb3duLW1lbnUtdGl0bGUtY29udGVudD5hOmhvdmVye2NvbG9yOmluaGVyaXR9LmFudC1kcm9wZG93bi1tZW51LXRpdGxlLWNvbnRlbnQ+YTphZnRlcntwb3NpdGlvbjphYnNvbHV0ZTt0b3A6MDtyaWdodDowO2JvdHRvbTowO2xlZnQ6MDtjb250ZW50OlwiXCJ9LmFudC1kcm9wZG93bi1tZW51LWl0ZW0sLmFudC1kcm9wZG93bi1tZW51LXN1Ym1lbnUtdGl0bGV7Y2xlYXI6Ym90aDttYXJnaW46MDtwYWRkaW5nOjVweCAxMnB4O2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtmb250LXdlaWdodDo0MDA7Zm9udC1zaXplOjE0cHg7bGluZS1oZWlnaHQ6MjJweDtjdXJzb3I6cG9pbnRlcjt0cmFuc2l0aW9uOmFsbCAuM3N9LmFudC1kcm9wZG93bi1tZW51LWl0ZW0tc2VsZWN0ZWQsLmFudC1kcm9wZG93bi1tZW51LXN1Ym1lbnUtdGl0bGUtc2VsZWN0ZWR7Y29sb3I6IzE4OTBmZjtiYWNrZ3JvdW5kLWNvbG9yOiNlNmY3ZmZ9LmFudC1kcm9wZG93bi1tZW51LWl0ZW0uYW50LWRyb3Bkb3duLW1lbnUtaXRlbS1hY3RpdmUsLmFudC1kcm9wZG93bi1tZW51LWl0ZW0uYW50LWRyb3Bkb3duLW1lbnUtc3VibWVudS10aXRsZS1hY3RpdmUsLmFudC1kcm9wZG93bi1tZW51LWl0ZW06aG92ZXIsLmFudC1kcm9wZG93bi1tZW51LXN1Ym1lbnUtdGl0bGUuYW50LWRyb3Bkb3duLW1lbnUtaXRlbS1hY3RpdmUsLmFudC1kcm9wZG93bi1tZW51LXN1Ym1lbnUtdGl0bGUuYW50LWRyb3Bkb3duLW1lbnUtc3VibWVudS10aXRsZS1hY3RpdmUsLmFudC1kcm9wZG93bi1tZW51LXN1Ym1lbnUtdGl0bGU6aG92ZXJ7YmFja2dyb3VuZC1jb2xvcjojZjVmNWY1fS5hbnQtZHJvcGRvd24tbWVudS1pdGVtLmFudC1kcm9wZG93bi1tZW51LWl0ZW0tZGlzYWJsZWQsLmFudC1kcm9wZG93bi1tZW51LWl0ZW0uYW50LWRyb3Bkb3duLW1lbnUtc3VibWVudS10aXRsZS1kaXNhYmxlZCwuYW50LWRyb3Bkb3duLW1lbnUtc3VibWVudS10aXRsZS5hbnQtZHJvcGRvd24tbWVudS1pdGVtLWRpc2FibGVkLC5hbnQtZHJvcGRvd24tbWVudS1zdWJtZW51LXRpdGxlLmFudC1kcm9wZG93bi1tZW51LXN1Ym1lbnUtdGl0bGUtZGlzYWJsZWR7Y29sb3I6cmdiYSgwLDAsMCwuMjUpO2N1cnNvcjpub3QtYWxsb3dlZH0uYW50LWRyb3Bkb3duLW1lbnUtaXRlbS5hbnQtZHJvcGRvd24tbWVudS1pdGVtLWRpc2FibGVkOmhvdmVyLC5hbnQtZHJvcGRvd24tbWVudS1pdGVtLmFudC1kcm9wZG93bi1tZW51LXN1Ym1lbnUtdGl0bGUtZGlzYWJsZWQ6aG92ZXIsLmFudC1kcm9wZG93bi1tZW51LXN1Ym1lbnUtdGl0bGUuYW50LWRyb3Bkb3duLW1lbnUtaXRlbS1kaXNhYmxlZDpob3ZlciwuYW50LWRyb3Bkb3duLW1lbnUtc3VibWVudS10aXRsZS5hbnQtZHJvcGRvd24tbWVudS1zdWJtZW51LXRpdGxlLWRpc2FibGVkOmhvdmVye2NvbG9yOnJnYmEoMCwwLDAsLjI1KTtiYWNrZ3JvdW5kLWNvbG9yOiNmZmY7Y3Vyc29yOm5vdC1hbGxvd2VkfS5hbnQtZHJvcGRvd24tbWVudS1pdGVtLmFudC1kcm9wZG93bi1tZW51LWl0ZW0tZGlzYWJsZWQgYSwuYW50LWRyb3Bkb3duLW1lbnUtaXRlbS5hbnQtZHJvcGRvd24tbWVudS1zdWJtZW51LXRpdGxlLWRpc2FibGVkIGEsLmFudC1kcm9wZG93bi1tZW51LXN1Ym1lbnUtdGl0bGUuYW50LWRyb3Bkb3duLW1lbnUtaXRlbS1kaXNhYmxlZCBhLC5hbnQtZHJvcGRvd24tbWVudS1zdWJtZW51LXRpdGxlLmFudC1kcm9wZG93bi1tZW51LXN1Ym1lbnUtdGl0bGUtZGlzYWJsZWQgYXtwb2ludGVyLWV2ZW50czpub25lfS5hbnQtZHJvcGRvd24tbWVudS1pdGVtLWRpdmlkZXIsLmFudC1kcm9wZG93bi1tZW51LXN1Ym1lbnUtdGl0bGUtZGl2aWRlcntoZWlnaHQ6MXB4O21hcmdpbjo0cHggMDtvdmVyZmxvdzpoaWRkZW47bGluZS1oZWlnaHQ6MDtiYWNrZ3JvdW5kLWNvbG9yOiNmMGYwZjB9LmFudC1kcm9wZG93bi1tZW51LWl0ZW0gLmFudC1kcm9wZG93bi1tZW51LXN1Ym1lbnUtZXhwYW5kLWljb24sLmFudC1kcm9wZG93bi1tZW51LXN1Ym1lbnUtdGl0bGUgLmFudC1kcm9wZG93bi1tZW51LXN1Ym1lbnUtZXhwYW5kLWljb257cG9zaXRpb246YWJzb2x1dGU7cmlnaHQ6OHB4fS5hbnQtZHJvcGRvd24tbWVudS1pdGVtIC5hbnQtZHJvcGRvd24tbWVudS1zdWJtZW51LWV4cGFuZC1pY29uIC5hbnQtZHJvcGRvd24tbWVudS1zdWJtZW51LWFycm93LWljb24sLmFudC1kcm9wZG93bi1tZW51LXN1Ym1lbnUtdGl0bGUgLmFudC1kcm9wZG93bi1tZW51LXN1Ym1lbnUtZXhwYW5kLWljb24gLmFudC1kcm9wZG93bi1tZW51LXN1Ym1lbnUtYXJyb3ctaWNvbnttYXJnaW4tcmlnaHQ6MCFpbXBvcnRhbnQ7Y29sb3I6cmdiYSgwLDAsMCwuNDUpO2ZvbnQtc2l6ZToxMHB4O2ZvbnQtc3R5bGU6bm9ybWFsfS5hbnQtZHJvcGRvd24tbWVudS1pdGVtLWdyb3VwLWxpc3R7bWFyZ2luOjAgOHB4O3BhZGRpbmc6MDtsaXN0LXN0eWxlOm5vbmV9LmFudC1kcm9wZG93bi1tZW51LXN1Ym1lbnUtdGl0bGV7cGFkZGluZy1yaWdodDoyNHB4fS5hbnQtZHJvcGRvd24tbWVudS1zdWJtZW51LXZlcnRpY2Fse3Bvc2l0aW9uOnJlbGF0aXZlfS5hbnQtZHJvcGRvd24tbWVudS1zdWJtZW51LXZlcnRpY2FsPi5hbnQtZHJvcGRvd24tbWVudXtwb3NpdGlvbjphYnNvbHV0ZTt0b3A6MDtsZWZ0OjEwMCU7bWluLXdpZHRoOjEwMCU7bWFyZ2luLWxlZnQ6NHB4O3RyYW5zZm9ybS1vcmlnaW46MCAwfS5hbnQtZHJvcGRvd24tbWVudS1zdWJtZW51LmFudC1kcm9wZG93bi1tZW51LXN1Ym1lbnUtZGlzYWJsZWQgLmFudC1kcm9wZG93bi1tZW51LXN1Ym1lbnUtdGl0bGUsLmFudC1kcm9wZG93bi1tZW51LXN1Ym1lbnUuYW50LWRyb3Bkb3duLW1lbnUtc3VibWVudS1kaXNhYmxlZCAuYW50LWRyb3Bkb3duLW1lbnUtc3VibWVudS10aXRsZSAuYW50LWRyb3Bkb3duLW1lbnUtc3VibWVudS1hcnJvdy1pY29ue2NvbG9yOnJnYmEoMCwwLDAsLjI1KTtiYWNrZ3JvdW5kLWNvbG9yOiNmZmY7Y3Vyc29yOm5vdC1hbGxvd2VkfS5hbnQtZHJvcGRvd24tbWVudS1zdWJtZW51LXNlbGVjdGVkIC5hbnQtZHJvcGRvd24tbWVudS1zdWJtZW51LXRpdGxle2NvbG9yOiMxODkwZmZ9LmFudC1kcm9wZG93bi5hbnQtc2xpZGUtZG93bi1hcHBlYXIuYW50LXNsaWRlLWRvd24tYXBwZWFyLWFjdGl2ZS5hbnQtZHJvcGRvd24tcGxhY2VtZW50LWJvdHRvbSwuYW50LWRyb3Bkb3duLmFudC1zbGlkZS1kb3duLWFwcGVhci5hbnQtc2xpZGUtZG93bi1hcHBlYXItYWN0aXZlLmFudC1kcm9wZG93bi1wbGFjZW1lbnQtYm90dG9tTGVmdCwuYW50LWRyb3Bkb3duLmFudC1zbGlkZS1kb3duLWFwcGVhci5hbnQtc2xpZGUtZG93bi1hcHBlYXItYWN0aXZlLmFudC1kcm9wZG93bi1wbGFjZW1lbnQtYm90dG9tUmlnaHQsLmFudC1kcm9wZG93bi5hbnQtc2xpZGUtZG93bi1lbnRlci5hbnQtc2xpZGUtZG93bi1lbnRlci1hY3RpdmUuYW50LWRyb3Bkb3duLXBsYWNlbWVudC1ib3R0b20sLmFudC1kcm9wZG93bi5hbnQtc2xpZGUtZG93bi1lbnRlci5hbnQtc2xpZGUtZG93bi1lbnRlci1hY3RpdmUuYW50LWRyb3Bkb3duLXBsYWNlbWVudC1ib3R0b21MZWZ0LC5hbnQtZHJvcGRvd24uYW50LXNsaWRlLWRvd24tZW50ZXIuYW50LXNsaWRlLWRvd24tZW50ZXItYWN0aXZlLmFudC1kcm9wZG93bi1wbGFjZW1lbnQtYm90dG9tUmlnaHR7YW5pbWF0aW9uLW5hbWU6YW50U2xpZGVVcElufS5hbnQtZHJvcGRvd24uYW50LXNsaWRlLXVwLWFwcGVhci5hbnQtc2xpZGUtdXAtYXBwZWFyLWFjdGl2ZS5hbnQtZHJvcGRvd24tcGxhY2VtZW50LXRvcCwuYW50LWRyb3Bkb3duLmFudC1zbGlkZS11cC1hcHBlYXIuYW50LXNsaWRlLXVwLWFwcGVhci1hY3RpdmUuYW50LWRyb3Bkb3duLXBsYWNlbWVudC10b3BMZWZ0LC5hbnQtZHJvcGRvd24uYW50LXNsaWRlLXVwLWFwcGVhci5hbnQtc2xpZGUtdXAtYXBwZWFyLWFjdGl2ZS5hbnQtZHJvcGRvd24tcGxhY2VtZW50LXRvcFJpZ2h0LC5hbnQtZHJvcGRvd24uYW50LXNsaWRlLXVwLWVudGVyLmFudC1zbGlkZS11cC1lbnRlci1hY3RpdmUuYW50LWRyb3Bkb3duLXBsYWNlbWVudC10b3AsLmFudC1kcm9wZG93bi5hbnQtc2xpZGUtdXAtZW50ZXIuYW50LXNsaWRlLXVwLWVudGVyLWFjdGl2ZS5hbnQtZHJvcGRvd24tcGxhY2VtZW50LXRvcExlZnQsLmFudC1kcm9wZG93bi5hbnQtc2xpZGUtdXAtZW50ZXIuYW50LXNsaWRlLXVwLWVudGVyLWFjdGl2ZS5hbnQtZHJvcGRvd24tcGxhY2VtZW50LXRvcFJpZ2h0e2FuaW1hdGlvbi1uYW1lOmFudFNsaWRlRG93bklufS5hbnQtZHJvcGRvd24uYW50LXNsaWRlLWRvd24tbGVhdmUuYW50LXNsaWRlLWRvd24tbGVhdmUtYWN0aXZlLmFudC1kcm9wZG93bi1wbGFjZW1lbnQtYm90dG9tLC5hbnQtZHJvcGRvd24uYW50LXNsaWRlLWRvd24tbGVhdmUuYW50LXNsaWRlLWRvd24tbGVhdmUtYWN0aXZlLmFudC1kcm9wZG93bi1wbGFjZW1lbnQtYm90dG9tTGVmdCwuYW50LWRyb3Bkb3duLmFudC1zbGlkZS1kb3duLWxlYXZlLmFudC1zbGlkZS1kb3duLWxlYXZlLWFjdGl2ZS5hbnQtZHJvcGRvd24tcGxhY2VtZW50LWJvdHRvbVJpZ2h0e2FuaW1hdGlvbi1uYW1lOmFudFNsaWRlVXBPdXR9LmFudC1kcm9wZG93bi5hbnQtc2xpZGUtdXAtbGVhdmUuYW50LXNsaWRlLXVwLWxlYXZlLWFjdGl2ZS5hbnQtZHJvcGRvd24tcGxhY2VtZW50LXRvcCwuYW50LWRyb3Bkb3duLmFudC1zbGlkZS11cC1sZWF2ZS5hbnQtc2xpZGUtdXAtbGVhdmUtYWN0aXZlLmFudC1kcm9wZG93bi1wbGFjZW1lbnQtdG9wTGVmdCwuYW50LWRyb3Bkb3duLmFudC1zbGlkZS11cC1sZWF2ZS5hbnQtc2xpZGUtdXAtbGVhdmUtYWN0aXZlLmFudC1kcm9wZG93bi1wbGFjZW1lbnQtdG9wUmlnaHR7YW5pbWF0aW9uLW5hbWU6YW50U2xpZGVEb3duT3V0fS5hbnQtZHJvcGRvd24tYnV0dG9uPi5hbnRpY29uLmFudGljb24tZG93biwuYW50LWRyb3Bkb3duLWxpbms+LmFudGljb24uYW50aWNvbi1kb3duLC5hbnQtZHJvcGRvd24tdHJpZ2dlcj4uYW50aWNvbi5hbnRpY29uLWRvd257Zm9udC1zaXplOjEwcHg7dmVydGljYWwtYWxpZ246YmFzZWxpbmV9LmFudC1kcm9wZG93bi1idXR0b257d2hpdGUtc3BhY2U6bm93cmFwfS5hbnQtZHJvcGRvd24tYnV0dG9uLmFudC1idG4tZ3JvdXA+LmFudC1idG4tbG9hZGluZywuYW50LWRyb3Bkb3duLWJ1dHRvbi5hbnQtYnRuLWdyb3VwPi5hbnQtYnRuLWxvYWRpbmcrLmFudC1idG57Y3Vyc29yOmRlZmF1bHQ7cG9pbnRlci1ldmVudHM6bm9uZX0uYW50LWRyb3Bkb3duLWJ1dHRvbi5hbnQtYnRuLWdyb3VwPi5hbnQtYnRuLWxvYWRpbmcrLmFudC1idG46YmVmb3Jle2Rpc3BsYXk6YmxvY2t9LmFudC1kcm9wZG93bi1idXR0b24uYW50LWJ0bi1ncm91cD4uYW50LWJ0bjpsYXN0LWNoaWxkOm5vdCg6Zmlyc3QtY2hpbGQpOm5vdCguYW50LWJ0bi1pY29uLW9ubHkpe3BhZGRpbmctcmlnaHQ6OHB4O3BhZGRpbmctbGVmdDo4cHh9LmFudC1kcm9wZG93bi1tZW51LWRhcmssLmFudC1kcm9wZG93bi1tZW51LWRhcmsgLmFudC1kcm9wZG93bi1tZW51e2JhY2tncm91bmQ6IzAwMTUyOX0uYW50LWRyb3Bkb3duLW1lbnUtZGFyayAuYW50LWRyb3Bkb3duLW1lbnUtaXRlbSwuYW50LWRyb3Bkb3duLW1lbnUtZGFyayAuYW50LWRyb3Bkb3duLW1lbnUtaXRlbSAuYW50LWRyb3Bkb3duLW1lbnUtc3VibWVudS1hcnJvdzphZnRlciwuYW50LWRyb3Bkb3duLW1lbnUtZGFyayAuYW50LWRyb3Bkb3duLW1lbnUtaXRlbT4uYW50aWNvbitzcGFuPmEsLmFudC1kcm9wZG93bi1tZW51LWRhcmsgLmFudC1kcm9wZG93bi1tZW51LWl0ZW0+LmFudGljb24rc3Bhbj5hIC5hbnQtZHJvcGRvd24tbWVudS1zdWJtZW51LWFycm93OmFmdGVyLC5hbnQtZHJvcGRvd24tbWVudS1kYXJrIC5hbnQtZHJvcGRvd24tbWVudS1pdGVtPmEsLmFudC1kcm9wZG93bi1tZW51LWRhcmsgLmFudC1kcm9wZG93bi1tZW51LWl0ZW0+YSAuYW50LWRyb3Bkb3duLW1lbnUtc3VibWVudS1hcnJvdzphZnRlciwuYW50LWRyb3Bkb3duLW1lbnUtZGFyayAuYW50LWRyb3Bkb3duLW1lbnUtc3VibWVudS10aXRsZSwuYW50LWRyb3Bkb3duLW1lbnUtZGFyayAuYW50LWRyb3Bkb3duLW1lbnUtc3VibWVudS10aXRsZSAuYW50LWRyb3Bkb3duLW1lbnUtc3VibWVudS1hcnJvdzphZnRlcntjb2xvcjpoc2xhKDAsMCUsMTAwJSwuNjUpfS5hbnQtZHJvcGRvd24tbWVudS1kYXJrIC5hbnQtZHJvcGRvd24tbWVudS1pdGVtOmhvdmVyLC5hbnQtZHJvcGRvd24tbWVudS1kYXJrIC5hbnQtZHJvcGRvd24tbWVudS1pdGVtPi5hbnRpY29uK3NwYW4+YTpob3ZlciwuYW50LWRyb3Bkb3duLW1lbnUtZGFyayAuYW50LWRyb3Bkb3duLW1lbnUtaXRlbT5hOmhvdmVyLC5hbnQtZHJvcGRvd24tbWVudS1kYXJrIC5hbnQtZHJvcGRvd24tbWVudS1zdWJtZW51LXRpdGxlOmhvdmVye2NvbG9yOiNmZmY7YmFja2dyb3VuZDp0cmFuc3BhcmVudH0uYW50LWRyb3Bkb3duLW1lbnUtZGFyayAuYW50LWRyb3Bkb3duLW1lbnUtaXRlbS1zZWxlY3RlZCwuYW50LWRyb3Bkb3duLW1lbnUtZGFyayAuYW50LWRyb3Bkb3duLW1lbnUtaXRlbS1zZWxlY3RlZDpob3ZlciwuYW50LWRyb3Bkb3duLW1lbnUtZGFyayAuYW50LWRyb3Bkb3duLW1lbnUtaXRlbS1zZWxlY3RlZD5he2NvbG9yOiNmZmY7YmFja2dyb3VuZDojMTg5MGZmfS5hbnQtZHJvcGRvd24tcnRse2RpcmVjdGlvbjpydGx9LmFudC1kcm9wZG93bi1ydGwuYW50LWRyb3Bkb3duOmJlZm9yZXtyaWdodDotN3B4O2xlZnQ6MH0uYW50LWRyb3Bkb3duLW1lbnUtc3VibWVudS1ydGwgLmFudC1kcm9wZG93bi1tZW51LWl0ZW0tZ3JvdXAtdGl0bGUsLmFudC1kcm9wZG93bi1tZW51LmFudC1kcm9wZG93bi1tZW51LXJ0bCwuYW50LWRyb3Bkb3duLXJ0bCAuYW50LWRyb3Bkb3duLW1lbnUtaXRlbS1ncm91cC10aXRsZXtkaXJlY3Rpb246cnRsO3RleHQtYWxpZ246cmlnaHR9LmFudC1kcm9wZG93bi1tZW51LXN1Ym1lbnUtcG9wdXAuYW50LWRyb3Bkb3duLW1lbnUtc3VibWVudS1ydGx7dHJhbnNmb3JtLW9yaWdpbjoxMDAlIDB9LmFudC1kcm9wZG93bi1ydGwgLmFudC1kcm9wZG93bi1tZW51LWl0ZW0sLmFudC1kcm9wZG93bi1ydGwgLmFudC1kcm9wZG93bi1tZW51LXN1Ym1lbnUtcG9wdXAgbGksLmFudC1kcm9wZG93bi1ydGwgLmFudC1kcm9wZG93bi1tZW51LXN1Ym1lbnUtcG9wdXAgdWwsLmFudC1kcm9wZG93bi1ydGwgLmFudC1kcm9wZG93bi1tZW51LXN1Ym1lbnUtdGl0bGV7dGV4dC1hbGlnbjpyaWdodH0uYW50LWRyb3Bkb3duLXJ0bCAuYW50LWRyb3Bkb3duLW1lbnUtaXRlbT4uYW50aWNvbjpmaXJzdC1jaGlsZCwuYW50LWRyb3Bkb3duLXJ0bCAuYW50LWRyb3Bkb3duLW1lbnUtaXRlbT5zcGFuPi5hbnRpY29uOmZpcnN0LWNoaWxkLC5hbnQtZHJvcGRvd24tcnRsIC5hbnQtZHJvcGRvd24tbWVudS1zdWJtZW51LXRpdGxlPi5hbnRpY29uOmZpcnN0LWNoaWxkLC5hbnQtZHJvcGRvd24tcnRsIC5hbnQtZHJvcGRvd24tbWVudS1zdWJtZW51LXRpdGxlPnNwYW4+LmFudGljb246Zmlyc3QtY2hpbGR7bWFyZ2luLXJpZ2h0OjA7bWFyZ2luLWxlZnQ6OHB4fS5hbnQtZHJvcGRvd24tcnRsIC5hbnQtZHJvcGRvd24tbWVudS1pdGVtIC5hbnQtZHJvcGRvd24tbWVudS1zdWJtZW51LWV4cGFuZC1pY29uLC5hbnQtZHJvcGRvd24tcnRsIC5hbnQtZHJvcGRvd24tbWVudS1zdWJtZW51LXRpdGxlIC5hbnQtZHJvcGRvd24tbWVudS1zdWJtZW51LWV4cGFuZC1pY29ue3JpZ2h0OmF1dG87bGVmdDo4cHh9LmFudC1kcm9wZG93bi1ydGwgLmFudC1kcm9wZG93bi1tZW51LWl0ZW0gLmFudC1kcm9wZG93bi1tZW51LXN1Ym1lbnUtZXhwYW5kLWljb24gLmFudC1kcm9wZG93bi1tZW51LXN1Ym1lbnUtYXJyb3ctaWNvbiwuYW50LWRyb3Bkb3duLXJ0bCAuYW50LWRyb3Bkb3duLW1lbnUtc3VibWVudS10aXRsZSAuYW50LWRyb3Bkb3duLW1lbnUtc3VibWVudS1leHBhbmQtaWNvbiAuYW50LWRyb3Bkb3duLW1lbnUtc3VibWVudS1hcnJvdy1pY29ue21hcmdpbi1sZWZ0OjAhaW1wb3J0YW50O3RyYW5zZm9ybTpzY2FsZVgoLTEpfS5hbnQtZHJvcGRvd24tcnRsIC5hbnQtZHJvcGRvd24tbWVudS1zdWJtZW51LXRpdGxle3BhZGRpbmctcmlnaHQ6MTJweDtwYWRkaW5nLWxlZnQ6MjRweH0uYW50LWRyb3Bkb3duLXJ0bCAuYW50LWRyb3Bkb3duLW1lbnUtc3VibWVudS12ZXJ0aWNhbD4uYW50LWRyb3Bkb3duLW1lbnV7cmlnaHQ6MTAwJTtsZWZ0OjA7bWFyZ2luLXJpZ2h0OjRweDttYXJnaW4tbGVmdDowfS5hbnQtZW1wdHl7bWFyZ2luOjAgOHB4O2ZvbnQtc2l6ZToxNHB4O2xpbmUtaGVpZ2h0OjEuNTcxNTt0ZXh0LWFsaWduOmNlbnRlcn0uYW50LWVtcHR5LWltYWdle2hlaWdodDoxMDBweDttYXJnaW4tYm90dG9tOjhweH0uYW50LWVtcHR5LWltYWdlIGltZ3toZWlnaHQ6MTAwJX0uYW50LWVtcHR5LWltYWdlIHN2Z3toZWlnaHQ6MTAwJTttYXJnaW46YXV0b30uYW50LWVtcHR5LWZvb3RlcnttYXJnaW4tdG9wOjE2cHh9LmFudC1lbXB0eS1ub3JtYWx7bWFyZ2luOjMycHggMDtjb2xvcjpyZ2JhKDAsMCwwLC4yNSl9LmFudC1lbXB0eS1ub3JtYWwgLmFudC1lbXB0eS1pbWFnZXtoZWlnaHQ6NDBweH0uYW50LWVtcHR5LXNtYWxse21hcmdpbjo4cHggMDtjb2xvcjpyZ2JhKDAsMCwwLC4yNSl9LmFudC1lbXB0eS1zbWFsbCAuYW50LWVtcHR5LWltYWdle2hlaWdodDozNXB4fS5hbnQtZW1wdHktaW1nLWRlZmF1bHQtZWxsaXBzZXtmaWxsOiNmNWY1ZjU7ZmlsbC1vcGFjaXR5Oi44fS5hbnQtZW1wdHktaW1nLWRlZmF1bHQtcGF0aC0xe2ZpbGw6I2FlYjhjMn0uYW50LWVtcHR5LWltZy1kZWZhdWx0LXBhdGgtMntmaWxsOnVybCgjbGluZWFyR3JhZGllbnQtMSl9LmFudC1lbXB0eS1pbWctZGVmYXVsdC1wYXRoLTN7ZmlsbDojZjVmNWY3fS5hbnQtZW1wdHktaW1nLWRlZmF1bHQtcGF0aC00LC5hbnQtZW1wdHktaW1nLWRlZmF1bHQtcGF0aC01e2ZpbGw6I2RjZTBlNn0uYW50LWVtcHR5LWltZy1kZWZhdWx0LWd7ZmlsbDojZmZmfS5hbnQtZW1wdHktaW1nLXNpbXBsZS1lbGxpcHNle2ZpbGw6I2Y1ZjVmNX0uYW50LWVtcHR5LWltZy1zaW1wbGUtZ3tzdHJva2U6I2Q5ZDlkOX0uYW50LWVtcHR5LWltZy1zaW1wbGUtcGF0aHtmaWxsOiNmYWZhZmF9LmFudC1lbXB0eS1ydGx7ZGlyZWN0aW9uOnJ0bH0uYW50LWZvcm0taXRlbSAuYW50LWlucHV0LW51bWJlcisuYW50LWZvcm0tdGV4dHttYXJnaW4tbGVmdDo4cHh9LmFudC1mb3JtLWlubGluZXtkaXNwbGF5OmZsZXg7ZmxleC13cmFwOndyYXB9LmFudC1mb3JtLWlubGluZSAuYW50LWZvcm0taXRlbXtmbGV4Om5vbmU7ZmxleC13cmFwOm5vd3JhcDttYXJnaW4tcmlnaHQ6MTZweDttYXJnaW4tYm90dG9tOjB9LmFudC1mb3JtLWlubGluZSAuYW50LWZvcm0taXRlbS13aXRoLWhlbHB7bWFyZ2luLWJvdHRvbToyNHB4fS5hbnQtZm9ybS1pbmxpbmUgLmFudC1mb3JtLWl0ZW0+LmFudC1mb3JtLWl0ZW0tY29udHJvbCwuYW50LWZvcm0taW5saW5lIC5hbnQtZm9ybS1pdGVtPi5hbnQtZm9ybS1pdGVtLWxhYmVse2Rpc3BsYXk6aW5saW5lLWJsb2NrO3ZlcnRpY2FsLWFsaWduOnRvcH0uYW50LWZvcm0taW5saW5lIC5hbnQtZm9ybS1pdGVtPi5hbnQtZm9ybS1pdGVtLWxhYmVse2ZsZXg6bm9uZX0uYW50LWZvcm0taW5saW5lIC5hbnQtZm9ybS1pdGVtIC5hbnQtZm9ybS1pdGVtLWhhcy1mZWVkYmFjaywuYW50LWZvcm0taW5saW5lIC5hbnQtZm9ybS1pdGVtIC5hbnQtZm9ybS10ZXh0e2Rpc3BsYXk6aW5saW5lLWJsb2NrfS5hbnQtZm9ybS1ob3Jpem9udGFsIC5hbnQtZm9ybS1pdGVtLWxhYmVse2ZsZXgtZ3JvdzowfS5hbnQtZm9ybS1ob3Jpem9udGFsIC5hbnQtZm9ybS1pdGVtLWNvbnRyb2x7ZmxleDoxIDEgMDttaW4td2lkdGg6MH0uYW50LWZvcm0taG9yaXpvbnRhbCAuYW50LWZvcm0taXRlbS1sYWJlbFtjbGFzcyQ9XCItMjRcIl0rLmFudC1mb3JtLWl0ZW0tY29udHJvbCwuYW50LWZvcm0taG9yaXpvbnRhbCAuYW50LWZvcm0taXRlbS1sYWJlbFtjbGFzcyo9XCItMjQgXCJdKy5hbnQtZm9ybS1pdGVtLWNvbnRyb2x7bWluLXdpZHRoOnVuc2V0fS5hbnQtZm9ybS12ZXJ0aWNhbCAuYW50LWZvcm0taXRlbS1yb3d7ZmxleC1kaXJlY3Rpb246Y29sdW1ufS5hbnQtZm9ybS12ZXJ0aWNhbCAuYW50LWZvcm0taXRlbS1sYWJlbD5sYWJlbHtoZWlnaHQ6YXV0b30uYW50LWZvcm0tdmVydGljYWwgLmFudC1mb3JtLWl0ZW0gLmFudC1mb3JtLWl0ZW0tY29udHJvbHt3aWR0aDoxMDAlfS5hbnQtY29sLTI0LmFudC1mb3JtLWl0ZW0tbGFiZWwsLmFudC1jb2wteGwtMjQuYW50LWZvcm0taXRlbS1sYWJlbCwuYW50LWZvcm0tdmVydGljYWwgLmFudC1mb3JtLWl0ZW0tbGFiZWx7cGFkZGluZzowIDAgOHB4O2xpbmUtaGVpZ2h0OjEuNTcxNTt3aGl0ZS1zcGFjZTpub3JtYWw7dGV4dC1hbGlnbjpsZWZ0fS5hbnQtY29sLTI0LmFudC1mb3JtLWl0ZW0tbGFiZWw+bGFiZWwsLmFudC1jb2wteGwtMjQuYW50LWZvcm0taXRlbS1sYWJlbD5sYWJlbCwuYW50LWZvcm0tdmVydGljYWwgLmFudC1mb3JtLWl0ZW0tbGFiZWw+bGFiZWx7bWFyZ2luOjB9LmFudC1jb2wtMjQuYW50LWZvcm0taXRlbS1sYWJlbD5sYWJlbDphZnRlciwuYW50LWNvbC14bC0yNC5hbnQtZm9ybS1pdGVtLWxhYmVsPmxhYmVsOmFmdGVyLC5hbnQtZm9ybS12ZXJ0aWNhbCAuYW50LWZvcm0taXRlbS1sYWJlbD5sYWJlbDphZnRlcntkaXNwbGF5Om5vbmV9LmFudC1mb3JtLXJ0bC5hbnQtY29sLTI0LmFudC1mb3JtLWl0ZW0tbGFiZWwsLmFudC1mb3JtLXJ0bC5hbnQtY29sLXhsLTI0LmFudC1mb3JtLWl0ZW0tbGFiZWwsLmFudC1mb3JtLXJ0bC5hbnQtZm9ybS12ZXJ0aWNhbCAuYW50LWZvcm0taXRlbS1sYWJlbHt0ZXh0LWFsaWduOnJpZ2h0fUBtZWRpYSAobWF4LXdpZHRoOjU3NXB4KXsuYW50LWZvcm0taXRlbSAuYW50LWZvcm0taXRlbS1sYWJlbHtwYWRkaW5nOjAgMCA4cHg7bGluZS1oZWlnaHQ6MS41NzE1O3doaXRlLXNwYWNlOm5vcm1hbDt0ZXh0LWFsaWduOmxlZnR9LmFudC1mb3JtLWl0ZW0gLmFudC1mb3JtLWl0ZW0tbGFiZWw+bGFiZWx7bWFyZ2luOjB9LmFudC1mb3JtLWl0ZW0gLmFudC1mb3JtLWl0ZW0tbGFiZWw+bGFiZWw6YWZ0ZXJ7ZGlzcGxheTpub25lfS5hbnQtZm9ybS1ydGwuYW50LWZvcm0taXRlbSAuYW50LWZvcm0taXRlbS1sYWJlbHt0ZXh0LWFsaWduOnJpZ2h0fS5hbnQtZm9ybSAuYW50LWZvcm0taXRlbXtmbGV4LXdyYXA6d3JhcH0uYW50LWZvcm0gLmFudC1mb3JtLWl0ZW0gLmFudC1mb3JtLWl0ZW0tY29udHJvbCwuYW50LWZvcm0gLmFudC1mb3JtLWl0ZW0gLmFudC1mb3JtLWl0ZW0tbGFiZWx7ZmxleDowIDAgMTAwJTttYXgtd2lkdGg6MTAwJX0uYW50LWNvbC14cy0yNC5hbnQtZm9ybS1pdGVtLWxhYmVse3BhZGRpbmc6MCAwIDhweDtsaW5lLWhlaWdodDoxLjU3MTU7d2hpdGUtc3BhY2U6bm9ybWFsO3RleHQtYWxpZ246bGVmdH0uYW50LWNvbC14cy0yNC5hbnQtZm9ybS1pdGVtLWxhYmVsPmxhYmVse21hcmdpbjowfS5hbnQtY29sLXhzLTI0LmFudC1mb3JtLWl0ZW0tbGFiZWw+bGFiZWw6YWZ0ZXJ7ZGlzcGxheTpub25lfS5hbnQtZm9ybS1ydGwuYW50LWNvbC14cy0yNC5hbnQtZm9ybS1pdGVtLWxhYmVse3RleHQtYWxpZ246cmlnaHR9fUBtZWRpYSAobWF4LXdpZHRoOjc2N3B4KXsuYW50LWNvbC1zbS0yNC5hbnQtZm9ybS1pdGVtLWxhYmVse3BhZGRpbmc6MCAwIDhweDtsaW5lLWhlaWdodDoxLjU3MTU7d2hpdGUtc3BhY2U6bm9ybWFsO3RleHQtYWxpZ246bGVmdH0uYW50LWNvbC1zbS0yNC5hbnQtZm9ybS1pdGVtLWxhYmVsPmxhYmVse21hcmdpbjowfS5hbnQtY29sLXNtLTI0LmFudC1mb3JtLWl0ZW0tbGFiZWw+bGFiZWw6YWZ0ZXJ7ZGlzcGxheTpub25lfS5hbnQtZm9ybS1ydGwuYW50LWNvbC1zbS0yNC5hbnQtZm9ybS1pdGVtLWxhYmVse3RleHQtYWxpZ246cmlnaHR9fUBtZWRpYSAobWF4LXdpZHRoOjk5MXB4KXsuYW50LWNvbC1tZC0yNC5hbnQtZm9ybS1pdGVtLWxhYmVse3BhZGRpbmc6MCAwIDhweDtsaW5lLWhlaWdodDoxLjU3MTU7d2hpdGUtc3BhY2U6bm9ybWFsO3RleHQtYWxpZ246bGVmdH0uYW50LWNvbC1tZC0yNC5hbnQtZm9ybS1pdGVtLWxhYmVsPmxhYmVse21hcmdpbjowfS5hbnQtY29sLW1kLTI0LmFudC1mb3JtLWl0ZW0tbGFiZWw+bGFiZWw6YWZ0ZXJ7ZGlzcGxheTpub25lfS5hbnQtZm9ybS1ydGwuYW50LWNvbC1tZC0yNC5hbnQtZm9ybS1pdGVtLWxhYmVse3RleHQtYWxpZ246cmlnaHR9fUBtZWRpYSAobWF4LXdpZHRoOjExOTlweCl7LmFudC1jb2wtbGctMjQuYW50LWZvcm0taXRlbS1sYWJlbHtwYWRkaW5nOjAgMCA4cHg7bGluZS1oZWlnaHQ6MS41NzE1O3doaXRlLXNwYWNlOm5vcm1hbDt0ZXh0LWFsaWduOmxlZnR9LmFudC1jb2wtbGctMjQuYW50LWZvcm0taXRlbS1sYWJlbD5sYWJlbHttYXJnaW46MH0uYW50LWNvbC1sZy0yNC5hbnQtZm9ybS1pdGVtLWxhYmVsPmxhYmVsOmFmdGVye2Rpc3BsYXk6bm9uZX0uYW50LWZvcm0tcnRsLmFudC1jb2wtbGctMjQuYW50LWZvcm0taXRlbS1sYWJlbHt0ZXh0LWFsaWduOnJpZ2h0fX1AbWVkaWEgKG1heC13aWR0aDoxNTk5cHgpey5hbnQtY29sLXhsLTI0LmFudC1mb3JtLWl0ZW0tbGFiZWx7cGFkZGluZzowIDAgOHB4O2xpbmUtaGVpZ2h0OjEuNTcxNTt3aGl0ZS1zcGFjZTpub3JtYWw7dGV4dC1hbGlnbjpsZWZ0fS5hbnQtY29sLXhsLTI0LmFudC1mb3JtLWl0ZW0tbGFiZWw+bGFiZWx7bWFyZ2luOjB9LmFudC1jb2wteGwtMjQuYW50LWZvcm0taXRlbS1sYWJlbD5sYWJlbDphZnRlcntkaXNwbGF5Om5vbmV9LmFudC1mb3JtLXJ0bC5hbnQtY29sLXhsLTI0LmFudC1mb3JtLWl0ZW0tbGFiZWx7dGV4dC1hbGlnbjpyaWdodH19LmFudC1mb3JtLWl0ZW0tZXhwbGFpbi1lcnJvcntjb2xvcjojZmY0ZDRmfS5hbnQtZm9ybS1pdGVtLWV4cGxhaW4td2FybmluZ3tjb2xvcjojZmFhZDE0fS5hbnQtZm9ybS1pdGVtLWhhcy1mZWVkYmFjayAuYW50LXN3aXRjaHttYXJnaW46MnB4IDAgNHB4fS5hbnQtZm9ybS1pdGVtLWhhcy13YXJuaW5nIC5hbnQtZm9ybS1pdGVtLXNwbGl0e2NvbG9yOiNmYWFkMTR9LmFudC1mb3JtLWl0ZW0taGFzLWVycm9yIC5hbnQtZm9ybS1pdGVtLXNwbGl0e2NvbG9yOiNmZjRkNGZ9LmFudC1mb3Jte2JveC1zaXppbmc6Ym9yZGVyLWJveDttYXJnaW46MDtwYWRkaW5nOjA7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtc2l6ZToxNHB4O2ZvbnQtdmFyaWFudDp0YWJ1bGFyLW51bXM7bGluZS1oZWlnaHQ6MS41NzE1O2xpc3Qtc3R5bGU6bm9uZTtmb250LWZlYXR1cmUtc2V0dGluZ3M6XCJ0bnVtXCJ9LmFudC1mb3JtIGxlZ2VuZHtkaXNwbGF5OmJsb2NrO3dpZHRoOjEwMCU7bWFyZ2luLWJvdHRvbToyMHB4O3BhZGRpbmc6MDtjb2xvcjpyZ2JhKDAsMCwwLC40NSk7Zm9udC1zaXplOjE2cHg7bGluZS1oZWlnaHQ6aW5oZXJpdDtib3JkZXI6MDtib3JkZXItYm90dG9tOjFweCBzb2xpZCAjZDlkOWQ5fS5hbnQtZm9ybSBsYWJlbHtmb250LXNpemU6MTRweH0uYW50LWZvcm0gaW5wdXRbdHlwZT1zZWFyY2hde2JveC1zaXppbmc6Ym9yZGVyLWJveH0uYW50LWZvcm0gaW5wdXRbdHlwZT1jaGVja2JveF0sLmFudC1mb3JtIGlucHV0W3R5cGU9cmFkaW9de2xpbmUtaGVpZ2h0Om5vcm1hbH0uYW50LWZvcm0gaW5wdXRbdHlwZT1maWxlXXtkaXNwbGF5OmJsb2NrfS5hbnQtZm9ybSBpbnB1dFt0eXBlPXJhbmdlXXtkaXNwbGF5OmJsb2NrO3dpZHRoOjEwMCV9LmFudC1mb3JtIHNlbGVjdFttdWx0aXBsZV0sLmFudC1mb3JtIHNlbGVjdFtzaXplXXtoZWlnaHQ6YXV0b30uYW50LWZvcm0gaW5wdXRbdHlwZT1jaGVja2JveF06Zm9jdXMsLmFudC1mb3JtIGlucHV0W3R5cGU9ZmlsZV06Zm9jdXMsLmFudC1mb3JtIGlucHV0W3R5cGU9cmFkaW9dOmZvY3Vze291dGxpbmU6dGhpbiBkb3R0ZWQ7b3V0bGluZTo1cHggYXV0byAtd2Via2l0LWZvY3VzLXJpbmctY29sb3I7b3V0bGluZS1vZmZzZXQ6LTJweH0uYW50LWZvcm0gb3V0cHV0e2Rpc3BsYXk6YmxvY2s7cGFkZGluZy10b3A6MTVweDtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7Zm9udC1zaXplOjE0cHg7bGluZS1oZWlnaHQ6MS41NzE1fS5hbnQtZm9ybSAuYW50LWZvcm0tdGV4dHtkaXNwbGF5OmlubGluZS1ibG9jaztwYWRkaW5nLXJpZ2h0OjhweH0uYW50LWZvcm0tc21hbGwgLmFudC1mb3JtLWl0ZW0tbGFiZWw+bGFiZWx7aGVpZ2h0OjI0cHh9LmFudC1mb3JtLXNtYWxsIC5hbnQtZm9ybS1pdGVtLWNvbnRyb2wtaW5wdXR7bWluLWhlaWdodDoyNHB4fS5hbnQtZm9ybS1sYXJnZSAuYW50LWZvcm0taXRlbS1sYWJlbD5sYWJlbHtoZWlnaHQ6NDBweH0uYW50LWZvcm0tbGFyZ2UgLmFudC1mb3JtLWl0ZW0tY29udHJvbC1pbnB1dHttaW4taGVpZ2h0OjQwcHh9LmFudC1mb3JtLWl0ZW17Ym94LXNpemluZzpib3JkZXItYm94O3BhZGRpbmc6MDtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7Zm9udC1zaXplOjE0cHg7Zm9udC12YXJpYW50OnRhYnVsYXItbnVtcztsaW5lLWhlaWdodDoxLjU3MTU7bGlzdC1zdHlsZTpub25lO2ZvbnQtZmVhdHVyZS1zZXR0aW5nczpcInRudW1cIjttYXJnaW46MCAwIDI0cHg7dmVydGljYWwtYWxpZ246dG9wfS5hbnQtZm9ybS1pdGVtLXdpdGgtaGVscHt0cmFuc2l0aW9uOm5vbmV9LmFudC1mb3JtLWl0ZW0taGlkZGVuLC5hbnQtZm9ybS1pdGVtLWhpZGRlbi5hbnQtcm93e2Rpc3BsYXk6bm9uZX0uYW50LWZvcm0taXRlbS1sYWJlbHtkaXNwbGF5OmlubGluZS1ibG9jaztmbGV4LWdyb3c6MDtvdmVyZmxvdzpoaWRkZW47d2hpdGUtc3BhY2U6bm93cmFwO3RleHQtYWxpZ246cmlnaHQ7dmVydGljYWwtYWxpZ246bWlkZGxlfS5hbnQtZm9ybS1pdGVtLWxhYmVsLWxlZnR7dGV4dC1hbGlnbjpsZWZ0fS5hbnQtZm9ybS1pdGVtLWxhYmVsLXdyYXB7b3ZlcmZsb3c6dW5zZXQ7bGluZS1oZWlnaHQ6MS4zMjE1ZW07d2hpdGUtc3BhY2U6dW5zZXR9LmFudC1mb3JtLWl0ZW0tbGFiZWw+bGFiZWx7cG9zaXRpb246cmVsYXRpdmU7ZGlzcGxheTppbmxpbmUtZmxleDthbGlnbi1pdGVtczpjZW50ZXI7bWF4LXdpZHRoOjEwMCU7aGVpZ2h0OjMycHg7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtc2l6ZToxNHB4fS5hbnQtZm9ybS1pdGVtLWxhYmVsPmxhYmVsPi5hbnRpY29ue2ZvbnQtc2l6ZToxNHB4O3ZlcnRpY2FsLWFsaWduOnRvcH0uYW50LWZvcm0taXRlbS1sYWJlbD5sYWJlbC5hbnQtZm9ybS1pdGVtLXJlcXVpcmVkOm5vdCguYW50LWZvcm0taXRlbS1yZXF1aXJlZC1tYXJrLW9wdGlvbmFsKTpiZWZvcmV7ZGlzcGxheTppbmxpbmUtYmxvY2s7bWFyZ2luLXJpZ2h0OjRweDtjb2xvcjojZmY0ZDRmO2ZvbnQtc2l6ZToxNHB4O2ZvbnQtZmFtaWx5OlNpbVN1bixzYW5zLXNlcmlmO2xpbmUtaGVpZ2h0OjE7Y29udGVudDpcIipcIn0uYW50LWZvcm0taGlkZS1yZXF1aXJlZC1tYXJrIC5hbnQtZm9ybS1pdGVtLWxhYmVsPmxhYmVsLmFudC1mb3JtLWl0ZW0tcmVxdWlyZWQ6bm90KC5hbnQtZm9ybS1pdGVtLXJlcXVpcmVkLW1hcmstb3B0aW9uYWwpOmJlZm9yZXtkaXNwbGF5Om5vbmV9LmFudC1mb3JtLWl0ZW0tbGFiZWw+bGFiZWwgLmFudC1mb3JtLWl0ZW0tb3B0aW9uYWx7ZGlzcGxheTppbmxpbmUtYmxvY2s7bWFyZ2luLWxlZnQ6NHB4O2NvbG9yOnJnYmEoMCwwLDAsLjQ1KX0uYW50LWZvcm0taGlkZS1yZXF1aXJlZC1tYXJrIC5hbnQtZm9ybS1pdGVtLWxhYmVsPmxhYmVsIC5hbnQtZm9ybS1pdGVtLW9wdGlvbmFse2Rpc3BsYXk6bm9uZX0uYW50LWZvcm0taXRlbS1sYWJlbD5sYWJlbCAuYW50LWZvcm0taXRlbS10b29sdGlwe2NvbG9yOnJnYmEoMCwwLDAsLjQ1KTtjdXJzb3I6aGVscDstbXMtd3JpdGluZy1tb2RlOmxyLXRiO3dyaXRpbmctbW9kZTpob3Jpem9udGFsLXRiOy13ZWJraXQtbWFyZ2luLXN0YXJ0OjRweDttYXJnaW4taW5saW5lLXN0YXJ0OjRweH0uYW50LWZvcm0taXRlbS1sYWJlbD5sYWJlbDphZnRlcntjb250ZW50OlwiOlwiO3Bvc2l0aW9uOnJlbGF0aXZlO3RvcDotLjVweDttYXJnaW46MCA4cHggMCAycHh9LmFudC1mb3JtLWl0ZW0tbGFiZWw+bGFiZWwuYW50LWZvcm0taXRlbS1uby1jb2xvbjphZnRlcntjb250ZW50OlwiIFwifS5hbnQtZm9ybS1pdGVtLWNvbnRyb2x7ZGlzcGxheTpmbGV4O2ZsZXgtZGlyZWN0aW9uOmNvbHVtbjtmbGV4LWdyb3c6MX0uYW50LWZvcm0taXRlbS1jb250cm9sOmZpcnN0LWNoaWxkOm5vdChbY2xhc3NePWFudC1jb2wtXSk6bm90KFtjbGFzcyo9XCIgYW50LWNvbC1cIl0pe3dpZHRoOjEwMCV9LmFudC1mb3JtLWl0ZW0tY29udHJvbC1pbnB1dHtwb3NpdGlvbjpyZWxhdGl2ZTtkaXNwbGF5OmZsZXg7YWxpZ24taXRlbXM6Y2VudGVyO21pbi1oZWlnaHQ6MzJweH0uYW50LWZvcm0taXRlbS1jb250cm9sLWlucHV0LWNvbnRlbnR7ZmxleDphdXRvO21heC13aWR0aDoxMDAlfS5hbnQtZm9ybS1pdGVtLWV4cGxhaW4sLmFudC1mb3JtLWl0ZW0tZXh0cmF7Y2xlYXI6Ym90aDtjb2xvcjpyZ2JhKDAsMCwwLC40NSk7Zm9udC1zaXplOjE0cHg7bGluZS1oZWlnaHQ6MS41NzE1O3RyYW5zaXRpb246Y29sb3IgLjNzIGN1YmljLWJlemllciguMjE1LC42MSwuMzU1LDEpfS5hbnQtZm9ybS1pdGVtLWV4cGxhaW4tY29ubmVjdGVke3dpZHRoOjEwMCV9LmFudC1mb3JtLWl0ZW0tZXh0cmF7bWluLWhlaWdodDoyNHB4fS5hbnQtZm9ybS1pdGVtLXdpdGgtaGVscCAuYW50LWZvcm0taXRlbS1leHBsYWlue2hlaWdodDphdXRvO29wYWNpdHk6MX0uYW50LWZvcm0taXRlbS1mZWVkYmFjay1pY29ue2ZvbnQtc2l6ZToxNHB4O3RleHQtYWxpZ246Y2VudGVyO3Zpc2liaWxpdHk6dmlzaWJsZTthbmltYXRpb246em9vbUluIC4zcyBjdWJpYy1iZXppZXIoLjEyLC40LC4yOSwxLjQ2KTtwb2ludGVyLWV2ZW50czpub25lfS5hbnQtZm9ybS1pdGVtLWZlZWRiYWNrLWljb24tc3VjY2Vzc3tjb2xvcjojNTJjNDFhfS5hbnQtZm9ybS1pdGVtLWZlZWRiYWNrLWljb24tZXJyb3J7Y29sb3I6I2ZmNGQ0Zn0uYW50LWZvcm0taXRlbS1mZWVkYmFjay1pY29uLXdhcm5pbmd7Y29sb3I6I2ZhYWQxNH0uYW50LWZvcm0taXRlbS1mZWVkYmFjay1pY29uLXZhbGlkYXRpbmd7Y29sb3I6IzE4OTBmZn0uYW50LXNob3ctaGVscHt0cmFuc2l0aW9uOm9wYWNpdHkgLjNzIGN1YmljLWJlemllciguNjQ1LC4wNDUsLjM1NSwxKX0uYW50LXNob3ctaGVscC1hcHBlYXIsLmFudC1zaG93LWhlbHAtZW50ZXJ7b3BhY2l0eTowfS5hbnQtc2hvdy1oZWxwLWFwcGVhci1hY3RpdmUsLmFudC1zaG93LWhlbHAtZW50ZXItYWN0aXZlLC5hbnQtc2hvdy1oZWxwLWxlYXZle29wYWNpdHk6MX0uYW50LXNob3ctaGVscC1sZWF2ZS1hY3RpdmV7b3BhY2l0eTowfS5hbnQtc2hvdy1oZWxwLWl0ZW17b3ZlcmZsb3c6aGlkZGVuO3RyYW5zaXRpb246aGVpZ2h0IC4zcyBjdWJpYy1iZXppZXIoLjY0NSwuMDQ1LC4zNTUsMSksb3BhY2l0eSAuM3MgY3ViaWMtYmV6aWVyKC42NDUsLjA0NSwuMzU1LDEpLHRyYW5zZm9ybSAuM3MgY3ViaWMtYmV6aWVyKC42NDUsLjA0NSwuMzU1LDEpIWltcG9ydGFudH0uYW50LXNob3ctaGVscC1pdGVtLWFwcGVhciwuYW50LXNob3ctaGVscC1pdGVtLWVudGVye3RyYW5zZm9ybTp0cmFuc2xhdGVZKC01cHgpO29wYWNpdHk6MH0uYW50LXNob3ctaGVscC1pdGVtLWFwcGVhci1hY3RpdmUsLmFudC1zaG93LWhlbHAtaXRlbS1lbnRlci1hY3RpdmV7dHJhbnNmb3JtOnRyYW5zbGF0ZVkoMCk7b3BhY2l0eToxfS5hbnQtc2hvdy1oZWxwLWl0ZW0tbGVhdmV7dHJhbnNpdGlvbjpoZWlnaHQgLjJzIGN1YmljLWJlemllciguNjQ1LC4wNDUsLjM1NSwxKSxvcGFjaXR5IC4ycyBjdWJpYy1iZXppZXIoLjY0NSwuMDQ1LC4zNTUsMSksdHJhbnNmb3JtIC4ycyBjdWJpYy1iZXppZXIoLjY0NSwuMDQ1LC4zNTUsMSkhaW1wb3J0YW50fS5hbnQtc2hvdy1oZWxwLWl0ZW0tbGVhdmUtYWN0aXZle3RyYW5zZm9ybTp0cmFuc2xhdGVZKC01cHgpfUBrZXlmcmFtZXMgZGlmZlpvb21JbjF7MCV7dHJhbnNmb3JtOnNjYWxlKDApO29wYWNpdHk6MH10b3t0cmFuc2Zvcm06c2NhbGUoMSk7b3BhY2l0eToxfX1Aa2V5ZnJhbWVzIGRpZmZab29tSW4yezAle3RyYW5zZm9ybTpzY2FsZSgwKTtvcGFjaXR5OjB9dG97dHJhbnNmb3JtOnNjYWxlKDEpO29wYWNpdHk6MX19QGtleWZyYW1lcyBkaWZmWm9vbUluM3swJXt0cmFuc2Zvcm06c2NhbGUoMCk7b3BhY2l0eTowfXRve3RyYW5zZm9ybTpzY2FsZSgxKTtvcGFjaXR5OjF9fS5hbnQtZm9ybS1ydGx7ZGlyZWN0aW9uOnJ0bH0uYW50LWZvcm0tcnRsIC5hbnQtZm9ybS1pdGVtLWxhYmVse3RleHQtYWxpZ246bGVmdH0uYW50LWZvcm0tcnRsIC5hbnQtZm9ybS1pdGVtLWxhYmVsPmxhYmVsLmFudC1mb3JtLWl0ZW0tcmVxdWlyZWQ6YmVmb3Jle21hcmdpbi1yaWdodDowO21hcmdpbi1sZWZ0OjRweH0uYW50LWZvcm0tcnRsIC5hbnQtZm9ybS1pdGVtLWxhYmVsPmxhYmVsOmFmdGVye21hcmdpbjowIDJweCAwIDhweH0uYW50LWZvcm0tcnRsIC5hbnQtZm9ybS1pdGVtLWxhYmVsPmxhYmVsIC5hbnQtZm9ybS1pdGVtLW9wdGlvbmFse21hcmdpbi1yaWdodDo0cHg7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC1ydGwgLmFudC1mb3JtLWl0ZW0tY29udHJvbDpmaXJzdC1jaGlsZHt3aWR0aDoxMDAlfS5hbnQtZm9ybS1ydGwgLmFudC1mb3JtLWl0ZW0taGFzLWZlZWRiYWNrIC5hbnQtaW5wdXR7cGFkZGluZy1yaWdodDoxMXB4O3BhZGRpbmctbGVmdDoyNHB4fS5hbnQtZm9ybS1ydGwgLmFudC1mb3JtLWl0ZW0taGFzLWZlZWRiYWNrIC5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlciAuYW50LWlucHV0LXN1ZmZpeHtwYWRkaW5nLXJpZ2h0OjExcHg7cGFkZGluZy1sZWZ0OjE4cHh9LmFudC1mb3JtLXJ0bCAuYW50LWZvcm0taXRlbS1oYXMtZmVlZGJhY2sgLmFudC1pbnB1dC1hZmZpeC13cmFwcGVyIC5hbnQtaW5wdXQsLmFudC1mb3JtLXJ0bCAuYW50LWZvcm0taXRlbS1oYXMtZmVlZGJhY2sgLmFudC1pbnB1dC1udW1iZXItYWZmaXgtd3JhcHBlciAuYW50LWlucHV0LW51bWJlcntwYWRkaW5nOjB9LmFudC1mb3JtLXJ0bCAuYW50LWZvcm0taXRlbS1oYXMtZmVlZGJhY2sgLmFudC1pbnB1dC1zZWFyY2g6bm90KC5hbnQtaW5wdXQtc2VhcmNoLWVudGVyLWJ1dHRvbikgLmFudC1pbnB1dC1zdWZmaXh7cmlnaHQ6YXV0bztsZWZ0OjI4cHh9LmFudC1mb3JtLXJ0bCAuYW50LWZvcm0taXRlbS1oYXMtZmVlZGJhY2sgLmFudC1pbnB1dC1udW1iZXJ7cGFkZGluZy1sZWZ0OjE4cHh9LmFudC1mb3JtLXJ0bCAuYW50LWZvcm0taXRlbS1oYXMtZmVlZGJhY2sgOm5vdCguYW50LWlucHV0LWdyb3VwLWFkZG9uKT4uYW50LXNlbGVjdCAuYW50LXNlbGVjdC1hcnJvdywuYW50LWZvcm0tcnRsIC5hbnQtZm9ybS1pdGVtLWhhcy1mZWVkYmFjayA6bm90KC5hbnQtaW5wdXQtZ3JvdXAtYWRkb24pPi5hbnQtc2VsZWN0IC5hbnQtc2VsZWN0LWNsZWFyLC5hbnQtZm9ybS1ydGwgLmFudC1mb3JtLWl0ZW0taGFzLWZlZWRiYWNrIDpub3QoLmFudC1pbnB1dC1udW1iZXItZ3JvdXAtYWRkb24pPi5hbnQtc2VsZWN0IC5hbnQtc2VsZWN0LWFycm93LC5hbnQtZm9ybS1ydGwgLmFudC1mb3JtLWl0ZW0taGFzLWZlZWRiYWNrIDpub3QoLmFudC1pbnB1dC1udW1iZXItZ3JvdXAtYWRkb24pPi5hbnQtc2VsZWN0IC5hbnQtc2VsZWN0LWNsZWFyLC5hbnQtZm9ybS1ydGwgLmFudC1mb3JtLWl0ZW0taGFzLWZlZWRiYWNrPi5hbnQtc2VsZWN0IC5hbnQtc2VsZWN0LWFycm93LC5hbnQtZm9ybS1ydGwgLmFudC1mb3JtLWl0ZW0taGFzLWZlZWRiYWNrPi5hbnQtc2VsZWN0IC5hbnQtc2VsZWN0LWNsZWFye3JpZ2h0OmF1dG87bGVmdDozMnB4fS5hbnQtZm9ybS1ydGwgLmFudC1mb3JtLWl0ZW0taGFzLWZlZWRiYWNrIDpub3QoLmFudC1pbnB1dC1ncm91cC1hZGRvbik+LmFudC1zZWxlY3QgLmFudC1zZWxlY3Qtc2VsZWN0aW9uLXNlbGVjdGVkLXZhbHVlLC5hbnQtZm9ybS1ydGwgLmFudC1mb3JtLWl0ZW0taGFzLWZlZWRiYWNrIDpub3QoLmFudC1pbnB1dC1udW1iZXItZ3JvdXAtYWRkb24pPi5hbnQtc2VsZWN0IC5hbnQtc2VsZWN0LXNlbGVjdGlvbi1zZWxlY3RlZC12YWx1ZSwuYW50LWZvcm0tcnRsIC5hbnQtZm9ybS1pdGVtLWhhcy1mZWVkYmFjaz4uYW50LXNlbGVjdCAuYW50LXNlbGVjdC1zZWxlY3Rpb24tc2VsZWN0ZWQtdmFsdWV7cGFkZGluZy1yaWdodDowO3BhZGRpbmctbGVmdDo0MnB4fS5hbnQtZm9ybS1ydGwgLmFudC1mb3JtLWl0ZW0taGFzLWZlZWRiYWNrIC5hbnQtY2FzY2FkZXItcGlja2VyLWFycm93e21hcmdpbi1yaWdodDowO21hcmdpbi1sZWZ0OjE5cHh9LmFudC1mb3JtLXJ0bCAuYW50LWZvcm0taXRlbS1oYXMtZmVlZGJhY2sgLmFudC1jYXNjYWRlci1waWNrZXItY2xlYXJ7cmlnaHQ6YXV0bztsZWZ0OjMycHh9LmFudC1mb3JtLXJ0bCAuYW50LWZvcm0taXRlbS1oYXMtZmVlZGJhY2sgLmFudC1waWNrZXIsLmFudC1mb3JtLXJ0bCAuYW50LWZvcm0taXRlbS1oYXMtZmVlZGJhY2sgLmFudC1waWNrZXItbGFyZ2V7cGFkZGluZy1yaWdodDoxMXB4O3BhZGRpbmctbGVmdDoyOS4ycHh9LmFudC1mb3JtLXJ0bCAuYW50LWZvcm0taXRlbS1oYXMtZmVlZGJhY2sgLmFudC1waWNrZXItc21hbGx7cGFkZGluZy1yaWdodDo3cHg7cGFkZGluZy1sZWZ0OjI1LjJweH0uYW50LWZvcm0tcnRsIC5hbnQtZm9ybS1pdGVtLWhhcy1mZWVkYmFjay5hbnQtZm9ybS1pdGVtLWhhcy1lcnJvciAuYW50LWZvcm0taXRlbS1jaGlsZHJlbi1pY29uLC5hbnQtZm9ybS1ydGwgLmFudC1mb3JtLWl0ZW0taGFzLWZlZWRiYWNrLmFudC1mb3JtLWl0ZW0taGFzLXN1Y2Nlc3MgLmFudC1mb3JtLWl0ZW0tY2hpbGRyZW4taWNvbiwuYW50LWZvcm0tcnRsIC5hbnQtZm9ybS1pdGVtLWhhcy1mZWVkYmFjay5hbnQtZm9ybS1pdGVtLWhhcy13YXJuaW5nIC5hbnQtZm9ybS1pdGVtLWNoaWxkcmVuLWljb24sLmFudC1mb3JtLXJ0bCAuYW50LWZvcm0taXRlbS1oYXMtZmVlZGJhY2suYW50LWZvcm0taXRlbS1pcy12YWxpZGF0aW5nIC5hbnQtZm9ybS1pdGVtLWNoaWxkcmVuLWljb257cmlnaHQ6YXV0bztsZWZ0OjB9LmFudC1mb3JtLXJ0bC5hbnQtZm9ybS1pbmxpbmUgLmFudC1mb3JtLWl0ZW17bWFyZ2luLXJpZ2h0OjA7bWFyZ2luLWxlZnQ6MTZweH0uYW50LXJvd3tmbGV4LWZsb3c6cm93IHdyYXA7bWluLXdpZHRoOjB9LmFudC1yb3csLmFudC1yb3c6YWZ0ZXIsLmFudC1yb3c6YmVmb3Jle2Rpc3BsYXk6ZmxleH0uYW50LXJvdy1uby13cmFwe2ZsZXgtd3JhcDpub3dyYXB9LmFudC1yb3ctc3RhcnR7anVzdGlmeS1jb250ZW50OmZsZXgtc3RhcnR9LmFudC1yb3ctY2VudGVye2p1c3RpZnktY29udGVudDpjZW50ZXJ9LmFudC1yb3ctZW5ke2p1c3RpZnktY29udGVudDpmbGV4LWVuZH0uYW50LXJvdy1zcGFjZS1iZXR3ZWVue2p1c3RpZnktY29udGVudDpzcGFjZS1iZXR3ZWVufS5hbnQtcm93LXNwYWNlLWFyb3VuZHtqdXN0aWZ5LWNvbnRlbnQ6c3BhY2UtYXJvdW5kfS5hbnQtcm93LXNwYWNlLWV2ZW5seXtqdXN0aWZ5LWNvbnRlbnQ6c3BhY2UtZXZlbmx5fS5hbnQtcm93LXRvcHthbGlnbi1pdGVtczpmbGV4LXN0YXJ0fS5hbnQtcm93LW1pZGRsZXthbGlnbi1pdGVtczpjZW50ZXJ9LmFudC1yb3ctYm90dG9te2FsaWduLWl0ZW1zOmZsZXgtZW5kfS5hbnQtY29se3Bvc2l0aW9uOnJlbGF0aXZlO21heC13aWR0aDoxMDAlO21pbi1oZWlnaHQ6MXB4fS5hbnQtY29sLTI0e2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgMTAwJTttYXgtd2lkdGg6MTAwJX0uYW50LWNvbC1wdXNoLTI0e2xlZnQ6MTAwJX0uYW50LWNvbC1wdWxsLTI0e3JpZ2h0OjEwMCV9LmFudC1jb2wtb2Zmc2V0LTI0e21hcmdpbi1sZWZ0OjEwMCV9LmFudC1jb2wtb3JkZXItMjR7b3JkZXI6MjR9LmFudC1jb2wtMjN7ZGlzcGxheTpibG9jaztmbGV4OjAgMCA5NS44MzMzMzMzMyU7bWF4LXdpZHRoOjk1LjgzMzMzMzMzJX0uYW50LWNvbC1wdXNoLTIze2xlZnQ6OTUuODMzMzMzMzMlfS5hbnQtY29sLXB1bGwtMjN7cmlnaHQ6OTUuODMzMzMzMzMlfS5hbnQtY29sLW9mZnNldC0yM3ttYXJnaW4tbGVmdDo5NS44MzMzMzMzMyV9LmFudC1jb2wtb3JkZXItMjN7b3JkZXI6MjN9LmFudC1jb2wtMjJ7ZGlzcGxheTpibG9jaztmbGV4OjAgMCA5MS42NjY2NjY2NyU7bWF4LXdpZHRoOjkxLjY2NjY2NjY3JX0uYW50LWNvbC1wdXNoLTIye2xlZnQ6OTEuNjY2NjY2NjclfS5hbnQtY29sLXB1bGwtMjJ7cmlnaHQ6OTEuNjY2NjY2NjclfS5hbnQtY29sLW9mZnNldC0yMnttYXJnaW4tbGVmdDo5MS42NjY2NjY2NyV9LmFudC1jb2wtb3JkZXItMjJ7b3JkZXI6MjJ9LmFudC1jb2wtMjF7ZGlzcGxheTpibG9jaztmbGV4OjAgMCA4Ny41JTttYXgtd2lkdGg6ODcuNSV9LmFudC1jb2wtcHVzaC0yMXtsZWZ0Ojg3LjUlfS5hbnQtY29sLXB1bGwtMjF7cmlnaHQ6ODcuNSV9LmFudC1jb2wtb2Zmc2V0LTIxe21hcmdpbi1sZWZ0Ojg3LjUlfS5hbnQtY29sLW9yZGVyLTIxe29yZGVyOjIxfS5hbnQtY29sLTIwe2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgODMuMzMzMzMzMzMlO21heC13aWR0aDo4My4zMzMzMzMzMyV9LmFudC1jb2wtcHVzaC0yMHtsZWZ0OjgzLjMzMzMzMzMzJX0uYW50LWNvbC1wdWxsLTIwe3JpZ2h0OjgzLjMzMzMzMzMzJX0uYW50LWNvbC1vZmZzZXQtMjB7bWFyZ2luLWxlZnQ6ODMuMzMzMzMzMzMlfS5hbnQtY29sLW9yZGVyLTIwe29yZGVyOjIwfS5hbnQtY29sLTE5e2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgNzkuMTY2NjY2NjclO21heC13aWR0aDo3OS4xNjY2NjY2NyV9LmFudC1jb2wtcHVzaC0xOXtsZWZ0Ojc5LjE2NjY2NjY3JX0uYW50LWNvbC1wdWxsLTE5e3JpZ2h0Ojc5LjE2NjY2NjY3JX0uYW50LWNvbC1vZmZzZXQtMTl7bWFyZ2luLWxlZnQ6NzkuMTY2NjY2NjclfS5hbnQtY29sLW9yZGVyLTE5e29yZGVyOjE5fS5hbnQtY29sLTE4e2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgNzUlO21heC13aWR0aDo3NSV9LmFudC1jb2wtcHVzaC0xOHtsZWZ0Ojc1JX0uYW50LWNvbC1wdWxsLTE4e3JpZ2h0Ojc1JX0uYW50LWNvbC1vZmZzZXQtMTh7bWFyZ2luLWxlZnQ6NzUlfS5hbnQtY29sLW9yZGVyLTE4e29yZGVyOjE4fS5hbnQtY29sLTE3e2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgNzAuODMzMzMzMzMlO21heC13aWR0aDo3MC44MzMzMzMzMyV9LmFudC1jb2wtcHVzaC0xN3tsZWZ0OjcwLjgzMzMzMzMzJX0uYW50LWNvbC1wdWxsLTE3e3JpZ2h0OjcwLjgzMzMzMzMzJX0uYW50LWNvbC1vZmZzZXQtMTd7bWFyZ2luLWxlZnQ6NzAuODMzMzMzMzMlfS5hbnQtY29sLW9yZGVyLTE3e29yZGVyOjE3fS5hbnQtY29sLTE2e2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgNjYuNjY2NjY2NjclO21heC13aWR0aDo2Ni42NjY2NjY2NyV9LmFudC1jb2wtcHVzaC0xNntsZWZ0OjY2LjY2NjY2NjY3JX0uYW50LWNvbC1wdWxsLTE2e3JpZ2h0OjY2LjY2NjY2NjY3JX0uYW50LWNvbC1vZmZzZXQtMTZ7bWFyZ2luLWxlZnQ6NjYuNjY2NjY2NjclfS5hbnQtY29sLW9yZGVyLTE2e29yZGVyOjE2fS5hbnQtY29sLTE1e2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgNjIuNSU7bWF4LXdpZHRoOjYyLjUlfS5hbnQtY29sLXB1c2gtMTV7bGVmdDo2Mi41JX0uYW50LWNvbC1wdWxsLTE1e3JpZ2h0OjYyLjUlfS5hbnQtY29sLW9mZnNldC0xNXttYXJnaW4tbGVmdDo2Mi41JX0uYW50LWNvbC1vcmRlci0xNXtvcmRlcjoxNX0uYW50LWNvbC0xNHtkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDU4LjMzMzMzMzMzJTttYXgtd2lkdGg6NTguMzMzMzMzMzMlfS5hbnQtY29sLXB1c2gtMTR7bGVmdDo1OC4zMzMzMzMzMyV9LmFudC1jb2wtcHVsbC0xNHtyaWdodDo1OC4zMzMzMzMzMyV9LmFudC1jb2wtb2Zmc2V0LTE0e21hcmdpbi1sZWZ0OjU4LjMzMzMzMzMzJX0uYW50LWNvbC1vcmRlci0xNHtvcmRlcjoxNH0uYW50LWNvbC0xM3tkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDU0LjE2NjY2NjY3JTttYXgtd2lkdGg6NTQuMTY2NjY2NjclfS5hbnQtY29sLXB1c2gtMTN7bGVmdDo1NC4xNjY2NjY2NyV9LmFudC1jb2wtcHVsbC0xM3tyaWdodDo1NC4xNjY2NjY2NyV9LmFudC1jb2wtb2Zmc2V0LTEze21hcmdpbi1sZWZ0OjU0LjE2NjY2NjY3JX0uYW50LWNvbC1vcmRlci0xM3tvcmRlcjoxM30uYW50LWNvbC0xMntkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDUwJTttYXgtd2lkdGg6NTAlfS5hbnQtY29sLXB1c2gtMTJ7bGVmdDo1MCV9LmFudC1jb2wtcHVsbC0xMntyaWdodDo1MCV9LmFudC1jb2wtb2Zmc2V0LTEye21hcmdpbi1sZWZ0OjUwJX0uYW50LWNvbC1vcmRlci0xMntvcmRlcjoxMn0uYW50LWNvbC0xMXtkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDQ1LjgzMzMzMzMzJTttYXgtd2lkdGg6NDUuODMzMzMzMzMlfS5hbnQtY29sLXB1c2gtMTF7bGVmdDo0NS44MzMzMzMzMyV9LmFudC1jb2wtcHVsbC0xMXtyaWdodDo0NS44MzMzMzMzMyV9LmFudC1jb2wtb2Zmc2V0LTExe21hcmdpbi1sZWZ0OjQ1LjgzMzMzMzMzJX0uYW50LWNvbC1vcmRlci0xMXtvcmRlcjoxMX0uYW50LWNvbC0xMHtkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDQxLjY2NjY2NjY3JTttYXgtd2lkdGg6NDEuNjY2NjY2NjclfS5hbnQtY29sLXB1c2gtMTB7bGVmdDo0MS42NjY2NjY2NyV9LmFudC1jb2wtcHVsbC0xMHtyaWdodDo0MS42NjY2NjY2NyV9LmFudC1jb2wtb2Zmc2V0LTEwe21hcmdpbi1sZWZ0OjQxLjY2NjY2NjY3JX0uYW50LWNvbC1vcmRlci0xMHtvcmRlcjoxMH0uYW50LWNvbC05e2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgMzcuNSU7bWF4LXdpZHRoOjM3LjUlfS5hbnQtY29sLXB1c2gtOXtsZWZ0OjM3LjUlfS5hbnQtY29sLXB1bGwtOXtyaWdodDozNy41JX0uYW50LWNvbC1vZmZzZXQtOXttYXJnaW4tbGVmdDozNy41JX0uYW50LWNvbC1vcmRlci05e29yZGVyOjl9LmFudC1jb2wtOHtkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDMzLjMzMzMzMzMzJTttYXgtd2lkdGg6MzMuMzMzMzMzMzMlfS5hbnQtY29sLXB1c2gtOHtsZWZ0OjMzLjMzMzMzMzMzJX0uYW50LWNvbC1wdWxsLTh7cmlnaHQ6MzMuMzMzMzMzMzMlfS5hbnQtY29sLW9mZnNldC04e21hcmdpbi1sZWZ0OjMzLjMzMzMzMzMzJX0uYW50LWNvbC1vcmRlci04e29yZGVyOjh9LmFudC1jb2wtN3tkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDI5LjE2NjY2NjY3JTttYXgtd2lkdGg6MjkuMTY2NjY2NjclfS5hbnQtY29sLXB1c2gtN3tsZWZ0OjI5LjE2NjY2NjY3JX0uYW50LWNvbC1wdWxsLTd7cmlnaHQ6MjkuMTY2NjY2NjclfS5hbnQtY29sLW9mZnNldC03e21hcmdpbi1sZWZ0OjI5LjE2NjY2NjY3JX0uYW50LWNvbC1vcmRlci03e29yZGVyOjd9LmFudC1jb2wtNntkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDI1JTttYXgtd2lkdGg6MjUlfS5hbnQtY29sLXB1c2gtNntsZWZ0OjI1JX0uYW50LWNvbC1wdWxsLTZ7cmlnaHQ6MjUlfS5hbnQtY29sLW9mZnNldC02e21hcmdpbi1sZWZ0OjI1JX0uYW50LWNvbC1vcmRlci02e29yZGVyOjZ9LmFudC1jb2wtNXtkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDIwLjgzMzMzMzMzJTttYXgtd2lkdGg6MjAuODMzMzMzMzMlfS5hbnQtY29sLXB1c2gtNXtsZWZ0OjIwLjgzMzMzMzMzJX0uYW50LWNvbC1wdWxsLTV7cmlnaHQ6MjAuODMzMzMzMzMlfS5hbnQtY29sLW9mZnNldC01e21hcmdpbi1sZWZ0OjIwLjgzMzMzMzMzJX0uYW50LWNvbC1vcmRlci01e29yZGVyOjV9LmFudC1jb2wtNHtkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDE2LjY2NjY2NjY3JTttYXgtd2lkdGg6MTYuNjY2NjY2NjclfS5hbnQtY29sLXB1c2gtNHtsZWZ0OjE2LjY2NjY2NjY3JX0uYW50LWNvbC1wdWxsLTR7cmlnaHQ6MTYuNjY2NjY2NjclfS5hbnQtY29sLW9mZnNldC00e21hcmdpbi1sZWZ0OjE2LjY2NjY2NjY3JX0uYW50LWNvbC1vcmRlci00e29yZGVyOjR9LmFudC1jb2wtM3tkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDEyLjUlO21heC13aWR0aDoxMi41JX0uYW50LWNvbC1wdXNoLTN7bGVmdDoxMi41JX0uYW50LWNvbC1wdWxsLTN7cmlnaHQ6MTIuNSV9LmFudC1jb2wtb2Zmc2V0LTN7bWFyZ2luLWxlZnQ6MTIuNSV9LmFudC1jb2wtb3JkZXItM3tvcmRlcjozfS5hbnQtY29sLTJ7ZGlzcGxheTpibG9jaztmbGV4OjAgMCA4LjMzMzMzMzMzJTttYXgtd2lkdGg6OC4zMzMzMzMzMyV9LmFudC1jb2wtcHVzaC0ye2xlZnQ6OC4zMzMzMzMzMyV9LmFudC1jb2wtcHVsbC0ye3JpZ2h0OjguMzMzMzMzMzMlfS5hbnQtY29sLW9mZnNldC0ye21hcmdpbi1sZWZ0OjguMzMzMzMzMzMlfS5hbnQtY29sLW9yZGVyLTJ7b3JkZXI6Mn0uYW50LWNvbC0xe2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgNC4xNjY2NjY2NyU7bWF4LXdpZHRoOjQuMTY2NjY2NjclfS5hbnQtY29sLXB1c2gtMXtsZWZ0OjQuMTY2NjY2NjclfS5hbnQtY29sLXB1bGwtMXtyaWdodDo0LjE2NjY2NjY3JX0uYW50LWNvbC1vZmZzZXQtMXttYXJnaW4tbGVmdDo0LjE2NjY2NjY3JX0uYW50LWNvbC1vcmRlci0xe29yZGVyOjF9LmFudC1jb2wtMHtkaXNwbGF5Om5vbmV9LmFudC1jb2wtb2Zmc2V0LTB7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC1vcmRlci0we29yZGVyOjB9LmFudC1jb2wtb2Zmc2V0LTAuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjB9LmFudC1jb2wtcHVzaC0xLmFudC1jb2wtcnRse3JpZ2h0OjQuMTY2NjY2NjclO2xlZnQ6YXV0b30uYW50LWNvbC1wdWxsLTEuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjQuMTY2NjY2NjclfS5hbnQtY29sLW9mZnNldC0xLmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo0LjE2NjY2NjY3JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLXB1c2gtMi5hbnQtY29sLXJ0bHtyaWdodDo4LjMzMzMzMzMzJTtsZWZ0OmF1dG99LmFudC1jb2wtcHVsbC0yLmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo4LjMzMzMzMzMzJX0uYW50LWNvbC1vZmZzZXQtMi5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6OC4zMzMzMzMzMyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC1wdXNoLTMuYW50LWNvbC1ydGx7cmlnaHQ6MTIuNSU7bGVmdDphdXRvfS5hbnQtY29sLXB1bGwtMy5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6MTIuNSV9LmFudC1jb2wtb2Zmc2V0LTMuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjEyLjUlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wtcHVzaC00LmFudC1jb2wtcnRse3JpZ2h0OjE2LjY2NjY2NjY3JTtsZWZ0OmF1dG99LmFudC1jb2wtcHVsbC00LmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDoxNi42NjY2NjY2NyV9LmFudC1jb2wtb2Zmc2V0LTQuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjE2LjY2NjY2NjY3JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLXB1c2gtNS5hbnQtY29sLXJ0bHtyaWdodDoyMC44MzMzMzMzMyU7bGVmdDphdXRvfS5hbnQtY29sLXB1bGwtNS5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6MjAuODMzMzMzMzMlfS5hbnQtY29sLW9mZnNldC01LmFudC1jb2wtcnRse21hcmdpbi1yaWdodDoyMC44MzMzMzMzMyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC1wdXNoLTYuYW50LWNvbC1ydGx7cmlnaHQ6MjUlO2xlZnQ6YXV0b30uYW50LWNvbC1wdWxsLTYuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjI1JX0uYW50LWNvbC1vZmZzZXQtNi5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6MjUlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wtcHVzaC03LmFudC1jb2wtcnRse3JpZ2h0OjI5LjE2NjY2NjY3JTtsZWZ0OmF1dG99LmFudC1jb2wtcHVsbC03LmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDoyOS4xNjY2NjY2NyV9LmFudC1jb2wtb2Zmc2V0LTcuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjI5LjE2NjY2NjY3JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLXB1c2gtOC5hbnQtY29sLXJ0bHtyaWdodDozMy4zMzMzMzMzMyU7bGVmdDphdXRvfS5hbnQtY29sLXB1bGwtOC5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6MzMuMzMzMzMzMzMlfS5hbnQtY29sLW9mZnNldC04LmFudC1jb2wtcnRse21hcmdpbi1yaWdodDozMy4zMzMzMzMzMyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC1wdXNoLTkuYW50LWNvbC1ydGx7cmlnaHQ6MzcuNSU7bGVmdDphdXRvfS5hbnQtY29sLXB1bGwtOS5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6MzcuNSV9LmFudC1jb2wtb2Zmc2V0LTkuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjM3LjUlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wtcHVzaC0xMC5hbnQtY29sLXJ0bHtyaWdodDo0MS42NjY2NjY2NyU7bGVmdDphdXRvfS5hbnQtY29sLXB1bGwtMTAuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjQxLjY2NjY2NjY3JX0uYW50LWNvbC1vZmZzZXQtMTAuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjQxLjY2NjY2NjY3JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLXB1c2gtMTEuYW50LWNvbC1ydGx7cmlnaHQ6NDUuODMzMzMzMzMlO2xlZnQ6YXV0b30uYW50LWNvbC1wdWxsLTExLmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo0NS44MzMzMzMzMyV9LmFudC1jb2wtb2Zmc2V0LTExLmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo0NS44MzMzMzMzMyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC1wdXNoLTEyLmFudC1jb2wtcnRse3JpZ2h0OjUwJTtsZWZ0OmF1dG99LmFudC1jb2wtcHVsbC0xMi5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6NTAlfS5hbnQtY29sLW9mZnNldC0xMi5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6NTAlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wtcHVzaC0xMy5hbnQtY29sLXJ0bHtyaWdodDo1NC4xNjY2NjY2NyU7bGVmdDphdXRvfS5hbnQtY29sLXB1bGwtMTMuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjU0LjE2NjY2NjY3JX0uYW50LWNvbC1vZmZzZXQtMTMuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjU0LjE2NjY2NjY3JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLXB1c2gtMTQuYW50LWNvbC1ydGx7cmlnaHQ6NTguMzMzMzMzMzMlO2xlZnQ6YXV0b30uYW50LWNvbC1wdWxsLTE0LmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo1OC4zMzMzMzMzMyV9LmFudC1jb2wtb2Zmc2V0LTE0LmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo1OC4zMzMzMzMzMyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC1wdXNoLTE1LmFudC1jb2wtcnRse3JpZ2h0OjYyLjUlO2xlZnQ6YXV0b30uYW50LWNvbC1wdWxsLTE1LmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo2Mi41JX0uYW50LWNvbC1vZmZzZXQtMTUuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjYyLjUlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wtcHVzaC0xNi5hbnQtY29sLXJ0bHtyaWdodDo2Ni42NjY2NjY2NyU7bGVmdDphdXRvfS5hbnQtY29sLXB1bGwtMTYuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjY2LjY2NjY2NjY3JX0uYW50LWNvbC1vZmZzZXQtMTYuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjY2LjY2NjY2NjY3JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLXB1c2gtMTcuYW50LWNvbC1ydGx7cmlnaHQ6NzAuODMzMzMzMzMlO2xlZnQ6YXV0b30uYW50LWNvbC1wdWxsLTE3LmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo3MC44MzMzMzMzMyV9LmFudC1jb2wtb2Zmc2V0LTE3LmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo3MC44MzMzMzMzMyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC1wdXNoLTE4LmFudC1jb2wtcnRse3JpZ2h0Ojc1JTtsZWZ0OmF1dG99LmFudC1jb2wtcHVsbC0xOC5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6NzUlfS5hbnQtY29sLW9mZnNldC0xOC5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6NzUlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wtcHVzaC0xOS5hbnQtY29sLXJ0bHtyaWdodDo3OS4xNjY2NjY2NyU7bGVmdDphdXRvfS5hbnQtY29sLXB1bGwtMTkuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0Ojc5LjE2NjY2NjY3JX0uYW50LWNvbC1vZmZzZXQtMTkuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0Ojc5LjE2NjY2NjY3JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLXB1c2gtMjAuYW50LWNvbC1ydGx7cmlnaHQ6ODMuMzMzMzMzMzMlO2xlZnQ6YXV0b30uYW50LWNvbC1wdWxsLTIwLmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo4My4zMzMzMzMzMyV9LmFudC1jb2wtb2Zmc2V0LTIwLmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo4My4zMzMzMzMzMyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC1wdXNoLTIxLmFudC1jb2wtcnRse3JpZ2h0Ojg3LjUlO2xlZnQ6YXV0b30uYW50LWNvbC1wdWxsLTIxLmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo4Ny41JX0uYW50LWNvbC1vZmZzZXQtMjEuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0Ojg3LjUlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wtcHVzaC0yMi5hbnQtY29sLXJ0bHtyaWdodDo5MS42NjY2NjY2NyU7bGVmdDphdXRvfS5hbnQtY29sLXB1bGwtMjIuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjkxLjY2NjY2NjY3JX0uYW50LWNvbC1vZmZzZXQtMjIuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjkxLjY2NjY2NjY3JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLXB1c2gtMjMuYW50LWNvbC1ydGx7cmlnaHQ6OTUuODMzMzMzMzMlO2xlZnQ6YXV0b30uYW50LWNvbC1wdWxsLTIzLmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo5NS44MzMzMzMzMyV9LmFudC1jb2wtb2Zmc2V0LTIzLmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo5NS44MzMzMzMzMyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC1wdXNoLTI0LmFudC1jb2wtcnRse3JpZ2h0OjEwMCU7bGVmdDphdXRvfS5hbnQtY29sLXB1bGwtMjQuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjEwMCV9LmFudC1jb2wtb2Zmc2V0LTI0LmFudC1jb2wtcnRse21hcmdpbi1yaWdodDoxMDAlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wteHMtMjR7ZGlzcGxheTpibG9jaztmbGV4OjAgMCAxMDAlO21heC13aWR0aDoxMDAlfS5hbnQtY29sLXhzLXB1c2gtMjR7bGVmdDoxMDAlfS5hbnQtY29sLXhzLXB1bGwtMjR7cmlnaHQ6MTAwJX0uYW50LWNvbC14cy1vZmZzZXQtMjR7bWFyZ2luLWxlZnQ6MTAwJX0uYW50LWNvbC14cy1vcmRlci0yNHtvcmRlcjoyNH0uYW50LWNvbC14cy0yM3tkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDk1LjgzMzMzMzMzJTttYXgtd2lkdGg6OTUuODMzMzMzMzMlfS5hbnQtY29sLXhzLXB1c2gtMjN7bGVmdDo5NS44MzMzMzMzMyV9LmFudC1jb2wteHMtcHVsbC0yM3tyaWdodDo5NS44MzMzMzMzMyV9LmFudC1jb2wteHMtb2Zmc2V0LTIze21hcmdpbi1sZWZ0Ojk1LjgzMzMzMzMzJX0uYW50LWNvbC14cy1vcmRlci0yM3tvcmRlcjoyM30uYW50LWNvbC14cy0yMntkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDkxLjY2NjY2NjY3JTttYXgtd2lkdGg6OTEuNjY2NjY2NjclfS5hbnQtY29sLXhzLXB1c2gtMjJ7bGVmdDo5MS42NjY2NjY2NyV9LmFudC1jb2wteHMtcHVsbC0yMntyaWdodDo5MS42NjY2NjY2NyV9LmFudC1jb2wteHMtb2Zmc2V0LTIye21hcmdpbi1sZWZ0OjkxLjY2NjY2NjY3JX0uYW50LWNvbC14cy1vcmRlci0yMntvcmRlcjoyMn0uYW50LWNvbC14cy0yMXtkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDg3LjUlO21heC13aWR0aDo4Ny41JX0uYW50LWNvbC14cy1wdXNoLTIxe2xlZnQ6ODcuNSV9LmFudC1jb2wteHMtcHVsbC0yMXtyaWdodDo4Ny41JX0uYW50LWNvbC14cy1vZmZzZXQtMjF7bWFyZ2luLWxlZnQ6ODcuNSV9LmFudC1jb2wteHMtb3JkZXItMjF7b3JkZXI6MjF9LmFudC1jb2wteHMtMjB7ZGlzcGxheTpibG9jaztmbGV4OjAgMCA4My4zMzMzMzMzMyU7bWF4LXdpZHRoOjgzLjMzMzMzMzMzJX0uYW50LWNvbC14cy1wdXNoLTIwe2xlZnQ6ODMuMzMzMzMzMzMlfS5hbnQtY29sLXhzLXB1bGwtMjB7cmlnaHQ6ODMuMzMzMzMzMzMlfS5hbnQtY29sLXhzLW9mZnNldC0yMHttYXJnaW4tbGVmdDo4My4zMzMzMzMzMyV9LmFudC1jb2wteHMtb3JkZXItMjB7b3JkZXI6MjB9LmFudC1jb2wteHMtMTl7ZGlzcGxheTpibG9jaztmbGV4OjAgMCA3OS4xNjY2NjY2NyU7bWF4LXdpZHRoOjc5LjE2NjY2NjY3JX0uYW50LWNvbC14cy1wdXNoLTE5e2xlZnQ6NzkuMTY2NjY2NjclfS5hbnQtY29sLXhzLXB1bGwtMTl7cmlnaHQ6NzkuMTY2NjY2NjclfS5hbnQtY29sLXhzLW9mZnNldC0xOXttYXJnaW4tbGVmdDo3OS4xNjY2NjY2NyV9LmFudC1jb2wteHMtb3JkZXItMTl7b3JkZXI6MTl9LmFudC1jb2wteHMtMTh7ZGlzcGxheTpibG9jaztmbGV4OjAgMCA3NSU7bWF4LXdpZHRoOjc1JX0uYW50LWNvbC14cy1wdXNoLTE4e2xlZnQ6NzUlfS5hbnQtY29sLXhzLXB1bGwtMTh7cmlnaHQ6NzUlfS5hbnQtY29sLXhzLW9mZnNldC0xOHttYXJnaW4tbGVmdDo3NSV9LmFudC1jb2wteHMtb3JkZXItMTh7b3JkZXI6MTh9LmFudC1jb2wteHMtMTd7ZGlzcGxheTpibG9jaztmbGV4OjAgMCA3MC44MzMzMzMzMyU7bWF4LXdpZHRoOjcwLjgzMzMzMzMzJX0uYW50LWNvbC14cy1wdXNoLTE3e2xlZnQ6NzAuODMzMzMzMzMlfS5hbnQtY29sLXhzLXB1bGwtMTd7cmlnaHQ6NzAuODMzMzMzMzMlfS5hbnQtY29sLXhzLW9mZnNldC0xN3ttYXJnaW4tbGVmdDo3MC44MzMzMzMzMyV9LmFudC1jb2wteHMtb3JkZXItMTd7b3JkZXI6MTd9LmFudC1jb2wteHMtMTZ7ZGlzcGxheTpibG9jaztmbGV4OjAgMCA2Ni42NjY2NjY2NyU7bWF4LXdpZHRoOjY2LjY2NjY2NjY3JX0uYW50LWNvbC14cy1wdXNoLTE2e2xlZnQ6NjYuNjY2NjY2NjclfS5hbnQtY29sLXhzLXB1bGwtMTZ7cmlnaHQ6NjYuNjY2NjY2NjclfS5hbnQtY29sLXhzLW9mZnNldC0xNnttYXJnaW4tbGVmdDo2Ni42NjY2NjY2NyV9LmFudC1jb2wteHMtb3JkZXItMTZ7b3JkZXI6MTZ9LmFudC1jb2wteHMtMTV7ZGlzcGxheTpibG9jaztmbGV4OjAgMCA2Mi41JTttYXgtd2lkdGg6NjIuNSV9LmFudC1jb2wteHMtcHVzaC0xNXtsZWZ0OjYyLjUlfS5hbnQtY29sLXhzLXB1bGwtMTV7cmlnaHQ6NjIuNSV9LmFudC1jb2wteHMtb2Zmc2V0LTE1e21hcmdpbi1sZWZ0OjYyLjUlfS5hbnQtY29sLXhzLW9yZGVyLTE1e29yZGVyOjE1fS5hbnQtY29sLXhzLTE0e2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgNTguMzMzMzMzMzMlO21heC13aWR0aDo1OC4zMzMzMzMzMyV9LmFudC1jb2wteHMtcHVzaC0xNHtsZWZ0OjU4LjMzMzMzMzMzJX0uYW50LWNvbC14cy1wdWxsLTE0e3JpZ2h0OjU4LjMzMzMzMzMzJX0uYW50LWNvbC14cy1vZmZzZXQtMTR7bWFyZ2luLWxlZnQ6NTguMzMzMzMzMzMlfS5hbnQtY29sLXhzLW9yZGVyLTE0e29yZGVyOjE0fS5hbnQtY29sLXhzLTEze2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgNTQuMTY2NjY2NjclO21heC13aWR0aDo1NC4xNjY2NjY2NyV9LmFudC1jb2wteHMtcHVzaC0xM3tsZWZ0OjU0LjE2NjY2NjY3JX0uYW50LWNvbC14cy1wdWxsLTEze3JpZ2h0OjU0LjE2NjY2NjY3JX0uYW50LWNvbC14cy1vZmZzZXQtMTN7bWFyZ2luLWxlZnQ6NTQuMTY2NjY2NjclfS5hbnQtY29sLXhzLW9yZGVyLTEze29yZGVyOjEzfS5hbnQtY29sLXhzLTEye2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgNTAlO21heC13aWR0aDo1MCV9LmFudC1jb2wteHMtcHVzaC0xMntsZWZ0OjUwJX0uYW50LWNvbC14cy1wdWxsLTEye3JpZ2h0OjUwJX0uYW50LWNvbC14cy1vZmZzZXQtMTJ7bWFyZ2luLWxlZnQ6NTAlfS5hbnQtY29sLXhzLW9yZGVyLTEye29yZGVyOjEyfS5hbnQtY29sLXhzLTExe2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgNDUuODMzMzMzMzMlO21heC13aWR0aDo0NS44MzMzMzMzMyV9LmFudC1jb2wteHMtcHVzaC0xMXtsZWZ0OjQ1LjgzMzMzMzMzJX0uYW50LWNvbC14cy1wdWxsLTExe3JpZ2h0OjQ1LjgzMzMzMzMzJX0uYW50LWNvbC14cy1vZmZzZXQtMTF7bWFyZ2luLWxlZnQ6NDUuODMzMzMzMzMlfS5hbnQtY29sLXhzLW9yZGVyLTExe29yZGVyOjExfS5hbnQtY29sLXhzLTEwe2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgNDEuNjY2NjY2NjclO21heC13aWR0aDo0MS42NjY2NjY2NyV9LmFudC1jb2wteHMtcHVzaC0xMHtsZWZ0OjQxLjY2NjY2NjY3JX0uYW50LWNvbC14cy1wdWxsLTEwe3JpZ2h0OjQxLjY2NjY2NjY3JX0uYW50LWNvbC14cy1vZmZzZXQtMTB7bWFyZ2luLWxlZnQ6NDEuNjY2NjY2NjclfS5hbnQtY29sLXhzLW9yZGVyLTEwe29yZGVyOjEwfS5hbnQtY29sLXhzLTl7ZGlzcGxheTpibG9jaztmbGV4OjAgMCAzNy41JTttYXgtd2lkdGg6MzcuNSV9LmFudC1jb2wteHMtcHVzaC05e2xlZnQ6MzcuNSV9LmFudC1jb2wteHMtcHVsbC05e3JpZ2h0OjM3LjUlfS5hbnQtY29sLXhzLW9mZnNldC05e21hcmdpbi1sZWZ0OjM3LjUlfS5hbnQtY29sLXhzLW9yZGVyLTl7b3JkZXI6OX0uYW50LWNvbC14cy04e2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgMzMuMzMzMzMzMzMlO21heC13aWR0aDozMy4zMzMzMzMzMyV9LmFudC1jb2wteHMtcHVzaC04e2xlZnQ6MzMuMzMzMzMzMzMlfS5hbnQtY29sLXhzLXB1bGwtOHtyaWdodDozMy4zMzMzMzMzMyV9LmFudC1jb2wteHMtb2Zmc2V0LTh7bWFyZ2luLWxlZnQ6MzMuMzMzMzMzMzMlfS5hbnQtY29sLXhzLW9yZGVyLTh7b3JkZXI6OH0uYW50LWNvbC14cy03e2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgMjkuMTY2NjY2NjclO21heC13aWR0aDoyOS4xNjY2NjY2NyV9LmFudC1jb2wteHMtcHVzaC03e2xlZnQ6MjkuMTY2NjY2NjclfS5hbnQtY29sLXhzLXB1bGwtN3tyaWdodDoyOS4xNjY2NjY2NyV9LmFudC1jb2wteHMtb2Zmc2V0LTd7bWFyZ2luLWxlZnQ6MjkuMTY2NjY2NjclfS5hbnQtY29sLXhzLW9yZGVyLTd7b3JkZXI6N30uYW50LWNvbC14cy02e2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgMjUlO21heC13aWR0aDoyNSV9LmFudC1jb2wteHMtcHVzaC02e2xlZnQ6MjUlfS5hbnQtY29sLXhzLXB1bGwtNntyaWdodDoyNSV9LmFudC1jb2wteHMtb2Zmc2V0LTZ7bWFyZ2luLWxlZnQ6MjUlfS5hbnQtY29sLXhzLW9yZGVyLTZ7b3JkZXI6Nn0uYW50LWNvbC14cy01e2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgMjAuODMzMzMzMzMlO21heC13aWR0aDoyMC44MzMzMzMzMyV9LmFudC1jb2wteHMtcHVzaC01e2xlZnQ6MjAuODMzMzMzMzMlfS5hbnQtY29sLXhzLXB1bGwtNXtyaWdodDoyMC44MzMzMzMzMyV9LmFudC1jb2wteHMtb2Zmc2V0LTV7bWFyZ2luLWxlZnQ6MjAuODMzMzMzMzMlfS5hbnQtY29sLXhzLW9yZGVyLTV7b3JkZXI6NX0uYW50LWNvbC14cy00e2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgMTYuNjY2NjY2NjclO21heC13aWR0aDoxNi42NjY2NjY2NyV9LmFudC1jb2wteHMtcHVzaC00e2xlZnQ6MTYuNjY2NjY2NjclfS5hbnQtY29sLXhzLXB1bGwtNHtyaWdodDoxNi42NjY2NjY2NyV9LmFudC1jb2wteHMtb2Zmc2V0LTR7bWFyZ2luLWxlZnQ6MTYuNjY2NjY2NjclfS5hbnQtY29sLXhzLW9yZGVyLTR7b3JkZXI6NH0uYW50LWNvbC14cy0ze2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgMTIuNSU7bWF4LXdpZHRoOjEyLjUlfS5hbnQtY29sLXhzLXB1c2gtM3tsZWZ0OjEyLjUlfS5hbnQtY29sLXhzLXB1bGwtM3tyaWdodDoxMi41JX0uYW50LWNvbC14cy1vZmZzZXQtM3ttYXJnaW4tbGVmdDoxMi41JX0uYW50LWNvbC14cy1vcmRlci0ze29yZGVyOjN9LmFudC1jb2wteHMtMntkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDguMzMzMzMzMzMlO21heC13aWR0aDo4LjMzMzMzMzMzJX0uYW50LWNvbC14cy1wdXNoLTJ7bGVmdDo4LjMzMzMzMzMzJX0uYW50LWNvbC14cy1wdWxsLTJ7cmlnaHQ6OC4zMzMzMzMzMyV9LmFudC1jb2wteHMtb2Zmc2V0LTJ7bWFyZ2luLWxlZnQ6OC4zMzMzMzMzMyV9LmFudC1jb2wteHMtb3JkZXItMntvcmRlcjoyfS5hbnQtY29sLXhzLTF7ZGlzcGxheTpibG9jaztmbGV4OjAgMCA0LjE2NjY2NjY3JTttYXgtd2lkdGg6NC4xNjY2NjY2NyV9LmFudC1jb2wteHMtcHVzaC0xe2xlZnQ6NC4xNjY2NjY2NyV9LmFudC1jb2wteHMtcHVsbC0xe3JpZ2h0OjQuMTY2NjY2NjclfS5hbnQtY29sLXhzLW9mZnNldC0xe21hcmdpbi1sZWZ0OjQuMTY2NjY2NjclfS5hbnQtY29sLXhzLW9yZGVyLTF7b3JkZXI6MX0uYW50LWNvbC14cy0we2Rpc3BsYXk6bm9uZX0uYW50LWNvbC1wdXNoLTB7bGVmdDphdXRvfS5hbnQtY29sLXB1bGwtMHtyaWdodDphdXRvfS5hbnQtY29sLXhzLXB1c2gtMHtsZWZ0OmF1dG99LmFudC1jb2wteHMtcHVsbC0we3JpZ2h0OmF1dG99LmFudC1jb2wteHMtb2Zmc2V0LTB7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC14cy1vcmRlci0we29yZGVyOjB9LmFudC1jb2wtcHVzaC0wLmFudC1jb2wtcnRse3JpZ2h0OmF1dG99LmFudC1jb2wtcHVsbC0wLmFudC1jb2wtcnRse2xlZnQ6YXV0b30uYW50LWNvbC14cy1wdXNoLTAuYW50LWNvbC1ydGx7cmlnaHQ6YXV0b30uYW50LWNvbC14cy1wdWxsLTAuYW50LWNvbC1ydGx7bGVmdDphdXRvfS5hbnQtY29sLXhzLW9mZnNldC0wLmFudC1jb2wtcnRse21hcmdpbi1yaWdodDowfS5hbnQtY29sLXhzLXB1c2gtMS5hbnQtY29sLXJ0bHtyaWdodDo0LjE2NjY2NjY3JTtsZWZ0OmF1dG99LmFudC1jb2wteHMtcHVsbC0xLmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo0LjE2NjY2NjY3JX0uYW50LWNvbC14cy1vZmZzZXQtMS5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6NC4xNjY2NjY2NyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC14cy1wdXNoLTIuYW50LWNvbC1ydGx7cmlnaHQ6OC4zMzMzMzMzMyU7bGVmdDphdXRvfS5hbnQtY29sLXhzLXB1bGwtMi5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6OC4zMzMzMzMzMyV9LmFudC1jb2wteHMtb2Zmc2V0LTIuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjguMzMzMzMzMzMlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wteHMtcHVzaC0zLmFudC1jb2wtcnRse3JpZ2h0OjEyLjUlO2xlZnQ6YXV0b30uYW50LWNvbC14cy1wdWxsLTMuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjEyLjUlfS5hbnQtY29sLXhzLW9mZnNldC0zLmFudC1jb2wtcnRse21hcmdpbi1yaWdodDoxMi41JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLXhzLXB1c2gtNC5hbnQtY29sLXJ0bHtyaWdodDoxNi42NjY2NjY2NyU7bGVmdDphdXRvfS5hbnQtY29sLXhzLXB1bGwtNC5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6MTYuNjY2NjY2NjclfS5hbnQtY29sLXhzLW9mZnNldC00LmFudC1jb2wtcnRse21hcmdpbi1yaWdodDoxNi42NjY2NjY2NyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC14cy1wdXNoLTUuYW50LWNvbC1ydGx7cmlnaHQ6MjAuODMzMzMzMzMlO2xlZnQ6YXV0b30uYW50LWNvbC14cy1wdWxsLTUuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjIwLjgzMzMzMzMzJX0uYW50LWNvbC14cy1vZmZzZXQtNS5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6MjAuODMzMzMzMzMlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wteHMtcHVzaC02LmFudC1jb2wtcnRse3JpZ2h0OjI1JTtsZWZ0OmF1dG99LmFudC1jb2wteHMtcHVsbC02LmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDoyNSV9LmFudC1jb2wteHMtb2Zmc2V0LTYuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjI1JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLXhzLXB1c2gtNy5hbnQtY29sLXJ0bHtyaWdodDoyOS4xNjY2NjY2NyU7bGVmdDphdXRvfS5hbnQtY29sLXhzLXB1bGwtNy5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6MjkuMTY2NjY2NjclfS5hbnQtY29sLXhzLW9mZnNldC03LmFudC1jb2wtcnRse21hcmdpbi1yaWdodDoyOS4xNjY2NjY2NyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC14cy1wdXNoLTguYW50LWNvbC1ydGx7cmlnaHQ6MzMuMzMzMzMzMzMlO2xlZnQ6YXV0b30uYW50LWNvbC14cy1wdWxsLTguYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjMzLjMzMzMzMzMzJX0uYW50LWNvbC14cy1vZmZzZXQtOC5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6MzMuMzMzMzMzMzMlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wteHMtcHVzaC05LmFudC1jb2wtcnRse3JpZ2h0OjM3LjUlO2xlZnQ6YXV0b30uYW50LWNvbC14cy1wdWxsLTkuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjM3LjUlfS5hbnQtY29sLXhzLW9mZnNldC05LmFudC1jb2wtcnRse21hcmdpbi1yaWdodDozNy41JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLXhzLXB1c2gtMTAuYW50LWNvbC1ydGx7cmlnaHQ6NDEuNjY2NjY2NjclO2xlZnQ6YXV0b30uYW50LWNvbC14cy1wdWxsLTEwLmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo0MS42NjY2NjY2NyV9LmFudC1jb2wteHMtb2Zmc2V0LTEwLmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo0MS42NjY2NjY2NyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC14cy1wdXNoLTExLmFudC1jb2wtcnRse3JpZ2h0OjQ1LjgzMzMzMzMzJTtsZWZ0OmF1dG99LmFudC1jb2wteHMtcHVsbC0xMS5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6NDUuODMzMzMzMzMlfS5hbnQtY29sLXhzLW9mZnNldC0xMS5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6NDUuODMzMzMzMzMlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wteHMtcHVzaC0xMi5hbnQtY29sLXJ0bHtyaWdodDo1MCU7bGVmdDphdXRvfS5hbnQtY29sLXhzLXB1bGwtMTIuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjUwJX0uYW50LWNvbC14cy1vZmZzZXQtMTIuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjUwJTttYXJnaW4tbGVmdDowfS5hbnQtY29sLXhzLXB1c2gtMTMuYW50LWNvbC1ydGx7cmlnaHQ6NTQuMTY2NjY2NjclO2xlZnQ6YXV0b30uYW50LWNvbC14cy1wdWxsLTEzLmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo1NC4xNjY2NjY2NyV9LmFudC1jb2wteHMtb2Zmc2V0LTEzLmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo1NC4xNjY2NjY2NyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC14cy1wdXNoLTE0LmFudC1jb2wtcnRse3JpZ2h0OjU4LjMzMzMzMzMzJTtsZWZ0OmF1dG99LmFudC1jb2wteHMtcHVsbC0xNC5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6NTguMzMzMzMzMzMlfS5hbnQtY29sLXhzLW9mZnNldC0xNC5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6NTguMzMzMzMzMzMlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wteHMtcHVzaC0xNS5hbnQtY29sLXJ0bHtyaWdodDo2Mi41JTtsZWZ0OmF1dG99LmFudC1jb2wteHMtcHVsbC0xNS5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6NjIuNSV9LmFudC1jb2wteHMtb2Zmc2V0LTE1LmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo2Mi41JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLXhzLXB1c2gtMTYuYW50LWNvbC1ydGx7cmlnaHQ6NjYuNjY2NjY2NjclO2xlZnQ6YXV0b30uYW50LWNvbC14cy1wdWxsLTE2LmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo2Ni42NjY2NjY2NyV9LmFudC1jb2wteHMtb2Zmc2V0LTE2LmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo2Ni42NjY2NjY2NyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC14cy1wdXNoLTE3LmFudC1jb2wtcnRse3JpZ2h0OjcwLjgzMzMzMzMzJTtsZWZ0OmF1dG99LmFudC1jb2wteHMtcHVsbC0xNy5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6NzAuODMzMzMzMzMlfS5hbnQtY29sLXhzLW9mZnNldC0xNy5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6NzAuODMzMzMzMzMlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wteHMtcHVzaC0xOC5hbnQtY29sLXJ0bHtyaWdodDo3NSU7bGVmdDphdXRvfS5hbnQtY29sLXhzLXB1bGwtMTguYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0Ojc1JX0uYW50LWNvbC14cy1vZmZzZXQtMTguYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0Ojc1JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLXhzLXB1c2gtMTkuYW50LWNvbC1ydGx7cmlnaHQ6NzkuMTY2NjY2NjclO2xlZnQ6YXV0b30uYW50LWNvbC14cy1wdWxsLTE5LmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo3OS4xNjY2NjY2NyV9LmFudC1jb2wteHMtb2Zmc2V0LTE5LmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo3OS4xNjY2NjY2NyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC14cy1wdXNoLTIwLmFudC1jb2wtcnRse3JpZ2h0OjgzLjMzMzMzMzMzJTtsZWZ0OmF1dG99LmFudC1jb2wteHMtcHVsbC0yMC5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6ODMuMzMzMzMzMzMlfS5hbnQtY29sLXhzLW9mZnNldC0yMC5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6ODMuMzMzMzMzMzMlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wteHMtcHVzaC0yMS5hbnQtY29sLXJ0bHtyaWdodDo4Ny41JTtsZWZ0OmF1dG99LmFudC1jb2wteHMtcHVsbC0yMS5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6ODcuNSV9LmFudC1jb2wteHMtb2Zmc2V0LTIxLmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo4Ny41JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLXhzLXB1c2gtMjIuYW50LWNvbC1ydGx7cmlnaHQ6OTEuNjY2NjY2NjclO2xlZnQ6YXV0b30uYW50LWNvbC14cy1wdWxsLTIyLmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo5MS42NjY2NjY2NyV9LmFudC1jb2wteHMtb2Zmc2V0LTIyLmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo5MS42NjY2NjY2NyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC14cy1wdXNoLTIzLmFudC1jb2wtcnRse3JpZ2h0Ojk1LjgzMzMzMzMzJTtsZWZ0OmF1dG99LmFudC1jb2wteHMtcHVsbC0yMy5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6OTUuODMzMzMzMzMlfS5hbnQtY29sLXhzLW9mZnNldC0yMy5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6OTUuODMzMzMzMzMlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wteHMtcHVzaC0yNC5hbnQtY29sLXJ0bHtyaWdodDoxMDAlO2xlZnQ6YXV0b30uYW50LWNvbC14cy1wdWxsLTI0LmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDoxMDAlfS5hbnQtY29sLXhzLW9mZnNldC0yNC5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6MTAwJTttYXJnaW4tbGVmdDowfUBtZWRpYSAobWluLXdpZHRoOjU3NnB4KXsuYW50LWNvbC1zbS0yNHtkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDEwMCU7bWF4LXdpZHRoOjEwMCV9LmFudC1jb2wtc20tcHVzaC0yNHtsZWZ0OjEwMCV9LmFudC1jb2wtc20tcHVsbC0yNHtyaWdodDoxMDAlfS5hbnQtY29sLXNtLW9mZnNldC0yNHttYXJnaW4tbGVmdDoxMDAlfS5hbnQtY29sLXNtLW9yZGVyLTI0e29yZGVyOjI0fS5hbnQtY29sLXNtLTIze2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgOTUuODMzMzMzMzMlO21heC13aWR0aDo5NS44MzMzMzMzMyV9LmFudC1jb2wtc20tcHVzaC0yM3tsZWZ0Ojk1LjgzMzMzMzMzJX0uYW50LWNvbC1zbS1wdWxsLTIze3JpZ2h0Ojk1LjgzMzMzMzMzJX0uYW50LWNvbC1zbS1vZmZzZXQtMjN7bWFyZ2luLWxlZnQ6OTUuODMzMzMzMzMlfS5hbnQtY29sLXNtLW9yZGVyLTIze29yZGVyOjIzfS5hbnQtY29sLXNtLTIye2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgOTEuNjY2NjY2NjclO21heC13aWR0aDo5MS42NjY2NjY2NyV9LmFudC1jb2wtc20tcHVzaC0yMntsZWZ0OjkxLjY2NjY2NjY3JX0uYW50LWNvbC1zbS1wdWxsLTIye3JpZ2h0OjkxLjY2NjY2NjY3JX0uYW50LWNvbC1zbS1vZmZzZXQtMjJ7bWFyZ2luLWxlZnQ6OTEuNjY2NjY2NjclfS5hbnQtY29sLXNtLW9yZGVyLTIye29yZGVyOjIyfS5hbnQtY29sLXNtLTIxe2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgODcuNSU7bWF4LXdpZHRoOjg3LjUlfS5hbnQtY29sLXNtLXB1c2gtMjF7bGVmdDo4Ny41JX0uYW50LWNvbC1zbS1wdWxsLTIxe3JpZ2h0Ojg3LjUlfS5hbnQtY29sLXNtLW9mZnNldC0yMXttYXJnaW4tbGVmdDo4Ny41JX0uYW50LWNvbC1zbS1vcmRlci0yMXtvcmRlcjoyMX0uYW50LWNvbC1zbS0yMHtkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDgzLjMzMzMzMzMzJTttYXgtd2lkdGg6ODMuMzMzMzMzMzMlfS5hbnQtY29sLXNtLXB1c2gtMjB7bGVmdDo4My4zMzMzMzMzMyV9LmFudC1jb2wtc20tcHVsbC0yMHtyaWdodDo4My4zMzMzMzMzMyV9LmFudC1jb2wtc20tb2Zmc2V0LTIwe21hcmdpbi1sZWZ0OjgzLjMzMzMzMzMzJX0uYW50LWNvbC1zbS1vcmRlci0yMHtvcmRlcjoyMH0uYW50LWNvbC1zbS0xOXtkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDc5LjE2NjY2NjY3JTttYXgtd2lkdGg6NzkuMTY2NjY2NjclfS5hbnQtY29sLXNtLXB1c2gtMTl7bGVmdDo3OS4xNjY2NjY2NyV9LmFudC1jb2wtc20tcHVsbC0xOXtyaWdodDo3OS4xNjY2NjY2NyV9LmFudC1jb2wtc20tb2Zmc2V0LTE5e21hcmdpbi1sZWZ0Ojc5LjE2NjY2NjY3JX0uYW50LWNvbC1zbS1vcmRlci0xOXtvcmRlcjoxOX0uYW50LWNvbC1zbS0xOHtkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDc1JTttYXgtd2lkdGg6NzUlfS5hbnQtY29sLXNtLXB1c2gtMTh7bGVmdDo3NSV9LmFudC1jb2wtc20tcHVsbC0xOHtyaWdodDo3NSV9LmFudC1jb2wtc20tb2Zmc2V0LTE4e21hcmdpbi1sZWZ0Ojc1JX0uYW50LWNvbC1zbS1vcmRlci0xOHtvcmRlcjoxOH0uYW50LWNvbC1zbS0xN3tkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDcwLjgzMzMzMzMzJTttYXgtd2lkdGg6NzAuODMzMzMzMzMlfS5hbnQtY29sLXNtLXB1c2gtMTd7bGVmdDo3MC44MzMzMzMzMyV9LmFudC1jb2wtc20tcHVsbC0xN3tyaWdodDo3MC44MzMzMzMzMyV9LmFudC1jb2wtc20tb2Zmc2V0LTE3e21hcmdpbi1sZWZ0OjcwLjgzMzMzMzMzJX0uYW50LWNvbC1zbS1vcmRlci0xN3tvcmRlcjoxN30uYW50LWNvbC1zbS0xNntkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDY2LjY2NjY2NjY3JTttYXgtd2lkdGg6NjYuNjY2NjY2NjclfS5hbnQtY29sLXNtLXB1c2gtMTZ7bGVmdDo2Ni42NjY2NjY2NyV9LmFudC1jb2wtc20tcHVsbC0xNntyaWdodDo2Ni42NjY2NjY2NyV9LmFudC1jb2wtc20tb2Zmc2V0LTE2e21hcmdpbi1sZWZ0OjY2LjY2NjY2NjY3JX0uYW50LWNvbC1zbS1vcmRlci0xNntvcmRlcjoxNn0uYW50LWNvbC1zbS0xNXtkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDYyLjUlO21heC13aWR0aDo2Mi41JX0uYW50LWNvbC1zbS1wdXNoLTE1e2xlZnQ6NjIuNSV9LmFudC1jb2wtc20tcHVsbC0xNXtyaWdodDo2Mi41JX0uYW50LWNvbC1zbS1vZmZzZXQtMTV7bWFyZ2luLWxlZnQ6NjIuNSV9LmFudC1jb2wtc20tb3JkZXItMTV7b3JkZXI6MTV9LmFudC1jb2wtc20tMTR7ZGlzcGxheTpibG9jaztmbGV4OjAgMCA1OC4zMzMzMzMzMyU7bWF4LXdpZHRoOjU4LjMzMzMzMzMzJX0uYW50LWNvbC1zbS1wdXNoLTE0e2xlZnQ6NTguMzMzMzMzMzMlfS5hbnQtY29sLXNtLXB1bGwtMTR7cmlnaHQ6NTguMzMzMzMzMzMlfS5hbnQtY29sLXNtLW9mZnNldC0xNHttYXJnaW4tbGVmdDo1OC4zMzMzMzMzMyV9LmFudC1jb2wtc20tb3JkZXItMTR7b3JkZXI6MTR9LmFudC1jb2wtc20tMTN7ZGlzcGxheTpibG9jaztmbGV4OjAgMCA1NC4xNjY2NjY2NyU7bWF4LXdpZHRoOjU0LjE2NjY2NjY3JX0uYW50LWNvbC1zbS1wdXNoLTEze2xlZnQ6NTQuMTY2NjY2NjclfS5hbnQtY29sLXNtLXB1bGwtMTN7cmlnaHQ6NTQuMTY2NjY2NjclfS5hbnQtY29sLXNtLW9mZnNldC0xM3ttYXJnaW4tbGVmdDo1NC4xNjY2NjY2NyV9LmFudC1jb2wtc20tb3JkZXItMTN7b3JkZXI6MTN9LmFudC1jb2wtc20tMTJ7ZGlzcGxheTpibG9jaztmbGV4OjAgMCA1MCU7bWF4LXdpZHRoOjUwJX0uYW50LWNvbC1zbS1wdXNoLTEye2xlZnQ6NTAlfS5hbnQtY29sLXNtLXB1bGwtMTJ7cmlnaHQ6NTAlfS5hbnQtY29sLXNtLW9mZnNldC0xMnttYXJnaW4tbGVmdDo1MCV9LmFudC1jb2wtc20tb3JkZXItMTJ7b3JkZXI6MTJ9LmFudC1jb2wtc20tMTF7ZGlzcGxheTpibG9jaztmbGV4OjAgMCA0NS44MzMzMzMzMyU7bWF4LXdpZHRoOjQ1LjgzMzMzMzMzJX0uYW50LWNvbC1zbS1wdXNoLTExe2xlZnQ6NDUuODMzMzMzMzMlfS5hbnQtY29sLXNtLXB1bGwtMTF7cmlnaHQ6NDUuODMzMzMzMzMlfS5hbnQtY29sLXNtLW9mZnNldC0xMXttYXJnaW4tbGVmdDo0NS44MzMzMzMzMyV9LmFudC1jb2wtc20tb3JkZXItMTF7b3JkZXI6MTF9LmFudC1jb2wtc20tMTB7ZGlzcGxheTpibG9jaztmbGV4OjAgMCA0MS42NjY2NjY2NyU7bWF4LXdpZHRoOjQxLjY2NjY2NjY3JX0uYW50LWNvbC1zbS1wdXNoLTEwe2xlZnQ6NDEuNjY2NjY2NjclfS5hbnQtY29sLXNtLXB1bGwtMTB7cmlnaHQ6NDEuNjY2NjY2NjclfS5hbnQtY29sLXNtLW9mZnNldC0xMHttYXJnaW4tbGVmdDo0MS42NjY2NjY2NyV9LmFudC1jb2wtc20tb3JkZXItMTB7b3JkZXI6MTB9LmFudC1jb2wtc20tOXtkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDM3LjUlO21heC13aWR0aDozNy41JX0uYW50LWNvbC1zbS1wdXNoLTl7bGVmdDozNy41JX0uYW50LWNvbC1zbS1wdWxsLTl7cmlnaHQ6MzcuNSV9LmFudC1jb2wtc20tb2Zmc2V0LTl7bWFyZ2luLWxlZnQ6MzcuNSV9LmFudC1jb2wtc20tb3JkZXItOXtvcmRlcjo5fS5hbnQtY29sLXNtLTh7ZGlzcGxheTpibG9jaztmbGV4OjAgMCAzMy4zMzMzMzMzMyU7bWF4LXdpZHRoOjMzLjMzMzMzMzMzJX0uYW50LWNvbC1zbS1wdXNoLTh7bGVmdDozMy4zMzMzMzMzMyV9LmFudC1jb2wtc20tcHVsbC04e3JpZ2h0OjMzLjMzMzMzMzMzJX0uYW50LWNvbC1zbS1vZmZzZXQtOHttYXJnaW4tbGVmdDozMy4zMzMzMzMzMyV9LmFudC1jb2wtc20tb3JkZXItOHtvcmRlcjo4fS5hbnQtY29sLXNtLTd7ZGlzcGxheTpibG9jaztmbGV4OjAgMCAyOS4xNjY2NjY2NyU7bWF4LXdpZHRoOjI5LjE2NjY2NjY3JX0uYW50LWNvbC1zbS1wdXNoLTd7bGVmdDoyOS4xNjY2NjY2NyV9LmFudC1jb2wtc20tcHVsbC03e3JpZ2h0OjI5LjE2NjY2NjY3JX0uYW50LWNvbC1zbS1vZmZzZXQtN3ttYXJnaW4tbGVmdDoyOS4xNjY2NjY2NyV9LmFudC1jb2wtc20tb3JkZXItN3tvcmRlcjo3fS5hbnQtY29sLXNtLTZ7ZGlzcGxheTpibG9jaztmbGV4OjAgMCAyNSU7bWF4LXdpZHRoOjI1JX0uYW50LWNvbC1zbS1wdXNoLTZ7bGVmdDoyNSV9LmFudC1jb2wtc20tcHVsbC02e3JpZ2h0OjI1JX0uYW50LWNvbC1zbS1vZmZzZXQtNnttYXJnaW4tbGVmdDoyNSV9LmFudC1jb2wtc20tb3JkZXItNntvcmRlcjo2fS5hbnQtY29sLXNtLTV7ZGlzcGxheTpibG9jaztmbGV4OjAgMCAyMC44MzMzMzMzMyU7bWF4LXdpZHRoOjIwLjgzMzMzMzMzJX0uYW50LWNvbC1zbS1wdXNoLTV7bGVmdDoyMC44MzMzMzMzMyV9LmFudC1jb2wtc20tcHVsbC01e3JpZ2h0OjIwLjgzMzMzMzMzJX0uYW50LWNvbC1zbS1vZmZzZXQtNXttYXJnaW4tbGVmdDoyMC44MzMzMzMzMyV9LmFudC1jb2wtc20tb3JkZXItNXtvcmRlcjo1fS5hbnQtY29sLXNtLTR7ZGlzcGxheTpibG9jaztmbGV4OjAgMCAxNi42NjY2NjY2NyU7bWF4LXdpZHRoOjE2LjY2NjY2NjY3JX0uYW50LWNvbC1zbS1wdXNoLTR7bGVmdDoxNi42NjY2NjY2NyV9LmFudC1jb2wtc20tcHVsbC00e3JpZ2h0OjE2LjY2NjY2NjY3JX0uYW50LWNvbC1zbS1vZmZzZXQtNHttYXJnaW4tbGVmdDoxNi42NjY2NjY2NyV9LmFudC1jb2wtc20tb3JkZXItNHtvcmRlcjo0fS5hbnQtY29sLXNtLTN7ZGlzcGxheTpibG9jaztmbGV4OjAgMCAxMi41JTttYXgtd2lkdGg6MTIuNSV9LmFudC1jb2wtc20tcHVzaC0ze2xlZnQ6MTIuNSV9LmFudC1jb2wtc20tcHVsbC0ze3JpZ2h0OjEyLjUlfS5hbnQtY29sLXNtLW9mZnNldC0ze21hcmdpbi1sZWZ0OjEyLjUlfS5hbnQtY29sLXNtLW9yZGVyLTN7b3JkZXI6M30uYW50LWNvbC1zbS0ye2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgOC4zMzMzMzMzMyU7bWF4LXdpZHRoOjguMzMzMzMzMzMlfS5hbnQtY29sLXNtLXB1c2gtMntsZWZ0OjguMzMzMzMzMzMlfS5hbnQtY29sLXNtLXB1bGwtMntyaWdodDo4LjMzMzMzMzMzJX0uYW50LWNvbC1zbS1vZmZzZXQtMnttYXJnaW4tbGVmdDo4LjMzMzMzMzMzJX0uYW50LWNvbC1zbS1vcmRlci0ye29yZGVyOjJ9LmFudC1jb2wtc20tMXtkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDQuMTY2NjY2NjclO21heC13aWR0aDo0LjE2NjY2NjY3JX0uYW50LWNvbC1zbS1wdXNoLTF7bGVmdDo0LjE2NjY2NjY3JX0uYW50LWNvbC1zbS1wdWxsLTF7cmlnaHQ6NC4xNjY2NjY2NyV9LmFudC1jb2wtc20tb2Zmc2V0LTF7bWFyZ2luLWxlZnQ6NC4xNjY2NjY2NyV9LmFudC1jb2wtc20tb3JkZXItMXtvcmRlcjoxfS5hbnQtY29sLXNtLTB7ZGlzcGxheTpub25lfS5hbnQtY29sLXB1c2gtMHtsZWZ0OmF1dG99LmFudC1jb2wtcHVsbC0we3JpZ2h0OmF1dG99LmFudC1jb2wtc20tcHVzaC0we2xlZnQ6YXV0b30uYW50LWNvbC1zbS1wdWxsLTB7cmlnaHQ6YXV0b30uYW50LWNvbC1zbS1vZmZzZXQtMHttYXJnaW4tbGVmdDowfS5hbnQtY29sLXNtLW9yZGVyLTB7b3JkZXI6MH0uYW50LWNvbC1wdXNoLTAuYW50LWNvbC1ydGx7cmlnaHQ6YXV0b30uYW50LWNvbC1wdWxsLTAuYW50LWNvbC1ydGx7bGVmdDphdXRvfS5hbnQtY29sLXNtLXB1c2gtMC5hbnQtY29sLXJ0bHtyaWdodDphdXRvfS5hbnQtY29sLXNtLXB1bGwtMC5hbnQtY29sLXJ0bHtsZWZ0OmF1dG99LmFudC1jb2wtc20tb2Zmc2V0LTAuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjB9LmFudC1jb2wtc20tcHVzaC0xLmFudC1jb2wtcnRse3JpZ2h0OjQuMTY2NjY2NjclO2xlZnQ6YXV0b30uYW50LWNvbC1zbS1wdWxsLTEuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjQuMTY2NjY2NjclfS5hbnQtY29sLXNtLW9mZnNldC0xLmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo0LjE2NjY2NjY3JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLXNtLXB1c2gtMi5hbnQtY29sLXJ0bHtyaWdodDo4LjMzMzMzMzMzJTtsZWZ0OmF1dG99LmFudC1jb2wtc20tcHVsbC0yLmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo4LjMzMzMzMzMzJX0uYW50LWNvbC1zbS1vZmZzZXQtMi5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6OC4zMzMzMzMzMyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC1zbS1wdXNoLTMuYW50LWNvbC1ydGx7cmlnaHQ6MTIuNSU7bGVmdDphdXRvfS5hbnQtY29sLXNtLXB1bGwtMy5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6MTIuNSV9LmFudC1jb2wtc20tb2Zmc2V0LTMuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjEyLjUlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wtc20tcHVzaC00LmFudC1jb2wtcnRse3JpZ2h0OjE2LjY2NjY2NjY3JTtsZWZ0OmF1dG99LmFudC1jb2wtc20tcHVsbC00LmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDoxNi42NjY2NjY2NyV9LmFudC1jb2wtc20tb2Zmc2V0LTQuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjE2LjY2NjY2NjY3JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLXNtLXB1c2gtNS5hbnQtY29sLXJ0bHtyaWdodDoyMC44MzMzMzMzMyU7bGVmdDphdXRvfS5hbnQtY29sLXNtLXB1bGwtNS5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6MjAuODMzMzMzMzMlfS5hbnQtY29sLXNtLW9mZnNldC01LmFudC1jb2wtcnRse21hcmdpbi1yaWdodDoyMC44MzMzMzMzMyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC1zbS1wdXNoLTYuYW50LWNvbC1ydGx7cmlnaHQ6MjUlO2xlZnQ6YXV0b30uYW50LWNvbC1zbS1wdWxsLTYuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjI1JX0uYW50LWNvbC1zbS1vZmZzZXQtNi5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6MjUlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wtc20tcHVzaC03LmFudC1jb2wtcnRse3JpZ2h0OjI5LjE2NjY2NjY3JTtsZWZ0OmF1dG99LmFudC1jb2wtc20tcHVsbC03LmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDoyOS4xNjY2NjY2NyV9LmFudC1jb2wtc20tb2Zmc2V0LTcuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjI5LjE2NjY2NjY3JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLXNtLXB1c2gtOC5hbnQtY29sLXJ0bHtyaWdodDozMy4zMzMzMzMzMyU7bGVmdDphdXRvfS5hbnQtY29sLXNtLXB1bGwtOC5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6MzMuMzMzMzMzMzMlfS5hbnQtY29sLXNtLW9mZnNldC04LmFudC1jb2wtcnRse21hcmdpbi1yaWdodDozMy4zMzMzMzMzMyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC1zbS1wdXNoLTkuYW50LWNvbC1ydGx7cmlnaHQ6MzcuNSU7bGVmdDphdXRvfS5hbnQtY29sLXNtLXB1bGwtOS5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6MzcuNSV9LmFudC1jb2wtc20tb2Zmc2V0LTkuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjM3LjUlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wtc20tcHVzaC0xMC5hbnQtY29sLXJ0bHtyaWdodDo0MS42NjY2NjY2NyU7bGVmdDphdXRvfS5hbnQtY29sLXNtLXB1bGwtMTAuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjQxLjY2NjY2NjY3JX0uYW50LWNvbC1zbS1vZmZzZXQtMTAuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjQxLjY2NjY2NjY3JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLXNtLXB1c2gtMTEuYW50LWNvbC1ydGx7cmlnaHQ6NDUuODMzMzMzMzMlO2xlZnQ6YXV0b30uYW50LWNvbC1zbS1wdWxsLTExLmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo0NS44MzMzMzMzMyV9LmFudC1jb2wtc20tb2Zmc2V0LTExLmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo0NS44MzMzMzMzMyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC1zbS1wdXNoLTEyLmFudC1jb2wtcnRse3JpZ2h0OjUwJTtsZWZ0OmF1dG99LmFudC1jb2wtc20tcHVsbC0xMi5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6NTAlfS5hbnQtY29sLXNtLW9mZnNldC0xMi5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6NTAlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wtc20tcHVzaC0xMy5hbnQtY29sLXJ0bHtyaWdodDo1NC4xNjY2NjY2NyU7bGVmdDphdXRvfS5hbnQtY29sLXNtLXB1bGwtMTMuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjU0LjE2NjY2NjY3JX0uYW50LWNvbC1zbS1vZmZzZXQtMTMuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjU0LjE2NjY2NjY3JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLXNtLXB1c2gtMTQuYW50LWNvbC1ydGx7cmlnaHQ6NTguMzMzMzMzMzMlO2xlZnQ6YXV0b30uYW50LWNvbC1zbS1wdWxsLTE0LmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo1OC4zMzMzMzMzMyV9LmFudC1jb2wtc20tb2Zmc2V0LTE0LmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo1OC4zMzMzMzMzMyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC1zbS1wdXNoLTE1LmFudC1jb2wtcnRse3JpZ2h0OjYyLjUlO2xlZnQ6YXV0b30uYW50LWNvbC1zbS1wdWxsLTE1LmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo2Mi41JX0uYW50LWNvbC1zbS1vZmZzZXQtMTUuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjYyLjUlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wtc20tcHVzaC0xNi5hbnQtY29sLXJ0bHtyaWdodDo2Ni42NjY2NjY2NyU7bGVmdDphdXRvfS5hbnQtY29sLXNtLXB1bGwtMTYuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjY2LjY2NjY2NjY3JX0uYW50LWNvbC1zbS1vZmZzZXQtMTYuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjY2LjY2NjY2NjY3JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLXNtLXB1c2gtMTcuYW50LWNvbC1ydGx7cmlnaHQ6NzAuODMzMzMzMzMlO2xlZnQ6YXV0b30uYW50LWNvbC1zbS1wdWxsLTE3LmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo3MC44MzMzMzMzMyV9LmFudC1jb2wtc20tb2Zmc2V0LTE3LmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo3MC44MzMzMzMzMyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC1zbS1wdXNoLTE4LmFudC1jb2wtcnRse3JpZ2h0Ojc1JTtsZWZ0OmF1dG99LmFudC1jb2wtc20tcHVsbC0xOC5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6NzUlfS5hbnQtY29sLXNtLW9mZnNldC0xOC5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6NzUlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wtc20tcHVzaC0xOS5hbnQtY29sLXJ0bHtyaWdodDo3OS4xNjY2NjY2NyU7bGVmdDphdXRvfS5hbnQtY29sLXNtLXB1bGwtMTkuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0Ojc5LjE2NjY2NjY3JX0uYW50LWNvbC1zbS1vZmZzZXQtMTkuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0Ojc5LjE2NjY2NjY3JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLXNtLXB1c2gtMjAuYW50LWNvbC1ydGx7cmlnaHQ6ODMuMzMzMzMzMzMlO2xlZnQ6YXV0b30uYW50LWNvbC1zbS1wdWxsLTIwLmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo4My4zMzMzMzMzMyV9LmFudC1jb2wtc20tb2Zmc2V0LTIwLmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo4My4zMzMzMzMzMyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC1zbS1wdXNoLTIxLmFudC1jb2wtcnRse3JpZ2h0Ojg3LjUlO2xlZnQ6YXV0b30uYW50LWNvbC1zbS1wdWxsLTIxLmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo4Ny41JX0uYW50LWNvbC1zbS1vZmZzZXQtMjEuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0Ojg3LjUlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wtc20tcHVzaC0yMi5hbnQtY29sLXJ0bHtyaWdodDo5MS42NjY2NjY2NyU7bGVmdDphdXRvfS5hbnQtY29sLXNtLXB1bGwtMjIuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjkxLjY2NjY2NjY3JX0uYW50LWNvbC1zbS1vZmZzZXQtMjIuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjkxLjY2NjY2NjY3JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLXNtLXB1c2gtMjMuYW50LWNvbC1ydGx7cmlnaHQ6OTUuODMzMzMzMzMlO2xlZnQ6YXV0b30uYW50LWNvbC1zbS1wdWxsLTIzLmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo5NS44MzMzMzMzMyV9LmFudC1jb2wtc20tb2Zmc2V0LTIzLmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo5NS44MzMzMzMzMyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC1zbS1wdXNoLTI0LmFudC1jb2wtcnRse3JpZ2h0OjEwMCU7bGVmdDphdXRvfS5hbnQtY29sLXNtLXB1bGwtMjQuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjEwMCV9LmFudC1jb2wtc20tb2Zmc2V0LTI0LmFudC1jb2wtcnRse21hcmdpbi1yaWdodDoxMDAlO21hcmdpbi1sZWZ0OjB9fUBtZWRpYSAobWluLXdpZHRoOjc2OHB4KXsuYW50LWNvbC1tZC0yNHtkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDEwMCU7bWF4LXdpZHRoOjEwMCV9LmFudC1jb2wtbWQtcHVzaC0yNHtsZWZ0OjEwMCV9LmFudC1jb2wtbWQtcHVsbC0yNHtyaWdodDoxMDAlfS5hbnQtY29sLW1kLW9mZnNldC0yNHttYXJnaW4tbGVmdDoxMDAlfS5hbnQtY29sLW1kLW9yZGVyLTI0e29yZGVyOjI0fS5hbnQtY29sLW1kLTIze2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgOTUuODMzMzMzMzMlO21heC13aWR0aDo5NS44MzMzMzMzMyV9LmFudC1jb2wtbWQtcHVzaC0yM3tsZWZ0Ojk1LjgzMzMzMzMzJX0uYW50LWNvbC1tZC1wdWxsLTIze3JpZ2h0Ojk1LjgzMzMzMzMzJX0uYW50LWNvbC1tZC1vZmZzZXQtMjN7bWFyZ2luLWxlZnQ6OTUuODMzMzMzMzMlfS5hbnQtY29sLW1kLW9yZGVyLTIze29yZGVyOjIzfS5hbnQtY29sLW1kLTIye2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgOTEuNjY2NjY2NjclO21heC13aWR0aDo5MS42NjY2NjY2NyV9LmFudC1jb2wtbWQtcHVzaC0yMntsZWZ0OjkxLjY2NjY2NjY3JX0uYW50LWNvbC1tZC1wdWxsLTIye3JpZ2h0OjkxLjY2NjY2NjY3JX0uYW50LWNvbC1tZC1vZmZzZXQtMjJ7bWFyZ2luLWxlZnQ6OTEuNjY2NjY2NjclfS5hbnQtY29sLW1kLW9yZGVyLTIye29yZGVyOjIyfS5hbnQtY29sLW1kLTIxe2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgODcuNSU7bWF4LXdpZHRoOjg3LjUlfS5hbnQtY29sLW1kLXB1c2gtMjF7bGVmdDo4Ny41JX0uYW50LWNvbC1tZC1wdWxsLTIxe3JpZ2h0Ojg3LjUlfS5hbnQtY29sLW1kLW9mZnNldC0yMXttYXJnaW4tbGVmdDo4Ny41JX0uYW50LWNvbC1tZC1vcmRlci0yMXtvcmRlcjoyMX0uYW50LWNvbC1tZC0yMHtkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDgzLjMzMzMzMzMzJTttYXgtd2lkdGg6ODMuMzMzMzMzMzMlfS5hbnQtY29sLW1kLXB1c2gtMjB7bGVmdDo4My4zMzMzMzMzMyV9LmFudC1jb2wtbWQtcHVsbC0yMHtyaWdodDo4My4zMzMzMzMzMyV9LmFudC1jb2wtbWQtb2Zmc2V0LTIwe21hcmdpbi1sZWZ0OjgzLjMzMzMzMzMzJX0uYW50LWNvbC1tZC1vcmRlci0yMHtvcmRlcjoyMH0uYW50LWNvbC1tZC0xOXtkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDc5LjE2NjY2NjY3JTttYXgtd2lkdGg6NzkuMTY2NjY2NjclfS5hbnQtY29sLW1kLXB1c2gtMTl7bGVmdDo3OS4xNjY2NjY2NyV9LmFudC1jb2wtbWQtcHVsbC0xOXtyaWdodDo3OS4xNjY2NjY2NyV9LmFudC1jb2wtbWQtb2Zmc2V0LTE5e21hcmdpbi1sZWZ0Ojc5LjE2NjY2NjY3JX0uYW50LWNvbC1tZC1vcmRlci0xOXtvcmRlcjoxOX0uYW50LWNvbC1tZC0xOHtkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDc1JTttYXgtd2lkdGg6NzUlfS5hbnQtY29sLW1kLXB1c2gtMTh7bGVmdDo3NSV9LmFudC1jb2wtbWQtcHVsbC0xOHtyaWdodDo3NSV9LmFudC1jb2wtbWQtb2Zmc2V0LTE4e21hcmdpbi1sZWZ0Ojc1JX0uYW50LWNvbC1tZC1vcmRlci0xOHtvcmRlcjoxOH0uYW50LWNvbC1tZC0xN3tkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDcwLjgzMzMzMzMzJTttYXgtd2lkdGg6NzAuODMzMzMzMzMlfS5hbnQtY29sLW1kLXB1c2gtMTd7bGVmdDo3MC44MzMzMzMzMyV9LmFudC1jb2wtbWQtcHVsbC0xN3tyaWdodDo3MC44MzMzMzMzMyV9LmFudC1jb2wtbWQtb2Zmc2V0LTE3e21hcmdpbi1sZWZ0OjcwLjgzMzMzMzMzJX0uYW50LWNvbC1tZC1vcmRlci0xN3tvcmRlcjoxN30uYW50LWNvbC1tZC0xNntkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDY2LjY2NjY2NjY3JTttYXgtd2lkdGg6NjYuNjY2NjY2NjclfS5hbnQtY29sLW1kLXB1c2gtMTZ7bGVmdDo2Ni42NjY2NjY2NyV9LmFudC1jb2wtbWQtcHVsbC0xNntyaWdodDo2Ni42NjY2NjY2NyV9LmFudC1jb2wtbWQtb2Zmc2V0LTE2e21hcmdpbi1sZWZ0OjY2LjY2NjY2NjY3JX0uYW50LWNvbC1tZC1vcmRlci0xNntvcmRlcjoxNn0uYW50LWNvbC1tZC0xNXtkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDYyLjUlO21heC13aWR0aDo2Mi41JX0uYW50LWNvbC1tZC1wdXNoLTE1e2xlZnQ6NjIuNSV9LmFudC1jb2wtbWQtcHVsbC0xNXtyaWdodDo2Mi41JX0uYW50LWNvbC1tZC1vZmZzZXQtMTV7bWFyZ2luLWxlZnQ6NjIuNSV9LmFudC1jb2wtbWQtb3JkZXItMTV7b3JkZXI6MTV9LmFudC1jb2wtbWQtMTR7ZGlzcGxheTpibG9jaztmbGV4OjAgMCA1OC4zMzMzMzMzMyU7bWF4LXdpZHRoOjU4LjMzMzMzMzMzJX0uYW50LWNvbC1tZC1wdXNoLTE0e2xlZnQ6NTguMzMzMzMzMzMlfS5hbnQtY29sLW1kLXB1bGwtMTR7cmlnaHQ6NTguMzMzMzMzMzMlfS5hbnQtY29sLW1kLW9mZnNldC0xNHttYXJnaW4tbGVmdDo1OC4zMzMzMzMzMyV9LmFudC1jb2wtbWQtb3JkZXItMTR7b3JkZXI6MTR9LmFudC1jb2wtbWQtMTN7ZGlzcGxheTpibG9jaztmbGV4OjAgMCA1NC4xNjY2NjY2NyU7bWF4LXdpZHRoOjU0LjE2NjY2NjY3JX0uYW50LWNvbC1tZC1wdXNoLTEze2xlZnQ6NTQuMTY2NjY2NjclfS5hbnQtY29sLW1kLXB1bGwtMTN7cmlnaHQ6NTQuMTY2NjY2NjclfS5hbnQtY29sLW1kLW9mZnNldC0xM3ttYXJnaW4tbGVmdDo1NC4xNjY2NjY2NyV9LmFudC1jb2wtbWQtb3JkZXItMTN7b3JkZXI6MTN9LmFudC1jb2wtbWQtMTJ7ZGlzcGxheTpibG9jaztmbGV4OjAgMCA1MCU7bWF4LXdpZHRoOjUwJX0uYW50LWNvbC1tZC1wdXNoLTEye2xlZnQ6NTAlfS5hbnQtY29sLW1kLXB1bGwtMTJ7cmlnaHQ6NTAlfS5hbnQtY29sLW1kLW9mZnNldC0xMnttYXJnaW4tbGVmdDo1MCV9LmFudC1jb2wtbWQtb3JkZXItMTJ7b3JkZXI6MTJ9LmFudC1jb2wtbWQtMTF7ZGlzcGxheTpibG9jaztmbGV4OjAgMCA0NS44MzMzMzMzMyU7bWF4LXdpZHRoOjQ1LjgzMzMzMzMzJX0uYW50LWNvbC1tZC1wdXNoLTExe2xlZnQ6NDUuODMzMzMzMzMlfS5hbnQtY29sLW1kLXB1bGwtMTF7cmlnaHQ6NDUuODMzMzMzMzMlfS5hbnQtY29sLW1kLW9mZnNldC0xMXttYXJnaW4tbGVmdDo0NS44MzMzMzMzMyV9LmFudC1jb2wtbWQtb3JkZXItMTF7b3JkZXI6MTF9LmFudC1jb2wtbWQtMTB7ZGlzcGxheTpibG9jaztmbGV4OjAgMCA0MS42NjY2NjY2NyU7bWF4LXdpZHRoOjQxLjY2NjY2NjY3JX0uYW50LWNvbC1tZC1wdXNoLTEwe2xlZnQ6NDEuNjY2NjY2NjclfS5hbnQtY29sLW1kLXB1bGwtMTB7cmlnaHQ6NDEuNjY2NjY2NjclfS5hbnQtY29sLW1kLW9mZnNldC0xMHttYXJnaW4tbGVmdDo0MS42NjY2NjY2NyV9LmFudC1jb2wtbWQtb3JkZXItMTB7b3JkZXI6MTB9LmFudC1jb2wtbWQtOXtkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDM3LjUlO21heC13aWR0aDozNy41JX0uYW50LWNvbC1tZC1wdXNoLTl7bGVmdDozNy41JX0uYW50LWNvbC1tZC1wdWxsLTl7cmlnaHQ6MzcuNSV9LmFudC1jb2wtbWQtb2Zmc2V0LTl7bWFyZ2luLWxlZnQ6MzcuNSV9LmFudC1jb2wtbWQtb3JkZXItOXtvcmRlcjo5fS5hbnQtY29sLW1kLTh7ZGlzcGxheTpibG9jaztmbGV4OjAgMCAzMy4zMzMzMzMzMyU7bWF4LXdpZHRoOjMzLjMzMzMzMzMzJX0uYW50LWNvbC1tZC1wdXNoLTh7bGVmdDozMy4zMzMzMzMzMyV9LmFudC1jb2wtbWQtcHVsbC04e3JpZ2h0OjMzLjMzMzMzMzMzJX0uYW50LWNvbC1tZC1vZmZzZXQtOHttYXJnaW4tbGVmdDozMy4zMzMzMzMzMyV9LmFudC1jb2wtbWQtb3JkZXItOHtvcmRlcjo4fS5hbnQtY29sLW1kLTd7ZGlzcGxheTpibG9jaztmbGV4OjAgMCAyOS4xNjY2NjY2NyU7bWF4LXdpZHRoOjI5LjE2NjY2NjY3JX0uYW50LWNvbC1tZC1wdXNoLTd7bGVmdDoyOS4xNjY2NjY2NyV9LmFudC1jb2wtbWQtcHVsbC03e3JpZ2h0OjI5LjE2NjY2NjY3JX0uYW50LWNvbC1tZC1vZmZzZXQtN3ttYXJnaW4tbGVmdDoyOS4xNjY2NjY2NyV9LmFudC1jb2wtbWQtb3JkZXItN3tvcmRlcjo3fS5hbnQtY29sLW1kLTZ7ZGlzcGxheTpibG9jaztmbGV4OjAgMCAyNSU7bWF4LXdpZHRoOjI1JX0uYW50LWNvbC1tZC1wdXNoLTZ7bGVmdDoyNSV9LmFudC1jb2wtbWQtcHVsbC02e3JpZ2h0OjI1JX0uYW50LWNvbC1tZC1vZmZzZXQtNnttYXJnaW4tbGVmdDoyNSV9LmFudC1jb2wtbWQtb3JkZXItNntvcmRlcjo2fS5hbnQtY29sLW1kLTV7ZGlzcGxheTpibG9jaztmbGV4OjAgMCAyMC44MzMzMzMzMyU7bWF4LXdpZHRoOjIwLjgzMzMzMzMzJX0uYW50LWNvbC1tZC1wdXNoLTV7bGVmdDoyMC44MzMzMzMzMyV9LmFudC1jb2wtbWQtcHVsbC01e3JpZ2h0OjIwLjgzMzMzMzMzJX0uYW50LWNvbC1tZC1vZmZzZXQtNXttYXJnaW4tbGVmdDoyMC44MzMzMzMzMyV9LmFudC1jb2wtbWQtb3JkZXItNXtvcmRlcjo1fS5hbnQtY29sLW1kLTR7ZGlzcGxheTpibG9jaztmbGV4OjAgMCAxNi42NjY2NjY2NyU7bWF4LXdpZHRoOjE2LjY2NjY2NjY3JX0uYW50LWNvbC1tZC1wdXNoLTR7bGVmdDoxNi42NjY2NjY2NyV9LmFudC1jb2wtbWQtcHVsbC00e3JpZ2h0OjE2LjY2NjY2NjY3JX0uYW50LWNvbC1tZC1vZmZzZXQtNHttYXJnaW4tbGVmdDoxNi42NjY2NjY2NyV9LmFudC1jb2wtbWQtb3JkZXItNHtvcmRlcjo0fS5hbnQtY29sLW1kLTN7ZGlzcGxheTpibG9jaztmbGV4OjAgMCAxMi41JTttYXgtd2lkdGg6MTIuNSV9LmFudC1jb2wtbWQtcHVzaC0ze2xlZnQ6MTIuNSV9LmFudC1jb2wtbWQtcHVsbC0ze3JpZ2h0OjEyLjUlfS5hbnQtY29sLW1kLW9mZnNldC0ze21hcmdpbi1sZWZ0OjEyLjUlfS5hbnQtY29sLW1kLW9yZGVyLTN7b3JkZXI6M30uYW50LWNvbC1tZC0ye2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgOC4zMzMzMzMzMyU7bWF4LXdpZHRoOjguMzMzMzMzMzMlfS5hbnQtY29sLW1kLXB1c2gtMntsZWZ0OjguMzMzMzMzMzMlfS5hbnQtY29sLW1kLXB1bGwtMntyaWdodDo4LjMzMzMzMzMzJX0uYW50LWNvbC1tZC1vZmZzZXQtMnttYXJnaW4tbGVmdDo4LjMzMzMzMzMzJX0uYW50LWNvbC1tZC1vcmRlci0ye29yZGVyOjJ9LmFudC1jb2wtbWQtMXtkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDQuMTY2NjY2NjclO21heC13aWR0aDo0LjE2NjY2NjY3JX0uYW50LWNvbC1tZC1wdXNoLTF7bGVmdDo0LjE2NjY2NjY3JX0uYW50LWNvbC1tZC1wdWxsLTF7cmlnaHQ6NC4xNjY2NjY2NyV9LmFudC1jb2wtbWQtb2Zmc2V0LTF7bWFyZ2luLWxlZnQ6NC4xNjY2NjY2NyV9LmFudC1jb2wtbWQtb3JkZXItMXtvcmRlcjoxfS5hbnQtY29sLW1kLTB7ZGlzcGxheTpub25lfS5hbnQtY29sLXB1c2gtMHtsZWZ0OmF1dG99LmFudC1jb2wtcHVsbC0we3JpZ2h0OmF1dG99LmFudC1jb2wtbWQtcHVzaC0we2xlZnQ6YXV0b30uYW50LWNvbC1tZC1wdWxsLTB7cmlnaHQ6YXV0b30uYW50LWNvbC1tZC1vZmZzZXQtMHttYXJnaW4tbGVmdDowfS5hbnQtY29sLW1kLW9yZGVyLTB7b3JkZXI6MH0uYW50LWNvbC1wdXNoLTAuYW50LWNvbC1ydGx7cmlnaHQ6YXV0b30uYW50LWNvbC1wdWxsLTAuYW50LWNvbC1ydGx7bGVmdDphdXRvfS5hbnQtY29sLW1kLXB1c2gtMC5hbnQtY29sLXJ0bHtyaWdodDphdXRvfS5hbnQtY29sLW1kLXB1bGwtMC5hbnQtY29sLXJ0bHtsZWZ0OmF1dG99LmFudC1jb2wtbWQtb2Zmc2V0LTAuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjB9LmFudC1jb2wtbWQtcHVzaC0xLmFudC1jb2wtcnRse3JpZ2h0OjQuMTY2NjY2NjclO2xlZnQ6YXV0b30uYW50LWNvbC1tZC1wdWxsLTEuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjQuMTY2NjY2NjclfS5hbnQtY29sLW1kLW9mZnNldC0xLmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo0LjE2NjY2NjY3JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLW1kLXB1c2gtMi5hbnQtY29sLXJ0bHtyaWdodDo4LjMzMzMzMzMzJTtsZWZ0OmF1dG99LmFudC1jb2wtbWQtcHVsbC0yLmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo4LjMzMzMzMzMzJX0uYW50LWNvbC1tZC1vZmZzZXQtMi5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6OC4zMzMzMzMzMyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC1tZC1wdXNoLTMuYW50LWNvbC1ydGx7cmlnaHQ6MTIuNSU7bGVmdDphdXRvfS5hbnQtY29sLW1kLXB1bGwtMy5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6MTIuNSV9LmFudC1jb2wtbWQtb2Zmc2V0LTMuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjEyLjUlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wtbWQtcHVzaC00LmFudC1jb2wtcnRse3JpZ2h0OjE2LjY2NjY2NjY3JTtsZWZ0OmF1dG99LmFudC1jb2wtbWQtcHVsbC00LmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDoxNi42NjY2NjY2NyV9LmFudC1jb2wtbWQtb2Zmc2V0LTQuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjE2LjY2NjY2NjY3JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLW1kLXB1c2gtNS5hbnQtY29sLXJ0bHtyaWdodDoyMC44MzMzMzMzMyU7bGVmdDphdXRvfS5hbnQtY29sLW1kLXB1bGwtNS5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6MjAuODMzMzMzMzMlfS5hbnQtY29sLW1kLW9mZnNldC01LmFudC1jb2wtcnRse21hcmdpbi1yaWdodDoyMC44MzMzMzMzMyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC1tZC1wdXNoLTYuYW50LWNvbC1ydGx7cmlnaHQ6MjUlO2xlZnQ6YXV0b30uYW50LWNvbC1tZC1wdWxsLTYuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjI1JX0uYW50LWNvbC1tZC1vZmZzZXQtNi5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6MjUlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wtbWQtcHVzaC03LmFudC1jb2wtcnRse3JpZ2h0OjI5LjE2NjY2NjY3JTtsZWZ0OmF1dG99LmFudC1jb2wtbWQtcHVsbC03LmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDoyOS4xNjY2NjY2NyV9LmFudC1jb2wtbWQtb2Zmc2V0LTcuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjI5LjE2NjY2NjY3JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLW1kLXB1c2gtOC5hbnQtY29sLXJ0bHtyaWdodDozMy4zMzMzMzMzMyU7bGVmdDphdXRvfS5hbnQtY29sLW1kLXB1bGwtOC5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6MzMuMzMzMzMzMzMlfS5hbnQtY29sLW1kLW9mZnNldC04LmFudC1jb2wtcnRse21hcmdpbi1yaWdodDozMy4zMzMzMzMzMyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC1tZC1wdXNoLTkuYW50LWNvbC1ydGx7cmlnaHQ6MzcuNSU7bGVmdDphdXRvfS5hbnQtY29sLW1kLXB1bGwtOS5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6MzcuNSV9LmFudC1jb2wtbWQtb2Zmc2V0LTkuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjM3LjUlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wtbWQtcHVzaC0xMC5hbnQtY29sLXJ0bHtyaWdodDo0MS42NjY2NjY2NyU7bGVmdDphdXRvfS5hbnQtY29sLW1kLXB1bGwtMTAuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjQxLjY2NjY2NjY3JX0uYW50LWNvbC1tZC1vZmZzZXQtMTAuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjQxLjY2NjY2NjY3JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLW1kLXB1c2gtMTEuYW50LWNvbC1ydGx7cmlnaHQ6NDUuODMzMzMzMzMlO2xlZnQ6YXV0b30uYW50LWNvbC1tZC1wdWxsLTExLmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo0NS44MzMzMzMzMyV9LmFudC1jb2wtbWQtb2Zmc2V0LTExLmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo0NS44MzMzMzMzMyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC1tZC1wdXNoLTEyLmFudC1jb2wtcnRse3JpZ2h0OjUwJTtsZWZ0OmF1dG99LmFudC1jb2wtbWQtcHVsbC0xMi5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6NTAlfS5hbnQtY29sLW1kLW9mZnNldC0xMi5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6NTAlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wtbWQtcHVzaC0xMy5hbnQtY29sLXJ0bHtyaWdodDo1NC4xNjY2NjY2NyU7bGVmdDphdXRvfS5hbnQtY29sLW1kLXB1bGwtMTMuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjU0LjE2NjY2NjY3JX0uYW50LWNvbC1tZC1vZmZzZXQtMTMuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjU0LjE2NjY2NjY3JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLW1kLXB1c2gtMTQuYW50LWNvbC1ydGx7cmlnaHQ6NTguMzMzMzMzMzMlO2xlZnQ6YXV0b30uYW50LWNvbC1tZC1wdWxsLTE0LmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo1OC4zMzMzMzMzMyV9LmFudC1jb2wtbWQtb2Zmc2V0LTE0LmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo1OC4zMzMzMzMzMyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC1tZC1wdXNoLTE1LmFudC1jb2wtcnRse3JpZ2h0OjYyLjUlO2xlZnQ6YXV0b30uYW50LWNvbC1tZC1wdWxsLTE1LmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo2Mi41JX0uYW50LWNvbC1tZC1vZmZzZXQtMTUuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjYyLjUlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wtbWQtcHVzaC0xNi5hbnQtY29sLXJ0bHtyaWdodDo2Ni42NjY2NjY2NyU7bGVmdDphdXRvfS5hbnQtY29sLW1kLXB1bGwtMTYuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjY2LjY2NjY2NjY3JX0uYW50LWNvbC1tZC1vZmZzZXQtMTYuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjY2LjY2NjY2NjY3JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLW1kLXB1c2gtMTcuYW50LWNvbC1ydGx7cmlnaHQ6NzAuODMzMzMzMzMlO2xlZnQ6YXV0b30uYW50LWNvbC1tZC1wdWxsLTE3LmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo3MC44MzMzMzMzMyV9LmFudC1jb2wtbWQtb2Zmc2V0LTE3LmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo3MC44MzMzMzMzMyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC1tZC1wdXNoLTE4LmFudC1jb2wtcnRse3JpZ2h0Ojc1JTtsZWZ0OmF1dG99LmFudC1jb2wtbWQtcHVsbC0xOC5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6NzUlfS5hbnQtY29sLW1kLW9mZnNldC0xOC5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6NzUlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wtbWQtcHVzaC0xOS5hbnQtY29sLXJ0bHtyaWdodDo3OS4xNjY2NjY2NyU7bGVmdDphdXRvfS5hbnQtY29sLW1kLXB1bGwtMTkuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0Ojc5LjE2NjY2NjY3JX0uYW50LWNvbC1tZC1vZmZzZXQtMTkuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0Ojc5LjE2NjY2NjY3JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLW1kLXB1c2gtMjAuYW50LWNvbC1ydGx7cmlnaHQ6ODMuMzMzMzMzMzMlO2xlZnQ6YXV0b30uYW50LWNvbC1tZC1wdWxsLTIwLmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo4My4zMzMzMzMzMyV9LmFudC1jb2wtbWQtb2Zmc2V0LTIwLmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo4My4zMzMzMzMzMyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC1tZC1wdXNoLTIxLmFudC1jb2wtcnRse3JpZ2h0Ojg3LjUlO2xlZnQ6YXV0b30uYW50LWNvbC1tZC1wdWxsLTIxLmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo4Ny41JX0uYW50LWNvbC1tZC1vZmZzZXQtMjEuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0Ojg3LjUlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wtbWQtcHVzaC0yMi5hbnQtY29sLXJ0bHtyaWdodDo5MS42NjY2NjY2NyU7bGVmdDphdXRvfS5hbnQtY29sLW1kLXB1bGwtMjIuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjkxLjY2NjY2NjY3JX0uYW50LWNvbC1tZC1vZmZzZXQtMjIuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjkxLjY2NjY2NjY3JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLW1kLXB1c2gtMjMuYW50LWNvbC1ydGx7cmlnaHQ6OTUuODMzMzMzMzMlO2xlZnQ6YXV0b30uYW50LWNvbC1tZC1wdWxsLTIzLmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo5NS44MzMzMzMzMyV9LmFudC1jb2wtbWQtb2Zmc2V0LTIzLmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo5NS44MzMzMzMzMyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC1tZC1wdXNoLTI0LmFudC1jb2wtcnRse3JpZ2h0OjEwMCU7bGVmdDphdXRvfS5hbnQtY29sLW1kLXB1bGwtMjQuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjEwMCV9LmFudC1jb2wtbWQtb2Zmc2V0LTI0LmFudC1jb2wtcnRse21hcmdpbi1yaWdodDoxMDAlO21hcmdpbi1sZWZ0OjB9fUBtZWRpYSAobWluLXdpZHRoOjk5MnB4KXsuYW50LWNvbC1sZy0yNHtkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDEwMCU7bWF4LXdpZHRoOjEwMCV9LmFudC1jb2wtbGctcHVzaC0yNHtsZWZ0OjEwMCV9LmFudC1jb2wtbGctcHVsbC0yNHtyaWdodDoxMDAlfS5hbnQtY29sLWxnLW9mZnNldC0yNHttYXJnaW4tbGVmdDoxMDAlfS5hbnQtY29sLWxnLW9yZGVyLTI0e29yZGVyOjI0fS5hbnQtY29sLWxnLTIze2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgOTUuODMzMzMzMzMlO21heC13aWR0aDo5NS44MzMzMzMzMyV9LmFudC1jb2wtbGctcHVzaC0yM3tsZWZ0Ojk1LjgzMzMzMzMzJX0uYW50LWNvbC1sZy1wdWxsLTIze3JpZ2h0Ojk1LjgzMzMzMzMzJX0uYW50LWNvbC1sZy1vZmZzZXQtMjN7bWFyZ2luLWxlZnQ6OTUuODMzMzMzMzMlfS5hbnQtY29sLWxnLW9yZGVyLTIze29yZGVyOjIzfS5hbnQtY29sLWxnLTIye2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgOTEuNjY2NjY2NjclO21heC13aWR0aDo5MS42NjY2NjY2NyV9LmFudC1jb2wtbGctcHVzaC0yMntsZWZ0OjkxLjY2NjY2NjY3JX0uYW50LWNvbC1sZy1wdWxsLTIye3JpZ2h0OjkxLjY2NjY2NjY3JX0uYW50LWNvbC1sZy1vZmZzZXQtMjJ7bWFyZ2luLWxlZnQ6OTEuNjY2NjY2NjclfS5hbnQtY29sLWxnLW9yZGVyLTIye29yZGVyOjIyfS5hbnQtY29sLWxnLTIxe2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgODcuNSU7bWF4LXdpZHRoOjg3LjUlfS5hbnQtY29sLWxnLXB1c2gtMjF7bGVmdDo4Ny41JX0uYW50LWNvbC1sZy1wdWxsLTIxe3JpZ2h0Ojg3LjUlfS5hbnQtY29sLWxnLW9mZnNldC0yMXttYXJnaW4tbGVmdDo4Ny41JX0uYW50LWNvbC1sZy1vcmRlci0yMXtvcmRlcjoyMX0uYW50LWNvbC1sZy0yMHtkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDgzLjMzMzMzMzMzJTttYXgtd2lkdGg6ODMuMzMzMzMzMzMlfS5hbnQtY29sLWxnLXB1c2gtMjB7bGVmdDo4My4zMzMzMzMzMyV9LmFudC1jb2wtbGctcHVsbC0yMHtyaWdodDo4My4zMzMzMzMzMyV9LmFudC1jb2wtbGctb2Zmc2V0LTIwe21hcmdpbi1sZWZ0OjgzLjMzMzMzMzMzJX0uYW50LWNvbC1sZy1vcmRlci0yMHtvcmRlcjoyMH0uYW50LWNvbC1sZy0xOXtkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDc5LjE2NjY2NjY3JTttYXgtd2lkdGg6NzkuMTY2NjY2NjclfS5hbnQtY29sLWxnLXB1c2gtMTl7bGVmdDo3OS4xNjY2NjY2NyV9LmFudC1jb2wtbGctcHVsbC0xOXtyaWdodDo3OS4xNjY2NjY2NyV9LmFudC1jb2wtbGctb2Zmc2V0LTE5e21hcmdpbi1sZWZ0Ojc5LjE2NjY2NjY3JX0uYW50LWNvbC1sZy1vcmRlci0xOXtvcmRlcjoxOX0uYW50LWNvbC1sZy0xOHtkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDc1JTttYXgtd2lkdGg6NzUlfS5hbnQtY29sLWxnLXB1c2gtMTh7bGVmdDo3NSV9LmFudC1jb2wtbGctcHVsbC0xOHtyaWdodDo3NSV9LmFudC1jb2wtbGctb2Zmc2V0LTE4e21hcmdpbi1sZWZ0Ojc1JX0uYW50LWNvbC1sZy1vcmRlci0xOHtvcmRlcjoxOH0uYW50LWNvbC1sZy0xN3tkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDcwLjgzMzMzMzMzJTttYXgtd2lkdGg6NzAuODMzMzMzMzMlfS5hbnQtY29sLWxnLXB1c2gtMTd7bGVmdDo3MC44MzMzMzMzMyV9LmFudC1jb2wtbGctcHVsbC0xN3tyaWdodDo3MC44MzMzMzMzMyV9LmFudC1jb2wtbGctb2Zmc2V0LTE3e21hcmdpbi1sZWZ0OjcwLjgzMzMzMzMzJX0uYW50LWNvbC1sZy1vcmRlci0xN3tvcmRlcjoxN30uYW50LWNvbC1sZy0xNntkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDY2LjY2NjY2NjY3JTttYXgtd2lkdGg6NjYuNjY2NjY2NjclfS5hbnQtY29sLWxnLXB1c2gtMTZ7bGVmdDo2Ni42NjY2NjY2NyV9LmFudC1jb2wtbGctcHVsbC0xNntyaWdodDo2Ni42NjY2NjY2NyV9LmFudC1jb2wtbGctb2Zmc2V0LTE2e21hcmdpbi1sZWZ0OjY2LjY2NjY2NjY3JX0uYW50LWNvbC1sZy1vcmRlci0xNntvcmRlcjoxNn0uYW50LWNvbC1sZy0xNXtkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDYyLjUlO21heC13aWR0aDo2Mi41JX0uYW50LWNvbC1sZy1wdXNoLTE1e2xlZnQ6NjIuNSV9LmFudC1jb2wtbGctcHVsbC0xNXtyaWdodDo2Mi41JX0uYW50LWNvbC1sZy1vZmZzZXQtMTV7bWFyZ2luLWxlZnQ6NjIuNSV9LmFudC1jb2wtbGctb3JkZXItMTV7b3JkZXI6MTV9LmFudC1jb2wtbGctMTR7ZGlzcGxheTpibG9jaztmbGV4OjAgMCA1OC4zMzMzMzMzMyU7bWF4LXdpZHRoOjU4LjMzMzMzMzMzJX0uYW50LWNvbC1sZy1wdXNoLTE0e2xlZnQ6NTguMzMzMzMzMzMlfS5hbnQtY29sLWxnLXB1bGwtMTR7cmlnaHQ6NTguMzMzMzMzMzMlfS5hbnQtY29sLWxnLW9mZnNldC0xNHttYXJnaW4tbGVmdDo1OC4zMzMzMzMzMyV9LmFudC1jb2wtbGctb3JkZXItMTR7b3JkZXI6MTR9LmFudC1jb2wtbGctMTN7ZGlzcGxheTpibG9jaztmbGV4OjAgMCA1NC4xNjY2NjY2NyU7bWF4LXdpZHRoOjU0LjE2NjY2NjY3JX0uYW50LWNvbC1sZy1wdXNoLTEze2xlZnQ6NTQuMTY2NjY2NjclfS5hbnQtY29sLWxnLXB1bGwtMTN7cmlnaHQ6NTQuMTY2NjY2NjclfS5hbnQtY29sLWxnLW9mZnNldC0xM3ttYXJnaW4tbGVmdDo1NC4xNjY2NjY2NyV9LmFudC1jb2wtbGctb3JkZXItMTN7b3JkZXI6MTN9LmFudC1jb2wtbGctMTJ7ZGlzcGxheTpibG9jaztmbGV4OjAgMCA1MCU7bWF4LXdpZHRoOjUwJX0uYW50LWNvbC1sZy1wdXNoLTEye2xlZnQ6NTAlfS5hbnQtY29sLWxnLXB1bGwtMTJ7cmlnaHQ6NTAlfS5hbnQtY29sLWxnLW9mZnNldC0xMnttYXJnaW4tbGVmdDo1MCV9LmFudC1jb2wtbGctb3JkZXItMTJ7b3JkZXI6MTJ9LmFudC1jb2wtbGctMTF7ZGlzcGxheTpibG9jaztmbGV4OjAgMCA0NS44MzMzMzMzMyU7bWF4LXdpZHRoOjQ1LjgzMzMzMzMzJX0uYW50LWNvbC1sZy1wdXNoLTExe2xlZnQ6NDUuODMzMzMzMzMlfS5hbnQtY29sLWxnLXB1bGwtMTF7cmlnaHQ6NDUuODMzMzMzMzMlfS5hbnQtY29sLWxnLW9mZnNldC0xMXttYXJnaW4tbGVmdDo0NS44MzMzMzMzMyV9LmFudC1jb2wtbGctb3JkZXItMTF7b3JkZXI6MTF9LmFudC1jb2wtbGctMTB7ZGlzcGxheTpibG9jaztmbGV4OjAgMCA0MS42NjY2NjY2NyU7bWF4LXdpZHRoOjQxLjY2NjY2NjY3JX0uYW50LWNvbC1sZy1wdXNoLTEwe2xlZnQ6NDEuNjY2NjY2NjclfS5hbnQtY29sLWxnLXB1bGwtMTB7cmlnaHQ6NDEuNjY2NjY2NjclfS5hbnQtY29sLWxnLW9mZnNldC0xMHttYXJnaW4tbGVmdDo0MS42NjY2NjY2NyV9LmFudC1jb2wtbGctb3JkZXItMTB7b3JkZXI6MTB9LmFudC1jb2wtbGctOXtkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDM3LjUlO21heC13aWR0aDozNy41JX0uYW50LWNvbC1sZy1wdXNoLTl7bGVmdDozNy41JX0uYW50LWNvbC1sZy1wdWxsLTl7cmlnaHQ6MzcuNSV9LmFudC1jb2wtbGctb2Zmc2V0LTl7bWFyZ2luLWxlZnQ6MzcuNSV9LmFudC1jb2wtbGctb3JkZXItOXtvcmRlcjo5fS5hbnQtY29sLWxnLTh7ZGlzcGxheTpibG9jaztmbGV4OjAgMCAzMy4zMzMzMzMzMyU7bWF4LXdpZHRoOjMzLjMzMzMzMzMzJX0uYW50LWNvbC1sZy1wdXNoLTh7bGVmdDozMy4zMzMzMzMzMyV9LmFudC1jb2wtbGctcHVsbC04e3JpZ2h0OjMzLjMzMzMzMzMzJX0uYW50LWNvbC1sZy1vZmZzZXQtOHttYXJnaW4tbGVmdDozMy4zMzMzMzMzMyV9LmFudC1jb2wtbGctb3JkZXItOHtvcmRlcjo4fS5hbnQtY29sLWxnLTd7ZGlzcGxheTpibG9jaztmbGV4OjAgMCAyOS4xNjY2NjY2NyU7bWF4LXdpZHRoOjI5LjE2NjY2NjY3JX0uYW50LWNvbC1sZy1wdXNoLTd7bGVmdDoyOS4xNjY2NjY2NyV9LmFudC1jb2wtbGctcHVsbC03e3JpZ2h0OjI5LjE2NjY2NjY3JX0uYW50LWNvbC1sZy1vZmZzZXQtN3ttYXJnaW4tbGVmdDoyOS4xNjY2NjY2NyV9LmFudC1jb2wtbGctb3JkZXItN3tvcmRlcjo3fS5hbnQtY29sLWxnLTZ7ZGlzcGxheTpibG9jaztmbGV4OjAgMCAyNSU7bWF4LXdpZHRoOjI1JX0uYW50LWNvbC1sZy1wdXNoLTZ7bGVmdDoyNSV9LmFudC1jb2wtbGctcHVsbC02e3JpZ2h0OjI1JX0uYW50LWNvbC1sZy1vZmZzZXQtNnttYXJnaW4tbGVmdDoyNSV9LmFudC1jb2wtbGctb3JkZXItNntvcmRlcjo2fS5hbnQtY29sLWxnLTV7ZGlzcGxheTpibG9jaztmbGV4OjAgMCAyMC44MzMzMzMzMyU7bWF4LXdpZHRoOjIwLjgzMzMzMzMzJX0uYW50LWNvbC1sZy1wdXNoLTV7bGVmdDoyMC44MzMzMzMzMyV9LmFudC1jb2wtbGctcHVsbC01e3JpZ2h0OjIwLjgzMzMzMzMzJX0uYW50LWNvbC1sZy1vZmZzZXQtNXttYXJnaW4tbGVmdDoyMC44MzMzMzMzMyV9LmFudC1jb2wtbGctb3JkZXItNXtvcmRlcjo1fS5hbnQtY29sLWxnLTR7ZGlzcGxheTpibG9jaztmbGV4OjAgMCAxNi42NjY2NjY2NyU7bWF4LXdpZHRoOjE2LjY2NjY2NjY3JX0uYW50LWNvbC1sZy1wdXNoLTR7bGVmdDoxNi42NjY2NjY2NyV9LmFudC1jb2wtbGctcHVsbC00e3JpZ2h0OjE2LjY2NjY2NjY3JX0uYW50LWNvbC1sZy1vZmZzZXQtNHttYXJnaW4tbGVmdDoxNi42NjY2NjY2NyV9LmFudC1jb2wtbGctb3JkZXItNHtvcmRlcjo0fS5hbnQtY29sLWxnLTN7ZGlzcGxheTpibG9jaztmbGV4OjAgMCAxMi41JTttYXgtd2lkdGg6MTIuNSV9LmFudC1jb2wtbGctcHVzaC0ze2xlZnQ6MTIuNSV9LmFudC1jb2wtbGctcHVsbC0ze3JpZ2h0OjEyLjUlfS5hbnQtY29sLWxnLW9mZnNldC0ze21hcmdpbi1sZWZ0OjEyLjUlfS5hbnQtY29sLWxnLW9yZGVyLTN7b3JkZXI6M30uYW50LWNvbC1sZy0ye2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgOC4zMzMzMzMzMyU7bWF4LXdpZHRoOjguMzMzMzMzMzMlfS5hbnQtY29sLWxnLXB1c2gtMntsZWZ0OjguMzMzMzMzMzMlfS5hbnQtY29sLWxnLXB1bGwtMntyaWdodDo4LjMzMzMzMzMzJX0uYW50LWNvbC1sZy1vZmZzZXQtMnttYXJnaW4tbGVmdDo4LjMzMzMzMzMzJX0uYW50LWNvbC1sZy1vcmRlci0ye29yZGVyOjJ9LmFudC1jb2wtbGctMXtkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDQuMTY2NjY2NjclO21heC13aWR0aDo0LjE2NjY2NjY3JX0uYW50LWNvbC1sZy1wdXNoLTF7bGVmdDo0LjE2NjY2NjY3JX0uYW50LWNvbC1sZy1wdWxsLTF7cmlnaHQ6NC4xNjY2NjY2NyV9LmFudC1jb2wtbGctb2Zmc2V0LTF7bWFyZ2luLWxlZnQ6NC4xNjY2NjY2NyV9LmFudC1jb2wtbGctb3JkZXItMXtvcmRlcjoxfS5hbnQtY29sLWxnLTB7ZGlzcGxheTpub25lfS5hbnQtY29sLXB1c2gtMHtsZWZ0OmF1dG99LmFudC1jb2wtcHVsbC0we3JpZ2h0OmF1dG99LmFudC1jb2wtbGctcHVzaC0we2xlZnQ6YXV0b30uYW50LWNvbC1sZy1wdWxsLTB7cmlnaHQ6YXV0b30uYW50LWNvbC1sZy1vZmZzZXQtMHttYXJnaW4tbGVmdDowfS5hbnQtY29sLWxnLW9yZGVyLTB7b3JkZXI6MH0uYW50LWNvbC1wdXNoLTAuYW50LWNvbC1ydGx7cmlnaHQ6YXV0b30uYW50LWNvbC1wdWxsLTAuYW50LWNvbC1ydGx7bGVmdDphdXRvfS5hbnQtY29sLWxnLXB1c2gtMC5hbnQtY29sLXJ0bHtyaWdodDphdXRvfS5hbnQtY29sLWxnLXB1bGwtMC5hbnQtY29sLXJ0bHtsZWZ0OmF1dG99LmFudC1jb2wtbGctb2Zmc2V0LTAuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjB9LmFudC1jb2wtbGctcHVzaC0xLmFudC1jb2wtcnRse3JpZ2h0OjQuMTY2NjY2NjclO2xlZnQ6YXV0b30uYW50LWNvbC1sZy1wdWxsLTEuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjQuMTY2NjY2NjclfS5hbnQtY29sLWxnLW9mZnNldC0xLmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo0LjE2NjY2NjY3JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLWxnLXB1c2gtMi5hbnQtY29sLXJ0bHtyaWdodDo4LjMzMzMzMzMzJTtsZWZ0OmF1dG99LmFudC1jb2wtbGctcHVsbC0yLmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo4LjMzMzMzMzMzJX0uYW50LWNvbC1sZy1vZmZzZXQtMi5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6OC4zMzMzMzMzMyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC1sZy1wdXNoLTMuYW50LWNvbC1ydGx7cmlnaHQ6MTIuNSU7bGVmdDphdXRvfS5hbnQtY29sLWxnLXB1bGwtMy5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6MTIuNSV9LmFudC1jb2wtbGctb2Zmc2V0LTMuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjEyLjUlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wtbGctcHVzaC00LmFudC1jb2wtcnRse3JpZ2h0OjE2LjY2NjY2NjY3JTtsZWZ0OmF1dG99LmFudC1jb2wtbGctcHVsbC00LmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDoxNi42NjY2NjY2NyV9LmFudC1jb2wtbGctb2Zmc2V0LTQuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjE2LjY2NjY2NjY3JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLWxnLXB1c2gtNS5hbnQtY29sLXJ0bHtyaWdodDoyMC44MzMzMzMzMyU7bGVmdDphdXRvfS5hbnQtY29sLWxnLXB1bGwtNS5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6MjAuODMzMzMzMzMlfS5hbnQtY29sLWxnLW9mZnNldC01LmFudC1jb2wtcnRse21hcmdpbi1yaWdodDoyMC44MzMzMzMzMyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC1sZy1wdXNoLTYuYW50LWNvbC1ydGx7cmlnaHQ6MjUlO2xlZnQ6YXV0b30uYW50LWNvbC1sZy1wdWxsLTYuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjI1JX0uYW50LWNvbC1sZy1vZmZzZXQtNi5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6MjUlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wtbGctcHVzaC03LmFudC1jb2wtcnRse3JpZ2h0OjI5LjE2NjY2NjY3JTtsZWZ0OmF1dG99LmFudC1jb2wtbGctcHVsbC03LmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDoyOS4xNjY2NjY2NyV9LmFudC1jb2wtbGctb2Zmc2V0LTcuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjI5LjE2NjY2NjY3JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLWxnLXB1c2gtOC5hbnQtY29sLXJ0bHtyaWdodDozMy4zMzMzMzMzMyU7bGVmdDphdXRvfS5hbnQtY29sLWxnLXB1bGwtOC5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6MzMuMzMzMzMzMzMlfS5hbnQtY29sLWxnLW9mZnNldC04LmFudC1jb2wtcnRse21hcmdpbi1yaWdodDozMy4zMzMzMzMzMyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC1sZy1wdXNoLTkuYW50LWNvbC1ydGx7cmlnaHQ6MzcuNSU7bGVmdDphdXRvfS5hbnQtY29sLWxnLXB1bGwtOS5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6MzcuNSV9LmFudC1jb2wtbGctb2Zmc2V0LTkuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjM3LjUlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wtbGctcHVzaC0xMC5hbnQtY29sLXJ0bHtyaWdodDo0MS42NjY2NjY2NyU7bGVmdDphdXRvfS5hbnQtY29sLWxnLXB1bGwtMTAuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjQxLjY2NjY2NjY3JX0uYW50LWNvbC1sZy1vZmZzZXQtMTAuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjQxLjY2NjY2NjY3JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLWxnLXB1c2gtMTEuYW50LWNvbC1ydGx7cmlnaHQ6NDUuODMzMzMzMzMlO2xlZnQ6YXV0b30uYW50LWNvbC1sZy1wdWxsLTExLmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo0NS44MzMzMzMzMyV9LmFudC1jb2wtbGctb2Zmc2V0LTExLmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo0NS44MzMzMzMzMyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC1sZy1wdXNoLTEyLmFudC1jb2wtcnRse3JpZ2h0OjUwJTtsZWZ0OmF1dG99LmFudC1jb2wtbGctcHVsbC0xMi5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6NTAlfS5hbnQtY29sLWxnLW9mZnNldC0xMi5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6NTAlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wtbGctcHVzaC0xMy5hbnQtY29sLXJ0bHtyaWdodDo1NC4xNjY2NjY2NyU7bGVmdDphdXRvfS5hbnQtY29sLWxnLXB1bGwtMTMuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjU0LjE2NjY2NjY3JX0uYW50LWNvbC1sZy1vZmZzZXQtMTMuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjU0LjE2NjY2NjY3JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLWxnLXB1c2gtMTQuYW50LWNvbC1ydGx7cmlnaHQ6NTguMzMzMzMzMzMlO2xlZnQ6YXV0b30uYW50LWNvbC1sZy1wdWxsLTE0LmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo1OC4zMzMzMzMzMyV9LmFudC1jb2wtbGctb2Zmc2V0LTE0LmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo1OC4zMzMzMzMzMyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC1sZy1wdXNoLTE1LmFudC1jb2wtcnRse3JpZ2h0OjYyLjUlO2xlZnQ6YXV0b30uYW50LWNvbC1sZy1wdWxsLTE1LmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo2Mi41JX0uYW50LWNvbC1sZy1vZmZzZXQtMTUuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjYyLjUlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wtbGctcHVzaC0xNi5hbnQtY29sLXJ0bHtyaWdodDo2Ni42NjY2NjY2NyU7bGVmdDphdXRvfS5hbnQtY29sLWxnLXB1bGwtMTYuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjY2LjY2NjY2NjY3JX0uYW50LWNvbC1sZy1vZmZzZXQtMTYuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjY2LjY2NjY2NjY3JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLWxnLXB1c2gtMTcuYW50LWNvbC1ydGx7cmlnaHQ6NzAuODMzMzMzMzMlO2xlZnQ6YXV0b30uYW50LWNvbC1sZy1wdWxsLTE3LmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo3MC44MzMzMzMzMyV9LmFudC1jb2wtbGctb2Zmc2V0LTE3LmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo3MC44MzMzMzMzMyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC1sZy1wdXNoLTE4LmFudC1jb2wtcnRse3JpZ2h0Ojc1JTtsZWZ0OmF1dG99LmFudC1jb2wtbGctcHVsbC0xOC5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6NzUlfS5hbnQtY29sLWxnLW9mZnNldC0xOC5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6NzUlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wtbGctcHVzaC0xOS5hbnQtY29sLXJ0bHtyaWdodDo3OS4xNjY2NjY2NyU7bGVmdDphdXRvfS5hbnQtY29sLWxnLXB1bGwtMTkuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0Ojc5LjE2NjY2NjY3JX0uYW50LWNvbC1sZy1vZmZzZXQtMTkuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0Ojc5LjE2NjY2NjY3JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLWxnLXB1c2gtMjAuYW50LWNvbC1ydGx7cmlnaHQ6ODMuMzMzMzMzMzMlO2xlZnQ6YXV0b30uYW50LWNvbC1sZy1wdWxsLTIwLmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo4My4zMzMzMzMzMyV9LmFudC1jb2wtbGctb2Zmc2V0LTIwLmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo4My4zMzMzMzMzMyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC1sZy1wdXNoLTIxLmFudC1jb2wtcnRse3JpZ2h0Ojg3LjUlO2xlZnQ6YXV0b30uYW50LWNvbC1sZy1wdWxsLTIxLmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo4Ny41JX0uYW50LWNvbC1sZy1vZmZzZXQtMjEuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0Ojg3LjUlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wtbGctcHVzaC0yMi5hbnQtY29sLXJ0bHtyaWdodDo5MS42NjY2NjY2NyU7bGVmdDphdXRvfS5hbnQtY29sLWxnLXB1bGwtMjIuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjkxLjY2NjY2NjY3JX0uYW50LWNvbC1sZy1vZmZzZXQtMjIuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjkxLjY2NjY2NjY3JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLWxnLXB1c2gtMjMuYW50LWNvbC1ydGx7cmlnaHQ6OTUuODMzMzMzMzMlO2xlZnQ6YXV0b30uYW50LWNvbC1sZy1wdWxsLTIzLmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo5NS44MzMzMzMzMyV9LmFudC1jb2wtbGctb2Zmc2V0LTIzLmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo5NS44MzMzMzMzMyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC1sZy1wdXNoLTI0LmFudC1jb2wtcnRse3JpZ2h0OjEwMCU7bGVmdDphdXRvfS5hbnQtY29sLWxnLXB1bGwtMjQuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjEwMCV9LmFudC1jb2wtbGctb2Zmc2V0LTI0LmFudC1jb2wtcnRse21hcmdpbi1yaWdodDoxMDAlO21hcmdpbi1sZWZ0OjB9fUBtZWRpYSAobWluLXdpZHRoOjEyMDBweCl7LmFudC1jb2wteGwtMjR7ZGlzcGxheTpibG9jaztmbGV4OjAgMCAxMDAlO21heC13aWR0aDoxMDAlfS5hbnQtY29sLXhsLXB1c2gtMjR7bGVmdDoxMDAlfS5hbnQtY29sLXhsLXB1bGwtMjR7cmlnaHQ6MTAwJX0uYW50LWNvbC14bC1vZmZzZXQtMjR7bWFyZ2luLWxlZnQ6MTAwJX0uYW50LWNvbC14bC1vcmRlci0yNHtvcmRlcjoyNH0uYW50LWNvbC14bC0yM3tkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDk1LjgzMzMzMzMzJTttYXgtd2lkdGg6OTUuODMzMzMzMzMlfS5hbnQtY29sLXhsLXB1c2gtMjN7bGVmdDo5NS44MzMzMzMzMyV9LmFudC1jb2wteGwtcHVsbC0yM3tyaWdodDo5NS44MzMzMzMzMyV9LmFudC1jb2wteGwtb2Zmc2V0LTIze21hcmdpbi1sZWZ0Ojk1LjgzMzMzMzMzJX0uYW50LWNvbC14bC1vcmRlci0yM3tvcmRlcjoyM30uYW50LWNvbC14bC0yMntkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDkxLjY2NjY2NjY3JTttYXgtd2lkdGg6OTEuNjY2NjY2NjclfS5hbnQtY29sLXhsLXB1c2gtMjJ7bGVmdDo5MS42NjY2NjY2NyV9LmFudC1jb2wteGwtcHVsbC0yMntyaWdodDo5MS42NjY2NjY2NyV9LmFudC1jb2wteGwtb2Zmc2V0LTIye21hcmdpbi1sZWZ0OjkxLjY2NjY2NjY3JX0uYW50LWNvbC14bC1vcmRlci0yMntvcmRlcjoyMn0uYW50LWNvbC14bC0yMXtkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDg3LjUlO21heC13aWR0aDo4Ny41JX0uYW50LWNvbC14bC1wdXNoLTIxe2xlZnQ6ODcuNSV9LmFudC1jb2wteGwtcHVsbC0yMXtyaWdodDo4Ny41JX0uYW50LWNvbC14bC1vZmZzZXQtMjF7bWFyZ2luLWxlZnQ6ODcuNSV9LmFudC1jb2wteGwtb3JkZXItMjF7b3JkZXI6MjF9LmFudC1jb2wteGwtMjB7ZGlzcGxheTpibG9jaztmbGV4OjAgMCA4My4zMzMzMzMzMyU7bWF4LXdpZHRoOjgzLjMzMzMzMzMzJX0uYW50LWNvbC14bC1wdXNoLTIwe2xlZnQ6ODMuMzMzMzMzMzMlfS5hbnQtY29sLXhsLXB1bGwtMjB7cmlnaHQ6ODMuMzMzMzMzMzMlfS5hbnQtY29sLXhsLW9mZnNldC0yMHttYXJnaW4tbGVmdDo4My4zMzMzMzMzMyV9LmFudC1jb2wteGwtb3JkZXItMjB7b3JkZXI6MjB9LmFudC1jb2wteGwtMTl7ZGlzcGxheTpibG9jaztmbGV4OjAgMCA3OS4xNjY2NjY2NyU7bWF4LXdpZHRoOjc5LjE2NjY2NjY3JX0uYW50LWNvbC14bC1wdXNoLTE5e2xlZnQ6NzkuMTY2NjY2NjclfS5hbnQtY29sLXhsLXB1bGwtMTl7cmlnaHQ6NzkuMTY2NjY2NjclfS5hbnQtY29sLXhsLW9mZnNldC0xOXttYXJnaW4tbGVmdDo3OS4xNjY2NjY2NyV9LmFudC1jb2wteGwtb3JkZXItMTl7b3JkZXI6MTl9LmFudC1jb2wteGwtMTh7ZGlzcGxheTpibG9jaztmbGV4OjAgMCA3NSU7bWF4LXdpZHRoOjc1JX0uYW50LWNvbC14bC1wdXNoLTE4e2xlZnQ6NzUlfS5hbnQtY29sLXhsLXB1bGwtMTh7cmlnaHQ6NzUlfS5hbnQtY29sLXhsLW9mZnNldC0xOHttYXJnaW4tbGVmdDo3NSV9LmFudC1jb2wteGwtb3JkZXItMTh7b3JkZXI6MTh9LmFudC1jb2wteGwtMTd7ZGlzcGxheTpibG9jaztmbGV4OjAgMCA3MC44MzMzMzMzMyU7bWF4LXdpZHRoOjcwLjgzMzMzMzMzJX0uYW50LWNvbC14bC1wdXNoLTE3e2xlZnQ6NzAuODMzMzMzMzMlfS5hbnQtY29sLXhsLXB1bGwtMTd7cmlnaHQ6NzAuODMzMzMzMzMlfS5hbnQtY29sLXhsLW9mZnNldC0xN3ttYXJnaW4tbGVmdDo3MC44MzMzMzMzMyV9LmFudC1jb2wteGwtb3JkZXItMTd7b3JkZXI6MTd9LmFudC1jb2wteGwtMTZ7ZGlzcGxheTpibG9jaztmbGV4OjAgMCA2Ni42NjY2NjY2NyU7bWF4LXdpZHRoOjY2LjY2NjY2NjY3JX0uYW50LWNvbC14bC1wdXNoLTE2e2xlZnQ6NjYuNjY2NjY2NjclfS5hbnQtY29sLXhsLXB1bGwtMTZ7cmlnaHQ6NjYuNjY2NjY2NjclfS5hbnQtY29sLXhsLW9mZnNldC0xNnttYXJnaW4tbGVmdDo2Ni42NjY2NjY2NyV9LmFudC1jb2wteGwtb3JkZXItMTZ7b3JkZXI6MTZ9LmFudC1jb2wteGwtMTV7ZGlzcGxheTpibG9jaztmbGV4OjAgMCA2Mi41JTttYXgtd2lkdGg6NjIuNSV9LmFudC1jb2wteGwtcHVzaC0xNXtsZWZ0OjYyLjUlfS5hbnQtY29sLXhsLXB1bGwtMTV7cmlnaHQ6NjIuNSV9LmFudC1jb2wteGwtb2Zmc2V0LTE1e21hcmdpbi1sZWZ0OjYyLjUlfS5hbnQtY29sLXhsLW9yZGVyLTE1e29yZGVyOjE1fS5hbnQtY29sLXhsLTE0e2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgNTguMzMzMzMzMzMlO21heC13aWR0aDo1OC4zMzMzMzMzMyV9LmFudC1jb2wteGwtcHVzaC0xNHtsZWZ0OjU4LjMzMzMzMzMzJX0uYW50LWNvbC14bC1wdWxsLTE0e3JpZ2h0OjU4LjMzMzMzMzMzJX0uYW50LWNvbC14bC1vZmZzZXQtMTR7bWFyZ2luLWxlZnQ6NTguMzMzMzMzMzMlfS5hbnQtY29sLXhsLW9yZGVyLTE0e29yZGVyOjE0fS5hbnQtY29sLXhsLTEze2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgNTQuMTY2NjY2NjclO21heC13aWR0aDo1NC4xNjY2NjY2NyV9LmFudC1jb2wteGwtcHVzaC0xM3tsZWZ0OjU0LjE2NjY2NjY3JX0uYW50LWNvbC14bC1wdWxsLTEze3JpZ2h0OjU0LjE2NjY2NjY3JX0uYW50LWNvbC14bC1vZmZzZXQtMTN7bWFyZ2luLWxlZnQ6NTQuMTY2NjY2NjclfS5hbnQtY29sLXhsLW9yZGVyLTEze29yZGVyOjEzfS5hbnQtY29sLXhsLTEye2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgNTAlO21heC13aWR0aDo1MCV9LmFudC1jb2wteGwtcHVzaC0xMntsZWZ0OjUwJX0uYW50LWNvbC14bC1wdWxsLTEye3JpZ2h0OjUwJX0uYW50LWNvbC14bC1vZmZzZXQtMTJ7bWFyZ2luLWxlZnQ6NTAlfS5hbnQtY29sLXhsLW9yZGVyLTEye29yZGVyOjEyfS5hbnQtY29sLXhsLTExe2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgNDUuODMzMzMzMzMlO21heC13aWR0aDo0NS44MzMzMzMzMyV9LmFudC1jb2wteGwtcHVzaC0xMXtsZWZ0OjQ1LjgzMzMzMzMzJX0uYW50LWNvbC14bC1wdWxsLTExe3JpZ2h0OjQ1LjgzMzMzMzMzJX0uYW50LWNvbC14bC1vZmZzZXQtMTF7bWFyZ2luLWxlZnQ6NDUuODMzMzMzMzMlfS5hbnQtY29sLXhsLW9yZGVyLTExe29yZGVyOjExfS5hbnQtY29sLXhsLTEwe2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgNDEuNjY2NjY2NjclO21heC13aWR0aDo0MS42NjY2NjY2NyV9LmFudC1jb2wteGwtcHVzaC0xMHtsZWZ0OjQxLjY2NjY2NjY3JX0uYW50LWNvbC14bC1wdWxsLTEwe3JpZ2h0OjQxLjY2NjY2NjY3JX0uYW50LWNvbC14bC1vZmZzZXQtMTB7bWFyZ2luLWxlZnQ6NDEuNjY2NjY2NjclfS5hbnQtY29sLXhsLW9yZGVyLTEwe29yZGVyOjEwfS5hbnQtY29sLXhsLTl7ZGlzcGxheTpibG9jaztmbGV4OjAgMCAzNy41JTttYXgtd2lkdGg6MzcuNSV9LmFudC1jb2wteGwtcHVzaC05e2xlZnQ6MzcuNSV9LmFudC1jb2wteGwtcHVsbC05e3JpZ2h0OjM3LjUlfS5hbnQtY29sLXhsLW9mZnNldC05e21hcmdpbi1sZWZ0OjM3LjUlfS5hbnQtY29sLXhsLW9yZGVyLTl7b3JkZXI6OX0uYW50LWNvbC14bC04e2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgMzMuMzMzMzMzMzMlO21heC13aWR0aDozMy4zMzMzMzMzMyV9LmFudC1jb2wteGwtcHVzaC04e2xlZnQ6MzMuMzMzMzMzMzMlfS5hbnQtY29sLXhsLXB1bGwtOHtyaWdodDozMy4zMzMzMzMzMyV9LmFudC1jb2wteGwtb2Zmc2V0LTh7bWFyZ2luLWxlZnQ6MzMuMzMzMzMzMzMlfS5hbnQtY29sLXhsLW9yZGVyLTh7b3JkZXI6OH0uYW50LWNvbC14bC03e2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgMjkuMTY2NjY2NjclO21heC13aWR0aDoyOS4xNjY2NjY2NyV9LmFudC1jb2wteGwtcHVzaC03e2xlZnQ6MjkuMTY2NjY2NjclfS5hbnQtY29sLXhsLXB1bGwtN3tyaWdodDoyOS4xNjY2NjY2NyV9LmFudC1jb2wteGwtb2Zmc2V0LTd7bWFyZ2luLWxlZnQ6MjkuMTY2NjY2NjclfS5hbnQtY29sLXhsLW9yZGVyLTd7b3JkZXI6N30uYW50LWNvbC14bC02e2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgMjUlO21heC13aWR0aDoyNSV9LmFudC1jb2wteGwtcHVzaC02e2xlZnQ6MjUlfS5hbnQtY29sLXhsLXB1bGwtNntyaWdodDoyNSV9LmFudC1jb2wteGwtb2Zmc2V0LTZ7bWFyZ2luLWxlZnQ6MjUlfS5hbnQtY29sLXhsLW9yZGVyLTZ7b3JkZXI6Nn0uYW50LWNvbC14bC01e2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgMjAuODMzMzMzMzMlO21heC13aWR0aDoyMC44MzMzMzMzMyV9LmFudC1jb2wteGwtcHVzaC01e2xlZnQ6MjAuODMzMzMzMzMlfS5hbnQtY29sLXhsLXB1bGwtNXtyaWdodDoyMC44MzMzMzMzMyV9LmFudC1jb2wteGwtb2Zmc2V0LTV7bWFyZ2luLWxlZnQ6MjAuODMzMzMzMzMlfS5hbnQtY29sLXhsLW9yZGVyLTV7b3JkZXI6NX0uYW50LWNvbC14bC00e2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgMTYuNjY2NjY2NjclO21heC13aWR0aDoxNi42NjY2NjY2NyV9LmFudC1jb2wteGwtcHVzaC00e2xlZnQ6MTYuNjY2NjY2NjclfS5hbnQtY29sLXhsLXB1bGwtNHtyaWdodDoxNi42NjY2NjY2NyV9LmFudC1jb2wteGwtb2Zmc2V0LTR7bWFyZ2luLWxlZnQ6MTYuNjY2NjY2NjclfS5hbnQtY29sLXhsLW9yZGVyLTR7b3JkZXI6NH0uYW50LWNvbC14bC0ze2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgMTIuNSU7bWF4LXdpZHRoOjEyLjUlfS5hbnQtY29sLXhsLXB1c2gtM3tsZWZ0OjEyLjUlfS5hbnQtY29sLXhsLXB1bGwtM3tyaWdodDoxMi41JX0uYW50LWNvbC14bC1vZmZzZXQtM3ttYXJnaW4tbGVmdDoxMi41JX0uYW50LWNvbC14bC1vcmRlci0ze29yZGVyOjN9LmFudC1jb2wteGwtMntkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDguMzMzMzMzMzMlO21heC13aWR0aDo4LjMzMzMzMzMzJX0uYW50LWNvbC14bC1wdXNoLTJ7bGVmdDo4LjMzMzMzMzMzJX0uYW50LWNvbC14bC1wdWxsLTJ7cmlnaHQ6OC4zMzMzMzMzMyV9LmFudC1jb2wteGwtb2Zmc2V0LTJ7bWFyZ2luLWxlZnQ6OC4zMzMzMzMzMyV9LmFudC1jb2wteGwtb3JkZXItMntvcmRlcjoyfS5hbnQtY29sLXhsLTF7ZGlzcGxheTpibG9jaztmbGV4OjAgMCA0LjE2NjY2NjY3JTttYXgtd2lkdGg6NC4xNjY2NjY2NyV9LmFudC1jb2wteGwtcHVzaC0xe2xlZnQ6NC4xNjY2NjY2NyV9LmFudC1jb2wteGwtcHVsbC0xe3JpZ2h0OjQuMTY2NjY2NjclfS5hbnQtY29sLXhsLW9mZnNldC0xe21hcmdpbi1sZWZ0OjQuMTY2NjY2NjclfS5hbnQtY29sLXhsLW9yZGVyLTF7b3JkZXI6MX0uYW50LWNvbC14bC0we2Rpc3BsYXk6bm9uZX0uYW50LWNvbC1wdXNoLTB7bGVmdDphdXRvfS5hbnQtY29sLXB1bGwtMHtyaWdodDphdXRvfS5hbnQtY29sLXhsLXB1c2gtMHtsZWZ0OmF1dG99LmFudC1jb2wteGwtcHVsbC0we3JpZ2h0OmF1dG99LmFudC1jb2wteGwtb2Zmc2V0LTB7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC14bC1vcmRlci0we29yZGVyOjB9LmFudC1jb2wtcHVzaC0wLmFudC1jb2wtcnRse3JpZ2h0OmF1dG99LmFudC1jb2wtcHVsbC0wLmFudC1jb2wtcnRse2xlZnQ6YXV0b30uYW50LWNvbC14bC1wdXNoLTAuYW50LWNvbC1ydGx7cmlnaHQ6YXV0b30uYW50LWNvbC14bC1wdWxsLTAuYW50LWNvbC1ydGx7bGVmdDphdXRvfS5hbnQtY29sLXhsLW9mZnNldC0wLmFudC1jb2wtcnRse21hcmdpbi1yaWdodDowfS5hbnQtY29sLXhsLXB1c2gtMS5hbnQtY29sLXJ0bHtyaWdodDo0LjE2NjY2NjY3JTtsZWZ0OmF1dG99LmFudC1jb2wteGwtcHVsbC0xLmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo0LjE2NjY2NjY3JX0uYW50LWNvbC14bC1vZmZzZXQtMS5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6NC4xNjY2NjY2NyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC14bC1wdXNoLTIuYW50LWNvbC1ydGx7cmlnaHQ6OC4zMzMzMzMzMyU7bGVmdDphdXRvfS5hbnQtY29sLXhsLXB1bGwtMi5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6OC4zMzMzMzMzMyV9LmFudC1jb2wteGwtb2Zmc2V0LTIuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjguMzMzMzMzMzMlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wteGwtcHVzaC0zLmFudC1jb2wtcnRse3JpZ2h0OjEyLjUlO2xlZnQ6YXV0b30uYW50LWNvbC14bC1wdWxsLTMuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjEyLjUlfS5hbnQtY29sLXhsLW9mZnNldC0zLmFudC1jb2wtcnRse21hcmdpbi1yaWdodDoxMi41JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLXhsLXB1c2gtNC5hbnQtY29sLXJ0bHtyaWdodDoxNi42NjY2NjY2NyU7bGVmdDphdXRvfS5hbnQtY29sLXhsLXB1bGwtNC5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6MTYuNjY2NjY2NjclfS5hbnQtY29sLXhsLW9mZnNldC00LmFudC1jb2wtcnRse21hcmdpbi1yaWdodDoxNi42NjY2NjY2NyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC14bC1wdXNoLTUuYW50LWNvbC1ydGx7cmlnaHQ6MjAuODMzMzMzMzMlO2xlZnQ6YXV0b30uYW50LWNvbC14bC1wdWxsLTUuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjIwLjgzMzMzMzMzJX0uYW50LWNvbC14bC1vZmZzZXQtNS5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6MjAuODMzMzMzMzMlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wteGwtcHVzaC02LmFudC1jb2wtcnRse3JpZ2h0OjI1JTtsZWZ0OmF1dG99LmFudC1jb2wteGwtcHVsbC02LmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDoyNSV9LmFudC1jb2wteGwtb2Zmc2V0LTYuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjI1JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLXhsLXB1c2gtNy5hbnQtY29sLXJ0bHtyaWdodDoyOS4xNjY2NjY2NyU7bGVmdDphdXRvfS5hbnQtY29sLXhsLXB1bGwtNy5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6MjkuMTY2NjY2NjclfS5hbnQtY29sLXhsLW9mZnNldC03LmFudC1jb2wtcnRse21hcmdpbi1yaWdodDoyOS4xNjY2NjY2NyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC14bC1wdXNoLTguYW50LWNvbC1ydGx7cmlnaHQ6MzMuMzMzMzMzMzMlO2xlZnQ6YXV0b30uYW50LWNvbC14bC1wdWxsLTguYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjMzLjMzMzMzMzMzJX0uYW50LWNvbC14bC1vZmZzZXQtOC5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6MzMuMzMzMzMzMzMlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wteGwtcHVzaC05LmFudC1jb2wtcnRse3JpZ2h0OjM3LjUlO2xlZnQ6YXV0b30uYW50LWNvbC14bC1wdWxsLTkuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjM3LjUlfS5hbnQtY29sLXhsLW9mZnNldC05LmFudC1jb2wtcnRse21hcmdpbi1yaWdodDozNy41JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLXhsLXB1c2gtMTAuYW50LWNvbC1ydGx7cmlnaHQ6NDEuNjY2NjY2NjclO2xlZnQ6YXV0b30uYW50LWNvbC14bC1wdWxsLTEwLmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo0MS42NjY2NjY2NyV9LmFudC1jb2wteGwtb2Zmc2V0LTEwLmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo0MS42NjY2NjY2NyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC14bC1wdXNoLTExLmFudC1jb2wtcnRse3JpZ2h0OjQ1LjgzMzMzMzMzJTtsZWZ0OmF1dG99LmFudC1jb2wteGwtcHVsbC0xMS5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6NDUuODMzMzMzMzMlfS5hbnQtY29sLXhsLW9mZnNldC0xMS5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6NDUuODMzMzMzMzMlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wteGwtcHVzaC0xMi5hbnQtY29sLXJ0bHtyaWdodDo1MCU7bGVmdDphdXRvfS5hbnQtY29sLXhsLXB1bGwtMTIuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjUwJX0uYW50LWNvbC14bC1vZmZzZXQtMTIuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjUwJTttYXJnaW4tbGVmdDowfS5hbnQtY29sLXhsLXB1c2gtMTMuYW50LWNvbC1ydGx7cmlnaHQ6NTQuMTY2NjY2NjclO2xlZnQ6YXV0b30uYW50LWNvbC14bC1wdWxsLTEzLmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo1NC4xNjY2NjY2NyV9LmFudC1jb2wteGwtb2Zmc2V0LTEzLmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo1NC4xNjY2NjY2NyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC14bC1wdXNoLTE0LmFudC1jb2wtcnRse3JpZ2h0OjU4LjMzMzMzMzMzJTtsZWZ0OmF1dG99LmFudC1jb2wteGwtcHVsbC0xNC5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6NTguMzMzMzMzMzMlfS5hbnQtY29sLXhsLW9mZnNldC0xNC5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6NTguMzMzMzMzMzMlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wteGwtcHVzaC0xNS5hbnQtY29sLXJ0bHtyaWdodDo2Mi41JTtsZWZ0OmF1dG99LmFudC1jb2wteGwtcHVsbC0xNS5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6NjIuNSV9LmFudC1jb2wteGwtb2Zmc2V0LTE1LmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo2Mi41JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLXhsLXB1c2gtMTYuYW50LWNvbC1ydGx7cmlnaHQ6NjYuNjY2NjY2NjclO2xlZnQ6YXV0b30uYW50LWNvbC14bC1wdWxsLTE2LmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo2Ni42NjY2NjY2NyV9LmFudC1jb2wteGwtb2Zmc2V0LTE2LmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo2Ni42NjY2NjY2NyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC14bC1wdXNoLTE3LmFudC1jb2wtcnRse3JpZ2h0OjcwLjgzMzMzMzMzJTtsZWZ0OmF1dG99LmFudC1jb2wteGwtcHVsbC0xNy5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6NzAuODMzMzMzMzMlfS5hbnQtY29sLXhsLW9mZnNldC0xNy5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6NzAuODMzMzMzMzMlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wteGwtcHVzaC0xOC5hbnQtY29sLXJ0bHtyaWdodDo3NSU7bGVmdDphdXRvfS5hbnQtY29sLXhsLXB1bGwtMTguYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0Ojc1JX0uYW50LWNvbC14bC1vZmZzZXQtMTguYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0Ojc1JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLXhsLXB1c2gtMTkuYW50LWNvbC1ydGx7cmlnaHQ6NzkuMTY2NjY2NjclO2xlZnQ6YXV0b30uYW50LWNvbC14bC1wdWxsLTE5LmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo3OS4xNjY2NjY2NyV9LmFudC1jb2wteGwtb2Zmc2V0LTE5LmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo3OS4xNjY2NjY2NyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC14bC1wdXNoLTIwLmFudC1jb2wtcnRse3JpZ2h0OjgzLjMzMzMzMzMzJTtsZWZ0OmF1dG99LmFudC1jb2wteGwtcHVsbC0yMC5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6ODMuMzMzMzMzMzMlfS5hbnQtY29sLXhsLW9mZnNldC0yMC5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6ODMuMzMzMzMzMzMlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wteGwtcHVzaC0yMS5hbnQtY29sLXJ0bHtyaWdodDo4Ny41JTtsZWZ0OmF1dG99LmFudC1jb2wteGwtcHVsbC0yMS5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6ODcuNSV9LmFudC1jb2wteGwtb2Zmc2V0LTIxLmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo4Ny41JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLXhsLXB1c2gtMjIuYW50LWNvbC1ydGx7cmlnaHQ6OTEuNjY2NjY2NjclO2xlZnQ6YXV0b30uYW50LWNvbC14bC1wdWxsLTIyLmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo5MS42NjY2NjY2NyV9LmFudC1jb2wteGwtb2Zmc2V0LTIyLmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo5MS42NjY2NjY2NyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC14bC1wdXNoLTIzLmFudC1jb2wtcnRse3JpZ2h0Ojk1LjgzMzMzMzMzJTtsZWZ0OmF1dG99LmFudC1jb2wteGwtcHVsbC0yMy5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6OTUuODMzMzMzMzMlfS5hbnQtY29sLXhsLW9mZnNldC0yMy5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6OTUuODMzMzMzMzMlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wteGwtcHVzaC0yNC5hbnQtY29sLXJ0bHtyaWdodDoxMDAlO2xlZnQ6YXV0b30uYW50LWNvbC14bC1wdWxsLTI0LmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDoxMDAlfS5hbnQtY29sLXhsLW9mZnNldC0yNC5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6MTAwJTttYXJnaW4tbGVmdDowfX1AbWVkaWEgKG1pbi13aWR0aDoxNjAwcHgpey5hbnQtY29sLXh4bC0yNHtkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDEwMCU7bWF4LXdpZHRoOjEwMCV9LmFudC1jb2wteHhsLXB1c2gtMjR7bGVmdDoxMDAlfS5hbnQtY29sLXh4bC1wdWxsLTI0e3JpZ2h0OjEwMCV9LmFudC1jb2wteHhsLW9mZnNldC0yNHttYXJnaW4tbGVmdDoxMDAlfS5hbnQtY29sLXh4bC1vcmRlci0yNHtvcmRlcjoyNH0uYW50LWNvbC14eGwtMjN7ZGlzcGxheTpibG9jaztmbGV4OjAgMCA5NS44MzMzMzMzMyU7bWF4LXdpZHRoOjk1LjgzMzMzMzMzJX0uYW50LWNvbC14eGwtcHVzaC0yM3tsZWZ0Ojk1LjgzMzMzMzMzJX0uYW50LWNvbC14eGwtcHVsbC0yM3tyaWdodDo5NS44MzMzMzMzMyV9LmFudC1jb2wteHhsLW9mZnNldC0yM3ttYXJnaW4tbGVmdDo5NS44MzMzMzMzMyV9LmFudC1jb2wteHhsLW9yZGVyLTIze29yZGVyOjIzfS5hbnQtY29sLXh4bC0yMntkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDkxLjY2NjY2NjY3JTttYXgtd2lkdGg6OTEuNjY2NjY2NjclfS5hbnQtY29sLXh4bC1wdXNoLTIye2xlZnQ6OTEuNjY2NjY2NjclfS5hbnQtY29sLXh4bC1wdWxsLTIye3JpZ2h0OjkxLjY2NjY2NjY3JX0uYW50LWNvbC14eGwtb2Zmc2V0LTIye21hcmdpbi1sZWZ0OjkxLjY2NjY2NjY3JX0uYW50LWNvbC14eGwtb3JkZXItMjJ7b3JkZXI6MjJ9LmFudC1jb2wteHhsLTIxe2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgODcuNSU7bWF4LXdpZHRoOjg3LjUlfS5hbnQtY29sLXh4bC1wdXNoLTIxe2xlZnQ6ODcuNSV9LmFudC1jb2wteHhsLXB1bGwtMjF7cmlnaHQ6ODcuNSV9LmFudC1jb2wteHhsLW9mZnNldC0yMXttYXJnaW4tbGVmdDo4Ny41JX0uYW50LWNvbC14eGwtb3JkZXItMjF7b3JkZXI6MjF9LmFudC1jb2wteHhsLTIwe2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgODMuMzMzMzMzMzMlO21heC13aWR0aDo4My4zMzMzMzMzMyV9LmFudC1jb2wteHhsLXB1c2gtMjB7bGVmdDo4My4zMzMzMzMzMyV9LmFudC1jb2wteHhsLXB1bGwtMjB7cmlnaHQ6ODMuMzMzMzMzMzMlfS5hbnQtY29sLXh4bC1vZmZzZXQtMjB7bWFyZ2luLWxlZnQ6ODMuMzMzMzMzMzMlfS5hbnQtY29sLXh4bC1vcmRlci0yMHtvcmRlcjoyMH0uYW50LWNvbC14eGwtMTl7ZGlzcGxheTpibG9jaztmbGV4OjAgMCA3OS4xNjY2NjY2NyU7bWF4LXdpZHRoOjc5LjE2NjY2NjY3JX0uYW50LWNvbC14eGwtcHVzaC0xOXtsZWZ0Ojc5LjE2NjY2NjY3JX0uYW50LWNvbC14eGwtcHVsbC0xOXtyaWdodDo3OS4xNjY2NjY2NyV9LmFudC1jb2wteHhsLW9mZnNldC0xOXttYXJnaW4tbGVmdDo3OS4xNjY2NjY2NyV9LmFudC1jb2wteHhsLW9yZGVyLTE5e29yZGVyOjE5fS5hbnQtY29sLXh4bC0xOHtkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDc1JTttYXgtd2lkdGg6NzUlfS5hbnQtY29sLXh4bC1wdXNoLTE4e2xlZnQ6NzUlfS5hbnQtY29sLXh4bC1wdWxsLTE4e3JpZ2h0Ojc1JX0uYW50LWNvbC14eGwtb2Zmc2V0LTE4e21hcmdpbi1sZWZ0Ojc1JX0uYW50LWNvbC14eGwtb3JkZXItMTh7b3JkZXI6MTh9LmFudC1jb2wteHhsLTE3e2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgNzAuODMzMzMzMzMlO21heC13aWR0aDo3MC44MzMzMzMzMyV9LmFudC1jb2wteHhsLXB1c2gtMTd7bGVmdDo3MC44MzMzMzMzMyV9LmFudC1jb2wteHhsLXB1bGwtMTd7cmlnaHQ6NzAuODMzMzMzMzMlfS5hbnQtY29sLXh4bC1vZmZzZXQtMTd7bWFyZ2luLWxlZnQ6NzAuODMzMzMzMzMlfS5hbnQtY29sLXh4bC1vcmRlci0xN3tvcmRlcjoxN30uYW50LWNvbC14eGwtMTZ7ZGlzcGxheTpibG9jaztmbGV4OjAgMCA2Ni42NjY2NjY2NyU7bWF4LXdpZHRoOjY2LjY2NjY2NjY3JX0uYW50LWNvbC14eGwtcHVzaC0xNntsZWZ0OjY2LjY2NjY2NjY3JX0uYW50LWNvbC14eGwtcHVsbC0xNntyaWdodDo2Ni42NjY2NjY2NyV9LmFudC1jb2wteHhsLW9mZnNldC0xNnttYXJnaW4tbGVmdDo2Ni42NjY2NjY2NyV9LmFudC1jb2wteHhsLW9yZGVyLTE2e29yZGVyOjE2fS5hbnQtY29sLXh4bC0xNXtkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDYyLjUlO21heC13aWR0aDo2Mi41JX0uYW50LWNvbC14eGwtcHVzaC0xNXtsZWZ0OjYyLjUlfS5hbnQtY29sLXh4bC1wdWxsLTE1e3JpZ2h0OjYyLjUlfS5hbnQtY29sLXh4bC1vZmZzZXQtMTV7bWFyZ2luLWxlZnQ6NjIuNSV9LmFudC1jb2wteHhsLW9yZGVyLTE1e29yZGVyOjE1fS5hbnQtY29sLXh4bC0xNHtkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDU4LjMzMzMzMzMzJTttYXgtd2lkdGg6NTguMzMzMzMzMzMlfS5hbnQtY29sLXh4bC1wdXNoLTE0e2xlZnQ6NTguMzMzMzMzMzMlfS5hbnQtY29sLXh4bC1wdWxsLTE0e3JpZ2h0OjU4LjMzMzMzMzMzJX0uYW50LWNvbC14eGwtb2Zmc2V0LTE0e21hcmdpbi1sZWZ0OjU4LjMzMzMzMzMzJX0uYW50LWNvbC14eGwtb3JkZXItMTR7b3JkZXI6MTR9LmFudC1jb2wteHhsLTEze2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgNTQuMTY2NjY2NjclO21heC13aWR0aDo1NC4xNjY2NjY2NyV9LmFudC1jb2wteHhsLXB1c2gtMTN7bGVmdDo1NC4xNjY2NjY2NyV9LmFudC1jb2wteHhsLXB1bGwtMTN7cmlnaHQ6NTQuMTY2NjY2NjclfS5hbnQtY29sLXh4bC1vZmZzZXQtMTN7bWFyZ2luLWxlZnQ6NTQuMTY2NjY2NjclfS5hbnQtY29sLXh4bC1vcmRlci0xM3tvcmRlcjoxM30uYW50LWNvbC14eGwtMTJ7ZGlzcGxheTpibG9jaztmbGV4OjAgMCA1MCU7bWF4LXdpZHRoOjUwJX0uYW50LWNvbC14eGwtcHVzaC0xMntsZWZ0OjUwJX0uYW50LWNvbC14eGwtcHVsbC0xMntyaWdodDo1MCV9LmFudC1jb2wteHhsLW9mZnNldC0xMnttYXJnaW4tbGVmdDo1MCV9LmFudC1jb2wteHhsLW9yZGVyLTEye29yZGVyOjEyfS5hbnQtY29sLXh4bC0xMXtkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDQ1LjgzMzMzMzMzJTttYXgtd2lkdGg6NDUuODMzMzMzMzMlfS5hbnQtY29sLXh4bC1wdXNoLTExe2xlZnQ6NDUuODMzMzMzMzMlfS5hbnQtY29sLXh4bC1wdWxsLTExe3JpZ2h0OjQ1LjgzMzMzMzMzJX0uYW50LWNvbC14eGwtb2Zmc2V0LTExe21hcmdpbi1sZWZ0OjQ1LjgzMzMzMzMzJX0uYW50LWNvbC14eGwtb3JkZXItMTF7b3JkZXI6MTF9LmFudC1jb2wteHhsLTEwe2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgNDEuNjY2NjY2NjclO21heC13aWR0aDo0MS42NjY2NjY2NyV9LmFudC1jb2wteHhsLXB1c2gtMTB7bGVmdDo0MS42NjY2NjY2NyV9LmFudC1jb2wteHhsLXB1bGwtMTB7cmlnaHQ6NDEuNjY2NjY2NjclfS5hbnQtY29sLXh4bC1vZmZzZXQtMTB7bWFyZ2luLWxlZnQ6NDEuNjY2NjY2NjclfS5hbnQtY29sLXh4bC1vcmRlci0xMHtvcmRlcjoxMH0uYW50LWNvbC14eGwtOXtkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDM3LjUlO21heC13aWR0aDozNy41JX0uYW50LWNvbC14eGwtcHVzaC05e2xlZnQ6MzcuNSV9LmFudC1jb2wteHhsLXB1bGwtOXtyaWdodDozNy41JX0uYW50LWNvbC14eGwtb2Zmc2V0LTl7bWFyZ2luLWxlZnQ6MzcuNSV9LmFudC1jb2wteHhsLW9yZGVyLTl7b3JkZXI6OX0uYW50LWNvbC14eGwtOHtkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDMzLjMzMzMzMzMzJTttYXgtd2lkdGg6MzMuMzMzMzMzMzMlfS5hbnQtY29sLXh4bC1wdXNoLTh7bGVmdDozMy4zMzMzMzMzMyV9LmFudC1jb2wteHhsLXB1bGwtOHtyaWdodDozMy4zMzMzMzMzMyV9LmFudC1jb2wteHhsLW9mZnNldC04e21hcmdpbi1sZWZ0OjMzLjMzMzMzMzMzJX0uYW50LWNvbC14eGwtb3JkZXItOHtvcmRlcjo4fS5hbnQtY29sLXh4bC03e2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgMjkuMTY2NjY2NjclO21heC13aWR0aDoyOS4xNjY2NjY2NyV9LmFudC1jb2wteHhsLXB1c2gtN3tsZWZ0OjI5LjE2NjY2NjY3JX0uYW50LWNvbC14eGwtcHVsbC03e3JpZ2h0OjI5LjE2NjY2NjY3JX0uYW50LWNvbC14eGwtb2Zmc2V0LTd7bWFyZ2luLWxlZnQ6MjkuMTY2NjY2NjclfS5hbnQtY29sLXh4bC1vcmRlci03e29yZGVyOjd9LmFudC1jb2wteHhsLTZ7ZGlzcGxheTpibG9jaztmbGV4OjAgMCAyNSU7bWF4LXdpZHRoOjI1JX0uYW50LWNvbC14eGwtcHVzaC02e2xlZnQ6MjUlfS5hbnQtY29sLXh4bC1wdWxsLTZ7cmlnaHQ6MjUlfS5hbnQtY29sLXh4bC1vZmZzZXQtNnttYXJnaW4tbGVmdDoyNSV9LmFudC1jb2wteHhsLW9yZGVyLTZ7b3JkZXI6Nn0uYW50LWNvbC14eGwtNXtkaXNwbGF5OmJsb2NrO2ZsZXg6MCAwIDIwLjgzMzMzMzMzJTttYXgtd2lkdGg6MjAuODMzMzMzMzMlfS5hbnQtY29sLXh4bC1wdXNoLTV7bGVmdDoyMC44MzMzMzMzMyV9LmFudC1jb2wteHhsLXB1bGwtNXtyaWdodDoyMC44MzMzMzMzMyV9LmFudC1jb2wteHhsLW9mZnNldC01e21hcmdpbi1sZWZ0OjIwLjgzMzMzMzMzJX0uYW50LWNvbC14eGwtb3JkZXItNXtvcmRlcjo1fS5hbnQtY29sLXh4bC00e2Rpc3BsYXk6YmxvY2s7ZmxleDowIDAgMTYuNjY2NjY2NjclO21heC13aWR0aDoxNi42NjY2NjY2NyV9LmFudC1jb2wteHhsLXB1c2gtNHtsZWZ0OjE2LjY2NjY2NjY3JX0uYW50LWNvbC14eGwtcHVsbC00e3JpZ2h0OjE2LjY2NjY2NjY3JX0uYW50LWNvbC14eGwtb2Zmc2V0LTR7bWFyZ2luLWxlZnQ6MTYuNjY2NjY2NjclfS5hbnQtY29sLXh4bC1vcmRlci00e29yZGVyOjR9LmFudC1jb2wteHhsLTN7ZGlzcGxheTpibG9jaztmbGV4OjAgMCAxMi41JTttYXgtd2lkdGg6MTIuNSV9LmFudC1jb2wteHhsLXB1c2gtM3tsZWZ0OjEyLjUlfS5hbnQtY29sLXh4bC1wdWxsLTN7cmlnaHQ6MTIuNSV9LmFudC1jb2wteHhsLW9mZnNldC0ze21hcmdpbi1sZWZ0OjEyLjUlfS5hbnQtY29sLXh4bC1vcmRlci0ze29yZGVyOjN9LmFudC1jb2wteHhsLTJ7ZGlzcGxheTpibG9jaztmbGV4OjAgMCA4LjMzMzMzMzMzJTttYXgtd2lkdGg6OC4zMzMzMzMzMyV9LmFudC1jb2wteHhsLXB1c2gtMntsZWZ0OjguMzMzMzMzMzMlfS5hbnQtY29sLXh4bC1wdWxsLTJ7cmlnaHQ6OC4zMzMzMzMzMyV9LmFudC1jb2wteHhsLW9mZnNldC0ye21hcmdpbi1sZWZ0OjguMzMzMzMzMzMlfS5hbnQtY29sLXh4bC1vcmRlci0ye29yZGVyOjJ9LmFudC1jb2wteHhsLTF7ZGlzcGxheTpibG9jaztmbGV4OjAgMCA0LjE2NjY2NjY3JTttYXgtd2lkdGg6NC4xNjY2NjY2NyV9LmFudC1jb2wteHhsLXB1c2gtMXtsZWZ0OjQuMTY2NjY2NjclfS5hbnQtY29sLXh4bC1wdWxsLTF7cmlnaHQ6NC4xNjY2NjY2NyV9LmFudC1jb2wteHhsLW9mZnNldC0xe21hcmdpbi1sZWZ0OjQuMTY2NjY2NjclfS5hbnQtY29sLXh4bC1vcmRlci0xe29yZGVyOjF9LmFudC1jb2wteHhsLTB7ZGlzcGxheTpub25lfS5hbnQtY29sLXB1c2gtMHtsZWZ0OmF1dG99LmFudC1jb2wtcHVsbC0we3JpZ2h0OmF1dG99LmFudC1jb2wteHhsLXB1c2gtMHtsZWZ0OmF1dG99LmFudC1jb2wteHhsLXB1bGwtMHtyaWdodDphdXRvfS5hbnQtY29sLXh4bC1vZmZzZXQtMHttYXJnaW4tbGVmdDowfS5hbnQtY29sLXh4bC1vcmRlci0we29yZGVyOjB9LmFudC1jb2wtcHVzaC0wLmFudC1jb2wtcnRse3JpZ2h0OmF1dG99LmFudC1jb2wtcHVsbC0wLmFudC1jb2wtcnRse2xlZnQ6YXV0b30uYW50LWNvbC14eGwtcHVzaC0wLmFudC1jb2wtcnRse3JpZ2h0OmF1dG99LmFudC1jb2wteHhsLXB1bGwtMC5hbnQtY29sLXJ0bHtsZWZ0OmF1dG99LmFudC1jb2wteHhsLW9mZnNldC0wLmFudC1jb2wtcnRse21hcmdpbi1yaWdodDowfS5hbnQtY29sLXh4bC1wdXNoLTEuYW50LWNvbC1ydGx7cmlnaHQ6NC4xNjY2NjY2NyU7bGVmdDphdXRvfS5hbnQtY29sLXh4bC1wdWxsLTEuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjQuMTY2NjY2NjclfS5hbnQtY29sLXh4bC1vZmZzZXQtMS5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6NC4xNjY2NjY2NyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC14eGwtcHVzaC0yLmFudC1jb2wtcnRse3JpZ2h0OjguMzMzMzMzMzMlO2xlZnQ6YXV0b30uYW50LWNvbC14eGwtcHVsbC0yLmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo4LjMzMzMzMzMzJX0uYW50LWNvbC14eGwtb2Zmc2V0LTIuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjguMzMzMzMzMzMlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wteHhsLXB1c2gtMy5hbnQtY29sLXJ0bHtyaWdodDoxMi41JTtsZWZ0OmF1dG99LmFudC1jb2wteHhsLXB1bGwtMy5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6MTIuNSV9LmFudC1jb2wteHhsLW9mZnNldC0zLmFudC1jb2wtcnRse21hcmdpbi1yaWdodDoxMi41JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLXh4bC1wdXNoLTQuYW50LWNvbC1ydGx7cmlnaHQ6MTYuNjY2NjY2NjclO2xlZnQ6YXV0b30uYW50LWNvbC14eGwtcHVsbC00LmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDoxNi42NjY2NjY2NyV9LmFudC1jb2wteHhsLW9mZnNldC00LmFudC1jb2wtcnRse21hcmdpbi1yaWdodDoxNi42NjY2NjY2NyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC14eGwtcHVzaC01LmFudC1jb2wtcnRse3JpZ2h0OjIwLjgzMzMzMzMzJTtsZWZ0OmF1dG99LmFudC1jb2wteHhsLXB1bGwtNS5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6MjAuODMzMzMzMzMlfS5hbnQtY29sLXh4bC1vZmZzZXQtNS5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6MjAuODMzMzMzMzMlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wteHhsLXB1c2gtNi5hbnQtY29sLXJ0bHtyaWdodDoyNSU7bGVmdDphdXRvfS5hbnQtY29sLXh4bC1wdWxsLTYuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjI1JX0uYW50LWNvbC14eGwtb2Zmc2V0LTYuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjI1JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLXh4bC1wdXNoLTcuYW50LWNvbC1ydGx7cmlnaHQ6MjkuMTY2NjY2NjclO2xlZnQ6YXV0b30uYW50LWNvbC14eGwtcHVsbC03LmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDoyOS4xNjY2NjY2NyV9LmFudC1jb2wteHhsLW9mZnNldC03LmFudC1jb2wtcnRse21hcmdpbi1yaWdodDoyOS4xNjY2NjY2NyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC14eGwtcHVzaC04LmFudC1jb2wtcnRse3JpZ2h0OjMzLjMzMzMzMzMzJTtsZWZ0OmF1dG99LmFudC1jb2wteHhsLXB1bGwtOC5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6MzMuMzMzMzMzMzMlfS5hbnQtY29sLXh4bC1vZmZzZXQtOC5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6MzMuMzMzMzMzMzMlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wteHhsLXB1c2gtOS5hbnQtY29sLXJ0bHtyaWdodDozNy41JTtsZWZ0OmF1dG99LmFudC1jb2wteHhsLXB1bGwtOS5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6MzcuNSV9LmFudC1jb2wteHhsLW9mZnNldC05LmFudC1jb2wtcnRse21hcmdpbi1yaWdodDozNy41JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLXh4bC1wdXNoLTEwLmFudC1jb2wtcnRse3JpZ2h0OjQxLjY2NjY2NjY3JTtsZWZ0OmF1dG99LmFudC1jb2wteHhsLXB1bGwtMTAuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjQxLjY2NjY2NjY3JX0uYW50LWNvbC14eGwtb2Zmc2V0LTEwLmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo0MS42NjY2NjY2NyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC14eGwtcHVzaC0xMS5hbnQtY29sLXJ0bHtyaWdodDo0NS44MzMzMzMzMyU7bGVmdDphdXRvfS5hbnQtY29sLXh4bC1wdWxsLTExLmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo0NS44MzMzMzMzMyV9LmFudC1jb2wteHhsLW9mZnNldC0xMS5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6NDUuODMzMzMzMzMlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wteHhsLXB1c2gtMTIuYW50LWNvbC1ydGx7cmlnaHQ6NTAlO2xlZnQ6YXV0b30uYW50LWNvbC14eGwtcHVsbC0xMi5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6NTAlfS5hbnQtY29sLXh4bC1vZmZzZXQtMTIuYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0OjUwJTttYXJnaW4tbGVmdDowfS5hbnQtY29sLXh4bC1wdXNoLTEzLmFudC1jb2wtcnRse3JpZ2h0OjU0LjE2NjY2NjY3JTtsZWZ0OmF1dG99LmFudC1jb2wteHhsLXB1bGwtMTMuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjU0LjE2NjY2NjY3JX0uYW50LWNvbC14eGwtb2Zmc2V0LTEzLmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo1NC4xNjY2NjY2NyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC14eGwtcHVzaC0xNC5hbnQtY29sLXJ0bHtyaWdodDo1OC4zMzMzMzMzMyU7bGVmdDphdXRvfS5hbnQtY29sLXh4bC1wdWxsLTE0LmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo1OC4zMzMzMzMzMyV9LmFudC1jb2wteHhsLW9mZnNldC0xNC5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6NTguMzMzMzMzMzMlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wteHhsLXB1c2gtMTUuYW50LWNvbC1ydGx7cmlnaHQ6NjIuNSU7bGVmdDphdXRvfS5hbnQtY29sLXh4bC1wdWxsLTE1LmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo2Mi41JX0uYW50LWNvbC14eGwtb2Zmc2V0LTE1LmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo2Mi41JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLXh4bC1wdXNoLTE2LmFudC1jb2wtcnRse3JpZ2h0OjY2LjY2NjY2NjY3JTtsZWZ0OmF1dG99LmFudC1jb2wteHhsLXB1bGwtMTYuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjY2LjY2NjY2NjY3JX0uYW50LWNvbC14eGwtb2Zmc2V0LTE2LmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo2Ni42NjY2NjY2NyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC14eGwtcHVzaC0xNy5hbnQtY29sLXJ0bHtyaWdodDo3MC44MzMzMzMzMyU7bGVmdDphdXRvfS5hbnQtY29sLXh4bC1wdWxsLTE3LmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo3MC44MzMzMzMzMyV9LmFudC1jb2wteHhsLW9mZnNldC0xNy5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6NzAuODMzMzMzMzMlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wteHhsLXB1c2gtMTguYW50LWNvbC1ydGx7cmlnaHQ6NzUlO2xlZnQ6YXV0b30uYW50LWNvbC14eGwtcHVsbC0xOC5hbnQtY29sLXJ0bHtyaWdodDphdXRvO2xlZnQ6NzUlfS5hbnQtY29sLXh4bC1vZmZzZXQtMTguYW50LWNvbC1ydGx7bWFyZ2luLXJpZ2h0Ojc1JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLXh4bC1wdXNoLTE5LmFudC1jb2wtcnRse3JpZ2h0Ojc5LjE2NjY2NjY3JTtsZWZ0OmF1dG99LmFudC1jb2wteHhsLXB1bGwtMTkuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0Ojc5LjE2NjY2NjY3JX0uYW50LWNvbC14eGwtb2Zmc2V0LTE5LmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo3OS4xNjY2NjY2NyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC14eGwtcHVzaC0yMC5hbnQtY29sLXJ0bHtyaWdodDo4My4zMzMzMzMzMyU7bGVmdDphdXRvfS5hbnQtY29sLXh4bC1wdWxsLTIwLmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo4My4zMzMzMzMzMyV9LmFudC1jb2wteHhsLW9mZnNldC0yMC5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6ODMuMzMzMzMzMzMlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wteHhsLXB1c2gtMjEuYW50LWNvbC1ydGx7cmlnaHQ6ODcuNSU7bGVmdDphdXRvfS5hbnQtY29sLXh4bC1wdWxsLTIxLmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo4Ny41JX0uYW50LWNvbC14eGwtb2Zmc2V0LTIxLmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo4Ny41JTttYXJnaW4tbGVmdDowfS5hbnQtY29sLXh4bC1wdXNoLTIyLmFudC1jb2wtcnRse3JpZ2h0OjkxLjY2NjY2NjY3JTtsZWZ0OmF1dG99LmFudC1jb2wteHhsLXB1bGwtMjIuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjkxLjY2NjY2NjY3JX0uYW50LWNvbC14eGwtb2Zmc2V0LTIyLmFudC1jb2wtcnRse21hcmdpbi1yaWdodDo5MS42NjY2NjY2NyU7bWFyZ2luLWxlZnQ6MH0uYW50LWNvbC14eGwtcHVzaC0yMy5hbnQtY29sLXJ0bHtyaWdodDo5NS44MzMzMzMzMyU7bGVmdDphdXRvfS5hbnQtY29sLXh4bC1wdWxsLTIzLmFudC1jb2wtcnRse3JpZ2h0OmF1dG87bGVmdDo5NS44MzMzMzMzMyV9LmFudC1jb2wteHhsLW9mZnNldC0yMy5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6OTUuODMzMzMzMzMlO21hcmdpbi1sZWZ0OjB9LmFudC1jb2wteHhsLXB1c2gtMjQuYW50LWNvbC1ydGx7cmlnaHQ6MTAwJTtsZWZ0OmF1dG99LmFudC1jb2wteHhsLXB1bGwtMjQuYW50LWNvbC1ydGx7cmlnaHQ6YXV0bztsZWZ0OjEwMCV9LmFudC1jb2wteHhsLW9mZnNldC0yNC5hbnQtY29sLXJ0bHttYXJnaW4tcmlnaHQ6MTAwJTttYXJnaW4tbGVmdDowfX0uYW50LXJvdy1ydGx7ZGlyZWN0aW9uOnJ0bH0uYW50LWltYWdle3Bvc2l0aW9uOnJlbGF0aXZlO2Rpc3BsYXk6aW5saW5lLWJsb2NrfS5hbnQtaW1hZ2UtaW1ne3dpZHRoOjEwMCU7aGVpZ2h0OmF1dG87dmVydGljYWwtYWxpZ246bWlkZGxlfS5hbnQtaW1hZ2UtaW1nLXBsYWNlaG9sZGVye2JhY2tncm91bmQtY29sb3I6I2Y1ZjVmNTtiYWNrZ3JvdW5kLWltYWdlOnVybChcImRhdGE6aW1hZ2Uvc3ZnK3htbDtiYXNlNjQsUEhOMlp5QjNhV1IwYUQwaU1UWWlJR2hsYVdkb2REMGlNVFlpSUhodGJHNXpQU0pvZEhSd09pOHZkM2QzTG5jekxtOXlaeTh5TURBd0wzTjJaeUkrUEhCaGRHZ2daRDBpVFRFMExqVWdNaTQxYUMweE0wRXVOUzQxSURBZ01EQXhJRE4yTVRCaExqVXVOU0F3SURBd0xqVXVOV2d4TTJFdU5TNDFJREFnTURBdU5TMHVOVll6WVM0MUxqVWdNQ0F3TUMwdU5TMHVOWHBOTlM0eU9ERWdOQzQzTldFeElERWdNQ0F3TVRBZ01pQXhJREVnTUNBd01UQXRNbnB0T0M0d015QTJMamd6WVM0eE1qY3VNVEkzSURBZ01ERXRMakE0TVM0d00wZ3lMamMyT1dFdU1USTFMakV5TlNBd0lEQXhMUzR3T1RZdExqSXdOMnd5TGpZMk1TMHpMakUxTm1FdU1USTJMakV5TmlBd0lEQXhMakUzTnkwdU1ERTJiQzR3TVRZdU1ERTJURGN1TURnZ01UQXVNRGxzTWk0ME55MHlMamt6WVM0eE1qWXVNVEkySURBZ01ERXVNVGMzTFM0d01UWnNMakF4TlM0d01UWWdNeTQxT0RnZ05DNHlORFJoTGpFeU55NHhNamNnTUNBd01TMHVNREl1TVRjMWVpSWdabWxzYkQwaUl6aERPRU00UXlJdlBqd3ZjM1puUGc9PVwiKTtiYWNrZ3JvdW5kLXJlcGVhdDpuby1yZXBlYXQ7YmFja2dyb3VuZC1wb3NpdGlvbjo1MCU7YmFja2dyb3VuZC1zaXplOjMwJX0uYW50LWltYWdlLW1hc2t7cG9zaXRpb246YWJzb2x1dGU7dG9wOjA7cmlnaHQ6MDtib3R0b206MDtsZWZ0OjA7ZGlzcGxheTpmbGV4O2FsaWduLWl0ZW1zOmNlbnRlcjtqdXN0aWZ5LWNvbnRlbnQ6Y2VudGVyO2NvbG9yOiNmZmY7YmFja2dyb3VuZDpyZ2JhKDAsMCwwLC41KTtjdXJzb3I6cG9pbnRlcjtvcGFjaXR5OjA7dHJhbnNpdGlvbjpvcGFjaXR5IC4zc30uYW50LWltYWdlLW1hc2staW5mb3twYWRkaW5nOjAgNHB4O292ZXJmbG93OmhpZGRlbjt3aGl0ZS1zcGFjZTpub3dyYXA7dGV4dC1vdmVyZmxvdzplbGxpcHNpc30uYW50LWltYWdlLW1hc2staW5mbyAuYW50aWNvbnstd2Via2l0LW1hcmdpbi1lbmQ6NHB4O21hcmdpbi1pbmxpbmUtZW5kOjRweH0uYW50LWltYWdlLW1hc2s6aG92ZXJ7b3BhY2l0eToxfS5hbnQtaW1hZ2UtcGxhY2Vob2xkZXJ7cG9zaXRpb246YWJzb2x1dGU7dG9wOjA7cmlnaHQ6MDtib3R0b206MDtsZWZ0OjB9LmFudC1pbWFnZS1wcmV2aWV3e3BvaW50ZXItZXZlbnRzOm5vbmU7aGVpZ2h0OjEwMCU7dGV4dC1hbGlnbjpjZW50ZXJ9LmFudC1pbWFnZS1wcmV2aWV3LmFudC16b29tLWFwcGVhciwuYW50LWltYWdlLXByZXZpZXcuYW50LXpvb20tZW50ZXJ7dHJhbnNmb3JtOm5vbmU7b3BhY2l0eTowO2FuaW1hdGlvbi1kdXJhdGlvbjouM3M7LXdlYmtpdC11c2VyLXNlbGVjdDpub25lOy1tb3otdXNlci1zZWxlY3Q6bm9uZTstbXMtdXNlci1zZWxlY3Q6bm9uZTt1c2VyLXNlbGVjdDpub25lfS5hbnQtaW1hZ2UtcHJldmlldy1tYXNre3Bvc2l0aW9uOmZpeGVkO3RvcDowO3JpZ2h0OjA7Ym90dG9tOjA7bGVmdDowO3otaW5kZXg6MTAwMDtoZWlnaHQ6MTAwJTtiYWNrZ3JvdW5kLWNvbG9yOnJnYmEoMCwwLDAsLjQ1KX0uYW50LWltYWdlLXByZXZpZXctbWFzay1oaWRkZW57ZGlzcGxheTpub25lfS5hbnQtaW1hZ2UtcHJldmlldy13cmFwe3Bvc2l0aW9uOmZpeGVkO3RvcDowO3JpZ2h0OjA7Ym90dG9tOjA7bGVmdDowO292ZXJmbG93OmF1dG87b3V0bGluZTowfS5hbnQtaW1hZ2UtcHJldmlldy1ib2R5e3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO3JpZ2h0OjA7Ym90dG9tOjA7bGVmdDowO292ZXJmbG93OmhpZGRlbn0uYW50LWltYWdlLXByZXZpZXctaW1ne21heC13aWR0aDoxMDAlO21heC1oZWlnaHQ6MTAwJTt2ZXJ0aWNhbC1hbGlnbjptaWRkbGU7dHJhbnNmb3JtOnNjYWxlWCgxKTtjdXJzb3I6Z3JhYjstd2Via2l0LXVzZXItc2VsZWN0Om5vbmU7LW1vei11c2VyLXNlbGVjdDpub25lOy1tcy11c2VyLXNlbGVjdDpub25lO3VzZXItc2VsZWN0Om5vbmU7cG9pbnRlci1ldmVudHM6YXV0b30uYW50LWltYWdlLXByZXZpZXctaW1nLC5hbnQtaW1hZ2UtcHJldmlldy1pbWctd3JhcHBlcnt0cmFuc2l0aW9uOnRyYW5zZm9ybSAuM3MgY3ViaWMtYmV6aWVyKC4yMTUsLjYxLC4zNTUsMSkgMHN9LmFudC1pbWFnZS1wcmV2aWV3LWltZy13cmFwcGVye3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO3JpZ2h0OjA7Ym90dG9tOjA7bGVmdDowfS5hbnQtaW1hZ2UtcHJldmlldy1pbWctd3JhcHBlcjpiZWZvcmV7ZGlzcGxheTppbmxpbmUtYmxvY2s7d2lkdGg6MXB4O2hlaWdodDo1MCU7bWFyZ2luLXJpZ2h0Oi0xcHg7Y29udGVudDpcIlwifS5hbnQtaW1hZ2UtcHJldmlldy1tb3ZpbmcgLmFudC1pbWFnZS1wcmV2aWV3LWltZ3tjdXJzb3I6Z3JhYmJpbmd9LmFudC1pbWFnZS1wcmV2aWV3LW1vdmluZyAuYW50LWltYWdlLXByZXZpZXctaW1nLXdyYXBwZXJ7dHJhbnNpdGlvbi1kdXJhdGlvbjowc30uYW50LWltYWdlLXByZXZpZXctd3JhcHt6LWluZGV4OjEwODB9LmFudC1pbWFnZS1wcmV2aWV3LW9wZXJhdGlvbnMtd3JhcHBlcntwb3NpdGlvbjpmaXhlZDt0b3A6MDtyaWdodDowO3otaW5kZXg6MTA4MTt3aWR0aDoxMDAlfS5hbnQtaW1hZ2UtcHJldmlldy1vcGVyYXRpb25ze2JveC1zaXppbmc6Ym9yZGVyLWJveDttYXJnaW46MDtwYWRkaW5nOjA7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtc2l6ZToxNHB4O2ZvbnQtdmFyaWFudDp0YWJ1bGFyLW51bXM7bGluZS1oZWlnaHQ6MS41NzE1O2ZvbnQtZmVhdHVyZS1zZXR0aW5nczpcInRudW1cIjtkaXNwbGF5OmZsZXg7ZmxleC1kaXJlY3Rpb246cm93LXJldmVyc2U7YWxpZ24taXRlbXM6Y2VudGVyO2NvbG9yOmhzbGEoMCwwJSwxMDAlLC44NSk7bGlzdC1zdHlsZTpub25lO2JhY2tncm91bmQ6cmdiYSgwLDAsMCwuMSk7cG9pbnRlci1ldmVudHM6YXV0b30uYW50LWltYWdlLXByZXZpZXctb3BlcmF0aW9ucy1vcGVyYXRpb257bWFyZ2luLWxlZnQ6MTJweDtwYWRkaW5nOjEycHg7Y3Vyc29yOnBvaW50ZXI7dHJhbnNpdGlvbjphbGwgLjNzfS5hbnQtaW1hZ2UtcHJldmlldy1vcGVyYXRpb25zLW9wZXJhdGlvbjpob3ZlcntiYWNrZ3JvdW5kOnJnYmEoMCwwLDAsLjIpfS5hbnQtaW1hZ2UtcHJldmlldy1vcGVyYXRpb25zLW9wZXJhdGlvbi1kaXNhYmxlZHtjb2xvcjpoc2xhKDAsMCUsMTAwJSwuMjUpO3BvaW50ZXItZXZlbnRzOm5vbmV9LmFudC1pbWFnZS1wcmV2aWV3LW9wZXJhdGlvbnMtb3BlcmF0aW9uOmxhc3Qtb2YtdHlwZXttYXJnaW4tbGVmdDowfS5hbnQtaW1hZ2UtcHJldmlldy1vcGVyYXRpb25zLXByb2dyZXNze3Bvc2l0aW9uOmFic29sdXRlO2xlZnQ6NTAlO3RyYW5zZm9ybTp0cmFuc2xhdGVYKC01MCUpfS5hbnQtaW1hZ2UtcHJldmlldy1vcGVyYXRpb25zLWljb257Zm9udC1zaXplOjE4cHh9LmFudC1pbWFnZS1wcmV2aWV3LXN3aXRjaC1sZWZ0LC5hbnQtaW1hZ2UtcHJldmlldy1zd2l0Y2gtcmlnaHR7cG9zaXRpb246Zml4ZWQ7dG9wOjUwJTtyaWdodDo4cHg7ei1pbmRleDoxMDgxO2Rpc3BsYXk6ZmxleDthbGlnbi1pdGVtczpjZW50ZXI7anVzdGlmeS1jb250ZW50OmNlbnRlcjt3aWR0aDo0NHB4O2hlaWdodDo0NHB4O2NvbG9yOmhzbGEoMCwwJSwxMDAlLC44NSk7YmFja2dyb3VuZDpyZ2JhKDAsMCwwLC4xKTtib3JkZXItcmFkaXVzOjUwJTt0cmFuc2Zvcm06dHJhbnNsYXRlWSgtNTAlKTtjdXJzb3I6cG9pbnRlcjt0cmFuc2l0aW9uOmFsbCAuM3M7cG9pbnRlci1ldmVudHM6YXV0b30uYW50LWltYWdlLXByZXZpZXctc3dpdGNoLWxlZnQ6aG92ZXIsLmFudC1pbWFnZS1wcmV2aWV3LXN3aXRjaC1yaWdodDpob3ZlcntiYWNrZ3JvdW5kOnJnYmEoMCwwLDAsLjIpfS5hbnQtaW1hZ2UtcHJldmlldy1zd2l0Y2gtbGVmdC1kaXNhYmxlZCwuYW50LWltYWdlLXByZXZpZXctc3dpdGNoLWxlZnQtZGlzYWJsZWQ6aG92ZXIsLmFudC1pbWFnZS1wcmV2aWV3LXN3aXRjaC1yaWdodC1kaXNhYmxlZCwuYW50LWltYWdlLXByZXZpZXctc3dpdGNoLXJpZ2h0LWRpc2FibGVkOmhvdmVye2NvbG9yOmhzbGEoMCwwJSwxMDAlLC4yNSk7YmFja2dyb3VuZDpyZ2JhKDAsMCwwLC4xKTtjdXJzb3I6bm90LWFsbG93ZWR9LmFudC1pbWFnZS1wcmV2aWV3LXN3aXRjaC1sZWZ0LWRpc2FibGVkOmhvdmVyPi5hbnRpY29uLC5hbnQtaW1hZ2UtcHJldmlldy1zd2l0Y2gtbGVmdC1kaXNhYmxlZD4uYW50aWNvbiwuYW50LWltYWdlLXByZXZpZXctc3dpdGNoLXJpZ2h0LWRpc2FibGVkOmhvdmVyPi5hbnRpY29uLC5hbnQtaW1hZ2UtcHJldmlldy1zd2l0Y2gtcmlnaHQtZGlzYWJsZWQ+LmFudGljb257Y3Vyc29yOm5vdC1hbGxvd2VkfS5hbnQtaW1hZ2UtcHJldmlldy1zd2l0Y2gtbGVmdD4uYW50aWNvbiwuYW50LWltYWdlLXByZXZpZXctc3dpdGNoLXJpZ2h0Pi5hbnRpY29ue2ZvbnQtc2l6ZToxOHB4fS5hbnQtaW1hZ2UtcHJldmlldy1zd2l0Y2gtbGVmdHtsZWZ0OjhweH0uYW50LWltYWdlLXByZXZpZXctc3dpdGNoLXJpZ2h0e3JpZ2h0OjhweH0uYW50LWlucHV0LW51bWJlci1hZmZpeC13cmFwcGVye2Rpc3BsYXk6aW5saW5lLWJsb2NrO3dpZHRoOjEwMCU7bWluLXdpZHRoOjA7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtc2l6ZToxNHB4O2xpbmUtaGVpZ2h0OjEuNTcxNTtiYWNrZ3JvdW5kLWNvbG9yOiNmZmY7YmFja2dyb3VuZC1pbWFnZTpub25lO2JvcmRlcjoxcHggc29saWQgI2Q5ZDlkOTtib3JkZXItcmFkaXVzOjJweDt0cmFuc2l0aW9uOmFsbCAuM3M7cG9zaXRpb246cmVsYXRpdmU7ZGlzcGxheTppbmxpbmUtZmxleDt3aWR0aDo5MHB4O3BhZGRpbmc6MDstd2Via2l0LXBhZGRpbmctc3RhcnQ6MTFweDtwYWRkaW5nLWlubGluZS1zdGFydDoxMXB4fS5hbnQtaW5wdXQtbnVtYmVyLWFmZml4LXdyYXBwZXI6Oi1tb3otcGxhY2Vob2xkZXJ7Y29sb3I6I2JmYmZiZjstbW96LXVzZXItc2VsZWN0Om5vbmU7dXNlci1zZWxlY3Q6bm9uZX0uYW50LWlucHV0LW51bWJlci1hZmZpeC13cmFwcGVyOi1tcy1pbnB1dC1wbGFjZWhvbGRlcntjb2xvcjojYmZiZmJmOy1tcy11c2VyLXNlbGVjdDpub25lO3VzZXItc2VsZWN0Om5vbmV9LmFudC1pbnB1dC1udW1iZXItYWZmaXgtd3JhcHBlcjo6cGxhY2Vob2xkZXJ7Y29sb3I6I2JmYmZiZjstd2Via2l0LXVzZXItc2VsZWN0Om5vbmU7LW1vei11c2VyLXNlbGVjdDpub25lOy1tcy11c2VyLXNlbGVjdDpub25lO3VzZXItc2VsZWN0Om5vbmV9LmFudC1pbnB1dC1udW1iZXItYWZmaXgtd3JhcHBlcjotbW96LXBsYWNlaG9sZGVyLXNob3due3RleHQtb3ZlcmZsb3c6ZWxsaXBzaXN9LmFudC1pbnB1dC1udW1iZXItYWZmaXgtd3JhcHBlcjotbXMtaW5wdXQtcGxhY2Vob2xkZXJ7dGV4dC1vdmVyZmxvdzplbGxpcHNpc30uYW50LWlucHV0LW51bWJlci1hZmZpeC13cmFwcGVyOnBsYWNlaG9sZGVyLXNob3due3RleHQtb3ZlcmZsb3c6ZWxsaXBzaXN9LmFudC1pbnB1dC1udW1iZXItYWZmaXgtd3JhcHBlcjpob3Zlcntib3JkZXItY29sb3I6IzQwYTlmZjtib3JkZXItcmlnaHQtd2lkdGg6MXB4fS5hbnQtaW5wdXQtbnVtYmVyLWFmZml4LXdyYXBwZXItZm9jdXNlZCwuYW50LWlucHV0LW51bWJlci1hZmZpeC13cmFwcGVyOmZvY3Vze2JvcmRlci1jb2xvcjojNDBhOWZmO2JveC1zaGFkb3c6MCAwIDAgMnB4IHJnYmEoMjQsMTQ0LDI1NSwuMik7Ym9yZGVyLXJpZ2h0LXdpZHRoOjFweDtvdXRsaW5lOjB9LmFudC1pbnB1dC1udW1iZXItYWZmaXgtd3JhcHBlci1kaXNhYmxlZHtjb2xvcjpyZ2JhKDAsMCwwLC4yNSk7YmFja2dyb3VuZC1jb2xvcjojZjVmNWY1O2JvcmRlci1jb2xvcjojZDlkOWQ5O2JveC1zaGFkb3c6bm9uZTtjdXJzb3I6bm90LWFsbG93ZWQ7b3BhY2l0eToxfS5hbnQtaW5wdXQtbnVtYmVyLWFmZml4LXdyYXBwZXItZGlzYWJsZWQ6aG92ZXJ7Ym9yZGVyLWNvbG9yOiNkOWQ5ZDk7Ym9yZGVyLXJpZ2h0LXdpZHRoOjFweH0uYW50LWlucHV0LW51bWJlci1hZmZpeC13cmFwcGVyW2Rpc2FibGVkXXtjb2xvcjpyZ2JhKDAsMCwwLC4yNSk7YmFja2dyb3VuZC1jb2xvcjojZjVmNWY1O2JvcmRlci1jb2xvcjojZDlkOWQ5O2JveC1zaGFkb3c6bm9uZTtjdXJzb3I6bm90LWFsbG93ZWQ7b3BhY2l0eToxfS5hbnQtaW5wdXQtbnVtYmVyLWFmZml4LXdyYXBwZXJbZGlzYWJsZWRdOmhvdmVye2JvcmRlci1jb2xvcjojZDlkOWQ5O2JvcmRlci1yaWdodC13aWR0aDoxcHh9LmFudC1pbnB1dC1udW1iZXItYWZmaXgtd3JhcHBlci1ib3JkZXJsZXNzLC5hbnQtaW5wdXQtbnVtYmVyLWFmZml4LXdyYXBwZXItYm9yZGVybGVzcy1kaXNhYmxlZCwuYW50LWlucHV0LW51bWJlci1hZmZpeC13cmFwcGVyLWJvcmRlcmxlc3MtZm9jdXNlZCwuYW50LWlucHV0LW51bWJlci1hZmZpeC13cmFwcGVyLWJvcmRlcmxlc3M6Zm9jdXMsLmFudC1pbnB1dC1udW1iZXItYWZmaXgtd3JhcHBlci1ib3JkZXJsZXNzOmhvdmVyLC5hbnQtaW5wdXQtbnVtYmVyLWFmZml4LXdyYXBwZXItYm9yZGVybGVzc1tkaXNhYmxlZF17YmFja2dyb3VuZC1jb2xvcjp0cmFuc3BhcmVudDtib3JkZXI6bm9uZTtib3gtc2hhZG93Om5vbmV9dGV4dGFyZWEuYW50LWlucHV0LW51bWJlci1hZmZpeC13cmFwcGVye21heC13aWR0aDoxMDAlO2hlaWdodDphdXRvO21pbi1oZWlnaHQ6MzJweDtsaW5lLWhlaWdodDoxLjU3MTU7dmVydGljYWwtYWxpZ246Ym90dG9tO3RyYW5zaXRpb246YWxsIC4zcyxoZWlnaHQgMHN9LmFudC1pbnB1dC1udW1iZXItYWZmaXgtd3JhcHBlci1sZ3twYWRkaW5nOjYuNXB4IDExcHg7Zm9udC1zaXplOjE2cHh9LmFudC1pbnB1dC1udW1iZXItYWZmaXgtd3JhcHBlci1zbXtwYWRkaW5nOjAgN3B4fS5hbnQtaW5wdXQtbnVtYmVyLWFmZml4LXdyYXBwZXI6bm90KC5hbnQtaW5wdXQtbnVtYmVyLWFmZml4LXdyYXBwZXItZGlzYWJsZWQpOmhvdmVye2JvcmRlci1jb2xvcjojNDBhOWZmO2JvcmRlci1yaWdodC13aWR0aDoxcHg7ei1pbmRleDoxfS5hbnQtaW5wdXQtbnVtYmVyLWFmZml4LXdyYXBwZXItZm9jdXNlZCwuYW50LWlucHV0LW51bWJlci1hZmZpeC13cmFwcGVyOmZvY3Vze3otaW5kZXg6MX0uYW50LWlucHV0LW51bWJlci1hZmZpeC13cmFwcGVyLWRpc2FibGVkIC5hbnQtaW5wdXQtbnVtYmVyW2Rpc2FibGVkXXtiYWNrZ3JvdW5kOnRyYW5zcGFyZW50fS5hbnQtaW5wdXQtbnVtYmVyLWFmZml4LXdyYXBwZXI+ZGl2LmFudC1pbnB1dC1udW1iZXJ7d2lkdGg6MTAwJTtib3JkZXI6bm9uZTtvdXRsaW5lOm5vbmV9LmFudC1pbnB1dC1udW1iZXItYWZmaXgtd3JhcHBlcj5kaXYuYW50LWlucHV0LW51bWJlci5hbnQtaW5wdXQtbnVtYmVyLWZvY3VzZWR7Ym94LXNoYWRvdzpub25lIWltcG9ydGFudH0uYW50LWlucHV0LW51bWJlci1hZmZpeC13cmFwcGVyIGlucHV0LmFudC1pbnB1dC1udW1iZXItaW5wdXR7cGFkZGluZzowfS5hbnQtaW5wdXQtbnVtYmVyLWFmZml4LXdyYXBwZXI6YmVmb3Jle3dpZHRoOjA7dmlzaWJpbGl0eTpoaWRkZW47Y29udGVudDpcIlxcYTBcIn0uYW50LWlucHV0LW51bWJlci1hZmZpeC13cmFwcGVyIC5hbnQtaW5wdXQtbnVtYmVyLWhhbmRsZXItd3JhcHt6LWluZGV4OjJ9LmFudC1pbnB1dC1udW1iZXItcHJlZml4LC5hbnQtaW5wdXQtbnVtYmVyLXN1ZmZpeHtkaXNwbGF5OmZsZXg7ZmxleDpub25lO2FsaWduLWl0ZW1zOmNlbnRlcjtwb2ludGVyLWV2ZW50czpub25lfS5hbnQtaW5wdXQtbnVtYmVyLXByZWZpeHstd2Via2l0LW1hcmdpbi1lbmQ6NHB4O21hcmdpbi1pbmxpbmUtZW5kOjRweH0uYW50LWlucHV0LW51bWJlci1zdWZmaXh7cG9zaXRpb246YWJzb2x1dGU7dG9wOjA7cmlnaHQ6MDt6LWluZGV4OjE7aGVpZ2h0OjEwMCU7bWFyZ2luLXJpZ2h0OjExcHg7bWFyZ2luLWxlZnQ6NHB4fS5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLXdyYXBwZXIgLmFudC1pbnB1dC1udW1iZXItYWZmaXgtd3JhcHBlcnt3aWR0aDoxMDAlfS5hbnQtaW5wdXQtbnVtYmVyLXN0YXR1cy1lcnJvcjpub3QoLmFudC1pbnB1dC1udW1iZXItZGlzYWJsZWQpOm5vdCguYW50LWlucHV0LW51bWJlci1ib3JkZXJsZXNzKS5hbnQtaW5wdXQtbnVtYmVyLC5hbnQtaW5wdXQtbnVtYmVyLXN0YXR1cy1lcnJvcjpub3QoLmFudC1pbnB1dC1udW1iZXItZGlzYWJsZWQpOm5vdCguYW50LWlucHV0LW51bWJlci1ib3JkZXJsZXNzKS5hbnQtaW5wdXQtbnVtYmVyOmhvdmVye2JhY2tncm91bmQ6I2ZmZjtib3JkZXItY29sb3I6I2ZmNGQ0Zn0uYW50LWlucHV0LW51bWJlci1zdGF0dXMtZXJyb3I6bm90KC5hbnQtaW5wdXQtbnVtYmVyLWRpc2FibGVkKTpub3QoLmFudC1pbnB1dC1udW1iZXItYm9yZGVybGVzcykuYW50LWlucHV0LW51bWJlci1mb2N1c2VkLC5hbnQtaW5wdXQtbnVtYmVyLXN0YXR1cy1lcnJvcjpub3QoLmFudC1pbnB1dC1udW1iZXItZGlzYWJsZWQpOm5vdCguYW50LWlucHV0LW51bWJlci1ib3JkZXJsZXNzKS5hbnQtaW5wdXQtbnVtYmVyOmZvY3Vze2JvcmRlci1jb2xvcjojZmY3ODc1O2JveC1zaGFkb3c6MCAwIDAgMnB4IHJnYmEoMjU1LDc3LDc5LC4yKTtib3JkZXItcmlnaHQtd2lkdGg6MXB4O291dGxpbmU6MH0uYW50LWlucHV0LW51bWJlci1zdGF0dXMtZXJyb3IgLmFudC1pbnB1dC1udW1iZXItcHJlZml4e2NvbG9yOiNmZjRkNGZ9LmFudC1pbnB1dC1udW1iZXItc3RhdHVzLXdhcm5pbmc6bm90KC5hbnQtaW5wdXQtbnVtYmVyLWRpc2FibGVkKTpub3QoLmFudC1pbnB1dC1udW1iZXItYm9yZGVybGVzcykuYW50LWlucHV0LW51bWJlciwuYW50LWlucHV0LW51bWJlci1zdGF0dXMtd2FybmluZzpub3QoLmFudC1pbnB1dC1udW1iZXItZGlzYWJsZWQpOm5vdCguYW50LWlucHV0LW51bWJlci1ib3JkZXJsZXNzKS5hbnQtaW5wdXQtbnVtYmVyOmhvdmVye2JhY2tncm91bmQ6I2ZmZjtib3JkZXItY29sb3I6I2ZhYWQxNH0uYW50LWlucHV0LW51bWJlci1zdGF0dXMtd2FybmluZzpub3QoLmFudC1pbnB1dC1udW1iZXItZGlzYWJsZWQpOm5vdCguYW50LWlucHV0LW51bWJlci1ib3JkZXJsZXNzKS5hbnQtaW5wdXQtbnVtYmVyLWZvY3VzZWQsLmFudC1pbnB1dC1udW1iZXItc3RhdHVzLXdhcm5pbmc6bm90KC5hbnQtaW5wdXQtbnVtYmVyLWRpc2FibGVkKTpub3QoLmFudC1pbnB1dC1udW1iZXItYm9yZGVybGVzcykuYW50LWlucHV0LW51bWJlcjpmb2N1c3tib3JkZXItY29sb3I6I2ZmYzUzZDtib3gtc2hhZG93OjAgMCAwIDJweCByZ2JhKDI1MCwxNzMsMjAsLjIpO2JvcmRlci1yaWdodC13aWR0aDoxcHg7b3V0bGluZTowfS5hbnQtaW5wdXQtbnVtYmVyLXN0YXR1cy13YXJuaW5nIC5hbnQtaW5wdXQtbnVtYmVyLXByZWZpeHtjb2xvcjojZmFhZDE0fS5hbnQtaW5wdXQtbnVtYmVyLWFmZml4LXdyYXBwZXItc3RhdHVzLWVycm9yOm5vdCguYW50LWlucHV0LW51bWJlci1hZmZpeC13cmFwcGVyLWRpc2FibGVkKTpub3QoLmFudC1pbnB1dC1udW1iZXItYWZmaXgtd3JhcHBlci1ib3JkZXJsZXNzKS5hbnQtaW5wdXQtbnVtYmVyLWFmZml4LXdyYXBwZXIsLmFudC1pbnB1dC1udW1iZXItYWZmaXgtd3JhcHBlci1zdGF0dXMtZXJyb3I6bm90KC5hbnQtaW5wdXQtbnVtYmVyLWFmZml4LXdyYXBwZXItZGlzYWJsZWQpOm5vdCguYW50LWlucHV0LW51bWJlci1hZmZpeC13cmFwcGVyLWJvcmRlcmxlc3MpLmFudC1pbnB1dC1udW1iZXItYWZmaXgtd3JhcHBlcjpob3ZlcntiYWNrZ3JvdW5kOiNmZmY7Ym9yZGVyLWNvbG9yOiNmZjRkNGZ9LmFudC1pbnB1dC1udW1iZXItYWZmaXgtd3JhcHBlci1zdGF0dXMtZXJyb3I6bm90KC5hbnQtaW5wdXQtbnVtYmVyLWFmZml4LXdyYXBwZXItZGlzYWJsZWQpOm5vdCguYW50LWlucHV0LW51bWJlci1hZmZpeC13cmFwcGVyLWJvcmRlcmxlc3MpLmFudC1pbnB1dC1udW1iZXItYWZmaXgtd3JhcHBlci1mb2N1c2VkLC5hbnQtaW5wdXQtbnVtYmVyLWFmZml4LXdyYXBwZXItc3RhdHVzLWVycm9yOm5vdCguYW50LWlucHV0LW51bWJlci1hZmZpeC13cmFwcGVyLWRpc2FibGVkKTpub3QoLmFudC1pbnB1dC1udW1iZXItYWZmaXgtd3JhcHBlci1ib3JkZXJsZXNzKS5hbnQtaW5wdXQtbnVtYmVyLWFmZml4LXdyYXBwZXI6Zm9jdXN7Ym9yZGVyLWNvbG9yOiNmZjc4NzU7Ym94LXNoYWRvdzowIDAgMCAycHggcmdiYSgyNTUsNzcsNzksLjIpO2JvcmRlci1yaWdodC13aWR0aDoxcHg7b3V0bGluZTowfS5hbnQtaW5wdXQtbnVtYmVyLWFmZml4LXdyYXBwZXItc3RhdHVzLWVycm9yIC5hbnQtaW5wdXQtbnVtYmVyLXByZWZpeHtjb2xvcjojZmY0ZDRmfS5hbnQtaW5wdXQtbnVtYmVyLWFmZml4LXdyYXBwZXItc3RhdHVzLXdhcm5pbmc6bm90KC5hbnQtaW5wdXQtbnVtYmVyLWFmZml4LXdyYXBwZXItZGlzYWJsZWQpOm5vdCguYW50LWlucHV0LW51bWJlci1hZmZpeC13cmFwcGVyLWJvcmRlcmxlc3MpLmFudC1pbnB1dC1udW1iZXItYWZmaXgtd3JhcHBlciwuYW50LWlucHV0LW51bWJlci1hZmZpeC13cmFwcGVyLXN0YXR1cy13YXJuaW5nOm5vdCguYW50LWlucHV0LW51bWJlci1hZmZpeC13cmFwcGVyLWRpc2FibGVkKTpub3QoLmFudC1pbnB1dC1udW1iZXItYWZmaXgtd3JhcHBlci1ib3JkZXJsZXNzKS5hbnQtaW5wdXQtbnVtYmVyLWFmZml4LXdyYXBwZXI6aG92ZXJ7YmFja2dyb3VuZDojZmZmO2JvcmRlci1jb2xvcjojZmFhZDE0fS5hbnQtaW5wdXQtbnVtYmVyLWFmZml4LXdyYXBwZXItc3RhdHVzLXdhcm5pbmc6bm90KC5hbnQtaW5wdXQtbnVtYmVyLWFmZml4LXdyYXBwZXItZGlzYWJsZWQpOm5vdCguYW50LWlucHV0LW51bWJlci1hZmZpeC13cmFwcGVyLWJvcmRlcmxlc3MpLmFudC1pbnB1dC1udW1iZXItYWZmaXgtd3JhcHBlci1mb2N1c2VkLC5hbnQtaW5wdXQtbnVtYmVyLWFmZml4LXdyYXBwZXItc3RhdHVzLXdhcm5pbmc6bm90KC5hbnQtaW5wdXQtbnVtYmVyLWFmZml4LXdyYXBwZXItZGlzYWJsZWQpOm5vdCguYW50LWlucHV0LW51bWJlci1hZmZpeC13cmFwcGVyLWJvcmRlcmxlc3MpLmFudC1pbnB1dC1udW1iZXItYWZmaXgtd3JhcHBlcjpmb2N1c3tib3JkZXItY29sb3I6I2ZmYzUzZDtib3gtc2hhZG93OjAgMCAwIDJweCByZ2JhKDI1MCwxNzMsMjAsLjIpO2JvcmRlci1yaWdodC13aWR0aDoxcHg7b3V0bGluZTowfS5hbnQtaW5wdXQtbnVtYmVyLWFmZml4LXdyYXBwZXItc3RhdHVzLXdhcm5pbmcgLmFudC1pbnB1dC1udW1iZXItcHJlZml4e2NvbG9yOiNmYWFkMTR9LmFudC1pbnB1dC1udW1iZXItZ3JvdXAtd3JhcHBlci1zdGF0dXMtZXJyb3IgLmFudC1pbnB1dC1udW1iZXItZ3JvdXAtYWRkb257Y29sb3I6I2ZmNGQ0Zjtib3JkZXItY29sb3I6I2ZmNGQ0Zn0uYW50LWlucHV0LW51bWJlci1ncm91cC13cmFwcGVyLXN0YXR1cy13YXJuaW5nIC5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLWFkZG9ue2NvbG9yOiNmYWFkMTQ7Ym9yZGVyLWNvbG9yOiNmYWFkMTR9LmFudC1pbnB1dC1udW1iZXJ7Ym94LXNpemluZzpib3JkZXItYm94O2ZvbnQtdmFyaWFudDp0YWJ1bGFyLW51bXM7bGlzdC1zdHlsZTpub25lO2ZvbnQtZmVhdHVyZS1zZXR0aW5nczpcInRudW1cIjtwb3NpdGlvbjpyZWxhdGl2ZTt3aWR0aDoxMDAlO21pbi13aWR0aDowO2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtmb250LXNpemU6MTRweDtsaW5lLWhlaWdodDoxLjU3MTU7YmFja2dyb3VuZC1jb2xvcjojZmZmO2JhY2tncm91bmQtaW1hZ2U6bm9uZTt0cmFuc2l0aW9uOmFsbCAuM3M7ZGlzcGxheTppbmxpbmUtYmxvY2s7d2lkdGg6OTBweDttYXJnaW46MDtwYWRkaW5nOjA7Ym9yZGVyOjFweCBzb2xpZCAjZDlkOWQ5O2JvcmRlci1yYWRpdXM6MnB4fS5hbnQtaW5wdXQtbnVtYmVyOjotbW96LXBsYWNlaG9sZGVye2NvbG9yOiNiZmJmYmY7LW1vei11c2VyLXNlbGVjdDpub25lO3VzZXItc2VsZWN0Om5vbmV9LmFudC1pbnB1dC1udW1iZXI6LW1zLWlucHV0LXBsYWNlaG9sZGVye2NvbG9yOiNiZmJmYmY7LW1zLXVzZXItc2VsZWN0Om5vbmU7dXNlci1zZWxlY3Q6bm9uZX0uYW50LWlucHV0LW51bWJlcjo6cGxhY2Vob2xkZXJ7Y29sb3I6I2JmYmZiZjstd2Via2l0LXVzZXItc2VsZWN0Om5vbmU7LW1vei11c2VyLXNlbGVjdDpub25lOy1tcy11c2VyLXNlbGVjdDpub25lO3VzZXItc2VsZWN0Om5vbmV9LmFudC1pbnB1dC1udW1iZXI6LW1vei1wbGFjZWhvbGRlci1zaG93bnt0ZXh0LW92ZXJmbG93OmVsbGlwc2lzfS5hbnQtaW5wdXQtbnVtYmVyOi1tcy1pbnB1dC1wbGFjZWhvbGRlcnt0ZXh0LW92ZXJmbG93OmVsbGlwc2lzfS5hbnQtaW5wdXQtbnVtYmVyOnBsYWNlaG9sZGVyLXNob3due3RleHQtb3ZlcmZsb3c6ZWxsaXBzaXN9LmFudC1pbnB1dC1udW1iZXItZm9jdXNlZCwuYW50LWlucHV0LW51bWJlcjpmb2N1c3tib3JkZXItY29sb3I6IzQwYTlmZjtib3gtc2hhZG93OjAgMCAwIDJweCByZ2JhKDI0LDE0NCwyNTUsLjIpO2JvcmRlci1yaWdodC13aWR0aDoxcHg7b3V0bGluZTowfS5hbnQtaW5wdXQtbnVtYmVyW2Rpc2FibGVkXXtjb2xvcjpyZ2JhKDAsMCwwLC4yNSk7YmFja2dyb3VuZC1jb2xvcjojZjVmNWY1O2JvcmRlci1jb2xvcjojZDlkOWQ5O2JveC1zaGFkb3c6bm9uZTtjdXJzb3I6bm90LWFsbG93ZWQ7b3BhY2l0eToxfS5hbnQtaW5wdXQtbnVtYmVyW2Rpc2FibGVkXTpob3Zlcntib3JkZXItY29sb3I6I2Q5ZDlkOTtib3JkZXItcmlnaHQtd2lkdGg6MXB4fS5hbnQtaW5wdXQtbnVtYmVyLWJvcmRlcmxlc3MsLmFudC1pbnB1dC1udW1iZXItYm9yZGVybGVzcy1kaXNhYmxlZCwuYW50LWlucHV0LW51bWJlci1ib3JkZXJsZXNzLWZvY3VzZWQsLmFudC1pbnB1dC1udW1iZXItYm9yZGVybGVzczpmb2N1cywuYW50LWlucHV0LW51bWJlci1ib3JkZXJsZXNzOmhvdmVyLC5hbnQtaW5wdXQtbnVtYmVyLWJvcmRlcmxlc3NbZGlzYWJsZWRde2JhY2tncm91bmQtY29sb3I6dHJhbnNwYXJlbnQ7Ym9yZGVyOm5vbmU7Ym94LXNoYWRvdzpub25lfXRleHRhcmVhLmFudC1pbnB1dC1udW1iZXJ7bWF4LXdpZHRoOjEwMCU7aGVpZ2h0OmF1dG87bWluLWhlaWdodDozMnB4O2xpbmUtaGVpZ2h0OjEuNTcxNTt2ZXJ0aWNhbC1hbGlnbjpib3R0b207dHJhbnNpdGlvbjphbGwgLjNzLGhlaWdodCAwc30uYW50LWlucHV0LW51bWJlci1sZ3twYWRkaW5nOjYuNXB4IDExcHh9LmFudC1pbnB1dC1udW1iZXItc217cGFkZGluZzowIDdweH0uYW50LWlucHV0LW51bWJlci1ncm91cHtib3gtc2l6aW5nOmJvcmRlci1ib3g7bWFyZ2luOjA7cGFkZGluZzowO2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtmb250LXNpemU6MTRweDtmb250LXZhcmlhbnQ6dGFidWxhci1udW1zO2xpbmUtaGVpZ2h0OjEuNTcxNTtsaXN0LXN0eWxlOm5vbmU7Zm9udC1mZWF0dXJlLXNldHRpbmdzOlwidG51bVwiO3Bvc2l0aW9uOnJlbGF0aXZlO2Rpc3BsYXk6dGFibGU7d2lkdGg6MTAwJTtib3JkZXItY29sbGFwc2U6c2VwYXJhdGU7Ym9yZGVyLXNwYWNpbmc6MH0uYW50LWlucHV0LW51bWJlci1ncm91cFtjbGFzcyo9Y29sLV17ZmxvYXQ6bm9uZTtwYWRkaW5nLXJpZ2h0OjA7cGFkZGluZy1sZWZ0OjB9LmFudC1pbnB1dC1udW1iZXItZ3JvdXA+W2NsYXNzKj1jb2wtXXtwYWRkaW5nLXJpZ2h0OjhweH0uYW50LWlucHV0LW51bWJlci1ncm91cD5bY2xhc3MqPWNvbC1dOmxhc3QtY2hpbGR7cGFkZGluZy1yaWdodDowfS5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLWFkZG9uLC5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLXdyYXAsLmFudC1pbnB1dC1udW1iZXItZ3JvdXA+LmFudC1pbnB1dC1udW1iZXJ7ZGlzcGxheTp0YWJsZS1jZWxsfS5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLWFkZG9uOm5vdCg6Zmlyc3QtY2hpbGQpOm5vdCg6bGFzdC1jaGlsZCksLmFudC1pbnB1dC1udW1iZXItZ3JvdXAtd3JhcDpub3QoOmZpcnN0LWNoaWxkKTpub3QoOmxhc3QtY2hpbGQpLC5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwPi5hbnQtaW5wdXQtbnVtYmVyOm5vdCg6Zmlyc3QtY2hpbGQpOm5vdCg6bGFzdC1jaGlsZCl7Ym9yZGVyLXJhZGl1czowfS5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLWFkZG9uLC5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLXdyYXB7d2lkdGg6MXB4O3doaXRlLXNwYWNlOm5vd3JhcDt2ZXJ0aWNhbC1hbGlnbjptaWRkbGV9LmFudC1pbnB1dC1udW1iZXItZ3JvdXAtd3JhcD4qe2Rpc3BsYXk6YmxvY2shaW1wb3J0YW50fS5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwIC5hbnQtaW5wdXQtbnVtYmVye2Zsb2F0OmxlZnQ7d2lkdGg6MTAwJTttYXJnaW4tYm90dG9tOjA7dGV4dC1hbGlnbjppbmhlcml0fS5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwIC5hbnQtaW5wdXQtbnVtYmVyOmZvY3VzLC5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwIC5hbnQtaW5wdXQtbnVtYmVyOmhvdmVye3otaW5kZXg6MTtib3JkZXItcmlnaHQtd2lkdGg6MXB4fS5hbnQtaW5wdXQtc2VhcmNoLXdpdGgtYnV0dG9uIC5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwIC5hbnQtaW5wdXQtbnVtYmVyOmhvdmVye3otaW5kZXg6MH0uYW50LWlucHV0LW51bWJlci1ncm91cC1hZGRvbntwb3NpdGlvbjpyZWxhdGl2ZTtwYWRkaW5nOjAgMTFweDtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7Zm9udC13ZWlnaHQ6NDAwO2ZvbnQtc2l6ZToxNHB4O3RleHQtYWxpZ246Y2VudGVyO2JhY2tncm91bmQtY29sb3I6I2ZhZmFmYTtib3JkZXI6MXB4IHNvbGlkICNkOWQ5ZDk7Ym9yZGVyLXJhZGl1czoycHg7dHJhbnNpdGlvbjphbGwgLjNzfS5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLWFkZG9uIC5hbnQtc2VsZWN0e21hcmdpbjotNXB4IC0xMXB4fS5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLWFkZG9uIC5hbnQtc2VsZWN0LmFudC1zZWxlY3Qtc2luZ2xlOm5vdCguYW50LXNlbGVjdC1jdXN0b21pemUtaW5wdXQpIC5hbnQtc2VsZWN0LXNlbGVjdG9ye2JhY2tncm91bmQtY29sb3I6aW5oZXJpdDtib3JkZXI6MXB4IHNvbGlkIHRyYW5zcGFyZW50O2JveC1zaGFkb3c6bm9uZX0uYW50LWlucHV0LW51bWJlci1ncm91cC1hZGRvbiAuYW50LXNlbGVjdC1mb2N1c2VkIC5hbnQtc2VsZWN0LXNlbGVjdG9yLC5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLWFkZG9uIC5hbnQtc2VsZWN0LW9wZW4gLmFudC1zZWxlY3Qtc2VsZWN0b3J7Y29sb3I6IzE4OTBmZn0uYW50LWlucHV0LW51bWJlci1ncm91cC1hZGRvbiAuYW50LWNhc2NhZGVyLXBpY2tlcnttYXJnaW46LTlweCAtMTJweDtiYWNrZ3JvdW5kLWNvbG9yOnRyYW5zcGFyZW50fS5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLWFkZG9uIC5hbnQtY2FzY2FkZXItcGlja2VyIC5hbnQtY2FzY2FkZXItaW5wdXR7dGV4dC1hbGlnbjpsZWZ0O2JvcmRlcjowO2JveC1zaGFkb3c6bm9uZX0uYW50LWlucHV0LW51bWJlci1ncm91cC1hZGRvbjpmaXJzdC1jaGlsZCwuYW50LWlucHV0LW51bWJlci1ncm91cC1hZGRvbjpmaXJzdC1jaGlsZCAuYW50LXNlbGVjdCAuYW50LXNlbGVjdC1zZWxlY3RvciwuYW50LWlucHV0LW51bWJlci1ncm91cD4uYW50LWlucHV0LW51bWJlcjpmaXJzdC1jaGlsZCwuYW50LWlucHV0LW51bWJlci1ncm91cD4uYW50LWlucHV0LW51bWJlcjpmaXJzdC1jaGlsZCAuYW50LXNlbGVjdCAuYW50LXNlbGVjdC1zZWxlY3Rvcntib3JkZXItdG9wLXJpZ2h0LXJhZGl1czowO2JvcmRlci1ib3R0b20tcmlnaHQtcmFkaXVzOjB9LmFudC1pbnB1dC1udW1iZXItZ3JvdXA+LmFudC1pbnB1dC1udW1iZXItYWZmaXgtd3JhcHBlcjpub3QoOmZpcnN0LWNoaWxkKSAuYW50LWlucHV0LW51bWJlcntib3JkZXItdG9wLWxlZnQtcmFkaXVzOjA7Ym9yZGVyLWJvdHRvbS1sZWZ0LXJhZGl1czowfS5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwPi5hbnQtaW5wdXQtbnVtYmVyLWFmZml4LXdyYXBwZXI6bm90KDpsYXN0LWNoaWxkKSAuYW50LWlucHV0LW51bWJlcntib3JkZXItdG9wLXJpZ2h0LXJhZGl1czowO2JvcmRlci1ib3R0b20tcmlnaHQtcmFkaXVzOjB9LmFudC1pbnB1dC1udW1iZXItZ3JvdXAtYWRkb246Zmlyc3QtY2hpbGR7Ym9yZGVyLXJpZ2h0OjB9LmFudC1pbnB1dC1udW1iZXItZ3JvdXAtYWRkb246bGFzdC1jaGlsZHtib3JkZXItbGVmdDowfS5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLWFkZG9uOmxhc3QtY2hpbGQsLmFudC1pbnB1dC1udW1iZXItZ3JvdXAtYWRkb246bGFzdC1jaGlsZCAuYW50LXNlbGVjdCAuYW50LXNlbGVjdC1zZWxlY3RvciwuYW50LWlucHV0LW51bWJlci1ncm91cD4uYW50LWlucHV0LW51bWJlcjpsYXN0LWNoaWxkLC5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwPi5hbnQtaW5wdXQtbnVtYmVyOmxhc3QtY2hpbGQgLmFudC1zZWxlY3QgLmFudC1zZWxlY3Qtc2VsZWN0b3J7Ym9yZGVyLXRvcC1sZWZ0LXJhZGl1czowO2JvcmRlci1ib3R0b20tbGVmdC1yYWRpdXM6MH0uYW50LWlucHV0LW51bWJlci1ncm91cC1sZyAuYW50LWlucHV0LW51bWJlciwuYW50LWlucHV0LW51bWJlci1ncm91cC1sZz4uYW50LWlucHV0LW51bWJlci1ncm91cC1hZGRvbntwYWRkaW5nOjYuNXB4IDExcHg7Zm9udC1zaXplOjE2cHh9LmFudC1pbnB1dC1udW1iZXItZ3JvdXAtc20gLmFudC1pbnB1dC1udW1iZXIsLmFudC1pbnB1dC1udW1iZXItZ3JvdXAtc20+LmFudC1pbnB1dC1udW1iZXItZ3JvdXAtYWRkb257cGFkZGluZzowIDdweH0uYW50LWlucHV0LW51bWJlci1ncm91cC1sZyAuYW50LXNlbGVjdC1zaW5nbGUgLmFudC1zZWxlY3Qtc2VsZWN0b3J7aGVpZ2h0OjQwcHh9LmFudC1pbnB1dC1udW1iZXItZ3JvdXAtc20gLmFudC1zZWxlY3Qtc2luZ2xlIC5hbnQtc2VsZWN0LXNlbGVjdG9ye2hlaWdodDoyNHB4fS5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwIC5hbnQtaW5wdXQtbnVtYmVyLWFmZml4LXdyYXBwZXI6bm90KDpsYXN0LWNoaWxkKXtib3JkZXItdG9wLXJpZ2h0LXJhZGl1czowO2JvcmRlci1ib3R0b20tcmlnaHQtcmFkaXVzOjB9LmFudC1pbnB1dC1zZWFyY2ggLmFudC1pbnB1dC1udW1iZXItZ3JvdXAgLmFudC1pbnB1dC1udW1iZXItYWZmaXgtd3JhcHBlcjpub3QoOmxhc3QtY2hpbGQpe2JvcmRlci10b3AtbGVmdC1yYWRpdXM6MnB4O2JvcmRlci1ib3R0b20tbGVmdC1yYWRpdXM6MnB4fS5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwIC5hbnQtaW5wdXQtbnVtYmVyLWFmZml4LXdyYXBwZXI6bm90KDpmaXJzdC1jaGlsZCksLmFudC1pbnB1dC1zZWFyY2ggLmFudC1pbnB1dC1udW1iZXItZ3JvdXAgLmFudC1pbnB1dC1udW1iZXItYWZmaXgtd3JhcHBlcjpub3QoOmZpcnN0LWNoaWxkKXtib3JkZXItdG9wLWxlZnQtcmFkaXVzOjA7Ym9yZGVyLWJvdHRvbS1sZWZ0LXJhZGl1czowfS5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLmFudC1pbnB1dC1udW1iZXItZ3JvdXAtY29tcGFjdHtkaXNwbGF5OmJsb2NrfS5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLmFudC1pbnB1dC1udW1iZXItZ3JvdXAtY29tcGFjdDpiZWZvcmV7ZGlzcGxheTp0YWJsZTtjb250ZW50OlwiXCJ9LmFudC1pbnB1dC1udW1iZXItZ3JvdXAuYW50LWlucHV0LW51bWJlci1ncm91cC1jb21wYWN0OmFmdGVye2Rpc3BsYXk6dGFibGU7Y2xlYXI6Ym90aDtjb250ZW50OlwiXCJ9LmFudC1pbnB1dC1udW1iZXItZ3JvdXAuYW50LWlucHV0LW51bWJlci1ncm91cC1jb21wYWN0LWFkZG9uOm5vdCg6Zmlyc3QtY2hpbGQpOm5vdCg6bGFzdC1jaGlsZCksLmFudC1pbnB1dC1udW1iZXItZ3JvdXAuYW50LWlucHV0LW51bWJlci1ncm91cC1jb21wYWN0LXdyYXA6bm90KDpmaXJzdC1jaGlsZCk6bm90KDpsYXN0LWNoaWxkKSwuYW50LWlucHV0LW51bWJlci1ncm91cC5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLWNvbXBhY3Q+LmFudC1pbnB1dC1udW1iZXI6bm90KDpmaXJzdC1jaGlsZCk6bm90KDpsYXN0LWNoaWxkKXtib3JkZXItcmlnaHQtd2lkdGg6MXB4fS5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLmFudC1pbnB1dC1udW1iZXItZ3JvdXAtY29tcGFjdC1hZGRvbjpub3QoOmZpcnN0LWNoaWxkKTpub3QoOmxhc3QtY2hpbGQpOmZvY3VzLC5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLmFudC1pbnB1dC1udW1iZXItZ3JvdXAtY29tcGFjdC1hZGRvbjpub3QoOmZpcnN0LWNoaWxkKTpub3QoOmxhc3QtY2hpbGQpOmhvdmVyLC5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLmFudC1pbnB1dC1udW1iZXItZ3JvdXAtY29tcGFjdC13cmFwOm5vdCg6Zmlyc3QtY2hpbGQpOm5vdCg6bGFzdC1jaGlsZCk6Zm9jdXMsLmFudC1pbnB1dC1udW1iZXItZ3JvdXAuYW50LWlucHV0LW51bWJlci1ncm91cC1jb21wYWN0LXdyYXA6bm90KDpmaXJzdC1jaGlsZCk6bm90KDpsYXN0LWNoaWxkKTpob3ZlciwuYW50LWlucHV0LW51bWJlci1ncm91cC5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLWNvbXBhY3Q+LmFudC1pbnB1dC1udW1iZXI6bm90KDpmaXJzdC1jaGlsZCk6bm90KDpsYXN0LWNoaWxkKTpmb2N1cywuYW50LWlucHV0LW51bWJlci1ncm91cC5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLWNvbXBhY3Q+LmFudC1pbnB1dC1udW1iZXI6bm90KDpmaXJzdC1jaGlsZCk6bm90KDpsYXN0LWNoaWxkKTpob3Zlcnt6LWluZGV4OjF9LmFudC1pbnB1dC1udW1iZXItZ3JvdXAuYW50LWlucHV0LW51bWJlci1ncm91cC1jb21wYWN0Pip7ZGlzcGxheTppbmxpbmUtYmxvY2s7ZmxvYXQ6bm9uZTt2ZXJ0aWNhbC1hbGlnbjp0b3A7Ym9yZGVyLXJhZGl1czowfS5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLmFudC1pbnB1dC1udW1iZXItZ3JvdXAtY29tcGFjdD4uYW50LWlucHV0LW51bWJlci1hZmZpeC13cmFwcGVyLC5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLmFudC1pbnB1dC1udW1iZXItZ3JvdXAtY29tcGFjdD4uYW50LXBpY2tlci1yYW5nZXtkaXNwbGF5OmlubGluZS1mbGV4fS5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLmFudC1pbnB1dC1udW1iZXItZ3JvdXAtY29tcGFjdD46bm90KDpsYXN0LWNoaWxkKXttYXJnaW4tcmlnaHQ6LTFweDtib3JkZXItcmlnaHQtd2lkdGg6MXB4fS5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLmFudC1pbnB1dC1udW1iZXItZ3JvdXAtY29tcGFjdCAuYW50LWlucHV0LW51bWJlcntmbG9hdDpub25lfS5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLmFudC1pbnB1dC1udW1iZXItZ3JvdXAtY29tcGFjdD4uYW50LWNhc2NhZGVyLXBpY2tlciAuYW50LWlucHV0LC5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLmFudC1pbnB1dC1udW1iZXItZ3JvdXAtY29tcGFjdD4uYW50LWlucHV0LWdyb3VwLXdyYXBwZXIgLmFudC1pbnB1dCwuYW50LWlucHV0LW51bWJlci1ncm91cC5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLWNvbXBhY3Q+LmFudC1zZWxlY3QtYXV0by1jb21wbGV0ZSAuYW50LWlucHV0LC5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLmFudC1pbnB1dC1udW1iZXItZ3JvdXAtY29tcGFjdD4uYW50LXNlbGVjdD4uYW50LXNlbGVjdC1zZWxlY3Rvcntib3JkZXItcmlnaHQtd2lkdGg6MXB4O2JvcmRlci1yYWRpdXM6MH0uYW50LWlucHV0LW51bWJlci1ncm91cC5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLWNvbXBhY3Q+LmFudC1jYXNjYWRlci1waWNrZXIgLmFudC1pbnB1dDpmb2N1cywuYW50LWlucHV0LW51bWJlci1ncm91cC5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLWNvbXBhY3Q+LmFudC1jYXNjYWRlci1waWNrZXIgLmFudC1pbnB1dDpob3ZlciwuYW50LWlucHV0LW51bWJlci1ncm91cC5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLWNvbXBhY3Q+LmFudC1pbnB1dC1ncm91cC13cmFwcGVyIC5hbnQtaW5wdXQ6Zm9jdXMsLmFudC1pbnB1dC1udW1iZXItZ3JvdXAuYW50LWlucHV0LW51bWJlci1ncm91cC1jb21wYWN0Pi5hbnQtaW5wdXQtZ3JvdXAtd3JhcHBlciAuYW50LWlucHV0OmhvdmVyLC5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLmFudC1pbnB1dC1udW1iZXItZ3JvdXAtY29tcGFjdD4uYW50LXNlbGVjdC1hdXRvLWNvbXBsZXRlIC5hbnQtaW5wdXQ6Zm9jdXMsLmFudC1pbnB1dC1udW1iZXItZ3JvdXAuYW50LWlucHV0LW51bWJlci1ncm91cC1jb21wYWN0Pi5hbnQtc2VsZWN0LWF1dG8tY29tcGxldGUgLmFudC1pbnB1dDpob3ZlciwuYW50LWlucHV0LW51bWJlci1ncm91cC5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLWNvbXBhY3Q+LmFudC1zZWxlY3QtZm9jdXNlZCwuYW50LWlucHV0LW51bWJlci1ncm91cC5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLWNvbXBhY3Q+LmFudC1zZWxlY3Q+LmFudC1zZWxlY3QtYXJyb3csLmFudC1pbnB1dC1udW1iZXItZ3JvdXAuYW50LWlucHV0LW51bWJlci1ncm91cC1jb21wYWN0Pi5hbnQtc2VsZWN0Pi5hbnQtc2VsZWN0LXNlbGVjdG9yOmZvY3VzLC5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLmFudC1pbnB1dC1udW1iZXItZ3JvdXAtY29tcGFjdD4uYW50LXNlbGVjdD4uYW50LXNlbGVjdC1zZWxlY3Rvcjpob3Zlcnt6LWluZGV4OjF9LmFudC1pbnB1dC1udW1iZXItZ3JvdXAuYW50LWlucHV0LW51bWJlci1ncm91cC1jb21wYWN0Pi5hbnQtY2FzY2FkZXItcGlja2VyOmZpcnN0LWNoaWxkIC5hbnQtaW5wdXQsLmFudC1pbnB1dC1udW1iZXItZ3JvdXAuYW50LWlucHV0LW51bWJlci1ncm91cC1jb21wYWN0Pi5hbnQtc2VsZWN0LWF1dG8tY29tcGxldGU6Zmlyc3QtY2hpbGQgLmFudC1pbnB1dCwuYW50LWlucHV0LW51bWJlci1ncm91cC5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLWNvbXBhY3Q+LmFudC1zZWxlY3Q6Zmlyc3QtY2hpbGQ+LmFudC1zZWxlY3Qtc2VsZWN0b3IsLmFudC1pbnB1dC1udW1iZXItZ3JvdXAuYW50LWlucHV0LW51bWJlci1ncm91cC1jb21wYWN0PjpmaXJzdC1jaGlsZHtib3JkZXItdG9wLWxlZnQtcmFkaXVzOjJweDtib3JkZXItYm90dG9tLWxlZnQtcmFkaXVzOjJweH0uYW50LWlucHV0LW51bWJlci1ncm91cC5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLWNvbXBhY3Q+LmFudC1jYXNjYWRlci1waWNrZXItZm9jdXNlZDpsYXN0LWNoaWxkIC5hbnQtaW5wdXQsLmFudC1pbnB1dC1udW1iZXItZ3JvdXAuYW50LWlucHV0LW51bWJlci1ncm91cC1jb21wYWN0Pi5hbnQtY2FzY2FkZXItcGlja2VyOmxhc3QtY2hpbGQgLmFudC1pbnB1dCwuYW50LWlucHV0LW51bWJlci1ncm91cC5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLWNvbXBhY3Q+LmFudC1zZWxlY3Q6bGFzdC1jaGlsZD4uYW50LXNlbGVjdC1zZWxlY3RvciwuYW50LWlucHV0LW51bWJlci1ncm91cC5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLWNvbXBhY3Q+Omxhc3QtY2hpbGR7Ym9yZGVyLXJpZ2h0LXdpZHRoOjFweDtib3JkZXItdG9wLXJpZ2h0LXJhZGl1czoycHg7Ym9yZGVyLWJvdHRvbS1yaWdodC1yYWRpdXM6MnB4fS5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLmFudC1pbnB1dC1udW1iZXItZ3JvdXAtY29tcGFjdD4uYW50LXNlbGVjdC1hdXRvLWNvbXBsZXRlIC5hbnQtaW5wdXR7dmVydGljYWwtYWxpZ246dG9wfS5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLmFudC1pbnB1dC1udW1iZXItZ3JvdXAtY29tcGFjdCAuYW50LWlucHV0LWdyb3VwLXdyYXBwZXIrLmFudC1pbnB1dC1ncm91cC13cmFwcGVye21hcmdpbi1sZWZ0Oi0xcHh9LmFudC1pbnB1dC1udW1iZXItZ3JvdXAuYW50LWlucHV0LW51bWJlci1ncm91cC1jb21wYWN0IC5hbnQtaW5wdXQtZ3JvdXAtd3JhcHBlcisuYW50LWlucHV0LWdyb3VwLXdyYXBwZXIgLmFudC1pbnB1dC1hZmZpeC13cmFwcGVyLC5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLmFudC1pbnB1dC1udW1iZXItZ3JvdXAtY29tcGFjdCAuYW50LWlucHV0LWdyb3VwLXdyYXBwZXI6bm90KDpsYXN0LWNoaWxkKS5hbnQtaW5wdXQtc2VhcmNoPi5hbnQtaW5wdXQtZ3JvdXA+LmFudC1pbnB1dC1ncm91cC1hZGRvbj4uYW50LWlucHV0LXNlYXJjaC1idXR0b257Ym9yZGVyLXJhZGl1czowfS5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLmFudC1pbnB1dC1udW1iZXItZ3JvdXAtY29tcGFjdCAuYW50LWlucHV0LWdyb3VwLXdyYXBwZXI6bm90KDpsYXN0LWNoaWxkKS5hbnQtaW5wdXQtc2VhcmNoPi5hbnQtaW5wdXQtZ3JvdXA+LmFudC1pbnB1dHtib3JkZXItcmFkaXVzOjJweCAwIDAgMnB4fS5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwPi5hbnQtaW5wdXQtbnVtYmVyLXJ0bDpmaXJzdC1jaGlsZHtib3JkZXItcmFkaXVzOjAgMnB4IDJweCAwfS5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwPi5hbnQtaW5wdXQtbnVtYmVyLXJ0bDpsYXN0LWNoaWxke2JvcmRlci1yYWRpdXM6MnB4IDAgMCAycHh9LmFudC1pbnB1dC1udW1iZXItZ3JvdXAtcnRsIC5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLWFkZG9uOmZpcnN0LWNoaWxke2JvcmRlci1yaWdodDoxcHggc29saWQgI2Q5ZDlkOTtib3JkZXItbGVmdDowO2JvcmRlci1yYWRpdXM6MCAycHggMnB4IDB9LmFudC1pbnB1dC1udW1iZXItZ3JvdXAtcnRsIC5hbnQtaW5wdXQtbnVtYmVyLWdyb3VwLWFkZG9uOmxhc3QtY2hpbGR7Ym9yZGVyLXJpZ2h0OjA7Ym9yZGVyLWxlZnQ6MXB4IHNvbGlkICNkOWQ5ZDk7Ym9yZGVyLXJhZGl1czoycHggMCAwIDJweH0uYW50LWlucHV0LW51bWJlci1ncm91cC13cmFwcGVye2Rpc3BsYXk6aW5saW5lLWJsb2NrO3RleHQtYWxpZ246c3RhcnQ7dmVydGljYWwtYWxpZ246dG9wfS5hbnQtaW5wdXQtbnVtYmVyLWhhbmRsZXJ7cG9zaXRpb246cmVsYXRpdmU7ZGlzcGxheTpibG9jazt3aWR0aDoxMDAlO2hlaWdodDo1MCU7b3ZlcmZsb3c6aGlkZGVuO2NvbG9yOnJnYmEoMCwwLDAsLjQ1KTtmb250LXdlaWdodDo3MDA7bGluZS1oZWlnaHQ6MDt0ZXh0LWFsaWduOmNlbnRlcjtib3JkZXItbGVmdDoxcHggc29saWQgI2Q5ZDlkOTt0cmFuc2l0aW9uOmFsbCAuMXMgbGluZWFyfS5hbnQtaW5wdXQtbnVtYmVyLWhhbmRsZXI6YWN0aXZle2JhY2tncm91bmQ6I2Y0ZjRmNH0uYW50LWlucHV0LW51bWJlci1oYW5kbGVyOmhvdmVyIC5hbnQtaW5wdXQtbnVtYmVyLWhhbmRsZXItZG93bi1pbm5lciwuYW50LWlucHV0LW51bWJlci1oYW5kbGVyOmhvdmVyIC5hbnQtaW5wdXQtbnVtYmVyLWhhbmRsZXItdXAtaW5uZXJ7Y29sb3I6IzQwYTlmZn0uYW50LWlucHV0LW51bWJlci1oYW5kbGVyLWRvd24taW5uZXIsLmFudC1pbnB1dC1udW1iZXItaGFuZGxlci11cC1pbm5lcntkaXNwbGF5OmlubGluZS1ibG9jaztjb2xvcjppbmhlcml0O2ZvbnQtc3R5bGU6bm9ybWFsO2xpbmUtaGVpZ2h0OjA7dGV4dC1hbGlnbjpjZW50ZXI7dGV4dC10cmFuc2Zvcm06bm9uZTt2ZXJ0aWNhbC1hbGlnbjotLjEyNWVtO3RleHQtcmVuZGVyaW5nOm9wdGltaXplbGVnaWJpbGl0eTstd2Via2l0LWZvbnQtc21vb3RoaW5nOmFudGlhbGlhc2VkOy1tb3otb3N4LWZvbnQtc21vb3RoaW5nOmdyYXlzY2FsZTtwb3NpdGlvbjphYnNvbHV0ZTtyaWdodDo0cHg7d2lkdGg6MTJweDtoZWlnaHQ6MTJweDtjb2xvcjpyZ2JhKDAsMCwwLC40NSk7bGluZS1oZWlnaHQ6MTJweDt0cmFuc2l0aW9uOmFsbCAuMXMgbGluZWFyOy13ZWJraXQtdXNlci1zZWxlY3Q6bm9uZTstbW96LXVzZXItc2VsZWN0Om5vbmU7LW1zLXVzZXItc2VsZWN0Om5vbmU7dXNlci1zZWxlY3Q6bm9uZX0uYW50LWlucHV0LW51bWJlci1oYW5kbGVyLWRvd24taW5uZXI+KiwuYW50LWlucHV0LW51bWJlci1oYW5kbGVyLXVwLWlubmVyPip7bGluZS1oZWlnaHQ6MX0uYW50LWlucHV0LW51bWJlci1oYW5kbGVyLWRvd24taW5uZXIgc3ZnLC5hbnQtaW5wdXQtbnVtYmVyLWhhbmRsZXItdXAtaW5uZXIgc3Zne2Rpc3BsYXk6aW5saW5lLWJsb2NrfS5hbnQtaW5wdXQtbnVtYmVyLWhhbmRsZXItZG93bi1pbm5lcjpiZWZvcmUsLmFudC1pbnB1dC1udW1iZXItaGFuZGxlci11cC1pbm5lcjpiZWZvcmV7ZGlzcGxheTpub25lfS5hbnQtaW5wdXQtbnVtYmVyLWhhbmRsZXItZG93bi1pbm5lciAuYW50LWlucHV0LW51bWJlci1oYW5kbGVyLWRvd24taW5uZXItaWNvbiwuYW50LWlucHV0LW51bWJlci1oYW5kbGVyLWRvd24taW5uZXIgLmFudC1pbnB1dC1udW1iZXItaGFuZGxlci11cC1pbm5lci1pY29uLC5hbnQtaW5wdXQtbnVtYmVyLWhhbmRsZXItdXAtaW5uZXIgLmFudC1pbnB1dC1udW1iZXItaGFuZGxlci1kb3duLWlubmVyLWljb24sLmFudC1pbnB1dC1udW1iZXItaGFuZGxlci11cC1pbm5lciAuYW50LWlucHV0LW51bWJlci1oYW5kbGVyLXVwLWlubmVyLWljb257ZGlzcGxheTpibG9ja30uYW50LWlucHV0LW51bWJlcjpob3Zlcntib3JkZXItY29sb3I6IzQwYTlmZjtib3JkZXItcmlnaHQtd2lkdGg6MXB4fS5hbnQtaW5wdXQtbnVtYmVyOmhvdmVyKy5hbnQtZm9ybS1pdGVtLWNoaWxkcmVuLWljb257b3BhY2l0eTowO3RyYW5zaXRpb246b3BhY2l0eSAuMjRzIGxpbmVhciAuMjRzfS5hbnQtaW5wdXQtbnVtYmVyLWZvY3VzZWR7Ym9yZGVyLWNvbG9yOiM0MGE5ZmY7Ym94LXNoYWRvdzowIDAgMCAycHggcmdiYSgyNCwxNDQsMjU1LC4yKTtib3JkZXItcmlnaHQtd2lkdGg6MXB4O291dGxpbmU6MH0uYW50LWlucHV0LW51bWJlci1kaXNhYmxlZHtjb2xvcjpyZ2JhKDAsMCwwLC4yNSk7YmFja2dyb3VuZC1jb2xvcjojZjVmNWY1O2JvcmRlci1jb2xvcjojZDlkOWQ5O2JveC1zaGFkb3c6bm9uZTtjdXJzb3I6bm90LWFsbG93ZWQ7b3BhY2l0eToxfS5hbnQtaW5wdXQtbnVtYmVyLWRpc2FibGVkOmhvdmVye2JvcmRlci1jb2xvcjojZDlkOWQ5O2JvcmRlci1yaWdodC13aWR0aDoxcHh9LmFudC1pbnB1dC1udW1iZXItZGlzYWJsZWQgLmFudC1pbnB1dC1udW1iZXItaW5wdXR7Y3Vyc29yOm5vdC1hbGxvd2VkfS5hbnQtaW5wdXQtbnVtYmVyLWRpc2FibGVkIC5hbnQtaW5wdXQtbnVtYmVyLWhhbmRsZXItd3JhcCwuYW50LWlucHV0LW51bWJlci1yZWFkb25seSAuYW50LWlucHV0LW51bWJlci1oYW5kbGVyLXdyYXB7ZGlzcGxheTpub25lfS5hbnQtaW5wdXQtbnVtYmVyLWlucHV0e3dpZHRoOjEwMCU7aGVpZ2h0OjMwcHg7cGFkZGluZzowIDExcHg7dGV4dC1hbGlnbjpsZWZ0O2JhY2tncm91bmQtY29sb3I6dHJhbnNwYXJlbnQ7Ym9yZGVyOjA7Ym9yZGVyLXJhZGl1czoycHg7b3V0bGluZTowO3RyYW5zaXRpb246YWxsIC4zcyBsaW5lYXI7LXdlYmtpdC1hcHBlYXJhbmNlOnRleHRmaWVsZCFpbXBvcnRhbnQ7LW1vei1hcHBlYXJhbmNlOnRleHRmaWVsZCFpbXBvcnRhbnQ7YXBwZWFyYW5jZTp0ZXh0ZmllbGQhaW1wb3J0YW50fS5hbnQtaW5wdXQtbnVtYmVyLWlucHV0OjotbW96LXBsYWNlaG9sZGVye2NvbG9yOiNiZmJmYmY7LW1vei11c2VyLXNlbGVjdDpub25lO3VzZXItc2VsZWN0Om5vbmV9LmFudC1pbnB1dC1udW1iZXItaW5wdXQ6LW1zLWlucHV0LXBsYWNlaG9sZGVye2NvbG9yOiNiZmJmYmY7LW1zLXVzZXItc2VsZWN0Om5vbmU7dXNlci1zZWxlY3Q6bm9uZX0uYW50LWlucHV0LW51bWJlci1pbnB1dDo6cGxhY2Vob2xkZXJ7Y29sb3I6I2JmYmZiZjstd2Via2l0LXVzZXItc2VsZWN0Om5vbmU7LW1vei11c2VyLXNlbGVjdDpub25lOy1tcy11c2VyLXNlbGVjdDpub25lO3VzZXItc2VsZWN0Om5vbmV9LmFudC1pbnB1dC1udW1iZXItaW5wdXQ6LW1vei1wbGFjZWhvbGRlci1zaG93bnt0ZXh0LW92ZXJmbG93OmVsbGlwc2lzfS5hbnQtaW5wdXQtbnVtYmVyLWlucHV0Oi1tcy1pbnB1dC1wbGFjZWhvbGRlcnt0ZXh0LW92ZXJmbG93OmVsbGlwc2lzfS5hbnQtaW5wdXQtbnVtYmVyLWlucHV0OnBsYWNlaG9sZGVyLXNob3due3RleHQtb3ZlcmZsb3c6ZWxsaXBzaXN9LmFudC1pbnB1dC1udW1iZXItaW5wdXRbdHlwZT1udW1iZXJdOjotd2Via2l0LWlubmVyLXNwaW4tYnV0dG9uLC5hbnQtaW5wdXQtbnVtYmVyLWlucHV0W3R5cGU9bnVtYmVyXTo6LXdlYmtpdC1vdXRlci1zcGluLWJ1dHRvbnttYXJnaW46MDstd2Via2l0LWFwcGVhcmFuY2U6bm9uZTthcHBlYXJhbmNlOm5vbmV9LmFudC1pbnB1dC1udW1iZXItbGd7cGFkZGluZzowO2ZvbnQtc2l6ZToxNnB4fS5hbnQtaW5wdXQtbnVtYmVyLWxnIGlucHV0e2hlaWdodDozOHB4fS5hbnQtaW5wdXQtbnVtYmVyLXNte3BhZGRpbmc6MH0uYW50LWlucHV0LW51bWJlci1zbSBpbnB1dHtoZWlnaHQ6MjJweDtwYWRkaW5nOjAgN3B4fS5hbnQtaW5wdXQtbnVtYmVyLWhhbmRsZXItd3JhcHtwb3NpdGlvbjphYnNvbHV0ZTt0b3A6MDtyaWdodDowO3dpZHRoOjIycHg7aGVpZ2h0OjEwMCU7YmFja2dyb3VuZDojZmZmO2JvcmRlci1yYWRpdXM6MCAycHggMnB4IDA7b3BhY2l0eTowO3RyYW5zaXRpb246b3BhY2l0eSAuMjRzIGxpbmVhciAuMXN9LmFudC1pbnB1dC1udW1iZXItaGFuZGxlci13cmFwIC5hbnQtaW5wdXQtbnVtYmVyLWhhbmRsZXIgLmFudC1pbnB1dC1udW1iZXItaGFuZGxlci1kb3duLWlubmVyLC5hbnQtaW5wdXQtbnVtYmVyLWhhbmRsZXItd3JhcCAuYW50LWlucHV0LW51bWJlci1oYW5kbGVyIC5hbnQtaW5wdXQtbnVtYmVyLWhhbmRsZXItdXAtaW5uZXJ7ZGlzcGxheTpmbGV4O2FsaWduLWl0ZW1zOmNlbnRlcjtqdXN0aWZ5LWNvbnRlbnQ6Y2VudGVyO21pbi13aWR0aDphdXRvO21hcmdpbi1yaWdodDowO2ZvbnQtc2l6ZTo3cHh9LmFudC1pbnB1dC1udW1iZXItYm9yZGVybGVzcyAuYW50LWlucHV0LW51bWJlci1oYW5kbGVyLXdyYXB7Ym9yZGVyLWxlZnQtd2lkdGg6MH0uYW50LWlucHV0LW51bWJlci1oYW5kbGVyLXdyYXA6aG92ZXIgLmFudC1pbnB1dC1udW1iZXItaGFuZGxlcntoZWlnaHQ6NDAlfS5hbnQtaW5wdXQtbnVtYmVyLWZvY3VzZWQgLmFudC1pbnB1dC1udW1iZXItaGFuZGxlci13cmFwLC5hbnQtaW5wdXQtbnVtYmVyOmhvdmVyIC5hbnQtaW5wdXQtbnVtYmVyLWhhbmRsZXItd3JhcHtvcGFjaXR5OjF9LmFudC1pbnB1dC1udW1iZXItaGFuZGxlci11cHtib3JkZXItdG9wLXJpZ2h0LXJhZGl1czoycHg7Y3Vyc29yOnBvaW50ZXJ9LmFudC1pbnB1dC1udW1iZXItaGFuZGxlci11cC1pbm5lcnt0b3A6NTAlO21hcmdpbi10b3A6LTVweDt0ZXh0LWFsaWduOmNlbnRlcn0uYW50LWlucHV0LW51bWJlci1oYW5kbGVyLXVwOmhvdmVye2hlaWdodDo2MCUhaW1wb3J0YW50fS5hbnQtaW5wdXQtbnVtYmVyLWhhbmRsZXItZG93bnt0b3A6MDtib3JkZXItdG9wOjFweCBzb2xpZCAjZDlkOWQ5O2JvcmRlci1ib3R0b20tcmlnaHQtcmFkaXVzOjJweDtjdXJzb3I6cG9pbnRlcn0uYW50LWlucHV0LW51bWJlci1oYW5kbGVyLWRvd24taW5uZXJ7dG9wOjUwJTt0ZXh0LWFsaWduOmNlbnRlcjt0cmFuc2Zvcm06dHJhbnNsYXRlWSgtNTAlKX0uYW50LWlucHV0LW51bWJlci1oYW5kbGVyLWRvd246aG92ZXJ7aGVpZ2h0OjYwJSFpbXBvcnRhbnR9LmFudC1pbnB1dC1udW1iZXItYm9yZGVybGVzcyAuYW50LWlucHV0LW51bWJlci1oYW5kbGVyLWRvd257Ym9yZGVyLXRvcC13aWR0aDowfS5hbnQtaW5wdXQtbnVtYmVyLWZvY3VzZWQ6bm90KC5hbnQtaW5wdXQtbnVtYmVyLWJvcmRlcmxlc3MpIC5hbnQtaW5wdXQtbnVtYmVyLWhhbmRsZXItZG93biwuYW50LWlucHV0LW51bWJlcjpob3Zlcjpub3QoLmFudC1pbnB1dC1udW1iZXItYm9yZGVybGVzcykgLmFudC1pbnB1dC1udW1iZXItaGFuZGxlci1kb3due2JvcmRlci10b3A6MXB4IHNvbGlkICNkOWQ5ZDl9LmFudC1pbnB1dC1udW1iZXItaGFuZGxlci1kb3duLWRpc2FibGVkLC5hbnQtaW5wdXQtbnVtYmVyLWhhbmRsZXItdXAtZGlzYWJsZWR7Y3Vyc29yOm5vdC1hbGxvd2VkfS5hbnQtaW5wdXQtbnVtYmVyLWhhbmRsZXItZG93bi1kaXNhYmxlZDpob3ZlciAuYW50LWlucHV0LW51bWJlci1oYW5kbGVyLWRvd24taW5uZXIsLmFudC1pbnB1dC1udW1iZXItaGFuZGxlci11cC1kaXNhYmxlZDpob3ZlciAuYW50LWlucHV0LW51bWJlci1oYW5kbGVyLXVwLWlubmVye2NvbG9yOnJnYmEoMCwwLDAsLjI1KX0uYW50LWlucHV0LW51bWJlci1ib3JkZXJsZXNze2JveC1zaGFkb3c6bm9uZX0uYW50LWlucHV0LW51bWJlci1vdXQtb2YtcmFuZ2UgaW5wdXR7Y29sb3I6I2ZmNGQ0Zn0uYW50LWlucHV0LW51bWJlci1jb21wYWN0LWl0ZW06bm90KC5hbnQtaW5wdXQtbnVtYmVyLWNvbXBhY3QtbGFzdC1pdGVtKTpub3QoLmFudC1pbnB1dC1udW1iZXItY29tcGFjdC1pdGVtLXJ0bCl7bWFyZ2luLXJpZ2h0Oi0xcHh9LmFudC1pbnB1dC1udW1iZXItY29tcGFjdC1pdGVtOm5vdCguYW50LWlucHV0LW51bWJlci1jb21wYWN0LWxhc3QtaXRlbSkuYW50LWlucHV0LW51bWJlci1jb21wYWN0LWl0ZW0tcnRse21hcmdpbi1sZWZ0Oi0xcHh9LmFudC1pbnB1dC1udW1iZXItY29tcGFjdC1pdGVtLmFudC1pbnB1dC1udW1iZXItZm9jdXNlZCwuYW50LWlucHV0LW51bWJlci1jb21wYWN0LWl0ZW06YWN0aXZlLC5hbnQtaW5wdXQtbnVtYmVyLWNvbXBhY3QtaXRlbTpmb2N1cywuYW50LWlucHV0LW51bWJlci1jb21wYWN0LWl0ZW06aG92ZXJ7ei1pbmRleDoyfS5hbnQtaW5wdXQtbnVtYmVyLWNvbXBhY3QtaXRlbVtkaXNhYmxlZF17ei1pbmRleDowfS5hbnQtaW5wdXQtbnVtYmVyLWNvbXBhY3QtaXRlbTpub3QoLmFudC1pbnB1dC1udW1iZXItY29tcGFjdC1maXJzdC1pdGVtKTpub3QoLmFudC1pbnB1dC1udW1iZXItY29tcGFjdC1sYXN0LWl0ZW0pLmFudC1pbnB1dC1udW1iZXJ7Ym9yZGVyLXJhZGl1czowfS5hbnQtaW5wdXQtbnVtYmVyLWNvbXBhY3QtaXRlbS5hbnQtaW5wdXQtbnVtYmVyLmFudC1pbnB1dC1udW1iZXItY29tcGFjdC1maXJzdC1pdGVtOm5vdCguYW50LWlucHV0LW51bWJlci1jb21wYWN0LWxhc3QtaXRlbSk6bm90KC5hbnQtaW5wdXQtbnVtYmVyLWNvbXBhY3QtaXRlbS1ydGwpe2JvcmRlci10b3AtcmlnaHQtcmFkaXVzOjA7Ym9yZGVyLWJvdHRvbS1yaWdodC1yYWRpdXM6MH0uYW50LWlucHV0LW51bWJlci1jb21wYWN0LWl0ZW0uYW50LWlucHV0LW51bWJlci5hbnQtaW5wdXQtbnVtYmVyLWNvbXBhY3QtaXRlbS1ydGwuYW50LWlucHV0LW51bWJlci1jb21wYWN0LWZpcnN0LWl0ZW06bm90KC5hbnQtaW5wdXQtbnVtYmVyLWNvbXBhY3QtbGFzdC1pdGVtKSwuYW50LWlucHV0LW51bWJlci1jb21wYWN0LWl0ZW0uYW50LWlucHV0LW51bWJlci5hbnQtaW5wdXQtbnVtYmVyLWNvbXBhY3QtbGFzdC1pdGVtOm5vdCguYW50LWlucHV0LW51bWJlci1jb21wYWN0LWZpcnN0LWl0ZW0pOm5vdCguYW50LWlucHV0LW51bWJlci1jb21wYWN0LWl0ZW0tcnRsKXtib3JkZXItdG9wLWxlZnQtcmFkaXVzOjA7Ym9yZGVyLWJvdHRvbS1sZWZ0LXJhZGl1czowfS5hbnQtaW5wdXQtbnVtYmVyLWNvbXBhY3QtaXRlbS5hbnQtaW5wdXQtbnVtYmVyLmFudC1pbnB1dC1udW1iZXItY29tcGFjdC1pdGVtLXJ0bC5hbnQtaW5wdXQtbnVtYmVyLWNvbXBhY3QtbGFzdC1pdGVtOm5vdCguYW50LWlucHV0LW51bWJlci1jb21wYWN0LWZpcnN0LWl0ZW0pe2JvcmRlci10b3AtcmlnaHQtcmFkaXVzOjA7Ym9yZGVyLWJvdHRvbS1yaWdodC1yYWRpdXM6MH0uYW50LWlucHV0LW51bWJlci1ydGx7ZGlyZWN0aW9uOnJ0bH0uYW50LWlucHV0LW51bWJlci1ydGwgLmFudC1pbnB1dC1udW1iZXItaGFuZGxlcntib3JkZXItcmlnaHQ6MXB4IHNvbGlkICNkOWQ5ZDk7Ym9yZGVyLWxlZnQ6MH0uYW50LWlucHV0LW51bWJlci1ydGwgLmFudC1pbnB1dC1udW1iZXItaGFuZGxlci13cmFwe3JpZ2h0OmF1dG87bGVmdDowfS5hbnQtaW5wdXQtbnVtYmVyLXJ0bC5hbnQtaW5wdXQtbnVtYmVyLWJvcmRlcmxlc3MgLmFudC1pbnB1dC1udW1iZXItaGFuZGxlci13cmFwe2JvcmRlci1yaWdodC13aWR0aDowfS5hbnQtaW5wdXQtbnVtYmVyLXJ0bCAuYW50LWlucHV0LW51bWJlci1oYW5kbGVyLXVwe2JvcmRlci10b3AtcmlnaHQtcmFkaXVzOjB9LmFudC1pbnB1dC1udW1iZXItcnRsIC5hbnQtaW5wdXQtbnVtYmVyLWhhbmRsZXItZG93bntib3JkZXItYm90dG9tLXJpZ2h0LXJhZGl1czowfS5hbnQtaW5wdXQtbnVtYmVyLXJ0bCAuYW50LWlucHV0LW51bWJlci1pbnB1dHtkaXJlY3Rpb246bHRyO3RleHQtYWxpZ246cmlnaHR9LmFudC1pbnB1dC1hZmZpeC13cmFwcGVye3Bvc2l0aW9uOnJlbGF0aXZlO2Rpc3BsYXk6aW5saW5lLWJsb2NrO3dpZHRoOjEwMCU7bWluLXdpZHRoOjA7cGFkZGluZzo0cHggMTFweDtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7Zm9udC1zaXplOjE0cHg7bGluZS1oZWlnaHQ6MS41NzE1O2JhY2tncm91bmQtY29sb3I6I2ZmZjtiYWNrZ3JvdW5kLWltYWdlOm5vbmU7Ym9yZGVyOjFweCBzb2xpZCAjZDlkOWQ5O2JvcmRlci1yYWRpdXM6MnB4O3RyYW5zaXRpb246YWxsIC4zcztkaXNwbGF5OmlubGluZS1mbGV4fS5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlcjo6LW1vei1wbGFjZWhvbGRlcntjb2xvcjojYmZiZmJmOy1tb3otdXNlci1zZWxlY3Q6bm9uZTt1c2VyLXNlbGVjdDpub25lfS5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlcjotbXMtaW5wdXQtcGxhY2Vob2xkZXJ7Y29sb3I6I2JmYmZiZjstbXMtdXNlci1zZWxlY3Q6bm9uZTt1c2VyLXNlbGVjdDpub25lfS5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlcjo6cGxhY2Vob2xkZXJ7Y29sb3I6I2JmYmZiZjstd2Via2l0LXVzZXItc2VsZWN0Om5vbmU7LW1vei11c2VyLXNlbGVjdDpub25lOy1tcy11c2VyLXNlbGVjdDpub25lO3VzZXItc2VsZWN0Om5vbmV9LmFudC1pbnB1dC1hZmZpeC13cmFwcGVyOi1tb3otcGxhY2Vob2xkZXItc2hvd257dGV4dC1vdmVyZmxvdzplbGxpcHNpc30uYW50LWlucHV0LWFmZml4LXdyYXBwZXI6LW1zLWlucHV0LXBsYWNlaG9sZGVye3RleHQtb3ZlcmZsb3c6ZWxsaXBzaXN9LmFudC1pbnB1dC1hZmZpeC13cmFwcGVyOnBsYWNlaG9sZGVyLXNob3due3RleHQtb3ZlcmZsb3c6ZWxsaXBzaXN9LmFudC1pbnB1dC1hZmZpeC13cmFwcGVyOmhvdmVye2JvcmRlci1jb2xvcjojNDBhOWZmO2JvcmRlci1yaWdodC13aWR0aDoxcHh9LmFudC1pbnB1dC1ydGwgLmFudC1pbnB1dC1hZmZpeC13cmFwcGVyOmhvdmVye2JvcmRlci1yaWdodC13aWR0aDowO2JvcmRlci1sZWZ0LXdpZHRoOjFweCFpbXBvcnRhbnR9LmFudC1pbnB1dC1hZmZpeC13cmFwcGVyLWZvY3VzZWQsLmFudC1pbnB1dC1hZmZpeC13cmFwcGVyOmZvY3Vze2JvcmRlci1jb2xvcjojNDBhOWZmO2JveC1zaGFkb3c6MCAwIDAgMnB4IHJnYmEoMjQsMTQ0LDI1NSwuMik7Ym9yZGVyLXJpZ2h0LXdpZHRoOjFweDtvdXRsaW5lOjB9LmFudC1pbnB1dC1ydGwgLmFudC1pbnB1dC1hZmZpeC13cmFwcGVyLWZvY3VzZWQsLmFudC1pbnB1dC1ydGwgLmFudC1pbnB1dC1hZmZpeC13cmFwcGVyOmZvY3Vze2JvcmRlci1yaWdodC13aWR0aDowO2JvcmRlci1sZWZ0LXdpZHRoOjFweCFpbXBvcnRhbnR9LmFudC1pbnB1dC1hZmZpeC13cmFwcGVyLWRpc2FibGVke2NvbG9yOnJnYmEoMCwwLDAsLjI1KTtiYWNrZ3JvdW5kLWNvbG9yOiNmNWY1ZjU7Ym9yZGVyLWNvbG9yOiNkOWQ5ZDk7Ym94LXNoYWRvdzpub25lO2N1cnNvcjpub3QtYWxsb3dlZDtvcGFjaXR5OjF9LmFudC1pbnB1dC1hZmZpeC13cmFwcGVyLWRpc2FibGVkOmhvdmVye2JvcmRlci1jb2xvcjojZDlkOWQ5O2JvcmRlci1yaWdodC13aWR0aDoxcHh9LmFudC1pbnB1dC1hZmZpeC13cmFwcGVyW2Rpc2FibGVkXXtjb2xvcjpyZ2JhKDAsMCwwLC4yNSk7YmFja2dyb3VuZC1jb2xvcjojZjVmNWY1O2JvcmRlci1jb2xvcjojZDlkOWQ5O2JveC1zaGFkb3c6bm9uZTtjdXJzb3I6bm90LWFsbG93ZWQ7b3BhY2l0eToxfS5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlcltkaXNhYmxlZF06aG92ZXJ7Ym9yZGVyLWNvbG9yOiNkOWQ5ZDk7Ym9yZGVyLXJpZ2h0LXdpZHRoOjFweH0uYW50LWlucHV0LWFmZml4LXdyYXBwZXItYm9yZGVybGVzcywuYW50LWlucHV0LWFmZml4LXdyYXBwZXItYm9yZGVybGVzcy1kaXNhYmxlZCwuYW50LWlucHV0LWFmZml4LXdyYXBwZXItYm9yZGVybGVzcy1mb2N1c2VkLC5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlci1ib3JkZXJsZXNzOmZvY3VzLC5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlci1ib3JkZXJsZXNzOmhvdmVyLC5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlci1ib3JkZXJsZXNzW2Rpc2FibGVkXXtiYWNrZ3JvdW5kLWNvbG9yOnRyYW5zcGFyZW50O2JvcmRlcjpub25lO2JveC1zaGFkb3c6bm9uZX10ZXh0YXJlYS5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlcnttYXgtd2lkdGg6MTAwJTtoZWlnaHQ6YXV0bzttaW4taGVpZ2h0OjMycHg7bGluZS1oZWlnaHQ6MS41NzE1O3ZlcnRpY2FsLWFsaWduOmJvdHRvbTt0cmFuc2l0aW9uOmFsbCAuM3MsaGVpZ2h0IDBzfS5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlci1sZ3twYWRkaW5nOjYuNXB4IDExcHg7Zm9udC1zaXplOjE2cHh9LmFudC1pbnB1dC1hZmZpeC13cmFwcGVyLXNte3BhZGRpbmc6MCA3cHh9LmFudC1pbnB1dC1hZmZpeC13cmFwcGVyLXJ0bHtkaXJlY3Rpb246cnRsfS5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlcjpub3QoLmFudC1pbnB1dC1hZmZpeC13cmFwcGVyLWRpc2FibGVkKTpob3Zlcntib3JkZXItY29sb3I6IzQwYTlmZjtib3JkZXItcmlnaHQtd2lkdGg6MXB4O3otaW5kZXg6MX0uYW50LWlucHV0LXJ0bCAuYW50LWlucHV0LWFmZml4LXdyYXBwZXI6bm90KC5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlci1kaXNhYmxlZCk6aG92ZXJ7Ym9yZGVyLXJpZ2h0LXdpZHRoOjA7Ym9yZGVyLWxlZnQtd2lkdGg6MXB4IWltcG9ydGFudH0uYW50LWlucHV0LXNlYXJjaC13aXRoLWJ1dHRvbiAuYW50LWlucHV0LWFmZml4LXdyYXBwZXI6bm90KC5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlci1kaXNhYmxlZCk6aG92ZXJ7ei1pbmRleDowfS5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlci1mb2N1c2VkLC5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlcjpmb2N1c3t6LWluZGV4OjF9LmFudC1pbnB1dC1hZmZpeC13cmFwcGVyLWRpc2FibGVkIC5hbnQtaW5wdXRbZGlzYWJsZWRde2JhY2tncm91bmQ6aHNsYSgwLDAlLDEwMCUsMCl9LmFudC1pbnB1dC1hZmZpeC13cmFwcGVyPi5hbnQtaW5wdXR7Zm9udC1zaXplOmluaGVyaXQ7Ym9yZGVyOm5vbmU7b3V0bGluZTpub25lfS5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlcj4uYW50LWlucHV0OmZvY3Vze2JveC1zaGFkb3c6bm9uZSFpbXBvcnRhbnR9LmFudC1pbnB1dC1hZmZpeC13cmFwcGVyPi5hbnQtaW5wdXQ6bm90KHRleHRhcmVhKXtwYWRkaW5nOjB9LmFudC1pbnB1dC1hZmZpeC13cmFwcGVyOmJlZm9yZXt3aWR0aDowO3Zpc2liaWxpdHk6aGlkZGVuO2NvbnRlbnQ6XCJcXGEwXCJ9LmFudC1pbnB1dC1wcmVmaXgsLmFudC1pbnB1dC1zdWZmaXh7ZGlzcGxheTpmbGV4O2ZsZXg6bm9uZTthbGlnbi1pdGVtczpjZW50ZXJ9LmFudC1pbnB1dC1wcmVmaXg+Om5vdCg6bGFzdC1jaGlsZCksLmFudC1pbnB1dC1zdWZmaXg+Om5vdCg6bGFzdC1jaGlsZCl7bWFyZ2luLXJpZ2h0OjhweH0uYW50LWlucHV0LXNob3ctY291bnQtc3VmZml4e2NvbG9yOnJnYmEoMCwwLDAsLjQ1KX0uYW50LWlucHV0LXNob3ctY291bnQtaGFzLXN1ZmZpeHttYXJnaW4tcmlnaHQ6MnB4fS5hbnQtaW5wdXQtcHJlZml4e21hcmdpbi1yaWdodDo0cHh9LmFudC1pbnB1dC1zdWZmaXh7bWFyZ2luLWxlZnQ6NHB4fS5hbnQtaW5wdXQtY2xlYXItaWNvbiwuYW50aWNvbi5hbnQtaW5wdXQtY2xlYXItaWNvbnttYXJnaW46MDtjb2xvcjpyZ2JhKDAsMCwwLC4yNSk7Zm9udC1zaXplOjEycHg7dmVydGljYWwtYWxpZ246LTFweDtjdXJzb3I6cG9pbnRlcjt0cmFuc2l0aW9uOmNvbG9yIC4zc30uYW50LWlucHV0LWNsZWFyLWljb246aG92ZXIsLmFudGljb24uYW50LWlucHV0LWNsZWFyLWljb246aG92ZXJ7Y29sb3I6cmdiYSgwLDAsMCwuNDUpfS5hbnQtaW5wdXQtY2xlYXItaWNvbjphY3RpdmUsLmFudGljb24uYW50LWlucHV0LWNsZWFyLWljb246YWN0aXZle2NvbG9yOnJnYmEoMCwwLDAsLjg1KX0uYW50LWlucHV0LWNsZWFyLWljb24taGlkZGVuLC5hbnRpY29uLmFudC1pbnB1dC1jbGVhci1pY29uLWhpZGRlbnt2aXNpYmlsaXR5OmhpZGRlbn0uYW50LWlucHV0LWNsZWFyLWljb24taGFzLXN1ZmZpeCwuYW50aWNvbi5hbnQtaW5wdXQtY2xlYXItaWNvbi1oYXMtc3VmZml4e21hcmdpbjowIDRweH0uYW50LWlucHV0LWFmZml4LXdyYXBwZXIuYW50LWlucHV0LWFmZml4LXdyYXBwZXItdGV4dGFyZWEtd2l0aC1jbGVhci1idG57cGFkZGluZzowfS5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlci5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlci10ZXh0YXJlYS13aXRoLWNsZWFyLWJ0biAuYW50LWlucHV0LWNsZWFyLWljb257cG9zaXRpb246YWJzb2x1dGU7dG9wOjhweDtyaWdodDo4cHg7ei1pbmRleDoxfS5hbnQtaW5wdXQtc3RhdHVzLWVycm9yOm5vdCguYW50LWlucHV0LWRpc2FibGVkKTpub3QoLmFudC1pbnB1dC1ib3JkZXJsZXNzKS5hbnQtaW5wdXQsLmFudC1pbnB1dC1zdGF0dXMtZXJyb3I6bm90KC5hbnQtaW5wdXQtZGlzYWJsZWQpOm5vdCguYW50LWlucHV0LWJvcmRlcmxlc3MpLmFudC1pbnB1dDpob3ZlcntiYWNrZ3JvdW5kOiNmZmY7Ym9yZGVyLWNvbG9yOiNmZjRkNGZ9LmFudC1pbnB1dC1zdGF0dXMtZXJyb3I6bm90KC5hbnQtaW5wdXQtZGlzYWJsZWQpOm5vdCguYW50LWlucHV0LWJvcmRlcmxlc3MpLmFudC1pbnB1dC1mb2N1c2VkLC5hbnQtaW5wdXQtc3RhdHVzLWVycm9yOm5vdCguYW50LWlucHV0LWRpc2FibGVkKTpub3QoLmFudC1pbnB1dC1ib3JkZXJsZXNzKS5hbnQtaW5wdXQ6Zm9jdXN7Ym9yZGVyLWNvbG9yOiNmZjc4NzU7Ym94LXNoYWRvdzowIDAgMCAycHggcmdiYSgyNTUsNzcsNzksLjIpO2JvcmRlci1yaWdodC13aWR0aDoxcHg7b3V0bGluZTowfS5hbnQtaW5wdXQtc3RhdHVzLWVycm9yIC5hbnQtaW5wdXQtcHJlZml4e2NvbG9yOiNmZjRkNGZ9LmFudC1pbnB1dC1zdGF0dXMtd2FybmluZzpub3QoLmFudC1pbnB1dC1kaXNhYmxlZCk6bm90KC5hbnQtaW5wdXQtYm9yZGVybGVzcykuYW50LWlucHV0LC5hbnQtaW5wdXQtc3RhdHVzLXdhcm5pbmc6bm90KC5hbnQtaW5wdXQtZGlzYWJsZWQpOm5vdCguYW50LWlucHV0LWJvcmRlcmxlc3MpLmFudC1pbnB1dDpob3ZlcntiYWNrZ3JvdW5kOiNmZmY7Ym9yZGVyLWNvbG9yOiNmYWFkMTR9LmFudC1pbnB1dC1zdGF0dXMtd2FybmluZzpub3QoLmFudC1pbnB1dC1kaXNhYmxlZCk6bm90KC5hbnQtaW5wdXQtYm9yZGVybGVzcykuYW50LWlucHV0LWZvY3VzZWQsLmFudC1pbnB1dC1zdGF0dXMtd2FybmluZzpub3QoLmFudC1pbnB1dC1kaXNhYmxlZCk6bm90KC5hbnQtaW5wdXQtYm9yZGVybGVzcykuYW50LWlucHV0OmZvY3Vze2JvcmRlci1jb2xvcjojZmZjNTNkO2JveC1zaGFkb3c6MCAwIDAgMnB4IHJnYmEoMjUwLDE3MywyMCwuMik7Ym9yZGVyLXJpZ2h0LXdpZHRoOjFweDtvdXRsaW5lOjB9LmFudC1pbnB1dC1zdGF0dXMtd2FybmluZyAuYW50LWlucHV0LXByZWZpeHtjb2xvcjojZmFhZDE0fS5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlci1zdGF0dXMtZXJyb3I6bm90KC5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlci1kaXNhYmxlZCk6bm90KC5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlci1ib3JkZXJsZXNzKS5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlciwuYW50LWlucHV0LWFmZml4LXdyYXBwZXItc3RhdHVzLWVycm9yOm5vdCguYW50LWlucHV0LWFmZml4LXdyYXBwZXItZGlzYWJsZWQpOm5vdCguYW50LWlucHV0LWFmZml4LXdyYXBwZXItYm9yZGVybGVzcykuYW50LWlucHV0LWFmZml4LXdyYXBwZXI6aG92ZXJ7YmFja2dyb3VuZDojZmZmO2JvcmRlci1jb2xvcjojZmY0ZDRmfS5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlci1zdGF0dXMtZXJyb3I6bm90KC5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlci1kaXNhYmxlZCk6bm90KC5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlci1ib3JkZXJsZXNzKS5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlci1mb2N1c2VkLC5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlci1zdGF0dXMtZXJyb3I6bm90KC5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlci1kaXNhYmxlZCk6bm90KC5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlci1ib3JkZXJsZXNzKS5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlcjpmb2N1c3tib3JkZXItY29sb3I6I2ZmNzg3NTtib3gtc2hhZG93OjAgMCAwIDJweCByZ2JhKDI1NSw3Nyw3OSwuMik7Ym9yZGVyLXJpZ2h0LXdpZHRoOjFweDtvdXRsaW5lOjB9LmFudC1pbnB1dC1hZmZpeC13cmFwcGVyLXN0YXR1cy1lcnJvciAuYW50LWlucHV0LXByZWZpeHtjb2xvcjojZmY0ZDRmfS5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlci1zdGF0dXMtd2FybmluZzpub3QoLmFudC1pbnB1dC1hZmZpeC13cmFwcGVyLWRpc2FibGVkKTpub3QoLmFudC1pbnB1dC1hZmZpeC13cmFwcGVyLWJvcmRlcmxlc3MpLmFudC1pbnB1dC1hZmZpeC13cmFwcGVyLC5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlci1zdGF0dXMtd2FybmluZzpub3QoLmFudC1pbnB1dC1hZmZpeC13cmFwcGVyLWRpc2FibGVkKTpub3QoLmFudC1pbnB1dC1hZmZpeC13cmFwcGVyLWJvcmRlcmxlc3MpLmFudC1pbnB1dC1hZmZpeC13cmFwcGVyOmhvdmVye2JhY2tncm91bmQ6I2ZmZjtib3JkZXItY29sb3I6I2ZhYWQxNH0uYW50LWlucHV0LWFmZml4LXdyYXBwZXItc3RhdHVzLXdhcm5pbmc6bm90KC5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlci1kaXNhYmxlZCk6bm90KC5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlci1ib3JkZXJsZXNzKS5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlci1mb2N1c2VkLC5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlci1zdGF0dXMtd2FybmluZzpub3QoLmFudC1pbnB1dC1hZmZpeC13cmFwcGVyLWRpc2FibGVkKTpub3QoLmFudC1pbnB1dC1hZmZpeC13cmFwcGVyLWJvcmRlcmxlc3MpLmFudC1pbnB1dC1hZmZpeC13cmFwcGVyOmZvY3Vze2JvcmRlci1jb2xvcjojZmZjNTNkO2JveC1zaGFkb3c6MCAwIDAgMnB4IHJnYmEoMjUwLDE3MywyMCwuMik7Ym9yZGVyLXJpZ2h0LXdpZHRoOjFweDtvdXRsaW5lOjB9LmFudC1pbnB1dC1hZmZpeC13cmFwcGVyLXN0YXR1cy13YXJuaW5nIC5hbnQtaW5wdXQtcHJlZml4e2NvbG9yOiNmYWFkMTR9LmFudC1pbnB1dC10ZXh0YXJlYS1zdGF0dXMtZXJyb3IuYW50LWlucHV0LXRleHRhcmVhLWhhcy1mZWVkYmFjayAuYW50LWlucHV0LC5hbnQtaW5wdXQtdGV4dGFyZWEtc3RhdHVzLXN1Y2Nlc3MuYW50LWlucHV0LXRleHRhcmVhLWhhcy1mZWVkYmFjayAuYW50LWlucHV0LC5hbnQtaW5wdXQtdGV4dGFyZWEtc3RhdHVzLXZhbGlkYXRpbmcuYW50LWlucHV0LXRleHRhcmVhLWhhcy1mZWVkYmFjayAuYW50LWlucHV0LC5hbnQtaW5wdXQtdGV4dGFyZWEtc3RhdHVzLXdhcm5pbmcuYW50LWlucHV0LXRleHRhcmVhLWhhcy1mZWVkYmFjayAuYW50LWlucHV0e3BhZGRpbmctcmlnaHQ6MjRweH0uYW50LWlucHV0LWdyb3VwLXdyYXBwZXItc3RhdHVzLWVycm9yIC5hbnQtaW5wdXQtZ3JvdXAtYWRkb257Y29sb3I6I2ZmNGQ0Zjtib3JkZXItY29sb3I6I2ZmNGQ0Zn0uYW50LWlucHV0LWdyb3VwLXdyYXBwZXItc3RhdHVzLXdhcm5pbmcgLmFudC1pbnB1dC1ncm91cC1hZGRvbntjb2xvcjojZmFhZDE0O2JvcmRlci1jb2xvcjojZmFhZDE0fS5hbnQtaW5wdXR7Ym94LXNpemluZzpib3JkZXItYm94O21hcmdpbjowO2ZvbnQtdmFyaWFudDp0YWJ1bGFyLW51bXM7bGlzdC1zdHlsZTpub25lO2ZvbnQtZmVhdHVyZS1zZXR0aW5nczpcInRudW1cIjtwb3NpdGlvbjpyZWxhdGl2ZTtkaXNwbGF5OmlubGluZS1ibG9jazt3aWR0aDoxMDAlO21pbi13aWR0aDowO3BhZGRpbmc6NHB4IDExcHg7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtc2l6ZToxNHB4O2xpbmUtaGVpZ2h0OjEuNTcxNTtiYWNrZ3JvdW5kLWNvbG9yOiNmZmY7YmFja2dyb3VuZC1pbWFnZTpub25lO2JvcmRlcjoxcHggc29saWQgI2Q5ZDlkOTtib3JkZXItcmFkaXVzOjJweDt0cmFuc2l0aW9uOmFsbCAuM3N9LmFudC1pbnB1dDo6LW1vei1wbGFjZWhvbGRlcntjb2xvcjojYmZiZmJmOy1tb3otdXNlci1zZWxlY3Q6bm9uZTt1c2VyLXNlbGVjdDpub25lfS5hbnQtaW5wdXQ6LW1zLWlucHV0LXBsYWNlaG9sZGVye2NvbG9yOiNiZmJmYmY7LW1zLXVzZXItc2VsZWN0Om5vbmU7dXNlci1zZWxlY3Q6bm9uZX0uYW50LWlucHV0OjpwbGFjZWhvbGRlcntjb2xvcjojYmZiZmJmOy13ZWJraXQtdXNlci1zZWxlY3Q6bm9uZTstbW96LXVzZXItc2VsZWN0Om5vbmU7LW1zLXVzZXItc2VsZWN0Om5vbmU7dXNlci1zZWxlY3Q6bm9uZX0uYW50LWlucHV0Oi1tb3otcGxhY2Vob2xkZXItc2hvd257dGV4dC1vdmVyZmxvdzplbGxpcHNpc30uYW50LWlucHV0Oi1tcy1pbnB1dC1wbGFjZWhvbGRlcnt0ZXh0LW92ZXJmbG93OmVsbGlwc2lzfS5hbnQtaW5wdXQ6cGxhY2Vob2xkZXItc2hvd257dGV4dC1vdmVyZmxvdzplbGxpcHNpc30uYW50LWlucHV0OmhvdmVye2JvcmRlci1jb2xvcjojNDBhOWZmO2JvcmRlci1yaWdodC13aWR0aDoxcHh9LmFudC1pbnB1dC1ydGwgLmFudC1pbnB1dDpob3Zlcntib3JkZXItcmlnaHQtd2lkdGg6MDtib3JkZXItbGVmdC13aWR0aDoxcHghaW1wb3J0YW50fS5hbnQtaW5wdXQtZm9jdXNlZCwuYW50LWlucHV0OmZvY3Vze2JvcmRlci1jb2xvcjojNDBhOWZmO2JveC1zaGFkb3c6MCAwIDAgMnB4IHJnYmEoMjQsMTQ0LDI1NSwuMik7Ym9yZGVyLXJpZ2h0LXdpZHRoOjFweDtvdXRsaW5lOjB9LmFudC1pbnB1dC1ydGwgLmFudC1pbnB1dC1mb2N1c2VkLC5hbnQtaW5wdXQtcnRsIC5hbnQtaW5wdXQ6Zm9jdXN7Ym9yZGVyLXJpZ2h0LXdpZHRoOjA7Ym9yZGVyLWxlZnQtd2lkdGg6MXB4IWltcG9ydGFudH0uYW50LWlucHV0LWRpc2FibGVke2NvbG9yOnJnYmEoMCwwLDAsLjI1KTtiYWNrZ3JvdW5kLWNvbG9yOiNmNWY1ZjU7Ym9yZGVyLWNvbG9yOiNkOWQ5ZDk7Ym94LXNoYWRvdzpub25lO2N1cnNvcjpub3QtYWxsb3dlZDtvcGFjaXR5OjF9LmFudC1pbnB1dC1kaXNhYmxlZDpob3Zlcntib3JkZXItY29sb3I6I2Q5ZDlkOTtib3JkZXItcmlnaHQtd2lkdGg6MXB4fS5hbnQtaW5wdXRbZGlzYWJsZWRde2NvbG9yOnJnYmEoMCwwLDAsLjI1KTtiYWNrZ3JvdW5kLWNvbG9yOiNmNWY1ZjU7Ym9yZGVyLWNvbG9yOiNkOWQ5ZDk7Ym94LXNoYWRvdzpub25lO2N1cnNvcjpub3QtYWxsb3dlZDtvcGFjaXR5OjF9LmFudC1pbnB1dFtkaXNhYmxlZF06aG92ZXJ7Ym9yZGVyLWNvbG9yOiNkOWQ5ZDk7Ym9yZGVyLXJpZ2h0LXdpZHRoOjFweH0uYW50LWlucHV0LWJvcmRlcmxlc3MsLmFudC1pbnB1dC1ib3JkZXJsZXNzLWRpc2FibGVkLC5hbnQtaW5wdXQtYm9yZGVybGVzcy1mb2N1c2VkLC5hbnQtaW5wdXQtYm9yZGVybGVzczpmb2N1cywuYW50LWlucHV0LWJvcmRlcmxlc3M6aG92ZXIsLmFudC1pbnB1dC1ib3JkZXJsZXNzW2Rpc2FibGVkXXtiYWNrZ3JvdW5kLWNvbG9yOnRyYW5zcGFyZW50O2JvcmRlcjpub25lO2JveC1zaGFkb3c6bm9uZX10ZXh0YXJlYS5hbnQtaW5wdXR7bWF4LXdpZHRoOjEwMCU7aGVpZ2h0OmF1dG87bWluLWhlaWdodDozMnB4O2xpbmUtaGVpZ2h0OjEuNTcxNTt2ZXJ0aWNhbC1hbGlnbjpib3R0b207dHJhbnNpdGlvbjphbGwgLjNzLGhlaWdodCAwc30uYW50LWlucHV0LWxne3BhZGRpbmc6Ni41cHggMTFweDtmb250LXNpemU6MTZweH0uYW50LWlucHV0LXNte3BhZGRpbmc6MCA3cHh9LmFudC1pbnB1dC1ydGx7ZGlyZWN0aW9uOnJ0bH0uYW50LWlucHV0LWdyb3Vwe2JveC1zaXppbmc6Ym9yZGVyLWJveDttYXJnaW46MDtwYWRkaW5nOjA7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtc2l6ZToxNHB4O2ZvbnQtdmFyaWFudDp0YWJ1bGFyLW51bXM7bGluZS1oZWlnaHQ6MS41NzE1O2xpc3Qtc3R5bGU6bm9uZTtmb250LWZlYXR1cmUtc2V0dGluZ3M6XCJ0bnVtXCI7cG9zaXRpb246cmVsYXRpdmU7ZGlzcGxheTp0YWJsZTt3aWR0aDoxMDAlO2JvcmRlci1jb2xsYXBzZTpzZXBhcmF0ZTtib3JkZXItc3BhY2luZzowfS5hbnQtaW5wdXQtZ3JvdXBbY2xhc3MqPWNvbC1de2Zsb2F0Om5vbmU7cGFkZGluZy1yaWdodDowO3BhZGRpbmctbGVmdDowfS5hbnQtaW5wdXQtZ3JvdXA+W2NsYXNzKj1jb2wtXXtwYWRkaW5nLXJpZ2h0OjhweH0uYW50LWlucHV0LWdyb3VwPltjbGFzcyo9Y29sLV06bGFzdC1jaGlsZHtwYWRkaW5nLXJpZ2h0OjB9LmFudC1pbnB1dC1ncm91cC1hZGRvbiwuYW50LWlucHV0LWdyb3VwLXdyYXAsLmFudC1pbnB1dC1ncm91cD4uYW50LWlucHV0e2Rpc3BsYXk6dGFibGUtY2VsbH0uYW50LWlucHV0LWdyb3VwLWFkZG9uOm5vdCg6Zmlyc3QtY2hpbGQpOm5vdCg6bGFzdC1jaGlsZCksLmFudC1pbnB1dC1ncm91cC13cmFwOm5vdCg6Zmlyc3QtY2hpbGQpOm5vdCg6bGFzdC1jaGlsZCksLmFudC1pbnB1dC1ncm91cD4uYW50LWlucHV0Om5vdCg6Zmlyc3QtY2hpbGQpOm5vdCg6bGFzdC1jaGlsZCl7Ym9yZGVyLXJhZGl1czowfS5hbnQtaW5wdXQtZ3JvdXAtYWRkb24sLmFudC1pbnB1dC1ncm91cC13cmFwe3dpZHRoOjFweDt3aGl0ZS1zcGFjZTpub3dyYXA7dmVydGljYWwtYWxpZ246bWlkZGxlfS5hbnQtaW5wdXQtZ3JvdXAtd3JhcD4qe2Rpc3BsYXk6YmxvY2shaW1wb3J0YW50fS5hbnQtaW5wdXQtZ3JvdXAgLmFudC1pbnB1dHtmbG9hdDpsZWZ0O3dpZHRoOjEwMCU7bWFyZ2luLWJvdHRvbTowO3RleHQtYWxpZ246aW5oZXJpdH0uYW50LWlucHV0LWdyb3VwIC5hbnQtaW5wdXQ6Zm9jdXMsLmFudC1pbnB1dC1ncm91cCAuYW50LWlucHV0OmhvdmVye3otaW5kZXg6MTtib3JkZXItcmlnaHQtd2lkdGg6MXB4fS5hbnQtaW5wdXQtc2VhcmNoLXdpdGgtYnV0dG9uIC5hbnQtaW5wdXQtZ3JvdXAgLmFudC1pbnB1dDpob3Zlcnt6LWluZGV4OjB9LmFudC1pbnB1dC1ncm91cC1hZGRvbntwb3NpdGlvbjpyZWxhdGl2ZTtwYWRkaW5nOjAgMTFweDtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7Zm9udC13ZWlnaHQ6NDAwO2ZvbnQtc2l6ZToxNHB4O3RleHQtYWxpZ246Y2VudGVyO2JhY2tncm91bmQtY29sb3I6I2ZhZmFmYTtib3JkZXI6MXB4IHNvbGlkICNkOWQ5ZDk7Ym9yZGVyLXJhZGl1czoycHg7dHJhbnNpdGlvbjphbGwgLjNzfS5hbnQtaW5wdXQtZ3JvdXAtYWRkb24gLmFudC1zZWxlY3R7bWFyZ2luOi01cHggLTExcHh9LmFudC1pbnB1dC1ncm91cC1hZGRvbiAuYW50LXNlbGVjdC5hbnQtc2VsZWN0LXNpbmdsZTpub3QoLmFudC1zZWxlY3QtY3VzdG9taXplLWlucHV0KSAuYW50LXNlbGVjdC1zZWxlY3RvcntiYWNrZ3JvdW5kLWNvbG9yOmluaGVyaXQ7Ym9yZGVyOjFweCBzb2xpZCB0cmFuc3BhcmVudDtib3gtc2hhZG93Om5vbmV9LmFudC1pbnB1dC1ncm91cC1hZGRvbiAuYW50LXNlbGVjdC1mb2N1c2VkIC5hbnQtc2VsZWN0LXNlbGVjdG9yLC5hbnQtaW5wdXQtZ3JvdXAtYWRkb24gLmFudC1zZWxlY3Qtb3BlbiAuYW50LXNlbGVjdC1zZWxlY3Rvcntjb2xvcjojMTg5MGZmfS5hbnQtaW5wdXQtZ3JvdXAtYWRkb24gLmFudC1jYXNjYWRlci1waWNrZXJ7bWFyZ2luOi05cHggLTEycHg7YmFja2dyb3VuZC1jb2xvcjp0cmFuc3BhcmVudH0uYW50LWlucHV0LWdyb3VwLWFkZG9uIC5hbnQtY2FzY2FkZXItcGlja2VyIC5hbnQtY2FzY2FkZXItaW5wdXR7dGV4dC1hbGlnbjpsZWZ0O2JvcmRlcjowO2JveC1zaGFkb3c6bm9uZX0uYW50LWlucHV0LWdyb3VwLWFkZG9uOmZpcnN0LWNoaWxkLC5hbnQtaW5wdXQtZ3JvdXAtYWRkb246Zmlyc3QtY2hpbGQgLmFudC1zZWxlY3QgLmFudC1zZWxlY3Qtc2VsZWN0b3IsLmFudC1pbnB1dC1ncm91cD4uYW50LWlucHV0OmZpcnN0LWNoaWxkLC5hbnQtaW5wdXQtZ3JvdXA+LmFudC1pbnB1dDpmaXJzdC1jaGlsZCAuYW50LXNlbGVjdCAuYW50LXNlbGVjdC1zZWxlY3Rvcntib3JkZXItdG9wLXJpZ2h0LXJhZGl1czowO2JvcmRlci1ib3R0b20tcmlnaHQtcmFkaXVzOjB9LmFudC1pbnB1dC1ncm91cD4uYW50LWlucHV0LWFmZml4LXdyYXBwZXI6bm90KDpmaXJzdC1jaGlsZCkgLmFudC1pbnB1dHtib3JkZXItdG9wLWxlZnQtcmFkaXVzOjA7Ym9yZGVyLWJvdHRvbS1sZWZ0LXJhZGl1czowfS5hbnQtaW5wdXQtZ3JvdXA+LmFudC1pbnB1dC1hZmZpeC13cmFwcGVyOm5vdCg6bGFzdC1jaGlsZCkgLmFudC1pbnB1dHtib3JkZXItdG9wLXJpZ2h0LXJhZGl1czowO2JvcmRlci1ib3R0b20tcmlnaHQtcmFkaXVzOjB9LmFudC1pbnB1dC1ncm91cC1hZGRvbjpmaXJzdC1jaGlsZHtib3JkZXItcmlnaHQ6MH0uYW50LWlucHV0LWdyb3VwLWFkZG9uOmxhc3QtY2hpbGR7Ym9yZGVyLWxlZnQ6MH0uYW50LWlucHV0LWdyb3VwLWFkZG9uOmxhc3QtY2hpbGQsLmFudC1pbnB1dC1ncm91cC1hZGRvbjpsYXN0LWNoaWxkIC5hbnQtc2VsZWN0IC5hbnQtc2VsZWN0LXNlbGVjdG9yLC5hbnQtaW5wdXQtZ3JvdXA+LmFudC1pbnB1dDpsYXN0LWNoaWxkLC5hbnQtaW5wdXQtZ3JvdXA+LmFudC1pbnB1dDpsYXN0LWNoaWxkIC5hbnQtc2VsZWN0IC5hbnQtc2VsZWN0LXNlbGVjdG9ye2JvcmRlci10b3AtbGVmdC1yYWRpdXM6MDtib3JkZXItYm90dG9tLWxlZnQtcmFkaXVzOjB9LmFudC1pbnB1dC1ncm91cC1sZyAuYW50LWlucHV0LC5hbnQtaW5wdXQtZ3JvdXAtbGc+LmFudC1pbnB1dC1ncm91cC1hZGRvbntwYWRkaW5nOjYuNXB4IDExcHg7Zm9udC1zaXplOjE2cHh9LmFudC1pbnB1dC1ncm91cC1zbSAuYW50LWlucHV0LC5hbnQtaW5wdXQtZ3JvdXAtc20+LmFudC1pbnB1dC1ncm91cC1hZGRvbntwYWRkaW5nOjAgN3B4fS5hbnQtaW5wdXQtZ3JvdXAtbGcgLmFudC1zZWxlY3Qtc2luZ2xlIC5hbnQtc2VsZWN0LXNlbGVjdG9ye2hlaWdodDo0MHB4fS5hbnQtaW5wdXQtZ3JvdXAtc20gLmFudC1zZWxlY3Qtc2luZ2xlIC5hbnQtc2VsZWN0LXNlbGVjdG9ye2hlaWdodDoyNHB4fS5hbnQtaW5wdXQtZ3JvdXAgLmFudC1pbnB1dC1hZmZpeC13cmFwcGVyOm5vdCg6bGFzdC1jaGlsZCl7Ym9yZGVyLXRvcC1yaWdodC1yYWRpdXM6MDtib3JkZXItYm90dG9tLXJpZ2h0LXJhZGl1czowfS5hbnQtaW5wdXQtc2VhcmNoIC5hbnQtaW5wdXQtZ3JvdXAgLmFudC1pbnB1dC1hZmZpeC13cmFwcGVyOm5vdCg6bGFzdC1jaGlsZCl7Ym9yZGVyLXRvcC1sZWZ0LXJhZGl1czoycHg7Ym9yZGVyLWJvdHRvbS1sZWZ0LXJhZGl1czoycHh9LmFudC1pbnB1dC1ncm91cCAuYW50LWlucHV0LWFmZml4LXdyYXBwZXI6bm90KDpmaXJzdC1jaGlsZCksLmFudC1pbnB1dC1zZWFyY2ggLmFudC1pbnB1dC1ncm91cCAuYW50LWlucHV0LWFmZml4LXdyYXBwZXI6bm90KDpmaXJzdC1jaGlsZCl7Ym9yZGVyLXRvcC1sZWZ0LXJhZGl1czowO2JvcmRlci1ib3R0b20tbGVmdC1yYWRpdXM6MH0uYW50LWlucHV0LWdyb3VwLmFudC1pbnB1dC1ncm91cC1jb21wYWN0e2Rpc3BsYXk6YmxvY2t9LmFudC1pbnB1dC1ncm91cC5hbnQtaW5wdXQtZ3JvdXAtY29tcGFjdDpiZWZvcmV7ZGlzcGxheTp0YWJsZTtjb250ZW50OlwiXCJ9LmFudC1pbnB1dC1ncm91cC5hbnQtaW5wdXQtZ3JvdXAtY29tcGFjdDphZnRlcntkaXNwbGF5OnRhYmxlO2NsZWFyOmJvdGg7Y29udGVudDpcIlwifS5hbnQtaW5wdXQtZ3JvdXAuYW50LWlucHV0LWdyb3VwLWNvbXBhY3QtYWRkb246bm90KDpmaXJzdC1jaGlsZCk6bm90KDpsYXN0LWNoaWxkKSwuYW50LWlucHV0LWdyb3VwLmFudC1pbnB1dC1ncm91cC1jb21wYWN0LXdyYXA6bm90KDpmaXJzdC1jaGlsZCk6bm90KDpsYXN0LWNoaWxkKSwuYW50LWlucHV0LWdyb3VwLmFudC1pbnB1dC1ncm91cC1jb21wYWN0Pi5hbnQtaW5wdXQ6bm90KDpmaXJzdC1jaGlsZCk6bm90KDpsYXN0LWNoaWxkKXtib3JkZXItcmlnaHQtd2lkdGg6MXB4fS5hbnQtaW5wdXQtZ3JvdXAuYW50LWlucHV0LWdyb3VwLWNvbXBhY3QtYWRkb246bm90KDpmaXJzdC1jaGlsZCk6bm90KDpsYXN0LWNoaWxkKTpmb2N1cywuYW50LWlucHV0LWdyb3VwLmFudC1pbnB1dC1ncm91cC1jb21wYWN0LWFkZG9uOm5vdCg6Zmlyc3QtY2hpbGQpOm5vdCg6bGFzdC1jaGlsZCk6aG92ZXIsLmFudC1pbnB1dC1ncm91cC5hbnQtaW5wdXQtZ3JvdXAtY29tcGFjdC13cmFwOm5vdCg6Zmlyc3QtY2hpbGQpOm5vdCg6bGFzdC1jaGlsZCk6Zm9jdXMsLmFudC1pbnB1dC1ncm91cC5hbnQtaW5wdXQtZ3JvdXAtY29tcGFjdC13cmFwOm5vdCg6Zmlyc3QtY2hpbGQpOm5vdCg6bGFzdC1jaGlsZCk6aG92ZXIsLmFudC1pbnB1dC1ncm91cC5hbnQtaW5wdXQtZ3JvdXAtY29tcGFjdD4uYW50LWlucHV0Om5vdCg6Zmlyc3QtY2hpbGQpOm5vdCg6bGFzdC1jaGlsZCk6Zm9jdXMsLmFudC1pbnB1dC1ncm91cC5hbnQtaW5wdXQtZ3JvdXAtY29tcGFjdD4uYW50LWlucHV0Om5vdCg6Zmlyc3QtY2hpbGQpOm5vdCg6bGFzdC1jaGlsZCk6aG92ZXJ7ei1pbmRleDoxfS5hbnQtaW5wdXQtZ3JvdXAuYW50LWlucHV0LWdyb3VwLWNvbXBhY3Q+KntkaXNwbGF5OmlubGluZS1ibG9jaztmbG9hdDpub25lO3ZlcnRpY2FsLWFsaWduOnRvcDtib3JkZXItcmFkaXVzOjB9LmFudC1pbnB1dC1ncm91cC5hbnQtaW5wdXQtZ3JvdXAtY29tcGFjdD4uYW50LWlucHV0LWFmZml4LXdyYXBwZXIsLmFudC1pbnB1dC1ncm91cC5hbnQtaW5wdXQtZ3JvdXAtY29tcGFjdD4uYW50LXBpY2tlci1yYW5nZXtkaXNwbGF5OmlubGluZS1mbGV4fS5hbnQtaW5wdXQtZ3JvdXAuYW50LWlucHV0LWdyb3VwLWNvbXBhY3Q+Om5vdCg6bGFzdC1jaGlsZCl7bWFyZ2luLXJpZ2h0Oi0xcHg7Ym9yZGVyLXJpZ2h0LXdpZHRoOjFweH0uYW50LWlucHV0LWdyb3VwLmFudC1pbnB1dC1ncm91cC1jb21wYWN0IC5hbnQtaW5wdXR7ZmxvYXQ6bm9uZX0uYW50LWlucHV0LWdyb3VwLmFudC1pbnB1dC1ncm91cC1jb21wYWN0Pi5hbnQtY2FzY2FkZXItcGlja2VyIC5hbnQtaW5wdXQsLmFudC1pbnB1dC1ncm91cC5hbnQtaW5wdXQtZ3JvdXAtY29tcGFjdD4uYW50LWlucHV0LWdyb3VwLXdyYXBwZXIgLmFudC1pbnB1dCwuYW50LWlucHV0LWdyb3VwLmFudC1pbnB1dC1ncm91cC1jb21wYWN0Pi5hbnQtc2VsZWN0LWF1dG8tY29tcGxldGUgLmFudC1pbnB1dCwuYW50LWlucHV0LWdyb3VwLmFudC1pbnB1dC1ncm91cC1jb21wYWN0Pi5hbnQtc2VsZWN0Pi5hbnQtc2VsZWN0LXNlbGVjdG9ye2JvcmRlci1yaWdodC13aWR0aDoxcHg7Ym9yZGVyLXJhZGl1czowfS5hbnQtaW5wdXQtZ3JvdXAuYW50LWlucHV0LWdyb3VwLWNvbXBhY3Q+LmFudC1jYXNjYWRlci1waWNrZXIgLmFudC1pbnB1dDpmb2N1cywuYW50LWlucHV0LWdyb3VwLmFudC1pbnB1dC1ncm91cC1jb21wYWN0Pi5hbnQtY2FzY2FkZXItcGlja2VyIC5hbnQtaW5wdXQ6aG92ZXIsLmFudC1pbnB1dC1ncm91cC5hbnQtaW5wdXQtZ3JvdXAtY29tcGFjdD4uYW50LWlucHV0LWdyb3VwLXdyYXBwZXIgLmFudC1pbnB1dDpmb2N1cywuYW50LWlucHV0LWdyb3VwLmFudC1pbnB1dC1ncm91cC1jb21wYWN0Pi5hbnQtaW5wdXQtZ3JvdXAtd3JhcHBlciAuYW50LWlucHV0OmhvdmVyLC5hbnQtaW5wdXQtZ3JvdXAuYW50LWlucHV0LWdyb3VwLWNvbXBhY3Q+LmFudC1zZWxlY3QtYXV0by1jb21wbGV0ZSAuYW50LWlucHV0OmZvY3VzLC5hbnQtaW5wdXQtZ3JvdXAuYW50LWlucHV0LWdyb3VwLWNvbXBhY3Q+LmFudC1zZWxlY3QtYXV0by1jb21wbGV0ZSAuYW50LWlucHV0OmhvdmVyLC5hbnQtaW5wdXQtZ3JvdXAuYW50LWlucHV0LWdyb3VwLWNvbXBhY3Q+LmFudC1zZWxlY3QtZm9jdXNlZCwuYW50LWlucHV0LWdyb3VwLmFudC1pbnB1dC1ncm91cC1jb21wYWN0Pi5hbnQtc2VsZWN0Pi5hbnQtc2VsZWN0LWFycm93LC5hbnQtaW5wdXQtZ3JvdXAuYW50LWlucHV0LWdyb3VwLWNvbXBhY3Q+LmFudC1zZWxlY3Q+LmFudC1zZWxlY3Qtc2VsZWN0b3I6Zm9jdXMsLmFudC1pbnB1dC1ncm91cC5hbnQtaW5wdXQtZ3JvdXAtY29tcGFjdD4uYW50LXNlbGVjdD4uYW50LXNlbGVjdC1zZWxlY3Rvcjpob3Zlcnt6LWluZGV4OjF9LmFudC1pbnB1dC1ncm91cC5hbnQtaW5wdXQtZ3JvdXAtY29tcGFjdD4uYW50LWNhc2NhZGVyLXBpY2tlcjpmaXJzdC1jaGlsZCAuYW50LWlucHV0LC5hbnQtaW5wdXQtZ3JvdXAuYW50LWlucHV0LWdyb3VwLWNvbXBhY3Q+LmFudC1zZWxlY3QtYXV0by1jb21wbGV0ZTpmaXJzdC1jaGlsZCAuYW50LWlucHV0LC5hbnQtaW5wdXQtZ3JvdXAuYW50LWlucHV0LWdyb3VwLWNvbXBhY3Q+LmFudC1zZWxlY3Q6Zmlyc3QtY2hpbGQ+LmFudC1zZWxlY3Qtc2VsZWN0b3IsLmFudC1pbnB1dC1ncm91cC5hbnQtaW5wdXQtZ3JvdXAtY29tcGFjdD46Zmlyc3QtY2hpbGR7Ym9yZGVyLXRvcC1sZWZ0LXJhZGl1czoycHg7Ym9yZGVyLWJvdHRvbS1sZWZ0LXJhZGl1czoycHh9LmFudC1pbnB1dC1ncm91cC5hbnQtaW5wdXQtZ3JvdXAtY29tcGFjdD4uYW50LWNhc2NhZGVyLXBpY2tlci1mb2N1c2VkOmxhc3QtY2hpbGQgLmFudC1pbnB1dCwuYW50LWlucHV0LWdyb3VwLmFudC1pbnB1dC1ncm91cC1jb21wYWN0Pi5hbnQtY2FzY2FkZXItcGlja2VyOmxhc3QtY2hpbGQgLmFudC1pbnB1dCwuYW50LWlucHV0LWdyb3VwLmFudC1pbnB1dC1ncm91cC1jb21wYWN0Pi5hbnQtc2VsZWN0Omxhc3QtY2hpbGQ+LmFudC1zZWxlY3Qtc2VsZWN0b3IsLmFudC1pbnB1dC1ncm91cC5hbnQtaW5wdXQtZ3JvdXAtY29tcGFjdD46bGFzdC1jaGlsZHtib3JkZXItcmlnaHQtd2lkdGg6MXB4O2JvcmRlci10b3AtcmlnaHQtcmFkaXVzOjJweDtib3JkZXItYm90dG9tLXJpZ2h0LXJhZGl1czoycHh9LmFudC1pbnB1dC1ncm91cC5hbnQtaW5wdXQtZ3JvdXAtY29tcGFjdD4uYW50LXNlbGVjdC1hdXRvLWNvbXBsZXRlIC5hbnQtaW5wdXR7dmVydGljYWwtYWxpZ246dG9wfS5hbnQtaW5wdXQtZ3JvdXAuYW50LWlucHV0LWdyb3VwLWNvbXBhY3QgLmFudC1pbnB1dC1ncm91cC13cmFwcGVyKy5hbnQtaW5wdXQtZ3JvdXAtd3JhcHBlcnttYXJnaW4tbGVmdDotMXB4fS5hbnQtaW5wdXQtZ3JvdXAuYW50LWlucHV0LWdyb3VwLWNvbXBhY3QgLmFudC1pbnB1dC1ncm91cC13cmFwcGVyKy5hbnQtaW5wdXQtZ3JvdXAtd3JhcHBlciAuYW50LWlucHV0LWFmZml4LXdyYXBwZXIsLmFudC1pbnB1dC1ncm91cC5hbnQtaW5wdXQtZ3JvdXAtY29tcGFjdCAuYW50LWlucHV0LWdyb3VwLXdyYXBwZXI6bm90KDpsYXN0LWNoaWxkKS5hbnQtaW5wdXQtc2VhcmNoPi5hbnQtaW5wdXQtZ3JvdXA+LmFudC1pbnB1dC1ncm91cC1hZGRvbj4uYW50LWlucHV0LXNlYXJjaC1idXR0b257Ym9yZGVyLXJhZGl1czowfS5hbnQtaW5wdXQtZ3JvdXAuYW50LWlucHV0LWdyb3VwLWNvbXBhY3QgLmFudC1pbnB1dC1ncm91cC13cmFwcGVyOm5vdCg6bGFzdC1jaGlsZCkuYW50LWlucHV0LXNlYXJjaD4uYW50LWlucHV0LWdyb3VwPi5hbnQtaW5wdXR7Ym9yZGVyLXJhZGl1czoycHggMCAwIDJweH0uYW50LWlucHV0LWdyb3VwLXJ0bCAuYW50LWlucHV0LWdyb3VwLWFkZG9uOmZpcnN0LWNoaWxkLC5hbnQtaW5wdXQtZ3JvdXA+LmFudC1pbnB1dC1ydGw6Zmlyc3QtY2hpbGR7Ym9yZGVyLXJhZGl1czowIDJweCAycHggMH0uYW50LWlucHV0LWdyb3VwLXJ0bCAuYW50LWlucHV0LWdyb3VwLWFkZG9uOmZpcnN0LWNoaWxke2JvcmRlci1yaWdodDoxcHggc29saWQgI2Q5ZDlkOTtib3JkZXItbGVmdDowfS5hbnQtaW5wdXQtZ3JvdXAtcnRsIC5hbnQtaW5wdXQtZ3JvdXAtYWRkb246bGFzdC1jaGlsZHtib3JkZXItcmlnaHQ6MDtib3JkZXItbGVmdDoxcHggc29saWQgI2Q5ZDlkOTtib3JkZXItcmFkaXVzOjJweCAwIDAgMnB4fS5hbnQtaW5wdXQtZ3JvdXAtcnRsLmFudC1pbnB1dC1ncm91cC1hZGRvbjpsYXN0LWNoaWxkLC5hbnQtaW5wdXQtZ3JvdXAtcnRsLmFudC1pbnB1dC1ncm91cCAuYW50LWlucHV0LWFmZml4LXdyYXBwZXI6bm90KDpmaXJzdC1jaGlsZCksLmFudC1pbnB1dC1ncm91cC1ydGwuYW50LWlucHV0LWdyb3VwPi5hbnQtaW5wdXQ6bGFzdC1jaGlsZHtib3JkZXItcmFkaXVzOjJweCAwIDAgMnB4fS5hbnQtaW5wdXQtZ3JvdXAtcnRsLmFudC1pbnB1dC1ncm91cCAuYW50LWlucHV0LWFmZml4LXdyYXBwZXI6bm90KDpsYXN0LWNoaWxkKXtib3JkZXItcmFkaXVzOjAgMnB4IDJweCAwfS5hbnQtaW5wdXQtZ3JvdXAtcnRsLmFudC1pbnB1dC1ncm91cC5hbnQtaW5wdXQtZ3JvdXAtY29tcGFjdD46bm90KDpsYXN0LWNoaWxkKXttYXJnaW4tcmlnaHQ6MDttYXJnaW4tbGVmdDotMXB4O2JvcmRlci1sZWZ0LXdpZHRoOjFweH0uYW50LWlucHV0LWdyb3VwLXJ0bC5hbnQtaW5wdXQtZ3JvdXAuYW50LWlucHV0LWdyb3VwLWNvbXBhY3Q+LmFudC1jYXNjYWRlci1waWNrZXI6Zmlyc3QtY2hpbGQgLmFudC1pbnB1dCwuYW50LWlucHV0LWdyb3VwLXJ0bC5hbnQtaW5wdXQtZ3JvdXAuYW50LWlucHV0LWdyb3VwLWNvbXBhY3Q+LmFudC1zZWxlY3QtYXV0by1jb21wbGV0ZTpmaXJzdC1jaGlsZCAuYW50LWlucHV0LC5hbnQtaW5wdXQtZ3JvdXAtcnRsLmFudC1pbnB1dC1ncm91cC5hbnQtaW5wdXQtZ3JvdXAtY29tcGFjdD4uYW50LXNlbGVjdDpmaXJzdC1jaGlsZD4uYW50LXNlbGVjdC1zZWxlY3RvciwuYW50LWlucHV0LWdyb3VwLXJ0bC5hbnQtaW5wdXQtZ3JvdXAuYW50LWlucHV0LWdyb3VwLWNvbXBhY3Q+OmZpcnN0LWNoaWxke2JvcmRlci1yYWRpdXM6MCAycHggMnB4IDB9LmFudC1pbnB1dC1ncm91cC1ydGwuYW50LWlucHV0LWdyb3VwLmFudC1pbnB1dC1ncm91cC1jb21wYWN0Pi5hbnQtY2FzY2FkZXItcGlja2VyLWZvY3VzZWQ6bGFzdC1jaGlsZCAuYW50LWlucHV0LC5hbnQtaW5wdXQtZ3JvdXAtcnRsLmFudC1pbnB1dC1ncm91cC5hbnQtaW5wdXQtZ3JvdXAtY29tcGFjdD4uYW50LWNhc2NhZGVyLXBpY2tlcjpsYXN0LWNoaWxkIC5hbnQtaW5wdXQsLmFudC1pbnB1dC1ncm91cC1ydGwuYW50LWlucHV0LWdyb3VwLmFudC1pbnB1dC1ncm91cC1jb21wYWN0Pi5hbnQtc2VsZWN0LWF1dG8tY29tcGxldGU6bGFzdC1jaGlsZCAuYW50LWlucHV0LC5hbnQtaW5wdXQtZ3JvdXAtcnRsLmFudC1pbnB1dC1ncm91cC5hbnQtaW5wdXQtZ3JvdXAtY29tcGFjdD4uYW50LXNlbGVjdDpsYXN0LWNoaWxkPi5hbnQtc2VsZWN0LXNlbGVjdG9yLC5hbnQtaW5wdXQtZ3JvdXAtcnRsLmFudC1pbnB1dC1ncm91cC5hbnQtaW5wdXQtZ3JvdXAtY29tcGFjdD46bGFzdC1jaGlsZHtib3JkZXItbGVmdC13aWR0aDoxcHg7Ym9yZGVyLXJhZGl1czoycHggMCAwIDJweH0uYW50LWlucHV0LWdyb3VwLmFudC1pbnB1dC1ncm91cC1jb21wYWN0IC5hbnQtaW5wdXQtZ3JvdXAtd3JhcHBlci1ydGwrLmFudC1pbnB1dC1ncm91cC13cmFwcGVyLXJ0bHttYXJnaW4tcmlnaHQ6LTFweDttYXJnaW4tbGVmdDowfS5hbnQtaW5wdXQtZ3JvdXAuYW50LWlucHV0LWdyb3VwLWNvbXBhY3QgLmFudC1pbnB1dC1ncm91cC13cmFwcGVyLXJ0bDpub3QoOmxhc3QtY2hpbGQpLmFudC1pbnB1dC1zZWFyY2g+LmFudC1pbnB1dC1ncm91cD4uYW50LWlucHV0e2JvcmRlci1yYWRpdXM6MCAycHggMnB4IDB9LmFudC1pbnB1dC1ncm91cC13cmFwcGVye2Rpc3BsYXk6aW5saW5lLWJsb2NrO3dpZHRoOjEwMCU7dGV4dC1hbGlnbjpzdGFydDt2ZXJ0aWNhbC1hbGlnbjp0b3B9LmFudC1pbnB1dC1wYXNzd29yZC1pY29uLmFudGljb257Y29sb3I6cmdiYSgwLDAsMCwuNDUpO2N1cnNvcjpwb2ludGVyO3RyYW5zaXRpb246YWxsIC4zc30uYW50LWlucHV0LXBhc3N3b3JkLWljb24uYW50aWNvbjpob3Zlcntjb2xvcjpyZ2JhKDAsMCwwLC44NSl9LmFudC1pbnB1dFt0eXBlPWNvbG9yXXtoZWlnaHQ6MzJweH0uYW50LWlucHV0W3R5cGU9Y29sb3JdLmFudC1pbnB1dC1sZ3toZWlnaHQ6NDBweH0uYW50LWlucHV0W3R5cGU9Y29sb3JdLmFudC1pbnB1dC1zbXtoZWlnaHQ6MjRweDtwYWRkaW5nLXRvcDozcHg7cGFkZGluZy1ib3R0b206M3B4fS5hbnQtaW5wdXQtdGV4dGFyZWEtc2hvdy1jb3VudD4uYW50LWlucHV0e2hlaWdodDoxMDAlfS5hbnQtaW5wdXQtdGV4dGFyZWEtc2hvdy1jb3VudDphZnRlcntmbG9hdDpyaWdodDtjb2xvcjpyZ2JhKDAsMCwwLC40NSk7d2hpdGUtc3BhY2U6bm93cmFwO2NvbnRlbnQ6YXR0cihkYXRhLWNvdW50KTtwb2ludGVyLWV2ZW50czpub25lfS5hbnQtaW5wdXQtdGV4dGFyZWEtc2hvdy1jb3VudC5hbnQtaW5wdXQtdGV4dGFyZWEtaW4tZm9ybS1pdGVtOmFmdGVye21hcmdpbi1ib3R0b206LTIycHh9LmFudC1pbnB1dC10ZXh0YXJlYS1zdWZmaXh7cG9zaXRpb246YWJzb2x1dGU7dG9wOjA7cmlnaHQ6MTFweDtib3R0b206MDt6LWluZGV4OjE7ZGlzcGxheTppbmxpbmUtZmxleDthbGlnbi1pdGVtczpjZW50ZXI7bWFyZ2luOmF1dG99LmFudC1pbnB1dC1jb21wYWN0LWl0ZW06bm90KC5hbnQtaW5wdXQtY29tcGFjdC1sYXN0LWl0ZW0pOm5vdCguYW50LWlucHV0LWNvbXBhY3QtaXRlbS1ydGwpe21hcmdpbi1yaWdodDotMXB4fS5hbnQtaW5wdXQtY29tcGFjdC1pdGVtOm5vdCguYW50LWlucHV0LWNvbXBhY3QtbGFzdC1pdGVtKS5hbnQtaW5wdXQtY29tcGFjdC1pdGVtLXJ0bHttYXJnaW4tbGVmdDotMXB4fS5hbnQtaW5wdXQtY29tcGFjdC1pdGVtOmFjdGl2ZSwuYW50LWlucHV0LWNvbXBhY3QtaXRlbTpmb2N1cywuYW50LWlucHV0LWNvbXBhY3QtaXRlbTpob3Zlcnt6LWluZGV4OjJ9LmFudC1pbnB1dC1jb21wYWN0LWl0ZW1bZGlzYWJsZWRde3otaW5kZXg6MH0uYW50LWlucHV0LWNvbXBhY3QtaXRlbTpub3QoLmFudC1pbnB1dC1jb21wYWN0LWZpcnN0LWl0ZW0pOm5vdCguYW50LWlucHV0LWNvbXBhY3QtbGFzdC1pdGVtKS5hbnQtaW5wdXR7Ym9yZGVyLXJhZGl1czowfS5hbnQtaW5wdXQtY29tcGFjdC1pdGVtLmFudC1pbnB1dC5hbnQtaW5wdXQtY29tcGFjdC1maXJzdC1pdGVtOm5vdCguYW50LWlucHV0LWNvbXBhY3QtbGFzdC1pdGVtKTpub3QoLmFudC1pbnB1dC1jb21wYWN0LWl0ZW0tcnRsKXtib3JkZXItdG9wLXJpZ2h0LXJhZGl1czowO2JvcmRlci1ib3R0b20tcmlnaHQtcmFkaXVzOjB9LmFudC1pbnB1dC1jb21wYWN0LWl0ZW0uYW50LWlucHV0LmFudC1pbnB1dC1jb21wYWN0LWl0ZW0tcnRsLmFudC1pbnB1dC1jb21wYWN0LWZpcnN0LWl0ZW06bm90KC5hbnQtaW5wdXQtY29tcGFjdC1sYXN0LWl0ZW0pLC5hbnQtaW5wdXQtY29tcGFjdC1pdGVtLmFudC1pbnB1dC5hbnQtaW5wdXQtY29tcGFjdC1sYXN0LWl0ZW06bm90KC5hbnQtaW5wdXQtY29tcGFjdC1maXJzdC1pdGVtKTpub3QoLmFudC1pbnB1dC1jb21wYWN0LWl0ZW0tcnRsKXtib3JkZXItdG9wLWxlZnQtcmFkaXVzOjA7Ym9yZGVyLWJvdHRvbS1sZWZ0LXJhZGl1czowfS5hbnQtaW5wdXQtY29tcGFjdC1pdGVtLmFudC1pbnB1dC5hbnQtaW5wdXQtY29tcGFjdC1pdGVtLXJ0bC5hbnQtaW5wdXQtY29tcGFjdC1sYXN0LWl0ZW06bm90KC5hbnQtaW5wdXQtY29tcGFjdC1maXJzdC1pdGVtKXtib3JkZXItdG9wLXJpZ2h0LXJhZGl1czowO2JvcmRlci1ib3R0b20tcmlnaHQtcmFkaXVzOjB9LmFudC1pbnB1dC1zZWFyY2ggLmFudC1pbnB1dDpmb2N1cywuYW50LWlucHV0LXNlYXJjaCAuYW50LWlucHV0OmhvdmVye2JvcmRlci1jb2xvcjojNDBhOWZmfS5hbnQtaW5wdXQtc2VhcmNoIC5hbnQtaW5wdXQ6Zm9jdXMrLmFudC1pbnB1dC1ncm91cC1hZGRvbiAuYW50LWlucHV0LXNlYXJjaC1idXR0b246bm90KC5hbnQtYnRuLXByaW1hcnkpLC5hbnQtaW5wdXQtc2VhcmNoIC5hbnQtaW5wdXQ6aG92ZXIrLmFudC1pbnB1dC1ncm91cC1hZGRvbiAuYW50LWlucHV0LXNlYXJjaC1idXR0b246bm90KC5hbnQtYnRuLXByaW1hcnkpe2JvcmRlci1sZWZ0LWNvbG9yOiM0MGE5ZmZ9LmFudC1pbnB1dC1zZWFyY2ggLmFudC1pbnB1dC1hZmZpeC13cmFwcGVye2JvcmRlci1yYWRpdXM6MH0uYW50LWlucHV0LXNlYXJjaCAuYW50LWlucHV0LWxne2xpbmUtaGVpZ2h0OjEuNTcxM30uYW50LWlucHV0LXNlYXJjaD4uYW50LWlucHV0LWdyb3VwPi5hbnQtaW5wdXQtZ3JvdXAtYWRkb246bGFzdC1jaGlsZHtsZWZ0Oi0xcHg7cGFkZGluZzowO2JvcmRlcjowfS5hbnQtaW5wdXQtc2VhcmNoPi5hbnQtaW5wdXQtZ3JvdXA+LmFudC1pbnB1dC1ncm91cC1hZGRvbjpsYXN0LWNoaWxkIC5hbnQtaW5wdXQtc2VhcmNoLWJ1dHRvbntwYWRkaW5nLXRvcDowO3BhZGRpbmctYm90dG9tOjA7Ym9yZGVyLXJhZGl1czowIDJweCAycHggMH0uYW50LWlucHV0LXNlYXJjaD4uYW50LWlucHV0LWdyb3VwPi5hbnQtaW5wdXQtZ3JvdXAtYWRkb246bGFzdC1jaGlsZCAuYW50LWlucHV0LXNlYXJjaC1idXR0b246bm90KC5hbnQtYnRuLXByaW1hcnkpe2NvbG9yOnJnYmEoMCwwLDAsLjQ1KX0uYW50LWlucHV0LXNlYXJjaD4uYW50LWlucHV0LWdyb3VwPi5hbnQtaW5wdXQtZ3JvdXAtYWRkb246bGFzdC1jaGlsZCAuYW50LWlucHV0LXNlYXJjaC1idXR0b246bm90KC5hbnQtYnRuLXByaW1hcnkpLmFudC1idG4tbG9hZGluZzpiZWZvcmV7dG9wOjA7cmlnaHQ6MDtib3R0b206MDtsZWZ0OjB9LmFudC1pbnB1dC1zZWFyY2gtYnV0dG9ue2hlaWdodDozMnB4fS5hbnQtaW5wdXQtc2VhcmNoLWJ1dHRvbjpmb2N1cywuYW50LWlucHV0LXNlYXJjaC1idXR0b246aG92ZXJ7ei1pbmRleDoxfS5hbnQtaW5wdXQtc2VhcmNoLWxhcmdlIC5hbnQtaW5wdXQtc2VhcmNoLWJ1dHRvbntoZWlnaHQ6NDBweH0uYW50LWlucHV0LXNlYXJjaC1zbWFsbCAuYW50LWlucHV0LXNlYXJjaC1idXR0b257aGVpZ2h0OjI0cHh9LmFudC1pbnB1dC1zZWFyY2guYW50LWlucHV0LWNvbXBhY3QtaXRlbTpub3QoLmFudC1pbnB1dC1jb21wYWN0LWl0ZW0tcnRsKTpub3QoLmFudC1pbnB1dC1jb21wYWN0LWxhc3QtaXRlbSkgLmFudC1pbnB1dC1ncm91cC1hZGRvbiAuYW50LWlucHV0LXNlYXJjaC1idXR0b257bWFyZ2luLXJpZ2h0Oi0xcHg7Ym9yZGVyLXJhZGl1czowfS5hbnQtaW5wdXQtc2VhcmNoLmFudC1pbnB1dC1jb21wYWN0LWl0ZW06bm90KC5hbnQtaW5wdXQtY29tcGFjdC1maXJzdC1pdGVtKSAuYW50LWlucHV0LC5hbnQtaW5wdXQtc2VhcmNoLmFudC1pbnB1dC1jb21wYWN0LWl0ZW06bm90KC5hbnQtaW5wdXQtY29tcGFjdC1maXJzdC1pdGVtKSAuYW50LWlucHV0LWFmZml4LXdyYXBwZXJ7Ym9yZGVyLXJhZGl1czowfS5hbnQtaW5wdXQtc2VhcmNoLmFudC1pbnB1dC1jb21wYWN0LWl0ZW0gLmFudC1pbnB1dC1hZmZpeC13cmFwcGVyOmFjdGl2ZSwuYW50LWlucHV0LXNlYXJjaC5hbnQtaW5wdXQtY29tcGFjdC1pdGVtIC5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlcjpmb2N1cywuYW50LWlucHV0LXNlYXJjaC5hbnQtaW5wdXQtY29tcGFjdC1pdGVtIC5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlcjpob3ZlciwuYW50LWlucHV0LXNlYXJjaC5hbnQtaW5wdXQtY29tcGFjdC1pdGVtPi5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlci1mb2N1c2VkLC5hbnQtaW5wdXQtc2VhcmNoLmFudC1pbnB1dC1jb21wYWN0LWl0ZW0+LmFudC1pbnB1dC1ncm91cC1hZGRvbiAuYW50LWlucHV0LXNlYXJjaC1idXR0b246YWN0aXZlLC5hbnQtaW5wdXQtc2VhcmNoLmFudC1pbnB1dC1jb21wYWN0LWl0ZW0+LmFudC1pbnB1dC1ncm91cC1hZGRvbiAuYW50LWlucHV0LXNlYXJjaC1idXR0b246Zm9jdXMsLmFudC1pbnB1dC1zZWFyY2guYW50LWlucHV0LWNvbXBhY3QtaXRlbT4uYW50LWlucHV0LWdyb3VwLWFkZG9uIC5hbnQtaW5wdXQtc2VhcmNoLWJ1dHRvbjpob3ZlciwuYW50LWlucHV0LXNlYXJjaC5hbnQtaW5wdXQtY29tcGFjdC1pdGVtPi5hbnQtaW5wdXQ6YWN0aXZlLC5hbnQtaW5wdXQtc2VhcmNoLmFudC1pbnB1dC1jb21wYWN0LWl0ZW0+LmFudC1pbnB1dDpmb2N1cywuYW50LWlucHV0LXNlYXJjaC5hbnQtaW5wdXQtY29tcGFjdC1pdGVtPi5hbnQtaW5wdXQ6aG92ZXJ7ei1pbmRleDoyfS5hbnQtaW5wdXQtc2VhcmNoLmFudC1pbnB1dC1jb21wYWN0LWl0ZW0tcnRsOm5vdCguYW50LWlucHV0LWNvbXBhY3QtbGFzdC1pdGVtKSAuYW50LWlucHV0LWdyb3VwLWFkZG9uOmxhc3QtY2hpbGQgLmFudC1pbnB1dC1zZWFyY2gtYnV0dG9ue21hcmdpbi1sZWZ0Oi0xcHg7Ym9yZGVyLXJhZGl1czowfS5hbnQtaW5wdXQtZ3JvdXAtcnRsLC5hbnQtaW5wdXQtZ3JvdXAtd3JhcHBlci1ydGx7ZGlyZWN0aW9uOnJ0bH0uYW50LWlucHV0LWFmZml4LXdyYXBwZXIuYW50LWlucHV0LWFmZml4LXdyYXBwZXItcnRsPmlucHV0LmFudC1pbnB1dHtib3JkZXI6bm9uZTtvdXRsaW5lOm5vbmV9LmFudC1pbnB1dC1hZmZpeC13cmFwcGVyLXJ0bCAuYW50LWlucHV0LXByZWZpeHttYXJnaW46MCAwIDAgNHB4fS5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlci1ydGwgLmFudC1pbnB1dC1zdWZmaXh7bWFyZ2luOjAgNHB4IDAgMH0uYW50LWlucHV0LXRleHRhcmVhLXJ0bHtkaXJlY3Rpb246cnRsfS5hbnQtaW5wdXQtdGV4dGFyZWEtcnRsLmFudC1pbnB1dC10ZXh0YXJlYS1zaG93LWNvdW50OmFmdGVye3RleHQtYWxpZ246bGVmdH0uYW50LWlucHV0LWFmZml4LXdyYXBwZXItcnRsIC5hbnQtaW5wdXQtY2xlYXItaWNvbi1oYXMtc3VmZml4e21hcmdpbi1yaWdodDowO21hcmdpbi1sZWZ0OjRweH0uYW50LWlucHV0LWFmZml4LXdyYXBwZXItcnRsIC5hbnQtaW5wdXQtY2xlYXItaWNvbntyaWdodDphdXRvO2xlZnQ6OHB4fS5hbnQtaW5wdXQtc2VhcmNoLXJ0bHtkaXJlY3Rpb246cnRsfS5hbnQtaW5wdXQtc2VhcmNoLXJ0bCAuYW50LWlucHV0OmZvY3VzKy5hbnQtaW5wdXQtZ3JvdXAtYWRkb24gLmFudC1pbnB1dC1zZWFyY2gtYnV0dG9uOm5vdCguYW50LWJ0bi1wcmltYXJ5KSwuYW50LWlucHV0LXNlYXJjaC1ydGwgLmFudC1pbnB1dDpob3ZlcisuYW50LWlucHV0LWdyb3VwLWFkZG9uIC5hbnQtaW5wdXQtc2VhcmNoLWJ1dHRvbjpub3QoLmFudC1idG4tcHJpbWFyeSl7Ym9yZGVyLWxlZnQtY29sb3I6I2Q5ZDlkOX0uYW50LWlucHV0LXNlYXJjaC1ydGwgLmFudC1pbnB1dDpmb2N1cysuYW50LWlucHV0LWdyb3VwLWFkZG9uIC5hbnQtaW5wdXQtc2VhcmNoLWJ1dHRvbjpub3QoLmFudC1idG4tcHJpbWFyeSk6aG92ZXIsLmFudC1pbnB1dC1zZWFyY2gtcnRsIC5hbnQtaW5wdXQ6aG92ZXIrLmFudC1pbnB1dC1ncm91cC1hZGRvbiAuYW50LWlucHV0LXNlYXJjaC1idXR0b246bm90KC5hbnQtYnRuLXByaW1hcnkpOmhvdmVye2JvcmRlci1sZWZ0LWNvbG9yOiM0MGE5ZmZ9LmFudC1pbnB1dC1zZWFyY2gtcnRsPi5hbnQtaW5wdXQtZ3JvdXA+LmFudC1pbnB1dC1hZmZpeC13cmFwcGVyLWZvY3VzZWQsLmFudC1pbnB1dC1zZWFyY2gtcnRsPi5hbnQtaW5wdXQtZ3JvdXA+LmFudC1pbnB1dC1hZmZpeC13cmFwcGVyOmhvdmVye2JvcmRlci1yaWdodC1jb2xvcjojNDBhOWZmfS5hbnQtaW5wdXQtc2VhcmNoLXJ0bD4uYW50LWlucHV0LWdyb3VwPi5hbnQtaW5wdXQtZ3JvdXAtYWRkb246bGFzdC1jaGlsZHtyaWdodDotMXB4O2xlZnQ6YXV0b30uYW50LWlucHV0LXNlYXJjaC1ydGw+LmFudC1pbnB1dC1ncm91cD4uYW50LWlucHV0LWdyb3VwLWFkZG9uOmxhc3QtY2hpbGQgLmFudC1pbnB1dC1zZWFyY2gtYnV0dG9ue2JvcmRlci1yYWRpdXM6MnB4IDAgMCAycHh9QG1lZGlhICgtbXMtaGlnaC1jb250cmFzdDpub25lKSxzY3JlZW4gYW5kICgtbXMtaGlnaC1jb250cmFzdDphY3RpdmUpey5hbnQtaW5wdXR7aGVpZ2h0OjMycHh9LmFudC1pbnB1dC1sZ3toZWlnaHQ6NDBweH0uYW50LWlucHV0LXNte2hlaWdodDoyNHB4fS5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlcj5pbnB1dC5hbnQtaW5wdXR7aGVpZ2h0OmF1dG99fS5hbnQtbGF5b3V0e2Rpc3BsYXk6ZmxleDtmbGV4OmF1dG87ZmxleC1kaXJlY3Rpb246Y29sdW1uO21pbi1oZWlnaHQ6MDtiYWNrZ3JvdW5kOiNmMGYyZjV9LmFudC1sYXlvdXQsLmFudC1sYXlvdXQgKntib3gtc2l6aW5nOmJvcmRlci1ib3h9LmFudC1sYXlvdXQuYW50LWxheW91dC1oYXMtc2lkZXJ7ZmxleC1kaXJlY3Rpb246cm93fS5hbnQtbGF5b3V0LmFudC1sYXlvdXQtaGFzLXNpZGVyPi5hbnQtbGF5b3V0LC5hbnQtbGF5b3V0LmFudC1sYXlvdXQtaGFzLXNpZGVyPi5hbnQtbGF5b3V0LWNvbnRlbnR7d2lkdGg6MH0uYW50LWxheW91dC1mb290ZXIsLmFudC1sYXlvdXQtaGVhZGVye2ZsZXg6MCAwIGF1dG99LmFudC1sYXlvdXQtaGVhZGVye2hlaWdodDo2NHB4O3BhZGRpbmc6MCA1MHB4O2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtsaW5lLWhlaWdodDo2NHB4O2JhY2tncm91bmQ6IzAwMTUyOX0uYW50LWxheW91dC1mb290ZXJ7cGFkZGluZzoyNHB4IDUwcHg7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtc2l6ZToxNHB4O2JhY2tncm91bmQ6I2YwZjJmNX0uYW50LWxheW91dC1jb250ZW50e2ZsZXg6YXV0bzttaW4taGVpZ2h0OjB9LmFudC1sYXlvdXQtc2lkZXJ7cG9zaXRpb246cmVsYXRpdmU7bWluLXdpZHRoOjA7YmFja2dyb3VuZDojMDAxNTI5O3RyYW5zaXRpb246YWxsIC4yc30uYW50LWxheW91dC1zaWRlci1jaGlsZHJlbntoZWlnaHQ6MTAwJTttYXJnaW4tdG9wOi0uMXB4O3BhZGRpbmctdG9wOi4xcHh9LmFudC1sYXlvdXQtc2lkZXItY2hpbGRyZW4gLmFudC1tZW51LmFudC1tZW51LWlubGluZS1jb2xsYXBzZWR7d2lkdGg6YXV0b30uYW50LWxheW91dC1zaWRlci1oYXMtdHJpZ2dlcntwYWRkaW5nLWJvdHRvbTo0OHB4fS5hbnQtbGF5b3V0LXNpZGVyLXJpZ2h0e29yZGVyOjF9LmFudC1sYXlvdXQtc2lkZXItdHJpZ2dlcntwb3NpdGlvbjpmaXhlZDtib3R0b206MDt6LWluZGV4OjE7aGVpZ2h0OjQ4cHg7Y29sb3I6I2ZmZjtsaW5lLWhlaWdodDo0OHB4O3RleHQtYWxpZ246Y2VudGVyO2JhY2tncm91bmQ6IzAwMjE0MDtjdXJzb3I6cG9pbnRlcjt0cmFuc2l0aW9uOmFsbCAuMnN9LmFudC1sYXlvdXQtc2lkZXItemVyby13aWR0aD4qe292ZXJmbG93OmhpZGRlbn0uYW50LWxheW91dC1zaWRlci16ZXJvLXdpZHRoLXRyaWdnZXJ7cG9zaXRpb246YWJzb2x1dGU7dG9wOjY0cHg7cmlnaHQ6LTM2cHg7ei1pbmRleDoxO3dpZHRoOjM2cHg7aGVpZ2h0OjQycHg7Y29sb3I6I2ZmZjtmb250LXNpemU6MThweDtsaW5lLWhlaWdodDo0MnB4O3RleHQtYWxpZ246Y2VudGVyO2JhY2tncm91bmQ6IzAwMTUyOTtib3JkZXItcmFkaXVzOjAgMnB4IDJweCAwO2N1cnNvcjpwb2ludGVyO3RyYW5zaXRpb246YmFja2dyb3VuZCAuM3MgZWFzZX0uYW50LWxheW91dC1zaWRlci16ZXJvLXdpZHRoLXRyaWdnZXI6YWZ0ZXJ7cG9zaXRpb246YWJzb2x1dGU7dG9wOjA7cmlnaHQ6MDtib3R0b206MDtsZWZ0OjA7YmFja2dyb3VuZDp0cmFuc3BhcmVudDt0cmFuc2l0aW9uOmFsbCAuM3M7Y29udGVudDpcIlwifS5hbnQtbGF5b3V0LXNpZGVyLXplcm8td2lkdGgtdHJpZ2dlcjpob3ZlcjphZnRlcntiYWNrZ3JvdW5kOmhzbGEoMCwwJSwxMDAlLC4xKX0uYW50LWxheW91dC1zaWRlci16ZXJvLXdpZHRoLXRyaWdnZXItcmlnaHR7bGVmdDotMzZweDtib3JkZXItcmFkaXVzOjJweCAwIDAgMnB4fS5hbnQtbGF5b3V0LXNpZGVyLWxpZ2h0e2JhY2tncm91bmQ6I2ZmZn0uYW50LWxheW91dC1zaWRlci1saWdodCAuYW50LWxheW91dC1zaWRlci10cmlnZ2VyLC5hbnQtbGF5b3V0LXNpZGVyLWxpZ2h0IC5hbnQtbGF5b3V0LXNpZGVyLXplcm8td2lkdGgtdHJpZ2dlcntjb2xvcjpyZ2JhKDAsMCwwLC44NSk7YmFja2dyb3VuZDojZmZmfS5hbnQtbGF5b3V0LXJ0bHtkaXJlY3Rpb246cnRsfS5hbnQtbGlzdHtib3gtc2l6aW5nOmJvcmRlci1ib3g7bWFyZ2luOjA7cGFkZGluZzowO2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtmb250LXNpemU6MTRweDtmb250LXZhcmlhbnQ6dGFidWxhci1udW1zO2xpbmUtaGVpZ2h0OjEuNTcxNTtsaXN0LXN0eWxlOm5vbmU7Zm9udC1mZWF0dXJlLXNldHRpbmdzOlwidG51bVwiO3Bvc2l0aW9uOnJlbGF0aXZlfS5hbnQtbGlzdCAqe291dGxpbmU6bm9uZX0uYW50LWxpc3QtcGFnaW5hdGlvbnttYXJnaW4tdG9wOjI0cHg7dGV4dC1hbGlnbjpyaWdodH0uYW50LWxpc3QtcGFnaW5hdGlvbiAuYW50LXBhZ2luYXRpb24tb3B0aW9uc3t0ZXh0LWFsaWduOmxlZnR9LmFudC1saXN0LW1vcmV7bWFyZ2luLXRvcDoxMnB4O3RleHQtYWxpZ246Y2VudGVyfS5hbnQtbGlzdC1tb3JlIGJ1dHRvbntwYWRkaW5nLXJpZ2h0OjMycHg7cGFkZGluZy1sZWZ0OjMycHh9LmFudC1saXN0LXNwaW57bWluLWhlaWdodDo0MHB4O3RleHQtYWxpZ246Y2VudGVyfS5hbnQtbGlzdC1lbXB0eS10ZXh0e3BhZGRpbmc6MTZweDtjb2xvcjpyZ2JhKDAsMCwwLC4yNSk7Zm9udC1zaXplOjE0cHg7dGV4dC1hbGlnbjpjZW50ZXJ9LmFudC1saXN0LWl0ZW1ze21hcmdpbjowO3BhZGRpbmc6MDtsaXN0LXN0eWxlOm5vbmV9LmFudC1saXN0LWl0ZW17ZGlzcGxheTpmbGV4O2FsaWduLWl0ZW1zOmNlbnRlcjtqdXN0aWZ5LWNvbnRlbnQ6c3BhY2UtYmV0d2VlbjtwYWRkaW5nOjEycHggMDtjb2xvcjpyZ2JhKDAsMCwwLC44NSl9LmFudC1saXN0LWl0ZW0tbWV0YXtkaXNwbGF5OmZsZXg7ZmxleDoxO2FsaWduLWl0ZW1zOmZsZXgtc3RhcnQ7bWF4LXdpZHRoOjEwMCV9LmFudC1saXN0LWl0ZW0tbWV0YS1hdmF0YXJ7bWFyZ2luLXJpZ2h0OjE2cHh9LmFudC1saXN0LWl0ZW0tbWV0YS1jb250ZW50e2ZsZXg6MSAwO3dpZHRoOjA7Y29sb3I6cmdiYSgwLDAsMCwuODUpfS5hbnQtbGlzdC1pdGVtLW1ldGEtdGl0bGV7bWFyZ2luLWJvdHRvbTo0cHg7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtc2l6ZToxNHB4O2xpbmUtaGVpZ2h0OjEuNTcxNX0uYW50LWxpc3QtaXRlbS1tZXRhLXRpdGxlPmF7Y29sb3I6cmdiYSgwLDAsMCwuODUpO3RyYW5zaXRpb246YWxsIC4zc30uYW50LWxpc3QtaXRlbS1tZXRhLXRpdGxlPmE6aG92ZXJ7Y29sb3I6IzE4OTBmZn0uYW50LWxpc3QtaXRlbS1tZXRhLWRlc2NyaXB0aW9ue2NvbG9yOnJnYmEoMCwwLDAsLjQ1KTtmb250LXNpemU6MTRweDtsaW5lLWhlaWdodDoxLjU3MTV9LmFudC1saXN0LWl0ZW0tYWN0aW9ue2ZsZXg6MCAwIGF1dG87bWFyZ2luLWxlZnQ6NDhweDtwYWRkaW5nOjA7Zm9udC1zaXplOjA7bGlzdC1zdHlsZTpub25lfS5hbnQtbGlzdC1pdGVtLWFjdGlvbj5saXtwb3NpdGlvbjpyZWxhdGl2ZTtkaXNwbGF5OmlubGluZS1ibG9jaztwYWRkaW5nOjAgOHB4O2NvbG9yOnJnYmEoMCwwLDAsLjQ1KTtmb250LXNpemU6MTRweDtsaW5lLWhlaWdodDoxLjU3MTU7dGV4dC1hbGlnbjpjZW50ZXJ9LmFudC1saXN0LWl0ZW0tYWN0aW9uPmxpOmZpcnN0LWNoaWxke3BhZGRpbmctbGVmdDowfS5hbnQtbGlzdC1pdGVtLWFjdGlvbi1zcGxpdHtwb3NpdGlvbjphYnNvbHV0ZTt0b3A6NTAlO3JpZ2h0OjA7d2lkdGg6MXB4O2hlaWdodDoxNHB4O21hcmdpbi10b3A6LTdweDtiYWNrZ3JvdW5kLWNvbG9yOiNmMGYwZjB9LmFudC1saXN0LWZvb3RlciwuYW50LWxpc3QtaGVhZGVye2JhY2tncm91bmQ6dHJhbnNwYXJlbnR9LmFudC1saXN0LWZvb3RlciwuYW50LWxpc3QtaGVhZGVye3BhZGRpbmctdG9wOjEycHg7cGFkZGluZy1ib3R0b206MTJweH0uYW50LWxpc3QtZW1wdHl7cGFkZGluZzoxNnB4IDA7Y29sb3I6cmdiYSgwLDAsMCwuNDUpO2ZvbnQtc2l6ZToxMnB4O3RleHQtYWxpZ246Y2VudGVyfS5hbnQtbGlzdC1zcGxpdCAuYW50LWxpc3QtaXRlbXtib3JkZXItYm90dG9tOjFweCBzb2xpZCAjZjBmMGYwfS5hbnQtbGlzdC1zcGxpdCAuYW50LWxpc3QtaXRlbTpsYXN0LWNoaWxke2JvcmRlci1ib3R0b206bm9uZX0uYW50LWxpc3Qtc3BsaXQgLmFudC1saXN0LWhlYWRlcntib3JkZXItYm90dG9tOjFweCBzb2xpZCAjZjBmMGYwfS5hbnQtbGlzdC1zcGxpdC5hbnQtbGlzdC1lbXB0eSAuYW50LWxpc3QtZm9vdGVye2JvcmRlci10b3A6MXB4IHNvbGlkICNmMGYwZjB9LmFudC1saXN0LWxvYWRpbmcgLmFudC1saXN0LXNwaW4tbmVzdGVkLWxvYWRpbmd7bWluLWhlaWdodDozMnB4fS5hbnQtbGlzdC1zcGxpdC5hbnQtbGlzdC1zb21ldGhpbmctYWZ0ZXItbGFzdC1pdGVtIC5hbnQtc3Bpbi1jb250YWluZXI+LmFudC1saXN0LWl0ZW1zPi5hbnQtbGlzdC1pdGVtOmxhc3QtY2hpbGR7Ym9yZGVyLWJvdHRvbToxcHggc29saWQgI2YwZjBmMH0uYW50LWxpc3QtbGcgLmFudC1saXN0LWl0ZW17cGFkZGluZzoxNnB4IDI0cHh9LmFudC1saXN0LXNtIC5hbnQtbGlzdC1pdGVte3BhZGRpbmc6OHB4IDE2cHh9LmFudC1saXN0LXZlcnRpY2FsIC5hbnQtbGlzdC1pdGVte2FsaWduLWl0ZW1zOm5vcm1hbH0uYW50LWxpc3QtdmVydGljYWwgLmFudC1saXN0LWl0ZW0tbWFpbntkaXNwbGF5OmJsb2NrO2ZsZXg6MX0uYW50LWxpc3QtdmVydGljYWwgLmFudC1saXN0LWl0ZW0tZXh0cmF7bWFyZ2luLWxlZnQ6NDBweH0uYW50LWxpc3QtdmVydGljYWwgLmFudC1saXN0LWl0ZW0tbWV0YXttYXJnaW4tYm90dG9tOjE2cHh9LmFudC1saXN0LXZlcnRpY2FsIC5hbnQtbGlzdC1pdGVtLW1ldGEtdGl0bGV7bWFyZ2luLWJvdHRvbToxMnB4O2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtmb250LXNpemU6MTZweDtsaW5lLWhlaWdodDoyNHB4fS5hbnQtbGlzdC12ZXJ0aWNhbCAuYW50LWxpc3QtaXRlbS1hY3Rpb257bWFyZ2luLXRvcDoxNnB4O21hcmdpbi1sZWZ0OmF1dG99LmFudC1saXN0LXZlcnRpY2FsIC5hbnQtbGlzdC1pdGVtLWFjdGlvbj5saXtwYWRkaW5nOjAgMTZweH0uYW50LWxpc3QtdmVydGljYWwgLmFudC1saXN0LWl0ZW0tYWN0aW9uPmxpOmZpcnN0LWNoaWxke3BhZGRpbmctbGVmdDowfS5hbnQtbGlzdC1ncmlkIC5hbnQtY29sPi5hbnQtbGlzdC1pdGVte2Rpc3BsYXk6YmxvY2s7bWF4LXdpZHRoOjEwMCU7bWFyZ2luLWJvdHRvbToxNnB4O3BhZGRpbmctdG9wOjA7cGFkZGluZy1ib3R0b206MDtib3JkZXItYm90dG9tOm5vbmV9LmFudC1saXN0LWl0ZW0tbm8tZmxleHtkaXNwbGF5OmJsb2NrfS5hbnQtbGlzdDpub3QoLmFudC1saXN0LXZlcnRpY2FsKSAuYW50LWxpc3QtaXRlbS1uby1mbGV4IC5hbnQtbGlzdC1pdGVtLWFjdGlvbntmbG9hdDpyaWdodH0uYW50LWxpc3QtYm9yZGVyZWR7Ym9yZGVyOjFweCBzb2xpZCAjZDlkOWQ5O2JvcmRlci1yYWRpdXM6MnB4fS5hbnQtbGlzdC1ib3JkZXJlZCAuYW50LWxpc3QtZm9vdGVyLC5hbnQtbGlzdC1ib3JkZXJlZCAuYW50LWxpc3QtaGVhZGVyLC5hbnQtbGlzdC1ib3JkZXJlZCAuYW50LWxpc3QtaXRlbXtwYWRkaW5nLXJpZ2h0OjI0cHg7cGFkZGluZy1sZWZ0OjI0cHh9LmFudC1saXN0LWJvcmRlcmVkIC5hbnQtbGlzdC1wYWdpbmF0aW9ue21hcmdpbjoxNnB4IDI0cHh9LmFudC1saXN0LWJvcmRlcmVkLmFudC1saXN0LXNtIC5hbnQtbGlzdC1mb290ZXIsLmFudC1saXN0LWJvcmRlcmVkLmFudC1saXN0LXNtIC5hbnQtbGlzdC1oZWFkZXIsLmFudC1saXN0LWJvcmRlcmVkLmFudC1saXN0LXNtIC5hbnQtbGlzdC1pdGVte3BhZGRpbmc6OHB4IDE2cHh9LmFudC1saXN0LWJvcmRlcmVkLmFudC1saXN0LWxnIC5hbnQtbGlzdC1mb290ZXIsLmFudC1saXN0LWJvcmRlcmVkLmFudC1saXN0LWxnIC5hbnQtbGlzdC1oZWFkZXIsLmFudC1saXN0LWJvcmRlcmVkLmFudC1saXN0LWxnIC5hbnQtbGlzdC1pdGVte3BhZGRpbmc6MTZweCAyNHB4fUBtZWRpYSBzY3JlZW4gYW5kIChtYXgtd2lkdGg6NzY4cHgpey5hbnQtbGlzdC1pdGVtLWFjdGlvbiwuYW50LWxpc3QtdmVydGljYWwgLmFudC1saXN0LWl0ZW0tZXh0cmF7bWFyZ2luLWxlZnQ6MjRweH19QG1lZGlhIHNjcmVlbiBhbmQgKG1heC13aWR0aDo1NzZweCl7LmFudC1saXN0LWl0ZW17ZmxleC13cmFwOndyYXB9LmFudC1saXN0LWl0ZW0tYWN0aW9ue21hcmdpbi1sZWZ0OjEycHh9LmFudC1saXN0LXZlcnRpY2FsIC5hbnQtbGlzdC1pdGVte2ZsZXgtd3JhcDp3cmFwLXJldmVyc2V9LmFudC1saXN0LXZlcnRpY2FsIC5hbnQtbGlzdC1pdGVtLW1haW57bWluLXdpZHRoOjIyMHB4fS5hbnQtbGlzdC12ZXJ0aWNhbCAuYW50LWxpc3QtaXRlbS1leHRyYXttYXJnaW46YXV0byBhdXRvIDE2cHh9fS5hbnQtbGlzdC1ydGx7ZGlyZWN0aW9uOnJ0bDt0ZXh0LWFsaWduOnJpZ2h0fS5hbnQtbGlzdC1ydGwgLlJlYWN0VmlydHVhbGl6ZWRfX0xpc3QgLmFudC1saXN0LWl0ZW17ZGlyZWN0aW9uOnJ0bH0uYW50LWxpc3QtcnRsIC5hbnQtbGlzdC1wYWdpbmF0aW9ue3RleHQtYWxpZ246bGVmdH0uYW50LWxpc3QtcnRsIC5hbnQtbGlzdC1pdGVtLW1ldGEtYXZhdGFye21hcmdpbi1yaWdodDowO21hcmdpbi1sZWZ0OjE2cHh9LmFudC1saXN0LXJ0bCAuYW50LWxpc3QtaXRlbS1hY3Rpb257bWFyZ2luLXJpZ2h0OjQ4cHg7bWFyZ2luLWxlZnQ6MH0uYW50LWxpc3QuYW50LWxpc3QtcnRsIC5hbnQtbGlzdC1pdGVtLWFjdGlvbj5saTpmaXJzdC1jaGlsZHtwYWRkaW5nLXJpZ2h0OjA7cGFkZGluZy1sZWZ0OjE2cHh9LmFudC1saXN0LXJ0bCAuYW50LWxpc3QtaXRlbS1hY3Rpb24tc3BsaXR7cmlnaHQ6YXV0bztsZWZ0OjB9LmFudC1saXN0LXJ0bC5hbnQtbGlzdC12ZXJ0aWNhbCAuYW50LWxpc3QtaXRlbS1leHRyYXttYXJnaW4tcmlnaHQ6NDBweDttYXJnaW4tbGVmdDowfS5hbnQtbGlzdC1ydGwuYW50LWxpc3QtdmVydGljYWwgLmFudC1saXN0LWl0ZW0tYWN0aW9ue21hcmdpbi1yaWdodDphdXRvfS5hbnQtbGlzdC1ydGwgLmFudC1saXN0LXZlcnRpY2FsIC5hbnQtbGlzdC1pdGVtLWFjdGlvbj5saTpmaXJzdC1jaGlsZHtwYWRkaW5nLXJpZ2h0OjA7cGFkZGluZy1sZWZ0OjE2cHh9LmFudC1saXN0LXJ0bCAuYW50LWxpc3Q6bm90KC5hbnQtbGlzdC12ZXJ0aWNhbCkgLmFudC1saXN0LWl0ZW0tbm8tZmxleCAuYW50LWxpc3QtaXRlbS1hY3Rpb257ZmxvYXQ6bGVmdH1AbWVkaWEgc2NyZWVuIGFuZCAobWF4LXdpZHRoOjc2OHB4KXsuYW50LWxpc3QtcnRsIC5hbnQtbGlzdC1pdGVtLWFjdGlvbiwuYW50LWxpc3QtcnRsIC5hbnQtbGlzdC12ZXJ0aWNhbCAuYW50LWxpc3QtaXRlbS1leHRyYXttYXJnaW4tcmlnaHQ6MjRweDttYXJnaW4tbGVmdDowfX1AbWVkaWEgc2NyZWVuIGFuZCAobWF4LXdpZHRoOjU3NnB4KXsuYW50LWxpc3QtcnRsIC5hbnQtbGlzdC1pdGVtLWFjdGlvbnttYXJnaW4tcmlnaHQ6MjJweDttYXJnaW4tbGVmdDowfS5hbnQtbGlzdC1ydGwuYW50LWxpc3QtdmVydGljYWwgLmFudC1saXN0LWl0ZW0tZXh0cmF7bWFyZ2luOmF1dG8gYXV0byAxNnB4fX0uYW50LW1lbnRpb25zLXN0YXR1cy1lcnJvcjpub3QoLmFudC1tZW50aW9ucy1kaXNhYmxlZCk6bm90KC5hbnQtbWVudGlvbnMtYm9yZGVybGVzcykuYW50LW1lbnRpb25zLC5hbnQtbWVudGlvbnMtc3RhdHVzLWVycm9yOm5vdCguYW50LW1lbnRpb25zLWRpc2FibGVkKTpub3QoLmFudC1tZW50aW9ucy1ib3JkZXJsZXNzKS5hbnQtbWVudGlvbnM6aG92ZXJ7YmFja2dyb3VuZDojZmZmO2JvcmRlci1jb2xvcjojZmY0ZDRmfS5hbnQtbWVudGlvbnMtc3RhdHVzLWVycm9yOm5vdCguYW50LW1lbnRpb25zLWRpc2FibGVkKTpub3QoLmFudC1tZW50aW9ucy1ib3JkZXJsZXNzKS5hbnQtbWVudGlvbnMtZm9jdXNlZCwuYW50LW1lbnRpb25zLXN0YXR1cy1lcnJvcjpub3QoLmFudC1tZW50aW9ucy1kaXNhYmxlZCk6bm90KC5hbnQtbWVudGlvbnMtYm9yZGVybGVzcykuYW50LW1lbnRpb25zOmZvY3Vze2JvcmRlci1jb2xvcjojZmY3ODc1O2JveC1zaGFkb3c6MCAwIDAgMnB4IHJnYmEoMjU1LDc3LDc5LC4yKTtib3JkZXItcmlnaHQtd2lkdGg6MXB4O291dGxpbmU6MH0uYW50LW1lbnRpb25zLXN0YXR1cy1lcnJvciAuYW50LWlucHV0LXByZWZpeHtjb2xvcjojZmY0ZDRmfS5hbnQtbWVudGlvbnMtc3RhdHVzLXdhcm5pbmc6bm90KC5hbnQtbWVudGlvbnMtZGlzYWJsZWQpOm5vdCguYW50LW1lbnRpb25zLWJvcmRlcmxlc3MpLmFudC1tZW50aW9ucywuYW50LW1lbnRpb25zLXN0YXR1cy13YXJuaW5nOm5vdCguYW50LW1lbnRpb25zLWRpc2FibGVkKTpub3QoLmFudC1tZW50aW9ucy1ib3JkZXJsZXNzKS5hbnQtbWVudGlvbnM6aG92ZXJ7YmFja2dyb3VuZDojZmZmO2JvcmRlci1jb2xvcjojZmFhZDE0fS5hbnQtbWVudGlvbnMtc3RhdHVzLXdhcm5pbmc6bm90KC5hbnQtbWVudGlvbnMtZGlzYWJsZWQpOm5vdCguYW50LW1lbnRpb25zLWJvcmRlcmxlc3MpLmFudC1tZW50aW9ucy1mb2N1c2VkLC5hbnQtbWVudGlvbnMtc3RhdHVzLXdhcm5pbmc6bm90KC5hbnQtbWVudGlvbnMtZGlzYWJsZWQpOm5vdCguYW50LW1lbnRpb25zLWJvcmRlcmxlc3MpLmFudC1tZW50aW9uczpmb2N1c3tib3JkZXItY29sb3I6I2ZmYzUzZDtib3gtc2hhZG93OjAgMCAwIDJweCByZ2JhKDI1MCwxNzMsMjAsLjIpO2JvcmRlci1yaWdodC13aWR0aDoxcHg7b3V0bGluZTowfS5hbnQtbWVudGlvbnMtc3RhdHVzLXdhcm5pbmcgLmFudC1pbnB1dC1wcmVmaXh7Y29sb3I6I2ZhYWQxNH0uYW50LW1lbnRpb25ze2JveC1zaXppbmc6Ym9yZGVyLWJveDttYXJnaW46MDtmb250LXZhcmlhbnQ6dGFidWxhci1udW1zO2xpc3Qtc3R5bGU6bm9uZTtmb250LWZlYXR1cmUtc2V0dGluZ3M6XCJ0bnVtXCI7d2lkdGg6MTAwJTttaW4td2lkdGg6MDtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7Zm9udC1zaXplOjE0cHg7YmFja2dyb3VuZC1jb2xvcjojZmZmO2JhY2tncm91bmQtaW1hZ2U6bm9uZTtib3JkZXI6MXB4IHNvbGlkICNkOWQ5ZDk7Ym9yZGVyLXJhZGl1czoycHg7dHJhbnNpdGlvbjphbGwgLjNzO3Bvc2l0aW9uOnJlbGF0aXZlO2Rpc3BsYXk6aW5saW5lLWJsb2NrO2hlaWdodDphdXRvO3BhZGRpbmc6MDtvdmVyZmxvdzpoaWRkZW47bGluZS1oZWlnaHQ6MS41NzE1O3doaXRlLXNwYWNlOnByZS13cmFwO3ZlcnRpY2FsLWFsaWduOmJvdHRvbX0uYW50LW1lbnRpb25zOjotbW96LXBsYWNlaG9sZGVye2NvbG9yOiNiZmJmYmY7LW1vei11c2VyLXNlbGVjdDpub25lO3VzZXItc2VsZWN0Om5vbmV9LmFudC1tZW50aW9uczotbXMtaW5wdXQtcGxhY2Vob2xkZXJ7Y29sb3I6I2JmYmZiZjstbXMtdXNlci1zZWxlY3Q6bm9uZTt1c2VyLXNlbGVjdDpub25lfS5hbnQtbWVudGlvbnM6OnBsYWNlaG9sZGVye2NvbG9yOiNiZmJmYmY7LXdlYmtpdC11c2VyLXNlbGVjdDpub25lOy1tb3otdXNlci1zZWxlY3Q6bm9uZTstbXMtdXNlci1zZWxlY3Q6bm9uZTt1c2VyLXNlbGVjdDpub25lfS5hbnQtbWVudGlvbnM6LW1vei1wbGFjZWhvbGRlci1zaG93bnt0ZXh0LW92ZXJmbG93OmVsbGlwc2lzfS5hbnQtbWVudGlvbnM6LW1zLWlucHV0LXBsYWNlaG9sZGVye3RleHQtb3ZlcmZsb3c6ZWxsaXBzaXN9LmFudC1tZW50aW9uczpwbGFjZWhvbGRlci1zaG93bnt0ZXh0LW92ZXJmbG93OmVsbGlwc2lzfS5hbnQtbWVudGlvbnMtZm9jdXNlZCwuYW50LW1lbnRpb25zOmZvY3VzLC5hbnQtbWVudGlvbnM6aG92ZXJ7Ym9yZGVyLWNvbG9yOiM0MGE5ZmY7Ym9yZGVyLXJpZ2h0LXdpZHRoOjFweH0uYW50LW1lbnRpb25zLWZvY3VzZWQsLmFudC1tZW50aW9uczpmb2N1c3tib3gtc2hhZG93OjAgMCAwIDJweCByZ2JhKDI0LDE0NCwyNTUsLjIpO291dGxpbmU6MH0uYW50LW1lbnRpb25zLWRpc2FibGVke2NvbG9yOnJnYmEoMCwwLDAsLjI1KTtiYWNrZ3JvdW5kLWNvbG9yOiNmNWY1ZjU7Ym9yZGVyLWNvbG9yOiNkOWQ5ZDk7Ym94LXNoYWRvdzpub25lO2N1cnNvcjpub3QtYWxsb3dlZDtvcGFjaXR5OjF9LmFudC1tZW50aW9ucy1kaXNhYmxlZDpob3Zlcntib3JkZXItY29sb3I6I2Q5ZDlkOTtib3JkZXItcmlnaHQtd2lkdGg6MXB4fS5hbnQtbWVudGlvbnNbZGlzYWJsZWRde2NvbG9yOnJnYmEoMCwwLDAsLjI1KTtiYWNrZ3JvdW5kLWNvbG9yOiNmNWY1ZjU7Ym9yZGVyLWNvbG9yOiNkOWQ5ZDk7Ym94LXNoYWRvdzpub25lO2N1cnNvcjpub3QtYWxsb3dlZDtvcGFjaXR5OjF9LmFudC1tZW50aW9uc1tkaXNhYmxlZF06aG92ZXJ7Ym9yZGVyLWNvbG9yOiNkOWQ5ZDk7Ym9yZGVyLXJpZ2h0LXdpZHRoOjFweH0uYW50LW1lbnRpb25zLWJvcmRlcmxlc3MsLmFudC1tZW50aW9ucy1ib3JkZXJsZXNzLWRpc2FibGVkLC5hbnQtbWVudGlvbnMtYm9yZGVybGVzcy1mb2N1c2VkLC5hbnQtbWVudGlvbnMtYm9yZGVybGVzczpmb2N1cywuYW50LW1lbnRpb25zLWJvcmRlcmxlc3M6aG92ZXIsLmFudC1tZW50aW9ucy1ib3JkZXJsZXNzW2Rpc2FibGVkXXtiYWNrZ3JvdW5kLWNvbG9yOnRyYW5zcGFyZW50O2JvcmRlcjpub25lO2JveC1zaGFkb3c6bm9uZX10ZXh0YXJlYS5hbnQtbWVudGlvbnN7bWF4LXdpZHRoOjEwMCU7aGVpZ2h0OmF1dG87bWluLWhlaWdodDozMnB4O2xpbmUtaGVpZ2h0OjEuNTcxNTt2ZXJ0aWNhbC1hbGlnbjpib3R0b207dHJhbnNpdGlvbjphbGwgLjNzLGhlaWdodCAwc30uYW50LW1lbnRpb25zLWxne3BhZGRpbmc6Ni41cHggMTFweDtmb250LXNpemU6MTZweH0uYW50LW1lbnRpb25zLXNte3BhZGRpbmc6MCA3cHh9LmFudC1tZW50aW9ucy1kaXNhYmxlZD50ZXh0YXJlYXtjb2xvcjpyZ2JhKDAsMCwwLC4yNSk7YmFja2dyb3VuZC1jb2xvcjojZjVmNWY1O2JvcmRlci1jb2xvcjojZDlkOWQ5O2JveC1zaGFkb3c6bm9uZTtjdXJzb3I6bm90LWFsbG93ZWQ7b3BhY2l0eToxfS5hbnQtbWVudGlvbnMtZGlzYWJsZWQ+dGV4dGFyZWE6aG92ZXJ7Ym9yZGVyLWNvbG9yOiNkOWQ5ZDk7Ym9yZGVyLXJpZ2h0LXdpZHRoOjFweH0uYW50LW1lbnRpb25zLWZvY3VzZWR7Ym9yZGVyLWNvbG9yOiM0MGE5ZmY7Ym94LXNoYWRvdzowIDAgMCAycHggcmdiYSgyNCwxNDQsMjU1LC4yKTtib3JkZXItcmlnaHQtd2lkdGg6MXB4O291dGxpbmU6MH0uYW50LW1lbnRpb25zLW1lYXN1cmUsLmFudC1tZW50aW9ucz50ZXh0YXJlYXttaW4taGVpZ2h0OjMwcHg7bWFyZ2luOjA7cGFkZGluZzo0cHggMTFweDtvdmVyZmxvdzppbmhlcml0O292ZXJmbG93LXg6aGlkZGVuO292ZXJmbG93LXk6YXV0bztmb250LXdlaWdodDppbmhlcml0O2ZvbnQtc2l6ZTppbmhlcml0O2ZvbnQtZmFtaWx5OmluaGVyaXQ7Zm9udC1zdHlsZTppbmhlcml0O2ZvbnQtdmFyaWFudDppbmhlcml0O2ZvbnQtc2l6ZS1hZGp1c3Q6aW5oZXJpdDtmb250LXN0cmV0Y2g6aW5oZXJpdDtsaW5lLWhlaWdodDppbmhlcml0O2RpcmVjdGlvbjppbmhlcml0O2xldHRlci1zcGFjaW5nOmluaGVyaXQ7d2hpdGUtc3BhY2U6aW5oZXJpdDt0ZXh0LWFsaWduOmluaGVyaXQ7dmVydGljYWwtYWxpZ246dG9wO3dvcmQtd3JhcDpicmVhay13b3JkO3dvcmQtYnJlYWs6aW5oZXJpdDstbW96LXRhYi1zaXplOmluaGVyaXQ7LW8tdGFiLXNpemU6aW5oZXJpdDt0YWItc2l6ZTppbmhlcml0fS5hbnQtbWVudGlvbnM+dGV4dGFyZWF7d2lkdGg6MTAwJTtib3JkZXI6bm9uZTtvdXRsaW5lOm5vbmU7cmVzaXplOm5vbmV9LmFudC1tZW50aW9ucz50ZXh0YXJlYTo6LW1vei1wbGFjZWhvbGRlcntjb2xvcjojYmZiZmJmOy1tb3otdXNlci1zZWxlY3Q6bm9uZTt1c2VyLXNlbGVjdDpub25lfS5hbnQtbWVudGlvbnM+dGV4dGFyZWE6LW1zLWlucHV0LXBsYWNlaG9sZGVye2NvbG9yOiNiZmJmYmY7LW1zLXVzZXItc2VsZWN0Om5vbmU7dXNlci1zZWxlY3Q6bm9uZX0uYW50LW1lbnRpb25zPnRleHRhcmVhOjpwbGFjZWhvbGRlcntjb2xvcjojYmZiZmJmOy13ZWJraXQtdXNlci1zZWxlY3Q6bm9uZTstbW96LXVzZXItc2VsZWN0Om5vbmU7LW1zLXVzZXItc2VsZWN0Om5vbmU7dXNlci1zZWxlY3Q6bm9uZX0uYW50LW1lbnRpb25zPnRleHRhcmVhOi1tb3otcGxhY2Vob2xkZXItc2hvd257dGV4dC1vdmVyZmxvdzplbGxpcHNpc30uYW50LW1lbnRpb25zPnRleHRhcmVhOi1tcy1pbnB1dC1wbGFjZWhvbGRlcnt0ZXh0LW92ZXJmbG93OmVsbGlwc2lzfS5hbnQtbWVudGlvbnM+dGV4dGFyZWE6cGxhY2Vob2xkZXItc2hvd257dGV4dC1vdmVyZmxvdzplbGxpcHNpc30uYW50LW1lbnRpb25zLW1lYXN1cmV7cG9zaXRpb246YWJzb2x1dGU7dG9wOjA7cmlnaHQ6MDtib3R0b206MDtsZWZ0OjA7ei1pbmRleDotMTtjb2xvcjp0cmFuc3BhcmVudDtwb2ludGVyLWV2ZW50czpub25lfS5hbnQtbWVudGlvbnMtbWVhc3VyZT5zcGFue2Rpc3BsYXk6aW5saW5lLWJsb2NrO21pbi1oZWlnaHQ6MWVtfS5hbnQtbWVudGlvbnMtZHJvcGRvd257bWFyZ2luOjA7cGFkZGluZzowO2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtmb250LXZhcmlhbnQ6dGFidWxhci1udW1zO2xpbmUtaGVpZ2h0OjEuNTcxNTtsaXN0LXN0eWxlOm5vbmU7Zm9udC1mZWF0dXJlLXNldHRpbmdzOlwidG51bVwiO3Bvc2l0aW9uOmFic29sdXRlO3RvcDotOTk5OXB4O2xlZnQ6LTk5OTlweDt6LWluZGV4OjEwNTA7Ym94LXNpemluZzpib3JkZXItYm94O2ZvbnQtc2l6ZToxNHB4O2ZvbnQtdmFyaWFudDpub3JtYWw7YmFja2dyb3VuZC1jb2xvcjojZmZmO2JvcmRlci1yYWRpdXM6MnB4O291dGxpbmU6bm9uZTtib3gtc2hhZG93OjAgM3B4IDZweCAtNHB4IHJnYmEoMCwwLDAsLjEyKSwwIDZweCAxNnB4IDAgcmdiYSgwLDAsMCwuMDgpLDAgOXB4IDI4cHggOHB4IHJnYmEoMCwwLDAsLjA1KX0uYW50LW1lbnRpb25zLWRyb3Bkb3duLWhpZGRlbntkaXNwbGF5Om5vbmV9LmFudC1tZW50aW9ucy1kcm9wZG93bi1tZW51e21heC1oZWlnaHQ6MjUwcHg7bWFyZ2luLWJvdHRvbTowO3BhZGRpbmctbGVmdDowO292ZXJmbG93OmF1dG87bGlzdC1zdHlsZTpub25lO291dGxpbmU6bm9uZX0uYW50LW1lbnRpb25zLWRyb3Bkb3duLW1lbnUtaXRlbXtwb3NpdGlvbjpyZWxhdGl2ZTtkaXNwbGF5OmJsb2NrO21pbi13aWR0aDoxMDBweDtwYWRkaW5nOjVweCAxMnB4O292ZXJmbG93OmhpZGRlbjtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7Zm9udC13ZWlnaHQ6NDAwO2xpbmUtaGVpZ2h0OjEuNTcxNTt3aGl0ZS1zcGFjZTpub3dyYXA7dGV4dC1vdmVyZmxvdzplbGxpcHNpcztjdXJzb3I6cG9pbnRlcjt0cmFuc2l0aW9uOmJhY2tncm91bmQgLjNzIGVhc2V9LmFudC1tZW50aW9ucy1kcm9wZG93bi1tZW51LWl0ZW06aG92ZXJ7YmFja2dyb3VuZC1jb2xvcjojZjVmNWY1fS5hbnQtbWVudGlvbnMtZHJvcGRvd24tbWVudS1pdGVtOmZpcnN0LWNoaWxke2JvcmRlci1yYWRpdXM6MnB4IDJweCAwIDB9LmFudC1tZW50aW9ucy1kcm9wZG93bi1tZW51LWl0ZW06bGFzdC1jaGlsZHtib3JkZXItcmFkaXVzOjAgMCAycHggMnB4fS5hbnQtbWVudGlvbnMtZHJvcGRvd24tbWVudS1pdGVtLWRpc2FibGVke2NvbG9yOnJnYmEoMCwwLDAsLjI1KTtjdXJzb3I6bm90LWFsbG93ZWR9LmFudC1tZW50aW9ucy1kcm9wZG93bi1tZW51LWl0ZW0tZGlzYWJsZWQ6aG92ZXJ7Y29sb3I6cmdiYSgwLDAsMCwuMjUpO2JhY2tncm91bmQtY29sb3I6I2ZmZjtjdXJzb3I6bm90LWFsbG93ZWR9LmFudC1tZW50aW9ucy1kcm9wZG93bi1tZW51LWl0ZW0tc2VsZWN0ZWR7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtd2VpZ2h0OjYwMDtiYWNrZ3JvdW5kLWNvbG9yOiNmYWZhZmF9LmFudC1tZW50aW9ucy1kcm9wZG93bi1tZW51LWl0ZW0tYWN0aXZle2JhY2tncm91bmQtY29sb3I6I2Y1ZjVmNX0uYW50LW1lbnRpb25zLXN1ZmZpeHtwb3NpdGlvbjphYnNvbHV0ZTt0b3A6MDtyaWdodDoxMXB4O2JvdHRvbTowO3otaW5kZXg6MTtkaXNwbGF5OmlubGluZS1mbGV4O2FsaWduLWl0ZW1zOmNlbnRlcjttYXJnaW46YXV0b30uYW50LW1lbnRpb25zLXJ0bHtkaXJlY3Rpb246cnRsfS5hbnQtbWVudS1pdGVtLWRhbmdlci5hbnQtbWVudS1pdGVtLC5hbnQtbWVudS1pdGVtLWRhbmdlci5hbnQtbWVudS1pdGVtLWFjdGl2ZSwuYW50LW1lbnUtaXRlbS1kYW5nZXIuYW50LW1lbnUtaXRlbTpob3Zlcntjb2xvcjojZmY0ZDRmfS5hbnQtbWVudS1pdGVtLWRhbmdlci5hbnQtbWVudS1pdGVtOmFjdGl2ZXtiYWNrZ3JvdW5kOiNmZmYxZjB9LmFudC1tZW51LWl0ZW0tZGFuZ2VyLmFudC1tZW51LWl0ZW0tc2VsZWN0ZWQsLmFudC1tZW51LWl0ZW0tZGFuZ2VyLmFudC1tZW51LWl0ZW0tc2VsZWN0ZWQ+YSwuYW50LW1lbnUtaXRlbS1kYW5nZXIuYW50LW1lbnUtaXRlbS1zZWxlY3RlZD5hOmhvdmVye2NvbG9yOiNmZjRkNGZ9LmFudC1tZW51Om5vdCguYW50LW1lbnUtaG9yaXpvbnRhbCkgLmFudC1tZW51LWl0ZW0tZGFuZ2VyLmFudC1tZW51LWl0ZW0tc2VsZWN0ZWR7YmFja2dyb3VuZC1jb2xvcjojZmZmMWYwfS5hbnQtbWVudS1pbmxpbmUgLmFudC1tZW51LWl0ZW0tZGFuZ2VyLmFudC1tZW51LWl0ZW06YWZ0ZXJ7Ym9yZGVyLXJpZ2h0LWNvbG9yOiNmZjRkNGZ9LmFudC1tZW51LWRhcmsgLmFudC1tZW51LWl0ZW0tZGFuZ2VyLmFudC1tZW51LWl0ZW0sLmFudC1tZW51LWRhcmsgLmFudC1tZW51LWl0ZW0tZGFuZ2VyLmFudC1tZW51LWl0ZW06aG92ZXIsLmFudC1tZW51LWRhcmsgLmFudC1tZW51LWl0ZW0tZGFuZ2VyLmFudC1tZW51LWl0ZW0+YXtjb2xvcjojZmY0ZDRmfS5hbnQtbWVudS1kYXJrLmFudC1tZW51LWRhcms6bm90KC5hbnQtbWVudS1ob3Jpem9udGFsKSAuYW50LW1lbnUtaXRlbS1kYW5nZXIuYW50LW1lbnUtaXRlbS1zZWxlY3RlZHtjb2xvcjojZmZmO2JhY2tncm91bmQtY29sb3I6I2ZmNGQ0Zn0uYW50LW1lbnV7Ym94LXNpemluZzpib3JkZXItYm94O2ZvbnQtdmFyaWFudDp0YWJ1bGFyLW51bXM7bGluZS1oZWlnaHQ6MS41NzE1O2ZvbnQtZmVhdHVyZS1zZXR0aW5nczpcInRudW1cIjttYXJnaW46MDtwYWRkaW5nOjA7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtc2l6ZToxNHB4O2xpbmUtaGVpZ2h0OjA7dGV4dC1hbGlnbjpsZWZ0O2xpc3Qtc3R5bGU6bm9uZTtiYWNrZ3JvdW5kOiNmZmY7b3V0bGluZTpub25lO2JveC1zaGFkb3c6MCAzcHggNnB4IC00cHggcmdiYSgwLDAsMCwuMTIpLDAgNnB4IDE2cHggMCByZ2JhKDAsMCwwLC4wOCksMCA5cHggMjhweCA4cHggcmdiYSgwLDAsMCwuMDUpO3RyYW5zaXRpb246YmFja2dyb3VuZCAuM3Msd2lkdGggLjNzIGN1YmljLWJlemllciguMiwwLDAsMSkgMHN9LmFudC1tZW51OmFmdGVyLC5hbnQtbWVudTpiZWZvcmV7ZGlzcGxheTp0YWJsZTtjb250ZW50OlwiXCJ9LmFudC1tZW51OmFmdGVye2NsZWFyOmJvdGh9LmFudC1tZW51LmFudC1tZW51LXJvb3Q6Zm9jdXMtdmlzaWJsZXtib3gtc2hhZG93OjAgMCAwIDJweCAjYmFlN2ZmfS5hbnQtbWVudSBvbCwuYW50LW1lbnUgdWx7bWFyZ2luOjA7cGFkZGluZzowO2xpc3Qtc3R5bGU6bm9uZX0uYW50LW1lbnUtb3ZlcmZsb3d7ZGlzcGxheTpmbGV4fS5hbnQtbWVudS1vdmVyZmxvdy1pdGVte2ZsZXg6bm9uZX0uYW50LW1lbnUtaGlkZGVuLC5hbnQtbWVudS1zdWJtZW51LWhpZGRlbntkaXNwbGF5Om5vbmV9LmFudC1tZW51LWl0ZW0tZ3JvdXAtdGl0bGV7aGVpZ2h0OjEuNTcxNTtwYWRkaW5nOjhweCAxNnB4O2NvbG9yOnJnYmEoMCwwLDAsLjQ1KTtmb250LXNpemU6MTRweDtsaW5lLWhlaWdodDoxLjU3MTU7dHJhbnNpdGlvbjphbGwgLjNzfS5hbnQtbWVudS1ob3Jpem9udGFsIC5hbnQtbWVudS1zdWJtZW51e3RyYW5zaXRpb246Ym9yZGVyLWNvbG9yIC4zcyBjdWJpYy1iZXppZXIoLjY0NSwuMDQ1LC4zNTUsMSksYmFja2dyb3VuZCAuM3MgY3ViaWMtYmV6aWVyKC42NDUsLjA0NSwuMzU1LDEpfS5hbnQtbWVudS1zdWJtZW51LC5hbnQtbWVudS1zdWJtZW51LWlubGluZXt0cmFuc2l0aW9uOmJvcmRlci1jb2xvciAuM3MgY3ViaWMtYmV6aWVyKC42NDUsLjA0NSwuMzU1LDEpLGJhY2tncm91bmQgLjNzIGN1YmljLWJlemllciguNjQ1LC4wNDUsLjM1NSwxKSxwYWRkaW5nIC4xNXMgY3ViaWMtYmV6aWVyKC42NDUsLjA0NSwuMzU1LDEpfS5hbnQtbWVudS1zdWJtZW51LXNlbGVjdGVke2NvbG9yOiMxODkwZmZ9LmFudC1tZW51LWl0ZW06YWN0aXZlLC5hbnQtbWVudS1zdWJtZW51LXRpdGxlOmFjdGl2ZXtiYWNrZ3JvdW5kOiNlNmY3ZmZ9LmFudC1tZW51LXN1Ym1lbnUgLmFudC1tZW51LXN1YntjdXJzb3I6YXV0bzt0cmFuc2l0aW9uOmJhY2tncm91bmQgLjNzIGN1YmljLWJlemllciguNjQ1LC4wNDUsLjM1NSwxKSxwYWRkaW5nIC4zcyBjdWJpYy1iZXppZXIoLjY0NSwuMDQ1LC4zNTUsMSl9LmFudC1tZW51LXRpdGxlLWNvbnRlbnR7dHJhbnNpdGlvbjpjb2xvciAuM3N9LmFudC1tZW51LWl0ZW0gYXtjb2xvcjpyZ2JhKDAsMCwwLC44NSl9LmFudC1tZW51LWl0ZW0gYTpob3Zlcntjb2xvcjojMTg5MGZmfS5hbnQtbWVudS1pdGVtIGE6YmVmb3Jle3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO3JpZ2h0OjA7Ym90dG9tOjA7bGVmdDowO2JhY2tncm91bmQtY29sb3I6dHJhbnNwYXJlbnQ7Y29udGVudDpcIlwifS5hbnQtbWVudS1pdGVtPi5hbnQtYmFkZ2UgYXtjb2xvcjpyZ2JhKDAsMCwwLC44NSl9LmFudC1tZW51LWl0ZW0+LmFudC1iYWRnZSBhOmhvdmVye2NvbG9yOiMxODkwZmZ9LmFudC1tZW51LWl0ZW0tZGl2aWRlcntvdmVyZmxvdzpoaWRkZW47bGluZS1oZWlnaHQ6MDtib3JkZXI6c29saWQgI2YwZjBmMDtib3JkZXItd2lkdGg6MXB4IDAgMH0uYW50LW1lbnUtaXRlbS1kaXZpZGVyLWRhc2hlZHtib3JkZXItc3R5bGU6ZGFzaGVkfS5hbnQtbWVudS1ob3Jpem9udGFsIC5hbnQtbWVudS1pdGVtLC5hbnQtbWVudS1ob3Jpem9udGFsIC5hbnQtbWVudS1zdWJtZW51e21hcmdpbi10b3A6LTFweH0uYW50LW1lbnUtaG9yaXpvbnRhbD4uYW50LW1lbnUtaXRlbS1hY3RpdmUsLmFudC1tZW51LWhvcml6b250YWw+LmFudC1tZW51LWl0ZW06aG92ZXIsLmFudC1tZW51LWhvcml6b250YWw+LmFudC1tZW51LXN1Ym1lbnUgLmFudC1tZW51LXN1Ym1lbnUtdGl0bGU6aG92ZXJ7YmFja2dyb3VuZC1jb2xvcjp0cmFuc3BhcmVudH0uYW50LW1lbnUtaXRlbS1zZWxlY3RlZCwuYW50LW1lbnUtaXRlbS1zZWxlY3RlZCBhLC5hbnQtbWVudS1pdGVtLXNlbGVjdGVkIGE6aG92ZXJ7Y29sb3I6IzE4OTBmZn0uYW50LW1lbnU6bm90KC5hbnQtbWVudS1ob3Jpem9udGFsKSAuYW50LW1lbnUtaXRlbS1zZWxlY3RlZHtiYWNrZ3JvdW5kLWNvbG9yOiNlNmY3ZmZ9LmFudC1tZW51LWlubGluZSwuYW50LW1lbnUtdmVydGljYWwsLmFudC1tZW51LXZlcnRpY2FsLWxlZnR7Ym9yZGVyLXJpZ2h0OjFweCBzb2xpZCAjZjBmMGYwfS5hbnQtbWVudS12ZXJ0aWNhbC1yaWdodHtib3JkZXItbGVmdDoxcHggc29saWQgI2YwZjBmMH0uYW50LW1lbnUtdmVydGljYWwtbGVmdC5hbnQtbWVudS1zdWIsLmFudC1tZW51LXZlcnRpY2FsLXJpZ2h0LmFudC1tZW51LXN1YiwuYW50LW1lbnUtdmVydGljYWwuYW50LW1lbnUtc3Vie21pbi13aWR0aDoxNjBweDttYXgtaGVpZ2h0OmNhbGMoMTAwdmggLSAxMDBweCk7cGFkZGluZzowO292ZXJmbG93OmhpZGRlbjtib3JkZXItcmlnaHQ6MH0uYW50LW1lbnUtdmVydGljYWwtbGVmdC5hbnQtbWVudS1zdWI6bm90KFtjbGFzcyo9LWFjdGl2ZV0pLC5hbnQtbWVudS12ZXJ0aWNhbC1yaWdodC5hbnQtbWVudS1zdWI6bm90KFtjbGFzcyo9LWFjdGl2ZV0pLC5hbnQtbWVudS12ZXJ0aWNhbC5hbnQtbWVudS1zdWI6bm90KFtjbGFzcyo9LWFjdGl2ZV0pe292ZXJmbG93LXg6aGlkZGVuO292ZXJmbG93LXk6YXV0b30uYW50LW1lbnUtdmVydGljYWwtbGVmdC5hbnQtbWVudS1zdWIgLmFudC1tZW51LWl0ZW0sLmFudC1tZW51LXZlcnRpY2FsLXJpZ2h0LmFudC1tZW51LXN1YiAuYW50LW1lbnUtaXRlbSwuYW50LW1lbnUtdmVydGljYWwuYW50LW1lbnUtc3ViIC5hbnQtbWVudS1pdGVte2xlZnQ6MDttYXJnaW4tbGVmdDowO2JvcmRlci1yaWdodDowfS5hbnQtbWVudS12ZXJ0aWNhbC1sZWZ0LmFudC1tZW51LXN1YiAuYW50LW1lbnUtaXRlbTphZnRlciwuYW50LW1lbnUtdmVydGljYWwtcmlnaHQuYW50LW1lbnUtc3ViIC5hbnQtbWVudS1pdGVtOmFmdGVyLC5hbnQtbWVudS12ZXJ0aWNhbC5hbnQtbWVudS1zdWIgLmFudC1tZW51LWl0ZW06YWZ0ZXJ7Ym9yZGVyLXJpZ2h0OjB9LmFudC1tZW51LXZlcnRpY2FsLWxlZnQuYW50LW1lbnUtc3ViPi5hbnQtbWVudS1pdGVtLC5hbnQtbWVudS12ZXJ0aWNhbC1sZWZ0LmFudC1tZW51LXN1Yj4uYW50LW1lbnUtc3VibWVudSwuYW50LW1lbnUtdmVydGljYWwtcmlnaHQuYW50LW1lbnUtc3ViPi5hbnQtbWVudS1pdGVtLC5hbnQtbWVudS12ZXJ0aWNhbC1yaWdodC5hbnQtbWVudS1zdWI+LmFudC1tZW51LXN1Ym1lbnUsLmFudC1tZW51LXZlcnRpY2FsLmFudC1tZW51LXN1Yj4uYW50LW1lbnUtaXRlbSwuYW50LW1lbnUtdmVydGljYWwuYW50LW1lbnUtc3ViPi5hbnQtbWVudS1zdWJtZW51e3RyYW5zZm9ybS1vcmlnaW46MCAwfS5hbnQtbWVudS1ob3Jpem9udGFsLmFudC1tZW51LXN1YnttaW4td2lkdGg6MTE0cHh9LmFudC1tZW51LWhvcml6b250YWwgLmFudC1tZW51LWl0ZW0sLmFudC1tZW51LWhvcml6b250YWwgLmFudC1tZW51LXN1Ym1lbnUtdGl0bGV7dHJhbnNpdGlvbjpib3JkZXItY29sb3IgLjNzLGJhY2tncm91bmQgLjNzfS5hbnQtbWVudS1pdGVtLC5hbnQtbWVudS1zdWJtZW51LXRpdGxle3Bvc2l0aW9uOnJlbGF0aXZlO2Rpc3BsYXk6YmxvY2s7bWFyZ2luOjA7cGFkZGluZzowIDIwcHg7d2hpdGUtc3BhY2U6bm93cmFwO2N1cnNvcjpwb2ludGVyO3RyYW5zaXRpb246Ym9yZGVyLWNvbG9yIC4zcyxiYWNrZ3JvdW5kIC4zcyxwYWRkaW5nIC4zcyBjdWJpYy1iZXppZXIoLjY0NSwuMDQ1LC4zNTUsMSl9LmFudC1tZW51LWl0ZW0gLmFudC1tZW51LWl0ZW0taWNvbiwuYW50LW1lbnUtaXRlbSAuYW50aWNvbiwuYW50LW1lbnUtc3VibWVudS10aXRsZSAuYW50LW1lbnUtaXRlbS1pY29uLC5hbnQtbWVudS1zdWJtZW51LXRpdGxlIC5hbnRpY29ue21pbi13aWR0aDoxNHB4O2ZvbnQtc2l6ZToxNHB4O3RyYW5zaXRpb246Zm9udC1zaXplIC4xNXMgY3ViaWMtYmV6aWVyKC4yMTUsLjYxLC4zNTUsMSksbWFyZ2luIC4zcyBjdWJpYy1iZXppZXIoLjY0NSwuMDQ1LC4zNTUsMSksY29sb3IgLjNzfS5hbnQtbWVudS1pdGVtIC5hbnQtbWVudS1pdGVtLWljb24rc3BhbiwuYW50LW1lbnUtaXRlbSAuYW50aWNvbitzcGFuLC5hbnQtbWVudS1zdWJtZW51LXRpdGxlIC5hbnQtbWVudS1pdGVtLWljb24rc3BhbiwuYW50LW1lbnUtc3VibWVudS10aXRsZSAuYW50aWNvbitzcGFue21hcmdpbi1sZWZ0OjEwcHg7b3BhY2l0eToxO3RyYW5zaXRpb246b3BhY2l0eSAuM3MgY3ViaWMtYmV6aWVyKC42NDUsLjA0NSwuMzU1LDEpLG1hcmdpbiAuM3MsY29sb3IgLjNzfS5hbnQtbWVudS1pdGVtIC5hbnQtbWVudS1pdGVtLWljb24uc3ZnLC5hbnQtbWVudS1zdWJtZW51LXRpdGxlIC5hbnQtbWVudS1pdGVtLWljb24uc3Zne3ZlcnRpY2FsLWFsaWduOi0uMTI1ZW19LmFudC1tZW51LWl0ZW0uYW50LW1lbnUtaXRlbS1vbmx5LWNoaWxkPi5hbnQtbWVudS1pdGVtLWljb24sLmFudC1tZW51LWl0ZW0uYW50LW1lbnUtaXRlbS1vbmx5LWNoaWxkPi5hbnRpY29uLC5hbnQtbWVudS1zdWJtZW51LXRpdGxlLmFudC1tZW51LWl0ZW0tb25seS1jaGlsZD4uYW50LW1lbnUtaXRlbS1pY29uLC5hbnQtbWVudS1zdWJtZW51LXRpdGxlLmFudC1tZW51LWl0ZW0tb25seS1jaGlsZD4uYW50aWNvbnttYXJnaW4tcmlnaHQ6MH0uYW50LW1lbnUtaXRlbTpub3QoLmFudC1tZW51LWl0ZW0tZGlzYWJsZWQpOmZvY3VzLXZpc2libGUsLmFudC1tZW51LXN1Ym1lbnUtdGl0bGU6bm90KC5hbnQtbWVudS1pdGVtLWRpc2FibGVkKTpmb2N1cy12aXNpYmxle2JveC1zaGFkb3c6MCAwIDAgMnB4ICNiYWU3ZmZ9LmFudC1tZW51Pi5hbnQtbWVudS1pdGVtLWRpdmlkZXJ7bWFyZ2luOjFweCAwO3BhZGRpbmc6MH0uYW50LW1lbnUtc3VibWVudS1wb3B1cHtwb3NpdGlvbjphYnNvbHV0ZTt6LWluZGV4OjEwNTA7YmFja2dyb3VuZDp0cmFuc3BhcmVudDtib3JkZXItcmFkaXVzOjJweDtib3gtc2hhZG93Om5vbmU7dHJhbnNmb3JtLW9yaWdpbjowIDB9LmFudC1tZW51LXN1Ym1lbnUtcG9wdXA6YmVmb3Jle3Bvc2l0aW9uOmFic29sdXRlO3RvcDotN3B4O3JpZ2h0OjA7Ym90dG9tOjA7bGVmdDowO3otaW5kZXg6LTE7d2lkdGg6MTAwJTtoZWlnaHQ6MTAwJTtvcGFjaXR5Oi4wMDAxO2NvbnRlbnQ6XCIgXCJ9LmFudC1tZW51LXN1Ym1lbnUtcGxhY2VtZW50LXJpZ2h0VG9wOmJlZm9yZXt0b3A6MDtsZWZ0Oi03cHh9LmFudC1tZW51LXN1Ym1lbnU+LmFudC1tZW51e2JhY2tncm91bmQtY29sb3I6I2ZmZjtib3JkZXItcmFkaXVzOjJweH0uYW50LW1lbnUtc3VibWVudT4uYW50LW1lbnUtc3VibWVudS10aXRsZTphZnRlcnt0cmFuc2l0aW9uOnRyYW5zZm9ybSAuM3MgY3ViaWMtYmV6aWVyKC42NDUsLjA0NSwuMzU1LDEpfS5hbnQtbWVudS1zdWJtZW51LXBvcHVwPi5hbnQtbWVudXtiYWNrZ3JvdW5kLWNvbG9yOiNmZmZ9LmFudC1tZW51LXN1Ym1lbnUtYXJyb3csLmFudC1tZW51LXN1Ym1lbnUtZXhwYW5kLWljb257cG9zaXRpb246YWJzb2x1dGU7dG9wOjUwJTtyaWdodDoxNnB4O3dpZHRoOjEwcHg7Y29sb3I6cmdiYSgwLDAsMCwuODUpO3RyYW5zZm9ybTp0cmFuc2xhdGVZKC01MCUpO3RyYW5zaXRpb246dHJhbnNmb3JtIC4zcyBjdWJpYy1iZXppZXIoLjY0NSwuMDQ1LC4zNTUsMSl9LmFudC1tZW51LXN1Ym1lbnUtYXJyb3c6YWZ0ZXIsLmFudC1tZW51LXN1Ym1lbnUtYXJyb3c6YmVmb3Jle3Bvc2l0aW9uOmFic29sdXRlO3dpZHRoOjZweDtoZWlnaHQ6MS41cHg7YmFja2dyb3VuZC1jb2xvcjpjdXJyZW50Y29sb3I7Ym9yZGVyLXJhZGl1czoycHg7dHJhbnNpdGlvbjpiYWNrZ3JvdW5kIC4zcyBjdWJpYy1iZXppZXIoLjY0NSwuMDQ1LC4zNTUsMSksdHJhbnNmb3JtIC4zcyBjdWJpYy1iZXppZXIoLjY0NSwuMDQ1LC4zNTUsMSksdG9wIC4zcyBjdWJpYy1iZXppZXIoLjY0NSwuMDQ1LC4zNTUsMSksY29sb3IgLjNzIGN1YmljLWJlemllciguNjQ1LC4wNDUsLjM1NSwxKTtjb250ZW50OlwiXCJ9LmFudC1tZW51LXN1Ym1lbnUtYXJyb3c6YmVmb3Jle3RyYW5zZm9ybTpyb3RhdGUoNDVkZWcpIHRyYW5zbGF0ZVkoLTIuNXB4KX0uYW50LW1lbnUtc3VibWVudS1hcnJvdzphZnRlcnt0cmFuc2Zvcm06cm90YXRlKC00NWRlZykgdHJhbnNsYXRlWSgyLjVweCl9LmFudC1tZW51LXN1Ym1lbnU6aG92ZXI+LmFudC1tZW51LXN1Ym1lbnUtdGl0bGU+LmFudC1tZW51LXN1Ym1lbnUtYXJyb3csLmFudC1tZW51LXN1Ym1lbnU6aG92ZXI+LmFudC1tZW51LXN1Ym1lbnUtdGl0bGU+LmFudC1tZW51LXN1Ym1lbnUtZXhwYW5kLWljb257Y29sb3I6IzE4OTBmZn0uYW50LW1lbnUtaW5saW5lLWNvbGxhcHNlZCAuYW50LW1lbnUtc3VibWVudS1hcnJvdzpiZWZvcmUsLmFudC1tZW51LXN1Ym1lbnUtaW5saW5lIC5hbnQtbWVudS1zdWJtZW51LWFycm93OmJlZm9yZXt0cmFuc2Zvcm06cm90YXRlKC00NWRlZykgdHJhbnNsYXRlWCgyLjVweCl9LmFudC1tZW51LWlubGluZS1jb2xsYXBzZWQgLmFudC1tZW51LXN1Ym1lbnUtYXJyb3c6YWZ0ZXIsLmFudC1tZW51LXN1Ym1lbnUtaW5saW5lIC5hbnQtbWVudS1zdWJtZW51LWFycm93OmFmdGVye3RyYW5zZm9ybTpyb3RhdGUoNDVkZWcpIHRyYW5zbGF0ZVgoLTIuNXB4KX0uYW50LW1lbnUtc3VibWVudS1ob3Jpem9udGFsIC5hbnQtbWVudS1zdWJtZW51LWFycm93e2Rpc3BsYXk6bm9uZX0uYW50LW1lbnUtc3VibWVudS1vcGVuLmFudC1tZW51LXN1Ym1lbnUtaW5saW5lPi5hbnQtbWVudS1zdWJtZW51LXRpdGxlPi5hbnQtbWVudS1zdWJtZW51LWFycm93e3RyYW5zZm9ybTp0cmFuc2xhdGVZKC0ycHgpfS5hbnQtbWVudS1zdWJtZW51LW9wZW4uYW50LW1lbnUtc3VibWVudS1pbmxpbmU+LmFudC1tZW51LXN1Ym1lbnUtdGl0bGU+LmFudC1tZW51LXN1Ym1lbnUtYXJyb3c6YWZ0ZXJ7dHJhbnNmb3JtOnJvdGF0ZSgtNDVkZWcpIHRyYW5zbGF0ZVgoLTIuNXB4KX0uYW50LW1lbnUtc3VibWVudS1vcGVuLmFudC1tZW51LXN1Ym1lbnUtaW5saW5lPi5hbnQtbWVudS1zdWJtZW51LXRpdGxlPi5hbnQtbWVudS1zdWJtZW51LWFycm93OmJlZm9yZXt0cmFuc2Zvcm06cm90YXRlKDQ1ZGVnKSB0cmFuc2xhdGVYKDIuNXB4KX0uYW50LW1lbnUtdmVydGljYWwtbGVmdCAuYW50LW1lbnUtc3VibWVudS1zZWxlY3RlZCwuYW50LW1lbnUtdmVydGljYWwtcmlnaHQgLmFudC1tZW51LXN1Ym1lbnUtc2VsZWN0ZWQsLmFudC1tZW51LXZlcnRpY2FsIC5hbnQtbWVudS1zdWJtZW51LXNlbGVjdGVke2NvbG9yOiMxODkwZmZ9LmFudC1tZW51LWhvcml6b250YWx7bGluZS1oZWlnaHQ6NDZweDtib3JkZXI6MDtib3JkZXItYm90dG9tOjFweCBzb2xpZCAjZjBmMGYwO2JveC1zaGFkb3c6bm9uZX0uYW50LW1lbnUtaG9yaXpvbnRhbDpub3QoLmFudC1tZW51LWRhcmspPi5hbnQtbWVudS1pdGVtLC5hbnQtbWVudS1ob3Jpem9udGFsOm5vdCguYW50LW1lbnUtZGFyayk+LmFudC1tZW51LXN1Ym1lbnV7bWFyZ2luLXRvcDotMXB4O21hcmdpbi1ib3R0b206MDtwYWRkaW5nOjAgMjBweH0uYW50LW1lbnUtaG9yaXpvbnRhbDpub3QoLmFudC1tZW51LWRhcmspPi5hbnQtbWVudS1pdGVtLWFjdGl2ZSwuYW50LW1lbnUtaG9yaXpvbnRhbDpub3QoLmFudC1tZW51LWRhcmspPi5hbnQtbWVudS1pdGVtLW9wZW4sLmFudC1tZW51LWhvcml6b250YWw6bm90KC5hbnQtbWVudS1kYXJrKT4uYW50LW1lbnUtaXRlbS1zZWxlY3RlZCwuYW50LW1lbnUtaG9yaXpvbnRhbDpub3QoLmFudC1tZW51LWRhcmspPi5hbnQtbWVudS1pdGVtOmhvdmVyLC5hbnQtbWVudS1ob3Jpem9udGFsOm5vdCguYW50LW1lbnUtZGFyayk+LmFudC1tZW51LXN1Ym1lbnUtYWN0aXZlLC5hbnQtbWVudS1ob3Jpem9udGFsOm5vdCguYW50LW1lbnUtZGFyayk+LmFudC1tZW51LXN1Ym1lbnUtb3BlbiwuYW50LW1lbnUtaG9yaXpvbnRhbDpub3QoLmFudC1tZW51LWRhcmspPi5hbnQtbWVudS1zdWJtZW51LXNlbGVjdGVkLC5hbnQtbWVudS1ob3Jpem9udGFsOm5vdCguYW50LW1lbnUtZGFyayk+LmFudC1tZW51LXN1Ym1lbnU6aG92ZXJ7Y29sb3I6IzE4OTBmZn0uYW50LW1lbnUtaG9yaXpvbnRhbDpub3QoLmFudC1tZW51LWRhcmspPi5hbnQtbWVudS1pdGVtLWFjdGl2ZTphZnRlciwuYW50LW1lbnUtaG9yaXpvbnRhbDpub3QoLmFudC1tZW51LWRhcmspPi5hbnQtbWVudS1pdGVtLW9wZW46YWZ0ZXIsLmFudC1tZW51LWhvcml6b250YWw6bm90KC5hbnQtbWVudS1kYXJrKT4uYW50LW1lbnUtaXRlbS1zZWxlY3RlZDphZnRlciwuYW50LW1lbnUtaG9yaXpvbnRhbDpub3QoLmFudC1tZW51LWRhcmspPi5hbnQtbWVudS1pdGVtOmhvdmVyOmFmdGVyLC5hbnQtbWVudS1ob3Jpem9udGFsOm5vdCguYW50LW1lbnUtZGFyayk+LmFudC1tZW51LXN1Ym1lbnUtYWN0aXZlOmFmdGVyLC5hbnQtbWVudS1ob3Jpem9udGFsOm5vdCguYW50LW1lbnUtZGFyayk+LmFudC1tZW51LXN1Ym1lbnUtb3BlbjphZnRlciwuYW50LW1lbnUtaG9yaXpvbnRhbDpub3QoLmFudC1tZW51LWRhcmspPi5hbnQtbWVudS1zdWJtZW51LXNlbGVjdGVkOmFmdGVyLC5hbnQtbWVudS1ob3Jpem9udGFsOm5vdCguYW50LW1lbnUtZGFyayk+LmFudC1tZW51LXN1Ym1lbnU6aG92ZXI6YWZ0ZXJ7Ym9yZGVyLWJvdHRvbToycHggc29saWQgIzE4OTBmZn0uYW50LW1lbnUtaG9yaXpvbnRhbD4uYW50LW1lbnUtaXRlbSwuYW50LW1lbnUtaG9yaXpvbnRhbD4uYW50LW1lbnUtc3VibWVudXtwb3NpdGlvbjpyZWxhdGl2ZTt0b3A6MXB4O2Rpc3BsYXk6aW5saW5lLWJsb2NrO3ZlcnRpY2FsLWFsaWduOmJvdHRvbX0uYW50LW1lbnUtaG9yaXpvbnRhbD4uYW50LW1lbnUtaXRlbTphZnRlciwuYW50LW1lbnUtaG9yaXpvbnRhbD4uYW50LW1lbnUtc3VibWVudTphZnRlcntwb3NpdGlvbjphYnNvbHV0ZTtyaWdodDoyMHB4O2JvdHRvbTowO2xlZnQ6MjBweDtib3JkZXItYm90dG9tOjJweCBzb2xpZCB0cmFuc3BhcmVudDt0cmFuc2l0aW9uOmJvcmRlci1jb2xvciAuM3MgY3ViaWMtYmV6aWVyKC42NDUsLjA0NSwuMzU1LDEpO2NvbnRlbnQ6XCJcIn0uYW50LW1lbnUtaG9yaXpvbnRhbD4uYW50LW1lbnUtc3VibWVudT4uYW50LW1lbnUtc3VibWVudS10aXRsZXtwYWRkaW5nOjB9LmFudC1tZW51LWhvcml6b250YWw+LmFudC1tZW51LWl0ZW0gYXtjb2xvcjpyZ2JhKDAsMCwwLC44NSl9LmFudC1tZW51LWhvcml6b250YWw+LmFudC1tZW51LWl0ZW0gYTpob3Zlcntjb2xvcjojMTg5MGZmfS5hbnQtbWVudS1ob3Jpem9udGFsPi5hbnQtbWVudS1pdGVtIGE6YmVmb3Jle2JvdHRvbTotMnB4fS5hbnQtbWVudS1ob3Jpem9udGFsPi5hbnQtbWVudS1pdGVtLXNlbGVjdGVkIGF7Y29sb3I6IzE4OTBmZn0uYW50LW1lbnUtaG9yaXpvbnRhbDphZnRlcntkaXNwbGF5OmJsb2NrO2NsZWFyOmJvdGg7aGVpZ2h0OjA7Y29udGVudDpcIlxcMjBcIn0uYW50LW1lbnUtaW5saW5lIC5hbnQtbWVudS1pdGVtLC5hbnQtbWVudS12ZXJ0aWNhbC1sZWZ0IC5hbnQtbWVudS1pdGVtLC5hbnQtbWVudS12ZXJ0aWNhbC1yaWdodCAuYW50LW1lbnUtaXRlbSwuYW50LW1lbnUtdmVydGljYWwgLmFudC1tZW51LWl0ZW17cG9zaXRpb246cmVsYXRpdmV9LmFudC1tZW51LWlubGluZSAuYW50LW1lbnUtaXRlbTphZnRlciwuYW50LW1lbnUtdmVydGljYWwtbGVmdCAuYW50LW1lbnUtaXRlbTphZnRlciwuYW50LW1lbnUtdmVydGljYWwtcmlnaHQgLmFudC1tZW51LWl0ZW06YWZ0ZXIsLmFudC1tZW51LXZlcnRpY2FsIC5hbnQtbWVudS1pdGVtOmFmdGVye3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO3JpZ2h0OjA7Ym90dG9tOjA7Ym9yZGVyLXJpZ2h0OjNweCBzb2xpZCAjMTg5MGZmO3RyYW5zZm9ybTpzY2FsZVkoLjAwMDEpO29wYWNpdHk6MDt0cmFuc2l0aW9uOnRyYW5zZm9ybSAuMTVzIGN1YmljLWJlemllciguMjE1LC42MSwuMzU1LDEpLG9wYWNpdHkgLjE1cyBjdWJpYy1iZXppZXIoLjIxNSwuNjEsLjM1NSwxKTtjb250ZW50OlwiXCJ9LmFudC1tZW51LWlubGluZSAuYW50LW1lbnUtaXRlbSwuYW50LW1lbnUtaW5saW5lIC5hbnQtbWVudS1zdWJtZW51LXRpdGxlLC5hbnQtbWVudS12ZXJ0aWNhbC1sZWZ0IC5hbnQtbWVudS1pdGVtLC5hbnQtbWVudS12ZXJ0aWNhbC1sZWZ0IC5hbnQtbWVudS1zdWJtZW51LXRpdGxlLC5hbnQtbWVudS12ZXJ0aWNhbC1yaWdodCAuYW50LW1lbnUtaXRlbSwuYW50LW1lbnUtdmVydGljYWwtcmlnaHQgLmFudC1tZW51LXN1Ym1lbnUtdGl0bGUsLmFudC1tZW51LXZlcnRpY2FsIC5hbnQtbWVudS1pdGVtLC5hbnQtbWVudS12ZXJ0aWNhbCAuYW50LW1lbnUtc3VibWVudS10aXRsZXtoZWlnaHQ6NDBweDttYXJnaW4tdG9wOjRweDttYXJnaW4tYm90dG9tOjRweDtwYWRkaW5nOjAgMTZweDtvdmVyZmxvdzpoaWRkZW47bGluZS1oZWlnaHQ6NDBweDt0ZXh0LW92ZXJmbG93OmVsbGlwc2lzfS5hbnQtbWVudS1pbmxpbmUgLmFudC1tZW51LXN1Ym1lbnUsLmFudC1tZW51LXZlcnRpY2FsLWxlZnQgLmFudC1tZW51LXN1Ym1lbnUsLmFudC1tZW51LXZlcnRpY2FsLXJpZ2h0IC5hbnQtbWVudS1zdWJtZW51LC5hbnQtbWVudS12ZXJ0aWNhbCAuYW50LW1lbnUtc3VibWVudXtwYWRkaW5nLWJvdHRvbTouMDJweH0uYW50LW1lbnUtaW5saW5lIC5hbnQtbWVudS1pdGVtOm5vdCg6bGFzdC1jaGlsZCksLmFudC1tZW51LXZlcnRpY2FsLWxlZnQgLmFudC1tZW51LWl0ZW06bm90KDpsYXN0LWNoaWxkKSwuYW50LW1lbnUtdmVydGljYWwtcmlnaHQgLmFudC1tZW51LWl0ZW06bm90KDpsYXN0LWNoaWxkKSwuYW50LW1lbnUtdmVydGljYWwgLmFudC1tZW51LWl0ZW06bm90KDpsYXN0LWNoaWxkKXttYXJnaW4tYm90dG9tOjhweH0uYW50LW1lbnUtaW5saW5lPi5hbnQtbWVudS1pdGVtLC5hbnQtbWVudS1pbmxpbmU+LmFudC1tZW51LXN1Ym1lbnU+LmFudC1tZW51LXN1Ym1lbnUtdGl0bGUsLmFudC1tZW51LXZlcnRpY2FsLWxlZnQ+LmFudC1tZW51LWl0ZW0sLmFudC1tZW51LXZlcnRpY2FsLWxlZnQ+LmFudC1tZW51LXN1Ym1lbnU+LmFudC1tZW51LXN1Ym1lbnUtdGl0bGUsLmFudC1tZW51LXZlcnRpY2FsLXJpZ2h0Pi5hbnQtbWVudS1pdGVtLC5hbnQtbWVudS12ZXJ0aWNhbC1yaWdodD4uYW50LW1lbnUtc3VibWVudT4uYW50LW1lbnUtc3VibWVudS10aXRsZSwuYW50LW1lbnUtdmVydGljYWw+LmFudC1tZW51LWl0ZW0sLmFudC1tZW51LXZlcnRpY2FsPi5hbnQtbWVudS1zdWJtZW51Pi5hbnQtbWVudS1zdWJtZW51LXRpdGxle2hlaWdodDo0MHB4O2xpbmUtaGVpZ2h0OjQwcHh9LmFudC1tZW51LXZlcnRpY2FsIC5hbnQtbWVudS1pdGVtLWdyb3VwLWxpc3QgLmFudC1tZW51LXN1Ym1lbnUtdGl0bGUsLmFudC1tZW51LXZlcnRpY2FsIC5hbnQtbWVudS1zdWJtZW51LXRpdGxle3BhZGRpbmctcmlnaHQ6MzRweH0uYW50LW1lbnUtaW5saW5le3dpZHRoOjEwMCV9LmFudC1tZW51LWlubGluZSAuYW50LW1lbnUtaXRlbS1zZWxlY3RlZDphZnRlciwuYW50LW1lbnUtaW5saW5lIC5hbnQtbWVudS1zZWxlY3RlZDphZnRlcnt0cmFuc2Zvcm06c2NhbGVZKDEpO29wYWNpdHk6MTt0cmFuc2l0aW9uOnRyYW5zZm9ybSAuMTVzIGN1YmljLWJlemllciguNjQ1LC4wNDUsLjM1NSwxKSxvcGFjaXR5IC4xNXMgY3ViaWMtYmV6aWVyKC42NDUsLjA0NSwuMzU1LDEpfS5hbnQtbWVudS1pbmxpbmUgLmFudC1tZW51LWl0ZW0sLmFudC1tZW51LWlubGluZSAuYW50LW1lbnUtc3VibWVudS10aXRsZXt3aWR0aDpjYWxjKDEwMCUgKyAxcHgpfS5hbnQtbWVudS1pbmxpbmUgLmFudC1tZW51LWl0ZW0tZ3JvdXAtbGlzdCAuYW50LW1lbnUtc3VibWVudS10aXRsZSwuYW50LW1lbnUtaW5saW5lIC5hbnQtbWVudS1zdWJtZW51LXRpdGxle3BhZGRpbmctcmlnaHQ6MzRweH0uYW50LW1lbnUtaW5saW5lLmFudC1tZW51LXJvb3QgLmFudC1tZW51LWl0ZW0sLmFudC1tZW51LWlubGluZS5hbnQtbWVudS1yb290IC5hbnQtbWVudS1zdWJtZW51LXRpdGxle2Rpc3BsYXk6ZmxleDthbGlnbi1pdGVtczpjZW50ZXI7dHJhbnNpdGlvbjpib3JkZXItY29sb3IgLjNzLGJhY2tncm91bmQgLjNzLHBhZGRpbmcgLjFzIGN1YmljLWJlemllciguMjE1LC42MSwuMzU1LDEpfS5hbnQtbWVudS1pbmxpbmUuYW50LW1lbnUtcm9vdCAuYW50LW1lbnUtaXRlbT4uYW50LW1lbnUtdGl0bGUtY29udGVudCwuYW50LW1lbnUtaW5saW5lLmFudC1tZW51LXJvb3QgLmFudC1tZW51LXN1Ym1lbnUtdGl0bGU+LmFudC1tZW51LXRpdGxlLWNvbnRlbnR7ZmxleDphdXRvO21pbi13aWR0aDowO292ZXJmbG93OmhpZGRlbjt0ZXh0LW92ZXJmbG93OmVsbGlwc2lzfS5hbnQtbWVudS1pbmxpbmUuYW50LW1lbnUtcm9vdCAuYW50LW1lbnUtaXRlbT4qLC5hbnQtbWVudS1pbmxpbmUuYW50LW1lbnUtcm9vdCAuYW50LW1lbnUtc3VibWVudS10aXRsZT4qe2ZsZXg6bm9uZX0uYW50LW1lbnUuYW50LW1lbnUtaW5saW5lLWNvbGxhcHNlZHt3aWR0aDo4MHB4fS5hbnQtbWVudS5hbnQtbWVudS1pbmxpbmUtY29sbGFwc2VkPi5hbnQtbWVudS1pdGVtLC5hbnQtbWVudS5hbnQtbWVudS1pbmxpbmUtY29sbGFwc2VkPi5hbnQtbWVudS1pdGVtLWdyb3VwPi5hbnQtbWVudS1pdGVtLWdyb3VwLWxpc3Q+LmFudC1tZW51LWl0ZW0sLmFudC1tZW51LmFudC1tZW51LWlubGluZS1jb2xsYXBzZWQ+LmFudC1tZW51LWl0ZW0tZ3JvdXA+LmFudC1tZW51LWl0ZW0tZ3JvdXAtbGlzdD4uYW50LW1lbnUtc3VibWVudT4uYW50LW1lbnUtc3VibWVudS10aXRsZSwuYW50LW1lbnUuYW50LW1lbnUtaW5saW5lLWNvbGxhcHNlZD4uYW50LW1lbnUtc3VibWVudT4uYW50LW1lbnUtc3VibWVudS10aXRsZXtsZWZ0OjA7cGFkZGluZzowIGNhbGMoNTAlIC0gOHB4KTt0ZXh0LW92ZXJmbG93OmNsaXB9LmFudC1tZW51LmFudC1tZW51LWlubGluZS1jb2xsYXBzZWQ+LmFudC1tZW51LWl0ZW0tZ3JvdXA+LmFudC1tZW51LWl0ZW0tZ3JvdXAtbGlzdD4uYW50LW1lbnUtaXRlbSAuYW50LW1lbnUtc3VibWVudS1hcnJvdywuYW50LW1lbnUuYW50LW1lbnUtaW5saW5lLWNvbGxhcHNlZD4uYW50LW1lbnUtaXRlbS1ncm91cD4uYW50LW1lbnUtaXRlbS1ncm91cC1saXN0Pi5hbnQtbWVudS1zdWJtZW51Pi5hbnQtbWVudS1zdWJtZW51LXRpdGxlIC5hbnQtbWVudS1zdWJtZW51LWFycm93LC5hbnQtbWVudS5hbnQtbWVudS1pbmxpbmUtY29sbGFwc2VkPi5hbnQtbWVudS1pdGVtIC5hbnQtbWVudS1zdWJtZW51LWFycm93LC5hbnQtbWVudS5hbnQtbWVudS1pbmxpbmUtY29sbGFwc2VkPi5hbnQtbWVudS1zdWJtZW51Pi5hbnQtbWVudS1zdWJtZW51LXRpdGxlIC5hbnQtbWVudS1zdWJtZW51LWFycm93e29wYWNpdHk6MH0uYW50LW1lbnUuYW50LW1lbnUtaW5saW5lLWNvbGxhcHNlZD4uYW50LW1lbnUtaXRlbS1ncm91cD4uYW50LW1lbnUtaXRlbS1ncm91cC1saXN0Pi5hbnQtbWVudS1pdGVtIC5hbnQtbWVudS1pdGVtLWljb24sLmFudC1tZW51LmFudC1tZW51LWlubGluZS1jb2xsYXBzZWQ+LmFudC1tZW51LWl0ZW0tZ3JvdXA+LmFudC1tZW51LWl0ZW0tZ3JvdXAtbGlzdD4uYW50LW1lbnUtaXRlbSAuYW50aWNvbiwuYW50LW1lbnUuYW50LW1lbnUtaW5saW5lLWNvbGxhcHNlZD4uYW50LW1lbnUtaXRlbS1ncm91cD4uYW50LW1lbnUtaXRlbS1ncm91cC1saXN0Pi5hbnQtbWVudS1zdWJtZW51Pi5hbnQtbWVudS1zdWJtZW51LXRpdGxlIC5hbnQtbWVudS1pdGVtLWljb24sLmFudC1tZW51LmFudC1tZW51LWlubGluZS1jb2xsYXBzZWQ+LmFudC1tZW51LWl0ZW0tZ3JvdXA+LmFudC1tZW51LWl0ZW0tZ3JvdXAtbGlzdD4uYW50LW1lbnUtc3VibWVudT4uYW50LW1lbnUtc3VibWVudS10aXRsZSAuYW50aWNvbiwuYW50LW1lbnUuYW50LW1lbnUtaW5saW5lLWNvbGxhcHNlZD4uYW50LW1lbnUtaXRlbSAuYW50LW1lbnUtaXRlbS1pY29uLC5hbnQtbWVudS5hbnQtbWVudS1pbmxpbmUtY29sbGFwc2VkPi5hbnQtbWVudS1pdGVtIC5hbnRpY29uLC5hbnQtbWVudS5hbnQtbWVudS1pbmxpbmUtY29sbGFwc2VkPi5hbnQtbWVudS1zdWJtZW51Pi5hbnQtbWVudS1zdWJtZW51LXRpdGxlIC5hbnQtbWVudS1pdGVtLWljb24sLmFudC1tZW51LmFudC1tZW51LWlubGluZS1jb2xsYXBzZWQ+LmFudC1tZW51LXN1Ym1lbnU+LmFudC1tZW51LXN1Ym1lbnUtdGl0bGUgLmFudGljb257bWFyZ2luOjA7Zm9udC1zaXplOjE2cHg7bGluZS1oZWlnaHQ6NDBweH0uYW50LW1lbnUuYW50LW1lbnUtaW5saW5lLWNvbGxhcHNlZD4uYW50LW1lbnUtaXRlbS1ncm91cD4uYW50LW1lbnUtaXRlbS1ncm91cC1saXN0Pi5hbnQtbWVudS1pdGVtIC5hbnQtbWVudS1pdGVtLWljb24rc3BhbiwuYW50LW1lbnUuYW50LW1lbnUtaW5saW5lLWNvbGxhcHNlZD4uYW50LW1lbnUtaXRlbS1ncm91cD4uYW50LW1lbnUtaXRlbS1ncm91cC1saXN0Pi5hbnQtbWVudS1pdGVtIC5hbnRpY29uK3NwYW4sLmFudC1tZW51LmFudC1tZW51LWlubGluZS1jb2xsYXBzZWQ+LmFudC1tZW51LWl0ZW0tZ3JvdXA+LmFudC1tZW51LWl0ZW0tZ3JvdXAtbGlzdD4uYW50LW1lbnUtc3VibWVudT4uYW50LW1lbnUtc3VibWVudS10aXRsZSAuYW50LW1lbnUtaXRlbS1pY29uK3NwYW4sLmFudC1tZW51LmFudC1tZW51LWlubGluZS1jb2xsYXBzZWQ+LmFudC1tZW51LWl0ZW0tZ3JvdXA+LmFudC1tZW51LWl0ZW0tZ3JvdXAtbGlzdD4uYW50LW1lbnUtc3VibWVudT4uYW50LW1lbnUtc3VibWVudS10aXRsZSAuYW50aWNvbitzcGFuLC5hbnQtbWVudS5hbnQtbWVudS1pbmxpbmUtY29sbGFwc2VkPi5hbnQtbWVudS1pdGVtIC5hbnQtbWVudS1pdGVtLWljb24rc3BhbiwuYW50LW1lbnUuYW50LW1lbnUtaW5saW5lLWNvbGxhcHNlZD4uYW50LW1lbnUtaXRlbSAuYW50aWNvbitzcGFuLC5hbnQtbWVudS5hbnQtbWVudS1pbmxpbmUtY29sbGFwc2VkPi5hbnQtbWVudS1zdWJtZW51Pi5hbnQtbWVudS1zdWJtZW51LXRpdGxlIC5hbnQtbWVudS1pdGVtLWljb24rc3BhbiwuYW50LW1lbnUuYW50LW1lbnUtaW5saW5lLWNvbGxhcHNlZD4uYW50LW1lbnUtc3VibWVudT4uYW50LW1lbnUtc3VibWVudS10aXRsZSAuYW50aWNvbitzcGFue2Rpc3BsYXk6aW5saW5lLWJsb2NrO29wYWNpdHk6MH0uYW50LW1lbnUuYW50LW1lbnUtaW5saW5lLWNvbGxhcHNlZCAuYW50LW1lbnUtaXRlbS1pY29uLC5hbnQtbWVudS5hbnQtbWVudS1pbmxpbmUtY29sbGFwc2VkIC5hbnRpY29ue2Rpc3BsYXk6aW5saW5lLWJsb2NrfS5hbnQtbWVudS5hbnQtbWVudS1pbmxpbmUtY29sbGFwc2VkLXRvb2x0aXB7cG9pbnRlci1ldmVudHM6bm9uZX0uYW50LW1lbnUuYW50LW1lbnUtaW5saW5lLWNvbGxhcHNlZC10b29sdGlwIC5hbnQtbWVudS1pdGVtLWljb24sLmFudC1tZW51LmFudC1tZW51LWlubGluZS1jb2xsYXBzZWQtdG9vbHRpcCAuYW50aWNvbntkaXNwbGF5Om5vbmV9LmFudC1tZW51LmFudC1tZW51LWlubGluZS1jb2xsYXBzZWQtdG9vbHRpcCBhe2NvbG9yOmhzbGEoMCwwJSwxMDAlLC44NSl9LmFudC1tZW51LmFudC1tZW51LWlubGluZS1jb2xsYXBzZWQgLmFudC1tZW51LWl0ZW0tZ3JvdXAtdGl0bGV7cGFkZGluZy1yaWdodDo0cHg7cGFkZGluZy1sZWZ0OjRweDtvdmVyZmxvdzpoaWRkZW47d2hpdGUtc3BhY2U6bm93cmFwO3RleHQtb3ZlcmZsb3c6ZWxsaXBzaXN9LmFudC1tZW51LWl0ZW0tZ3JvdXAtbGlzdHttYXJnaW46MDtwYWRkaW5nOjB9LmFudC1tZW51LWl0ZW0tZ3JvdXAtbGlzdCAuYW50LW1lbnUtaXRlbSwuYW50LW1lbnUtaXRlbS1ncm91cC1saXN0IC5hbnQtbWVudS1zdWJtZW51LXRpdGxle3BhZGRpbmc6MCAxNnB4IDAgMjhweH0uYW50LW1lbnUtcm9vdC5hbnQtbWVudS1pbmxpbmUsLmFudC1tZW51LXJvb3QuYW50LW1lbnUtdmVydGljYWwsLmFudC1tZW51LXJvb3QuYW50LW1lbnUtdmVydGljYWwtbGVmdCwuYW50LW1lbnUtcm9vdC5hbnQtbWVudS12ZXJ0aWNhbC1yaWdodHtib3gtc2hhZG93Om5vbmV9LmFudC1tZW51LXJvb3QuYW50LW1lbnUtaW5saW5lLWNvbGxhcHNlZCAuYW50LW1lbnUtaXRlbT4uYW50LW1lbnUtaW5saW5lLWNvbGxhcHNlZC1ub2ljb24sLmFudC1tZW51LXJvb3QuYW50LW1lbnUtaW5saW5lLWNvbGxhcHNlZCAuYW50LW1lbnUtc3VibWVudSAuYW50LW1lbnUtc3VibWVudS10aXRsZT4uYW50LW1lbnUtaW5saW5lLWNvbGxhcHNlZC1ub2ljb257Zm9udC1zaXplOjE2cHg7dGV4dC1hbGlnbjpjZW50ZXJ9LmFudC1tZW51LXN1Yi5hbnQtbWVudS1pbmxpbmV7cGFkZGluZzowO2JhY2tncm91bmQ6I2ZhZmFmYTtib3JkZXItcmFkaXVzOjA7Ym94LXNoYWRvdzpub25lfS5hbnQtbWVudS1zdWIuYW50LW1lbnUtaW5saW5lPi5hbnQtbWVudS1pdGVtLC5hbnQtbWVudS1zdWIuYW50LW1lbnUtaW5saW5lPi5hbnQtbWVudS1zdWJtZW51Pi5hbnQtbWVudS1zdWJtZW51LXRpdGxle2hlaWdodDo0MHB4O2xpbmUtaGVpZ2h0OjQwcHg7bGlzdC1zdHlsZS1wb3NpdGlvbjppbnNpZGU7bGlzdC1zdHlsZS10eXBlOmRpc2N9LmFudC1tZW51LXN1Yi5hbnQtbWVudS1pbmxpbmUgLmFudC1tZW51LWl0ZW0tZ3JvdXAtdGl0bGV7cGFkZGluZy1sZWZ0OjMycHh9LmFudC1tZW51LWl0ZW0tZGlzYWJsZWQsLmFudC1tZW51LXN1Ym1lbnUtZGlzYWJsZWR7Y29sb3I6cmdiYSgwLDAsMCwuMjUpIWltcG9ydGFudDtiYWNrZ3JvdW5kOm5vbmU7Y3Vyc29yOm5vdC1hbGxvd2VkfS5hbnQtbWVudS1pdGVtLWRpc2FibGVkOmFmdGVyLC5hbnQtbWVudS1zdWJtZW51LWRpc2FibGVkOmFmdGVye2JvcmRlci1jb2xvcjp0cmFuc3BhcmVudCFpbXBvcnRhbnR9LmFudC1tZW51LWl0ZW0tZGlzYWJsZWQgYSwuYW50LW1lbnUtc3VibWVudS1kaXNhYmxlZCBhe2NvbG9yOnJnYmEoMCwwLDAsLjI1KSFpbXBvcnRhbnQ7cG9pbnRlci1ldmVudHM6bm9uZX0uYW50LW1lbnUtaXRlbS1kaXNhYmxlZD4uYW50LW1lbnUtc3VibWVudS10aXRsZSwuYW50LW1lbnUtc3VibWVudS1kaXNhYmxlZD4uYW50LW1lbnUtc3VibWVudS10aXRsZXtjb2xvcjpyZ2JhKDAsMCwwLC4yNSkhaW1wb3J0YW50O2N1cnNvcjpub3QtYWxsb3dlZH0uYW50LW1lbnUtaXRlbS1kaXNhYmxlZD4uYW50LW1lbnUtc3VibWVudS10aXRsZT4uYW50LW1lbnUtc3VibWVudS1hcnJvdzphZnRlciwuYW50LW1lbnUtaXRlbS1kaXNhYmxlZD4uYW50LW1lbnUtc3VibWVudS10aXRsZT4uYW50LW1lbnUtc3VibWVudS1hcnJvdzpiZWZvcmUsLmFudC1tZW51LXN1Ym1lbnUtZGlzYWJsZWQ+LmFudC1tZW51LXN1Ym1lbnUtdGl0bGU+LmFudC1tZW51LXN1Ym1lbnUtYXJyb3c6YWZ0ZXIsLmFudC1tZW51LXN1Ym1lbnUtZGlzYWJsZWQ+LmFudC1tZW51LXN1Ym1lbnUtdGl0bGU+LmFudC1tZW51LXN1Ym1lbnUtYXJyb3c6YmVmb3Jle2JhY2tncm91bmQ6cmdiYSgwLDAsMCwuMjUpIWltcG9ydGFudH0uYW50LWxheW91dC1oZWFkZXIgLmFudC1tZW51e2xpbmUtaGVpZ2h0OmluaGVyaXR9LmFudC1tZW51LWlubGluZS1jb2xsYXBzZWQtdG9vbHRpcCBhLC5hbnQtbWVudS1pbmxpbmUtY29sbGFwc2VkLXRvb2x0aXAgYTpob3Zlcntjb2xvcjojZmZmfS5hbnQtbWVudS1saWdodCAuYW50LW1lbnUtaXRlbS1hY3RpdmUsLmFudC1tZW51LWxpZ2h0IC5hbnQtbWVudS1pdGVtOmhvdmVyLC5hbnQtbWVudS1saWdodCAuYW50LW1lbnUtc3VibWVudS1hY3RpdmUsLmFudC1tZW51LWxpZ2h0IC5hbnQtbWVudS1zdWJtZW51LXRpdGxlOmhvdmVyLC5hbnQtbWVudS1saWdodCAuYW50LW1lbnU6bm90KC5hbnQtbWVudS1pbmxpbmUpIC5hbnQtbWVudS1zdWJtZW51LW9wZW57Y29sb3I6IzE4OTBmZn0uYW50LW1lbnUtZGFyayAuYW50LW1lbnUtaXRlbTpmb2N1cy12aXNpYmxlLC5hbnQtbWVudS1kYXJrIC5hbnQtbWVudS1zdWJtZW51LXRpdGxlOmZvY3VzLXZpc2libGUsLmFudC1tZW51LmFudC1tZW51LXJvb3Q6Zm9jdXMtdmlzaWJsZXtib3gtc2hhZG93OjAgMCAwIDJweCAjMDk2ZGQ5fS5hbnQtbWVudS1kYXJrIC5hbnQtbWVudS1zdWIsLmFudC1tZW51LmFudC1tZW51LWRhcmssLmFudC1tZW51LmFudC1tZW51LWRhcmsgLmFudC1tZW51LXN1Yntjb2xvcjpoc2xhKDAsMCUsMTAwJSwuNjUpO2JhY2tncm91bmQ6IzAwMTUyOX0uYW50LW1lbnUtZGFyayAuYW50LW1lbnUtc3ViIC5hbnQtbWVudS1zdWJtZW51LXRpdGxlIC5hbnQtbWVudS1zdWJtZW51LWFycm93LC5hbnQtbWVudS5hbnQtbWVudS1kYXJrIC5hbnQtbWVudS1zdWIgLmFudC1tZW51LXN1Ym1lbnUtdGl0bGUgLmFudC1tZW51LXN1Ym1lbnUtYXJyb3csLmFudC1tZW51LmFudC1tZW51LWRhcmsgLmFudC1tZW51LXN1Ym1lbnUtdGl0bGUgLmFudC1tZW51LXN1Ym1lbnUtYXJyb3d7b3BhY2l0eTouNDU7dHJhbnNpdGlvbjphbGwgLjNzfS5hbnQtbWVudS1kYXJrIC5hbnQtbWVudS1zdWIgLmFudC1tZW51LXN1Ym1lbnUtdGl0bGUgLmFudC1tZW51LXN1Ym1lbnUtYXJyb3c6YWZ0ZXIsLmFudC1tZW51LWRhcmsgLmFudC1tZW51LXN1YiAuYW50LW1lbnUtc3VibWVudS10aXRsZSAuYW50LW1lbnUtc3VibWVudS1hcnJvdzpiZWZvcmUsLmFudC1tZW51LmFudC1tZW51LWRhcmsgLmFudC1tZW51LXN1YiAuYW50LW1lbnUtc3VibWVudS10aXRsZSAuYW50LW1lbnUtc3VibWVudS1hcnJvdzphZnRlciwuYW50LW1lbnUuYW50LW1lbnUtZGFyayAuYW50LW1lbnUtc3ViIC5hbnQtbWVudS1zdWJtZW51LXRpdGxlIC5hbnQtbWVudS1zdWJtZW51LWFycm93OmJlZm9yZSwuYW50LW1lbnUuYW50LW1lbnUtZGFyayAuYW50LW1lbnUtc3VibWVudS10aXRsZSAuYW50LW1lbnUtc3VibWVudS1hcnJvdzphZnRlciwuYW50LW1lbnUuYW50LW1lbnUtZGFyayAuYW50LW1lbnUtc3VibWVudS10aXRsZSAuYW50LW1lbnUtc3VibWVudS1hcnJvdzpiZWZvcmV7YmFja2dyb3VuZDojZmZmfS5hbnQtbWVudS1kYXJrLmFudC1tZW51LXN1Ym1lbnUtcG9wdXB7YmFja2dyb3VuZDp0cmFuc3BhcmVudH0uYW50LW1lbnUtZGFyayAuYW50LW1lbnUtaW5saW5lLmFudC1tZW51LXN1YntiYWNrZ3JvdW5kOiMwMDBjMTd9LmFudC1tZW51LWRhcmsuYW50LW1lbnUtaG9yaXpvbnRhbHtib3JkZXItYm90dG9tOjB9LmFudC1tZW51LWRhcmsuYW50LW1lbnUtaG9yaXpvbnRhbD4uYW50LW1lbnUtaXRlbSwuYW50LW1lbnUtZGFyay5hbnQtbWVudS1ob3Jpem9udGFsPi5hbnQtbWVudS1zdWJtZW51e3RvcDowO21hcmdpbi10b3A6MDtwYWRkaW5nOjAgMjBweDtib3JkZXItY29sb3I6IzAwMTUyOTtib3JkZXItYm90dG9tOjB9LmFudC1tZW51LWRhcmsuYW50LW1lbnUtaG9yaXpvbnRhbD4uYW50LW1lbnUtaXRlbTpob3ZlcntiYWNrZ3JvdW5kLWNvbG9yOiMxODkwZmZ9LmFudC1tZW51LWRhcmsuYW50LW1lbnUtaG9yaXpvbnRhbD4uYW50LW1lbnUtaXRlbT5hOmJlZm9yZXtib3R0b206MH0uYW50LW1lbnUtZGFyayAuYW50LW1lbnUtaXRlbSwuYW50LW1lbnUtZGFyayAuYW50LW1lbnUtaXRlbS1ncm91cC10aXRsZSwuYW50LW1lbnUtZGFyayAuYW50LW1lbnUtaXRlbT5hLC5hbnQtbWVudS1kYXJrIC5hbnQtbWVudS1pdGVtPnNwYW4+YXtjb2xvcjpoc2xhKDAsMCUsMTAwJSwuNjUpfS5hbnQtbWVudS1kYXJrLmFudC1tZW51LWlubGluZSwuYW50LW1lbnUtZGFyay5hbnQtbWVudS12ZXJ0aWNhbCwuYW50LW1lbnUtZGFyay5hbnQtbWVudS12ZXJ0aWNhbC1sZWZ0LC5hbnQtbWVudS1kYXJrLmFudC1tZW51LXZlcnRpY2FsLXJpZ2h0e2JvcmRlci1yaWdodDowfS5hbnQtbWVudS1kYXJrLmFudC1tZW51LWlubGluZSAuYW50LW1lbnUtaXRlbSwuYW50LW1lbnUtZGFyay5hbnQtbWVudS12ZXJ0aWNhbC1sZWZ0IC5hbnQtbWVudS1pdGVtLC5hbnQtbWVudS1kYXJrLmFudC1tZW51LXZlcnRpY2FsLXJpZ2h0IC5hbnQtbWVudS1pdGVtLC5hbnQtbWVudS1kYXJrLmFudC1tZW51LXZlcnRpY2FsIC5hbnQtbWVudS1pdGVte2xlZnQ6MDttYXJnaW4tbGVmdDowO2JvcmRlci1yaWdodDowfS5hbnQtbWVudS1kYXJrLmFudC1tZW51LWlubGluZSAuYW50LW1lbnUtaXRlbTphZnRlciwuYW50LW1lbnUtZGFyay5hbnQtbWVudS12ZXJ0aWNhbC1sZWZ0IC5hbnQtbWVudS1pdGVtOmFmdGVyLC5hbnQtbWVudS1kYXJrLmFudC1tZW51LXZlcnRpY2FsLXJpZ2h0IC5hbnQtbWVudS1pdGVtOmFmdGVyLC5hbnQtbWVudS1kYXJrLmFudC1tZW51LXZlcnRpY2FsIC5hbnQtbWVudS1pdGVtOmFmdGVye2JvcmRlci1yaWdodDowfS5hbnQtbWVudS1kYXJrLmFudC1tZW51LWlubGluZSAuYW50LW1lbnUtaXRlbSwuYW50LW1lbnUtZGFyay5hbnQtbWVudS1pbmxpbmUgLmFudC1tZW51LXN1Ym1lbnUtdGl0bGV7d2lkdGg6MTAwJX0uYW50LW1lbnUtZGFyayAuYW50LW1lbnUtaXRlbS1hY3RpdmUsLmFudC1tZW51LWRhcmsgLmFudC1tZW51LWl0ZW06aG92ZXIsLmFudC1tZW51LWRhcmsgLmFudC1tZW51LXN1Ym1lbnUtYWN0aXZlLC5hbnQtbWVudS1kYXJrIC5hbnQtbWVudS1zdWJtZW51LW9wZW4sLmFudC1tZW51LWRhcmsgLmFudC1tZW51LXN1Ym1lbnUtc2VsZWN0ZWQsLmFudC1tZW51LWRhcmsgLmFudC1tZW51LXN1Ym1lbnUtdGl0bGU6aG92ZXJ7Y29sb3I6I2ZmZjtiYWNrZ3JvdW5kLWNvbG9yOnRyYW5zcGFyZW50fS5hbnQtbWVudS1kYXJrIC5hbnQtbWVudS1pdGVtLWFjdGl2ZT5hLC5hbnQtbWVudS1kYXJrIC5hbnQtbWVudS1pdGVtLWFjdGl2ZT5zcGFuPmEsLmFudC1tZW51LWRhcmsgLmFudC1tZW51LWl0ZW06aG92ZXI+YSwuYW50LW1lbnUtZGFyayAuYW50LW1lbnUtaXRlbTpob3Zlcj5zcGFuPmEsLmFudC1tZW51LWRhcmsgLmFudC1tZW51LXN1Ym1lbnUtYWN0aXZlPmEsLmFudC1tZW51LWRhcmsgLmFudC1tZW51LXN1Ym1lbnUtYWN0aXZlPnNwYW4+YSwuYW50LW1lbnUtZGFyayAuYW50LW1lbnUtc3VibWVudS1vcGVuPmEsLmFudC1tZW51LWRhcmsgLmFudC1tZW51LXN1Ym1lbnUtb3Blbj5zcGFuPmEsLmFudC1tZW51LWRhcmsgLmFudC1tZW51LXN1Ym1lbnUtc2VsZWN0ZWQ+YSwuYW50LW1lbnUtZGFyayAuYW50LW1lbnUtc3VibWVudS1zZWxlY3RlZD5zcGFuPmEsLmFudC1tZW51LWRhcmsgLmFudC1tZW51LXN1Ym1lbnUtdGl0bGU6aG92ZXI+YSwuYW50LW1lbnUtZGFyayAuYW50LW1lbnUtc3VibWVudS10aXRsZTpob3Zlcj5zcGFuPmF7Y29sb3I6I2ZmZn0uYW50LW1lbnUtZGFyayAuYW50LW1lbnUtaXRlbS1hY3RpdmU+LmFudC1tZW51LXN1Ym1lbnUtdGl0bGU+LmFudC1tZW51LXN1Ym1lbnUtYXJyb3csLmFudC1tZW51LWRhcmsgLmFudC1tZW51LWl0ZW06aG92ZXI+LmFudC1tZW51LXN1Ym1lbnUtdGl0bGU+LmFudC1tZW51LXN1Ym1lbnUtYXJyb3csLmFudC1tZW51LWRhcmsgLmFudC1tZW51LXN1Ym1lbnUtYWN0aXZlPi5hbnQtbWVudS1zdWJtZW51LXRpdGxlPi5hbnQtbWVudS1zdWJtZW51LWFycm93LC5hbnQtbWVudS1kYXJrIC5hbnQtbWVudS1zdWJtZW51LW9wZW4+LmFudC1tZW51LXN1Ym1lbnUtdGl0bGU+LmFudC1tZW51LXN1Ym1lbnUtYXJyb3csLmFudC1tZW51LWRhcmsgLmFudC1tZW51LXN1Ym1lbnUtc2VsZWN0ZWQ+LmFudC1tZW51LXN1Ym1lbnUtdGl0bGU+LmFudC1tZW51LXN1Ym1lbnUtYXJyb3csLmFudC1tZW51LWRhcmsgLmFudC1tZW51LXN1Ym1lbnUtdGl0bGU6aG92ZXI+LmFudC1tZW51LXN1Ym1lbnUtdGl0bGU+LmFudC1tZW51LXN1Ym1lbnUtYXJyb3d7b3BhY2l0eToxfS5hbnQtbWVudS1kYXJrIC5hbnQtbWVudS1pdGVtLWFjdGl2ZT4uYW50LW1lbnUtc3VibWVudS10aXRsZT4uYW50LW1lbnUtc3VibWVudS1hcnJvdzphZnRlciwuYW50LW1lbnUtZGFyayAuYW50LW1lbnUtaXRlbS1hY3RpdmU+LmFudC1tZW51LXN1Ym1lbnUtdGl0bGU+LmFudC1tZW51LXN1Ym1lbnUtYXJyb3c6YmVmb3JlLC5hbnQtbWVudS1kYXJrIC5hbnQtbWVudS1pdGVtOmhvdmVyPi5hbnQtbWVudS1zdWJtZW51LXRpdGxlPi5hbnQtbWVudS1zdWJtZW51LWFycm93OmFmdGVyLC5hbnQtbWVudS1kYXJrIC5hbnQtbWVudS1pdGVtOmhvdmVyPi5hbnQtbWVudS1zdWJtZW51LXRpdGxlPi5hbnQtbWVudS1zdWJtZW51LWFycm93OmJlZm9yZSwuYW50LW1lbnUtZGFyayAuYW50LW1lbnUtc3VibWVudS1hY3RpdmU+LmFudC1tZW51LXN1Ym1lbnUtdGl0bGU+LmFudC1tZW51LXN1Ym1lbnUtYXJyb3c6YWZ0ZXIsLmFudC1tZW51LWRhcmsgLmFudC1tZW51LXN1Ym1lbnUtYWN0aXZlPi5hbnQtbWVudS1zdWJtZW51LXRpdGxlPi5hbnQtbWVudS1zdWJtZW51LWFycm93OmJlZm9yZSwuYW50LW1lbnUtZGFyayAuYW50LW1lbnUtc3VibWVudS1vcGVuPi5hbnQtbWVudS1zdWJtZW51LXRpdGxlPi5hbnQtbWVudS1zdWJtZW51LWFycm93OmFmdGVyLC5hbnQtbWVudS1kYXJrIC5hbnQtbWVudS1zdWJtZW51LW9wZW4+LmFudC1tZW51LXN1Ym1lbnUtdGl0bGU+LmFudC1tZW51LXN1Ym1lbnUtYXJyb3c6YmVmb3JlLC5hbnQtbWVudS1kYXJrIC5hbnQtbWVudS1zdWJtZW51LXNlbGVjdGVkPi5hbnQtbWVudS1zdWJtZW51LXRpdGxlPi5hbnQtbWVudS1zdWJtZW51LWFycm93OmFmdGVyLC5hbnQtbWVudS1kYXJrIC5hbnQtbWVudS1zdWJtZW51LXNlbGVjdGVkPi5hbnQtbWVudS1zdWJtZW51LXRpdGxlPi5hbnQtbWVudS1zdWJtZW51LWFycm93OmJlZm9yZSwuYW50LW1lbnUtZGFyayAuYW50LW1lbnUtc3VibWVudS10aXRsZTpob3Zlcj4uYW50LW1lbnUtc3VibWVudS10aXRsZT4uYW50LW1lbnUtc3VibWVudS1hcnJvdzphZnRlciwuYW50LW1lbnUtZGFyayAuYW50LW1lbnUtc3VibWVudS10aXRsZTpob3Zlcj4uYW50LW1lbnUtc3VibWVudS10aXRsZT4uYW50LW1lbnUtc3VibWVudS1hcnJvdzpiZWZvcmV7YmFja2dyb3VuZDojZmZmfS5hbnQtbWVudS1kYXJrIC5hbnQtbWVudS1pdGVtOmhvdmVye2JhY2tncm91bmQtY29sb3I6dHJhbnNwYXJlbnR9LmFudC1tZW51LWRhcmsuYW50LW1lbnUtZGFyazpub3QoLmFudC1tZW51LWhvcml6b250YWwpIC5hbnQtbWVudS1pdGVtLXNlbGVjdGVke2JhY2tncm91bmQtY29sb3I6IzE4OTBmZn0uYW50LW1lbnUtZGFyayAuYW50LW1lbnUtaXRlbS1zZWxlY3RlZHtjb2xvcjojZmZmO2JvcmRlci1yaWdodDowfS5hbnQtbWVudS1kYXJrIC5hbnQtbWVudS1pdGVtLXNlbGVjdGVkOmFmdGVye2JvcmRlci1yaWdodDowfS5hbnQtbWVudS1kYXJrIC5hbnQtbWVudS1pdGVtLXNlbGVjdGVkIC5hbnQtbWVudS1pdGVtLWljb24sLmFudC1tZW51LWRhcmsgLmFudC1tZW51LWl0ZW0tc2VsZWN0ZWQgLmFudC1tZW51LWl0ZW0taWNvbitzcGFuLC5hbnQtbWVudS1kYXJrIC5hbnQtbWVudS1pdGVtLXNlbGVjdGVkIC5hbnRpY29uLC5hbnQtbWVudS1kYXJrIC5hbnQtbWVudS1pdGVtLXNlbGVjdGVkIC5hbnRpY29uK3NwYW4sLmFudC1tZW51LWRhcmsgLmFudC1tZW51LWl0ZW0tc2VsZWN0ZWQ+YSwuYW50LW1lbnUtZGFyayAuYW50LW1lbnUtaXRlbS1zZWxlY3RlZD5hOmhvdmVyLC5hbnQtbWVudS1kYXJrIC5hbnQtbWVudS1pdGVtLXNlbGVjdGVkPnNwYW4+YSwuYW50LW1lbnUtZGFyayAuYW50LW1lbnUtaXRlbS1zZWxlY3RlZD5zcGFuPmE6aG92ZXJ7Y29sb3I6I2ZmZn0uYW50LW1lbnUtc3VibWVudS1wb3B1cC5hbnQtbWVudS1kYXJrIC5hbnQtbWVudS1pdGVtLXNlbGVjdGVkLC5hbnQtbWVudS5hbnQtbWVudS1kYXJrIC5hbnQtbWVudS1pdGVtLXNlbGVjdGVke2JhY2tncm91bmQtY29sb3I6IzE4OTBmZn0uYW50LW1lbnUtZGFyayAuYW50LW1lbnUtaXRlbS1kaXNhYmxlZCwuYW50LW1lbnUtZGFyayAuYW50LW1lbnUtaXRlbS1kaXNhYmxlZD5hLC5hbnQtbWVudS1kYXJrIC5hbnQtbWVudS1pdGVtLWRpc2FibGVkPnNwYW4+YSwuYW50LW1lbnUtZGFyayAuYW50LW1lbnUtc3VibWVudS1kaXNhYmxlZCwuYW50LW1lbnUtZGFyayAuYW50LW1lbnUtc3VibWVudS1kaXNhYmxlZD5hLC5hbnQtbWVudS1kYXJrIC5hbnQtbWVudS1zdWJtZW51LWRpc2FibGVkPnNwYW4+YXtjb2xvcjpoc2xhKDAsMCUsMTAwJSwuMzUpIWltcG9ydGFudDtvcGFjaXR5Oi44fS5hbnQtbWVudS1kYXJrIC5hbnQtbWVudS1pdGVtLWRpc2FibGVkPi5hbnQtbWVudS1zdWJtZW51LXRpdGxlLC5hbnQtbWVudS1kYXJrIC5hbnQtbWVudS1zdWJtZW51LWRpc2FibGVkPi5hbnQtbWVudS1zdWJtZW51LXRpdGxle2NvbG9yOmhzbGEoMCwwJSwxMDAlLC4zNSkhaW1wb3J0YW50fS5hbnQtbWVudS1kYXJrIC5hbnQtbWVudS1pdGVtLWRpc2FibGVkPi5hbnQtbWVudS1zdWJtZW51LXRpdGxlPi5hbnQtbWVudS1zdWJtZW51LWFycm93OmFmdGVyLC5hbnQtbWVudS1kYXJrIC5hbnQtbWVudS1pdGVtLWRpc2FibGVkPi5hbnQtbWVudS1zdWJtZW51LXRpdGxlPi5hbnQtbWVudS1zdWJtZW51LWFycm93OmJlZm9yZSwuYW50LW1lbnUtZGFyayAuYW50LW1lbnUtc3VibWVudS1kaXNhYmxlZD4uYW50LW1lbnUtc3VibWVudS10aXRsZT4uYW50LW1lbnUtc3VibWVudS1hcnJvdzphZnRlciwuYW50LW1lbnUtZGFyayAuYW50LW1lbnUtc3VibWVudS1kaXNhYmxlZD4uYW50LW1lbnUtc3VibWVudS10aXRsZT4uYW50LW1lbnUtc3VibWVudS1hcnJvdzpiZWZvcmV7YmFja2dyb3VuZDpoc2xhKDAsMCUsMTAwJSwuMzUpIWltcG9ydGFudH0uYW50LW1lbnUuYW50LW1lbnUtcnRse2RpcmVjdGlvbjpydGw7dGV4dC1hbGlnbjpyaWdodH0uYW50LW1lbnUtcnRsIC5hbnQtbWVudS1pdGVtLWdyb3VwLXRpdGxle3RleHQtYWxpZ246cmlnaHR9LmFudC1tZW51LXJ0bC5hbnQtbWVudS1pbmxpbmUsLmFudC1tZW51LXJ0bC5hbnQtbWVudS12ZXJ0aWNhbHtib3JkZXItcmlnaHQ6bm9uZTtib3JkZXItbGVmdDoxcHggc29saWQgI2YwZjBmMH0uYW50LW1lbnUtcnRsLmFudC1tZW51LWRhcmsuYW50LW1lbnUtaW5saW5lLC5hbnQtbWVudS1ydGwuYW50LW1lbnUtZGFyay5hbnQtbWVudS12ZXJ0aWNhbHtib3JkZXItbGVmdDpub25lfS5hbnQtbWVudS1ydGwuYW50LW1lbnUtdmVydGljYWwtbGVmdC5hbnQtbWVudS1zdWI+LmFudC1tZW51LWl0ZW0sLmFudC1tZW51LXJ0bC5hbnQtbWVudS12ZXJ0aWNhbC1sZWZ0LmFudC1tZW51LXN1Yj4uYW50LW1lbnUtc3VibWVudSwuYW50LW1lbnUtcnRsLmFudC1tZW51LXZlcnRpY2FsLXJpZ2h0LmFudC1tZW51LXN1Yj4uYW50LW1lbnUtaXRlbSwuYW50LW1lbnUtcnRsLmFudC1tZW51LXZlcnRpY2FsLXJpZ2h0LmFudC1tZW51LXN1Yj4uYW50LW1lbnUtc3VibWVudSwuYW50LW1lbnUtcnRsLmFudC1tZW51LXZlcnRpY2FsLmFudC1tZW51LXN1Yj4uYW50LW1lbnUtaXRlbSwuYW50LW1lbnUtcnRsLmFudC1tZW51LXZlcnRpY2FsLmFudC1tZW51LXN1Yj4uYW50LW1lbnUtc3VibWVudXt0cmFuc2Zvcm0tb3JpZ2luOnRvcCByaWdodH0uYW50LW1lbnUtcnRsIC5hbnQtbWVudS1pdGVtIC5hbnQtbWVudS1pdGVtLWljb24sLmFudC1tZW51LXJ0bCAuYW50LW1lbnUtaXRlbSAuYW50aWNvbiwuYW50LW1lbnUtcnRsIC5hbnQtbWVudS1zdWJtZW51LXRpdGxlIC5hbnQtbWVudS1pdGVtLWljb24sLmFudC1tZW51LXJ0bCAuYW50LW1lbnUtc3VibWVudS10aXRsZSAuYW50aWNvbnttYXJnaW4tcmlnaHQ6YXV0bzttYXJnaW4tbGVmdDoxMHB4fS5hbnQtbWVudS1ydGwgLmFudC1tZW51LWl0ZW0uYW50LW1lbnUtaXRlbS1vbmx5LWNoaWxkPi5hbnQtbWVudS1pdGVtLWljb24sLmFudC1tZW51LXJ0bCAuYW50LW1lbnUtaXRlbS5hbnQtbWVudS1pdGVtLW9ubHktY2hpbGQ+LmFudGljb24sLmFudC1tZW51LXJ0bCAuYW50LW1lbnUtc3VibWVudS10aXRsZS5hbnQtbWVudS1pdGVtLW9ubHktY2hpbGQ+LmFudC1tZW51LWl0ZW0taWNvbiwuYW50LW1lbnUtcnRsIC5hbnQtbWVudS1zdWJtZW51LXRpdGxlLmFudC1tZW51LWl0ZW0tb25seS1jaGlsZD4uYW50aWNvbnttYXJnaW4tbGVmdDowfS5hbnQtbWVudS1zdWJtZW51LXJ0bC5hbnQtbWVudS1zdWJtZW51LXBvcHVwe3RyYW5zZm9ybS1vcmlnaW46MTAwJSAwfS5hbnQtbWVudS1ydGwgLmFudC1tZW51LXN1Ym1lbnUtaW5saW5lPi5hbnQtbWVudS1zdWJtZW51LXRpdGxlIC5hbnQtbWVudS1zdWJtZW51LWFycm93LC5hbnQtbWVudS1ydGwgLmFudC1tZW51LXN1Ym1lbnUtdmVydGljYWwtbGVmdD4uYW50LW1lbnUtc3VibWVudS10aXRsZSAuYW50LW1lbnUtc3VibWVudS1hcnJvdywuYW50LW1lbnUtcnRsIC5hbnQtbWVudS1zdWJtZW51LXZlcnRpY2FsLXJpZ2h0Pi5hbnQtbWVudS1zdWJtZW51LXRpdGxlIC5hbnQtbWVudS1zdWJtZW51LWFycm93LC5hbnQtbWVudS1ydGwgLmFudC1tZW51LXN1Ym1lbnUtdmVydGljYWw+LmFudC1tZW51LXN1Ym1lbnUtdGl0bGUgLmFudC1tZW51LXN1Ym1lbnUtYXJyb3d7cmlnaHQ6YXV0bztsZWZ0OjE2cHh9LmFudC1tZW51LXJ0bCAuYW50LW1lbnUtc3VibWVudS12ZXJ0aWNhbC1sZWZ0Pi5hbnQtbWVudS1zdWJtZW51LXRpdGxlIC5hbnQtbWVudS1zdWJtZW51LWFycm93OmJlZm9yZSwuYW50LW1lbnUtcnRsIC5hbnQtbWVudS1zdWJtZW51LXZlcnRpY2FsLXJpZ2h0Pi5hbnQtbWVudS1zdWJtZW51LXRpdGxlIC5hbnQtbWVudS1zdWJtZW51LWFycm93OmJlZm9yZSwuYW50LW1lbnUtcnRsIC5hbnQtbWVudS1zdWJtZW51LXZlcnRpY2FsPi5hbnQtbWVudS1zdWJtZW51LXRpdGxlIC5hbnQtbWVudS1zdWJtZW51LWFycm93OmJlZm9yZXt0cmFuc2Zvcm06cm90YXRlKC00NWRlZykgdHJhbnNsYXRlWSgtMnB4KX0uYW50LW1lbnUtcnRsIC5hbnQtbWVudS1zdWJtZW51LXZlcnRpY2FsLWxlZnQ+LmFudC1tZW51LXN1Ym1lbnUtdGl0bGUgLmFudC1tZW51LXN1Ym1lbnUtYXJyb3c6YWZ0ZXIsLmFudC1tZW51LXJ0bCAuYW50LW1lbnUtc3VibWVudS12ZXJ0aWNhbC1yaWdodD4uYW50LW1lbnUtc3VibWVudS10aXRsZSAuYW50LW1lbnUtc3VibWVudS1hcnJvdzphZnRlciwuYW50LW1lbnUtcnRsIC5hbnQtbWVudS1zdWJtZW51LXZlcnRpY2FsPi5hbnQtbWVudS1zdWJtZW51LXRpdGxlIC5hbnQtbWVudS1zdWJtZW51LWFycm93OmFmdGVye3RyYW5zZm9ybTpyb3RhdGUoNDVkZWcpIHRyYW5zbGF0ZVkoMnB4KX0uYW50LW1lbnUtcnRsLmFudC1tZW51LWlubGluZSAuYW50LW1lbnUtaXRlbTphZnRlciwuYW50LW1lbnUtcnRsLmFudC1tZW51LXZlcnRpY2FsLWxlZnQgLmFudC1tZW51LWl0ZW06YWZ0ZXIsLmFudC1tZW51LXJ0bC5hbnQtbWVudS12ZXJ0aWNhbC1yaWdodCAuYW50LW1lbnUtaXRlbTphZnRlciwuYW50LW1lbnUtcnRsLmFudC1tZW51LXZlcnRpY2FsIC5hbnQtbWVudS1pdGVtOmFmdGVye3JpZ2h0OmF1dG87bGVmdDowfS5hbnQtbWVudS1ydGwuYW50LW1lbnUtaW5saW5lIC5hbnQtbWVudS1pdGVtLC5hbnQtbWVudS1ydGwuYW50LW1lbnUtaW5saW5lIC5hbnQtbWVudS1zdWJtZW51LXRpdGxlLC5hbnQtbWVudS1ydGwuYW50LW1lbnUtdmVydGljYWwtbGVmdCAuYW50LW1lbnUtaXRlbSwuYW50LW1lbnUtcnRsLmFudC1tZW51LXZlcnRpY2FsLWxlZnQgLmFudC1tZW51LXN1Ym1lbnUtdGl0bGUsLmFudC1tZW51LXJ0bC5hbnQtbWVudS12ZXJ0aWNhbC1yaWdodCAuYW50LW1lbnUtaXRlbSwuYW50LW1lbnUtcnRsLmFudC1tZW51LXZlcnRpY2FsLXJpZ2h0IC5hbnQtbWVudS1zdWJtZW51LXRpdGxlLC5hbnQtbWVudS1ydGwuYW50LW1lbnUtdmVydGljYWwgLmFudC1tZW51LWl0ZW0sLmFudC1tZW51LXJ0bC5hbnQtbWVudS12ZXJ0aWNhbCAuYW50LW1lbnUtc3VibWVudS10aXRsZXt0ZXh0LWFsaWduOnJpZ2h0fS5hbnQtbWVudS1ydGwuYW50LW1lbnUtaW5saW5lIC5hbnQtbWVudS1zdWJtZW51LXRpdGxle3BhZGRpbmctcmlnaHQ6MDtwYWRkaW5nLWxlZnQ6MzRweH0uYW50LW1lbnUtcnRsLmFudC1tZW51LXZlcnRpY2FsIC5hbnQtbWVudS1zdWJtZW51LXRpdGxle3BhZGRpbmctcmlnaHQ6MTZweDtwYWRkaW5nLWxlZnQ6MzRweH0uYW50LW1lbnUtcnRsLmFudC1tZW51LWlubGluZS1jb2xsYXBzZWQuYW50LW1lbnUtdmVydGljYWwgLmFudC1tZW51LXN1Ym1lbnUtdGl0bGV7cGFkZGluZzowIGNhbGMoNTAlIC0gOHB4KX0uYW50LW1lbnUtcnRsIC5hbnQtbWVudS1pdGVtLWdyb3VwLWxpc3QgLmFudC1tZW51LWl0ZW0sLmFudC1tZW51LXJ0bCAuYW50LW1lbnUtaXRlbS1ncm91cC1saXN0IC5hbnQtbWVudS1zdWJtZW51LXRpdGxle3BhZGRpbmc6MCAyOHB4IDAgMTZweH0uYW50LW1lbnUtc3ViLmFudC1tZW51LWlubGluZXtib3JkZXI6MH0uYW50LW1lbnUtcnRsLmFudC1tZW51LXN1Yi5hbnQtbWVudS1pbmxpbmUgLmFudC1tZW51LWl0ZW0tZ3JvdXAtdGl0bGV7cGFkZGluZy1yaWdodDozMnB4O3BhZGRpbmctbGVmdDowfS5hbnQtbWVzc2FnZXtib3gtc2l6aW5nOmJvcmRlci1ib3g7bWFyZ2luOjA7cGFkZGluZzowO2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtmb250LXNpemU6MTRweDtmb250LXZhcmlhbnQ6dGFidWxhci1udW1zO2xpbmUtaGVpZ2h0OjEuNTcxNTtsaXN0LXN0eWxlOm5vbmU7Zm9udC1mZWF0dXJlLXNldHRpbmdzOlwidG51bVwiO3Bvc2l0aW9uOmZpeGVkO3RvcDo4cHg7bGVmdDowO3otaW5kZXg6MTAxMDt3aWR0aDoxMDAlO3BvaW50ZXItZXZlbnRzOm5vbmV9LmFudC1tZXNzYWdlLW5vdGljZXtwYWRkaW5nOjhweDt0ZXh0LWFsaWduOmNlbnRlcn0uYW50LW1lc3NhZ2Utbm90aWNlLWNvbnRlbnR7ZGlzcGxheTppbmxpbmUtYmxvY2s7cGFkZGluZzoxMHB4IDE2cHg7YmFja2dyb3VuZDojZmZmO2JvcmRlci1yYWRpdXM6MnB4O2JveC1zaGFkb3c6MCAzcHggNnB4IC00cHggcmdiYSgwLDAsMCwuMTIpLDAgNnB4IDE2cHggMCByZ2JhKDAsMCwwLC4wOCksMCA5cHggMjhweCA4cHggcmdiYSgwLDAsMCwuMDUpO3BvaW50ZXItZXZlbnRzOmFsbH0uYW50LW1lc3NhZ2Utc3VjY2VzcyAuYW50aWNvbntjb2xvcjojNTJjNDFhfS5hbnQtbWVzc2FnZS1lcnJvciAuYW50aWNvbntjb2xvcjojZmY0ZDRmfS5hbnQtbWVzc2FnZS13YXJuaW5nIC5hbnRpY29ue2NvbG9yOiNmYWFkMTR9LmFudC1tZXNzYWdlLWluZm8gLmFudGljb24sLmFudC1tZXNzYWdlLWxvYWRpbmcgLmFudGljb257Y29sb3I6IzE4OTBmZn0uYW50LW1lc3NhZ2UgLmFudGljb257cG9zaXRpb246cmVsYXRpdmU7dG9wOjFweDttYXJnaW4tcmlnaHQ6OHB4O2ZvbnQtc2l6ZToxNnB4fS5hbnQtbWVzc2FnZS1ub3RpY2UuYW50LW1vdmUtdXAtbGVhdmUuYW50LW1vdmUtdXAtbGVhdmUtYWN0aXZle2FuaW1hdGlvbi1uYW1lOk1lc3NhZ2VNb3ZlT3V0O2FuaW1hdGlvbi1kdXJhdGlvbjouM3N9QGtleWZyYW1lcyBNZXNzYWdlTW92ZU91dHswJXttYXgtaGVpZ2h0OjE1MHB4O3BhZGRpbmc6OHB4O29wYWNpdHk6MX10b3ttYXgtaGVpZ2h0OjA7cGFkZGluZzowO29wYWNpdHk6MH19LmFudC1tZXNzYWdlLXJ0bCwuYW50LW1lc3NhZ2UtcnRsIHNwYW57ZGlyZWN0aW9uOnJ0bH0uYW50LW1lc3NhZ2UtcnRsIC5hbnRpY29ue21hcmdpbi1yaWdodDowO21hcmdpbi1sZWZ0OjhweH0uYW50LW1vZGFse2JveC1zaXppbmc6Ym9yZGVyLWJveDtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7Zm9udC1zaXplOjE0cHg7Zm9udC12YXJpYW50OnRhYnVsYXItbnVtcztsaW5lLWhlaWdodDoxLjU3MTU7bGlzdC1zdHlsZTpub25lO2ZvbnQtZmVhdHVyZS1zZXR0aW5nczpcInRudW1cIjtwb2ludGVyLWV2ZW50czpub25lO3Bvc2l0aW9uOnJlbGF0aXZlO3RvcDoxMDBweDt3aWR0aDphdXRvO21heC13aWR0aDpjYWxjKDEwMHZ3IC0gMzJweCk7bWFyZ2luOjAgYXV0bztwYWRkaW5nOjAgMCAyNHB4fS5hbnQtbW9kYWwuYW50LXpvb20tYXBwZWFyLC5hbnQtbW9kYWwuYW50LXpvb20tZW50ZXJ7dHJhbnNmb3JtOm5vbmU7b3BhY2l0eTowO2FuaW1hdGlvbi1kdXJhdGlvbjouM3M7LXdlYmtpdC11c2VyLXNlbGVjdDpub25lOy1tb3otdXNlci1zZWxlY3Q6bm9uZTstbXMtdXNlci1zZWxlY3Q6bm9uZTt1c2VyLXNlbGVjdDpub25lfS5hbnQtbW9kYWwtbWFza3twb3NpdGlvbjpmaXhlZDt0b3A6MDtyaWdodDowO2JvdHRvbTowO2xlZnQ6MDt6LWluZGV4OjEwMDA7aGVpZ2h0OjEwMCU7YmFja2dyb3VuZC1jb2xvcjpyZ2JhKDAsMCwwLC40NSl9LmFudC1tb2RhbC1tYXNrLWhpZGRlbntkaXNwbGF5Om5vbmV9LmFudC1tb2RhbC13cmFwe3Bvc2l0aW9uOmZpeGVkO3RvcDowO3JpZ2h0OjA7Ym90dG9tOjA7bGVmdDowO292ZXJmbG93OmF1dG87b3V0bGluZTowO3otaW5kZXg6MTAwMH0uYW50LW1vZGFsLXRpdGxle21hcmdpbjowO2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtmb250LXdlaWdodDo1MDA7Zm9udC1zaXplOjE2cHg7bGluZS1oZWlnaHQ6MjJweDt3b3JkLXdyYXA6YnJlYWstd29yZH0uYW50LW1vZGFsLWNvbnRlbnR7cG9zaXRpb246cmVsYXRpdmU7YmFja2dyb3VuZC1jb2xvcjojZmZmO2JhY2tncm91bmQtY2xpcDpwYWRkaW5nLWJveDtib3JkZXI6MDtib3JkZXItcmFkaXVzOjJweDtib3gtc2hhZG93OjAgM3B4IDZweCAtNHB4IHJnYmEoMCwwLDAsLjEyKSwwIDZweCAxNnB4IDAgcmdiYSgwLDAsMCwuMDgpLDAgOXB4IDI4cHggOHB4IHJnYmEoMCwwLDAsLjA1KTtwb2ludGVyLWV2ZW50czphdXRvfS5hbnQtbW9kYWwtY2xvc2V7cG9zaXRpb246YWJzb2x1dGU7dG9wOjA7cmlnaHQ6MDt6LWluZGV4OjEwO3BhZGRpbmc6MDtjb2xvcjpyZ2JhKDAsMCwwLC40NSk7Zm9udC13ZWlnaHQ6NzAwO2xpbmUtaGVpZ2h0OjE7dGV4dC1kZWNvcmF0aW9uOm5vbmU7YmFja2dyb3VuZDp0cmFuc3BhcmVudDtib3JkZXI6MDtvdXRsaW5lOjA7Y3Vyc29yOnBvaW50ZXI7dHJhbnNpdGlvbjpjb2xvciAuM3N9LmFudC1tb2RhbC1jbG9zZS14e2Rpc3BsYXk6YmxvY2s7d2lkdGg6NTRweDtoZWlnaHQ6NTRweDtmb250LXNpemU6MTZweDtmb250LXN0eWxlOm5vcm1hbDtsaW5lLWhlaWdodDo1NHB4O3RleHQtYWxpZ246Y2VudGVyO3RleHQtdHJhbnNmb3JtOm5vbmU7dGV4dC1yZW5kZXJpbmc6YXV0b30uYW50LW1vZGFsLWNsb3NlOmZvY3VzLC5hbnQtbW9kYWwtY2xvc2U6aG92ZXJ7Y29sb3I6cmdiYSgwLDAsMCwuNzUpO3RleHQtZGVjb3JhdGlvbjpub25lfS5hbnQtbW9kYWwtaGVhZGVye3BhZGRpbmc6MTZweCAyNHB4O2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtiYWNrZ3JvdW5kOiNmZmY7Ym9yZGVyLWJvdHRvbToxcHggc29saWQgI2YwZjBmMDtib3JkZXItcmFkaXVzOjJweCAycHggMCAwfS5hbnQtbW9kYWwtYm9keXtwYWRkaW5nOjI0cHg7Zm9udC1zaXplOjE0cHg7bGluZS1oZWlnaHQ6MS41NzE1O3dvcmQtd3JhcDpicmVhay13b3JkfS5hbnQtbW9kYWwtZm9vdGVye3BhZGRpbmc6MTBweCAxNnB4O3RleHQtYWxpZ246cmlnaHQ7YmFja2dyb3VuZDp0cmFuc3BhcmVudDtib3JkZXItdG9wOjFweCBzb2xpZCAjZjBmMGYwO2JvcmRlci1yYWRpdXM6MCAwIDJweCAycHh9LmFudC1tb2RhbC1mb290ZXIgLmFudC1idG4rLmFudC1idG46bm90KC5hbnQtZHJvcGRvd24tdHJpZ2dlcil7bWFyZ2luLWJvdHRvbTowO21hcmdpbi1sZWZ0OjhweH0uYW50LW1vZGFsLW9wZW57b3ZlcmZsb3c6aGlkZGVufS5hbnQtbW9kYWwtY2VudGVyZWR7dGV4dC1hbGlnbjpjZW50ZXJ9LmFudC1tb2RhbC1jZW50ZXJlZDpiZWZvcmV7ZGlzcGxheTppbmxpbmUtYmxvY2s7d2lkdGg6MDtoZWlnaHQ6MTAwJTt2ZXJ0aWNhbC1hbGlnbjptaWRkbGU7Y29udGVudDpcIlwifS5hbnQtbW9kYWwtY2VudGVyZWQgLmFudC1tb2RhbHt0b3A6MDtkaXNwbGF5OmlubGluZS1ibG9jaztwYWRkaW5nLWJvdHRvbTowO3RleHQtYWxpZ246bGVmdDt2ZXJ0aWNhbC1hbGlnbjptaWRkbGV9QG1lZGlhIChtYXgtd2lkdGg6NzY3cHgpey5hbnQtbW9kYWx7bWF4LXdpZHRoOmNhbGMoMTAwdncgLSAxNnB4KTttYXJnaW46OHB4IGF1dG99LmFudC1tb2RhbC1jZW50ZXJlZCAuYW50LW1vZGFse2ZsZXg6MX19LmFudC1tb2RhbC1jb25maXJtIC5hbnQtbW9kYWwtaGVhZGVye2Rpc3BsYXk6bm9uZX0uYW50LW1vZGFsLWNvbmZpcm0gLmFudC1tb2RhbC1ib2R5e3BhZGRpbmc6MzJweCAzMnB4IDI0cHh9LmFudC1tb2RhbC1jb25maXJtLWJvZHktd3JhcHBlcjpiZWZvcmV7ZGlzcGxheTp0YWJsZTtjb250ZW50OlwiXCJ9LmFudC1tb2RhbC1jb25maXJtLWJvZHktd3JhcHBlcjphZnRlcntkaXNwbGF5OnRhYmxlO2NsZWFyOmJvdGg7Y29udGVudDpcIlwifS5hbnQtbW9kYWwtY29uZmlybS1ib2R5IC5hbnQtbW9kYWwtY29uZmlybS10aXRsZXtkaXNwbGF5OmJsb2NrO292ZXJmbG93OmhpZGRlbjtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7Zm9udC13ZWlnaHQ6NTAwO2ZvbnQtc2l6ZToxNnB4O2xpbmUtaGVpZ2h0OjEuNH0uYW50LW1vZGFsLWNvbmZpcm0tYm9keSAuYW50LW1vZGFsLWNvbmZpcm0tY29udGVudHttYXJnaW4tdG9wOjhweDtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7Zm9udC1zaXplOjE0cHh9LmFudC1tb2RhbC1jb25maXJtLWJvZHk+LmFudGljb257ZmxvYXQ6bGVmdDttYXJnaW4tcmlnaHQ6MTZweDtmb250LXNpemU6MjJweH0uYW50LW1vZGFsLWNvbmZpcm0tYm9keT4uYW50aWNvbisuYW50LW1vZGFsLWNvbmZpcm0tdGl0bGUrLmFudC1tb2RhbC1jb25maXJtLWNvbnRlbnR7bWFyZ2luLWxlZnQ6MzhweH0uYW50LW1vZGFsLWNvbmZpcm0gLmFudC1tb2RhbC1jb25maXJtLWJ0bnN7bWFyZ2luLXRvcDoyNHB4O3RleHQtYWxpZ246cmlnaHR9LmFudC1tb2RhbC1jb25maXJtIC5hbnQtbW9kYWwtY29uZmlybS1idG5zIC5hbnQtYnRuKy5hbnQtYnRue21hcmdpbi1ib3R0b206MDttYXJnaW4tbGVmdDo4cHh9LmFudC1tb2RhbC1jb25maXJtLWVycm9yIC5hbnQtbW9kYWwtY29uZmlybS1ib2R5Pi5hbnRpY29ue2NvbG9yOiNmZjRkNGZ9LmFudC1tb2RhbC1jb25maXJtLWNvbmZpcm0gLmFudC1tb2RhbC1jb25maXJtLWJvZHk+LmFudGljb24sLmFudC1tb2RhbC1jb25maXJtLXdhcm5pbmcgLmFudC1tb2RhbC1jb25maXJtLWJvZHk+LmFudGljb257Y29sb3I6I2ZhYWQxNH0uYW50LW1vZGFsLWNvbmZpcm0taW5mbyAuYW50LW1vZGFsLWNvbmZpcm0tYm9keT4uYW50aWNvbntjb2xvcjojMTg5MGZmfS5hbnQtbW9kYWwtY29uZmlybS1zdWNjZXNzIC5hbnQtbW9kYWwtY29uZmlybS1ib2R5Pi5hbnRpY29ue2NvbG9yOiM1MmM0MWF9LmFudC1tb2RhbC1jb25maXJtIC5hbnQtem9vbS1sZWF2ZSAuYW50LW1vZGFsLWNvbmZpcm0tYnRuc3twb2ludGVyLWV2ZW50czpub25lfS5hbnQtbW9kYWwtd3JhcC1ydGx7ZGlyZWN0aW9uOnJ0bH0uYW50LW1vZGFsLXdyYXAtcnRsIC5hbnQtbW9kYWwtY2xvc2V7cmlnaHQ6YXV0bztsZWZ0OjB9LmFudC1tb2RhbC13cmFwLXJ0bCAuYW50LW1vZGFsLWZvb3Rlcnt0ZXh0LWFsaWduOmxlZnR9LmFudC1tb2RhbC13cmFwLXJ0bCAuYW50LW1vZGFsLWZvb3RlciAuYW50LWJ0bisuYW50LWJ0bnttYXJnaW4tcmlnaHQ6OHB4O21hcmdpbi1sZWZ0OjB9LmFudC1tb2RhbC13cmFwLXJ0bCAuYW50LW1vZGFsLWNvbmZpcm0tYm9keXtkaXJlY3Rpb246cnRsfS5hbnQtbW9kYWwtd3JhcC1ydGwgLmFudC1tb2RhbC1jb25maXJtLWJvZHk+LmFudGljb257ZmxvYXQ6cmlnaHQ7bWFyZ2luLXJpZ2h0OjA7bWFyZ2luLWxlZnQ6MTZweH0uYW50LW1vZGFsLXdyYXAtcnRsIC5hbnQtbW9kYWwtY29uZmlybS1ib2R5Pi5hbnRpY29uKy5hbnQtbW9kYWwtY29uZmlybS10aXRsZSsuYW50LW1vZGFsLWNvbmZpcm0tY29udGVudHttYXJnaW4tcmlnaHQ6MzhweDttYXJnaW4tbGVmdDowfS5hbnQtbW9kYWwtd3JhcC1ydGwgLmFudC1tb2RhbC1jb25maXJtLWJ0bnN7dGV4dC1hbGlnbjpsZWZ0fS5hbnQtbW9kYWwtd3JhcC1ydGwgLmFudC1tb2RhbC1jb25maXJtLWJ0bnMgLmFudC1idG4rLmFudC1idG57bWFyZ2luLXJpZ2h0OjhweDttYXJnaW4tbGVmdDowfS5hbnQtbW9kYWwtd3JhcC1ydGwuYW50LW1vZGFsLWNlbnRlcmVkIC5hbnQtbW9kYWx7dGV4dC1hbGlnbjpyaWdodH0uYW50LW5vdGlmaWNhdGlvbntib3gtc2l6aW5nOmJvcmRlci1ib3g7cGFkZGluZzowO2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtmb250LXNpemU6MTRweDtmb250LXZhcmlhbnQ6dGFidWxhci1udW1zO2xpbmUtaGVpZ2h0OjEuNTcxNTtsaXN0LXN0eWxlOm5vbmU7Zm9udC1mZWF0dXJlLXNldHRpbmdzOlwidG51bVwiO3Bvc2l0aW9uOmZpeGVkO3otaW5kZXg6MTAxMDttYXJnaW46MCAyNHB4IDAgMH0uYW50LW5vdGlmaWNhdGlvbi1jbG9zZS1pY29ue2ZvbnQtc2l6ZToxNHB4O2N1cnNvcjpwb2ludGVyfS5hbnQtbm90aWZpY2F0aW9uLWhvb2staG9sZGVye3Bvc2l0aW9uOnJlbGF0aXZlfS5hbnQtbm90aWZpY2F0aW9uLW5vdGljZXtwb3NpdGlvbjpyZWxhdGl2ZTt3aWR0aDozODRweDttYXgtd2lkdGg6Y2FsYygxMDB2dyAtIDQ4cHgpO21hcmdpbi1ib3R0b206MTZweDttYXJnaW4tbGVmdDphdXRvO3BhZGRpbmc6MTZweCAyNHB4O292ZXJmbG93OmhpZGRlbjtsaW5lLWhlaWdodDoxLjU3MTU7d29yZC13cmFwOmJyZWFrLXdvcmQ7YmFja2dyb3VuZDojZmZmO2JvcmRlci1yYWRpdXM6MnB4O2JveC1zaGFkb3c6MCAzcHggNnB4IC00cHggcmdiYSgwLDAsMCwuMTIpLDAgNnB4IDE2cHggMCByZ2JhKDAsMCwwLC4wOCksMCA5cHggMjhweCA4cHggcmdiYSgwLDAsMCwuMDUpfS5hbnQtbm90aWZpY2F0aW9uLWJvdHRvbSAuYW50LW5vdGlmaWNhdGlvbi1ub3RpY2UsLmFudC1ub3RpZmljYXRpb24tdG9wIC5hbnQtbm90aWZpY2F0aW9uLW5vdGljZXttYXJnaW4tcmlnaHQ6YXV0bzttYXJnaW4tbGVmdDphdXRvfS5hbnQtbm90aWZpY2F0aW9uLWJvdHRvbUxlZnQgLmFudC1ub3RpZmljYXRpb24tbm90aWNlLC5hbnQtbm90aWZpY2F0aW9uLXRvcExlZnQgLmFudC1ub3RpZmljYXRpb24tbm90aWNle21hcmdpbi1yaWdodDphdXRvO21hcmdpbi1sZWZ0OjB9LmFudC1ub3RpZmljYXRpb24tbm90aWNlLW1lc3NhZ2V7bWFyZ2luLWJvdHRvbTo4cHg7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtc2l6ZToxNnB4O2xpbmUtaGVpZ2h0OjI0cHh9LmFudC1ub3RpZmljYXRpb24tbm90aWNlLW1lc3NhZ2Utc2luZ2xlLWxpbmUtYXV0by1tYXJnaW57ZGlzcGxheTpibG9jazt3aWR0aDpjYWxjKDI2NHB4IC0gMTAwJSk7bWF4LXdpZHRoOjRweDtiYWNrZ3JvdW5kLWNvbG9yOnRyYW5zcGFyZW50O3BvaW50ZXItZXZlbnRzOm5vbmV9LmFudC1ub3RpZmljYXRpb24tbm90aWNlLW1lc3NhZ2Utc2luZ2xlLWxpbmUtYXV0by1tYXJnaW46YmVmb3Jle2Rpc3BsYXk6YmxvY2s7Y29udGVudDpcIlwifS5hbnQtbm90aWZpY2F0aW9uLW5vdGljZS1kZXNjcmlwdGlvbntmb250LXNpemU6MTRweH0uYW50LW5vdGlmaWNhdGlvbi1ub3RpY2UtY2xvc2FibGUgLmFudC1ub3RpZmljYXRpb24tbm90aWNlLW1lc3NhZ2V7cGFkZGluZy1yaWdodDoyNHB4fS5hbnQtbm90aWZpY2F0aW9uLW5vdGljZS13aXRoLWljb24gLmFudC1ub3RpZmljYXRpb24tbm90aWNlLW1lc3NhZ2V7bWFyZ2luLWJvdHRvbTo0cHg7bWFyZ2luLWxlZnQ6NDhweDtmb250LXNpemU6MTZweH0uYW50LW5vdGlmaWNhdGlvbi1ub3RpY2Utd2l0aC1pY29uIC5hbnQtbm90aWZpY2F0aW9uLW5vdGljZS1kZXNjcmlwdGlvbnttYXJnaW4tbGVmdDo0OHB4O2ZvbnQtc2l6ZToxNHB4fS5hbnQtbm90aWZpY2F0aW9uLW5vdGljZS1pY29ue3Bvc2l0aW9uOmFic29sdXRlO21hcmdpbi1sZWZ0OjRweDtmb250LXNpemU6MjRweDtsaW5lLWhlaWdodDoyNHB4fS5hbnRpY29uLmFudC1ub3RpZmljYXRpb24tbm90aWNlLWljb24tc3VjY2Vzc3tjb2xvcjojNTJjNDFhfS5hbnRpY29uLmFudC1ub3RpZmljYXRpb24tbm90aWNlLWljb24taW5mb3tjb2xvcjojMTg5MGZmfS5hbnRpY29uLmFudC1ub3RpZmljYXRpb24tbm90aWNlLWljb24td2FybmluZ3tjb2xvcjojZmFhZDE0fS5hbnRpY29uLmFudC1ub3RpZmljYXRpb24tbm90aWNlLWljb24tZXJyb3J7Y29sb3I6I2ZmNGQ0Zn0uYW50LW5vdGlmaWNhdGlvbi1ub3RpY2UtY2xvc2V7cG9zaXRpb246YWJzb2x1dGU7dG9wOjE2cHg7cmlnaHQ6MjJweDtjb2xvcjpyZ2JhKDAsMCwwLC40NSk7b3V0bGluZTpub25lfS5hbnQtbm90aWZpY2F0aW9uLW5vdGljZS1jbG9zZTpob3Zlcntjb2xvcjpyZ2JhKDAsMCwwLC42Nyl9LmFudC1ub3RpZmljYXRpb24tbm90aWNlLWJ0bntmbG9hdDpyaWdodDttYXJnaW4tdG9wOjE2cHh9LmFudC1ub3RpZmljYXRpb24gLm5vdGlmaWNhdGlvbi1mYWRlLWVmZmVjdHthbmltYXRpb24tZHVyYXRpb246LjI0czthbmltYXRpb24tdGltaW5nLWZ1bmN0aW9uOmN1YmljLWJlemllciguNjQ1LC4wNDUsLjM1NSwxKTthbmltYXRpb24tZmlsbC1tb2RlOmJvdGh9LmFudC1ub3RpZmljYXRpb24tZmFkZS1hcHBlYXIsLmFudC1ub3RpZmljYXRpb24tZmFkZS1lbnRlcntvcGFjaXR5OjA7YW5pbWF0aW9uLXBsYXktc3RhdGU6cGF1c2VkfS5hbnQtbm90aWZpY2F0aW9uLWZhZGUtYXBwZWFyLC5hbnQtbm90aWZpY2F0aW9uLWZhZGUtZW50ZXIsLmFudC1ub3RpZmljYXRpb24tZmFkZS1sZWF2ZXthbmltYXRpb24tZHVyYXRpb246LjI0czthbmltYXRpb24tdGltaW5nLWZ1bmN0aW9uOmN1YmljLWJlemllciguNjQ1LC4wNDUsLjM1NSwxKTthbmltYXRpb24tZmlsbC1tb2RlOmJvdGh9LmFudC1ub3RpZmljYXRpb24tZmFkZS1sZWF2ZXthbmltYXRpb24tZHVyYXRpb246LjJzO2FuaW1hdGlvbi1wbGF5LXN0YXRlOnBhdXNlZH0uYW50LW5vdGlmaWNhdGlvbi1mYWRlLWFwcGVhci5hbnQtbm90aWZpY2F0aW9uLWZhZGUtYXBwZWFyLWFjdGl2ZSwuYW50LW5vdGlmaWNhdGlvbi1mYWRlLWVudGVyLmFudC1ub3RpZmljYXRpb24tZmFkZS1lbnRlci1hY3RpdmV7YW5pbWF0aW9uLW5hbWU6Tm90aWZpY2F0aW9uRmFkZUluO2FuaW1hdGlvbi1wbGF5LXN0YXRlOnJ1bm5pbmd9LmFudC1ub3RpZmljYXRpb24tZmFkZS1sZWF2ZS5hbnQtbm90aWZpY2F0aW9uLWZhZGUtbGVhdmUtYWN0aXZle2FuaW1hdGlvbi1uYW1lOk5vdGlmaWNhdGlvbkZhZGVPdXQ7YW5pbWF0aW9uLXBsYXktc3RhdGU6cnVubmluZ31Aa2V5ZnJhbWVzIE5vdGlmaWNhdGlvbkZhZGVJbnswJXtsZWZ0OjM4NHB4O29wYWNpdHk6MH10b3tsZWZ0OjA7b3BhY2l0eToxfX1Aa2V5ZnJhbWVzIE5vdGlmaWNhdGlvbkZhZGVPdXR7MCV7bWF4LWhlaWdodDoxNTBweDttYXJnaW4tYm90dG9tOjE2cHg7b3BhY2l0eToxfXRve21heC1oZWlnaHQ6MDttYXJnaW4tYm90dG9tOjA7cGFkZGluZy10b3A6MDtwYWRkaW5nLWJvdHRvbTowO29wYWNpdHk6MH19LmFudC1ub3RpZmljYXRpb24tcnRse2RpcmVjdGlvbjpydGx9LmFudC1ub3RpZmljYXRpb24tcnRsIC5hbnQtbm90aWZpY2F0aW9uLW5vdGljZS1jbG9zYWJsZSAuYW50LW5vdGlmaWNhdGlvbi1ub3RpY2UtbWVzc2FnZXtwYWRkaW5nLXJpZ2h0OjA7cGFkZGluZy1sZWZ0OjI0cHh9LmFudC1ub3RpZmljYXRpb24tcnRsIC5hbnQtbm90aWZpY2F0aW9uLW5vdGljZS13aXRoLWljb24gLmFudC1ub3RpZmljYXRpb24tbm90aWNlLWRlc2NyaXB0aW9uLC5hbnQtbm90aWZpY2F0aW9uLXJ0bCAuYW50LW5vdGlmaWNhdGlvbi1ub3RpY2Utd2l0aC1pY29uIC5hbnQtbm90aWZpY2F0aW9uLW5vdGljZS1tZXNzYWdle21hcmdpbi1yaWdodDo0OHB4O21hcmdpbi1sZWZ0OjB9LmFudC1ub3RpZmljYXRpb24tcnRsIC5hbnQtbm90aWZpY2F0aW9uLW5vdGljZS1pY29ue21hcmdpbi1yaWdodDo0cHg7bWFyZ2luLWxlZnQ6MH0uYW50LW5vdGlmaWNhdGlvbi1ydGwgLmFudC1ub3RpZmljYXRpb24tbm90aWNlLWNsb3Nle3JpZ2h0OmF1dG87bGVmdDoyMnB4fS5hbnQtbm90aWZpY2F0aW9uLXJ0bCAuYW50LW5vdGlmaWNhdGlvbi1ub3RpY2UtYnRue2Zsb2F0OmxlZnR9LmFudC1ub3RpZmljYXRpb24tYm90dG9tLC5hbnQtbm90aWZpY2F0aW9uLXRvcHttYXJnaW4tcmlnaHQ6MDttYXJnaW4tbGVmdDowfS5hbnQtbm90aWZpY2F0aW9uLXRvcCAuYW50LW5vdGlmaWNhdGlvbi1mYWRlLWFwcGVhci5hbnQtbm90aWZpY2F0aW9uLWZhZGUtYXBwZWFyLWFjdGl2ZSwuYW50LW5vdGlmaWNhdGlvbi10b3AgLmFudC1ub3RpZmljYXRpb24tZmFkZS1lbnRlci5hbnQtbm90aWZpY2F0aW9uLWZhZGUtZW50ZXItYWN0aXZle2FuaW1hdGlvbi1uYW1lOk5vdGlmaWNhdGlvblRvcEZhZGVJbn0uYW50LW5vdGlmaWNhdGlvbi1ib3R0b20gLmFudC1ub3RpZmljYXRpb24tZmFkZS1hcHBlYXIuYW50LW5vdGlmaWNhdGlvbi1mYWRlLWFwcGVhci1hY3RpdmUsLmFudC1ub3RpZmljYXRpb24tYm90dG9tIC5hbnQtbm90aWZpY2F0aW9uLWZhZGUtZW50ZXIuYW50LW5vdGlmaWNhdGlvbi1mYWRlLWVudGVyLWFjdGl2ZXthbmltYXRpb24tbmFtZTpOb3RpZmljYXRpb25Cb3R0b21GYWRlSW59LmFudC1ub3RpZmljYXRpb24tYm90dG9tTGVmdCwuYW50LW5vdGlmaWNhdGlvbi10b3BMZWZ0e21hcmdpbi1yaWdodDowO21hcmdpbi1sZWZ0OjI0cHh9LmFudC1ub3RpZmljYXRpb24tYm90dG9tTGVmdCAuYW50LW5vdGlmaWNhdGlvbi1mYWRlLWFwcGVhci5hbnQtbm90aWZpY2F0aW9uLWZhZGUtYXBwZWFyLWFjdGl2ZSwuYW50LW5vdGlmaWNhdGlvbi1ib3R0b21MZWZ0IC5hbnQtbm90aWZpY2F0aW9uLWZhZGUtZW50ZXIuYW50LW5vdGlmaWNhdGlvbi1mYWRlLWVudGVyLWFjdGl2ZSwuYW50LW5vdGlmaWNhdGlvbi10b3BMZWZ0IC5hbnQtbm90aWZpY2F0aW9uLWZhZGUtYXBwZWFyLmFudC1ub3RpZmljYXRpb24tZmFkZS1hcHBlYXItYWN0aXZlLC5hbnQtbm90aWZpY2F0aW9uLXRvcExlZnQgLmFudC1ub3RpZmljYXRpb24tZmFkZS1lbnRlci5hbnQtbm90aWZpY2F0aW9uLWZhZGUtZW50ZXItYWN0aXZle2FuaW1hdGlvbi1uYW1lOk5vdGlmaWNhdGlvbkxlZnRGYWRlSW59QGtleWZyYW1lcyBOb3RpZmljYXRpb25Ub3BGYWRlSW57MCV7bWFyZ2luLXRvcDotMTAwJTtvcGFjaXR5OjB9dG97bWFyZ2luLXRvcDowO29wYWNpdHk6MX19QGtleWZyYW1lcyBOb3RpZmljYXRpb25Cb3R0b21GYWRlSW57MCV7bWFyZ2luLWJvdHRvbTotMTAwJTtvcGFjaXR5OjB9dG97bWFyZ2luLWJvdHRvbTowO29wYWNpdHk6MX19QGtleWZyYW1lcyBOb3RpZmljYXRpb25MZWZ0RmFkZUluezAle3JpZ2h0OjM4NHB4O29wYWNpdHk6MH10b3tyaWdodDowO29wYWNpdHk6MX19LmFudC1wYWdlLWhlYWRlcntib3gtc2l6aW5nOmJvcmRlci1ib3g7bWFyZ2luOjA7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtc2l6ZToxNHB4O2ZvbnQtdmFyaWFudDp0YWJ1bGFyLW51bXM7bGluZS1oZWlnaHQ6MS41NzE1O2xpc3Qtc3R5bGU6bm9uZTtmb250LWZlYXR1cmUtc2V0dGluZ3M6XCJ0bnVtXCI7cG9zaXRpb246cmVsYXRpdmU7cGFkZGluZzoxNnB4IDI0cHg7YmFja2dyb3VuZC1jb2xvcjojZmZmfS5hbnQtcGFnZS1oZWFkZXItZ2hvc3R7YmFja2dyb3VuZC1jb2xvcjppbmhlcml0fS5hbnQtcGFnZS1oZWFkZXIuaGFzLWJyZWFkY3J1bWJ7cGFkZGluZy10b3A6MTJweH0uYW50LXBhZ2UtaGVhZGVyLmhhcy1mb290ZXJ7cGFkZGluZy1ib3R0b206MH0uYW50LXBhZ2UtaGVhZGVyLWJhY2t7bWFyZ2luLXJpZ2h0OjE2cHg7Zm9udC1zaXplOjE2cHg7bGluZS1oZWlnaHQ6MX0uYW50LXBhZ2UtaGVhZGVyLWJhY2stYnV0dG9ue2NvbG9yOiMxODkwZmY7b3V0bGluZTpub25lO2N1cnNvcjpwb2ludGVyO3RyYW5zaXRpb246Y29sb3IgLjNzO2NvbG9yOiMwMDB9LmFudC1wYWdlLWhlYWRlci1iYWNrLWJ1dHRvbjpmb2N1cy12aXNpYmxlLC5hbnQtcGFnZS1oZWFkZXItYmFjay1idXR0b246aG92ZXJ7Y29sb3I6IzQwYTlmZn0uYW50LXBhZ2UtaGVhZGVyLWJhY2stYnV0dG9uOmFjdGl2ZXtjb2xvcjojMDk2ZGQ5fS5hbnQtcGFnZS1oZWFkZXIgLmFudC1kaXZpZGVyLXZlcnRpY2Fse2hlaWdodDoxNHB4O21hcmdpbjowIDEycHg7dmVydGljYWwtYWxpZ246bWlkZGxlfS5hbnQtYnJlYWRjcnVtYisuYW50LXBhZ2UtaGVhZGVyLWhlYWRpbmd7bWFyZ2luLXRvcDo4cHh9LmFudC1wYWdlLWhlYWRlci1oZWFkaW5ne2Rpc3BsYXk6ZmxleDtqdXN0aWZ5LWNvbnRlbnQ6c3BhY2UtYmV0d2Vlbn0uYW50LXBhZ2UtaGVhZGVyLWhlYWRpbmctbGVmdHtkaXNwbGF5OmZsZXg7YWxpZ24taXRlbXM6Y2VudGVyO21hcmdpbjo0cHggMDtvdmVyZmxvdzpoaWRkZW59LmFudC1wYWdlLWhlYWRlci1oZWFkaW5nLXRpdGxle21hcmdpbi1yaWdodDoxMnB4O21hcmdpbi1ib3R0b206MDtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7Zm9udC13ZWlnaHQ6NjAwO2ZvbnQtc2l6ZToyMHB4O2xpbmUtaGVpZ2h0OjMycHg7b3ZlcmZsb3c6aGlkZGVuO3doaXRlLXNwYWNlOm5vd3JhcDt0ZXh0LW92ZXJmbG93OmVsbGlwc2lzfS5hbnQtcGFnZS1oZWFkZXItaGVhZGluZyAuYW50LWF2YXRhcnttYXJnaW4tcmlnaHQ6MTJweH0uYW50LXBhZ2UtaGVhZGVyLWhlYWRpbmctc3ViLXRpdGxle21hcmdpbi1yaWdodDoxMnB4O2NvbG9yOnJnYmEoMCwwLDAsLjQ1KTtmb250LXNpemU6MTRweDtsaW5lLWhlaWdodDoxLjU3MTU7b3ZlcmZsb3c6aGlkZGVuO3doaXRlLXNwYWNlOm5vd3JhcDt0ZXh0LW92ZXJmbG93OmVsbGlwc2lzfS5hbnQtcGFnZS1oZWFkZXItaGVhZGluZy1leHRyYXttYXJnaW46NHB4IDA7d2hpdGUtc3BhY2U6bm93cmFwfS5hbnQtcGFnZS1oZWFkZXItaGVhZGluZy1leHRyYT4qe3doaXRlLXNwYWNlOnVuc2V0fS5hbnQtcGFnZS1oZWFkZXItY29udGVudHtwYWRkaW5nLXRvcDoxMnB4fS5hbnQtcGFnZS1oZWFkZXItZm9vdGVye21hcmdpbi10b3A6MTZweH0uYW50LXBhZ2UtaGVhZGVyLWZvb3RlciAuYW50LXRhYnM+LmFudC10YWJzLW5hdnttYXJnaW46MH0uYW50LXBhZ2UtaGVhZGVyLWZvb3RlciAuYW50LXRhYnM+LmFudC10YWJzLW5hdjpiZWZvcmV7Ym9yZGVyOm5vbmV9LmFudC1wYWdlLWhlYWRlci1mb290ZXIgLmFudC10YWJzIC5hbnQtdGFicy10YWJ7cGFkZGluZy10b3A6OHB4O3BhZGRpbmctYm90dG9tOjhweDtmb250LXNpemU6MTZweH0uYW50LXBhZ2UtaGVhZGVyLWNvbXBhY3QgLmFudC1wYWdlLWhlYWRlci1oZWFkaW5ne2ZsZXgtd3JhcDp3cmFwfS5hbnQtcGFnZS1oZWFkZXItcnRse2RpcmVjdGlvbjpydGx9LmFudC1wYWdlLWhlYWRlci1ydGwgLmFudC1wYWdlLWhlYWRlci1iYWNre2Zsb2F0OnJpZ2h0O21hcmdpbi1yaWdodDowO21hcmdpbi1sZWZ0OjE2cHh9LmFudC1wYWdlLWhlYWRlci1ydGwgLmFudC1wYWdlLWhlYWRlci1oZWFkaW5nLXRpdGxlLC5hbnQtcGFnZS1oZWFkZXItcnRsIC5hbnQtcGFnZS1oZWFkZXItaGVhZGluZyAuYW50LWF2YXRhcnttYXJnaW4tcmlnaHQ6MDttYXJnaW4tbGVmdDoxMnB4fS5hbnQtcGFnZS1oZWFkZXItcnRsIC5hbnQtcGFnZS1oZWFkZXItaGVhZGluZy1zdWItdGl0bGV7ZmxvYXQ6cmlnaHQ7bWFyZ2luLXJpZ2h0OjA7bWFyZ2luLWxlZnQ6MTJweH0uYW50LXBhZ2UtaGVhZGVyLXJ0bCAuYW50LXBhZ2UtaGVhZGVyLWhlYWRpbmctdGFnc3tmbG9hdDpyaWdodH0uYW50LXBhZ2UtaGVhZGVyLXJ0bCAuYW50LXBhZ2UtaGVhZGVyLWhlYWRpbmctZXh0cmF7ZmxvYXQ6bGVmdH0uYW50LXBhZ2UtaGVhZGVyLXJ0bCAuYW50LXBhZ2UtaGVhZGVyLWhlYWRpbmctZXh0cmE+KnttYXJnaW4tcmlnaHQ6MTJweDttYXJnaW4tbGVmdDowfS5hbnQtcGFnZS1oZWFkZXItcnRsIC5hbnQtcGFnZS1oZWFkZXItaGVhZGluZy1leHRyYT46Zmlyc3QtY2hpbGR7bWFyZ2luLXJpZ2h0OjB9LmFudC1wYWdlLWhlYWRlci1ydGwgLmFudC1wYWdlLWhlYWRlci1mb290ZXIgLmFudC10YWJzLWJhciAuYW50LXRhYnMtbmF2e2Zsb2F0OnJpZ2h0fS5hbnQtcGFnaW5hdGlvbntib3gtc2l6aW5nOmJvcmRlci1ib3g7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtc2l6ZToxNHB4O2ZvbnQtdmFyaWFudDp0YWJ1bGFyLW51bXM7bGluZS1oZWlnaHQ6MS41NzE1O2ZvbnQtZmVhdHVyZS1zZXR0aW5nczpcInRudW1cIn0uYW50LXBhZ2luYXRpb24sLmFudC1wYWdpbmF0aW9uIG9sLC5hbnQtcGFnaW5hdGlvbiB1bHttYXJnaW46MDtwYWRkaW5nOjA7bGlzdC1zdHlsZTpub25lfS5hbnQtcGFnaW5hdGlvbjphZnRlcntkaXNwbGF5OmJsb2NrO2NsZWFyOmJvdGg7aGVpZ2h0OjA7b3ZlcmZsb3c6aGlkZGVuO3Zpc2liaWxpdHk6aGlkZGVuO2NvbnRlbnQ6XCIgXCJ9LmFudC1wYWdpbmF0aW9uLWl0ZW0sLmFudC1wYWdpbmF0aW9uLXRvdGFsLXRleHR7ZGlzcGxheTppbmxpbmUtYmxvY2s7aGVpZ2h0OjMycHg7bWFyZ2luLXJpZ2h0OjhweDtsaW5lLWhlaWdodDozMHB4O3ZlcnRpY2FsLWFsaWduOm1pZGRsZX0uYW50LXBhZ2luYXRpb24taXRlbXttaW4td2lkdGg6MzJweDtmb250LWZhbWlseTotYXBwbGUtc3lzdGVtLEJsaW5rTWFjU3lzdGVtRm9udCxTZWdvZSBVSSxSb2JvdG8sSGVsdmV0aWNhIE5ldWUsQXJpYWwsTm90byBTYW5zLHNhbnMtc2VyaWYsQXBwbGUgQ29sb3IgRW1vamksU2Vnb2UgVUkgRW1vamksU2Vnb2UgVUkgU3ltYm9sLE5vdG8gQ29sb3IgRW1vamk7dGV4dC1hbGlnbjpjZW50ZXI7bGlzdC1zdHlsZTpub25lO2JhY2tncm91bmQtY29sb3I6I2ZmZjtib3JkZXI6MXB4IHNvbGlkICNkOWQ5ZDk7Ym9yZGVyLXJhZGl1czoycHg7b3V0bGluZTowO2N1cnNvcjpwb2ludGVyOy13ZWJraXQtdXNlci1zZWxlY3Q6bm9uZTstbW96LXVzZXItc2VsZWN0Om5vbmU7LW1zLXVzZXItc2VsZWN0Om5vbmU7dXNlci1zZWxlY3Q6bm9uZX0uYW50LXBhZ2luYXRpb24taXRlbSBhe2Rpc3BsYXk6YmxvY2s7cGFkZGluZzowIDZweDtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7dHJhbnNpdGlvbjpub25lfS5hbnQtcGFnaW5hdGlvbi1pdGVtIGE6aG92ZXJ7dGV4dC1kZWNvcmF0aW9uOm5vbmV9LmFudC1wYWdpbmF0aW9uLWl0ZW06aG92ZXJ7Ym9yZGVyLWNvbG9yOiMxODkwZmY7dHJhbnNpdGlvbjphbGwgLjNzfS5hbnQtcGFnaW5hdGlvbi1pdGVtOmhvdmVyIGF7Y29sb3I6IzE4OTBmZn0uYW50LXBhZ2luYXRpb24taXRlbTpmb2N1cy12aXNpYmxle2JvcmRlci1jb2xvcjojMTg5MGZmO3RyYW5zaXRpb246YWxsIC4zc30uYW50LXBhZ2luYXRpb24taXRlbTpmb2N1cy12aXNpYmxlIGF7Y29sb3I6IzE4OTBmZn0uYW50LXBhZ2luYXRpb24taXRlbS1hY3RpdmV7Zm9udC13ZWlnaHQ6NTAwO2JhY2tncm91bmQ6I2ZmZjtib3JkZXItY29sb3I6IzE4OTBmZn0uYW50LXBhZ2luYXRpb24taXRlbS1hY3RpdmUgYXtjb2xvcjojMTg5MGZmfS5hbnQtcGFnaW5hdGlvbi1pdGVtLWFjdGl2ZTpmb2N1cy12aXNpYmxlLC5hbnQtcGFnaW5hdGlvbi1pdGVtLWFjdGl2ZTpob3Zlcntib3JkZXItY29sb3I6IzQwYTlmZn0uYW50LXBhZ2luYXRpb24taXRlbS1hY3RpdmU6Zm9jdXMtdmlzaWJsZSBhLC5hbnQtcGFnaW5hdGlvbi1pdGVtLWFjdGl2ZTpob3ZlciBhe2NvbG9yOiM0MGE5ZmZ9LmFudC1wYWdpbmF0aW9uLWp1bXAtbmV4dCwuYW50LXBhZ2luYXRpb24tanVtcC1wcmV2e291dGxpbmU6MH0uYW50LXBhZ2luYXRpb24tanVtcC1uZXh0IC5hbnQtcGFnaW5hdGlvbi1pdGVtLWNvbnRhaW5lciwuYW50LXBhZ2luYXRpb24tanVtcC1wcmV2IC5hbnQtcGFnaW5hdGlvbi1pdGVtLWNvbnRhaW5lcntwb3NpdGlvbjpyZWxhdGl2ZX0uYW50LXBhZ2luYXRpb24tanVtcC1uZXh0IC5hbnQtcGFnaW5hdGlvbi1pdGVtLWNvbnRhaW5lciAuYW50LXBhZ2luYXRpb24taXRlbS1saW5rLWljb24sLmFudC1wYWdpbmF0aW9uLWp1bXAtcHJldiAuYW50LXBhZ2luYXRpb24taXRlbS1jb250YWluZXIgLmFudC1wYWdpbmF0aW9uLWl0ZW0tbGluay1pY29ue2NvbG9yOiMxODkwZmY7Zm9udC1zaXplOjEycHg7bGV0dGVyLXNwYWNpbmc6LTFweDtvcGFjaXR5OjA7dHJhbnNpdGlvbjphbGwgLjJzfS5hbnQtcGFnaW5hdGlvbi1qdW1wLW5leHQgLmFudC1wYWdpbmF0aW9uLWl0ZW0tY29udGFpbmVyIC5hbnQtcGFnaW5hdGlvbi1pdGVtLWxpbmstaWNvbi1zdmcsLmFudC1wYWdpbmF0aW9uLWp1bXAtcHJldiAuYW50LXBhZ2luYXRpb24taXRlbS1jb250YWluZXIgLmFudC1wYWdpbmF0aW9uLWl0ZW0tbGluay1pY29uLXN2Z3t0b3A6MDtyaWdodDowO2JvdHRvbTowO2xlZnQ6MDttYXJnaW46YXV0b30uYW50LXBhZ2luYXRpb24tanVtcC1uZXh0IC5hbnQtcGFnaW5hdGlvbi1pdGVtLWNvbnRhaW5lciAuYW50LXBhZ2luYXRpb24taXRlbS1lbGxpcHNpcywuYW50LXBhZ2luYXRpb24tanVtcC1wcmV2IC5hbnQtcGFnaW5hdGlvbi1pdGVtLWNvbnRhaW5lciAuYW50LXBhZ2luYXRpb24taXRlbS1lbGxpcHNpc3twb3NpdGlvbjphYnNvbHV0ZTt0b3A6MDtyaWdodDowO2JvdHRvbTowO2xlZnQ6MDtkaXNwbGF5OmJsb2NrO21hcmdpbjphdXRvO2NvbG9yOnJnYmEoMCwwLDAsLjI1KTtmb250LWZhbWlseTpBcmlhbCxIZWx2ZXRpY2Esc2Fucy1zZXJpZjtsZXR0ZXItc3BhY2luZzoycHg7dGV4dC1hbGlnbjpjZW50ZXI7dGV4dC1pbmRlbnQ6LjEzZW07b3BhY2l0eToxO3RyYW5zaXRpb246YWxsIC4yc30uYW50LXBhZ2luYXRpb24tanVtcC1uZXh0OmhvdmVyIC5hbnQtcGFnaW5hdGlvbi1pdGVtLWxpbmstaWNvbiwuYW50LXBhZ2luYXRpb24tanVtcC1wcmV2OmhvdmVyIC5hbnQtcGFnaW5hdGlvbi1pdGVtLWxpbmstaWNvbntvcGFjaXR5OjF9LmFudC1wYWdpbmF0aW9uLWp1bXAtbmV4dDpob3ZlciAuYW50LXBhZ2luYXRpb24taXRlbS1lbGxpcHNpcywuYW50LXBhZ2luYXRpb24tanVtcC1wcmV2OmhvdmVyIC5hbnQtcGFnaW5hdGlvbi1pdGVtLWVsbGlwc2lze29wYWNpdHk6MH0uYW50LXBhZ2luYXRpb24tanVtcC1uZXh0OmZvY3VzLXZpc2libGUgLmFudC1wYWdpbmF0aW9uLWl0ZW0tbGluay1pY29uLC5hbnQtcGFnaW5hdGlvbi1qdW1wLXByZXY6Zm9jdXMtdmlzaWJsZSAuYW50LXBhZ2luYXRpb24taXRlbS1saW5rLWljb257b3BhY2l0eToxfS5hbnQtcGFnaW5hdGlvbi1qdW1wLW5leHQ6Zm9jdXMtdmlzaWJsZSAuYW50LXBhZ2luYXRpb24taXRlbS1lbGxpcHNpcywuYW50LXBhZ2luYXRpb24tanVtcC1wcmV2OmZvY3VzLXZpc2libGUgLmFudC1wYWdpbmF0aW9uLWl0ZW0tZWxsaXBzaXN7b3BhY2l0eTowfS5hbnQtcGFnaW5hdGlvbi1qdW1wLW5leHQsLmFudC1wYWdpbmF0aW9uLWp1bXAtcHJldiwuYW50LXBhZ2luYXRpb24tcHJldnttYXJnaW4tcmlnaHQ6OHB4fS5hbnQtcGFnaW5hdGlvbi1qdW1wLW5leHQsLmFudC1wYWdpbmF0aW9uLWp1bXAtcHJldiwuYW50LXBhZ2luYXRpb24tbmV4dCwuYW50LXBhZ2luYXRpb24tcHJldntkaXNwbGF5OmlubGluZS1ibG9jazttaW4td2lkdGg6MzJweDtoZWlnaHQ6MzJweDtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7Zm9udC1mYW1pbHk6LWFwcGxlLXN5c3RlbSxCbGlua01hY1N5c3RlbUZvbnQsU2Vnb2UgVUksUm9ib3RvLEhlbHZldGljYSBOZXVlLEFyaWFsLE5vdG8gU2FucyxzYW5zLXNlcmlmLEFwcGxlIENvbG9yIEVtb2ppLFNlZ29lIFVJIEVtb2ppLFNlZ29lIFVJIFN5bWJvbCxOb3RvIENvbG9yIEVtb2ppO2xpbmUtaGVpZ2h0OjMycHg7dGV4dC1hbGlnbjpjZW50ZXI7dmVydGljYWwtYWxpZ246bWlkZGxlO2xpc3Qtc3R5bGU6bm9uZTtib3JkZXItcmFkaXVzOjJweDtjdXJzb3I6cG9pbnRlcjt0cmFuc2l0aW9uOmFsbCAuM3N9LmFudC1wYWdpbmF0aW9uLW5leHQsLmFudC1wYWdpbmF0aW9uLXByZXZ7Zm9udC1mYW1pbHk6QXJpYWwsSGVsdmV0aWNhLHNhbnMtc2VyaWY7b3V0bGluZTowfS5hbnQtcGFnaW5hdGlvbi1uZXh0IGJ1dHRvbiwuYW50LXBhZ2luYXRpb24tcHJldiBidXR0b257Y29sb3I6cmdiYSgwLDAsMCwuODUpO2N1cnNvcjpwb2ludGVyOy13ZWJraXQtdXNlci1zZWxlY3Q6bm9uZTstbW96LXVzZXItc2VsZWN0Om5vbmU7LW1zLXVzZXItc2VsZWN0Om5vbmU7dXNlci1zZWxlY3Q6bm9uZX0uYW50LXBhZ2luYXRpb24tbmV4dDpob3ZlciBidXR0b24sLmFudC1wYWdpbmF0aW9uLXByZXY6aG92ZXIgYnV0dG9ue2JvcmRlci1jb2xvcjojNDBhOWZmfS5hbnQtcGFnaW5hdGlvbi1uZXh0IC5hbnQtcGFnaW5hdGlvbi1pdGVtLWxpbmssLmFudC1wYWdpbmF0aW9uLXByZXYgLmFudC1wYWdpbmF0aW9uLWl0ZW0tbGlua3tkaXNwbGF5OmJsb2NrO3dpZHRoOjEwMCU7aGVpZ2h0OjEwMCU7cGFkZGluZzowO2ZvbnQtc2l6ZToxMnB4O3RleHQtYWxpZ246Y2VudGVyO2JhY2tncm91bmQtY29sb3I6I2ZmZjtib3JkZXI6MXB4IHNvbGlkICNkOWQ5ZDk7Ym9yZGVyLXJhZGl1czoycHg7b3V0bGluZTpub25lO3RyYW5zaXRpb246YWxsIC4zc30uYW50LXBhZ2luYXRpb24tbmV4dDpmb2N1cy12aXNpYmxlIC5hbnQtcGFnaW5hdGlvbi1pdGVtLWxpbmssLmFudC1wYWdpbmF0aW9uLW5leHQ6aG92ZXIgLmFudC1wYWdpbmF0aW9uLWl0ZW0tbGluaywuYW50LXBhZ2luYXRpb24tcHJldjpmb2N1cy12aXNpYmxlIC5hbnQtcGFnaW5hdGlvbi1pdGVtLWxpbmssLmFudC1wYWdpbmF0aW9uLXByZXY6aG92ZXIgLmFudC1wYWdpbmF0aW9uLWl0ZW0tbGlua3tjb2xvcjojMTg5MGZmO2JvcmRlci1jb2xvcjojMTg5MGZmfS5hbnQtcGFnaW5hdGlvbi1kaXNhYmxlZCwuYW50LXBhZ2luYXRpb24tZGlzYWJsZWQ6aG92ZXJ7Y3Vyc29yOm5vdC1hbGxvd2VkfS5hbnQtcGFnaW5hdGlvbi1kaXNhYmxlZCAuYW50LXBhZ2luYXRpb24taXRlbS1saW5rLC5hbnQtcGFnaW5hdGlvbi1kaXNhYmxlZDpob3ZlciAuYW50LXBhZ2luYXRpb24taXRlbS1saW5re2NvbG9yOnJnYmEoMCwwLDAsLjI1KTtib3JkZXItY29sb3I6I2Q5ZDlkOTtjdXJzb3I6bm90LWFsbG93ZWR9LmFudC1wYWdpbmF0aW9uLWRpc2FibGVkOmZvY3VzLXZpc2libGV7Y3Vyc29yOm5vdC1hbGxvd2VkfS5hbnQtcGFnaW5hdGlvbi1kaXNhYmxlZDpmb2N1cy12aXNpYmxlIC5hbnQtcGFnaW5hdGlvbi1pdGVtLWxpbmt7Y29sb3I6cmdiYSgwLDAsMCwuMjUpO2JvcmRlci1jb2xvcjojZDlkOWQ5O2N1cnNvcjpub3QtYWxsb3dlZH0uYW50LXBhZ2luYXRpb24tc2xhc2h7bWFyZ2luOjAgMTBweCAwIDVweH0uYW50LXBhZ2luYXRpb24tb3B0aW9uc3tkaXNwbGF5OmlubGluZS1ibG9jazttYXJnaW4tbGVmdDoxNnB4O3ZlcnRpY2FsLWFsaWduOm1pZGRsZX1AbWVkaWEgKC1tcy1oaWdoLWNvbnRyYXN0Om5vbmUpey5hbnQtcGFnaW5hdGlvbi1vcHRpb25zLC5hbnQtcGFnaW5hdGlvbi1vcHRpb25zIDo6LW1zLWJhY2tkcm9we3ZlcnRpY2FsLWFsaWduOnRvcH19LmFudC1wYWdpbmF0aW9uLW9wdGlvbnMtc2l6ZS1jaGFuZ2VyLmFudC1zZWxlY3R7ZGlzcGxheTppbmxpbmUtYmxvY2s7d2lkdGg6YXV0b30uYW50LXBhZ2luYXRpb24tb3B0aW9ucy1xdWljay1qdW1wZXJ7ZGlzcGxheTppbmxpbmUtYmxvY2s7aGVpZ2h0OjMycHg7bWFyZ2luLWxlZnQ6OHB4O2xpbmUtaGVpZ2h0OjMycHg7dmVydGljYWwtYWxpZ246dG9wfS5hbnQtcGFnaW5hdGlvbi1vcHRpb25zLXF1aWNrLWp1bXBlciBpbnB1dHtwb3NpdGlvbjpyZWxhdGl2ZTtkaXNwbGF5OmlubGluZS1ibG9jazt3aWR0aDoxMDAlO21pbi13aWR0aDowO3BhZGRpbmc6NHB4IDExcHg7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtc2l6ZToxNHB4O2xpbmUtaGVpZ2h0OjEuNTcxNTtiYWNrZ3JvdW5kLWNvbG9yOiNmZmY7YmFja2dyb3VuZC1pbWFnZTpub25lO2JvcmRlcjoxcHggc29saWQgI2Q5ZDlkOTtib3JkZXItcmFkaXVzOjJweDt0cmFuc2l0aW9uOmFsbCAuM3M7d2lkdGg6NTBweDtoZWlnaHQ6MzJweDttYXJnaW46MCA4cHh9LmFudC1wYWdpbmF0aW9uLW9wdGlvbnMtcXVpY2stanVtcGVyIGlucHV0OjotbW96LXBsYWNlaG9sZGVye2NvbG9yOiNiZmJmYmY7LW1vei11c2VyLXNlbGVjdDpub25lO3VzZXItc2VsZWN0Om5vbmV9LmFudC1wYWdpbmF0aW9uLW9wdGlvbnMtcXVpY2stanVtcGVyIGlucHV0Oi1tcy1pbnB1dC1wbGFjZWhvbGRlcntjb2xvcjojYmZiZmJmOy1tcy11c2VyLXNlbGVjdDpub25lO3VzZXItc2VsZWN0Om5vbmV9LmFudC1wYWdpbmF0aW9uLW9wdGlvbnMtcXVpY2stanVtcGVyIGlucHV0OjpwbGFjZWhvbGRlcntjb2xvcjojYmZiZmJmOy13ZWJraXQtdXNlci1zZWxlY3Q6bm9uZTstbW96LXVzZXItc2VsZWN0Om5vbmU7LW1zLXVzZXItc2VsZWN0Om5vbmU7dXNlci1zZWxlY3Q6bm9uZX0uYW50LXBhZ2luYXRpb24tb3B0aW9ucy1xdWljay1qdW1wZXIgaW5wdXQ6LW1vei1wbGFjZWhvbGRlci1zaG93bnt0ZXh0LW92ZXJmbG93OmVsbGlwc2lzfS5hbnQtcGFnaW5hdGlvbi1vcHRpb25zLXF1aWNrLWp1bXBlciBpbnB1dDotbXMtaW5wdXQtcGxhY2Vob2xkZXJ7dGV4dC1vdmVyZmxvdzplbGxpcHNpc30uYW50LXBhZ2luYXRpb24tb3B0aW9ucy1xdWljay1qdW1wZXIgaW5wdXQ6cGxhY2Vob2xkZXItc2hvd257dGV4dC1vdmVyZmxvdzplbGxpcHNpc30uYW50LXBhZ2luYXRpb24tb3B0aW9ucy1xdWljay1qdW1wZXIgaW5wdXQ6aG92ZXJ7Ym9yZGVyLWNvbG9yOiM0MGE5ZmY7Ym9yZGVyLXJpZ2h0LXdpZHRoOjFweH0uYW50LXBhZ2luYXRpb24tb3B0aW9ucy1xdWljay1qdW1wZXIgaW5wdXQtZm9jdXNlZCwuYW50LXBhZ2luYXRpb24tb3B0aW9ucy1xdWljay1qdW1wZXIgaW5wdXQ6Zm9jdXN7Ym9yZGVyLWNvbG9yOiM0MGE5ZmY7Ym94LXNoYWRvdzowIDAgMCAycHggcmdiYSgyNCwxNDQsMjU1LC4yKTtib3JkZXItcmlnaHQtd2lkdGg6MXB4O291dGxpbmU6MH0uYW50LXBhZ2luYXRpb24tb3B0aW9ucy1xdWljay1qdW1wZXIgaW5wdXQtZGlzYWJsZWR7Y29sb3I6cmdiYSgwLDAsMCwuMjUpO2JhY2tncm91bmQtY29sb3I6I2Y1ZjVmNTtib3JkZXItY29sb3I6I2Q5ZDlkOTtib3gtc2hhZG93Om5vbmU7Y3Vyc29yOm5vdC1hbGxvd2VkO29wYWNpdHk6MX0uYW50LXBhZ2luYXRpb24tb3B0aW9ucy1xdWljay1qdW1wZXIgaW5wdXQtZGlzYWJsZWQ6aG92ZXJ7Ym9yZGVyLWNvbG9yOiNkOWQ5ZDk7Ym9yZGVyLXJpZ2h0LXdpZHRoOjFweH0uYW50LXBhZ2luYXRpb24tb3B0aW9ucy1xdWljay1qdW1wZXIgaW5wdXRbZGlzYWJsZWRde2NvbG9yOnJnYmEoMCwwLDAsLjI1KTtiYWNrZ3JvdW5kLWNvbG9yOiNmNWY1ZjU7Ym9yZGVyLWNvbG9yOiNkOWQ5ZDk7Ym94LXNoYWRvdzpub25lO2N1cnNvcjpub3QtYWxsb3dlZDtvcGFjaXR5OjF9LmFudC1wYWdpbmF0aW9uLW9wdGlvbnMtcXVpY2stanVtcGVyIGlucHV0W2Rpc2FibGVkXTpob3Zlcntib3JkZXItY29sb3I6I2Q5ZDlkOTtib3JkZXItcmlnaHQtd2lkdGg6MXB4fS5hbnQtcGFnaW5hdGlvbi1vcHRpb25zLXF1aWNrLWp1bXBlciBpbnB1dC1ib3JkZXJsZXNzLC5hbnQtcGFnaW5hdGlvbi1vcHRpb25zLXF1aWNrLWp1bXBlciBpbnB1dC1ib3JkZXJsZXNzLWRpc2FibGVkLC5hbnQtcGFnaW5hdGlvbi1vcHRpb25zLXF1aWNrLWp1bXBlciBpbnB1dC1ib3JkZXJsZXNzLWZvY3VzZWQsLmFudC1wYWdpbmF0aW9uLW9wdGlvbnMtcXVpY2stanVtcGVyIGlucHV0LWJvcmRlcmxlc3M6Zm9jdXMsLmFudC1wYWdpbmF0aW9uLW9wdGlvbnMtcXVpY2stanVtcGVyIGlucHV0LWJvcmRlcmxlc3M6aG92ZXIsLmFudC1wYWdpbmF0aW9uLW9wdGlvbnMtcXVpY2stanVtcGVyIGlucHV0LWJvcmRlcmxlc3NbZGlzYWJsZWRde2JhY2tncm91bmQtY29sb3I6dHJhbnNwYXJlbnQ7Ym9yZGVyOm5vbmU7Ym94LXNoYWRvdzpub25lfXRleHRhcmVhLmFudC1wYWdpbmF0aW9uLW9wdGlvbnMtcXVpY2stanVtcGVyIGlucHV0e21heC13aWR0aDoxMDAlO2hlaWdodDphdXRvO21pbi1oZWlnaHQ6MzJweDtsaW5lLWhlaWdodDoxLjU3MTU7dmVydGljYWwtYWxpZ246Ym90dG9tO3RyYW5zaXRpb246YWxsIC4zcyxoZWlnaHQgMHN9LmFudC1wYWdpbmF0aW9uLW9wdGlvbnMtcXVpY2stanVtcGVyIGlucHV0LWxne3BhZGRpbmc6Ni41cHggMTFweDtmb250LXNpemU6MTZweH0uYW50LXBhZ2luYXRpb24tb3B0aW9ucy1xdWljay1qdW1wZXIgaW5wdXQtc217cGFkZGluZzowIDdweH0uYW50LXBhZ2luYXRpb24tc2ltcGxlIC5hbnQtcGFnaW5hdGlvbi1uZXh0LC5hbnQtcGFnaW5hdGlvbi1zaW1wbGUgLmFudC1wYWdpbmF0aW9uLXByZXZ7aGVpZ2h0OjI0cHg7bGluZS1oZWlnaHQ6MjRweDt2ZXJ0aWNhbC1hbGlnbjp0b3B9LmFudC1wYWdpbmF0aW9uLXNpbXBsZSAuYW50LXBhZ2luYXRpb24tbmV4dCAuYW50LXBhZ2luYXRpb24taXRlbS1saW5rLC5hbnQtcGFnaW5hdGlvbi1zaW1wbGUgLmFudC1wYWdpbmF0aW9uLXByZXYgLmFudC1wYWdpbmF0aW9uLWl0ZW0tbGlua3toZWlnaHQ6MjRweDtiYWNrZ3JvdW5kLWNvbG9yOnRyYW5zcGFyZW50O2JvcmRlcjowfS5hbnQtcGFnaW5hdGlvbi1zaW1wbGUgLmFudC1wYWdpbmF0aW9uLW5leHQgLmFudC1wYWdpbmF0aW9uLWl0ZW0tbGluazphZnRlciwuYW50LXBhZ2luYXRpb24tc2ltcGxlIC5hbnQtcGFnaW5hdGlvbi1wcmV2IC5hbnQtcGFnaW5hdGlvbi1pdGVtLWxpbms6YWZ0ZXJ7aGVpZ2h0OjI0cHg7bGluZS1oZWlnaHQ6MjRweH0uYW50LXBhZ2luYXRpb24tc2ltcGxlIC5hbnQtcGFnaW5hdGlvbi1zaW1wbGUtcGFnZXJ7ZGlzcGxheTppbmxpbmUtYmxvY2s7aGVpZ2h0OjI0cHg7bWFyZ2luLXJpZ2h0OjhweH0uYW50LXBhZ2luYXRpb24tc2ltcGxlIC5hbnQtcGFnaW5hdGlvbi1zaW1wbGUtcGFnZXIgaW5wdXR7Ym94LXNpemluZzpib3JkZXItYm94O2hlaWdodDoxMDAlO21hcmdpbi1yaWdodDo4cHg7cGFkZGluZzowIDZweDt0ZXh0LWFsaWduOmNlbnRlcjtiYWNrZ3JvdW5kLWNvbG9yOiNmZmY7Ym9yZGVyOjFweCBzb2xpZCAjZDlkOWQ5O2JvcmRlci1yYWRpdXM6MnB4O291dGxpbmU6bm9uZTt0cmFuc2l0aW9uOmJvcmRlci1jb2xvciAuM3N9LmFudC1wYWdpbmF0aW9uLXNpbXBsZSAuYW50LXBhZ2luYXRpb24tc2ltcGxlLXBhZ2VyIGlucHV0OmhvdmVye2JvcmRlci1jb2xvcjojMTg5MGZmfS5hbnQtcGFnaW5hdGlvbi1zaW1wbGUgLmFudC1wYWdpbmF0aW9uLXNpbXBsZS1wYWdlciBpbnB1dDpmb2N1c3tib3JkZXItY29sb3I6IzQwYTlmZjtib3gtc2hhZG93OjAgMCAwIDJweCByZ2JhKDI0LDE0NCwyNTUsLjIpfS5hbnQtcGFnaW5hdGlvbi1zaW1wbGUgLmFudC1wYWdpbmF0aW9uLXNpbXBsZS1wYWdlciBpbnB1dFtkaXNhYmxlZF17Y29sb3I6cmdiYSgwLDAsMCwuMjUpO2JhY2tncm91bmQ6I2Y1ZjVmNTtib3JkZXItY29sb3I6I2Q5ZDlkOTtjdXJzb3I6bm90LWFsbG93ZWR9LmFudC1wYWdpbmF0aW9uLmFudC1wYWdpbmF0aW9uLW1pbmkgLmFudC1wYWdpbmF0aW9uLXNpbXBsZS1wYWdlciwuYW50LXBhZ2luYXRpb24uYW50LXBhZ2luYXRpb24tbWluaSAuYW50LXBhZ2luYXRpb24tdG90YWwtdGV4dHtoZWlnaHQ6MjRweDtsaW5lLWhlaWdodDoyNHB4fS5hbnQtcGFnaW5hdGlvbi5hbnQtcGFnaW5hdGlvbi1taW5pIC5hbnQtcGFnaW5hdGlvbi1pdGVte21pbi13aWR0aDoyNHB4O2hlaWdodDoyNHB4O21hcmdpbjowO2xpbmUtaGVpZ2h0OjIycHh9LmFudC1wYWdpbmF0aW9uLmFudC1wYWdpbmF0aW9uLW1pbmkgLmFudC1wYWdpbmF0aW9uLWl0ZW06bm90KC5hbnQtcGFnaW5hdGlvbi1pdGVtLWFjdGl2ZSl7YmFja2dyb3VuZDp0cmFuc3BhcmVudDtib3JkZXItY29sb3I6dHJhbnNwYXJlbnR9LmFudC1wYWdpbmF0aW9uLmFudC1wYWdpbmF0aW9uLW1pbmkgLmFudC1wYWdpbmF0aW9uLW5leHQsLmFudC1wYWdpbmF0aW9uLmFudC1wYWdpbmF0aW9uLW1pbmkgLmFudC1wYWdpbmF0aW9uLXByZXZ7bWluLXdpZHRoOjI0cHg7aGVpZ2h0OjI0cHg7bWFyZ2luOjA7bGluZS1oZWlnaHQ6MjRweH0uYW50LXBhZ2luYXRpb24uYW50LXBhZ2luYXRpb24tbWluaSAuYW50LXBhZ2luYXRpb24tbmV4dCAuYW50LXBhZ2luYXRpb24taXRlbS1saW5rLC5hbnQtcGFnaW5hdGlvbi5hbnQtcGFnaW5hdGlvbi1taW5pIC5hbnQtcGFnaW5hdGlvbi1wcmV2IC5hbnQtcGFnaW5hdGlvbi1pdGVtLWxpbmt7YmFja2dyb3VuZDp0cmFuc3BhcmVudDtib3JkZXItY29sb3I6dHJhbnNwYXJlbnR9LmFudC1wYWdpbmF0aW9uLmFudC1wYWdpbmF0aW9uLW1pbmkgLmFudC1wYWdpbmF0aW9uLW5leHQgLmFudC1wYWdpbmF0aW9uLWl0ZW0tbGluazphZnRlciwuYW50LXBhZ2luYXRpb24uYW50LXBhZ2luYXRpb24tbWluaSAuYW50LXBhZ2luYXRpb24tcHJldiAuYW50LXBhZ2luYXRpb24taXRlbS1saW5rOmFmdGVye2hlaWdodDoyNHB4O2xpbmUtaGVpZ2h0OjI0cHh9LmFudC1wYWdpbmF0aW9uLmFudC1wYWdpbmF0aW9uLW1pbmkgLmFudC1wYWdpbmF0aW9uLWp1bXAtbmV4dCwuYW50LXBhZ2luYXRpb24uYW50LXBhZ2luYXRpb24tbWluaSAuYW50LXBhZ2luYXRpb24tanVtcC1wcmV2e2hlaWdodDoyNHB4O21hcmdpbi1yaWdodDowO2xpbmUtaGVpZ2h0OjI0cHh9LmFudC1wYWdpbmF0aW9uLmFudC1wYWdpbmF0aW9uLW1pbmkgLmFudC1wYWdpbmF0aW9uLW9wdGlvbnN7bWFyZ2luLWxlZnQ6MnB4fS5hbnQtcGFnaW5hdGlvbi5hbnQtcGFnaW5hdGlvbi1taW5pIC5hbnQtcGFnaW5hdGlvbi1vcHRpb25zLXNpemUtY2hhbmdlcnt0b3A6MH0uYW50LXBhZ2luYXRpb24uYW50LXBhZ2luYXRpb24tbWluaSAuYW50LXBhZ2luYXRpb24tb3B0aW9ucy1xdWljay1qdW1wZXJ7aGVpZ2h0OjI0cHg7bGluZS1oZWlnaHQ6MjRweH0uYW50LXBhZ2luYXRpb24uYW50LXBhZ2luYXRpb24tbWluaSAuYW50LXBhZ2luYXRpb24tb3B0aW9ucy1xdWljay1qdW1wZXIgaW5wdXR7cGFkZGluZzowIDdweDt3aWR0aDo0NHB4O2hlaWdodDoyNHB4fS5hbnQtcGFnaW5hdGlvbi5hbnQtcGFnaW5hdGlvbi1kaXNhYmxlZHtjdXJzb3I6bm90LWFsbG93ZWR9LmFudC1wYWdpbmF0aW9uLmFudC1wYWdpbmF0aW9uLWRpc2FibGVkIC5hbnQtcGFnaW5hdGlvbi1pdGVte2JhY2tncm91bmQ6I2Y1ZjVmNTtib3JkZXItY29sb3I6I2Q5ZDlkOTtjdXJzb3I6bm90LWFsbG93ZWR9LmFudC1wYWdpbmF0aW9uLmFudC1wYWdpbmF0aW9uLWRpc2FibGVkIC5hbnQtcGFnaW5hdGlvbi1pdGVtIGF7Y29sb3I6cmdiYSgwLDAsMCwuMjUpO2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7Ym9yZGVyOm5vbmU7Y3Vyc29yOm5vdC1hbGxvd2VkfS5hbnQtcGFnaW5hdGlvbi5hbnQtcGFnaW5hdGlvbi1kaXNhYmxlZCAuYW50LXBhZ2luYXRpb24taXRlbS1hY3RpdmV7YmFja2dyb3VuZDojZTZlNmU2fS5hbnQtcGFnaW5hdGlvbi5hbnQtcGFnaW5hdGlvbi1kaXNhYmxlZCAuYW50LXBhZ2luYXRpb24taXRlbS1hY3RpdmUgYXtjb2xvcjpyZ2JhKDAsMCwwLC4yNSl9LmFudC1wYWdpbmF0aW9uLmFudC1wYWdpbmF0aW9uLWRpc2FibGVkIC5hbnQtcGFnaW5hdGlvbi1pdGVtLWxpbmt7Y29sb3I6cmdiYSgwLDAsMCwuMjUpO2JhY2tncm91bmQ6I2Y1ZjVmNTtib3JkZXItY29sb3I6I2Q5ZDlkOTtjdXJzb3I6bm90LWFsbG93ZWR9LmFudC1wYWdpbmF0aW9uLXNpbXBsZS5hbnQtcGFnaW5hdGlvbi5hbnQtcGFnaW5hdGlvbi1kaXNhYmxlZCAuYW50LXBhZ2luYXRpb24taXRlbS1saW5re2JhY2tncm91bmQ6dHJhbnNwYXJlbnR9LmFudC1wYWdpbmF0aW9uLmFudC1wYWdpbmF0aW9uLWRpc2FibGVkIC5hbnQtcGFnaW5hdGlvbi1pdGVtLWxpbmstaWNvbntvcGFjaXR5OjB9LmFudC1wYWdpbmF0aW9uLmFudC1wYWdpbmF0aW9uLWRpc2FibGVkIC5hbnQtcGFnaW5hdGlvbi1pdGVtLWVsbGlwc2lze29wYWNpdHk6MX0uYW50LXBhZ2luYXRpb24uYW50LXBhZ2luYXRpb24tZGlzYWJsZWQgLmFudC1wYWdpbmF0aW9uLXNpbXBsZS1wYWdlcntjb2xvcjpyZ2JhKDAsMCwwLC4yNSl9QG1lZGlhIG9ubHkgc2NyZWVuIGFuZCAobWF4LXdpZHRoOjk5MnB4KXsuYW50LXBhZ2luYXRpb24taXRlbS1hZnRlci1qdW1wLXByZXYsLmFudC1wYWdpbmF0aW9uLWl0ZW0tYmVmb3JlLWp1bXAtbmV4dHtkaXNwbGF5Om5vbmV9fUBtZWRpYSBvbmx5IHNjcmVlbiBhbmQgKG1heC13aWR0aDo1NzZweCl7LmFudC1wYWdpbmF0aW9uLW9wdGlvbnN7ZGlzcGxheTpub25lfX0uYW50LXBhZ2luYXRpb24tcnRsIC5hbnQtcGFnaW5hdGlvbi1pdGVtLC5hbnQtcGFnaW5hdGlvbi1ydGwgLmFudC1wYWdpbmF0aW9uLWp1bXAtbmV4dCwuYW50LXBhZ2luYXRpb24tcnRsIC5hbnQtcGFnaW5hdGlvbi1qdW1wLXByZXYsLmFudC1wYWdpbmF0aW9uLXJ0bCAuYW50LXBhZ2luYXRpb24tcHJldiwuYW50LXBhZ2luYXRpb24tcnRsIC5hbnQtcGFnaW5hdGlvbi10b3RhbC10ZXh0e21hcmdpbi1yaWdodDowO21hcmdpbi1sZWZ0OjhweH0uYW50LXBhZ2luYXRpb24tcnRsIC5hbnQtcGFnaW5hdGlvbi1zbGFzaHttYXJnaW46MCA1cHggMCAxMHB4fS5hbnQtcGFnaW5hdGlvbi1ydGwgLmFudC1wYWdpbmF0aW9uLW9wdGlvbnN7bWFyZ2luLXJpZ2h0OjE2cHg7bWFyZ2luLWxlZnQ6MH0uYW50LXBhZ2luYXRpb24tcnRsIC5hbnQtcGFnaW5hdGlvbi1vcHRpb25zIC5hbnQtcGFnaW5hdGlvbi1vcHRpb25zLXNpemUtY2hhbmdlci5hbnQtc2VsZWN0e21hcmdpbi1yaWdodDowO21hcmdpbi1sZWZ0OjhweH0uYW50LXBhZ2luYXRpb24tcnRsIC5hbnQtcGFnaW5hdGlvbi1vcHRpb25zIC5hbnQtcGFnaW5hdGlvbi1vcHRpb25zLXF1aWNrLWp1bXBlcnttYXJnaW4tbGVmdDowfS5hbnQtcGFnaW5hdGlvbi1ydGwuYW50LXBhZ2luYXRpb24tc2ltcGxlIC5hbnQtcGFnaW5hdGlvbi1zaW1wbGUtcGFnZXIsLmFudC1wYWdpbmF0aW9uLXJ0bC5hbnQtcGFnaW5hdGlvbi1zaW1wbGUgLmFudC1wYWdpbmF0aW9uLXNpbXBsZS1wYWdlciBpbnB1dHttYXJnaW4tcmlnaHQ6MDttYXJnaW4tbGVmdDo4cHh9LmFudC1wYWdpbmF0aW9uLXJ0bC5hbnQtcGFnaW5hdGlvbi5taW5pIC5hbnQtcGFnaW5hdGlvbi1vcHRpb25ze21hcmdpbi1yaWdodDoycHg7bWFyZ2luLWxlZnQ6MH0uYW50LXBvcGNvbmZpcm17ei1pbmRleDoxMDYwfS5hbnQtcG9wb3Zlcntib3gtc2l6aW5nOmJvcmRlci1ib3g7bWFyZ2luOjA7cGFkZGluZzowO2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtmb250LXNpemU6MTRweDtmb250LXZhcmlhbnQ6dGFidWxhci1udW1zO2xpbmUtaGVpZ2h0OjEuNTcxNTtsaXN0LXN0eWxlOm5vbmU7Zm9udC1mZWF0dXJlLXNldHRpbmdzOlwidG51bVwiO3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO2xlZnQ6MDt6LWluZGV4OjEwMzA7bWF4LXdpZHRoOjEwMCU7Zm9udC13ZWlnaHQ6NDAwO3doaXRlLXNwYWNlOm5vcm1hbDt0ZXh0LWFsaWduOmxlZnQ7Y3Vyc29yOmF1dG87LXdlYmtpdC11c2VyLXNlbGVjdDp0ZXh0Oy1tb3otdXNlci1zZWxlY3Q6dGV4dDstbXMtdXNlci1zZWxlY3Q6dGV4dDt1c2VyLXNlbGVjdDp0ZXh0fS5hbnQtcG9wb3Zlci1jb250ZW50e3Bvc2l0aW9uOnJlbGF0aXZlfS5hbnQtcG9wb3ZlcjphZnRlcntwb3NpdGlvbjphYnNvbHV0ZTtiYWNrZ3JvdW5kOmhzbGEoMCwwJSwxMDAlLC4wMSk7Y29udGVudDpcIlwifS5hbnQtcG9wb3Zlci1oaWRkZW57ZGlzcGxheTpub25lfS5hbnQtcG9wb3Zlci1wbGFjZW1lbnQtdG9wLC5hbnQtcG9wb3Zlci1wbGFjZW1lbnQtdG9wTGVmdCwuYW50LXBvcG92ZXItcGxhY2VtZW50LXRvcFJpZ2h0e3BhZGRpbmctYm90dG9tOjE1LjMxMzcwODVweH0uYW50LXBvcG92ZXItcGxhY2VtZW50LXJpZ2h0LC5hbnQtcG9wb3Zlci1wbGFjZW1lbnQtcmlnaHRCb3R0b20sLmFudC1wb3BvdmVyLXBsYWNlbWVudC1yaWdodFRvcHtwYWRkaW5nLWxlZnQ6MTUuMzEzNzA4NXB4fS5hbnQtcG9wb3Zlci1wbGFjZW1lbnQtYm90dG9tLC5hbnQtcG9wb3Zlci1wbGFjZW1lbnQtYm90dG9tTGVmdCwuYW50LXBvcG92ZXItcGxhY2VtZW50LWJvdHRvbVJpZ2h0e3BhZGRpbmctdG9wOjE1LjMxMzcwODVweH0uYW50LXBvcG92ZXItcGxhY2VtZW50LWxlZnQsLmFudC1wb3BvdmVyLXBsYWNlbWVudC1sZWZ0Qm90dG9tLC5hbnQtcG9wb3Zlci1wbGFjZW1lbnQtbGVmdFRvcHtwYWRkaW5nLXJpZ2h0OjE1LjMxMzcwODVweH0uYW50LXBvcG92ZXItaW5uZXJ7YmFja2dyb3VuZC1jb2xvcjojZmZmO2JhY2tncm91bmQtY2xpcDpwYWRkaW5nLWJveDtib3JkZXItcmFkaXVzOjJweDtib3gtc2hhZG93OjAgM3B4IDZweCAtNHB4IHJnYmEoMCwwLDAsLjEyKSwwIDZweCAxNnB4IDAgcmdiYSgwLDAsMCwuMDgpLDAgOXB4IDI4cHggOHB4IHJnYmEoMCwwLDAsLjA1KX1AbWVkaWEgKC1tcy1oaWdoLWNvbnRyYXN0Om5vbmUpLHNjcmVlbiBhbmQgKC1tcy1oaWdoLWNvbnRyYXN0OmFjdGl2ZSl7LmFudC1wb3BvdmVyLWlubmVye2JveC1zaGFkb3c6MCAzcHggNnB4IC00cHggcmdiYSgwLDAsMCwuMTIpLDAgNnB4IDE2cHggMCByZ2JhKDAsMCwwLC4wOCksMCA5cHggMjhweCA4cHggcmdiYSgwLDAsMCwuMDUpfX0uYW50LXBvcG92ZXItdGl0bGV7bWluLXdpZHRoOjE3N3B4O21pbi1oZWlnaHQ6MzJweDttYXJnaW46MDtwYWRkaW5nOjVweCAxNnB4IDRweDtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7Zm9udC13ZWlnaHQ6NTAwO2JvcmRlci1ib3R0b206MXB4IHNvbGlkICNmMGYwZjB9LmFudC1wb3BvdmVyLWlubmVyLWNvbnRlbnR7d2lkdGg6LW1vei1tYXgtY29udGVudDt3aWR0aDptYXgtY29udGVudDttYXgtd2lkdGg6MTAwJTtwYWRkaW5nOjEycHggMTZweDtjb2xvcjpyZ2JhKDAsMCwwLC44NSl9LmFudC1wb3BvdmVyLW1lc3NhZ2V7ZGlzcGxheTpmbGV4O3BhZGRpbmc6NHB4IDAgMTJweDtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7Zm9udC1zaXplOjE0cHh9LmFudC1wb3BvdmVyLW1lc3NhZ2UtaWNvbntkaXNwbGF5OmlubGluZS1ibG9jazttYXJnaW4tcmlnaHQ6OHB4O2NvbG9yOiNmYWFkMTQ7Zm9udC1zaXplOjE0cHh9LmFudC1wb3BvdmVyLWJ1dHRvbnN7bWFyZ2luLWJvdHRvbTo0cHg7dGV4dC1hbGlnbjpyaWdodH0uYW50LXBvcG92ZXItYnV0dG9ucyBidXR0b246bm90KDpmaXJzdC1jaGlsZCl7bWFyZ2luLWxlZnQ6OHB4fS5hbnQtcG9wb3Zlci1hcnJvd3twb3NpdGlvbjphYnNvbHV0ZTtkaXNwbGF5OmJsb2NrO3dpZHRoOjIycHg7aGVpZ2h0OjIycHg7b3ZlcmZsb3c6aGlkZGVuO2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7cG9pbnRlci1ldmVudHM6bm9uZX0uYW50LXBvcG92ZXItYXJyb3ctY29udGVudHstLWFudGQtYXJyb3ctYmFja2dyb3VuZC1jb2xvcjojZmZmO3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO3JpZ2h0OjA7Ym90dG9tOjA7bGVmdDowO2Rpc3BsYXk6YmxvY2s7d2lkdGg6MTEuMzEzNzA4NXB4O2hlaWdodDoxMS4zMTM3MDg1cHg7bWFyZ2luOmF1dG87Y29udGVudDpcIlwiO3BvaW50ZXItZXZlbnRzOmF1dG87Ym9yZGVyLXJhZGl1czowIDAgMnB4O3BvaW50ZXItZXZlbnRzOm5vbmV9LmFudC1wb3BvdmVyLWFycm93LWNvbnRlbnQ6YmVmb3Jle3Bvc2l0aW9uOmFic29sdXRlO3RvcDotMTEuMzEzNzA4NXB4O2xlZnQ6LTExLjMxMzcwODVweDt3aWR0aDozMy45NDExMjU1cHg7aGVpZ2h0OjMzLjk0MTEyNTVweDtiYWNrZ3JvdW5kOnZhcigtLWFudGQtYXJyb3ctYmFja2dyb3VuZC1jb2xvcik7YmFja2dyb3VuZC1yZXBlYXQ6bm8tcmVwZWF0O2JhY2tncm91bmQtcG9zaXRpb246LTEwcHggLTEwcHg7Y29udGVudDpcIlwiOy13ZWJraXQtY2xpcC1wYXRoOmluc2V0KDMzJSAzMyUpO2NsaXAtcGF0aDppbnNldCgzMyUgMzMlKTstd2Via2l0LWNsaXAtcGF0aDpwYXRoKFwiTSA5Ljg0OTI0MjQwNDkxNzQ5OSAyNC4wOTE4ODMwOTIwMzY3ODUgQSA1IDUgMCAwIDEgMTMuMzg0Nzc2MzEwODUwMjM3IDIyLjYyNzQxNjk5Nzk2OTUyMiBMIDIwLjYyNzQxNjk5Nzk2OTUyMiAyMi42Mjc0MTY5OTc5Njk1MjIgQSAyIDIgMCAwIDAgMjIuNjI3NDE2OTk3OTY5NTIyIDIwLjYyNzQxNjk5Nzk2OTUyMiBMIDIyLjYyNzQxNjk5Nzk2OTUyMiAxMy4zODQ3NzYzMTA4NTAyMzcgQSA1IDUgMCAwIDEgMjQuMDkxODgzMDkyMDM2Nzg1IDkuODQ5MjQyNDA0OTE3NDk5IEwgMjMuMDkxODgzMDkyMDM2Nzg1IDkuODQ5MjQyNDA0OTE3NDk5IEwgOS44NDkyNDI0MDQ5MTc0OTkgMjMuMDkxODgzMDkyMDM2Nzg1IFpcIik7Y2xpcC1wYXRoOnBhdGgoXCJNIDkuODQ5MjQyNDA0OTE3NDk5IDI0LjA5MTg4MzA5MjAzNjc4NSBBIDUgNSAwIDAgMSAxMy4zODQ3NzYzMTA4NTAyMzcgMjIuNjI3NDE2OTk3OTY5NTIyIEwgMjAuNjI3NDE2OTk3OTY5NTIyIDIyLjYyNzQxNjk5Nzk2OTUyMiBBIDIgMiAwIDAgMCAyMi42Mjc0MTY5OTc5Njk1MjIgMjAuNjI3NDE2OTk3OTY5NTIyIEwgMjIuNjI3NDE2OTk3OTY5NTIyIDEzLjM4NDc3NjMxMDg1MDIzNyBBIDUgNSAwIDAgMSAyNC4wOTE4ODMwOTIwMzY3ODUgOS44NDkyNDI0MDQ5MTc0OTkgTCAyMy4wOTE4ODMwOTIwMzY3ODUgOS44NDkyNDI0MDQ5MTc0OTkgTCA5Ljg0OTI0MjQwNDkxNzQ5OSAyMy4wOTE4ODMwOTIwMzY3ODUgWlwiKX0uYW50LXBvcG92ZXItcGxhY2VtZW50LXRvcCAuYW50LXBvcG92ZXItYXJyb3csLmFudC1wb3BvdmVyLXBsYWNlbWVudC10b3BMZWZ0IC5hbnQtcG9wb3Zlci1hcnJvdywuYW50LXBvcG92ZXItcGxhY2VtZW50LXRvcFJpZ2h0IC5hbnQtcG9wb3Zlci1hcnJvd3tib3R0b206MDt0cmFuc2Zvcm06dHJhbnNsYXRlWSgxMDAlKX0uYW50LXBvcG92ZXItcGxhY2VtZW50LXRvcCAuYW50LXBvcG92ZXItYXJyb3ctY29udGVudCwuYW50LXBvcG92ZXItcGxhY2VtZW50LXRvcExlZnQgLmFudC1wb3BvdmVyLWFycm93LWNvbnRlbnQsLmFudC1wb3BvdmVyLXBsYWNlbWVudC10b3BSaWdodCAuYW50LXBvcG92ZXItYXJyb3ctY29udGVudHtib3gtc2hhZG93OjNweCAzcHggN3B4IHJnYmEoMCwwLDAsLjA3KTt0cmFuc2Zvcm06dHJhbnNsYXRlWSgtMTFweCkgcm90YXRlKDQ1ZGVnKX0uYW50LXBvcG92ZXItcGxhY2VtZW50LXRvcCAuYW50LXBvcG92ZXItYXJyb3d7bGVmdDo1MCU7dHJhbnNmb3JtOnRyYW5zbGF0ZVkoMTAwJSkgdHJhbnNsYXRlWCgtNTAlKX0uYW50LXBvcG92ZXItcGxhY2VtZW50LXRvcExlZnQgLmFudC1wb3BvdmVyLWFycm93e2xlZnQ6MTZweH0uYW50LXBvcG92ZXItcGxhY2VtZW50LXRvcFJpZ2h0IC5hbnQtcG9wb3Zlci1hcnJvd3tyaWdodDoxNnB4fS5hbnQtcG9wb3Zlci1wbGFjZW1lbnQtcmlnaHQgLmFudC1wb3BvdmVyLWFycm93LC5hbnQtcG9wb3Zlci1wbGFjZW1lbnQtcmlnaHRCb3R0b20gLmFudC1wb3BvdmVyLWFycm93LC5hbnQtcG9wb3Zlci1wbGFjZW1lbnQtcmlnaHRUb3AgLmFudC1wb3BvdmVyLWFycm93e2xlZnQ6MDt0cmFuc2Zvcm06dHJhbnNsYXRlWCgtMTAwJSl9LmFudC1wb3BvdmVyLXBsYWNlbWVudC1yaWdodCAuYW50LXBvcG92ZXItYXJyb3ctY29udGVudCwuYW50LXBvcG92ZXItcGxhY2VtZW50LXJpZ2h0Qm90dG9tIC5hbnQtcG9wb3Zlci1hcnJvdy1jb250ZW50LC5hbnQtcG9wb3Zlci1wbGFjZW1lbnQtcmlnaHRUb3AgLmFudC1wb3BvdmVyLWFycm93LWNvbnRlbnR7Ym94LXNoYWRvdzozcHggM3B4IDdweCByZ2JhKDAsMCwwLC4wNyk7dHJhbnNmb3JtOnRyYW5zbGF0ZVgoMTFweCkgcm90YXRlKDEzNWRlZyl9LmFudC1wb3BvdmVyLXBsYWNlbWVudC1yaWdodCAuYW50LXBvcG92ZXItYXJyb3d7dG9wOjUwJTt0cmFuc2Zvcm06dHJhbnNsYXRlWCgtMTAwJSkgdHJhbnNsYXRlWSgtNTAlKX0uYW50LXBvcG92ZXItcGxhY2VtZW50LXJpZ2h0VG9wIC5hbnQtcG9wb3Zlci1hcnJvd3t0b3A6MTJweH0uYW50LXBvcG92ZXItcGxhY2VtZW50LXJpZ2h0Qm90dG9tIC5hbnQtcG9wb3Zlci1hcnJvd3tib3R0b206MTJweH0uYW50LXBvcG92ZXItcGxhY2VtZW50LWJvdHRvbSAuYW50LXBvcG92ZXItYXJyb3csLmFudC1wb3BvdmVyLXBsYWNlbWVudC1ib3R0b21MZWZ0IC5hbnQtcG9wb3Zlci1hcnJvdywuYW50LXBvcG92ZXItcGxhY2VtZW50LWJvdHRvbVJpZ2h0IC5hbnQtcG9wb3Zlci1hcnJvd3t0b3A6MDt0cmFuc2Zvcm06dHJhbnNsYXRlWSgtMTAwJSl9LmFudC1wb3BvdmVyLXBsYWNlbWVudC1ib3R0b20gLmFudC1wb3BvdmVyLWFycm93LWNvbnRlbnQsLmFudC1wb3BvdmVyLXBsYWNlbWVudC1ib3R0b21MZWZ0IC5hbnQtcG9wb3Zlci1hcnJvdy1jb250ZW50LC5hbnQtcG9wb3Zlci1wbGFjZW1lbnQtYm90dG9tUmlnaHQgLmFudC1wb3BvdmVyLWFycm93LWNvbnRlbnR7Ym94LXNoYWRvdzoycHggMnB4IDVweCByZ2JhKDAsMCwwLC4wNik7dHJhbnNmb3JtOnRyYW5zbGF0ZVkoMTFweCkgcm90YXRlKC0xMzVkZWcpfS5hbnQtcG9wb3Zlci1wbGFjZW1lbnQtYm90dG9tIC5hbnQtcG9wb3Zlci1hcnJvd3tsZWZ0OjUwJTt0cmFuc2Zvcm06dHJhbnNsYXRlWSgtMTAwJSkgdHJhbnNsYXRlWCgtNTAlKX0uYW50LXBvcG92ZXItcGxhY2VtZW50LWJvdHRvbUxlZnQgLmFudC1wb3BvdmVyLWFycm93e2xlZnQ6MTZweH0uYW50LXBvcG92ZXItcGxhY2VtZW50LWJvdHRvbVJpZ2h0IC5hbnQtcG9wb3Zlci1hcnJvd3tyaWdodDoxNnB4fS5hbnQtcG9wb3Zlci1wbGFjZW1lbnQtbGVmdCAuYW50LXBvcG92ZXItYXJyb3csLmFudC1wb3BvdmVyLXBsYWNlbWVudC1sZWZ0Qm90dG9tIC5hbnQtcG9wb3Zlci1hcnJvdywuYW50LXBvcG92ZXItcGxhY2VtZW50LWxlZnRUb3AgLmFudC1wb3BvdmVyLWFycm93e3JpZ2h0OjA7dHJhbnNmb3JtOnRyYW5zbGF0ZVgoMTAwJSl9LmFudC1wb3BvdmVyLXBsYWNlbWVudC1sZWZ0IC5hbnQtcG9wb3Zlci1hcnJvdy1jb250ZW50LC5hbnQtcG9wb3Zlci1wbGFjZW1lbnQtbGVmdEJvdHRvbSAuYW50LXBvcG92ZXItYXJyb3ctY29udGVudCwuYW50LXBvcG92ZXItcGxhY2VtZW50LWxlZnRUb3AgLmFudC1wb3BvdmVyLWFycm93LWNvbnRlbnR7Ym94LXNoYWRvdzozcHggM3B4IDdweCByZ2JhKDAsMCwwLC4wNyk7dHJhbnNmb3JtOnRyYW5zbGF0ZVgoLTExcHgpIHJvdGF0ZSgtNDVkZWcpfS5hbnQtcG9wb3Zlci1wbGFjZW1lbnQtbGVmdCAuYW50LXBvcG92ZXItYXJyb3d7dG9wOjUwJTt0cmFuc2Zvcm06dHJhbnNsYXRlWCgxMDAlKSB0cmFuc2xhdGVZKC01MCUpfS5hbnQtcG9wb3Zlci1wbGFjZW1lbnQtbGVmdFRvcCAuYW50LXBvcG92ZXItYXJyb3d7dG9wOjEycHh9LmFudC1wb3BvdmVyLXBsYWNlbWVudC1sZWZ0Qm90dG9tIC5hbnQtcG9wb3Zlci1hcnJvd3tib3R0b206MTJweH0uYW50LXBvcG92ZXItbWFnZW50YSAuYW50LXBvcG92ZXItYXJyb3ctY29udGVudCwuYW50LXBvcG92ZXItbWFnZW50YSAuYW50LXBvcG92ZXItaW5uZXIsLmFudC1wb3BvdmVyLXBpbmsgLmFudC1wb3BvdmVyLWFycm93LWNvbnRlbnQsLmFudC1wb3BvdmVyLXBpbmsgLmFudC1wb3BvdmVyLWlubmVye2JhY2tncm91bmQtY29sb3I6I2ViMmY5Nn0uYW50LXBvcG92ZXItcmVkIC5hbnQtcG9wb3Zlci1hcnJvdy1jb250ZW50LC5hbnQtcG9wb3Zlci1yZWQgLmFudC1wb3BvdmVyLWlubmVye2JhY2tncm91bmQtY29sb3I6I2Y1MjIyZH0uYW50LXBvcG92ZXItdm9sY2FubyAuYW50LXBvcG92ZXItYXJyb3ctY29udGVudCwuYW50LXBvcG92ZXItdm9sY2FubyAuYW50LXBvcG92ZXItaW5uZXJ7YmFja2dyb3VuZC1jb2xvcjojZmE1NDFjfS5hbnQtcG9wb3Zlci1vcmFuZ2UgLmFudC1wb3BvdmVyLWFycm93LWNvbnRlbnQsLmFudC1wb3BvdmVyLW9yYW5nZSAuYW50LXBvcG92ZXItaW5uZXJ7YmFja2dyb3VuZC1jb2xvcjojZmE4YzE2fS5hbnQtcG9wb3Zlci15ZWxsb3cgLmFudC1wb3BvdmVyLWFycm93LWNvbnRlbnQsLmFudC1wb3BvdmVyLXllbGxvdyAuYW50LXBvcG92ZXItaW5uZXJ7YmFja2dyb3VuZC1jb2xvcjojZmFkYjE0fS5hbnQtcG9wb3Zlci1nb2xkIC5hbnQtcG9wb3Zlci1hcnJvdy1jb250ZW50LC5hbnQtcG9wb3Zlci1nb2xkIC5hbnQtcG9wb3Zlci1pbm5lcntiYWNrZ3JvdW5kLWNvbG9yOiNmYWFkMTR9LmFudC1wb3BvdmVyLWN5YW4gLmFudC1wb3BvdmVyLWFycm93LWNvbnRlbnQsLmFudC1wb3BvdmVyLWN5YW4gLmFudC1wb3BvdmVyLWlubmVye2JhY2tncm91bmQtY29sb3I6IzEzYzJjMn0uYW50LXBvcG92ZXItbGltZSAuYW50LXBvcG92ZXItYXJyb3ctY29udGVudCwuYW50LXBvcG92ZXItbGltZSAuYW50LXBvcG92ZXItaW5uZXJ7YmFja2dyb3VuZC1jb2xvcjojYTBkOTExfS5hbnQtcG9wb3Zlci1ncmVlbiAuYW50LXBvcG92ZXItYXJyb3ctY29udGVudCwuYW50LXBvcG92ZXItZ3JlZW4gLmFudC1wb3BvdmVyLWlubmVye2JhY2tncm91bmQtY29sb3I6IzUyYzQxYX0uYW50LXBvcG92ZXItYmx1ZSAuYW50LXBvcG92ZXItYXJyb3ctY29udGVudCwuYW50LXBvcG92ZXItYmx1ZSAuYW50LXBvcG92ZXItaW5uZXJ7YmFja2dyb3VuZC1jb2xvcjojMTg5MGZmfS5hbnQtcG9wb3Zlci1nZWVrYmx1ZSAuYW50LXBvcG92ZXItYXJyb3ctY29udGVudCwuYW50LXBvcG92ZXItZ2Vla2JsdWUgLmFudC1wb3BvdmVyLWlubmVye2JhY2tncm91bmQtY29sb3I6IzJmNTRlYn0uYW50LXBvcG92ZXItcHVycGxlIC5hbnQtcG9wb3Zlci1hcnJvdy1jb250ZW50LC5hbnQtcG9wb3Zlci1wdXJwbGUgLmFudC1wb3BvdmVyLWlubmVye2JhY2tncm91bmQtY29sb3I6IzcyMmVkMX0uYW50LXBvcG92ZXItcnRse2RpcmVjdGlvbjpydGw7dGV4dC1hbGlnbjpyaWdodH0uYW50LXBvcG92ZXItcnRsIC5hbnQtcG9wb3Zlci1tZXNzYWdlLWljb257bWFyZ2luLXJpZ2h0OjA7bWFyZ2luLWxlZnQ6OHB4fS5hbnQtcG9wb3Zlci1ydGwgLmFudC1wb3BvdmVyLW1lc3NhZ2UtdGl0bGV7cGFkZGluZy1sZWZ0OjE2cHh9LmFudC1wb3BvdmVyLXJ0bCAuYW50LXBvcG92ZXItYnV0dG9uc3t0ZXh0LWFsaWduOmxlZnR9LmFudC1wb3BvdmVyLXJ0bCAuYW50LXBvcG92ZXItYnV0dG9ucyBidXR0b257bWFyZ2luLXJpZ2h0OjhweDttYXJnaW4tbGVmdDowfS5hbnQtcHJvZ3Jlc3N7Ym94LXNpemluZzpib3JkZXItYm94O21hcmdpbjowO3BhZGRpbmc6MDtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7Zm9udC1zaXplOjE0cHg7Zm9udC12YXJpYW50OnRhYnVsYXItbnVtcztsaW5lLWhlaWdodDoxLjU3MTU7bGlzdC1zdHlsZTpub25lO2ZvbnQtZmVhdHVyZS1zZXR0aW5nczpcInRudW1cIjtkaXNwbGF5OmlubGluZS1ibG9ja30uYW50LXByb2dyZXNzLWxpbmV7cG9zaXRpb246cmVsYXRpdmU7d2lkdGg6MTAwJTtmb250LXNpemU6MTRweH0uYW50LXByb2dyZXNzLXN0ZXBze2Rpc3BsYXk6aW5saW5lLWJsb2NrfS5hbnQtcHJvZ3Jlc3Mtc3RlcHMtb3V0ZXJ7ZGlzcGxheTpmbGV4O2ZsZXgtZGlyZWN0aW9uOnJvdzthbGlnbi1pdGVtczpjZW50ZXJ9LmFudC1wcm9ncmVzcy1zdGVwcy1pdGVte2ZsZXgtc2hyaW5rOjA7bWluLXdpZHRoOjJweDttYXJnaW4tcmlnaHQ6MnB4O2JhY2tncm91bmQ6I2YzZjNmMzt0cmFuc2l0aW9uOmFsbCAuM3N9LmFudC1wcm9ncmVzcy1zdGVwcy1pdGVtLWFjdGl2ZXtiYWNrZ3JvdW5kOiMxODkwZmZ9LmFudC1wcm9ncmVzcy1zbWFsbC5hbnQtcHJvZ3Jlc3MtbGluZSwuYW50LXByb2dyZXNzLXNtYWxsLmFudC1wcm9ncmVzcy1saW5lIC5hbnQtcHJvZ3Jlc3MtdGV4dCAuYW50aWNvbntmb250LXNpemU6MTJweH0uYW50LXByb2dyZXNzLW91dGVye2Rpc3BsYXk6aW5saW5lLWJsb2NrO3dpZHRoOjEwMCU7bWFyZ2luLXJpZ2h0OjA7cGFkZGluZy1yaWdodDowfS5hbnQtcHJvZ3Jlc3Mtc2hvdy1pbmZvIC5hbnQtcHJvZ3Jlc3Mtb3V0ZXJ7bWFyZ2luLXJpZ2h0OmNhbGMoLTJlbSAtIDhweCk7cGFkZGluZy1yaWdodDpjYWxjKDJlbSArIDhweCl9LmFudC1wcm9ncmVzcy1pbm5lcntwb3NpdGlvbjpyZWxhdGl2ZTtkaXNwbGF5OmlubGluZS1ibG9jazt3aWR0aDoxMDAlO292ZXJmbG93OmhpZGRlbjt2ZXJ0aWNhbC1hbGlnbjptaWRkbGU7YmFja2dyb3VuZC1jb2xvcjojZjVmNWY1O2JvcmRlci1yYWRpdXM6MTAwcHh9LmFudC1wcm9ncmVzcy1jaXJjbGUtdHJhaWx7c3Ryb2tlOiNmNWY1ZjV9LmFudC1wcm9ncmVzcy1jaXJjbGUtcGF0aHthbmltYXRpb246YW50LXByb2dyZXNzLWFwcGVhciAuM3N9LmFudC1wcm9ncmVzcy1pbm5lcjpub3QoLmFudC1wcm9ncmVzcy1jaXJjbGUtZ3JhZGllbnQpIC5hbnQtcHJvZ3Jlc3MtY2lyY2xlLXBhdGh7c3Ryb2tlOiMxODkwZmZ9LmFudC1wcm9ncmVzcy1iZywuYW50LXByb2dyZXNzLXN1Y2Nlc3MtYmd7cG9zaXRpb246cmVsYXRpdmU7YmFja2dyb3VuZC1jb2xvcjojMTg5MGZmO2JvcmRlci1yYWRpdXM6MTAwcHg7dHJhbnNpdGlvbjphbGwgLjRzIGN1YmljLWJlemllciguMDgsLjgyLC4xNywxKSAwc30uYW50LXByb2dyZXNzLXN1Y2Nlc3MtYmd7cG9zaXRpb246YWJzb2x1dGU7dG9wOjA7bGVmdDowO2JhY2tncm91bmQtY29sb3I6IzUyYzQxYX0uYW50LXByb2dyZXNzLXRleHR7ZGlzcGxheTppbmxpbmUtYmxvY2s7d2lkdGg6MmVtO21hcmdpbi1sZWZ0OjhweDtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7Zm9udC1zaXplOjFlbTtsaW5lLWhlaWdodDoxO3doaXRlLXNwYWNlOm5vd3JhcDt0ZXh0LWFsaWduOmxlZnQ7dmVydGljYWwtYWxpZ246bWlkZGxlO3dvcmQtYnJlYWs6bm9ybWFsfS5hbnQtcHJvZ3Jlc3MtdGV4dCAuYW50aWNvbntmb250LXNpemU6MTRweH0uYW50LXByb2dyZXNzLXN0YXR1cy1hY3RpdmUgLmFudC1wcm9ncmVzcy1iZzpiZWZvcmV7cG9zaXRpb246YWJzb2x1dGU7dG9wOjA7cmlnaHQ6MDtib3R0b206MDtsZWZ0OjA7YmFja2dyb3VuZDojZmZmO2JvcmRlci1yYWRpdXM6MTBweDtvcGFjaXR5OjA7YW5pbWF0aW9uOmFudC1wcm9ncmVzcy1hY3RpdmUgMi40cyBjdWJpYy1iZXppZXIoLjIzLDEsLjMyLDEpIGluZmluaXRlO2NvbnRlbnQ6XCJcIn0uYW50LXByb2dyZXNzLXN0YXR1cy1leGNlcHRpb24gLmFudC1wcm9ncmVzcy1iZ3tiYWNrZ3JvdW5kLWNvbG9yOiNmZjRkNGZ9LmFudC1wcm9ncmVzcy1zdGF0dXMtZXhjZXB0aW9uIC5hbnQtcHJvZ3Jlc3MtdGV4dHtjb2xvcjojZmY0ZDRmfS5hbnQtcHJvZ3Jlc3Mtc3RhdHVzLWV4Y2VwdGlvbiAuYW50LXByb2dyZXNzLWlubmVyOm5vdCguYW50LXByb2dyZXNzLWNpcmNsZS1ncmFkaWVudCkgLmFudC1wcm9ncmVzcy1jaXJjbGUtcGF0aHtzdHJva2U6I2ZmNGQ0Zn0uYW50LXByb2dyZXNzLXN0YXR1cy1zdWNjZXNzIC5hbnQtcHJvZ3Jlc3MtYmd7YmFja2dyb3VuZC1jb2xvcjojNTJjNDFhfS5hbnQtcHJvZ3Jlc3Mtc3RhdHVzLXN1Y2Nlc3MgLmFudC1wcm9ncmVzcy10ZXh0e2NvbG9yOiM1MmM0MWF9LmFudC1wcm9ncmVzcy1zdGF0dXMtc3VjY2VzcyAuYW50LXByb2dyZXNzLWlubmVyOm5vdCguYW50LXByb2dyZXNzLWNpcmNsZS1ncmFkaWVudCkgLmFudC1wcm9ncmVzcy1jaXJjbGUtcGF0aHtzdHJva2U6IzUyYzQxYX0uYW50LXByb2dyZXNzLWNpcmNsZSAuYW50LXByb2dyZXNzLWlubmVye3Bvc2l0aW9uOnJlbGF0aXZlO2xpbmUtaGVpZ2h0OjE7YmFja2dyb3VuZC1jb2xvcjp0cmFuc3BhcmVudH0uYW50LXByb2dyZXNzLWNpcmNsZSAuYW50LXByb2dyZXNzLXRleHR7cG9zaXRpb246YWJzb2x1dGU7dG9wOjUwJTtsZWZ0OjUwJTt3aWR0aDoxMDAlO21hcmdpbjowO3BhZGRpbmc6MDtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7Zm9udC1zaXplOjFlbTtsaW5lLWhlaWdodDoxO3doaXRlLXNwYWNlOm5vcm1hbDt0ZXh0LWFsaWduOmNlbnRlcjt0cmFuc2Zvcm06dHJhbnNsYXRlKC01MCUsLTUwJSl9LmFudC1wcm9ncmVzcy1jaXJjbGUgLmFudC1wcm9ncmVzcy10ZXh0IC5hbnRpY29ue2ZvbnQtc2l6ZToxLjE2NjY2NjY3ZW19LmFudC1wcm9ncmVzcy1jaXJjbGUuYW50LXByb2dyZXNzLXN0YXR1cy1leGNlcHRpb24gLmFudC1wcm9ncmVzcy10ZXh0e2NvbG9yOiNmZjRkNGZ9LmFudC1wcm9ncmVzcy1jaXJjbGUuYW50LXByb2dyZXNzLXN0YXR1cy1zdWNjZXNzIC5hbnQtcHJvZ3Jlc3MtdGV4dHtjb2xvcjojNTJjNDFhfUBrZXlmcmFtZXMgYW50LXByb2dyZXNzLWFjdGl2ZXswJXt0cmFuc2Zvcm06dHJhbnNsYXRlWCgtMTAwJSkgc2NhbGVYKDApO29wYWNpdHk6LjF9MjAle3RyYW5zZm9ybTp0cmFuc2xhdGVYKC0xMDAlKSBzY2FsZVgoMCk7b3BhY2l0eTouNX10b3t0cmFuc2Zvcm06dHJhbnNsYXRlWCgwKSBzY2FsZVgoMSk7b3BhY2l0eTowfX0uYW50LXByb2dyZXNzLXJ0bHtkaXJlY3Rpb246cnRsfS5hbnQtcHJvZ3Jlc3MtcnRsLmFudC1wcm9ncmVzcy1zaG93LWluZm8gLmFudC1wcm9ncmVzcy1vdXRlcnttYXJnaW4tcmlnaHQ6MDttYXJnaW4tbGVmdDpjYWxjKC0yZW0gLSA4cHgpO3BhZGRpbmctcmlnaHQ6MDtwYWRkaW5nLWxlZnQ6Y2FsYygyZW0gKyA4cHgpfS5hbnQtcHJvZ3Jlc3MtcnRsIC5hbnQtcHJvZ3Jlc3Mtc3VjY2Vzcy1iZ3tyaWdodDowO2xlZnQ6YXV0b30uYW50LXByb2dyZXNzLXJ0bC5hbnQtcHJvZ3Jlc3MtbGluZSAuYW50LXByb2dyZXNzLXRleHQsLmFudC1wcm9ncmVzcy1ydGwuYW50LXByb2dyZXNzLXN0ZXBzIC5hbnQtcHJvZ3Jlc3MtdGV4dHttYXJnaW4tcmlnaHQ6OHB4O21hcmdpbi1sZWZ0OjA7dGV4dC1hbGlnbjpyaWdodH0uYW50LXJhZGlvLWdyb3Vwe2JveC1zaXppbmc6Ym9yZGVyLWJveDttYXJnaW46MDtwYWRkaW5nOjA7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtc2l6ZToxNHB4O2ZvbnQtdmFyaWFudDp0YWJ1bGFyLW51bXM7bGluZS1oZWlnaHQ6MS41NzE1O2xpc3Qtc3R5bGU6bm9uZTtmb250LWZlYXR1cmUtc2V0dGluZ3M6XCJ0bnVtXCI7ZGlzcGxheTppbmxpbmUtYmxvY2s7Zm9udC1zaXplOjB9LmFudC1yYWRpby1ncm91cCAuYW50LWJhZGdlLWNvdW50e3otaW5kZXg6MX0uYW50LXJhZGlvLWdyb3VwPi5hbnQtYmFkZ2U6bm90KDpmaXJzdC1jaGlsZCk+LmFudC1yYWRpby1idXR0b24td3JhcHBlcntib3JkZXItbGVmdDpub25lfS5hbnQtcmFkaW8td3JhcHBlcntib3gtc2l6aW5nOmJvcmRlci1ib3g7cGFkZGluZzowO2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtmb250LXNpemU6MTRweDtmb250LXZhcmlhbnQ6dGFidWxhci1udW1zO2xpbmUtaGVpZ2h0OjEuNTcxNTtsaXN0LXN0eWxlOm5vbmU7Zm9udC1mZWF0dXJlLXNldHRpbmdzOlwidG51bVwiO3Bvc2l0aW9uOnJlbGF0aXZlO2Rpc3BsYXk6aW5saW5lLWZsZXg7YWxpZ24taXRlbXM6YmFzZWxpbmU7bWFyZ2luOjAgOHB4IDAgMDtjdXJzb3I6cG9pbnRlcn0uYW50LXJhZGlvLXdyYXBwZXItZGlzYWJsZWR7Y3Vyc29yOm5vdC1hbGxvd2VkfS5hbnQtcmFkaW8td3JhcHBlcjphZnRlcntkaXNwbGF5OmlubGluZS1ibG9jazt3aWR0aDowO292ZXJmbG93OmhpZGRlbjtjb250ZW50OlwiXFxhMFwifS5hbnQtcmFkaW8td3JhcHBlci5hbnQtcmFkaW8td3JhcHBlci1pbi1mb3JtLWl0ZW0gaW5wdXRbdHlwZT1yYWRpb117d2lkdGg6MTRweDtoZWlnaHQ6MTRweH0uYW50LXJhZGlve2JveC1zaXppbmc6Ym9yZGVyLWJveDttYXJnaW46MDtwYWRkaW5nOjA7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtc2l6ZToxNHB4O2ZvbnQtdmFyaWFudDp0YWJ1bGFyLW51bXM7bGluZS1oZWlnaHQ6MS41NzE1O2xpc3Qtc3R5bGU6bm9uZTtmb250LWZlYXR1cmUtc2V0dGluZ3M6XCJ0bnVtXCI7cG9zaXRpb246cmVsYXRpdmU7dG9wOi4yZW07ZGlzcGxheTppbmxpbmUtYmxvY2s7b3V0bGluZTpub25lO2N1cnNvcjpwb2ludGVyfS5hbnQtcmFkaW8taW5wdXQ6Zm9jdXMrLmFudC1yYWRpby1pbm5lciwuYW50LXJhZGlvLXdyYXBwZXI6aG92ZXIgLmFudC1yYWRpbywuYW50LXJhZGlvOmhvdmVyIC5hbnQtcmFkaW8taW5uZXJ7Ym9yZGVyLWNvbG9yOiMxODkwZmZ9LmFudC1yYWRpby1pbnB1dDpmb2N1cysuYW50LXJhZGlvLWlubmVye2JveC1zaGFkb3c6MCAwIDAgM3B4IHJnYmEoMjQsMTQ0LDI1NSwuMTIpfS5hbnQtcmFkaW8tY2hlY2tlZDphZnRlcntwb3NpdGlvbjphYnNvbHV0ZTt0b3A6MDtsZWZ0OjA7d2lkdGg6MTAwJTtoZWlnaHQ6MTAwJTtib3JkZXI6MXB4IHNvbGlkICMxODkwZmY7Ym9yZGVyLXJhZGl1czo1MCU7dmlzaWJpbGl0eTpoaWRkZW47YW5pbWF0aW9uOmFudFJhZGlvRWZmZWN0IC4zNnMgZWFzZS1pbi1vdXQ7YW5pbWF0aW9uLWZpbGwtbW9kZTpib3RoO2NvbnRlbnQ6XCJcIn0uYW50LXJhZGlvLXdyYXBwZXI6aG92ZXIgLmFudC1yYWRpbzphZnRlciwuYW50LXJhZGlvOmhvdmVyOmFmdGVye3Zpc2liaWxpdHk6dmlzaWJsZX0uYW50LXJhZGlvLWlubmVye3Bvc2l0aW9uOnJlbGF0aXZlO3RvcDowO2xlZnQ6MDtkaXNwbGF5OmJsb2NrO3dpZHRoOjE2cHg7aGVpZ2h0OjE2cHg7YmFja2dyb3VuZC1jb2xvcjojZmZmO2JvcmRlcjoxcHggc29saWQgI2Q5ZDlkOTtib3JkZXItcmFkaXVzOjUwJTt0cmFuc2l0aW9uOmFsbCAuM3N9LmFudC1yYWRpby1pbm5lcjphZnRlcntwb3NpdGlvbjphYnNvbHV0ZTt0b3A6NTAlO2xlZnQ6NTAlO2Rpc3BsYXk6YmxvY2s7d2lkdGg6MTZweDtoZWlnaHQ6MTZweDttYXJnaW4tdG9wOi04cHg7bWFyZ2luLWxlZnQ6LThweDtiYWNrZ3JvdW5kLWNvbG9yOiMxODkwZmY7Ym9yZGVyLXRvcDowO2JvcmRlci1sZWZ0OjA7Ym9yZGVyLXJhZGl1czoxNnB4O3RyYW5zZm9ybTpzY2FsZSgwKTtvcGFjaXR5OjA7dHJhbnNpdGlvbjphbGwgLjNzIGN1YmljLWJlemllciguNzgsLjE0LC4xNSwuODYpO2NvbnRlbnQ6XCIgXCJ9LmFudC1yYWRpby1pbnB1dHtwb3NpdGlvbjphYnNvbHV0ZTt0b3A6MDtyaWdodDowO2JvdHRvbTowO2xlZnQ6MDt6LWluZGV4OjE7Y3Vyc29yOnBvaW50ZXI7b3BhY2l0eTowfS5hbnQtcmFkaW8uYW50LXJhZGlvLWRpc2FibGVkIC5hbnQtcmFkaW8taW5uZXJ7Ym9yZGVyLWNvbG9yOiNkOWQ5ZDl9LmFudC1yYWRpby1jaGVja2VkIC5hbnQtcmFkaW8taW5uZXJ7Ym9yZGVyLWNvbG9yOiMxODkwZmZ9LmFudC1yYWRpby1jaGVja2VkIC5hbnQtcmFkaW8taW5uZXI6YWZ0ZXJ7dHJhbnNmb3JtOnNjYWxlKC41KTtvcGFjaXR5OjE7dHJhbnNpdGlvbjphbGwgLjNzIGN1YmljLWJlemllciguNzgsLjE0LC4xNSwuODYpfS5hbnQtcmFkaW8tZGlzYWJsZWR7Y3Vyc29yOm5vdC1hbGxvd2VkfS5hbnQtcmFkaW8tZGlzYWJsZWQgLmFudC1yYWRpby1pbm5lcntiYWNrZ3JvdW5kLWNvbG9yOiNmNWY1ZjU7Y3Vyc29yOm5vdC1hbGxvd2VkfS5hbnQtcmFkaW8tZGlzYWJsZWQgLmFudC1yYWRpby1pbm5lcjphZnRlcntiYWNrZ3JvdW5kLWNvbG9yOnJnYmEoMCwwLDAsLjIpfS5hbnQtcmFkaW8tZGlzYWJsZWQgLmFudC1yYWRpby1pbnB1dHtjdXJzb3I6bm90LWFsbG93ZWR9LmFudC1yYWRpby1kaXNhYmxlZCtzcGFue2NvbG9yOnJnYmEoMCwwLDAsLjI1KTtjdXJzb3I6bm90LWFsbG93ZWR9c3Bhbi5hbnQtcmFkaW8rKntwYWRkaW5nLXJpZ2h0OjhweDtwYWRkaW5nLWxlZnQ6OHB4fS5hbnQtcmFkaW8tYnV0dG9uLXdyYXBwZXJ7cG9zaXRpb246cmVsYXRpdmU7ZGlzcGxheTppbmxpbmUtYmxvY2s7aGVpZ2h0OjMycHg7bWFyZ2luOjA7cGFkZGluZzowIDE1cHg7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtc2l6ZToxNHB4O2xpbmUtaGVpZ2h0OjMwcHg7YmFja2dyb3VuZDojZmZmO2JvcmRlci1jb2xvcjojZDlkOWQ5O2JvcmRlci1zdHlsZTpzb2xpZDtib3JkZXItd2lkdGg6MS4wMnB4IDFweCAxcHggMDtjdXJzb3I6cG9pbnRlcjt0cmFuc2l0aW9uOmNvbG9yIC4zcyxiYWNrZ3JvdW5kIC4zcyxib3JkZXItY29sb3IgLjNzLGJveC1zaGFkb3cgLjNzfS5hbnQtcmFkaW8tYnV0dG9uLXdyYXBwZXIgYXtjb2xvcjpyZ2JhKDAsMCwwLC44NSl9LmFudC1yYWRpby1idXR0b24td3JhcHBlcj4uYW50LXJhZGlvLWJ1dHRvbntwb3NpdGlvbjphYnNvbHV0ZTt0b3A6MDtsZWZ0OjA7ei1pbmRleDotMTt3aWR0aDoxMDAlO2hlaWdodDoxMDAlfS5hbnQtcmFkaW8tZ3JvdXAtbGFyZ2UgLmFudC1yYWRpby1idXR0b24td3JhcHBlcntoZWlnaHQ6NDBweDtmb250LXNpemU6MTZweDtsaW5lLWhlaWdodDozOHB4fS5hbnQtcmFkaW8tZ3JvdXAtc21hbGwgLmFudC1yYWRpby1idXR0b24td3JhcHBlcntoZWlnaHQ6MjRweDtwYWRkaW5nOjAgN3B4O2xpbmUtaGVpZ2h0OjIycHh9LmFudC1yYWRpby1idXR0b24td3JhcHBlcjpub3QoOmZpcnN0LWNoaWxkKTpiZWZvcmV7cG9zaXRpb246YWJzb2x1dGU7dG9wOi0xcHg7bGVmdDotMXB4O2Rpc3BsYXk6YmxvY2s7Ym94LXNpemluZzpjb250ZW50LWJveDt3aWR0aDoxcHg7aGVpZ2h0OjEwMCU7cGFkZGluZzoxcHggMDtiYWNrZ3JvdW5kLWNvbG9yOiNkOWQ5ZDk7dHJhbnNpdGlvbjpiYWNrZ3JvdW5kLWNvbG9yIC4zcztjb250ZW50OlwiXCJ9LmFudC1yYWRpby1idXR0b24td3JhcHBlcjpmaXJzdC1jaGlsZHtib3JkZXItbGVmdDoxcHggc29saWQgI2Q5ZDlkOTtib3JkZXItcmFkaXVzOjJweCAwIDAgMnB4fS5hbnQtcmFkaW8tYnV0dG9uLXdyYXBwZXI6bGFzdC1jaGlsZHtib3JkZXItcmFkaXVzOjAgMnB4IDJweCAwfS5hbnQtcmFkaW8tYnV0dG9uLXdyYXBwZXI6Zmlyc3QtY2hpbGQ6bGFzdC1jaGlsZHtib3JkZXItcmFkaXVzOjJweH0uYW50LXJhZGlvLWJ1dHRvbi13cmFwcGVyOmhvdmVye3Bvc2l0aW9uOnJlbGF0aXZlO2NvbG9yOiMxODkwZmZ9LmFudC1yYWRpby1idXR0b24td3JhcHBlcjpmb2N1cy13aXRoaW57Ym94LXNoYWRvdzowIDAgMCAzcHggcmdiYSgyNCwxNDQsMjU1LC4xMil9LmFudC1yYWRpby1idXR0b24td3JhcHBlciAuYW50LXJhZGlvLWlubmVyLC5hbnQtcmFkaW8tYnV0dG9uLXdyYXBwZXIgaW5wdXRbdHlwZT1jaGVja2JveF0sLmFudC1yYWRpby1idXR0b24td3JhcHBlciBpbnB1dFt0eXBlPXJhZGlvXXt3aWR0aDowO2hlaWdodDowO29wYWNpdHk6MDtwb2ludGVyLWV2ZW50czpub25lfS5hbnQtcmFkaW8tYnV0dG9uLXdyYXBwZXItY2hlY2tlZDpub3QoLmFudC1yYWRpby1idXR0b24td3JhcHBlci1kaXNhYmxlZCl7ei1pbmRleDoxO2NvbG9yOiMxODkwZmY7YmFja2dyb3VuZDojZmZmO2JvcmRlci1jb2xvcjojMTg5MGZmfS5hbnQtcmFkaW8tYnV0dG9uLXdyYXBwZXItY2hlY2tlZDpub3QoLmFudC1yYWRpby1idXR0b24td3JhcHBlci1kaXNhYmxlZCk6YmVmb3Jle2JhY2tncm91bmQtY29sb3I6IzE4OTBmZn0uYW50LXJhZGlvLWJ1dHRvbi13cmFwcGVyLWNoZWNrZWQ6bm90KC5hbnQtcmFkaW8tYnV0dG9uLXdyYXBwZXItZGlzYWJsZWQpOmZpcnN0LWNoaWxke2JvcmRlci1jb2xvcjojMTg5MGZmfS5hbnQtcmFkaW8tYnV0dG9uLXdyYXBwZXItY2hlY2tlZDpub3QoLmFudC1yYWRpby1idXR0b24td3JhcHBlci1kaXNhYmxlZCk6aG92ZXJ7Y29sb3I6IzQwYTlmZjtib3JkZXItY29sb3I6IzQwYTlmZn0uYW50LXJhZGlvLWJ1dHRvbi13cmFwcGVyLWNoZWNrZWQ6bm90KC5hbnQtcmFkaW8tYnV0dG9uLXdyYXBwZXItZGlzYWJsZWQpOmhvdmVyOmJlZm9yZXtiYWNrZ3JvdW5kLWNvbG9yOiM0MGE5ZmZ9LmFudC1yYWRpby1idXR0b24td3JhcHBlci1jaGVja2VkOm5vdCguYW50LXJhZGlvLWJ1dHRvbi13cmFwcGVyLWRpc2FibGVkKTphY3RpdmV7Y29sb3I6IzA5NmRkOTtib3JkZXItY29sb3I6IzA5NmRkOX0uYW50LXJhZGlvLWJ1dHRvbi13cmFwcGVyLWNoZWNrZWQ6bm90KC5hbnQtcmFkaW8tYnV0dG9uLXdyYXBwZXItZGlzYWJsZWQpOmFjdGl2ZTpiZWZvcmV7YmFja2dyb3VuZC1jb2xvcjojMDk2ZGQ5fS5hbnQtcmFkaW8tYnV0dG9uLXdyYXBwZXItY2hlY2tlZDpub3QoLmFudC1yYWRpby1idXR0b24td3JhcHBlci1kaXNhYmxlZCk6Zm9jdXMtd2l0aGlue2JveC1zaGFkb3c6MCAwIDAgM3B4IHJnYmEoMjQsMTQ0LDI1NSwuMTIpfS5hbnQtcmFkaW8tZ3JvdXAtc29saWQgLmFudC1yYWRpby1idXR0b24td3JhcHBlci1jaGVja2VkOm5vdCguYW50LXJhZGlvLWJ1dHRvbi13cmFwcGVyLWRpc2FibGVkKXtjb2xvcjojZmZmO2JhY2tncm91bmQ6IzE4OTBmZjtib3JkZXItY29sb3I6IzE4OTBmZn0uYW50LXJhZGlvLWdyb3VwLXNvbGlkIC5hbnQtcmFkaW8tYnV0dG9uLXdyYXBwZXItY2hlY2tlZDpub3QoLmFudC1yYWRpby1idXR0b24td3JhcHBlci1kaXNhYmxlZCk6aG92ZXJ7Y29sb3I6I2ZmZjtiYWNrZ3JvdW5kOiM0MGE5ZmY7Ym9yZGVyLWNvbG9yOiM0MGE5ZmZ9LmFudC1yYWRpby1ncm91cC1zb2xpZCAuYW50LXJhZGlvLWJ1dHRvbi13cmFwcGVyLWNoZWNrZWQ6bm90KC5hbnQtcmFkaW8tYnV0dG9uLXdyYXBwZXItZGlzYWJsZWQpOmFjdGl2ZXtjb2xvcjojZmZmO2JhY2tncm91bmQ6IzA5NmRkOTtib3JkZXItY29sb3I6IzA5NmRkOX0uYW50LXJhZGlvLWdyb3VwLXNvbGlkIC5hbnQtcmFkaW8tYnV0dG9uLXdyYXBwZXItY2hlY2tlZDpub3QoLmFudC1yYWRpby1idXR0b24td3JhcHBlci1kaXNhYmxlZCk6Zm9jdXMtd2l0aGlue2JveC1zaGFkb3c6MCAwIDAgM3B4IHJnYmEoMjQsMTQ0LDI1NSwuMTIpfS5hbnQtcmFkaW8tYnV0dG9uLXdyYXBwZXItZGlzYWJsZWR7Y3Vyc29yOm5vdC1hbGxvd2VkfS5hbnQtcmFkaW8tYnV0dG9uLXdyYXBwZXItZGlzYWJsZWQsLmFudC1yYWRpby1idXR0b24td3JhcHBlci1kaXNhYmxlZDpmaXJzdC1jaGlsZCwuYW50LXJhZGlvLWJ1dHRvbi13cmFwcGVyLWRpc2FibGVkOmhvdmVye2NvbG9yOnJnYmEoMCwwLDAsLjI1KTtiYWNrZ3JvdW5kLWNvbG9yOiNmNWY1ZjU7Ym9yZGVyLWNvbG9yOiNkOWQ5ZDl9LmFudC1yYWRpby1idXR0b24td3JhcHBlci1kaXNhYmxlZDpmaXJzdC1jaGlsZHtib3JkZXItbGVmdC1jb2xvcjojZDlkOWQ5fS5hbnQtcmFkaW8tYnV0dG9uLXdyYXBwZXItZGlzYWJsZWQuYW50LXJhZGlvLWJ1dHRvbi13cmFwcGVyLWNoZWNrZWR7Y29sb3I6cmdiYSgwLDAsMCwuMjUpO2JhY2tncm91bmQtY29sb3I6I2U2ZTZlNjtib3JkZXItY29sb3I6I2Q5ZDlkOTtib3gtc2hhZG93Om5vbmV9QGtleWZyYW1lcyBhbnRSYWRpb0VmZmVjdHswJXt0cmFuc2Zvcm06c2NhbGUoMSk7b3BhY2l0eTouNX10b3t0cmFuc2Zvcm06c2NhbGUoMS42KTtvcGFjaXR5OjB9fS5hbnQtcmFkaW8tZ3JvdXAuYW50LXJhZGlvLWdyb3VwLXJ0bHtkaXJlY3Rpb246cnRsfS5hbnQtcmFkaW8td3JhcHBlci5hbnQtcmFkaW8td3JhcHBlci1ydGx7bWFyZ2luLXJpZ2h0OjA7bWFyZ2luLWxlZnQ6OHB4O2RpcmVjdGlvbjpydGx9LmFudC1yYWRpby1idXR0b24td3JhcHBlci5hbnQtcmFkaW8tYnV0dG9uLXdyYXBwZXItcnRse2JvcmRlci1yaWdodC13aWR0aDowO2JvcmRlci1sZWZ0LXdpZHRoOjFweH0uYW50LXJhZGlvLWJ1dHRvbi13cmFwcGVyLmFudC1yYWRpby1idXR0b24td3JhcHBlci1ydGwuYW50LXJhZGlvLWJ1dHRvbi13cmFwcGVyOm5vdCg6Zmlyc3QtY2hpbGQpOmJlZm9yZXtyaWdodDotMXB4O2xlZnQ6MH0uYW50LXJhZGlvLWJ1dHRvbi13cmFwcGVyLmFudC1yYWRpby1idXR0b24td3JhcHBlci1ydGwuYW50LXJhZGlvLWJ1dHRvbi13cmFwcGVyOmZpcnN0LWNoaWxke2JvcmRlci1yaWdodDoxcHggc29saWQgI2Q5ZDlkOTtib3JkZXItcmFkaXVzOjAgMnB4IDJweCAwfS5hbnQtcmFkaW8tYnV0dG9uLXdyYXBwZXItY2hlY2tlZDpub3QoW2NsYXNzKj1cIiBhbnQtcmFkaW8tYnV0dG9uLXdyYXBwZXItZGlzYWJsZWRcIl0pLmFudC1yYWRpby1idXR0b24td3JhcHBlcjpmaXJzdC1jaGlsZHtib3JkZXItcmlnaHQtY29sb3I6IzQwYTlmZn0uYW50LXJhZGlvLWJ1dHRvbi13cmFwcGVyLmFudC1yYWRpby1idXR0b24td3JhcHBlci1ydGwuYW50LXJhZGlvLWJ1dHRvbi13cmFwcGVyOmxhc3QtY2hpbGR7Ym9yZGVyLXJhZGl1czoycHggMCAwIDJweH0uYW50LXJhZGlvLWJ1dHRvbi13cmFwcGVyLmFudC1yYWRpby1idXR0b24td3JhcHBlci1ydGwuYW50LXJhZGlvLWJ1dHRvbi13cmFwcGVyLWRpc2FibGVkOmZpcnN0LWNoaWxke2JvcmRlci1yaWdodC1jb2xvcjojZDlkOWQ5fS5hbnQtcmF0ZXtib3gtc2l6aW5nOmJvcmRlci1ib3g7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtc2l6ZToxNHB4O2ZvbnQtdmFyaWFudDp0YWJ1bGFyLW51bXM7bGluZS1oZWlnaHQ6MS41NzE1O2ZvbnQtZmVhdHVyZS1zZXR0aW5nczpcInRudW1cIjtkaXNwbGF5OmlubGluZS1ibG9jazttYXJnaW46MDtwYWRkaW5nOjA7Y29sb3I6I2ZhZGIxNDtmb250LXNpemU6MjBweDtsaW5lLWhlaWdodDp1bnNldDtsaXN0LXN0eWxlOm5vbmU7b3V0bGluZTpub25lfS5hbnQtcmF0ZS1kaXNhYmxlZCAuYW50LXJhdGUtc3RhcntjdXJzb3I6ZGVmYXVsdH0uYW50LXJhdGUtZGlzYWJsZWQgLmFudC1yYXRlLXN0YXI+ZGl2OmhvdmVye3RyYW5zZm9ybTpzY2FsZSgxKX0uYW50LXJhdGUtc3Rhcntwb3NpdGlvbjpyZWxhdGl2ZTtkaXNwbGF5OmlubGluZS1ibG9jaztjb2xvcjppbmhlcml0O2N1cnNvcjpwb2ludGVyfS5hbnQtcmF0ZS1zdGFyOm5vdCg6bGFzdC1jaGlsZCl7bWFyZ2luLXJpZ2h0OjhweH0uYW50LXJhdGUtc3Rhcj5kaXZ7dHJhbnNpdGlvbjphbGwgLjNzLG91dGxpbmUgMHN9LmFudC1yYXRlLXN0YXI+ZGl2OmhvdmVye3RyYW5zZm9ybTpzY2FsZSgxLjEpfS5hbnQtcmF0ZS1zdGFyPmRpdjpmb2N1c3tvdXRsaW5lOjB9LmFudC1yYXRlLXN0YXI+ZGl2OmZvY3VzLXZpc2libGV7b3V0bGluZToxcHggZGFzaGVkICNmYWRiMTQ7dHJhbnNmb3JtOnNjYWxlKDEuMSl9LmFudC1yYXRlLXN0YXItZmlyc3QsLmFudC1yYXRlLXN0YXItc2Vjb25ke2NvbG9yOiNmMGYwZjA7dHJhbnNpdGlvbjphbGwgLjNzOy13ZWJraXQtdXNlci1zZWxlY3Q6bm9uZTstbW96LXVzZXItc2VsZWN0Om5vbmU7LW1zLXVzZXItc2VsZWN0Om5vbmU7dXNlci1zZWxlY3Q6bm9uZX0uYW50LXJhdGUtc3Rhci1maXJzdCAuYW50aWNvbiwuYW50LXJhdGUtc3Rhci1zZWNvbmQgLmFudGljb257dmVydGljYWwtYWxpZ246bWlkZGxlfS5hbnQtcmF0ZS1zdGFyLWZpcnN0e3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO2xlZnQ6MDt3aWR0aDo1MCU7aGVpZ2h0OjEwMCU7b3ZlcmZsb3c6aGlkZGVuO29wYWNpdHk6MH0uYW50LXJhdGUtc3Rhci1oYWxmIC5hbnQtcmF0ZS1zdGFyLWZpcnN0LC5hbnQtcmF0ZS1zdGFyLWhhbGYgLmFudC1yYXRlLXN0YXItc2Vjb25ke29wYWNpdHk6MX0uYW50LXJhdGUtc3Rhci1mdWxsIC5hbnQtcmF0ZS1zdGFyLXNlY29uZCwuYW50LXJhdGUtc3Rhci1oYWxmIC5hbnQtcmF0ZS1zdGFyLWZpcnN0e2NvbG9yOmluaGVyaXR9LmFudC1yYXRlLXRleHR7ZGlzcGxheTppbmxpbmUtYmxvY2s7bWFyZ2luOjAgOHB4O2ZvbnQtc2l6ZToxNHB4fS5hbnQtcmF0ZS1ydGx7ZGlyZWN0aW9uOnJ0bH0uYW50LXJhdGUtcnRsIC5hbnQtcmF0ZS1zdGFyOm5vdCg6bGFzdC1jaGlsZCl7bWFyZ2luLXJpZ2h0OjA7bWFyZ2luLWxlZnQ6OHB4fS5hbnQtcmF0ZS1ydGwgLmFudC1yYXRlLXN0YXItZmlyc3R7cmlnaHQ6MDtsZWZ0OmF1dG99LmFudC1yZXN1bHR7cGFkZGluZzo0OHB4IDMycHh9LmFudC1yZXN1bHQtc3VjY2VzcyAuYW50LXJlc3VsdC1pY29uPi5hbnRpY29ue2NvbG9yOiM1MmM0MWF9LmFudC1yZXN1bHQtZXJyb3IgLmFudC1yZXN1bHQtaWNvbj4uYW50aWNvbntjb2xvcjojZmY0ZDRmfS5hbnQtcmVzdWx0LWluZm8gLmFudC1yZXN1bHQtaWNvbj4uYW50aWNvbntjb2xvcjojMTg5MGZmfS5hbnQtcmVzdWx0LXdhcm5pbmcgLmFudC1yZXN1bHQtaWNvbj4uYW50aWNvbntjb2xvcjojZmFhZDE0fS5hbnQtcmVzdWx0LWltYWdle3dpZHRoOjI1MHB4O2hlaWdodDoyOTVweDttYXJnaW46YXV0b30uYW50LXJlc3VsdC1pY29ue21hcmdpbi1ib3R0b206MjRweDt0ZXh0LWFsaWduOmNlbnRlcn0uYW50LXJlc3VsdC1pY29uPi5hbnRpY29ue2ZvbnQtc2l6ZTo3MnB4fS5hbnQtcmVzdWx0LXRpdGxle2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtmb250LXNpemU6MjRweDtsaW5lLWhlaWdodDoxLjg7dGV4dC1hbGlnbjpjZW50ZXJ9LmFudC1yZXN1bHQtc3VidGl0bGV7Y29sb3I6cmdiYSgwLDAsMCwuNDUpO2ZvbnQtc2l6ZToxNHB4O2xpbmUtaGVpZ2h0OjEuNjt0ZXh0LWFsaWduOmNlbnRlcn0uYW50LXJlc3VsdC1leHRyYXttYXJnaW46MjRweCAwIDA7dGV4dC1hbGlnbjpjZW50ZXJ9LmFudC1yZXN1bHQtZXh0cmE+KnttYXJnaW4tcmlnaHQ6OHB4fS5hbnQtcmVzdWx0LWV4dHJhPjpsYXN0LWNoaWxke21hcmdpbi1yaWdodDowfS5hbnQtcmVzdWx0LWNvbnRlbnR7bWFyZ2luLXRvcDoyNHB4O3BhZGRpbmc6MjRweCA0MHB4O2JhY2tncm91bmQtY29sb3I6I2ZhZmFmYX0uYW50LXJlc3VsdC1ydGx7ZGlyZWN0aW9uOnJ0bH0uYW50LXJlc3VsdC1ydGwgLmFudC1yZXN1bHQtZXh0cmE+KnttYXJnaW4tcmlnaHQ6MDttYXJnaW4tbGVmdDo4cHh9LmFudC1yZXN1bHQtcnRsIC5hbnQtcmVzdWx0LWV4dHJhPjpsYXN0LWNoaWxke21hcmdpbi1sZWZ0OjB9LnNlZ21lbnRlZC1kaXNhYmxlZC1pdGVtLC5zZWdtZW50ZWQtZGlzYWJsZWQtaXRlbTpmb2N1cywuc2VnbWVudGVkLWRpc2FibGVkLWl0ZW06aG92ZXJ7Y29sb3I6cmdiYSgwLDAsMCwuMjUpO2N1cnNvcjpub3QtYWxsb3dlZH0uc2VnbWVudGVkLWl0ZW0tc2VsZWN0ZWR7YmFja2dyb3VuZC1jb2xvcjojZmZmO2JvcmRlci1yYWRpdXM6MnB4O2JveC1zaGFkb3c6MCAycHggOHB4IC0ycHggcmdiYSgwLDAsMCwuMDUpLDAgMXB4IDRweCAtMXB4IHJnYmEoMCwwLDAsLjA3KSwwIDAgMXB4IDAgcmdiYSgwLDAsMCwuMDgpfS5zZWdtZW50ZWQtdGV4dC1lbGxpcHNpc3tvdmVyZmxvdzpoaWRkZW47d2hpdGUtc3BhY2U6bm93cmFwO3RleHQtb3ZlcmZsb3c6ZWxsaXBzaXM7d29yZC1icmVhazprZWVwLWFsbH0uYW50LXNlZ21lbnRlZHtib3gtc2l6aW5nOmJvcmRlci1ib3g7bWFyZ2luOjA7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtc2l6ZToxNHB4O2ZvbnQtdmFyaWFudDp0YWJ1bGFyLW51bXM7bGluZS1oZWlnaHQ6MS41NzE1O2xpc3Qtc3R5bGU6bm9uZTtmb250LWZlYXR1cmUtc2V0dGluZ3M6XCJ0bnVtXCI7ZGlzcGxheTppbmxpbmUtYmxvY2s7cGFkZGluZzoycHg7Y29sb3I6cmdiYSgwLDAsMCwuNjUpO2JhY2tncm91bmQtY29sb3I6cmdiYSgwLDAsMCwuMDQpO2JvcmRlci1yYWRpdXM6MnB4O3RyYW5zaXRpb246YWxsIC4zcyBjdWJpYy1iZXppZXIoLjY0NSwuMDQ1LC4zNTUsMSl9LmFudC1zZWdtZW50ZWQtZ3JvdXB7cG9zaXRpb246cmVsYXRpdmU7ZGlzcGxheTpmbGV4O2FsaWduLWl0ZW1zOnN0cmV0Y2g7anVzdGlmeS1pdGVtczpmbGV4LXN0YXJ0O3dpZHRoOjEwMCV9LmFudC1zZWdtZW50ZWQuYW50LXNlZ21lbnRlZC1ibG9ja3tkaXNwbGF5OmZsZXh9LmFudC1zZWdtZW50ZWQuYW50LXNlZ21lbnRlZC1ibG9jayAuYW50LXNlZ21lbnRlZC1pdGVte2ZsZXg6MTttaW4td2lkdGg6MH0uYW50LXNlZ21lbnRlZDpub3QoLmFudC1zZWdtZW50ZWQtZGlzYWJsZWQpOmZvY3VzLC5hbnQtc2VnbWVudGVkOm5vdCguYW50LXNlZ21lbnRlZC1kaXNhYmxlZCk6aG92ZXJ7YmFja2dyb3VuZC1jb2xvcjpyZ2JhKDAsMCwwLC4wNil9LmFudC1zZWdtZW50ZWQtaXRlbXtwb3NpdGlvbjpyZWxhdGl2ZTt0ZXh0LWFsaWduOmNlbnRlcjtjdXJzb3I6cG9pbnRlcjt0cmFuc2l0aW9uOmNvbG9yIC4zcyBjdWJpYy1iZXppZXIoLjY0NSwuMDQ1LC4zNTUsMSl9LmFudC1zZWdtZW50ZWQtaXRlbS1zZWxlY3RlZHtiYWNrZ3JvdW5kLWNvbG9yOiNmZmY7Ym9yZGVyLXJhZGl1czoycHg7Ym94LXNoYWRvdzowIDJweCA4cHggLTJweCByZ2JhKDAsMCwwLC4wNSksMCAxcHggNHB4IC0xcHggcmdiYSgwLDAsMCwuMDcpLDAgMCAxcHggMCByZ2JhKDAsMCwwLC4wOCk7Y29sb3I6IzI2MjYyNn0uYW50LXNlZ21lbnRlZC1pdGVtOmZvY3VzLC5hbnQtc2VnbWVudGVkLWl0ZW06aG92ZXJ7Y29sb3I6IzI2MjYyNn0uYW50LXNlZ21lbnRlZC1pdGVtLWxhYmVse21pbi1oZWlnaHQ6MjhweDtwYWRkaW5nOjAgMTFweDtsaW5lLWhlaWdodDoyOHB4O292ZXJmbG93OmhpZGRlbjt3aGl0ZS1zcGFjZTpub3dyYXA7dGV4dC1vdmVyZmxvdzplbGxpcHNpczt3b3JkLWJyZWFrOmtlZXAtYWxsfS5hbnQtc2VnbWVudGVkLWl0ZW0taWNvbisqe21hcmdpbi1sZWZ0OjZweH0uYW50LXNlZ21lbnRlZC1pdGVtLWlucHV0e3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO2xlZnQ6MDt3aWR0aDowO2hlaWdodDowO29wYWNpdHk6MDtwb2ludGVyLWV2ZW50czpub25lfS5hbnQtc2VnbWVudGVkLmFudC1zZWdtZW50ZWQtbGcgLmFudC1zZWdtZW50ZWQtaXRlbS1sYWJlbHttaW4taGVpZ2h0OjM2cHg7cGFkZGluZzowIDExcHg7Zm9udC1zaXplOjE2cHg7bGluZS1oZWlnaHQ6MzZweH0uYW50LXNlZ21lbnRlZC5hbnQtc2VnbWVudGVkLXNtIC5hbnQtc2VnbWVudGVkLWl0ZW0tbGFiZWx7bWluLWhlaWdodDoyMHB4O3BhZGRpbmc6MCA3cHg7bGluZS1oZWlnaHQ6MjBweH0uYW50LXNlZ21lbnRlZC1pdGVtLWRpc2FibGVkLC5hbnQtc2VnbWVudGVkLWl0ZW0tZGlzYWJsZWQ6Zm9jdXMsLmFudC1zZWdtZW50ZWQtaXRlbS1kaXNhYmxlZDpob3Zlcntjb2xvcjpyZ2JhKDAsMCwwLC4yNSk7Y3Vyc29yOm5vdC1hbGxvd2VkfS5hbnQtc2VnbWVudGVkLXRodW1ie2JhY2tncm91bmQtY29sb3I6I2ZmZjtib3JkZXItcmFkaXVzOjJweDtib3gtc2hhZG93OjAgMnB4IDhweCAtMnB4IHJnYmEoMCwwLDAsLjA1KSwwIDFweCA0cHggLTFweCByZ2JhKDAsMCwwLC4wNyksMCAwIDFweCAwIHJnYmEoMCwwLDAsLjA4KTtwb3NpdGlvbjphYnNvbHV0ZTt0b3A6MDtsZWZ0OjA7d2lkdGg6MDtoZWlnaHQ6MTAwJTtwYWRkaW5nOjRweCAwfS5hbnQtc2VnbWVudGVkLXRodW1iLW1vdGlvbi1hcHBlYXItYWN0aXZle3RyYW5zaXRpb246dHJhbnNmb3JtIC4zcyBjdWJpYy1iZXppZXIoLjY0NSwuMDQ1LC4zNTUsMSksd2lkdGggLjNzIGN1YmljLWJlemllciguNjQ1LC4wNDUsLjM1NSwxKTt3aWxsLWNoYW5nZTp0cmFuc2Zvcm0sd2lkdGh9LmFudC1zZWdtZW50ZWQuYW50LXNlZ21lbnRlZC1ydGx7ZGlyZWN0aW9uOnJ0bH0uYW50LXNlZ21lbnRlZC5hbnQtc2VnbWVudGVkLXJ0bCAuYW50LXNlZ21lbnRlZC1pdGVtLWljb257bWFyZ2luLXJpZ2h0OjA7bWFyZ2luLWxlZnQ6NnB4fS5hbnQtc2VsZWN0LXNpbmdsZSAuYW50LXNlbGVjdC1zZWxlY3RvcntkaXNwbGF5OmZsZXh9LmFudC1zZWxlY3Qtc2luZ2xlIC5hbnQtc2VsZWN0LXNlbGVjdG9yIC5hbnQtc2VsZWN0LXNlbGVjdGlvbi1zZWFyY2h7cG9zaXRpb246YWJzb2x1dGU7dG9wOjA7cmlnaHQ6MTFweDtib3R0b206MDtsZWZ0OjExcHh9LmFudC1zZWxlY3Qtc2luZ2xlIC5hbnQtc2VsZWN0LXNlbGVjdG9yIC5hbnQtc2VsZWN0LXNlbGVjdGlvbi1zZWFyY2gtaW5wdXR7d2lkdGg6MTAwJX0uYW50LXNlbGVjdC1zaW5nbGUgLmFudC1zZWxlY3Qtc2VsZWN0b3IgLmFudC1zZWxlY3Qtc2VsZWN0aW9uLWl0ZW0sLmFudC1zZWxlY3Qtc2luZ2xlIC5hbnQtc2VsZWN0LXNlbGVjdG9yIC5hbnQtc2VsZWN0LXNlbGVjdGlvbi1wbGFjZWhvbGRlcntwYWRkaW5nOjA7bGluZS1oZWlnaHQ6MzBweDt0cmFuc2l0aW9uOmFsbCAuM3MsdmlzaWJpbGl0eSAwc30uYW50LXNlbGVjdC1zaW5nbGUgLmFudC1zZWxlY3Qtc2VsZWN0b3IgLmFudC1zZWxlY3Qtc2VsZWN0aW9uLWl0ZW17cG9zaXRpb246cmVsYXRpdmU7LXdlYmtpdC11c2VyLXNlbGVjdDpub25lOy1tb3otdXNlci1zZWxlY3Q6bm9uZTstbXMtdXNlci1zZWxlY3Q6bm9uZTt1c2VyLXNlbGVjdDpub25lfS5hbnQtc2VsZWN0LXNpbmdsZSAuYW50LXNlbGVjdC1zZWxlY3RvciAuYW50LXNlbGVjdC1zZWxlY3Rpb24tcGxhY2Vob2xkZXJ7dHJhbnNpdGlvbjpub25lO3BvaW50ZXItZXZlbnRzOm5vbmV9LmFudC1zZWxlY3Qtc2luZ2xlIC5hbnQtc2VsZWN0LXNlbGVjdG9yIC5hbnQtc2VsZWN0LXNlbGVjdGlvbi1pdGVtOmFmdGVyLC5hbnQtc2VsZWN0LXNpbmdsZSAuYW50LXNlbGVjdC1zZWxlY3RvciAuYW50LXNlbGVjdC1zZWxlY3Rpb24tcGxhY2Vob2xkZXI6YWZ0ZXIsLmFudC1zZWxlY3Qtc2luZ2xlIC5hbnQtc2VsZWN0LXNlbGVjdG9yOmFmdGVye2Rpc3BsYXk6aW5saW5lLWJsb2NrO3dpZHRoOjA7dmlzaWJpbGl0eTpoaWRkZW47Y29udGVudDpcIlxcYTBcIn0uYW50LXNlbGVjdC1zaW5nbGUuYW50LXNlbGVjdC1zaG93LWFycm93IC5hbnQtc2VsZWN0LXNlbGVjdGlvbi1zZWFyY2h7cmlnaHQ6MjVweH0uYW50LXNlbGVjdC1zaW5nbGUuYW50LXNlbGVjdC1zaG93LWFycm93IC5hbnQtc2VsZWN0LXNlbGVjdGlvbi1pdGVtLC5hbnQtc2VsZWN0LXNpbmdsZS5hbnQtc2VsZWN0LXNob3ctYXJyb3cgLmFudC1zZWxlY3Qtc2VsZWN0aW9uLXBsYWNlaG9sZGVye3BhZGRpbmctcmlnaHQ6MThweH0uYW50LXNlbGVjdC1zaW5nbGUuYW50LXNlbGVjdC1vcGVuIC5hbnQtc2VsZWN0LXNlbGVjdGlvbi1pdGVte2NvbG9yOiNiZmJmYmZ9LmFudC1zZWxlY3Qtc2luZ2xlOm5vdCguYW50LXNlbGVjdC1jdXN0b21pemUtaW5wdXQpIC5hbnQtc2VsZWN0LXNlbGVjdG9ye3dpZHRoOjEwMCU7aGVpZ2h0OjMycHg7cGFkZGluZzowIDExcHh9LmFudC1zZWxlY3Qtc2luZ2xlOm5vdCguYW50LXNlbGVjdC1jdXN0b21pemUtaW5wdXQpIC5hbnQtc2VsZWN0LXNlbGVjdG9yIC5hbnQtc2VsZWN0LXNlbGVjdGlvbi1zZWFyY2gtaW5wdXR7aGVpZ2h0OjMwcHh9LmFudC1zZWxlY3Qtc2luZ2xlOm5vdCguYW50LXNlbGVjdC1jdXN0b21pemUtaW5wdXQpIC5hbnQtc2VsZWN0LXNlbGVjdG9yOmFmdGVye2xpbmUtaGVpZ2h0OjMwcHh9LmFudC1zZWxlY3Qtc2luZ2xlLmFudC1zZWxlY3QtY3VzdG9taXplLWlucHV0IC5hbnQtc2VsZWN0LXNlbGVjdG9yOmFmdGVye2Rpc3BsYXk6bm9uZX0uYW50LXNlbGVjdC1zaW5nbGUuYW50LXNlbGVjdC1jdXN0b21pemUtaW5wdXQgLmFudC1zZWxlY3Qtc2VsZWN0b3IgLmFudC1zZWxlY3Qtc2VsZWN0aW9uLXNlYXJjaHtwb3NpdGlvbjpzdGF0aWM7d2lkdGg6MTAwJX0uYW50LXNlbGVjdC1zaW5nbGUuYW50LXNlbGVjdC1jdXN0b21pemUtaW5wdXQgLmFudC1zZWxlY3Qtc2VsZWN0b3IgLmFudC1zZWxlY3Qtc2VsZWN0aW9uLXBsYWNlaG9sZGVye3Bvc2l0aW9uOmFic29sdXRlO3JpZ2h0OjA7bGVmdDowO3BhZGRpbmc6MCAxMXB4fS5hbnQtc2VsZWN0LXNpbmdsZS5hbnQtc2VsZWN0LWN1c3RvbWl6ZS1pbnB1dCAuYW50LXNlbGVjdC1zZWxlY3RvciAuYW50LXNlbGVjdC1zZWxlY3Rpb24tcGxhY2Vob2xkZXI6YWZ0ZXJ7ZGlzcGxheTpub25lfS5hbnQtc2VsZWN0LXNpbmdsZS5hbnQtc2VsZWN0LWxnOm5vdCguYW50LXNlbGVjdC1jdXN0b21pemUtaW5wdXQpIC5hbnQtc2VsZWN0LXNlbGVjdG9ye2hlaWdodDo0MHB4fS5hbnQtc2VsZWN0LXNpbmdsZS5hbnQtc2VsZWN0LWxnOm5vdCguYW50LXNlbGVjdC1jdXN0b21pemUtaW5wdXQpIC5hbnQtc2VsZWN0LXNlbGVjdG9yIC5hbnQtc2VsZWN0LXNlbGVjdGlvbi1pdGVtLC5hbnQtc2VsZWN0LXNpbmdsZS5hbnQtc2VsZWN0LWxnOm5vdCguYW50LXNlbGVjdC1jdXN0b21pemUtaW5wdXQpIC5hbnQtc2VsZWN0LXNlbGVjdG9yIC5hbnQtc2VsZWN0LXNlbGVjdGlvbi1wbGFjZWhvbGRlciwuYW50LXNlbGVjdC1zaW5nbGUuYW50LXNlbGVjdC1sZzpub3QoLmFudC1zZWxlY3QtY3VzdG9taXplLWlucHV0KSAuYW50LXNlbGVjdC1zZWxlY3RvcjphZnRlcntsaW5lLWhlaWdodDozOHB4fS5hbnQtc2VsZWN0LXNpbmdsZS5hbnQtc2VsZWN0LWxnOm5vdCguYW50LXNlbGVjdC1jdXN0b21pemUtaW5wdXQpOm5vdCguYW50LXNlbGVjdC1jdXN0b21pemUtaW5wdXQpIC5hbnQtc2VsZWN0LXNlbGVjdGlvbi1zZWFyY2gtaW5wdXR7aGVpZ2h0OjM4cHh9LmFudC1zZWxlY3Qtc2luZ2xlLmFudC1zZWxlY3Qtc206bm90KC5hbnQtc2VsZWN0LWN1c3RvbWl6ZS1pbnB1dCkgLmFudC1zZWxlY3Qtc2VsZWN0b3J7aGVpZ2h0OjI0cHh9LmFudC1zZWxlY3Qtc2luZ2xlLmFudC1zZWxlY3Qtc206bm90KC5hbnQtc2VsZWN0LWN1c3RvbWl6ZS1pbnB1dCkgLmFudC1zZWxlY3Qtc2VsZWN0b3IgLmFudC1zZWxlY3Qtc2VsZWN0aW9uLWl0ZW0sLmFudC1zZWxlY3Qtc2luZ2xlLmFudC1zZWxlY3Qtc206bm90KC5hbnQtc2VsZWN0LWN1c3RvbWl6ZS1pbnB1dCkgLmFudC1zZWxlY3Qtc2VsZWN0b3IgLmFudC1zZWxlY3Qtc2VsZWN0aW9uLXBsYWNlaG9sZGVyLC5hbnQtc2VsZWN0LXNpbmdsZS5hbnQtc2VsZWN0LXNtOm5vdCguYW50LXNlbGVjdC1jdXN0b21pemUtaW5wdXQpIC5hbnQtc2VsZWN0LXNlbGVjdG9yOmFmdGVye2xpbmUtaGVpZ2h0OjIycHh9LmFudC1zZWxlY3Qtc2luZ2xlLmFudC1zZWxlY3Qtc206bm90KC5hbnQtc2VsZWN0LWN1c3RvbWl6ZS1pbnB1dCk6bm90KC5hbnQtc2VsZWN0LWN1c3RvbWl6ZS1pbnB1dCkgLmFudC1zZWxlY3Qtc2VsZWN0aW9uLXNlYXJjaC1pbnB1dHtoZWlnaHQ6MjJweH0uYW50LXNlbGVjdC1zaW5nbGUuYW50LXNlbGVjdC1zbTpub3QoLmFudC1zZWxlY3QtY3VzdG9taXplLWlucHV0KSAuYW50LXNlbGVjdC1zZWxlY3Rpb24tc2VhcmNoe3JpZ2h0OjdweDtsZWZ0OjdweH0uYW50LXNlbGVjdC1zaW5nbGUuYW50LXNlbGVjdC1zbTpub3QoLmFudC1zZWxlY3QtY3VzdG9taXplLWlucHV0KSAuYW50LXNlbGVjdC1zZWxlY3RvcntwYWRkaW5nOjAgN3B4fS5hbnQtc2VsZWN0LXNpbmdsZS5hbnQtc2VsZWN0LXNtOm5vdCguYW50LXNlbGVjdC1jdXN0b21pemUtaW5wdXQpLmFudC1zZWxlY3Qtc2hvdy1hcnJvdyAuYW50LXNlbGVjdC1zZWxlY3Rpb24tc2VhcmNoe3JpZ2h0OjI4cHh9LmFudC1zZWxlY3Qtc2luZ2xlLmFudC1zZWxlY3Qtc206bm90KC5hbnQtc2VsZWN0LWN1c3RvbWl6ZS1pbnB1dCkuYW50LXNlbGVjdC1zaG93LWFycm93IC5hbnQtc2VsZWN0LXNlbGVjdGlvbi1pdGVtLC5hbnQtc2VsZWN0LXNpbmdsZS5hbnQtc2VsZWN0LXNtOm5vdCguYW50LXNlbGVjdC1jdXN0b21pemUtaW5wdXQpLmFudC1zZWxlY3Qtc2hvdy1hcnJvdyAuYW50LXNlbGVjdC1zZWxlY3Rpb24tcGxhY2Vob2xkZXJ7cGFkZGluZy1yaWdodDoyMXB4fS5hbnQtc2VsZWN0LXNpbmdsZS5hbnQtc2VsZWN0LWxnOm5vdCguYW50LXNlbGVjdC1jdXN0b21pemUtaW5wdXQpIC5hbnQtc2VsZWN0LXNlbGVjdG9ye3BhZGRpbmc6MCAxMXB4fS5hbnQtc2VsZWN0LXNlbGVjdGlvbi1vdmVyZmxvd3twb3NpdGlvbjpyZWxhdGl2ZTtkaXNwbGF5OmZsZXg7ZmxleDphdXRvO2ZsZXgtd3JhcDp3cmFwO21heC13aWR0aDoxMDAlfS5hbnQtc2VsZWN0LXNlbGVjdGlvbi1vdmVyZmxvdy1pdGVte2ZsZXg6bm9uZTthbGlnbi1zZWxmOmNlbnRlcjttYXgtd2lkdGg6MTAwJX0uYW50LXNlbGVjdC1tdWx0aXBsZSAuYW50LXNlbGVjdC1zZWxlY3RvcntkaXNwbGF5OmZsZXg7ZmxleC13cmFwOndyYXA7YWxpZ24taXRlbXM6Y2VudGVyO3BhZGRpbmc6MXB4IDRweH0uYW50LXNlbGVjdC1zaG93LXNlYXJjaC5hbnQtc2VsZWN0LW11bHRpcGxlIC5hbnQtc2VsZWN0LXNlbGVjdG9ye2N1cnNvcjp0ZXh0fS5hbnQtc2VsZWN0LWRpc2FibGVkLmFudC1zZWxlY3QtbXVsdGlwbGUgLmFudC1zZWxlY3Qtc2VsZWN0b3J7YmFja2dyb3VuZDojZjVmNWY1O2N1cnNvcjpub3QtYWxsb3dlZH0uYW50LXNlbGVjdC1tdWx0aXBsZSAuYW50LXNlbGVjdC1zZWxlY3RvcjphZnRlcntkaXNwbGF5OmlubGluZS1ibG9jazt3aWR0aDowO21hcmdpbjoycHggMDtsaW5lLWhlaWdodDoyNHB4O2NvbnRlbnQ6XCJcXGEwXCJ9LmFudC1zZWxlY3QtbXVsdGlwbGUuYW50LXNlbGVjdC1hbGxvdy1jbGVhciAuYW50LXNlbGVjdC1zZWxlY3RvciwuYW50LXNlbGVjdC1tdWx0aXBsZS5hbnQtc2VsZWN0LXNob3ctYXJyb3cgLmFudC1zZWxlY3Qtc2VsZWN0b3J7cGFkZGluZy1yaWdodDoyNHB4fS5hbnQtc2VsZWN0LW11bHRpcGxlIC5hbnQtc2VsZWN0LXNlbGVjdGlvbi1pdGVte3Bvc2l0aW9uOnJlbGF0aXZlO2Rpc3BsYXk6ZmxleDtmbGV4Om5vbmU7Ym94LXNpemluZzpib3JkZXItYm94O21heC13aWR0aDoxMDAlO2hlaWdodDoyNHB4O21hcmdpbi10b3A6MnB4O21hcmdpbi1ib3R0b206MnB4O2xpbmUtaGVpZ2h0OjIycHg7YmFja2dyb3VuZDojZjVmNWY1O2JvcmRlcjoxcHggc29saWQgI2YwZjBmMDtib3JkZXItcmFkaXVzOjJweDtjdXJzb3I6ZGVmYXVsdDt0cmFuc2l0aW9uOmZvbnQtc2l6ZSAuM3MsbGluZS1oZWlnaHQgLjNzLGhlaWdodCAuM3M7LXdlYmtpdC11c2VyLXNlbGVjdDpub25lOy1tb3otdXNlci1zZWxlY3Q6bm9uZTstbXMtdXNlci1zZWxlY3Q6bm9uZTt1c2VyLXNlbGVjdDpub25lOy13ZWJraXQtbWFyZ2luLWVuZDo0cHg7bWFyZ2luLWlubGluZS1lbmQ6NHB4Oy13ZWJraXQtcGFkZGluZy1zdGFydDo4cHg7cGFkZGluZy1pbmxpbmUtc3RhcnQ6OHB4Oy13ZWJraXQtcGFkZGluZy1lbmQ6NHB4O3BhZGRpbmctaW5saW5lLWVuZDo0cHh9LmFudC1zZWxlY3QtZGlzYWJsZWQuYW50LXNlbGVjdC1tdWx0aXBsZSAuYW50LXNlbGVjdC1zZWxlY3Rpb24taXRlbXtjb2xvcjojYmZiZmJmO2JvcmRlci1jb2xvcjojZDlkOWQ5O2N1cnNvcjpub3QtYWxsb3dlZH0uYW50LXNlbGVjdC1tdWx0aXBsZSAuYW50LXNlbGVjdC1zZWxlY3Rpb24taXRlbS1jb250ZW50e2Rpc3BsYXk6aW5saW5lLWJsb2NrO21hcmdpbi1yaWdodDo0cHg7b3ZlcmZsb3c6aGlkZGVuO3doaXRlLXNwYWNlOnByZTt0ZXh0LW92ZXJmbG93OmVsbGlwc2lzfS5hbnQtc2VsZWN0LW11bHRpcGxlIC5hbnQtc2VsZWN0LXNlbGVjdGlvbi1pdGVtLXJlbW92ZXtjb2xvcjppbmhlcml0O2ZvbnQtc3R5bGU6bm9ybWFsO2xpbmUtaGVpZ2h0OjA7dGV4dC1hbGlnbjpjZW50ZXI7dGV4dC10cmFuc2Zvcm06bm9uZTt2ZXJ0aWNhbC1hbGlnbjotLjEyNWVtO3RleHQtcmVuZGVyaW5nOm9wdGltaXplbGVnaWJpbGl0eTstd2Via2l0LWZvbnQtc21vb3RoaW5nOmFudGlhbGlhc2VkOy1tb3otb3N4LWZvbnQtc21vb3RoaW5nOmdyYXlzY2FsZTtkaXNwbGF5OmlubGluZS1ibG9jaztjb2xvcjpyZ2JhKDAsMCwwLC40NSk7Zm9udC13ZWlnaHQ6NzAwO2ZvbnQtc2l6ZToxMHB4O2xpbmUtaGVpZ2h0OmluaGVyaXQ7Y3Vyc29yOnBvaW50ZXJ9LmFudC1zZWxlY3QtbXVsdGlwbGUgLmFudC1zZWxlY3Qtc2VsZWN0aW9uLWl0ZW0tcmVtb3ZlPip7bGluZS1oZWlnaHQ6MX0uYW50LXNlbGVjdC1tdWx0aXBsZSAuYW50LXNlbGVjdC1zZWxlY3Rpb24taXRlbS1yZW1vdmUgc3Zne2Rpc3BsYXk6aW5saW5lLWJsb2NrfS5hbnQtc2VsZWN0LW11bHRpcGxlIC5hbnQtc2VsZWN0LXNlbGVjdGlvbi1pdGVtLXJlbW92ZTpiZWZvcmV7ZGlzcGxheTpub25lfS5hbnQtc2VsZWN0LW11bHRpcGxlIC5hbnQtc2VsZWN0LXNlbGVjdGlvbi1pdGVtLXJlbW92ZSAuYW50LXNlbGVjdC1tdWx0aXBsZSAuYW50LXNlbGVjdC1zZWxlY3Rpb24taXRlbS1yZW1vdmUtaWNvbntkaXNwbGF5OmJsb2NrfS5hbnQtc2VsZWN0LW11bHRpcGxlIC5hbnQtc2VsZWN0LXNlbGVjdGlvbi1pdGVtLXJlbW92ZT4uYW50aWNvbnt2ZXJ0aWNhbC1hbGlnbjptaWRkbGV9LmFudC1zZWxlY3QtbXVsdGlwbGUgLmFudC1zZWxlY3Qtc2VsZWN0aW9uLWl0ZW0tcmVtb3ZlOmhvdmVye2NvbG9yOnJnYmEoMCwwLDAsLjc1KX0uYW50LXNlbGVjdC1tdWx0aXBsZSAuYW50LXNlbGVjdC1zZWxlY3Rpb24tb3ZlcmZsb3ctaXRlbSsuYW50LXNlbGVjdC1zZWxlY3Rpb24tb3ZlcmZsb3ctaXRlbSAuYW50LXNlbGVjdC1zZWxlY3Rpb24tc2VhcmNoey13ZWJraXQtbWFyZ2luLXN0YXJ0OjA7bWFyZ2luLWlubGluZS1zdGFydDowfS5hbnQtc2VsZWN0LW11bHRpcGxlIC5hbnQtc2VsZWN0LXNlbGVjdGlvbi1zZWFyY2h7cG9zaXRpb246cmVsYXRpdmU7bWF4LXdpZHRoOjEwMCU7LXdlYmtpdC1tYXJnaW4tc3RhcnQ6N3B4O21hcmdpbi1pbmxpbmUtc3RhcnQ6N3B4fS5hbnQtc2VsZWN0LW11bHRpcGxlIC5hbnQtc2VsZWN0LXNlbGVjdGlvbi1zZWFyY2gtaW5wdXQsLmFudC1zZWxlY3QtbXVsdGlwbGUgLmFudC1zZWxlY3Qtc2VsZWN0aW9uLXNlYXJjaC1taXJyb3J7aGVpZ2h0OjI0cHg7Zm9udC1mYW1pbHk6LWFwcGxlLXN5c3RlbSxCbGlua01hY1N5c3RlbUZvbnQsU2Vnb2UgVUksUm9ib3RvLEhlbHZldGljYSBOZXVlLEFyaWFsLE5vdG8gU2FucyxzYW5zLXNlcmlmLEFwcGxlIENvbG9yIEVtb2ppLFNlZ29lIFVJIEVtb2ppLFNlZ29lIFVJIFN5bWJvbCxOb3RvIENvbG9yIEVtb2ppO2xpbmUtaGVpZ2h0OjI0cHg7dHJhbnNpdGlvbjphbGwgLjNzfS5hbnQtc2VsZWN0LW11bHRpcGxlIC5hbnQtc2VsZWN0LXNlbGVjdGlvbi1zZWFyY2gtaW5wdXR7d2lkdGg6MTAwJTttaW4td2lkdGg6NC4xcHh9LmFudC1zZWxlY3QtbXVsdGlwbGUgLmFudC1zZWxlY3Qtc2VsZWN0aW9uLXNlYXJjaC1taXJyb3J7cG9zaXRpb246YWJzb2x1dGU7dG9wOjA7bGVmdDowO3otaW5kZXg6OTk5O3doaXRlLXNwYWNlOnByZTt2aXNpYmlsaXR5OmhpZGRlbn0uYW50LXNlbGVjdC1tdWx0aXBsZSAuYW50LXNlbGVjdC1zZWxlY3Rpb24tcGxhY2Vob2xkZXJ7cG9zaXRpb246YWJzb2x1dGU7dG9wOjUwJTtyaWdodDoxMXB4O2xlZnQ6MTFweDt0cmFuc2Zvcm06dHJhbnNsYXRlWSgtNTAlKTt0cmFuc2l0aW9uOmFsbCAuM3N9LmFudC1zZWxlY3QtbXVsdGlwbGUuYW50LXNlbGVjdC1sZyAuYW50LXNlbGVjdC1zZWxlY3RvcjphZnRlcntsaW5lLWhlaWdodDozMnB4fS5hbnQtc2VsZWN0LW11bHRpcGxlLmFudC1zZWxlY3QtbGcgLmFudC1zZWxlY3Qtc2VsZWN0aW9uLWl0ZW17bGluZS1oZWlnaHQ6MzBweH0uYW50LXNlbGVjdC1tdWx0aXBsZS5hbnQtc2VsZWN0LWxnIC5hbnQtc2VsZWN0LXNlbGVjdGlvbi1zZWFyY2h7aGVpZ2h0OjMycHg7bGluZS1oZWlnaHQ6MzJweH0uYW50LXNlbGVjdC1tdWx0aXBsZS5hbnQtc2VsZWN0LWxnIC5hbnQtc2VsZWN0LXNlbGVjdGlvbi1zZWFyY2gtaW5wdXQsLmFudC1zZWxlY3QtbXVsdGlwbGUuYW50LXNlbGVjdC1sZyAuYW50LXNlbGVjdC1zZWxlY3Rpb24tc2VhcmNoLW1pcnJvcntoZWlnaHQ6MzJweDtsaW5lLWhlaWdodDozMHB4fS5hbnQtc2VsZWN0LW11bHRpcGxlLmFudC1zZWxlY3Qtc20gLmFudC1zZWxlY3Qtc2VsZWN0b3I6YWZ0ZXJ7bGluZS1oZWlnaHQ6MTZweH0uYW50LXNlbGVjdC1tdWx0aXBsZS5hbnQtc2VsZWN0LXNtIC5hbnQtc2VsZWN0LXNlbGVjdGlvbi1pdGVte2hlaWdodDoxNnB4O2xpbmUtaGVpZ2h0OjE0cHh9LmFudC1zZWxlY3QtbXVsdGlwbGUuYW50LXNlbGVjdC1zbSAuYW50LXNlbGVjdC1zZWxlY3Rpb24tc2VhcmNoe2hlaWdodDoxNnB4O2xpbmUtaGVpZ2h0OjE2cHh9LmFudC1zZWxlY3QtbXVsdGlwbGUuYW50LXNlbGVjdC1zbSAuYW50LXNlbGVjdC1zZWxlY3Rpb24tc2VhcmNoLWlucHV0LC5hbnQtc2VsZWN0LW11bHRpcGxlLmFudC1zZWxlY3Qtc20gLmFudC1zZWxlY3Qtc2VsZWN0aW9uLXNlYXJjaC1taXJyb3J7aGVpZ2h0OjE2cHg7bGluZS1oZWlnaHQ6MTRweH0uYW50LXNlbGVjdC1tdWx0aXBsZS5hbnQtc2VsZWN0LXNtIC5hbnQtc2VsZWN0LXNlbGVjdGlvbi1wbGFjZWhvbGRlcntsZWZ0OjdweH0uYW50LXNlbGVjdC1tdWx0aXBsZS5hbnQtc2VsZWN0LXNtIC5hbnQtc2VsZWN0LXNlbGVjdGlvbi1zZWFyY2h7LXdlYmtpdC1tYXJnaW4tc3RhcnQ6M3B4O21hcmdpbi1pbmxpbmUtc3RhcnQ6M3B4fS5hbnQtc2VsZWN0LW11bHRpcGxlLmFudC1zZWxlY3QtbGcgLmFudC1zZWxlY3Qtc2VsZWN0aW9uLWl0ZW17aGVpZ2h0OjMycHg7bGluZS1oZWlnaHQ6MzJweH0uYW50LXNlbGVjdC1kaXNhYmxlZCAuYW50LXNlbGVjdC1zZWxlY3Rpb24taXRlbS1yZW1vdmV7ZGlzcGxheTpub25lfS5hbnQtc2VsZWN0LXN0YXR1cy1lcnJvci5hbnQtc2VsZWN0Om5vdCguYW50LXNlbGVjdC1kaXNhYmxlZCk6bm90KC5hbnQtc2VsZWN0LWN1c3RvbWl6ZS1pbnB1dCk6bm90KC5hbnQtcGFnaW5hdGlvbi1zaXplLWNoYW5nZXIpIC5hbnQtc2VsZWN0LXNlbGVjdG9ye2JhY2tncm91bmQtY29sb3I6I2ZmZjtib3JkZXItY29sb3I6I2ZmNGQ0ZiFpbXBvcnRhbnR9LmFudC1zZWxlY3Qtc3RhdHVzLWVycm9yLmFudC1zZWxlY3Q6bm90KC5hbnQtc2VsZWN0LWRpc2FibGVkKTpub3QoLmFudC1zZWxlY3QtY3VzdG9taXplLWlucHV0KTpub3QoLmFudC1wYWdpbmF0aW9uLXNpemUtY2hhbmdlcikuYW50LXNlbGVjdC1mb2N1c2VkIC5hbnQtc2VsZWN0LXNlbGVjdG9yLC5hbnQtc2VsZWN0LXN0YXR1cy1lcnJvci5hbnQtc2VsZWN0Om5vdCguYW50LXNlbGVjdC1kaXNhYmxlZCk6bm90KC5hbnQtc2VsZWN0LWN1c3RvbWl6ZS1pbnB1dCk6bm90KC5hbnQtcGFnaW5hdGlvbi1zaXplLWNoYW5nZXIpLmFudC1zZWxlY3Qtb3BlbiAuYW50LXNlbGVjdC1zZWxlY3Rvcntib3JkZXItY29sb3I6I2ZmNzg3NTtib3gtc2hhZG93OjAgMCAwIDJweCByZ2JhKDI1NSw3Nyw3OSwuMik7Ym9yZGVyLXJpZ2h0LXdpZHRoOjFweDtvdXRsaW5lOjB9LmFudC1zZWxlY3Qtc3RhdHVzLXdhcm5pbmcuYW50LXNlbGVjdDpub3QoLmFudC1zZWxlY3QtZGlzYWJsZWQpOm5vdCguYW50LXNlbGVjdC1jdXN0b21pemUtaW5wdXQpOm5vdCguYW50LXBhZ2luYXRpb24tc2l6ZS1jaGFuZ2VyKSAuYW50LXNlbGVjdC1zZWxlY3RvcntiYWNrZ3JvdW5kLWNvbG9yOiNmZmY7Ym9yZGVyLWNvbG9yOiNmYWFkMTQhaW1wb3J0YW50fS5hbnQtc2VsZWN0LXN0YXR1cy13YXJuaW5nLmFudC1zZWxlY3Q6bm90KC5hbnQtc2VsZWN0LWRpc2FibGVkKTpub3QoLmFudC1zZWxlY3QtY3VzdG9taXplLWlucHV0KTpub3QoLmFudC1wYWdpbmF0aW9uLXNpemUtY2hhbmdlcikuYW50LXNlbGVjdC1mb2N1c2VkIC5hbnQtc2VsZWN0LXNlbGVjdG9yLC5hbnQtc2VsZWN0LXN0YXR1cy13YXJuaW5nLmFudC1zZWxlY3Q6bm90KC5hbnQtc2VsZWN0LWRpc2FibGVkKTpub3QoLmFudC1zZWxlY3QtY3VzdG9taXplLWlucHV0KTpub3QoLmFudC1wYWdpbmF0aW9uLXNpemUtY2hhbmdlcikuYW50LXNlbGVjdC1vcGVuIC5hbnQtc2VsZWN0LXNlbGVjdG9ye2JvcmRlci1jb2xvcjojZmZjNTNkO2JveC1zaGFkb3c6MCAwIDAgMnB4IHJnYmEoMjUwLDE3MywyMCwuMik7Ym9yZGVyLXJpZ2h0LXdpZHRoOjFweDtvdXRsaW5lOjB9LmFudC1zZWxlY3Qtc3RhdHVzLWVycm9yLmFudC1zZWxlY3QtaGFzLWZlZWRiYWNrIC5hbnQtc2VsZWN0LWNsZWFyLC5hbnQtc2VsZWN0LXN0YXR1cy1zdWNjZXNzLmFudC1zZWxlY3QtaGFzLWZlZWRiYWNrIC5hbnQtc2VsZWN0LWNsZWFyLC5hbnQtc2VsZWN0LXN0YXR1cy12YWxpZGF0aW5nLmFudC1zZWxlY3QtaGFzLWZlZWRiYWNrIC5hbnQtc2VsZWN0LWNsZWFyLC5hbnQtc2VsZWN0LXN0YXR1cy13YXJuaW5nLmFudC1zZWxlY3QtaGFzLWZlZWRiYWNrIC5hbnQtc2VsZWN0LWNsZWFye3JpZ2h0OjMycHh9LmFudC1zZWxlY3Qtc3RhdHVzLWVycm9yLmFudC1zZWxlY3QtaGFzLWZlZWRiYWNrIC5hbnQtc2VsZWN0LXNlbGVjdGlvbi1zZWxlY3RlZC12YWx1ZSwuYW50LXNlbGVjdC1zdGF0dXMtc3VjY2Vzcy5hbnQtc2VsZWN0LWhhcy1mZWVkYmFjayAuYW50LXNlbGVjdC1zZWxlY3Rpb24tc2VsZWN0ZWQtdmFsdWUsLmFudC1zZWxlY3Qtc3RhdHVzLXZhbGlkYXRpbmcuYW50LXNlbGVjdC1oYXMtZmVlZGJhY2sgLmFudC1zZWxlY3Qtc2VsZWN0aW9uLXNlbGVjdGVkLXZhbHVlLC5hbnQtc2VsZWN0LXN0YXR1cy13YXJuaW5nLmFudC1zZWxlY3QtaGFzLWZlZWRiYWNrIC5hbnQtc2VsZWN0LXNlbGVjdGlvbi1zZWxlY3RlZC12YWx1ZXtwYWRkaW5nLXJpZ2h0OjQycHh9LmFudC1zZWxlY3R7Ym94LXNpemluZzpib3JkZXItYm94O21hcmdpbjowO3BhZGRpbmc6MDtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7Zm9udC1zaXplOjE0cHg7Zm9udC12YXJpYW50OnRhYnVsYXItbnVtcztsaW5lLWhlaWdodDoxLjU3MTU7bGlzdC1zdHlsZTpub25lO2ZvbnQtZmVhdHVyZS1zZXR0aW5nczpcInRudW1cIjtwb3NpdGlvbjpyZWxhdGl2ZTtkaXNwbGF5OmlubGluZS1ibG9jaztjdXJzb3I6cG9pbnRlcn0uYW50LXNlbGVjdDpub3QoLmFudC1zZWxlY3QtY3VzdG9taXplLWlucHV0KSAuYW50LXNlbGVjdC1zZWxlY3Rvcntwb3NpdGlvbjpyZWxhdGl2ZTtiYWNrZ3JvdW5kLWNvbG9yOiNmZmY7Ym9yZGVyOjFweCBzb2xpZCAjZDlkOWQ5O2JvcmRlci1yYWRpdXM6MnB4O3RyYW5zaXRpb246YWxsIC4zcyBjdWJpYy1iZXppZXIoLjY0NSwuMDQ1LC4zNTUsMSl9LmFudC1zZWxlY3Q6bm90KC5hbnQtc2VsZWN0LWN1c3RvbWl6ZS1pbnB1dCkgLmFudC1zZWxlY3Qtc2VsZWN0b3IgaW5wdXR7Y3Vyc29yOnBvaW50ZXJ9LmFudC1zZWxlY3Qtc2hvdy1zZWFyY2guYW50LXNlbGVjdDpub3QoLmFudC1zZWxlY3QtY3VzdG9taXplLWlucHV0KSAuYW50LXNlbGVjdC1zZWxlY3RvcntjdXJzb3I6dGV4dH0uYW50LXNlbGVjdC1zaG93LXNlYXJjaC5hbnQtc2VsZWN0Om5vdCguYW50LXNlbGVjdC1jdXN0b21pemUtaW5wdXQpIC5hbnQtc2VsZWN0LXNlbGVjdG9yIGlucHV0e2N1cnNvcjphdXRvfS5hbnQtc2VsZWN0LWZvY3VzZWQ6bm90KC5hbnQtc2VsZWN0LWRpc2FibGVkKS5hbnQtc2VsZWN0Om5vdCguYW50LXNlbGVjdC1jdXN0b21pemUtaW5wdXQpIC5hbnQtc2VsZWN0LXNlbGVjdG9ye2JvcmRlci1jb2xvcjojNDBhOWZmO2JveC1zaGFkb3c6MCAwIDAgMnB4IHJnYmEoMjQsMTQ0LDI1NSwuMik7Ym9yZGVyLXJpZ2h0LXdpZHRoOjFweDtvdXRsaW5lOjB9LmFudC1zZWxlY3QtZGlzYWJsZWQuYW50LXNlbGVjdDpub3QoLmFudC1zZWxlY3QtY3VzdG9taXplLWlucHV0KSAuYW50LXNlbGVjdC1zZWxlY3Rvcntjb2xvcjpyZ2JhKDAsMCwwLC4yNSk7YmFja2dyb3VuZDojZjVmNWY1O2N1cnNvcjpub3QtYWxsb3dlZH0uYW50LXNlbGVjdC1tdWx0aXBsZS5hbnQtc2VsZWN0LWRpc2FibGVkLmFudC1zZWxlY3Q6bm90KC5hbnQtc2VsZWN0LWN1c3RvbWl6ZS1pbnB1dCkgLmFudC1zZWxlY3Qtc2VsZWN0b3J7YmFja2dyb3VuZDojZjVmNWY1fS5hbnQtc2VsZWN0LWRpc2FibGVkLmFudC1zZWxlY3Q6bm90KC5hbnQtc2VsZWN0LWN1c3RvbWl6ZS1pbnB1dCkgLmFudC1zZWxlY3Qtc2VsZWN0b3IgaW5wdXR7Y3Vyc29yOm5vdC1hbGxvd2VkfS5hbnQtc2VsZWN0Om5vdCguYW50LXNlbGVjdC1jdXN0b21pemUtaW5wdXQpIC5hbnQtc2VsZWN0LXNlbGVjdG9yIC5hbnQtc2VsZWN0LXNlbGVjdGlvbi1zZWFyY2gtaW5wdXR7bWFyZ2luOjA7cGFkZGluZzowO2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7Ym9yZGVyOm5vbmU7b3V0bGluZTpub25lOy13ZWJraXQtYXBwZWFyYW5jZTpub25lOy1tb3otYXBwZWFyYW5jZTpub25lO2FwcGVhcmFuY2U6bm9uZX0uYW50LXNlbGVjdDpub3QoLmFudC1zZWxlY3QtY3VzdG9taXplLWlucHV0KSAuYW50LXNlbGVjdC1zZWxlY3RvciAuYW50LXNlbGVjdC1zZWxlY3Rpb24tc2VhcmNoLWlucHV0Ojotd2Via2l0LXNlYXJjaC1jYW5jZWwtYnV0dG9ue2Rpc3BsYXk6bm9uZTstd2Via2l0LWFwcGVhcmFuY2U6bm9uZX0uYW50LXNlbGVjdDpub3QoLmFudC1zZWxlY3QtZGlzYWJsZWQpOmhvdmVyIC5hbnQtc2VsZWN0LXNlbGVjdG9ye2JvcmRlci1jb2xvcjojNDBhOWZmO2JvcmRlci1yaWdodC13aWR0aDoxcHh9LmFudC1zZWxlY3Qtc2VsZWN0aW9uLWl0ZW17ZmxleDoxO292ZXJmbG93OmhpZGRlbjtmb250LXdlaWdodDo0MDA7d2hpdGUtc3BhY2U6bm93cmFwO3RleHQtb3ZlcmZsb3c6ZWxsaXBzaXN9QG1lZGlhICgtbXMtaGlnaC1jb250cmFzdDpub25lKXsuYW50LXNlbGVjdC1zZWxlY3Rpb24taXRlbSwuYW50LXNlbGVjdC1zZWxlY3Rpb24taXRlbSA6Oi1tcy1iYWNrZHJvcHtmbGV4OmF1dG99fS5hbnQtc2VsZWN0LXNlbGVjdGlvbi1wbGFjZWhvbGRlcntmbGV4OjE7b3ZlcmZsb3c6aGlkZGVuO2NvbG9yOiNiZmJmYmY7d2hpdGUtc3BhY2U6bm93cmFwO3RleHQtb3ZlcmZsb3c6ZWxsaXBzaXM7cG9pbnRlci1ldmVudHM6bm9uZX1AbWVkaWEgKC1tcy1oaWdoLWNvbnRyYXN0Om5vbmUpey5hbnQtc2VsZWN0LXNlbGVjdGlvbi1wbGFjZWhvbGRlciwuYW50LXNlbGVjdC1zZWxlY3Rpb24tcGxhY2Vob2xkZXIgOjotbXMtYmFja2Ryb3B7ZmxleDphdXRvfX0uYW50LXNlbGVjdC1hcnJvd3tkaXNwbGF5OmlubGluZS1ibG9jaztjb2xvcjppbmhlcml0O2ZvbnQtc3R5bGU6bm9ybWFsO2xpbmUtaGVpZ2h0OjA7dGV4dC10cmFuc2Zvcm06bm9uZTt2ZXJ0aWNhbC1hbGlnbjotLjEyNWVtO3RleHQtcmVuZGVyaW5nOm9wdGltaXplbGVnaWJpbGl0eTstd2Via2l0LWZvbnQtc21vb3RoaW5nOmFudGlhbGlhc2VkOy1tb3otb3N4LWZvbnQtc21vb3RoaW5nOmdyYXlzY2FsZTtwb3NpdGlvbjphYnNvbHV0ZTt0b3A6NTAlO3JpZ2h0OjExcHg7ZGlzcGxheTpmbGV4O2FsaWduLWl0ZW1zOmNlbnRlcjtoZWlnaHQ6MTJweDttYXJnaW4tdG9wOi02cHg7Y29sb3I6cmdiYSgwLDAsMCwuMjUpO2ZvbnQtc2l6ZToxMnB4O2xpbmUtaGVpZ2h0OjE7dGV4dC1hbGlnbjpjZW50ZXI7cG9pbnRlci1ldmVudHM6bm9uZX0uYW50LXNlbGVjdC1hcnJvdz4qe2xpbmUtaGVpZ2h0OjF9LmFudC1zZWxlY3QtYXJyb3cgc3Zne2Rpc3BsYXk6aW5saW5lLWJsb2NrfS5hbnQtc2VsZWN0LWFycm93OmJlZm9yZXtkaXNwbGF5Om5vbmV9LmFudC1zZWxlY3QtYXJyb3cgLmFudC1zZWxlY3QtYXJyb3ctaWNvbntkaXNwbGF5OmJsb2NrfS5hbnQtc2VsZWN0LWFycm93IC5hbnRpY29ue3ZlcnRpY2FsLWFsaWduOnRvcDt0cmFuc2l0aW9uOnRyYW5zZm9ybSAuM3N9LmFudC1zZWxlY3QtYXJyb3cgLmFudGljb24+c3Zne3ZlcnRpY2FsLWFsaWduOnRvcH0uYW50LXNlbGVjdC1hcnJvdyAuYW50aWNvbjpub3QoLmFudC1zZWxlY3Qtc3VmZml4KXtwb2ludGVyLWV2ZW50czphdXRvfS5hbnQtc2VsZWN0LWRpc2FibGVkIC5hbnQtc2VsZWN0LWFycm93e2N1cnNvcjpub3QtYWxsb3dlZH0uYW50LXNlbGVjdC1hcnJvdz46bm90KDpsYXN0LWNoaWxkKXstd2Via2l0LW1hcmdpbi1lbmQ6OHB4O21hcmdpbi1pbmxpbmUtZW5kOjhweH0uYW50LXNlbGVjdC1jbGVhcntwb3NpdGlvbjphYnNvbHV0ZTt0b3A6NTAlO3JpZ2h0OjExcHg7ei1pbmRleDoxO2Rpc3BsYXk6aW5saW5lLWJsb2NrO3dpZHRoOjEycHg7aGVpZ2h0OjEycHg7bWFyZ2luLXRvcDotNnB4O2NvbG9yOnJnYmEoMCwwLDAsLjI1KTtmb250LXNpemU6MTJweDtmb250LXN0eWxlOm5vcm1hbDtsaW5lLWhlaWdodDoxO3RleHQtYWxpZ246Y2VudGVyO3RleHQtdHJhbnNmb3JtOm5vbmU7YmFja2dyb3VuZDojZmZmO2N1cnNvcjpwb2ludGVyO29wYWNpdHk6MDt0cmFuc2l0aW9uOmNvbG9yIC4zcyBlYXNlLG9wYWNpdHkgLjE1cyBlYXNlO3RleHQtcmVuZGVyaW5nOmF1dG99LmFudC1zZWxlY3QtY2xlYXI6YmVmb3Jle2Rpc3BsYXk6YmxvY2t9LmFudC1zZWxlY3QtY2xlYXI6aG92ZXJ7Y29sb3I6cmdiYSgwLDAsMCwuNDUpfS5hbnQtc2VsZWN0OmhvdmVyIC5hbnQtc2VsZWN0LWNsZWFye29wYWNpdHk6MX0uYW50LXNlbGVjdC1kcm9wZG93bnttYXJnaW46MDtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7Zm9udC12YXJpYW50OnRhYnVsYXItbnVtcztsaW5lLWhlaWdodDoxLjU3MTU7bGlzdC1zdHlsZTpub25lO2ZvbnQtZmVhdHVyZS1zZXR0aW5nczpcInRudW1cIjtwb3NpdGlvbjphYnNvbHV0ZTt0b3A6LTk5OTlweDtsZWZ0Oi05OTk5cHg7ei1pbmRleDoxMDUwO2JveC1zaXppbmc6Ym9yZGVyLWJveDtwYWRkaW5nOjRweCAwO292ZXJmbG93OmhpZGRlbjtmb250LXNpemU6MTRweDtmb250LXZhcmlhbnQ6bm9ybWFsO2JhY2tncm91bmQtY29sb3I6I2ZmZjtib3JkZXItcmFkaXVzOjJweDtvdXRsaW5lOm5vbmU7Ym94LXNoYWRvdzowIDNweCA2cHggLTRweCByZ2JhKDAsMCwwLC4xMiksMCA2cHggMTZweCAwIHJnYmEoMCwwLDAsLjA4KSwwIDlweCAyOHB4IDhweCByZ2JhKDAsMCwwLC4wNSl9LmFudC1zZWxlY3QtZHJvcGRvd24uYW50LXNsaWRlLXVwLWFwcGVhci5hbnQtc2xpZGUtdXAtYXBwZWFyLWFjdGl2ZS5hbnQtc2VsZWN0LWRyb3Bkb3duLXBsYWNlbWVudC1ib3R0b21MZWZ0LC5hbnQtc2VsZWN0LWRyb3Bkb3duLmFudC1zbGlkZS11cC1lbnRlci5hbnQtc2xpZGUtdXAtZW50ZXItYWN0aXZlLmFudC1zZWxlY3QtZHJvcGRvd24tcGxhY2VtZW50LWJvdHRvbUxlZnR7YW5pbWF0aW9uLW5hbWU6YW50U2xpZGVVcElufS5hbnQtc2VsZWN0LWRyb3Bkb3duLmFudC1zbGlkZS11cC1hcHBlYXIuYW50LXNsaWRlLXVwLWFwcGVhci1hY3RpdmUuYW50LXNlbGVjdC1kcm9wZG93bi1wbGFjZW1lbnQtdG9wTGVmdCwuYW50LXNlbGVjdC1kcm9wZG93bi5hbnQtc2xpZGUtdXAtZW50ZXIuYW50LXNsaWRlLXVwLWVudGVyLWFjdGl2ZS5hbnQtc2VsZWN0LWRyb3Bkb3duLXBsYWNlbWVudC10b3BMZWZ0e2FuaW1hdGlvbi1uYW1lOmFudFNsaWRlRG93bklufS5hbnQtc2VsZWN0LWRyb3Bkb3duLmFudC1zbGlkZS11cC1sZWF2ZS5hbnQtc2xpZGUtdXAtbGVhdmUtYWN0aXZlLmFudC1zZWxlY3QtZHJvcGRvd24tcGxhY2VtZW50LWJvdHRvbUxlZnR7YW5pbWF0aW9uLW5hbWU6YW50U2xpZGVVcE91dH0uYW50LXNlbGVjdC1kcm9wZG93bi5hbnQtc2xpZGUtdXAtbGVhdmUuYW50LXNsaWRlLXVwLWxlYXZlLWFjdGl2ZS5hbnQtc2VsZWN0LWRyb3Bkb3duLXBsYWNlbWVudC10b3BMZWZ0e2FuaW1hdGlvbi1uYW1lOmFudFNsaWRlRG93bk91dH0uYW50LXNlbGVjdC1kcm9wZG93bi1oaWRkZW57ZGlzcGxheTpub25lfS5hbnQtc2VsZWN0LWRyb3Bkb3duLWVtcHR5e2NvbG9yOnJnYmEoMCwwLDAsLjI1KX0uYW50LXNlbGVjdC1pdGVtLWVtcHR5e2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtjb2xvcjpyZ2JhKDAsMCwwLC4yNSl9LmFudC1zZWxlY3QtaXRlbSwuYW50LXNlbGVjdC1pdGVtLWVtcHR5e3Bvc2l0aW9uOnJlbGF0aXZlO2Rpc3BsYXk6YmxvY2s7bWluLWhlaWdodDozMnB4O3BhZGRpbmc6NXB4IDEycHg7Zm9udC13ZWlnaHQ6NDAwO2ZvbnQtc2l6ZToxNHB4O2xpbmUtaGVpZ2h0OjIycHh9LmFudC1zZWxlY3QtaXRlbXtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7Y3Vyc29yOnBvaW50ZXI7dHJhbnNpdGlvbjpiYWNrZ3JvdW5kIC4zcyBlYXNlfS5hbnQtc2VsZWN0LWl0ZW0tZ3JvdXB7Y29sb3I6cmdiYSgwLDAsMCwuNDUpO2ZvbnQtc2l6ZToxMnB4O2N1cnNvcjpkZWZhdWx0fS5hbnQtc2VsZWN0LWl0ZW0tb3B0aW9ue2Rpc3BsYXk6ZmxleH0uYW50LXNlbGVjdC1pdGVtLW9wdGlvbi1jb250ZW50e2ZsZXg6YXV0bztvdmVyZmxvdzpoaWRkZW47d2hpdGUtc3BhY2U6bm93cmFwO3RleHQtb3ZlcmZsb3c6ZWxsaXBzaXN9LmFudC1zZWxlY3QtaXRlbS1vcHRpb24tc3RhdGV7ZmxleDpub25lfS5hbnQtc2VsZWN0LWl0ZW0tb3B0aW9uLWFjdGl2ZTpub3QoLmFudC1zZWxlY3QtaXRlbS1vcHRpb24tZGlzYWJsZWQpe2JhY2tncm91bmQtY29sb3I6I2Y1ZjVmNX0uYW50LXNlbGVjdC1pdGVtLW9wdGlvbi1zZWxlY3RlZDpub3QoLmFudC1zZWxlY3QtaXRlbS1vcHRpb24tZGlzYWJsZWQpe2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtmb250LXdlaWdodDo2MDA7YmFja2dyb3VuZC1jb2xvcjojZTZmN2ZmfS5hbnQtc2VsZWN0LWl0ZW0tb3B0aW9uLXNlbGVjdGVkOm5vdCguYW50LXNlbGVjdC1pdGVtLW9wdGlvbi1kaXNhYmxlZCkgLmFudC1zZWxlY3QtaXRlbS1vcHRpb24tc3RhdGV7Y29sb3I6IzE4OTBmZn0uYW50LXNlbGVjdC1pdGVtLW9wdGlvbi1kaXNhYmxlZHtjb2xvcjpyZ2JhKDAsMCwwLC4yNSk7Y3Vyc29yOm5vdC1hbGxvd2VkfS5hbnQtc2VsZWN0LWl0ZW0tb3B0aW9uLWRpc2FibGVkLmFudC1zZWxlY3QtaXRlbS1vcHRpb24tc2VsZWN0ZWR7YmFja2dyb3VuZC1jb2xvcjojZjVmNWY1fS5hbnQtc2VsZWN0LWl0ZW0tb3B0aW9uLWdyb3VwZWR7cGFkZGluZy1sZWZ0OjI0cHh9LmFudC1zZWxlY3QtbGd7Zm9udC1zaXplOjE2cHh9LmFudC1zZWxlY3QtYm9yZGVybGVzcyAuYW50LXNlbGVjdC1zZWxlY3RvcntiYWNrZ3JvdW5kLWNvbG9yOnRyYW5zcGFyZW50IWltcG9ydGFudDtib3JkZXItY29sb3I6dHJhbnNwYXJlbnQhaW1wb3J0YW50O2JveC1zaGFkb3c6bm9uZSFpbXBvcnRhbnR9LmFudC1zZWxlY3QuYW50LXNlbGVjdC1pbi1mb3JtLWl0ZW17d2lkdGg6MTAwJX0uYW50LXNlbGVjdC1jb21wYWN0LWl0ZW06bm90KC5hbnQtc2VsZWN0LWNvbXBhY3QtbGFzdC1pdGVtKXttYXJnaW4tcmlnaHQ6LTFweH0uYW50LXNlbGVjdC1jb21wYWN0LWl0ZW06bm90KC5hbnQtc2VsZWN0LWNvbXBhY3QtbGFzdC1pdGVtKS5hbnQtc2VsZWN0LWNvbXBhY3QtaXRlbS1ydGx7bWFyZ2luLXJpZ2h0OjA7bWFyZ2luLWxlZnQ6LTFweH0uYW50LXNlbGVjdC1jb21wYWN0LWl0ZW0uYW50LXNlbGVjdC1mb2N1c2VkPiosLmFudC1zZWxlY3QtY29tcGFjdC1pdGVtOmFjdGl2ZT4qLC5hbnQtc2VsZWN0LWNvbXBhY3QtaXRlbTpmb2N1cz4qLC5hbnQtc2VsZWN0LWNvbXBhY3QtaXRlbTpob3Zlcj4qe3otaW5kZXg6Mn0uYW50LXNlbGVjdC1jb21wYWN0LWl0ZW1bZGlzYWJsZWRdPip7ei1pbmRleDowfS5hbnQtc2VsZWN0LWNvbXBhY3QtaXRlbTpub3QoLmFudC1zZWxlY3QtY29tcGFjdC1maXJzdC1pdGVtKTpub3QoLmFudC1zZWxlY3QtY29tcGFjdC1sYXN0LWl0ZW0pLmFudC1zZWxlY3Q+LmFudC1zZWxlY3Qtc2VsZWN0b3J7Ym9yZGVyLXJhZGl1czowfS5hbnQtc2VsZWN0LWNvbXBhY3QtaXRlbS5hbnQtc2VsZWN0LWNvbXBhY3QtZmlyc3QtaXRlbS5hbnQtc2VsZWN0Om5vdCguYW50LXNlbGVjdC1jb21wYWN0LWxhc3QtaXRlbSk6bm90KC5hbnQtc2VsZWN0LWNvbXBhY3QtaXRlbS1ydGwpPi5hbnQtc2VsZWN0LXNlbGVjdG9ye2JvcmRlci10b3AtcmlnaHQtcmFkaXVzOjA7Ym9yZGVyLWJvdHRvbS1yaWdodC1yYWRpdXM6MH0uYW50LXNlbGVjdC1jb21wYWN0LWl0ZW0uYW50LXNlbGVjdC1jb21wYWN0LWxhc3QtaXRlbS5hbnQtc2VsZWN0Om5vdCguYW50LXNlbGVjdC1jb21wYWN0LWZpcnN0LWl0ZW0pOm5vdCguYW50LXNlbGVjdC1jb21wYWN0LWl0ZW0tcnRsKT4uYW50LXNlbGVjdC1zZWxlY3RvciwuYW50LXNlbGVjdC1jb21wYWN0LWl0ZW0uYW50LXNlbGVjdC5hbnQtc2VsZWN0LWNvbXBhY3QtZmlyc3QtaXRlbS5hbnQtc2VsZWN0LWNvbXBhY3QtaXRlbS1ydGw6bm90KC5hbnQtc2VsZWN0LWNvbXBhY3QtbGFzdC1pdGVtKT4uYW50LXNlbGVjdC1zZWxlY3Rvcntib3JkZXItdG9wLWxlZnQtcmFkaXVzOjA7Ym9yZGVyLWJvdHRvbS1sZWZ0LXJhZGl1czowfS5hbnQtc2VsZWN0LWNvbXBhY3QtaXRlbS5hbnQtc2VsZWN0LmFudC1zZWxlY3QtY29tcGFjdC1sYXN0LWl0ZW0uYW50LXNlbGVjdC1jb21wYWN0LWl0ZW0tcnRsOm5vdCguYW50LXNlbGVjdC1jb21wYWN0LWZpcnN0LWl0ZW0pPi5hbnQtc2VsZWN0LXNlbGVjdG9ye2JvcmRlci10b3AtcmlnaHQtcmFkaXVzOjA7Ym9yZGVyLWJvdHRvbS1yaWdodC1yYWRpdXM6MH0uYW50LXNlbGVjdC1ydGx7ZGlyZWN0aW9uOnJ0bH0uYW50LXNlbGVjdC1ydGwgLmFudC1zZWxlY3QtYXJyb3csLmFudC1zZWxlY3QtcnRsIC5hbnQtc2VsZWN0LWNsZWFye3JpZ2h0OmF1dG87bGVmdDoxMXB4fS5hbnQtc2VsZWN0LWRyb3Bkb3duLXJ0bHtkaXJlY3Rpb246cnRsfS5hbnQtc2VsZWN0LWRyb3Bkb3duLXJ0bCAuYW50LXNlbGVjdC1pdGVtLW9wdGlvbi1ncm91cGVke3BhZGRpbmctcmlnaHQ6MjRweDtwYWRkaW5nLWxlZnQ6MTJweH0uYW50LXNlbGVjdC1ydGwuYW50LXNlbGVjdC1tdWx0aXBsZS5hbnQtc2VsZWN0LWFsbG93LWNsZWFyIC5hbnQtc2VsZWN0LXNlbGVjdG9yLC5hbnQtc2VsZWN0LXJ0bC5hbnQtc2VsZWN0LW11bHRpcGxlLmFudC1zZWxlY3Qtc2hvdy1hcnJvdyAuYW50LXNlbGVjdC1zZWxlY3RvcntwYWRkaW5nLXJpZ2h0OjRweDtwYWRkaW5nLWxlZnQ6MjRweH0uYW50LXNlbGVjdC1ydGwuYW50LXNlbGVjdC1tdWx0aXBsZSAuYW50LXNlbGVjdC1zZWxlY3Rpb24taXRlbXt0ZXh0LWFsaWduOnJpZ2h0fS5hbnQtc2VsZWN0LXJ0bC5hbnQtc2VsZWN0LW11bHRpcGxlIC5hbnQtc2VsZWN0LXNlbGVjdGlvbi1pdGVtLWNvbnRlbnR7bWFyZ2luLXJpZ2h0OjA7bWFyZ2luLWxlZnQ6NHB4O3RleHQtYWxpZ246cmlnaHR9LmFudC1zZWxlY3QtcnRsLmFudC1zZWxlY3QtbXVsdGlwbGUgLmFudC1zZWxlY3Qtc2VsZWN0aW9uLXNlYXJjaC1taXJyb3J7cmlnaHQ6MDtsZWZ0OmF1dG99LmFudC1zZWxlY3QtcnRsLmFudC1zZWxlY3QtbXVsdGlwbGUgLmFudC1zZWxlY3Qtc2VsZWN0aW9uLXBsYWNlaG9sZGVye3JpZ2h0OjExcHg7bGVmdDphdXRvfS5hbnQtc2VsZWN0LXJ0bC5hbnQtc2VsZWN0LW11bHRpcGxlLmFudC1zZWxlY3Qtc20gLmFudC1zZWxlY3Qtc2VsZWN0aW9uLXBsYWNlaG9sZGVye3JpZ2h0OjdweH0uYW50LXNlbGVjdC1ydGwuYW50LXNlbGVjdC1zaW5nbGUgLmFudC1zZWxlY3Qtc2VsZWN0b3IgLmFudC1zZWxlY3Qtc2VsZWN0aW9uLWl0ZW0sLmFudC1zZWxlY3QtcnRsLmFudC1zZWxlY3Qtc2luZ2xlIC5hbnQtc2VsZWN0LXNlbGVjdG9yIC5hbnQtc2VsZWN0LXNlbGVjdGlvbi1wbGFjZWhvbGRlcntyaWdodDowO2xlZnQ6OXB4O3RleHQtYWxpZ246cmlnaHR9LmFudC1zZWxlY3QtcnRsLmFudC1zZWxlY3Qtc2luZ2xlLmFudC1zZWxlY3Qtc2hvdy1hcnJvdyAuYW50LXNlbGVjdC1zZWxlY3Rpb24tc2VhcmNoe3JpZ2h0OjExcHg7bGVmdDoyNXB4fS5hbnQtc2VsZWN0LXJ0bC5hbnQtc2VsZWN0LXNpbmdsZS5hbnQtc2VsZWN0LXNob3ctYXJyb3cgLmFudC1zZWxlY3Qtc2VsZWN0aW9uLWl0ZW0sLmFudC1zZWxlY3QtcnRsLmFudC1zZWxlY3Qtc2luZ2xlLmFudC1zZWxlY3Qtc2hvdy1hcnJvdyAuYW50LXNlbGVjdC1zZWxlY3Rpb24tcGxhY2Vob2xkZXJ7cGFkZGluZy1yaWdodDowO3BhZGRpbmctbGVmdDoxOHB4fS5hbnQtc2VsZWN0LXJ0bC5hbnQtc2VsZWN0LXNpbmdsZS5hbnQtc2VsZWN0LXNtOm5vdCguYW50LXNlbGVjdC1jdXN0b21pemUtaW5wdXQpLmFudC1zZWxlY3Qtc2hvdy1hcnJvdyAuYW50LXNlbGVjdC1zZWxlY3Rpb24tc2VhcmNoe3JpZ2h0OjZweH0uYW50LXNlbGVjdC1ydGwuYW50LXNlbGVjdC1zaW5nbGUuYW50LXNlbGVjdC1zbTpub3QoLmFudC1zZWxlY3QtY3VzdG9taXplLWlucHV0KS5hbnQtc2VsZWN0LXNob3ctYXJyb3cgLmFudC1zZWxlY3Qtc2VsZWN0aW9uLWl0ZW0sLmFudC1zZWxlY3QtcnRsLmFudC1zZWxlY3Qtc2luZ2xlLmFudC1zZWxlY3Qtc206bm90KC5hbnQtc2VsZWN0LWN1c3RvbWl6ZS1pbnB1dCkuYW50LXNlbGVjdC1zaG93LWFycm93IC5hbnQtc2VsZWN0LXNlbGVjdGlvbi1wbGFjZWhvbGRlcntwYWRkaW5nLXJpZ2h0OjA7cGFkZGluZy1sZWZ0OjIxcHh9LmFudC1za2VsZXRvbntkaXNwbGF5OnRhYmxlO3dpZHRoOjEwMCV9LmFudC1za2VsZXRvbi1oZWFkZXJ7ZGlzcGxheTp0YWJsZS1jZWxsO3BhZGRpbmctcmlnaHQ6MTZweDt2ZXJ0aWNhbC1hbGlnbjp0b3B9LmFudC1za2VsZXRvbi1oZWFkZXIgLmFudC1za2VsZXRvbi1hdmF0YXJ7ZGlzcGxheTppbmxpbmUtYmxvY2s7dmVydGljYWwtYWxpZ246dG9wO2JhY2tncm91bmQ6aHNsYSgwLDAlLDc0LjUlLC4yKTt3aWR0aDozMnB4O2hlaWdodDozMnB4O2xpbmUtaGVpZ2h0OjMycHh9LmFudC1za2VsZXRvbi1oZWFkZXIgLmFudC1za2VsZXRvbi1hdmF0YXIuYW50LXNrZWxldG9uLWF2YXRhci1jaXJjbGV7Ym9yZGVyLXJhZGl1czo1MCV9LmFudC1za2VsZXRvbi1oZWFkZXIgLmFudC1za2VsZXRvbi1hdmF0YXItbGd7d2lkdGg6NDBweDtoZWlnaHQ6NDBweDtsaW5lLWhlaWdodDo0MHB4fS5hbnQtc2tlbGV0b24taGVhZGVyIC5hbnQtc2tlbGV0b24tYXZhdGFyLWxnLmFudC1za2VsZXRvbi1hdmF0YXItY2lyY2xle2JvcmRlci1yYWRpdXM6NTAlfS5hbnQtc2tlbGV0b24taGVhZGVyIC5hbnQtc2tlbGV0b24tYXZhdGFyLXNte3dpZHRoOjI0cHg7aGVpZ2h0OjI0cHg7bGluZS1oZWlnaHQ6MjRweH0uYW50LXNrZWxldG9uLWhlYWRlciAuYW50LXNrZWxldG9uLWF2YXRhci1zbS5hbnQtc2tlbGV0b24tYXZhdGFyLWNpcmNsZXtib3JkZXItcmFkaXVzOjUwJX0uYW50LXNrZWxldG9uLWNvbnRlbnR7ZGlzcGxheTp0YWJsZS1jZWxsO3dpZHRoOjEwMCU7dmVydGljYWwtYWxpZ246dG9wfS5hbnQtc2tlbGV0b24tY29udGVudCAuYW50LXNrZWxldG9uLXRpdGxle3dpZHRoOjEwMCU7aGVpZ2h0OjE2cHg7YmFja2dyb3VuZDpoc2xhKDAsMCUsNzQuNSUsLjIpO2JvcmRlci1yYWRpdXM6MnB4fS5hbnQtc2tlbGV0b24tY29udGVudCAuYW50LXNrZWxldG9uLXRpdGxlKy5hbnQtc2tlbGV0b24tcGFyYWdyYXBoe21hcmdpbi10b3A6MjRweH0uYW50LXNrZWxldG9uLWNvbnRlbnQgLmFudC1za2VsZXRvbi1wYXJhZ3JhcGh7cGFkZGluZzowfS5hbnQtc2tlbGV0b24tY29udGVudCAuYW50LXNrZWxldG9uLXBhcmFncmFwaD5saXt3aWR0aDoxMDAlO2hlaWdodDoxNnB4O2xpc3Qtc3R5bGU6bm9uZTtiYWNrZ3JvdW5kOmhzbGEoMCwwJSw3NC41JSwuMik7Ym9yZGVyLXJhZGl1czoycHh9LmFudC1za2VsZXRvbi1jb250ZW50IC5hbnQtc2tlbGV0b24tcGFyYWdyYXBoPmxpOmxhc3QtY2hpbGQ6bm90KDpmaXJzdC1jaGlsZCk6bm90KDpudGgtY2hpbGQoMikpe3dpZHRoOjYxJX0uYW50LXNrZWxldG9uLWNvbnRlbnQgLmFudC1za2VsZXRvbi1wYXJhZ3JhcGg+bGkrbGl7bWFyZ2luLXRvcDoxNnB4fS5hbnQtc2tlbGV0b24td2l0aC1hdmF0YXIgLmFudC1za2VsZXRvbi1jb250ZW50IC5hbnQtc2tlbGV0b24tdGl0bGV7bWFyZ2luLXRvcDoxMnB4fS5hbnQtc2tlbGV0b24td2l0aC1hdmF0YXIgLmFudC1za2VsZXRvbi1jb250ZW50IC5hbnQtc2tlbGV0b24tdGl0bGUrLmFudC1za2VsZXRvbi1wYXJhZ3JhcGh7bWFyZ2luLXRvcDoyOHB4fS5hbnQtc2tlbGV0b24tcm91bmQgLmFudC1za2VsZXRvbi1jb250ZW50IC5hbnQtc2tlbGV0b24tcGFyYWdyYXBoPmxpLC5hbnQtc2tlbGV0b24tcm91bmQgLmFudC1za2VsZXRvbi1jb250ZW50IC5hbnQtc2tlbGV0b24tdGl0bGV7Ym9yZGVyLXJhZGl1czoxMDBweH0uYW50LXNrZWxldG9uLWFjdGl2ZSAuYW50LXNrZWxldG9uLWF2YXRhciwuYW50LXNrZWxldG9uLWFjdGl2ZSAuYW50LXNrZWxldG9uLWJ1dHRvbiwuYW50LXNrZWxldG9uLWFjdGl2ZSAuYW50LXNrZWxldG9uLWltYWdlLC5hbnQtc2tlbGV0b24tYWN0aXZlIC5hbnQtc2tlbGV0b24taW5wdXQsLmFudC1za2VsZXRvbi1hY3RpdmUgLmFudC1za2VsZXRvbi1wYXJhZ3JhcGg+bGksLmFudC1za2VsZXRvbi1hY3RpdmUgLmFudC1za2VsZXRvbi10aXRsZXtwb3NpdGlvbjpyZWxhdGl2ZTt6LWluZGV4OjA7b3ZlcmZsb3c6aGlkZGVuO2JhY2tncm91bmQ6dHJhbnNwYXJlbnR9LmFudC1za2VsZXRvbi1hY3RpdmUgLmFudC1za2VsZXRvbi1hdmF0YXI6YWZ0ZXIsLmFudC1za2VsZXRvbi1hY3RpdmUgLmFudC1za2VsZXRvbi1idXR0b246YWZ0ZXIsLmFudC1za2VsZXRvbi1hY3RpdmUgLmFudC1za2VsZXRvbi1pbWFnZTphZnRlciwuYW50LXNrZWxldG9uLWFjdGl2ZSAuYW50LXNrZWxldG9uLWlucHV0OmFmdGVyLC5hbnQtc2tlbGV0b24tYWN0aXZlIC5hbnQtc2tlbGV0b24tcGFyYWdyYXBoPmxpOmFmdGVyLC5hbnQtc2tlbGV0b24tYWN0aXZlIC5hbnQtc2tlbGV0b24tdGl0bGU6YWZ0ZXJ7cG9zaXRpb246YWJzb2x1dGU7dG9wOjA7cmlnaHQ6LTE1MCU7Ym90dG9tOjA7bGVmdDotMTUwJTtiYWNrZ3JvdW5kOmxpbmVhci1ncmFkaWVudCg5MGRlZyxoc2xhKDAsMCUsNzQuNSUsLjIpIDI1JSxoc2xhKDAsMCUsNTAuNiUsLjI0KSAzNyUsaHNsYSgwLDAlLDc0LjUlLC4yKSA2MyUpO2FuaW1hdGlvbjphbnQtc2tlbGV0b24tbG9hZGluZyAxLjRzIGVhc2UgaW5maW5pdGU7Y29udGVudDpcIlwifS5hbnQtc2tlbGV0b24uYW50LXNrZWxldG9uLWJsb2NrLC5hbnQtc2tlbGV0b24uYW50LXNrZWxldG9uLWJsb2NrIC5hbnQtc2tlbGV0b24tYnV0dG9uLC5hbnQtc2tlbGV0b24uYW50LXNrZWxldG9uLWJsb2NrIC5hbnQtc2tlbGV0b24taW5wdXR7d2lkdGg6MTAwJX0uYW50LXNrZWxldG9uLWVsZW1lbnR7ZGlzcGxheTppbmxpbmUtYmxvY2s7d2lkdGg6YXV0b30uYW50LXNrZWxldG9uLWVsZW1lbnQgLmFudC1za2VsZXRvbi1idXR0b257ZGlzcGxheTppbmxpbmUtYmxvY2s7dmVydGljYWwtYWxpZ246dG9wO2JhY2tncm91bmQ6aHNsYSgwLDAlLDc0LjUlLC4yKTtib3JkZXItcmFkaXVzOjJweDt3aWR0aDo2NHB4O21pbi13aWR0aDo2NHB4O2hlaWdodDozMnB4O2xpbmUtaGVpZ2h0OjMycHh9LmFudC1za2VsZXRvbi1lbGVtZW50IC5hbnQtc2tlbGV0b24tYnV0dG9uLmFudC1za2VsZXRvbi1idXR0b24tc3F1YXJle3dpZHRoOjMycHg7bWluLXdpZHRoOjMycHh9LmFudC1za2VsZXRvbi1lbGVtZW50IC5hbnQtc2tlbGV0b24tYnV0dG9uLmFudC1za2VsZXRvbi1idXR0b24tY2lyY2xle3dpZHRoOjMycHg7bWluLXdpZHRoOjMycHg7Ym9yZGVyLXJhZGl1czo1MCV9LmFudC1za2VsZXRvbi1lbGVtZW50IC5hbnQtc2tlbGV0b24tYnV0dG9uLmFudC1za2VsZXRvbi1idXR0b24tcm91bmR7Ym9yZGVyLXJhZGl1czozMnB4fS5hbnQtc2tlbGV0b24tZWxlbWVudCAuYW50LXNrZWxldG9uLWJ1dHRvbi1sZ3t3aWR0aDo4MHB4O21pbi13aWR0aDo4MHB4O2hlaWdodDo0MHB4O2xpbmUtaGVpZ2h0OjQwcHh9LmFudC1za2VsZXRvbi1lbGVtZW50IC5hbnQtc2tlbGV0b24tYnV0dG9uLWxnLmFudC1za2VsZXRvbi1idXR0b24tc3F1YXJle3dpZHRoOjQwcHg7bWluLXdpZHRoOjQwcHh9LmFudC1za2VsZXRvbi1lbGVtZW50IC5hbnQtc2tlbGV0b24tYnV0dG9uLWxnLmFudC1za2VsZXRvbi1idXR0b24tY2lyY2xle3dpZHRoOjQwcHg7bWluLXdpZHRoOjQwcHg7Ym9yZGVyLXJhZGl1czo1MCV9LmFudC1za2VsZXRvbi1lbGVtZW50IC5hbnQtc2tlbGV0b24tYnV0dG9uLWxnLmFudC1za2VsZXRvbi1idXR0b24tcm91bmR7Ym9yZGVyLXJhZGl1czo0MHB4fS5hbnQtc2tlbGV0b24tZWxlbWVudCAuYW50LXNrZWxldG9uLWJ1dHRvbi1zbXt3aWR0aDo0OHB4O21pbi13aWR0aDo0OHB4O2hlaWdodDoyNHB4O2xpbmUtaGVpZ2h0OjI0cHh9LmFudC1za2VsZXRvbi1lbGVtZW50IC5hbnQtc2tlbGV0b24tYnV0dG9uLXNtLmFudC1za2VsZXRvbi1idXR0b24tc3F1YXJle3dpZHRoOjI0cHg7bWluLXdpZHRoOjI0cHh9LmFudC1za2VsZXRvbi1lbGVtZW50IC5hbnQtc2tlbGV0b24tYnV0dG9uLXNtLmFudC1za2VsZXRvbi1idXR0b24tY2lyY2xle3dpZHRoOjI0cHg7bWluLXdpZHRoOjI0cHg7Ym9yZGVyLXJhZGl1czo1MCV9LmFudC1za2VsZXRvbi1lbGVtZW50IC5hbnQtc2tlbGV0b24tYnV0dG9uLXNtLmFudC1za2VsZXRvbi1idXR0b24tcm91bmR7Ym9yZGVyLXJhZGl1czoyNHB4fS5hbnQtc2tlbGV0b24tZWxlbWVudCAuYW50LXNrZWxldG9uLWF2YXRhcntkaXNwbGF5OmlubGluZS1ibG9jazt2ZXJ0aWNhbC1hbGlnbjp0b3A7YmFja2dyb3VuZDpoc2xhKDAsMCUsNzQuNSUsLjIpO3dpZHRoOjMycHg7aGVpZ2h0OjMycHg7bGluZS1oZWlnaHQ6MzJweH0uYW50LXNrZWxldG9uLWVsZW1lbnQgLmFudC1za2VsZXRvbi1hdmF0YXIuYW50LXNrZWxldG9uLWF2YXRhci1jaXJjbGV7Ym9yZGVyLXJhZGl1czo1MCV9LmFudC1za2VsZXRvbi1lbGVtZW50IC5hbnQtc2tlbGV0b24tYXZhdGFyLWxne3dpZHRoOjQwcHg7aGVpZ2h0OjQwcHg7bGluZS1oZWlnaHQ6NDBweH0uYW50LXNrZWxldG9uLWVsZW1lbnQgLmFudC1za2VsZXRvbi1hdmF0YXItbGcuYW50LXNrZWxldG9uLWF2YXRhci1jaXJjbGV7Ym9yZGVyLXJhZGl1czo1MCV9LmFudC1za2VsZXRvbi1lbGVtZW50IC5hbnQtc2tlbGV0b24tYXZhdGFyLXNte3dpZHRoOjI0cHg7aGVpZ2h0OjI0cHg7bGluZS1oZWlnaHQ6MjRweH0uYW50LXNrZWxldG9uLWVsZW1lbnQgLmFudC1za2VsZXRvbi1hdmF0YXItc20uYW50LXNrZWxldG9uLWF2YXRhci1jaXJjbGV7Ym9yZGVyLXJhZGl1czo1MCV9LmFudC1za2VsZXRvbi1lbGVtZW50IC5hbnQtc2tlbGV0b24taW5wdXR7ZGlzcGxheTppbmxpbmUtYmxvY2s7dmVydGljYWwtYWxpZ246dG9wO2JhY2tncm91bmQ6aHNsYSgwLDAlLDc0LjUlLC4yKTt3aWR0aDoxNjBweDttaW4td2lkdGg6MTYwcHg7aGVpZ2h0OjMycHg7bGluZS1oZWlnaHQ6MzJweH0uYW50LXNrZWxldG9uLWVsZW1lbnQgLmFudC1za2VsZXRvbi1pbnB1dC1sZ3t3aWR0aDoyMDBweDttaW4td2lkdGg6MjAwcHg7aGVpZ2h0OjQwcHg7bGluZS1oZWlnaHQ6NDBweH0uYW50LXNrZWxldG9uLWVsZW1lbnQgLmFudC1za2VsZXRvbi1pbnB1dC1zbXt3aWR0aDoxMjBweDttaW4td2lkdGg6MTIwcHg7aGVpZ2h0OjI0cHg7bGluZS1oZWlnaHQ6MjRweH0uYW50LXNrZWxldG9uLWVsZW1lbnQgLmFudC1za2VsZXRvbi1pbWFnZXtkaXNwbGF5OmZsZXg7YWxpZ24taXRlbXM6Y2VudGVyO2p1c3RpZnktY29udGVudDpjZW50ZXI7dmVydGljYWwtYWxpZ246dG9wO2JhY2tncm91bmQ6aHNsYSgwLDAlLDc0LjUlLC4yKTt3aWR0aDo5NnB4O2hlaWdodDo5NnB4O2xpbmUtaGVpZ2h0Ojk2cHh9LmFudC1za2VsZXRvbi1lbGVtZW50IC5hbnQtc2tlbGV0b24taW1hZ2UuYW50LXNrZWxldG9uLWltYWdlLWNpcmNsZXtib3JkZXItcmFkaXVzOjUwJX0uYW50LXNrZWxldG9uLWVsZW1lbnQgLmFudC1za2VsZXRvbi1pbWFnZS1wYXRoe2ZpbGw6I2JmYmZiZn0uYW50LXNrZWxldG9uLWVsZW1lbnQgLmFudC1za2VsZXRvbi1pbWFnZS1zdmd7d2lkdGg6NDhweDtoZWlnaHQ6NDhweDtsaW5lLWhlaWdodDo0OHB4O21heC13aWR0aDoxOTJweDttYXgtaGVpZ2h0OjE5MnB4fS5hbnQtc2tlbGV0b24tZWxlbWVudCAuYW50LXNrZWxldG9uLWltYWdlLXN2Zy5hbnQtc2tlbGV0b24taW1hZ2UtY2lyY2xle2JvcmRlci1yYWRpdXM6NTAlfUBrZXlmcmFtZXMgYW50LXNrZWxldG9uLWxvYWRpbmd7MCV7dHJhbnNmb3JtOnRyYW5zbGF0ZVgoLTM3LjUlKX10b3t0cmFuc2Zvcm06dHJhbnNsYXRlWCgzNy41JSl9fS5hbnQtc2tlbGV0b24tcnRse2RpcmVjdGlvbjpydGx9LmFudC1za2VsZXRvbi1ydGwgLmFudC1za2VsZXRvbi1oZWFkZXJ7cGFkZGluZy1yaWdodDowO3BhZGRpbmctbGVmdDoxNnB4fS5hbnQtc2tlbGV0b24tcnRsLmFudC1za2VsZXRvbi5hbnQtc2tlbGV0b24tYWN0aXZlIC5hbnQtc2tlbGV0b24tYXZhdGFyLC5hbnQtc2tlbGV0b24tcnRsLmFudC1za2VsZXRvbi5hbnQtc2tlbGV0b24tYWN0aXZlIC5hbnQtc2tlbGV0b24tY29udGVudCAuYW50LXNrZWxldG9uLXBhcmFncmFwaD5saSwuYW50LXNrZWxldG9uLXJ0bC5hbnQtc2tlbGV0b24uYW50LXNrZWxldG9uLWFjdGl2ZSAuYW50LXNrZWxldG9uLWNvbnRlbnQgLmFudC1za2VsZXRvbi10aXRsZXthbmltYXRpb24tbmFtZTphbnQtc2tlbGV0b24tbG9hZGluZy1ydGx9QGtleWZyYW1lcyBhbnQtc2tlbGV0b24tbG9hZGluZy1ydGx7MCV7YmFja2dyb3VuZC1wb3NpdGlvbjowIDUwJX10b3tiYWNrZ3JvdW5kLXBvc2l0aW9uOjEwMCUgNTAlfX0uYW50LXNsaWRlcntib3gtc2l6aW5nOmJvcmRlci1ib3g7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtc2l6ZToxNHB4O2ZvbnQtdmFyaWFudDp0YWJ1bGFyLW51bXM7bGluZS1oZWlnaHQ6MS41NzE1O2xpc3Qtc3R5bGU6bm9uZTtmb250LWZlYXR1cmUtc2V0dGluZ3M6XCJ0bnVtXCI7cG9zaXRpb246cmVsYXRpdmU7aGVpZ2h0OjEycHg7bWFyZ2luOjEwcHggNnB4O3BhZGRpbmc6NHB4IDA7Y3Vyc29yOnBvaW50ZXI7dG91Y2gtYWN0aW9uOm5vbmV9LmFudC1zbGlkZXItdmVydGljYWx7d2lkdGg6MTJweDtoZWlnaHQ6MTAwJTttYXJnaW46NnB4IDEwcHg7cGFkZGluZzowIDRweH0uYW50LXNsaWRlci12ZXJ0aWNhbCAuYW50LXNsaWRlci1yYWlse3dpZHRoOjRweDtoZWlnaHQ6MTAwJX0uYW50LXNsaWRlci12ZXJ0aWNhbCAuYW50LXNsaWRlci10cmFja3t3aWR0aDo0cHh9LmFudC1zbGlkZXItdmVydGljYWwgLmFudC1zbGlkZXItaGFuZGxle21hcmdpbi10b3A6LTZweDttYXJnaW4tbGVmdDotNXB4fS5hbnQtc2xpZGVyLXZlcnRpY2FsIC5hbnQtc2xpZGVyLW1hcmt7dG9wOjA7bGVmdDoxMnB4O3dpZHRoOjE4cHg7aGVpZ2h0OjEwMCV9LmFudC1zbGlkZXItdmVydGljYWwgLmFudC1zbGlkZXItbWFyay10ZXh0e2xlZnQ6NHB4O3doaXRlLXNwYWNlOm5vd3JhcH0uYW50LXNsaWRlci12ZXJ0aWNhbCAuYW50LXNsaWRlci1zdGVwe3dpZHRoOjRweDtoZWlnaHQ6MTAwJX0uYW50LXNsaWRlci12ZXJ0aWNhbCAuYW50LXNsaWRlci1kb3R7dG9wOmF1dG87bWFyZ2luLWxlZnQ6LTJweH0uYW50LXNsaWRlci10b29sdGlwIC5hbnQtdG9vbHRpcC1pbm5lcnttaW4td2lkdGg6dW5zZXR9LmFudC1zbGlkZXItcnRsLmFudC1zbGlkZXItdmVydGljYWwgLmFudC1zbGlkZXItaGFuZGxle21hcmdpbi1yaWdodDotNXB4O21hcmdpbi1sZWZ0OjB9LmFudC1zbGlkZXItcnRsLmFudC1zbGlkZXItdmVydGljYWwgLmFudC1zbGlkZXItbWFya3tyaWdodDoxMnB4O2xlZnQ6YXV0b30uYW50LXNsaWRlci1ydGwuYW50LXNsaWRlci12ZXJ0aWNhbCAuYW50LXNsaWRlci1tYXJrLXRleHR7cmlnaHQ6NHB4O2xlZnQ6YXV0b30uYW50LXNsaWRlci1ydGwuYW50LXNsaWRlci12ZXJ0aWNhbCAuYW50LXNsaWRlci1kb3R7cmlnaHQ6MnB4O2xlZnQ6YXV0b30uYW50LXNsaWRlci13aXRoLW1hcmtze21hcmdpbi1ib3R0b206MjhweH0uYW50LXNsaWRlci1yYWlse3dpZHRoOjEwMCU7YmFja2dyb3VuZC1jb2xvcjojZjVmNWY1fS5hbnQtc2xpZGVyLXJhaWwsLmFudC1zbGlkZXItdHJhY2t7cG9zaXRpb246YWJzb2x1dGU7aGVpZ2h0OjRweDtib3JkZXItcmFkaXVzOjJweDt0cmFuc2l0aW9uOmJhY2tncm91bmQtY29sb3IgLjNzfS5hbnQtc2xpZGVyLXRyYWNre2JhY2tncm91bmQtY29sb3I6IzkxZDVmZn0uYW50LXNsaWRlci1oYW5kbGV7cG9zaXRpb246YWJzb2x1dGU7d2lkdGg6MTRweDtoZWlnaHQ6MTRweDttYXJnaW4tdG9wOi01cHg7YmFja2dyb3VuZC1jb2xvcjojZmZmO2JvcmRlcjoycHggc29saWQgIzkxZDVmZjtib3JkZXItcmFkaXVzOjUwJTtib3gtc2hhZG93OjA7Y3Vyc29yOnBvaW50ZXI7dHJhbnNpdGlvbjpib3JkZXItY29sb3IgLjNzLGJveC1zaGFkb3cgLjZzLHRyYW5zZm9ybSAuM3MgY3ViaWMtYmV6aWVyKC4xOCwuODksLjMyLDEuMjgpfS5hbnQtc2xpZGVyLWhhbmRsZS1kcmFnZ2luZ3t6LWluZGV4OjF9LmFudC1zbGlkZXItaGFuZGxlOmZvY3Vze2JvcmRlci1jb2xvcjojNDZhNmZmO291dGxpbmU6bm9uZTtib3gtc2hhZG93OjAgMCAwIDVweCByZ2JhKDI0LDE0NCwyNTUsLjEyKX0uYW50LXNsaWRlci1oYW5kbGUuYW50LXRvb2x0aXAtb3Blbntib3JkZXItY29sb3I6IzE4OTBmZn0uYW50LXNsaWRlci1oYW5kbGU6YWZ0ZXJ7cG9zaXRpb246YWJzb2x1dGU7dG9wOi02cHg7cmlnaHQ6LTZweDtib3R0b206LTZweDtsZWZ0Oi02cHg7Y29udGVudDpcIlwifS5hbnQtc2xpZGVyOmhvdmVyIC5hbnQtc2xpZGVyLXJhaWx7YmFja2dyb3VuZC1jb2xvcjojZTFlMWUxfS5hbnQtc2xpZGVyOmhvdmVyIC5hbnQtc2xpZGVyLXRyYWNre2JhY2tncm91bmQtY29sb3I6IzY5YzBmZn0uYW50LXNsaWRlcjpob3ZlciAuYW50LXNsaWRlci1oYW5kbGU6bm90KC5hbnQtdG9vbHRpcC1vcGVuKXtib3JkZXItY29sb3I6IzY5YzBmZn0uYW50LXNsaWRlci1tYXJre3Bvc2l0aW9uOmFic29sdXRlO3RvcDoxNHB4O2xlZnQ6MDt3aWR0aDoxMDAlO2ZvbnQtc2l6ZToxNHB4fS5hbnQtc2xpZGVyLW1hcmstdGV4dHtwb3NpdGlvbjphYnNvbHV0ZTtkaXNwbGF5OmlubGluZS1ibG9jaztjb2xvcjpyZ2JhKDAsMCwwLC40NSk7dGV4dC1hbGlnbjpjZW50ZXI7d29yZC1icmVhazprZWVwLWFsbDtjdXJzb3I6cG9pbnRlcjstd2Via2l0LXVzZXItc2VsZWN0Om5vbmU7LW1vei11c2VyLXNlbGVjdDpub25lOy1tcy11c2VyLXNlbGVjdDpub25lO3VzZXItc2VsZWN0Om5vbmV9LmFudC1zbGlkZXItbWFyay10ZXh0LWFjdGl2ZXtjb2xvcjpyZ2JhKDAsMCwwLC44NSl9LmFudC1zbGlkZXItc3RlcHtwb3NpdGlvbjphYnNvbHV0ZTt3aWR0aDoxMDAlO2hlaWdodDo0cHg7YmFja2dyb3VuZDp0cmFuc3BhcmVudDtwb2ludGVyLWV2ZW50czpub25lfS5hbnQtc2xpZGVyLWRvdHtwb3NpdGlvbjphYnNvbHV0ZTt0b3A6LTJweDt3aWR0aDo4cHg7aGVpZ2h0OjhweDtiYWNrZ3JvdW5kLWNvbG9yOiNmZmY7Ym9yZGVyOjJweCBzb2xpZCAjZjBmMGYwO2JvcmRlci1yYWRpdXM6NTAlO2N1cnNvcjpwb2ludGVyfS5hbnQtc2xpZGVyLWRvdC1hY3RpdmV7Ym9yZGVyLWNvbG9yOiM4Y2M4ZmZ9LmFudC1zbGlkZXItZGlzYWJsZWR7Y3Vyc29yOm5vdC1hbGxvd2VkfS5hbnQtc2xpZGVyLWRpc2FibGVkIC5hbnQtc2xpZGVyLXJhaWx7YmFja2dyb3VuZC1jb2xvcjojZjVmNWY1IWltcG9ydGFudH0uYW50LXNsaWRlci1kaXNhYmxlZCAuYW50LXNsaWRlci10cmFja3tiYWNrZ3JvdW5kLWNvbG9yOnJnYmEoMCwwLDAsLjI1KSFpbXBvcnRhbnR9LmFudC1zbGlkZXItZGlzYWJsZWQgLmFudC1zbGlkZXItZG90LC5hbnQtc2xpZGVyLWRpc2FibGVkIC5hbnQtc2xpZGVyLWhhbmRsZXtiYWNrZ3JvdW5kLWNvbG9yOiNmZmY7Ym9yZGVyLWNvbG9yOnJnYmEoMCwwLDAsLjI1KSFpbXBvcnRhbnQ7Ym94LXNoYWRvdzpub25lO2N1cnNvcjpub3QtYWxsb3dlZH0uYW50LXNsaWRlci1kaXNhYmxlZCAuYW50LXNsaWRlci1kb3QsLmFudC1zbGlkZXItZGlzYWJsZWQgLmFudC1zbGlkZXItbWFyay10ZXh0e2N1cnNvcjpub3QtYWxsb3dlZCFpbXBvcnRhbnR9LmFudC1zbGlkZXItcnRse2RpcmVjdGlvbjpydGx9LmFudC1zbGlkZXItcnRsIC5hbnQtc2xpZGVyLW1hcmt7cmlnaHQ6MDtsZWZ0OmF1dG99LmFudC1zcGFjZXtkaXNwbGF5OmlubGluZS1mbGV4fS5hbnQtc3BhY2UtdmVydGljYWx7ZmxleC1kaXJlY3Rpb246Y29sdW1ufS5hbnQtc3BhY2UtYWxpZ24tY2VudGVye2FsaWduLWl0ZW1zOmNlbnRlcn0uYW50LXNwYWNlLWFsaWduLXN0YXJ0e2FsaWduLWl0ZW1zOmZsZXgtc3RhcnR9LmFudC1zcGFjZS1hbGlnbi1lbmR7YWxpZ24taXRlbXM6ZmxleC1lbmR9LmFudC1zcGFjZS1hbGlnbi1iYXNlbGluZXthbGlnbi1pdGVtczpiYXNlbGluZX0uYW50LXNwYWNlLWl0ZW06ZW1wdHl7ZGlzcGxheTpub25lfS5hbnQtc3BhY2UtY29tcGFjdHtkaXNwbGF5OmlubGluZS1mbGV4fS5hbnQtc3BhY2UtY29tcGFjdC1ibG9ja3tkaXNwbGF5OmZsZXg7d2lkdGg6MTAwJX0uYW50LXNwYWNlLWNvbXBhY3QtdmVydGljYWx7ZmxleC1kaXJlY3Rpb246Y29sdW1ufS5hbnQtc3BhY2UtY29tcGFjdC1ydGwsLmFudC1zcGFjZS1ydGx7ZGlyZWN0aW9uOnJ0bH0uYW50LXNwaW57Ym94LXNpemluZzpib3JkZXItYm94O21hcmdpbjowO3BhZGRpbmc6MDtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7Zm9udC1zaXplOjE0cHg7Zm9udC12YXJpYW50OnRhYnVsYXItbnVtcztsaW5lLWhlaWdodDoxLjU3MTU7bGlzdC1zdHlsZTpub25lO2ZvbnQtZmVhdHVyZS1zZXR0aW5nczpcInRudW1cIjtwb3NpdGlvbjphYnNvbHV0ZTtkaXNwbGF5Om5vbmU7Y29sb3I6IzE4OTBmZjt0ZXh0LWFsaWduOmNlbnRlcjt2ZXJ0aWNhbC1hbGlnbjptaWRkbGU7b3BhY2l0eTowO3RyYW5zaXRpb246dHJhbnNmb3JtIC4zcyBjdWJpYy1iZXppZXIoLjc4LC4xNCwuMTUsLjg2KX0uYW50LXNwaW4tc3Bpbm5pbmd7cG9zaXRpb246c3RhdGljO2Rpc3BsYXk6aW5saW5lLWJsb2NrO29wYWNpdHk6MX0uYW50LXNwaW4tbmVzdGVkLWxvYWRpbmd7cG9zaXRpb246cmVsYXRpdmV9LmFudC1zcGluLW5lc3RlZC1sb2FkaW5nPmRpdj4uYW50LXNwaW57cG9zaXRpb246YWJzb2x1dGU7dG9wOjA7bGVmdDowO3otaW5kZXg6NDtkaXNwbGF5OmJsb2NrO3dpZHRoOjEwMCU7aGVpZ2h0OjEwMCU7bWF4LWhlaWdodDo0MDBweH0uYW50LXNwaW4tbmVzdGVkLWxvYWRpbmc+ZGl2Pi5hbnQtc3BpbiAuYW50LXNwaW4tZG90e3Bvc2l0aW9uOmFic29sdXRlO3RvcDo1MCU7bGVmdDo1MCU7bWFyZ2luOi0xMHB4fS5hbnQtc3Bpbi1uZXN0ZWQtbG9hZGluZz5kaXY+LmFudC1zcGluIC5hbnQtc3Bpbi10ZXh0e3Bvc2l0aW9uOmFic29sdXRlO3RvcDo1MCU7d2lkdGg6MTAwJTtwYWRkaW5nLXRvcDo1cHg7dGV4dC1zaGFkb3c6MCAxcHggMnB4ICNmZmZ9LmFudC1zcGluLW5lc3RlZC1sb2FkaW5nPmRpdj4uYW50LXNwaW4uYW50LXNwaW4tc2hvdy10ZXh0IC5hbnQtc3Bpbi1kb3R7bWFyZ2luLXRvcDotMjBweH0uYW50LXNwaW4tbmVzdGVkLWxvYWRpbmc+ZGl2Pi5hbnQtc3Bpbi1zbSAuYW50LXNwaW4tZG90e21hcmdpbjotN3B4fS5hbnQtc3Bpbi1uZXN0ZWQtbG9hZGluZz5kaXY+LmFudC1zcGluLXNtIC5hbnQtc3Bpbi10ZXh0e3BhZGRpbmctdG9wOjJweH0uYW50LXNwaW4tbmVzdGVkLWxvYWRpbmc+ZGl2Pi5hbnQtc3Bpbi1zbS5hbnQtc3Bpbi1zaG93LXRleHQgLmFudC1zcGluLWRvdHttYXJnaW4tdG9wOi0xN3B4fS5hbnQtc3Bpbi1uZXN0ZWQtbG9hZGluZz5kaXY+LmFudC1zcGluLWxnIC5hbnQtc3Bpbi1kb3R7bWFyZ2luOi0xNnB4fS5hbnQtc3Bpbi1uZXN0ZWQtbG9hZGluZz5kaXY+LmFudC1zcGluLWxnIC5hbnQtc3Bpbi10ZXh0e3BhZGRpbmctdG9wOjExcHh9LmFudC1zcGluLW5lc3RlZC1sb2FkaW5nPmRpdj4uYW50LXNwaW4tbGcuYW50LXNwaW4tc2hvdy10ZXh0IC5hbnQtc3Bpbi1kb3R7bWFyZ2luLXRvcDotMjZweH0uYW50LXNwaW4tY29udGFpbmVye3Bvc2l0aW9uOnJlbGF0aXZlO3RyYW5zaXRpb246b3BhY2l0eSAuM3N9LmFudC1zcGluLWNvbnRhaW5lcjphZnRlcntwb3NpdGlvbjphYnNvbHV0ZTt0b3A6MDtyaWdodDowO2JvdHRvbTowO2xlZnQ6MDt6LWluZGV4OjEwO2Rpc3BsYXk6bm9uZVxcOTt3aWR0aDoxMDAlO2hlaWdodDoxMDAlO2JhY2tncm91bmQ6I2ZmZjtvcGFjaXR5OjA7dHJhbnNpdGlvbjphbGwgLjNzO2NvbnRlbnQ6XCJcIjtwb2ludGVyLWV2ZW50czpub25lfS5hbnQtc3Bpbi1ibHVye2NsZWFyOmJvdGg7b3BhY2l0eTouNTstd2Via2l0LXVzZXItc2VsZWN0Om5vbmU7LW1vei11c2VyLXNlbGVjdDpub25lOy1tcy11c2VyLXNlbGVjdDpub25lO3VzZXItc2VsZWN0Om5vbmU7cG9pbnRlci1ldmVudHM6bm9uZX0uYW50LXNwaW4tYmx1cjphZnRlcntvcGFjaXR5Oi40O3BvaW50ZXItZXZlbnRzOmF1dG99LmFudC1zcGluLXRpcHtjb2xvcjpyZ2JhKDAsMCwwLC40NSl9LmFudC1zcGluLWRvdHtwb3NpdGlvbjpyZWxhdGl2ZTtkaXNwbGF5OmlubGluZS1ibG9jaztmb250LXNpemU6MjBweDt3aWR0aDoxZW07aGVpZ2h0OjFlbX0uYW50LXNwaW4tZG90LWl0ZW17cG9zaXRpb246YWJzb2x1dGU7ZGlzcGxheTpibG9jazt3aWR0aDo5cHg7aGVpZ2h0OjlweDtiYWNrZ3JvdW5kLWNvbG9yOiMxODkwZmY7Ym9yZGVyLXJhZGl1czoxMDAlO3RyYW5zZm9ybTpzY2FsZSguNzUpO3RyYW5zZm9ybS1vcmlnaW46NTAlIDUwJTtvcGFjaXR5Oi4zO2FuaW1hdGlvbjphbnRTcGluTW92ZSAxcyBsaW5lYXIgaW5maW5pdGUgYWx0ZXJuYXRlfS5hbnQtc3Bpbi1kb3QtaXRlbTpmaXJzdC1jaGlsZHt0b3A6MDtsZWZ0OjB9LmFudC1zcGluLWRvdC1pdGVtOm50aC1jaGlsZCgyKXt0b3A6MDtyaWdodDowO2FuaW1hdGlvbi1kZWxheTouNHN9LmFudC1zcGluLWRvdC1pdGVtOm50aC1jaGlsZCgzKXtyaWdodDowO2JvdHRvbTowO2FuaW1hdGlvbi1kZWxheTouOHN9LmFudC1zcGluLWRvdC1pdGVtOm50aC1jaGlsZCg0KXtib3R0b206MDtsZWZ0OjA7YW5pbWF0aW9uLWRlbGF5OjEuMnN9LmFudC1zcGluLWRvdC1zcGlue3RyYW5zZm9ybTpyb3RhdGUoMGRlZyk7YW5pbWF0aW9uOmFudFJvdGF0ZSAxLjJzIGxpbmVhciBpbmZpbml0ZX0uYW50LXNwaW4tc20gLmFudC1zcGluLWRvdHtmb250LXNpemU6MTRweH0uYW50LXNwaW4tc20gLmFudC1zcGluLWRvdCBpe3dpZHRoOjZweDtoZWlnaHQ6NnB4fS5hbnQtc3Bpbi1sZyAuYW50LXNwaW4tZG90e2ZvbnQtc2l6ZTozMnB4fS5hbnQtc3Bpbi1sZyAuYW50LXNwaW4tZG90IGl7d2lkdGg6MTRweDtoZWlnaHQ6MTRweH0uYW50LXNwaW4uYW50LXNwaW4tc2hvdy10ZXh0IC5hbnQtc3Bpbi10ZXh0e2Rpc3BsYXk6YmxvY2t9QG1lZGlhICgtbXMtaGlnaC1jb250cmFzdDphY3RpdmUpLCgtbXMtaGlnaC1jb250cmFzdDpub25lKXsuYW50LXNwaW4tYmx1cntiYWNrZ3JvdW5kOiNmZmY7b3BhY2l0eTouNX19QGtleWZyYW1lcyBhbnRTcGluTW92ZXt0b3tvcGFjaXR5OjF9fUBrZXlmcmFtZXMgYW50Um90YXRle3Rve3RyYW5zZm9ybTpyb3RhdGUoMXR1cm4pfX0uYW50LXNwaW4tcnRse2RpcmVjdGlvbjpydGx9LmFudC1zcGluLXJ0bCAuYW50LXNwaW4tZG90LXNwaW57dHJhbnNmb3JtOnJvdGF0ZSgtNDVkZWcpO2FuaW1hdGlvbi1uYW1lOmFudFJvdGF0ZVJ0bH1Aa2V5ZnJhbWVzIGFudFJvdGF0ZVJ0bHt0b3t0cmFuc2Zvcm06cm90YXRlKC00MDVkZWcpfX0uYW50LXN0YXRpc3RpY3tib3gtc2l6aW5nOmJvcmRlci1ib3g7bWFyZ2luOjA7cGFkZGluZzowO2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtmb250LXNpemU6MTRweDtmb250LXZhcmlhbnQ6dGFidWxhci1udW1zO2xpbmUtaGVpZ2h0OjEuNTcxNTtsaXN0LXN0eWxlOm5vbmU7Zm9udC1mZWF0dXJlLXNldHRpbmdzOlwidG51bVwifS5hbnQtc3RhdGlzdGljLXRpdGxle21hcmdpbi1ib3R0b206NHB4O2NvbG9yOnJnYmEoMCwwLDAsLjQ1KTtmb250LXNpemU6MTRweH0uYW50LXN0YXRpc3RpYy1za2VsZXRvbntwYWRkaW5nLXRvcDoxNnB4fS5hbnQtc3RhdGlzdGljLWNvbnRlbnR7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtc2l6ZToyNHB4O2ZvbnQtZmFtaWx5Oi1hcHBsZS1zeXN0ZW0sQmxpbmtNYWNTeXN0ZW1Gb250LFNlZ29lIFVJLFJvYm90byxIZWx2ZXRpY2EgTmV1ZSxBcmlhbCxOb3RvIFNhbnMsc2Fucy1zZXJpZixBcHBsZSBDb2xvciBFbW9qaSxTZWdvZSBVSSBFbW9qaSxTZWdvZSBVSSBTeW1ib2wsTm90byBDb2xvciBFbW9qaX0uYW50LXN0YXRpc3RpYy1jb250ZW50LXZhbHVle2Rpc3BsYXk6aW5saW5lLWJsb2NrO2RpcmVjdGlvbjpsdHJ9LmFudC1zdGF0aXN0aWMtY29udGVudC1wcmVmaXgsLmFudC1zdGF0aXN0aWMtY29udGVudC1zdWZmaXh7ZGlzcGxheTppbmxpbmUtYmxvY2t9LmFudC1zdGF0aXN0aWMtY29udGVudC1wcmVmaXh7bWFyZ2luLXJpZ2h0OjRweH0uYW50LXN0YXRpc3RpYy1jb250ZW50LXN1ZmZpeHttYXJnaW4tbGVmdDo0cHh9LmFudC1zdGF0aXN0aWMtcnRse2RpcmVjdGlvbjpydGx9LmFudC1zdGF0aXN0aWMtcnRsIC5hbnQtc3RhdGlzdGljLWNvbnRlbnQtcHJlZml4e21hcmdpbi1yaWdodDowO21hcmdpbi1sZWZ0OjRweH0uYW50LXN0YXRpc3RpYy1ydGwgLmFudC1zdGF0aXN0aWMtY29udGVudC1zdWZmaXh7bWFyZ2luLXJpZ2h0OjRweDttYXJnaW4tbGVmdDowfS5hbnQtc3RlcHN7Ym94LXNpemluZzpib3JkZXItYm94O21hcmdpbjowO3BhZGRpbmc6MDtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7Zm9udC1zaXplOjE0cHg7Zm9udC12YXJpYW50OnRhYnVsYXItbnVtcztsaW5lLWhlaWdodDoxLjU3MTU7bGlzdC1zdHlsZTpub25lO2ZvbnQtZmVhdHVyZS1zZXR0aW5nczpcInRudW1cIjtkaXNwbGF5OmZsZXg7d2lkdGg6MTAwJTtmb250LXNpemU6MDt0ZXh0LWFsaWduOmluaXRpYWx9LmFudC1zdGVwcy1pdGVte3Bvc2l0aW9uOnJlbGF0aXZlO2Rpc3BsYXk6aW5saW5lLWJsb2NrO2ZsZXg6MTtvdmVyZmxvdzpoaWRkZW47dmVydGljYWwtYWxpZ246dG9wfS5hbnQtc3RlcHMtaXRlbS1jb250YWluZXJ7b3V0bGluZTpub25lfS5hbnQtc3RlcHMtaXRlbTpsYXN0LWNoaWxke2ZsZXg6bm9uZX0uYW50LXN0ZXBzLWl0ZW06bGFzdC1jaGlsZD4uYW50LXN0ZXBzLWl0ZW0tY29udGFpbmVyPi5hbnQtc3RlcHMtaXRlbS1jb250ZW50Pi5hbnQtc3RlcHMtaXRlbS10aXRsZTphZnRlciwuYW50LXN0ZXBzLWl0ZW06bGFzdC1jaGlsZD4uYW50LXN0ZXBzLWl0ZW0tY29udGFpbmVyPi5hbnQtc3RlcHMtaXRlbS10YWlse2Rpc3BsYXk6bm9uZX0uYW50LXN0ZXBzLWl0ZW0tY29udGVudCwuYW50LXN0ZXBzLWl0ZW0taWNvbntkaXNwbGF5OmlubGluZS1ibG9jazt2ZXJ0aWNhbC1hbGlnbjp0b3B9LmFudC1zdGVwcy1pdGVtLWljb257d2lkdGg6MzJweDtoZWlnaHQ6MzJweDttYXJnaW46MCA4cHggMCAwO2ZvbnQtc2l6ZToxNnB4O2ZvbnQtZmFtaWx5Oi1hcHBsZS1zeXN0ZW0sQmxpbmtNYWNTeXN0ZW1Gb250LFNlZ29lIFVJLFJvYm90byxIZWx2ZXRpY2EgTmV1ZSxBcmlhbCxOb3RvIFNhbnMsc2Fucy1zZXJpZixBcHBsZSBDb2xvciBFbW9qaSxTZWdvZSBVSSBFbW9qaSxTZWdvZSBVSSBTeW1ib2wsTm90byBDb2xvciBFbW9qaTtsaW5lLWhlaWdodDozMnB4O3RleHQtYWxpZ246Y2VudGVyO2JvcmRlcjoxcHggc29saWQgcmdiYSgwLDAsMCwuMjUpO2JvcmRlci1yYWRpdXM6MzJweDt0cmFuc2l0aW9uOmJhY2tncm91bmQtY29sb3IgLjNzLGJvcmRlci1jb2xvciAuM3N9LmFudC1zdGVwcy1pdGVtLWljb24gLmFudC1zdGVwcy1pY29ue3Bvc2l0aW9uOnJlbGF0aXZlO3RvcDotLjVweDtjb2xvcjojMTg5MGZmO2xpbmUtaGVpZ2h0OjF9LmFudC1zdGVwcy1pdGVtLXRhaWx7cG9zaXRpb246YWJzb2x1dGU7dG9wOjEycHg7bGVmdDowO3dpZHRoOjEwMCU7cGFkZGluZzowIDEwcHh9LmFudC1zdGVwcy1pdGVtLXRhaWw6YWZ0ZXJ7ZGlzcGxheTppbmxpbmUtYmxvY2s7d2lkdGg6MTAwJTtoZWlnaHQ6MXB4O2JhY2tncm91bmQ6I2YwZjBmMDtib3JkZXItcmFkaXVzOjFweDt0cmFuc2l0aW9uOmJhY2tncm91bmQgLjNzO2NvbnRlbnQ6XCJcIn0uYW50LXN0ZXBzLWl0ZW0tdGl0bGV7cG9zaXRpb246cmVsYXRpdmU7ZGlzcGxheTppbmxpbmUtYmxvY2s7cGFkZGluZy1yaWdodDoxNnB4O2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtmb250LXNpemU6MTZweDtsaW5lLWhlaWdodDozMnB4fS5hbnQtc3RlcHMtaXRlbS10aXRsZTphZnRlcntwb3NpdGlvbjphYnNvbHV0ZTt0b3A6MTZweDtsZWZ0OjEwMCU7ZGlzcGxheTpibG9jazt3aWR0aDo5OTk5cHg7aGVpZ2h0OjFweDtiYWNrZ3JvdW5kOiNmMGYwZjA7Y29udGVudDpcIlwifS5hbnQtc3RlcHMtaXRlbS1zdWJ0aXRsZXtkaXNwbGF5OmlubGluZTttYXJnaW4tbGVmdDo4cHg7Zm9udC13ZWlnaHQ6NDAwfS5hbnQtc3RlcHMtaXRlbS1kZXNjcmlwdGlvbiwuYW50LXN0ZXBzLWl0ZW0tc3VidGl0bGV7Y29sb3I6cmdiYSgwLDAsMCwuNDUpO2ZvbnQtc2l6ZToxNHB4fS5hbnQtc3RlcHMtaXRlbS13YWl0IC5hbnQtc3RlcHMtaXRlbS1pY29ue2JhY2tncm91bmQtY29sb3I6I2ZmZjtib3JkZXItY29sb3I6cmdiYSgwLDAsMCwuMjUpfS5hbnQtc3RlcHMtaXRlbS13YWl0IC5hbnQtc3RlcHMtaXRlbS1pY29uPi5hbnQtc3RlcHMtaWNvbntjb2xvcjpyZ2JhKDAsMCwwLC4yNSl9LmFudC1zdGVwcy1pdGVtLXdhaXQgLmFudC1zdGVwcy1pdGVtLWljb24+LmFudC1zdGVwcy1pY29uIC5hbnQtc3RlcHMtaWNvbi1kb3R7YmFja2dyb3VuZDpyZ2JhKDAsMCwwLC4yNSl9LmFudC1zdGVwcy1pdGVtLXdhaXQ+LmFudC1zdGVwcy1pdGVtLWNvbnRhaW5lcj4uYW50LXN0ZXBzLWl0ZW0tY29udGVudD4uYW50LXN0ZXBzLWl0ZW0tdGl0bGV7Y29sb3I6cmdiYSgwLDAsMCwuNDUpfS5hbnQtc3RlcHMtaXRlbS13YWl0Pi5hbnQtc3RlcHMtaXRlbS1jb250YWluZXI+LmFudC1zdGVwcy1pdGVtLWNvbnRlbnQ+LmFudC1zdGVwcy1pdGVtLXRpdGxlOmFmdGVye2JhY2tncm91bmQtY29sb3I6I2YwZjBmMH0uYW50LXN0ZXBzLWl0ZW0td2FpdD4uYW50LXN0ZXBzLWl0ZW0tY29udGFpbmVyPi5hbnQtc3RlcHMtaXRlbS1jb250ZW50Pi5hbnQtc3RlcHMtaXRlbS1kZXNjcmlwdGlvbntjb2xvcjpyZ2JhKDAsMCwwLC40NSl9LmFudC1zdGVwcy1pdGVtLXdhaXQ+LmFudC1zdGVwcy1pdGVtLWNvbnRhaW5lcj4uYW50LXN0ZXBzLWl0ZW0tdGFpbDphZnRlcntiYWNrZ3JvdW5kLWNvbG9yOiNmMGYwZjB9LmFudC1zdGVwcy1pdGVtLXByb2Nlc3MgLmFudC1zdGVwcy1pdGVtLWljb257YmFja2dyb3VuZC1jb2xvcjojZmZmO2JvcmRlci1jb2xvcjojMTg5MGZmfS5hbnQtc3RlcHMtaXRlbS1wcm9jZXNzIC5hbnQtc3RlcHMtaXRlbS1pY29uPi5hbnQtc3RlcHMtaWNvbntjb2xvcjojMTg5MGZmfS5hbnQtc3RlcHMtaXRlbS1wcm9jZXNzIC5hbnQtc3RlcHMtaXRlbS1pY29uPi5hbnQtc3RlcHMtaWNvbiAuYW50LXN0ZXBzLWljb24tZG90e2JhY2tncm91bmQ6IzE4OTBmZn0uYW50LXN0ZXBzLWl0ZW0tcHJvY2Vzcz4uYW50LXN0ZXBzLWl0ZW0tY29udGFpbmVyPi5hbnQtc3RlcHMtaXRlbS1jb250ZW50Pi5hbnQtc3RlcHMtaXRlbS10aXRsZXtjb2xvcjpyZ2JhKDAsMCwwLC44NSl9LmFudC1zdGVwcy1pdGVtLXByb2Nlc3M+LmFudC1zdGVwcy1pdGVtLWNvbnRhaW5lcj4uYW50LXN0ZXBzLWl0ZW0tY29udGVudD4uYW50LXN0ZXBzLWl0ZW0tdGl0bGU6YWZ0ZXJ7YmFja2dyb3VuZC1jb2xvcjojZjBmMGYwfS5hbnQtc3RlcHMtaXRlbS1wcm9jZXNzPi5hbnQtc3RlcHMtaXRlbS1jb250YWluZXI+LmFudC1zdGVwcy1pdGVtLWNvbnRlbnQ+LmFudC1zdGVwcy1pdGVtLWRlc2NyaXB0aW9ue2NvbG9yOnJnYmEoMCwwLDAsLjg1KX0uYW50LXN0ZXBzLWl0ZW0tcHJvY2Vzcz4uYW50LXN0ZXBzLWl0ZW0tY29udGFpbmVyPi5hbnQtc3RlcHMtaXRlbS10YWlsOmFmdGVye2JhY2tncm91bmQtY29sb3I6I2YwZjBmMH0uYW50LXN0ZXBzLWl0ZW0tcHJvY2Vzcz4uYW50LXN0ZXBzLWl0ZW0tY29udGFpbmVyPi5hbnQtc3RlcHMtaXRlbS1pY29ue2JhY2tncm91bmQ6IzE4OTBmZn0uYW50LXN0ZXBzLWl0ZW0tcHJvY2Vzcz4uYW50LXN0ZXBzLWl0ZW0tY29udGFpbmVyPi5hbnQtc3RlcHMtaXRlbS1pY29uIC5hbnQtc3RlcHMtaWNvbntjb2xvcjojZmZmfS5hbnQtc3RlcHMtaXRlbS1wcm9jZXNzPi5hbnQtc3RlcHMtaXRlbS1jb250YWluZXI+LmFudC1zdGVwcy1pdGVtLXRpdGxle2ZvbnQtd2VpZ2h0OjUwMH0uYW50LXN0ZXBzLWl0ZW0tZmluaXNoIC5hbnQtc3RlcHMtaXRlbS1pY29ue2JhY2tncm91bmQtY29sb3I6I2ZmZjtib3JkZXItY29sb3I6IzE4OTBmZn0uYW50LXN0ZXBzLWl0ZW0tZmluaXNoIC5hbnQtc3RlcHMtaXRlbS1pY29uPi5hbnQtc3RlcHMtaWNvbntjb2xvcjojMTg5MGZmfS5hbnQtc3RlcHMtaXRlbS1maW5pc2ggLmFudC1zdGVwcy1pdGVtLWljb24+LmFudC1zdGVwcy1pY29uIC5hbnQtc3RlcHMtaWNvbi1kb3R7YmFja2dyb3VuZDojMTg5MGZmfS5hbnQtc3RlcHMtaXRlbS1maW5pc2g+LmFudC1zdGVwcy1pdGVtLWNvbnRhaW5lcj4uYW50LXN0ZXBzLWl0ZW0tY29udGVudD4uYW50LXN0ZXBzLWl0ZW0tdGl0bGV7Y29sb3I6cmdiYSgwLDAsMCwuODUpfS5hbnQtc3RlcHMtaXRlbS1maW5pc2g+LmFudC1zdGVwcy1pdGVtLWNvbnRhaW5lcj4uYW50LXN0ZXBzLWl0ZW0tY29udGVudD4uYW50LXN0ZXBzLWl0ZW0tdGl0bGU6YWZ0ZXJ7YmFja2dyb3VuZC1jb2xvcjojMTg5MGZmfS5hbnQtc3RlcHMtaXRlbS1maW5pc2g+LmFudC1zdGVwcy1pdGVtLWNvbnRhaW5lcj4uYW50LXN0ZXBzLWl0ZW0tY29udGVudD4uYW50LXN0ZXBzLWl0ZW0tZGVzY3JpcHRpb257Y29sb3I6cmdiYSgwLDAsMCwuNDUpfS5hbnQtc3RlcHMtaXRlbS1maW5pc2g+LmFudC1zdGVwcy1pdGVtLWNvbnRhaW5lcj4uYW50LXN0ZXBzLWl0ZW0tdGFpbDphZnRlcntiYWNrZ3JvdW5kLWNvbG9yOiMxODkwZmZ9LmFudC1zdGVwcy1pdGVtLWVycm9yIC5hbnQtc3RlcHMtaXRlbS1pY29ue2JhY2tncm91bmQtY29sb3I6I2ZmZjtib3JkZXItY29sb3I6I2ZmNGQ0Zn0uYW50LXN0ZXBzLWl0ZW0tZXJyb3IgLmFudC1zdGVwcy1pdGVtLWljb24+LmFudC1zdGVwcy1pY29ue2NvbG9yOiNmZjRkNGZ9LmFudC1zdGVwcy1pdGVtLWVycm9yIC5hbnQtc3RlcHMtaXRlbS1pY29uPi5hbnQtc3RlcHMtaWNvbiAuYW50LXN0ZXBzLWljb24tZG90e2JhY2tncm91bmQ6I2ZmNGQ0Zn0uYW50LXN0ZXBzLWl0ZW0tZXJyb3I+LmFudC1zdGVwcy1pdGVtLWNvbnRhaW5lcj4uYW50LXN0ZXBzLWl0ZW0tY29udGVudD4uYW50LXN0ZXBzLWl0ZW0tdGl0bGV7Y29sb3I6I2ZmNGQ0Zn0uYW50LXN0ZXBzLWl0ZW0tZXJyb3I+LmFudC1zdGVwcy1pdGVtLWNvbnRhaW5lcj4uYW50LXN0ZXBzLWl0ZW0tY29udGVudD4uYW50LXN0ZXBzLWl0ZW0tdGl0bGU6YWZ0ZXJ7YmFja2dyb3VuZC1jb2xvcjojZjBmMGYwfS5hbnQtc3RlcHMtaXRlbS1lcnJvcj4uYW50LXN0ZXBzLWl0ZW0tY29udGFpbmVyPi5hbnQtc3RlcHMtaXRlbS1jb250ZW50Pi5hbnQtc3RlcHMtaXRlbS1kZXNjcmlwdGlvbntjb2xvcjojZmY0ZDRmfS5hbnQtc3RlcHMtaXRlbS1lcnJvcj4uYW50LXN0ZXBzLWl0ZW0tY29udGFpbmVyPi5hbnQtc3RlcHMtaXRlbS10YWlsOmFmdGVye2JhY2tncm91bmQtY29sb3I6I2YwZjBmMH0uYW50LXN0ZXBzLWl0ZW0uYW50LXN0ZXBzLW5leHQtZXJyb3IgLmFudC1zdGVwcy1pdGVtLXRpdGxlOmFmdGVye2JhY2tncm91bmQ6I2ZmNGQ0Zn0uYW50LXN0ZXBzLWl0ZW0tZGlzYWJsZWR7Y3Vyc29yOm5vdC1hbGxvd2VkfS5hbnQtc3RlcHMgLmFudC1zdGVwcy1pdGVtOm5vdCguYW50LXN0ZXBzLWl0ZW0tYWN0aXZlKT4uYW50LXN0ZXBzLWl0ZW0tY29udGFpbmVyW3JvbGU9YnV0dG9uXXtjdXJzb3I6cG9pbnRlcn0uYW50LXN0ZXBzIC5hbnQtc3RlcHMtaXRlbTpub3QoLmFudC1zdGVwcy1pdGVtLWFjdGl2ZSk+LmFudC1zdGVwcy1pdGVtLWNvbnRhaW5lcltyb2xlPWJ1dHRvbl0gLmFudC1zdGVwcy1pdGVtLWRlc2NyaXB0aW9uLC5hbnQtc3RlcHMgLmFudC1zdGVwcy1pdGVtOm5vdCguYW50LXN0ZXBzLWl0ZW0tYWN0aXZlKT4uYW50LXN0ZXBzLWl0ZW0tY29udGFpbmVyW3JvbGU9YnV0dG9uXSAuYW50LXN0ZXBzLWl0ZW0taWNvbiAuYW50LXN0ZXBzLWljb24sLmFudC1zdGVwcyAuYW50LXN0ZXBzLWl0ZW06bm90KC5hbnQtc3RlcHMtaXRlbS1hY3RpdmUpPi5hbnQtc3RlcHMtaXRlbS1jb250YWluZXJbcm9sZT1idXR0b25dIC5hbnQtc3RlcHMtaXRlbS1zdWJ0aXRsZSwuYW50LXN0ZXBzIC5hbnQtc3RlcHMtaXRlbTpub3QoLmFudC1zdGVwcy1pdGVtLWFjdGl2ZSk+LmFudC1zdGVwcy1pdGVtLWNvbnRhaW5lcltyb2xlPWJ1dHRvbl0gLmFudC1zdGVwcy1pdGVtLXRpdGxle3RyYW5zaXRpb246Y29sb3IgLjNzfS5hbnQtc3RlcHMgLmFudC1zdGVwcy1pdGVtOm5vdCguYW50LXN0ZXBzLWl0ZW0tYWN0aXZlKT4uYW50LXN0ZXBzLWl0ZW0tY29udGFpbmVyW3JvbGU9YnV0dG9uXTpob3ZlciAuYW50LXN0ZXBzLWl0ZW0tZGVzY3JpcHRpb24sLmFudC1zdGVwcyAuYW50LXN0ZXBzLWl0ZW06bm90KC5hbnQtc3RlcHMtaXRlbS1hY3RpdmUpPi5hbnQtc3RlcHMtaXRlbS1jb250YWluZXJbcm9sZT1idXR0b25dOmhvdmVyIC5hbnQtc3RlcHMtaXRlbS1zdWJ0aXRsZSwuYW50LXN0ZXBzIC5hbnQtc3RlcHMtaXRlbTpub3QoLmFudC1zdGVwcy1pdGVtLWFjdGl2ZSk+LmFudC1zdGVwcy1pdGVtLWNvbnRhaW5lcltyb2xlPWJ1dHRvbl06aG92ZXIgLmFudC1zdGVwcy1pdGVtLXRpdGxle2NvbG9yOiMxODkwZmZ9LmFudC1zdGVwcyAuYW50LXN0ZXBzLWl0ZW06bm90KC5hbnQtc3RlcHMtaXRlbS1hY3RpdmUpOm5vdCguYW50LXN0ZXBzLWl0ZW0tcHJvY2Vzcyk+LmFudC1zdGVwcy1pdGVtLWNvbnRhaW5lcltyb2xlPWJ1dHRvbl06aG92ZXIgLmFudC1zdGVwcy1pdGVtLWljb257Ym9yZGVyLWNvbG9yOiMxODkwZmZ9LmFudC1zdGVwcyAuYW50LXN0ZXBzLWl0ZW06bm90KC5hbnQtc3RlcHMtaXRlbS1hY3RpdmUpOm5vdCguYW50LXN0ZXBzLWl0ZW0tcHJvY2Vzcyk+LmFudC1zdGVwcy1pdGVtLWNvbnRhaW5lcltyb2xlPWJ1dHRvbl06aG92ZXIgLmFudC1zdGVwcy1pdGVtLWljb24gLmFudC1zdGVwcy1pY29ue2NvbG9yOiMxODkwZmZ9LmFudC1zdGVwcy1ob3Jpem9udGFsOm5vdCguYW50LXN0ZXBzLWxhYmVsLXZlcnRpY2FsKSAuYW50LXN0ZXBzLWl0ZW17cGFkZGluZy1sZWZ0OjE2cHg7d2hpdGUtc3BhY2U6bm93cmFwfS5hbnQtc3RlcHMtaG9yaXpvbnRhbDpub3QoLmFudC1zdGVwcy1sYWJlbC12ZXJ0aWNhbCkgLmFudC1zdGVwcy1pdGVtOmZpcnN0LWNoaWxke3BhZGRpbmctbGVmdDowfS5hbnQtc3RlcHMtaG9yaXpvbnRhbDpub3QoLmFudC1zdGVwcy1sYWJlbC12ZXJ0aWNhbCkgLmFudC1zdGVwcy1pdGVtOmxhc3QtY2hpbGQgLmFudC1zdGVwcy1pdGVtLXRpdGxle3BhZGRpbmctcmlnaHQ6MH0uYW50LXN0ZXBzLWhvcml6b250YWw6bm90KC5hbnQtc3RlcHMtbGFiZWwtdmVydGljYWwpIC5hbnQtc3RlcHMtaXRlbS10YWlse2Rpc3BsYXk6bm9uZX0uYW50LXN0ZXBzLWhvcml6b250YWw6bm90KC5hbnQtc3RlcHMtbGFiZWwtdmVydGljYWwpIC5hbnQtc3RlcHMtaXRlbS1kZXNjcmlwdGlvbnttYXgtd2lkdGg6MTQwcHg7d2hpdGUtc3BhY2U6bm9ybWFsfS5hbnQtc3RlcHMtaXRlbS1jdXN0b20+LmFudC1zdGVwcy1pdGVtLWNvbnRhaW5lcj4uYW50LXN0ZXBzLWl0ZW0taWNvbntoZWlnaHQ6YXV0bztiYWNrZ3JvdW5kOm5vbmU7Ym9yZGVyOjB9LmFudC1zdGVwcy1pdGVtLWN1c3RvbT4uYW50LXN0ZXBzLWl0ZW0tY29udGFpbmVyPi5hbnQtc3RlcHMtaXRlbS1pY29uPi5hbnQtc3RlcHMtaWNvbnt0b3A6MDtsZWZ0Oi41cHg7d2lkdGg6MzJweDtoZWlnaHQ6MzJweDtmb250LXNpemU6MjRweDtsaW5lLWhlaWdodDozMnB4fS5hbnQtc3RlcHMtaXRlbS1jdXN0b20uYW50LXN0ZXBzLWl0ZW0tcHJvY2VzcyAuYW50LXN0ZXBzLWl0ZW0taWNvbj4uYW50LXN0ZXBzLWljb257Y29sb3I6IzE4OTBmZn0uYW50LXN0ZXBzOm5vdCguYW50LXN0ZXBzLXZlcnRpY2FsKSAuYW50LXN0ZXBzLWl0ZW0tY3VzdG9tIC5hbnQtc3RlcHMtaXRlbS1pY29ue3dpZHRoOmF1dG87YmFja2dyb3VuZDpub25lfS5hbnQtc3RlcHMtc21hbGwuYW50LXN0ZXBzLWhvcml6b250YWw6bm90KC5hbnQtc3RlcHMtbGFiZWwtdmVydGljYWwpIC5hbnQtc3RlcHMtaXRlbXtwYWRkaW5nLWxlZnQ6MTJweH0uYW50LXN0ZXBzLXNtYWxsLmFudC1zdGVwcy1ob3Jpem9udGFsOm5vdCguYW50LXN0ZXBzLWxhYmVsLXZlcnRpY2FsKSAuYW50LXN0ZXBzLWl0ZW06Zmlyc3QtY2hpbGR7cGFkZGluZy1sZWZ0OjB9LmFudC1zdGVwcy1zbWFsbCAuYW50LXN0ZXBzLWl0ZW0taWNvbnt3aWR0aDoyNHB4O2hlaWdodDoyNHB4O21hcmdpbjowIDhweCAwIDA7Zm9udC1zaXplOjEycHg7bGluZS1oZWlnaHQ6MjRweDt0ZXh0LWFsaWduOmNlbnRlcjtib3JkZXItcmFkaXVzOjI0cHh9LmFudC1zdGVwcy1zbWFsbCAuYW50LXN0ZXBzLWl0ZW0tdGl0bGV7cGFkZGluZy1yaWdodDoxMnB4O2ZvbnQtc2l6ZToxNHB4O2xpbmUtaGVpZ2h0OjI0cHh9LmFudC1zdGVwcy1zbWFsbCAuYW50LXN0ZXBzLWl0ZW0tdGl0bGU6YWZ0ZXJ7dG9wOjEycHh9LmFudC1zdGVwcy1zbWFsbCAuYW50LXN0ZXBzLWl0ZW0tZGVzY3JpcHRpb257Y29sb3I6cmdiYSgwLDAsMCwuNDUpO2ZvbnQtc2l6ZToxNHB4fS5hbnQtc3RlcHMtc21hbGwgLmFudC1zdGVwcy1pdGVtLXRhaWx7dG9wOjhweH0uYW50LXN0ZXBzLXNtYWxsIC5hbnQtc3RlcHMtaXRlbS1jdXN0b20gLmFudC1zdGVwcy1pdGVtLWljb257d2lkdGg6aW5oZXJpdDtoZWlnaHQ6aW5oZXJpdDtsaW5lLWhlaWdodDppbmhlcml0O2JhY2tncm91bmQ6bm9uZTtib3JkZXI6MDtib3JkZXItcmFkaXVzOjB9LmFudC1zdGVwcy1zbWFsbCAuYW50LXN0ZXBzLWl0ZW0tY3VzdG9tIC5hbnQtc3RlcHMtaXRlbS1pY29uPi5hbnQtc3RlcHMtaWNvbntmb250LXNpemU6MjRweDtsaW5lLWhlaWdodDoyNHB4O3RyYW5zZm9ybTpub25lfS5hbnQtc3RlcHMtdmVydGljYWx7ZGlzcGxheTpmbGV4O2ZsZXgtZGlyZWN0aW9uOmNvbHVtbn0uYW50LXN0ZXBzLXZlcnRpY2FsPi5hbnQtc3RlcHMtaXRlbXtkaXNwbGF5OmJsb2NrO2ZsZXg6MSAwIGF1dG87cGFkZGluZy1sZWZ0OjA7b3ZlcmZsb3c6dmlzaWJsZX0uYW50LXN0ZXBzLXZlcnRpY2FsPi5hbnQtc3RlcHMtaXRlbSAuYW50LXN0ZXBzLWl0ZW0taWNvbntmbG9hdDpsZWZ0O21hcmdpbi1yaWdodDoxNnB4fS5hbnQtc3RlcHMtdmVydGljYWw+LmFudC1zdGVwcy1pdGVtIC5hbnQtc3RlcHMtaXRlbS1jb250ZW50e2Rpc3BsYXk6YmxvY2s7bWluLWhlaWdodDo0OHB4O292ZXJmbG93OmhpZGRlbn0uYW50LXN0ZXBzLXZlcnRpY2FsPi5hbnQtc3RlcHMtaXRlbSAuYW50LXN0ZXBzLWl0ZW0tdGl0bGV7bGluZS1oZWlnaHQ6MzJweH0uYW50LXN0ZXBzLXZlcnRpY2FsPi5hbnQtc3RlcHMtaXRlbSAuYW50LXN0ZXBzLWl0ZW0tZGVzY3JpcHRpb257cGFkZGluZy1ib3R0b206MTJweH0uYW50LXN0ZXBzLXZlcnRpY2FsPi5hbnQtc3RlcHMtaXRlbT4uYW50LXN0ZXBzLWl0ZW0tY29udGFpbmVyPi5hbnQtc3RlcHMtaXRlbS10YWlse3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO2xlZnQ6MTVweDt3aWR0aDoxcHg7aGVpZ2h0OjEwMCU7cGFkZGluZzozOHB4IDAgNnB4fS5hbnQtc3RlcHMtdmVydGljYWw+LmFudC1zdGVwcy1pdGVtPi5hbnQtc3RlcHMtaXRlbS1jb250YWluZXI+LmFudC1zdGVwcy1pdGVtLXRhaWw6YWZ0ZXJ7d2lkdGg6MXB4O2hlaWdodDoxMDAlfS5hbnQtc3RlcHMtdmVydGljYWw+LmFudC1zdGVwcy1pdGVtOm5vdCg6bGFzdC1jaGlsZCk+LmFudC1zdGVwcy1pdGVtLWNvbnRhaW5lcj4uYW50LXN0ZXBzLWl0ZW0tdGFpbHtkaXNwbGF5OmJsb2NrfS5hbnQtc3RlcHMtdmVydGljYWw+LmFudC1zdGVwcy1pdGVtPi5hbnQtc3RlcHMtaXRlbS1jb250YWluZXI+LmFudC1zdGVwcy1pdGVtLWNvbnRlbnQ+LmFudC1zdGVwcy1pdGVtLXRpdGxlOmFmdGVye2Rpc3BsYXk6bm9uZX0uYW50LXN0ZXBzLXZlcnRpY2FsLmFudC1zdGVwcy1zbWFsbCAuYW50LXN0ZXBzLWl0ZW0tY29udGFpbmVyIC5hbnQtc3RlcHMtaXRlbS10YWlse3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO2xlZnQ6MTFweDtwYWRkaW5nOjMwcHggMCA2cHh9LmFudC1zdGVwcy12ZXJ0aWNhbC5hbnQtc3RlcHMtc21hbGwgLmFudC1zdGVwcy1pdGVtLWNvbnRhaW5lciAuYW50LXN0ZXBzLWl0ZW0tdGl0bGV7bGluZS1oZWlnaHQ6MjRweH0uYW50LXN0ZXBzLWxhYmVsLXZlcnRpY2FsIC5hbnQtc3RlcHMtaXRlbXtvdmVyZmxvdzp2aXNpYmxlfS5hbnQtc3RlcHMtbGFiZWwtdmVydGljYWwgLmFudC1zdGVwcy1pdGVtLXRhaWx7bWFyZ2luLWxlZnQ6NThweDtwYWRkaW5nOjMuNXB4IDI0cHh9LmFudC1zdGVwcy1sYWJlbC12ZXJ0aWNhbCAuYW50LXN0ZXBzLWl0ZW0tY29udGVudHtkaXNwbGF5OmJsb2NrO3dpZHRoOjExNnB4O21hcmdpbi10b3A6OHB4O3RleHQtYWxpZ246Y2VudGVyfS5hbnQtc3RlcHMtbGFiZWwtdmVydGljYWwgLmFudC1zdGVwcy1pdGVtLWljb257ZGlzcGxheTppbmxpbmUtYmxvY2s7bWFyZ2luLWxlZnQ6NDJweH0uYW50LXN0ZXBzLWxhYmVsLXZlcnRpY2FsIC5hbnQtc3RlcHMtaXRlbS10aXRsZXtwYWRkaW5nLXJpZ2h0OjA7cGFkZGluZy1sZWZ0OjB9LmFudC1zdGVwcy1sYWJlbC12ZXJ0aWNhbCAuYW50LXN0ZXBzLWl0ZW0tdGl0bGU6YWZ0ZXJ7ZGlzcGxheTpub25lfS5hbnQtc3RlcHMtbGFiZWwtdmVydGljYWwgLmFudC1zdGVwcy1pdGVtLXN1YnRpdGxle2Rpc3BsYXk6YmxvY2s7bWFyZ2luLWJvdHRvbTo0cHg7bWFyZ2luLWxlZnQ6MDtsaW5lLWhlaWdodDoxLjU3MTV9LmFudC1zdGVwcy1sYWJlbC12ZXJ0aWNhbC5hbnQtc3RlcHMtc21hbGw6bm90KC5hbnQtc3RlcHMtZG90KSAuYW50LXN0ZXBzLWl0ZW0taWNvbnttYXJnaW4tbGVmdDo0NnB4fS5hbnQtc3RlcHMtZG90IC5hbnQtc3RlcHMtaXRlbS10aXRsZSwuYW50LXN0ZXBzLWRvdC5hbnQtc3RlcHMtc21hbGwgLmFudC1zdGVwcy1pdGVtLXRpdGxle2xpbmUtaGVpZ2h0OjEuNTcxNX0uYW50LXN0ZXBzLWRvdCAuYW50LXN0ZXBzLWl0ZW0tdGFpbCwuYW50LXN0ZXBzLWRvdC5hbnQtc3RlcHMtc21hbGwgLmFudC1zdGVwcy1pdGVtLXRhaWx7dG9wOjJweDt3aWR0aDoxMDAlO21hcmdpbjowIDAgMCA3MHB4O3BhZGRpbmc6MH0uYW50LXN0ZXBzLWRvdCAuYW50LXN0ZXBzLWl0ZW0tdGFpbDphZnRlciwuYW50LXN0ZXBzLWRvdC5hbnQtc3RlcHMtc21hbGwgLmFudC1zdGVwcy1pdGVtLXRhaWw6YWZ0ZXJ7d2lkdGg6Y2FsYygxMDAlIC0gMjBweCk7aGVpZ2h0OjNweDttYXJnaW4tbGVmdDoxMnB4fS5hbnQtc3RlcHMtZG90IC5hbnQtc3RlcHMtaXRlbTpmaXJzdC1jaGlsZCAuYW50LXN0ZXBzLWljb24tZG90LC5hbnQtc3RlcHMtZG90LmFudC1zdGVwcy1zbWFsbCAuYW50LXN0ZXBzLWl0ZW06Zmlyc3QtY2hpbGQgLmFudC1zdGVwcy1pY29uLWRvdHtsZWZ0OjJweH0uYW50LXN0ZXBzLWRvdCAuYW50LXN0ZXBzLWl0ZW0taWNvbiwuYW50LXN0ZXBzLWRvdC5hbnQtc3RlcHMtc21hbGwgLmFudC1zdGVwcy1pdGVtLWljb257d2lkdGg6OHB4O2hlaWdodDo4cHg7bWFyZ2luLWxlZnQ6NjdweDtwYWRkaW5nLXJpZ2h0OjA7bGluZS1oZWlnaHQ6OHB4O2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7Ym9yZGVyOjB9LmFudC1zdGVwcy1kb3QgLmFudC1zdGVwcy1pdGVtLWljb24gLmFudC1zdGVwcy1pY29uLWRvdCwuYW50LXN0ZXBzLWRvdC5hbnQtc3RlcHMtc21hbGwgLmFudC1zdGVwcy1pdGVtLWljb24gLmFudC1zdGVwcy1pY29uLWRvdHtwb3NpdGlvbjpyZWxhdGl2ZTtmbG9hdDpsZWZ0O3dpZHRoOjEwMCU7aGVpZ2h0OjEwMCU7Ym9yZGVyLXJhZGl1czoxMDBweDt0cmFuc2l0aW9uOmFsbCAuM3N9LmFudC1zdGVwcy1kb3QgLmFudC1zdGVwcy1pdGVtLWljb24gLmFudC1zdGVwcy1pY29uLWRvdDphZnRlciwuYW50LXN0ZXBzLWRvdC5hbnQtc3RlcHMtc21hbGwgLmFudC1zdGVwcy1pdGVtLWljb24gLmFudC1zdGVwcy1pY29uLWRvdDphZnRlcntwb3NpdGlvbjphYnNvbHV0ZTt0b3A6LTEycHg7bGVmdDotMjZweDt3aWR0aDo2MHB4O2hlaWdodDozMnB4O2JhY2tncm91bmQ6cmdiYSgwLDAsMCwuMDAxKTtjb250ZW50OlwiXCJ9LmFudC1zdGVwcy1kb3QgLmFudC1zdGVwcy1pdGVtLWNvbnRlbnQsLmFudC1zdGVwcy1kb3QuYW50LXN0ZXBzLXNtYWxsIC5hbnQtc3RlcHMtaXRlbS1jb250ZW50e3dpZHRoOjE0MHB4fS5hbnQtc3RlcHMtZG90IC5hbnQtc3RlcHMtaXRlbS1wcm9jZXNzIC5hbnQtc3RlcHMtaXRlbS1pY29uLC5hbnQtc3RlcHMtZG90LmFudC1zdGVwcy1zbWFsbCAuYW50LXN0ZXBzLWl0ZW0tcHJvY2VzcyAuYW50LXN0ZXBzLWl0ZW0taWNvbntwb3NpdGlvbjpyZWxhdGl2ZTt0b3A6LTFweDt3aWR0aDoxMHB4O2hlaWdodDoxMHB4O2xpbmUtaGVpZ2h0OjEwcHg7YmFja2dyb3VuZDpub25lfS5hbnQtc3RlcHMtZG90IC5hbnQtc3RlcHMtaXRlbS1wcm9jZXNzIC5hbnQtc3RlcHMtaWNvbjpmaXJzdC1jaGlsZCAuYW50LXN0ZXBzLWljb24tZG90LC5hbnQtc3RlcHMtZG90LmFudC1zdGVwcy1zbWFsbCAuYW50LXN0ZXBzLWl0ZW0tcHJvY2VzcyAuYW50LXN0ZXBzLWljb246Zmlyc3QtY2hpbGQgLmFudC1zdGVwcy1pY29uLWRvdHtsZWZ0OjB9LmFudC1zdGVwcy12ZXJ0aWNhbC5hbnQtc3RlcHMtZG90IC5hbnQtc3RlcHMtaXRlbS1pY29ue21hcmdpbi10b3A6MTNweDttYXJnaW4tbGVmdDowO2JhY2tncm91bmQ6bm9uZX0uYW50LXN0ZXBzLXZlcnRpY2FsLmFudC1zdGVwcy1kb3QgLmFudC1zdGVwcy1pdGVtPi5hbnQtc3RlcHMtaXRlbS1jb250YWluZXI+LmFudC1zdGVwcy1pdGVtLXRhaWx7dG9wOjYuNXB4O2xlZnQ6LTlweDttYXJnaW46MDtwYWRkaW5nOjIycHggMCA0cHh9LmFudC1zdGVwcy12ZXJ0aWNhbC5hbnQtc3RlcHMtZG90LmFudC1zdGVwcy1zbWFsbCAuYW50LXN0ZXBzLWl0ZW0taWNvbnttYXJnaW4tdG9wOjEwcHh9LmFudC1zdGVwcy12ZXJ0aWNhbC5hbnQtc3RlcHMtZG90LmFudC1zdGVwcy1zbWFsbCAuYW50LXN0ZXBzLWl0ZW0+LmFudC1zdGVwcy1pdGVtLWNvbnRhaW5lcj4uYW50LXN0ZXBzLWl0ZW0tdGFpbHt0b3A6My41cHh9LmFudC1zdGVwcy12ZXJ0aWNhbC5hbnQtc3RlcHMtZG90IC5hbnQtc3RlcHMtaXRlbTpmaXJzdC1jaGlsZCAuYW50LXN0ZXBzLWljb24tZG90e2xlZnQ6MH0uYW50LXN0ZXBzLXZlcnRpY2FsLmFudC1zdGVwcy1kb3QgLmFudC1zdGVwcy1pdGVtLWNvbnRlbnR7d2lkdGg6aW5oZXJpdH0uYW50LXN0ZXBzLXZlcnRpY2FsLmFudC1zdGVwcy1kb3QgLmFudC1zdGVwcy1pdGVtLXByb2Nlc3MgLmFudC1zdGVwcy1pdGVtLWNvbnRhaW5lciAuYW50LXN0ZXBzLWl0ZW0taWNvbiAuYW50LXN0ZXBzLWljb24tZG90e3RvcDotMXB4O2xlZnQ6LTFweH0uYW50LXN0ZXBzLW5hdmlnYXRpb257cGFkZGluZy10b3A6MTJweH0uYW50LXN0ZXBzLW5hdmlnYXRpb24uYW50LXN0ZXBzLXNtYWxsIC5hbnQtc3RlcHMtaXRlbS1jb250YWluZXJ7bWFyZ2luLWxlZnQ6LTEycHh9LmFudC1zdGVwcy1uYXZpZ2F0aW9uIC5hbnQtc3RlcHMtaXRlbXtvdmVyZmxvdzp2aXNpYmxlO3RleHQtYWxpZ246Y2VudGVyfS5hbnQtc3RlcHMtbmF2aWdhdGlvbiAuYW50LXN0ZXBzLWl0ZW0tY29udGFpbmVye2Rpc3BsYXk6aW5saW5lLWJsb2NrO2hlaWdodDoxMDAlO21hcmdpbi1sZWZ0Oi0xNnB4O3BhZGRpbmctYm90dG9tOjEycHg7dGV4dC1hbGlnbjpsZWZ0O3RyYW5zaXRpb246b3BhY2l0eSAuM3N9LmFudC1zdGVwcy1uYXZpZ2F0aW9uIC5hbnQtc3RlcHMtaXRlbS1jb250YWluZXIgLmFudC1zdGVwcy1pdGVtLWNvbnRlbnR7bWF4LXdpZHRoOmF1dG99LmFudC1zdGVwcy1uYXZpZ2F0aW9uIC5hbnQtc3RlcHMtaXRlbS1jb250YWluZXIgLmFudC1zdGVwcy1pdGVtLXRpdGxle21heC13aWR0aDoxMDAlO3BhZGRpbmctcmlnaHQ6MDtvdmVyZmxvdzpoaWRkZW47d2hpdGUtc3BhY2U6bm93cmFwO3RleHQtb3ZlcmZsb3c6ZWxsaXBzaXN9LmFudC1zdGVwcy1uYXZpZ2F0aW9uIC5hbnQtc3RlcHMtaXRlbS1jb250YWluZXIgLmFudC1zdGVwcy1pdGVtLXRpdGxlOmFmdGVye2Rpc3BsYXk6bm9uZX0uYW50LXN0ZXBzLW5hdmlnYXRpb24gLmFudC1zdGVwcy1pdGVtOm5vdCguYW50LXN0ZXBzLWl0ZW0tYWN0aXZlKSAuYW50LXN0ZXBzLWl0ZW0tY29udGFpbmVyW3JvbGU9YnV0dG9uXXtjdXJzb3I6cG9pbnRlcn0uYW50LXN0ZXBzLW5hdmlnYXRpb24gLmFudC1zdGVwcy1pdGVtOm5vdCguYW50LXN0ZXBzLWl0ZW0tYWN0aXZlKSAuYW50LXN0ZXBzLWl0ZW0tY29udGFpbmVyW3JvbGU9YnV0dG9uXTpob3ZlcntvcGFjaXR5Oi44NX0uYW50LXN0ZXBzLW5hdmlnYXRpb24gLmFudC1zdGVwcy1pdGVtOmxhc3QtY2hpbGR7ZmxleDoxfS5hbnQtc3RlcHMtbmF2aWdhdGlvbiAuYW50LXN0ZXBzLWl0ZW06bGFzdC1jaGlsZDphZnRlcntkaXNwbGF5Om5vbmV9LmFudC1zdGVwcy1uYXZpZ2F0aW9uIC5hbnQtc3RlcHMtaXRlbTphZnRlcntwb3NpdGlvbjphYnNvbHV0ZTt0b3A6NTAlO2xlZnQ6MTAwJTtkaXNwbGF5OmlubGluZS1ibG9jazt3aWR0aDoxMnB4O2hlaWdodDoxMnB4O21hcmdpbi10b3A6LTE0cHg7bWFyZ2luLWxlZnQ6LTJweDtib3JkZXI6MXB4IHNvbGlkIHJnYmEoMCwwLDAsLjI1KTtib3JkZXItYm90dG9tOm5vbmU7Ym9yZGVyLWxlZnQ6bm9uZTt0cmFuc2Zvcm06cm90YXRlKDQ1ZGVnKTtjb250ZW50OlwiXCJ9LmFudC1zdGVwcy1uYXZpZ2F0aW9uIC5hbnQtc3RlcHMtaXRlbTpiZWZvcmV7cG9zaXRpb246YWJzb2x1dGU7Ym90dG9tOjA7bGVmdDo1MCU7ZGlzcGxheTppbmxpbmUtYmxvY2s7d2lkdGg6MDtoZWlnaHQ6MnB4O2JhY2tncm91bmQtY29sb3I6IzE4OTBmZjt0cmFuc2l0aW9uOndpZHRoIC4zcyxsZWZ0IC4zczt0cmFuc2l0aW9uLXRpbWluZy1mdW5jdGlvbjplYXNlLW91dDtjb250ZW50OlwiXCJ9LmFudC1zdGVwcy1uYXZpZ2F0aW9uIC5hbnQtc3RlcHMtaXRlbS5hbnQtc3RlcHMtaXRlbS1hY3RpdmU6YmVmb3Jle2xlZnQ6MDt3aWR0aDoxMDAlfS5hbnQtc3RlcHMtbmF2aWdhdGlvbi5hbnQtc3RlcHMtdmVydGljYWw+LmFudC1zdGVwcy1pdGVte21hcmdpbi1yaWdodDowIWltcG9ydGFudH0uYW50LXN0ZXBzLW5hdmlnYXRpb24uYW50LXN0ZXBzLXZlcnRpY2FsPi5hbnQtc3RlcHMtaXRlbTpiZWZvcmV7ZGlzcGxheTpub25lfS5hbnQtc3RlcHMtbmF2aWdhdGlvbi5hbnQtc3RlcHMtdmVydGljYWw+LmFudC1zdGVwcy1pdGVtLmFudC1zdGVwcy1pdGVtLWFjdGl2ZTpiZWZvcmV7dG9wOjA7cmlnaHQ6MDtsZWZ0OnVuc2V0O2Rpc3BsYXk6YmxvY2s7d2lkdGg6M3B4O2hlaWdodDpjYWxjKDEwMCUgLSAyNHB4KX0uYW50LXN0ZXBzLW5hdmlnYXRpb24uYW50LXN0ZXBzLXZlcnRpY2FsPi5hbnQtc3RlcHMtaXRlbTphZnRlcntwb3NpdGlvbjpyZWxhdGl2ZTt0b3A6LTJweDtsZWZ0OjUwJTtkaXNwbGF5OmJsb2NrO3dpZHRoOjhweDtoZWlnaHQ6OHB4O21hcmdpbi1ib3R0b206OHB4O3RleHQtYWxpZ246Y2VudGVyO3RyYW5zZm9ybTpyb3RhdGUoMTM1ZGVnKX0uYW50LXN0ZXBzLW5hdmlnYXRpb24uYW50LXN0ZXBzLWhvcml6b250YWw+LmFudC1zdGVwcy1pdGVtPi5hbnQtc3RlcHMtaXRlbS1jb250YWluZXI+LmFudC1zdGVwcy1pdGVtLXRhaWwsLmFudC1zdGVwcy1uYXZpZ2F0aW9uLmFudC1zdGVwcy12ZXJ0aWNhbD4uYW50LXN0ZXBzLWl0ZW0+LmFudC1zdGVwcy1pdGVtLWNvbnRhaW5lcj4uYW50LXN0ZXBzLWl0ZW0tdGFpbHt2aXNpYmlsaXR5OmhpZGRlbn0uYW50LXN0ZXBzLXJ0bHtkaXJlY3Rpb246cnRsfS5hbnQtc3RlcHMuYW50LXN0ZXBzLXJ0bCAuYW50LXN0ZXBzLWl0ZW0taWNvbnttYXJnaW4tcmlnaHQ6MDttYXJnaW4tbGVmdDo4cHh9LmFudC1zdGVwcy1ydGwgLmFudC1zdGVwcy1pdGVtLXRhaWx7cmlnaHQ6MDtsZWZ0OmF1dG99LmFudC1zdGVwcy1ydGwgLmFudC1zdGVwcy1pdGVtLXRpdGxle3BhZGRpbmctcmlnaHQ6MDtwYWRkaW5nLWxlZnQ6MTZweH0uYW50LXN0ZXBzLXJ0bCAuYW50LXN0ZXBzLWl0ZW0tdGl0bGUgLmFudC1zdGVwcy1pdGVtLXN1YnRpdGxle2Zsb2F0OmxlZnQ7bWFyZ2luLXJpZ2h0OjhweDttYXJnaW4tbGVmdDowfS5hbnQtc3RlcHMtcnRsIC5hbnQtc3RlcHMtaXRlbS10aXRsZTphZnRlcntyaWdodDoxMDAlO2xlZnQ6YXV0b30uYW50LXN0ZXBzLXJ0bC5hbnQtc3RlcHMtaG9yaXpvbnRhbDpub3QoLmFudC1zdGVwcy1sYWJlbC12ZXJ0aWNhbCkgLmFudC1zdGVwcy1pdGVte3BhZGRpbmctcmlnaHQ6MTZweDtwYWRkaW5nLWxlZnQ6MH0uYW50LXN0ZXBzLXJ0bC5hbnQtc3RlcHMtaG9yaXpvbnRhbDpub3QoLmFudC1zdGVwcy1sYWJlbC12ZXJ0aWNhbCkgLmFudC1zdGVwcy1pdGVtOmZpcnN0LWNoaWxke3BhZGRpbmctcmlnaHQ6MH0uYW50LXN0ZXBzLXJ0bC5hbnQtc3RlcHMtaG9yaXpvbnRhbDpub3QoLmFudC1zdGVwcy1sYWJlbC12ZXJ0aWNhbCkgLmFudC1zdGVwcy1pdGVtOmxhc3QtY2hpbGQgLmFudC1zdGVwcy1pdGVtLXRpdGxle3BhZGRpbmctbGVmdDowfS5hbnQtc3RlcHMtcnRsIC5hbnQtc3RlcHMtaXRlbS1jdXN0b20gLmFudC1zdGVwcy1pdGVtLWljb24+LmFudC1zdGVwcy1pY29ue3JpZ2h0Oi41cHg7bGVmdDphdXRvfS5hbnQtc3RlcHMtcnRsLmFudC1zdGVwcy1uYXZpZ2F0aW9uLmFudC1zdGVwcy1zbWFsbCAuYW50LXN0ZXBzLWl0ZW0tY29udGFpbmVye21hcmdpbi1yaWdodDotMTJweDttYXJnaW4tbGVmdDowfS5hbnQtc3RlcHMtcnRsLmFudC1zdGVwcy1uYXZpZ2F0aW9uIC5hbnQtc3RlcHMtaXRlbS1jb250YWluZXJ7bWFyZ2luLXJpZ2h0Oi0xNnB4O21hcmdpbi1sZWZ0OjA7dGV4dC1hbGlnbjpyaWdodH0uYW50LXN0ZXBzLXJ0bC5hbnQtc3RlcHMtbmF2aWdhdGlvbiAuYW50LXN0ZXBzLWl0ZW0tY29udGFpbmVyIC5hbnQtc3RlcHMtaXRlbS10aXRsZXtwYWRkaW5nLWxlZnQ6MH0uYW50LXN0ZXBzLXJ0bC5hbnQtc3RlcHMtbmF2aWdhdGlvbiAuYW50LXN0ZXBzLWl0ZW06YWZ0ZXJ7cmlnaHQ6MTAwJTtsZWZ0OmF1dG87bWFyZ2luLXJpZ2h0Oi0ycHg7bWFyZ2luLWxlZnQ6MDt0cmFuc2Zvcm06cm90YXRlKDIyNWRlZyl9LmFudC1zdGVwcy1ydGwuYW50LXN0ZXBzLXNtYWxsLmFudC1zdGVwcy1ob3Jpem9udGFsOm5vdCguYW50LXN0ZXBzLWxhYmVsLXZlcnRpY2FsKSAuYW50LXN0ZXBzLWl0ZW17cGFkZGluZy1yaWdodDoxMnB4O3BhZGRpbmctbGVmdDowfS5hbnQtc3RlcHMtcnRsLmFudC1zdGVwcy1zbWFsbC5hbnQtc3RlcHMtaG9yaXpvbnRhbDpub3QoLmFudC1zdGVwcy1sYWJlbC12ZXJ0aWNhbCkgLmFudC1zdGVwcy1pdGVtOmZpcnN0LWNoaWxke3BhZGRpbmctcmlnaHQ6MH0uYW50LXN0ZXBzLXJ0bC5hbnQtc3RlcHMtc21hbGwgLmFudC1zdGVwcy1pdGVtLXRpdGxle3BhZGRpbmctcmlnaHQ6MDtwYWRkaW5nLWxlZnQ6MTJweH0uYW50LXN0ZXBzLXJ0bC5hbnQtc3RlcHMtdmVydGljYWw+LmFudC1zdGVwcy1pdGVtIC5hbnQtc3RlcHMtaXRlbS1pY29ue2Zsb2F0OnJpZ2h0O21hcmdpbi1yaWdodDowO21hcmdpbi1sZWZ0OjE2cHh9LmFudC1zdGVwcy1ydGwuYW50LXN0ZXBzLXZlcnRpY2FsPi5hbnQtc3RlcHMtaXRlbT4uYW50LXN0ZXBzLWl0ZW0tY29udGFpbmVyPi5hbnQtc3RlcHMtaXRlbS10YWlse3JpZ2h0OjE2cHg7bGVmdDphdXRvfS5hbnQtc3RlcHMtcnRsLmFudC1zdGVwcy12ZXJ0aWNhbC5hbnQtc3RlcHMtc21hbGwgLmFudC1zdGVwcy1pdGVtLWNvbnRhaW5lciAuYW50LXN0ZXBzLWl0ZW0tdGFpbHtyaWdodDoxMnB4O2xlZnQ6YXV0b30uYW50LXN0ZXBzLXJ0bC5hbnQtc3RlcHMtbGFiZWwtdmVydGljYWwgLmFudC1zdGVwcy1pdGVtLXRpdGxle3BhZGRpbmctbGVmdDowfS5hbnQtc3RlcHMtcnRsLmFudC1zdGVwcy1kb3QgLmFudC1zdGVwcy1pdGVtLXRhaWwsLmFudC1zdGVwcy1ydGwuYW50LXN0ZXBzLWRvdC5hbnQtc3RlcHMtc21hbGwgLmFudC1zdGVwcy1pdGVtLXRhaWx7bWFyZ2luOjAgNzBweCAwIDB9LmFudC1zdGVwcy1ydGwuYW50LXN0ZXBzLWRvdCAuYW50LXN0ZXBzLWl0ZW0tdGFpbDphZnRlciwuYW50LXN0ZXBzLXJ0bC5hbnQtc3RlcHMtZG90LmFudC1zdGVwcy1zbWFsbCAuYW50LXN0ZXBzLWl0ZW0tdGFpbDphZnRlcnttYXJnaW4tcmlnaHQ6MTJweDttYXJnaW4tbGVmdDowfS5hbnQtc3RlcHMtcnRsLmFudC1zdGVwcy1kb3QgLmFudC1zdGVwcy1pdGVtOmZpcnN0LWNoaWxkIC5hbnQtc3RlcHMtaWNvbi1kb3QsLmFudC1zdGVwcy1ydGwuYW50LXN0ZXBzLWRvdC5hbnQtc3RlcHMtc21hbGwgLmFudC1zdGVwcy1pdGVtOmZpcnN0LWNoaWxkIC5hbnQtc3RlcHMtaWNvbi1kb3R7cmlnaHQ6MnB4O2xlZnQ6YXV0b30uYW50LXN0ZXBzLXJ0bC5hbnQtc3RlcHMtZG90IC5hbnQtc3RlcHMtaXRlbS1pY29uLC5hbnQtc3RlcHMtcnRsLmFudC1zdGVwcy1kb3QuYW50LXN0ZXBzLXNtYWxsIC5hbnQtc3RlcHMtaXRlbS1pY29ue21hcmdpbi1yaWdodDo2N3B4O21hcmdpbi1sZWZ0OjB9LmFudC1zdGVwcy1ydGwuYW50LXN0ZXBzLWRvdCAuYW50LXN0ZXBzLWl0ZW0taWNvbiAuYW50LXN0ZXBzLWljb24tZG90LC5hbnQtc3RlcHMtcnRsLmFudC1zdGVwcy1kb3QuYW50LXN0ZXBzLXNtYWxsIC5hbnQtc3RlcHMtaXRlbS1pY29uIC5hbnQtc3RlcHMtaWNvbi1kb3R7ZmxvYXQ6cmlnaHR9LmFudC1zdGVwcy1ydGwuYW50LXN0ZXBzLWRvdCAuYW50LXN0ZXBzLWl0ZW0taWNvbiAuYW50LXN0ZXBzLWljb24tZG90OmFmdGVyLC5hbnQtc3RlcHMtcnRsLmFudC1zdGVwcy1kb3QuYW50LXN0ZXBzLXNtYWxsIC5hbnQtc3RlcHMtaXRlbS1pY29uIC5hbnQtc3RlcHMtaWNvbi1kb3Q6YWZ0ZXJ7cmlnaHQ6LTI2cHg7bGVmdDphdXRvfS5hbnQtc3RlcHMtcnRsLmFudC1zdGVwcy12ZXJ0aWNhbC5hbnQtc3RlcHMtZG90IC5hbnQtc3RlcHMtaXRlbS1pY29ue21hcmdpbi1yaWdodDowO21hcmdpbi1sZWZ0OjE2cHh9LmFudC1zdGVwcy1ydGwuYW50LXN0ZXBzLXZlcnRpY2FsLmFudC1zdGVwcy1kb3QgLmFudC1zdGVwcy1pdGVtPi5hbnQtc3RlcHMtaXRlbS1jb250YWluZXI+LmFudC1zdGVwcy1pdGVtLXRhaWx7cmlnaHQ6LTlweDtsZWZ0OmF1dG99LmFudC1zdGVwcy1ydGwuYW50LXN0ZXBzLXZlcnRpY2FsLmFudC1zdGVwcy1kb3QgLmFudC1zdGVwcy1pdGVtOmZpcnN0LWNoaWxkIC5hbnQtc3RlcHMtaWNvbi1kb3R7cmlnaHQ6MDtsZWZ0OmF1dG99LmFudC1zdGVwcy1ydGwuYW50LXN0ZXBzLXZlcnRpY2FsLmFudC1zdGVwcy1kb3QgLmFudC1zdGVwcy1pdGVtLXByb2Nlc3MgLmFudC1zdGVwcy1pY29uLWRvdHtyaWdodDotMnB4O2xlZnQ6YXV0b30uYW50LXN0ZXBzLXJ0bC5hbnQtc3RlcHMtd2l0aC1wcm9ncmVzcy5hbnQtc3RlcHMtdmVydGljYWw+LmFudC1zdGVwcy1pdGVte3BhZGRpbmctcmlnaHQ6NHB4fS5hbnQtc3RlcHMtcnRsLmFudC1zdGVwcy13aXRoLXByb2dyZXNzLmFudC1zdGVwcy12ZXJ0aWNhbD4uYW50LXN0ZXBzLWl0ZW0+LmFudC1zdGVwcy1pdGVtLWNvbnRhaW5lcj4uYW50LXN0ZXBzLWl0ZW0tdGFpbHtyaWdodDoxOXB4fS5hbnQtc3RlcHMtcnRsLmFudC1zdGVwcy13aXRoLXByb2dyZXNzLmFudC1zdGVwcy1zbWFsbC5hbnQtc3RlcHMtdmVydGljYWw+LmFudC1zdGVwcy1pdGVtPi5hbnQtc3RlcHMtaXRlbS1jb250YWluZXI+LmFudC1zdGVwcy1pdGVtLXRhaWx7cmlnaHQ6MTVweH0uYW50LXN0ZXBzLXJ0bC5hbnQtc3RlcHMtd2l0aC1wcm9ncmVzcy5hbnQtc3RlcHMtaG9yaXpvbnRhbC5hbnQtc3RlcHMtbGFiZWwtaG9yaXpvbnRhbCAuYW50LXN0ZXBzLWl0ZW06Zmlyc3QtY2hpbGR7cGFkZGluZy1yaWdodDo0cHg7cGFkZGluZy1sZWZ0OjB9LmFudC1zdGVwcy1ydGwuYW50LXN0ZXBzLXdpdGgtcHJvZ3Jlc3MuYW50LXN0ZXBzLWhvcml6b250YWwuYW50LXN0ZXBzLWxhYmVsLWhvcml6b250YWwgLmFudC1zdGVwcy1pdGVtOmZpcnN0LWNoaWxkLmFudC1zdGVwcy1pdGVtLWFjdGl2ZXtwYWRkaW5nLXJpZ2h0OjRweH0uYW50LXN0ZXBzLXdpdGgtcHJvZ3Jlc3MgLmFudC1zdGVwcy1pdGVte3BhZGRpbmctdG9wOjRweH0uYW50LXN0ZXBzLXdpdGgtcHJvZ3Jlc3MgLmFudC1zdGVwcy1pdGVtPi5hbnQtc3RlcHMtaXRlbS1jb250YWluZXI+LmFudC1zdGVwcy1pdGVtLXRhaWx7dG9wOjRweDtsZWZ0OjE5cHh9LmFudC1zdGVwcy13aXRoLXByb2dyZXNzLmFudC1zdGVwcy1ob3Jpem9udGFsIC5hbnQtc3RlcHMtaXRlbTpmaXJzdC1jaGlsZCwuYW50LXN0ZXBzLXdpdGgtcHJvZ3Jlc3MuYW50LXN0ZXBzLXNtYWxsLmFudC1zdGVwcy1ob3Jpem9udGFsIC5hbnQtc3RlcHMtaXRlbTpmaXJzdC1jaGlsZHtwYWRkaW5nLWJvdHRvbTo0cHg7cGFkZGluZy1sZWZ0OjRweH0uYW50LXN0ZXBzLXdpdGgtcHJvZ3Jlc3MuYW50LXN0ZXBzLXNtYWxsPi5hbnQtc3RlcHMtaXRlbT4uYW50LXN0ZXBzLWl0ZW0tY29udGFpbmVyPi5hbnQtc3RlcHMtaXRlbS10YWlse2xlZnQ6MTVweH0uYW50LXN0ZXBzLXdpdGgtcHJvZ3Jlc3MuYW50LXN0ZXBzLXZlcnRpY2FsIC5hbnQtc3RlcHMtaXRlbXtwYWRkaW5nLWxlZnQ6NHB4fS5hbnQtc3RlcHMtd2l0aC1wcm9ncmVzcy5hbnQtc3RlcHMtbGFiZWwtdmVydGljYWwgLmFudC1zdGVwcy1pdGVtIC5hbnQtc3RlcHMtaXRlbS10YWlse3RvcDoxNHB4IWltcG9ydGFudH0uYW50LXN0ZXBzLXdpdGgtcHJvZ3Jlc3MgLmFudC1zdGVwcy1pdGVtLWljb257cG9zaXRpb246cmVsYXRpdmV9LmFudC1zdGVwcy13aXRoLXByb2dyZXNzIC5hbnQtc3RlcHMtaXRlbS1pY29uIC5hbnQtcHJvZ3Jlc3N7cG9zaXRpb246YWJzb2x1dGU7dG9wOi01cHg7cmlnaHQ6LTVweDtib3R0b206LTVweDtsZWZ0Oi01cHh9LmFudC1zd2l0Y2h7bWFyZ2luOjA7cGFkZGluZzowO2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtmb250LXNpemU6MTRweDtmb250LXZhcmlhbnQ6dGFidWxhci1udW1zO2xpbmUtaGVpZ2h0OjEuNTcxNTtsaXN0LXN0eWxlOm5vbmU7Zm9udC1mZWF0dXJlLXNldHRpbmdzOlwidG51bVwiO3Bvc2l0aW9uOnJlbGF0aXZlO2Rpc3BsYXk6aW5saW5lLWJsb2NrO2JveC1zaXppbmc6Ym9yZGVyLWJveDttaW4td2lkdGg6NDRweDtoZWlnaHQ6MjJweDtsaW5lLWhlaWdodDoyMnB4O3ZlcnRpY2FsLWFsaWduOm1pZGRsZTtiYWNrZ3JvdW5kLWNvbG9yOnJnYmEoMCwwLDAsLjI1KTtib3JkZXI6MDtib3JkZXItcmFkaXVzOjEwMHB4O2N1cnNvcjpwb2ludGVyO3RyYW5zaXRpb246YWxsIC4yczstd2Via2l0LXVzZXItc2VsZWN0Om5vbmU7LW1vei11c2VyLXNlbGVjdDpub25lOy1tcy11c2VyLXNlbGVjdDpub25lO3VzZXItc2VsZWN0Om5vbmV9LmFudC1zd2l0Y2g6Zm9jdXN7b3V0bGluZTowO2JveC1zaGFkb3c6MCAwIDAgMnB4IHJnYmEoMCwwLDAsLjEpfS5hbnQtc3dpdGNoLWNoZWNrZWQ6Zm9jdXN7Ym94LXNoYWRvdzowIDAgMCAycHggI2U2ZjdmZn0uYW50LXN3aXRjaDpmb2N1czpob3Zlcntib3gtc2hhZG93Om5vbmV9LmFudC1zd2l0Y2gtY2hlY2tlZHtiYWNrZ3JvdW5kLWNvbG9yOiMxODkwZmZ9LmFudC1zd2l0Y2gtZGlzYWJsZWQsLmFudC1zd2l0Y2gtbG9hZGluZ3tjdXJzb3I6bm90LWFsbG93ZWQ7b3BhY2l0eTouNH0uYW50LXN3aXRjaC1kaXNhYmxlZCAqLC5hbnQtc3dpdGNoLWxvYWRpbmcgKntib3gtc2hhZG93Om5vbmU7Y3Vyc29yOm5vdC1hbGxvd2VkfS5hbnQtc3dpdGNoLWlubmVye2Rpc3BsYXk6YmxvY2s7bWFyZ2luOjAgN3B4IDAgMjVweDtjb2xvcjojZmZmO2ZvbnQtc2l6ZToxMnB4O3RyYW5zaXRpb246bWFyZ2luIC4yc30uYW50LXN3aXRjaC1jaGVja2VkIC5hbnQtc3dpdGNoLWlubmVye21hcmdpbjowIDI1cHggMCA3cHh9LmFudC1zd2l0Y2gtaGFuZGxle3RvcDoycHg7bGVmdDoycHg7d2lkdGg6MThweDtoZWlnaHQ6MThweH0uYW50LXN3aXRjaC1oYW5kbGUsLmFudC1zd2l0Y2gtaGFuZGxlOmJlZm9yZXtwb3NpdGlvbjphYnNvbHV0ZTt0cmFuc2l0aW9uOmFsbCAuMnMgZWFzZS1pbi1vdXR9LmFudC1zd2l0Y2gtaGFuZGxlOmJlZm9yZXt0b3A6MDtyaWdodDowO2JvdHRvbTowO2xlZnQ6MDtiYWNrZ3JvdW5kLWNvbG9yOiNmZmY7Ym9yZGVyLXJhZGl1czo5cHg7Ym94LXNoYWRvdzowIDJweCA0cHggMCByZ2JhKDAsMzUsMTEsLjIpO2NvbnRlbnQ6XCJcIn0uYW50LXN3aXRjaC1jaGVja2VkIC5hbnQtc3dpdGNoLWhhbmRsZXtsZWZ0OmNhbGMoMTAwJSAtIDIwcHgpfS5hbnQtc3dpdGNoOm5vdCguYW50LXN3aXRjaC1kaXNhYmxlZCk6YWN0aXZlIC5hbnQtc3dpdGNoLWhhbmRsZTpiZWZvcmV7cmlnaHQ6LTMwJTtsZWZ0OjB9LmFudC1zd2l0Y2g6bm90KC5hbnQtc3dpdGNoLWRpc2FibGVkKTphY3RpdmUuYW50LXN3aXRjaC1jaGVja2VkIC5hbnQtc3dpdGNoLWhhbmRsZTpiZWZvcmV7cmlnaHQ6MDtsZWZ0Oi0zMCV9LmFudC1zd2l0Y2gtbG9hZGluZy1pY29uLmFudGljb257cG9zaXRpb246cmVsYXRpdmU7dG9wOjJweDtjb2xvcjpyZ2JhKDAsMCwwLC42NSk7dmVydGljYWwtYWxpZ246dG9wfS5hbnQtc3dpdGNoLWNoZWNrZWQgLmFudC1zd2l0Y2gtbG9hZGluZy1pY29ue2NvbG9yOiMxODkwZmZ9LmFudC1zd2l0Y2gtc21hbGx7bWluLXdpZHRoOjI4cHg7aGVpZ2h0OjE2cHg7bGluZS1oZWlnaHQ6MTZweH0uYW50LXN3aXRjaC1zbWFsbCAuYW50LXN3aXRjaC1pbm5lcnttYXJnaW46MCA1cHggMCAxOHB4O2ZvbnQtc2l6ZToxMnB4fS5hbnQtc3dpdGNoLXNtYWxsIC5hbnQtc3dpdGNoLWhhbmRsZXt3aWR0aDoxMnB4O2hlaWdodDoxMnB4fS5hbnQtc3dpdGNoLXNtYWxsIC5hbnQtc3dpdGNoLWxvYWRpbmctaWNvbnt0b3A6MS41cHg7Zm9udC1zaXplOjlweH0uYW50LXN3aXRjaC1zbWFsbC5hbnQtc3dpdGNoLWNoZWNrZWQgLmFudC1zd2l0Y2gtaW5uZXJ7bWFyZ2luOjAgMThweCAwIDVweH0uYW50LXN3aXRjaC1zbWFsbC5hbnQtc3dpdGNoLWNoZWNrZWQgLmFudC1zd2l0Y2gtaGFuZGxle2xlZnQ6Y2FsYygxMDAlIC0gMTRweCl9LmFudC1zd2l0Y2gtcnRse2RpcmVjdGlvbjpydGx9LmFudC1zd2l0Y2gtcnRsIC5hbnQtc3dpdGNoLWlubmVye21hcmdpbjowIDI1cHggMCA3cHh9LmFudC1zd2l0Y2gtcnRsIC5hbnQtc3dpdGNoLWhhbmRsZXtyaWdodDoycHg7bGVmdDphdXRvfS5hbnQtc3dpdGNoLXJ0bDpub3QoLmFudC1zd2l0Y2gtcnRsLWRpc2FibGVkKTphY3RpdmUgLmFudC1zd2l0Y2gtaGFuZGxlOmJlZm9yZXtyaWdodDowO2xlZnQ6LTMwJX0uYW50LXN3aXRjaC1ydGw6bm90KC5hbnQtc3dpdGNoLXJ0bC1kaXNhYmxlZCk6YWN0aXZlLmFudC1zd2l0Y2gtY2hlY2tlZCAuYW50LXN3aXRjaC1oYW5kbGU6YmVmb3Jle3JpZ2h0Oi0zMCU7bGVmdDowfS5hbnQtc3dpdGNoLXJ0bC5hbnQtc3dpdGNoLWNoZWNrZWQgLmFudC1zd2l0Y2gtaW5uZXJ7bWFyZ2luOjAgN3B4IDAgMjVweH0uYW50LXN3aXRjaC1ydGwuYW50LXN3aXRjaC1jaGVja2VkIC5hbnQtc3dpdGNoLWhhbmRsZXtyaWdodDpjYWxjKDEwMCUgLSAyMHB4KX0uYW50LXN3aXRjaC1ydGwuYW50LXN3aXRjaC1zbWFsbC5hbnQtc3dpdGNoLWNoZWNrZWQgLmFudC1zd2l0Y2gtaGFuZGxle3JpZ2h0OmNhbGMoMTAwJSAtIDE0cHgpfS5hbnQtdGFibGUuYW50LXRhYmxlLW1pZGRsZXtmb250LXNpemU6MTRweH0uYW50LXRhYmxlLmFudC10YWJsZS1taWRkbGUgLmFudC10YWJsZS1mb290ZXIsLmFudC10YWJsZS5hbnQtdGFibGUtbWlkZGxlIC5hbnQtdGFibGUtdGJvZHk+dHI+dGQsLmFudC10YWJsZS5hbnQtdGFibGUtbWlkZGxlIC5hbnQtdGFibGUtdGhlYWQ+dHI+dGgsLmFudC10YWJsZS5hbnQtdGFibGUtbWlkZGxlIC5hbnQtdGFibGUtdGl0bGUsLmFudC10YWJsZS5hbnQtdGFibGUtbWlkZGxlIHRmb290PnRyPnRkLC5hbnQtdGFibGUuYW50LXRhYmxlLW1pZGRsZSB0Zm9vdD50cj50aHtwYWRkaW5nOjEycHggOHB4fS5hbnQtdGFibGUuYW50LXRhYmxlLW1pZGRsZSAuYW50LXRhYmxlLWZpbHRlci10cmlnZ2Vye21hcmdpbi1yaWdodDotNHB4fS5hbnQtdGFibGUuYW50LXRhYmxlLW1pZGRsZSAuYW50LXRhYmxlLWV4cGFuZGVkLXJvdy1maXhlZHttYXJnaW46LTEycHggLThweH0uYW50LXRhYmxlLmFudC10YWJsZS1taWRkbGUgLmFudC10YWJsZS10Ym9keSAuYW50LXRhYmxlLXdyYXBwZXI6b25seS1jaGlsZCAuYW50LXRhYmxle21hcmdpbjotMTJweCAtOHB4IC0xMnB4IDQwcHh9LmFudC10YWJsZS5hbnQtdGFibGUtbWlkZGxlIC5hbnQtdGFibGUtc2VsZWN0aW9uLWNvbHVtbnstd2Via2l0LXBhZGRpbmctc3RhcnQ6MnB4O3BhZGRpbmctaW5saW5lLXN0YXJ0OjJweH0uYW50LXRhYmxlLmFudC10YWJsZS1zbWFsbHtmb250LXNpemU6MTRweH0uYW50LXRhYmxlLmFudC10YWJsZS1zbWFsbCAuYW50LXRhYmxlLWZvb3RlciwuYW50LXRhYmxlLmFudC10YWJsZS1zbWFsbCAuYW50LXRhYmxlLXRib2R5PnRyPnRkLC5hbnQtdGFibGUuYW50LXRhYmxlLXNtYWxsIC5hbnQtdGFibGUtdGhlYWQ+dHI+dGgsLmFudC10YWJsZS5hbnQtdGFibGUtc21hbGwgLmFudC10YWJsZS10aXRsZSwuYW50LXRhYmxlLmFudC10YWJsZS1zbWFsbCB0Zm9vdD50cj50ZCwuYW50LXRhYmxlLmFudC10YWJsZS1zbWFsbCB0Zm9vdD50cj50aHtwYWRkaW5nOjhweH0uYW50LXRhYmxlLmFudC10YWJsZS1zbWFsbCAuYW50LXRhYmxlLWZpbHRlci10cmlnZ2Vye21hcmdpbi1yaWdodDotNHB4fS5hbnQtdGFibGUuYW50LXRhYmxlLXNtYWxsIC5hbnQtdGFibGUtZXhwYW5kZWQtcm93LWZpeGVke21hcmdpbjotOHB4fS5hbnQtdGFibGUuYW50LXRhYmxlLXNtYWxsIC5hbnQtdGFibGUtdGJvZHkgLmFudC10YWJsZS13cmFwcGVyOm9ubHktY2hpbGQgLmFudC10YWJsZXttYXJnaW46LThweCAtOHB4IC04cHggNDBweH0uYW50LXRhYmxlLmFudC10YWJsZS1zbWFsbCAuYW50LXRhYmxlLXNlbGVjdGlvbi1jb2x1bW57LXdlYmtpdC1wYWRkaW5nLXN0YXJ0OjJweDtwYWRkaW5nLWlubGluZS1zdGFydDoycHh9LmFudC10YWJsZS5hbnQtdGFibGUtYm9yZGVyZWQ+LmFudC10YWJsZS10aXRsZXtib3JkZXI6MXB4IHNvbGlkICNmMGYwZjA7Ym9yZGVyLWJvdHRvbTowfS5hbnQtdGFibGUuYW50LXRhYmxlLWJvcmRlcmVkPi5hbnQtdGFibGUtY29udGFpbmVye2JvcmRlci1sZWZ0OjFweCBzb2xpZCAjZjBmMGYwfS5hbnQtdGFibGUuYW50LXRhYmxlLWJvcmRlcmVkPi5hbnQtdGFibGUtY29udGFpbmVyPi5hbnQtdGFibGUtYm9keT50YWJsZT50Ym9keT50cj50ZCwuYW50LXRhYmxlLmFudC10YWJsZS1ib3JkZXJlZD4uYW50LXRhYmxlLWNvbnRhaW5lcj4uYW50LXRhYmxlLWJvZHk+dGFibGU+dGZvb3Q+dHI+dGQsLmFudC10YWJsZS5hbnQtdGFibGUtYm9yZGVyZWQ+LmFudC10YWJsZS1jb250YWluZXI+LmFudC10YWJsZS1ib2R5PnRhYmxlPnRmb290PnRyPnRoLC5hbnQtdGFibGUuYW50LXRhYmxlLWJvcmRlcmVkPi5hbnQtdGFibGUtY29udGFpbmVyPi5hbnQtdGFibGUtYm9keT50YWJsZT50aGVhZD50cj50aCwuYW50LXRhYmxlLmFudC10YWJsZS1ib3JkZXJlZD4uYW50LXRhYmxlLWNvbnRhaW5lcj4uYW50LXRhYmxlLWNvbnRlbnQ+dGFibGU+dGJvZHk+dHI+dGQsLmFudC10YWJsZS5hbnQtdGFibGUtYm9yZGVyZWQ+LmFudC10YWJsZS1jb250YWluZXI+LmFudC10YWJsZS1jb250ZW50PnRhYmxlPnRmb290PnRyPnRkLC5hbnQtdGFibGUuYW50LXRhYmxlLWJvcmRlcmVkPi5hbnQtdGFibGUtY29udGFpbmVyPi5hbnQtdGFibGUtY29udGVudD50YWJsZT50Zm9vdD50cj50aCwuYW50LXRhYmxlLmFudC10YWJsZS1ib3JkZXJlZD4uYW50LXRhYmxlLWNvbnRhaW5lcj4uYW50LXRhYmxlLWNvbnRlbnQ+dGFibGU+dGhlYWQ+dHI+dGgsLmFudC10YWJsZS5hbnQtdGFibGUtYm9yZGVyZWQ+LmFudC10YWJsZS1jb250YWluZXI+LmFudC10YWJsZS1oZWFkZXI+dGFibGU+dGJvZHk+dHI+dGQsLmFudC10YWJsZS5hbnQtdGFibGUtYm9yZGVyZWQ+LmFudC10YWJsZS1jb250YWluZXI+LmFudC10YWJsZS1oZWFkZXI+dGFibGU+dGZvb3Q+dHI+dGQsLmFudC10YWJsZS5hbnQtdGFibGUtYm9yZGVyZWQ+LmFudC10YWJsZS1jb250YWluZXI+LmFudC10YWJsZS1oZWFkZXI+dGFibGU+dGZvb3Q+dHI+dGgsLmFudC10YWJsZS5hbnQtdGFibGUtYm9yZGVyZWQ+LmFudC10YWJsZS1jb250YWluZXI+LmFudC10YWJsZS1oZWFkZXI+dGFibGU+dGhlYWQ+dHI+dGgsLmFudC10YWJsZS5hbnQtdGFibGUtYm9yZGVyZWQ+LmFudC10YWJsZS1jb250YWluZXI+LmFudC10YWJsZS1zdW1tYXJ5PnRhYmxlPnRib2R5PnRyPnRkLC5hbnQtdGFibGUuYW50LXRhYmxlLWJvcmRlcmVkPi5hbnQtdGFibGUtY29udGFpbmVyPi5hbnQtdGFibGUtc3VtbWFyeT50YWJsZT50Zm9vdD50cj50ZCwuYW50LXRhYmxlLmFudC10YWJsZS1ib3JkZXJlZD4uYW50LXRhYmxlLWNvbnRhaW5lcj4uYW50LXRhYmxlLXN1bW1hcnk+dGFibGU+dGZvb3Q+dHI+dGgsLmFudC10YWJsZS5hbnQtdGFibGUtYm9yZGVyZWQ+LmFudC10YWJsZS1jb250YWluZXI+LmFudC10YWJsZS1zdW1tYXJ5PnRhYmxlPnRoZWFkPnRyPnRoe2JvcmRlci1yaWdodDoxcHggc29saWQgI2YwZjBmMH0uYW50LXRhYmxlLmFudC10YWJsZS1ib3JkZXJlZD4uYW50LXRhYmxlLWNvbnRhaW5lcj4uYW50LXRhYmxlLWJvZHk+dGFibGU+dGhlYWQ+dHI6bm90KDpsYXN0LWNoaWxkKT50aCwuYW50LXRhYmxlLmFudC10YWJsZS1ib3JkZXJlZD4uYW50LXRhYmxlLWNvbnRhaW5lcj4uYW50LXRhYmxlLWNvbnRlbnQ+dGFibGU+dGhlYWQ+dHI6bm90KDpsYXN0LWNoaWxkKT50aCwuYW50LXRhYmxlLmFudC10YWJsZS1ib3JkZXJlZD4uYW50LXRhYmxlLWNvbnRhaW5lcj4uYW50LXRhYmxlLWhlYWRlcj50YWJsZT50aGVhZD50cjpub3QoOmxhc3QtY2hpbGQpPnRoLC5hbnQtdGFibGUuYW50LXRhYmxlLWJvcmRlcmVkPi5hbnQtdGFibGUtY29udGFpbmVyPi5hbnQtdGFibGUtc3VtbWFyeT50YWJsZT50aGVhZD50cjpub3QoOmxhc3QtY2hpbGQpPnRoe2JvcmRlci1ib3R0b206MXB4IHNvbGlkICNmMGYwZjB9LmFudC10YWJsZS5hbnQtdGFibGUtYm9yZGVyZWQ+LmFudC10YWJsZS1jb250YWluZXI+LmFudC10YWJsZS1ib2R5PnRhYmxlPnRoZWFkPnRyPnRoOmJlZm9yZSwuYW50LXRhYmxlLmFudC10YWJsZS1ib3JkZXJlZD4uYW50LXRhYmxlLWNvbnRhaW5lcj4uYW50LXRhYmxlLWNvbnRlbnQ+dGFibGU+dGhlYWQ+dHI+dGg6YmVmb3JlLC5hbnQtdGFibGUuYW50LXRhYmxlLWJvcmRlcmVkPi5hbnQtdGFibGUtY29udGFpbmVyPi5hbnQtdGFibGUtaGVhZGVyPnRhYmxlPnRoZWFkPnRyPnRoOmJlZm9yZSwuYW50LXRhYmxlLmFudC10YWJsZS1ib3JkZXJlZD4uYW50LXRhYmxlLWNvbnRhaW5lcj4uYW50LXRhYmxlLXN1bW1hcnk+dGFibGU+dGhlYWQ+dHI+dGg6YmVmb3Jle2JhY2tncm91bmQtY29sb3I6dHJhbnNwYXJlbnQhaW1wb3J0YW50fS5hbnQtdGFibGUuYW50LXRhYmxlLWJvcmRlcmVkPi5hbnQtdGFibGUtY29udGFpbmVyPi5hbnQtdGFibGUtYm9keT50YWJsZT50Ym9keT50cj4uYW50LXRhYmxlLWNlbGwtZml4LXJpZ2h0LWZpcnN0OmFmdGVyLC5hbnQtdGFibGUuYW50LXRhYmxlLWJvcmRlcmVkPi5hbnQtdGFibGUtY29udGFpbmVyPi5hbnQtdGFibGUtYm9keT50YWJsZT50Zm9vdD50cj4uYW50LXRhYmxlLWNlbGwtZml4LXJpZ2h0LWZpcnN0OmFmdGVyLC5hbnQtdGFibGUuYW50LXRhYmxlLWJvcmRlcmVkPi5hbnQtdGFibGUtY29udGFpbmVyPi5hbnQtdGFibGUtYm9keT50YWJsZT50aGVhZD50cj4uYW50LXRhYmxlLWNlbGwtZml4LXJpZ2h0LWZpcnN0OmFmdGVyLC5hbnQtdGFibGUuYW50LXRhYmxlLWJvcmRlcmVkPi5hbnQtdGFibGUtY29udGFpbmVyPi5hbnQtdGFibGUtY29udGVudD50YWJsZT50Ym9keT50cj4uYW50LXRhYmxlLWNlbGwtZml4LXJpZ2h0LWZpcnN0OmFmdGVyLC5hbnQtdGFibGUuYW50LXRhYmxlLWJvcmRlcmVkPi5hbnQtdGFibGUtY29udGFpbmVyPi5hbnQtdGFibGUtY29udGVudD50YWJsZT50Zm9vdD50cj4uYW50LXRhYmxlLWNlbGwtZml4LXJpZ2h0LWZpcnN0OmFmdGVyLC5hbnQtdGFibGUuYW50LXRhYmxlLWJvcmRlcmVkPi5hbnQtdGFibGUtY29udGFpbmVyPi5hbnQtdGFibGUtY29udGVudD50YWJsZT50aGVhZD50cj4uYW50LXRhYmxlLWNlbGwtZml4LXJpZ2h0LWZpcnN0OmFmdGVyLC5hbnQtdGFibGUuYW50LXRhYmxlLWJvcmRlcmVkPi5hbnQtdGFibGUtY29udGFpbmVyPi5hbnQtdGFibGUtaGVhZGVyPnRhYmxlPnRib2R5PnRyPi5hbnQtdGFibGUtY2VsbC1maXgtcmlnaHQtZmlyc3Q6YWZ0ZXIsLmFudC10YWJsZS5hbnQtdGFibGUtYm9yZGVyZWQ+LmFudC10YWJsZS1jb250YWluZXI+LmFudC10YWJsZS1oZWFkZXI+dGFibGU+dGZvb3Q+dHI+LmFudC10YWJsZS1jZWxsLWZpeC1yaWdodC1maXJzdDphZnRlciwuYW50LXRhYmxlLmFudC10YWJsZS1ib3JkZXJlZD4uYW50LXRhYmxlLWNvbnRhaW5lcj4uYW50LXRhYmxlLWhlYWRlcj50YWJsZT50aGVhZD50cj4uYW50LXRhYmxlLWNlbGwtZml4LXJpZ2h0LWZpcnN0OmFmdGVyLC5hbnQtdGFibGUuYW50LXRhYmxlLWJvcmRlcmVkPi5hbnQtdGFibGUtY29udGFpbmVyPi5hbnQtdGFibGUtc3VtbWFyeT50YWJsZT50Ym9keT50cj4uYW50LXRhYmxlLWNlbGwtZml4LXJpZ2h0LWZpcnN0OmFmdGVyLC5hbnQtdGFibGUuYW50LXRhYmxlLWJvcmRlcmVkPi5hbnQtdGFibGUtY29udGFpbmVyPi5hbnQtdGFibGUtc3VtbWFyeT50YWJsZT50Zm9vdD50cj4uYW50LXRhYmxlLWNlbGwtZml4LXJpZ2h0LWZpcnN0OmFmdGVyLC5hbnQtdGFibGUuYW50LXRhYmxlLWJvcmRlcmVkPi5hbnQtdGFibGUtY29udGFpbmVyPi5hbnQtdGFibGUtc3VtbWFyeT50YWJsZT50aGVhZD50cj4uYW50LXRhYmxlLWNlbGwtZml4LXJpZ2h0LWZpcnN0OmFmdGVye2JvcmRlci1yaWdodDoxcHggc29saWQgI2YwZjBmMH0uYW50LXRhYmxlLmFudC10YWJsZS1ib3JkZXJlZD4uYW50LXRhYmxlLWNvbnRhaW5lcj4uYW50LXRhYmxlLWJvZHk+dGFibGU+dGJvZHk+dHI+dGQ+LmFudC10YWJsZS1leHBhbmRlZC1yb3ctZml4ZWQsLmFudC10YWJsZS5hbnQtdGFibGUtYm9yZGVyZWQ+LmFudC10YWJsZS1jb250YWluZXI+LmFudC10YWJsZS1jb250ZW50PnRhYmxlPnRib2R5PnRyPnRkPi5hbnQtdGFibGUtZXhwYW5kZWQtcm93LWZpeGVkLC5hbnQtdGFibGUuYW50LXRhYmxlLWJvcmRlcmVkPi5hbnQtdGFibGUtY29udGFpbmVyPi5hbnQtdGFibGUtaGVhZGVyPnRhYmxlPnRib2R5PnRyPnRkPi5hbnQtdGFibGUtZXhwYW5kZWQtcm93LWZpeGVkLC5hbnQtdGFibGUuYW50LXRhYmxlLWJvcmRlcmVkPi5hbnQtdGFibGUtY29udGFpbmVyPi5hbnQtdGFibGUtc3VtbWFyeT50YWJsZT50Ym9keT50cj50ZD4uYW50LXRhYmxlLWV4cGFuZGVkLXJvdy1maXhlZHttYXJnaW46LTE2cHggLTE3cHh9LmFudC10YWJsZS5hbnQtdGFibGUtYm9yZGVyZWQ+LmFudC10YWJsZS1jb250YWluZXI+LmFudC10YWJsZS1ib2R5PnRhYmxlPnRib2R5PnRyPnRkPi5hbnQtdGFibGUtZXhwYW5kZWQtcm93LWZpeGVkOmFmdGVyLC5hbnQtdGFibGUuYW50LXRhYmxlLWJvcmRlcmVkPi5hbnQtdGFibGUtY29udGFpbmVyPi5hbnQtdGFibGUtY29udGVudD50YWJsZT50Ym9keT50cj50ZD4uYW50LXRhYmxlLWV4cGFuZGVkLXJvdy1maXhlZDphZnRlciwuYW50LXRhYmxlLmFudC10YWJsZS1ib3JkZXJlZD4uYW50LXRhYmxlLWNvbnRhaW5lcj4uYW50LXRhYmxlLWhlYWRlcj50YWJsZT50Ym9keT50cj50ZD4uYW50LXRhYmxlLWV4cGFuZGVkLXJvdy1maXhlZDphZnRlciwuYW50LXRhYmxlLmFudC10YWJsZS1ib3JkZXJlZD4uYW50LXRhYmxlLWNvbnRhaW5lcj4uYW50LXRhYmxlLXN1bW1hcnk+dGFibGU+dGJvZHk+dHI+dGQ+LmFudC10YWJsZS1leHBhbmRlZC1yb3ctZml4ZWQ6YWZ0ZXJ7cG9zaXRpb246YWJzb2x1dGU7dG9wOjA7cmlnaHQ6MXB4O2JvdHRvbTowO2JvcmRlci1yaWdodDoxcHggc29saWQgI2YwZjBmMDtjb250ZW50OlwiXCJ9LmFudC10YWJsZS5hbnQtdGFibGUtYm9yZGVyZWQ+LmFudC10YWJsZS1jb250YWluZXI+LmFudC10YWJsZS1jb250ZW50PnRhYmxlLC5hbnQtdGFibGUuYW50LXRhYmxlLWJvcmRlcmVkPi5hbnQtdGFibGUtY29udGFpbmVyPi5hbnQtdGFibGUtaGVhZGVyPnRhYmxle2JvcmRlci10b3A6MXB4IHNvbGlkICNmMGYwZjB9LmFudC10YWJsZS5hbnQtdGFibGUtYm9yZGVyZWQuYW50LXRhYmxlLXNjcm9sbC1ob3Jpem9udGFsPi5hbnQtdGFibGUtY29udGFpbmVyPi5hbnQtdGFibGUtYm9keT50YWJsZT50Ym9keT50ci5hbnQtdGFibGUtZXhwYW5kZWQtcm93PnRkLC5hbnQtdGFibGUuYW50LXRhYmxlLWJvcmRlcmVkLmFudC10YWJsZS1zY3JvbGwtaG9yaXpvbnRhbD4uYW50LXRhYmxlLWNvbnRhaW5lcj4uYW50LXRhYmxlLWJvZHk+dGFibGU+dGJvZHk+dHIuYW50LXRhYmxlLXBsYWNlaG9sZGVyPnRke2JvcmRlci1yaWdodDowfS5hbnQtdGFibGUuYW50LXRhYmxlLWJvcmRlcmVkLmFudC10YWJsZS1taWRkbGU+LmFudC10YWJsZS1jb250YWluZXI+LmFudC10YWJsZS1ib2R5PnRhYmxlPnRib2R5PnRyPnRkPi5hbnQtdGFibGUtZXhwYW5kZWQtcm93LWZpeGVkLC5hbnQtdGFibGUuYW50LXRhYmxlLWJvcmRlcmVkLmFudC10YWJsZS1taWRkbGU+LmFudC10YWJsZS1jb250YWluZXI+LmFudC10YWJsZS1jb250ZW50PnRhYmxlPnRib2R5PnRyPnRkPi5hbnQtdGFibGUtZXhwYW5kZWQtcm93LWZpeGVke21hcmdpbjotMTJweCAtOXB4fS5hbnQtdGFibGUuYW50LXRhYmxlLWJvcmRlcmVkLmFudC10YWJsZS1zbWFsbD4uYW50LXRhYmxlLWNvbnRhaW5lcj4uYW50LXRhYmxlLWJvZHk+dGFibGU+dGJvZHk+dHI+dGQ+LmFudC10YWJsZS1leHBhbmRlZC1yb3ctZml4ZWQsLmFudC10YWJsZS5hbnQtdGFibGUtYm9yZGVyZWQuYW50LXRhYmxlLXNtYWxsPi5hbnQtdGFibGUtY29udGFpbmVyPi5hbnQtdGFibGUtY29udGVudD50YWJsZT50Ym9keT50cj50ZD4uYW50LXRhYmxlLWV4cGFuZGVkLXJvdy1maXhlZHttYXJnaW46LThweCAtOXB4fS5hbnQtdGFibGUuYW50LXRhYmxlLWJvcmRlcmVkPi5hbnQtdGFibGUtZm9vdGVye2JvcmRlcjoxcHggc29saWQgI2YwZjBmMDtib3JkZXItdG9wOjB9LmFudC10YWJsZS1jZWxsIC5hbnQtdGFibGUtY29udGFpbmVyOmZpcnN0LWNoaWxke2JvcmRlci10b3A6MH0uYW50LXRhYmxlLWNlbGwtc2Nyb2xsYmFyOm5vdChbcm93c3Bhbl0pe2JveC1zaGFkb3c6MCAxcHggMCAxcHggI2ZhZmFmYX0uYW50LXRhYmxlLXdyYXBwZXJ7Y2xlYXI6Ym90aDttYXgtd2lkdGg6MTAwJX0uYW50LXRhYmxlLXdyYXBwZXI6YmVmb3Jle2Rpc3BsYXk6dGFibGU7Y29udGVudDpcIlwifS5hbnQtdGFibGUtd3JhcHBlcjphZnRlcntkaXNwbGF5OnRhYmxlO2NsZWFyOmJvdGg7Y29udGVudDpcIlwifS5hbnQtdGFibGV7Ym94LXNpemluZzpib3JkZXItYm94O21hcmdpbjowO3BhZGRpbmc6MDtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7Zm9udC12YXJpYW50OnRhYnVsYXItbnVtcztsaW5lLWhlaWdodDoxLjU3MTU7bGlzdC1zdHlsZTpub25lO2ZvbnQtZmVhdHVyZS1zZXR0aW5nczpcInRudW1cIjtwb3NpdGlvbjpyZWxhdGl2ZTtmb250LXNpemU6MTRweDtiYWNrZ3JvdW5kOiNmZmY7Ym9yZGVyLXJhZGl1czoycHh9LmFudC10YWJsZSB0YWJsZXt3aWR0aDoxMDAlO3RleHQtYWxpZ246bGVmdDtib3JkZXItcmFkaXVzOjJweCAycHggMCAwO2JvcmRlci1jb2xsYXBzZTpzZXBhcmF0ZTtib3JkZXItc3BhY2luZzowfS5hbnQtdGFibGUtdGJvZHk+dHI+dGQsLmFudC10YWJsZS10aGVhZD50cj50aCwuYW50LXRhYmxlIHRmb290PnRyPnRkLC5hbnQtdGFibGUgdGZvb3Q+dHI+dGh7cG9zaXRpb246cmVsYXRpdmU7cGFkZGluZzoxNnB4O292ZXJmbG93LXdyYXA6YnJlYWstd29yZH0uYW50LXRhYmxlLWNlbGwtZWxsaXBzaXN7b3ZlcmZsb3c6aGlkZGVuO3doaXRlLXNwYWNlOm5vd3JhcDt0ZXh0LW92ZXJmbG93OmVsbGlwc2lzO3dvcmQtYnJlYWs6a2VlcC1hbGx9LmFudC10YWJsZS1jZWxsLWVsbGlwc2lzLmFudC10YWJsZS1jZWxsLWZpeC1sZWZ0LWxhc3QsLmFudC10YWJsZS1jZWxsLWVsbGlwc2lzLmFudC10YWJsZS1jZWxsLWZpeC1yaWdodC1maXJzdHtvdmVyZmxvdzp2aXNpYmxlfS5hbnQtdGFibGUtY2VsbC1lbGxpcHNpcy5hbnQtdGFibGUtY2VsbC1maXgtbGVmdC1sYXN0IC5hbnQtdGFibGUtY2VsbC1jb250ZW50LC5hbnQtdGFibGUtY2VsbC1lbGxpcHNpcy5hbnQtdGFibGUtY2VsbC1maXgtcmlnaHQtZmlyc3QgLmFudC10YWJsZS1jZWxsLWNvbnRlbnR7ZGlzcGxheTpibG9jaztvdmVyZmxvdzpoaWRkZW47dGV4dC1vdmVyZmxvdzplbGxpcHNpc30uYW50LXRhYmxlLWNlbGwtZWxsaXBzaXMgLmFudC10YWJsZS1jb2x1bW4tdGl0bGV7b3ZlcmZsb3c6aGlkZGVuO3RleHQtb3ZlcmZsb3c6ZWxsaXBzaXM7d29yZC1icmVhazprZWVwLWFsbH0uYW50LXRhYmxlLXRpdGxle3BhZGRpbmc6MTZweH0uYW50LXRhYmxlLWZvb3RlcntwYWRkaW5nOjE2cHg7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2JhY2tncm91bmQ6I2ZhZmFmYX0uYW50LXRhYmxlLXRoZWFkPnRyPnRoe3Bvc2l0aW9uOnJlbGF0aXZlO2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtmb250LXdlaWdodDo1MDA7dGV4dC1hbGlnbjpsZWZ0O2JhY2tncm91bmQ6I2ZhZmFmYTtib3JkZXItYm90dG9tOjFweCBzb2xpZCAjZjBmMGYwO3RyYW5zaXRpb246YmFja2dyb3VuZCAuM3MgZWFzZX0uYW50LXRhYmxlLXRoZWFkPnRyPnRoW2NvbHNwYW5dOm5vdChbY29sc3Bhbj1cIjFcIl0pe3RleHQtYWxpZ246Y2VudGVyfS5hbnQtdGFibGUtdGhlYWQ+dHI+dGg6bm90KDpsYXN0LWNoaWxkKTpub3QoLmFudC10YWJsZS1zZWxlY3Rpb24tY29sdW1uKTpub3QoLmFudC10YWJsZS1yb3ctZXhwYW5kLWljb24tY2VsbCk6bm90KFtjb2xzcGFuXSk6YmVmb3Jle3Bvc2l0aW9uOmFic29sdXRlO3RvcDo1MCU7cmlnaHQ6MDt3aWR0aDoxcHg7aGVpZ2h0OjEuNmVtO2JhY2tncm91bmQtY29sb3I6cmdiYSgwLDAsMCwuMDYpO3RyYW5zZm9ybTp0cmFuc2xhdGVZKC01MCUpO3RyYW5zaXRpb246YmFja2dyb3VuZC1jb2xvciAuM3M7Y29udGVudDpcIlwifS5hbnQtdGFibGUtdGhlYWQ+dHI6bm90KDpsYXN0LWNoaWxkKT50aFtjb2xzcGFuXXtib3JkZXItYm90dG9tOjB9LmFudC10YWJsZS10Ym9keT50cj50ZHtib3JkZXItYm90dG9tOjFweCBzb2xpZCAjZjBmMGYwO3RyYW5zaXRpb246YmFja2dyb3VuZCAuM3N9LmFudC10YWJsZS10Ym9keT50cj50ZD4uYW50LXRhYmxlLWV4cGFuZGVkLXJvdy1maXhlZD4uYW50LXRhYmxlLXdyYXBwZXI6b25seS1jaGlsZCAuYW50LXRhYmxlLC5hbnQtdGFibGUtdGJvZHk+dHI+dGQ+LmFudC10YWJsZS13cmFwcGVyOm9ubHktY2hpbGQgLmFudC10YWJsZXttYXJnaW46LTE2cHggLTE2cHggLTE2cHggMzJweH0uYW50LXRhYmxlLXRib2R5PnRyPnRkPi5hbnQtdGFibGUtZXhwYW5kZWQtcm93LWZpeGVkPi5hbnQtdGFibGUtd3JhcHBlcjpvbmx5LWNoaWxkIC5hbnQtdGFibGUtdGJvZHk+dHI6bGFzdC1jaGlsZD50ZCwuYW50LXRhYmxlLXRib2R5PnRyPnRkPi5hbnQtdGFibGUtd3JhcHBlcjpvbmx5LWNoaWxkIC5hbnQtdGFibGUtdGJvZHk+dHI6bGFzdC1jaGlsZD50ZHtib3JkZXItYm90dG9tOjB9LmFudC10YWJsZS10Ym9keT50cj50ZD4uYW50LXRhYmxlLWV4cGFuZGVkLXJvdy1maXhlZD4uYW50LXRhYmxlLXdyYXBwZXI6b25seS1jaGlsZCAuYW50LXRhYmxlLXRib2R5PnRyOmxhc3QtY2hpbGQ+dGQ6Zmlyc3QtY2hpbGQsLmFudC10YWJsZS10Ym9keT50cj50ZD4uYW50LXRhYmxlLWV4cGFuZGVkLXJvdy1maXhlZD4uYW50LXRhYmxlLXdyYXBwZXI6b25seS1jaGlsZCAuYW50LXRhYmxlLXRib2R5PnRyOmxhc3QtY2hpbGQ+dGQ6bGFzdC1jaGlsZCwuYW50LXRhYmxlLXRib2R5PnRyPnRkPi5hbnQtdGFibGUtd3JhcHBlcjpvbmx5LWNoaWxkIC5hbnQtdGFibGUtdGJvZHk+dHI6bGFzdC1jaGlsZD50ZDpmaXJzdC1jaGlsZCwuYW50LXRhYmxlLXRib2R5PnRyPnRkPi5hbnQtdGFibGUtd3JhcHBlcjpvbmx5LWNoaWxkIC5hbnQtdGFibGUtdGJvZHk+dHI6bGFzdC1jaGlsZD50ZDpsYXN0LWNoaWxke2JvcmRlci1yYWRpdXM6MH0uYW50LXRhYmxlLXRib2R5PnRyLmFudC10YWJsZS1yb3c6aG92ZXI+dGQsLmFudC10YWJsZS10Ym9keT50cj50ZC5hbnQtdGFibGUtY2VsbC1yb3ctaG92ZXJ7YmFja2dyb3VuZDojZmFmYWZhfS5hbnQtdGFibGUtdGJvZHk+dHIuYW50LXRhYmxlLXJvdy1zZWxlY3RlZD50ZHtiYWNrZ3JvdW5kOiNlNmY3ZmY7Ym9yZGVyLWNvbG9yOnJnYmEoMCwwLDAsLjAzKX0uYW50LXRhYmxlLXRib2R5PnRyLmFudC10YWJsZS1yb3ctc2VsZWN0ZWQ6aG92ZXI+dGR7YmFja2dyb3VuZDojZGNmNGZmfS5hbnQtdGFibGUtc3VtbWFyeXtwb3NpdGlvbjpyZWxhdGl2ZTt6LWluZGV4OjI7YmFja2dyb3VuZDojZmZmfWRpdi5hbnQtdGFibGUtc3VtbWFyeXtib3gtc2hhZG93OjAgLTFweCAwICNmMGYwZjB9LmFudC10YWJsZS1zdW1tYXJ5PnRyPnRkLC5hbnQtdGFibGUtc3VtbWFyeT50cj50aHtib3JkZXItYm90dG9tOjFweCBzb2xpZCAjZjBmMGYwfS5hbnQtdGFibGUtcGFnaW5hdGlvbi5hbnQtcGFnaW5hdGlvbnttYXJnaW46MTZweCAwfS5hbnQtdGFibGUtcGFnaW5hdGlvbntkaXNwbGF5OmZsZXg7ZmxleC13cmFwOndyYXA7cm93LWdhcDo4cHh9LmFudC10YWJsZS1wYWdpbmF0aW9uPip7ZmxleDpub25lfS5hbnQtdGFibGUtcGFnaW5hdGlvbi1sZWZ0e2p1c3RpZnktY29udGVudDpmbGV4LXN0YXJ0fS5hbnQtdGFibGUtcGFnaW5hdGlvbi1jZW50ZXJ7anVzdGlmeS1jb250ZW50OmNlbnRlcn0uYW50LXRhYmxlLXBhZ2luYXRpb24tcmlnaHR7anVzdGlmeS1jb250ZW50OmZsZXgtZW5kfS5hbnQtdGFibGUtdGhlYWQgdGguYW50LXRhYmxlLWNvbHVtbi1oYXMtc29ydGVyc3tvdXRsaW5lOm5vbmU7Y3Vyc29yOnBvaW50ZXI7dHJhbnNpdGlvbjphbGwgLjNzfS5hbnQtdGFibGUtdGhlYWQgdGguYW50LXRhYmxlLWNvbHVtbi1oYXMtc29ydGVyczpob3ZlcntiYWNrZ3JvdW5kOnJnYmEoMCwwLDAsLjA0KX0uYW50LXRhYmxlLXRoZWFkIHRoLmFudC10YWJsZS1jb2x1bW4taGFzLXNvcnRlcnM6aG92ZXI6YmVmb3Jle2JhY2tncm91bmQtY29sb3I6dHJhbnNwYXJlbnQhaW1wb3J0YW50fS5hbnQtdGFibGUtdGhlYWQgdGguYW50LXRhYmxlLWNvbHVtbi1oYXMtc29ydGVyczpmb2N1cy12aXNpYmxle2NvbG9yOiMxODkwZmZ9LmFudC10YWJsZS10aGVhZCB0aC5hbnQtdGFibGUtY29sdW1uLWhhcy1zb3J0ZXJzLmFudC10YWJsZS1jZWxsLWZpeC1sZWZ0OmhvdmVyLC5hbnQtdGFibGUtdGhlYWQgdGguYW50LXRhYmxlLWNvbHVtbi1oYXMtc29ydGVycy5hbnQtdGFibGUtY2VsbC1maXgtcmlnaHQ6aG92ZXIsLmFudC10YWJsZS10aGVhZCB0aC5hbnQtdGFibGUtY29sdW1uLXNvcnR7YmFja2dyb3VuZDojZjVmNWY1fS5hbnQtdGFibGUtdGhlYWQgdGguYW50LXRhYmxlLWNvbHVtbi1zb3J0OmJlZm9yZXtiYWNrZ3JvdW5kLWNvbG9yOnRyYW5zcGFyZW50IWltcG9ydGFudH10ZC5hbnQtdGFibGUtY29sdW1uLXNvcnR7YmFja2dyb3VuZDojZmFmYWZhfS5hbnQtdGFibGUtY29sdW1uLXRpdGxle3Bvc2l0aW9uOnJlbGF0aXZlO3otaW5kZXg6MTtmbGV4OjF9LmFudC10YWJsZS1jb2x1bW4tc29ydGVyc3tkaXNwbGF5OmZsZXg7ZmxleDphdXRvO2FsaWduLWl0ZW1zOmNlbnRlcjtqdXN0aWZ5LWNvbnRlbnQ6c3BhY2UtYmV0d2Vlbn0uYW50LXRhYmxlLWNvbHVtbi1zb3J0ZXJzOmFmdGVye3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO3JpZ2h0OjA7Ym90dG9tOjA7bGVmdDowO3dpZHRoOjEwMCU7aGVpZ2h0OjEwMCU7Y29udGVudDpcIlwifS5hbnQtdGFibGUtY29sdW1uLXNvcnRlcnttYXJnaW4tbGVmdDo0cHg7Y29sb3I6I2JmYmZiZjtmb250LXNpemU6MDt0cmFuc2l0aW9uOmNvbG9yIC4zc30uYW50LXRhYmxlLWNvbHVtbi1zb3J0ZXItaW5uZXJ7ZGlzcGxheTppbmxpbmUtZmxleDtmbGV4LWRpcmVjdGlvbjpjb2x1bW47YWxpZ24taXRlbXM6Y2VudGVyfS5hbnQtdGFibGUtY29sdW1uLXNvcnRlci1kb3duLC5hbnQtdGFibGUtY29sdW1uLXNvcnRlci11cHtmb250LXNpemU6MTFweH0uYW50LXRhYmxlLWNvbHVtbi1zb3J0ZXItZG93bi5hY3RpdmUsLmFudC10YWJsZS1jb2x1bW4tc29ydGVyLXVwLmFjdGl2ZXtjb2xvcjojMTg5MGZmfS5hbnQtdGFibGUtY29sdW1uLXNvcnRlci11cCsuYW50LXRhYmxlLWNvbHVtbi1zb3J0ZXItZG93bnttYXJnaW4tdG9wOi0uM2VtfS5hbnQtdGFibGUtY29sdW1uLXNvcnRlcnM6aG92ZXIgLmFudC10YWJsZS1jb2x1bW4tc29ydGVye2NvbG9yOiNhNmE2YTZ9LmFudC10YWJsZS1maWx0ZXItY29sdW1ue2Rpc3BsYXk6ZmxleDtqdXN0aWZ5LWNvbnRlbnQ6c3BhY2UtYmV0d2Vlbn0uYW50LXRhYmxlLWZpbHRlci10cmlnZ2Vye3Bvc2l0aW9uOnJlbGF0aXZlO2Rpc3BsYXk6ZmxleDthbGlnbi1pdGVtczpjZW50ZXI7bWFyZ2luOi00cHggLThweCAtNHB4IDRweDtwYWRkaW5nOjAgNHB4O2NvbG9yOiNiZmJmYmY7Zm9udC1zaXplOjEycHg7Ym9yZGVyLXJhZGl1czoycHg7Y3Vyc29yOnBvaW50ZXI7dHJhbnNpdGlvbjphbGwgLjNzfS5hbnQtdGFibGUtZmlsdGVyLXRyaWdnZXI6aG92ZXJ7Y29sb3I6cmdiYSgwLDAsMCwuNDUpO2JhY2tncm91bmQ6cmdiYSgwLDAsMCwuMDQpfS5hbnQtdGFibGUtZmlsdGVyLXRyaWdnZXIuYWN0aXZle2NvbG9yOiMxODkwZmZ9LmFudC10YWJsZS1maWx0ZXItZHJvcGRvd257Ym94LXNpemluZzpib3JkZXItYm94O21hcmdpbjowO3BhZGRpbmc6MDtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7Zm9udC1zaXplOjE0cHg7Zm9udC12YXJpYW50OnRhYnVsYXItbnVtcztsaW5lLWhlaWdodDoxLjU3MTU7bGlzdC1zdHlsZTpub25lO2ZvbnQtZmVhdHVyZS1zZXR0aW5nczpcInRudW1cIjttaW4td2lkdGg6MTIwcHg7YmFja2dyb3VuZC1jb2xvcjojZmZmO2JvcmRlci1yYWRpdXM6MnB4O2JveC1zaGFkb3c6MCAzcHggNnB4IC00cHggcmdiYSgwLDAsMCwuMTIpLDAgNnB4IDE2cHggMCByZ2JhKDAsMCwwLC4wOCksMCA5cHggMjhweCA4cHggcmdiYSgwLDAsMCwuMDUpfS5hbnQtdGFibGUtZmlsdGVyLWRyb3Bkb3duIC5hbnQtZHJvcGRvd24tbWVudXttYXgtaGVpZ2h0OjI2NHB4O292ZXJmbG93LXg6aGlkZGVuO2JvcmRlcjowO2JveC1zaGFkb3c6bm9uZX0uYW50LXRhYmxlLWZpbHRlci1kcm9wZG93biAuYW50LWRyb3Bkb3duLW1lbnU6ZW1wdHk6YWZ0ZXJ7ZGlzcGxheTpibG9jaztwYWRkaW5nOjhweCAwO2NvbG9yOnJnYmEoMCwwLDAsLjI1KTtmb250LXNpemU6MTJweDt0ZXh0LWFsaWduOmNlbnRlcjtjb250ZW50OlwiTm90IEZvdW5kXCJ9LmFudC10YWJsZS1maWx0ZXItZHJvcGRvd24tdHJlZXtwYWRkaW5nOjhweCA4cHggMH0uYW50LXRhYmxlLWZpbHRlci1kcm9wZG93bi10cmVlIC5hbnQtdHJlZS10cmVlbm9kZSAuYW50LXRyZWUtbm9kZS1jb250ZW50LXdyYXBwZXI6aG92ZXJ7YmFja2dyb3VuZC1jb2xvcjojZjVmNWY1fS5hbnQtdGFibGUtZmlsdGVyLWRyb3Bkb3duLXRyZWUgLmFudC10cmVlLXRyZWVub2RlLWNoZWNrYm94LWNoZWNrZWQgLmFudC10cmVlLW5vZGUtY29udGVudC13cmFwcGVyLC5hbnQtdGFibGUtZmlsdGVyLWRyb3Bkb3duLXRyZWUgLmFudC10cmVlLXRyZWVub2RlLWNoZWNrYm94LWNoZWNrZWQgLmFudC10cmVlLW5vZGUtY29udGVudC13cmFwcGVyOmhvdmVye2JhY2tncm91bmQtY29sb3I6I2JhZTdmZn0uYW50LXRhYmxlLWZpbHRlci1kcm9wZG93bi1zZWFyY2h7cGFkZGluZzo4cHg7Ym9yZGVyLWJvdHRvbToxcHggc29saWQgI2YwZjBmMH0uYW50LXRhYmxlLWZpbHRlci1kcm9wZG93bi1zZWFyY2gtaW5wdXQgaW5wdXR7bWluLXdpZHRoOjE0MHB4fS5hbnQtdGFibGUtZmlsdGVyLWRyb3Bkb3duLXNlYXJjaC1pbnB1dCAuYW50aWNvbntjb2xvcjpyZ2JhKDAsMCwwLC4yNSl9LmFudC10YWJsZS1maWx0ZXItZHJvcGRvd24tY2hlY2thbGx7d2lkdGg6MTAwJTttYXJnaW4tYm90dG9tOjRweDttYXJnaW4tbGVmdDo0cHh9LmFudC10YWJsZS1maWx0ZXItZHJvcGRvd24tc3VibWVudT51bHttYXgtaGVpZ2h0OmNhbGMoMTAwdmggLSAxMzBweCk7b3ZlcmZsb3cteDpoaWRkZW47b3ZlcmZsb3cteTphdXRvfS5hbnQtdGFibGUtZmlsdGVyLWRyb3Bkb3duLXN1Ym1lbnUgLmFudC1jaGVja2JveC13cmFwcGVyK3NwYW4sLmFudC10YWJsZS1maWx0ZXItZHJvcGRvd24gLmFudC1jaGVja2JveC13cmFwcGVyK3NwYW57cGFkZGluZy1sZWZ0OjhweH0uYW50LXRhYmxlLWZpbHRlci1kcm9wZG93bi1idG5ze2Rpc3BsYXk6ZmxleDtqdXN0aWZ5LWNvbnRlbnQ6c3BhY2UtYmV0d2VlbjtwYWRkaW5nOjdweCA4cHg7b3ZlcmZsb3c6aGlkZGVuO2JhY2tncm91bmQtY29sb3I6aW5oZXJpdDtib3JkZXItdG9wOjFweCBzb2xpZCAjZjBmMGYwfS5hbnQtdGFibGUtc2VsZWN0aW9uLWNvbHt3aWR0aDozMnB4fS5hbnQtdGFibGUtYm9yZGVyZWQgLmFudC10YWJsZS1zZWxlY3Rpb24tY29se3dpZHRoOjUwcHh9dGFibGUgdHIgdGQuYW50LXRhYmxlLXNlbGVjdGlvbi1jb2x1bW4sdGFibGUgdHIgdGguYW50LXRhYmxlLXNlbGVjdGlvbi1jb2x1bW57cGFkZGluZy1yaWdodDo4cHg7cGFkZGluZy1sZWZ0OjhweDt0ZXh0LWFsaWduOmNlbnRlcn10YWJsZSB0ciB0ZC5hbnQtdGFibGUtc2VsZWN0aW9uLWNvbHVtbiAuYW50LXJhZGlvLXdyYXBwZXIsdGFibGUgdHIgdGguYW50LXRhYmxlLXNlbGVjdGlvbi1jb2x1bW4gLmFudC1yYWRpby13cmFwcGVye21hcmdpbi1yaWdodDowfXRhYmxlIHRyIHRoLmFudC10YWJsZS1zZWxlY3Rpb24tY29sdW1uLmFudC10YWJsZS1jZWxsLWZpeC1sZWZ0e3otaW5kZXg6M310YWJsZSB0ciB0aC5hbnQtdGFibGUtc2VsZWN0aW9uLWNvbHVtbjphZnRlcntiYWNrZ3JvdW5kLWNvbG9yOnRyYW5zcGFyZW50IWltcG9ydGFudH0uYW50LXRhYmxlLXNlbGVjdGlvbntwb3NpdGlvbjpyZWxhdGl2ZTtkaXNwbGF5OmlubGluZS1mbGV4O2ZsZXgtZGlyZWN0aW9uOmNvbHVtbn0uYW50LXRhYmxlLXNlbGVjdGlvbi1leHRyYXtwb3NpdGlvbjphYnNvbHV0ZTt0b3A6MDt6LWluZGV4OjE7Y3Vyc29yOnBvaW50ZXI7dHJhbnNpdGlvbjphbGwgLjNzOy13ZWJraXQtbWFyZ2luLXN0YXJ0OjEwMCU7bWFyZ2luLWlubGluZS1zdGFydDoxMDAlOy13ZWJraXQtcGFkZGluZy1zdGFydDo0cHg7cGFkZGluZy1pbmxpbmUtc3RhcnQ6NHB4fS5hbnQtdGFibGUtc2VsZWN0aW9uLWV4dHJhIC5hbnRpY29ue2NvbG9yOiNiZmJmYmY7Zm9udC1zaXplOjEwcHh9LmFudC10YWJsZS1zZWxlY3Rpb24tZXh0cmEgLmFudGljb246aG92ZXJ7Y29sb3I6I2E2YTZhNn0uYW50LXRhYmxlLWV4cGFuZC1pY29uLWNvbHt3aWR0aDo0OHB4fS5hbnQtdGFibGUtcm93LWV4cGFuZC1pY29uLWNlbGx7dGV4dC1hbGlnbjpjZW50ZXJ9LmFudC10YWJsZS1yb3ctZXhwYW5kLWljb24tY2VsbCAuYW50LXRhYmxlLXJvdy1leHBhbmQtaWNvbntkaXNwbGF5OmlubGluZS1mbGV4O2Zsb2F0Om5vbmU7dmVydGljYWwtYWxpZ246c3VifS5hbnQtdGFibGUtcm93LWluZGVudHtmbG9hdDpsZWZ0O2hlaWdodDoxcHh9LmFudC10YWJsZS1yb3ctZXhwYW5kLWljb257Y29sb3I6IzE4OTBmZjtvdXRsaW5lOm5vbmU7Y3Vyc29yOnBvaW50ZXI7dHJhbnNpdGlvbjpjb2xvciAuM3M7cG9zaXRpb246cmVsYXRpdmU7ZmxvYXQ6bGVmdDtib3gtc2l6aW5nOmJvcmRlci1ib3g7d2lkdGg6MTdweDtoZWlnaHQ6MTdweDtwYWRkaW5nOjA7Y29sb3I6aW5oZXJpdDtsaW5lLWhlaWdodDoxN3B4O2JhY2tncm91bmQ6I2ZmZjtib3JkZXI6MXB4IHNvbGlkICNmMGYwZjA7Ym9yZGVyLXJhZGl1czoycHg7dHJhbnNmb3JtOnNjYWxlKC45NDExNzY0Nyk7dHJhbnNpdGlvbjphbGwgLjNzOy13ZWJraXQtdXNlci1zZWxlY3Q6bm9uZTstbW96LXVzZXItc2VsZWN0Om5vbmU7LW1zLXVzZXItc2VsZWN0Om5vbmU7dXNlci1zZWxlY3Q6bm9uZX0uYW50LXRhYmxlLXJvdy1leHBhbmQtaWNvbjpmb2N1cy12aXNpYmxlLC5hbnQtdGFibGUtcm93LWV4cGFuZC1pY29uOmhvdmVye2NvbG9yOiM0MGE5ZmZ9LmFudC10YWJsZS1yb3ctZXhwYW5kLWljb246YWN0aXZle2NvbG9yOiMwOTZkZDl9LmFudC10YWJsZS1yb3ctZXhwYW5kLWljb246YWN0aXZlLC5hbnQtdGFibGUtcm93LWV4cGFuZC1pY29uOmZvY3VzLC5hbnQtdGFibGUtcm93LWV4cGFuZC1pY29uOmhvdmVye2JvcmRlci1jb2xvcjpjdXJyZW50Y29sb3J9LmFudC10YWJsZS1yb3ctZXhwYW5kLWljb246YWZ0ZXIsLmFudC10YWJsZS1yb3ctZXhwYW5kLWljb246YmVmb3Jle3Bvc2l0aW9uOmFic29sdXRlO2JhY2tncm91bmQ6Y3VycmVudGNvbG9yO3RyYW5zaXRpb246dHJhbnNmb3JtIC4zcyBlYXNlLW91dDtjb250ZW50OlwiXCJ9LmFudC10YWJsZS1yb3ctZXhwYW5kLWljb246YmVmb3Jle3RvcDo3cHg7cmlnaHQ6M3B4O2xlZnQ6M3B4O2hlaWdodDoxcHh9LmFudC10YWJsZS1yb3ctZXhwYW5kLWljb246YWZ0ZXJ7dG9wOjNweDtib3R0b206M3B4O2xlZnQ6N3B4O3dpZHRoOjFweDt0cmFuc2Zvcm06cm90YXRlKDkwZGVnKX0uYW50LXRhYmxlLXJvdy1leHBhbmQtaWNvbi1jb2xsYXBzZWQ6YmVmb3Jle3RyYW5zZm9ybTpyb3RhdGUoLTE4MGRlZyl9LmFudC10YWJsZS1yb3ctZXhwYW5kLWljb24tY29sbGFwc2VkOmFmdGVye3RyYW5zZm9ybTpyb3RhdGUoMGRlZyl9LmFudC10YWJsZS1yb3ctZXhwYW5kLWljb24tc3BhY2Vke2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7Ym9yZGVyOjA7dmlzaWJpbGl0eTpoaWRkZW59LmFudC10YWJsZS1yb3ctZXhwYW5kLWljb24tc3BhY2VkOmFmdGVyLC5hbnQtdGFibGUtcm93LWV4cGFuZC1pY29uLXNwYWNlZDpiZWZvcmV7ZGlzcGxheTpub25lO2NvbnRlbnQ6bm9uZX0uYW50LXRhYmxlLXJvdy1pbmRlbnQrLmFudC10YWJsZS1yb3ctZXhwYW5kLWljb257bWFyZ2luLXRvcDoyLjUwMDVweDttYXJnaW4tcmlnaHQ6OHB4fXRyLmFudC10YWJsZS1leHBhbmRlZC1yb3c6aG92ZXI+dGQsdHIuYW50LXRhYmxlLWV4cGFuZGVkLXJvdz50ZHtiYWNrZ3JvdW5kOiNmYmZiZmJ9dHIuYW50LXRhYmxlLWV4cGFuZGVkLXJvdyAuYW50LWRlc2NyaXB0aW9ucy12aWV3e2Rpc3BsYXk6ZmxleH10ci5hbnQtdGFibGUtZXhwYW5kZWQtcm93IC5hbnQtZGVzY3JpcHRpb25zLXZpZXcgdGFibGV7ZmxleDphdXRvO3dpZHRoOmF1dG99LmFudC10YWJsZSAuYW50LXRhYmxlLWV4cGFuZGVkLXJvdy1maXhlZHtwb3NpdGlvbjpyZWxhdGl2ZTttYXJnaW46LTE2cHg7cGFkZGluZzoxNnB4fS5hbnQtdGFibGUtdGJvZHk+dHIuYW50LXRhYmxlLXBsYWNlaG9sZGVye3RleHQtYWxpZ246Y2VudGVyfS5hbnQtdGFibGUtZW1wdHkgLmFudC10YWJsZS10Ym9keT50ci5hbnQtdGFibGUtcGxhY2Vob2xkZXJ7Y29sb3I6cmdiYSgwLDAsMCwuMjUpfS5hbnQtdGFibGUtdGJvZHk+dHIuYW50LXRhYmxlLXBsYWNlaG9sZGVyOmhvdmVyPnRke2JhY2tncm91bmQ6I2ZmZn0uYW50LXRhYmxlLWNlbGwtZml4LWxlZnQsLmFudC10YWJsZS1jZWxsLWZpeC1yaWdodHtwb3NpdGlvbjpzdGlja3khaW1wb3J0YW50O3otaW5kZXg6MjtiYWNrZ3JvdW5kOiNmZmZ9LmFudC10YWJsZS1jZWxsLWZpeC1sZWZ0LWZpcnN0OmFmdGVyLC5hbnQtdGFibGUtY2VsbC1maXgtbGVmdC1sYXN0OmFmdGVye3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO3JpZ2h0OjA7Ym90dG9tOi0xcHg7d2lkdGg6MzBweDt0cmFuc2Zvcm06dHJhbnNsYXRlWCgxMDAlKTt0cmFuc2l0aW9uOmJveC1zaGFkb3cgLjNzO2NvbnRlbnQ6XCJcIjtwb2ludGVyLWV2ZW50czpub25lfS5hbnQtdGFibGUtY2VsbC1maXgtbGVmdC1hbGw6YWZ0ZXJ7ZGlzcGxheTpub25lfS5hbnQtdGFibGUtY2VsbC1maXgtcmlnaHQtZmlyc3Q6YWZ0ZXIsLmFudC10YWJsZS1jZWxsLWZpeC1yaWdodC1sYXN0OmFmdGVye3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO2JvdHRvbTotMXB4O2xlZnQ6MDt3aWR0aDozMHB4O3RyYW5zZm9ybTp0cmFuc2xhdGVYKC0xMDAlKTt0cmFuc2l0aW9uOmJveC1zaGFkb3cgLjNzO2NvbnRlbnQ6XCJcIjtwb2ludGVyLWV2ZW50czpub25lfS5hbnQtdGFibGUgLmFudC10YWJsZS1jb250YWluZXI6YWZ0ZXIsLmFudC10YWJsZSAuYW50LXRhYmxlLWNvbnRhaW5lcjpiZWZvcmV7cG9zaXRpb246YWJzb2x1dGU7dG9wOjA7Ym90dG9tOjA7ei1pbmRleDo0O3dpZHRoOjMwcHg7dHJhbnNpdGlvbjpib3gtc2hhZG93IC4zcztjb250ZW50OlwiXCI7cG9pbnRlci1ldmVudHM6bm9uZX0uYW50LXRhYmxlIC5hbnQtdGFibGUtY29udGFpbmVyOmJlZm9yZXtsZWZ0OjB9LmFudC10YWJsZSAuYW50LXRhYmxlLWNvbnRhaW5lcjphZnRlcntyaWdodDowfS5hbnQtdGFibGUtcGluZy1sZWZ0Om5vdCguYW50LXRhYmxlLWhhcy1maXgtbGVmdCk+LmFudC10YWJsZS1jb250YWluZXJ7cG9zaXRpb246cmVsYXRpdmV9LmFudC10YWJsZS1waW5nLWxlZnQgLmFudC10YWJsZS1jZWxsLWZpeC1sZWZ0LWZpcnN0OmFmdGVyLC5hbnQtdGFibGUtcGluZy1sZWZ0IC5hbnQtdGFibGUtY2VsbC1maXgtbGVmdC1sYXN0OmFmdGVyLC5hbnQtdGFibGUtcGluZy1sZWZ0Om5vdCguYW50LXRhYmxlLWhhcy1maXgtbGVmdCk+LmFudC10YWJsZS1jb250YWluZXI6YmVmb3Jle2JveC1zaGFkb3c6aW5zZXQgMTBweCAwIDhweCAtOHB4IHJnYmEoMCwwLDAsLjE1KX0uYW50LXRhYmxlLXBpbmctbGVmdCAuYW50LXRhYmxlLWNlbGwtZml4LWxlZnQtbGFzdDpiZWZvcmV7YmFja2dyb3VuZC1jb2xvcjp0cmFuc3BhcmVudCFpbXBvcnRhbnR9LmFudC10YWJsZS1waW5nLXJpZ2h0Om5vdCguYW50LXRhYmxlLWhhcy1maXgtcmlnaHQpPi5hbnQtdGFibGUtY29udGFpbmVye3Bvc2l0aW9uOnJlbGF0aXZlfS5hbnQtdGFibGUtcGluZy1yaWdodCAuYW50LXRhYmxlLWNlbGwtZml4LXJpZ2h0LWZpcnN0OmFmdGVyLC5hbnQtdGFibGUtcGluZy1yaWdodCAuYW50LXRhYmxlLWNlbGwtZml4LXJpZ2h0LWxhc3Q6YWZ0ZXIsLmFudC10YWJsZS1waW5nLXJpZ2h0Om5vdCguYW50LXRhYmxlLWhhcy1maXgtcmlnaHQpPi5hbnQtdGFibGUtY29udGFpbmVyOmFmdGVye2JveC1zaGFkb3c6aW5zZXQgLTEwcHggMCA4cHggLThweCByZ2JhKDAsMCwwLC4xNSl9LmFudC10YWJsZS1zdGlja3ktaG9sZGVyLC5hbnQtdGFibGUtc3RpY2t5LXNjcm9sbHtwb3NpdGlvbjpzdGlja3k7ei1pbmRleDozO2JhY2tncm91bmQ6I2ZmZn0uYW50LXRhYmxlLXN0aWNreS1zY3JvbGx7Ym90dG9tOjA7ZGlzcGxheTpmbGV4O2FsaWduLWl0ZW1zOmNlbnRlcjtib3JkZXItdG9wOjFweCBzb2xpZCAjZjBmMGYwO29wYWNpdHk6LjZ9LmFudC10YWJsZS1zdGlja3ktc2Nyb2xsOmhvdmVye3RyYW5zZm9ybS1vcmlnaW46Y2VudGVyIGJvdHRvbX0uYW50LXRhYmxlLXN0aWNreS1zY3JvbGwtYmFye2hlaWdodDo4cHg7YmFja2dyb3VuZC1jb2xvcjpyZ2JhKDAsMCwwLC4zNSk7Ym9yZGVyLXJhZGl1czo0cHh9LmFudC10YWJsZS1zdGlja3ktc2Nyb2xsLWJhci1hY3RpdmUsLmFudC10YWJsZS1zdGlja3ktc2Nyb2xsLWJhcjpob3ZlcntiYWNrZ3JvdW5kLWNvbG9yOnJnYmEoMCwwLDAsLjgpfUBtZWRpYSAoLW1zLWhpZ2gtY29udHJhc3Q6bm9uZSl7LmFudC10YWJsZS1waW5nLWxlZnQgLmFudC10YWJsZS1jZWxsLWZpeC1sZWZ0LWxhc3Q6YWZ0ZXIsLmFudC10YWJsZS1waW5nLXJpZ2h0IC5hbnQtdGFibGUtY2VsbC1maXgtcmlnaHQtZmlyc3Q6YWZ0ZXJ7Ym94LXNoYWRvdzpub25lIWltcG9ydGFudH19LmFudC10YWJsZS10aXRsZXtib3JkZXItcmFkaXVzOjJweCAycHggMCAwfS5hbnQtdGFibGUtdGl0bGUrLmFudC10YWJsZS1jb250YWluZXJ7Ym9yZGVyLXRvcC1sZWZ0LXJhZGl1czowO2JvcmRlci10b3AtcmlnaHQtcmFkaXVzOjB9LmFudC10YWJsZS10aXRsZSsuYW50LXRhYmxlLWNvbnRhaW5lciB0YWJsZSwuYW50LXRhYmxlLXRpdGxlKy5hbnQtdGFibGUtY29udGFpbmVyIHRhYmxlPnRoZWFkPnRyOmZpcnN0LWNoaWxkIHRoOmZpcnN0LWNoaWxkLC5hbnQtdGFibGUtdGl0bGUrLmFudC10YWJsZS1jb250YWluZXIgdGFibGU+dGhlYWQ+dHI6Zmlyc3QtY2hpbGQgdGg6bGFzdC1jaGlsZHtib3JkZXItcmFkaXVzOjB9LmFudC10YWJsZS1jb250YWluZXJ7Ym9yZGVyLXRvcC1yaWdodC1yYWRpdXM6MnB4fS5hbnQtdGFibGUtY29udGFpbmVyLC5hbnQtdGFibGUtY29udGFpbmVyIHRhYmxlPnRoZWFkPnRyOmZpcnN0LWNoaWxkIHRoOmZpcnN0LWNoaWxke2JvcmRlci10b3AtbGVmdC1yYWRpdXM6MnB4fS5hbnQtdGFibGUtY29udGFpbmVyIHRhYmxlPnRoZWFkPnRyOmZpcnN0LWNoaWxkIHRoOmxhc3QtY2hpbGR7Ym9yZGVyLXRvcC1yaWdodC1yYWRpdXM6MnB4fS5hbnQtdGFibGUtZm9vdGVye2JvcmRlci1yYWRpdXM6MCAwIDJweCAycHh9LmFudC10YWJsZS1ydGwsLmFudC10YWJsZS13cmFwcGVyLXJ0bHtkaXJlY3Rpb246cnRsfS5hbnQtdGFibGUtd3JhcHBlci1ydGwgLmFudC10YWJsZSB0YWJsZXt0ZXh0LWFsaWduOnJpZ2h0fS5hbnQtdGFibGUtd3JhcHBlci1ydGwgLmFudC10YWJsZS10aGVhZD50cj50aFtjb2xzcGFuXTpub3QoW2NvbHNwYW49XCIxXCJdKXt0ZXh0LWFsaWduOmNlbnRlcn0uYW50LXRhYmxlLXdyYXBwZXItcnRsIC5hbnQtdGFibGUtdGhlYWQ+dHI+dGg6bm90KDpsYXN0LWNoaWxkKTpub3QoLmFudC10YWJsZS1zZWxlY3Rpb24tY29sdW1uKTpub3QoLmFudC10YWJsZS1yb3ctZXhwYW5kLWljb24tY2VsbCk6bm90KFtjb2xzcGFuXSk6YmVmb3Jle3JpZ2h0OmF1dG87bGVmdDowfS5hbnQtdGFibGUtd3JhcHBlci1ydGwgLmFudC10YWJsZS10aGVhZD50cj50aHt0ZXh0LWFsaWduOnJpZ2h0fS5hbnQtdGFibGUtdGJvZHk+dHIgLmFudC10YWJsZS13cmFwcGVyOm9ubHktY2hpbGQgLmFudC10YWJsZS5hbnQtdGFibGUtcnRse21hcmdpbjotMTZweCAzM3B4IC0xNnB4IC0xNnB4fS5hbnQtdGFibGUtd3JhcHBlci5hbnQtdGFibGUtd3JhcHBlci1ydGwgLmFudC10YWJsZS1wYWdpbmF0aW9uLWxlZnR7anVzdGlmeS1jb250ZW50OmZsZXgtZW5kfS5hbnQtdGFibGUtd3JhcHBlci5hbnQtdGFibGUtd3JhcHBlci1ydGwgLmFudC10YWJsZS1wYWdpbmF0aW9uLXJpZ2h0e2p1c3RpZnktY29udGVudDpmbGV4LXN0YXJ0fS5hbnQtdGFibGUtd3JhcHBlci1ydGwgLmFudC10YWJsZS1jb2x1bW4tc29ydGVye21hcmdpbi1yaWdodDo0cHg7bWFyZ2luLWxlZnQ6MH0uYW50LXRhYmxlLXdyYXBwZXItcnRsIC5hbnQtdGFibGUtZmlsdGVyLWNvbHVtbi10aXRsZXtwYWRkaW5nOjE2cHggMTZweCAxNnB4IDIuM2VtfS5hbnQtdGFibGUtcnRsIC5hbnQtdGFibGUtdGhlYWQgdHIgdGguYW50LXRhYmxlLWNvbHVtbi1oYXMtc29ydGVycyAuYW50LXRhYmxlLWZpbHRlci1jb2x1bW4tdGl0bGV7cGFkZGluZzowIDAgMCAyLjNlbX0uYW50LXRhYmxlLXdyYXBwZXItcnRsIC5hbnQtdGFibGUtZmlsdGVyLXRyaWdnZXJ7bWFyZ2luOi00cHggNHB4IC00cHggLThweH0uYW50LWRyb3Bkb3duLW1lbnUtc3VibWVudS1ydGwuYW50LXRhYmxlLWZpbHRlci1kcm9wZG93bi1zdWJtZW51IC5hbnQtY2hlY2tib3gtd3JhcHBlcitzcGFuLC5hbnQtZHJvcGRvd24tbWVudS1zdWJtZW51LXJ0bC5hbnQtdGFibGUtZmlsdGVyLWRyb3Bkb3duIC5hbnQtY2hlY2tib3gtd3JhcHBlcitzcGFuLC5hbnQtZHJvcGRvd24tcnRsIC5hbnQtdGFibGUtZmlsdGVyLWRyb3Bkb3duLXN1Ym1lbnUgLmFudC1jaGVja2JveC13cmFwcGVyK3NwYW4sLmFudC1kcm9wZG93bi1ydGwgLmFudC10YWJsZS1maWx0ZXItZHJvcGRvd24gLmFudC1jaGVja2JveC13cmFwcGVyK3NwYW57cGFkZGluZy1yaWdodDo4cHg7cGFkZGluZy1sZWZ0OjB9LmFudC10YWJsZS13cmFwcGVyLXJ0bCAuYW50LXRhYmxlLXNlbGVjdGlvbnt0ZXh0LWFsaWduOmNlbnRlcn0uYW50LXRhYmxlLXdyYXBwZXItcnRsIC5hbnQtdGFibGUtcm93LWV4cGFuZC1pY29uLC5hbnQtdGFibGUtd3JhcHBlci1ydGwgLmFudC10YWJsZS1yb3ctaW5kZW50e2Zsb2F0OnJpZ2h0fS5hbnQtdGFibGUtd3JhcHBlci1ydGwgLmFudC10YWJsZS1yb3ctaW5kZW50Ky5hbnQtdGFibGUtcm93LWV4cGFuZC1pY29ue21hcmdpbi1yaWdodDowO21hcmdpbi1sZWZ0OjhweH0uYW50LXRhYmxlLXdyYXBwZXItcnRsIC5hbnQtdGFibGUtcm93LWV4cGFuZC1pY29uOmFmdGVye3RyYW5zZm9ybTpyb3RhdGUoLTkwZGVnKX0uYW50LXRhYmxlLXdyYXBwZXItcnRsIC5hbnQtdGFibGUtcm93LWV4cGFuZC1pY29uLWNvbGxhcHNlZDpiZWZvcmV7dHJhbnNmb3JtOnJvdGF0ZSgxODBkZWcpfS5hbnQtdGFibGUtd3JhcHBlci1ydGwgLmFudC10YWJsZS1yb3ctZXhwYW5kLWljb24tY29sbGFwc2VkOmFmdGVye3RyYW5zZm9ybTpyb3RhdGUoMGRlZyl9LmFudC10YWJzLXNtYWxsPi5hbnQtdGFicy1uYXYgLmFudC10YWJzLXRhYntwYWRkaW5nOjhweCAwO2ZvbnQtc2l6ZToxNHB4fS5hbnQtdGFicy1sYXJnZT4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy10YWJ7cGFkZGluZzoxNnB4IDA7Zm9udC1zaXplOjE2cHh9LmFudC10YWJzLWNhcmQuYW50LXRhYnMtc21hbGw+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtdGFie3BhZGRpbmc6NnB4IDE2cHh9LmFudC10YWJzLWNhcmQuYW50LXRhYnMtbGFyZ2U+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtdGFie3BhZGRpbmc6N3B4IDE2cHggNnB4fS5hbnQtdGFicy1ydGx7ZGlyZWN0aW9uOnJ0bH0uYW50LXRhYnMtcnRsIC5hbnQtdGFicy1uYXYgLmFudC10YWJzLXRhYnttYXJnaW46MCAwIDAgMzJweH0uYW50LXRhYnMtcnRsIC5hbnQtdGFicy1uYXYgLmFudC10YWJzLXRhYjpsYXN0LW9mLXR5cGV7bWFyZ2luLWxlZnQ6MH0uYW50LXRhYnMtcnRsIC5hbnQtdGFicy1uYXYgLmFudC10YWJzLXRhYiAuYW50aWNvbnttYXJnaW4tcmlnaHQ6MDttYXJnaW4tbGVmdDoxMnB4fS5hbnQtdGFicy1ydGwgLmFudC10YWJzLW5hdiAuYW50LXRhYnMtdGFiIC5hbnQtdGFicy10YWItcmVtb3Zle21hcmdpbi1yaWdodDo4cHg7bWFyZ2luLWxlZnQ6LTRweH0uYW50LXRhYnMtcnRsIC5hbnQtdGFicy1uYXYgLmFudC10YWJzLXRhYiAuYW50LXRhYnMtdGFiLXJlbW92ZSAuYW50aWNvbnttYXJnaW46MH0uYW50LXRhYnMtcnRsLmFudC10YWJzLWxlZnQ+LmFudC10YWJzLW5hdntvcmRlcjoxfS5hbnQtdGFicy1ydGwuYW50LXRhYnMtbGVmdD4uYW50LXRhYnMtY29udGVudC1ob2xkZXIsLmFudC10YWJzLXJ0bC5hbnQtdGFicy1yaWdodD4uYW50LXRhYnMtbmF2e29yZGVyOjB9LmFudC10YWJzLXJ0bC5hbnQtdGFicy1yaWdodD4uYW50LXRhYnMtY29udGVudC1ob2xkZXJ7b3JkZXI6MX0uYW50LXRhYnMtcnRsLmFudC10YWJzLWNhcmQuYW50LXRhYnMtYm90dG9tPi5hbnQtdGFicy1uYXYgLmFudC10YWJzLW5hdi1hZGQsLmFudC10YWJzLXJ0bC5hbnQtdGFicy1jYXJkLmFudC10YWJzLWJvdHRvbT4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy10YWIrLmFudC10YWJzLXRhYiwuYW50LXRhYnMtcnRsLmFudC10YWJzLWNhcmQuYW50LXRhYnMtYm90dG9tPmRpdj4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1uYXYtYWRkLC5hbnQtdGFicy1ydGwuYW50LXRhYnMtY2FyZC5hbnQtdGFicy1ib3R0b20+ZGl2Pi5hbnQtdGFicy1uYXYgLmFudC10YWJzLXRhYisuYW50LXRhYnMtdGFiLC5hbnQtdGFicy1ydGwuYW50LXRhYnMtY2FyZC5hbnQtdGFicy10b3A+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtbmF2LWFkZCwuYW50LXRhYnMtcnRsLmFudC10YWJzLWNhcmQuYW50LXRhYnMtdG9wPi5hbnQtdGFicy1uYXYgLmFudC10YWJzLXRhYisuYW50LXRhYnMtdGFiLC5hbnQtdGFicy1ydGwuYW50LXRhYnMtY2FyZC5hbnQtdGFicy10b3A+ZGl2Pi5hbnQtdGFicy1uYXYgLmFudC10YWJzLW5hdi1hZGQsLmFudC10YWJzLXJ0bC5hbnQtdGFicy1jYXJkLmFudC10YWJzLXRvcD5kaXY+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtdGFiKy5hbnQtdGFicy10YWJ7bWFyZ2luLXJpZ2h0OjJweDttYXJnaW4tbGVmdDowfS5hbnQtdGFicy1kcm9wZG93bi1ydGx7ZGlyZWN0aW9uOnJ0bH0uYW50LXRhYnMtZHJvcGRvd24tcnRsIC5hbnQtdGFicy1kcm9wZG93bi1tZW51LWl0ZW17dGV4dC1hbGlnbjpyaWdodH0uYW50LXRhYnMtYm90dG9tLC5hbnQtdGFicy10b3B7ZmxleC1kaXJlY3Rpb246Y29sdW1ufS5hbnQtdGFicy1ib3R0b20+LmFudC10YWJzLW5hdiwuYW50LXRhYnMtYm90dG9tPmRpdj4uYW50LXRhYnMtbmF2LC5hbnQtdGFicy10b3A+LmFudC10YWJzLW5hdiwuYW50LXRhYnMtdG9wPmRpdj4uYW50LXRhYnMtbmF2e21hcmdpbjowIDAgMTZweH0uYW50LXRhYnMtYm90dG9tPi5hbnQtdGFicy1uYXY6YmVmb3JlLC5hbnQtdGFicy1ib3R0b20+ZGl2Pi5hbnQtdGFicy1uYXY6YmVmb3JlLC5hbnQtdGFicy10b3A+LmFudC10YWJzLW5hdjpiZWZvcmUsLmFudC10YWJzLXRvcD5kaXY+LmFudC10YWJzLW5hdjpiZWZvcmV7cG9zaXRpb246YWJzb2x1dGU7cmlnaHQ6MDtsZWZ0OjA7Ym9yZGVyLWJvdHRvbToxcHggc29saWQgI2YwZjBmMDtjb250ZW50OlwiXCJ9LmFudC10YWJzLWJvdHRvbT4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1pbmstYmFyLC5hbnQtdGFicy1ib3R0b20+ZGl2Pi5hbnQtdGFicy1uYXYgLmFudC10YWJzLWluay1iYXIsLmFudC10YWJzLXRvcD4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1pbmstYmFyLC5hbnQtdGFicy10b3A+ZGl2Pi5hbnQtdGFicy1uYXYgLmFudC10YWJzLWluay1iYXJ7aGVpZ2h0OjJweH0uYW50LXRhYnMtYm90dG9tPi5hbnQtdGFicy1uYXYgLmFudC10YWJzLWluay1iYXItYW5pbWF0ZWQsLmFudC10YWJzLWJvdHRvbT5kaXY+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtaW5rLWJhci1hbmltYXRlZCwuYW50LXRhYnMtdG9wPi5hbnQtdGFicy1uYXYgLmFudC10YWJzLWluay1iYXItYW5pbWF0ZWQsLmFudC10YWJzLXRvcD5kaXY+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtaW5rLWJhci1hbmltYXRlZHt0cmFuc2l0aW9uOndpZHRoIC4zcyxsZWZ0IC4zcyxyaWdodCAuM3N9LmFudC10YWJzLWJvdHRvbT4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1uYXYtd3JhcDphZnRlciwuYW50LXRhYnMtYm90dG9tPi5hbnQtdGFicy1uYXYgLmFudC10YWJzLW5hdi13cmFwOmJlZm9yZSwuYW50LXRhYnMtYm90dG9tPmRpdj4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1uYXYtd3JhcDphZnRlciwuYW50LXRhYnMtYm90dG9tPmRpdj4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1uYXYtd3JhcDpiZWZvcmUsLmFudC10YWJzLXRvcD4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1uYXYtd3JhcDphZnRlciwuYW50LXRhYnMtdG9wPi5hbnQtdGFicy1uYXYgLmFudC10YWJzLW5hdi13cmFwOmJlZm9yZSwuYW50LXRhYnMtdG9wPmRpdj4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1uYXYtd3JhcDphZnRlciwuYW50LXRhYnMtdG9wPmRpdj4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1uYXYtd3JhcDpiZWZvcmV7dG9wOjA7Ym90dG9tOjA7d2lkdGg6MzBweH0uYW50LXRhYnMtYm90dG9tPi5hbnQtdGFicy1uYXYgLmFudC10YWJzLW5hdi13cmFwOmJlZm9yZSwuYW50LXRhYnMtYm90dG9tPmRpdj4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1uYXYtd3JhcDpiZWZvcmUsLmFudC10YWJzLXRvcD4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1uYXYtd3JhcDpiZWZvcmUsLmFudC10YWJzLXRvcD5kaXY+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtbmF2LXdyYXA6YmVmb3Jle2xlZnQ6MDtib3gtc2hhZG93Omluc2V0IDEwcHggMCA4cHggLThweCByZ2JhKDAsMCwwLC4wOCl9LmFudC10YWJzLWJvdHRvbT4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1uYXYtd3JhcDphZnRlciwuYW50LXRhYnMtYm90dG9tPmRpdj4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1uYXYtd3JhcDphZnRlciwuYW50LXRhYnMtdG9wPi5hbnQtdGFicy1uYXYgLmFudC10YWJzLW5hdi13cmFwOmFmdGVyLC5hbnQtdGFicy10b3A+ZGl2Pi5hbnQtdGFicy1uYXYgLmFudC10YWJzLW5hdi13cmFwOmFmdGVye3JpZ2h0OjA7Ym94LXNoYWRvdzppbnNldCAtMTBweCAwIDhweCAtOHB4IHJnYmEoMCwwLDAsLjA4KX0uYW50LXRhYnMtYm90dG9tPi5hbnQtdGFicy1uYXYgLmFudC10YWJzLW5hdi13cmFwLmFudC10YWJzLW5hdi13cmFwLXBpbmctbGVmdDpiZWZvcmUsLmFudC10YWJzLWJvdHRvbT4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1uYXYtd3JhcC5hbnQtdGFicy1uYXYtd3JhcC1waW5nLXJpZ2h0OmFmdGVyLC5hbnQtdGFicy1ib3R0b20+ZGl2Pi5hbnQtdGFicy1uYXYgLmFudC10YWJzLW5hdi13cmFwLmFudC10YWJzLW5hdi13cmFwLXBpbmctbGVmdDpiZWZvcmUsLmFudC10YWJzLWJvdHRvbT5kaXY+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtbmF2LXdyYXAuYW50LXRhYnMtbmF2LXdyYXAtcGluZy1yaWdodDphZnRlciwuYW50LXRhYnMtdG9wPi5hbnQtdGFicy1uYXYgLmFudC10YWJzLW5hdi13cmFwLmFudC10YWJzLW5hdi13cmFwLXBpbmctbGVmdDpiZWZvcmUsLmFudC10YWJzLXRvcD4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1uYXYtd3JhcC5hbnQtdGFicy1uYXYtd3JhcC1waW5nLXJpZ2h0OmFmdGVyLC5hbnQtdGFicy10b3A+ZGl2Pi5hbnQtdGFicy1uYXYgLmFudC10YWJzLW5hdi13cmFwLmFudC10YWJzLW5hdi13cmFwLXBpbmctbGVmdDpiZWZvcmUsLmFudC10YWJzLXRvcD5kaXY+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtbmF2LXdyYXAuYW50LXRhYnMtbmF2LXdyYXAtcGluZy1yaWdodDphZnRlcntvcGFjaXR5OjF9LmFudC10YWJzLXRvcD4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1pbmstYmFyLC5hbnQtdGFicy10b3A+LmFudC10YWJzLW5hdjpiZWZvcmUsLmFudC10YWJzLXRvcD5kaXY+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtaW5rLWJhciwuYW50LXRhYnMtdG9wPmRpdj4uYW50LXRhYnMtbmF2OmJlZm9yZXtib3R0b206MH0uYW50LXRhYnMtYm90dG9tPi5hbnQtdGFicy1uYXYsLmFudC10YWJzLWJvdHRvbT5kaXY+LmFudC10YWJzLW5hdntvcmRlcjoxO21hcmdpbi10b3A6MTZweDttYXJnaW4tYm90dG9tOjB9LmFudC10YWJzLWJvdHRvbT4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1pbmstYmFyLC5hbnQtdGFicy1ib3R0b20+LmFudC10YWJzLW5hdjpiZWZvcmUsLmFudC10YWJzLWJvdHRvbT5kaXY+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtaW5rLWJhciwuYW50LXRhYnMtYm90dG9tPmRpdj4uYW50LXRhYnMtbmF2OmJlZm9yZXt0b3A6MH0uYW50LXRhYnMtYm90dG9tPi5hbnQtdGFicy1jb250ZW50LWhvbGRlciwuYW50LXRhYnMtYm90dG9tPmRpdj4uYW50LXRhYnMtY29udGVudC1ob2xkZXJ7b3JkZXI6MH0uYW50LXRhYnMtbGVmdD4uYW50LXRhYnMtbmF2LC5hbnQtdGFicy1sZWZ0PmRpdj4uYW50LXRhYnMtbmF2LC5hbnQtdGFicy1yaWdodD4uYW50LXRhYnMtbmF2LC5hbnQtdGFicy1yaWdodD5kaXY+LmFudC10YWJzLW5hdntmbGV4LWRpcmVjdGlvbjpjb2x1bW47bWluLXdpZHRoOjUwcHh9LmFudC10YWJzLWxlZnQ+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtdGFiLC5hbnQtdGFicy1sZWZ0PmRpdj4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy10YWIsLmFudC10YWJzLXJpZ2h0Pi5hbnQtdGFicy1uYXYgLmFudC10YWJzLXRhYiwuYW50LXRhYnMtcmlnaHQ+ZGl2Pi5hbnQtdGFicy1uYXYgLmFudC10YWJzLXRhYntwYWRkaW5nOjhweCAyNHB4O3RleHQtYWxpZ246Y2VudGVyfS5hbnQtdGFicy1sZWZ0Pi5hbnQtdGFicy1uYXYgLmFudC10YWJzLXRhYisuYW50LXRhYnMtdGFiLC5hbnQtdGFicy1sZWZ0PmRpdj4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy10YWIrLmFudC10YWJzLXRhYiwuYW50LXRhYnMtcmlnaHQ+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtdGFiKy5hbnQtdGFicy10YWIsLmFudC10YWJzLXJpZ2h0PmRpdj4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy10YWIrLmFudC10YWJzLXRhYnttYXJnaW46MTZweCAwIDB9LmFudC10YWJzLWxlZnQ+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtbmF2LXdyYXAsLmFudC10YWJzLWxlZnQ+ZGl2Pi5hbnQtdGFicy1uYXYgLmFudC10YWJzLW5hdi13cmFwLC5hbnQtdGFicy1yaWdodD4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1uYXYtd3JhcCwuYW50LXRhYnMtcmlnaHQ+ZGl2Pi5hbnQtdGFicy1uYXYgLmFudC10YWJzLW5hdi13cmFwe2ZsZXgtZGlyZWN0aW9uOmNvbHVtbn0uYW50LXRhYnMtbGVmdD4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1uYXYtd3JhcDphZnRlciwuYW50LXRhYnMtbGVmdD4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1uYXYtd3JhcDpiZWZvcmUsLmFudC10YWJzLWxlZnQ+ZGl2Pi5hbnQtdGFicy1uYXYgLmFudC10YWJzLW5hdi13cmFwOmFmdGVyLC5hbnQtdGFicy1sZWZ0PmRpdj4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1uYXYtd3JhcDpiZWZvcmUsLmFudC10YWJzLXJpZ2h0Pi5hbnQtdGFicy1uYXYgLmFudC10YWJzLW5hdi13cmFwOmFmdGVyLC5hbnQtdGFicy1yaWdodD4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1uYXYtd3JhcDpiZWZvcmUsLmFudC10YWJzLXJpZ2h0PmRpdj4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1uYXYtd3JhcDphZnRlciwuYW50LXRhYnMtcmlnaHQ+ZGl2Pi5hbnQtdGFicy1uYXYgLmFudC10YWJzLW5hdi13cmFwOmJlZm9yZXtyaWdodDowO2xlZnQ6MDtoZWlnaHQ6MzBweH0uYW50LXRhYnMtbGVmdD4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1uYXYtd3JhcDpiZWZvcmUsLmFudC10YWJzLWxlZnQ+ZGl2Pi5hbnQtdGFicy1uYXYgLmFudC10YWJzLW5hdi13cmFwOmJlZm9yZSwuYW50LXRhYnMtcmlnaHQ+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtbmF2LXdyYXA6YmVmb3JlLC5hbnQtdGFicy1yaWdodD5kaXY+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtbmF2LXdyYXA6YmVmb3Jle3RvcDowO2JveC1zaGFkb3c6aW5zZXQgMCAxMHB4IDhweCAtOHB4IHJnYmEoMCwwLDAsLjA4KX0uYW50LXRhYnMtbGVmdD4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1uYXYtd3JhcDphZnRlciwuYW50LXRhYnMtbGVmdD5kaXY+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtbmF2LXdyYXA6YWZ0ZXIsLmFudC10YWJzLXJpZ2h0Pi5hbnQtdGFicy1uYXYgLmFudC10YWJzLW5hdi13cmFwOmFmdGVyLC5hbnQtdGFicy1yaWdodD5kaXY+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtbmF2LXdyYXA6YWZ0ZXJ7Ym90dG9tOjA7Ym94LXNoYWRvdzppbnNldCAwIC0xMHB4IDhweCAtOHB4IHJnYmEoMCwwLDAsLjA4KX0uYW50LXRhYnMtbGVmdD4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1uYXYtd3JhcC5hbnQtdGFicy1uYXYtd3JhcC1waW5nLWJvdHRvbTphZnRlciwuYW50LXRhYnMtbGVmdD4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1uYXYtd3JhcC5hbnQtdGFicy1uYXYtd3JhcC1waW5nLXRvcDpiZWZvcmUsLmFudC10YWJzLWxlZnQ+ZGl2Pi5hbnQtdGFicy1uYXYgLmFudC10YWJzLW5hdi13cmFwLmFudC10YWJzLW5hdi13cmFwLXBpbmctYm90dG9tOmFmdGVyLC5hbnQtdGFicy1sZWZ0PmRpdj4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1uYXYtd3JhcC5hbnQtdGFicy1uYXYtd3JhcC1waW5nLXRvcDpiZWZvcmUsLmFudC10YWJzLXJpZ2h0Pi5hbnQtdGFicy1uYXYgLmFudC10YWJzLW5hdi13cmFwLmFudC10YWJzLW5hdi13cmFwLXBpbmctYm90dG9tOmFmdGVyLC5hbnQtdGFicy1yaWdodD4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1uYXYtd3JhcC5hbnQtdGFicy1uYXYtd3JhcC1waW5nLXRvcDpiZWZvcmUsLmFudC10YWJzLXJpZ2h0PmRpdj4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1uYXYtd3JhcC5hbnQtdGFicy1uYXYtd3JhcC1waW5nLWJvdHRvbTphZnRlciwuYW50LXRhYnMtcmlnaHQ+ZGl2Pi5hbnQtdGFicy1uYXYgLmFudC10YWJzLW5hdi13cmFwLmFudC10YWJzLW5hdi13cmFwLXBpbmctdG9wOmJlZm9yZXtvcGFjaXR5OjF9LmFudC10YWJzLWxlZnQ+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtaW5rLWJhciwuYW50LXRhYnMtbGVmdD5kaXY+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtaW5rLWJhciwuYW50LXRhYnMtcmlnaHQ+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtaW5rLWJhciwuYW50LXRhYnMtcmlnaHQ+ZGl2Pi5hbnQtdGFicy1uYXYgLmFudC10YWJzLWluay1iYXJ7d2lkdGg6MnB4fS5hbnQtdGFicy1sZWZ0Pi5hbnQtdGFicy1uYXYgLmFudC10YWJzLWluay1iYXItYW5pbWF0ZWQsLmFudC10YWJzLWxlZnQ+ZGl2Pi5hbnQtdGFicy1uYXYgLmFudC10YWJzLWluay1iYXItYW5pbWF0ZWQsLmFudC10YWJzLXJpZ2h0Pi5hbnQtdGFicy1uYXYgLmFudC10YWJzLWluay1iYXItYW5pbWF0ZWQsLmFudC10YWJzLXJpZ2h0PmRpdj4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1pbmstYmFyLWFuaW1hdGVke3RyYW5zaXRpb246aGVpZ2h0IC4zcyx0b3AgLjNzfS5hbnQtdGFicy1sZWZ0Pi5hbnQtdGFicy1uYXYgLmFudC10YWJzLW5hdi1saXN0LC5hbnQtdGFicy1sZWZ0Pi5hbnQtdGFicy1uYXYgLmFudC10YWJzLW5hdi1vcGVyYXRpb25zLC5hbnQtdGFicy1sZWZ0PmRpdj4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1uYXYtbGlzdCwuYW50LXRhYnMtbGVmdD5kaXY+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtbmF2LW9wZXJhdGlvbnMsLmFudC10YWJzLXJpZ2h0Pi5hbnQtdGFicy1uYXYgLmFudC10YWJzLW5hdi1saXN0LC5hbnQtdGFicy1yaWdodD4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1uYXYtb3BlcmF0aW9ucywuYW50LXRhYnMtcmlnaHQ+ZGl2Pi5hbnQtdGFicy1uYXYgLmFudC10YWJzLW5hdi1saXN0LC5hbnQtdGFicy1yaWdodD5kaXY+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtbmF2LW9wZXJhdGlvbnN7ZmxleDoxIDAgYXV0bztmbGV4LWRpcmVjdGlvbjpjb2x1bW59LmFudC10YWJzLWxlZnQ+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtaW5rLWJhciwuYW50LXRhYnMtbGVmdD5kaXY+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtaW5rLWJhcntyaWdodDowfS5hbnQtdGFicy1sZWZ0Pi5hbnQtdGFicy1jb250ZW50LWhvbGRlciwuYW50LXRhYnMtbGVmdD5kaXY+LmFudC10YWJzLWNvbnRlbnQtaG9sZGVye21hcmdpbi1sZWZ0Oi0xcHg7Ym9yZGVyLWxlZnQ6MXB4IHNvbGlkICNmMGYwZjB9LmFudC10YWJzLWxlZnQ+LmFudC10YWJzLWNvbnRlbnQtaG9sZGVyPi5hbnQtdGFicy1jb250ZW50Pi5hbnQtdGFicy10YWJwYW5lLC5hbnQtdGFicy1sZWZ0PmRpdj4uYW50LXRhYnMtY29udGVudC1ob2xkZXI+LmFudC10YWJzLWNvbnRlbnQ+LmFudC10YWJzLXRhYnBhbmV7cGFkZGluZy1sZWZ0OjI0cHh9LmFudC10YWJzLXJpZ2h0Pi5hbnQtdGFicy1uYXYsLmFudC10YWJzLXJpZ2h0PmRpdj4uYW50LXRhYnMtbmF2e29yZGVyOjF9LmFudC10YWJzLXJpZ2h0Pi5hbnQtdGFicy1uYXYgLmFudC10YWJzLWluay1iYXIsLmFudC10YWJzLXJpZ2h0PmRpdj4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1pbmstYmFye2xlZnQ6MH0uYW50LXRhYnMtcmlnaHQ+LmFudC10YWJzLWNvbnRlbnQtaG9sZGVyLC5hbnQtdGFicy1yaWdodD5kaXY+LmFudC10YWJzLWNvbnRlbnQtaG9sZGVye29yZGVyOjA7bWFyZ2luLXJpZ2h0Oi0xcHg7Ym9yZGVyLXJpZ2h0OjFweCBzb2xpZCAjZjBmMGYwfS5hbnQtdGFicy1yaWdodD4uYW50LXRhYnMtY29udGVudC1ob2xkZXI+LmFudC10YWJzLWNvbnRlbnQ+LmFudC10YWJzLXRhYnBhbmUsLmFudC10YWJzLXJpZ2h0PmRpdj4uYW50LXRhYnMtY29udGVudC1ob2xkZXI+LmFudC10YWJzLWNvbnRlbnQ+LmFudC10YWJzLXRhYnBhbmV7cGFkZGluZy1yaWdodDoyNHB4fS5hbnQtdGFicy1kcm9wZG93bntib3gtc2l6aW5nOmJvcmRlci1ib3g7bWFyZ2luOjA7cGFkZGluZzowO2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtmb250LXNpemU6MTRweDtmb250LXZhcmlhbnQ6dGFidWxhci1udW1zO2xpbmUtaGVpZ2h0OjEuNTcxNTtsaXN0LXN0eWxlOm5vbmU7Zm9udC1mZWF0dXJlLXNldHRpbmdzOlwidG51bVwiO3Bvc2l0aW9uOmFic29sdXRlO3RvcDotOTk5OXB4O2xlZnQ6LTk5OTlweDt6LWluZGV4OjEwNTA7ZGlzcGxheTpibG9ja30uYW50LXRhYnMtZHJvcGRvd24taGlkZGVue2Rpc3BsYXk6bm9uZX0uYW50LXRhYnMtZHJvcGRvd24tbWVudXttYXgtaGVpZ2h0OjIwMHB4O21hcmdpbjowO3BhZGRpbmc6NHB4IDA7b3ZlcmZsb3cteDpoaWRkZW47b3ZlcmZsb3cteTphdXRvO3RleHQtYWxpZ246bGVmdDtsaXN0LXN0eWxlLXR5cGU6bm9uZTtiYWNrZ3JvdW5kLWNvbG9yOiNmZmY7YmFja2dyb3VuZC1jbGlwOnBhZGRpbmctYm94O2JvcmRlci1yYWRpdXM6MnB4O291dGxpbmU6bm9uZTtib3gtc2hhZG93OjAgM3B4IDZweCAtNHB4IHJnYmEoMCwwLDAsLjEyKSwwIDZweCAxNnB4IDAgcmdiYSgwLDAsMCwuMDgpLDAgOXB4IDI4cHggOHB4IHJnYmEoMCwwLDAsLjA1KX0uYW50LXRhYnMtZHJvcGRvd24tbWVudS1pdGVte2Rpc3BsYXk6ZmxleDthbGlnbi1pdGVtczpjZW50ZXI7bWluLXdpZHRoOjEyMHB4O21hcmdpbjowO3BhZGRpbmc6NXB4IDEycHg7b3ZlcmZsb3c6aGlkZGVuO2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtmb250LXdlaWdodDo0MDA7Zm9udC1zaXplOjE0cHg7bGluZS1oZWlnaHQ6MjJweDt3aGl0ZS1zcGFjZTpub3dyYXA7dGV4dC1vdmVyZmxvdzplbGxpcHNpcztjdXJzb3I6cG9pbnRlcjt0cmFuc2l0aW9uOmFsbCAuM3N9LmFudC10YWJzLWRyb3Bkb3duLW1lbnUtaXRlbT5zcGFue2ZsZXg6MTt3aGl0ZS1zcGFjZTpub3dyYXB9LmFudC10YWJzLWRyb3Bkb3duLW1lbnUtaXRlbS1yZW1vdmV7ZmxleDpub25lO21hcmdpbi1sZWZ0OjEycHg7Y29sb3I6cmdiYSgwLDAsMCwuNDUpO2ZvbnQtc2l6ZToxMnB4O2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7Ym9yZGVyOjA7Y3Vyc29yOnBvaW50ZXJ9LmFudC10YWJzLWRyb3Bkb3duLW1lbnUtaXRlbS1yZW1vdmU6aG92ZXJ7Y29sb3I6IzQwYTlmZn0uYW50LXRhYnMtZHJvcGRvd24tbWVudS1pdGVtOmhvdmVye2JhY2tncm91bmQ6I2Y1ZjVmNX0uYW50LXRhYnMtZHJvcGRvd24tbWVudS1pdGVtLWRpc2FibGVkLC5hbnQtdGFicy1kcm9wZG93bi1tZW51LWl0ZW0tZGlzYWJsZWQ6aG92ZXJ7Y29sb3I6cmdiYSgwLDAsMCwuMjUpO2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7Y3Vyc29yOm5vdC1hbGxvd2VkfS5hbnQtdGFicy1jYXJkPi5hbnQtdGFicy1uYXYgLmFudC10YWJzLXRhYiwuYW50LXRhYnMtY2FyZD5kaXY+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtdGFie21hcmdpbjowO3BhZGRpbmc6OHB4IDE2cHg7YmFja2dyb3VuZDojZmFmYWZhO2JvcmRlcjoxcHggc29saWQgI2YwZjBmMDt0cmFuc2l0aW9uOmFsbCAuM3MgY3ViaWMtYmV6aWVyKC42NDUsLjA0NSwuMzU1LDEpfS5hbnQtdGFicy1jYXJkPi5hbnQtdGFicy1uYXYgLmFudC10YWJzLXRhYi1hY3RpdmUsLmFudC10YWJzLWNhcmQ+ZGl2Pi5hbnQtdGFicy1uYXYgLmFudC10YWJzLXRhYi1hY3RpdmV7Y29sb3I6IzE4OTBmZjtiYWNrZ3JvdW5kOiNmZmZ9LmFudC10YWJzLWNhcmQ+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtaW5rLWJhciwuYW50LXRhYnMtY2FyZD5kaXY+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtaW5rLWJhcnt2aXNpYmlsaXR5OmhpZGRlbn0uYW50LXRhYnMtY2FyZC5hbnQtdGFicy1ib3R0b20+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtdGFiKy5hbnQtdGFicy10YWIsLmFudC10YWJzLWNhcmQuYW50LXRhYnMtYm90dG9tPmRpdj4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy10YWIrLmFudC10YWJzLXRhYiwuYW50LXRhYnMtY2FyZC5hbnQtdGFicy10b3A+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtdGFiKy5hbnQtdGFicy10YWIsLmFudC10YWJzLWNhcmQuYW50LXRhYnMtdG9wPmRpdj4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy10YWIrLmFudC10YWJzLXRhYnttYXJnaW4tbGVmdDoycHh9LmFudC10YWJzLWNhcmQuYW50LXRhYnMtdG9wPi5hbnQtdGFicy1uYXYgLmFudC10YWJzLXRhYiwuYW50LXRhYnMtY2FyZC5hbnQtdGFicy10b3A+ZGl2Pi5hbnQtdGFicy1uYXYgLmFudC10YWJzLXRhYntib3JkZXItcmFkaXVzOjJweCAycHggMCAwfS5hbnQtdGFicy1jYXJkLmFudC10YWJzLXRvcD4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy10YWItYWN0aXZlLC5hbnQtdGFicy1jYXJkLmFudC10YWJzLXRvcD5kaXY+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtdGFiLWFjdGl2ZXtib3JkZXItYm90dG9tLWNvbG9yOiNmZmZ9LmFudC10YWJzLWNhcmQuYW50LXRhYnMtYm90dG9tPi5hbnQtdGFicy1uYXYgLmFudC10YWJzLXRhYiwuYW50LXRhYnMtY2FyZC5hbnQtdGFicy1ib3R0b20+ZGl2Pi5hbnQtdGFicy1uYXYgLmFudC10YWJzLXRhYntib3JkZXItcmFkaXVzOjAgMCAycHggMnB4fS5hbnQtdGFicy1jYXJkLmFudC10YWJzLWJvdHRvbT4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy10YWItYWN0aXZlLC5hbnQtdGFicy1jYXJkLmFudC10YWJzLWJvdHRvbT5kaXY+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtdGFiLWFjdGl2ZXtib3JkZXItdG9wLWNvbG9yOiNmZmZ9LmFudC10YWJzLWNhcmQuYW50LXRhYnMtbGVmdD4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy10YWIrLmFudC10YWJzLXRhYiwuYW50LXRhYnMtY2FyZC5hbnQtdGFicy1sZWZ0PmRpdj4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy10YWIrLmFudC10YWJzLXRhYiwuYW50LXRhYnMtY2FyZC5hbnQtdGFicy1yaWdodD4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy10YWIrLmFudC10YWJzLXRhYiwuYW50LXRhYnMtY2FyZC5hbnQtdGFicy1yaWdodD5kaXY+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtdGFiKy5hbnQtdGFicy10YWJ7bWFyZ2luLXRvcDoycHh9LmFudC10YWJzLWNhcmQuYW50LXRhYnMtbGVmdD4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy10YWIsLmFudC10YWJzLWNhcmQuYW50LXRhYnMtbGVmdD5kaXY+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtdGFie2JvcmRlci1yYWRpdXM6MnB4IDAgMCAycHh9LmFudC10YWJzLWNhcmQuYW50LXRhYnMtbGVmdD4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy10YWItYWN0aXZlLC5hbnQtdGFicy1jYXJkLmFudC10YWJzLWxlZnQ+ZGl2Pi5hbnQtdGFicy1uYXYgLmFudC10YWJzLXRhYi1hY3RpdmV7Ym9yZGVyLXJpZ2h0LWNvbG9yOiNmZmZ9LmFudC10YWJzLWNhcmQuYW50LXRhYnMtcmlnaHQ+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtdGFiLC5hbnQtdGFicy1jYXJkLmFudC10YWJzLXJpZ2h0PmRpdj4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy10YWJ7Ym9yZGVyLXJhZGl1czowIDJweCAycHggMH0uYW50LXRhYnMtY2FyZC5hbnQtdGFicy1yaWdodD4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy10YWItYWN0aXZlLC5hbnQtdGFicy1jYXJkLmFudC10YWJzLXJpZ2h0PmRpdj4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy10YWItYWN0aXZle2JvcmRlci1sZWZ0LWNvbG9yOiNmZmZ9LmFudC10YWJze2JveC1zaXppbmc6Ym9yZGVyLWJveDttYXJnaW46MDtwYWRkaW5nOjA7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtc2l6ZToxNHB4O2ZvbnQtdmFyaWFudDp0YWJ1bGFyLW51bXM7bGluZS1oZWlnaHQ6MS41NzE1O2xpc3Qtc3R5bGU6bm9uZTtmb250LWZlYXR1cmUtc2V0dGluZ3M6XCJ0bnVtXCI7ZGlzcGxheTpmbGV4fS5hbnQtdGFicz4uYW50LXRhYnMtbmF2LC5hbnQtdGFicz5kaXY+LmFudC10YWJzLW5hdntwb3NpdGlvbjpyZWxhdGl2ZTtkaXNwbGF5OmZsZXg7ZmxleDpub25lO2FsaWduLWl0ZW1zOmNlbnRlcn0uYW50LXRhYnM+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtbmF2LXdyYXAsLmFudC10YWJzPmRpdj4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1uYXYtd3JhcHtwb3NpdGlvbjpyZWxhdGl2ZTtkaXNwbGF5OmlubGluZS1ibG9jaztkaXNwbGF5OmZsZXg7ZmxleDphdXRvO2FsaWduLXNlbGY6c3RyZXRjaDtvdmVyZmxvdzpoaWRkZW47d2hpdGUtc3BhY2U6bm93cmFwO3RyYW5zZm9ybTp0cmFuc2xhdGUoMCl9LmFudC10YWJzPi5hbnQtdGFicy1uYXYgLmFudC10YWJzLW5hdi13cmFwOmFmdGVyLC5hbnQtdGFicz4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1uYXYtd3JhcDpiZWZvcmUsLmFudC10YWJzPmRpdj4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1uYXYtd3JhcDphZnRlciwuYW50LXRhYnM+ZGl2Pi5hbnQtdGFicy1uYXYgLmFudC10YWJzLW5hdi13cmFwOmJlZm9yZXtwb3NpdGlvbjphYnNvbHV0ZTt6LWluZGV4OjE7b3BhY2l0eTowO3RyYW5zaXRpb246b3BhY2l0eSAuM3M7Y29udGVudDpcIlwiO3BvaW50ZXItZXZlbnRzOm5vbmV9LmFudC10YWJzPi5hbnQtdGFicy1uYXYgLmFudC10YWJzLW5hdi1saXN0LC5hbnQtdGFicz5kaXY+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtbmF2LWxpc3R7cG9zaXRpb246cmVsYXRpdmU7ZGlzcGxheTpmbGV4O3RyYW5zaXRpb246dHJhbnNmb3JtIC4zc30uYW50LXRhYnM+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtbmF2LW9wZXJhdGlvbnMsLmFudC10YWJzPmRpdj4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1uYXYtb3BlcmF0aW9uc3tkaXNwbGF5OmZsZXg7YWxpZ24tc2VsZjpzdHJldGNofS5hbnQtdGFicz4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1uYXYtb3BlcmF0aW9ucy1oaWRkZW4sLmFudC10YWJzPmRpdj4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1uYXYtb3BlcmF0aW9ucy1oaWRkZW57cG9zaXRpb246YWJzb2x1dGU7dmlzaWJpbGl0eTpoaWRkZW47cG9pbnRlci1ldmVudHM6bm9uZX0uYW50LXRhYnM+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtbmF2LW1vcmUsLmFudC10YWJzPmRpdj4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1uYXYtbW9yZXtwb3NpdGlvbjpyZWxhdGl2ZTtwYWRkaW5nOjhweCAxNnB4O2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7Ym9yZGVyOjB9LmFudC10YWJzPi5hbnQtdGFicy1uYXYgLmFudC10YWJzLW5hdi1tb3JlOmFmdGVyLC5hbnQtdGFicz5kaXY+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtbmF2LW1vcmU6YWZ0ZXJ7cG9zaXRpb246YWJzb2x1dGU7cmlnaHQ6MDtib3R0b206MDtsZWZ0OjA7aGVpZ2h0OjVweDt0cmFuc2Zvcm06dHJhbnNsYXRlWSgxMDAlKTtjb250ZW50OlwiXCJ9LmFudC10YWJzPi5hbnQtdGFicy1uYXYgLmFudC10YWJzLW5hdi1hZGQsLmFudC10YWJzPmRpdj4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1uYXYtYWRke21pbi13aWR0aDo0MHB4O21hcmdpbi1sZWZ0OjJweDtwYWRkaW5nOjAgOHB4O2JhY2tncm91bmQ6I2ZhZmFmYTtib3JkZXI6MXB4IHNvbGlkICNmMGYwZjA7Ym9yZGVyLXJhZGl1czoycHggMnB4IDAgMDtvdXRsaW5lOm5vbmU7Y3Vyc29yOnBvaW50ZXI7dHJhbnNpdGlvbjphbGwgLjNzIGN1YmljLWJlemllciguNjQ1LC4wNDUsLjM1NSwxKX0uYW50LXRhYnM+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtbmF2LWFkZDpob3ZlciwuYW50LXRhYnM+ZGl2Pi5hbnQtdGFicy1uYXYgLmFudC10YWJzLW5hdi1hZGQ6aG92ZXJ7Y29sb3I6IzQwYTlmZn0uYW50LXRhYnM+LmFudC10YWJzLW5hdiAuYW50LXRhYnMtbmF2LWFkZDphY3RpdmUsLmFudC10YWJzPi5hbnQtdGFicy1uYXYgLmFudC10YWJzLW5hdi1hZGQ6Zm9jdXMsLmFudC10YWJzPmRpdj4uYW50LXRhYnMtbmF2IC5hbnQtdGFicy1uYXYtYWRkOmFjdGl2ZSwuYW50LXRhYnM+ZGl2Pi5hbnQtdGFicy1uYXYgLmFudC10YWJzLW5hdi1hZGQ6Zm9jdXN7Y29sb3I6IzA5NmRkOX0uYW50LXRhYnMtZXh0cmEtY29udGVudHtmbGV4Om5vbmV9LmFudC10YWJzLWNlbnRlcmVkPi5hbnQtdGFicy1uYXYgLmFudC10YWJzLW5hdi13cmFwOm5vdChbY2xhc3MqPWFudC10YWJzLW5hdi13cmFwLXBpbmddKSwuYW50LXRhYnMtY2VudGVyZWQ+ZGl2Pi5hbnQtdGFicy1uYXYgLmFudC10YWJzLW5hdi13cmFwOm5vdChbY2xhc3MqPWFudC10YWJzLW5hdi13cmFwLXBpbmddKXtqdXN0aWZ5LWNvbnRlbnQ6Y2VudGVyfS5hbnQtdGFicy1pbmstYmFye3Bvc2l0aW9uOmFic29sdXRlO2JhY2tncm91bmQ6IzE4OTBmZjtwb2ludGVyLWV2ZW50czpub25lfS5hbnQtdGFicy10YWJ7cG9zaXRpb246cmVsYXRpdmU7ZGlzcGxheTppbmxpbmUtZmxleDthbGlnbi1pdGVtczpjZW50ZXI7cGFkZGluZzoxMnB4IDA7Zm9udC1zaXplOjE0cHg7YmFja2dyb3VuZDp0cmFuc3BhcmVudDtib3JkZXI6MDtvdXRsaW5lOm5vbmU7Y3Vyc29yOnBvaW50ZXJ9LmFudC10YWJzLXRhYi1idG46YWN0aXZlLC5hbnQtdGFicy10YWItYnRuOmZvY3VzLC5hbnQtdGFicy10YWItcmVtb3ZlOmFjdGl2ZSwuYW50LXRhYnMtdGFiLXJlbW92ZTpmb2N1c3tjb2xvcjojMDk2ZGQ5fS5hbnQtdGFicy10YWItYnRuLC5hbnQtdGFicy10YWItcmVtb3Zle291dGxpbmU6bm9uZTt0cmFuc2l0aW9uOmFsbCAuM3N9LmFudC10YWJzLXRhYi1yZW1vdmV7ZmxleDpub25lO21hcmdpbi1yaWdodDotNHB4O21hcmdpbi1sZWZ0OjhweDtjb2xvcjpyZ2JhKDAsMCwwLC40NSk7Zm9udC1zaXplOjEycHg7YmFja2dyb3VuZDp0cmFuc3BhcmVudDtib3JkZXI6bm9uZTtjdXJzb3I6cG9pbnRlcn0uYW50LXRhYnMtdGFiLXJlbW92ZTpob3Zlcntjb2xvcjpyZ2JhKDAsMCwwLC44NSl9LmFudC10YWJzLXRhYjpob3Zlcntjb2xvcjojNDBhOWZmfS5hbnQtdGFicy10YWIuYW50LXRhYnMtdGFiLWFjdGl2ZSAuYW50LXRhYnMtdGFiLWJ0bntjb2xvcjojMTg5MGZmO3RleHQtc2hhZG93OjAgMCAuMjVweCBjdXJyZW50Y29sb3J9LmFudC10YWJzLXRhYi5hbnQtdGFicy10YWItZGlzYWJsZWR7Y29sb3I6cmdiYSgwLDAsMCwuMjUpO2N1cnNvcjpub3QtYWxsb3dlZH0uYW50LXRhYnMtdGFiLmFudC10YWJzLXRhYi1kaXNhYmxlZCAuYW50LXRhYnMtdGFiLWJ0bjphY3RpdmUsLmFudC10YWJzLXRhYi5hbnQtdGFicy10YWItZGlzYWJsZWQgLmFudC10YWJzLXRhYi1idG46Zm9jdXMsLmFudC10YWJzLXRhYi5hbnQtdGFicy10YWItZGlzYWJsZWQgLmFudC10YWJzLXRhYi1yZW1vdmU6YWN0aXZlLC5hbnQtdGFicy10YWIuYW50LXRhYnMtdGFiLWRpc2FibGVkIC5hbnQtdGFicy10YWItcmVtb3ZlOmZvY3Vze2NvbG9yOnJnYmEoMCwwLDAsLjI1KX0uYW50LXRhYnMtdGFiIC5hbnQtdGFicy10YWItcmVtb3ZlIC5hbnRpY29ue21hcmdpbjowfS5hbnQtdGFicy10YWIgLmFudGljb257bWFyZ2luLXJpZ2h0OjEycHh9LmFudC10YWJzLXRhYisuYW50LXRhYnMtdGFie21hcmdpbjowIDAgMCAzMnB4fS5hbnQtdGFicy1jb250ZW50e3Bvc2l0aW9uOnJlbGF0aXZlO3dpZHRoOjEwMCV9LmFudC10YWJzLWNvbnRlbnQtaG9sZGVye2ZsZXg6YXV0bzttaW4td2lkdGg6MDttaW4taGVpZ2h0OjB9LmFudC10YWJzLXRhYnBhbmV7b3V0bGluZTpub25lfS5hbnQtdGFicy10YWJwYW5lLWhpZGRlbntkaXNwbGF5Om5vbmV9LmFudC10YWJzLXN3aXRjaC1hcHBlYXIsLmFudC10YWJzLXN3aXRjaC1lbnRlcnt0cmFuc2l0aW9uOm5vbmV9LmFudC10YWJzLXN3aXRjaC1hcHBlYXItc3RhcnQsLmFudC10YWJzLXN3aXRjaC1lbnRlci1zdGFydHtvcGFjaXR5OjB9LmFudC10YWJzLXN3aXRjaC1hcHBlYXItYWN0aXZlLC5hbnQtdGFicy1zd2l0Y2gtZW50ZXItYWN0aXZle29wYWNpdHk6MTt0cmFuc2l0aW9uOm9wYWNpdHkgLjNzfS5hbnQtdGFicy1zd2l0Y2gtbGVhdmV7cG9zaXRpb246YWJzb2x1dGU7dHJhbnNpdGlvbjpub25lO2luc2V0OjB9LmFudC10YWJzLXN3aXRjaC1sZWF2ZS1zdGFydHtvcGFjaXR5OjF9LmFudC10YWJzLXN3aXRjaC1sZWF2ZS1hY3RpdmV7b3BhY2l0eTowO3RyYW5zaXRpb246b3BhY2l0eSAuM3N9LmFudC10YWd7Ym94LXNpemluZzpib3JkZXItYm94O2ZvbnQtc2l6ZToxNHB4O2ZvbnQtdmFyaWFudDp0YWJ1bGFyLW51bXM7bGluZS1oZWlnaHQ6MS41NzE1O2xpc3Qtc3R5bGU6bm9uZTtmb250LWZlYXR1cmUtc2V0dGluZ3M6XCJ0bnVtXCI7ZGlzcGxheTppbmxpbmUtYmxvY2s7aGVpZ2h0OmF1dG87bWFyZ2luOjAgOHB4IDAgMDtwYWRkaW5nOjAgN3B4O2ZvbnQtc2l6ZToxMnB4O2xpbmUtaGVpZ2h0OjIwcHg7d2hpdGUtc3BhY2U6bm93cmFwO2JhY2tncm91bmQ6I2ZhZmFmYTtib3JkZXI6MXB4IHNvbGlkICNkOWQ5ZDk7Ym9yZGVyLXJhZGl1czoycHg7b3BhY2l0eToxO3RyYW5zaXRpb246YWxsIC4zc30uYW50LXRhZywuYW50LXRhZyBhLC5hbnQtdGFnIGE6aG92ZXJ7Y29sb3I6cmdiYSgwLDAsMCwuODUpfS5hbnQtdGFnPmE6Zmlyc3QtY2hpbGQ6bGFzdC1jaGlsZHtkaXNwbGF5OmlubGluZS1ibG9jazttYXJnaW46MCAtOHB4O3BhZGRpbmc6MCA4cHh9LmFudC10YWctY2xvc2UtaWNvbnttYXJnaW4tbGVmdDozcHg7Y29sb3I6cmdiYSgwLDAsMCwuNDUpO2ZvbnQtc2l6ZToxMHB4O2N1cnNvcjpwb2ludGVyO3RyYW5zaXRpb246YWxsIC4zc30uYW50LXRhZy1jbG9zZS1pY29uOmhvdmVye2NvbG9yOnJnYmEoMCwwLDAsLjg1KX0uYW50LXRhZy1oYXMtY29sb3J7Ym9yZGVyLWNvbG9yOnRyYW5zcGFyZW50fS5hbnQtdGFnLWhhcy1jb2xvciwuYW50LXRhZy1oYXMtY29sb3IgLmFudGljb24tY2xvc2UsLmFudC10YWctaGFzLWNvbG9yIC5hbnRpY29uLWNsb3NlOmhvdmVyLC5hbnQtdGFnLWhhcy1jb2xvciBhLC5hbnQtdGFnLWhhcy1jb2xvciBhOmhvdmVye2NvbG9yOiNmZmZ9LmFudC10YWctY2hlY2thYmxle2JhY2tncm91bmQtY29sb3I6dHJhbnNwYXJlbnQ7Ym9yZGVyLWNvbG9yOnRyYW5zcGFyZW50O2N1cnNvcjpwb2ludGVyfS5hbnQtdGFnLWNoZWNrYWJsZTpub3QoLmFudC10YWctY2hlY2thYmxlLWNoZWNrZWQpOmhvdmVye2NvbG9yOiMxODkwZmZ9LmFudC10YWctY2hlY2thYmxlLWNoZWNrZWQsLmFudC10YWctY2hlY2thYmxlOmFjdGl2ZXtjb2xvcjojZmZmfS5hbnQtdGFnLWNoZWNrYWJsZS1jaGVja2Vke2JhY2tncm91bmQtY29sb3I6IzE4OTBmZn0uYW50LXRhZy1jaGVja2FibGU6YWN0aXZle2JhY2tncm91bmQtY29sb3I6IzA5NmRkOX0uYW50LXRhZy1oaWRkZW57ZGlzcGxheTpub25lfS5hbnQtdGFnLXBpbmt7Y29sb3I6I2M0MWQ3ZjtiYWNrZ3JvdW5kOiNmZmYwZjY7Ym9yZGVyLWNvbG9yOiNmZmFkZDJ9LmFudC10YWctcGluay1pbnZlcnNle2NvbG9yOiNmZmY7YmFja2dyb3VuZDojZWIyZjk2O2JvcmRlci1jb2xvcjojZWIyZjk2fS5hbnQtdGFnLW1hZ2VudGF7Y29sb3I6I2M0MWQ3ZjtiYWNrZ3JvdW5kOiNmZmYwZjY7Ym9yZGVyLWNvbG9yOiNmZmFkZDJ9LmFudC10YWctbWFnZW50YS1pbnZlcnNle2NvbG9yOiNmZmY7YmFja2dyb3VuZDojZWIyZjk2O2JvcmRlci1jb2xvcjojZWIyZjk2fS5hbnQtdGFnLXJlZHtjb2xvcjojY2YxMzIyO2JhY2tncm91bmQ6I2ZmZjFmMDtib3JkZXItY29sb3I6I2ZmYTM5ZX0uYW50LXRhZy1yZWQtaW52ZXJzZXtjb2xvcjojZmZmO2JhY2tncm91bmQ6I2Y1MjIyZDtib3JkZXItY29sb3I6I2Y1MjIyZH0uYW50LXRhZy12b2xjYW5ve2NvbG9yOiNkNDM4MGQ7YmFja2dyb3VuZDojZmZmMmU4O2JvcmRlci1jb2xvcjojZmZiYjk2fS5hbnQtdGFnLXZvbGNhbm8taW52ZXJzZXtjb2xvcjojZmZmO2JhY2tncm91bmQ6I2ZhNTQxYztib3JkZXItY29sb3I6I2ZhNTQxY30uYW50LXRhZy1vcmFuZ2V7Y29sb3I6I2Q0NmIwODtiYWNrZ3JvdW5kOiNmZmY3ZTY7Ym9yZGVyLWNvbG9yOiNmZmQ1OTF9LmFudC10YWctb3JhbmdlLWludmVyc2V7Y29sb3I6I2ZmZjtiYWNrZ3JvdW5kOiNmYThjMTY7Ym9yZGVyLWNvbG9yOiNmYThjMTZ9LmFudC10YWcteWVsbG93e2NvbG9yOiNkNGIxMDY7YmFja2dyb3VuZDojZmVmZmU2O2JvcmRlci1jb2xvcjojZmZmYjhmfS5hbnQtdGFnLXllbGxvdy1pbnZlcnNle2NvbG9yOiNmZmY7YmFja2dyb3VuZDojZmFkYjE0O2JvcmRlci1jb2xvcjojZmFkYjE0fS5hbnQtdGFnLWdvbGR7Y29sb3I6I2Q0ODgwNjtiYWNrZ3JvdW5kOiNmZmZiZTY7Ym9yZGVyLWNvbG9yOiNmZmU1OGZ9LmFudC10YWctZ29sZC1pbnZlcnNle2NvbG9yOiNmZmY7YmFja2dyb3VuZDojZmFhZDE0O2JvcmRlci1jb2xvcjojZmFhZDE0fS5hbnQtdGFnLWN5YW57Y29sb3I6IzA4OTc5YztiYWNrZ3JvdW5kOiNlNmZmZmI7Ym9yZGVyLWNvbG9yOiM4N2U4ZGV9LmFudC10YWctY3lhbi1pbnZlcnNle2NvbG9yOiNmZmY7YmFja2dyb3VuZDojMTNjMmMyO2JvcmRlci1jb2xvcjojMTNjMmMyfS5hbnQtdGFnLWxpbWV7Y29sb3I6IzdjYjMwNTtiYWNrZ3JvdW5kOiNmY2ZmZTY7Ym9yZGVyLWNvbG9yOiNlYWZmOGZ9LmFudC10YWctbGltZS1pbnZlcnNle2NvbG9yOiNmZmY7YmFja2dyb3VuZDojYTBkOTExO2JvcmRlci1jb2xvcjojYTBkOTExfS5hbnQtdGFnLWdyZWVue2NvbG9yOiMzODllMGQ7YmFja2dyb3VuZDojZjZmZmVkO2JvcmRlci1jb2xvcjojYjdlYjhmfS5hbnQtdGFnLWdyZWVuLWludmVyc2V7Y29sb3I6I2ZmZjtiYWNrZ3JvdW5kOiM1MmM0MWE7Ym9yZGVyLWNvbG9yOiM1MmM0MWF9LmFudC10YWctYmx1ZXtjb2xvcjojMDk2ZGQ5O2JhY2tncm91bmQ6I2U2ZjdmZjtib3JkZXItY29sb3I6IzkxZDVmZn0uYW50LXRhZy1ibHVlLWludmVyc2V7Y29sb3I6I2ZmZjtiYWNrZ3JvdW5kOiMxODkwZmY7Ym9yZGVyLWNvbG9yOiMxODkwZmZ9LmFudC10YWctZ2Vla2JsdWV7Y29sb3I6IzFkMzljNDtiYWNrZ3JvdW5kOiNmMGY1ZmY7Ym9yZGVyLWNvbG9yOiNhZGM2ZmZ9LmFudC10YWctZ2Vla2JsdWUtaW52ZXJzZXtjb2xvcjojZmZmO2JhY2tncm91bmQ6IzJmNTRlYjtib3JkZXItY29sb3I6IzJmNTRlYn0uYW50LXRhZy1wdXJwbGV7Y29sb3I6IzUzMWRhYjtiYWNrZ3JvdW5kOiNmOWYwZmY7Ym9yZGVyLWNvbG9yOiNkM2FkZjd9LmFudC10YWctcHVycGxlLWludmVyc2V7Y29sb3I6I2ZmZjtiYWNrZ3JvdW5kOiM3MjJlZDE7Ym9yZGVyLWNvbG9yOiM3MjJlZDF9LmFudC10YWctc3VjY2Vzc3tjb2xvcjojNTJjNDFhO2JhY2tncm91bmQ6I2Y2ZmZlZDtib3JkZXItY29sb3I6I2I3ZWI4Zn0uYW50LXRhZy1wcm9jZXNzaW5ne2NvbG9yOiMxODkwZmY7YmFja2dyb3VuZDojZTZmN2ZmO2JvcmRlci1jb2xvcjojOTFkNWZmfS5hbnQtdGFnLWVycm9ye2NvbG9yOiNmZjRkNGY7YmFja2dyb3VuZDojZmZmMmYwO2JvcmRlci1jb2xvcjojZmZjY2M3fS5hbnQtdGFnLXdhcm5pbmd7Y29sb3I6I2ZhYWQxNDtiYWNrZ3JvdW5kOiNmZmZiZTY7Ym9yZGVyLWNvbG9yOiNmZmU1OGZ9LmFudC10YWc+LmFudGljb24rc3BhbiwuYW50LXRhZz5zcGFuKy5hbnRpY29ue21hcmdpbi1sZWZ0OjdweH0uYW50LXRhZy5hbnQtdGFnLXJ0bHttYXJnaW4tcmlnaHQ6MDttYXJnaW4tbGVmdDo4cHg7ZGlyZWN0aW9uOnJ0bDt0ZXh0LWFsaWduOnJpZ2h0fS5hbnQtdGFnLXJ0bCAuYW50LXRhZy1jbG9zZS1pY29ue21hcmdpbi1yaWdodDozcHg7bWFyZ2luLWxlZnQ6MH0uYW50LXRhZy1ydGwuYW50LXRhZz4uYW50aWNvbitzcGFuLC5hbnQtdGFnLXJ0bC5hbnQtdGFnPnNwYW4rLmFudGljb257bWFyZ2luLXJpZ2h0OjdweDttYXJnaW4tbGVmdDowfS5hbnQtdGltZWxpbmV7Ym94LXNpemluZzpib3JkZXItYm94O2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtmb250LXNpemU6MTRweDtmb250LXZhcmlhbnQ6dGFidWxhci1udW1zO2xpbmUtaGVpZ2h0OjEuNTcxNTtmb250LWZlYXR1cmUtc2V0dGluZ3M6XCJ0bnVtXCI7bWFyZ2luOjA7cGFkZGluZzowO2xpc3Qtc3R5bGU6bm9uZX0uYW50LXRpbWVsaW5lLWl0ZW17cG9zaXRpb246cmVsYXRpdmU7bWFyZ2luOjA7cGFkZGluZy1ib3R0b206MjBweDtmb250LXNpemU6MTRweDtsaXN0LXN0eWxlOm5vbmV9LmFudC10aW1lbGluZS1pdGVtLXRhaWx7cG9zaXRpb246YWJzb2x1dGU7dG9wOjEwcHg7bGVmdDo0cHg7aGVpZ2h0OmNhbGMoMTAwJSAtIDEwcHgpO2JvcmRlci1sZWZ0OjJweCBzb2xpZCAjZjBmMGYwfS5hbnQtdGltZWxpbmUtaXRlbS1wZW5kaW5nIC5hbnQtdGltZWxpbmUtaXRlbS1oZWFke2ZvbnQtc2l6ZToxMnB4O2JhY2tncm91bmQtY29sb3I6dHJhbnNwYXJlbnR9LmFudC10aW1lbGluZS1pdGVtLXBlbmRpbmcgLmFudC10aW1lbGluZS1pdGVtLXRhaWx7ZGlzcGxheTpub25lfS5hbnQtdGltZWxpbmUtaXRlbS1oZWFke3Bvc2l0aW9uOmFic29sdXRlO3dpZHRoOjEwcHg7aGVpZ2h0OjEwcHg7YmFja2dyb3VuZC1jb2xvcjojZmZmO2JvcmRlcjoycHggc29saWQgdHJhbnNwYXJlbnQ7Ym9yZGVyLXJhZGl1czoxMDBweH0uYW50LXRpbWVsaW5lLWl0ZW0taGVhZC1ibHVle2NvbG9yOiMxODkwZmY7Ym9yZGVyLWNvbG9yOiMxODkwZmZ9LmFudC10aW1lbGluZS1pdGVtLWhlYWQtcmVke2NvbG9yOiNmZjRkNGY7Ym9yZGVyLWNvbG9yOiNmZjRkNGZ9LmFudC10aW1lbGluZS1pdGVtLWhlYWQtZ3JlZW57Y29sb3I6IzUyYzQxYTtib3JkZXItY29sb3I6IzUyYzQxYX0uYW50LXRpbWVsaW5lLWl0ZW0taGVhZC1ncmF5e2NvbG9yOnJnYmEoMCwwLDAsLjI1KTtib3JkZXItY29sb3I6cmdiYSgwLDAsMCwuMjUpfS5hbnQtdGltZWxpbmUtaXRlbS1oZWFkLWN1c3RvbXtwb3NpdGlvbjphYnNvbHV0ZTt0b3A6NS41cHg7bGVmdDo1cHg7d2lkdGg6YXV0bztoZWlnaHQ6YXV0bzttYXJnaW4tdG9wOjA7cGFkZGluZzozcHggMXB4O2xpbmUtaGVpZ2h0OjE7dGV4dC1hbGlnbjpjZW50ZXI7Ym9yZGVyOjA7Ym9yZGVyLXJhZGl1czowO3RyYW5zZm9ybTp0cmFuc2xhdGUoLTUwJSwtNTAlKX0uYW50LXRpbWVsaW5lLWl0ZW0tY29udGVudHtwb3NpdGlvbjpyZWxhdGl2ZTt0b3A6LTcuMDAxcHg7bWFyZ2luOjAgMCAwIDI2cHg7d29yZC1icmVhazpicmVhay13b3JkfS5hbnQtdGltZWxpbmUtaXRlbS1sYXN0Pi5hbnQtdGltZWxpbmUtaXRlbS10YWlse2Rpc3BsYXk6bm9uZX0uYW50LXRpbWVsaW5lLWl0ZW0tbGFzdD4uYW50LXRpbWVsaW5lLWl0ZW0tY29udGVudHttaW4taGVpZ2h0OjQ4cHh9LmFudC10aW1lbGluZS5hbnQtdGltZWxpbmUtYWx0ZXJuYXRlIC5hbnQtdGltZWxpbmUtaXRlbS1oZWFkLC5hbnQtdGltZWxpbmUuYW50LXRpbWVsaW5lLWFsdGVybmF0ZSAuYW50LXRpbWVsaW5lLWl0ZW0taGVhZC1jdXN0b20sLmFudC10aW1lbGluZS5hbnQtdGltZWxpbmUtYWx0ZXJuYXRlIC5hbnQtdGltZWxpbmUtaXRlbS10YWlsLC5hbnQtdGltZWxpbmUuYW50LXRpbWVsaW5lLWxhYmVsIC5hbnQtdGltZWxpbmUtaXRlbS1oZWFkLC5hbnQtdGltZWxpbmUuYW50LXRpbWVsaW5lLWxhYmVsIC5hbnQtdGltZWxpbmUtaXRlbS1oZWFkLWN1c3RvbSwuYW50LXRpbWVsaW5lLmFudC10aW1lbGluZS1sYWJlbCAuYW50LXRpbWVsaW5lLWl0ZW0tdGFpbCwuYW50LXRpbWVsaW5lLmFudC10aW1lbGluZS1yaWdodCAuYW50LXRpbWVsaW5lLWl0ZW0taGVhZCwuYW50LXRpbWVsaW5lLmFudC10aW1lbGluZS1yaWdodCAuYW50LXRpbWVsaW5lLWl0ZW0taGVhZC1jdXN0b20sLmFudC10aW1lbGluZS5hbnQtdGltZWxpbmUtcmlnaHQgLmFudC10aW1lbGluZS1pdGVtLXRhaWx7bGVmdDo1MCV9LmFudC10aW1lbGluZS5hbnQtdGltZWxpbmUtYWx0ZXJuYXRlIC5hbnQtdGltZWxpbmUtaXRlbS1oZWFkLC5hbnQtdGltZWxpbmUuYW50LXRpbWVsaW5lLWxhYmVsIC5hbnQtdGltZWxpbmUtaXRlbS1oZWFkLC5hbnQtdGltZWxpbmUuYW50LXRpbWVsaW5lLXJpZ2h0IC5hbnQtdGltZWxpbmUtaXRlbS1oZWFke21hcmdpbi1sZWZ0Oi00cHh9LmFudC10aW1lbGluZS5hbnQtdGltZWxpbmUtYWx0ZXJuYXRlIC5hbnQtdGltZWxpbmUtaXRlbS1oZWFkLWN1c3RvbSwuYW50LXRpbWVsaW5lLmFudC10aW1lbGluZS1sYWJlbCAuYW50LXRpbWVsaW5lLWl0ZW0taGVhZC1jdXN0b20sLmFudC10aW1lbGluZS5hbnQtdGltZWxpbmUtcmlnaHQgLmFudC10aW1lbGluZS1pdGVtLWhlYWQtY3VzdG9te21hcmdpbi1sZWZ0OjFweH0uYW50LXRpbWVsaW5lLmFudC10aW1lbGluZS1hbHRlcm5hdGUgLmFudC10aW1lbGluZS1pdGVtLWxlZnQgLmFudC10aW1lbGluZS1pdGVtLWNvbnRlbnQsLmFudC10aW1lbGluZS5hbnQtdGltZWxpbmUtbGFiZWwgLmFudC10aW1lbGluZS1pdGVtLWxlZnQgLmFudC10aW1lbGluZS1pdGVtLWNvbnRlbnQsLmFudC10aW1lbGluZS5hbnQtdGltZWxpbmUtcmlnaHQgLmFudC10aW1lbGluZS1pdGVtLWxlZnQgLmFudC10aW1lbGluZS1pdGVtLWNvbnRlbnR7bGVmdDpjYWxjKDUwJSAtIDRweCk7d2lkdGg6Y2FsYyg1MCUgLSAxNHB4KTt0ZXh0LWFsaWduOmxlZnR9LmFudC10aW1lbGluZS5hbnQtdGltZWxpbmUtYWx0ZXJuYXRlIC5hbnQtdGltZWxpbmUtaXRlbS1yaWdodCAuYW50LXRpbWVsaW5lLWl0ZW0tY29udGVudCwuYW50LXRpbWVsaW5lLmFudC10aW1lbGluZS1sYWJlbCAuYW50LXRpbWVsaW5lLWl0ZW0tcmlnaHQgLmFudC10aW1lbGluZS1pdGVtLWNvbnRlbnQsLmFudC10aW1lbGluZS5hbnQtdGltZWxpbmUtcmlnaHQgLmFudC10aW1lbGluZS1pdGVtLXJpZ2h0IC5hbnQtdGltZWxpbmUtaXRlbS1jb250ZW50e3dpZHRoOmNhbGMoNTAlIC0gMTJweCk7bWFyZ2luOjA7dGV4dC1hbGlnbjpyaWdodH0uYW50LXRpbWVsaW5lLmFudC10aW1lbGluZS1yaWdodCAuYW50LXRpbWVsaW5lLWl0ZW0tcmlnaHQgLmFudC10aW1lbGluZS1pdGVtLWhlYWQsLmFudC10aW1lbGluZS5hbnQtdGltZWxpbmUtcmlnaHQgLmFudC10aW1lbGluZS1pdGVtLXJpZ2h0IC5hbnQtdGltZWxpbmUtaXRlbS1oZWFkLWN1c3RvbSwuYW50LXRpbWVsaW5lLmFudC10aW1lbGluZS1yaWdodCAuYW50LXRpbWVsaW5lLWl0ZW0tcmlnaHQgLmFudC10aW1lbGluZS1pdGVtLXRhaWx7bGVmdDpjYWxjKDEwMCUgLSA2cHgpfS5hbnQtdGltZWxpbmUuYW50LXRpbWVsaW5lLXJpZ2h0IC5hbnQtdGltZWxpbmUtaXRlbS1yaWdodCAuYW50LXRpbWVsaW5lLWl0ZW0tY29udGVudHt3aWR0aDpjYWxjKDEwMCUgLSAxOHB4KX0uYW50LXRpbWVsaW5lLmFudC10aW1lbGluZS1wZW5kaW5nIC5hbnQtdGltZWxpbmUtaXRlbS1sYXN0IC5hbnQtdGltZWxpbmUtaXRlbS10YWlse2Rpc3BsYXk6YmxvY2s7aGVpZ2h0OmNhbGMoMTAwJSAtIDE0cHgpO2JvcmRlci1sZWZ0OjJweCBkb3R0ZWQgI2YwZjBmMH0uYW50LXRpbWVsaW5lLmFudC10aW1lbGluZS1yZXZlcnNlIC5hbnQtdGltZWxpbmUtaXRlbS1sYXN0IC5hbnQtdGltZWxpbmUtaXRlbS10YWlse2Rpc3BsYXk6bm9uZX0uYW50LXRpbWVsaW5lLmFudC10aW1lbGluZS1yZXZlcnNlIC5hbnQtdGltZWxpbmUtaXRlbS1wZW5kaW5nIC5hbnQtdGltZWxpbmUtaXRlbS10YWlse3RvcDoxNXB4O2Rpc3BsYXk6YmxvY2s7aGVpZ2h0OmNhbGMoMTAwJSAtIDE1cHgpO2JvcmRlci1sZWZ0OjJweCBkb3R0ZWQgI2YwZjBmMH0uYW50LXRpbWVsaW5lLmFudC10aW1lbGluZS1yZXZlcnNlIC5hbnQtdGltZWxpbmUtaXRlbS1wZW5kaW5nIC5hbnQtdGltZWxpbmUtaXRlbS1jb250ZW50e21pbi1oZWlnaHQ6NDhweH0uYW50LXRpbWVsaW5lLmFudC10aW1lbGluZS1sYWJlbCAuYW50LXRpbWVsaW5lLWl0ZW0tbGFiZWx7cG9zaXRpb246YWJzb2x1dGU7dG9wOi03LjAwMXB4O3dpZHRoOmNhbGMoNTAlIC0gMTJweCk7dGV4dC1hbGlnbjpyaWdodH0uYW50LXRpbWVsaW5lLmFudC10aW1lbGluZS1sYWJlbCAuYW50LXRpbWVsaW5lLWl0ZW0tcmlnaHQgLmFudC10aW1lbGluZS1pdGVtLWxhYmVse2xlZnQ6Y2FsYyg1MCUgKyAxNHB4KTt3aWR0aDpjYWxjKDUwJSAtIDE0cHgpO3RleHQtYWxpZ246bGVmdH0uYW50LXRpbWVsaW5lLXJ0bHtkaXJlY3Rpb246cnRsfS5hbnQtdGltZWxpbmUtcnRsIC5hbnQtdGltZWxpbmUtaXRlbS10YWlse3JpZ2h0OjRweDtsZWZ0OmF1dG87Ym9yZGVyLXJpZ2h0OjJweCBzb2xpZCAjZjBmMGYwO2JvcmRlci1sZWZ0Om5vbmV9LmFudC10aW1lbGluZS1ydGwgLmFudC10aW1lbGluZS1pdGVtLWhlYWQtY3VzdG9te3JpZ2h0OjVweDtsZWZ0OmF1dG87dHJhbnNmb3JtOnRyYW5zbGF0ZSg1MCUsLTUwJSl9LmFudC10aW1lbGluZS1ydGwgLmFudC10aW1lbGluZS1pdGVtLWNvbnRlbnR7bWFyZ2luOjAgMThweCAwIDB9LmFudC10aW1lbGluZS1ydGwuYW50LXRpbWVsaW5lLmFudC10aW1lbGluZS1hbHRlcm5hdGUgLmFudC10aW1lbGluZS1pdGVtLWhlYWQsLmFudC10aW1lbGluZS1ydGwuYW50LXRpbWVsaW5lLmFudC10aW1lbGluZS1hbHRlcm5hdGUgLmFudC10aW1lbGluZS1pdGVtLWhlYWQtY3VzdG9tLC5hbnQtdGltZWxpbmUtcnRsLmFudC10aW1lbGluZS5hbnQtdGltZWxpbmUtYWx0ZXJuYXRlIC5hbnQtdGltZWxpbmUtaXRlbS10YWlsLC5hbnQtdGltZWxpbmUtcnRsLmFudC10aW1lbGluZS5hbnQtdGltZWxpbmUtbGFiZWwgLmFudC10aW1lbGluZS1pdGVtLWhlYWQsLmFudC10aW1lbGluZS1ydGwuYW50LXRpbWVsaW5lLmFudC10aW1lbGluZS1sYWJlbCAuYW50LXRpbWVsaW5lLWl0ZW0taGVhZC1jdXN0b20sLmFudC10aW1lbGluZS1ydGwuYW50LXRpbWVsaW5lLmFudC10aW1lbGluZS1sYWJlbCAuYW50LXRpbWVsaW5lLWl0ZW0tdGFpbCwuYW50LXRpbWVsaW5lLXJ0bC5hbnQtdGltZWxpbmUuYW50LXRpbWVsaW5lLXJpZ2h0IC5hbnQtdGltZWxpbmUtaXRlbS1oZWFkLC5hbnQtdGltZWxpbmUtcnRsLmFudC10aW1lbGluZS5hbnQtdGltZWxpbmUtcmlnaHQgLmFudC10aW1lbGluZS1pdGVtLWhlYWQtY3VzdG9tLC5hbnQtdGltZWxpbmUtcnRsLmFudC10aW1lbGluZS5hbnQtdGltZWxpbmUtcmlnaHQgLmFudC10aW1lbGluZS1pdGVtLXRhaWx7cmlnaHQ6NTAlO2xlZnQ6YXV0b30uYW50LXRpbWVsaW5lLXJ0bC5hbnQtdGltZWxpbmUuYW50LXRpbWVsaW5lLWFsdGVybmF0ZSAuYW50LXRpbWVsaW5lLWl0ZW0taGVhZCwuYW50LXRpbWVsaW5lLXJ0bC5hbnQtdGltZWxpbmUuYW50LXRpbWVsaW5lLWxhYmVsIC5hbnQtdGltZWxpbmUtaXRlbS1oZWFkLC5hbnQtdGltZWxpbmUtcnRsLmFudC10aW1lbGluZS5hbnQtdGltZWxpbmUtcmlnaHQgLmFudC10aW1lbGluZS1pdGVtLWhlYWR7bWFyZ2luLXJpZ2h0Oi00cHg7bWFyZ2luLWxlZnQ6MH0uYW50LXRpbWVsaW5lLXJ0bC5hbnQtdGltZWxpbmUuYW50LXRpbWVsaW5lLWFsdGVybmF0ZSAuYW50LXRpbWVsaW5lLWl0ZW0taGVhZC1jdXN0b20sLmFudC10aW1lbGluZS1ydGwuYW50LXRpbWVsaW5lLmFudC10aW1lbGluZS1sYWJlbCAuYW50LXRpbWVsaW5lLWl0ZW0taGVhZC1jdXN0b20sLmFudC10aW1lbGluZS1ydGwuYW50LXRpbWVsaW5lLmFudC10aW1lbGluZS1yaWdodCAuYW50LXRpbWVsaW5lLWl0ZW0taGVhZC1jdXN0b217bWFyZ2luLXJpZ2h0OjFweDttYXJnaW4tbGVmdDowfS5hbnQtdGltZWxpbmUtcnRsLmFudC10aW1lbGluZS5hbnQtdGltZWxpbmUtYWx0ZXJuYXRlIC5hbnQtdGltZWxpbmUtaXRlbS1sZWZ0IC5hbnQtdGltZWxpbmUtaXRlbS1jb250ZW50LC5hbnQtdGltZWxpbmUtcnRsLmFudC10aW1lbGluZS5hbnQtdGltZWxpbmUtbGFiZWwgLmFudC10aW1lbGluZS1pdGVtLWxlZnQgLmFudC10aW1lbGluZS1pdGVtLWNvbnRlbnQsLmFudC10aW1lbGluZS1ydGwuYW50LXRpbWVsaW5lLmFudC10aW1lbGluZS1yaWdodCAuYW50LXRpbWVsaW5lLWl0ZW0tbGVmdCAuYW50LXRpbWVsaW5lLWl0ZW0tY29udGVudHtyaWdodDpjYWxjKDUwJSAtIDRweCk7bGVmdDphdXRvO3RleHQtYWxpZ246cmlnaHR9LmFudC10aW1lbGluZS1ydGwuYW50LXRpbWVsaW5lLmFudC10aW1lbGluZS1hbHRlcm5hdGUgLmFudC10aW1lbGluZS1pdGVtLXJpZ2h0IC5hbnQtdGltZWxpbmUtaXRlbS1jb250ZW50LC5hbnQtdGltZWxpbmUtcnRsLmFudC10aW1lbGluZS5hbnQtdGltZWxpbmUtbGFiZWwgLmFudC10aW1lbGluZS1pdGVtLXJpZ2h0IC5hbnQtdGltZWxpbmUtaXRlbS1jb250ZW50LC5hbnQtdGltZWxpbmUtcnRsLmFudC10aW1lbGluZS5hbnQtdGltZWxpbmUtcmlnaHQgLmFudC10aW1lbGluZS1pdGVtLXJpZ2h0IC5hbnQtdGltZWxpbmUtaXRlbS1jb250ZW50e3RleHQtYWxpZ246bGVmdH0uYW50LXRpbWVsaW5lLXJ0bC5hbnQtdGltZWxpbmUuYW50LXRpbWVsaW5lLXJpZ2h0IC5hbnQtdGltZWxpbmUtaXRlbS1yaWdodCAuYW50LXRpbWVsaW5lLWl0ZW0taGVhZCwuYW50LXRpbWVsaW5lLXJ0bC5hbnQtdGltZWxpbmUuYW50LXRpbWVsaW5lLXJpZ2h0IC5hbnQtdGltZWxpbmUtaXRlbS1yaWdodCAuYW50LXRpbWVsaW5lLWl0ZW0taGVhZC1jdXN0b20sLmFudC10aW1lbGluZS1ydGwuYW50LXRpbWVsaW5lLmFudC10aW1lbGluZS1yaWdodCAuYW50LXRpbWVsaW5lLWl0ZW0tcmlnaHQgLmFudC10aW1lbGluZS1pdGVtLXRhaWx7cmlnaHQ6MDtsZWZ0OmF1dG99LmFudC10aW1lbGluZS1ydGwuYW50LXRpbWVsaW5lLmFudC10aW1lbGluZS1yaWdodCAuYW50LXRpbWVsaW5lLWl0ZW0tcmlnaHQgLmFudC10aW1lbGluZS1pdGVtLWNvbnRlbnR7d2lkdGg6MTAwJTttYXJnaW4tcmlnaHQ6MThweDt0ZXh0LWFsaWduOnJpZ2h0fS5hbnQtdGltZWxpbmUtcnRsLmFudC10aW1lbGluZS5hbnQtdGltZWxpbmUtcGVuZGluZyAuYW50LXRpbWVsaW5lLWl0ZW0tbGFzdCAuYW50LXRpbWVsaW5lLWl0ZW0tdGFpbCwuYW50LXRpbWVsaW5lLXJ0bC5hbnQtdGltZWxpbmUuYW50LXRpbWVsaW5lLXJldmVyc2UgLmFudC10aW1lbGluZS1pdGVtLXBlbmRpbmcgLmFudC10aW1lbGluZS1pdGVtLXRhaWx7Ym9yZGVyLXJpZ2h0OjJweCBkb3R0ZWQgI2YwZjBmMDtib3JkZXItbGVmdDpub25lfS5hbnQtdGltZWxpbmUtcnRsLmFudC10aW1lbGluZS5hbnQtdGltZWxpbmUtbGFiZWwgLmFudC10aW1lbGluZS1pdGVtLWxhYmVse3RleHQtYWxpZ246bGVmdH0uYW50LXRpbWVsaW5lLXJ0bC5hbnQtdGltZWxpbmUuYW50LXRpbWVsaW5lLWxhYmVsIC5hbnQtdGltZWxpbmUtaXRlbS1yaWdodCAuYW50LXRpbWVsaW5lLWl0ZW0tbGFiZWx7cmlnaHQ6Y2FsYyg1MCUgKyAxNHB4KTt0ZXh0LWFsaWduOnJpZ2h0fS5hbnQtdG9vbHRpcHtib3gtc2l6aW5nOmJvcmRlci1ib3g7bWFyZ2luOjA7cGFkZGluZzowO2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtmb250LXNpemU6MTRweDtmb250LXZhcmlhbnQ6dGFidWxhci1udW1zO2xpbmUtaGVpZ2h0OjEuNTcxNTtsaXN0LXN0eWxlOm5vbmU7Zm9udC1mZWF0dXJlLXNldHRpbmdzOlwidG51bVwiO3Bvc2l0aW9uOmFic29sdXRlO3otaW5kZXg6MTA3MDtkaXNwbGF5OmJsb2NrO3dpZHRoOi1tb3otbWF4LWNvbnRlbnQ7d2lkdGg6bWF4LWNvbnRlbnQ7d2lkdGg6aW50cmluc2ljO21heC13aWR0aDoyNTBweDt2aXNpYmlsaXR5OnZpc2libGV9LmFudC10b29sdGlwLWNvbnRlbnR7cG9zaXRpb246cmVsYXRpdmV9LmFudC10b29sdGlwLWhpZGRlbntkaXNwbGF5Om5vbmV9LmFudC10b29sdGlwLXBsYWNlbWVudC10b3AsLmFudC10b29sdGlwLXBsYWNlbWVudC10b3BMZWZ0LC5hbnQtdG9vbHRpcC1wbGFjZW1lbnQtdG9wUmlnaHR7cGFkZGluZy1ib3R0b206MTQuMzEzNzA4NXB4fS5hbnQtdG9vbHRpcC1wbGFjZW1lbnQtcmlnaHQsLmFudC10b29sdGlwLXBsYWNlbWVudC1yaWdodEJvdHRvbSwuYW50LXRvb2x0aXAtcGxhY2VtZW50LXJpZ2h0VG9we3BhZGRpbmctbGVmdDoxNC4zMTM3MDg1cHh9LmFudC10b29sdGlwLXBsYWNlbWVudC1ib3R0b20sLmFudC10b29sdGlwLXBsYWNlbWVudC1ib3R0b21MZWZ0LC5hbnQtdG9vbHRpcC1wbGFjZW1lbnQtYm90dG9tUmlnaHR7cGFkZGluZy10b3A6MTQuMzEzNzA4NXB4fS5hbnQtdG9vbHRpcC1wbGFjZW1lbnQtbGVmdCwuYW50LXRvb2x0aXAtcGxhY2VtZW50LWxlZnRCb3R0b20sLmFudC10b29sdGlwLXBsYWNlbWVudC1sZWZ0VG9we3BhZGRpbmctcmlnaHQ6MTQuMzEzNzA4NXB4fS5hbnQtdG9vbHRpcC1pbm5lcnttaW4td2lkdGg6MzBweDttaW4taGVpZ2h0OjMycHg7cGFkZGluZzo2cHggOHB4O2NvbG9yOiNmZmY7dGV4dC1hbGlnbjpsZWZ0O3RleHQtZGVjb3JhdGlvbjpub25lO3dvcmQtd3JhcDpicmVhay13b3JkO2JhY2tncm91bmQtY29sb3I6cmdiYSgwLDAsMCwuNzUpO2JvcmRlci1yYWRpdXM6MnB4O2JveC1zaGFkb3c6MCAzcHggNnB4IC00cHggcmdiYSgwLDAsMCwuMTIpLDAgNnB4IDE2cHggMCByZ2JhKDAsMCwwLC4wOCksMCA5cHggMjhweCA4cHggcmdiYSgwLDAsMCwuMDUpfS5hbnQtdG9vbHRpcC1hcnJvd3twb3NpdGlvbjphYnNvbHV0ZTt6LWluZGV4OjI7ZGlzcGxheTpibG9jazt3aWR0aDoyMnB4O2hlaWdodDoyMnB4O292ZXJmbG93OmhpZGRlbjtiYWNrZ3JvdW5kOnRyYW5zcGFyZW50O3BvaW50ZXItZXZlbnRzOm5vbmV9LmFudC10b29sdGlwLWFycm93LWNvbnRlbnR7LS1hbnRkLWFycm93LWJhY2tncm91bmQtY29sb3I6bGluZWFyLWdyYWRpZW50KHRvIHJpZ2h0IGJvdHRvbSxyZ2JhKDAsMCwwLDAuNjUpLHJnYmEoMCwwLDAsMC43NSkpO3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO3JpZ2h0OjA7Ym90dG9tOjA7bGVmdDowO2Rpc3BsYXk6YmxvY2s7d2lkdGg6MTEuMzEzNzA4NXB4O2hlaWdodDoxMS4zMTM3MDg1cHg7bWFyZ2luOmF1dG87Y29udGVudDpcIlwiO3BvaW50ZXItZXZlbnRzOmF1dG87Ym9yZGVyLXJhZGl1czowIDAgMnB4O3BvaW50ZXItZXZlbnRzOm5vbmV9LmFudC10b29sdGlwLWFycm93LWNvbnRlbnQ6YmVmb3Jle3Bvc2l0aW9uOmFic29sdXRlO3RvcDotMTEuMzEzNzA4NXB4O2xlZnQ6LTExLjMxMzcwODVweDt3aWR0aDozMy45NDExMjU1cHg7aGVpZ2h0OjMzLjk0MTEyNTVweDtiYWNrZ3JvdW5kOnZhcigtLWFudGQtYXJyb3ctYmFja2dyb3VuZC1jb2xvcik7YmFja2dyb3VuZC1yZXBlYXQ6bm8tcmVwZWF0O2JhY2tncm91bmQtcG9zaXRpb246LTEwcHggLTEwcHg7Y29udGVudDpcIlwiOy13ZWJraXQtY2xpcC1wYXRoOmluc2V0KDMzJSAzMyUpO2NsaXAtcGF0aDppbnNldCgzMyUgMzMlKTstd2Via2l0LWNsaXAtcGF0aDpwYXRoKFwiTSA5Ljg0OTI0MjQwNDkxNzQ5OSAyNC4wOTE4ODMwOTIwMzY3ODUgQSA1IDUgMCAwIDEgMTMuMzg0Nzc2MzEwODUwMjM3IDIyLjYyNzQxNjk5Nzk2OTUyMiBMIDIwLjYyNzQxNjk5Nzk2OTUyMiAyMi42Mjc0MTY5OTc5Njk1MjIgQSAyIDIgMCAwIDAgMjIuNjI3NDE2OTk3OTY5NTIyIDIwLjYyNzQxNjk5Nzk2OTUyMiBMIDIyLjYyNzQxNjk5Nzk2OTUyMiAxMy4zODQ3NzYzMTA4NTAyMzcgQSA1IDUgMCAwIDEgMjQuMDkxODgzMDkyMDM2Nzg1IDkuODQ5MjQyNDA0OTE3NDk5IEwgMjMuMDkxODgzMDkyMDM2Nzg1IDkuODQ5MjQyNDA0OTE3NDk5IEwgOS44NDkyNDI0MDQ5MTc0OTkgMjMuMDkxODgzMDkyMDM2Nzg1IFpcIik7Y2xpcC1wYXRoOnBhdGgoXCJNIDkuODQ5MjQyNDA0OTE3NDk5IDI0LjA5MTg4MzA5MjAzNjc4NSBBIDUgNSAwIDAgMSAxMy4zODQ3NzYzMTA4NTAyMzcgMjIuNjI3NDE2OTk3OTY5NTIyIEwgMjAuNjI3NDE2OTk3OTY5NTIyIDIyLjYyNzQxNjk5Nzk2OTUyMiBBIDIgMiAwIDAgMCAyMi42Mjc0MTY5OTc5Njk1MjIgMjAuNjI3NDE2OTk3OTY5NTIyIEwgMjIuNjI3NDE2OTk3OTY5NTIyIDEzLjM4NDc3NjMxMDg1MDIzNyBBIDUgNSAwIDAgMSAyNC4wOTE4ODMwOTIwMzY3ODUgOS44NDkyNDI0MDQ5MTc0OTkgTCAyMy4wOTE4ODMwOTIwMzY3ODUgOS44NDkyNDI0MDQ5MTc0OTkgTCA5Ljg0OTI0MjQwNDkxNzQ5OSAyMy4wOTE4ODMwOTIwMzY3ODUgWlwiKX0uYW50LXRvb2x0aXAtcGxhY2VtZW50LXRvcCAuYW50LXRvb2x0aXAtYXJyb3csLmFudC10b29sdGlwLXBsYWNlbWVudC10b3BMZWZ0IC5hbnQtdG9vbHRpcC1hcnJvdywuYW50LXRvb2x0aXAtcGxhY2VtZW50LXRvcFJpZ2h0IC5hbnQtdG9vbHRpcC1hcnJvd3tib3R0b206MDt0cmFuc2Zvcm06dHJhbnNsYXRlWSgxMDAlKX0uYW50LXRvb2x0aXAtcGxhY2VtZW50LXRvcCAuYW50LXRvb2x0aXAtYXJyb3ctY29udGVudCwuYW50LXRvb2x0aXAtcGxhY2VtZW50LXRvcExlZnQgLmFudC10b29sdGlwLWFycm93LWNvbnRlbnQsLmFudC10b29sdGlwLXBsYWNlbWVudC10b3BSaWdodCAuYW50LXRvb2x0aXAtYXJyb3ctY29udGVudHtib3gtc2hhZG93OjNweCAzcHggN3B4IHJnYmEoMCwwLDAsLjA3KTt0cmFuc2Zvcm06dHJhbnNsYXRlWSgtMTFweCkgcm90YXRlKDQ1ZGVnKX0uYW50LXRvb2x0aXAtcGxhY2VtZW50LXRvcCAuYW50LXRvb2x0aXAtYXJyb3d7bGVmdDo1MCU7dHJhbnNmb3JtOnRyYW5zbGF0ZVkoMTAwJSkgdHJhbnNsYXRlWCgtNTAlKX0uYW50LXRvb2x0aXAtcGxhY2VtZW50LXRvcExlZnQgLmFudC10b29sdGlwLWFycm93e2xlZnQ6MTNweH0uYW50LXRvb2x0aXAtcGxhY2VtZW50LXRvcFJpZ2h0IC5hbnQtdG9vbHRpcC1hcnJvd3tyaWdodDoxM3B4fS5hbnQtdG9vbHRpcC1wbGFjZW1lbnQtcmlnaHQgLmFudC10b29sdGlwLWFycm93LC5hbnQtdG9vbHRpcC1wbGFjZW1lbnQtcmlnaHRCb3R0b20gLmFudC10b29sdGlwLWFycm93LC5hbnQtdG9vbHRpcC1wbGFjZW1lbnQtcmlnaHRUb3AgLmFudC10b29sdGlwLWFycm93e2xlZnQ6MDt0cmFuc2Zvcm06dHJhbnNsYXRlWCgtMTAwJSl9LmFudC10b29sdGlwLXBsYWNlbWVudC1yaWdodCAuYW50LXRvb2x0aXAtYXJyb3ctY29udGVudCwuYW50LXRvb2x0aXAtcGxhY2VtZW50LXJpZ2h0Qm90dG9tIC5hbnQtdG9vbHRpcC1hcnJvdy1jb250ZW50LC5hbnQtdG9vbHRpcC1wbGFjZW1lbnQtcmlnaHRUb3AgLmFudC10b29sdGlwLWFycm93LWNvbnRlbnR7Ym94LXNoYWRvdzotM3B4IDNweCA3cHggcmdiYSgwLDAsMCwuMDcpO3RyYW5zZm9ybTp0cmFuc2xhdGVYKDExcHgpIHJvdGF0ZSgxMzVkZWcpfS5hbnQtdG9vbHRpcC1wbGFjZW1lbnQtcmlnaHQgLmFudC10b29sdGlwLWFycm93e3RvcDo1MCU7dHJhbnNmb3JtOnRyYW5zbGF0ZVgoLTEwMCUpIHRyYW5zbGF0ZVkoLTUwJSl9LmFudC10b29sdGlwLXBsYWNlbWVudC1yaWdodFRvcCAuYW50LXRvb2x0aXAtYXJyb3d7dG9wOjVweH0uYW50LXRvb2x0aXAtcGxhY2VtZW50LXJpZ2h0Qm90dG9tIC5hbnQtdG9vbHRpcC1hcnJvd3tib3R0b206NXB4fS5hbnQtdG9vbHRpcC1wbGFjZW1lbnQtbGVmdCAuYW50LXRvb2x0aXAtYXJyb3csLmFudC10b29sdGlwLXBsYWNlbWVudC1sZWZ0Qm90dG9tIC5hbnQtdG9vbHRpcC1hcnJvdywuYW50LXRvb2x0aXAtcGxhY2VtZW50LWxlZnRUb3AgLmFudC10b29sdGlwLWFycm93e3JpZ2h0OjA7dHJhbnNmb3JtOnRyYW5zbGF0ZVgoMTAwJSl9LmFudC10b29sdGlwLXBsYWNlbWVudC1sZWZ0IC5hbnQtdG9vbHRpcC1hcnJvdy1jb250ZW50LC5hbnQtdG9vbHRpcC1wbGFjZW1lbnQtbGVmdEJvdHRvbSAuYW50LXRvb2x0aXAtYXJyb3ctY29udGVudCwuYW50LXRvb2x0aXAtcGxhY2VtZW50LWxlZnRUb3AgLmFudC10b29sdGlwLWFycm93LWNvbnRlbnR7Ym94LXNoYWRvdzozcHggLTNweCA3cHggcmdiYSgwLDAsMCwuMDcpO3RyYW5zZm9ybTp0cmFuc2xhdGVYKC0xMXB4KSByb3RhdGUoMzE1ZGVnKX0uYW50LXRvb2x0aXAtcGxhY2VtZW50LWxlZnQgLmFudC10b29sdGlwLWFycm93e3RvcDo1MCU7dHJhbnNmb3JtOnRyYW5zbGF0ZVgoMTAwJSkgdHJhbnNsYXRlWSgtNTAlKX0uYW50LXRvb2x0aXAtcGxhY2VtZW50LWxlZnRUb3AgLmFudC10b29sdGlwLWFycm93e3RvcDo1cHh9LmFudC10b29sdGlwLXBsYWNlbWVudC1sZWZ0Qm90dG9tIC5hbnQtdG9vbHRpcC1hcnJvd3tib3R0b206NXB4fS5hbnQtdG9vbHRpcC1wbGFjZW1lbnQtYm90dG9tIC5hbnQtdG9vbHRpcC1hcnJvdywuYW50LXRvb2x0aXAtcGxhY2VtZW50LWJvdHRvbUxlZnQgLmFudC10b29sdGlwLWFycm93LC5hbnQtdG9vbHRpcC1wbGFjZW1lbnQtYm90dG9tUmlnaHQgLmFudC10b29sdGlwLWFycm93e3RvcDowO3RyYW5zZm9ybTp0cmFuc2xhdGVZKC0xMDAlKX0uYW50LXRvb2x0aXAtcGxhY2VtZW50LWJvdHRvbSAuYW50LXRvb2x0aXAtYXJyb3ctY29udGVudCwuYW50LXRvb2x0aXAtcGxhY2VtZW50LWJvdHRvbUxlZnQgLmFudC10b29sdGlwLWFycm93LWNvbnRlbnQsLmFudC10b29sdGlwLXBsYWNlbWVudC1ib3R0b21SaWdodCAuYW50LXRvb2x0aXAtYXJyb3ctY29udGVudHtib3gtc2hhZG93Oi0zcHggLTNweCA3cHggcmdiYSgwLDAsMCwuMDcpO3RyYW5zZm9ybTp0cmFuc2xhdGVZKDExcHgpIHJvdGF0ZSgyMjVkZWcpfS5hbnQtdG9vbHRpcC1wbGFjZW1lbnQtYm90dG9tIC5hbnQtdG9vbHRpcC1hcnJvd3tsZWZ0OjUwJTt0cmFuc2Zvcm06dHJhbnNsYXRlWSgtMTAwJSkgdHJhbnNsYXRlWCgtNTAlKX0uYW50LXRvb2x0aXAtcGxhY2VtZW50LWJvdHRvbUxlZnQgLmFudC10b29sdGlwLWFycm93e2xlZnQ6MTNweH0uYW50LXRvb2x0aXAtcGxhY2VtZW50LWJvdHRvbVJpZ2h0IC5hbnQtdG9vbHRpcC1hcnJvd3tyaWdodDoxM3B4fS5hbnQtdG9vbHRpcC1waW5rIC5hbnQtdG9vbHRpcC1pbm5lcntiYWNrZ3JvdW5kLWNvbG9yOiNlYjJmOTZ9LmFudC10b29sdGlwLXBpbmsgLmFudC10b29sdGlwLWFycm93LWNvbnRlbnQ6YmVmb3Jle2JhY2tncm91bmQ6I2ViMmY5Nn0uYW50LXRvb2x0aXAtbWFnZW50YSAuYW50LXRvb2x0aXAtaW5uZXJ7YmFja2dyb3VuZC1jb2xvcjojZWIyZjk2fS5hbnQtdG9vbHRpcC1tYWdlbnRhIC5hbnQtdG9vbHRpcC1hcnJvdy1jb250ZW50OmJlZm9yZXtiYWNrZ3JvdW5kOiNlYjJmOTZ9LmFudC10b29sdGlwLXJlZCAuYW50LXRvb2x0aXAtaW5uZXJ7YmFja2dyb3VuZC1jb2xvcjojZjUyMjJkfS5hbnQtdG9vbHRpcC1yZWQgLmFudC10b29sdGlwLWFycm93LWNvbnRlbnQ6YmVmb3Jle2JhY2tncm91bmQ6I2Y1MjIyZH0uYW50LXRvb2x0aXAtdm9sY2FubyAuYW50LXRvb2x0aXAtaW5uZXJ7YmFja2dyb3VuZC1jb2xvcjojZmE1NDFjfS5hbnQtdG9vbHRpcC12b2xjYW5vIC5hbnQtdG9vbHRpcC1hcnJvdy1jb250ZW50OmJlZm9yZXtiYWNrZ3JvdW5kOiNmYTU0MWN9LmFudC10b29sdGlwLW9yYW5nZSAuYW50LXRvb2x0aXAtaW5uZXJ7YmFja2dyb3VuZC1jb2xvcjojZmE4YzE2fS5hbnQtdG9vbHRpcC1vcmFuZ2UgLmFudC10b29sdGlwLWFycm93LWNvbnRlbnQ6YmVmb3Jle2JhY2tncm91bmQ6I2ZhOGMxNn0uYW50LXRvb2x0aXAteWVsbG93IC5hbnQtdG9vbHRpcC1pbm5lcntiYWNrZ3JvdW5kLWNvbG9yOiNmYWRiMTR9LmFudC10b29sdGlwLXllbGxvdyAuYW50LXRvb2x0aXAtYXJyb3ctY29udGVudDpiZWZvcmV7YmFja2dyb3VuZDojZmFkYjE0fS5hbnQtdG9vbHRpcC1nb2xkIC5hbnQtdG9vbHRpcC1pbm5lcntiYWNrZ3JvdW5kLWNvbG9yOiNmYWFkMTR9LmFudC10b29sdGlwLWdvbGQgLmFudC10b29sdGlwLWFycm93LWNvbnRlbnQ6YmVmb3Jle2JhY2tncm91bmQ6I2ZhYWQxNH0uYW50LXRvb2x0aXAtY3lhbiAuYW50LXRvb2x0aXAtaW5uZXJ7YmFja2dyb3VuZC1jb2xvcjojMTNjMmMyfS5hbnQtdG9vbHRpcC1jeWFuIC5hbnQtdG9vbHRpcC1hcnJvdy1jb250ZW50OmJlZm9yZXtiYWNrZ3JvdW5kOiMxM2MyYzJ9LmFudC10b29sdGlwLWxpbWUgLmFudC10b29sdGlwLWlubmVye2JhY2tncm91bmQtY29sb3I6I2EwZDkxMX0uYW50LXRvb2x0aXAtbGltZSAuYW50LXRvb2x0aXAtYXJyb3ctY29udGVudDpiZWZvcmV7YmFja2dyb3VuZDojYTBkOTExfS5hbnQtdG9vbHRpcC1ncmVlbiAuYW50LXRvb2x0aXAtaW5uZXJ7YmFja2dyb3VuZC1jb2xvcjojNTJjNDFhfS5hbnQtdG9vbHRpcC1ncmVlbiAuYW50LXRvb2x0aXAtYXJyb3ctY29udGVudDpiZWZvcmV7YmFja2dyb3VuZDojNTJjNDFhfS5hbnQtdG9vbHRpcC1ibHVlIC5hbnQtdG9vbHRpcC1pbm5lcntiYWNrZ3JvdW5kLWNvbG9yOiMxODkwZmZ9LmFudC10b29sdGlwLWJsdWUgLmFudC10b29sdGlwLWFycm93LWNvbnRlbnQ6YmVmb3Jle2JhY2tncm91bmQ6IzE4OTBmZn0uYW50LXRvb2x0aXAtZ2Vla2JsdWUgLmFudC10b29sdGlwLWlubmVye2JhY2tncm91bmQtY29sb3I6IzJmNTRlYn0uYW50LXRvb2x0aXAtZ2Vla2JsdWUgLmFudC10b29sdGlwLWFycm93LWNvbnRlbnQ6YmVmb3Jle2JhY2tncm91bmQ6IzJmNTRlYn0uYW50LXRvb2x0aXAtcHVycGxlIC5hbnQtdG9vbHRpcC1pbm5lcntiYWNrZ3JvdW5kLWNvbG9yOiM3MjJlZDF9LmFudC10b29sdGlwLXB1cnBsZSAuYW50LXRvb2x0aXAtYXJyb3ctY29udGVudDpiZWZvcmV7YmFja2dyb3VuZDojNzIyZWQxfS5hbnQtdG9vbHRpcC1ydGx7ZGlyZWN0aW9uOnJ0bH0uYW50LXRvb2x0aXAtcnRsIC5hbnQtdG9vbHRpcC1pbm5lcnt0ZXh0LWFsaWduOnJpZ2h0fS5hbnQtdHJhbnNmZXItY3VzdG9taXplLWxpc3QgLmFudC10cmFuc2Zlci1saXN0e2ZsZXg6MSAxIDUwJTt3aWR0aDphdXRvO2hlaWdodDphdXRvO21pbi1oZWlnaHQ6MjAwcHh9LmFudC10cmFuc2Zlci1jdXN0b21pemUtbGlzdCAuYW50LXRhYmxlLXdyYXBwZXIgLmFudC10YWJsZS1zbWFsbHtib3JkZXI6MDtib3JkZXItcmFkaXVzOjB9LmFudC10cmFuc2Zlci1jdXN0b21pemUtbGlzdCAuYW50LXRhYmxlLXdyYXBwZXIgLmFudC10YWJsZS1zbWFsbCAuYW50LXRhYmxlLXNlbGVjdGlvbi1jb2x1bW57d2lkdGg6NDBweDttaW4td2lkdGg6NDBweH0uYW50LXRyYW5zZmVyLWN1c3RvbWl6ZS1saXN0IC5hbnQtdGFibGUtd3JhcHBlciAuYW50LXRhYmxlLXNtYWxsPi5hbnQtdGFibGUtY29udGVudD4uYW50LXRhYmxlLWJvZHk+dGFibGU+LmFudC10YWJsZS10aGVhZD50cj50aHtiYWNrZ3JvdW5kOiNmYWZhZmF9LmFudC10cmFuc2Zlci1jdXN0b21pemUtbGlzdCAuYW50LXRhYmxlLXdyYXBwZXIgLmFudC10YWJsZS1zbWFsbD4uYW50LXRhYmxlLWNvbnRlbnQgLmFudC10YWJsZS1yb3c6bGFzdC1jaGlsZCB0ZHtib3JkZXItYm90dG9tOjFweCBzb2xpZCAjZjBmMGYwfS5hbnQtdHJhbnNmZXItY3VzdG9taXplLWxpc3QgLmFudC10YWJsZS13cmFwcGVyIC5hbnQtdGFibGUtc21hbGwgLmFudC10YWJsZS1ib2R5e21hcmdpbjowfS5hbnQtdHJhbnNmZXItY3VzdG9taXplLWxpc3QgLmFudC10YWJsZS13cmFwcGVyIC5hbnQtdGFibGUtcGFnaW5hdGlvbi5hbnQtcGFnaW5hdGlvbnttYXJnaW46MTZweCAwIDRweH0uYW50LXRyYW5zZmVyLWN1c3RvbWl6ZS1saXN0IC5hbnQtaW5wdXRbZGlzYWJsZWRde2JhY2tncm91bmQtY29sb3I6dHJhbnNwYXJlbnR9LmFudC10cmFuc2Zlci1zdGF0dXMtZXJyb3IgLmFudC10cmFuc2Zlci1saXN0e2JvcmRlci1jb2xvcjojZmY0ZDRmfS5hbnQtdHJhbnNmZXItc3RhdHVzLWVycm9yIC5hbnQtdHJhbnNmZXItbGlzdC1zZWFyY2g6bm90KFtkaXNhYmxlZF0pe2JvcmRlci1jb2xvcjojZDlkOWQ5fS5hbnQtdHJhbnNmZXItc3RhdHVzLWVycm9yIC5hbnQtdHJhbnNmZXItbGlzdC1zZWFyY2g6bm90KFtkaXNhYmxlZF0pOmhvdmVye2JvcmRlci1jb2xvcjojNDBhOWZmO2JvcmRlci1yaWdodC13aWR0aDoxcHh9LmFudC10cmFuc2Zlci1zdGF0dXMtZXJyb3IgLmFudC10cmFuc2Zlci1saXN0LXNlYXJjaDpub3QoW2Rpc2FibGVkXSk6Zm9jdXN7Ym9yZGVyLWNvbG9yOiM0MGE5ZmY7Ym94LXNoYWRvdzowIDAgMCAycHggcmdiYSgyNCwxNDQsMjU1LC4yKTtib3JkZXItcmlnaHQtd2lkdGg6MXB4O291dGxpbmU6MH0uYW50LXRyYW5zZmVyLXN0YXR1cy13YXJuaW5nIC5hbnQtdHJhbnNmZXItbGlzdHtib3JkZXItY29sb3I6I2ZhYWQxNH0uYW50LXRyYW5zZmVyLXN0YXR1cy13YXJuaW5nIC5hbnQtdHJhbnNmZXItbGlzdC1zZWFyY2g6bm90KFtkaXNhYmxlZF0pe2JvcmRlci1jb2xvcjojZDlkOWQ5fS5hbnQtdHJhbnNmZXItc3RhdHVzLXdhcm5pbmcgLmFudC10cmFuc2Zlci1saXN0LXNlYXJjaDpub3QoW2Rpc2FibGVkXSk6aG92ZXJ7Ym9yZGVyLWNvbG9yOiM0MGE5ZmY7Ym9yZGVyLXJpZ2h0LXdpZHRoOjFweH0uYW50LXRyYW5zZmVyLXN0YXR1cy13YXJuaW5nIC5hbnQtdHJhbnNmZXItbGlzdC1zZWFyY2g6bm90KFtkaXNhYmxlZF0pOmZvY3Vze2JvcmRlci1jb2xvcjojNDBhOWZmO2JveC1zaGFkb3c6MCAwIDAgMnB4IHJnYmEoMjQsMTQ0LDI1NSwuMik7Ym9yZGVyLXJpZ2h0LXdpZHRoOjFweDtvdXRsaW5lOjB9LmFudC10cmFuc2Zlcntib3gtc2l6aW5nOmJvcmRlci1ib3g7bWFyZ2luOjA7cGFkZGluZzowO2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtmb250LXNpemU6MTRweDtmb250LXZhcmlhbnQ6dGFidWxhci1udW1zO2xpbmUtaGVpZ2h0OjEuNTcxNTtsaXN0LXN0eWxlOm5vbmU7Zm9udC1mZWF0dXJlLXNldHRpbmdzOlwidG51bVwiO3Bvc2l0aW9uOnJlbGF0aXZlO2Rpc3BsYXk6ZmxleDthbGlnbi1pdGVtczpzdHJldGNofS5hbnQtdHJhbnNmZXItZGlzYWJsZWQgLmFudC10cmFuc2Zlci1saXN0e2JhY2tncm91bmQ6I2Y1ZjVmNX0uYW50LXRyYW5zZmVyLWxpc3R7ZGlzcGxheTpmbGV4O2ZsZXgtZGlyZWN0aW9uOmNvbHVtbjt3aWR0aDoxODBweDtoZWlnaHQ6MjAwcHg7Ym9yZGVyOjFweCBzb2xpZCAjZDlkOWQ5O2JvcmRlci1yYWRpdXM6MnB4fS5hbnQtdHJhbnNmZXItbGlzdC13aXRoLXBhZ2luYXRpb257d2lkdGg6MjUwcHg7aGVpZ2h0OmF1dG99LmFudC10cmFuc2Zlci1saXN0LXNlYXJjaCAuYW50aWNvbi1zZWFyY2h7Y29sb3I6cmdiYSgwLDAsMCwuMjUpfS5hbnQtdHJhbnNmZXItbGlzdC1oZWFkZXJ7ZGlzcGxheTpmbGV4O2ZsZXg6bm9uZTthbGlnbi1pdGVtczpjZW50ZXI7aGVpZ2h0OjQwcHg7cGFkZGluZzo4cHggMTJweCA5cHg7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2JhY2tncm91bmQ6I2ZmZjtib3JkZXItYm90dG9tOjFweCBzb2xpZCAjZjBmMGYwO2JvcmRlci1yYWRpdXM6MnB4IDJweCAwIDB9LmFudC10cmFuc2Zlci1saXN0LWhlYWRlcj46bm90KDpsYXN0LWNoaWxkKXttYXJnaW4tcmlnaHQ6NHB4fS5hbnQtdHJhbnNmZXItbGlzdC1oZWFkZXI+KntmbGV4Om5vbmV9LmFudC10cmFuc2Zlci1saXN0LWhlYWRlci10aXRsZXtmbGV4OmF1dG87b3ZlcmZsb3c6aGlkZGVuO3doaXRlLXNwYWNlOm5vd3JhcDt0ZXh0LWFsaWduOnJpZ2h0O3RleHQtb3ZlcmZsb3c6ZWxsaXBzaXN9LmFudC10cmFuc2Zlci1saXN0LWhlYWRlci1kcm9wZG93bntmb250LXNpemU6MTBweDt0cmFuc2Zvcm06dHJhbnNsYXRlWSgxMCUpO2N1cnNvcjpwb2ludGVyfS5hbnQtdHJhbnNmZXItbGlzdC1oZWFkZXItZHJvcGRvd25bZGlzYWJsZWRde2N1cnNvcjpub3QtYWxsb3dlZH0uYW50LXRyYW5zZmVyLWxpc3QtYm9keXtkaXNwbGF5OmZsZXg7ZmxleDphdXRvO2ZsZXgtZGlyZWN0aW9uOmNvbHVtbjtvdmVyZmxvdzpoaWRkZW47Zm9udC1zaXplOjE0cHh9LmFudC10cmFuc2Zlci1saXN0LWJvZHktc2VhcmNoLXdyYXBwZXJ7cG9zaXRpb246cmVsYXRpdmU7ZmxleDpub25lO3BhZGRpbmc6MTJweH0uYW50LXRyYW5zZmVyLWxpc3QtY29udGVudHtmbGV4OmF1dG87bWFyZ2luOjA7cGFkZGluZzowO292ZXJmbG93OmF1dG87bGlzdC1zdHlsZTpub25lfS5hbnQtdHJhbnNmZXItbGlzdC1jb250ZW50LWl0ZW17ZGlzcGxheTpmbGV4O2FsaWduLWl0ZW1zOmNlbnRlcjttaW4taGVpZ2h0OjMycHg7cGFkZGluZzo2cHggMTJweDtsaW5lLWhlaWdodDoyMHB4O3RyYW5zaXRpb246YWxsIC4zc30uYW50LXRyYW5zZmVyLWxpc3QtY29udGVudC1pdGVtPjpub3QoOmxhc3QtY2hpbGQpe21hcmdpbi1yaWdodDo4cHh9LmFudC10cmFuc2Zlci1saXN0LWNvbnRlbnQtaXRlbT4qe2ZsZXg6bm9uZX0uYW50LXRyYW5zZmVyLWxpc3QtY29udGVudC1pdGVtLXRleHR7ZmxleDphdXRvO292ZXJmbG93OmhpZGRlbjt3aGl0ZS1zcGFjZTpub3dyYXA7dGV4dC1vdmVyZmxvdzplbGxpcHNpc30uYW50LXRyYW5zZmVyLWxpc3QtY29udGVudC1pdGVtLXJlbW92ZXtwb3NpdGlvbjpyZWxhdGl2ZTtjb2xvcjojZDlkOWQ5O2N1cnNvcjpwb2ludGVyO3RyYW5zaXRpb246YWxsIC4zc30uYW50LXRyYW5zZmVyLWxpc3QtY29udGVudC1pdGVtLXJlbW92ZTpob3Zlcntjb2xvcjojNDBhOWZmfS5hbnQtdHJhbnNmZXItbGlzdC1jb250ZW50LWl0ZW0tcmVtb3ZlOmFmdGVye3Bvc2l0aW9uOmFic29sdXRlO3RvcDotNnB4O3JpZ2h0Oi01MCU7Ym90dG9tOi02cHg7bGVmdDotNTAlO2NvbnRlbnQ6XCJcIn0uYW50LXRyYW5zZmVyLWxpc3QtY29udGVudC1pdGVtOm5vdCguYW50LXRyYW5zZmVyLWxpc3QtY29udGVudC1pdGVtLWRpc2FibGVkKTpob3ZlcntiYWNrZ3JvdW5kLWNvbG9yOiNmNWY1ZjU7Y3Vyc29yOnBvaW50ZXJ9LmFudC10cmFuc2Zlci1saXN0LWNvbnRlbnQtaXRlbTpub3QoLmFudC10cmFuc2Zlci1saXN0LWNvbnRlbnQtaXRlbS1kaXNhYmxlZCkuYW50LXRyYW5zZmVyLWxpc3QtY29udGVudC1pdGVtLWNoZWNrZWQ6aG92ZXJ7YmFja2dyb3VuZC1jb2xvcjojZGNmNGZmfS5hbnQtdHJhbnNmZXItbGlzdC1jb250ZW50LXNob3ctcmVtb3ZlIC5hbnQtdHJhbnNmZXItbGlzdC1jb250ZW50LWl0ZW06bm90KC5hbnQtdHJhbnNmZXItbGlzdC1jb250ZW50LWl0ZW0tZGlzYWJsZWQpOmhvdmVye2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7Y3Vyc29yOmRlZmF1bHR9LmFudC10cmFuc2Zlci1saXN0LWNvbnRlbnQtaXRlbS1jaGVja2Vke2JhY2tncm91bmQtY29sb3I6I2U2ZjdmZn0uYW50LXRyYW5zZmVyLWxpc3QtY29udGVudC1pdGVtLWRpc2FibGVke2NvbG9yOnJnYmEoMCwwLDAsLjI1KTtjdXJzb3I6bm90LWFsbG93ZWR9LmFudC10cmFuc2Zlci1saXN0LXBhZ2luYXRpb257cGFkZGluZzo4cHggMDt0ZXh0LWFsaWduOnJpZ2h0O2JvcmRlci10b3A6MXB4IHNvbGlkICNmMGYwZjB9LmFudC10cmFuc2Zlci1saXN0LWJvZHktbm90LWZvdW5ke2ZsZXg6bm9uZTt3aWR0aDoxMDAlO21hcmdpbjphdXRvIDA7Y29sb3I6cmdiYSgwLDAsMCwuMjUpO3RleHQtYWxpZ246Y2VudGVyfS5hbnQtdHJhbnNmZXItbGlzdC1mb290ZXJ7Ym9yZGVyLXRvcDoxcHggc29saWQgI2YwZjBmMH0uYW50LXRyYW5zZmVyLW9wZXJhdGlvbntkaXNwbGF5OmZsZXg7ZmxleDpub25lO2ZsZXgtZGlyZWN0aW9uOmNvbHVtbjthbGlnbi1zZWxmOmNlbnRlcjttYXJnaW46MCA4cHg7dmVydGljYWwtYWxpZ246bWlkZGxlfS5hbnQtdHJhbnNmZXItb3BlcmF0aW9uIC5hbnQtYnRue2Rpc3BsYXk6YmxvY2t9LmFudC10cmFuc2Zlci1vcGVyYXRpb24gLmFudC1idG46Zmlyc3QtY2hpbGR7bWFyZ2luLWJvdHRvbTo0cHh9LmFudC10cmFuc2Zlci1vcGVyYXRpb24gLmFudC1idG4gLmFudGljb257Zm9udC1zaXplOjEycHh9LmFudC10cmFuc2ZlciAuYW50LWVtcHR5LWltYWdle21heC1oZWlnaHQ6LTJweH0uYW50LXRyYW5zZmVyLXJ0bHtkaXJlY3Rpb246cnRsfS5hbnQtdHJhbnNmZXItcnRsIC5hbnQtdHJhbnNmZXItbGlzdC1zZWFyY2h7cGFkZGluZy1yaWdodDo4cHg7cGFkZGluZy1sZWZ0OjI0cHh9LmFudC10cmFuc2Zlci1ydGwgLmFudC10cmFuc2Zlci1saXN0LXNlYXJjaC1hY3Rpb257cmlnaHQ6YXV0bztsZWZ0OjEycHh9LmFudC10cmFuc2Zlci1ydGwgLmFudC10cmFuc2Zlci1saXN0LWhlYWRlcj46bm90KDpsYXN0LWNoaWxkKXttYXJnaW4tcmlnaHQ6MDttYXJnaW4tbGVmdDo0cHh9LmFudC10cmFuc2Zlci1ydGwgLmFudC10cmFuc2Zlci1saXN0LWhlYWRlcntyaWdodDowO2xlZnQ6YXV0b30uYW50LXRyYW5zZmVyLXJ0bCAuYW50LXRyYW5zZmVyLWxpc3QtaGVhZGVyLXRpdGxle3RleHQtYWxpZ246bGVmdH0uYW50LXRyYW5zZmVyLXJ0bCAuYW50LXRyYW5zZmVyLWxpc3QtY29udGVudC1pdGVtPjpub3QoOmxhc3QtY2hpbGQpe21hcmdpbi1yaWdodDowO21hcmdpbi1sZWZ0OjhweH0uYW50LXRyYW5zZmVyLXJ0bCAuYW50LXRyYW5zZmVyLWxpc3QtcGFnaW5hdGlvbnt0ZXh0LWFsaWduOmxlZnR9LmFudC10cmFuc2Zlci1ydGwgLmFudC10cmFuc2Zlci1saXN0LWZvb3RlcntyaWdodDowO2xlZnQ6YXV0b30uYW50LXNlbGVjdC10cmVlLWNoZWNrYm94e2JveC1zaXppbmc6Ym9yZGVyLWJveDttYXJnaW46MDtwYWRkaW5nOjA7Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtc2l6ZToxNHB4O2ZvbnQtdmFyaWFudDp0YWJ1bGFyLW51bXM7bGluZS1oZWlnaHQ6MS41NzE1O2xpc3Qtc3R5bGU6bm9uZTtmb250LWZlYXR1cmUtc2V0dGluZ3M6XCJ0bnVtXCI7cG9zaXRpb246cmVsYXRpdmU7dG9wOi4yZW07bGluZS1oZWlnaHQ6MTt3aGl0ZS1zcGFjZTpub3dyYXA7b3V0bGluZTpub25lO2N1cnNvcjpwb2ludGVyfS5hbnQtc2VsZWN0LXRyZWUtY2hlY2tib3gtaW5wdXQ6Zm9jdXMrLmFudC1zZWxlY3QtdHJlZS1jaGVja2JveC1pbm5lciwuYW50LXNlbGVjdC10cmVlLWNoZWNrYm94LXdyYXBwZXI6aG92ZXIgLmFudC1zZWxlY3QtdHJlZS1jaGVja2JveC1pbm5lciwuYW50LXNlbGVjdC10cmVlLWNoZWNrYm94OmhvdmVyIC5hbnQtc2VsZWN0LXRyZWUtY2hlY2tib3gtaW5uZXJ7Ym9yZGVyLWNvbG9yOiMxODkwZmZ9LmFudC1zZWxlY3QtdHJlZS1jaGVja2JveC1jaGVja2VkOmFmdGVye3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO2xlZnQ6MDt3aWR0aDoxMDAlO2hlaWdodDoxMDAlO2JvcmRlcjoxcHggc29saWQgIzE4OTBmZjtib3JkZXItcmFkaXVzOjJweDt2aXNpYmlsaXR5OmhpZGRlbjthbmltYXRpb246YW50Q2hlY2tib3hFZmZlY3QgLjM2cyBlYXNlLWluLW91dDthbmltYXRpb24tZmlsbC1tb2RlOmJhY2t3YXJkcztjb250ZW50OlwiXCJ9LmFudC1zZWxlY3QtdHJlZS1jaGVja2JveC13cmFwcGVyOmhvdmVyIC5hbnQtc2VsZWN0LXRyZWUtY2hlY2tib3g6YWZ0ZXIsLmFudC1zZWxlY3QtdHJlZS1jaGVja2JveDpob3ZlcjphZnRlcnt2aXNpYmlsaXR5OnZpc2libGV9LmFudC1zZWxlY3QtdHJlZS1jaGVja2JveC1pbm5lcntwb3NpdGlvbjpyZWxhdGl2ZTt0b3A6MDtsZWZ0OjA7ZGlzcGxheTpibG9jazt3aWR0aDoxNnB4O2hlaWdodDoxNnB4O2RpcmVjdGlvbjpsdHI7YmFja2dyb3VuZC1jb2xvcjojZmZmO2JvcmRlcjoxcHggc29saWQgI2Q5ZDlkOTtib3JkZXItcmFkaXVzOjJweDtib3JkZXItY29sbGFwc2U6c2VwYXJhdGU7dHJhbnNpdGlvbjphbGwgLjNzfS5hbnQtc2VsZWN0LXRyZWUtY2hlY2tib3gtaW5uZXI6YWZ0ZXJ7cG9zaXRpb246YWJzb2x1dGU7dG9wOjUwJTtsZWZ0OjIxLjUlO2Rpc3BsYXk6dGFibGU7d2lkdGg6NS43MTQyODU3MXB4O2hlaWdodDo5LjE0Mjg1NzE0cHg7Ym9yZGVyOjJweCBzb2xpZCAjZmZmO2JvcmRlci10b3A6MDtib3JkZXItbGVmdDowO3RyYW5zZm9ybTpyb3RhdGUoNDVkZWcpIHNjYWxlKDApIHRyYW5zbGF0ZSgtNTAlLC01MCUpO29wYWNpdHk6MDt0cmFuc2l0aW9uOmFsbCAuMXMgY3ViaWMtYmV6aWVyKC43MSwtLjQ2LC44OCwuNiksb3BhY2l0eSAuMXM7Y29udGVudDpcIiBcIn0uYW50LXNlbGVjdC10cmVlLWNoZWNrYm94LWlucHV0e3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO3JpZ2h0OjA7Ym90dG9tOjA7bGVmdDowO3otaW5kZXg6MTt3aWR0aDoxMDAlO2hlaWdodDoxMDAlO2N1cnNvcjpwb2ludGVyO29wYWNpdHk6MH0uYW50LXNlbGVjdC10cmVlLWNoZWNrYm94LWNoZWNrZWQgLmFudC1zZWxlY3QtdHJlZS1jaGVja2JveC1pbm5lcjphZnRlcntwb3NpdGlvbjphYnNvbHV0ZTtkaXNwbGF5OnRhYmxlO2JvcmRlcjoycHggc29saWQgI2ZmZjtib3JkZXItdG9wOjA7Ym9yZGVyLWxlZnQ6MDt0cmFuc2Zvcm06cm90YXRlKDQ1ZGVnKSBzY2FsZSgxKSB0cmFuc2xhdGUoLTUwJSwtNTAlKTtvcGFjaXR5OjE7dHJhbnNpdGlvbjphbGwgLjJzIGN1YmljLWJlemllciguMTIsLjQsLjI5LDEuNDYpIC4xcztjb250ZW50OlwiIFwifS5hbnQtc2VsZWN0LXRyZWUtY2hlY2tib3gtY2hlY2tlZCAuYW50LXNlbGVjdC10cmVlLWNoZWNrYm94LWlubmVye2JhY2tncm91bmQtY29sb3I6IzE4OTBmZjtib3JkZXItY29sb3I6IzE4OTBmZn0uYW50LXNlbGVjdC10cmVlLWNoZWNrYm94LWRpc2FibGVke2N1cnNvcjpub3QtYWxsb3dlZH0uYW50LXNlbGVjdC10cmVlLWNoZWNrYm94LWRpc2FibGVkLmFudC1zZWxlY3QtdHJlZS1jaGVja2JveC1jaGVja2VkIC5hbnQtc2VsZWN0LXRyZWUtY2hlY2tib3gtaW5uZXI6YWZ0ZXJ7Ym9yZGVyLWNvbG9yOnJnYmEoMCwwLDAsLjI1KTthbmltYXRpb24tbmFtZTpub25lfS5hbnQtc2VsZWN0LXRyZWUtY2hlY2tib3gtZGlzYWJsZWQgLmFudC1zZWxlY3QtdHJlZS1jaGVja2JveC1pbnB1dHtjdXJzb3I6bm90LWFsbG93ZWQ7cG9pbnRlci1ldmVudHM6bm9uZX0uYW50LXNlbGVjdC10cmVlLWNoZWNrYm94LWRpc2FibGVkIC5hbnQtc2VsZWN0LXRyZWUtY2hlY2tib3gtaW5uZXJ7YmFja2dyb3VuZC1jb2xvcjojZjVmNWY1O2JvcmRlci1jb2xvcjojZDlkOWQ5IWltcG9ydGFudH0uYW50LXNlbGVjdC10cmVlLWNoZWNrYm94LWRpc2FibGVkIC5hbnQtc2VsZWN0LXRyZWUtY2hlY2tib3gtaW5uZXI6YWZ0ZXJ7Ym9yZGVyLWNvbG9yOiNmNWY1ZjU7Ym9yZGVyLWNvbGxhcHNlOnNlcGFyYXRlO2FuaW1hdGlvbi1uYW1lOm5vbmV9LmFudC1zZWxlY3QtdHJlZS1jaGVja2JveC1kaXNhYmxlZCtzcGFue2NvbG9yOnJnYmEoMCwwLDAsLjI1KTtjdXJzb3I6bm90LWFsbG93ZWR9LmFudC1zZWxlY3QtdHJlZS1jaGVja2JveC1kaXNhYmxlZDpob3ZlcjphZnRlciwuYW50LXNlbGVjdC10cmVlLWNoZWNrYm94LXdyYXBwZXI6aG92ZXIgLmFudC1zZWxlY3QtdHJlZS1jaGVja2JveC1kaXNhYmxlZDphZnRlcnt2aXNpYmlsaXR5OmhpZGRlbn0uYW50LXNlbGVjdC10cmVlLWNoZWNrYm94LXdyYXBwZXJ7Ym94LXNpemluZzpib3JkZXItYm94O21hcmdpbjowO3BhZGRpbmc6MDtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7Zm9udC1zaXplOjE0cHg7Zm9udC12YXJpYW50OnRhYnVsYXItbnVtcztsaW5lLWhlaWdodDoxLjU3MTU7bGlzdC1zdHlsZTpub25lO2ZvbnQtZmVhdHVyZS1zZXR0aW5nczpcInRudW1cIjtkaXNwbGF5OmlubGluZS1mbGV4O2FsaWduLWl0ZW1zOmJhc2VsaW5lO2xpbmUtaGVpZ2h0OnVuc2V0O2N1cnNvcjpwb2ludGVyfS5hbnQtc2VsZWN0LXRyZWUtY2hlY2tib3gtd3JhcHBlcjphZnRlcntkaXNwbGF5OmlubGluZS1ibG9jazt3aWR0aDowO292ZXJmbG93OmhpZGRlbjtjb250ZW50OlwiXFxhMFwifS5hbnQtc2VsZWN0LXRyZWUtY2hlY2tib3gtd3JhcHBlci5hbnQtc2VsZWN0LXRyZWUtY2hlY2tib3gtd3JhcHBlci1kaXNhYmxlZHtjdXJzb3I6bm90LWFsbG93ZWR9LmFudC1zZWxlY3QtdHJlZS1jaGVja2JveC13cmFwcGVyKy5hbnQtc2VsZWN0LXRyZWUtY2hlY2tib3gtd3JhcHBlcnttYXJnaW4tbGVmdDo4cHh9LmFudC1zZWxlY3QtdHJlZS1jaGVja2JveC13cmFwcGVyLmFudC1zZWxlY3QtdHJlZS1jaGVja2JveC13cmFwcGVyLWluLWZvcm0taXRlbSBpbnB1dFt0eXBlPWNoZWNrYm94XXt3aWR0aDoxNHB4O2hlaWdodDoxNHB4fS5hbnQtc2VsZWN0LXRyZWUtY2hlY2tib3grc3BhbntwYWRkaW5nLXJpZ2h0OjhweDtwYWRkaW5nLWxlZnQ6OHB4fS5hbnQtc2VsZWN0LXRyZWUtY2hlY2tib3gtZ3JvdXB7Ym94LXNpemluZzpib3JkZXItYm94O21hcmdpbjowO3BhZGRpbmc6MDtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7Zm9udC1zaXplOjE0cHg7Zm9udC12YXJpYW50OnRhYnVsYXItbnVtcztsaW5lLWhlaWdodDoxLjU3MTU7bGlzdC1zdHlsZTpub25lO2ZvbnQtZmVhdHVyZS1zZXR0aW5nczpcInRudW1cIjtkaXNwbGF5OmlubGluZS1ibG9ja30uYW50LXNlbGVjdC10cmVlLWNoZWNrYm94LWdyb3VwLWl0ZW17bWFyZ2luLXJpZ2h0OjhweH0uYW50LXNlbGVjdC10cmVlLWNoZWNrYm94LWdyb3VwLWl0ZW06bGFzdC1jaGlsZHttYXJnaW4tcmlnaHQ6MH0uYW50LXNlbGVjdC10cmVlLWNoZWNrYm94LWdyb3VwLWl0ZW0rLmFudC1zZWxlY3QtdHJlZS1jaGVja2JveC1ncm91cC1pdGVte21hcmdpbi1sZWZ0OjB9LmFudC1zZWxlY3QtdHJlZS1jaGVja2JveC1pbmRldGVybWluYXRlIC5hbnQtc2VsZWN0LXRyZWUtY2hlY2tib3gtaW5uZXJ7YmFja2dyb3VuZC1jb2xvcjojZmZmO2JvcmRlci1jb2xvcjojZDlkOWQ5fS5hbnQtc2VsZWN0LXRyZWUtY2hlY2tib3gtaW5kZXRlcm1pbmF0ZSAuYW50LXNlbGVjdC10cmVlLWNoZWNrYm94LWlubmVyOmFmdGVye3RvcDo1MCU7bGVmdDo1MCU7d2lkdGg6OHB4O2hlaWdodDo4cHg7YmFja2dyb3VuZC1jb2xvcjojMTg5MGZmO2JvcmRlcjowO3RyYW5zZm9ybTp0cmFuc2xhdGUoLTUwJSwtNTAlKSBzY2FsZSgxKTtvcGFjaXR5OjE7Y29udGVudDpcIiBcIn0uYW50LXNlbGVjdC10cmVlLWNoZWNrYm94LWluZGV0ZXJtaW5hdGUuYW50LXNlbGVjdC10cmVlLWNoZWNrYm94LWRpc2FibGVkIC5hbnQtc2VsZWN0LXRyZWUtY2hlY2tib3gtaW5uZXI6YWZ0ZXJ7YmFja2dyb3VuZC1jb2xvcjpyZ2JhKDAsMCwwLC4yNSk7Ym9yZGVyLWNvbG9yOnJnYmEoMCwwLDAsLjI1KX0uYW50LXRyZWUtc2VsZWN0LWRyb3Bkb3due3BhZGRpbmc6OHB4IDRweH0uYW50LXRyZWUtc2VsZWN0LWRyb3Bkb3duLXJ0bHtkaXJlY3Rpb246cnRsfS5hbnQtdHJlZS1zZWxlY3QtZHJvcGRvd24gLmFudC1zZWxlY3QtdHJlZXtib3JkZXItcmFkaXVzOjB9LmFudC10cmVlLXNlbGVjdC1kcm9wZG93biAuYW50LXNlbGVjdC10cmVlLWxpc3QtaG9sZGVyLWlubmVye2FsaWduLWl0ZW1zOnN0cmV0Y2h9LmFudC10cmVlLXNlbGVjdC1kcm9wZG93biAuYW50LXNlbGVjdC10cmVlLWxpc3QtaG9sZGVyLWlubmVyIC5hbnQtc2VsZWN0LXRyZWUtdHJlZW5vZGUgLmFudC1zZWxlY3QtdHJlZS1ub2RlLWNvbnRlbnQtd3JhcHBlcntmbGV4OmF1dG99LmFudC1zZWxlY3QtdHJlZXtib3gtc2l6aW5nOmJvcmRlci1ib3g7bWFyZ2luOjA7cGFkZGluZzowO2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtmb250LXNpemU6MTRweDtmb250LXZhcmlhbnQ6dGFidWxhci1udW1zO2xpbmUtaGVpZ2h0OjEuNTcxNTtsaXN0LXN0eWxlOm5vbmU7Zm9udC1mZWF0dXJlLXNldHRpbmdzOlwidG51bVwiO2JhY2tncm91bmQ6I2ZmZjtib3JkZXItcmFkaXVzOjJweDt0cmFuc2l0aW9uOmJhY2tncm91bmQtY29sb3IgLjNzfS5hbnQtc2VsZWN0LXRyZWUtZm9jdXNlZDpub3QoOmhvdmVyKTpub3QoLmFudC1zZWxlY3QtdHJlZS1hY3RpdmUtZm9jdXNlZCl7YmFja2dyb3VuZDojZTZmN2ZmfS5hbnQtc2VsZWN0LXRyZWUtbGlzdC1ob2xkZXItaW5uZXJ7YWxpZ24taXRlbXM6ZmxleC1zdGFydH0uYW50LXNlbGVjdC10cmVlLmFudC1zZWxlY3QtdHJlZS1ibG9jay1ub2RlIC5hbnQtc2VsZWN0LXRyZWUtbGlzdC1ob2xkZXItaW5uZXJ7YWxpZ24taXRlbXM6c3RyZXRjaH0uYW50LXNlbGVjdC10cmVlLmFudC1zZWxlY3QtdHJlZS1ibG9jay1ub2RlIC5hbnQtc2VsZWN0LXRyZWUtbGlzdC1ob2xkZXItaW5uZXIgLmFudC1zZWxlY3QtdHJlZS1ub2RlLWNvbnRlbnQtd3JhcHBlcntmbGV4OmF1dG99LmFudC1zZWxlY3QtdHJlZS5hbnQtc2VsZWN0LXRyZWUtYmxvY2stbm9kZSAuYW50LXNlbGVjdC10cmVlLWxpc3QtaG9sZGVyLWlubmVyIC5hbnQtc2VsZWN0LXRyZWUtdHJlZW5vZGUuZHJhZ2dpbmd7cG9zaXRpb246cmVsYXRpdmV9LmFudC1zZWxlY3QtdHJlZS5hbnQtc2VsZWN0LXRyZWUtYmxvY2stbm9kZSAuYW50LXNlbGVjdC10cmVlLWxpc3QtaG9sZGVyLWlubmVyIC5hbnQtc2VsZWN0LXRyZWUtdHJlZW5vZGUuZHJhZ2dpbmc6YWZ0ZXJ7cG9zaXRpb246YWJzb2x1dGU7dG9wOjA7cmlnaHQ6MDtib3R0b206NHB4O2xlZnQ6MDtib3JkZXI6MXB4IHNvbGlkICMxODkwZmY7b3BhY2l0eTowO2FuaW1hdGlvbjphbnQtdHJlZS1ub2RlLWZ4LWRvLW5vdC11c2UgLjNzO2FuaW1hdGlvbi1wbGF5LXN0YXRlOnJ1bm5pbmc7YW5pbWF0aW9uLWZpbGwtbW9kZTpmb3J3YXJkcztjb250ZW50OlwiXCI7cG9pbnRlci1ldmVudHM6bm9uZX0uYW50LXNlbGVjdC10cmVlIC5hbnQtc2VsZWN0LXRyZWUtdHJlZW5vZGV7ZGlzcGxheTpmbGV4O2FsaWduLWl0ZW1zOmZsZXgtc3RhcnQ7cGFkZGluZzowIDAgNHB4O291dGxpbmU6bm9uZX0uYW50LXNlbGVjdC10cmVlIC5hbnQtc2VsZWN0LXRyZWUtdHJlZW5vZGUtZGlzYWJsZWQgLmFudC1zZWxlY3QtdHJlZS1ub2RlLWNvbnRlbnQtd3JhcHBlcntjb2xvcjpyZ2JhKDAsMCwwLC4yNSk7Y3Vyc29yOm5vdC1hbGxvd2VkfS5hbnQtc2VsZWN0LXRyZWUgLmFudC1zZWxlY3QtdHJlZS10cmVlbm9kZS1kaXNhYmxlZCAuYW50LXNlbGVjdC10cmVlLW5vZGUtY29udGVudC13cmFwcGVyOmhvdmVye2JhY2tncm91bmQ6dHJhbnNwYXJlbnR9LmFudC1zZWxlY3QtdHJlZSAuYW50LXNlbGVjdC10cmVlLXRyZWVub2RlLWFjdGl2ZSAuYW50LXNlbGVjdC10cmVlLW5vZGUtY29udGVudC13cmFwcGVye2JhY2tncm91bmQ6I2Y1ZjVmNX0uYW50LXNlbGVjdC10cmVlIC5hbnQtc2VsZWN0LXRyZWUtdHJlZW5vZGU6bm90KC5hbnQtc2VsZWN0LXRyZWUgLmFudC1zZWxlY3QtdHJlZS10cmVlbm9kZS1kaXNhYmxlZCkuZmlsdGVyLW5vZGUgLmFudC1zZWxlY3QtdHJlZS10aXRsZXtjb2xvcjppbmhlcml0O2ZvbnQtd2VpZ2h0OjUwMH0uYW50LXNlbGVjdC10cmVlIC5hbnQtc2VsZWN0LXRyZWUtdHJlZW5vZGUtZHJhZ2dhYmxlIC5hbnQtc2VsZWN0LXRyZWUtZHJhZ2dhYmxlLWljb257d2lkdGg6MjRweDtsaW5lLWhlaWdodDoyNHB4O3RleHQtYWxpZ246Y2VudGVyO3Zpc2liaWxpdHk6dmlzaWJsZTtvcGFjaXR5Oi4yO3RyYW5zaXRpb246b3BhY2l0eSAuM3N9LmFudC1zZWxlY3QtdHJlZS10cmVlbm9kZTpob3ZlciAuYW50LXNlbGVjdC10cmVlIC5hbnQtc2VsZWN0LXRyZWUtdHJlZW5vZGUtZHJhZ2dhYmxlIC5hbnQtc2VsZWN0LXRyZWUtZHJhZ2dhYmxlLWljb257b3BhY2l0eTouNDV9LmFudC1zZWxlY3QtdHJlZSAuYW50LXNlbGVjdC10cmVlLXRyZWVub2RlLWRyYWdnYWJsZS5hbnQtc2VsZWN0LXRyZWUtdHJlZW5vZGUtZGlzYWJsZWQgLmFudC1zZWxlY3QtdHJlZS1kcmFnZ2FibGUtaWNvbnt2aXNpYmlsaXR5OmhpZGRlbn0uYW50LXNlbGVjdC10cmVlLWluZGVudHthbGlnbi1zZWxmOnN0cmV0Y2g7d2hpdGUtc3BhY2U6bm93cmFwOy13ZWJraXQtdXNlci1zZWxlY3Q6bm9uZTstbW96LXVzZXItc2VsZWN0Om5vbmU7LW1zLXVzZXItc2VsZWN0Om5vbmU7dXNlci1zZWxlY3Q6bm9uZX0uYW50LXNlbGVjdC10cmVlLWluZGVudC11bml0e2Rpc3BsYXk6aW5saW5lLWJsb2NrO3dpZHRoOjI0cHh9LmFudC1zZWxlY3QtdHJlZS1kcmFnZ2FibGUtaWNvbnt2aXNpYmlsaXR5OmhpZGRlbn0uYW50LXNlbGVjdC10cmVlLXN3aXRjaGVye3Bvc2l0aW9uOnJlbGF0aXZlO2ZsZXg6bm9uZTthbGlnbi1zZWxmOnN0cmV0Y2g7d2lkdGg6MjRweDttYXJnaW46MDtsaW5lLWhlaWdodDoyNHB4O3RleHQtYWxpZ246Y2VudGVyO2N1cnNvcjpwb2ludGVyOy13ZWJraXQtdXNlci1zZWxlY3Q6bm9uZTstbW96LXVzZXItc2VsZWN0Om5vbmU7LW1zLXVzZXItc2VsZWN0Om5vbmU7dXNlci1zZWxlY3Q6bm9uZX0uYW50LXNlbGVjdC10cmVlLXN3aXRjaGVyIC5hbnQtc2VsZWN0LXRyZWUtc3dpdGNoZXItaWNvbiwuYW50LXNlbGVjdC10cmVlLXN3aXRjaGVyIC5hbnQtdHJlZS1zd2l0Y2hlci1pY29ue2Rpc3BsYXk6aW5saW5lLWJsb2NrO2ZvbnQtc2l6ZToxMHB4O3ZlcnRpY2FsLWFsaWduOmJhc2VsaW5lfS5hbnQtc2VsZWN0LXRyZWUtc3dpdGNoZXIgLmFudC1zZWxlY3QtdHJlZS1zd2l0Y2hlci1pY29uIHN2ZywuYW50LXNlbGVjdC10cmVlLXN3aXRjaGVyIC5hbnQtdHJlZS1zd2l0Y2hlci1pY29uIHN2Z3t0cmFuc2l0aW9uOnRyYW5zZm9ybSAuM3N9LmFudC1zZWxlY3QtdHJlZS1zd2l0Y2hlci1ub29we2N1cnNvcjpkZWZhdWx0fS5hbnQtc2VsZWN0LXRyZWUtc3dpdGNoZXJfY2xvc2UgLmFudC1zZWxlY3QtdHJlZS1zd2l0Y2hlci1pY29uIHN2Z3t0cmFuc2Zvcm06cm90YXRlKC05MGRlZyl9LmFudC1zZWxlY3QtdHJlZS1zd2l0Y2hlci1sb2FkaW5nLWljb257Y29sb3I6IzE4OTBmZn0uYW50LXNlbGVjdC10cmVlLXN3aXRjaGVyLWxlYWYtbGluZXtwb3NpdGlvbjpyZWxhdGl2ZTt6LWluZGV4OjE7ZGlzcGxheTppbmxpbmUtYmxvY2s7d2lkdGg6MTAwJTtoZWlnaHQ6MTAwJX0uYW50LXNlbGVjdC10cmVlLXN3aXRjaGVyLWxlYWYtbGluZTpiZWZvcmV7cG9zaXRpb246YWJzb2x1dGU7dG9wOjA7cmlnaHQ6MTJweDtib3R0b206LTRweDttYXJnaW4tbGVmdDotMXB4O2JvcmRlci1yaWdodDoxcHggc29saWQgI2Q5ZDlkOTtjb250ZW50OlwiIFwifS5hbnQtc2VsZWN0LXRyZWUtc3dpdGNoZXItbGVhZi1saW5lOmFmdGVye3Bvc2l0aW9uOmFic29sdXRlO3dpZHRoOjEwcHg7aGVpZ2h0OjE0cHg7Ym9yZGVyLWJvdHRvbToxcHggc29saWQgI2Q5ZDlkOTtjb250ZW50OlwiIFwifS5hbnQtc2VsZWN0LXRyZWUtY2hlY2tib3h7dG9wOmF1dG87bWFyZ2luOjRweCA4cHggMCAwfS5hbnQtc2VsZWN0LXRyZWUgLmFudC1zZWxlY3QtdHJlZS1ub2RlLWNvbnRlbnQtd3JhcHBlcntwb3NpdGlvbjpyZWxhdGl2ZTt6LWluZGV4OmF1dG87bWluLWhlaWdodDoyNHB4O21hcmdpbjowO3BhZGRpbmc6MCA0cHg7Y29sb3I6aW5oZXJpdDtsaW5lLWhlaWdodDoyNHB4O2JhY2tncm91bmQ6dHJhbnNwYXJlbnQ7Ym9yZGVyLXJhZGl1czoycHg7Y3Vyc29yOnBvaW50ZXI7dHJhbnNpdGlvbjphbGwgLjNzLGJvcmRlciAwcyxsaW5lLWhlaWdodCAwcyxib3gtc2hhZG93IDBzfS5hbnQtc2VsZWN0LXRyZWUgLmFudC1zZWxlY3QtdHJlZS1ub2RlLWNvbnRlbnQtd3JhcHBlcjpob3ZlcntiYWNrZ3JvdW5kLWNvbG9yOiNmNWY1ZjV9LmFudC1zZWxlY3QtdHJlZSAuYW50LXNlbGVjdC10cmVlLW5vZGUtY29udGVudC13cmFwcGVyLmFudC1zZWxlY3QtdHJlZS1ub2RlLXNlbGVjdGVke2JhY2tncm91bmQtY29sb3I6I2JhZTdmZn0uYW50LXNlbGVjdC10cmVlIC5hbnQtc2VsZWN0LXRyZWUtbm9kZS1jb250ZW50LXdyYXBwZXIgLmFudC1zZWxlY3QtdHJlZS1pY29uRWxle2Rpc3BsYXk6aW5saW5lLWJsb2NrO3dpZHRoOjI0cHg7aGVpZ2h0OjI0cHg7bGluZS1oZWlnaHQ6MjRweDt0ZXh0LWFsaWduOmNlbnRlcjt2ZXJ0aWNhbC1hbGlnbjp0b3B9LmFudC1zZWxlY3QtdHJlZSAuYW50LXNlbGVjdC10cmVlLW5vZGUtY29udGVudC13cmFwcGVyIC5hbnQtc2VsZWN0LXRyZWUtaWNvbkVsZTplbXB0eXtkaXNwbGF5Om5vbmV9LmFudC1zZWxlY3QtdHJlZS11bnNlbGVjdGFibGUgLmFudC1zZWxlY3QtdHJlZS1ub2RlLWNvbnRlbnQtd3JhcHBlcjpob3ZlcntiYWNrZ3JvdW5kLWNvbG9yOnRyYW5zcGFyZW50fS5hbnQtc2VsZWN0LXRyZWUtbm9kZS1jb250ZW50LXdyYXBwZXJ7bGluZS1oZWlnaHQ6MjRweDstd2Via2l0LXVzZXItc2VsZWN0Om5vbmU7LW1vei11c2VyLXNlbGVjdDpub25lOy1tcy11c2VyLXNlbGVjdDpub25lO3VzZXItc2VsZWN0Om5vbmV9LmFudC1zZWxlY3QtdHJlZS1ub2RlLWNvbnRlbnQtd3JhcHBlciAuYW50LXRyZWUtZHJvcC1pbmRpY2F0b3J7cG9zaXRpb246YWJzb2x1dGU7ei1pbmRleDoxO2hlaWdodDoycHg7YmFja2dyb3VuZC1jb2xvcjojMTg5MGZmO2JvcmRlci1yYWRpdXM6MXB4O3BvaW50ZXItZXZlbnRzOm5vbmV9LmFudC1zZWxlY3QtdHJlZS1ub2RlLWNvbnRlbnQtd3JhcHBlciAuYW50LXRyZWUtZHJvcC1pbmRpY2F0b3I6YWZ0ZXJ7cG9zaXRpb246YWJzb2x1dGU7dG9wOi0zcHg7bGVmdDotNnB4O3dpZHRoOjhweDtoZWlnaHQ6OHB4O2JhY2tncm91bmQtY29sb3I6dHJhbnNwYXJlbnQ7Ym9yZGVyOjJweCBzb2xpZCAjMTg5MGZmO2JvcmRlci1yYWRpdXM6NTAlO2NvbnRlbnQ6XCJcIn0uYW50LXNlbGVjdC10cmVlIC5hbnQtc2VsZWN0LXRyZWUtdHJlZW5vZGUuZHJvcC1jb250YWluZXI+W2RyYWdnYWJsZV17Ym94LXNoYWRvdzowIDAgMCAycHggIzE4OTBmZn0uYW50LXNlbGVjdC10cmVlLXNob3ctbGluZSAuYW50LXNlbGVjdC10cmVlLWluZGVudC11bml0e3Bvc2l0aW9uOnJlbGF0aXZlO2hlaWdodDoxMDAlfS5hbnQtc2VsZWN0LXRyZWUtc2hvdy1saW5lIC5hbnQtc2VsZWN0LXRyZWUtaW5kZW50LXVuaXQ6YmVmb3Jle3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO3JpZ2h0OjEycHg7Ym90dG9tOi00cHg7Ym9yZGVyLXJpZ2h0OjFweCBzb2xpZCAjZDlkOWQ5O2NvbnRlbnQ6XCJcIn0uYW50LXNlbGVjdC10cmVlLXNob3ctbGluZSAuYW50LXNlbGVjdC10cmVlLWluZGVudC11bml0LWVuZDpiZWZvcmV7ZGlzcGxheTpub25lfS5hbnQtc2VsZWN0LXRyZWUtc2hvdy1saW5lIC5hbnQtc2VsZWN0LXRyZWUtc3dpdGNoZXJ7YmFja2dyb3VuZDojZmZmfS5hbnQtc2VsZWN0LXRyZWUtc2hvdy1saW5lIC5hbnQtc2VsZWN0LXRyZWUtc3dpdGNoZXItbGluZS1pY29ue3ZlcnRpY2FsLWFsaWduOi0uMTVlbX0uYW50LXNlbGVjdC10cmVlIC5hbnQtc2VsZWN0LXRyZWUtdHJlZW5vZGUtbGVhZi1sYXN0IC5hbnQtc2VsZWN0LXRyZWUtc3dpdGNoZXItbGVhZi1saW5lOmJlZm9yZXt0b3A6YXV0byFpbXBvcnRhbnQ7Ym90dG9tOmF1dG8haW1wb3J0YW50O2hlaWdodDoxNHB4IWltcG9ydGFudH0uYW50LXRyZWUtc2VsZWN0LWRyb3Bkb3duLXJ0bCAuYW50LXNlbGVjdC10cmVlIC5hbnQtc2VsZWN0LXRyZWUtc3dpdGNoZXJfY2xvc2UgLmFudC1zZWxlY3QtdHJlZS1zd2l0Y2hlci1pY29uIHN2Z3t0cmFuc2Zvcm06cm90YXRlKDkwZGVnKX0uYW50LXRyZWUtc2VsZWN0LWRyb3Bkb3duLXJ0bCAuYW50LXNlbGVjdC10cmVlIC5hbnQtc2VsZWN0LXRyZWUtc3dpdGNoZXItbG9hZGluZy1pY29ue3RyYW5zZm9ybTpzY2FsZVkoLTEpfUBrZXlmcmFtZXMgYW50Q2hlY2tib3hFZmZlY3R7MCV7dHJhbnNmb3JtOnNjYWxlKDEpO29wYWNpdHk6LjV9dG97dHJhbnNmb3JtOnNjYWxlKDEuNik7b3BhY2l0eTowfX1Aa2V5ZnJhbWVzIGFudC10cmVlLW5vZGUtZngtZG8tbm90LXVzZXswJXtvcGFjaXR5OjB9dG97b3BhY2l0eToxfX0uYW50LXRyZWUuYW50LXRyZWUtZGlyZWN0b3J5IC5hbnQtdHJlZS10cmVlbm9kZXtwb3NpdGlvbjpyZWxhdGl2ZX0uYW50LXRyZWUuYW50LXRyZWUtZGlyZWN0b3J5IC5hbnQtdHJlZS10cmVlbm9kZTpiZWZvcmV7cG9zaXRpb246YWJzb2x1dGU7dG9wOjA7cmlnaHQ6MDtib3R0b206NHB4O2xlZnQ6MDt0cmFuc2l0aW9uOmJhY2tncm91bmQtY29sb3IgLjNzO2NvbnRlbnQ6XCJcIjtwb2ludGVyLWV2ZW50czpub25lfS5hbnQtdHJlZS5hbnQtdHJlZS1kaXJlY3RvcnkgLmFudC10cmVlLXRyZWVub2RlOmhvdmVyOmJlZm9yZXtiYWNrZ3JvdW5kOiNmNWY1ZjV9LmFudC10cmVlLmFudC10cmVlLWRpcmVjdG9yeSAuYW50LXRyZWUtdHJlZW5vZGU+Knt6LWluZGV4OjF9LmFudC10cmVlLmFudC10cmVlLWRpcmVjdG9yeSAuYW50LXRyZWUtdHJlZW5vZGUgLmFudC10cmVlLXN3aXRjaGVye3RyYW5zaXRpb246Y29sb3IgLjNzfS5hbnQtdHJlZS5hbnQtdHJlZS1kaXJlY3RvcnkgLmFudC10cmVlLXRyZWVub2RlIC5hbnQtdHJlZS1ub2RlLWNvbnRlbnQtd3JhcHBlcntib3JkZXItcmFkaXVzOjA7LXdlYmtpdC11c2VyLXNlbGVjdDpub25lOy1tb3otdXNlci1zZWxlY3Q6bm9uZTstbXMtdXNlci1zZWxlY3Q6bm9uZTt1c2VyLXNlbGVjdDpub25lfS5hbnQtdHJlZS5hbnQtdHJlZS1kaXJlY3RvcnkgLmFudC10cmVlLXRyZWVub2RlIC5hbnQtdHJlZS1ub2RlLWNvbnRlbnQtd3JhcHBlcjpob3ZlcntiYWNrZ3JvdW5kOnRyYW5zcGFyZW50fS5hbnQtdHJlZS5hbnQtdHJlZS1kaXJlY3RvcnkgLmFudC10cmVlLXRyZWVub2RlIC5hbnQtdHJlZS1ub2RlLWNvbnRlbnQtd3JhcHBlci5hbnQtdHJlZS1ub2RlLXNlbGVjdGVke2NvbG9yOiNmZmY7YmFja2dyb3VuZDp0cmFuc3BhcmVudH0uYW50LXRyZWUuYW50LXRyZWUtZGlyZWN0b3J5IC5hbnQtdHJlZS10cmVlbm9kZS1zZWxlY3RlZDpiZWZvcmUsLmFudC10cmVlLmFudC10cmVlLWRpcmVjdG9yeSAuYW50LXRyZWUtdHJlZW5vZGUtc2VsZWN0ZWQ6aG92ZXI6YmVmb3Jle2JhY2tncm91bmQ6IzE4OTBmZn0uYW50LXRyZWUuYW50LXRyZWUtZGlyZWN0b3J5IC5hbnQtdHJlZS10cmVlbm9kZS1zZWxlY3RlZCAuYW50LXRyZWUtc3dpdGNoZXJ7Y29sb3I6I2ZmZn0uYW50LXRyZWUuYW50LXRyZWUtZGlyZWN0b3J5IC5hbnQtdHJlZS10cmVlbm9kZS1zZWxlY3RlZCAuYW50LXRyZWUtbm9kZS1jb250ZW50LXdyYXBwZXJ7Y29sb3I6I2ZmZjtiYWNrZ3JvdW5kOnRyYW5zcGFyZW50fS5hbnQtdHJlZS1jaGVja2JveHtib3gtc2l6aW5nOmJvcmRlci1ib3g7bWFyZ2luOjA7cGFkZGluZzowO2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtmb250LXNpemU6MTRweDtmb250LXZhcmlhbnQ6dGFidWxhci1udW1zO2xpbmUtaGVpZ2h0OjEuNTcxNTtsaXN0LXN0eWxlOm5vbmU7Zm9udC1mZWF0dXJlLXNldHRpbmdzOlwidG51bVwiO3Bvc2l0aW9uOnJlbGF0aXZlO3RvcDouMmVtO2xpbmUtaGVpZ2h0OjE7d2hpdGUtc3BhY2U6bm93cmFwO291dGxpbmU6bm9uZTtjdXJzb3I6cG9pbnRlcn0uYW50LXRyZWUtY2hlY2tib3gtaW5wdXQ6Zm9jdXMrLmFudC10cmVlLWNoZWNrYm94LWlubmVyLC5hbnQtdHJlZS1jaGVja2JveC13cmFwcGVyOmhvdmVyIC5hbnQtdHJlZS1jaGVja2JveC1pbm5lciwuYW50LXRyZWUtY2hlY2tib3g6aG92ZXIgLmFudC10cmVlLWNoZWNrYm94LWlubmVye2JvcmRlci1jb2xvcjojMTg5MGZmfS5hbnQtdHJlZS1jaGVja2JveC1jaGVja2VkOmFmdGVye3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO2xlZnQ6MDt3aWR0aDoxMDAlO2hlaWdodDoxMDAlO2JvcmRlcjoxcHggc29saWQgIzE4OTBmZjtib3JkZXItcmFkaXVzOjJweDt2aXNpYmlsaXR5OmhpZGRlbjthbmltYXRpb246YW50Q2hlY2tib3hFZmZlY3QgLjM2cyBlYXNlLWluLW91dDthbmltYXRpb24tZmlsbC1tb2RlOmJhY2t3YXJkcztjb250ZW50OlwiXCJ9LmFudC10cmVlLWNoZWNrYm94LXdyYXBwZXI6aG92ZXIgLmFudC10cmVlLWNoZWNrYm94OmFmdGVyLC5hbnQtdHJlZS1jaGVja2JveDpob3ZlcjphZnRlcnt2aXNpYmlsaXR5OnZpc2libGV9LmFudC10cmVlLWNoZWNrYm94LWlubmVye3Bvc2l0aW9uOnJlbGF0aXZlO3RvcDowO2xlZnQ6MDtkaXNwbGF5OmJsb2NrO3dpZHRoOjE2cHg7aGVpZ2h0OjE2cHg7ZGlyZWN0aW9uOmx0cjtiYWNrZ3JvdW5kLWNvbG9yOiNmZmY7Ym9yZGVyOjFweCBzb2xpZCAjZDlkOWQ5O2JvcmRlci1yYWRpdXM6MnB4O2JvcmRlci1jb2xsYXBzZTpzZXBhcmF0ZTt0cmFuc2l0aW9uOmFsbCAuM3N9LmFudC10cmVlLWNoZWNrYm94LWlubmVyOmFmdGVye3Bvc2l0aW9uOmFic29sdXRlO3RvcDo1MCU7bGVmdDoyMS41JTtkaXNwbGF5OnRhYmxlO3dpZHRoOjUuNzE0Mjg1NzFweDtoZWlnaHQ6OS4xNDI4NTcxNHB4O2JvcmRlcjoycHggc29saWQgI2ZmZjtib3JkZXItdG9wOjA7Ym9yZGVyLWxlZnQ6MDt0cmFuc2Zvcm06cm90YXRlKDQ1ZGVnKSBzY2FsZSgwKSB0cmFuc2xhdGUoLTUwJSwtNTAlKTtvcGFjaXR5OjA7dHJhbnNpdGlvbjphbGwgLjFzIGN1YmljLWJlemllciguNzEsLS40NiwuODgsLjYpLG9wYWNpdHkgLjFzO2NvbnRlbnQ6XCIgXCJ9LmFudC10cmVlLWNoZWNrYm94LWlucHV0e3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO3JpZ2h0OjA7Ym90dG9tOjA7bGVmdDowO3otaW5kZXg6MTt3aWR0aDoxMDAlO2hlaWdodDoxMDAlO2N1cnNvcjpwb2ludGVyO29wYWNpdHk6MH0uYW50LXRyZWUtY2hlY2tib3gtY2hlY2tlZCAuYW50LXRyZWUtY2hlY2tib3gtaW5uZXI6YWZ0ZXJ7cG9zaXRpb246YWJzb2x1dGU7ZGlzcGxheTp0YWJsZTtib3JkZXI6MnB4IHNvbGlkICNmZmY7Ym9yZGVyLXRvcDowO2JvcmRlci1sZWZ0OjA7dHJhbnNmb3JtOnJvdGF0ZSg0NWRlZykgc2NhbGUoMSkgdHJhbnNsYXRlKC01MCUsLTUwJSk7b3BhY2l0eToxO3RyYW5zaXRpb246YWxsIC4ycyBjdWJpYy1iZXppZXIoLjEyLC40LC4yOSwxLjQ2KSAuMXM7Y29udGVudDpcIiBcIn0uYW50LXRyZWUtY2hlY2tib3gtY2hlY2tlZCAuYW50LXRyZWUtY2hlY2tib3gtaW5uZXJ7YmFja2dyb3VuZC1jb2xvcjojMTg5MGZmO2JvcmRlci1jb2xvcjojMTg5MGZmfS5hbnQtdHJlZS1jaGVja2JveC1kaXNhYmxlZHtjdXJzb3I6bm90LWFsbG93ZWR9LmFudC10cmVlLWNoZWNrYm94LWRpc2FibGVkLmFudC10cmVlLWNoZWNrYm94LWNoZWNrZWQgLmFudC10cmVlLWNoZWNrYm94LWlubmVyOmFmdGVye2JvcmRlci1jb2xvcjpyZ2JhKDAsMCwwLC4yNSk7YW5pbWF0aW9uLW5hbWU6bm9uZX0uYW50LXRyZWUtY2hlY2tib3gtZGlzYWJsZWQgLmFudC10cmVlLWNoZWNrYm94LWlucHV0e2N1cnNvcjpub3QtYWxsb3dlZDtwb2ludGVyLWV2ZW50czpub25lfS5hbnQtdHJlZS1jaGVja2JveC1kaXNhYmxlZCAuYW50LXRyZWUtY2hlY2tib3gtaW5uZXJ7YmFja2dyb3VuZC1jb2xvcjojZjVmNWY1O2JvcmRlci1jb2xvcjojZDlkOWQ5IWltcG9ydGFudH0uYW50LXRyZWUtY2hlY2tib3gtZGlzYWJsZWQgLmFudC10cmVlLWNoZWNrYm94LWlubmVyOmFmdGVye2JvcmRlci1jb2xvcjojZjVmNWY1O2JvcmRlci1jb2xsYXBzZTpzZXBhcmF0ZTthbmltYXRpb24tbmFtZTpub25lfS5hbnQtdHJlZS1jaGVja2JveC1kaXNhYmxlZCtzcGFue2NvbG9yOnJnYmEoMCwwLDAsLjI1KTtjdXJzb3I6bm90LWFsbG93ZWR9LmFudC10cmVlLWNoZWNrYm94LWRpc2FibGVkOmhvdmVyOmFmdGVyLC5hbnQtdHJlZS1jaGVja2JveC13cmFwcGVyOmhvdmVyIC5hbnQtdHJlZS1jaGVja2JveC1kaXNhYmxlZDphZnRlcnt2aXNpYmlsaXR5OmhpZGRlbn0uYW50LXRyZWUtY2hlY2tib3gtd3JhcHBlcntib3gtc2l6aW5nOmJvcmRlci1ib3g7bWFyZ2luOjA7cGFkZGluZzowO2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtmb250LXNpemU6MTRweDtmb250LXZhcmlhbnQ6dGFidWxhci1udW1zO2xpbmUtaGVpZ2h0OjEuNTcxNTtsaXN0LXN0eWxlOm5vbmU7Zm9udC1mZWF0dXJlLXNldHRpbmdzOlwidG51bVwiO2Rpc3BsYXk6aW5saW5lLWZsZXg7YWxpZ24taXRlbXM6YmFzZWxpbmU7bGluZS1oZWlnaHQ6dW5zZXQ7Y3Vyc29yOnBvaW50ZXJ9LmFudC10cmVlLWNoZWNrYm94LXdyYXBwZXI6YWZ0ZXJ7ZGlzcGxheTppbmxpbmUtYmxvY2s7d2lkdGg6MDtvdmVyZmxvdzpoaWRkZW47Y29udGVudDpcIlxcYTBcIn0uYW50LXRyZWUtY2hlY2tib3gtd3JhcHBlci5hbnQtdHJlZS1jaGVja2JveC13cmFwcGVyLWRpc2FibGVke2N1cnNvcjpub3QtYWxsb3dlZH0uYW50LXRyZWUtY2hlY2tib3gtd3JhcHBlcisuYW50LXRyZWUtY2hlY2tib3gtd3JhcHBlcnttYXJnaW4tbGVmdDo4cHh9LmFudC10cmVlLWNoZWNrYm94LXdyYXBwZXIuYW50LXRyZWUtY2hlY2tib3gtd3JhcHBlci1pbi1mb3JtLWl0ZW0gaW5wdXRbdHlwZT1jaGVja2JveF17d2lkdGg6MTRweDtoZWlnaHQ6MTRweH0uYW50LXRyZWUtY2hlY2tib3grc3BhbntwYWRkaW5nLXJpZ2h0OjhweDtwYWRkaW5nLWxlZnQ6OHB4fS5hbnQtdHJlZS1jaGVja2JveC1ncm91cHtib3gtc2l6aW5nOmJvcmRlci1ib3g7bWFyZ2luOjA7cGFkZGluZzowO2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtmb250LXNpemU6MTRweDtmb250LXZhcmlhbnQ6dGFidWxhci1udW1zO2xpbmUtaGVpZ2h0OjEuNTcxNTtsaXN0LXN0eWxlOm5vbmU7Zm9udC1mZWF0dXJlLXNldHRpbmdzOlwidG51bVwiO2Rpc3BsYXk6aW5saW5lLWJsb2NrfS5hbnQtdHJlZS1jaGVja2JveC1ncm91cC1pdGVte21hcmdpbi1yaWdodDo4cHh9LmFudC10cmVlLWNoZWNrYm94LWdyb3VwLWl0ZW06bGFzdC1jaGlsZHttYXJnaW4tcmlnaHQ6MH0uYW50LXRyZWUtY2hlY2tib3gtZ3JvdXAtaXRlbSsuYW50LXRyZWUtY2hlY2tib3gtZ3JvdXAtaXRlbXttYXJnaW4tbGVmdDowfS5hbnQtdHJlZS1jaGVja2JveC1pbmRldGVybWluYXRlIC5hbnQtdHJlZS1jaGVja2JveC1pbm5lcntiYWNrZ3JvdW5kLWNvbG9yOiNmZmY7Ym9yZGVyLWNvbG9yOiNkOWQ5ZDl9LmFudC10cmVlLWNoZWNrYm94LWluZGV0ZXJtaW5hdGUgLmFudC10cmVlLWNoZWNrYm94LWlubmVyOmFmdGVye3RvcDo1MCU7bGVmdDo1MCU7d2lkdGg6OHB4O2hlaWdodDo4cHg7YmFja2dyb3VuZC1jb2xvcjojMTg5MGZmO2JvcmRlcjowO3RyYW5zZm9ybTp0cmFuc2xhdGUoLTUwJSwtNTAlKSBzY2FsZSgxKTtvcGFjaXR5OjE7Y29udGVudDpcIiBcIn0uYW50LXRyZWUtY2hlY2tib3gtaW5kZXRlcm1pbmF0ZS5hbnQtdHJlZS1jaGVja2JveC1kaXNhYmxlZCAuYW50LXRyZWUtY2hlY2tib3gtaW5uZXI6YWZ0ZXJ7YmFja2dyb3VuZC1jb2xvcjpyZ2JhKDAsMCwwLC4yNSk7Ym9yZGVyLWNvbG9yOnJnYmEoMCwwLDAsLjI1KX0uYW50LXRyZWV7Ym94LXNpemluZzpib3JkZXItYm94O21hcmdpbjowO3BhZGRpbmc6MDtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7Zm9udC1zaXplOjE0cHg7Zm9udC12YXJpYW50OnRhYnVsYXItbnVtcztsaW5lLWhlaWdodDoxLjU3MTU7bGlzdC1zdHlsZTpub25lO2ZvbnQtZmVhdHVyZS1zZXR0aW5nczpcInRudW1cIjtiYWNrZ3JvdW5kOiNmZmY7Ym9yZGVyLXJhZGl1czoycHg7dHJhbnNpdGlvbjpiYWNrZ3JvdW5kLWNvbG9yIC4zc30uYW50LXRyZWUtZm9jdXNlZDpub3QoOmhvdmVyKTpub3QoLmFudC10cmVlLWFjdGl2ZS1mb2N1c2VkKXtiYWNrZ3JvdW5kOiNlNmY3ZmZ9LmFudC10cmVlLWxpc3QtaG9sZGVyLWlubmVye2FsaWduLWl0ZW1zOmZsZXgtc3RhcnR9LmFudC10cmVlLmFudC10cmVlLWJsb2NrLW5vZGUgLmFudC10cmVlLWxpc3QtaG9sZGVyLWlubmVye2FsaWduLWl0ZW1zOnN0cmV0Y2h9LmFudC10cmVlLmFudC10cmVlLWJsb2NrLW5vZGUgLmFudC10cmVlLWxpc3QtaG9sZGVyLWlubmVyIC5hbnQtdHJlZS1ub2RlLWNvbnRlbnQtd3JhcHBlcntmbGV4OmF1dG99LmFudC10cmVlLmFudC10cmVlLWJsb2NrLW5vZGUgLmFudC10cmVlLWxpc3QtaG9sZGVyLWlubmVyIC5hbnQtdHJlZS10cmVlbm9kZS5kcmFnZ2luZ3twb3NpdGlvbjpyZWxhdGl2ZX0uYW50LXRyZWUuYW50LXRyZWUtYmxvY2stbm9kZSAuYW50LXRyZWUtbGlzdC1ob2xkZXItaW5uZXIgLmFudC10cmVlLXRyZWVub2RlLmRyYWdnaW5nOmFmdGVye3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO3JpZ2h0OjA7Ym90dG9tOjRweDtsZWZ0OjA7Ym9yZGVyOjFweCBzb2xpZCAjMTg5MGZmO29wYWNpdHk6MDthbmltYXRpb246YW50LXRyZWUtbm9kZS1meC1kby1ub3QtdXNlIC4zczthbmltYXRpb24tcGxheS1zdGF0ZTpydW5uaW5nO2FuaW1hdGlvbi1maWxsLW1vZGU6Zm9yd2FyZHM7Y29udGVudDpcIlwiO3BvaW50ZXItZXZlbnRzOm5vbmV9LmFudC10cmVlIC5hbnQtdHJlZS10cmVlbm9kZXtkaXNwbGF5OmZsZXg7YWxpZ24taXRlbXM6ZmxleC1zdGFydDtwYWRkaW5nOjAgMCA0cHg7b3V0bGluZTpub25lfS5hbnQtdHJlZSAuYW50LXRyZWUtdHJlZW5vZGUtZGlzYWJsZWQgLmFudC10cmVlLW5vZGUtY29udGVudC13cmFwcGVye2NvbG9yOnJnYmEoMCwwLDAsLjI1KTtjdXJzb3I6bm90LWFsbG93ZWR9LmFudC10cmVlIC5hbnQtdHJlZS10cmVlbm9kZS1kaXNhYmxlZCAuYW50LXRyZWUtbm9kZS1jb250ZW50LXdyYXBwZXI6aG92ZXJ7YmFja2dyb3VuZDp0cmFuc3BhcmVudH0uYW50LXRyZWUgLmFudC10cmVlLXRyZWVub2RlLWFjdGl2ZSAuYW50LXRyZWUtbm9kZS1jb250ZW50LXdyYXBwZXJ7YmFja2dyb3VuZDojZjVmNWY1fS5hbnQtdHJlZSAuYW50LXRyZWUtdHJlZW5vZGU6bm90KC5hbnQtdHJlZSAuYW50LXRyZWUtdHJlZW5vZGUtZGlzYWJsZWQpLmZpbHRlci1ub2RlIC5hbnQtdHJlZS10aXRsZXtjb2xvcjppbmhlcml0O2ZvbnQtd2VpZ2h0OjUwMH0uYW50LXRyZWUgLmFudC10cmVlLXRyZWVub2RlLWRyYWdnYWJsZSAuYW50LXRyZWUtZHJhZ2dhYmxlLWljb257d2lkdGg6MjRweDtsaW5lLWhlaWdodDoyNHB4O3RleHQtYWxpZ246Y2VudGVyO3Zpc2liaWxpdHk6dmlzaWJsZTtvcGFjaXR5Oi4yO3RyYW5zaXRpb246b3BhY2l0eSAuM3N9LmFudC10cmVlLXRyZWVub2RlOmhvdmVyIC5hbnQtdHJlZSAuYW50LXRyZWUtdHJlZW5vZGUtZHJhZ2dhYmxlIC5hbnQtdHJlZS1kcmFnZ2FibGUtaWNvbntvcGFjaXR5Oi40NX0uYW50LXRyZWUgLmFudC10cmVlLXRyZWVub2RlLWRyYWdnYWJsZS5hbnQtdHJlZS10cmVlbm9kZS1kaXNhYmxlZCAuYW50LXRyZWUtZHJhZ2dhYmxlLWljb257dmlzaWJpbGl0eTpoaWRkZW59LmFudC10cmVlLWluZGVudHthbGlnbi1zZWxmOnN0cmV0Y2g7d2hpdGUtc3BhY2U6bm93cmFwOy13ZWJraXQtdXNlci1zZWxlY3Q6bm9uZTstbW96LXVzZXItc2VsZWN0Om5vbmU7LW1zLXVzZXItc2VsZWN0Om5vbmU7dXNlci1zZWxlY3Q6bm9uZX0uYW50LXRyZWUtaW5kZW50LXVuaXR7ZGlzcGxheTppbmxpbmUtYmxvY2s7d2lkdGg6MjRweH0uYW50LXRyZWUtZHJhZ2dhYmxlLWljb257dmlzaWJpbGl0eTpoaWRkZW59LmFudC10cmVlLXN3aXRjaGVye3Bvc2l0aW9uOnJlbGF0aXZlO2ZsZXg6bm9uZTthbGlnbi1zZWxmOnN0cmV0Y2g7d2lkdGg6MjRweDttYXJnaW46MDtsaW5lLWhlaWdodDoyNHB4O3RleHQtYWxpZ246Y2VudGVyO2N1cnNvcjpwb2ludGVyOy13ZWJraXQtdXNlci1zZWxlY3Q6bm9uZTstbW96LXVzZXItc2VsZWN0Om5vbmU7LW1zLXVzZXItc2VsZWN0Om5vbmU7dXNlci1zZWxlY3Q6bm9uZX0uYW50LXRyZWUtc3dpdGNoZXIgLmFudC1zZWxlY3QtdHJlZS1zd2l0Y2hlci1pY29uLC5hbnQtdHJlZS1zd2l0Y2hlciAuYW50LXRyZWUtc3dpdGNoZXItaWNvbntkaXNwbGF5OmlubGluZS1ibG9jaztmb250LXNpemU6MTBweDt2ZXJ0aWNhbC1hbGlnbjpiYXNlbGluZX0uYW50LXRyZWUtc3dpdGNoZXIgLmFudC1zZWxlY3QtdHJlZS1zd2l0Y2hlci1pY29uIHN2ZywuYW50LXRyZWUtc3dpdGNoZXIgLmFudC10cmVlLXN3aXRjaGVyLWljb24gc3Zne3RyYW5zaXRpb246dHJhbnNmb3JtIC4zc30uYW50LXRyZWUtc3dpdGNoZXItbm9vcHtjdXJzb3I6ZGVmYXVsdH0uYW50LXRyZWUtc3dpdGNoZXJfY2xvc2UgLmFudC10cmVlLXN3aXRjaGVyLWljb24gc3Zne3RyYW5zZm9ybTpyb3RhdGUoLTkwZGVnKX0uYW50LXRyZWUtc3dpdGNoZXItbG9hZGluZy1pY29ue2NvbG9yOiMxODkwZmZ9LmFudC10cmVlLXN3aXRjaGVyLWxlYWYtbGluZXtwb3NpdGlvbjpyZWxhdGl2ZTt6LWluZGV4OjE7ZGlzcGxheTppbmxpbmUtYmxvY2s7d2lkdGg6MTAwJTtoZWlnaHQ6MTAwJX0uYW50LXRyZWUtc3dpdGNoZXItbGVhZi1saW5lOmJlZm9yZXtwb3NpdGlvbjphYnNvbHV0ZTt0b3A6MDtyaWdodDoxMnB4O2JvdHRvbTotNHB4O21hcmdpbi1sZWZ0Oi0xcHg7Ym9yZGVyLXJpZ2h0OjFweCBzb2xpZCAjZDlkOWQ5O2NvbnRlbnQ6XCIgXCJ9LmFudC10cmVlLXN3aXRjaGVyLWxlYWYtbGluZTphZnRlcntwb3NpdGlvbjphYnNvbHV0ZTt3aWR0aDoxMHB4O2hlaWdodDoxNHB4O2JvcmRlci1ib3R0b206MXB4IHNvbGlkICNkOWQ5ZDk7Y29udGVudDpcIiBcIn0uYW50LXRyZWUtY2hlY2tib3h7dG9wOmF1dG87bWFyZ2luOjRweCA4cHggMCAwfS5hbnQtdHJlZSAuYW50LXRyZWUtbm9kZS1jb250ZW50LXdyYXBwZXJ7cG9zaXRpb246cmVsYXRpdmU7ei1pbmRleDphdXRvO21pbi1oZWlnaHQ6MjRweDttYXJnaW46MDtwYWRkaW5nOjAgNHB4O2NvbG9yOmluaGVyaXQ7bGluZS1oZWlnaHQ6MjRweDtiYWNrZ3JvdW5kOnRyYW5zcGFyZW50O2JvcmRlci1yYWRpdXM6MnB4O2N1cnNvcjpwb2ludGVyO3RyYW5zaXRpb246YWxsIC4zcyxib3JkZXIgMHMsbGluZS1oZWlnaHQgMHMsYm94LXNoYWRvdyAwc30uYW50LXRyZWUgLmFudC10cmVlLW5vZGUtY29udGVudC13cmFwcGVyOmhvdmVye2JhY2tncm91bmQtY29sb3I6I2Y1ZjVmNX0uYW50LXRyZWUgLmFudC10cmVlLW5vZGUtY29udGVudC13cmFwcGVyLmFudC10cmVlLW5vZGUtc2VsZWN0ZWR7YmFja2dyb3VuZC1jb2xvcjojYmFlN2ZmfS5hbnQtdHJlZSAuYW50LXRyZWUtbm9kZS1jb250ZW50LXdyYXBwZXIgLmFudC10cmVlLWljb25FbGV7ZGlzcGxheTppbmxpbmUtYmxvY2s7d2lkdGg6MjRweDtoZWlnaHQ6MjRweDtsaW5lLWhlaWdodDoyNHB4O3RleHQtYWxpZ246Y2VudGVyO3ZlcnRpY2FsLWFsaWduOnRvcH0uYW50LXRyZWUgLmFudC10cmVlLW5vZGUtY29udGVudC13cmFwcGVyIC5hbnQtdHJlZS1pY29uRWxlOmVtcHR5e2Rpc3BsYXk6bm9uZX0uYW50LXRyZWUtdW5zZWxlY3RhYmxlIC5hbnQtdHJlZS1ub2RlLWNvbnRlbnQtd3JhcHBlcjpob3ZlcntiYWNrZ3JvdW5kLWNvbG9yOnRyYW5zcGFyZW50fS5hbnQtdHJlZS1ub2RlLWNvbnRlbnQtd3JhcHBlcntsaW5lLWhlaWdodDoyNHB4Oy13ZWJraXQtdXNlci1zZWxlY3Q6bm9uZTstbW96LXVzZXItc2VsZWN0Om5vbmU7LW1zLXVzZXItc2VsZWN0Om5vbmU7dXNlci1zZWxlY3Q6bm9uZX0uYW50LXRyZWUtbm9kZS1jb250ZW50LXdyYXBwZXIgLmFudC10cmVlLWRyb3AtaW5kaWNhdG9ye3Bvc2l0aW9uOmFic29sdXRlO3otaW5kZXg6MTtoZWlnaHQ6MnB4O2JhY2tncm91bmQtY29sb3I6IzE4OTBmZjtib3JkZXItcmFkaXVzOjFweDtwb2ludGVyLWV2ZW50czpub25lfS5hbnQtdHJlZS1ub2RlLWNvbnRlbnQtd3JhcHBlciAuYW50LXRyZWUtZHJvcC1pbmRpY2F0b3I6YWZ0ZXJ7cG9zaXRpb246YWJzb2x1dGU7dG9wOi0zcHg7bGVmdDotNnB4O3dpZHRoOjhweDtoZWlnaHQ6OHB4O2JhY2tncm91bmQtY29sb3I6dHJhbnNwYXJlbnQ7Ym9yZGVyOjJweCBzb2xpZCAjMTg5MGZmO2JvcmRlci1yYWRpdXM6NTAlO2NvbnRlbnQ6XCJcIn0uYW50LXRyZWUgLmFudC10cmVlLXRyZWVub2RlLmRyb3AtY29udGFpbmVyPltkcmFnZ2FibGVde2JveC1zaGFkb3c6MCAwIDAgMnB4ICMxODkwZmZ9LmFudC10cmVlLXNob3ctbGluZSAuYW50LXRyZWUtaW5kZW50LXVuaXR7cG9zaXRpb246cmVsYXRpdmU7aGVpZ2h0OjEwMCV9LmFudC10cmVlLXNob3ctbGluZSAuYW50LXRyZWUtaW5kZW50LXVuaXQ6YmVmb3Jle3Bvc2l0aW9uOmFic29sdXRlO3RvcDowO3JpZ2h0OjEycHg7Ym90dG9tOi00cHg7Ym9yZGVyLXJpZ2h0OjFweCBzb2xpZCAjZDlkOWQ5O2NvbnRlbnQ6XCJcIn0uYW50LXRyZWUtc2hvdy1saW5lIC5hbnQtdHJlZS1pbmRlbnQtdW5pdC1lbmQ6YmVmb3Jle2Rpc3BsYXk6bm9uZX0uYW50LXRyZWUtc2hvdy1saW5lIC5hbnQtdHJlZS1zd2l0Y2hlcntiYWNrZ3JvdW5kOiNmZmZ9LmFudC10cmVlLXNob3ctbGluZSAuYW50LXRyZWUtc3dpdGNoZXItbGluZS1pY29ue3ZlcnRpY2FsLWFsaWduOi0uMTVlbX0uYW50LXRyZWUgLmFudC10cmVlLXRyZWVub2RlLWxlYWYtbGFzdCAuYW50LXRyZWUtc3dpdGNoZXItbGVhZi1saW5lOmJlZm9yZXt0b3A6YXV0byFpbXBvcnRhbnQ7Ym90dG9tOmF1dG8haW1wb3J0YW50O2hlaWdodDoxNHB4IWltcG9ydGFudH0uYW50LXRyZWUtcnRse2RpcmVjdGlvbjpydGx9LmFudC10cmVlLXJ0bCAuYW50LXRyZWUtbm9kZS1jb250ZW50LXdyYXBwZXJbZHJhZ2dhYmxlPXRydWVdIC5hbnQtdHJlZS1kcm9wLWluZGljYXRvcjphZnRlcntyaWdodDotNnB4O2xlZnQ6dW5zZXR9LmFudC10cmVlIC5hbnQtdHJlZS10cmVlbm9kZS1ydGx7ZGlyZWN0aW9uOnJ0bH0uYW50LXRyZWUtcnRsIC5hbnQtdHJlZS1zd2l0Y2hlcl9jbG9zZSAuYW50LXRyZWUtc3dpdGNoZXItaWNvbiBzdmd7dHJhbnNmb3JtOnJvdGF0ZSg5MGRlZyl9LmFudC10cmVlLXJ0bC5hbnQtdHJlZS1zaG93LWxpbmUgLmFudC10cmVlLWluZGVudC11bml0OmJlZm9yZXtyaWdodDphdXRvO2xlZnQ6LTEzcHg7Ym9yZGVyLXJpZ2h0Om5vbmU7Ym9yZGVyLWxlZnQ6MXB4IHNvbGlkICNkOWQ5ZDl9LmFudC10cmVlLXJ0bCAuYW50LXRyZWUtY2hlY2tib3gsLmFudC10cmVlLXNlbGVjdC1kcm9wZG93bi1ydGwgLmFudC1zZWxlY3QtdHJlZS1jaGVja2JveHttYXJnaW46NHB4IDAgMCA4cHh9LmFudC10eXBvZ3JhcGh5e2NvbG9yOnJnYmEoMCwwLDAsLjg1KTt3b3JkLWJyZWFrOmJyZWFrLXdvcmR9LmFudC10eXBvZ3JhcGh5LmFudC10eXBvZ3JhcGh5LXNlY29uZGFyeXtjb2xvcjpyZ2JhKDAsMCwwLC40NSl9LmFudC10eXBvZ3JhcGh5LmFudC10eXBvZ3JhcGh5LXN1Y2Nlc3N7Y29sb3I6IzUyYzQxYX0uYW50LXR5cG9ncmFwaHkuYW50LXR5cG9ncmFwaHktd2FybmluZ3tjb2xvcjojZmFhZDE0fS5hbnQtdHlwb2dyYXBoeS5hbnQtdHlwb2dyYXBoeS1kYW5nZXJ7Y29sb3I6I2ZmNGQ0Zn1hLmFudC10eXBvZ3JhcGh5LmFudC10eXBvZ3JhcGh5LWRhbmdlcjphY3RpdmUsYS5hbnQtdHlwb2dyYXBoeS5hbnQtdHlwb2dyYXBoeS1kYW5nZXI6Zm9jdXN7Y29sb3I6I2Q5MzYzZX1hLmFudC10eXBvZ3JhcGh5LmFudC10eXBvZ3JhcGh5LWRhbmdlcjpob3Zlcntjb2xvcjojZmY3ODc1fS5hbnQtdHlwb2dyYXBoeS5hbnQtdHlwb2dyYXBoeS1kaXNhYmxlZHtjb2xvcjpyZ2JhKDAsMCwwLC4yNSk7Y3Vyc29yOm5vdC1hbGxvd2VkOy13ZWJraXQtdXNlci1zZWxlY3Q6bm9uZTstbW96LXVzZXItc2VsZWN0Om5vbmU7LW1zLXVzZXItc2VsZWN0Om5vbmU7dXNlci1zZWxlY3Q6bm9uZX0uYW50LXR5cG9ncmFwaHkgcCxkaXYuYW50LXR5cG9ncmFwaHl7bWFyZ2luLWJvdHRvbToxZW19LmFudC10eXBvZ3JhcGh5IGgxLGRpdi5hbnQtdHlwb2dyYXBoeS1oMSxkaXYuYW50LXR5cG9ncmFwaHktaDE+dGV4dGFyZWEsaDEuYW50LXR5cG9ncmFwaHl7bWFyZ2luLWJvdHRvbTouNWVtO2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtmb250LXdlaWdodDo2MDA7Zm9udC1zaXplOjM4cHg7bGluZS1oZWlnaHQ6MS4yM30uYW50LXR5cG9ncmFwaHkgaDIsZGl2LmFudC10eXBvZ3JhcGh5LWgyLGRpdi5hbnQtdHlwb2dyYXBoeS1oMj50ZXh0YXJlYSxoMi5hbnQtdHlwb2dyYXBoeXttYXJnaW4tYm90dG9tOi41ZW07Y29sb3I6cmdiYSgwLDAsMCwuODUpO2ZvbnQtd2VpZ2h0OjYwMDtmb250LXNpemU6MzBweDtsaW5lLWhlaWdodDoxLjM1fS5hbnQtdHlwb2dyYXBoeSBoMyxkaXYuYW50LXR5cG9ncmFwaHktaDMsZGl2LmFudC10eXBvZ3JhcGh5LWgzPnRleHRhcmVhLGgzLmFudC10eXBvZ3JhcGh5e21hcmdpbi1ib3R0b206LjVlbTtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7Zm9udC13ZWlnaHQ6NjAwO2ZvbnQtc2l6ZToyNHB4O2xpbmUtaGVpZ2h0OjEuMzV9LmFudC10eXBvZ3JhcGh5IGg0LGRpdi5hbnQtdHlwb2dyYXBoeS1oNCxkaXYuYW50LXR5cG9ncmFwaHktaDQ+dGV4dGFyZWEsaDQuYW50LXR5cG9ncmFwaHl7bWFyZ2luLWJvdHRvbTouNWVtO2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtmb250LXdlaWdodDo2MDA7Zm9udC1zaXplOjIwcHg7bGluZS1oZWlnaHQ6MS40fS5hbnQtdHlwb2dyYXBoeSBoNSxkaXYuYW50LXR5cG9ncmFwaHktaDUsZGl2LmFudC10eXBvZ3JhcGh5LWg1PnRleHRhcmVhLGg1LmFudC10eXBvZ3JhcGh5e21hcmdpbi1ib3R0b206LjVlbTtjb2xvcjpyZ2JhKDAsMCwwLC44NSk7Zm9udC13ZWlnaHQ6NjAwO2ZvbnQtc2l6ZToxNnB4O2xpbmUtaGVpZ2h0OjEuNX0uYW50LXR5cG9ncmFwaHkraDEuYW50LXR5cG9ncmFwaHksLmFudC10eXBvZ3JhcGh5K2gyLmFudC10eXBvZ3JhcGh5LC5hbnQtdHlwb2dyYXBoeStoMy5hbnQtdHlwb2dyYXBoeSwuYW50LXR5cG9ncmFwaHkraDQuYW50LXR5cG9ncmFwaHksLmFudC10eXBvZ3JhcGh5K2g1LmFudC10eXBvZ3JhcGh5LC5hbnQtdHlwb2dyYXBoeSBkaXYraDEsLmFudC10eXBvZ3JhcGh5IGRpditoMiwuYW50LXR5cG9ncmFwaHkgZGl2K2gzLC5hbnQtdHlwb2dyYXBoeSBkaXYraDQsLmFudC10eXBvZ3JhcGh5IGRpditoNSwuYW50LXR5cG9ncmFwaHkgaDEraDEsLmFudC10eXBvZ3JhcGh5IGgxK2gyLC5hbnQtdHlwb2dyYXBoeSBoMStoMywuYW50LXR5cG9ncmFwaHkgaDEraDQsLmFudC10eXBvZ3JhcGh5IGgxK2g1LC5hbnQtdHlwb2dyYXBoeSBoMitoMSwuYW50LXR5cG9ncmFwaHkgaDIraDIsLmFudC10eXBvZ3JhcGh5IGgyK2gzLC5hbnQtdHlwb2dyYXBoeSBoMitoNCwuYW50LXR5cG9ncmFwaHkgaDIraDUsLmFudC10eXBvZ3JhcGh5IGgzK2gxLC5hbnQtdHlwb2dyYXBoeSBoMytoMiwuYW50LXR5cG9ncmFwaHkgaDMraDMsLmFudC10eXBvZ3JhcGh5IGgzK2g0LC5hbnQtdHlwb2dyYXBoeSBoMytoNSwuYW50LXR5cG9ncmFwaHkgaDQraDEsLmFudC10eXBvZ3JhcGh5IGg0K2gyLC5hbnQtdHlwb2dyYXBoeSBoNCtoMywuYW50LXR5cG9ncmFwaHkgaDQraDQsLmFudC10eXBvZ3JhcGh5IGg0K2g1LC5hbnQtdHlwb2dyYXBoeSBoNStoMSwuYW50LXR5cG9ncmFwaHkgaDUraDIsLmFudC10eXBvZ3JhcGh5IGg1K2gzLC5hbnQtdHlwb2dyYXBoeSBoNStoNCwuYW50LXR5cG9ncmFwaHkgaDUraDUsLmFudC10eXBvZ3JhcGh5IGxpK2gxLC5hbnQtdHlwb2dyYXBoeSBsaStoMiwuYW50LXR5cG9ncmFwaHkgbGkraDMsLmFudC10eXBvZ3JhcGh5IGxpK2g0LC5hbnQtdHlwb2dyYXBoeSBsaStoNSwuYW50LXR5cG9ncmFwaHkgcCtoMSwuYW50LXR5cG9ncmFwaHkgcCtoMiwuYW50LXR5cG9ncmFwaHkgcCtoMywuYW50LXR5cG9ncmFwaHkgcCtoNCwuYW50LXR5cG9ncmFwaHkgcCtoNSwuYW50LXR5cG9ncmFwaHkgdWwraDEsLmFudC10eXBvZ3JhcGh5IHVsK2gyLC5hbnQtdHlwb2dyYXBoeSB1bCtoMywuYW50LXR5cG9ncmFwaHkgdWwraDQsLmFudC10eXBvZ3JhcGh5IHVsK2g1e21hcmdpbi10b3A6MS4yZW19YS5hbnQtdHlwb2dyYXBoeS1lbGxpcHNpcyxzcGFuLmFudC10eXBvZ3JhcGh5LWVsbGlwc2lze2Rpc3BsYXk6aW5saW5lLWJsb2NrO21heC13aWR0aDoxMDAlfS5hbnQtdHlwb2dyYXBoeSBhLGEuYW50LXR5cG9ncmFwaHl7Y29sb3I6IzE4OTBmZjtvdXRsaW5lOm5vbmU7Y3Vyc29yOnBvaW50ZXI7dHJhbnNpdGlvbjpjb2xvciAuM3M7dGV4dC1kZWNvcmF0aW9uOm5vbmV9LmFudC10eXBvZ3JhcGh5IGE6Zm9jdXMtdmlzaWJsZSwuYW50LXR5cG9ncmFwaHkgYTpob3ZlcixhLmFudC10eXBvZ3JhcGh5OmZvY3VzLXZpc2libGUsYS5hbnQtdHlwb2dyYXBoeTpob3Zlcntjb2xvcjojNDBhOWZmfS5hbnQtdHlwb2dyYXBoeSBhOmFjdGl2ZSxhLmFudC10eXBvZ3JhcGh5OmFjdGl2ZXtjb2xvcjojMDk2ZGQ5fS5hbnQtdHlwb2dyYXBoeSBhOmFjdGl2ZSwuYW50LXR5cG9ncmFwaHkgYTpob3ZlcixhLmFudC10eXBvZ3JhcGh5OmFjdGl2ZSxhLmFudC10eXBvZ3JhcGh5OmhvdmVye3RleHQtZGVjb3JhdGlvbjpub25lfS5hbnQtdHlwb2dyYXBoeSBhLmFudC10eXBvZ3JhcGh5LWRpc2FibGVkLC5hbnQtdHlwb2dyYXBoeSBhW2Rpc2FibGVkXSxhLmFudC10eXBvZ3JhcGh5LmFudC10eXBvZ3JhcGh5LWRpc2FibGVkLGEuYW50LXR5cG9ncmFwaHlbZGlzYWJsZWRde2NvbG9yOnJnYmEoMCwwLDAsLjI1KTtjdXJzb3I6bm90LWFsbG93ZWR9LmFudC10eXBvZ3JhcGh5IGEuYW50LXR5cG9ncmFwaHktZGlzYWJsZWQ6YWN0aXZlLC5hbnQtdHlwb2dyYXBoeSBhLmFudC10eXBvZ3JhcGh5LWRpc2FibGVkOmhvdmVyLC5hbnQtdHlwb2dyYXBoeSBhW2Rpc2FibGVkXTphY3RpdmUsLmFudC10eXBvZ3JhcGh5IGFbZGlzYWJsZWRdOmhvdmVyLGEuYW50LXR5cG9ncmFwaHkuYW50LXR5cG9ncmFwaHktZGlzYWJsZWQ6YWN0aXZlLGEuYW50LXR5cG9ncmFwaHkuYW50LXR5cG9ncmFwaHktZGlzYWJsZWQ6aG92ZXIsYS5hbnQtdHlwb2dyYXBoeVtkaXNhYmxlZF06YWN0aXZlLGEuYW50LXR5cG9ncmFwaHlbZGlzYWJsZWRdOmhvdmVye2NvbG9yOnJnYmEoMCwwLDAsLjI1KX0uYW50LXR5cG9ncmFwaHkgYS5hbnQtdHlwb2dyYXBoeS1kaXNhYmxlZDphY3RpdmUsLmFudC10eXBvZ3JhcGh5IGFbZGlzYWJsZWRdOmFjdGl2ZSxhLmFudC10eXBvZ3JhcGh5LmFudC10eXBvZ3JhcGh5LWRpc2FibGVkOmFjdGl2ZSxhLmFudC10eXBvZ3JhcGh5W2Rpc2FibGVkXTphY3RpdmV7cG9pbnRlci1ldmVudHM6bm9uZX0uYW50LXR5cG9ncmFwaHkgY29kZXttYXJnaW46MCAuMmVtO3BhZGRpbmc6LjJlbSAuNGVtIC4xZW07Zm9udC1zaXplOjg1JTtiYWNrZ3JvdW5kOmhzbGEoMCwwJSw1OC44JSwuMSk7Ym9yZGVyOjFweCBzb2xpZCBoc2xhKDAsMCUsMzkuMiUsLjIpO2JvcmRlci1yYWRpdXM6M3B4fS5hbnQtdHlwb2dyYXBoeSBrYmR7bWFyZ2luOjAgLjJlbTtwYWRkaW5nOi4xNWVtIC40ZW0gLjFlbTtmb250LXNpemU6OTAlO2JhY2tncm91bmQ6aHNsYSgwLDAlLDU4LjglLC4wNik7Ym9yZGVyOnNvbGlkIGhzbGEoMCwwJSwzOS4yJSwuMik7Ym9yZGVyLXdpZHRoOjFweCAxcHggMnB4O2JvcmRlci1yYWRpdXM6M3B4fS5hbnQtdHlwb2dyYXBoeSBtYXJre3BhZGRpbmc6MDtiYWNrZ3JvdW5kLWNvbG9yOiNmZmU1OGZ9LmFudC10eXBvZ3JhcGh5IGlucywuYW50LXR5cG9ncmFwaHkgdXt0ZXh0LWRlY29yYXRpb246dW5kZXJsaW5lOy13ZWJraXQtdGV4dC1kZWNvcmF0aW9uLXNraXA6aW5rO3RleHQtZGVjb3JhdGlvbi1za2lwLWluazphdXRvfS5hbnQtdHlwb2dyYXBoeSBkZWwsLmFudC10eXBvZ3JhcGh5IHN7dGV4dC1kZWNvcmF0aW9uOmxpbmUtdGhyb3VnaH0uYW50LXR5cG9ncmFwaHkgc3Ryb25ne2ZvbnQtd2VpZ2h0OjYwMH0uYW50LXR5cG9ncmFwaHktY29weSwuYW50LXR5cG9ncmFwaHktZWRpdCwuYW50LXR5cG9ncmFwaHktZXhwYW5ke2NvbG9yOiMxODkwZmY7b3V0bGluZTpub25lO2N1cnNvcjpwb2ludGVyO3RyYW5zaXRpb246Y29sb3IgLjNzO21hcmdpbi1sZWZ0OjRweH0uYW50LXR5cG9ncmFwaHktY29weTpmb2N1cy12aXNpYmxlLC5hbnQtdHlwb2dyYXBoeS1jb3B5OmhvdmVyLC5hbnQtdHlwb2dyYXBoeS1lZGl0OmZvY3VzLXZpc2libGUsLmFudC10eXBvZ3JhcGh5LWVkaXQ6aG92ZXIsLmFudC10eXBvZ3JhcGh5LWV4cGFuZDpmb2N1cy12aXNpYmxlLC5hbnQtdHlwb2dyYXBoeS1leHBhbmQ6aG92ZXJ7Y29sb3I6IzQwYTlmZn0uYW50LXR5cG9ncmFwaHktY29weTphY3RpdmUsLmFudC10eXBvZ3JhcGh5LWVkaXQ6YWN0aXZlLC5hbnQtdHlwb2dyYXBoeS1leHBhbmQ6YWN0aXZle2NvbG9yOiMwOTZkZDl9LmFudC10eXBvZ3JhcGh5LWNvcHktc3VjY2VzcywuYW50LXR5cG9ncmFwaHktY29weS1zdWNjZXNzOmZvY3VzLC5hbnQtdHlwb2dyYXBoeS1jb3B5LXN1Y2Nlc3M6aG92ZXJ7Y29sb3I6IzUyYzQxYX0uYW50LXR5cG9ncmFwaHktZWRpdC1jb250ZW50e3Bvc2l0aW9uOnJlbGF0aXZlfWRpdi5hbnQtdHlwb2dyYXBoeS1lZGl0LWNvbnRlbnR7bGVmdDotMTJweDttYXJnaW4tdG9wOi01cHg7bWFyZ2luLWJvdHRvbTpjYWxjKDFlbSAtIDVweCl9LmFudC10eXBvZ3JhcGh5LWVkaXQtY29udGVudC1jb25maXJte3Bvc2l0aW9uOmFic29sdXRlO3JpZ2h0OjEwcHg7Ym90dG9tOjhweDtjb2xvcjpyZ2JhKDAsMCwwLC40NSk7Zm9udC13ZWlnaHQ6NDAwO2ZvbnQtc2l6ZToxNHB4O2ZvbnQtc3R5bGU6bm9ybWFsO3BvaW50ZXItZXZlbnRzOm5vbmV9LmFudC10eXBvZ3JhcGh5LWVkaXQtY29udGVudCB0ZXh0YXJlYXtoZWlnaHQ6MWVtO21hcmdpbjowIWltcG9ydGFudDstbW96LXRyYW5zaXRpb246bm9uZX0uYW50LXR5cG9ncmFwaHkgb2wsLmFudC10eXBvZ3JhcGh5IHVse21hcmdpbjowIDAgMWVtO3BhZGRpbmc6MH0uYW50LXR5cG9ncmFwaHkgb2wgbGksLmFudC10eXBvZ3JhcGh5IHVsIGxpe21hcmdpbjowIDAgMCAyMHB4O3BhZGRpbmc6MCAwIDAgNHB4fS5hbnQtdHlwb2dyYXBoeSB1bHtsaXN0LXN0eWxlLXR5cGU6Y2lyY2xlfS5hbnQtdHlwb2dyYXBoeSB1bCB1bHtsaXN0LXN0eWxlLXR5cGU6ZGlzY30uYW50LXR5cG9ncmFwaHkgb2x7bGlzdC1zdHlsZS10eXBlOmRlY2ltYWx9LmFudC10eXBvZ3JhcGh5IGJsb2NrcXVvdGUsLmFudC10eXBvZ3JhcGh5IHByZXttYXJnaW46MWVtIDB9LmFudC10eXBvZ3JhcGh5IHByZXtwYWRkaW5nOi40ZW0gLjZlbTt3aGl0ZS1zcGFjZTpwcmUtd3JhcDt3b3JkLXdyYXA6YnJlYWstd29yZDtiYWNrZ3JvdW5kOmhzbGEoMCwwJSw1OC44JSwuMSk7Ym9yZGVyOjFweCBzb2xpZCBoc2xhKDAsMCUsMzkuMiUsLjIpO2JvcmRlci1yYWRpdXM6M3B4fS5hbnQtdHlwb2dyYXBoeSBwcmUgY29kZXtkaXNwbGF5OmlubGluZTttYXJnaW46MDtwYWRkaW5nOjA7Zm9udC1zaXplOmluaGVyaXQ7Zm9udC1mYW1pbHk6aW5oZXJpdDtiYWNrZ3JvdW5kOnRyYW5zcGFyZW50O2JvcmRlcjowfS5hbnQtdHlwb2dyYXBoeSBibG9ja3F1b3Rle3BhZGRpbmc6MCAwIDAgLjZlbTtib3JkZXItbGVmdDo0cHggc29saWQgaHNsYSgwLDAlLDM5LjIlLC4yKTtvcGFjaXR5Oi44NX0uYW50LXR5cG9ncmFwaHktc2luZ2xlLWxpbmV7d2hpdGUtc3BhY2U6bm93cmFwfS5hbnQtdHlwb2dyYXBoeS1lbGxpcHNpcy1zaW5nbGUtbGluZXtvdmVyZmxvdzpoaWRkZW47dGV4dC1vdmVyZmxvdzplbGxpcHNpc31hLmFudC10eXBvZ3JhcGh5LWVsbGlwc2lzLXNpbmdsZS1saW5lLHNwYW4uYW50LXR5cG9ncmFwaHktZWxsaXBzaXMtc2luZ2xlLWxpbmV7dmVydGljYWwtYWxpZ246Ym90dG9tfS5hbnQtdHlwb2dyYXBoeS1lbGxpcHNpcy1tdWx0aXBsZS1saW5le2Rpc3BsYXk6LXdlYmtpdC1ib3g7b3ZlcmZsb3c6aGlkZGVuOy13ZWJraXQtbGluZS1jbGFtcDozO1xuICAvKiEgYXV0b3ByZWZpeGVyOiBpZ25vcmUgbmV4dCAqLy13ZWJraXQtYm94LW9yaWVudDp2ZXJ0aWNhbH0uYW50LXR5cG9ncmFwaHktcnRse2RpcmVjdGlvbjpydGx9LmFudC10eXBvZ3JhcGh5LXJ0bCAuYW50LXR5cG9ncmFwaHktY29weSwuYW50LXR5cG9ncmFwaHktcnRsIC5hbnQtdHlwb2dyYXBoeS1lZGl0LC5hbnQtdHlwb2dyYXBoeS1ydGwgLmFudC10eXBvZ3JhcGh5LWV4cGFuZHttYXJnaW4tcmlnaHQ6NHB4O21hcmdpbi1sZWZ0OjB9LmFudC10eXBvZ3JhcGh5LXJ0bCAuYW50LXR5cG9ncmFwaHktZXhwYW5ke2Zsb2F0OmxlZnR9ZGl2LmFudC10eXBvZ3JhcGh5LWVkaXQtY29udGVudC5hbnQtdHlwb2dyYXBoeS1ydGx7cmlnaHQ6LTEycHg7bGVmdDphdXRvfS5hbnQtdHlwb2dyYXBoeS1ydGwgLmFudC10eXBvZ3JhcGh5LWVkaXQtY29udGVudC1jb25maXJte3JpZ2h0OmF1dG87bGVmdDoxMHB4fS5hbnQtdHlwb2dyYXBoeS1ydGwuYW50LXR5cG9ncmFwaHkgb2wgbGksLmFudC10eXBvZ3JhcGh5LXJ0bC5hbnQtdHlwb2dyYXBoeSB1bCBsaXttYXJnaW46MCAyMHB4IDAgMDtwYWRkaW5nOjAgNHB4IDAgMH0uYW50LXVwbG9hZHtib3gtc2l6aW5nOmJvcmRlci1ib3g7bWFyZ2luOjA7cGFkZGluZzowO2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtmb250LXNpemU6MTRweDtmb250LXZhcmlhbnQ6dGFidWxhci1udW1zO2xpbmUtaGVpZ2h0OjEuNTcxNTtsaXN0LXN0eWxlOm5vbmU7Zm9udC1mZWF0dXJlLXNldHRpbmdzOlwidG51bVwiO291dGxpbmU6MH0uYW50LXVwbG9hZCBwe21hcmdpbjowfS5hbnQtdXBsb2FkLWJ0bntkaXNwbGF5OmJsb2NrO3dpZHRoOjEwMCU7b3V0bGluZTpub25lfS5hbnQtdXBsb2FkIGlucHV0W3R5cGU9ZmlsZV17Y3Vyc29yOnBvaW50ZXJ9LmFudC11cGxvYWQuYW50LXVwbG9hZC1zZWxlY3R7ZGlzcGxheTppbmxpbmUtYmxvY2t9LmFudC11cGxvYWQuYW50LXVwbG9hZC1kaXNhYmxlZHtjb2xvcjpyZ2JhKDAsMCwwLC4yNSk7Y3Vyc29yOm5vdC1hbGxvd2VkfS5hbnQtdXBsb2FkLmFudC11cGxvYWQtc2VsZWN0LXBpY3R1cmUtY2FyZHt3aWR0aDoxMDRweDtoZWlnaHQ6MTA0cHg7bWFyZ2luLXJpZ2h0OjhweDttYXJnaW4tYm90dG9tOjhweDt0ZXh0LWFsaWduOmNlbnRlcjt2ZXJ0aWNhbC1hbGlnbjp0b3A7YmFja2dyb3VuZC1jb2xvcjojZmFmYWZhO2JvcmRlcjoxcHggZGFzaGVkICNkOWQ5ZDk7Ym9yZGVyLXJhZGl1czoycHg7Y3Vyc29yOnBvaW50ZXI7dHJhbnNpdGlvbjpib3JkZXItY29sb3IgLjNzfS5hbnQtdXBsb2FkLmFudC11cGxvYWQtc2VsZWN0LXBpY3R1cmUtY2FyZD4uYW50LXVwbG9hZHtkaXNwbGF5OmZsZXg7YWxpZ24taXRlbXM6Y2VudGVyO2p1c3RpZnktY29udGVudDpjZW50ZXI7aGVpZ2h0OjEwMCU7dGV4dC1hbGlnbjpjZW50ZXJ9LmFudC11cGxvYWQuYW50LXVwbG9hZC1zZWxlY3QtcGljdHVyZS1jYXJkOmhvdmVye2JvcmRlci1jb2xvcjojMTg5MGZmfS5hbnQtdXBsb2FkLWRpc2FibGVkLmFudC11cGxvYWQuYW50LXVwbG9hZC1zZWxlY3QtcGljdHVyZS1jYXJkOmhvdmVye2JvcmRlci1jb2xvcjojZDlkOWQ5fS5hbnQtdXBsb2FkLmFudC11cGxvYWQtZHJhZ3twb3NpdGlvbjpyZWxhdGl2ZTt3aWR0aDoxMDAlO2hlaWdodDoxMDAlO3RleHQtYWxpZ246Y2VudGVyO2JhY2tncm91bmQ6I2ZhZmFmYTtib3JkZXI6MXB4IGRhc2hlZCAjZDlkOWQ5O2JvcmRlci1yYWRpdXM6MnB4O2N1cnNvcjpwb2ludGVyO3RyYW5zaXRpb246Ym9yZGVyLWNvbG9yIC4zc30uYW50LXVwbG9hZC5hbnQtdXBsb2FkLWRyYWcgLmFudC11cGxvYWR7cGFkZGluZzoxNnB4IDB9LmFudC11cGxvYWQuYW50LXVwbG9hZC1kcmFnLmFudC11cGxvYWQtZHJhZy1ob3Zlcjpub3QoLmFudC11cGxvYWQtZGlzYWJsZWQpe2JvcmRlci1jb2xvcjojMDk2ZGQ5fS5hbnQtdXBsb2FkLmFudC11cGxvYWQtZHJhZy5hbnQtdXBsb2FkLWRpc2FibGVke2N1cnNvcjpub3QtYWxsb3dlZH0uYW50LXVwbG9hZC5hbnQtdXBsb2FkLWRyYWcgLmFudC11cGxvYWQtYnRue2Rpc3BsYXk6dGFibGU7aGVpZ2h0OjEwMCV9LmFudC11cGxvYWQuYW50LXVwbG9hZC1kcmFnIC5hbnQtdXBsb2FkLWRyYWctY29udGFpbmVye2Rpc3BsYXk6dGFibGUtY2VsbDt2ZXJ0aWNhbC1hbGlnbjptaWRkbGV9LmFudC11cGxvYWQuYW50LXVwbG9hZC1kcmFnOm5vdCguYW50LXVwbG9hZC1kaXNhYmxlZCk6aG92ZXJ7Ym9yZGVyLWNvbG9yOiM0MGE5ZmZ9LmFudC11cGxvYWQuYW50LXVwbG9hZC1kcmFnIHAuYW50LXVwbG9hZC1kcmFnLWljb257bWFyZ2luLWJvdHRvbToyMHB4fS5hbnQtdXBsb2FkLmFudC11cGxvYWQtZHJhZyBwLmFudC11cGxvYWQtZHJhZy1pY29uIC5hbnRpY29ue2NvbG9yOiM0MGE5ZmY7Zm9udC1zaXplOjQ4cHh9LmFudC11cGxvYWQuYW50LXVwbG9hZC1kcmFnIHAuYW50LXVwbG9hZC10ZXh0e21hcmdpbjowIDAgNHB4O2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtmb250LXNpemU6MTZweH0uYW50LXVwbG9hZC5hbnQtdXBsb2FkLWRyYWcgcC5hbnQtdXBsb2FkLWhpbnR7Y29sb3I6cmdiYSgwLDAsMCwuNDUpO2ZvbnQtc2l6ZToxNHB4fS5hbnQtdXBsb2FkLmFudC11cGxvYWQtZHJhZyAuYW50aWNvbi1wbHVze2NvbG9yOnJnYmEoMCwwLDAsLjI1KTtmb250LXNpemU6MzBweDt0cmFuc2l0aW9uOmFsbCAuM3N9LmFudC11cGxvYWQuYW50LXVwbG9hZC1kcmFnIC5hbnRpY29uLXBsdXM6aG92ZXIsLmFudC11cGxvYWQuYW50LXVwbG9hZC1kcmFnOmhvdmVyIC5hbnRpY29uLXBsdXN7Y29sb3I6cmdiYSgwLDAsMCwuNDUpfS5hbnQtdXBsb2FkLXBpY3R1cmUtY2FyZC13cmFwcGVye2Rpc3BsYXk6aW5saW5lLWJsb2NrO3dpZHRoOjEwMCV9LmFudC11cGxvYWQtcGljdHVyZS1jYXJkLXdyYXBwZXI6YmVmb3Jle2Rpc3BsYXk6dGFibGU7Y29udGVudDpcIlwifS5hbnQtdXBsb2FkLXBpY3R1cmUtY2FyZC13cmFwcGVyOmFmdGVye2Rpc3BsYXk6dGFibGU7Y2xlYXI6Ym90aDtjb250ZW50OlwiXCJ9LmFudC11cGxvYWQtbGlzdHtib3gtc2l6aW5nOmJvcmRlci1ib3g7bWFyZ2luOjA7cGFkZGluZzowO2NvbG9yOnJnYmEoMCwwLDAsLjg1KTtmb250LXNpemU6MTRweDtmb250LXZhcmlhbnQ6dGFidWxhci1udW1zO2xpc3Qtc3R5bGU6bm9uZTtmb250LWZlYXR1cmUtc2V0dGluZ3M6XCJ0bnVtXCI7bGluZS1oZWlnaHQ6MS41NzE1fS5hbnQtdXBsb2FkLWxpc3Q6YWZ0ZXIsLmFudC11cGxvYWQtbGlzdDpiZWZvcmV7ZGlzcGxheTp0YWJsZTtjb250ZW50OlwiXCJ9LmFudC11cGxvYWQtbGlzdDphZnRlcntjbGVhcjpib3RofS5hbnQtdXBsb2FkLWxpc3QtaXRlbXtwb3NpdGlvbjpyZWxhdGl2ZTtoZWlnaHQ6MjIuMDAxcHg7bWFyZ2luLXRvcDo4cHg7Zm9udC1zaXplOjE0cHh9LmFudC11cGxvYWQtbGlzdC1pdGVtLW5hbWV7ZGlzcGxheTppbmxpbmUtYmxvY2s7d2lkdGg6MTAwJTtwYWRkaW5nLWxlZnQ6MjJweDtvdmVyZmxvdzpoaWRkZW47bGluZS1oZWlnaHQ6MS41NzE1O3doaXRlLXNwYWNlOm5vd3JhcDt0ZXh0LW92ZXJmbG93OmVsbGlwc2lzfS5hbnQtdXBsb2FkLWxpc3QtaXRlbS1jYXJkLWFjdGlvbnN7cG9zaXRpb246YWJzb2x1dGU7cmlnaHQ6MH0uYW50LXVwbG9hZC1saXN0LWl0ZW0tY2FyZC1hY3Rpb25zLWJ0bntvcGFjaXR5OjB9LmFudC11cGxvYWQtbGlzdC1pdGVtLWNhcmQtYWN0aW9ucy1idG4uYW50LWJ0bi1zbXtoZWlnaHQ6MjIuMDAxcHg7bGluZS1oZWlnaHQ6MTt2ZXJ0aWNhbC1hbGlnbjp0b3B9LmFudC11cGxvYWQtbGlzdC1pdGVtLWNhcmQtYWN0aW9ucy5waWN0dXJle3RvcDoyMnB4O2xpbmUtaGVpZ2h0OjB9LmFudC11cGxvYWQtbGlzdC1pdGVtLWNhcmQtYWN0aW9ucy1idG46Zm9jdXMsLmFudC11cGxvYWQtbGlzdC1pdGVtLWNhcmQtYWN0aW9ucy5waWN0dXJlIC5hbnQtdXBsb2FkLWxpc3QtaXRlbS1jYXJkLWFjdGlvbnMtYnRue29wYWNpdHk6MX0uYW50LXVwbG9hZC1saXN0LWl0ZW0tY2FyZC1hY3Rpb25zIC5hbnRpY29ue2NvbG9yOnJnYmEoMCwwLDAsLjQ1KTt0cmFuc2l0aW9uOmFsbCAuM3N9LmFudC11cGxvYWQtbGlzdC1pdGVtLWNhcmQtYWN0aW9uczpob3ZlciAuYW50aWNvbntjb2xvcjpyZ2JhKDAsMCwwLC44NSl9LmFudC11cGxvYWQtbGlzdC1pdGVtLWluZm97aGVpZ2h0OjEwMCU7dHJhbnNpdGlvbjpiYWNrZ3JvdW5kLWNvbG9yIC4zc30uYW50LXVwbG9hZC1saXN0LWl0ZW0taW5mbz5zcGFue2Rpc3BsYXk6YmxvY2s7d2lkdGg6MTAwJTtoZWlnaHQ6MTAwJX0uYW50LXVwbG9hZC1saXN0LWl0ZW0taW5mbyAuYW50LXVwbG9hZC10ZXh0LWljb24gLmFudGljb24sLmFudC11cGxvYWQtbGlzdC1pdGVtLWluZm8gLmFudGljb24tbG9hZGluZyAuYW50aWNvbntwb3NpdGlvbjphYnNvbHV0ZTt0b3A6NXB4O2NvbG9yOnJnYmEoMCwwLDAsLjQ1KTtmb250LXNpemU6MTRweH0uYW50LXVwbG9hZC1saXN0LWl0ZW06aG92ZXIgLmFudC11cGxvYWQtbGlzdC1pdGVtLWluZm97YmFja2dyb3VuZC1jb2xvcjojZjVmNWY1fS5hbnQtdXBsb2FkLWxpc3QtaXRlbTpob3ZlciAuYW50LXVwbG9hZC1saXN0LWl0ZW0tY2FyZC1hY3Rpb25zLWJ0bntvcGFjaXR5OjF9LmFudC11cGxvYWQtbGlzdC1pdGVtLWVycm9yLC5hbnQtdXBsb2FkLWxpc3QtaXRlbS1lcnJvciAuYW50LXVwbG9hZC1saXN0LWl0ZW0tY2FyZC1hY3Rpb25zIC5hbnRpY29uLC5hbnQtdXBsb2FkLWxpc3QtaXRlbS1lcnJvciAuYW50LXVwbG9hZC1saXN0LWl0ZW0tbmFtZSwuYW50LXVwbG9hZC1saXN0LWl0ZW0tZXJyb3IgLmFudC11cGxvYWQtdGV4dC1pY29uPi5hbnRpY29ue2NvbG9yOiNmZjRkNGZ9LmFudC11cGxvYWQtbGlzdC1pdGVtLWVycm9yIC5hbnQtdXBsb2FkLWxpc3QtaXRlbS1jYXJkLWFjdGlvbnMtYnRue29wYWNpdHk6MX0uYW50LXVwbG9hZC1saXN0LWl0ZW0tcHJvZ3Jlc3N7cG9zaXRpb246YWJzb2x1dGU7Ym90dG9tOi0xMnB4O3dpZHRoOjEwMCU7cGFkZGluZy1sZWZ0OjI2cHg7Zm9udC1zaXplOjE0cHg7bGluZS1oZWlnaHQ6MH0uYW50LXVwbG9hZC1saXN0LXBpY3R1cmUtY2FyZCAuYW50LXVwbG9hZC1saXN0LWl0ZW0sLmFudC11cGxvYWQtbGlzdC1waWN0dXJlIC5hbnQtdXBsb2FkLWxpc3QtaXRlbXtwb3NpdGlvbjpyZWxhdGl2ZTtoZWlnaHQ6NjZweDtwYWRkaW5nOjhweDtib3JkZXI6MXB4IHNvbGlkICNkOWQ5ZDk7Ym9yZGVyLXJhZGl1czoycHh9LmFudC11cGxvYWQtbGlzdC1waWN0dXJlLWNhcmQgLmFudC11cGxvYWQtbGlzdC1pdGVtOmhvdmVyLC5hbnQtdXBsb2FkLWxpc3QtcGljdHVyZSAuYW50LXVwbG9hZC1saXN0LWl0ZW06aG92ZXJ7YmFja2dyb3VuZDp0cmFuc3BhcmVudH0uYW50LXVwbG9hZC1saXN0LXBpY3R1cmUtY2FyZCAuYW50LXVwbG9hZC1saXN0LWl0ZW0tZXJyb3IsLmFudC11cGxvYWQtbGlzdC1waWN0dXJlIC5hbnQtdXBsb2FkLWxpc3QtaXRlbS1lcnJvcntib3JkZXItY29sb3I6I2ZmNGQ0Zn0uYW50LXVwbG9hZC1saXN0LXBpY3R1cmUtY2FyZCAuYW50LXVwbG9hZC1saXN0LWl0ZW06aG92ZXIgLmFudC11cGxvYWQtbGlzdC1pdGVtLWluZm8sLmFudC11cGxvYWQtbGlzdC1waWN0dXJlIC5hbnQtdXBsb2FkLWxpc3QtaXRlbTpob3ZlciAuYW50LXVwbG9hZC1saXN0LWl0ZW0taW5mb3tiYWNrZ3JvdW5kOnRyYW5zcGFyZW50fS5hbnQtdXBsb2FkLWxpc3QtcGljdHVyZS1jYXJkIC5hbnQtdXBsb2FkLWxpc3QtaXRlbS11cGxvYWRpbmcsLmFudC11cGxvYWQtbGlzdC1waWN0dXJlIC5hbnQtdXBsb2FkLWxpc3QtaXRlbS11cGxvYWRpbmd7Ym9yZGVyLXN0eWxlOmRhc2hlZH0uYW50LXVwbG9hZC1saXN0LXBpY3R1cmUtY2FyZCAuYW50LXVwbG9hZC1saXN0LWl0ZW0tdGh1bWJuYWlsLC5hbnQtdXBsb2FkLWxpc3QtcGljdHVyZSAuYW50LXVwbG9hZC1saXN0LWl0ZW0tdGh1bWJuYWlse3dpZHRoOjQ4cHg7aGVpZ2h0OjQ4cHg7bGluZS1oZWlnaHQ6NjBweDt0ZXh0LWFsaWduOmNlbnRlcjtvcGFjaXR5Oi44fS5hbnQtdXBsb2FkLWxpc3QtcGljdHVyZS1jYXJkIC5hbnQtdXBsb2FkLWxpc3QtaXRlbS10aHVtYm5haWwgLmFudGljb24sLmFudC11cGxvYWQtbGlzdC1waWN0dXJlIC5hbnQtdXBsb2FkLWxpc3QtaXRlbS10aHVtYm5haWwgLmFudGljb257Zm9udC1zaXplOjI2cHh9LmFudC11cGxvYWQtbGlzdC1waWN0dXJlLWNhcmQgLmFudC11cGxvYWQtbGlzdC1pdGVtLWVycm9yIC5hbnQtdXBsb2FkLWxpc3QtaXRlbS10aHVtYm5haWwgLmFudGljb24gc3ZnIHBhdGhbZmlsbD1cIiNlNmY3ZmZcIl0sLmFudC11cGxvYWQtbGlzdC1waWN0dXJlIC5hbnQtdXBsb2FkLWxpc3QtaXRlbS1lcnJvciAuYW50LXVwbG9hZC1saXN0LWl0ZW0tdGh1bWJuYWlsIC5hbnRpY29uIHN2ZyBwYXRoW2ZpbGw9XCIjZTZmN2ZmXCJde2ZpbGw6I2ZmZjJmMH0uYW50LXVwbG9hZC1saXN0LXBpY3R1cmUtY2FyZCAuYW50LXVwbG9hZC1saXN0LWl0ZW0tZXJyb3IgLmFudC11cGxvYWQtbGlzdC1pdGVtLXRodW1ibmFpbCAuYW50aWNvbiBzdmcgcGF0aFtmaWxsPVwiIzE4OTBmZlwiXSwuYW50LXVwbG9hZC1saXN0LXBpY3R1cmUgLmFudC11cGxvYWQtbGlzdC1pdGVtLWVycm9yIC5hbnQtdXBsb2FkLWxpc3QtaXRlbS10aHVtYm5haWwgLmFudGljb24gc3ZnIHBhdGhbZmlsbD1cIiMxODkwZmZcIl17ZmlsbDojZmY0ZDRmfS5hbnQtdXBsb2FkLWxpc3QtcGljdHVyZS1jYXJkIC5hbnQtdXBsb2FkLWxpc3QtaXRlbS1pY29uLC5hbnQtdXBsb2FkLWxpc3QtcGljdHVyZSAuYW50LXVwbG9hZC1saXN0LWl0ZW0taWNvbntwb3NpdGlvbjphYnNvbHV0ZTt0b3A6NTAlO2xlZnQ6NTAlO2ZvbnQtc2l6ZToyNnB4O3RyYW5zZm9ybTp0cmFuc2xhdGUoLTUwJSwtNTAlKX0uYW50LXVwbG9hZC1saXN0LXBpY3R1cmUtY2FyZCAuYW50LXVwbG9hZC1saXN0LWl0ZW0taWNvbiAuYW50aWNvbiwuYW50LXVwbG9hZC1saXN0LXBpY3R1cmUgLmFudC11cGxvYWQtbGlzdC1pdGVtLWljb24gLmFudGljb257Zm9udC1zaXplOjI2cHh9LmFudC11cGxvYWQtbGlzdC1waWN0dXJlLWNhcmQgLmFudC11cGxvYWQtbGlzdC1pdGVtLWltYWdlLC5hbnQtdXBsb2FkLWxpc3QtcGljdHVyZSAuYW50LXVwbG9hZC1saXN0LWl0ZW0taW1hZ2V7bWF4LXdpZHRoOjEwMCV9LmFudC11cGxvYWQtbGlzdC1waWN0dXJlLWNhcmQgLmFudC11cGxvYWQtbGlzdC1pdGVtLXRodW1ibmFpbCBpbWcsLmFudC11cGxvYWQtbGlzdC1waWN0dXJlIC5hbnQtdXBsb2FkLWxpc3QtaXRlbS10aHVtYm5haWwgaW1ne2Rpc3BsYXk6YmxvY2s7d2lkdGg6NDhweDtoZWlnaHQ6NDhweDtvdmVyZmxvdzpoaWRkZW59LmFudC11cGxvYWQtbGlzdC1waWN0dXJlLWNhcmQgLmFudC11cGxvYWQtbGlzdC1pdGVtLW5hbWUsLmFudC11cGxvYWQtbGlzdC1waWN0dXJlIC5hbnQtdXBsb2FkLWxpc3QtaXRlbS1uYW1le2Rpc3BsYXk6aW5saW5lLWJsb2NrO2JveC1zaXppbmc6Ym9yZGVyLWJveDttYXgtd2lkdGg6MTAwJTttYXJnaW46MCAwIDAgOHB4O3BhZGRpbmctcmlnaHQ6OHB4O3BhZGRpbmctbGVmdDo0OHB4O292ZXJmbG93OmhpZGRlbjtsaW5lLWhlaWdodDo0NHB4O3doaXRlLXNwYWNlOm5vd3JhcDt0ZXh0LW92ZXJmbG93OmVsbGlwc2lzO3RyYW5zaXRpb246YWxsIC4zc30uYW50LXVwbG9hZC1saXN0LXBpY3R1cmUtY2FyZCAuYW50LXVwbG9hZC1saXN0LWl0ZW0tdXBsb2FkaW5nIC5hbnQtdXBsb2FkLWxpc3QtaXRlbS1uYW1lLC5hbnQtdXBsb2FkLWxpc3QtcGljdHVyZSAuYW50LXVwbG9hZC1saXN0LWl0ZW0tdXBsb2FkaW5nIC5hbnQtdXBsb2FkLWxpc3QtaXRlbS1uYW1le21hcmdpbi1ib3R0b206MTJweH0uYW50LXVwbG9hZC1saXN0LXBpY3R1cmUtY2FyZCAuYW50LXVwbG9hZC1saXN0LWl0ZW0tcHJvZ3Jlc3MsLmFudC11cGxvYWQtbGlzdC1waWN0dXJlIC5hbnQtdXBsb2FkLWxpc3QtaXRlbS1wcm9ncmVzc3tib3R0b206MTRweDt3aWR0aDpjYWxjKDEwMCUgLSAyNHB4KTttYXJnaW4tdG9wOjA7cGFkZGluZy1sZWZ0OjU2cHh9LmFudC11cGxvYWQtbGlzdC1waWN0dXJlLWNhcmQtY29udGFpbmVye2Rpc3BsYXk6aW5saW5lLWJsb2NrO3dpZHRoOjEwNHB4O2hlaWdodDoxMDRweDttYXJnaW46MCA4cHggOHB4IDA7dmVydGljYWwtYWxpZ246dG9wfS5hbnQtdXBsb2FkLWxpc3QtcGljdHVyZS1jYXJkIC5hbnQtdXBsb2FkLWxpc3QtaXRlbXtoZWlnaHQ6MTAwJTttYXJnaW46MH0uYW50LXVwbG9hZC1saXN0LXBpY3R1cmUtY2FyZCAuYW50LXVwbG9hZC1saXN0LWl0ZW0taW5mb3twb3NpdGlvbjpyZWxhdGl2ZTtoZWlnaHQ6MTAwJTtvdmVyZmxvdzpoaWRkZW59LmFudC11cGxvYWQtbGlzdC1waWN0dXJlLWNhcmQgLmFudC11cGxvYWQtbGlzdC1pdGVtLWluZm86YmVmb3Jle3Bvc2l0aW9uOmFic29sdXRlO3otaW5kZXg6MTt3aWR0aDoxMDAlO2hlaWdodDoxMDAlO2JhY2tncm91bmQtY29sb3I6cmdiYSgwLDAsMCwuNSk7b3BhY2l0eTowO3RyYW5zaXRpb246YWxsIC4zcztjb250ZW50OlwiIFwifS5hbnQtdXBsb2FkLWxpc3QtcGljdHVyZS1jYXJkIC5hbnQtdXBsb2FkLWxpc3QtaXRlbTpob3ZlciAuYW50LXVwbG9hZC1saXN0LWl0ZW0taW5mbzpiZWZvcmV7b3BhY2l0eToxfS5hbnQtdXBsb2FkLWxpc3QtcGljdHVyZS1jYXJkIC5hbnQtdXBsb2FkLWxpc3QtaXRlbS1hY3Rpb25ze3Bvc2l0aW9uOmFic29sdXRlO3RvcDo1MCU7bGVmdDo1MCU7ei1pbmRleDoxMDt3aGl0ZS1zcGFjZTpub3dyYXA7dHJhbnNmb3JtOnRyYW5zbGF0ZSgtNTAlLC01MCUpO29wYWNpdHk6MDt0cmFuc2l0aW9uOmFsbCAuM3N9LmFudC11cGxvYWQtbGlzdC1waWN0dXJlLWNhcmQgLmFudC11cGxvYWQtbGlzdC1pdGVtLWFjdGlvbnMgLmFudGljb24tZGVsZXRlLC5hbnQtdXBsb2FkLWxpc3QtcGljdHVyZS1jYXJkIC5hbnQtdXBsb2FkLWxpc3QtaXRlbS1hY3Rpb25zIC5hbnRpY29uLWRvd25sb2FkLC5hbnQtdXBsb2FkLWxpc3QtcGljdHVyZS1jYXJkIC5hbnQtdXBsb2FkLWxpc3QtaXRlbS1hY3Rpb25zIC5hbnRpY29uLWV5ZXt6LWluZGV4OjEwO3dpZHRoOjE2cHg7bWFyZ2luOjAgNHB4O2NvbG9yOmhzbGEoMCwwJSwxMDAlLC44NSk7Zm9udC1zaXplOjE2cHg7Y3Vyc29yOnBvaW50ZXI7dHJhbnNpdGlvbjphbGwgLjNzfS5hbnQtdXBsb2FkLWxpc3QtcGljdHVyZS1jYXJkIC5hbnQtdXBsb2FkLWxpc3QtaXRlbS1hY3Rpb25zIC5hbnRpY29uLWRlbGV0ZTpob3ZlciwuYW50LXVwbG9hZC1saXN0LXBpY3R1cmUtY2FyZCAuYW50LXVwbG9hZC1saXN0LWl0ZW0tYWN0aW9ucyAuYW50aWNvbi1kb3dubG9hZDpob3ZlciwuYW50LXVwbG9hZC1saXN0LXBpY3R1cmUtY2FyZCAuYW50LXVwbG9hZC1saXN0LWl0ZW0tYWN0aW9ucyAuYW50aWNvbi1leWU6aG92ZXJ7Y29sb3I6I2ZmZn0uYW50LXVwbG9hZC1saXN0LXBpY3R1cmUtY2FyZCAuYW50LXVwbG9hZC1saXN0LWl0ZW0tYWN0aW9uczpob3ZlciwuYW50LXVwbG9hZC1saXN0LXBpY3R1cmUtY2FyZCAuYW50LXVwbG9hZC1saXN0LWl0ZW0taW5mbzpob3ZlcisuYW50LXVwbG9hZC1saXN0LWl0ZW0tYWN0aW9uc3tvcGFjaXR5OjF9LmFudC11cGxvYWQtbGlzdC1waWN0dXJlLWNhcmQgLmFudC11cGxvYWQtbGlzdC1pdGVtLXRodW1ibmFpbCwuYW50LXVwbG9hZC1saXN0LXBpY3R1cmUtY2FyZCAuYW50LXVwbG9hZC1saXN0LWl0ZW0tdGh1bWJuYWlsIGltZ3twb3NpdGlvbjpzdGF0aWM7ZGlzcGxheTpibG9jazt3aWR0aDoxMDAlO2hlaWdodDoxMDAlOy1vLW9iamVjdC1maXQ6Y29udGFpbjtvYmplY3QtZml0OmNvbnRhaW59LmFudC11cGxvYWQtbGlzdC1waWN0dXJlLWNhcmQgLmFudC11cGxvYWQtbGlzdC1pdGVtLW5hbWV7ZGlzcGxheTpub25lO21hcmdpbjo4cHggMCAwO3BhZGRpbmc6MDtsaW5lLWhlaWdodDoxLjU3MTU7dGV4dC1hbGlnbjpjZW50ZXJ9LmFudC11cGxvYWQtbGlzdC1waWN0dXJlLWNhcmQgLmFudC11cGxvYWQtbGlzdC1pdGVtLWZpbGUrLmFudC11cGxvYWQtbGlzdC1pdGVtLW5hbWV7cG9zaXRpb246YWJzb2x1dGU7Ym90dG9tOjEwcHg7ZGlzcGxheTpibG9ja30uYW50LXVwbG9hZC1saXN0LXBpY3R1cmUtY2FyZCAuYW50LXVwbG9hZC1saXN0LWl0ZW0tdXBsb2FkaW5nLmFudC11cGxvYWQtbGlzdC1pdGVte2JhY2tncm91bmQtY29sb3I6I2ZhZmFmYX0uYW50LXVwbG9hZC1saXN0LXBpY3R1cmUtY2FyZCAuYW50LXVwbG9hZC1saXN0LWl0ZW0tdXBsb2FkaW5nIC5hbnQtdXBsb2FkLWxpc3QtaXRlbS1pbmZve2hlaWdodDphdXRvfS5hbnQtdXBsb2FkLWxpc3QtcGljdHVyZS1jYXJkIC5hbnQtdXBsb2FkLWxpc3QtaXRlbS11cGxvYWRpbmcgLmFudC11cGxvYWQtbGlzdC1pdGVtLWluZm8gLmFudGljb24tZGVsZXRlLC5hbnQtdXBsb2FkLWxpc3QtcGljdHVyZS1jYXJkIC5hbnQtdXBsb2FkLWxpc3QtaXRlbS11cGxvYWRpbmcgLmFudC11cGxvYWQtbGlzdC1pdGVtLWluZm8gLmFudGljb24tZXllLC5hbnQtdXBsb2FkLWxpc3QtcGljdHVyZS1jYXJkIC5hbnQtdXBsb2FkLWxpc3QtaXRlbS11cGxvYWRpbmcgLmFudC11cGxvYWQtbGlzdC1pdGVtLWluZm86YmVmb3Jle2Rpc3BsYXk6bm9uZX0uYW50LXVwbG9hZC1saXN0LXBpY3R1cmUtY2FyZCAuYW50LXVwbG9hZC1saXN0LWl0ZW0tcHJvZ3Jlc3N7Ym90dG9tOjMycHg7d2lkdGg6Y2FsYygxMDAlIC0gMTRweCk7cGFkZGluZy1sZWZ0OjB9LmFudC11cGxvYWQtbGlzdC1waWN0dXJlLWNvbnRhaW5lciwuYW50LXVwbG9hZC1saXN0LXRleHQtY29udGFpbmVye3RyYW5zaXRpb246b3BhY2l0eSAuM3MsaGVpZ2h0IC4zc30uYW50LXVwbG9hZC1saXN0LXBpY3R1cmUtY29udGFpbmVyOmJlZm9yZSwuYW50LXVwbG9hZC1saXN0LXRleHQtY29udGFpbmVyOmJlZm9yZXtkaXNwbGF5OnRhYmxlO3dpZHRoOjA7aGVpZ2h0OjA7Y29udGVudDpcIlwifS5hbnQtdXBsb2FkLWxpc3QtcGljdHVyZS1jb250YWluZXIgLmFudC11cGxvYWQtc3BhbiwuYW50LXVwbG9hZC1saXN0LXRleHQtY29udGFpbmVyIC5hbnQtdXBsb2FkLXNwYW57ZGlzcGxheTpibG9jaztmbGV4OmF1dG99LmFudC11cGxvYWQtbGlzdC1waWN0dXJlIC5hbnQtdXBsb2FkLXNwYW4sLmFudC11cGxvYWQtbGlzdC10ZXh0IC5hbnQtdXBsb2FkLXNwYW57ZGlzcGxheTpmbGV4O2FsaWduLWl0ZW1zOmNlbnRlcn0uYW50LXVwbG9hZC1saXN0LXBpY3R1cmUgLmFudC11cGxvYWQtc3Bhbj4qLC5hbnQtdXBsb2FkLWxpc3QtdGV4dCAuYW50LXVwbG9hZC1zcGFuPip7ZmxleDpub25lfS5hbnQtdXBsb2FkLWxpc3QtcGljdHVyZSAuYW50LXVwbG9hZC1saXN0LWl0ZW0tbmFtZSwuYW50LXVwbG9hZC1saXN0LXRleHQgLmFudC11cGxvYWQtbGlzdC1pdGVtLW5hbWV7ZmxleDphdXRvO21hcmdpbjowO3BhZGRpbmc6MCA4cHh9LmFudC11cGxvYWQtbGlzdC1waWN0dXJlIC5hbnQtdXBsb2FkLWxpc3QtaXRlbS1jYXJkLWFjdGlvbnMsLmFudC11cGxvYWQtbGlzdC10ZXh0IC5hbnQtdXBsb2FkLWxpc3QtaXRlbS1jYXJkLWFjdGlvbnMsLmFudC11cGxvYWQtbGlzdC10ZXh0IC5hbnQtdXBsb2FkLXRleHQtaWNvbiAuYW50aWNvbntwb3NpdGlvbjpzdGF0aWN9LmFudC11cGxvYWQtbGlzdCAuYW50LXVwbG9hZC1hbmltYXRlLWlubGluZS1hcHBlYXIsLmFudC11cGxvYWQtbGlzdCAuYW50LXVwbG9hZC1hbmltYXRlLWlubGluZS1lbnRlciwuYW50LXVwbG9hZC1saXN0IC5hbnQtdXBsb2FkLWFuaW1hdGUtaW5saW5lLWxlYXZle2FuaW1hdGlvbi1kdXJhdGlvbjouM3M7YW5pbWF0aW9uLXRpbWluZy1mdW5jdGlvbjpjdWJpYy1iZXppZXIoLjc4LC4xNCwuMTUsLjg2KTthbmltYXRpb24tZmlsbC1tb2RlOmZvcndhcmRzfS5hbnQtdXBsb2FkLWxpc3QgLmFudC11cGxvYWQtYW5pbWF0ZS1pbmxpbmUtYXBwZWFyLC5hbnQtdXBsb2FkLWxpc3QgLmFudC11cGxvYWQtYW5pbWF0ZS1pbmxpbmUtZW50ZXJ7YW5pbWF0aW9uLW5hbWU6dXBsb2FkQW5pbWF0ZUlubGluZUlufS5hbnQtdXBsb2FkLWxpc3QgLmFudC11cGxvYWQtYW5pbWF0ZS1pbmxpbmUtbGVhdmV7YW5pbWF0aW9uLW5hbWU6dXBsb2FkQW5pbWF0ZUlubGluZU91dH1Aa2V5ZnJhbWVzIHVwbG9hZEFuaW1hdGVJbmxpbmVJbnswJXt3aWR0aDowO2hlaWdodDowO21hcmdpbjowO3BhZGRpbmc6MDtvcGFjaXR5OjB9fUBrZXlmcmFtZXMgdXBsb2FkQW5pbWF0ZUlubGluZU91dHt0b3t3aWR0aDowO2hlaWdodDowO21hcmdpbjowO3BhZGRpbmc6MDtvcGFjaXR5OjB9fS5hbnQtdXBsb2FkLXJ0bHtkaXJlY3Rpb246cnRsfS5hbnQtdXBsb2FkLXJ0bC5hbnQtdXBsb2FkLmFudC11cGxvYWQtc2VsZWN0LXBpY3R1cmUtY2FyZHttYXJnaW4tcmlnaHQ6YXV0bzttYXJnaW4tbGVmdDo4cHh9LmFudC11cGxvYWQtbGlzdC1ydGx7ZGlyZWN0aW9uOnJ0bH0uYW50LXVwbG9hZC1saXN0LXJ0bCAuYW50LXVwbG9hZC1saXN0LWl0ZW0tbGlzdC10eXBlLXRleHQ6aG92ZXIgLmFudC11cGxvYWQtbGlzdC1pdGVtLW5hbWUtaWNvbi1jb3VudC0xe3BhZGRpbmctcmlnaHQ6MjJweDtwYWRkaW5nLWxlZnQ6MTRweH0uYW50LXVwbG9hZC1saXN0LXJ0bCAuYW50LXVwbG9hZC1saXN0LWl0ZW0tbGlzdC10eXBlLXRleHQ6aG92ZXIgLmFudC11cGxvYWQtbGlzdC1pdGVtLW5hbWUtaWNvbi1jb3VudC0ye3BhZGRpbmctcmlnaHQ6MjJweDtwYWRkaW5nLWxlZnQ6MjhweH0uYW50LXVwbG9hZC1saXN0LXJ0bCAuYW50LXVwbG9hZC1saXN0LWl0ZW0tbmFtZXtwYWRkaW5nLXJpZ2h0OjIycHg7cGFkZGluZy1sZWZ0OjB9LmFudC11cGxvYWQtbGlzdC1ydGwgLmFudC11cGxvYWQtbGlzdC1pdGVtLW5hbWUtaWNvbi1jb3VudC0xe3BhZGRpbmctbGVmdDoxNHB4fS5hbnQtdXBsb2FkLWxpc3QtcnRsIC5hbnQtdXBsb2FkLWxpc3QtaXRlbS1jYXJkLWFjdGlvbnN7cmlnaHQ6YXV0bztsZWZ0OjB9LmFudC11cGxvYWQtbGlzdC1ydGwgLmFudC11cGxvYWQtbGlzdC1pdGVtLWNhcmQtYWN0aW9ucyAuYW50aWNvbntwYWRkaW5nLXJpZ2h0OjA7cGFkZGluZy1sZWZ0OjVweH0uYW50LXVwbG9hZC1saXN0LXJ0bCAuYW50LXVwbG9hZC1saXN0LWl0ZW0taW5mb3twYWRkaW5nOjAgNHB4IDAgMTJweH0uYW50LXVwbG9hZC1saXN0LXJ0bCAuYW50LXVwbG9hZC1saXN0LWl0ZW0tZXJyb3IgLmFudC11cGxvYWQtbGlzdC1pdGVtLWNhcmQtYWN0aW9ucyAuYW50aWNvbntwYWRkaW5nLXJpZ2h0OjA7cGFkZGluZy1sZWZ0OjVweH0uYW50LXVwbG9hZC1saXN0LXJ0bCAuYW50LXVwbG9hZC1saXN0LWl0ZW0tcHJvZ3Jlc3N7cGFkZGluZy1yaWdodDoyNnB4O3BhZGRpbmctbGVmdDowfS5hbnQtdXBsb2FkLWxpc3QtcGljdHVyZS1jYXJkIC5hbnQtdXBsb2FkLWxpc3QtaXRlbS1pbmZvLC5hbnQtdXBsb2FkLWxpc3QtcGljdHVyZSAuYW50LXVwbG9hZC1saXN0LWl0ZW0taW5mb3twYWRkaW5nOjB9LmFudC11cGxvYWQtbGlzdC1ydGwuYW50LXVwbG9hZC1saXN0LXBpY3R1cmUtY2FyZCAuYW50LXVwbG9hZC1saXN0LWl0ZW0tdGh1bWJuYWlsLC5hbnQtdXBsb2FkLWxpc3QtcnRsLmFudC11cGxvYWQtbGlzdC1waWN0dXJlIC5hbnQtdXBsb2FkLWxpc3QtaXRlbS10aHVtYm5haWx7cmlnaHQ6OHB4O2xlZnQ6YXV0b30uYW50LXVwbG9hZC1saXN0LXJ0bC5hbnQtdXBsb2FkLWxpc3QtcGljdHVyZS1jYXJkIC5hbnQtdXBsb2FkLWxpc3QtaXRlbS1pY29uLC5hbnQtdXBsb2FkLWxpc3QtcnRsLmFudC11cGxvYWQtbGlzdC1waWN0dXJlIC5hbnQtdXBsb2FkLWxpc3QtaXRlbS1pY29ue3JpZ2h0OjUwJTtsZWZ0OmF1dG87dHJhbnNmb3JtOnRyYW5zbGF0ZSg1MCUsLTUwJSl9LmFudC11cGxvYWQtbGlzdC1ydGwuYW50LXVwbG9hZC1saXN0LXBpY3R1cmUtY2FyZCAuYW50LXVwbG9hZC1saXN0LWl0ZW0tbmFtZSwuYW50LXVwbG9hZC1saXN0LXJ0bC5hbnQtdXBsb2FkLWxpc3QtcGljdHVyZSAuYW50LXVwbG9hZC1saXN0LWl0ZW0tbmFtZXttYXJnaW46MCA4cHggMCAwO3BhZGRpbmctcmlnaHQ6NDhweDtwYWRkaW5nLWxlZnQ6OHB4fS5hbnQtdXBsb2FkLWxpc3QtcnRsLmFudC11cGxvYWQtbGlzdC1waWN0dXJlLWNhcmQgLmFudC11cGxvYWQtbGlzdC1pdGVtLW5hbWUtaWNvbi1jb3VudC0xLC5hbnQtdXBsb2FkLWxpc3QtcnRsLmFudC11cGxvYWQtbGlzdC1waWN0dXJlIC5hbnQtdXBsb2FkLWxpc3QtaXRlbS1uYW1lLWljb24tY291bnQtMXtwYWRkaW5nLXJpZ2h0OjQ4cHg7cGFkZGluZy1sZWZ0OjE4cHh9LmFudC11cGxvYWQtbGlzdC1ydGwuYW50LXVwbG9hZC1saXN0LXBpY3R1cmUtY2FyZCAuYW50LXVwbG9hZC1saXN0LWl0ZW0tbmFtZS1pY29uLWNvdW50LTIsLmFudC11cGxvYWQtbGlzdC1ydGwuYW50LXVwbG9hZC1saXN0LXBpY3R1cmUgLmFudC11cGxvYWQtbGlzdC1pdGVtLW5hbWUtaWNvbi1jb3VudC0ye3BhZGRpbmctcmlnaHQ6NDhweDtwYWRkaW5nLWxlZnQ6MzZweH0uYW50LXVwbG9hZC1saXN0LXJ0bC5hbnQtdXBsb2FkLWxpc3QtcGljdHVyZS1jYXJkIC5hbnQtdXBsb2FkLWxpc3QtaXRlbS1wcm9ncmVzcywuYW50LXVwbG9hZC1saXN0LXJ0bC5hbnQtdXBsb2FkLWxpc3QtcGljdHVyZSAuYW50LXVwbG9hZC1saXN0LWl0ZW0tcHJvZ3Jlc3N7cGFkZGluZy1yaWdodDowO3BhZGRpbmctbGVmdDowfS5hbnQtdXBsb2FkLWxpc3QtcnRsIC5hbnQtdXBsb2FkLWxpc3QtcGljdHVyZS1jYXJkLWNvbnRhaW5lcnttYXJnaW46MCAwIDhweCA4cHh9LmFudC11cGxvYWQtbGlzdC1ydGwuYW50LXVwbG9hZC1saXN0LXBpY3R1cmUtY2FyZCAuYW50LXVwbG9hZC1saXN0LWl0ZW0tYWN0aW9uc3tyaWdodDo1MCU7bGVmdDphdXRvO3RyYW5zZm9ybTp0cmFuc2xhdGUoNTAlLC01MCUpfS5hbnQtdXBsb2FkLWxpc3QtcnRsLmFudC11cGxvYWQtbGlzdC1waWN0dXJlLWNhcmQgLmFudC11cGxvYWQtbGlzdC1pdGVtLWZpbGUrLmFudC11cGxvYWQtbGlzdC1pdGVtLW5hbWV7bWFyZ2luOjhweCAwIDA7cGFkZGluZzowfVxuLyojIHNvdXJjZU1hcHBpbmdVUkw9YW50ZC5taW4uY3NzLm1hcCovIiwiLy9DT05TVEFOVFNcbiRzcGFjZWFtb3VudHM6ICg1LCAxMCwgMTUsIDIwLCAyNSwgMzAsIDM1LCA0MCwgNDUsIDUwLCA3NSwgMTAwKTsgLy8gQWRqdXN0IHRoaXMgdG8gaW5jbHVkZSB0aGUgcGl4ZWwgYW1vdW50cyB5b3UgbmVlZC5cbiRzaWRlczogKHRvcCwgYm90dG9tLCBsZWZ0LCByaWdodCk7IC8vIExlYXZlIHRoaXMgdmFyaWFibGUgYWxvbmVcblxuLy89PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09XG4vLyAtR2xvYmFsIHN0eWxlIHN0YXJ0XG4vLz09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT1cblxuLy8gRGVmYXVsdCBzdHlsZSBzdGFydFxuKixcbio6OmJlZm9yZSxcbio6OmFmdGVyIHtcbiAgYm94LXNpemluZzogaW5oZXJpdDtcbn1cblxuI2FwcGxpY2F0aW9uLW1hbmdlci11aS1yb290IHtcbiAgYm94LXNpemluZzogYm9yZGVyLWJveDtcbiAgZm9udC1mYW1pbHk6ICRmb250LWRlZmF1bHQgIWltcG9ydGFudDtcbiAgYmFja2dyb3VuZC1jb2xvcjogJGJhY2tncm91bmQ7XG4gIG1pbi1oZWlnaHQ6IDEwMHZoO1xuICBtYXJnaW46IDA7XG4gIGZvbnQtc2l6ZTogMTZweDtcbiAgbGluZS1oZWlnaHQ6IDEuNTtcbiAgc2Nyb2xsLWJlaGF2aW9yOiBzbW9vdGg7XG4gIHRleHQtcmVuZGVyaW5nOiBvcHRpbWl6ZVNwZWVkO1xuICAtd2Via2l0LWZvbnQtc21vb3RoaW5nOiBhbnRpYWxpYXNlZDtcbiAgLW1vei1vc3gtZm9udC1zbW9vdGhpbmc6IGdyYXlzY2FsZTtcbiAgLXdlYmtpdC10ZXh0LXNpemUtYWRqdXN0OiAxMDAlO1xuICAtd2Via2l0LXRhcC1oaWdobGlnaHQtY29sb3I6IHRyYW5zcGFyZW50O1xufVxuXG4vKioqID09PT09PT09PT09PT09PT09IEZVTkNUSU9OUyA9PT09PT09PT09PT09PT09PSAqKiovXG5cbi8qXG5cblRoaXMgLnNjc3MgbG9vcCB3aWxsIGNyZWF0ZSBcIm1hcmdpbiBoZWxwZXJzXCIgYW5kIFwicGFkZGluZyBoZWxwZXJzXCIgXG5JdCB3aWxsIGdlbmVyYXRlIHNldmVyYWwgY2xhc3NlcyBzdWNoIGFzOlxuLm0tci0xMCB3aGljaCBnaXZlcyBtYXJnaW4tcmlnaHQgMTAgcGl4ZWxzLlxuLm0tci0xNSBnaXZlcyBNQVJHSU4gdG8gdGhlIFJJR0hUIDE1IHBpeGVscy5cbi5tLXQtMTUgZ2l2ZXMgTUFSR0lOIHRvIHRoZSBUT1AgMTUgcGl4ZWxzIGFuZCBzbyBvbi5cbi5wLWItNSBnaXZlcyBQQURESU5HIHRvIHRoZSBCT1RUT00gb2YgNSBwaXhlbHNcbi5wLWwtNDAgZ2l2ZXMgUEFERElORyB0byB0aGUgTEVGVCBvZiA0MCBwaXhlbHNcblRoZSBmaXJzdCBsZXR0ZXIgaXMgXCJtXCIgb3IgXCJwXCIgZm9yIE1BUkdJTiBvciBQQURESU5HXG5TZWNvbmQgbGV0dGVyIGlzIFwidFwiLCBcImJcIiwgXCJsXCIsIG9yIFwiclwiIGZvciBUT1AsIEJPVFRPTSwgTEVGVCwgb3IgUklHSFRcblRoaXJkIGxldHRlciBpcyB0aGUgbnVtYmVyIG9mIHNwYWNpbmcgaW4gcGl4ZWxzLiBBZGp1c3QgdGhlIGFtb3VudHMgZ2VuZXJhdGVkIGJ5IGVkaXRpbmcgdGhlICRzcGFjZWFtb3VudHMgdmFyaWFibGUgYmVsb3cuXG5cbiovXG5cbkBlYWNoICRzcGFjZSBpbiAkc3BhY2VhbW91bnRzIHtcbiAgQGVhY2ggJHNpZGUgaW4gJHNpZGVzIHtcbiAgICAubS0je3N0ci1zbGljZSgkc2lkZSwgMCwgMSl9LSN7JHNwYWNlfSB7XG4gICAgICBtYXJnaW4tI3skc2lkZX06ICN7JHNwYWNlfXB4ICFpbXBvcnRhbnQ7XG4gICAgfVxuXG4gICAgLnAtI3tzdHItc2xpY2UoJHNpZGUsIDAsIDEpfS0jeyRzcGFjZX0ge1xuICAgICAgcGFkZGluZy0jeyRzaWRlfTogI3skc3BhY2V9cHggIWltcG9ydGFudDtcbiAgICB9XG4gIH1cbn1cblxuLyogaWYgeW91IHdhbnQgaXQgZm9yIGFsbCBzaWRlcyBsaWtlIG0tMTAgcC0xMCAqL1xuXG5AZWFjaCAkc3BhY2UgaW4gJHNwYWNlYW1vdW50cyB7XG4gIC5tLSN7JHNwYWNlfSB7XG4gICAgbWFyZ2luOiAjeyRzcGFjZX1weCAhaW1wb3J0YW50O1xuICB9XG4gIC5wLSN7JHNwYWNlfSB7XG4gICAgcGFkZGluZzogI3skc3BhY2V9cHggIWltcG9ydGFudDtcbiAgfVxufVxuXG4vKioqID09PT09PT09PT09PT09PT09IEZVTkNUSU9OUyBFTkRTID09PT09PT09PT09PT09PT09ICoqKi9cblxuLy89PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09XG4vLyAtR2xvYmFsIHN0eWxlICBlbmRcbi8vPT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PVxuXG4ucGFnZS10aXRsZSB7XG4gIHBhZGRpbmctbGVmdDogNDBweDtcbn1cbiIsIi8vPT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PVxuLy8gLVZhcmlhYmxlcyBzdGFydFxuLy89PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09XG5cbi8vIENvbG9ycyBzdGFydFxuXG4vLyBkZWZpbmUgeW91ciB2YXJzIG9yIG92ZXJyaWRlIENhcmJvbiB2YXJzXG4kYmFja2dyb3VuZDogI2YwZjNmNztcbiR3aGl0ZTogI2ZmZjtcbiRibGFjazogIzAwMDtcbiRkYXJrLWdyZXk6ICNlNGU2ZWI7XG4kbGlnaHQtZ3JleTogI2Y0ZjdmYjtcbiRsaWdodC1ncmV5QjogI2U4ZThlODtcbiRwcmltYXJ5OiAjMTA0YWNlO1xuJHByaW1hcnktbGlnaHQ6IGxpZ2h0ZW4oZGVzYXR1cmF0ZShhZGp1c3QtaHVlKCRwcmltYXJ5LCA1LjcpLCAyMiksIDEyLjQpO1xuJHNlY29uZGFyeTogIzE1MjkzNTtcbiRhbHRlcm5hdGU6ICMyNWRhZWQ7XG4kc2Vjb25kYXJ5LWRhcms6ICM0MzU4Nzc7XG4kZGFyazogIzIyMjIyMjtcbiRzaWx2ZXI6ICNjOGM4Yzg7XG4kZnJlbmNoZ3JheTogI2JlYmRjNDtcbiRtaW5lc2hhZnQ6ICMzMzMzMzM7XG4kdGVhbDogIzAwODQ4NztcbiRkYXJrLXNoYWRlOiAjNTY1NjU2O1xuJGRpc2FibGVkOiAjZGRkZGU1O1xuJGxpZ2h0LWJsdWU6ICNlNGY4Zjk7XG4kaXJvbjogI2NkZDFkNDtcbiRzaHV0dGxlZ3JheTogIzVhNjg3MjtcbiR5ZWxsb3ctbGlnaHQ6ICNmZmNhODc7XG4keWVsbG93LWRhcms6IGRhcmtlbigkeWVsbG93LWxpZ2h0LCA4LjgpO1xuJHByaW1hcnktbGlnaHQ6IGxpZ2h0ZW4oZGVzYXR1cmF0ZShhZGp1c3QtaHVlKCRwcmltYXJ5LCA1LjcpLCAyMiksIDEyLjQpO1xuLy9zdGF0dXNcbiRub3RzdGFydGVkOiAjZmZiNjVhO1xuJGlucHJvZ3Jlc3M6ICMwMDIwNjk7XG4kY29tcGxldGVkOiAjMjVkYWVkO1xuJHRhYmxldGV4dC1jb2xvcjogIzE0MTQ5NztcbiRkcmF3ZXItY29sb3I6ICMxNzE3MTc7XG4vL2FsZXJ0c1xuJHdhcm5pbmc6ICNlMjYyMGM7XG5cbi8vIFR5cG9ncmFwaHkgRmFtaWx5XG4kZm9udC1kZWZhdWx0OiAnT3BlbiBTYW5zJywgc2Fucy1zZXJpZjtcbiRmb250LXByaW1lcnk6ICdNb250c2VycmF0Jywgc2Fucy1zZXJpZjtcbiRmb250LWlibTogJ0lCTSBQbGV4IFNhbnMnO1xuJGZvbnQtb3M6ICdPcGVuIFNhbnMnO1xuJGZvbnQtc2l6ZTE0OiAxNHB4O1xuJGZvbnQtc2l6ZTE2OiAxNnB4O1xuXG4vLyAkZm9udC1wYXRoOiBcIi4uL2ZvbnRzXCI7XG5cbi8vIFN1Y2Nlc3MgVUlcbiRzdWNjZWVkLW5hdi1oZWlnaHQ6IDcycHg7XG5cbi8vIERyYXdlclxuJHJpZ2h0LWRyYXdlci1oZWlnaHQ6IGNhbGMoMTAwdmggLSAjeyRzdWNjZWVkLW5hdi1oZWlnaHR9KTtcblxuLy8gVmFyaWFibGVzXG4kZm9udC1zdGFjazogJ09wZW4gU2FucycsIHNhbnMtc2VyaWY7XG4kcHJpbWFyeS1jb2xvcjogIzE0MTQ5OTtcbiR0YWJsZXRleHQtY29sb3I6ICMxNDE0OTc7XG4kYmxhY2stY29sb3I6ICMwMDAwMDA7XG4kdGFibGVoZWFkdGV4dC1jb2xvcjogIzE3MTcxNztcbiRmb250LXNpemUxNDogMTRweDtcblxuLy8gPT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PVxuLy8gLVZhcmlhYmxlcyBlbmRcbi8vID09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT1cbiIsIi5kYXRhLWltcG9ydCB7XG4gICYtaGVhZGVyIHtcbiAgICBib3JkZXItdG9wOiAxcHggc29saWQgI2M2YzZjNjtcbiAgICB3aWR0aDogMTAwJTtcbiAgICAmLW5vdC1zZWxlY3RlZCB7XG4gICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgYm9yZGVyLXdpZHRoOiA1cHg7XG4gICAgICBidXR0b24ge1xuICAgICAgICBoZWlnaHQ6IDQ4cHg7XG4gICAgICAgIHdpZHRoOiAxODBweDtcbiAgICAgICAgYmFja2dyb3VuZDogbGluZWFyLWdyYWRpZW50KDE4MGRlZywgI2ZmYjY1YSAwJSwgI2ZmYjY1YSAwJSwgI2ZlOTUyNyAxMDAlKTtcbiAgICAgIH1cblxuICAgICAgJi1sYWJlbCB7XG4gICAgICAgIHdpZHRoOiBjYWxjKDEwMCUgLSAxODBweCk7XG4gICAgICAgIHBhZGRpbmc6IDEwcHggMjBweDtcbiAgICAgICAgc3BhbiB7XG4gICAgICAgICAgY29sb3I6ICM4YzhjOGM7XG4gICAgICAgICAgZm9udC1mYW1pbHk6ICRmb250LWRlZmF1bHQ7XG4gICAgICAgICAgZm9udC1zaXplOiAkZm9udC1zaXplMTQ7XG4gICAgICAgICAgbGV0dGVyLXNwYWNpbmc6IDAuMTZweDtcbiAgICAgICAgfVxuICAgICAgfVxuICAgIH1cbiAgICAmLXNlbGVjdGVkIHtcbiAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICBoZWlnaHQ6IDQ4cHg7XG4gICAgICB3aWR0aDogMTAwJTtcbiAgICAgIGJhY2tncm91bmQ6IGxpbmVhci1ncmFkaWVudCgxODBkZWcsICMwZjI3NTcgMCUsICMwYTIyNTEgMCUsICMwOTE3MzQgMTAwJSk7XG4gICAgICAmLWxhYmVsIHtcbiAgICAgICAgcGFkZGluZzogMTBweCAyMHB4O1xuICAgICAgICBoZWlnaHQ6IDE4cHg7XG4gICAgICAgIHdpZHRoOiBjYWxjKDEwMCUgLSAoMTE1cHggKiA0KSk7XG4gICAgICAgIGNvbG9yOiAkd2hpdGU7XG4gICAgICAgIGZvbnQtZmFtaWx5OiAkZm9udC1kZWZhdWx0O1xuICAgICAgICBmb250LXNpemU6ICRmb250LXNpemUxNDtcbiAgICAgICAgbGV0dGVyLXNwYWNpbmc6IDAuMTZweDtcbiAgICAgICAgbGluZS1oZWlnaHQ6IDE4cHg7XG4gICAgICB9XG4gICAgICBidXR0b24ge1xuICAgICAgICBoZWlnaHQ6IDQ4cHg7XG4gICAgICAgIHdpZHRoOiAxMTVweDtcbiAgICAgICAgYmFja2dyb3VuZDogbGluZWFyLWdyYWRpZW50KDE4MGRlZywgIzBmMjc1NyAwJSwgIzBhMjI1MSAwJSwgIzA5MTczNCAxMDAlKTtcblxuICAgICAgICBjb2xvcjogJHdoaXRlO1xuICAgICAgICBmb250LWZhbWlseTogJGZvbnQtZGVmYXVsdDtcbiAgICAgICAgZm9udC1zaXplOiAkZm9udC1zaXplMTY7XG4gICAgICAgIGxldHRlci1zcGFjaW5nOiAwO1xuICAgICAgICBsaW5lLWhlaWdodDogMjRweDtcbiAgICAgIH1cbiAgICB9XG4gIH1cblxuICAubmV3LWRhdGEtaW1wb3J0LWJ0biB7XG4gICAgY29sb3I6ICRibGFjaztcbiAgICBiYWNrZ3JvdW5kLWltYWdlOiBsaW5lYXItZ3JhZGllbnQoMTgwZGVnLCByZ2JhKDI1NSwgMTgyLCA5MCwgMSkgMCUsICNmZmE1M2MgMTAwJSk7XG4gICAgZm9udC1zaXplOiAkZm9udC1zaXplMTY7XG4gICAgbGluZS1oZWlnaHQ6IDI0cHg7XG4gIH1cblxuICAvLyAubWFpbi1hZHZhbmNlLWZpbHRlci1zZWN0aW9uIHtcbiAgLy8gICBib3JkZXItbGVmdDogMXB4IHNvbGlkICNjNmM2YzY7XG4gIC8vICAgZGlzcGxheTogZmxleDtcbiAgLy8gICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAvLyAgIC5hZHZhbmNlLWZpbHRlci1idG4ge1xuICAvLyAgICAgd2lkdGg6IDIyMHB4O1xuICAvLyAgICAgZm9udC1zaXplOiAkZm9udC1zaXplMTY7XG4gIC8vICAgICBsZXR0ZXItc3BhY2luZzogMDtcbiAgLy8gICAgIGxpbmUtaGVpZ2h0OiAyMnB4O1xuICAvLyAgICAgY29sb3I6ICR0YWJsZXRleHQtY29sb3I7XG4gIC8vICAgICBwYWRkaW5nOiAxM3B4IDEwcHg7XG4gIC8vICAgICBkaXNwbGF5OiBmbGV4O1xuICAvLyAgICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gIC8vICAgICBib3JkZXI6IG5vbmU7XG4gIC8vICAgICBiYWNrZ3JvdW5kOiBsaW5lYXItZ3JhZGllbnQodG8gYm90dG9tLCB0cmFuc3BhcmVudCwgcmdiYSgwLCAwLCAwLCAwKSk7XG4gIC8vICAgICAmOmZvY3VzIHtcbiAgLy8gICAgICAgb3V0bGluZTogbm9uZTtcbiAgLy8gICAgIH1cbiAgLy8gICAgIC5pY29uIHtcbiAgLy8gICAgICAgbWFyZ2luLXJpZ2h0OiA4cHg7XG4gIC8vICAgICAgIHdpZHRoOiAxNnB4O1xuICAvLyAgICAgICBoZWlnaHQ6IDE2cHg7XG4gIC8vICAgICB9XG4gIC8vICAgfVxuICAvLyAgIC5hbnQtdGFibGUtY29sdW1uLXNvcnRlci1mdWxsIHtcbiAgLy8gICAgIG1hcmdpbi10b3A6IDBlbTtcbiAgLy8gICAgIG1hcmdpbi1ib3R0b206IDA7XG4gIC8vICAgICByaWdodDogMTBweDtcbiAgLy8gICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgLy8gICAgIHotaW5kZXg6IDk7XG4gIC8vICAgICB0b3A6IDM4cHg7XG4gIC8vICAgfVxuICAvLyB9XG59XG5cbi5sb3ItdG9vbHRpcCB7XG4gIHBhZGRpbmc6IDNweDtcbiAgaDQge1xuICAgIGNvbG9yOiB3aGl0ZTtcbiAgICBmb250LXdlaWdodDogYm9sZDtcbiAgfVxuICAubG9yLXN0YXRzIHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGp1c3RpZnktY29udGVudDogc3BhY2UtYmV0d2VlbjtcbiAgICBhbGlnbi1pdGVtczogZmxleC1zdGFydDtcbiAgICBwYWRkaW5nLWJvdHRvbTogMnB4O1xuICB9XG59XG5cbi5hbnQtdG9vbHRpcCAuYW50LXRvb2x0aXAtY29udGVudCB7XG4gIHdpZHRoOiAyNTBweDtcbn1cblxuLmFudC10b29sdGlwLWlubmVyIHtcbiAgY29sb3I6IHdoaXRlc21va2U7XG4gIGJhY2tncm91bmQtY29sb3I6ICMzYTNiM2Q7XG59XG5cbi5sb3ItdGV4dCB7XG4gIGJvcmRlci1ib3R0b206IDFweCBkYXNoZWQgIzI3MjcyODtcbn1cblxuLmFudC10b29sdGlwLWFycm93LWNvbnRlbnQge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjM2EzYjNkO1xufVxuXG4ubWFpblBlcmZvcm1UaW1lV3JhcHBlciB7XG4gIGJhY2tncm91bmQtY29sb3I6ICR3aGl0ZTtcbiAgcGFkZGluZzogMjBweDtcbiAgLnBhZ2VwYXJhIHtcbiAgICBjb2xvcjogIzI3MjcyODtcbiAgICBmb250LWZhbWlseTogJGZvbnQtaWJtO1xuICAgIGZvbnQtc2l6ZTogJGZvbnQtc2l6ZTE2O1xuICAgIGxldHRlci1zcGFjaW5nOiAwO1xuICAgIGxpbmUtaGVpZ2h0OiAyMnB4O1xuICAgIG1hcmdpbjogMDtcbiAgfVxuXG4gIC5sYWJlbE5hbWUge1xuICAgIGNvbG9yOiAjMTcxNzE3O1xuICAgIGZvbnQtZmFtaWx5OiAkZm9udC1pYm07XG4gICAgZm9udC1zaXplOiAyMHB4O1xuICAgIGxldHRlci1zcGFjaW5nOiAwO1xuICAgIGxpbmUtaGVpZ2h0OiAyNnB4O1xuICAgIG1hcmdpbjogMjBweCAwIDIwcHggMDtcbiAgICBkaXNwbGF5OiBpbmxpbmUtYmxvY2s7XG4gIH1cbiAgLm1haW5TZWxlY3RSb3cge1xuICAgIG1hcmdpbi1ib3R0b206IDIwcHg7XG4gIH1cblxuICAuc2VsZWN0TGFiZWwge1xuICAgIGNvbG9yOiAjNTE1MTUyO1xuICAgIGZvbnQtZmFtaWx5OiAkZm9udC1pYm07XG4gICAgZm9udC1zaXplOiAkZm9udC1zaXplMTY7XG4gICAgbGV0dGVyLXNwYWNpbmc6IDA7XG4gICAgbGluZS1oZWlnaHQ6IDIwcHg7XG4gICAgbWFyZ2luLWJvdHRvbTogNXB4O1xuICB9XG5cbiAgLnN1YlNlY3Rpb25zIHtcbiAgICA+IC5zdWJTZWN0aW9uIHtcbiAgICAgIHBhZGRpbmc6IDMwcHggMHB4O1xuXG4gICAgICAmOmZpcnN0LWNoaWxkIHtcbiAgICAgICAgcGFkZGluZy10b3A6IDBweDtcbiAgICAgIH1cblxuICAgICAgJjpsYXN0LWNoaWxkIHtcbiAgICAgICAgcGFkZGluZy1ib3R0b206IDBweDtcbiAgICAgIH1cbiAgICB9XG4gIH1cbn1cblxuLm1haW5Db25maWdTZWN0aW9uIHtcbiAgaGVpZ2h0OiAxMDB2aDtcbiAgLm1haW5QZXJmb3JtVGltZVdyYXBwZXIge1xuICAgIG1hcmdpbjogMHB4IDMwcHg7XG4gICAgcGFkZGluZzogMzBweCAyMHB4O1xuICAgIC5jb25maWdMaW5rIHtcbiAgICAgIGNvbG9yOiAjM2I3YmM2O1xuICAgICAgZm9udC1mYW1pbHk6ICRmb250LWRlZmF1bHQ7XG4gICAgICBmb250LXNpemU6ICRmb250LXNpemUxNDtcbiAgICAgIGZvbnQtd2VpZ2h0OiA2MDA7XG4gICAgICBsZXR0ZXItc3BhY2luZzogMDtcbiAgICAgIGxpbmUtaGVpZ2h0OiAxOXB4O1xuICAgIH1cbiAgICAuY29uZmlnVGV4dCB7XG4gICAgICBjb2xvcjogIzJkMmQyZDtcbiAgICAgIGZvbnQtZmFtaWx5OiAkZm9udC1kZWZhdWx0O1xuICAgICAgZm9udC1zaXplOiAkZm9udC1zaXplMTQ7XG4gICAgICBsZXR0ZXItc3BhY2luZzogMDtcbiAgICAgIGxpbmUtaGVpZ2h0OiAyMHB4O1xuICAgIH1cbiAgICAudXBkYXRlVGltZSB7XG4gICAgICBjb2xvcjogIzJkMmQyZDtcbiAgICAgIGZvbnQtZmFtaWx5OiAkZm9udC1kZWZhdWx0O1xuICAgICAgZm9udC1zaXplOiAkZm9udC1zaXplMTQ7XG4gICAgICBsZXR0ZXItc3BhY2luZzogMDtcbiAgICAgIGxpbmUtaGVpZ2h0OiAyMHB4O1xuICAgIH1cbiAgfVxufVxuXG50ZXh0YXJlYS5hbnQtaW5wdXQsXG4uZHJhd2VySW5wdXQge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjZWRlZmY1O1xuICBib3JkZXI6IHRyYW5zcGFyZW50O1xuICBwYWRkaW5nOiA1cHggMTFweDtcbiAgYm9yZGVyLWJvdHRvbTogMXB4IHNvbGlkICM4ZThlOTA7XG4gIGZvbnQtZmFtaWx5OiAkZm9udC1pYm07XG4gIGZvbnQtc2l6ZTogJGZvbnQtc2l6ZTE2O1xuICBsZXR0ZXItc3BhY2luZzogMDtcbiAgbGluZS1oZWlnaHQ6IDIycHg7XG4gIHdpZHRoOiAxMDAlO1xuICBtYXJnaW4tdG9wOiA1cHg7XG4gICY6aG92ZXIsXG4gICY6Zm9jdXMge1xuICAgIGJvcmRlci1ib3R0b206IDFweCBzb2xpZCAjOGU4ZTkwO1xuICAgIGJveC1zaGFkb3c6IG5vbmU7XG4gICAgb3V0bGluZTogbm9uZTtcbiAgfVxuICAmOjpwbGFjZWhvbGRlciB7XG4gICAgY29sb3I6ICNhMmEyYTQ7XG4gIH1cbn1cblxuLmxvYWRpbmdfY29udGFpbmVyIHtcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xuICBtYXJnaW46IDUwcHggMHB4IDIwcHggMHB4O1xufVxuXG4udmFsaWRhdGlvbi1lcnJvci1tZXNzYWdlIHtcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGZsZXgtc3RhcnQ7XG4gIG1hcmdpbi10b3A6IDRweDtcbiAgc3ZnIHtcbiAgICB3aWR0aDogMjVweCAhaW1wb3J0YW50O1xuICB9XG4gIHNwYW4ge1xuICAgIG1hcmdpbi10b3A6IC00cHg7XG4gICAgY29sb3I6IHJlZDtcbiAgfVxufVxuIiwiLm1haW4tY29udGVudCB7XG4gIG1pbi1oZWlnaHQ6IDEwMHZoO1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xufVxuXG4ubmV3LWRhdGEtaW1wb3J0IHtcbiAgLm1haW4taGVhZGVyLXNlYyB7XG4gICAgcGFkZGluZy10b3A6IDA7XG4gICAgcGFkZGluZy1yaWdodDogMzBweDtcbiAgfVxuICAuYnRuc1NlY3Rpb24ge1xuICAgIHBhZGRpbmc6IDMwcHggMDtcbiAgfVxuXG4gIC5zZWN0aW9uIHtcbiAgICBtYXJnaW4tdG9wOiAyMHB4O1xuICAgIC5sYWJlbE5hbWUge1xuICAgICAgY29sb3I6ICRkcmF3ZXItY29sb3I7XG4gICAgICBmb250LWZhbWlseTogJGZvbnQtZGVmYXVsdDtcbiAgICAgIGZvbnQtc2l6ZTogJGZvbnQtc2l6ZTE0O1xuICAgICAgbGV0dGVyLXNwYWNpbmc6IDAuMTZweDtcbiAgICAgIGxpbmUtaGVpZ2h0OiAxOHB4O1xuICAgIH1cbiAgICAudXBsb2FkUGFyYSB7XG4gICAgICBjb2xvcjogcmdiYSgwLCAwLCAwLCAwLjg3KTtcbiAgICAgIGZvbnQtZmFtaWx5OiAkZm9udC1kZWZhdWx0O1xuICAgICAgZm9udC1zaXplOiAkZm9udC1zaXplMTY7XG4gICAgICBsZXR0ZXItc3BhY2luZzogMDtcbiAgICAgIGxpbmUtaGVpZ2h0OiAyNHB4O1xuICAgICAgc3BhbiB7XG4gICAgICAgIGRpc3BsYXk6IGJsb2NrO1xuICAgICAgfVxuICAgIH1cbiAgICBzdHJvbmcge1xuICAgICAgY29sb3I6IHJnYmEoMCwgMCwgMCwgMC44Nyk7XG4gICAgICBmb250LWZhbWlseTogJGZvbnQtZGVmYXVsdDtcbiAgICAgIGZvbnQtc2l6ZTogJGZvbnQtc2l6ZTE2O1xuICAgICAgZm9udC1zdHlsZTogaXRhbGljO1xuICAgICAgbGV0dGVyLXNwYWNpbmc6IDA7XG4gICAgICBsaW5lLWhlaWdodDogMjJweDtcbiAgICAgIGEge1xuICAgICAgICBjb2xvcjogJHRhYmxldGV4dC1jb2xvcjtcbiAgICAgICAgdGV4dC1kZWNvcmF0aW9uOiB1bmRlcmxpbmU7XG4gICAgICB9XG4gICAgfVxuICAgIC51cGxvYWRIZWFkaW5nIHtcbiAgICAgIGNvbG9yOiAkZHJhd2VyLWNvbG9yO1xuICAgICAgZm9udC1mYW1pbHk6ICRmb250LWRlZmF1bHQ7XG4gICAgICBmb250LXNpemU6ICRmb250LXNpemUxNjtcbiAgICAgIGZvbnQtd2VpZ2h0OiA2MDA7XG4gICAgICBsZXR0ZXItc3BhY2luZzogMDtcbiAgICAgIGxpbmUtaGVpZ2h0OiAyMnB4O1xuICAgICAgcGFkZGluZzogMTVweCAwIDNweCAwO1xuICAgIH1cbiAgICAudXBsb2FkY29udCB7XG4gICAgICBjb2xvcjogIzUxNTE1MjtcbiAgICAgIGZvbnQtZmFtaWx5OiAkZm9udC1pYm07XG4gICAgICBmb250LXNpemU6ICRmb250LXNpemUxNDtcbiAgICAgIGxldHRlci1zcGFjaW5nOiAwO1xuICAgICAgbGluZS1oZWlnaHQ6IDE4cHg7XG4gICAgfVxuICAgIC51cGxvYWRTZWN0aW9uIHtcbiAgICAgIHBhZGRpbmc6IDBweCAxMnB4O1xuICAgIH1cbiAgICAuaW5mb0hlYWRpbmcge1xuICAgICAgcGFkZGluZzogOHB4IDA7XG4gICAgICBtYXJnaW46IDBweDtcbiAgICAgIGZvbnQtc2l6ZTogJGZvbnQtc2l6ZTE2ICsgMjtcbiAgICAgIGZvbnQtd2VpZ2h0OiBib2xkO1xuICAgIH1cbiAgICAucmFkaW9WYWx1ZSB7XG4gICAgICBwYWRkaW5nLWxlZnQ6IDEwcHg7XG4gICAgICAucmFkaW8taXRlbSB7XG4gICAgICAgIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgICAgICAgbWFyZ2luLWJvdHRvbTogMTJweDtcbiAgICAgIH1cbiAgICB9XG4gICAgLnJhZGlvSW1wb3J0IHtcbiAgICAgIHBhZGRpbmctbGVmdDogMTBweDtcbiAgICB9XG4gICAgLmZpbGVVcGxvYWRidG4ge1xuICAgICAgcGFkZGluZy10b3A6IDE1cHg7XG4gICAgICBidXR0b24ge1xuICAgICAgICBiYWNrZ3JvdW5kOiBsaW5lYXItZ3JhZGllbnQoMTgwZGVnLCAjMjYyNmUzIDAlLCAkdGFibGV0ZXh0LWNvbG9yIDEwMCUpO1xuICAgICAgICBib3JkZXI6IG5vbmU7XG4gICAgICAgIGJvcmRlci1yYWRpdXM6IDRweDtcbiAgICAgICAgLXdlYmtpdC1ib3JkZXItcmFkaXVzOiA0cHg7XG4gICAgICAgIC1tb3otYm9yZGVyLXJhZGl1czogNHB4O1xuICAgICAgICAtbXMtYm9yZGVyLXJhZGl1czogNHB4O1xuICAgICAgICAtby1ib3JkZXItcmFkaXVzOiA0cHg7XG4gICAgICAgIGNvbG9yOiAkd2hpdGU7XG4gICAgICAgIGZvbnQtZmFtaWx5OiAkZm9udC1pYm07XG4gICAgICAgIGZvbnQtc2l6ZTogJGZvbnQtc2l6ZTE2O1xuICAgICAgICBsZXR0ZXItc3BhY2luZzogMDtcbiAgICAgICAgbGluZS1oZWlnaHQ6IDIwcHg7XG4gICAgICAgIGN1cnNvcjogcG9pbnRlcjtcbiAgICAgICAgcGFkZGluZzogNXB4IDEwcHg7XG4gICAgICAgICY6Zm9jdXMge1xuICAgICAgICAgIG91dGxpbmU6IG5vbmU7XG4gICAgICAgIH1cbiAgICAgIH1cbiAgICB9XG4gIH1cbiAgLmltcHJ0UnVsZXMge1xuICAgIC5hbnQtY2hlY2tib3gtd3JhcHBlciB7XG4gICAgICBwYWRkaW5nLWxlZnQ6IDEwcHg7XG4gICAgICBsaW5lLWhlaWdodDogMjhweDtcbiAgICB9XG4gICAgLmNoZWNrYm94IC5hbnQtY2hlY2tib3ggLmFudC1jaGVja2JveC1pbm5lciB7XG4gICAgICBib3JkZXItY29sb3I6ICRibGFjaztcbiAgICB9XG4gICAgLmNoZWNrYm94IC5hbnQtY2hlY2tib3gtY2hlY2tlZCAuYW50LWNoZWNrYm94LWlubmVyIHtcbiAgICAgIGJhY2tncm91bmQtaW1hZ2U6IG5vbmU7XG4gICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAkYmxhY2s7XG4gICAgfVxuICB9XG5cbiAgLm1haW5VcGxvYWRGaWxlU2VjdGlvbiB7XG4gICAgYmFja2dyb3VuZDogI2VkZWRmZDtcbiAgICBtYXJnaW4tdG9wOiAzMHB4O1xuICAgIG1hcmdpbi1ib3R0b206IDIwcHg7XG4gICAgcGFkZGluZzogMTVweCAyMHB4IDI1cHggMjBweDtcbiAgfVxuXG4gIC5hbnQtZGl2aWRlci1ob3Jpem9udGFsIHtcbiAgICBtYXJnaW46IDAgMCAxMnB4IDA7XG4gICAgYm9yZGVyLXRvcDogMnB4IHNvbGlkICNjNmM2YzY7XG4gIH1cblxuICAubWFpbi1oZWFkZXItc2VjIHtcbiAgICBwYWRkaW5nLXJpZ2h0OiAzMHB4O1xuICB9XG5cbiAgLm1haW5XaGl0ZWJnV3JhcHBlciB7XG4gICAgYmFja2dyb3VuZDogJHdoaXRlO1xuICAgIHBhZGRpbmc6IDI1cHggMjBweCAwcHggMzBweDtcbiAgICBtYXJnaW46IDAgMzBweCAzMHB4IDMwcHg7XG4gICAgLmFudC1zZWxlY3Qge1xuICAgICAgJi1zZWxlY3RvciB7XG4gICAgICAgIGJhY2tncm91bmQtY29sb3I6ICNlZGVmZjU7XG4gICAgICAgIGJvcmRlcjogdHJhbnNwYXJlbnQ7XG4gICAgICAgIHBhZGRpbmc6IDVweCAxMXB4O1xuICAgICAgICBoZWlnaHQ6IDQwcHg7XG4gICAgICAgIGJvcmRlci1ib3R0b206IDFweCBzb2xpZCAkYmxhY2s7XG4gICAgICAgIGJvcmRlci1yYWRpdXM6IDBweCAwcHggMHB4IDBweDtcbiAgICAgICAgLXdlYmtpdC1ib3JkZXItcmFkaXVzOiAwcHggMHB4IDBweCAwcHg7XG4gICAgICAgIC1tb3otYm9yZGVyLXJhZGl1czogMHB4IDBweCAwcHggMHB4O1xuICAgICAgICAtbXMtYm9yZGVyLXJhZGl1czogMHB4IDBweCAwcHggMHB4O1xuICAgICAgICAtby1ib3JkZXItcmFkaXVzOiAwcHggMHB4IDBweCAwcHg7XG4gICAgICB9XG4gICAgICAmLWFycm93IHtcbiAgICAgICAgY29sb3I6ICR0YWJsZXRleHQtY29sb3I7XG4gICAgICAgIC5hbnRpY29uLWRvd24ge1xuICAgICAgICAgIHZlcnRpY2FsLWFsaWduOiBtaWRkbGU7XG4gICAgICAgICAgc3ZnIHtcbiAgICAgICAgICAgIHRyYW5zZm9ybTogc2NhbGUoMS4zLCAxKTtcbiAgICAgICAgICAgIGhlaWdodDogMTBweDtcbiAgICAgICAgICAgIHdpZHRoOiAxNHB4O1xuICAgICAgICAgIH1cbiAgICAgICAgfVxuICAgICAgfVxuICAgICAgJi1zZWxlY3Rpb24ge1xuICAgICAgICAmLXBsYWNlaG9sZGVyIHtcbiAgICAgICAgICBjb2xvcjogIzY2NjY2NjtcbiAgICAgICAgfVxuICAgICAgfVxuICAgICAgJi1mb2N1c2VkOm5vdCguYW50LXNlbGVjdC1kaXNhYmxlZCkuYW50LXNlbGVjdDpub3QoLmFudC1zZWxlY3QtY3VzdG9taXplLWlucHV0KSB7XG4gICAgICAgIC5hbnQtc2VsZWN0LXNlbGVjdG9yIHtcbiAgICAgICAgICBib3gtc2hhZG93OiBub25lO1xuICAgICAgICAgIG91dGxpbmU6IG5vbmU7XG4gICAgICAgIH1cbiAgICAgIH1cbiAgICAgICY6aG92ZXIsXG4gICAgICAmOmZvY3VzIHtcbiAgICAgICAgLmFudC1zZWxlY3Qtc2VsZWN0b3Ige1xuICAgICAgICAgIGJvcmRlci1jb2xvcjogJGJsYWNrO1xuICAgICAgICB9XG4gICAgICB9XG4gICAgfVxuICAgIC5wYWdlVGl0bGUge1xuICAgICAgY29sb3I6ICMyZDJkMmQ7XG4gICAgICBmb250LWZhbWlseTogJGZvbnQtZGVmYXVsdDtcbiAgICAgIGZvbnQtc2l6ZTogJGZvbnQtc2l6ZTE2ICsgMjtcbiAgICAgIGZvbnQtd2VpZ2h0OiBib2xkO1xuICAgICAgbGV0dGVyLXNwYWNpbmc6IDAuNDVweDtcbiAgICAgIGxpbmUtaGVpZ2h0OiAyMnB4O1xuICAgIH1cbiAgfVxuXG4gIC50ZXh0LWlucHV0IHtcbiAgICBvdXRsaW5lOiBub25lO1xuICAgIGJvcmRlcjogbm9uZTtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjZWRlZmY1O1xuICAgIHBhZGRpbmc6IDlweCAxMHB4IDlweCAxMHB4O1xuICAgIG1hcmdpbi10b3A6IDVweDtcbiAgICB3aWR0aDogMTAwJTtcbiAgICBtYXgtd2lkdGg6IDEwMCU7XG4gICAgJjo6cGxhY2Vob2xkZXIge1xuICAgICAgY29sb3I6ICM2NjY2NjY7XG4gICAgfVxuICB9XG5cbiAgLnNlbGVjdCB7XG4gICAgcGFkZGluZy10b3A6IDVweDtcbiAgICB3aWR0aDogMTAwJTtcbiAgfVxuICAubWFpbkRhdGFJbXBvcnRUYWJsZSB7XG4gICAgdGFibGUge1xuICAgICAgdGhlYWQge1xuICAgICAgICB0ciB7XG4gICAgICAgICAgdGgge1xuICAgICAgICAgICAgcGFkZGluZzogMTVweCAxMnB4IDhweCAxMnB4O1xuICAgICAgICAgICAgd2lkdGg6IDUwcHg7XG4gICAgICAgICAgICAmOm50aC1jaGlsZCgzKSxcbiAgICAgICAgICAgICY6bnRoLWNoaWxkKDQpIHtcbiAgICAgICAgICAgICAgd2lkdGg6IDI0NXB4O1xuICAgICAgICAgICAgfVxuICAgICAgICAgICAgJjpudGgtY2hpbGQoNSkge1xuICAgICAgICAgICAgICB3aWR0aDogNzBweDtcbiAgICAgICAgICAgIH1cbiAgICAgICAgICAgICY6bnRoLWNoaWxkKDYpIHtcbiAgICAgICAgICAgICAgd2lkdGg6IDEwMnB4O1xuICAgICAgICAgICAgfVxuICAgICAgICAgICAgJjpudGgtY2hpbGQoNykge1xuICAgICAgICAgICAgICB3aWR0aDogMzMwcHg7XG4gICAgICAgICAgICB9XG4gICAgICAgICAgICAmOm50aC1jaGlsZCg4KSB7XG4gICAgICAgICAgICAgIHdpZHRoOiA2MHB4O1xuICAgICAgICAgICAgfVxuICAgICAgICAgICAgJjpudGgtY2hpbGQoOSkge1xuICAgICAgICAgICAgICB3aWR0aDogODBweDtcbiAgICAgICAgICAgIH1cbiAgICAgICAgICB9XG4gICAgICAgIH1cbiAgICAgIH1cbiAgICAgIHRib2R5IHtcbiAgICAgICAgdHIge1xuICAgICAgICAgIHRkIHtcbiAgICAgICAgICAgIGNvbG9yOiAjMjcyNzI4O1xuICAgICAgICAgICAgZm9udC1mYW1pbHk6ICdJQk0gUGxleCBTYW5zJztcbiAgICAgICAgICAgIGZvbnQtc2l6ZTogMTRweDtcbiAgICAgICAgICAgIGxldHRlci1zcGFjaW5nOiAwO1xuICAgICAgICAgICAgbGluZS1oZWlnaHQ6IDE1cHg7XG4gICAgICAgICAgICBib3JkZXItdG9wOiAxcHggc29saWQgI2Q2ZDZkNjtcbiAgICAgICAgICAgIHBhZGRpbmc6IDdweCAxMnB4IDAgMTJweDtcbiAgICAgICAgICAgIGhlaWdodDogNDBweDtcbiAgICAgICAgICAgIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgICAgICAgICAgICY6Zmlyc3QtY2hpbGQge1xuICAgICAgICAgICAgICB3aGl0ZS1zcGFjZTogbm93cmFwO1xuICAgICAgICAgICAgICB0ZXh0LW92ZXJmbG93OiBlbGxpcHNpcztcbiAgICAgICAgICAgICAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgICAgICAgICAgICAgbWF4LXdpZHRoOiAxNjBweDtcbiAgICAgICAgICAgIH1cbiAgICAgICAgICAgIHNwYW4ge1xuICAgICAgICAgICAgICBwYWRkaW5nLWxlZnQ6IDhweDtcbiAgICAgICAgICAgICAgc3ZnIHtcbiAgICAgICAgICAgICAgICBoZWlnaHQ6IDIzcHg7XG4gICAgICAgICAgICAgICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgICAgICAgICAgICAgIHRvcDogMTRweDtcbiAgICAgICAgICAgICAgICBsZWZ0OiAwO1xuICAgICAgICAgICAgICAgIGJvdHRvbTogMDtcbiAgICAgICAgICAgICAgICBtYXJnaW46IGF1dG8gIWltcG9ydGFudDtcbiAgICAgICAgICAgICAgICB3aWR0aDogYXV0byAhaW1wb3J0YW50O1xuICAgICAgICAgICAgICB9XG4gICAgICAgICAgICB9XG4gICAgICAgICAgfVxuICAgICAgICB9XG4gICAgICB9XG4gICAgfVxuICB9XG59XG5cbi5uZXctZGF0YS1pbXBvcnQgLnNpc0ltcG9ydFRhYmxlIHtcbiAgdGFibGUge1xuICAgIHRib2R5IHtcbiAgICAgIHRyIHtcbiAgICAgICAgdGQge1xuICAgICAgICAgIHBhZGRpbmctdG9wOiAwcHg7XG5cbiAgICAgICAgICBzcGFuIHtcbiAgICAgICAgICAgIHBhZGRpbmctbGVmdDogMHB4O1xuICAgICAgICAgICAgLy8gbWFyZ2luLWxlZnQ6IDhweDtcbiAgICAgICAgICAgICYuc3RhdHVzIHtcbiAgICAgICAgICAgICAgLy8gcGFkZGluZy1sZWZ0OiAxNHB4O1xuXG4gICAgICAgICAgICAgIHN2ZyB7XG4gICAgICAgICAgICAgICAgdG9wOiAxMHB4O1xuICAgICAgICAgICAgICB9XG5cbiAgICAgICAgICAgICAgc3BhbiB7XG4gICAgICAgICAgICAgICAgbWFyZ2luLWxlZnQ6IDhweDtcbiAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgfVxuICAgICAgICAgIH1cbiAgICAgICAgfVxuICAgICAgfVxuICAgIH1cbiAgfVxufVxuXG4ubG9yLXRvb2x0aXAge1xuICBwYWRkaW5nOiAzcHg7XG4gIGg0IHtcbiAgICBjb2xvcjogJHdoaXRlO1xuICAgIGZvbnQtd2VpZ2h0OiBib2xkO1xuICB9XG4gIC5sb3Itc3RhdHMge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuICAgIGFsaWduLWl0ZW1zOiBmbGV4LXN0YXJ0O1xuICAgIHBhZGRpbmctYm90dG9tOiAycHg7XG4gIH1cbn1cblxuLmFudC10b29sdGlwIC5hbnQtdG9vbHRpcC1jb250ZW50IHtcbiAgd2lkdGg6IDI1MHB4O1xufVxuXG4uYW50LXRvb2x0aXAtaW5uZXIge1xuICBjb2xvcjogd2hpdGVzbW9rZTtcbiAgYmFja2dyb3VuZC1jb2xvcjogIzNhM2IzZDtcbn1cblxuLmxvci10ZXh0IHtcbiAgYm9yZGVyLWJvdHRvbTogMXB4IGRhc2hlZCAjMjcyNzI4O1xufVxuXG4uYW50LXRvb2x0aXAtYXJyb3ctY29udGVudCB7XG4gIGJhY2tncm91bmQtY29sb3I6ICMzYTNiM2Q7XG59XG5cbi5yYWRpby1pdGVtIHtcbiAgdmVydGljYWwtYWxpZ246IG1pZGRsZTtcbiAgY29sb3I6ICMyNzI3Mjg7XG4gIGZvbnQtZmFtaWx5OiAkZm9udC1pYm07XG4gIGZvbnQtc2l6ZTogJGZvbnQtc2l6ZTE0O1xuICBsZXR0ZXItc3BhY2luZzogMDtcbiAgbGluZS1oZWlnaHQ6IDM0cHg7XG4gICYudmVydGljYWwge1xuICAgIGRpc3BsYXk6IGJsb2NrO1xuICB9XG4gIC5hbnQtcmFkaW8taW5uZXI6OmFmdGVyIHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAkdGFibGV0ZXh0LWNvbG9yO1xuICAgIHRvcDogMDtcbiAgICByaWdodDogMDtcbiAgICBib3R0b206IDA7XG4gICAgbGVmdDogMDtcbiAgICBtYXJnaW46IGF1dG87XG4gIH1cbiAgLmFudC1yYWRpby13cmFwcGVyOmhvdmVyIC5hbnQtcmFkaW8sXG4gIC5hbnQtcmFkaW86aG92ZXIgLmFudC1yYWRpby1pbm5lcixcbiAgLmFudC1yYWRpby1pbnB1dDpmb2N1cyArIC5hbnQtcmFkaW8taW5uZXIge1xuICAgIGJvcmRlci1jb2xvcjogJHRhYmxldGV4dC1jb2xvcjtcbiAgfVxuICAuYW50LXJhZGlvLWNoZWNrZWQ6OmFmdGVyLFxuICAuYW50LXJhZGlvLWNoZWNrZWQgLmFudC1yYWRpby1pbm5lciB7XG4gICAgYm9yZGVyLWNvbG9yOiAkdGFibGV0ZXh0LWNvbG9yO1xuICB9XG4gIC5hbnQtcmFkaW8taW5wdXQ6Zm9jdXMgKyAuYW50LXJhZGlvLWlubmVyIHtcbiAgICAtd2Via2l0LWJveC1zaGFkb3c6IG5vbmU7XG4gICAgYm94LXNoYWRvdzogbm9uZTtcbiAgfVxuICAuYW50LXJhZGlvLWlubmVyIHtcbiAgICBoZWlnaHQ6ICRmb250LXNpemUxNiArIDI7XG4gICAgd2lkdGg6ICRmb250LXNpemUxNiArIDI7XG4gICAgYm9yZGVyLWNvbG9yOiAkdGFibGV0ZXh0LWNvbG9yO1xuICB9XG59XG5cbi5jb250aW51ZS1idG4ge1xuICBiYWNrZ3JvdW5kOiBsaW5lYXItZ3JhZGllbnQoMTgwZGVnLCAjZmZiNjVhIDAlLCAjZmZiNjVhIDAlLCAjZmU5NTI3IDEwMCUpO1xuICBib3JkZXI6IG5vbmU7XG4gIHBhZGRpbmc6IDExcHggMThweDtcbiAgdHJhbnNpdGlvbi1kdXJhdGlvbjogMC40cztcbiAgY3Vyc29yOiBwb2ludGVyO1xuICBib3JkZXItcmFkaXVzOiA0cHg7XG4gIGNvbG9yOiAjMjcyNzI4O1xuICBmb250LWZhbWlseTogJGZvbnQtaWJtO1xuICBmb250LXNpemU6ICRmb250LXNpemUxNjtcbiAgbGV0dGVyLXNwYWNpbmc6IDA7XG4gIGxpbmUtaGVpZ2h0OiAyMHB4O1xuICB0ZXh0LWFsaWduOiBjZW50ZXI7XG4gIC13ZWJraXQtYm9yZGVyLXJhZGl1czogNHB4O1xuICAtbW96LWJvcmRlci1yYWRpdXM6IDRweDtcbiAgLW1zLWJvcmRlci1yYWRpdXM6IDRweDtcbiAgLW8tYm9yZGVyLXJhZGl1czogNHB4O1xuICAmOmZvY3VzIHtcbiAgICBvdXRsaW5lOiBub25lO1xuICB9XG59XG5cbi5idXR0b24uYnV0dG9uLWJsdWUge1xuICBiYWNrZ3JvdW5kOiAkdGFibGV0ZXh0LWNvbG9yO1xuICBjb2xvcjogd2hpdGU7XG5cbiAgJjpob3ZlciB7XG4gICAgYm9yZGVyOiAxcHggc29saWQgJHRhYmxldGV4dC1jb2xvcjtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAkd2hpdGU7XG4gICAgY29sb3I6ICR0YWJsZXRleHQtY29sb3I7XG4gICAgc3ZnIHBhdGgge1xuICAgICAgZmlsbDogJHRhYmxldGV4dC1jb2xvcjtcbiAgICB9XG4gIH1cblxuICAmOmRpc2FibGVkLFxuICAmW2Rpc2FibGVkXSB7XG4gICAgYmFja2dyb3VuZC1pbWFnZTogbm9uZTtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjYjViNWI1O1xuICAgIGNvbG9yOiAjZmZmO1xuICAgIGN1cnNvcjogbm90LWFsbG93ZWQ7XG4gICAgYm9yZGVyLWNvbG9yOiB0cmFuc3BhcmVudDtcbiAgICAmOmhvdmVyIHtcbiAgICAgIGJhY2tncm91bmQtY29sb3I6ICNiNWI1YjU7XG4gICAgfVxuICB9XG59XG5cbi5jYW5jZWwtc2F2ZS1jb250aW51ZS1idG4tZ3JvdXAge1xuICAuY29udGludWUtYnRuIHtcbiAgICBiYWNrZ3JvdW5kOiAkdGFibGV0ZXh0LWNvbG9yO1xuICAgIGNvbG9yOiAkd2hpdGU7XG4gICAgYm9yZGVyOiAxcHggc29saWQgJHdoaXRlO1xuXG4gICAgJjpob3ZlciB7XG4gICAgICBib3JkZXI6IDFweCBzb2xpZCAkdGFibGV0ZXh0LWNvbG9yO1xuICAgICAgYmFja2dyb3VuZC1jb2xvcjogJHdoaXRlO1xuICAgICAgY29sb3I6ICR0YWJsZXRleHQtY29sb3I7XG4gICAgICBzdmcgcGF0aCB7XG4gICAgICAgIGZpbGw6ICR0YWJsZXRleHQtY29sb3I7XG4gICAgICB9XG4gICAgfVxuICB9XG5cbiAgLmNhbmNlbC1idXR0b24ge1xuICAgIGJvcmRlcjogbm9uZTtcbiAgICBjb2xvcjogJGRhcmstc2hhZGU7XG5cbiAgICAmOmhvdmVyIHtcbiAgICAgIGJhY2tncm91bmQtY29sb3I6ICRkYXJrLXNoYWRlO1xuICAgICAgY29sb3I6ICR3aGl0ZTtcbiAgICAgIHN2ZyBwYXRoIHtcbiAgICAgICAgZmlsbDogJHdoaXRlO1xuICAgICAgfVxuICAgIH1cbiAgfVxufVxuXG5idXR0b246ZGlzYWJsZWQsXG5idXR0b25bZGlzYWJsZWRdIHtcbiAgYmFja2dyb3VuZC1pbWFnZTogbm9uZTtcbiAgYmFja2dyb3VuZC1jb2xvcjogI2I1YjViNTtcbiAgY29sb3I6ICNmZmY7XG4gIGN1cnNvcjogbm90LWFsbG93ZWQ7XG4gIGJvcmRlci1jb2xvcjogdHJhbnNwYXJlbnQ7XG4gICY6aG92ZXIge1xuICAgIGJhY2tncm91bmQtY29sb3I6ICNiNWI1YjU7XG4gIH1cbn1cbi5idXR0b24ge1xuICBwYWRkaW5nOiA5cHggMThweDtcbiAgbWFyZ2luOiAwcHg7XG4gIHRyYW5zaXRpb24tZHVyYXRpb246IDAuNHM7XG4gIGN1cnNvcjogcG9pbnRlcjtcbiAgYm9yZGVyOiAxcHggc29saWQgJHRhYmxldGV4dC1jb2xvcjtcbiAgYm9yZGVyLXJhZGl1czogNHB4O1xuICBiYWNrZ3JvdW5kLWNvbG9yOiByZ2JhKDI1NSwgMjU1LCAyNTUsIDAuMDUpO1xuICBjb2xvcjogJHRhYmxldGV4dC1jb2xvcjtcbiAgZm9udC1mYW1pbHk6ICRmb250LWRlZmF1bHQ7XG4gIGZvbnQtc2l6ZTogJGZvbnQtc2l6ZTE2O1xuICBsZXR0ZXItc3BhY2luZzogMDtcbiAgbGluZS1oZWlnaHQ6IDIycHg7XG4gIGhlaWdodDogYXV0bztcbiAgJjpob3ZlciB7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogJHRhYmxldGV4dC1jb2xvcjtcbiAgICBjb2xvcjogJHdoaXRlO1xuICAgIHN2ZyBwYXRoIHtcbiAgICAgIGZpbGw6ICR3aGl0ZTtcbiAgICB9XG4gIH1cbiAgJjpmb2N1cyB7XG4gICAgb3V0bGluZTogbm9uZTtcbiAgfVxufVxuXG4uZHJvcGRvd25fYnV0dG9uIHtcbiAgPiAuYW50LWJ0biB7XG4gICAgcGFkZGluZzogOXB4IDE4cHg7XG4gICAgbWFyZ2luOiAwcHg7XG4gICAgdHJhbnNpdGlvbi1kdXJhdGlvbjogMC40cztcbiAgICBjdXJzb3I6IHBvaW50ZXI7XG4gICAgYm9yZGVyOiAxcHggc29saWQgJHRhYmxldGV4dC1jb2xvcjtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiByZ2JhKDI1NSwgMjU1LCAyNTUsIDAuMDUpO1xuICAgIGNvbG9yOiAkdGFibGV0ZXh0LWNvbG9yO1xuICAgIGZvbnQtZmFtaWx5OiAkZm9udC1kZWZhdWx0O1xuICAgIGZvbnQtc2l6ZTogJGZvbnQtc2l6ZTE2O1xuICAgIGxldHRlci1zcGFjaW5nOiAwO1xuICAgIGxpbmUtaGVpZ2h0OiAyMnB4O1xuXG4gICAgJjpmaXJzdC1jaGlsZCB7XG4gICAgICBib3JkZXItcmFkaXVzOiA0cHggMHB4IDBweCA0cHggIWltcG9ydGFudDtcbiAgICB9XG4gICAgJjpsYXN0LWNoaWxkIHtcbiAgICAgIGJvcmRlci1yYWRpdXM6IDBweCA0cHggNHB4IDBweCAhaW1wb3J0YW50O1xuICAgIH1cblxuICAgICY6aG92ZXIge1xuICAgICAgYmFja2dyb3VuZC1jb2xvcjogJHRhYmxldGV4dC1jb2xvcjtcbiAgICAgIGNvbG9yOiAkd2hpdGU7XG4gICAgICBzdmcgcGF0aCB7XG4gICAgICAgIGZpbGw6ICR3aGl0ZTtcbiAgICAgIH1cbiAgICB9XG4gICAgJjpmb2N1cyB7XG4gICAgICBvdXRsaW5lOiBub25lO1xuICAgIH1cbiAgfVxufVxuXG4uYnV0dG9uU29saWQge1xuICBiYWNrZ3JvdW5kOiBsaW5lYXItZ3JhZGllbnQoMTgwZGVnLCAjMjYyNmUzIDAlLCAjMTQxNDk3IDEwMCUpO1xuICBwYWRkaW5nOiA5cHggMThweDtcbiAgbWFyZ2luOiAwcHg7XG4gIHRyYW5zaXRpb24tZHVyYXRpb246IDAuNHM7XG4gIGN1cnNvcjogcG9pbnRlcjtcbiAgYm9yZGVyOiAxcHggc29saWQgdHJhbnNwYXJlbnQ7XG4gIGJvcmRlci1yYWRpdXM6IDRweDtcbiAgY29sb3I6ICR3aGl0ZTtcbiAgZm9udC1mYW1pbHk6ICRmb250LWRlZmF1bHQ7XG4gIGZvbnQtc2l6ZTogJGZvbnQtc2l6ZTE2O1xuICBsZXR0ZXItc3BhY2luZzogMDtcbiAgbGluZS1oZWlnaHQ6IDIycHg7XG4gIGhlaWdodDogYXV0bztcbiAgJjpmb2N1cyB7XG4gICAgb3V0bGluZTogbm9uZTtcbiAgfVxufVxuXG4uYnV0dG9uQm90dG9tR3V0dGVyIHtcbiAgbWFyZ2luLWJvdHRvbTogMTBweDtcbn1cblxuLmJ1dHRvblRvcEd1dHRlckxhcmdlIHtcbiAgbWFyZ2luLXRvcDogMzBweDtcbn1cbiIsIi5tYWluLWhlYWRlci1zZWMge1xuICBwYWRkaW5nOiAzMHB4IDBweCAwcHggMzBweDtcblxuICAuYW50LWJyZWFkY3J1bWIge1xuICAgIHBhZGRpbmctYm90dG9tOiAxMHB4O1xuICAgIHBvc2l0aW9uOiB1bnNldDtcbiAgICB6LWluZGV4OiBhdXRvO1xuICB9XG5cbiAgLmFudC1icmVhZGNydW1iIGEge1xuICAgIGNvbG9yOiAkcHJpbWFyeS1jb2xvcjtcbiAgICBmb250LWZhbWlseTogJGZvbnQtc3RhY2s7XG4gICAgZm9udC1zaXplOiAkZm9udC1zaXplMTQ7XG4gICAgbGV0dGVyLXNwYWNpbmc6IDAuMTZweDtcbiAgICBsaW5lLWhlaWdodDogMThweDtcbiAgfVxuXG4gIC5hbnQtYnJlYWRjcnVtYi1zZXBhcmF0b3Ige1xuICAgIGNvbG9yOiAkYmxhY2stY29sb3I7XG4gICAgZm9udC1mYW1pbHk6ICRmb250LXN0YWNrO1xuICAgIGZvbnQtc2l6ZTogJGZvbnQtc2l6ZTE0O1xuICAgIGxldHRlci1zcGFjaW5nOiAwLjE2cHg7XG4gICAgbGluZS1oZWlnaHQ6IDE4cHg7XG4gIH1cbiAgLmFudC1icmVhZGNydW1iID4gc3BhbjpsYXN0LWNoaWxkIGEge1xuICAgIGNvbG9yOiAkYmxhY2stY29sb3I7XG4gIH1cblxuICAuY3NzLWNoZWNrYm94LXJvdyB7XG4gICAgcGFkZGluZzogNXB4IDAgMjBweCA0MHB4O1xuICAgIGJhY2tncm91bmQtY29sb3I6ICNmMGYyZjU7XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcblxuICAgIC5sZWZ0LWJvcmRlci1jb2wge1xuICAgICAgYm9yZGVyLWxlZnQ6IDFweCBzb2xpZCAjOTc5Nzk3O1xuICAgICAgYWxpZ24tY29udGVudDogc3BhY2UtYmV0d2VlbjtcbiAgICAgIHBhZGRpbmctbGVmdDogMTBweDtcbiAgICB9XG4gICAgLmdsb2JhbC1maWx0ZXItb2Zmc2V0IHtcbiAgICAgIG1hcmdpbi10b3A6IDEwcHg7XG4gICAgICBtYXJnaW4tbGVmdDogMTBweDtcbiAgICB9XG4gICAgLmNsYXNzLXllYXItbGFiZWwge1xuICAgICAgaGVpZ2h0OiAyMnB4O1xuICAgICAgd2lkdGg6IDg3cHg7XG4gICAgICBjb2xvcjogIzE3MTcxNztcbiAgICAgIGZvbnQtZmFtaWx5OiAnT3BlbiBTYW5zJztcbiAgICAgIGZvbnQtc2l6ZTogMTZweDtcbiAgICAgIGZvbnQtd2VpZ2h0OiA2MDA7XG4gICAgICBsZXR0ZXItc3BhY2luZzogMDtcbiAgICAgIGxpbmUtaGVpZ2h0OiAyO1xuICAgICAgbWFyZ2luLXJpZ2h0OiAxMHB4O1xuICAgIH1cbiAgICAuaGVhZGVyLWZpbHRlci1jb2wge1xuICAgICAgaGVpZ2h0OiAyMnB4O1xuICAgICAgd2lkdGg6IGF1dG87XG4gICAgICBkaXNwbGF5OiBpbmhlcml0O1xuICAgIH1cbiAgICAuY3NlbGVjdC1kcm9wZG93biB7XG4gICAgICAuYW50LXNlbGVjdC1tdWx0aXBsZSAuYW50LXNlbGVjdC1zZWxlY3Rpb24taXRlbS1jb250ZW50IHtcbiAgICAgICAgd2lkdGg6IDI3NXB4O1xuICAgICAgfVxuICAgICAgLmFudC1zZWxlY3Qtc2VsZWN0b3IgLnNlbGVjdGVkLWl0ZW0ge1xuICAgICAgICB3aGl0ZS1zcGFjZTogbm93cmFwO1xuICAgICAgICBvdmVyZmxvdzogaGlkZGVuO1xuICAgICAgICB0ZXh0LW92ZXJmbG93OiBlbGxpcHNpcztcbiAgICAgICAgd2lkdGg6IDI1MHB4O1xuICAgICAgfVxuICAgIH1cblxuICAgIC5hbnQtY29sLmFudC1jb2wtNiB7XG4gICAgICBkaXNwbGF5OiBpbmxpbmUtZmxleDtcbiAgICAgIGFsaWduLXNlbGY6IGNlbnRlcjtcbiAgICAgIGxhYmVsIHtcbiAgICAgICAgcGFkZGluZzogMCAxMnB4O1xuICAgICAgICBjb2xvcjogIzE3MTcxNztcbiAgICAgICAgZm9udC1mYW1pbHk6ICdPcGVuIFNhbnMnO1xuICAgICAgICBmb250LXNpemU6IDE2cHg7XG4gICAgICAgIGZvbnQtd2VpZ2h0OiA2MDA7XG4gICAgICAgIGxldHRlci1zcGFjaW5nOiAwO1xuICAgICAgICBsaW5lLWhlaWdodDogMjJweDtcbiAgICAgIH1cbiAgICAgIC5hbnRpY29uLmFudGljb24tZG93biB7XG4gICAgICAgIGNvbG9yOiAkYmxhY2stY29sb3I7XG4gICAgICB9XG4gICAgfVxuICAgIC5zZWxlY3QtZHJvcGRvd24gLmFudC1zZWxlY3Qtc2VsZWN0b3Ige1xuICAgICAgYmFja2dyb3VuZC1jb2xvcjogdHJhbnNwYXJlbnQgIWltcG9ydGFudDtcbiAgICAgIGhlaWdodDogMzBweDtcbiAgICAgIHBhZGRpbmctbGVmdDogMDtcbiAgICAgIC5hbnQtc2VsZWN0LXNlbGVjdGlvbi1pdGVtIHtcbiAgICAgICAgYmFja2dyb3VuZC1jb2xvcjogdHJhbnNwYXJlbnQgIWltcG9ydGFudDtcbiAgICAgICAgcGFkZGluZy1sZWZ0OiAwO1xuICAgICAgICAuYW50LXRhZyB7XG4gICAgICAgICAgcGFkZGluZzogM3B4IDBweDtcbiAgICAgICAgICB3aWR0aDogNTBweDtcbiAgICAgICAgICBoZWlnaHQ6IDI1cHg7XG4gICAgICAgICAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xuICAgICAgICAgIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgICAgICAgICAuYW50aWNvbiArIHNwYW4sXG4gICAgICAgICAgc3BhbiArIC5hbnRpY29uIHtcbiAgICAgICAgICAgIG1hcmdpbi1sZWZ0OiAzcHg7XG4gICAgICAgICAgfVxuICAgICAgICB9XG4gICAgICB9XG4gICAgfVxuICB9XG59XG4iLCIuY2hlY2tib3gge1xuICAuYW50LWNoZWNrYm94IHtcbiAgICAuYW50LWNoZWNrYm94LWlubmVyIHtcbiAgICAgIGJvcmRlci1jb2xvcjogJHRhYmxldGV4dC1jb2xvcjtcbiAgICAgIGJvcmRlci13aWR0aDogMS41cHg7XG4gICAgICBib3JkZXItcmFkaXVzOiAwcHg7XG4gICAgICBiYWNrZ3JvdW5kOiB0cmFuc3BhcmVudDtcbiAgICAgIC13ZWJraXQtYm9yZGVyLXJhZGl1czogMHB4O1xuICAgICAgLW1vei1ib3JkZXItcmFkaXVzOiAwcHg7XG4gICAgICAtbXMtYm9yZGVyLXJhZGl1czogMHB4O1xuICAgICAgLW8tYm9yZGVyLXJhZGl1czogMHB4O1xuICAgIH1cblxuICAgICYuYW50LWNoZWNrYm94LWRpc2FibGVkIHtcbiAgICAgIC5hbnQtY2hlY2tib3gtaW5uZXIge1xuICAgICAgICBib3JkZXItY29sb3I6ICM4ZThlOTAgIWltcG9ydGFudDtcbiAgICAgIH1cbiAgICB9XG4gIH1cblxuICAuYW50LWNoZWNrYm94ICsgc3BhbiB7XG4gICAgY29sb3I6ICRibGFjaztcbiAgICBmb250LWZhbWlseTogJGZvbnQtZGVmYXVsdDtcbiAgICBmb250LXNpemU6IDE0cHg7XG4gICAgbGV0dGVyLXNwYWNpbmc6IDA7XG4gICAgbGluZS1oZWlnaHQ6IDIycHg7XG4gIH1cblxuICAuYW50LWNoZWNrYm94LWRpc2FibGVkICsgc3BhbiB7XG4gICAgY29sb3I6ICM2NTY1Njc7XG4gIH1cblxuICAuYW50LWNoZWNrYm94LWNoZWNrZWQge1xuICAgIC5hbnQtY2hlY2tib3gtaW5uZXIge1xuICAgICAgYm9yZGVyOiBub25lO1xuICAgICAgYmFja2dyb3VuZDogbGluZWFyLWdyYWRpZW50KDE4MGRlZywgIzI2MjZlMyAwJSwgIzE0MTQ5NyAxMDAlKTtcbiAgICB9XG5cbiAgICAmOmFmdGVyIHtcbiAgICAgIGJvcmRlcjogbm9uZTtcbiAgICB9XG4gIH1cbn1cbiIsIi5tYWluTWF0Y2hGaWVsZHNTZWN0aW9uIHtcbiAgaGVpZ2h0OiBhdXRvO1xuXG4gIC5tYWluLWhlYWRlci1zZWMge1xuICAgIHBhZGRpbmctcmlnaHQ6IDMwcHg7XG4gICAgcGFkZGluZy10b3A6IDA7XG4gIH1cblxuICAuc3Bpbm5lciB7XG4gICAgbWFyZ2luOiAyMHB4IDA7XG4gICAgbWFyZ2luLWJvdHRvbTogMjBweDtcbiAgICBwYWRkaW5nOiAzMHB4IDUwcHg7XG4gICAgdGV4dC1hbGlnbjogY2VudGVyO1xuICAgIGJhY2tncm91bmQ6IHJnYmEoMCwgMCwgMCwgMC4wNSk7XG4gICAgYm9yZGVyLXJhZGl1czogNHB4O1xuICB9XG5cbiAgLnJldmlld05hcHBpbmdUZXh0IHtcbiAgICBoZWlnaHQ6IDMycHg7XG4gICAgd2lkdGg6IDU0NHB4O1xuICAgIGNvbG9yOiAjNTE1MTUyO1xuICAgIGZvbnQtZmFtaWx5OiAnSUJNIFBsZXggU2Fucyc7XG4gICAgZm9udC1zaXplOiAxNnB4O1xuICAgIGZvbnQtd2VpZ2h0OiA2MDA7XG4gICAgbGV0dGVyLXNwYWNpbmc6IDA7XG4gICAgbGluZS1oZWlnaHQ6IDIwcHg7XG4gIH1cblxuICAudGl0bGVJbXByTmFtZSxcbiAgLnRpdGxlSW1wcmFsdW1uaSxcbiAgLnRpdGxlTWF0Y2hGaWVsZCxcbiAgLnRpdGxlU3R1ZGVudCB7XG4gICAgZm9udC1mYW1pbHk6ICRmb250LWRlZmF1bHQ7XG4gICAgZm9udC13ZWlnaHQ6IGJvbGQ7XG4gICAgbGV0dGVyLXNwYWNpbmc6IDA7XG4gICAgbGluZS1oZWlnaHQ6IDIwcHg7XG4gICAgbWFyZ2luOiAwO1xuICB9XG4gIC50aXRsZUltcHJOYW1lIHtcbiAgICBmb250LXNpemU6ICRmb250LXNpemUxNiArIDQ7XG4gIH1cbiAgLnRpdGxlSW1wcmFsdW1uaSB7XG4gICAgZm9udC1zaXplOiAkZm9udC1zaXplMTQ7XG4gICAgcGFkZGluZzogN3B4IDAgMTBweCAwO1xuICB9XG4gIC50aXRsZU1hdGNoRmllbGQge1xuICAgIGZvbnQtc2l6ZTogJGZvbnQtc2l6ZTE0ICsgMjtcbiAgICBwYWRkaW5nLWJvdHRvbTogNXB4O1xuICB9XG4gIC50aXRsZVN0dWRlbnQge1xuICAgIGZvbnQtc2l6ZTogJGZvbnQtc2l6ZTE0ICsgMjtcbiAgICBmb250LXdlaWdodDogNjAwO1xuICB9XG5cbiAgLmRpdmlkZXItZGF0YSB7XG4gICAgbWFyZ2luLXRvcDogMTJweDtcbiAgfVxuICAubWFpbldoaXRlYmdXcmFwcGVyIHtcbiAgICBwYWRkaW5nOiAwO1xuICAgIGJhY2tncm91bmQ6IHRyYW5zcGFyZW50O1xuICAgIG1hcmdpbjogMCAzMHB4IDQwcHggMzBweDtcbiAgICAuaW1wck5hbWVTZWN0aW9uIHtcbiAgICAgIGJhY2tncm91bmQtY29sb3I6ICR3aGl0ZTtcbiAgICAgIHBhZGRpbmc6IDE1cHggMjBweDtcbiAgICB9XG4gICAgLnNlbGVjdCB7XG4gICAgICBwYWRkaW5nLXRvcDogMDtcbiAgICAgIC5hbnQtc2VsZWN0LXNlbGVjdG9yIHtcbiAgICAgICAgYmFja2dyb3VuZC1jb2xvcjogJHdoaXRlO1xuICAgICAgICBoZWlnaHQ6IDMwcHg7XG4gICAgICAgIHBhZGRpbmc6IDAgMTFweDtcbiAgICAgICAgYm9yZGVyLWJvdHRvbS1jb2xvcjogIzhlOGU5MDtcbiAgICAgICAgYm9yZGVyLXJhZGl1czogNHB4IDRweCAwIDA7XG4gICAgICAgIC13ZWJraXQtYm9yZGVyLXJhZGl1czogNHB4IDRweCAwIDA7XG4gICAgICAgIC1tb3otYm9yZGVyLXJhZGl1czogNHB4IDRweCAwIDA7XG4gICAgICAgIC1tcy1ib3JkZXItcmFkaXVzOiA0cHggNHB4IDAgMDtcbiAgICAgICAgLW8tYm9yZGVyLXJhZGl1czogNHB4IDRweCAwIDA7XG4gICAgICB9XG4gICAgfVxuICB9XG4gIHVsLmxpc3RGaWVsZHMge1xuICAgIGxpc3Qtc3R5bGU6IG5vbmU7XG4gICAgcGFkZGluZy1sZWZ0OiAzNXB4O1xuICAgIGxpIHtcbiAgICAgIGNvbG9yOiByZ2JhKDAsIDAsIDAsIDAuODcpO1xuICAgICAgZm9udC1mYW1pbHk6ICRmb250LWRlZmF1bHQ7XG4gICAgICBmb250LXNpemU6ICRmb250LXNpemUxNCAtIDE7XG4gICAgICBsZXR0ZXItc3BhY2luZzogMDtcbiAgICAgIGxpbmUtaGVpZ2h0OiAyMHB4O1xuICAgICAgcG9zaXRpb246IHJlbGF0aXZlO1xuICAgICAgJjpiZWZvcmUge1xuICAgICAgICBjb250ZW50OiAnJztcbiAgICAgICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiByZ2JhKDAsIDAsIDAsIDAuODcpO1xuICAgICAgICBoZWlnaHQ6IDRweDtcbiAgICAgICAgd2lkdGg6IDRweDtcbiAgICAgICAgYm9yZGVyLXJhZGl1czogNTAlO1xuICAgICAgICAtd2Via2l0LWJvcmRlci1yYWRpdXM6IDUwJTtcbiAgICAgICAgLW1vei1ib3JkZXItcmFkaXVzOiA1MCU7XG4gICAgICAgIC1tcy1ib3JkZXItcmFkaXVzOiA1MCU7XG4gICAgICAgIC1vLWJvcmRlci1yYWRpdXM6IDUwJTtcbiAgICAgICAgdG9wOiAwO1xuICAgICAgICBib3R0b206IDA7XG4gICAgICAgIGxlZnQ6IC0yNXB4O1xuICAgICAgICBtYXJnaW46IGF1dG87XG4gICAgICB9XG4gICAgfVxuICB9XG4gIHRhYmxlIHtcbiAgICB3aWR0aDogMTAwJTtcbiAgICB0aGVhZCB7XG4gICAgICB0ciB7XG4gICAgICAgIHRoIHtcbiAgICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjZWJlYmViO1xuICAgICAgICAgIGNvbG9yOiAkdGFibGVoZWFkdGV4dC1jb2xvcjtcbiAgICAgICAgICBmb250LWZhbWlseTogJGZvbnQtaWJtO1xuICAgICAgICAgIGZvbnQtc2l6ZTogJGZvbnQtc2l6ZTE0O1xuICAgICAgICAgIGZvbnQtd2VpZ2h0OiA2MDA7XG4gICAgICAgICAgbGV0dGVyLXNwYWNpbmc6IDA7XG4gICAgICAgICAgbGluZS1oZWlnaHQ6IDE4cHg7XG4gICAgICAgICAgcGFkZGluZzogMTVweCAxNXB4IDhweCAxNXB4O1xuICAgICAgICAgICY6bnRoLWNoaWxkKDIpIHtcbiAgICAgICAgICAgIHdpZHRoOiA1MCU7XG4gICAgICAgICAgfVxuICAgICAgICB9XG4gICAgICAgIHRoLmNsZWFyRmllbGQge1xuICAgICAgICAgIGNvbG9yOiAjNGE5MGUyO1xuICAgICAgICAgIGZvbnQtZmFtaWx5OiAkZm9udC1kZWZhdWx0O1xuICAgICAgICAgIGZvbnQtd2VpZ2h0OiA1MDA7XG4gICAgICAgICAgY3Vyc29yOiBwb2ludGVyO1xuICAgICAgICAgIHRleHQtZGVjb3JhdGlvbjogdW5kZXJsaW5lO1xuICAgICAgICB9XG4gICAgICB9XG4gICAgfVxuICAgIHRib2R5IHtcbiAgICAgIHRyIHtcbiAgICAgICAgdGQge1xuICAgICAgICAgIGJvcmRlci10b3A6IDFweCBzb2xpZCAjZDZkNmQ2O1xuICAgICAgICAgIGNvbG9yOiAjMjcyNzI4O1xuICAgICAgICAgIGZvbnQtZmFtaWx5OiAkZm9udC1pYm07XG4gICAgICAgICAgZm9udC1zaXplOiAkZm9udC1zaXplMTQ7XG4gICAgICAgICAgbGV0dGVyLXNwYWNpbmc6IDA7XG4gICAgICAgICAgbGluZS1oZWlnaHQ6IDE1cHg7XG4gICAgICAgICAgcGFkZGluZzogMHB4IDE1cHg7XG4gICAgICAgICAgaGVpZ2h0OiA0MHB4O1xuICAgICAgICB9XG4gICAgICAgICY6bnRoLWNoaWxkKGV2ZW4pIHtcbiAgICAgICAgICB0ZCB7XG4gICAgICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjZjVmNWY1O1xuICAgICAgICAgIH1cbiAgICAgICAgfVxuICAgICAgfVxuICAgIH1cbiAgfVxuICAucmVxRmllbGQsXG4gIC5tYXRGaWVsZCxcbiAgLnVtbUZpZWxkIHtcbiAgICBjb2xvcjogJHRhYmxlaGVhZHRleHQtY29sb3I7XG4gICAgZm9udC1mYW1pbHk6ICRmb250LWRlZmF1bHQ7XG4gICAgZm9udC1zaXplOiAkZm9udC1zaXplMTQ7XG4gICAgbGV0dGVyLXNwYWNpbmc6IDA7XG4gICAgbGluZS1oZWlnaHQ6IDE4cHg7XG4gICAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xuICAgIHBhZGRpbmc6IDEwcHggMCAzcHggMDtcbiAgICBzdmcge1xuICAgICAgd2lkdGg6IDIycHggIWltcG9ydGFudDtcbiAgICAgIHZlcnRpY2FsLWFsaWduOiAtd2Via2l0LWJhc2VsaW5lLW1pZGRsZSAhaW1wb3J0YW50O1xuICAgICAgbWFyZ2luLXJpZ2h0OiAtOHB4O1xuICAgIH1cbiAgfVxuICAubWFpblBlcmZvcm1UaW1lV3JhcHBlciB7XG4gICAgLnNlbGVjdCB7XG4gICAgICAmOmhvdmVyIHtcbiAgICAgICAgLmFudC1zZWxlY3Qtc2VsZWN0b3Ige1xuICAgICAgICAgIGJvcmRlci1jb2xvcjogIzhlOGU5MDtcbiAgICAgICAgfVxuICAgICAgfVxuICAgICAgLmFudC1zZWxlY3Qtc2VsZWN0b3Ige1xuICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjZWRlZmY1O1xuICAgICAgICBib3JkZXI6IHRyYW5zcGFyZW50O1xuICAgICAgICBwYWRkaW5nOiA1cHggMTFweDtcbiAgICAgICAgaGVpZ2h0OiA0MHB4O1xuICAgICAgICBib3JkZXItYm90dG9tOiAxcHggc29saWQgIzhlOGU5MDtcbiAgICAgIH1cbiAgICAgICYuc2VsZWN0LXJlc3BvbnNpdmUge1xuICAgICAgICAuYW50LXNlbGVjdC1zZWxlY3RvciB7XG4gICAgICAgICAgaGVpZ2h0OiAxMDAlO1xuICAgICAgICB9XG4gICAgICB9XG4gICAgfVxuICAgIHRhYmxlIHtcbiAgICAgIHRoZWFkIHtcbiAgICAgICAgdHIge1xuICAgICAgICAgIHRoIHtcbiAgICAgICAgICAgIHdpZHRoOiAxMDBweDtcbiAgICAgICAgICAgICY6bnRoLWNoaWxkKDIpIHtcbiAgICAgICAgICAgICAgd2lkdGg6IDEwMHB4O1xuICAgICAgICAgICAgfVxuICAgICAgICAgIH1cbiAgICAgICAgfVxuICAgICAgfVxuICAgICAgdGJvZHkge1xuICAgICAgICB0ciB7XG4gICAgICAgICAgJjpudGgtY2hpbGQob2RkKSB7XG4gICAgICAgICAgICB0ZCB7XG4gICAgICAgICAgICAgIGJhY2tncm91bmQtY29sb3I6ICNmNWY1ZjU7XG4gICAgICAgICAgICB9XG4gICAgICAgICAgfVxuICAgICAgICAgICY6bnRoLWNoaWxkKGV2ZW4pIHtcbiAgICAgICAgICAgIHRkIHtcbiAgICAgICAgICAgICAgYmFja2dyb3VuZC1jb2xvcjogdW5zZXQ7XG4gICAgICAgICAgICB9XG4gICAgICAgICAgfVxuICAgICAgICB9XG4gICAgICB9XG4gICAgfVxuICAgIC5hbnQtc2VsZWN0LXNlbGVjdGlvbi1wbGFjZWhvbGRlciB7XG4gICAgICBjb2xvcjogIzI3MjcyODtcbiAgICAgIGZvbnQtZmFtaWx5OiAnSUJNIFBsZXggU2Fucyc7XG4gICAgfVxuICB9XG59XG4uYW50LXNlbGVjdC1pdGVtLW9wdGlvbi1zZWxlY3RlZC5zZWxlY3RPcHRpb25zIHtcbiAgYmFja2dyb3VuZC1jb2xvcjogI2VkZWRlZDtcbn1cbi5hbnQtZGl2aWRlci1ob3Jpem9udGFsIHtcbiAgbWFyZ2luOiAwIDAgMTJweCAwO1xuICBib3JkZXItdG9wOiAycHggc29saWQgI2M2YzZjNjtcbn1cbi5tYWluLWhlYWRlci1zZWMge1xuICAudGl0bGVDb2wge1xuICAgIHBhZGRpbmctbGVmdDogMjBweDtcbiAgfVxuICAudGl0bGVGaWVsZCB7XG4gICAgY29sb3I6IHJnYmEoMCwgMCwgMCwgMC44Nyk7XG4gICAgZm9udC1mYW1pbHk6ICRmb250LWRlZmF1bHQ7XG4gICAgZm9udC1zaXplOiAzMnB4O1xuICAgIGxldHRlci1zcGFjaW5nOiAwO1xuICAgIGxpbmUtaGVpZ2h0OiA0MHB4O1xuICAgIG1hcmdpbjogMCAhaW1wb3J0YW50O1xuICAgIHBhZGRpbmctYm90dG9tOiA1cHg7XG4gIH1cbn1cbiIsIi5kZWZpbmVDb2RlU2VjIHtcbiAgLmRpdmlkZXItZGF0YSB7XG4gICAgbWFyZ2luLXRvcDogMDtcbiAgfVxuICAubXRjaHBhcmEge1xuICAgIGNvbG9yOiByZ2JhKDAsIDAsIDAsIDAuODcpO1xuICAgIGZvbnQtZmFtaWx5OiAnT3BlbiBTYW5zJztcbiAgICBmb250LXNpemU6IDE0cHg7XG4gICAgbGV0dGVyLXNwYWNpbmc6IDA7XG4gICAgbGluZS1oZWlnaHQ6IDIwcHg7XG4gICAgbWFyZ2luLWJvdHRvbTogMzBweDtcbiAgfVxuICAuc3Bpbm5lciB7XG4gICAgbWFyZ2luOiAyMHB4IDA7XG4gICAgbWFyZ2luLWJvdHRvbTogMjBweDtcbiAgICBwYWRkaW5nOiAzMHB4IDUwcHg7XG4gICAgdGV4dC1hbGlnbjogY2VudGVyO1xuICAgIGJhY2tncm91bmQ6IHJnYmEoMCwgMCwgMCwgMC4wNSk7XG4gICAgYm9yZGVyLXJhZGl1czogNHB4O1xuICB9XG4gIC5pbXBydFNlY3Rpb24ge1xuICAgIHAge1xuICAgICAgbWFyZ2luOiAwO1xuICAgICAgc3Ryb25nIHtcbiAgICAgICAgZm9udC1zaXplOiAxNnB4O1xuICAgICAgfVxuICAgIH1cbiAgfVxuICAubWFpbkRhdGFUYWJsZVNlY3Rpb24ge1xuICAgIC50aXRsZU1hdGNoRmllbGQge1xuICAgICAgbWFyZ2luLXRvcDogMzBweDtcbiAgICB9XG4gICAgdGFibGUge1xuICAgICAgd2lkdGg6IDEwMCU7XG4gICAgICB0aGVhZCB7XG4gICAgICAgIHRyIHtcbiAgICAgICAgICB0aCB7XG4gICAgICAgICAgICB3aWR0aDogMjUwcHg7XG4gICAgICAgICAgICAmOm50aC1jaGlsZCgyKSB7XG4gICAgICAgICAgICAgIHdpZHRoOiAxNTBweDtcbiAgICAgICAgICAgIH1cbiAgICAgICAgICB9XG4gICAgICAgIH1cbiAgICAgIH1cbiAgICAgIHRib2R5IHtcbiAgICAgICAgdHIge1xuICAgICAgICAgICY6bnRoLWNoaWxkKG9kZCkge1xuICAgICAgICAgICAgdGQge1xuICAgICAgICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiB1bnNldDtcbiAgICAgICAgICAgIH1cbiAgICAgICAgICB9XG4gICAgICAgICAgJjpudGgtY2hpbGQoZXZlbikge1xuICAgICAgICAgICAgdGQge1xuICAgICAgICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjZjVmNWY1O1xuICAgICAgICAgICAgfVxuICAgICAgICAgIH1cbiAgICAgICAgICB0ZCB7XG4gICAgICAgICAgICBwYWRkaW5nOiAwIDEwcHg7XG4gICAgICAgICAgICAudGV4dC1pbnB1dCB7XG4gICAgICAgICAgICAgIG1hcmdpbi10b3A6IDA7XG4gICAgICAgICAgICAgIGhlaWdodDogMzJweDtcbiAgICAgICAgICAgICAgYm9yZGVyLWJvdHRvbTogMXB4IHNvbGlkICM3MTczNzQ7XG4gICAgICAgICAgICAgIGJvcmRlci1yYWRpdXM6IDRweCA0cHggMCAwO1xuICAgICAgICAgICAgICAtd2Via2l0LWJvcmRlci1yYWRpdXM6IDRweCA0cHggMCAwO1xuICAgICAgICAgICAgICAtbW96LWJvcmRlci1yYWRpdXM6IDRweCA0cHggMCAwO1xuICAgICAgICAgICAgICAtbXMtYm9yZGVyLXJhZGl1czogNHB4IDRweCAwIDA7XG4gICAgICAgICAgICAgIC1vLWJvcmRlci1yYWRpdXM6IDRweCA0cHggMCAwO1xuICAgICAgICAgICAgICAmOmZvY3VzIHtcbiAgICAgICAgICAgICAgICBib3gtc2hhZG93OiBub25lO1xuICAgICAgICAgICAgICB9XG4gICAgICAgICAgICB9XG4gICAgICAgICAgICAucmFkaW8taXRlbSAuYW50LXJhZGlvLWlubmVyIHtcbiAgICAgICAgICAgICAgYmFja2dyb3VuZDogdHJhbnNwYXJlbnQ7XG4gICAgICAgICAgICB9XG4gICAgICAgICAgfVxuICAgICAgICB9XG4gICAgICB9XG4gICAgfVxuICB9XG59XG4iLCIubWFpblNhdmVJbXBvcnRTZXR0aW5ncyB7XG4gIGhlaWdodDogMTAwdmg7XG59XG5cbi5hY3Rpb25zSWNvbiB7XG4gIHN2ZyB7XG4gICAgd2lkdGg6IDIwcHggIWltcG9ydGFudDtcbiAgfVxufVxuXG4uZWRpdC1hY3Rpb24ge1xuICBtYXJnaW4tcmlnaHQ6IDE4cHg7XG4gIG1hcmdpbi1sZWZ0OiA0cHg7XG4gIHdpZHRoOiAyNHB4O1xufVxuXG4uZWRpdC1hY3Rpb24ge1xuICBtYXJnaW4tcmlnaHQ6IDE4cHg7XG4gIG1hcmdpbi1sZWZ0OiA0cHg7XG5cbiAgPiBzdmcge1xuICAgIHdpZHRoOiAyNHB4ICFpbXBvcnRhbnQ7XG4gIH1cblxuICAmW2Rpc2FibGVkXSB7XG4gICAgcG9pbnRlci1ldmVudHM6IG5vbmU7XG4gIH1cbn1cblxuLmRlbGV0ZS1hY3Rpb24ge1xuICBzdmcge1xuICAgIHdpZHRoOiAxOHB4O1xuICAgIHZlcnRpY2FsLWFsaWduOiBib3R0b207XG4gICAgbWFyZ2luLWxlZnQ6IDVweDtcbiAgfVxufVxuXG4uZGlzYWJsZS1hY3Rpb24ge1xuICBzdmcge1xuICAgIG1hcmdpbi1ib3R0b206IDRweDtcbiAgfVxuXG4gICZbZGlzYWJsZWRdIHtcbiAgICBwb2ludGVyLWV2ZW50czogbm9uZTtcbiAgfVxufVxuIiwiLm1haW5EcmF3ZXJTZWN0aW9uIHtcbiAgbWFyZ2luLXRvcDogODBweDtcbiAgLm1haW5EcmF3ZXIge1xuICAgIFxuICAgIC5kcmF3ZXJUaXRsZSB7XG4gICAgICBjb2xvcjogIzExMTExMTtcbiAgICAgIGZvbnQtZmFtaWx5OiAkZm9udC1vcztcbiAgICAgIGZvbnQtc2l6ZTogMjhweDtcbiAgICAgIGxldHRlci1zcGFjaW5nOiAwO1xuICAgICAgbGluZS1oZWlnaHQ6IDM2cHg7XG4gICAgICBtYXJnaW4tYm90dG9tOiAyMHB4O1xuICAgICAgZm9udC13ZWlnaHQ6IDUwMDtcbiAgICB9XG4gICAgLmRyYXdlclN1YlRpdGxlIHtcbiAgICAgIGNvbG9yOiAjMjcyNzI4O1xuICAgICAgZm9udC1mYW1pbHk6ICRmb250LW9zO1xuICAgICAgZm9udC1zaXplOiAxOHB4O1xuICAgICAgZm9udC13ZWlnaHQ6IGJvbGQ7XG4gICAgICBsZXR0ZXItc3BhY2luZzogMC4xOXB4O1xuICAgICAgbGluZS1oZWlnaHQ6IDI0cHg7XG4gICAgfVxuICAgIC5kcmF3ZXJEZXNjcmlwdGlvbiB7XG4gICAgICBjb2xvcjogIzI3MjcyODtcbiAgICAgIGZvbnQtZmFtaWx5OiAkZm9udC1vcztcbiAgICAgIGZvbnQtc2l6ZTogJGZvbnQtc2l6ZTE2O1xuICAgICAgbGV0dGVyLXNwYWNpbmc6IDA7XG4gICAgICBsaW5lLWhlaWdodDogMjJweDtcbiAgICAgIG1hcmdpbi1ib3R0b206IDIwcHg7XG4gICAgfVxuICAgIC5kcmF3ZXJMYWJsZVRleHQge1xuICAgICAgY29sb3I6ICRkYXJrLXNoYWRlO1xuICAgICAgZm9udC1mYW1pbHk6ICRmb250LWRlZmF1bHQ7XG4gICAgICBmb250LXNpemU6ICRmb250LXNpemUxNjtcbiAgICAgIGxldHRlci1zcGFjaW5nOiAwLjQzcHg7XG4gICAgICBsaW5lLWhlaWdodDogMjBweDtcbiAgICAgIG1hcmdpbi1ib3R0b206IDA7XG4gICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuICAgIH1cbiAgICAuYm9sZERyYXdlckxhYmVsVGV4dCB7XG4gICAgICBmb250LXdlaWdodDogYm9sZDtcbiAgICB9XG4gICAgLmFudC1zZWxlY3Qtc2VsZWN0aW9uLXBsYWNlaG9sZGVyIHtcbiAgICAgIGNvbG9yOiAjYTJhMmE0ICFpbXBvcnRhbnQ7XG4gICAgICBmb250LXNpemU6ICRmb250LXNpemUxNjtcbiAgICB9XG4gICAgLmFkZEJ0bi5idXR0b24ge1xuICAgICAgbWFyZ2luOiAyNXB4IDAgMCAwO1xuICAgIH1cbiAgICAuZHJhd2VyVG9wR3V0dGVyIHtcbiAgICAgIG1hcmdpbi10b3A6IDMwcHg7XG4gICAgfVxuICAgIC5saW5lVG9wR3V0dGVyIHtcbiAgICAgIG1hcmdpbi10b3A6IDVweDtcbiAgICB9XG5cbiAgICAubW9kYWwge1xuICAgICAgdG9wOiAnNTUlJztcbiAgICAgIGxlZnQ6ICc1MCUnO1xuICAgICAgcmlnaHQ6ICdhdXRvJztcbiAgICAgIGJvdHRvbTogJ2F1dG8nO1xuICAgICAgd2lkdGg6ICc2MCUnO1xuICAgICAgY29sb3I6ICMxMGQwOTc7XG4gICAgICB0cmFuc2Zvcm06ICd0cmFuc2xhdGUoLTQwJSwgLTEwJSknO1xuICAgIH1cblxuICAgIC5kcmF3ZXJJbnB1dCB7XG4gICAgICBoZWlnaHQ6IDQwcHg7XG4gICAgICBtYXJnaW46IDA7XG4gICAgICBwYWRkaW5nOiA1cHggMTBweDtcbiAgICB9XG4gICAgLmRyYXdlckludmFsaWRJbnB1dCB7XG4gICAgICBib3JkZXI6IDJweCBzb2xpZCAjZDkxZTI4O1xuICAgICAgYm9yZGVyLXJhZGl1czogNXB4O1xuICAgIH1cbiAgICAuaW5wdXRFcnJvckljb24ge1xuICAgICAgY29sb3I6ICNkOTFlMjg7XG4gICAgICBtYXJnaW4tdG9wOiAtMnJlbTtcbiAgICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICAgIHJpZ2h0OiAwO1xuICAgICAgZm9udC1zaXplOiAxcmVtO1xuICAgIH1cbiAgICBpbnB1dFt0eXBlPSd0ZXh0J10sXG4gICAgaW5wdXRbdHlwZT0ncGFzc3dvcmQnXSB7XG4gICAgICBtYXgtd2lkdGg6IDI5MHB4O1xuXG4gICAgICAmLmRyYXdlcklucHV0RnVsbCB7XG4gICAgICAgIG1heC13aWR0aDogMTAwJTtcbiAgICAgIH1cbiAgICB9XG4gICAgLmRyYXdlclNob3dMaW5rIHtcbiAgICAgIGNvbG9yOiAkdGFibGV0ZXh0LWNvbG9yO1xuICAgICAgZm9udC1zaXplOiAkZm9udC1zaXplMTQgLSAxO1xuICAgIH1cbiAgICAubm90ZSB7XG4gICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjZmZmZGU1O1xuICAgICAgcGFkZGluZzogMTVweCAyMHB4O1xuICAgICAgcG9zaXRpb246IHJlbGF0aXZlO1xuICAgICAgJjo6YmVmb3JlIHtcbiAgICAgICAgY29udGVudDogJyc7XG4gICAgICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICAgICAgaGVpZ2h0OiA1NHB4O1xuICAgICAgICB3aWR0aDogM3B4O1xuICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjZmNkNzAzO1xuICAgICAgICB0b3A6IDA7XG4gICAgICAgIGxlZnQ6IDA7XG4gICAgICB9XG4gICAgICAuZHJhd2VyTGFibGVUZXh0IHtcbiAgICAgICAgY29sb3I6ICMyNzI3Mjg7XG4gICAgICAgIGZvbnQtc2l6ZTogJGZvbnQtc2l6ZTE0O1xuICAgICAgfVxuICAgICAgc3Ryb25nIHtcbiAgICAgICAgY29sb3I6ICMyNzI3Mjg7XG4gICAgICAgIGZvbnQtZmFtaWx5OiAkZm9udC1vcztcbiAgICAgICAgZm9udC1zaXplOiAkZm9udC1zaXplMTY7XG4gICAgICAgIGZvbnQtd2VpZ2h0OiA2MDA7XG4gICAgICAgIHN2ZyB7XG4gICAgICAgICAgd2lkdGg6IDMwcHggIWltcG9ydGFudDtcbiAgICAgICAgICBtYXJnaW46IDAgIWltcG9ydGFudDtcbiAgICAgICAgfVxuICAgICAgfVxuICAgIH1cbiAgICAuc3VjY2Vzc0Jhbm5lciB7XG4gICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjZGFmOWU5O1xuICAgICAgcGFkZGluZzogMTBweCAyMHB4O1xuICAgICAgbWFyZ2luLWJvdHRvbTogMjBweDtcbiAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAmOjpiZWZvcmUge1xuICAgICAgICBjb250ZW50OiAnJztcbiAgICAgICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgICAgICBoZWlnaHQ6IDYwcHg7XG4gICAgICAgIHdpZHRoOiAzcHg7XG4gICAgICAgIGJhY2tncm91bmQtY29sb3I6ICMxMGQwOTc7XG4gICAgICAgIHRvcDogMDtcbiAgICAgICAgbGVmdDogMDtcbiAgICAgIH1cbiAgICAgIC5kcmF3ZXJMYWJsZVRleHQge1xuICAgICAgICBjb2xvcjogIzI3MjcyODtcbiAgICAgICAgZm9udC1zaXplOiAkZm9udC1zaXplMTY7XG4gICAgICB9XG4gICAgICA6bnRoLWxhc3QtY2hpbGQoMikge1xuICAgICAgICBmbGV4LWdyb3c6IDE7XG4gICAgICB9XG4gICAgICBzdHJvbmcge1xuICAgICAgICBjb2xvcjogIzI3MjcyODtcbiAgICAgICAgZm9udC1mYW1pbHk6ICRmb250LW9zO1xuICAgICAgICBmb250LXNpemU6ICRmb250LXNpemUxNjtcbiAgICAgICAgZm9udC13ZWlnaHQ6IDYwMDtcbiAgICAgICAgc3ZnIHtcbiAgICAgICAgICB3aWR0aDogMzBweCAhaW1wb3J0YW50O1xuICAgICAgICAgIG1hcmdpbjogMTBweCAwIDAgMCAhaW1wb3J0YW50O1xuICAgICAgICB9XG4gICAgICB9XG4gICAgfVxuICAgIC5lcnJvckJhbm5lciB7XG4gICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjZmRjOWNiO1xuICAgICAgcGFkZGluZzogMTBweCAyMHB4O1xuICAgICAgbWFyZ2luLWJvdHRvbTogMjBweDtcbiAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAmOjpiZWZvcmUge1xuICAgICAgICBjb250ZW50OiAnJztcbiAgICAgICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgICAgICBoZWlnaHQ6IDYwcHg7XG4gICAgICAgIHdpZHRoOiAzcHg7XG4gICAgICAgIGJhY2tncm91bmQtY29sb3I6ICNkYTFlMjg7XG4gICAgICAgIHRvcDogMDtcbiAgICAgICAgbGVmdDogMDtcbiAgICAgIH1cbiAgICAgIC5kcmF3ZXJMYWJsZVRleHQge1xuICAgICAgICBjb2xvcjogIzI3MjcyODtcbiAgICAgICAgZm9udC1zaXplOiAkZm9udC1zaXplMTY7XG4gICAgICB9XG4gICAgICA6bnRoLWxhc3QtY2hpbGQoMikge1xuICAgICAgICBmbGV4LWdyb3c6IDE7XG4gICAgICB9XG4gICAgICBzdHJvbmcge1xuICAgICAgICBjb2xvcjogIzI3MjcyODtcbiAgICAgICAgZm9udC1mYW1pbHk6ICRmb250LW9zO1xuICAgICAgICBmb250LXNpemU6ICRmb250LXNpemUxNjtcbiAgICAgICAgZm9udC13ZWlnaHQ6IDYwMDtcbiAgICAgICAgc3ZnIHtcbiAgICAgICAgICB3aWR0aDogMzBweCAhaW1wb3J0YW50O1xuICAgICAgICAgIG1hcmdpbjogMTBweCAwIDAgMCAhaW1wb3J0YW50O1xuICAgICAgICB9XG4gICAgICB9XG4gICAgfVxuICAgIC5nZW5jcmVkIHtcbiAgICAgIGEge1xuICAgICAgICB0ZXh0LWRlY29yYXRpb246IHVuZGVybGluZTtcbiAgICAgIH1cbiAgICAgIC5kcmF3ZXJMYWJsZVRleHQge1xuICAgICAgICBtYXJnaW4tdG9wOiAxMHB4O1xuICAgICAgICBjb2xvcjogIzY1NjU2NztcbiAgICAgICAgZm9udC1zaXplOiAkZm9udC1zaXplMTQ7XG4gICAgICB9XG4gICAgfVxuICAgIC5kcmF3ZXJBbGVydENsb3NlIHtcbiAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICBqdXN0aWZ5LWNvbnRlbnQ6IGZsZXgtZW5kO1xuICAgICAgc3ZnIHtcbiAgICAgICAgd2lkdGg6IDI0cHggIWltcG9ydGFudDtcbiAgICAgICAgcGF0aCB7XG4gICAgICAgICAgZmlsbDogIzI3MjcyODtcbiAgICAgICAgfVxuICAgICAgfVxuICAgIH1cbiAgICAuZHJhd2VyU2VsZWN0RHJvcGRvd24ge1xuICAgICAgLnNlbGVjdCB7XG4gICAgICAgIHBhZGRpbmctdG9wOiA1cHg7XG4gICAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgICAuYW50LXNlbGVjdCB7XG4gICAgICAgICAgJi1zZWxlY3RvciB7XG4gICAgICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjZWRlZmY1O1xuICAgICAgICAgICAgYm9yZGVyOiB0cmFuc3BhcmVudDtcbiAgICAgICAgICAgIHBhZGRpbmc6IDVweCAxMXB4O1xuICAgICAgICAgICAgaGVpZ2h0OiA0MHB4O1xuICAgICAgICAgICAgYm9yZGVyLWJvdHRvbTogMXB4IHNvbGlkICRibGFjaztcbiAgICAgICAgICAgIGJvcmRlci1yYWRpdXM6IDBweCAwcHggMHB4IDBweDtcbiAgICAgICAgICAgIC13ZWJraXQtYm9yZGVyLXJhZGl1czogMHB4IDBweCAwcHggMHB4O1xuICAgICAgICAgICAgLW1vei1ib3JkZXItcmFkaXVzOiAwcHggMHB4IDBweCAwcHg7XG4gICAgICAgICAgICAtbXMtYm9yZGVyLXJhZGl1czogMHB4IDBweCAwcHggMHB4O1xuICAgICAgICAgICAgLW8tYm9yZGVyLXJhZGl1czogMHB4IDBweCAwcHggMHB4O1xuICAgICAgICAgICAgYm94LXNoYWRvdzogbm9uZTtcbiAgICAgICAgICB9XG4gICAgICAgICAgJi1hcnJvdyB7XG4gICAgICAgICAgICBjb2xvcjogJHRhYmxldGV4dC1jb2xvcjtcbiAgICAgICAgICAgIC5hbnRpY29uLWRvd24ge1xuICAgICAgICAgICAgICB2ZXJ0aWNhbC1hbGlnbjogbWlkZGxlO1xuICAgICAgICAgICAgICBzdmcge1xuICAgICAgICAgICAgICAgIHRyYW5zZm9ybTogc2NhbGUoMS4zLCAxKTtcbiAgICAgICAgICAgICAgICBoZWlnaHQ6IDEwcHg7XG4gICAgICAgICAgICAgICAgd2lkdGg6IDE0cHg7XG4gICAgICAgICAgICAgIH1cbiAgICAgICAgICAgIH1cbiAgICAgICAgICB9XG4gICAgICAgICAgJi1zZWxlY3Rpb24ge1xuICAgICAgICAgICAgJi1wbGFjZWhvbGRlciB7XG4gICAgICAgICAgICAgIGNvbG9yOiAjNjY2NjY2O1xuICAgICAgICAgICAgfVxuICAgICAgICAgIH1cbiAgICAgICAgICAmLWZvY3VzZWQ6bm90KC5hbnQtc2VsZWN0LWRpc2FibGVkKS5hbnQtc2VsZWN0Om5vdCguYW50LXNlbGVjdC1jdXN0b21pemUtaW5wdXQpIHtcbiAgICAgICAgICAgIC5hbnQtc2VsZWN0LXNlbGVjdG9yIHtcbiAgICAgICAgICAgICAgYm94LXNoYWRvdzogbm9uZTtcbiAgICAgICAgICAgICAgb3V0bGluZTogbm9uZTtcbiAgICAgICAgICAgIH1cbiAgICAgICAgICB9XG4gICAgICAgICAgJjpob3ZlcixcbiAgICAgICAgICAmOmZvY3VzIHtcbiAgICAgICAgICAgIC5hbnQtc2VsZWN0LXNlbGVjdG9yIHtcbiAgICAgICAgICAgICAgYm9yZGVyLWNvbG9yOiAkYmxhY2s7XG4gICAgICAgICAgICB9XG4gICAgICAgICAgfVxuICAgICAgICB9XG4gICAgICB9XG4gICAgfVxuICAgIC5kcmF3ZXJUYWJsZUljb25zIHtcbiAgICAgIHRleHQtYWxpZ246IHJpZ2h0O1xuICAgICAgc3ZnIHtcbiAgICAgICAgd2lkdGg6IDIwcHggIWltcG9ydGFudDtcbiAgICAgICAgcGF0aCB7XG4gICAgICAgICAgZmlsbDogIzNkM2QzZTtcbiAgICAgICAgfVxuICAgICAgfVxuICAgIH1cbiAgICAuZHJhd2VyU2VsZWN0Q29udGFpbmVyIHtcbiAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICBqdXN0aWZ5LWNvbnRlbnQ6IGZsZXgtc3RhcnQ7XG4gICAgICBnYXA6IDEycHg7XG4gICAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgICAgbWFyZ2luLWJvdHRvbTogMjBweDtcblxuICAgICAgLmRpc2FibGVkIHtcbiAgICAgICAgY29sb3I6ICNhMmEyYTQ7XG4gICAgICB9XG4gICAgfVxuICAgIC5kcmF3ZXJMaW5rQ29udGFpbmVyIHtcbiAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICBnYXA6IDRweDtcblxuICAgICAgPiAqIHtcbiAgICAgICAgZm9udC1zaXplOiAkZm9udC1zaXplMTQ7XG4gICAgICB9XG4gICAgfVxuICB9XG4gIC5hbnQtZHJhd2VyLWNvbnRlbnQge1xuICAgIGJvcmRlcjogMXB4IHNvbGlkICNiYWMyZDA7XG4gICAgLmFudC1kcmF3ZXItYm9keSB7XG4gICAgICBtYXJnaW4tYm90dG9tOiA4MHB4O1xuICAgIH1cbiAgICAuYW50LWRyYXdlci1oZWFkZXIge1xuICAgICAgYm94LXNoYWRvdzogMCAxcHggMnB4IDAgcmdiYSgwLCAwLCAwLCAwLjI0KTtcbiAgICAgIHBhZGRpbmc6IDI2cHggMjBweDtcbiAgICAgIC5hbnQtZHJhd2VyLWNsb3NlIHtcbiAgICAgICAgcmlnaHQ6IHVuc2V0O1xuICAgICAgICBsZWZ0OiAwO1xuICAgICAgICBjb2xvcjogJHRhYmxldGV4dC1jb2xvcjtcbiAgICAgICAgcGFkZGluZzogMjVweCAyMHB4O1xuICAgICAgICBmb250LXNpemU6ICRmb250LXNpemUxNiArIDQ7XG4gICAgICB9XG4gICAgICAuYW50LWRyYXdlci10aXRsZSB7XG4gICAgICAgIHBhZGRpbmctbGVmdDogMjVweDtcbiAgICAgICAgY29sb3I6ICR0YWJsZXRleHQtY29sb3I7XG4gICAgICAgIGZvbnQtZmFtaWx5OiAkZm9udC1vcztcbiAgICAgICAgZm9udC1zaXplOiAkZm9udC1zaXplMTQ7XG4gICAgICAgIGxldHRlci1zcGFjaW5nOiAwO1xuICAgICAgICBsaW5lLWhlaWdodDogMThweDtcbiAgICAgIH1cbiAgICB9XG4gIH1cbiAgLm1haW5NYXRjaEZpZWxkc1NlY3Rpb24ge1xuICAgIGhlaWdodDogYXV0bztcbiAgfVxufVxuIiwiLm1haW5Mb2dzU2VjdGlvbiB7XG4gIGhlaWdodDogYXV0bztcblxuICAuc3Bpbm5lciB7XG4gICAgbWFyZ2luOiAyMHB4IDA7XG4gICAgbWFyZ2luLWJvdHRvbTogMjBweDtcbiAgICBwYWRkaW5nOiAzMHB4IDUwcHg7XG4gICAgdGV4dC1hbGlnbjogY2VudGVyO1xuICAgIGJhY2tncm91bmQ6IHJnYmEoMCwgMCwgMCwgMC4wNSk7XG4gICAgYm9yZGVyLXJhZGl1czogNHB4O1xuICB9XG5cbiAgLm1haW4taGVhZGVyLXNlYyB7XG4gICAgcGFkZGluZy1yaWdodDogMzBweDtcbiAgICBwYWRkaW5nLXRvcDogMDtcbiAgfVxuICAubWFpbldoaXRlYmdXcmFwcGVyIHtcbiAgICBtYXJnaW46IDAgMzBweCAzMHB4IDMwcHg7XG4gICAgcGFkZGluZzogMTVweCAyMHB4O1xuICAgIGhlaWdodDogMTAwdmg7XG4gIH1cbiAgLmJja0J0biB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICBjdXJzb3I6IHBvaW50ZXI7XG4gICAgc3ZnIHtcbiAgICAgIHdpZHRoOiAyNnB4O1xuICAgIH1cbiAgfVxuICAuYmFja2J0biB7XG4gICAgY29sb3I6ICMzYjdiYzY7XG4gICAgZm9udC1mYW1pbHk6ICRmb250LWRlZmF1bHQ7XG4gICAgZm9udC1zaXplOiAkZm9udC1zaXplMTQ7XG4gICAgZm9udC13ZWlnaHQ6IDYwMDtcbiAgICBsZXR0ZXItc3BhY2luZzogMDtcbiAgICBsaW5lLWhlaWdodDogMTlweDtcbiAgICBtYXJnaW4tdG9wOiAtMTJweDtcbiAgICB0ZXh0LWRlY29yYXRpb246IHVuZGVybGluZTtcbiAgfVxuICAuaW1wRGV0YWlscyB7XG4gICAgdWwge1xuICAgICAgcGFkZGluZzogMDtcbiAgICAgIGxpc3Qtc3R5bGU6IG5vbmU7XG4gICAgICBsaSB7XG4gICAgICAgIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgICAgICAgd2lkdGg6IDUwJTtcbiAgICAgIH1cbiAgICB9XG4gIH1cbiAgLmRhcmtUZXh0IHtcbiAgICBjb2xvcjogJGJsYWNrO1xuICAgIGZvbnQtZmFtaWx5OiAkZm9udC1kZWZhdWx0O1xuICAgIGZvbnQtc2l6ZTogJGZvbnQtc2l6ZTE2O1xuICAgIGxldHRlci1zcGFjaW5nOiAwLjE4cHg7XG4gICAgbGluZS1oZWlnaHQ6IDIycHg7XG4gIH1cbiAgLmxpZ2h0VGV4dCB7XG4gICAgY29sb3I6ICRibGFjaztcbiAgICBmb250LWZhbWlseTogJGZvbnQtZGVmYXVsdDtcbiAgICBmb250LXNpemU6ICRmb250LXNpemUxNCAtIDE7XG4gICAgbGV0dGVyLXNwYWNpbmc6IDAuMTVweDtcbiAgICBsaW5lLWhlaWdodDogMThweDtcbiAgfVxuICAuaW1wU3VtbWFyeSB7XG4gICAgdWwge1xuICAgICAgbGlzdC1zdHlsZTogbm9uZTtcbiAgICAgIHBhZGRpbmc6IDBweDtcbiAgICB9XG4gIH1cbiAgLm5lZEF0dGVudGlvbiB7XG4gICAgaDUge1xuICAgICAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xuICAgIH1cbiAgICBzcGFuIHtcbiAgICAgIHBhZGRpbmctbGVmdDogNXB4O1xuICAgIH1cbiAgfVxuXG4gIC5wYWRkZWRIMSB7XG4gICAgcGFkZGluZy10b3A6IDEwcHg7XG4gIH1cblxuICAubWFpblBlcmZvcm1UaW1lV3JhcHBlciB7XG4gICAgLnZpZXdMb2dUYWJsZSB7XG4gICAgICB0ciB7XG4gICAgICAgICY6Zmlyc3Qtb2YtdHlwZSB7XG4gICAgICAgICAgdGQge1xuICAgICAgICAgICAgYm9yZGVyLXRvcDogMXB4IHNvbGlkICNkNmQ2ZDY7XG4gICAgICAgICAgfVxuICAgICAgICB9XG4gICAgICAgIHRkIHtcbiAgICAgICAgICBiYWNrZ3JvdW5kOiB1bnNldDtcbiAgICAgICAgICBib3JkZXItYm90dG9tOiAxcHggc29saWQgI2Q2ZDZkNjtcbiAgICAgICAgICB2ZXJ0aWNhbC1hbGlnbjogdG9wO1xuICAgICAgICB9XG4gICAgICB9XG4gICAgfVxuICB9XG59XG4iLCIubWFpbi1mb290ZXIge1xuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47XG4gIG1hcmdpbi10b3A6IGF1dG87XG59XG5cbi5mb290ZXItY29udGVudCB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIGZvbnQtc2l6ZTogMTJweDtcbn1cbiIsIi5zaWRlYmFyLWNvbnRlbnQge1xuICBiYWNrZ3JvdW5kOiAjZjBmMmY1O1xufVxuXG4ud2l6YXJkLWhlYWRlciB7XG4gIGJhY2tncm91bmQ6ICMwNzFkNGU7XG4gIGNvbG9yOiB3aGl0ZTtcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xuICBoZWlnaHQ6IGF1dG87XG4gIGxpbmUtaGVpZ2h0OiAzMHB4O1xuICBwYWRkaW5nOiA4cHggMHB4O1xuXG4gID4gaDIsXG4gID4gaDQge1xuICAgIGNvbG9yOiB3aGl0ZTtcbiAgICBtYXJnaW46IDBweDtcbiAgfVxufVxuXG4ud2l6YXJkLXN0ZXBzIHtcbiAgbWFyZ2luLXRvcDogMjBweDtcbiAgbWFyZ2luLWxlZnQ6IDIwcHg7XG5cbiAgLmFudC1zdGVwcy1pdGVtLXRhaWwge1xuICAgIGxlZnQ6IC02cHggIWltcG9ydGFudDtcbiAgICB0b3A6IDRweCAhaW1wb3J0YW50O1xuXG4gICAgJjphZnRlciB7XG4gICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAkc2h1dHRsZWdyYXkgIWltcG9ydGFudDtcbiAgICB9XG4gIH1cblxuICAud2l6YXJkLXN0ZXAtcHJvY2VzcyB7XG4gICAgLmNpcmNsZS1pY29uIHtcbiAgICAgIGJhY2tncm91bmQ6ICMxODkwZmY7XG4gICAgICBib3JkZXItY29sb3I6ICMxODkwZmY7XG4gICAgfVxuICAgIC5hbnQtc3RlcHMtaXRlbS10aXRsZSB7XG4gICAgICBjb2xvcjogIzE4OTBmZiAhaW1wb3J0YW50O1xuICAgIH1cbiAgfVxuXG4gIC53aXphcmQtc3RlcC13YWl0IHtcbiAgICAuYW50LXN0ZXBzLWl0ZW0tdGl0bGUge1xuICAgICAgY29sb3I6ICRzaHV0dGxlZ3JheSAhaW1wb3J0YW50O1xuICAgIH1cbiAgfVxufVxuXG4uY2lyY2xlLWljb24ge1xuICBiYWNrZ3JvdW5kOiB3aGl0ZTtcbiAgYm9yZGVyOiAycHggc29saWQgJHNodXR0bGVncmF5O1xuICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gIGZsb2F0OiBsZWZ0O1xuICB3aWR0aDogMTAwJTtcbiAgaGVpZ2h0OiAxMDAlO1xuICBib3JkZXItcmFkaXVzOiAxMDBweDtcbiAgaGVpZ2h0OiAxMnB4O1xuICB3aWR0aDogMTJweDtcbn1cblxuLndpemFyZC1mb290ZXIge1xuICBiYWNrZ3JvdW5kOiB3aGl0ZTtcbiAgYm9yZGVyLXRvcDogMXB4IHNvbGlkICNmMGYyZjU7XG5cbiAgLndpemFyZC1mb290ZXItbWFpbiB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47XG4gIH1cbn1cblxuLndpemFyZC1jb250ZW50LWhlYWRlciB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGp1c3RpZnktY29udGVudDogc3BhY2UtYmV0d2VlbjtcbiAgbWFyZ2luLWJvdHRvbTogNnB4O1xufVxuXG4ud2l6YXJkLWxheW91dCB7XG4gIG1pbi1oZWlnaHQ6IDEwMHZoO1xuXG4gID4gLm1haW4tY29udGVudCB7XG4gICAgbWluLWhlaWdodDogMTAwJTtcbiAgfVxufVxuIiwiQHVzZSAnfmFudGQvZGlzdC9hbnRkLm1pbi5jc3MnO1xuXG5AaW1wb3J0ICcuLi9hc3NldHMvc2Fzcy9zdHlsZS5zY3NzJztcblxuLnNpc1JvdyB7XG4gIGJhY2tncm91bmQtY29sb3I6ICNlZGVmZjU7XG59XG5cbi5kZWZpbmVDb2RlcyB0YWJsZSB0Ym9keSB0ciB0ZDpudGgtb2YtdHlwZSgyKSB7XG4gIHBhZGRpbmctcmlnaHQ6IDA7XG4gIHBhZGRpbmctbGVmdDogMDtcbn1cblxuLmRlZmluZUNvZGVzIHRhYmxlIHRib2R5IHRyIHRkOmxhc3QtY2hpbGQge1xuICBwYWRkaW5nLXJpZ2h0OiAwO1xuICBwYWRkaW5nLWxlZnQ6IDA7XG59XG5cbi5idXR0b246bm90KFtkaXNhYmxlZF0pIHtcbiAgYm94LXNpemluZzogYm9yZGVyLWJveCAhaW1wb3J0YW50O1xuICBib3JkZXI6IDFweCBzb2xpZCAjMTQxNDk3ICFpbXBvcnRhbnQ7XG4gIGJvcmRlci1yYWRpdXM6IDRweCAhaW1wb3J0YW50O1xufVxuXG4uY2FuY2VsLXNhdmUtY29udGludWUtYnRuLWdyb3VwIC5jYW5jZWwtYnV0dG9uIHtcbiAgYm9yZGVyOiBub25lICFpbXBvcnRhbnQ7XG4gIGNvbG9yOiAjNTY1NjU2ICFpbXBvcnRhbnQ7XG59XG5cbi5idXR0b246bm90KFtkaXNhYmxlZF0pOmFjdGl2ZSxcbi5kcm9wZG93bl9idXR0b24gPiAuYW50LWJ0bjpub3QoW2Rpc2FibGVkXSk6YWN0aXZlIHtcbiAgYm9yZGVyLXJhZGl1czogNHB4ICFpbXBvcnRhbnQ7XG4gIGNvbG9yOiAjMTQxNDk3ICFpbXBvcnRhbnQ7XG4gIGJhY2tncm91bmQtY29sb3I6ICNlY2U2ZjYgIWltcG9ydGFudDtcbiAgYm94LXNoYWRvdzogaW5zZXQgMCAwIDVweCAwIHJnYmEoMjA2LCAxOTQsIDIzNCwgMC41KSAhaW1wb3J0YW50O1xufVxuXG4uYnV0dG9uOm5vdChbZGlzYWJsZWRdKTpob3Zlcixcbi5kcm9wZG93bl9idXR0b24gPiAuYW50LWJ0bjpub3QoW2Rpc2FibGVkXSk6aG92ZXIge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjZWNlNmY2ICFpbXBvcnRhbnQ7XG4gIGNvbG9yOiAjMTQxNDk3ICFpbXBvcnRhbnQ7XG4gIGJvcmRlci1jb2xvcjogI2VjZTZmNiAhaW1wb3J0YW50O1xuICBib3JkZXItcmFkaXVzOiA0cHggIWltcG9ydGFudDtcbn1cblxuLmJ1dHRvbjpub3QoW2Rpc2FibGVkXSk6Zm9jdXMtdmlzaWJsZSxcbi5kcm9wZG93bl9idXR0b24gPiAuYW50LWJ0bjpub3QoW2Rpc2FibGVkXSlmb2N1cy12aXNpYmxlIHtcbiAgYmFja2dyb3VuZC1jb2xvcjogI2VjZTVmNiAhaW1wb3J0YW50O1xuICBjb2xvcjogIzE0MTQ5NyAhaW1wb3J0YW50O1xuICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuICBib3JkZXI6IDJweCBzb2xpZCAjZmZmZmZmICFpbXBvcnRhbnQ7XG4gIG91dGxpbmU6IDFweCBzb2xpZCAjMTQxNDk3ICFpbXBvcnRhbnQ7XG59XG5cbi5kcm9wZG93bl9idXR0b24gPiAuYW50LWJ0bjpub3QoW2Rpc2FibGVkXSk6aG92ZXIgc3ZnIHBhdGgsXG4uYnV0dG9uOm5vdChbZGlzYWJsZWRdKTpob3ZlciBzdmcgcGF0aCxcbi5kcm9wZG93bl9idXR0b24gPiAuYW50LWJ0bjpub3QoW2Rpc2FibGVkXSk6YWN0aXZlIHN2ZyBwYXRoLFxuLmJ1dHRvbjpub3QoW2Rpc2FibGVkXSk6YWN0aXZlIHN2ZyBwYXRoIHtcbiAgZmlsbDogIzE0MTQ5NyAhaW1wb3J0YW50O1xufVxuLmRyb3Bkb3duX2J1dHRvbiA+IC5hbnQtYnRuLWljb24tb25seSB7XG4gIGhlaWdodDogdW5zZXQ7XG4gIHdpZHRoOiB1bnNldDtcbn1cblxuLmJ1dHRvbltkaXNhYmxlZF0ge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjZmZmICFpbXBvcnRhbnQ7XG4gIGNvbG9yOiAjMTQxNDk3ICFpbXBvcnRhbnQ7XG59XG5cbi5idXR0b24tYmx1ZTpub3QoW2Rpc2FibGVkXSkge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiBsaW5lYXItZ3JhZGllbnQoMTgwZGVnLCAjMjYyNmUzIDAlLCAjMTQxNDk3IDEwMCUpICFpbXBvcnRhbnQ7XG4gIGNvbG9yOiAjZmZmICFpbXBvcnRhbnQ7XG59XG5cbi5idXR0b24tYmx1ZTpub3QoW2Rpc2FibGVkXSk6aG92ZXIge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjMTQxNDk3ICFpbXBvcnRhbnQ7XG4gIGNvbG9yOiAjZmZmICFpbXBvcnRhbnQ7XG59XG5cbi5idXR0b24tYmx1ZTpub3QoW2Rpc2FibGVkXSk6YWN0aXZlIHtcbiAgYmFja2dyb3VuZC1jb2xvcjogIzFhMWFjNyAhaW1wb3J0YW50O1xuICBib3gtc2hhZG93OiBpbnNldCAwIDAgOHB4IDAgcmdiYSgxNCwgMTQsIDEwOCwgMC43KSAhaW1wb3J0YW50O1xufVxuXG4uYnV0dG9uLWJsdWU6bm90KFtkaXNhYmxlZF0pOmZvY3VzLXZpc2libGUge1xuICBib3gtc2l6aW5nOiBib3JkZXItYm94ICFpbXBvcnRhbnQ7XG4gIGJvcmRlcjogMnB4IHNvbGlkICNmZmYgIWltcG9ydGFudDtcbiAgb3V0bGluZTogMXB4IHNvbGlkICMxNDE0OTcgIWltcG9ydGFudDtcbiAgYmFja2dyb3VuZC1jb2xvcjogbGluZWFyLWdyYWRpZW50KDE4MGRlZywgIzI2MjZlMyAwJSwgIzE0MTQ5NyAxMDAlKSAhaW1wb3J0YW50O1xufVxuXG4uYnV0dG9uLWJsdWVbZGlzYWJsZWRdIHtcbiAgYmFja2dyb3VuZC1jb2xvcjogcmdiYSgyMCwgMjAsIDE1MSwgMC4xKSAhaW1wb3J0YW50O1xuICBjb2xvcjogIzhlOGU5MCAhaW1wb3J0YW50O1xufVxuXG4uY291bnNlbG9yVGFibGUgLmFudC1pbnB1dC1hZmZpeC13cmFwcGVyLFxuLmNvdW5zZWxvclRhYmxlIC5hbnQtaW5wdXQge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjZWRlZmY1O1xuICBib3JkZXI6IHRyYW5zcGFyZW50O1xufVxuXG4uY291bnNlbG9yVGFibGUgLmFudC1pbnB1dCB7XG4gIG1heC13aWR0aDogbm9uZTtcbn1cblxuLmNvdW5zZWxvclRhYmxlIC5hbnQtaW5wdXQtYWZmaXgtd3JhcHBlciB7XG4gIGJvcmRlci1ib3R0b206IDFweCBzb2xpZCAjOGU4ZTkwICFpbXBvcnRhbnQ7XG4gIHBhZGRpbmc6IDVweCAxMXB4O1xufVxuXG4uY291bnNlbG9yVGFibGUgdGQ6bnRoLW9mLXR5cGUoMikge1xuICBwYWRkaW5nLXRvcDogNXB4O1xufVxuXG4uc2Nob29sTWF0Y2hpbmcgPiAuYW50LXNlbGVjdC1zZWxlY3RvciB7XG4gIGhlaWdodDogYXV0byAhaW1wb3J0YW50O1xufVxuXG4uYWxlcnQgLmFudC1hbGVydC1jb250ZW50IHtcbiAgZGlzcGxheTogYmxvY2sgIWltcG9ydGFudDtcbn1cbiJdfQ== */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
